/*! Commit Hash: ad62a4f */
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://s3.amazonaws.com/cdn.hellosign.com/1.40.0/build";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	__webpack_require__(1);
	
	var _blocks = __webpack_require__(301);
	
	var _blocks2 = _interopRequireDefault(_blocks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	__webpack_require__(422);
	__webpack_require__(476);
	__webpack_require__(481);
	__webpack_require__(485);
	
	(0, _blocks2['default'])();
	
	var Application = __webpack_require__(487);
	
	// for server-side rendering (lib/vendor/react-server) (CC)
	global.Application = Application;
	global.app = new Application();
	
	// Accessing 'window' breaks node.js server-side rendering.
	// We MUST use 'typeof' to check for its existence. -Chris
	if (typeof window !== 'undefined') {
	    window.app = global.app;
	}
	
	exports.components = __webpack_require__(695);
	global.HfReactHelper = __webpack_require__(517);
	global.Validation = __webpack_require__(1660);
	global.React = __webpack_require__(304);
	global.ReactDOM = __webpack_require__(528);
	
	// hack to expose HS components to the react server (CC)
	global.HSComponents = exports.components;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* eslint max-len: 0 */
	
	"use strict";
	
	var _Object$defineProperty = __webpack_require__(2)["default"];
	
	__webpack_require__(5);
	
	__webpack_require__(296);
	
	// Should be removed in the next major release:
	
	__webpack_require__(298);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	function define(O, key, value) {
	  O[key] || _Object$defineProperty(O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(3), __esModule: true };

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(4);
	module.exports = function defineProperty(it, key, desc){
	  return $.setDesc(it, key, desc);
	};

/***/ },
/* 4 */
/***/ function(module, exports) {

	var $Object = Object;
	module.exports = {
	  create:     $Object.create,
	  getProto:   $Object.getPrototypeOf,
	  isEnum:     {}.propertyIsEnumerable,
	  getDesc:    $Object.getOwnPropertyDescriptor,
	  setDesc:    $Object.defineProperty,
	  setDescs:   $Object.defineProperties,
	  getKeys:    $Object.keys,
	  getNames:   $Object.getOwnPropertyNames,
	  getSymbols: $Object.getOwnPropertySymbols,
	  each:       [].forEach
	};

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(6);
	__webpack_require__(55);
	__webpack_require__(56);
	__webpack_require__(57);
	__webpack_require__(58);
	__webpack_require__(60);
	__webpack_require__(63);
	__webpack_require__(64);
	__webpack_require__(65);
	__webpack_require__(66);
	__webpack_require__(67);
	__webpack_require__(68);
	__webpack_require__(69);
	__webpack_require__(70);
	__webpack_require__(71);
	__webpack_require__(73);
	__webpack_require__(75);
	__webpack_require__(77);
	__webpack_require__(79);
	__webpack_require__(82);
	__webpack_require__(83);
	__webpack_require__(84);
	__webpack_require__(88);
	__webpack_require__(90);
	__webpack_require__(92);
	__webpack_require__(95);
	__webpack_require__(96);
	__webpack_require__(97);
	__webpack_require__(98);
	__webpack_require__(100);
	__webpack_require__(101);
	__webpack_require__(102);
	__webpack_require__(103);
	__webpack_require__(104);
	__webpack_require__(105);
	__webpack_require__(106);
	__webpack_require__(108);
	__webpack_require__(109);
	__webpack_require__(110);
	__webpack_require__(112);
	__webpack_require__(113);
	__webpack_require__(114);
	__webpack_require__(116);
	__webpack_require__(117);
	__webpack_require__(118);
	__webpack_require__(119);
	__webpack_require__(120);
	__webpack_require__(121);
	__webpack_require__(122);
	__webpack_require__(123);
	__webpack_require__(124);
	__webpack_require__(125);
	__webpack_require__(126);
	__webpack_require__(127);
	__webpack_require__(128);
	__webpack_require__(129);
	__webpack_require__(134);
	__webpack_require__(135);
	__webpack_require__(139);
	__webpack_require__(140);
	__webpack_require__(141);
	__webpack_require__(142);
	__webpack_require__(144);
	__webpack_require__(145);
	__webpack_require__(146);
	__webpack_require__(147);
	__webpack_require__(148);
	__webpack_require__(149);
	__webpack_require__(150);
	__webpack_require__(151);
	__webpack_require__(152);
	__webpack_require__(153);
	__webpack_require__(154);
	__webpack_require__(155);
	__webpack_require__(156);
	__webpack_require__(157);
	__webpack_require__(158);
	__webpack_require__(159);
	__webpack_require__(160);
	__webpack_require__(162);
	__webpack_require__(163);
	__webpack_require__(169);
	__webpack_require__(170);
	__webpack_require__(172);
	__webpack_require__(173);
	__webpack_require__(174);
	__webpack_require__(178);
	__webpack_require__(179);
	__webpack_require__(180);
	__webpack_require__(181);
	__webpack_require__(182);
	__webpack_require__(184);
	__webpack_require__(185);
	__webpack_require__(186);
	__webpack_require__(187);
	__webpack_require__(190);
	__webpack_require__(192);
	__webpack_require__(193);
	__webpack_require__(194);
	__webpack_require__(196);
	__webpack_require__(198);
	__webpack_require__(200);
	__webpack_require__(201);
	__webpack_require__(202);
	__webpack_require__(204);
	__webpack_require__(205);
	__webpack_require__(206);
	__webpack_require__(207);
	__webpack_require__(214);
	__webpack_require__(217);
	__webpack_require__(218);
	__webpack_require__(220);
	__webpack_require__(221);
	__webpack_require__(224);
	__webpack_require__(225);
	__webpack_require__(227);
	__webpack_require__(228);
	__webpack_require__(229);
	__webpack_require__(230);
	__webpack_require__(231);
	__webpack_require__(232);
	__webpack_require__(233);
	__webpack_require__(234);
	__webpack_require__(235);
	__webpack_require__(236);
	__webpack_require__(237);
	__webpack_require__(238);
	__webpack_require__(239);
	__webpack_require__(240);
	__webpack_require__(241);
	__webpack_require__(242);
	__webpack_require__(243);
	__webpack_require__(244);
	__webpack_require__(245);
	__webpack_require__(247);
	__webpack_require__(248);
	__webpack_require__(249);
	__webpack_require__(250);
	__webpack_require__(251);
	__webpack_require__(252);
	__webpack_require__(254);
	__webpack_require__(255);
	__webpack_require__(256);
	__webpack_require__(257);
	__webpack_require__(258);
	__webpack_require__(259);
	__webpack_require__(260);
	__webpack_require__(261);
	__webpack_require__(263);
	__webpack_require__(264);
	__webpack_require__(266);
	__webpack_require__(267);
	__webpack_require__(268);
	__webpack_require__(269);
	__webpack_require__(272);
	__webpack_require__(273);
	__webpack_require__(274);
	__webpack_require__(275);
	__webpack_require__(276);
	__webpack_require__(277);
	__webpack_require__(278);
	__webpack_require__(279);
	__webpack_require__(281);
	__webpack_require__(282);
	__webpack_require__(283);
	__webpack_require__(284);
	__webpack_require__(285);
	__webpack_require__(286);
	__webpack_require__(287);
	__webpack_require__(288);
	__webpack_require__(289);
	__webpack_require__(290);
	__webpack_require__(291);
	__webpack_require__(294);
	__webpack_require__(295);
	module.exports = __webpack_require__(12);

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global         = __webpack_require__(7)
	  , has            = __webpack_require__(8)
	  , DESCRIPTORS    = __webpack_require__(9)
	  , $export        = __webpack_require__(11)
	  , redefine       = __webpack_require__(21)
	  , META           = __webpack_require__(25).KEY
	  , $fails         = __webpack_require__(10)
	  , shared         = __webpack_require__(26)
	  , setToStringTag = __webpack_require__(27)
	  , uid            = __webpack_require__(22)
	  , wks            = __webpack_require__(28)
	  , wksExt         = __webpack_require__(29)
	  , wksDefine      = __webpack_require__(30)
	  , keyOf          = __webpack_require__(32)
	  , enumKeys       = __webpack_require__(45)
	  , isArray        = __webpack_require__(48)
	  , anObject       = __webpack_require__(15)
	  , toIObject      = __webpack_require__(35)
	  , toPrimitive    = __webpack_require__(19)
	  , createDesc     = __webpack_require__(20)
	  , _create        = __webpack_require__(49)
	  , gOPNExt        = __webpack_require__(52)
	  , $GOPD          = __webpack_require__(54)
	  , $DP            = __webpack_require__(14)
	  , $keys          = __webpack_require__(33)
	  , gOPD           = $GOPD.f
	  , dP             = $DP.f
	  , gOPN           = gOPNExt.f
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , PROTOTYPE      = 'prototype'
	  , HIDDEN         = wks('_hidden')
	  , TO_PRIMITIVE   = wks('toPrimitive')
	  , isEnum         = {}.propertyIsEnumerable
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , OPSymbols      = shared('op-symbols')
	  , ObjectProto    = Object[PROTOTYPE]
	  , USE_NATIVE     = typeof $Symbol == 'function'
	  , QObject        = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(dP({}, 'a', {
	    get: function(){ return dP(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = gOPD(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  dP(it, key, D);
	  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
	  return typeof it == 'symbol';
	} : function(it){
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if(has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  it  = toIObject(it);
	  key = toPrimitive(key, true);
	  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
	  var D = gOPD(it, key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = gOPN(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var IS_OP  = it === ObjectProto
	    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if(!USE_NATIVE){
	  $Symbol = function Symbol(){
	    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function(value){
	      if(this === ObjectProto)$set.call(OPSymbols, value);
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f   = $defineProperty;
	  __webpack_require__(53).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(47).f  = $propertyIsEnumerable;
	  __webpack_require__(46).f = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(31)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function(name){
	    return wrap(wks(name));
	  }
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});
	
	for(var symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);
	
	for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    if(isSymbol(key))return keyOf(SymbolRegistry, key);
	    throw TypeError(key + ' is not a symbol!');
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it){
	    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	    var args = [it]
	      , i    = 1
	      , replacer, $replacer;
	    while(arguments.length > i)args.push(arguments[i++]);
	    replacer = args[1];
	    if(typeof replacer == 'function')$replacer = replacer;
	    if($replacer || !isArray(replacer))replacer = function(key, value){
	      if($replacer)value = $replacer.call(this, key, value);
	      if(!isSymbol(value))return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(13)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ },
/* 7 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 8 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(10)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 10 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(7)
	  , core      = __webpack_require__(12)
	  , hide      = __webpack_require__(13)
	  , redefine  = __webpack_require__(21)
	  , ctx       = __webpack_require__(23)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target)redefine(target, key, out, type & $export.U);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 12 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(14)
	  , createDesc = __webpack_require__(20);
	module.exports = __webpack_require__(9) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(15)
	  , IE8_DOM_DEFINE = __webpack_require__(17)
	  , toPrimitive    = __webpack_require__(19)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(9) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(16);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 16 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(9) && !__webpack_require__(10)(function(){
	  return Object.defineProperty(__webpack_require__(18)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(16)
	  , document = __webpack_require__(7).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(16);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 20 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(7)
	  , hide      = __webpack_require__(13)
	  , has       = __webpack_require__(8)
	  , SRC       = __webpack_require__(22)('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(12).inspectSource = function(it){
	  return $toString.call(it);
	};
	
	(module.exports = function(O, key, val, safe){
	  var isFunction = typeof val == 'function';
	  if(isFunction)has(val, 'name') || hide(val, 'name', key);
	  if(O[key] === val)return;
	  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe){
	      delete O[key];
	      hide(O, key, val);
	    } else {
	      if(O[key])O[key] = val;
	      else hide(O, key, val);
	    }
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ },
/* 22 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(24);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 24 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var META     = __webpack_require__(22)('meta')
	  , isObject = __webpack_require__(16)
	  , has      = __webpack_require__(8)
	  , setDesc  = __webpack_require__(14).f
	  , id       = 0;
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	var FREEZE = !__webpack_require__(10)(function(){
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function(it){
	  setDesc(it, META, {value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  }});
	};
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add metadata
	    if(!create)return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function(it, create){
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return true;
	    // not necessary to add metadata
	    if(!create)return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function(it){
	  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY:      META,
	  NEED:     false,
	  fastKey:  fastKey,
	  getWeak:  getWeak,
	  onFreeze: onFreeze
	};

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(7)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(14).f
	  , has = __webpack_require__(8)
	  , TAG = __webpack_require__(28)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	var store      = __webpack_require__(26)('wks')
	  , uid        = __webpack_require__(22)
	  , Symbol     = __webpack_require__(7).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(28);

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	var global         = __webpack_require__(7)
	  , core           = __webpack_require__(12)
	  , LIBRARY        = __webpack_require__(31)
	  , wksExt         = __webpack_require__(29)
	  , defineProperty = __webpack_require__(14).f;
	module.exports = function(name){
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
	};

/***/ },
/* 31 */
/***/ function(module, exports) {

	module.exports = false;

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(33)
	  , toIObject = __webpack_require__(35);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(34)
	  , enumBugKeys = __webpack_require__(44);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(8)
	  , toIObject    = __webpack_require__(35)
	  , arrayIndexOf = __webpack_require__(39)(false)
	  , IE_PROTO     = __webpack_require__(43)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(36)
	  , defined = __webpack_require__(38);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(37);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 37 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 38 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(35)
	  , toLength  = __webpack_require__(40)
	  , toIndex   = __webpack_require__(42);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(41)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 41 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(41)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(26)('keys')
	  , uid    = __webpack_require__(22);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ },
/* 44 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(33)
	  , gOPS    = __webpack_require__(46)
	  , pIE     = __webpack_require__(47);
	module.exports = function(it){
	  var result     = getKeys(it)
	    , getSymbols = gOPS.f;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = pIE.f
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
	  } return result;
	};

/***/ },
/* 46 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ },
/* 47 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(37);
	module.exports = Array.isArray || function isArray(arg){
	  return cof(arg) == 'Array';
	};

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject    = __webpack_require__(15)
	  , dPs         = __webpack_require__(50)
	  , enumBugKeys = __webpack_require__(44)
	  , IE_PROTO    = __webpack_require__(43)('IE_PROTO')
	  , Empty       = function(){ /* empty */ }
	  , PROTOTYPE   = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(18)('iframe')
	    , i      = enumBugKeys.length
	    , lt     = '<'
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(51).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties){
	  var result;
	  if(O !== null){
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty;
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	var dP       = __webpack_require__(14)
	  , anObject = __webpack_require__(15)
	  , getKeys  = __webpack_require__(33);
	
	module.exports = __webpack_require__(9) ? Object.defineProperties : function defineProperties(O, Properties){
	  anObject(O);
	  var keys   = getKeys(Properties)
	    , length = keys.length
	    , i = 0
	    , P;
	  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(7).document && document.documentElement;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(35)
	  , gOPN      = __webpack_require__(53).f
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return gOPN(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it){
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys      = __webpack_require__(34)
	  , hiddenKeys = __webpack_require__(44).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
	  return $keys(O, hiddenKeys);
	};

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var pIE            = __webpack_require__(47)
	  , createDesc     = __webpack_require__(20)
	  , toIObject      = __webpack_require__(35)
	  , toPrimitive    = __webpack_require__(19)
	  , has            = __webpack_require__(8)
	  , IE8_DOM_DEFINE = __webpack_require__(17)
	  , gOPD           = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(9) ? gOPD : function getOwnPropertyDescriptor(O, P){
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if(IE8_DOM_DEFINE)try {
	    return gOPD(O, P);
	  } catch(e){ /* empty */ }
	  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
	};

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(11)
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', {create: __webpack_require__(49)});

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(11);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(9), 'Object', {defineProperty: __webpack_require__(14).f});

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(11);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(9), 'Object', {defineProperties: __webpack_require__(50)});

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject                 = __webpack_require__(35)
	  , $getOwnPropertyDescriptor = __webpack_require__(54).f;
	
	__webpack_require__(59)('getOwnPropertyDescriptor', function(){
	  return function getOwnPropertyDescriptor(it, key){
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(11)
	  , core    = __webpack_require__(12)
	  , fails   = __webpack_require__(10);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject        = __webpack_require__(61)
	  , $getPrototypeOf = __webpack_require__(62);
	
	__webpack_require__(59)('getPrototypeOf', function(){
	  return function getPrototypeOf(it){
	    return $getPrototypeOf(toObject(it));
	  };
	});

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(38);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has         = __webpack_require__(8)
	  , toObject    = __webpack_require__(61)
	  , IE_PROTO    = __webpack_require__(43)('IE_PROTO')
	  , ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function(O){
	  O = toObject(O);
	  if(has(O, IE_PROTO))return O[IE_PROTO];
	  if(typeof O.constructor == 'function' && O instanceof O.constructor){
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(61)
	  , $keys    = __webpack_require__(33);
	
	__webpack_require__(59)('keys', function(){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(59)('getOwnPropertyNames', function(){
	  return __webpack_require__(52).f;
	});

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(16)
	  , meta     = __webpack_require__(25).onFreeze;
	
	__webpack_require__(59)('freeze', function($freeze){
	  return function freeze(it){
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(16)
	  , meta     = __webpack_require__(25).onFreeze;
	
	__webpack_require__(59)('seal', function($seal){
	  return function seal(it){
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(16)
	  , meta     = __webpack_require__(25).onFreeze;
	
	__webpack_require__(59)('preventExtensions', function($preventExtensions){
	  return function preventExtensions(it){
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(16);
	
	__webpack_require__(59)('isFrozen', function($isFrozen){
	  return function isFrozen(it){
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(16);
	
	__webpack_require__(59)('isSealed', function($isSealed){
	  return function isSealed(it){
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(16);
	
	__webpack_require__(59)('isExtensible', function($isExtensible){
	  return function isExtensible(it){
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(11);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(72)});

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__(33)
	  , gOPS     = __webpack_require__(46)
	  , pIE      = __webpack_require__(47)
	  , toObject = __webpack_require__(61)
	  , IObject  = __webpack_require__(36)
	  , $assign  = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(10)(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(11);
	$export($export.S, 'Object', {is: __webpack_require__(74)});

/***/ },
/* 74 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y){
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(11);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(76).set});

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(16)
	  , anObject = __webpack_require__(15);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(23)(Function.call, __webpack_require__(54).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(78)
	  , test    = {};
	test[__webpack_require__(28)('toStringTag')] = 'z';
	if(test + '' != '[object z]'){
	  __webpack_require__(21)(Object.prototype, 'toString', function toString(){
	    return '[object ' + classof(this) + ']';
	  }, true);
	}

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(37)
	  , TAG = __webpack_require__(28)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function(it, key){
	  try {
	    return it[key];
	  } catch(e){ /* empty */ }
	};
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(11);
	
	$export($export.P, 'Function', {bind: __webpack_require__(80)});

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction  = __webpack_require__(24)
	  , isObject   = __webpack_require__(16)
	  , invoke     = __webpack_require__(81)
	  , arraySlice = [].slice
	  , factories  = {};
	
	var construct = function(F, len, args){
	  if(!(len in factories)){
	    for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /*, args... */){
	  var fn       = aFunction(this)
	    , partArgs = arraySlice.call(arguments, 1);
	  var bound = function(/* args... */){
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if(isObject(fn.prototype))bound.prototype = fn.prototype;
	  return bound;
	};

/***/ },
/* 81 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function(fn, args, that){
	  var un = that === undefined;
	  switch(args.length){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return              fn.apply(that, args);
	};

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(14).f
	  , createDesc = __webpack_require__(20)
	  , has        = __webpack_require__(8)
	  , FProto     = Function.prototype
	  , nameRE     = /^\s*function ([^ (]*)/
	  , NAME       = 'name';
	
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(9) && dP(FProto, NAME, {
	  configurable: true,
	  get: function(){
	    try {
	      var that = this
	        , name = ('' + that).match(nameRE)[1];
	      has(that, NAME) || !isExtensible(that) || dP(that, NAME, createDesc(5, name));
	      return name;
	    } catch(e){
	      return '';
	    }
	  }
	});

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject       = __webpack_require__(16)
	  , getPrototypeOf = __webpack_require__(62)
	  , HAS_INSTANCE   = __webpack_require__(28)('hasInstance')
	  , FunctionProto  = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if(!(HAS_INSTANCE in FunctionProto))__webpack_require__(14).f(FunctionProto, HAS_INSTANCE, {value: function(O){
	  if(typeof this != 'function' || !isObject(O))return false;
	  if(!isObject(this.prototype))return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while(O = getPrototypeOf(O))if(this.prototype === O)return true;
	  return false;
	}});

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(11)
	  , $parseInt = __webpack_require__(85);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), {parseInt: $parseInt});

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(7).parseInt
	  , $trim     = __webpack_require__(86).trim
	  , ws        = __webpack_require__(87)
	  , hex       = /^[\-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix){
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(11)
	  , defined = __webpack_require__(38)
	  , fails   = __webpack_require__(10)
	  , spaces  = __webpack_require__(87)
	  , space   = '[' + spaces + ']'
	  , non     = '\u200b\u0085'
	  , ltrim   = RegExp('^' + space + space + '*')
	  , rtrim   = RegExp(space + space + '*$');
	
	var exporter = function(KEY, exec, ALIAS){
	  var exp   = {};
	  var FORCE = fails(function(){
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if(ALIAS)exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function(string, TYPE){
	  string = String(defined(string));
	  if(TYPE & 1)string = string.replace(ltrim, '');
	  if(TYPE & 2)string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;

/***/ },
/* 87 */
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(11)
	  , $parseFloat = __webpack_require__(89);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), {parseFloat: $parseFloat});

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(7).parseFloat
	  , $trim       = __webpack_require__(86).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(87) + '-0') !== -Infinity ? function parseFloat(str){
	  var string = $trim(String(str), 3)
	    , result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(7)
	  , has               = __webpack_require__(8)
	  , cof               = __webpack_require__(37)
	  , inheritIfRequired = __webpack_require__(91)
	  , toPrimitive       = __webpack_require__(19)
	  , fails             = __webpack_require__(10)
	  , gOPN              = __webpack_require__(53).f
	  , gOPD              = __webpack_require__(54).f
	  , dP                = __webpack_require__(14).f
	  , $trim             = __webpack_require__(86).trim
	  , NUMBER            = 'Number'
	  , $Number           = global[NUMBER]
	  , Base              = $Number
	  , proto             = $Number.prototype
	  // Opera ~12 has broken Object#toString
	  , BROKEN_COF        = cof(__webpack_require__(49)(proto)) == NUMBER
	  , TRIM              = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function(argument){
	  var it = toPrimitive(argument, false);
	  if(typeof it == 'string' && it.length > 2){
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0)
	      , third, radix, maxCode;
	    if(first === 43 || first === 45){
	      third = it.charCodeAt(2);
	      if(third === 88 || third === 120)return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if(first === 48){
	      switch(it.charCodeAt(1)){
	        case 66 : case 98  : radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79 : case 111 : radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default : return +it;
	      }
	      for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if(code < 48 || code > maxCode)return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if(!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')){
	  $Number = function Number(value){
	    var it = arguments.length < 1 ? 0 : value
	      , that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function(){ proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for(var keys = __webpack_require__(9) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++){
	    if(has(Base, key = keys[j]) && !has($Number, key)){
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(21)(global, NUMBER, $Number);
	}

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	var isObject       = __webpack_require__(16)
	  , setPrototypeOf = __webpack_require__(76).set;
	module.exports = function(that, target, C){
	  var P, S = target.constructor;
	  if(S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf){
	    setPrototypeOf(that, P);
	  } return that;
	};

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(11)
	  , toInteger    = __webpack_require__(41)
	  , aNumberValue = __webpack_require__(93)
	  , repeat       = __webpack_require__(94)
	  , $toFixed     = 1..toFixed
	  , floor        = Math.floor
	  , data         = [0, 0, 0, 0, 0, 0]
	  , ERROR        = 'Number.toFixed: incorrect invocation!'
	  , ZERO         = '0';
	
	var multiply = function(n, c){
	  var i  = -1
	    , c2 = c;
	  while(++i < 6){
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function(n){
	  var i = 6
	    , c = 0;
	  while(--i >= 0){
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function(){
	  var i = 6
	    , s = '';
	  while(--i >= 0){
	    if(s !== '' || i === 0 || data[i] !== 0){
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function(x, n, acc){
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function(x){
	  var n  = 0
	    , x2 = x;
	  while(x2 >= 4096){
	    n += 12;
	    x2 /= 4096;
	  }
	  while(x2 >= 2){
	    n  += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128..toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(10)(function(){
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits){
	    var x = aNumberValue(this, ERROR)
	      , f = toInteger(fractionDigits)
	      , s = ''
	      , m = ZERO
	      , e, z, j, k;
	    if(f < 0 || f > 20)throw RangeError(ERROR);
	    if(x != x)return 'NaN';
	    if(x <= -1e21 || x >= 1e21)return String(x);
	    if(x < 0){
	      s = '-';
	      x = -x;
	    }
	    if(x > 1e-21){
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if(e > 0){
	        multiply(0, z);
	        j = f;
	        while(j >= 7){
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while(j >= 23){
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if(f > 0){
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(37);
	module.exports = function(it, msg){
	  if(typeof it != 'number' && cof(it) != 'Number')throw TypeError(msg);
	  return +it;
	};

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(41)
	  , defined   = __webpack_require__(38);
	
	module.exports = function repeat(count){
	  var str = String(defined(this))
	    , res = ''
	    , n   = toInteger(count);
	  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
	  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
	  return res;
	};

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(11)
	  , $fails       = __webpack_require__(10)
	  , aNumberValue = __webpack_require__(93)
	  , $toPrecision = 1..toPrecision;
	
	$export($export.P + $export.F * ($fails(function(){
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function(){
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision){
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision); 
	  }
	});

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Number', {EPSILON: Math.pow(2, -52)});

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export   = __webpack_require__(11)
	  , _isFinite = __webpack_require__(7).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it){
	    return typeof it == 'number' && _isFinite(it);
	  }
	});

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Number', {isInteger: __webpack_require__(99)});

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(16)
	  , floor    = Math.floor;
	module.exports = function isInteger(it){
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number){
	    return number != number;
	  }
	});

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export   = __webpack_require__(11)
	  , isInteger = __webpack_require__(99)
	  , abs       = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number){
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(11)
	  , $parseFloat = __webpack_require__(89);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', {parseFloat: $parseFloat});

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(11)
	  , $parseInt = __webpack_require__(85);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', {parseInt: $parseInt});

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(11)
	  , log1p   = __webpack_require__(107)
	  , sqrt    = Math.sqrt
	  , $acosh  = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN 
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x){
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});

/***/ },
/* 107 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x){
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(11)
	  , $asinh  = Math.asinh;
	
	function asinh(x){
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0 
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {asinh: asinh});

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(11)
	  , $atanh  = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0 
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x){
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(11)
	  , sign    = __webpack_require__(111);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x){
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});

/***/ },
/* 111 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x){
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x){
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(11)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x){
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(11)
	  , $expm1  = __webpack_require__(115);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {expm1: $expm1});

/***/ },
/* 115 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x){
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export   = __webpack_require__(11)
	  , sign      = __webpack_require__(111)
	  , pow       = Math.pow
	  , EPSILON   = pow(2, -52)
	  , EPSILON32 = pow(2, -23)
	  , MAX32     = pow(2, 127) * (2 - EPSILON32)
	  , MIN32     = pow(2, -126);
	
	var roundTiesToEven = function(n){
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	
	$export($export.S, 'Math', {
	  fround: function fround(x){
	    var $abs  = Math.abs(x)
	      , $sign = sign(x)
	      , a, result;
	    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	    a = (1 + EPSILON32 / EPSILON) * $abs;
	    result = a - (a - $abs);
	    if(result > MAX32 || result != result)return $sign * Infinity;
	    return $sign * result;
	  }
	});

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(11)
	  , abs     = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
	    var sum  = 0
	      , i    = 0
	      , aLen = arguments.length
	      , larg = 0
	      , arg, div;
	    while(i < aLen){
	      arg = abs(arguments[i++]);
	      if(larg < arg){
	        div  = larg / arg;
	        sum  = sum * div * div + 1;
	        larg = arg;
	      } else if(arg > 0){
	        div  = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(11)
	  , $imul   = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(10)(function(){
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y){
	    var UINT16 = 0xffff
	      , xn = +x
	      , yn = +y
	      , xl = UINT16 & xn
	      , yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Math', {
	  log10: function log10(x){
	    return Math.log(x) / Math.LN10;
	  }
	});

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Math', {log1p: __webpack_require__(107)});

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Math', {
	  log2: function log2(x){
	    return Math.log(x) / Math.LN2;
	  }
	});

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Math', {sign: __webpack_require__(111)});

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(11)
	  , expm1   = __webpack_require__(115)
	  , exp     = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(10)(function(){
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x){
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(11)
	  , expm1   = __webpack_require__(115)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x){
	    var a = expm1(x = +x)
	      , b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it){
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	var $export        = __webpack_require__(11)
	  , toIndex        = __webpack_require__(42)
	  , fromCharCode   = String.fromCharCode
	  , $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
	    var res  = []
	      , aLen = arguments.length
	      , i    = 0
	      , code;
	    while(aLen > i){
	      code = +arguments[i++];
	      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(11)
	  , toIObject = __webpack_require__(35)
	  , toLength  = __webpack_require__(40);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite){
	    var tpl  = toIObject(callSite.raw)
	      , len  = toLength(tpl.length)
	      , aLen = arguments.length
	      , res  = []
	      , i    = 0;
	    while(len > i){
	      res.push(String(tpl[i++]));
	      if(i < aLen)res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(86)('trim', function($trim){
	  return function trim(){
	    return $trim(this, 3);
	  };
	});

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(130)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(131)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(41)
	  , defined   = __webpack_require__(38);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(31)
	  , $export        = __webpack_require__(11)
	  , redefine       = __webpack_require__(21)
	  , hide           = __webpack_require__(13)
	  , has            = __webpack_require__(8)
	  , Iterators      = __webpack_require__(132)
	  , $iterCreate    = __webpack_require__(133)
	  , setToStringTag = __webpack_require__(27)
	  , getPrototypeOf = __webpack_require__(62)
	  , ITERATOR       = __webpack_require__(28)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ },
/* 132 */
/***/ function(module, exports) {

	module.exports = {};

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create         = __webpack_require__(49)
	  , descriptor     = __webpack_require__(20)
	  , setToStringTag = __webpack_require__(27)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(13)(IteratorPrototype, __webpack_require__(28)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(11)
	  , $at     = __webpack_require__(130)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos){
	    return $at(this, pos);
	  }
	});

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export   = __webpack_require__(11)
	  , toLength  = __webpack_require__(40)
	  , context   = __webpack_require__(136)
	  , ENDS_WITH = 'endsWith'
	  , $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(138)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /*, endPosition = @length */){
	    var that = context(this, searchString, ENDS_WITH)
	      , endPosition = arguments.length > 1 ? arguments[1] : undefined
	      , len    = toLength(that.length)
	      , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)
	      , search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(137)
	  , defined  = __webpack_require__(38);
	
	module.exports = function(that, searchString, NAME){
	  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(16)
	  , cof      = __webpack_require__(37)
	  , MATCH    = __webpack_require__(28)('match');
	module.exports = function(it){
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(28)('match');
	module.exports = function(KEY){
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch(e){
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch(f){ /* empty */ }
	  } return true;
	};

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export  = __webpack_require__(11)
	  , context  = __webpack_require__(136)
	  , INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(138)(INCLUDES), 'String', {
	  includes: function includes(searchString /*, position = 0 */){
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(11);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(94)
	});

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export     = __webpack_require__(11)
	  , toLength    = __webpack_require__(40)
	  , context     = __webpack_require__(136)
	  , STARTS_WITH = 'startsWith'
	  , $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(138)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /*, position = 0 */){
	    var that   = context(this, searchString, STARTS_WITH)
	      , index  = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length))
	      , search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(143)('anchor', function(createHTML){
	  return function anchor(name){
	    return createHTML(this, 'a', 'name', name);
	  }
	});

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(11)
	  , fails   = __webpack_require__(10)
	  , defined = __webpack_require__(38)
	  , quot    = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function(string, tag, attribute, value) {
	  var S  = String(defined(string))
	    , p1 = '<' + tag;
	  if(attribute !== '')p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function(NAME, exec){
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function(){
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(143)('big', function(createHTML){
	  return function big(){
	    return createHTML(this, 'big', '', '');
	  }
	});

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(143)('blink', function(createHTML){
	  return function blink(){
	    return createHTML(this, 'blink', '', '');
	  }
	});

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(143)('bold', function(createHTML){
	  return function bold(){
	    return createHTML(this, 'b', '', '');
	  }
	});

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(143)('fixed', function(createHTML){
	  return function fixed(){
	    return createHTML(this, 'tt', '', '');
	  }
	});

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(143)('fontcolor', function(createHTML){
	  return function fontcolor(color){
	    return createHTML(this, 'font', 'color', color);
	  }
	});

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(143)('fontsize', function(createHTML){
	  return function fontsize(size){
	    return createHTML(this, 'font', 'size', size);
	  }
	});

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(143)('italics', function(createHTML){
	  return function italics(){
	    return createHTML(this, 'i', '', '');
	  }
	});

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(143)('link', function(createHTML){
	  return function link(url){
	    return createHTML(this, 'a', 'href', url);
	  }
	});

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(143)('small', function(createHTML){
	  return function small(){
	    return createHTML(this, 'small', '', '');
	  }
	});

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(143)('strike', function(createHTML){
	  return function strike(){
	    return createHTML(this, 'strike', '', '');
	  }
	});

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(143)('sub', function(createHTML){
	  return function sub(){
	    return createHTML(this, 'sub', '', '');
	  }
	});

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(143)('sup', function(createHTML){
	  return function sup(){
	    return createHTML(this, 'sup', '', '');
	  }
	});

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Date', {now: function(){ return new Date().getTime(); }});

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export     = __webpack_require__(11)
	  , toObject    = __webpack_require__(61)
	  , toPrimitive = __webpack_require__(19);
	
	$export($export.P + $export.F * __webpack_require__(10)(function(){
	  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({toISOString: function(){ return 1; }}) !== 1;
	}), 'Date', {
	  toJSON: function toJSON(key){
	    var O  = toObject(this)
	      , pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(11)
	  , fails   = __webpack_require__(10)
	  , getTime = Date.prototype.getTime;
	
	var lz = function(num){
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (fails(function(){
	  return new Date(-5e13 - 1).toISOString() != '0385-07-25T07:06:39.999Z';
	}) || !fails(function(){
	  new Date(NaN).toISOString();
	})), 'Date', {
	  toISOString: function toISOString(){
	    if(!isFinite(getTime.call(this)))throw RangeError('Invalid time value');
	    var d = this
	      , y = d.getUTCFullYear()
	      , m = d.getUTCMilliseconds()
	      , s = y < 0 ? '-' : y > 9999 ? '+' : '';
	    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	      '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	      'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	      ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	  }
	});

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	var DateProto    = Date.prototype
	  , INVALID_DATE = 'Invalid Date'
	  , TO_STRING    = 'toString'
	  , $toString    = DateProto[TO_STRING]
	  , getTime      = DateProto.getTime;
	if(new Date(NaN) + '' != INVALID_DATE){
	  __webpack_require__(21)(DateProto, TO_STRING, function toString(){
	    var value = getTime.call(this);
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(28)('toPrimitive')
	  , proto        = Date.prototype;
	
	if(!(TO_PRIMITIVE in proto))__webpack_require__(13)(proto, TO_PRIMITIVE, __webpack_require__(161));

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject    = __webpack_require__(15)
	  , toPrimitive = __webpack_require__(19)
	  , NUMBER      = 'number';
	
	module.exports = function(hint){
	  if(hint !== 'string' && hint !== NUMBER && hint !== 'default')throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Array', {isArray: __webpack_require__(48)});

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx            = __webpack_require__(23)
	  , $export        = __webpack_require__(11)
	  , toObject       = __webpack_require__(61)
	  , call           = __webpack_require__(164)
	  , isArrayIter    = __webpack_require__(165)
	  , toLength       = __webpack_require__(40)
	  , createProperty = __webpack_require__(166)
	  , getIterFn      = __webpack_require__(167);
	
	$export($export.S + $export.F * !__webpack_require__(168)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(15);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(132)
	  , ITERATOR   = __webpack_require__(28)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(14)
	  , createDesc      = __webpack_require__(20);
	
	module.exports = function(object, index, value){
	  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(78)
	  , ITERATOR  = __webpack_require__(28)('iterator')
	  , Iterators = __webpack_require__(132);
	module.exports = __webpack_require__(12).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(28)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ return {done: safe = true}; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export        = __webpack_require__(11)
	  , createProperty = __webpack_require__(166);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(10)(function(){
	  function F(){}
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */){
	    var index  = 0
	      , aLen   = arguments.length
	      , result = new (typeof this == 'function' ? this : Array)(aLen);
	    while(aLen > index)createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export   = __webpack_require__(11)
	  , toIObject = __webpack_require__(35)
	  , arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(36) != Object || !__webpack_require__(171)(arrayJoin)), 'Array', {
	  join: function join(separator){
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	var fails = __webpack_require__(10);
	
	module.exports = function(method, arg){
	  return !!method && fails(function(){
	    arg ? method.call(null, function(){}, 1) : method.call(null);
	  });
	};

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export    = __webpack_require__(11)
	  , html       = __webpack_require__(51)
	  , cof        = __webpack_require__(37)
	  , toIndex    = __webpack_require__(42)
	  , toLength   = __webpack_require__(40)
	  , arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(10)(function(){
	  if(html)arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end){
	    var len   = toLength(this.length)
	      , klass = cof(this);
	    end = end === undefined ? len : end;
	    if(klass == 'Array')return arraySlice.call(this, begin, end);
	    var start  = toIndex(begin, len)
	      , upTo   = toIndex(end, len)
	      , size   = toLength(upTo - start)
	      , cloned = Array(size)
	      , i      = 0;
	    for(; i < size; i++)cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export   = __webpack_require__(11)
	  , aFunction = __webpack_require__(24)
	  , toObject  = __webpack_require__(61)
	  , fails     = __webpack_require__(10)
	  , $sort     = [].sort
	  , test      = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function(){
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function(){
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(171)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn){
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export  = __webpack_require__(11)
	  , $forEach = __webpack_require__(175)(0)
	  , STRICT   = __webpack_require__(171)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */){
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx      = __webpack_require__(23)
	  , IObject  = __webpack_require__(36)
	  , toObject = __webpack_require__(61)
	  , toLength = __webpack_require__(40)
	  , asc      = __webpack_require__(176);
	module.exports = function(TYPE, $create){
	  var IS_MAP        = TYPE == 1
	    , IS_FILTER     = TYPE == 2
	    , IS_SOME       = TYPE == 3
	    , IS_EVERY      = TYPE == 4
	    , IS_FIND_INDEX = TYPE == 6
	    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
	    , create        = $create || asc;
	  return function($this, callbackfn, that){
	    var O      = toObject($this)
	      , self   = IObject(O)
	      , f      = ctx(callbackfn, that, 3)
	      , length = toLength(self.length)
	      , index  = 0
	      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
	      , val, res;
	    for(;length > index; index++)if(NO_HOLES || index in self){
	      val = self[index];
	      res = f(val, index, O);
	      if(TYPE){
	        if(IS_MAP)result[index] = res;            // map
	        else if(res)switch(TYPE){
	          case 3: return true;                    // some
	          case 5: return val;                     // find
	          case 6: return index;                   // findIndex
	          case 2: result.push(val);               // filter
	        } else if(IS_EVERY)return false;          // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(177);
	
	module.exports = function(original, length){
	  return new (speciesConstructor(original))(length);
	};

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(16)
	  , isArray  = __webpack_require__(48)
	  , SPECIES  = __webpack_require__(28)('species');
	
	module.exports = function(original){
	  var C;
	  if(isArray(original)){
	    C = original.constructor;
	    // cross-realm fallback
	    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
	    if(isObject(C)){
	      C = C[SPECIES];
	      if(C === null)C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(11)
	  , $map    = __webpack_require__(175)(1);
	
	$export($export.P + $export.F * !__webpack_require__(171)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */){
	    return $map(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(11)
	  , $filter = __webpack_require__(175)(2);
	
	$export($export.P + $export.F * !__webpack_require__(171)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */){
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(11)
	  , $some   = __webpack_require__(175)(3);
	
	$export($export.P + $export.F * !__webpack_require__(171)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */){
	    return $some(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(11)
	  , $every  = __webpack_require__(175)(4);
	
	$export($export.P + $export.F * !__webpack_require__(171)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */){
	    return $every(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(11)
	  , $reduce = __webpack_require__(183);
	
	$export($export.P + $export.F * !__webpack_require__(171)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(24)
	  , toObject  = __webpack_require__(61)
	  , IObject   = __webpack_require__(36)
	  , toLength  = __webpack_require__(40);
	
	module.exports = function(that, callbackfn, aLen, memo, isRight){
	  aFunction(callbackfn);
	  var O      = toObject(that)
	    , self   = IObject(O)
	    , length = toLength(O.length)
	    , index  = isRight ? length - 1 : 0
	    , i      = isRight ? -1 : 1;
	  if(aLen < 2)for(;;){
	    if(index in self){
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if(isRight ? index < 0 : length <= index){
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for(;isRight ? index >= 0 : length > index; index += i)if(index in self){
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(11)
	  , $reduce = __webpack_require__(183);
	
	$export($export.P + $export.F * !__webpack_require__(171)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(11)
	  , $indexOf      = __webpack_require__(39)(false)
	  , $native       = [].indexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(171)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /*, fromIndex = 0 */){
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(11)
	  , toIObject     = __webpack_require__(35)
	  , toInteger     = __webpack_require__(41)
	  , toLength      = __webpack_require__(40)
	  , $native       = [].lastIndexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(171)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /*, fromIndex = @[*-1] */){
	    // convert -0 to +0
	    if(NEGATIVE_ZERO)return $native.apply(this, arguments) || 0;
	    var O      = toIObject(this)
	      , length = toLength(O.length)
	      , index  = length - 1;
	    if(arguments.length > 1)index = Math.min(index, toInteger(arguments[1]));
	    if(index < 0)index = length + index;
	    for(;index >= 0; index--)if(index in O)if(O[index] === searchElement)return index || 0;
	    return -1;
	  }
	});

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(11);
	
	$export($export.P, 'Array', {copyWithin: __webpack_require__(188)});
	
	__webpack_require__(189)('copyWithin');

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(61)
	  , toIndex  = __webpack_require__(42)
	  , toLength = __webpack_require__(40);
	
	module.exports = [].copyWithin || function copyWithin(target/*= 0*/, start/*= 0, end = @length*/){
	  var O     = toObject(this)
	    , len   = toLength(O.length)
	    , to    = toIndex(target, len)
	    , from  = toIndex(start, len)
	    , end   = arguments.length > 2 ? arguments[2] : undefined
	    , count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to)
	    , inc   = 1;
	  if(from < to && to < from + count){
	    inc  = -1;
	    from += count - 1;
	    to   += count - 1;
	  }
	  while(count-- > 0){
	    if(from in O)O[to] = O[from];
	    else delete O[to];
	    to   += inc;
	    from += inc;
	  } return O;
	};

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(28)('unscopables')
	  , ArrayProto  = Array.prototype;
	if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(13)(ArrayProto, UNSCOPABLES, {});
	module.exports = function(key){
	  ArrayProto[UNSCOPABLES][key] = true;
	};

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(11);
	
	$export($export.P, 'Array', {fill: __webpack_require__(191)});
	
	__webpack_require__(189)('fill');

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(61)
	  , toIndex  = __webpack_require__(42)
	  , toLength = __webpack_require__(40);
	module.exports = function fill(value /*, start = 0, end = @length */){
	  var O      = toObject(this)
	    , length = toLength(O.length)
	    , aLen   = arguments.length
	    , index  = toIndex(aLen > 1 ? arguments[1] : undefined, length)
	    , end    = aLen > 2 ? arguments[2] : undefined
	    , endPos = end === undefined ? length : toIndex(end, length);
	  while(endPos > index)O[index++] = value;
	  return O;
	};

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(11)
	  , $find   = __webpack_require__(175)(5)
	  , KEY     = 'find'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(189)(KEY);

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(11)
	  , $find   = __webpack_require__(175)(6)
	  , KEY     = 'findIndex'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(189)(KEY);

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(195)('Array');

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global      = __webpack_require__(7)
	  , dP          = __webpack_require__(14)
	  , DESCRIPTORS = __webpack_require__(9)
	  , SPECIES     = __webpack_require__(28)('species');
	
	module.exports = function(KEY){
	  var C = global[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(189)
	  , step             = __webpack_require__(197)
	  , Iterators        = __webpack_require__(132)
	  , toIObject        = __webpack_require__(35);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(131)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ },
/* 197 */
/***/ function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	var global            = __webpack_require__(7)
	  , inheritIfRequired = __webpack_require__(91)
	  , dP                = __webpack_require__(14).f
	  , gOPN              = __webpack_require__(53).f
	  , isRegExp          = __webpack_require__(137)
	  , $flags            = __webpack_require__(199)
	  , $RegExp           = global.RegExp
	  , Base              = $RegExp
	  , proto             = $RegExp.prototype
	  , re1               = /a/g
	  , re2               = /a/g
	  // "new" creates a new object, old webkit buggy here
	  , CORRECT_NEW       = new $RegExp(re1) !== re1;
	
	if(__webpack_require__(9) && (!CORRECT_NEW || __webpack_require__(10)(function(){
	  re2[__webpack_require__(28)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))){
	  $RegExp = function RegExp(p, f){
	    var tiRE = this instanceof $RegExp
	      , piRE = isRegExp(p)
	      , fiU  = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function(key){
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function(){ return Base[key]; },
	      set: function(it){ Base[key] = it; }
	    });
	  };
	  for(var keys = gOPN(Base), i = 0; keys.length > i; )proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(21)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(195)('RegExp');

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(15);
	module.exports = function(){
	  var that   = anObject(this)
	    , result = '';
	  if(that.global)     result += 'g';
	  if(that.ignoreCase) result += 'i';
	  if(that.multiline)  result += 'm';
	  if(that.unicode)    result += 'u';
	  if(that.sticky)     result += 'y';
	  return result;
	};

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(201);
	var anObject    = __webpack_require__(15)
	  , $flags      = __webpack_require__(199)
	  , DESCRIPTORS = __webpack_require__(9)
	  , TO_STRING   = 'toString'
	  , $toString   = /./[TO_STRING];
	
	var define = function(fn){
	  __webpack_require__(21)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if(__webpack_require__(10)(function(){ return $toString.call({source: 'a', flags: 'b'}) != '/a/b'; })){
	  define(function toString(){
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if($toString.name != TO_STRING){
	  define(function toString(){
	    return $toString.call(this);
	  });
	}

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if(__webpack_require__(9) && /./g.flags != 'g')__webpack_require__(14).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(199)
	});

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(203)('match', 1, function(defined, MATCH, $match){
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var hide     = __webpack_require__(13)
	  , redefine = __webpack_require__(21)
	  , fails    = __webpack_require__(10)
	  , defined  = __webpack_require__(38)
	  , wks      = __webpack_require__(28);
	
	module.exports = function(KEY, length, exec){
	  var SYMBOL   = wks(KEY)
	    , fns      = exec(defined, SYMBOL, ''[KEY])
	    , strfn    = fns[0]
	    , rxfn     = fns[1];
	  if(fails(function(){
	    var O = {};
	    O[SYMBOL] = function(){ return 7; };
	    return ''[KEY](O) != 7;
	  })){
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function(string, arg){ return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function(string){ return rxfn.call(string, this); }
	    );
	  }
	};

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(203)('replace', 2, function(defined, REPLACE, $replace){
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue){
	    'use strict';
	    var O  = defined(this)
	      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(203)('search', 1, function(defined, SEARCH, $search){
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(203)('split', 2, function(defined, SPLIT, $split){
	  'use strict';
	  var isRegExp   = __webpack_require__(137)
	    , _split     = $split
	    , $push      = [].push
	    , $SPLIT     = 'split'
	    , LENGTH     = 'length'
	    , LAST_INDEX = 'lastIndex';
	  if(
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ){
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function(separator, limit){
	      var string = String(this);
	      if(separator === undefined && limit === 0)return [];
	      // If `separator` is not a regex, use native split
	      if(!isRegExp(separator))return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if(!NPCG)separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while(match = separatorCopy.exec(string)){
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if(lastIndex > lastLastIndex){
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          if(!NPCG && match[LENGTH] > 1)match[0].replace(separator2, function(){
	            for(i = 1; i < arguments[LENGTH] - 2; i++)if(arguments[i] === undefined)match[i] = undefined;
	          });
	          if(match[LENGTH] > 1 && match.index < string[LENGTH])$push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if(output[LENGTH] >= splitLimit)break;
	        }
	        if(separatorCopy[LAST_INDEX] === match.index)separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if(lastLastIndex === string[LENGTH]){
	        if(lastLength || !separatorCopy.test(''))output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if('0'[$SPLIT](undefined, 0)[LENGTH]){
	    $split = function(separator, limit){
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit){
	    var O  = defined(this)
	      , fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY            = __webpack_require__(31)
	  , global             = __webpack_require__(7)
	  , ctx                = __webpack_require__(23)
	  , classof            = __webpack_require__(78)
	  , $export            = __webpack_require__(11)
	  , isObject           = __webpack_require__(16)
	  , aFunction          = __webpack_require__(24)
	  , anInstance         = __webpack_require__(208)
	  , forOf              = __webpack_require__(209)
	  , speciesConstructor = __webpack_require__(210)
	  , task               = __webpack_require__(211).set
	  , microtask          = __webpack_require__(212)()
	  , PROMISE            = 'Promise'
	  , TypeError          = global.TypeError
	  , process            = global.process
	  , $Promise           = global[PROMISE]
	  , process            = global.process
	  , isNode             = classof(process) == 'process'
	  , empty              = function(){ /* empty */ }
	  , Internal, GenericPromiseCapability, Wrapper;
	
	var USE_NATIVE = !!function(){
	  try {
	    // correct subclassing with @@species support
	    var promise     = $Promise.resolve(1)
	      , FakePromise = (promise.constructor = {})[__webpack_require__(28)('species')] = function(exec){ exec(empty, empty); };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch(e){ /* empty */ }
	}();
	
	// helpers
	var sameConstructor = function(a, b){
	  // with library wrapper special case
	  return a === b || a === $Promise && b === Wrapper;
	};
	var isThenable = function(it){
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var newPromiseCapability = function(C){
	  return sameConstructor($Promise, C)
	    ? new PromiseCapability(C)
	    : new GenericPromiseCapability(C);
	};
	var PromiseCapability = GenericPromiseCapability = function(C){
	  var resolve, reject;
	  this.promise = new C(function($$resolve, $$reject){
	    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject  = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject  = aFunction(reject);
	};
	var perform = function(exec){
	  try {
	    exec();
	  } catch(e){
	    return {error: e};
	  }
	};
	var notify = function(promise, isReject){
	  if(promise._n)return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function(){
	    var value = promise._v
	      , ok    = promise._s == 1
	      , i     = 0;
	    var run = function(reaction){
	      var handler = ok ? reaction.ok : reaction.fail
	        , resolve = reaction.resolve
	        , reject  = reaction.reject
	        , domain  = reaction.domain
	        , result, then;
	      try {
	        if(handler){
	          if(!ok){
	            if(promise._h == 2)onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if(handler === true)result = value;
	          else {
	            if(domain)domain.enter();
	            result = handler(value);
	            if(domain)domain.exit();
	          }
	          if(result === reaction.promise){
	            reject(TypeError('Promise-chain cycle'));
	          } else if(then = isThenable(result)){
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch(e){
	        reject(e);
	      }
	    };
	    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if(isReject && !promise._h)onUnhandled(promise);
	  });
	};
	var onUnhandled = function(promise){
	  task.call(global, function(){
	    var value = promise._v
	      , abrupt, handler, console;
	    if(isUnhandled(promise)){
	      abrupt = perform(function(){
	        if(isNode){
	          process.emit('unhandledRejection', value, promise);
	        } else if(handler = global.onunhandledrejection){
	          handler({promise: promise, reason: value});
	        } else if((console = global.console) && console.error){
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if(abrupt)throw abrupt.error;
	  });
	};
	var isUnhandled = function(promise){
	  if(promise._h == 1)return false;
	  var chain = promise._a || promise._c
	    , i     = 0
	    , reaction;
	  while(chain.length > i){
	    reaction = chain[i++];
	    if(reaction.fail || !isUnhandled(reaction.promise))return false;
	  } return true;
	};
	var onHandleUnhandled = function(promise){
	  task.call(global, function(){
	    var handler;
	    if(isNode){
	      process.emit('rejectionHandled', promise);
	    } else if(handler = global.onrejectionhandled){
	      handler({promise: promise, reason: promise._v});
	    }
	  });
	};
	var $reject = function(value){
	  var promise = this;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if(!promise._a)promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function(value){
	  var promise = this
	    , then;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if(promise === value)throw TypeError("Promise can't be resolved itself");
	    if(then = isThenable(value)){
	      microtask(function(){
	        var wrapper = {_w: promise, _d: false}; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch(e){
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch(e){
	    $reject.call({_w: promise, _d: false}, e); // wrap
	  }
	};
	
	// constructor polyfill
	if(!USE_NATIVE){
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor){
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch(err){
	      $reject.call(this, err);
	    }
	  };
	  Internal = function Promise(executor){
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(213)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected){
	      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail   = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if(this._a)this._a.push(reaction);
	      if(this._s)notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function(onRejected){
	      return this.then(undefined, onRejected);
	    }
	  });
	  PromiseCapability = function(){
	    var promise  = new Internal;
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject  = ctx($reject, promise, 1);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
	__webpack_require__(27)($Promise, PROMISE);
	__webpack_require__(195)(PROMISE);
	Wrapper = __webpack_require__(12)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r){
	    var capability = newPromiseCapability(this)
	      , $$reject   = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x){
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
	    var capability = newPromiseCapability(this)
	      , $$resolve  = capability.resolve;
	    $$resolve(x);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(168)(function(iter){
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , resolve    = capability.resolve
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      var values    = []
	        , index     = 0
	        , remaining = 1;
	      forOf(iterable, false, function(promise){
	        var $index        = index++
	          , alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function(value){
	          if(alreadyCalled)return;
	          alreadyCalled  = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      forOf(iterable, false, function(promise){
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  }
	});

/***/ },
/* 208 */
/***/ function(module, exports) {

	module.exports = function(it, Constructor, name, forbiddenField){
	  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(23)
	  , call        = __webpack_require__(164)
	  , isArrayIter = __webpack_require__(165)
	  , anObject    = __webpack_require__(15)
	  , toLength    = __webpack_require__(40)
	  , getIterFn   = __webpack_require__(167)
	  , BREAK       = {}
	  , RETURN      = {};
	var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
	  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator, result;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if(result === BREAK || result === RETURN)return result;
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    result = call(iterator, f, step.value, entries);
	    if(result === BREAK || result === RETURN)return result;
	  }
	};
	exports.BREAK  = BREAK;
	exports.RETURN = RETURN;

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject  = __webpack_require__(15)
	  , aFunction = __webpack_require__(24)
	  , SPECIES   = __webpack_require__(28)('species');
	module.exports = function(O, D){
	  var C = anObject(O).constructor, S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	var ctx                = __webpack_require__(23)
	  , invoke             = __webpack_require__(81)
	  , html               = __webpack_require__(51)
	  , cel                = __webpack_require__(18)
	  , global             = __webpack_require__(7)
	  , process            = global.process
	  , setTask            = global.setImmediate
	  , clearTask          = global.clearImmediate
	  , MessageChannel     = global.MessageChannel
	  , counter            = 0
	  , queue              = {}
	  , ONREADYSTATECHANGE = 'onreadystatechange'
	  , defer, channel, port;
	var run = function(){
	  var id = +this;
	  if(queue.hasOwnProperty(id)){
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function(event){
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if(!setTask || !clearTask){
	  setTask = function setImmediate(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id){
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if(__webpack_require__(37)(process) == 'process'){
	    defer = function(id){
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if(MessageChannel){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
	    defer = function(id){
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if(ONREADYSTATECHANGE in cel('script')){
	    defer = function(id){
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set:   setTask,
	  clear: clearTask
	};

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(7)
	  , macrotask = __webpack_require__(211).set
	  , Observer  = global.MutationObserver || global.WebKitMutationObserver
	  , process   = global.process
	  , Promise   = global.Promise
	  , isNode    = __webpack_require__(37)(process) == 'process';
	
	module.exports = function(){
	  var head, last, notify;
	
	  var flush = function(){
	    var parent, fn;
	    if(isNode && (parent = process.domain))parent.exit();
	    while(head){
	      fn   = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch(e){
	        if(head)notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if(parent)parent.enter();
	  };
	
	  // Node.js
	  if(isNode){
	    notify = function(){
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver
	  } else if(Observer){
	    var toggle = true
	      , node   = document.createTextNode('');
	    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
	    notify = function(){
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if(Promise && Promise.resolve){
	    var promise = Promise.resolve();
	    notify = function(){
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function(){
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function(fn){
	    var task = {fn: fn, next: undefined};
	    if(last)last.next = task;
	    if(!head){
	      head = task;
	      notify();
	    } last = task;
	  };
	};

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(21);
	module.exports = function(target, src, safe){
	  for(var key in src)redefine(target, key, src[key], safe);
	  return target;
	};

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(215);
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(216)('Map', function(get){
	  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key){
	    var entry = strong.getEntry(this, key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value){
	    return strong.def(this, key === 0 ? 0 : key, value);
	  }
	}, strong, true);

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var dP          = __webpack_require__(14).f
	  , create      = __webpack_require__(49)
	  , redefineAll = __webpack_require__(213)
	  , ctx         = __webpack_require__(23)
	  , anInstance  = __webpack_require__(208)
	  , defined     = __webpack_require__(38)
	  , forOf       = __webpack_require__(209)
	  , $iterDefine = __webpack_require__(131)
	  , step        = __webpack_require__(197)
	  , setSpecies  = __webpack_require__(195)
	  , DESCRIPTORS = __webpack_require__(9)
	  , fastKey     = __webpack_require__(25).fastKey
	  , SIZE        = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function(that, key){
	  // fast case
	  var index = fastKey(key), entry;
	  if(index !== 'F')return that._i[index];
	  // frozen object case
	  for(entry = that._f; entry; entry = entry.n){
	    if(entry.k == key)return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear(){
	        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
	          entry.r = true;
	          if(entry.p)entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function(key){
	        var that  = this
	          , entry = getEntry(that, key);
	        if(entry){
	          var next = entry.n
	            , prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if(prev)prev.n = next;
	          if(next)next.p = prev;
	          if(that._f == entry)that._f = next;
	          if(that._l == entry)that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /*, that = undefined */){
	        anInstance(this, C, 'forEach');
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
	          , entry;
	        while(entry = entry ? entry.n : this._f){
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while(entry && entry.r)entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key){
	        return !!getEntry(this, key);
	      }
	    });
	    if(DESCRIPTORS)dP(C.prototype, 'size', {
	      get: function(){
	        return defined(this[SIZE]);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var entry = getEntry(that, key)
	      , prev, index;
	    // change existing entry
	    if(entry){
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if(!that._f)that._f = entry;
	      if(prev)prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if(index !== 'F')that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function(C, NAME, IS_MAP){
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function(iterated, kind){
	      this._t = iterated;  // target
	      this._k = kind;      // kind
	      this._l = undefined; // previous
	    }, function(){
	      var that  = this
	        , kind  = that._k
	        , entry = that._l;
	      // revert to the last existing entry
	      while(entry && entry.r)entry = entry.p;
	      // get next entry
	      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if(kind == 'keys'  )return step(0, entry.k);
	      if(kind == 'values')return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(7)
	  , $export           = __webpack_require__(11)
	  , redefine          = __webpack_require__(21)
	  , redefineAll       = __webpack_require__(213)
	  , meta              = __webpack_require__(25)
	  , forOf             = __webpack_require__(209)
	  , anInstance        = __webpack_require__(208)
	  , isObject          = __webpack_require__(16)
	  , fails             = __webpack_require__(10)
	  , $iterDetect       = __webpack_require__(168)
	  , setToStringTag    = __webpack_require__(27)
	  , inheritIfRequired = __webpack_require__(91);
	
	module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = global[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  var fixMethod = function(KEY){
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a){
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
	    new C().entries().next();
	  }))){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance             = new C
	      // early implementations not supports chaining
	      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
	      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
	      // most early implementations doesn't supports iterables, most modern - not close it correctly
	      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
	      // for early implementations -0 and +0 not the same
	      , BUGGY_ZERO = !IS_WEAK && fails(function(){
	        // V8 ~ Chromium 42- fails only with 5+ elements
	        var $instance = new C()
	          , index     = 5;
	        while(index--)$instance[ADDER](index, index);
	        return !$instance.has(-0);
	      });
	    if(!ACCEPT_ITERABLES){ 
	      C = wrapper(function(target, iterable){
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base, target, C);
	        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if(IS_WEAK && proto.clear)delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(215);
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(216)('Set', function(get){
	  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value){
	    return strong.def(this, value = value === 0 ? 0 : value, value);
	  }
	}, strong);

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var each         = __webpack_require__(175)(0)
	  , redefine     = __webpack_require__(21)
	  , meta         = __webpack_require__(25)
	  , assign       = __webpack_require__(72)
	  , weak         = __webpack_require__(219)
	  , isObject     = __webpack_require__(16)
	  , getWeak      = meta.getWeak
	  , isExtensible = Object.isExtensible
	  , uncaughtFrozenStore = weak.ufstore
	  , tmp          = {}
	  , InternalMap;
	
	var wrapper = function(get){
	  return function WeakMap(){
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key){
	    if(isObject(key)){
	      var data = getWeak(key);
	      if(data === true)return uncaughtFrozenStore(this).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value){
	    return weak.def(this, key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(216)('WeakMap', wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
	  InternalMap = weak.getConstructor(wrapper);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function(key){
	    var proto  = $WeakMap.prototype
	      , method = proto[key];
	    redefine(proto, key, function(a, b){
	      // store frozen objects on internal weakmap shim
	      if(isObject(a) && !isExtensible(a)){
	        if(!this._f)this._f = new InternalMap;
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll       = __webpack_require__(213)
	  , getWeak           = __webpack_require__(25).getWeak
	  , anObject          = __webpack_require__(15)
	  , isObject          = __webpack_require__(16)
	  , anInstance        = __webpack_require__(208)
	  , forOf             = __webpack_require__(209)
	  , createArrayMethod = __webpack_require__(175)
	  , $has              = __webpack_require__(8)
	  , arrayFind         = createArrayMethod(5)
	  , arrayFindIndex    = createArrayMethod(6)
	  , id                = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function(that){
	  return that._l || (that._l = new UncaughtFrozenStore);
	};
	var UncaughtFrozenStore = function(){
	  this.a = [];
	};
	var findUncaughtFrozen = function(store, key){
	  return arrayFind(store.a, function(it){
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function(key){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)return entry[1];
	  },
	  has: function(key){
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function(key, value){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function(key){
	    var index = arrayFindIndex(this.a, function(it){
	      return it[0] === key;
	    });
	    if(~index)this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this)['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var data = getWeak(anObject(key), true);
	    if(data === true)uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(219);
	
	// 23.4 WeakSet Objects
	__webpack_require__(216)('WeakSet', function(get){
	  return function WeakSet(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value){
	    return weak.def(this, value, true);
	  }
	}, weak, false, true);

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(11)
	  , $typed       = __webpack_require__(222)
	  , buffer       = __webpack_require__(223)
	  , anObject     = __webpack_require__(15)
	  , toIndex      = __webpack_require__(42)
	  , toLength     = __webpack_require__(40)
	  , isObject     = __webpack_require__(16)
	  , ArrayBuffer  = __webpack_require__(7).ArrayBuffer
	  , speciesConstructor = __webpack_require__(210)
	  , $ArrayBuffer = buffer.ArrayBuffer
	  , $DataView    = buffer.DataView
	  , $isView      = $typed.ABV && ArrayBuffer.isView
	  , $slice       = $ArrayBuffer.prototype.slice
	  , VIEW         = $typed.VIEW
	  , ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), {ArrayBuffer: $ArrayBuffer});
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it){
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(10)(function(){
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end){
	    if($slice !== undefined && end === undefined)return $slice.call(anObject(this), start); // FF fix
	    var len    = anObject(this).byteLength
	      , first  = toIndex(start, len)
	      , final  = toIndex(end === undefined ? len : end, len)
	      , result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first))
	      , viewS  = new $DataView(this)
	      , viewT  = new $DataView(result)
	      , index  = 0;
	    while(first < final){
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(195)(ARRAY_BUFFER);

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(7)
	  , hide   = __webpack_require__(13)
	  , uid    = __webpack_require__(22)
	  , TYPED  = uid('typed_array')
	  , VIEW   = uid('view')
	  , ABV    = !!(global.ArrayBuffer && global.DataView)
	  , CONSTR = ABV
	  , i = 0, l = 9, Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while(i < l){
	  if(Typed = global[TypedArrayConstructors[i++]]){
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV:    ABV,
	  CONSTR: CONSTR,
	  TYPED:  TYPED,
	  VIEW:   VIEW
	};

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global         = __webpack_require__(7)
	  , DESCRIPTORS    = __webpack_require__(9)
	  , LIBRARY        = __webpack_require__(31)
	  , $typed         = __webpack_require__(222)
	  , hide           = __webpack_require__(13)
	  , redefineAll    = __webpack_require__(213)
	  , fails          = __webpack_require__(10)
	  , anInstance     = __webpack_require__(208)
	  , toInteger      = __webpack_require__(41)
	  , toLength       = __webpack_require__(40)
	  , gOPN           = __webpack_require__(53).f
	  , dP             = __webpack_require__(14).f
	  , arrayFill      = __webpack_require__(191)
	  , setToStringTag = __webpack_require__(27)
	  , ARRAY_BUFFER   = 'ArrayBuffer'
	  , DATA_VIEW      = 'DataView'
	  , PROTOTYPE      = 'prototype'
	  , WRONG_LENGTH   = 'Wrong length!'
	  , WRONG_INDEX    = 'Wrong index!'
	  , $ArrayBuffer   = global[ARRAY_BUFFER]
	  , $DataView      = global[DATA_VIEW]
	  , Math           = global.Math
	  , RangeError     = global.RangeError
	  , Infinity       = global.Infinity
	  , BaseBuffer     = $ArrayBuffer
	  , abs            = Math.abs
	  , pow            = Math.pow
	  , floor          = Math.floor
	  , log            = Math.log
	  , LN2            = Math.LN2
	  , BUFFER         = 'buffer'
	  , BYTE_LENGTH    = 'byteLength'
	  , BYTE_OFFSET    = 'byteOffset'
	  , $BUFFER        = DESCRIPTORS ? '_b' : BUFFER
	  , $LENGTH        = DESCRIPTORS ? '_l' : BYTE_LENGTH
	  , $OFFSET        = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	var packIEEE754 = function(value, mLen, nBytes){
	  var buffer = Array(nBytes)
	    , eLen   = nBytes * 8 - mLen - 1
	    , eMax   = (1 << eLen) - 1
	    , eBias  = eMax >> 1
	    , rt     = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0
	    , i      = 0
	    , s      = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0
	    , e, m, c;
	  value = abs(value)
	  if(value != value || value === Infinity){
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if(value * (c = pow(2, -e)) < 1){
	      e--;
	      c *= 2;
	    }
	    if(e + eBias >= 1){
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if(value * c >= 2){
	      e++;
	      c /= 2;
	    }
	    if(e + eBias >= eMax){
	      m = 0;
	      e = eMax;
	    } else if(e + eBias >= 1){
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for(; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for(; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	};
	var unpackIEEE754 = function(buffer, mLen, nBytes){
	  var eLen  = nBytes * 8 - mLen - 1
	    , eMax  = (1 << eLen) - 1
	    , eBias = eMax >> 1
	    , nBits = eLen - 7
	    , i     = nBytes - 1
	    , s     = buffer[i--]
	    , e     = s & 127
	    , m;
	  s >>= 7;
	  for(; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for(; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if(e === 0){
	    e = 1 - eBias;
	  } else if(e === eMax){
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	};
	
	var unpackI32 = function(bytes){
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	};
	var packI8 = function(it){
	  return [it & 0xff];
	};
	var packI16 = function(it){
	  return [it & 0xff, it >> 8 & 0xff];
	};
	var packI32 = function(it){
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	};
	var packF64 = function(it){
	  return packIEEE754(it, 52, 8);
	};
	var packF32 = function(it){
	  return packIEEE754(it, 23, 4);
	};
	
	var addGetter = function(C, key, internal){
	  dP(C[PROTOTYPE], key, {get: function(){ return this[internal]; }});
	};
	
	var get = function(view, bytes, index, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	};
	var set = function(view, bytes, index, conversion, value, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = conversion(+value);
	  for(var i = 0; i < bytes; i++)store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	};
	
	var validateArrayBufferArguments = function(that, length){
	  anInstance(that, $ArrayBuffer, ARRAY_BUFFER);
	  var numberLength = +length
	    , byteLength   = toLength(numberLength);
	  if(numberLength != byteLength)throw RangeError(WRONG_LENGTH);
	  return byteLength;
	};
	
	if(!$typed.ABV){
	  $ArrayBuffer = function ArrayBuffer(length){
	    var byteLength = validateArrayBufferArguments(this, length);
	    this._b       = arrayFill.call(Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength){
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH]
	      , offset       = toInteger(byteOffset);
	    if(offset < 0 || offset > bufferLength)throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if(offset + byteLength > bufferLength)throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if(DESCRIPTORS){
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset){
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset){
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /*, littleEndian */){
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if(!fails(function(){
	    new $ArrayBuffer;     // eslint-disable-line no-new
	  }) || !fails(function(){
	    new $ArrayBuffer(.5); // eslint-disable-line no-new
	  })){
	    $ArrayBuffer = function ArrayBuffer(length){
	      return new BaseBuffer(validateArrayBufferArguments(this, length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for(var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j; ){
	      if(!((key = keys[j++]) in $ArrayBuffer))hide($ArrayBuffer, key, BaseBuffer[key]);
	    };
	    if(!LIBRARY)ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2))
	    , $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if(view.getInt8(0) || !view.getInt8(1))redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(11);
	$export($export.G + $export.W + $export.F * !__webpack_require__(222).ABV, {
	  DataView: __webpack_require__(223).DataView
	});

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(226)('Int8', 1, function(init){
	  return function Int8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	if(__webpack_require__(9)){
	  var LIBRARY             = __webpack_require__(31)
	    , global              = __webpack_require__(7)
	    , fails               = __webpack_require__(10)
	    , $export             = __webpack_require__(11)
	    , $typed              = __webpack_require__(222)
	    , $buffer             = __webpack_require__(223)
	    , ctx                 = __webpack_require__(23)
	    , anInstance          = __webpack_require__(208)
	    , propertyDesc        = __webpack_require__(20)
	    , hide                = __webpack_require__(13)
	    , redefineAll         = __webpack_require__(213)
	    , toInteger           = __webpack_require__(41)
	    , toLength            = __webpack_require__(40)
	    , toIndex             = __webpack_require__(42)
	    , toPrimitive         = __webpack_require__(19)
	    , has                 = __webpack_require__(8)
	    , same                = __webpack_require__(74)
	    , classof             = __webpack_require__(78)
	    , isObject            = __webpack_require__(16)
	    , toObject            = __webpack_require__(61)
	    , isArrayIter         = __webpack_require__(165)
	    , create              = __webpack_require__(49)
	    , getPrototypeOf      = __webpack_require__(62)
	    , gOPN                = __webpack_require__(53).f
	    , getIterFn           = __webpack_require__(167)
	    , uid                 = __webpack_require__(22)
	    , wks                 = __webpack_require__(28)
	    , createArrayMethod   = __webpack_require__(175)
	    , createArrayIncludes = __webpack_require__(39)
	    , speciesConstructor  = __webpack_require__(210)
	    , ArrayIterators      = __webpack_require__(196)
	    , Iterators           = __webpack_require__(132)
	    , $iterDetect         = __webpack_require__(168)
	    , setSpecies          = __webpack_require__(195)
	    , arrayFill           = __webpack_require__(191)
	    , arrayCopyWithin     = __webpack_require__(188)
	    , $DP                 = __webpack_require__(14)
	    , $GOPD               = __webpack_require__(54)
	    , dP                  = $DP.f
	    , gOPD                = $GOPD.f
	    , RangeError          = global.RangeError
	    , TypeError           = global.TypeError
	    , Uint8Array          = global.Uint8Array
	    , ARRAY_BUFFER        = 'ArrayBuffer'
	    , SHARED_BUFFER       = 'Shared' + ARRAY_BUFFER
	    , BYTES_PER_ELEMENT   = 'BYTES_PER_ELEMENT'
	    , PROTOTYPE           = 'prototype'
	    , ArrayProto          = Array[PROTOTYPE]
	    , $ArrayBuffer        = $buffer.ArrayBuffer
	    , $DataView           = $buffer.DataView
	    , arrayForEach        = createArrayMethod(0)
	    , arrayFilter         = createArrayMethod(2)
	    , arraySome           = createArrayMethod(3)
	    , arrayEvery          = createArrayMethod(4)
	    , arrayFind           = createArrayMethod(5)
	    , arrayFindIndex      = createArrayMethod(6)
	    , arrayIncludes       = createArrayIncludes(true)
	    , arrayIndexOf        = createArrayIncludes(false)
	    , arrayValues         = ArrayIterators.values
	    , arrayKeys           = ArrayIterators.keys
	    , arrayEntries        = ArrayIterators.entries
	    , arrayLastIndexOf    = ArrayProto.lastIndexOf
	    , arrayReduce         = ArrayProto.reduce
	    , arrayReduceRight    = ArrayProto.reduceRight
	    , arrayJoin           = ArrayProto.join
	    , arraySort           = ArrayProto.sort
	    , arraySlice          = ArrayProto.slice
	    , arrayToString       = ArrayProto.toString
	    , arrayToLocaleString = ArrayProto.toLocaleString
	    , ITERATOR            = wks('iterator')
	    , TAG                 = wks('toStringTag')
	    , TYPED_CONSTRUCTOR   = uid('typed_constructor')
	    , DEF_CONSTRUCTOR     = uid('def_constructor')
	    , ALL_CONSTRUCTORS    = $typed.CONSTR
	    , TYPED_ARRAY         = $typed.TYPED
	    , VIEW                = $typed.VIEW
	    , WRONG_LENGTH        = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function(O, length){
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function(){
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function(){
	    new Uint8Array(1).set({});
	  });
	
	  var strictToLength = function(it, SAME){
	    if(it === undefined)throw TypeError(WRONG_LENGTH);
	    var number = +it
	      , length = toLength(it);
	    if(SAME && !same(number, length))throw RangeError(WRONG_LENGTH);
	    return length;
	  };
	
	  var toOffset = function(it, BYTES){
	    var offset = toInteger(it);
	    if(offset < 0 || offset % BYTES)throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function(it){
	    if(isObject(it) && TYPED_ARRAY in it)return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function(C, length){
	    if(!(isObject(C) && TYPED_CONSTRUCTOR in C)){
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function(O, list){
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function(C, list){
	    var index  = 0
	      , length = list.length
	      , result = allocate(C, length);
	    while(length > index)result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function(it, key, internal){
	    dP(it, key, {get: function(){ return this._d[internal]; }});
	  };
	
	  var $from = function from(source /*, mapfn, thisArg */){
	    var O       = toObject(source)
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , iterFn  = getIterFn(O)
	      , i, length, values, result, step, iterator;
	    if(iterFn != undefined && !isArrayIter(iterFn)){
	      for(iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++){
	        values.push(step.value);
	      } O = values;
	    }
	    if(mapping && aLen > 2)mapfn = ctx(mapfn, arguments[2], 2);
	    for(i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++){
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/*...items*/){
	    var index  = 0
	      , length = arguments.length
	      , result = allocate(this, length);
	    while(length > index)result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function(){ arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString(){
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /*, end */){
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /*, thisArg */){
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /*, start, end */){ // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /*, thisArg */){
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /*, thisArg */){
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /*, thisArg */){
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /*, thisArg */){
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /*, fromIndex */){
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /*, fromIndex */){
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator){ // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /*, fromIndex */){ // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /*, thisArg */){
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse(){
	      var that   = this
	        , length = validate(that).length
	        , middle = Math.floor(length / 2)
	        , index  = 0
	        , value;
	      while(index < middle){
	        value         = that[index];
	        that[index++] = that[--length];
	        that[length]  = value;
	      } return that;
	    },
	    some: function some(callbackfn /*, thisArg */){
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn){
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end){
	      var O      = validate(this)
	        , length = O.length
	        , $begin = toIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end){
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /*, offset */){
	    validate(this);
	    var offset = toOffset(arguments[1], 1)
	      , length = this.length
	      , src    = toObject(arrayLike)
	      , len    = toLength(src.length)
	      , index  = 0;
	    if(len + offset > length)throw RangeError(WRONG_LENGTH);
	    while(index < len)this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries(){
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys(){
	      return arrayKeys.call(validate(this));
	    },
	    values: function values(){
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function(target, key){
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key){
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc){
	    if(isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ){
	      target[key] = desc.value;
	      return target;
	    } else return dP(target, key, desc);
	  };
	
	  if(!ALL_CONSTRUCTORS){
	    $GOPD.f = $getDesc;
	    $DP.f   = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty:           $setDesc
	  });
	
	  if(fails(function(){ arrayToString.call({}); })){
	    arrayToString = arrayToLocaleString = function toString(){
	      return arrayJoin.call(this);
	    }
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice:          $slice,
	    set:            $set,
	    constructor:    function(){ /* noop */ },
	    toString:       arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function(){ return this[TYPED_ARRAY]; }
	  });
	
	  module.exports = function(KEY, BYTES, wrapper, CLAMPED){
	    CLAMPED = !!CLAMPED;
	    var NAME       = KEY + (CLAMPED ? 'Clamped' : '') + 'Array'
	      , ISNT_UINT8 = NAME != 'Uint8Array'
	      , GETTER     = 'get' + KEY
	      , SETTER     = 'set' + KEY
	      , TypedArray = global[NAME]
	      , Base       = TypedArray || {}
	      , TAC        = TypedArray && getPrototypeOf(TypedArray)
	      , FORCED     = !TypedArray || !$typed.ABV
	      , O          = {}
	      , TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function(that, index){
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function(that, index, value){
	      var data = that._d;
	      if(CLAMPED)value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function(that, index){
	      dP(that, index, {
	        get: function(){
	          return getter(this, index);
	        },
	        set: function(value){
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if(FORCED){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME, '_d');
	        var index  = 0
	          , offset = 0
	          , buffer, byteLength, length, klass;
	        if(!isObject(data)){
	          length     = strictToLength(data, true)
	          byteLength = length * BYTES;
	          buffer     = new $ArrayBuffer(byteLength);
	        } else if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if($length === undefined){
	            if($len % BYTES)throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if(byteLength < 0)throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if(byteLength + offset > $len)throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if(TYPED_ARRAY in data){
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while(index < length)addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if(!$iterDetect(function(iter){
	      // V8 works with iterators, but fails in many other cases
	      // https://code.google.com/p/v8/issues/detail?id=4552
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if(!isObject(data))return new Base(strictToLength(data, ISNT_UINT8));
	        if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if(TYPED_ARRAY in data)return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function(key){
	        if(!(key in TypedArray))hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if(!LIBRARY)TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator   = TypedArrayPrototype[ITERATOR]
	      , CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined)
	      , $iterator         = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if(CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)){
	      dP(TypedArrayPrototype, TAG, {
	        get: function(){ return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES,
	      from: $from,
	      of: $of
	    });
	
	    if(!(BYTES_PER_ELEMENT in TypedArrayPrototype))hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, {set: $set});
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    $export($export.P + $export.F * (TypedArrayPrototype.toString != arrayToString), NAME, {toString: arrayToString});
	
	    $export($export.P + $export.F * fails(function(){
	      new TypedArray(1).slice();
	    }), NAME, {slice: $slice});
	
	    $export($export.P + $export.F * (fails(function(){
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString()
	    }) || !fails(function(){
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, {toLocaleString: $toLocaleString});
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if(!LIBRARY && !CORRECT_ITER_NAME)hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function(){ /* empty */ };

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(226)('Uint8', 1, function(init){
	  return function Uint8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(226)('Uint8', 1, function(init){
	  return function Uint8ClampedArray(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	}, true);

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(226)('Int16', 2, function(init){
	  return function Int16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(226)('Uint16', 2, function(init){
	  return function Uint16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(226)('Int32', 4, function(init){
	  return function Int32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(226)('Uint32', 4, function(init){
	  return function Uint32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(226)('Float32', 4, function(init){
	  return function Float32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(226)('Float64', 8, function(init){
	  return function Float64Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export   = __webpack_require__(11)
	  , aFunction = __webpack_require__(24)
	  , anObject  = __webpack_require__(15)
	  , rApply    = (__webpack_require__(7).Reflect || {}).apply
	  , fApply    = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(10)(function(){
	  rApply(function(){});
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList){
	    var T = aFunction(target)
	      , L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export    = __webpack_require__(11)
	  , create     = __webpack_require__(49)
	  , aFunction  = __webpack_require__(24)
	  , anObject   = __webpack_require__(15)
	  , isObject   = __webpack_require__(16)
	  , fails      = __webpack_require__(10)
	  , bind       = __webpack_require__(80)
	  , rConstruct = (__webpack_require__(7).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function(){
	  function F(){}
	  return !(rConstruct(function(){}, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function(){
	  rConstruct(function(){});
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /*, newTarget*/){
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if(ARGS_BUG && !NEW_TARGET_BUG)return rConstruct(Target, args, newTarget);
	    if(Target == newTarget){
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch(args.length){
	        case 0: return new Target;
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args));
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto    = newTarget.prototype
	      , instance = create(isObject(proto) ? proto : Object.prototype)
	      , result   = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP          = __webpack_require__(14)
	  , $export     = __webpack_require__(11)
	  , anObject    = __webpack_require__(15)
	  , toPrimitive = __webpack_require__(19);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(10)(function(){
	  Reflect.defineProperty(dP.f({}, 1, {value: 1}), 1, {value: 2});
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes){
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export  = __webpack_require__(11)
	  , gOPD     = __webpack_require__(54).f
	  , anObject = __webpack_require__(15);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey){
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export  = __webpack_require__(11)
	  , anObject = __webpack_require__(15);
	var Enumerate = function(iterated){
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = []       // keys
	    , key;
	  for(key in iterated)keys.push(key);
	};
	__webpack_require__(133)(Enumerate, 'Object', function(){
	  var that = this
	    , keys = that._k
	    , key;
	  do {
	    if(that._i >= keys.length)return {value: undefined, done: true};
	  } while(!((key = keys[that._i++]) in that._t));
	  return {value: key, done: false};
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target){
	    return new Enumerate(target);
	  }
	});

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD           = __webpack_require__(54)
	  , getPrototypeOf = __webpack_require__(62)
	  , has            = __webpack_require__(8)
	  , $export        = __webpack_require__(11)
	  , isObject       = __webpack_require__(16)
	  , anObject       = __webpack_require__(15);
	
	function get(target, propertyKey/*, receiver*/){
	  var receiver = arguments.length < 3 ? target : arguments[2]
	    , desc, proto;
	  if(anObject(target) === receiver)return target[propertyKey];
	  if(desc = gOPD.f(target, propertyKey))return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if(isObject(proto = getPrototypeOf(target)))return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', {get: get});

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD     = __webpack_require__(54)
	  , $export  = __webpack_require__(11)
	  , anObject = __webpack_require__(15);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export  = __webpack_require__(11)
	  , getProto = __webpack_require__(62)
	  , anObject = __webpack_require__(15);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target){
	    return getProto(anObject(target));
	  }
	});

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey){
	    return propertyKey in target;
	  }
	});

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export       = __webpack_require__(11)
	  , anObject      = __webpack_require__(15)
	  , $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target){
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Reflect', {ownKeys: __webpack_require__(246)});

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN     = __webpack_require__(53)
	  , gOPS     = __webpack_require__(46)
	  , anObject = __webpack_require__(15)
	  , Reflect  = __webpack_require__(7).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it){
	  var keys       = gOPN.f(anObject(it))
	    , getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export            = __webpack_require__(11)
	  , anObject           = __webpack_require__(15)
	  , $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target){
	    anObject(target);
	    try {
	      if($preventExtensions)$preventExtensions(target);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP             = __webpack_require__(14)
	  , gOPD           = __webpack_require__(54)
	  , getPrototypeOf = __webpack_require__(62)
	  , has            = __webpack_require__(8)
	  , $export        = __webpack_require__(11)
	  , createDesc     = __webpack_require__(20)
	  , anObject       = __webpack_require__(15)
	  , isObject       = __webpack_require__(16);
	
	function set(target, propertyKey, V/*, receiver*/){
	  var receiver = arguments.length < 4 ? target : arguments[3]
	    , ownDesc  = gOPD.f(anObject(target), propertyKey)
	    , existingDescriptor, proto;
	  if(!ownDesc){
	    if(isObject(proto = getPrototypeOf(target))){
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if(has(ownDesc, 'value')){
	    if(ownDesc.writable === false || !isObject(receiver))return false;
	    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    dP.f(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', {set: set});

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export  = __webpack_require__(11)
	  , setProto = __webpack_require__(76);
	
	if(setProto)$export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto){
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export   = __webpack_require__(11)
	  , $includes = __webpack_require__(39)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /*, fromIndex = 0 */){
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(189)('includes');

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(11)
	  , $at     = __webpack_require__(130)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos){
	    return $at(this, pos);
	  }
	});

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(11)
	  , $pad    = __webpack_require__(253);
	
	$export($export.P, 'String', {
	  padStart: function padStart(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(40)
	  , repeat   = __webpack_require__(94)
	  , defined  = __webpack_require__(38);
	
	module.exports = function(that, maxLength, fillString, left){
	  var S            = String(defined(that))
	    , stringLength = S.length
	    , fillStr      = fillString === undefined ? ' ' : String(fillString)
	    , intMaxLength = toLength(maxLength);
	  if(intMaxLength <= stringLength || fillStr == '')return S;
	  var fillLen = intMaxLength - stringLength
	    , stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if(stringFiller.length > fillLen)stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(11)
	  , $pad    = __webpack_require__(253);
	
	$export($export.P, 'String', {
	  padEnd: function padEnd(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(86)('trimLeft', function($trim){
	  return function trimLeft(){
	    return $trim(this, 1);
	  };
	}, 'trimStart');

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(86)('trimRight', function($trim){
	  return function trimRight(){
	    return $trim(this, 2);
	  };
	}, 'trimEnd');

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export     = __webpack_require__(11)
	  , defined     = __webpack_require__(38)
	  , toLength    = __webpack_require__(40)
	  , isRegExp    = __webpack_require__(137)
	  , getFlags    = __webpack_require__(199)
	  , RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function(regexp, string){
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(133)($RegExpStringIterator, 'RegExp String', function next(){
	  var match = this._r.exec(this._s);
	  return {value: match, done: match === null};
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp){
	    defined(this);
	    if(!isRegExp(regexp))throw TypeError(regexp + ' is not a regexp!');
	    var S     = String(this)
	      , flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp)
	      , rx    = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(30)('asyncIterator');

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(30)('observable');

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export        = __webpack_require__(11)
	  , ownKeys        = __webpack_require__(246)
	  , toIObject      = __webpack_require__(35)
	  , gOPD           = __webpack_require__(54)
	  , createProperty = __webpack_require__(166);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
	    var O       = toIObject(object)
	      , getDesc = gOPD.f
	      , keys    = ownKeys(O)
	      , result  = {}
	      , i       = 0
	      , key;
	    while(keys.length > i)createProperty(result, key = keys[i++], getDesc(O, key));
	    return result;
	  }
	});

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(11)
	  , $values = __webpack_require__(262)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it){
	    return $values(it);
	  }
	});

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(33)
	  , toIObject = __webpack_require__(35)
	  , isEnum    = __webpack_require__(47).f;
	module.exports = function(isEntries){
	  return function(it){
	    var O      = toIObject(it)
	      , keys   = getKeys(O)
	      , length = keys.length
	      , i      = 0
	      , result = []
	      , key;
	    while(length > i)if(isEnum.call(O, key = keys[i++])){
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export  = __webpack_require__(11)
	  , $entries = __webpack_require__(262)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it){
	    return $entries(it);
	  }
	});

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(11)
	  , toObject        = __webpack_require__(61)
	  , aFunction       = __webpack_require__(24)
	  , $defineProperty = __webpack_require__(14);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(9) && $export($export.P + __webpack_require__(265), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter){
	    $defineProperty.f(toObject(this), P, {get: aFunction(getter), enumerable: true, configurable: true});
	  }
	});

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(31)|| !__webpack_require__(10)(function(){
	  var K = Math.random();
	  // In FF throws only define methods
	  __defineSetter__.call(null, K, function(){ /* empty */});
	  delete __webpack_require__(7)[K];
	});

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(11)
	  , toObject        = __webpack_require__(61)
	  , aFunction       = __webpack_require__(24)
	  , $defineProperty = __webpack_require__(14);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(9) && $export($export.P + __webpack_require__(265), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter){
	    $defineProperty.f(toObject(this), P, {set: aFunction(setter), enumerable: true, configurable: true});
	  }
	});

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(11)
	  , toObject                 = __webpack_require__(61)
	  , toPrimitive              = __webpack_require__(19)
	  , getPrototypeOf           = __webpack_require__(62)
	  , getOwnPropertyDescriptor = __webpack_require__(54).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(9) && $export($export.P + __webpack_require__(265), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.get;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(11)
	  , toObject                 = __webpack_require__(61)
	  , toPrimitive              = __webpack_require__(19)
	  , getPrototypeOf           = __webpack_require__(62)
	  , getOwnPropertyDescriptor = __webpack_require__(54).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(9) && $export($export.P + __webpack_require__(265), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.set;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(11);
	
	$export($export.P + $export.R, 'Map', {toJSON: __webpack_require__(270)('Map')});

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(78)
	  , from    = __webpack_require__(271);
	module.exports = function(NAME){
	  return function toJSON(){
	    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(209);
	
	module.exports = function(iter, ITERATOR){
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(11);
	
	$export($export.P + $export.R, 'Set', {toJSON: __webpack_require__(270)('Set')});

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-global
	var $export = __webpack_require__(11);
	
	$export($export.S, 'System', {global: __webpack_require__(7)});

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(11)
	  , cof     = __webpack_require__(37);
	
	$export($export.S, 'Error', {
	  isError: function isError(it){
	    return cof(it) === 'Error';
	  }
	});

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >> 16
	      , v1 = $v >> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >>> 16
	      , v1 = $v >>> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(280)
	  , anObject                  = __webpack_require__(15)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey){
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	}});

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	var Map     = __webpack_require__(214)
	  , $export = __webpack_require__(11)
	  , shared  = __webpack_require__(26)('metadata')
	  , store   = shared.store || (shared.store = new (__webpack_require__(218)));
	
	var getOrCreateMetadataMap = function(target, targetKey, create){
	  var targetMetadata = store.get(target);
	  if(!targetMetadata){
	    if(!create)return undefined;
	    store.set(target, targetMetadata = new Map);
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if(!keyMetadata){
	    if(!create)return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map);
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P){
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function(target, targetKey){
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false)
	    , keys        = [];
	  if(metadataMap)metadataMap.forEach(function(_, key){ keys.push(key); });
	  return keys;
	};
	var toMetaKey = function(it){
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function(O){
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(280)
	  , anObject               = __webpack_require__(15)
	  , toMetaKey              = metadata.key
	  , getOrCreateMetadataMap = metadata.map
	  , store                  = metadata.store;
	
	metadata.exp({deleteMetadata: function deleteMetadata(metadataKey, target /*, targetKey */){
	  var targetKey   = arguments.length < 3 ? undefined : toMetaKey(arguments[2])
	    , metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if(metadataMap === undefined || !metadataMap['delete'](metadataKey))return false;
	  if(metadataMap.size)return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	}});

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(280)
	  , anObject               = __webpack_require__(15)
	  , getPrototypeOf         = __webpack_require__(62)
	  , ordinaryHasOwnMetadata = metadata.has
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	var ordinaryGetMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({getMetadata: function getMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	var Set                     = __webpack_require__(217)
	  , from                    = __webpack_require__(271)
	  , metadata                = __webpack_require__(280)
	  , anObject                = __webpack_require__(15)
	  , getPrototypeOf          = __webpack_require__(62)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	var ordinaryMetadataKeys = function(O, P){
	  var oKeys  = ordinaryOwnMetadataKeys(O, P)
	    , parent = getPrototypeOf(O);
	  if(parent === null)return oKeys;
	  var pKeys  = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({getMetadataKeys: function getMetadataKeys(target /*, targetKey */){
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(280)
	  , anObject               = __webpack_require__(15)
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	metadata.exp({getOwnMetadata: function getOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                = __webpack_require__(280)
	  , anObject                = __webpack_require__(15)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	metadata.exp({getOwnMetadataKeys: function getOwnMetadataKeys(target /*, targetKey */){
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(280)
	  , anObject               = __webpack_require__(15)
	  , getPrototypeOf         = __webpack_require__(62)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	var ordinaryHasMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({hasMetadata: function hasMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(280)
	  , anObject               = __webpack_require__(15)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	metadata.exp({hasOwnMetadata: function hasOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(280)
	  , anObject                  = __webpack_require__(15)
	  , aFunction                 = __webpack_require__(24)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({metadata: function metadata(metadataKey, metadataValue){
	  return function decorator(target, targetKey){
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	}});

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export   = __webpack_require__(11)
	  , microtask = __webpack_require__(212)()
	  , process   = __webpack_require__(7).process
	  , isNode    = __webpack_require__(37)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn){
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export     = __webpack_require__(11)
	  , global      = __webpack_require__(7)
	  , core        = __webpack_require__(12)
	  , microtask   = __webpack_require__(212)()
	  , OBSERVABLE  = __webpack_require__(28)('observable')
	  , aFunction   = __webpack_require__(24)
	  , anObject    = __webpack_require__(15)
	  , anInstance  = __webpack_require__(208)
	  , redefineAll = __webpack_require__(213)
	  , hide        = __webpack_require__(13)
	  , forOf       = __webpack_require__(209)
	  , RETURN      = forOf.RETURN;
	
	var getMethod = function(fn){
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function(subscription){
	  var cleanup = subscription._c;
	  if(cleanup){
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function(subscription){
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function(subscription){
	  if(!subscriptionClosed(subscription)){
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function(observer, subscriber){
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup      = subscriber(observer)
	      , subscription = cleanup;
	    if(cleanup != null){
	      if(typeof cleanup.unsubscribe === 'function')cleanup = function(){ subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch(e){
	    observer.error(e);
	    return;
	  } if(subscriptionClosed(this))cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe(){ closeSubscription(this); }
	});
	
	var SubscriptionObserver = function(subscription){
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if(m)return m.call(observer, value);
	      } catch(e){
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value){
	    var subscription = this._s;
	    if(subscriptionClosed(subscription))throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if(!m)throw value;
	      value = m.call(observer, value);
	    } catch(e){
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch(e){
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber){
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer){
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn){
	    var that = this;
	    return new (core.Promise || global.Promise)(function(resolve, reject){
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next : function(value){
	          try {
	            return fn(value);
	          } catch(e){
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x){
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if(method){
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function(observer){
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          try {
	            if(forOf(x, false, function(it){
	              observer.next(it);
	              if(done)return RETURN;
	            }) === RETURN)return;
	          } catch(e){
	            if(done)throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  },
	  of: function of(){
	    for(var i = 0, l = arguments.length, items = Array(l); i < l;)items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          for(var i = 0; i < items.length; ++i){
	            observer.next(items[i]);
	            if(done)return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function(){ return this; });
	
	$export($export.G, {Observable: $Observable});
	
	__webpack_require__(195)('Observable');

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global     = __webpack_require__(7)
	  , $export    = __webpack_require__(11)
	  , invoke     = __webpack_require__(81)
	  , partial    = __webpack_require__(292)
	  , navigator  = global.navigator
	  , MSIE       = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
	var wrap = function(set){
	  return MSIE ? function(fn, time /*, ...args */){
	    return set(invoke(
	      partial,
	      [].slice.call(arguments, 2),
	      typeof fn == 'function' ? fn : Function(fn)
	    ), time);
	  } : set;
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout:  wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var path      = __webpack_require__(293)
	  , invoke    = __webpack_require__(81)
	  , aFunction = __webpack_require__(24);
	module.exports = function(/* ...pargs */){
	  var fn     = aFunction(this)
	    , length = arguments.length
	    , pargs  = Array(length)
	    , i      = 0
	    , _      = path._
	    , holder = false;
	  while(length > i)if((pargs[i] = arguments[i++]) === _)holder = true;
	  return function(/* ...args */){
	    var that = this
	      , aLen = arguments.length
	      , j = 0, k = 0, args;
	    if(!holder && !aLen)return invoke(fn, pargs, that);
	    args = pargs.slice();
	    if(holder)for(;length > j; j++)if(args[j] === _)args[j] = arguments[k++];
	    while(aLen > k)args.push(arguments[k++]);
	    return invoke(fn, args, that);
	  };
	};

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(7);

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(11)
	  , $task   = __webpack_require__(211);
	$export($export.G + $export.B, {
	  setImmediate:   $task.set,
	  clearImmediate: $task.clear
	});

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	var $iterators    = __webpack_require__(196)
	  , redefine      = __webpack_require__(21)
	  , global        = __webpack_require__(7)
	  , hide          = __webpack_require__(13)
	  , Iterators     = __webpack_require__(132)
	  , wks           = __webpack_require__(28)
	  , ITERATOR      = wks('iterator')
	  , TO_STRING_TAG = wks('toStringTag')
	  , ArrayValues   = Iterators.Array;
	
	for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
	  var NAME       = collections[i]
	    , Collection = global[NAME]
	    , proto      = Collection && Collection.prototype
	    , key;
	  if(proto){
	    if(!proto[ITERATOR])hide(proto, ITERATOR, ArrayValues);
	    if(!proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    for(key in $iterators)if(!proto[key])redefine(proto, key, $iterators[key], true);
	  }
	}

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var iteratorSymbol =
	    typeof Symbol === "function" && Symbol.iterator || "@@iterator";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided, then outerFn.prototype instanceof Generator.
	    var generator = Object.create((outerFn || Generator).prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `value instanceof AwaitArgument` to determine if the yielded value is
	  // meant to be awaited. Some may consider the name of this method too
	  // cutesy, but they are curmudgeons.
	  runtime.awrap = function(arg) {
	    return new AwaitArgument(arg);
	  };
	
	  function AwaitArgument(arg) {
	    this.arg = arg;
	  }
	
	  function AsyncIterator(generator) {
	    // This invoke function is written in a style that assumes some
	    // calling function (or Promise) will handle exceptions.
	    function invoke(method, arg) {
	      var result = generator[method](arg);
	      var value = result.value;
	      return value instanceof AwaitArgument
	        ? Promise.resolve(value.arg).then(invokeNext, invokeThrow)
	        : Promise.resolve(value).then(function(unwrapped) {
	            // When a yielded Promise is resolved, its final value becomes
	            // the .value of the Promise<{value,done}> result for the
	            // current iteration. If the Promise is rejected, however, the
	            // result for this iteration will be rejected with the same
	            // reason. Note that rejections of yielded Promises are not
	            // thrown back into the generator function, as is the case
	            // when an awaited Promise is rejected. This difference in
	            // behavior between yield and await is important, because it
	            // allows the consumer to decide what to do with the yielded
	            // rejection (swallow it and continue, manually .throw it back
	            // into the generator, abandon iteration, whatever). With
	            // await, by contrast, there is no opportunity to examine the
	            // rejection reason outside the generator function, so the
	            // only option is to throw it from the await expression, and
	            // let the generator function handle the exception.
	            result.value = unwrapped;
	            return result;
	          });
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var invokeNext = invoke.bind(generator, "next");
	    var invokeThrow = invoke.bind(generator, "throw");
	    var invokeReturn = invoke.bind(generator, "return");
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return invoke(method, arg);
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : new Promise(function (resolve) {
	          resolve(callInvokeWithMethodAndArg());
	        });
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" ||
	              (method === "throw" && delegate.iterator[method] === undefined)) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;
	
	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }
	
	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }
	
	          var record = tryCatch(
	            delegate.iterator[method],
	            delegate.iterator,
	            arg
	          );
	
	          if (record.type === "throw") {
	            context.delegate = null;
	
	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }
	
	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;
	
	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }
	
	          context.delegate = null;
	        }
	
	        if (method === "next") {
	          context._sent = arg;
	
	          if (state === GenStateSuspendedYield) {
	            context.sent = arg;
	          } else {
	            context.sent = undefined;
	          }
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }
	
	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }
	
	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          var info = {
	            value: record.arg,
	            done: context.done
	          };
	
	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      this.sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }
	
	      return ContinueSentinel;
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(297)))

/***/ },
/* 297 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(299);
	module.exports = __webpack_require__(12).RegExp.escape;

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(11)
	  , $re     = __webpack_require__(300)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', {escape: function escape(it){ return $re(it); }});


/***/ },
/* 300 */
/***/ function(module, exports) {

	module.exports = function(regExp, replace){
	  var replacer = replace === Object(replace) ? function(part){
	    return replace[part];
	  } : replace;
	  return function(it){
	    return String(it).replace(regExp, replacer);
	  };
	};

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports['default'] = setupBlockStyles;
	
	var _blocks = __webpack_require__(302);
	
	var _blocks2 = __webpack_require__(418);
	
	var _blocks3 = _interopRequireDefault(_blocks2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function setupBlockStyles() {
	    _blocks.config.set({ styles: _blocks3['default'] });
	}

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _box = __webpack_require__(303);
	
	Object.defineProperty(exports, 'Box', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_box)['default'];
	  }
	});
	
	var _text = __webpack_require__(416);
	
	Object.defineProperty(exports, 'Text', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_text)['default'];
	  }
	});
	
	var _flex = __webpack_require__(417);
	
	Object.defineProperty(exports, 'Flex', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_flex)['default'];
	  }
	});
	
	var _config = __webpack_require__(415);
	
	Object.defineProperty(exports, 'config', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_config)['default'];
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Box = Box;
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _asBlock = __webpack_require__(331);
	
	var _asBlock2 = _interopRequireDefault(_asBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * Box component.  The lowest-level building component for other layout
	 * components.  Use this to apply style properties to a wrapping container.
	 *
	 * @example
	 * <Box margin={2} padding={3}>
	 *      <MyComponent {...}  />
	 * </Box>
	 */
	function Box(props) {
	    var _props$is = props.is,
	        is = _props$is === undefined ? 'div' : _props$is,
	        rest = _objectWithoutProperties(props, ['is']);
	
	    return _react2['default'].createElement(is, rest);
	}
	
	Box.propTypes = {
	
	    /**
	     * Can be either a string representing a React element ('div', 'span', etc)
	     * or another component.
	     */
	    is: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.func])
	};
	
	exports['default'] = (0, _asBlock2['default'])(Box);

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(305);


/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(306);
	
	var ReactChildren = __webpack_require__(307);
	var ReactComponent = __webpack_require__(320);
	var ReactPureComponent = __webpack_require__(323);
	var ReactClass = __webpack_require__(324);
	var ReactDOMFactories = __webpack_require__(326);
	var ReactElement = __webpack_require__(311);
	var ReactPropTypes = __webpack_require__(327);
	var ReactVersion = __webpack_require__(329);
	
	var onlyChild = __webpack_require__(330);
	var warning = __webpack_require__(313);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	module.exports = React;

/***/ },
/* 306 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(308);
	var ReactElement = __webpack_require__(311);
	
	var emptyFunction = __webpack_require__(314);
	var traverseAllChildren = __webpack_require__(317);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(309);
	
	var invariant = __webpack_require__(310);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 309 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(306);
	
	var ReactCurrentOwner = __webpack_require__(312);
	
	var warning = __webpack_require__(313);
	var canDefineProperty = __webpack_require__(315);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(316);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 312 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(314);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  (function () {
	    var printWarning = function printWarning(format) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    };
	
	    warning = function warning(condition, format) {
	      if (format === undefined) {
	        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	      }
	
	      if (format.indexOf('Failed Composite propType: ') === 0) {
	        return; // Ignore CompositeComponent proptype check.
	      }
	
	      if (!condition) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	          args[_key2 - 2] = arguments[_key2];
	        }
	
	        printWarning.apply(undefined, [format].concat(args));
	      }
	    };
	  })();
	}
	
	module.exports = warning;

/***/ },
/* 314 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 316 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(309);
	
	var ReactCurrentOwner = __webpack_require__(312);
	var REACT_ELEMENT_TYPE = __webpack_require__(316);
	
	var getIteratorFn = __webpack_require__(318);
	var invariant = __webpack_require__(310);
	var KeyEscapeUtils = __webpack_require__(319);
	var warning = __webpack_require__(313);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 318 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 319 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(309);
	
	var ReactNoopUpdateQueue = __webpack_require__(321);
	
	var canDefineProperty = __webpack_require__(315);
	var emptyObject = __webpack_require__(322);
	var invariant = __webpack_require__(310);
	var warning = __webpack_require__(313);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(313);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(306);
	
	var ReactComponent = __webpack_require__(320);
	var ReactNoopUpdateQueue = __webpack_require__(321);
	
	var emptyObject = __webpack_require__(322);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(309),
	    _assign = __webpack_require__(306);
	
	var ReactComponent = __webpack_require__(320);
	var ReactElement = __webpack_require__(311);
	var ReactPropTypeLocationNames = __webpack_require__(325);
	var ReactNoopUpdateQueue = __webpack_require__(321);
	
	var emptyObject = __webpack_require__(322);
	var invariant = __webpack_require__(310);
	var warning = __webpack_require__(313);
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: 'DEFINE_MANY',
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: 'DEFINE_MANY',
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: 'DEFINE_MANY',
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: 'DEFINE_MANY_MERGED',
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: 'DEFINE_ONCE',
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: 'DEFINE_MANY',
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: 'DEFINE_ONCE',
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: 'DEFINE_MANY',
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: 'OVERRIDE_BASE'
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, 'childContext');
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, 'context');
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, 'prop');
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === 'OVERRIDE_BASE') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === 'DEFINE_MANY_MERGED') {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === 'DEFINE_MANY') {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(311);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(311);
	var ReactPropTypeLocationNames = __webpack_require__(325);
	var ReactPropTypesSecret = __webpack_require__(328);
	
	var emptyFunction = __webpack_require__(314);
	var getIteratorFn = __webpack_require__(318);
	var warning = __webpack_require__(313);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	  symbol: createPrimitiveTypeChecker('symbol'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	/*eslint-disable no-self-compare*/
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	/*eslint-enable no-self-compare*/
	
	/**
	 * We use an Error-like object for backward compatibility as people may call
	 * PropTypes directly and inspect their output. However we don't use real
	 * Errors anymore. We don't inspect their stack anyway, and creating them
	 * is prohibitively expensive if they are created too often, such as what
	 * happens in oneOfType() for any type before the one that matched.
	 */
	function PropTypeError(message) {
	  this.message = message;
	  this.stack = '';
	}
	// Make `instanceof Error` still work for returned errors.
	PropTypeError.prototype = Error.prototype;
	
	function createChainableTypeChecker(validate) {
	  if (false) {
	    var manualPropTypeCallCache = {};
	  }
	  function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (false) {
	      if (secret !== ReactPropTypesSecret && typeof console !== 'undefined') {
	        var cacheKey = componentName + ':' + propName;
	        if (!manualPropTypeCallCache[cacheKey]) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will not work in production with the next major version. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.', propFullName, componentName) : void 0;
	          manualPropTypeCallCache[cacheKey] = true;
	        }
	      }
	    }
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        if (props[propName] === null) {
	          return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	        }
	        return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName, secret) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	    }
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!ReactElement.isValidElement(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	     false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (is(propValue, expectedValues[i])) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	    }
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	     false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	function isSymbol(propType, propValue) {
	  // Native Symbol.
	  if (propType === 'symbol') {
	    return true;
	  }
	
	  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	  if (propValue['@@toStringTag'] === 'Symbol') {
	    return true;
	  }
	
	  // Fallback for non-spec compliant Symbols which are polyfilled.
	  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	    return true;
	  }
	
	  return false;
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  if (isSymbol(propType, propValue)) {
	    return 'symbol';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return ANONYMOUS;
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 328 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 329 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.4.1';

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(309);
	
	var ReactElement = __webpack_require__(311);
	
	var invariant = __webpack_require__(310);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.asBlock = asBlock;
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _parseProps2 = __webpack_require__(332);
	
	var _parseProps3 = _interopRequireDefault(_parseProps2);
	
	var _config = __webpack_require__(415);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _propTypes = __webpack_require__(414);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var parseProps = (0, _parseProps3['default'])(_config2['default']);
	
	/**
	 * UI Block higher-order-component.  This function will return a component that
	 * can handle any of the defined style props.  The style props that are accepted
	 * are any that are accepted by understyle: https://github.com/jxnblk/understyle/
	 *
	 * @example
	 * function Box(props) {
	 *      const { is = 'div', ...rest } = props;
	 *      return React.createElement(props.is, rest)
	 * }
	 *
	 * export default asBlock(Box);
	 *
	 * // later...
	 * // style props coverted to the appropriate CSS classes and applied
	 * accordingly
	 * <Box m2 padding={2}>My Stuff</Box>
	 */
	function asBlock(BlockComponent) {
	    function WithLayout(originalProps) {
	        var _parseProps = parseProps(originalProps),
	            props = _parseProps.props,
	            className = _parseProps.className;
	
	        return _react2['default'].createElement(BlockComponent, _extends({}, props, {
	            className: className
	        }));
	    }
	
	    WithLayout.displayName = 'AsUIBlock(' + (BlockComponent.displayName || BlockComponent.name) + ')';
	    WithLayout.propTypes = _propTypes2['default'];
	
	    return WithLayout;
	}
	
	exports['default'] = asBlock;

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _flatten = __webpack_require__(334);
	
	var _flatten2 = _interopRequireDefault(_flatten);
	
	var _pairs = __webpack_require__(350);
	
	var _pairs2 = _interopRequireDefault(_pairs);
	
	var _map = __webpack_require__(355);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _flow = __webpack_require__(386);
	
	var _flow2 = _interopRequireDefault(_flow);
	
	var _kebabCase = __webpack_require__(401);
	
	var _kebabCase2 = _interopRequireDefault(_kebabCase);
	
	var _get = __webpack_require__(406);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _pick = __webpack_require__(407);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _normalize = __webpack_require__(412);
	
	var _normalize2 = _interopRequireDefault(_normalize);
	
	var _negate = __webpack_require__(413);
	
	var _negate2 = _interopRequireDefault(_negate);
	
	var _propTypes2 = __webpack_require__(414);
	
	var _propTypes3 = _interopRequireDefault(_propTypes2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var pickBy = function pickBy(fn) {
	    return function (obj) {
	        return (0, _pick2['default'])(obj, fn);
	    };
	};
	var mapWith = function mapWith(fn) {
	    return function (coll) {
	        return (0, _map2['default'])(coll, fn);
	    };
	};
	
	var isStyleProp = function isStyleProp(_, key) {
	    return _propTypes3['default'][key];
	};
	var isNotStyleProp = (0, _negate2['default'])(isStyleProp);
	
	/**
	 * Takes the rule name, value, and an optional prefix and constructs the correct
	 * classname.  That classname is used to lookup the runtime classname via CSS
	 * Modules.
	 *
	 * @example
	 * const config = {
	 *      breakpoints: ['m', 'l'],
	 *      styles: {
	 *          'display-block': 'display-block-hashed-by-css-modules'
	 *      }
	 * };
	 * const converted = makeConvertStyleToClassName(config);
	 * const className = convertStylesToClassName('display', 'block');
	 * //=> styles['display-block']
	 * //=> display-block-hashed-by-css-modules
	 */
	var makeConvertStyleToClassName = function makeConvertStyleToClassName(config) {
	    return function (ruleName, ruleValue, prefix) {
	        var rule = (0, _kebabCase2['default'])(ruleName + '-' + ruleValue);
	        var prefixedRule = prefix ? prefix + '-' + rule : rule;
	        var className = (0, _get2['default'])(config.styles, prefixedRule, '');
	
	        return className;
	    };
	};
	
	/**
	 * This function converts understyles's inline styles to CSS classes.  We take
	 * the style rules and create rule name out of them.  So, { flexDirection: 'row'
	 * } becomes the string 'flex-direction-row'.  We take that rule name and get
	 * the associated classname via the CSS module lookup.
	 *
	 * @param {Object} config - The config object
	 * @return {Function} A function that takes in an array of style objects
	 *
	 * @example
	 * const config = {
	 *      breakpoints: ['m', 'l'],
	 *      styles: {
	 *          'display-block': 'display-block-hashed-by-css-modules'
	 *      }
	 * };
	 * const converter = convertStylesToClassName(config);
	 * const styles = [{ property: 'display', value: 'block' }];
	 * const result = converter(styles);
	 * //=> ['display-block-hashed-by-css-modules']
	 */
	function makeConvertStylesToClassName(config) {
	    var convertStyleToClassName = makeConvertStyleToClassName(config);
	    var breakpoints = [''].concat(_toConsumableArray(config.breakpointPrefixes));
	
	    /**
	     * A function that takes in an array of style objects.
	     * @param {Array<{ property: string, value: (number|string) }>}
	     * @return {Array<string>}
	     */
	    return mapWith(function (rule) {
	        if (!rule) return;
	
	        var property = rule.property,
	            value = rule.value;
	
	
	        if (Array.isArray(value)) {
	            return value.map(function (val, idx) {
	                return convertStyleToClassName(property, val, breakpoints[idx]);
	            });
	        }
	
	        return convertStyleToClassName(property, value);
	    });
	}
	
	/**
	 * Takes a config and a props object, picks off any of the defined style props,
	 * and returns the correct classname for the combined style props.
	 *
	 * @param {Object} config - See config file for types
	 * @param {Object} props - The props object
	 * @return {Object} result - Tuple of class name and filtered props
	 * @return {string} result.className - The resulting class name
	 * @return {Object} result.props - The filtered props
	 *
	 * @example
	 * const config = {
	 *      breakpoints: ['m', 'l'],
	 *      styles: {
	 *          'display-block': 'display-block-hashed-by-css-modules'
	 *      }
	 * };
	 * const parser = parseProps(config);
	 * const myProps = { display: 'block', someOtherProp: true };
	 * const { props, className } = parser(myProps);
	 *
	 * console.log(props);
	 * //=> { someOtherProps: true; }
	 *
	 * console.log(className);
	 * //=> 'display-block-hashed-by-css-modules'
	 */
	var parseProps = function parseProps(config) {
	    return function (props) {
	        var pipeline = (0, _flow2['default'])(pickBy(isStyleProp), _pairs2['default'], mapWith((0, _normalize2['default'])(config)), _flatten2['default'], makeConvertStylesToClassName(config));
	
	        var className = (0, _classnames2['default'])(props.className, pipeline(props));
	        var filteredProps = (0, _pick2['default'])(props, isNotStyleProp);
	
	        return {
	            className: className,
	            props: filteredProps
	        };
	    };
	};
	
	exports['default'] = parseProps;

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	
	function classNames() {
		var classes = '';
		var arg;
	
		for (var i = 0; i < arguments.length; i++) {
			arg = arguments[i];
			if (!arg) {
				continue;
			}
	
			if ('string' === typeof arg || 'number' === typeof arg) {
				classes += ' ' + arg;
			} else if (Object.prototype.toString.call(arg) === '[object Array]') {
				classes += ' ' + classNames.apply(null, arg);
			} else if ('object' === typeof arg) {
				for (var key in arg) {
					if (!arg.hasOwnProperty(key) || !arg[key]) {
						continue;
					}
					classes += ' ' + key;
				}
			}
		}
		return classes.substr(1);
	}
	
	// safely export classNames for node / browserify
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	}
	
	// safely export classNames for RequireJS
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}


/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(335),
	    isIterateeCall = __webpack_require__(348);
	
	/**
	 * Flattens a nested array. If `isDeep` is `true` the array is recursively
	 * flattened, otherwise it is only flattened a single level.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @param {boolean} [isDeep] Specify a deep flatten.
	 * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, 3, [4]]]);
	 * // => [1, 2, 3, [4]]
	 *
	 * // using `isDeep`
	 * _.flatten([1, [2, 3, [4]]], true);
	 * // => [1, 2, 3, 4]
	 */
	function flatten(array, isDeep, guard) {
	  var length = array ? array.length : 0;
	  if (guard && isIterateeCall(array, isDeep, guard)) {
	    isDeep = false;
	  }
	  return length ? baseFlatten(array, isDeep) : [];
	}
	
	module.exports = flatten;


/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(336),
	    isArguments = __webpack_require__(337),
	    isArray = __webpack_require__(343),
	    isArrayLike = __webpack_require__(338),
	    isObjectLike = __webpack_require__(342);
	
	/**
	 * The base implementation of `_.flatten` with added support for restricting
	 * flattening and specifying the start index.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {boolean} [isDeep] Specify a deep flatten.
	 * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, isDeep, isStrict, result) {
	  result || (result = []);
	
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var value = array[index];
	    if (isObjectLike(value) && isArrayLike(value) &&
	        (isStrict || isArray(value) || isArguments(value))) {
	      if (isDeep) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, isDeep, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 336 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(338),
	    isObjectLike = __webpack_require__(342);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Native method references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is classified as an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  return isObjectLike(value) && isArrayLike(value) &&
	    hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	}
	
	module.exports = isArguments;


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(339),
	    isLength = __webpack_require__(341);
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	module.exports = isArrayLike;


/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(340);
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	module.exports = getLength;


/***/ },
/* 340 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 341 */
/***/ function(module, exports) {

	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 342 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(344),
	    isLength = __webpack_require__(341),
	    isObjectLike = __webpack_require__(342);
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	module.exports = isArray;


/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	var isNative = __webpack_require__(345);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(346),
	    isObjectLike = __webpack_require__(342);
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isNative;


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(347);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 347 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(338),
	    isIndex = __webpack_require__(349),
	    isObject = __webpack_require__(347);
	
	/**
	 * Checks if the provided arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	      ? (isArrayLike(object) && isIndex(index, object.length))
	      : (type == 'string' && index in object)) {
	    var other = object[index];
	    return value === value ? (value === other) : (other !== other);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 349 */
/***/ function(module, exports) {

	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	module.exports = isIndex;


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(351),
	    toObject = __webpack_require__(354);
	
	/**
	 * Creates a two dimensional array of the key-value pairs for `object`,
	 * e.g. `[[key1, value1], [key2, value2]]`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the new array of key-value pairs.
	 * @example
	 *
	 * _.pairs({ 'barney': 36, 'fred': 40 });
	 * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	 */
	function pairs(object) {
	  object = toObject(object);
	
	  var index = -1,
	      props = keys(object),
	      length = props.length,
	      result = Array(length);
	
	  while (++index < length) {
	    var key = props[index];
	    result[index] = [key, object[key]];
	  }
	  return result;
	}
	
	module.exports = pairs;


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(344),
	    isArrayLike = __webpack_require__(338),
	    isObject = __webpack_require__(347),
	    shimKeys = __webpack_require__(352);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeKeys = getNative(Object, 'keys');
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	var keys = !nativeKeys ? shimKeys : function(object) {
	  var Ctor = object == null ? undefined : object.constructor;
	  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	      (typeof object != 'function' && isArrayLike(object))) {
	    return shimKeys(object);
	  }
	  return isObject(object) ? nativeKeys(object) : [];
	};
	
	module.exports = keys;


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(337),
	    isArray = __webpack_require__(343),
	    isIndex = __webpack_require__(349),
	    isLength = __webpack_require__(341),
	    keysIn = __webpack_require__(353);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A fallback implementation of `Object.keys` which creates an array of the
	 * own enumerable property names of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function shimKeys(object) {
	  var props = keysIn(object),
	      propsLength = props.length,
	      length = propsLength && object.length;
	
	  var allowIndexes = !!length && isLength(length) &&
	    (isArray(object) || isArguments(object));
	
	  var index = -1,
	      result = [];
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = shimKeys;


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(337),
	    isArray = __webpack_require__(343),
	    isIndex = __webpack_require__(349),
	    isLength = __webpack_require__(341),
	    isObject = __webpack_require__(347);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(347);
	
	/**
	 * Converts `value` to an object if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Object} Returns the object.
	 */
	function toObject(value) {
	  return isObject(value) ? value : Object(value);
	}
	
	module.exports = toObject;


/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(356),
	    baseCallback = __webpack_require__(357),
	    baseMap = __webpack_require__(380),
	    isArray = __webpack_require__(343);
	
	/**
	 * Creates an array of values by running each element in `collection` through
	 * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * If a property name is provided for `iteratee` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `iteratee` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
	 * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
	 * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
	 * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
	 * `sum`, `uniq`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @alias collect
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `iteratee`.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function timesThree(n) {
	 *   return n * 3;
	 * }
	 *
	 * _.map([1, 2], timesThree);
	 * // => [3, 6]
	 *
	 * _.map({ 'a': 1, 'b': 2 }, timesThree);
	 * // => [3, 6] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // using the `_.property` callback shorthand
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee, thisArg) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  iteratee = baseCallback(iteratee, thisArg, 3);
	  return func(collection, iteratee);
	}
	
	module.exports = map;


/***/ },
/* 356 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(358),
	    baseMatchesProperty = __webpack_require__(369),
	    bindCallback = __webpack_require__(376),
	    identity = __webpack_require__(377),
	    property = __webpack_require__(378);
	
	/**
	 * The base implementation of `_.callback` which supports specifying the
	 * number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {*} [func=_.identity] The value to convert to a callback.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function baseCallback(func, thisArg, argCount) {
	  var type = typeof func;
	  if (type == 'function') {
	    return thisArg === undefined
	      ? func
	      : bindCallback(func, thisArg, argCount);
	  }
	  if (func == null) {
	    return identity;
	  }
	  if (type == 'object') {
	    return baseMatches(func);
	  }
	  return thisArg === undefined
	    ? property(func)
	    : baseMatchesProperty(func, thisArg);
	}
	
	module.exports = baseCallback;


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(359),
	    getMatchData = __webpack_require__(367),
	    toObject = __webpack_require__(354);
	
	/**
	 * The base implementation of `_.matches` which does not clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    var key = matchData[0][0],
	        value = matchData[0][1];
	
	    return function(object) {
	      if (object == null) {
	        return false;
	      }
	      return object[key] === value && (value !== undefined || (key in toObject(object)));
	    };
	  }
	  return function(object) {
	    return baseIsMatch(object, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(360),
	    toObject = __webpack_require__(354);
	
	/**
	 * The base implementation of `_.isMatch` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Array} matchData The propery names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparing objects.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = toObject(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	      if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(361),
	    isObject = __webpack_require__(347),
	    isObjectLike = __webpack_require__(342);
	
	/**
	 * The base implementation of `_.isEqual` without support for `this` binding
	 * `customizer` functions.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparing values.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	var equalArrays = __webpack_require__(362),
	    equalByTag = __webpack_require__(364),
	    equalObjects = __webpack_require__(365),
	    isArray = __webpack_require__(343),
	    isTypedArray = __webpack_require__(366);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing objects.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	 * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = objToString.call(object);
	    if (objTag == argsTag) {
	      objTag = objectTag;
	    } else if (objTag != objectTag) {
	      objIsArr = isTypedArray(object);
	    }
	  }
	  if (!othIsArr) {
	    othTag = objToString.call(other);
	    if (othTag == argsTag) {
	      othTag = objectTag;
	    } else if (othTag != objectTag) {
	      othIsArr = isTypedArray(other);
	    }
	  }
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !(objIsArr || objIsObj)) {
	    return equalByTag(object, other, objTag);
	  }
	  if (!isLoose) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  // For more information on detecting circular references see https://es5.github.io/#JO.
	  stackA || (stackA = []);
	  stackB || (stackB = []);
	
	  var length = stackA.length;
	  while (length--) {
	    if (stackA[length] == object) {
	      return stackB[length] == other;
	    }
	  }
	  // Add `object` and `other` to the stack of traversed objects.
	  stackA.push(object);
	  stackB.push(other);
	
	  var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
	
	  stackA.pop();
	  stackB.pop();
	
	  return result;
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(363);
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing arrays.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var index = -1,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	    return false;
	  }
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index],
	        result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
	
	    if (result !== undefined) {
	      if (result) {
	        continue;
	      }
	      return false;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (isLoose) {
	      if (!arraySome(other, function(othValue) {
	            return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	          })) {
	        return false;
	      }
	    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = equalArrays;


/***/ },
/* 363 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 364 */
/***/ function(module, exports) {

	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    stringTag = '[object String]';
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag) {
	  switch (tag) {
	    case boolTag:
	    case dateTag:
	      // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	      // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	      return +object == +other;
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case numberTag:
	      // Treat `NaN` vs. `NaN` as equal.
	      return (object != +object)
	        ? other != +other
	        : object == +other;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings primitives and string
	      // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	      return object == (other + '');
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(351);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing values.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isLoose) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  var skipCtor = isLoose;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key],
	        result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
	
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	      return false;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (!skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = equalObjects;


/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(341),
	    isObjectLike = __webpack_require__(342);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	function isTypedArray(value) {
	  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	}
	
	module.exports = isTypedArray;


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(368),
	    pairs = __webpack_require__(350);
	
	/**
	 * Gets the propery names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = pairs(object),
	      length = result.length;
	
	  while (length--) {
	    result[length][2] = isStrictComparable(result[length][1]);
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(347);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(370),
	    baseIsEqual = __webpack_require__(360),
	    baseSlice = __webpack_require__(371),
	    isArray = __webpack_require__(343),
	    isKey = __webpack_require__(372),
	    isStrictComparable = __webpack_require__(368),
	    last = __webpack_require__(373),
	    toObject = __webpack_require__(354),
	    toPath = __webpack_require__(374);
	
	/**
	 * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to compare.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  var isArr = isArray(path),
	      isCommon = isKey(path) && isStrictComparable(srcValue),
	      pathKey = (path + '');
	
	  path = toPath(path);
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    var key = pathKey;
	    object = toObject(object);
	    if ((isArr || !isCommon) && !(key in object)) {
	      object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	      if (object == null) {
	        return false;
	      }
	      key = last(path);
	      object = toObject(object);
	    }
	    return object[key] === srcValue
	      ? (srcValue !== undefined || (key in object))
	      : baseIsEqual(srcValue, object[key], undefined, true);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(354);
	
	/**
	 * The base implementation of `get` without support for string paths
	 * and default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path of the property to get.
	 * @param {string} [pathKey] The key representation of path.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path, pathKey) {
	  if (object == null) {
	    return;
	  }
	  if (pathKey !== undefined && pathKey in toObject(object)) {
	    path = [pathKey];
	  }
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[path[index++]];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 371 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  start = start == null ? 0 : (+start || 0);
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = (end === undefined || end > length) ? length : (+end || 0);
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(343),
	    toObject = __webpack_require__(354);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  var type = typeof value;
	  if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	    return true;
	  }
	  if (isArray(value)) {
	    return false;
	  }
	  var result = !reIsDeepProp.test(value);
	  return result || (object != null && value in toObject(object));
	}
	
	module.exports = isKey;


/***/ },
/* 373 */
/***/ function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array ? array.length : 0;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(375),
	    isArray = __webpack_require__(343);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `value` to property path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Array} Returns the property path array.
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return value;
	  }
	  var result = [];
	  baseToString(value).replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	}
	
	module.exports = toPath;


/***/ },
/* 375 */
/***/ function(module, exports) {

	/**
	 * Converts `value` to a string if it's not one. An empty string is returned
	 * for `null` or `undefined` values.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  return value == null ? '' : (value + '');
	}
	
	module.exports = baseToString;


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(377);
	
	/**
	 * A specialized version of `baseCallback` which only supports `this` binding
	 * and specifying the number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function bindCallback(func, thisArg, argCount) {
	  if (typeof func != 'function') {
	    return identity;
	  }
	  if (thisArg === undefined) {
	    return func;
	  }
	  switch (argCount) {
	    case 1: return function(value) {
	      return func.call(thisArg, value);
	    };
	    case 3: return function(value, index, collection) {
	      return func.call(thisArg, value, index, collection);
	    };
	    case 4: return function(accumulator, value, index, collection) {
	      return func.call(thisArg, accumulator, value, index, collection);
	    };
	    case 5: return function(value, other, key, object, source) {
	      return func.call(thisArg, value, other, key, object, source);
	    };
	  }
	  return function() {
	    return func.apply(thisArg, arguments);
	  };
	}
	
	module.exports = bindCallback;


/***/ },
/* 377 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument provided to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.identity(object) === object;
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(340),
	    basePropertyDeep = __webpack_require__(379),
	    isKey = __webpack_require__(372);
	
	/**
	 * Creates a function that returns the property value at `path` on a
	 * given object.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': { 'c': 2 } } },
	 *   { 'a': { 'b': { 'c': 1 } } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b.c'));
	 * // => [2, 1]
	 *
	 * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(370),
	    toPath = __webpack_require__(374);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function basePropertyDeep(path) {
	  var pathKey = (path + '');
	  path = toPath(path);
	  return function(object) {
	    return baseGet(object, path, pathKey);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(381),
	    isArrayLike = __webpack_require__(338);
	
	/**
	 * The base implementation of `_.map` without support for callback shorthands
	 * and `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(382),
	    createBaseEach = __webpack_require__(385);
	
	/**
	 * The base implementation of `_.forEach` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object|string} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(383),
	    keys = __webpack_require__(351);
	
	/**
	 * The base implementation of `_.forOwn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(384);
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(354);
	
	/**
	 * Creates a base function for `_.forIn` or `_.forInRight`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var iterable = toObject(object),
	        props = keysFunc(object),
	        length = props.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var key = props[index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(339),
	    isLength = __webpack_require__(341),
	    toObject = __webpack_require__(354);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    var length = collection ? getLength(collection) : 0;
	    if (!isLength(length)) {
	      return eachFunc(collection, iteratee);
	    }
	    var index = fromRight ? length : -1,
	        iterable = toObject(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	var createFlow = __webpack_require__(387);
	
	/**
	 * Creates a function that returns the result of invoking the provided
	 * functions with the `this` binding of the created function, where each
	 * successive invocation is supplied the return value of the previous.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {...Function} [funcs] Functions to invoke.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var addSquare = _.flow(_.add, square);
	 * addSquare(1, 2);
	 * // => 9
	 */
	var flow = createFlow();
	
	module.exports = flow;


/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	var LodashWrapper = __webpack_require__(388),
	    getData = __webpack_require__(391),
	    getFuncName = __webpack_require__(394),
	    isArray = __webpack_require__(343),
	    isLaziable = __webpack_require__(396);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var CURRY_FLAG = 8,
	    PARTIAL_FLAG = 32,
	    ARY_FLAG = 128,
	    REARG_FLAG = 256;
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a `_.flow` or `_.flowRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new flow function.
	 */
	function createFlow(fromRight) {
	  return function() {
	    var wrapper,
	        length = arguments.length,
	        index = fromRight ? length : -1,
	        leftIndex = 0,
	        funcs = Array(length);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var func = funcs[leftIndex++] = arguments[index];
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
	        wrapper = new LodashWrapper([], true);
	      }
	    }
	    index = wrapper ? -1 : length;
	    while (++index < length) {
	      func = funcs[index];
	
	      var funcName = getFuncName(func),
	          data = funcName == 'wrapper' ? getData(func) : undefined;
	
	      if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
	        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	      } else {
	        wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
	      }
	    }
	    return function() {
	      var args = arguments,
	          value = args[0];
	
	      if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	        return wrapper.plant(value).value();
	      }
	      var index = 0,
	          result = length ? funcs[index].apply(this, args) : value;
	
	      while (++index < length) {
	        result = funcs[index].call(this, result);
	      }
	      return result;
	    };
	  };
	}
	
	module.exports = createFlow;


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(389),
	    baseLodash = __webpack_require__(390);
	
	/**
	 * The base constructor for creating `lodash` wrapper objects.
	 *
	 * @private
	 * @param {*} value The value to wrap.
	 * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
	 * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
	 */
	function LodashWrapper(value, chainAll, actions) {
	  this.__wrapped__ = value;
	  this.__actions__ = actions || [];
	  this.__chain__ = !!chainAll;
	}
	
	LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	LodashWrapper.prototype.constructor = LodashWrapper;
	
	module.exports = LodashWrapper;


/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(347);
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} prototype The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(prototype) {
	    if (isObject(prototype)) {
	      object.prototype = prototype;
	      var result = new object;
	      object.prototype = undefined;
	    }
	    return result || {};
	  };
	}());
	
	module.exports = baseCreate;


/***/ },
/* 390 */
/***/ function(module, exports) {

	/**
	 * The function whose prototype all chaining wrappers inherit from.
	 *
	 * @private
	 */
	function baseLodash() {
	  // No operation performed.
	}
	
	module.exports = baseLodash;


/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	var metaMap = __webpack_require__(392),
	    noop = __webpack_require__(393);
	
	/**
	 * Gets metadata for `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {*} Returns the metadata for `func`.
	 */
	var getData = !metaMap ? noop : function(func) {
	  return metaMap.get(func);
	};
	
	module.exports = getData;


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var getNative = __webpack_require__(344);
	
	/** Native method references. */
	var WeakMap = getNative(global, 'WeakMap');
	
	/** Used to store function metadata. */
	var metaMap = WeakMap && new WeakMap;
	
	module.exports = metaMap;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 393 */
/***/ function(module, exports) {

	/**
	 * A no-operation function that returns `undefined` regardless of the
	 * arguments it receives.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.noop(object) === undefined;
	 * // => true
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	var realNames = __webpack_require__(395);
	
	/**
	 * Gets the name of `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {string} Returns the function name.
	 */
	function getFuncName(func) {
	  var result = func.name,
	      array = realNames[result],
	      length = array ? array.length : 0;
	
	  while (length--) {
	    var data = array[length],
	        otherFunc = data.func;
	    if (otherFunc == null || otherFunc == func) {
	      return data.name;
	    }
	  }
	  return result;
	}
	
	module.exports = getFuncName;


/***/ },
/* 395 */
/***/ function(module, exports) {

	/** Used to lookup unminified function names. */
	var realNames = {};
	
	module.exports = realNames;


/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(397),
	    getData = __webpack_require__(391),
	    getFuncName = __webpack_require__(394),
	    lodash = __webpack_require__(398);
	
	/**
	 * Checks if `func` has a lazy counterpart.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
	 */
	function isLaziable(func) {
	  var funcName = getFuncName(func);
	  if (!(funcName in LazyWrapper.prototype)) {
	    return false;
	  }
	  var other = lodash[funcName];
	  if (func === other) {
	    return true;
	  }
	  var data = getData(other);
	  return !!data && func === data[0];
	}
	
	module.exports = isLaziable;


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(389),
	    baseLodash = __webpack_require__(390);
	
	/** Used as references for `-Infinity` and `Infinity`. */
	var POSITIVE_INFINITY = Number.POSITIVE_INFINITY;
	
	/**
	 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	 *
	 * @private
	 * @param {*} value The value to wrap.
	 */
	function LazyWrapper(value) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__dir__ = 1;
	  this.__filtered__ = false;
	  this.__iteratees__ = [];
	  this.__takeCount__ = POSITIVE_INFINITY;
	  this.__views__ = [];
	}
	
	LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	LazyWrapper.prototype.constructor = LazyWrapper;
	
	module.exports = LazyWrapper;


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(397),
	    LodashWrapper = __webpack_require__(388),
	    baseLodash = __webpack_require__(390),
	    isArray = __webpack_require__(343),
	    isObjectLike = __webpack_require__(342),
	    wrapperClone = __webpack_require__(399);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates a `lodash` object which wraps `value` to enable implicit chaining.
	 * Methods that operate on and return arrays, collections, and functions can
	 * be chained together. Methods that retrieve a single value or may return a
	 * primitive value will automatically end the chain returning the unwrapped
	 * value. Explicit chaining may be enabled using `_.chain`. The execution of
	 * chained methods is lazy, that is, execution is deferred until `_#value`
	 * is implicitly or explicitly called.
	 *
	 * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
	 * fusion is an optimization strategy which merge iteratee calls; this can help
	 * to avoid the creation of intermediate data structures and greatly reduce the
	 * number of iteratee executions.
	 *
	 * Chaining is supported in custom builds as long as the `_#value` method is
	 * directly or indirectly included in the build.
	 *
	 * In addition to lodash methods, wrappers have `Array` and `String` methods.
	 *
	 * The wrapper `Array` methods are:
	 * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
	 * `splice`, and `unshift`
	 *
	 * The wrapper `String` methods are:
	 * `replace` and `split`
	 *
	 * The wrapper methods that support shortcut fusion are:
	 * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
	 * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
	 * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
	 * and `where`
	 *
	 * The chainable wrapper methods are:
	 * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
	 * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
	 * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
	 * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
	 * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
	 * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
	 * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
	 * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
	 * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
	 * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
	 * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
	 * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
	 * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
	 * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
	 * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
	 * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
	 * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
	 *
	 * The wrapper methods that are **not** chainable by default are:
	 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
	 * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
	 * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
	 * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
	 * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
	 * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
	 * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
	 * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
	 * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
	 * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
	 * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
	 * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
	 * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
	 * `unescape`, `uniqueId`, `value`, and `words`
	 *
	 * The wrapper method `sample` will return a wrapped value when `n` is provided,
	 * otherwise an unwrapped value is returned.
	 *
	 * @name _
	 * @constructor
	 * @category Chain
	 * @param {*} value The value to wrap in a `lodash` instance.
	 * @returns {Object} Returns the new `lodash` wrapper instance.
	 * @example
	 *
	 * var wrapped = _([1, 2, 3]);
	 *
	 * // returns an unwrapped value
	 * wrapped.reduce(function(total, n) {
	 *   return total + n;
	 * });
	 * // => 6
	 *
	 * // returns a wrapped value
	 * var squares = wrapped.map(function(n) {
	 *   return n * n;
	 * });
	 *
	 * _.isArray(squares);
	 * // => false
	 *
	 * _.isArray(squares.value());
	 * // => true
	 */
	function lodash(value) {
	  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	    if (value instanceof LodashWrapper) {
	      return value;
	    }
	    if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
	      return wrapperClone(value);
	    }
	  }
	  return new LodashWrapper(value);
	}
	
	// Ensure wrappers are instances of `baseLodash`.
	lodash.prototype = baseLodash.prototype;
	
	module.exports = lodash;


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(397),
	    LodashWrapper = __webpack_require__(388),
	    arrayCopy = __webpack_require__(400);
	
	/**
	 * Creates a clone of `wrapper`.
	 *
	 * @private
	 * @param {Object} wrapper The wrapper to clone.
	 * @returns {Object} Returns the cloned wrapper.
	 */
	function wrapperClone(wrapper) {
	  return wrapper instanceof LazyWrapper
	    ? wrapper.clone()
	    : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
	}
	
	module.exports = wrapperClone;


/***/ },
/* 400 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function arrayCopy(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = arrayCopy;


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	var createCompounder = __webpack_require__(402);
	
	/**
	 * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the kebab cased string.
	 * @example
	 *
	 * _.kebabCase('Foo Bar');
	 * // => 'foo-bar'
	 *
	 * _.kebabCase('fooBar');
	 * // => 'foo-bar'
	 *
	 * _.kebabCase('__foo_bar__');
	 * // => 'foo-bar'
	 */
	var kebabCase = createCompounder(function(result, word, index) {
	  return result + (index ? '-' : '') + word.toLowerCase();
	});
	
	module.exports = kebabCase;


/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	var deburr = __webpack_require__(403),
	    words = __webpack_require__(405);
	
	/**
	 * Creates a function that produces compound words out of the words in a
	 * given string.
	 *
	 * @private
	 * @param {Function} callback The function to combine each word.
	 * @returns {Function} Returns the new compounder function.
	 */
	function createCompounder(callback) {
	  return function(string) {
	    var index = -1,
	        array = words(deburr(string)),
	        length = array.length,
	        result = '';
	
	    while (++index < length) {
	      result = callback(result, array[index], index);
	    }
	    return result;
	  };
	}
	
	module.exports = createCompounder;


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(375),
	    deburrLetter = __webpack_require__(404);
	
	/** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
	var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;
	
	/** Used to match latin-1 supplementary letters (excluding mathematical operators). */
	var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;
	
	/**
	 * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	 * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to deburr.
	 * @returns {string} Returns the deburred string.
	 * @example
	 *
	 * _.deburr('déjà vu');
	 * // => 'deja vu'
	 */
	function deburr(string) {
	  string = baseToString(string);
	  return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
	}
	
	module.exports = deburr;


/***/ },
/* 404 */
/***/ function(module, exports) {

	/** Used to map latin-1 supplementary letters to basic latin letters. */
	var deburredLetters = {
	  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	  '\xc7': 'C',  '\xe7': 'c',
	  '\xd0': 'D',  '\xf0': 'd',
	  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	  '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	  '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	  '\xd1': 'N',  '\xf1': 'n',
	  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	  '\xc6': 'Ae', '\xe6': 'ae',
	  '\xde': 'Th', '\xfe': 'th',
	  '\xdf': 'ss'
	};
	
	/**
	 * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
	 *
	 * @private
	 * @param {string} letter The matched letter to deburr.
	 * @returns {string} Returns the deburred letter.
	 */
	function deburrLetter(letter) {
	  return deburredLetters[letter];
	}
	
	module.exports = deburrLetter;


/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(375),
	    isIterateeCall = __webpack_require__(348);
	
	/** Used to match words to create compound words. */
	var reWords = (function() {
	  var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
	      lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';
	
	  return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
	}());
	
	/**
	 * Splits `string` into an array of its words.
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to inspect.
	 * @param {RegExp|string} [pattern] The pattern to match words.
	 * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	 * @returns {Array} Returns the words of `string`.
	 * @example
	 *
	 * _.words('fred, barney, & pebbles');
	 * // => ['fred', 'barney', 'pebbles']
	 *
	 * _.words('fred, barney, & pebbles', /[^, ]+/g);
	 * // => ['fred', 'barney', '&', 'pebbles']
	 */
	function words(string, pattern, guard) {
	  if (guard && isIterateeCall(string, pattern, guard)) {
	    pattern = undefined;
	  }
	  string = baseToString(string);
	  return string.match(pattern || reWords) || [];
	}
	
	module.exports = words;


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(370),
	    toPath = __webpack_require__(374);
	
	/**
	 * Gets the property value at `path` of `object`. If the resolved value is
	 * `undefined` the `defaultValue` is used in its place.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(335),
	    bindCallback = __webpack_require__(376),
	    pickByArray = __webpack_require__(408),
	    pickByCallback = __webpack_require__(409),
	    restParam = __webpack_require__(411);
	
	/**
	 * Creates an object composed of the picked `object` properties. Property
	 * names may be specified as individual arguments or as arrays of property
	 * names. If `predicate` is provided it is invoked for each property of `object`
	 * picking the properties `predicate` returns truthy for. The predicate is
	 * bound to `thisArg` and invoked with three arguments: (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function|...(string|string[])} [predicate] The function invoked per
	 *  iteration or property names to pick, specified as individual property
	 *  names or arrays of property names.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'user': 'fred', 'age': 40 };
	 *
	 * _.pick(object, 'user');
	 * // => { 'user': 'fred' }
	 *
	 * _.pick(object, _.isString);
	 * // => { 'user': 'fred' }
	 */
	var pick = restParam(function(object, props) {
	  if (object == null) {
	    return {};
	  }
	  return typeof props[0] == 'function'
	    ? pickByCallback(object, bindCallback(props[0], props[1], 3))
	    : pickByArray(object, baseFlatten(props));
	});
	
	module.exports = pick;


/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(354);
	
	/**
	 * A specialized version of `_.pick` which picks `object` properties specified
	 * by `props`.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property names to pick.
	 * @returns {Object} Returns the new object.
	 */
	function pickByArray(object, props) {
	  object = toObject(object);
	
	  var index = -1,
	      length = props.length,
	      result = {};
	
	  while (++index < length) {
	    var key = props[index];
	    if (key in object) {
	      result[key] = object[key];
	    }
	  }
	  return result;
	}
	
	module.exports = pickByArray;


/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	var baseForIn = __webpack_require__(410);
	
	/**
	 * A specialized version of `_.pick` which picks `object` properties `predicate`
	 * returns truthy for.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Object} Returns the new object.
	 */
	function pickByCallback(object, predicate) {
	  var result = {};
	  baseForIn(object, function(value, key, object) {
	    if (predicate(value, key, object)) {
	      result[key] = value;
	    }
	  });
	  return result;
	}
	
	module.exports = pickByCallback;


/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(383),
	    keysIn = __webpack_require__(353);
	
	/**
	 * The base implementation of `_.forIn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForIn(object, iteratee) {
	  return baseFor(object, iteratee, keysIn);
	}
	
	module.exports = baseForIn;


/***/ },
/* 411 */
/***/ function(module, exports) {

	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as an array.
	 *
	 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.restParam(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function restParam(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        rest = Array(length);
	
	    while (++index < length) {
	      rest[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, rest);
	      case 1: return func.call(this, args[0], rest);
	      case 2: return func.call(this, args[0], args[1], rest);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = rest;
	    return func.apply(this, otherArgs);
	  };
	}
	
	module.exports = restParam;


/***/ },
/* 412 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var makeProperty = function makeProperty(property) {
	    return function (value) {
	        return [{ property: property, value: value }];
	    };
	};
	var makeProperties = function makeProperties(prop1, prop2) {
	    return function (value) {
	        return [].concat(_toConsumableArray(makeProperty(prop1)(value)), _toConsumableArray(makeProperty(prop2)(value)));
	    };
	};
	var border = function border(key) {
	    return function (value) {
	        return [].concat(_toConsumableArray(makeProperty(key)(value)), _toConsumableArray(makeProperty(key)('solid')));
	    };
	};
	
	var shorthands = {
	    alignItems: makeProperty('align'),
	    backgroundColor: makeProperty('bg'),
	    border: border('b'),
	    borderBottom: border('bb'),
	    borderColor: makeProperty('b'),
	    borderRight: border('br'),
	    borderTop: border('bt'),
	    borderLeft: border('bl'),
	    color: makeProperty('c'),
	    display: makeProperty('d'),
	    flexDirection: makeProperty('flex'),
	    flexWrap: makeProperty('flex'),
	    fontSize: makeProperty('f'),
	    fontWeight: makeProperty('fw'),
	    hoverColor: makeProperty('hover'),
	    justifyContent: makeProperty('justify'),
	    margin: makeProperty('m'),
	    marginBottom: makeProperty('mb'),
	    marginLeft: makeProperty('ml'),
	    marginRight: makeProperty('mr'),
	    marginTop: makeProperty('mt'),
	    marginX: makeProperties('ml', 'mr'),
	    marginY: makeProperties('mt', 'mb'),
	    mx: makeProperties('ml', 'mr'),
	    my: makeProperties('mt', 'mb'),
	    padding: makeProperty('p'),
	    paddingBottom: makeProperty('pb'),
	    paddingLeft: makeProperty('pl'),
	    paddingRight: makeProperty('pr'),
	    paddingTop: makeProperty('pt'),
	    paddingX: makeProperties('pl', 'pr'),
	    paddingY: makeProperties('pt', 'pb'),
	    position: makeProperty('pos'),
	    px: makeProperties('pl', 'pr'),
	    py: makeProperties('pt', 'pb'),
	    textAlign: makeProperty('t'),
	    textTransform: makeProperty('tt'),
	    verticalAlign: makeProperty('v'),
	    width: makeProperty('w')
	};
	
	function parseStyle(property, value) {
	    if (value === null) return null;
	
	    var propertyMaker = shorthands[property] || makeProperty(property);
	
	    return propertyMaker(value);
	}
	
	/**
	 * This normalizes the original property rule to make sure everything is
	 * converted to a shorthand class so it can be looked up in the style config.
	 */
	var normalize = function normalize(config) {
	    return function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2),
	            property = _ref2[0],
	            value = _ref2[1];
	
	        return parseStyle(property, value, config);
	    };
	};
	
	exports['default'] = normalize;

/***/ },
/* 413 */
/***/ function(module, exports) {

	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that negates the result of the predicate `func`. The
	 * `func` predicate is invoked with the `this` binding and arguments of the
	 * created function.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} predicate The predicate to negate.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * function isEven(n) {
	 *   return n % 2 == 0;
	 * }
	 *
	 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	 * // => [1, 3, 5]
	 */
	function negate(predicate) {
	  if (typeof predicate != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  return function() {
	    return !predicate.apply(this, arguments);
	  };
	}
	
	module.exports = negate;


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PropTypes = _react2['default'].PropTypes;
	
	
	var string = PropTypes.string;
	var number = PropTypes.number;
	var stringOrNumber = PropTypes.oneOfType([string, number]);
	var maybeStringArray = PropTypes.oneOfType([string, PropTypes.arrayOf(string)]);
	var maybeNumberArray = PropTypes.oneOfType([number, PropTypes.arrayOf(number)]);
	var maybeStringOrNumberArray = PropTypes.oneOfType([stringOrNumber, PropTypes.arrayOf(stringOrNumber)]);
	
	exports['default'] = {
	    alignItems: maybeStringArray,
	    backgroundColor: maybeStringArray,
	    bg: maybeStringArray,
	    borderColor: maybeStringArray,
	    border: maybeNumberArray,
	    borderBottom: maybeNumberArray,
	    borderLeft: maybeNumberArray,
	    borderRight: maybeNumberArray,
	    borderTop: maybeNumberArray,
	    color: maybeStringArray,
	    display: maybeStringArray,
	    flex: maybeStringOrNumberArray,
	    flexDirection: maybeStringArray,
	    flexWrap: maybeStringArray,
	    fontSize: maybeNumberArray,
	    fontWeight: maybeStringOrNumberArray,
	    hoverColor: maybeStringArray,
	    justifyContent: maybeStringArray,
	    m: maybeStringOrNumberArray,
	    margin: maybeStringOrNumberArray,
	    marginBottom: maybeStringOrNumberArray,
	    marginLeft: maybeStringOrNumberArray,
	    marginRight: maybeStringOrNumberArray,
	    marginTop: maybeStringOrNumberArray,
	    marginX: maybeStringOrNumberArray,
	    marginY: maybeStringOrNumberArray,
	    mb: maybeStringOrNumberArray,
	    ml: maybeStringOrNumberArray,
	    mr: maybeStringOrNumberArray,
	    mt: maybeStringOrNumberArray,
	    mx: maybeStringOrNumberArray,
	    my: maybeStringOrNumberArray,
	    order: maybeNumberArray,
	    p: maybeNumberArray,
	    padding: maybeNumberArray,
	    paddingBottom: maybeNumberArray,
	    paddingLeft: maybeNumberArray,
	    paddingRight: maybeNumberArray,
	    paddingTop: maybeNumberArray,
	    paddingX: maybeNumberArray,
	    paddingY: maybeNumberArray,
	    pb: maybeNumberArray,
	    pl: maybeNumberArray,
	    position: maybeStringArray,
	    pr: maybeNumberArray,
	    pt: maybeNumberArray,
	    px: maybeNumberArray,
	    py: maybeNumberArray,
	    textAlign: maybeStringArray,
	    textTransform: maybeStringArray,
	    verticalAlign: maybeStringArray,
	    width: maybeNumberArray
	};

/***/ },
/* 415 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Style config
	 *
	 * This config mimics the style config from understyle, but a notable difference
	 * is that we just use this config to construct classnames instead of the actual
	 * style since we're using plain CSS.
	 */
	var defaultConfig = {
	    colors: {
	        black: 'black',
	        cerulean: 'cerulean',
	        white: 'white'
	    },
	
	    /**
	     * Breakpoints represent the prefix to be applied for each breakpoint.  The
	     * prefix will be applied as `${prefix}-${rule}`.  Note that this is
	     * assuming a "mobile-first" approach.
	     *
	     * For example, this style prop would result in the following css rules
	     * { display: ['block', 'flex', 'inline'] }
	     * //=> 'display-block m-display-flex l-display-inline'
	     *
	     * The non-prefixed rule is meant to be applied up until the first
	     * breakpoint, then the "m-" rule and then the "l-" rule.
	     */
	    breakpointPrefixes: ['m', 'l']
	};
	
	var Config = function () {
	    function Config(config) {
	        _classCallCheck(this, Config);
	
	        this.value = _extends({}, config);
	    }
	
	    _createClass(Config, [{
	        key: 'get',
	        value: function get(key) {
	            return this.value[key];
	        }
	    }, {
	        key: 'set',
	        value: function set(obj) {
	            this.value = _extends({}, this.value, obj);
	
	            return this.value;
	        }
	    }, {
	        key: 'colors',
	        get: function get() {
	            return this.get('colors');
	        }
	    }, {
	        key: 'breakpointPrefixes',
	        get: function get() {
	            return this.get('breakpointPrefixes');
	        }
	    }, {
	        key: 'styles',
	        get: function get() {
	            return this.get('styles');
	        }
	    }]);
	
	    return Config;
	}();
	
	var config = new Config(defaultConfig);
	
	exports['default'] = config;

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = Text;
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _box = __webpack_require__(303);
	
	var _box2 = _interopRequireDefault(_box);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 */
	function Text(props) {
	  return _react2['default'].createElement(_box2['default'], _extends({ is: 'p' }, props));
	}

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.Flex = Flex;
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _box = __webpack_require__(303);
	
	var _box2 = _interopRequireDefault(_box);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Helper component for Flex elements
	 *
	 * @example
	 * <Flex flexDirection='column'>
	 *      content
	 * </Flex>
	 */
	function Flex(props) {
	  return _react2['default'].createElement(_box2['default'], _extends({}, props, { display: 'flex' }));
	}
	
	exports['default'] = Flex;

/***/ },
/* 418 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"t-center":"t-center_25UNi","t-left":"t-left_16oFn","t-right":"t-right_2Vs3b","v-middle":"v-middle_ckhwy","v-top":"v-top_vNLsX","v-bottom":"v-bottom_1ZzyB","bg-cerulean":"bg-cerulean_3xDWN","bg-white":"bg-white_14y--","bg-grey":"bg-grey_3P9Rv","bg-light-grey":"bg-light-grey_oQToy","bg-plume":"bg-plume_R1ACi","bg-red":"bg-red_2MVFy","b-black":"b-black_1DKrq","b-white":"b-white_1w4Uq","b-cerulean":"b-cerulean_2OJ4w","b-grey":"b-grey_2KZLc","b-ashen":"b-ashen_1Xtq9","b-warm-chinchilla":"b-warm-chinchilla_yOITt","b-1":"b-1_1qeMa","b-2":"b-2_2esvK","b-3":"b-3_22CHX","bt-1":"bt-1_3Ow2y","bt-2":"bt-2_1gNbV","bt-3":"bt-3_kw_BJ","bb-1":"bb-1_2hOWj","bb-2":"bb-2_2Quxj","bb-3":"bb-3_16meM","bl-1":"bl-1_1A8sP","bl-2":"bl-2_37eQA","bl-3":"bl-3_u-Rod","br-1":"br-1_3N5Zb","br-2":"br-2_3b3IS","br-3":"br-3_2DBeN","b-solid":"b-solid_2vuuL","bt-solid":"bt-solid_1eiEN","bb-solid":"bb-solid_3tC5m","bl-solid":"bl-solid_WGvey","br-solid":"br-solid_I5Ul4","c-black":"c-black_3py5x","c-white":"c-white_AkFMr","c-grey":"c-grey_1p-vi","c-ashen":"c-ashen_Ewp8T","c-cerulean":"c-cerulean_2yuBH","c-red":"c-red_2W0z3","c-light-grey":"c-light-grey_hldrL","hover-black":"hover-black_1vJzK","hover-white":"hover-white_1LL22","hover-grey":"hover-grey_3nnkw","hover-ashen":"hover-ashen_3LyVm","hover-cerulean":"hover-cerulean_2U1Pl","hover-red":"hover-red_3e-yr","hover-light-grey":"hover-light-grey_30sE2","d-none":"d-none_2ra6R","d-inline":"d-inline_Agvac","d-block":"d-block_ynA2p","d-flex":"d-flex_tn_a2","d-inline-block":"d-inline-block_1g7cU","flex-column":"flex-column_2-CSn","flex-row":"flex-row_12ibA","justify-start":"justify-start_3g1DP","justify-end":"justify-end_sJh7p","justify-center":"justify-center_14ee8","justify-space-between":"justify-space-between_3dvxy","justify-space-around":"justify-space-around_3uXzX","align-center":"align-center_19Ik6","flex-wrap":"flex-wrap_SMFk1","flex-none":"flex-none_36AD8","flex-1":"flex-1_3SaAP","flex-2":"flex-2_943h_","flex-3":"flex-3_2OEYM","flex-4":"flex-4_2eipe","flex-5":"flex-5_VK5ci","order-1":"order-1_1a2ke","order-2":"order-2_7WTdV","order-3":"order-3_1T2vj","order-4":"order-4_xrxIE","order-5":"order-5_2tPSg","fw-normal":"fw-normal_1ZyA-","fw-bold":"fw-bold_3kega","fw-semibold":"fw-semibold_JuPVU","tt-uppercase":"tt-uppercase_1aO0H","tt-lowercase":"tt-lowercase_2dqfL","f-1":"f-1_2ta1d","f-2":"f-2_SPN9T","f-3":"f-3_yAkqa","f-4":"f-4_3zzI1","f-5":"f-5_1ylqs","f-6":"f-6_1U5m2","pos-relative":"pos-relative_2Nht2","pos-absolute":"pos-absolute_2EumR","pos-static":"pos-static_1WVxG","ml-auto":"ml-auto_36p3r","mr-auto":"mr-auto_3CVYr","m-0":"m-0_2Bjp-","ml-0":"ml-0_2NiPq","mr-0":"mr-0_KnHGa","mt-0":"mt-0_1doyX","mb-0":"mb-0_3trCK","p-0":"p-0_2cSM0","pl-0":"pl-0_2V1NW","pr-0":"pr-0_39VgB","pt-0":"pt-0_1HbFP","pb-0":"pb-0_2Gtee","m-1":"m-1_3nqMf","ml-1":"ml-1_h3GyT","mr-1":"mr-1_1GJ_d","mt-1":"mt-1_RvYOh","mb-1":"mb-1_1i6ez","p-1":"p-1_1861J","pl-1":"pl-1_3MeRl","pr-1":"pr-1_lU7xN","pt-1":"pt-1_3_QEb","pb-1":"pb-1_1MMfL","m-2":"m-2_16EYg","ml-2":"ml-2_1AMr1","mr-2":"mr-2_12OMP","mt-2":"mt-2_30c-S","mb-2":"mb-2_2nD6_","p-2":"p-2_bXe6X","pl-2":"pl-2_1xKZF","pr-2":"pr-2_2BYcy","pt-2":"pt-2_1jucH","pb-2":"pb-2_1Wrd4","m-3":"m-3_2ZLgk","ml-3":"ml-3_1Kx41","mr-3":"mr-3_2I7Y_","mt-3":"mt-3_oPhDH","mb-3":"mb-3_3pMN1","p-3":"p-3_6HmuF","pl-3":"pl-3_OzDBo","pr-3":"pr-3_1H7HR","pt-3":"pt-3_2ofbs","pb-3":"pb-3_2ZCqZ","m-4":"m-4_8mqr-","ml-4":"ml-4_FSMRi","mr-4":"mr-4_3adSz","mt-4":"mt-4_PY903","mb-4":"mb-4_3EGxj","p-4":"p-4_JEN7K","pl-4":"pl-4_1jxGA","pr-4":"pr-4_22-cI","pt-4":"pt-4_1g1DY","pb-4":"pb-4_3xN2K","m-5":"m-5_GxUpE","ml-5":"ml-5_1l0RX","mr-5":"mr-5_2FVOE","mt-5":"mt-5_18cQL","mb-5":"mb-5_1y6Sy","p-5":"p-5_UFJYB","pl-5":"pl-5_10p-X","pr-5":"pr-5_30-ai","pt-5":"pt-5_2kGC2","pb-5":"pb-5_3ZgVs","w-100":"w-100_32sIV","w-90":"w-90_3BaXK","w-80":"w-80_2v_hU","w-70":"w-70_2VY9c","w-60":"w-60_2jNwC","w-50":"w-50_1n-HW","w-40":"w-40_1K89s","w-30":"w-30_1opnF","w-20":"w-20_MbhuG","w-10":"w-10_GBIq2","w-0":"w-0_1a_6f","m-t-center":"m-t-center_V0zB0","m-t-left":"m-t-left_2PQeO","m-t-right":"m-t-right_3Ds6Y","m-v-middle":"m-v-middle_1eAZB","m-v-top":"m-v-top_28oeH","m-v-bottom":"m-v-bottom_Kaed5","prefix-bg-cerulean":"prefix-bg-cerulean_3dKgV","prefix-bg-white":"prefix-bg-white_3-T_6","prefix-bg-grey":"prefix-bg-grey_13wf2","prefix-bg-light-grey":"prefix-bg-light-grey_19kJv","prefix-bg-plume":"prefix-bg-plume_3XV__","prefix-bg-red":"prefix-bg-red_qTOrs","m-b-black":"m-b-black_-bM35","m-b-white":"m-b-white_-glk3","m-b-cerulean":"m-b-cerulean_1hv0y","m-b-grey":"m-b-grey_3pn3E","m-b-ashen":"m-b-ashen_1_U2-","m-b-warm-chinchilla":"m-b-warm-chinchilla_2PCwN","m-b-1":"m-b-1_W0uZs","m-b-2":"m-b-2_3ljGp","m-b-3":"m-b-3_o3Uhd","m-bt-1":"m-bt-1_3uZJJ","m-bt-2":"m-bt-2_BD0z3","m-bt-3":"m-bt-3_317KN","m-bb-1":"m-bb-1_9DraU","m-bb-2":"m-bb-2_3srXQ","m-bb-3":"m-bb-3_19929","m-bl-1":"m-bl-1_3A4tG","m-bl-2":"m-bl-2_1cR2G","m-bl-3":"m-bl-3_3Y75R","m-br-1":"m-br-1_1bKWY","m-br-2":"m-br-2_25e23","m-br-3":"m-br-3_Z7BBq","m-b-solid":"m-b-solid_2XpG3","m-bt-solid":"m-bt-solid_21ffH","m-bb-solid":"m-bb-solid_3VF4r","m-bl-solid":"m-bl-solid_d0DfD","m-br-solid":"m-br-solid_82y-4","m-c-black":"m-c-black_P5gFG","m-c-white":"m-c-white_3PWjr","m-c-grey":"m-c-grey_17RXZ","m-c-ashen":"m-c-ashen_2ALmH","m-c-cerulean":"m-c-cerulean_ppDGw","m-c-red":"m-c-red_1KFNG","m-c-light-grey":"m-c-light-grey_cNj1l","m-hover-black":"m-hover-black_1klZD","m-hover-white":"m-hover-white_1b-_i","m-hover-grey":"m-hover-grey_5QlBI","m-hover-ashen":"m-hover-ashen_1_UgE","m-hover-cerulean":"m-hover-cerulean_3N0I_","m-hover-red":"m-hover-red_34QwI","m-hover-light-grey":"m-hover-light-grey_29QnI","m-d-none":"m-d-none_3aFc2","m-d-inline":"m-d-inline_2AfB9","m-d-block":"m-d-block_1HyLA","m-d-flex":"m-d-flex_2B1g4","m-d-inline-block":"m-d-inline-block_11_ii","m-flex-column":"m-flex-column_1QTpQ","m-flex-row":"m-flex-row_p4hYH","m-justify-start":"m-justify-start_5r-3Q","m-justify-end":"m-justify-end_3eH3L","m-justify-center":"m-justify-center_Wn8G4","m-justify-space-between":"m-justify-space-between_14HHj","m-justify-space-around":"m-justify-space-around_2DbRZ","m-align-center":"m-align-center_19ATF","m-flex-wrap":"m-flex-wrap_1NnxC","m-flex-none":"m-flex-none_K_LIC","m-flex-1":"m-flex-1_117Kj","m-flex-2":"m-flex-2_xOfGX","m-flex-3":"m-flex-3_16tAc","m-flex-4":"m-flex-4_1DqiT","m-flex-5":"m-flex-5_3Bf2h","m-order-1":"m-order-1_nAKHJ","m-order-2":"m-order-2_6GU8o","m-order-3":"m-order-3_2X7N3","m-order-4":"m-order-4_3FigV","m-order-5":"m-order-5_1XJGv","m-fw-normal":"m-fw-normal_3alFp","m-fw-bold":"m-fw-bold_1p7xK","m-fw-semibold":"m-fw-semibold_2s9d3","m-tt-uppercase":"m-tt-uppercase_r090Y","m-tt-lowercase":"m-tt-lowercase_3Ms3Z","m-f-1":"m-f-1_ahNeH","m-f-2":"m-f-2_2ehM4","m-f-3":"m-f-3_3PPJy","m-f-4":"m-f-4_2nThb","m-f-5":"m-f-5_2L4M3","m-f-6":"m-f-6_1E3Vy","m-pos-relative":"m-pos-relative_u9Wmu","m-pos-absolute":"m-pos-absolute_1yagQ","m-pos-static":"m-pos-static_2XNpA","m-ml-auto":"m-ml-auto_scAPa","m-mr-auto":"m-mr-auto_g4O4t","m-m-0":"m-m-0_LLErK","m-ml-0":"m-ml-0_3IxAI","m-mr-0":"m-mr-0_2G1Md","m-mt-0":"m-mt-0_1wnof","m-mb-0":"m-mb-0_zcgUH","m-p-0":"m-p-0_1zWw6","m-pl-0":"m-pl-0_3oVBb","m-pr-0":"m-pr-0_2zqtC","m-pt-0":"m-pt-0_18Hn_","m-pb-0":"m-pb-0_3aG1-","m-m-1":"m-m-1_hXciA","m-ml-1":"m-ml-1_2xv9R","m-mr-1":"m-mr-1_3kqu-","m-mt-1":"m-mt-1_2_jnm","m-mb-1":"m-mb-1_2LLWA","m-p-1":"m-p-1_2nkMn","m-pl-1":"m-pl-1_iV312","m-pr-1":"m-pr-1_2r34q","m-pt-1":"m-pt-1_1FrCL","m-pb-1":"m-pb-1_3sOmr","m-m-2":"m-m-2_15qjl","m-ml-2":"m-ml-2_2_T2n","m-mr-2":"m-mr-2_1mCKS","m-mt-2":"m-mt-2_261Wa","m-mb-2":"m-mb-2_1SNe8","m-p-2":"m-p-2_32NwI","m-pl-2":"m-pl-2_lmVnD","m-pr-2":"m-pr-2_21Ldc","m-pt-2":"m-pt-2_2Vy0u","m-pb-2":"m-pb-2_2U-aO","m-m-3":"m-m-3_YeLTg","m-ml-3":"m-ml-3_2oojI","m-mr-3":"m-mr-3_oqOnw","m-mt-3":"m-mt-3_29YgN","m-mb-3":"m-mb-3_1kAvq","m-p-3":"m-p-3_SSP2k","m-pl-3":"m-pl-3_3s3ac","m-pr-3":"m-pr-3_1Im_2","m-pt-3":"m-pt-3_20jOI","m-pb-3":"m-pb-3_2cKAr","m-m-4":"m-m-4_2AqPL","m-ml-4":"m-ml-4_1BwJo","m-mr-4":"m-mr-4_1n0oR","m-mt-4":"m-mt-4_25gCR","m-mb-4":"m-mb-4_21mlr","m-p-4":"m-p-4_2RdUj","m-pl-4":"m-pl-4_2N7eM","m-pr-4":"m-pr-4_1B41d","m-pt-4":"m-pt-4_uAS1N","m-pb-4":"m-pb-4_3M-ZG","m-m-5":"m-m-5_3ptWw","m-ml-5":"m-ml-5_2fIlW","m-mr-5":"m-mr-5_o5Mif","m-mt-5":"m-mt-5_36MFE","m-mb-5":"m-mb-5_16qpb","m-p-5":"m-p-5_JEcUN","m-pl-5":"m-pl-5_3kEGC","m-pr-5":"m-pr-5_3rM4z","m-pt-5":"m-pt-5_2xu9e","m-pb-5":"m-pb-5_VlpJk","m-w-100":"m-w-100_1DYbw","m-w-90":"m-w-90_3x526","m-w-80":"m-w-80_-XnmS","m-w-70":"m-w-70_3-cRt","m-w-60":"m-w-60_2TzKb","m-w-50":"m-w-50_XOxRM","m-w-40":"m-w-40_1j_u9","m-w-30":"m-w-30_FVfiE","m-w-20":"m-w-20_2HPPN","m-w-10":"m-w-10_2HZkg","m-w-0":"m-w-0_3_3fN","l-t-center":"l-t-center_1a8cO","l-t-left":"l-t-left_Oyd6v","l-t-right":"l-t-right_28gHh","l-v-middle":"l-v-middle_26SG0","l-v-top":"l-v-top_JR0w4","l-v-bottom":"l-v-bottom_1kb6d","l-b-black":"l-b-black_35KCT","l-b-white":"l-b-white_2G1V5","l-b-cerulean":"l-b-cerulean_23WY6","l-b-grey":"l-b-grey_2OAkj","l-b-ashen":"l-b-ashen_3Q5Vd","l-b-warm-chinchilla":"l-b-warm-chinchilla_3vDZD","l-b-1":"l-b-1_d0Esc","l-b-2":"l-b-2_2CCDx","l-b-3":"l-b-3_ENyG1","l-bt-1":"l-bt-1_1eCut","l-bt-2":"l-bt-2_Jg_MI","l-bt-3":"l-bt-3_1tM7Q","l-bb-1":"l-bb-1_UfL8p","l-bb-2":"l-bb-2_2QR9-","l-bb-3":"l-bb-3_2Ledk","l-bl-1":"l-bl-1_qSr4w","l-bl-2":"l-bl-2_RNSPv","l-bl-3":"l-bl-3_3xb26","l-br-1":"l-br-1_3ijuI","l-br-2":"l-br-2_17amp","l-br-3":"l-br-3_ftH2v","l-b-solid":"l-b-solid_2ILHm","l-bt-solid":"l-bt-solid_2VR8q","l-bb-solid":"l-bb-solid_1KAvJ","l-bl-solid":"l-bl-solid_2gOLk","l-br-solid":"l-br-solid_2iKH8","l-c-black":"l-c-black__qi0-","l-c-white":"l-c-white_3qzPk","l-c-grey":"l-c-grey_3qN1C","l-c-ashen":"l-c-ashen_Xbn30","l-c-cerulean":"l-c-cerulean_3Hyzo","l-c-red":"l-c-red_gwbb2","l-c-light-grey":"l-c-light-grey_3-Vvg","l-hover-black":"l-hover-black_31tPi","l-hover-white":"l-hover-white_3BfOw","l-hover-grey":"l-hover-grey_2EYmO","l-hover-ashen":"l-hover-ashen_3cier","l-hover-cerulean":"l-hover-cerulean_1s8oL","l-hover-red":"l-hover-red_3-oCJ","l-hover-light-grey":"l-hover-light-grey_RyDRC","l-d-none":"l-d-none_C2xLW","l-d-inline":"l-d-inline_2DBkK","l-d-block":"l-d-block_31A-z","l-d-flex":"l-d-flex_Kfmjc","l-d-inline-block":"l-d-inline-block_3Bg0H","l-flex-column":"l-flex-column_uQBvu","l-flex-row":"l-flex-row_N12wt","l-justify-start":"l-justify-start_tuRXC","l-justify-end":"l-justify-end_22CVU","l-justify-center":"l-justify-center_mnNzo","l-justify-space-between":"l-justify-space-between_1VPro","l-justify-space-around":"l-justify-space-around_H5YJi","l-align-center":"l-align-center_2IWcN","l-flex-wrap":"l-flex-wrap_V_8Fb","l-flex-none":"l-flex-none_QrfXo","l-flex-1":"l-flex-1_1FhBm","l-flex-2":"l-flex-2_3bUuo","l-flex-3":"l-flex-3_1BAPk","l-flex-4":"l-flex-4_1oCbm","l-flex-5":"l-flex-5_lDIz-","l-order-1":"l-order-1_2TNuc","l-order-2":"l-order-2_3Houa","l-order-3":"l-order-3_11eg1","l-order-4":"l-order-4_2MjzG","l-order-5":"l-order-5_2m4cR","l-fw-normal":"l-fw-normal_1w-SW","l-fw-bold":"l-fw-bold_1-MTc","l-fw-semibold":"l-fw-semibold_1VNWQ","l-tt-uppercase":"l-tt-uppercase_19uh7","l-tt-lowercase":"l-tt-lowercase_3fQHQ","l-f-1":"l-f-1_29hhp","l-f-2":"l-f-2_21EOv","l-f-3":"l-f-3_DbGs3","l-f-4":"l-f-4_xip9i","l-f-5":"l-f-5_DHtTj","l-f-6":"l-f-6_3BI7F","l-pos-relative":"l-pos-relative_3z3Mn","l-pos-absolute":"l-pos-absolute_8SwC8","l-pos-static":"l-pos-static_3IbI4","l-ml-auto":"l-ml-auto_3TXz2","l-mr-auto":"l-mr-auto_btHUv","l-m-0":"l-m-0_2u2am","l-ml-0":"l-ml-0_qeq2J","l-mr-0":"l-mr-0_3ZqH-","l-mt-0":"l-mt-0_3hnvU","l-mb-0":"l-mb-0_3HzBH","l-p-0":"l-p-0_2k-ka","l-pl-0":"l-pl-0_5UBRT","l-pr-0":"l-pr-0_39TUf","l-pt-0":"l-pt-0_D-ttS","l-pb-0":"l-pb-0_1jKI-","l-m-1":"l-m-1_33kdT","l-ml-1":"l-ml-1_3OSQ1","l-mr-1":"l-mr-1_2AhAs","l-mt-1":"l-mt-1_1xWDW","l-mb-1":"l-mb-1_3CfY1","l-p-1":"l-p-1_2X9b6","l-pl-1":"l-pl-1_17BYt","l-pr-1":"l-pr-1_2FiBT","l-pt-1":"l-pt-1_1Ov7p","l-pb-1":"l-pb-1_3KdLd","l-m-2":"l-m-2_2UCzj","l-ml-2":"l-ml-2_3tvGj","l-mr-2":"l-mr-2_3a2C6","l-mt-2":"l-mt-2_1msjk","l-mb-2":"l-mb-2_1-7MI","l-p-2":"l-p-2_29XEV","l-pl-2":"l-pl-2_2WsaO","l-pr-2":"l-pr-2_3tk4A","l-pt-2":"l-pt-2_2SkoS","l-pb-2":"l-pb-2_3MtYP","l-m-3":"l-m-3_37XL6","l-ml-3":"l-ml-3_2uG-z","l-mr-3":"l-mr-3_2gOj8","l-mt-3":"l-mt-3_1Tw6m","l-mb-3":"l-mb-3_ZyTX8","l-p-3":"l-p-3_3O1bC","l-pl-3":"l-pl-3_1EtzP","l-pr-3":"l-pr-3_Dimdy","l-pt-3":"l-pt-3_2kBeW","l-pb-3":"l-pb-3_EEB4R","l-m-4":"l-m-4_2JJR3","l-ml-4":"l-ml-4_1V6c9","l-mr-4":"l-mr-4_oi59d","l-mt-4":"l-mt-4_2MALO","l-mb-4":"l-mb-4_23Qgv","l-p-4":"l-p-4_tH6cc","l-pl-4":"l-pl-4_BtKQu","l-pr-4":"l-pr-4_rxeNF","l-pt-4":"l-pt-4_BDjwx","l-pb-4":"l-pb-4_fe2Lc","l-m-5":"l-m-5_1s72x","l-ml-5":"l-ml-5_3hdiF","l-mr-5":"l-mr-5_2rt-A","l-mt-5":"l-mt-5_3KYEx","l-mb-5":"l-mb-5_2ImuV","l-p-5":"l-p-5_OUczi","l-pl-5":"l-pl-5_1CGZS","l-pr-5":"l-pr-5_39IoK","l-pt-5":"l-pt-5_3kLDT","l-pb-5":"l-pb-5_2CPAT","l-w-100":"l-w-100_3nD61","l-w-90":"l-w-90_3J1Pv","l-w-80":"l-w-80_17RIt","l-w-70":"l-w-70_YYD42","l-w-60":"l-w-60_3Kwf0","l-w-50":"l-w-50_3YyUL","l-w-40":"l-w-40_2VqRb","l-w-30":"l-w-30_2Nj2c","l-w-20":"l-w-20_SEInc","l-w-10":"l-w-10_3RYVj","l-w-0":"l-w-0_2ZoCW"};

/***/ },
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var m = __webpack_require__(477),
	    IntlPolyfill = m.default;
	
	// Expose `IntlPolyfill` as global to add locale data into runtime later on.
	global.IntlPolyfill = IntlPolyfill;
	
	// Require all locale data for `Intl`. This module will be
	// ignored when bundling for the browser with Browserify/Webpack.
	__webpack_require__(480);
	
	// hack to export the polyfill as global Intl if needed
	if (!global.Intl) {
	    global.Intl = IntlPolyfill;
	    IntlPolyfill.__applyLocaleSensitivePrototypes();
	}
	
	// providing an idiomatic api for the nodejs version of this module
	module.exports = exports = IntlPolyfill;
	// preserving the original api in case another module is relying on that
	exports.default = IntlPolyfill;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license Copyright 2013 Andy Earnshaw, MIT License
	 *
	 * Implements the ECMAScript Internationalization API in ES5-compatible environments,
	 * following the ECMA-402 specification as closely as possible
	 *
	 * ECMA-402: http://ecma-international.org/ecma-402/1.0/
	 *
	 * CLDR format locale data should be provided using IntlPolyfill.__addLocaleData().
	 */
	/*jshint esnext: true, proto:true, eqnull:true, boss:true, laxbreak:true, newcap:false, shadow:true, funcscope:true */
	
	"use strict";
	var src$exp$$ = __webpack_require__(478), src$cldr$$ = __webpack_require__(479);
	
	var Intl = {},
	
	    realDefineProp = (function () {
	        var sentinel = {};
	        try {
	            Object.defineProperty(sentinel, 'a', {});
	            return 'a' in sentinel;
	        } catch (e) {
	            return false;
	        }
	    })(),
	
	    // Need a workaround for getters in ES3
	    es3  = !realDefineProp && !Object.prototype.__defineGetter__,
	
	    // We use this a lot (and need it for proto-less objects)
	    hop = Object.prototype.hasOwnProperty,
	
	    // Naive defineProperty for compatibility
	    defineProperty = realDefineProp ? Object.defineProperty : function (obj, name, desc) {
	        if ('get' in desc && obj.__defineGetter__)
	            obj.__defineGetter__(name, desc.get);
	
	        else if (!hop.call(obj, name) || 'value' in desc)
	            obj[name] = desc.value;
	    },
	
	    // Array.prototype.indexOf, as good as we need it to be
	    arrIndexOf = Array.prototype.indexOf || function (search) {
	        /*jshint validthis:true */
	        var t = this;
	        if (!t.length)
	            return -1;
	
	        for (var i = arguments[1] || 0, max = t.length; i < max; i++) {
	            if (t[i] === search)
	                return i;
	        }
	
	        return -1;
	    },
	
	    // Create an object with the specified prototype (2nd arg required for Record)
	    objCreate = Object.create || function (proto, props) {
	        var obj;
	
	        function F() {}
	        F.prototype = proto;
	        obj = new F();
	
	        for (var k in props) {
	            if (hop.call(props, k))
	                defineProperty(obj, k, props[k]);
	        }
	
	        return obj;
	    },
	
	    // Snapshot some (hopefully still) native built-ins
	    arrSlice  = Array.prototype.slice,
	    arrConcat = Array.prototype.concat,
	    arrPush   = Array.prototype.push,
	    arrJoin   = Array.prototype.join,
	    arrShift  = Array.prototype.shift,
	    arrUnshift= Array.prototype.unshift,
	
	    // Naive Function.prototype.bind for compatibility
	    fnBind = Function.prototype.bind || function (thisObj) {
	        var fn = this,
	            args = arrSlice.call(arguments, 1);
	
	        // All our (presently) bound functions have either 1 or 0 arguments. By returning
	        // different function signatures, we can pass some tests in ES3 environments
	        if (fn.length === 1) {
	            return function (a) {
	                return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
	            };
	        }
	        else {
	            return function () {
	                return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
	            };
	        }
	    },
	
	    // Default locale is the first-added locale data for us
	    defaultLocale,
	
	    // Object housing internal properties for constructors
	    internals = objCreate(null),
	
	    // Keep internal properties internal
	    secret = Math.random(),
	
	    // An object map of date component keys, saves using a regex later
	    dateWidths = objCreate(null, { narrow:{}, short:{}, long:{} }),
	
	    // Each constructor prototype should be an instance of the constructor itself, but we
	    // can't initialise them as such until some locale data has been added, so this is how
	    // we keep track
	    numberFormatProtoInitialised = false,
	    dateTimeFormatProtoInitialised = false,
	
	    // Some regular expressions we're using
	    expCurrencyCode = /^[A-Z]{3}$/,
	    expUnicodeExSeq = /-u(?:-[0-9a-z]{2,8})+/gi, // See `extension` below
	
	    // IANA Subtag Registry redundant tag and subtag maps
	    redundantTags = {
	        tags: {
	            "art-lojban":   "jbo",       "i-ami":        "ami",       "i-bnn":       "bnn",  "i-hak":      "hak",
	            "i-klingon":    "tlh",       "i-lux":        "lb",        "i-navajo":    "nv",   "i-pwn":      "pwn",
	            "i-tao":        "tao",       "i-tay":        "tay",       "i-tsu":       "tsu",  "no-bok":     "nb",
	            "no-nyn":       "nn",        "sgn-BE-FR":    "sfb",       "sgn-BE-NL":   "vgt",  "sgn-CH-DE":  "sgg",
	            "zh-guoyu":     "cmn",       "zh-hakka":     "hak",       "zh-min-nan":  "nan",  "zh-xiang":   "hsn",
	            "sgn-BR":       "bzs",       "sgn-CO":       "csn",       "sgn-DE":      "gsg",  "sgn-DK":     "dsl",
	            "sgn-ES":       "ssp",       "sgn-FR":       "fsl",       "sgn-GB":      "bfi",  "sgn-GR":     "gss",
	            "sgn-IE":       "isg",       "sgn-IT":       "ise",       "sgn-JP":      "jsl",  "sgn-MX":     "mfs",
	            "sgn-NI":       "ncs",       "sgn-NL":       "dse",       "sgn-NO":      "nsl",  "sgn-PT":     "psr",
	            "sgn-SE":       "swl",       "sgn-US":       "ase",       "sgn-ZA":      "sfs",  "zh-cmn":     "cmn",
	            "zh-cmn-Hans":  "cmn-Hans",  "zh-cmn-Hant":  "cmn-Hant",  "zh-gan":      "gan",  "zh-wuu":     "wuu",
	            "zh-yue":       "yue"
	        },
	        subtags: {
	              BU: "MM",   DD: "DE",   FX: "FR",   TP: "TL",   YD: "YE",   ZR: "CD",  heploc: "alalc97",
	            'in': "id",   iw: "he",   ji:  "yi",  jw: "jv",   mo: "ro",  ayx: "nun", bjd: "drl",
	             ccq: "rki", cjr: "mom", cka: "cmr", cmk: "xch", drh: "khk", drw: "prs", gav: "dev",
	             hrr: "jal", ibi: "opa", kgh: "kml", lcq: "ppr", mst: "mry", myt: "mry", sca: "hle",
	             tie: "ras", tkk: "twm", tlw: "weo", tnf: "prs", ybd: "rki", yma: "lrr"
	        },
	        extLang: {
	            aao: [ "aao", "ar"  ], abh: [ "abh", "ar"  ], abv: [ "abv", "ar"  ], acm: [ "acm", "ar"  ],
	            acq: [ "acq", "ar"  ], acw: [ "acw", "ar"  ], acx: [ "acx", "ar"  ], acy: [ "acy", "ar"  ],
	            adf: [ "adf", "ar"  ], ads: [ "ads", "sgn" ], aeb: [ "aeb", "ar"  ], aec: [ "aec", "ar"  ],
	            aed: [ "aed", "sgn" ], aen: [ "aen", "sgn" ], afb: [ "afb", "ar"  ], afg: [ "afg", "sgn" ],
	            ajp: [ "ajp", "ar"  ], apc: [ "apc", "ar"  ], apd: [ "apd", "ar"  ], arb: [ "arb", "ar"  ],
	            arq: [ "arq", "ar"  ], ars: [ "ars", "ar"  ], ary: [ "ary", "ar"  ], arz: [ "arz", "ar"  ],
	            ase: [ "ase", "sgn" ], asf: [ "asf", "sgn" ], asp: [ "asp", "sgn" ], asq: [ "asq", "sgn" ],
	            asw: [ "asw", "sgn" ], auz: [ "auz", "ar"  ], avl: [ "avl", "ar"  ], ayh: [ "ayh", "ar"  ],
	            ayl: [ "ayl", "ar"  ], ayn: [ "ayn", "ar"  ], ayp: [ "ayp", "ar"  ], bbz: [ "bbz", "ar"  ],
	            bfi: [ "bfi", "sgn" ], bfk: [ "bfk", "sgn" ], bjn: [ "bjn", "ms"  ], bog: [ "bog", "sgn" ],
	            bqn: [ "bqn", "sgn" ], bqy: [ "bqy", "sgn" ], btj: [ "btj", "ms"  ], bve: [ "bve", "ms"  ],
	            bvl: [ "bvl", "sgn" ], bvu: [ "bvu", "ms"  ], bzs: [ "bzs", "sgn" ], cdo: [ "cdo", "zh"  ],
	            cds: [ "cds", "sgn" ], cjy: [ "cjy", "zh"  ], cmn: [ "cmn", "zh"  ], coa: [ "coa", "ms"  ],
	            cpx: [ "cpx", "zh"  ], csc: [ "csc", "sgn" ], csd: [ "csd", "sgn" ], cse: [ "cse", "sgn" ],
	            csf: [ "csf", "sgn" ], csg: [ "csg", "sgn" ], csl: [ "csl", "sgn" ], csn: [ "csn", "sgn" ],
	            csq: [ "csq", "sgn" ], csr: [ "csr", "sgn" ], czh: [ "czh", "zh"  ], czo: [ "czo", "zh"  ],
	            doq: [ "doq", "sgn" ], dse: [ "dse", "sgn" ], dsl: [ "dsl", "sgn" ], dup: [ "dup", "ms"  ],
	            ecs: [ "ecs", "sgn" ], esl: [ "esl", "sgn" ], esn: [ "esn", "sgn" ], eso: [ "eso", "sgn" ],
	            eth: [ "eth", "sgn" ], fcs: [ "fcs", "sgn" ], fse: [ "fse", "sgn" ], fsl: [ "fsl", "sgn" ],
	            fss: [ "fss", "sgn" ], gan: [ "gan", "zh"  ], gds: [ "gds", "sgn" ], gom: [ "gom", "kok" ],
	            gse: [ "gse", "sgn" ], gsg: [ "gsg", "sgn" ], gsm: [ "gsm", "sgn" ], gss: [ "gss", "sgn" ],
	            gus: [ "gus", "sgn" ], hab: [ "hab", "sgn" ], haf: [ "haf", "sgn" ], hak: [ "hak", "zh"  ],
	            hds: [ "hds", "sgn" ], hji: [ "hji", "ms"  ], hks: [ "hks", "sgn" ], hos: [ "hos", "sgn" ],
	            hps: [ "hps", "sgn" ], hsh: [ "hsh", "sgn" ], hsl: [ "hsl", "sgn" ], hsn: [ "hsn", "zh"  ],
	            icl: [ "icl", "sgn" ], ils: [ "ils", "sgn" ], inl: [ "inl", "sgn" ], ins: [ "ins", "sgn" ],
	            ise: [ "ise", "sgn" ], isg: [ "isg", "sgn" ], isr: [ "isr", "sgn" ], jak: [ "jak", "ms"  ],
	            jax: [ "jax", "ms"  ], jcs: [ "jcs", "sgn" ], jhs: [ "jhs", "sgn" ], jls: [ "jls", "sgn" ],
	            jos: [ "jos", "sgn" ], jsl: [ "jsl", "sgn" ], jus: [ "jus", "sgn" ], kgi: [ "kgi", "sgn" ],
	            knn: [ "knn", "kok" ], kvb: [ "kvb", "ms"  ], kvk: [ "kvk", "sgn" ], kvr: [ "kvr", "ms"  ],
	            kxd: [ "kxd", "ms"  ], lbs: [ "lbs", "sgn" ], lce: [ "lce", "ms"  ], lcf: [ "lcf", "ms"  ],
	            liw: [ "liw", "ms"  ], lls: [ "lls", "sgn" ], lsg: [ "lsg", "sgn" ], lsl: [ "lsl", "sgn" ],
	            lso: [ "lso", "sgn" ], lsp: [ "lsp", "sgn" ], lst: [ "lst", "sgn" ], lsy: [ "lsy", "sgn" ],
	            ltg: [ "ltg", "lv"  ], lvs: [ "lvs", "lv"  ], lzh: [ "lzh", "zh"  ], max: [ "max", "ms"  ],
	            mdl: [ "mdl", "sgn" ], meo: [ "meo", "ms"  ], mfa: [ "mfa", "ms"  ], mfb: [ "mfb", "ms"  ],
	            mfs: [ "mfs", "sgn" ], min: [ "min", "ms"  ], mnp: [ "mnp", "zh"  ], mqg: [ "mqg", "ms"  ],
	            mre: [ "mre", "sgn" ], msd: [ "msd", "sgn" ], msi: [ "msi", "ms"  ], msr: [ "msr", "sgn" ],
	            mui: [ "mui", "ms"  ], mzc: [ "mzc", "sgn" ], mzg: [ "mzg", "sgn" ], mzy: [ "mzy", "sgn" ],
	            nan: [ "nan", "zh"  ], nbs: [ "nbs", "sgn" ], ncs: [ "ncs", "sgn" ], nsi: [ "nsi", "sgn" ],
	            nsl: [ "nsl", "sgn" ], nsp: [ "nsp", "sgn" ], nsr: [ "nsr", "sgn" ], nzs: [ "nzs", "sgn" ],
	            okl: [ "okl", "sgn" ], orn: [ "orn", "ms"  ], ors: [ "ors", "ms"  ], pel: [ "pel", "ms"  ],
	            pga: [ "pga", "ar"  ], pks: [ "pks", "sgn" ], prl: [ "prl", "sgn" ], prz: [ "prz", "sgn" ],
	            psc: [ "psc", "sgn" ], psd: [ "psd", "sgn" ], pse: [ "pse", "ms"  ], psg: [ "psg", "sgn" ],
	            psl: [ "psl", "sgn" ], pso: [ "pso", "sgn" ], psp: [ "psp", "sgn" ], psr: [ "psr", "sgn" ],
	            pys: [ "pys", "sgn" ], rms: [ "rms", "sgn" ], rsi: [ "rsi", "sgn" ], rsl: [ "rsl", "sgn" ],
	            sdl: [ "sdl", "sgn" ], sfb: [ "sfb", "sgn" ], sfs: [ "sfs", "sgn" ], sgg: [ "sgg", "sgn" ],
	            sgx: [ "sgx", "sgn" ], shu: [ "shu", "ar"  ], slf: [ "slf", "sgn" ], sls: [ "sls", "sgn" ],
	            sqk: [ "sqk", "sgn" ], sqs: [ "sqs", "sgn" ], ssh: [ "ssh", "ar"  ], ssp: [ "ssp", "sgn" ],
	            ssr: [ "ssr", "sgn" ], svk: [ "svk", "sgn" ], swc: [ "swc", "sw"  ], swh: [ "swh", "sw"  ],
	            swl: [ "swl", "sgn" ], syy: [ "syy", "sgn" ], tmw: [ "tmw", "ms"  ], tse: [ "tse", "sgn" ],
	            tsm: [ "tsm", "sgn" ], tsq: [ "tsq", "sgn" ], tss: [ "tss", "sgn" ], tsy: [ "tsy", "sgn" ],
	            tza: [ "tza", "sgn" ], ugn: [ "ugn", "sgn" ], ugy: [ "ugy", "sgn" ], ukl: [ "ukl", "sgn" ],
	            uks: [ "uks", "sgn" ], urk: [ "urk", "ms"  ], uzn: [ "uzn", "uz"  ], uzs: [ "uzs", "uz"  ],
	            vgt: [ "vgt", "sgn" ], vkk: [ "vkk", "ms"  ], vkt: [ "vkt", "ms"  ], vsi: [ "vsi", "sgn" ],
	            vsl: [ "vsl", "sgn" ], vsv: [ "vsv", "sgn" ], wuu: [ "wuu", "zh"  ], xki: [ "xki", "sgn" ],
	            xml: [ "xml", "sgn" ], xmm: [ "xmm", "ms"  ], xms: [ "xms", "sgn" ], yds: [ "yds", "sgn" ],
	            ysl: [ "ysl", "sgn" ], yue: [ "yue", "zh"  ], zib: [ "zib", "sgn" ], zlm: [ "zlm", "ms"  ],
	            zmi: [ "zmi", "ms"  ], zsl: [ "zsl", "sgn" ], zsm: [ "zsm", "ms"  ]
	        }
	    },
	
	    // Currency minor units output from get-4217 grunt task, formatted
	    currencyMinorUnits = {
	        BHD: 3, BYR: 0, XOF: 0, BIF: 0, XAF: 0, CLF: 4, CLP: 0, KMF: 0, DJF: 0,
	        XPF: 0, GNF: 0, ISK: 0, IQD: 3, JPY: 0, JOD: 3, KRW: 0, KWD: 3, LYD: 3,
	        OMR: 3, PYG: 0, RWF: 0, TND: 3, UGX: 0, UYI: 0, VUV: 0, VND: 0
	    };
	
	// Sect 6.2 Language Tags
	// ======================
	
	/**
	 * The IsStructurallyValidLanguageTag abstract operation verifies that the locale
	 * argument (which must be a String value)
	 *
	 * - represents a well-formed BCP 47 language tag as specified in RFC 5646 section
	 *   2.1, or successor,
	 * - does not include duplicate variant subtags, and
	 * - does not include duplicate singleton subtags.
	 *
	 * The abstract operation returns true if locale can be generated from the ABNF
	 * grammar in section 2.1 of the RFC, starting with Language-Tag, and does not
	 * contain duplicate variant or singleton subtags (other than as a private use
	 * subtag). It returns false otherwise. Terminal value characters in the grammar are
	 * interpreted as the Unicode equivalents of the ASCII octet values given.
	 */
	function /* 6.2.2 */IsStructurallyValidLanguageTag(locale) {
	    // represents a well-formed BCP 47 language tag as specified in RFC 5646
	    if (!src$exp$$.expBCP47Syntax.test(locale))
	        return false;
	
	    // does not include duplicate variant subtags, and
	    if (src$exp$$.expVariantDupes.test(locale))
	        return false;
	
	    // does not include duplicate singleton subtags.
	    if (src$exp$$.expSingletonDupes.test(locale))
	        return false;
	
	    return true;
	}
	
	/**
	 * The CanonicalizeLanguageTag abstract operation returns the canonical and case-
	 * regularized form of the locale argument (which must be a String value that is
	 * a structurally valid BCP 47 language tag as verified by the
	 * IsStructurallyValidLanguageTag abstract operation). It takes the steps
	 * specified in RFC 5646 section 4.5, or successor, to bring the language tag
	 * into canonical form, and to regularize the case of the subtags, but does not
	 * take the steps to bring a language tag into “extlang form” and to reorder
	 * variant subtags.
	
	 * The specifications for extensions to BCP 47 language tags, such as RFC 6067,
	 * may include canonicalization rules for the extension subtag sequences they
	 * define that go beyond the canonicalization rules of RFC 5646 section 4.5.
	 * Implementations are allowed, but not required, to apply these additional rules.
	 */
	function /* 6.2.3 */CanonicalizeLanguageTag (locale) {
	    var match, parts;
	
	    // A language tag is in 'canonical form' when the tag is well-formed
	    // according to the rules in Sections 2.1 and 2.2
	
	    // Section 2.1 says all subtags use lowercase...
	    locale = locale.toLowerCase();
	
	    // ...with 2 exceptions: 'two-letter and four-letter subtags that neither
	    // appear at the start of the tag nor occur after singletons.  Such two-letter
	    // subtags are all uppercase (as in the tags "en-CA-x-ca" or "sgn-BE-FR") and
	    // four-letter subtags are titlecase (as in the tag "az-Latn-x-latn").
	    parts = locale.split('-');
	    for (var i = 1, max = parts.length; i < max; i++) {
	        // Two-letter subtags are all uppercase
	        if (parts[i].length === 2)
	            parts[i] = parts[i].toUpperCase();
	
	        // Four-letter subtags are titlecase
	        else if (parts[i].length === 4)
	            parts[i] = parts[i].charAt(0).toUpperCase() + parts[i].slice(1);
	
	        // Is it a singleton?
	        else if (parts[i].length === 1 && parts[i] !== 'x')
	            break;
	    }
	    locale = arrJoin.call(parts, '-');
	
	    // The steps laid out in RFC 5646 section 4.5 are as follows:
	
	    // 1.  Extension sequences are ordered into case-insensitive ASCII order
	    //     by singleton subtag.
	    if ((match = locale.match(src$exp$$.expExtSequences)) && match.length > 1) {
	        // The built-in sort() sorts by ASCII order, so use that
	        match.sort();
	
	        // Replace all extensions with the joined, sorted array
	        locale = locale.replace(
	            RegExp('(?:' + src$exp$$.expExtSequences.source + ')+', 'i'),
	            arrJoin.call(match, '')
	        );
	    }
	
	    // 2.  Redundant or grandfathered tags are replaced by their 'Preferred-
	    //     Value', if there is one.
	    if (hop.call(redundantTags.tags, locale))
	        locale = redundantTags.tags[locale];
	
	    // 3.  Subtags are replaced by their 'Preferred-Value', if there is one.
	    //     For extlangs, the original primary language subtag is also
	    //     replaced if there is a primary language subtag in the 'Preferred-
	    //     Value'.
	    parts = locale.split('-');
	
	    for (var i = 1, max = parts.length; i < max; i++) {
	        if (hop.call(redundantTags.subtags, parts[i]))
	            parts[i] = redundantTags.subtags[parts[i]];
	
	        else if (hop.call(redundantTags.extLang, parts[i])) {
	            parts[i] = redundantTags.extLang[parts[i]][0];
	
	            // For extlang tags, the prefix needs to be removed if it is redundant
	            if (i === 1 && redundantTags.extLang[parts[1]][1] === parts[0]) {
	                parts = arrSlice.call(parts, i++);
	                max -= 1;
	            }
	        }
	    }
	
	    return arrJoin.call(parts, '-');
	}
	
	/**
	 * The DefaultLocale abstract operation returns a String value representing the
	 * structurally valid (6.2.2) and canonicalized (6.2.3) BCP 47 language tag for the
	 * host environment’s current locale.
	 */
	function /* 6.2.4 */DefaultLocale () {
	    return defaultLocale;
	}
	
	// Sect 6.3 Currency Codes
	// =======================
	
	/**
	 * The IsWellFormedCurrencyCode abstract operation verifies that the currency argument
	 * (after conversion to a String value) represents a well-formed 3-letter ISO currency
	 * code. The following steps are taken:
	 */
	function /* 6.3.1 */IsWellFormedCurrencyCode(currency) {
	    var
	        // 1. Let `c` be ToString(currency)
	        c = String(currency),
	
	        // 2. Let `normalized` be the result of mapping c to upper case as described
	        //    in 6.1.
	        normalized = toLatinUpperCase(c);
	
	    // 3. If the string length of normalized is not 3, return false.
	    // 4. If normalized contains any character that is not in the range "A" to "Z"
	    //    (U+0041 to U+005A), return false.
	    if (expCurrencyCode.test(normalized) === false)
	        return false;
	
	    // 5. Return true
	    return true;
	}
	
	// Sect 9.2 Abstract Operations
	// ============================
	function /* 9.2.1 */CanonicalizeLocaleList (locales) {
	// The abstract operation CanonicalizeLocaleList takes the following steps:
	
	    // 1. If locales is undefined, then a. Return a new empty List
	    if (locales === undefined)
	        return new List();
	
	    var
	        // 2. Let seen be a new empty List.
	        seen = new List(),
	
	        // 3. If locales is a String value, then
	        //    a. Let locales be a new array created as if by the expression new
	        //    Array(locales) where Array is the standard built-in constructor with
	        //    that name and locales is the value of locales.
	        locales = typeof locales === 'string' ? [ locales ] : locales,
	
	        // 4. Let O be ToObject(locales).
	        O = toObject(locales),
	
	        // 5. Let lenValue be the result of calling the [[Get]] internal method of
	        //    O with the argument "length".
	        // 6. Let len be ToUint32(lenValue).
	        len = O.length,
	
	        // 7. Let k be 0.
	        k = 0;
	
	    // 8. Repeat, while k < len
	    while (k < len) {
	        var
	            // a. Let Pk be ToString(k).
	            Pk = String(k),
	
	            // b. Let kPresent be the result of calling the [[HasProperty]] internal
	            //    method of O with argument Pk.
	            kPresent = Pk in O;
	
	        // c. If kPresent is true, then
	        if (kPresent) {
	            var
	                // i. Let kValue be the result of calling the [[Get]] internal
	                //     method of O with argument Pk.
	                kValue = O[Pk];
	
	            // ii. If the type of kValue is not String or Object, then throw a
	            //     TypeError exception.
	            if (kValue == null || (typeof kValue !== 'string' && typeof kValue !== 'object'))
	                throw new TypeError('String or Object type expected');
	
	            var
	                // iii. Let tag be ToString(kValue).
	                tag = String(kValue);
	
	            // iv. If the result of calling the abstract operation
	            //     IsStructurallyValidLanguageTag (defined in 6.2.2), passing tag as
	            //     the argument, is false, then throw a RangeError exception.
	            if (!IsStructurallyValidLanguageTag(tag))
	                throw new RangeError("'" + tag + "' is not a structurally valid language tag");
	
	            // v. Let tag be the result of calling the abstract operation
	            //    CanonicalizeLanguageTag (defined in 6.2.3), passing tag as the
	            //    argument.
	            tag = CanonicalizeLanguageTag(tag);
	
	            // vi. If tag is not an element of seen, then append tag as the last
	            //     element of seen.
	            if (arrIndexOf.call(seen, tag) === -1)
	                arrPush.call(seen, tag);
	        }
	
	        // d. Increase k by 1.
	        k++;
	    }
	
	    // 9. Return seen.
	    return seen;
	}
	
	/**
	 * The BestAvailableLocale abstract operation compares the provided argument
	 * locale, which must be a String value with a structurally valid and
	 * canonicalized BCP 47 language tag, against the locales in availableLocales and
	 * returns either the longest non-empty prefix of locale that is an element of
	 * availableLocales, or undefined if there is no such element. It uses the
	 * fallback mechanism of RFC 4647, section 3.4. The following steps are taken:
	 */
	function /* 9.2.2 */BestAvailableLocale (availableLocales, locale) {
	    var
	       // 1. Let candidate be locale
	       candidate = locale;
	
	    // 2. Repeat
	    while (true) {
	        // a. If availableLocales contains an element equal to candidate, then return
	        // candidate.
	        if (arrIndexOf.call(availableLocales, candidate) > -1)
	            return candidate;
	
	        var
	            // b. Let pos be the character index of the last occurrence of "-"
	            // (U+002D) within candidate. If that character does not occur, return
	            // undefined.
	            pos = candidate.lastIndexOf('-');
	
	        if (pos < 0)
	            return;
	
	        // c. If pos ≥ 2 and the character "-" occurs at index pos-2 of candidate,
	        //    then decrease pos by 2.
	        if (pos >= 2 && candidate.charAt(pos - 2) === '-')
	            pos -= 2;
	
	        // d. Let candidate be the substring of candidate from position 0, inclusive,
	        //    to position pos, exclusive.
	        candidate = candidate.substring(0, pos);
	    }
	}
	
	/**
	 * The LookupMatcher abstract operation compares requestedLocales, which must be
	 * a List as returned by CanonicalizeLocaleList, against the locales in
	 * availableLocales and determines the best available language to meet the
	 * request. The following steps are taken:
	 */
	function /* 9.2.3 */LookupMatcher (availableLocales, requestedLocales) {
	    var
	        // 1. Let i be 0.
	        i = 0,
	
	        // 2. Let len be the number of elements in requestedLocales.
	        len = requestedLocales.length,
	
	        // 3. Let availableLocale be undefined.
	        availableLocale;
	
	    // 4. Repeat while i < len and availableLocale is undefined:
	    while (i < len && !availableLocale) {
	        var
	            // a. Let locale be the element of requestedLocales at 0-origined list
	            //    position i.
	            locale = requestedLocales[i],
	
	            // b. Let noExtensionsLocale be the String value that is locale with all
	            //    Unicode locale extension sequences removed.
	            noExtensionsLocale = String(locale).replace(expUnicodeExSeq, ''),
	
	            // c. Let availableLocale be the result of calling the
	            //    BestAvailableLocale abstract operation (defined in 9.2.2) with
	            //    arguments availableLocales and noExtensionsLocale.
	            availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);
	
	        // d. Increase i by 1.
	        i++;
	    }
	
	    var
	        // 5. Let result be a new Record.
	        result = new Record();
	
	    // 6. If availableLocale is not undefined, then
	    if (availableLocale !== undefined) {
	        // a. Set result.[[locale]] to availableLocale.
	        result['[[locale]]'] = availableLocale;
	
	        // b. If locale and noExtensionsLocale are not the same String value, then
	        if (String(locale) !== String(noExtensionsLocale)) {
	            var
	                // i. Let extension be the String value consisting of the first
	                //    substring of locale that is a Unicode locale extension sequence.
	                extension = locale.match(expUnicodeExSeq)[0],
	
	                // ii. Let extensionIndex be the character position of the initial
	                //     "-" of the first Unicode locale extension sequence within locale.
	                extensionIndex = locale.indexOf('-u-');
	
	            // iii. Set result.[[extension]] to extension.
	            result['[[extension]]'] = extension;
	
	            // iv. Set result.[[extensionIndex]] to extensionIndex.
	            result['[[extensionIndex]]'] = extensionIndex;
	        }
	    }
	    // 7. Else
	    else
	        // a. Set result.[[locale]] to the value returned by the DefaultLocale abstract
	        //    operation (defined in 6.2.4).
	        result['[[locale]]'] = DefaultLocale();
	
	    // 8. Return result
	    return result;
	}
	
	/**
	 * The BestFitMatcher abstract operation compares requestedLocales, which must be
	 * a List as returned by CanonicalizeLocaleList, against the locales in
	 * availableLocales and determines the best available language to meet the
	 * request. The algorithm is implementation dependent, but should produce results
	 * that a typical user of the requested locales would perceive as at least as
	 * good as those produced by the LookupMatcher abstract operation. Options
	 * specified through Unicode locale extension sequences must be ignored by the
	 * algorithm. Information about such subsequences is returned separately.
	 * The abstract operation returns a record with a [[locale]] field, whose value
	 * is the language tag of the selected locale, which must be an element of
	 * availableLocales. If the language tag of the request locale that led to the
	 * selected locale contained a Unicode locale extension sequence, then the
	 * returned record also contains an [[extension]] field whose value is the first
	 * Unicode locale extension sequence, and an [[extensionIndex]] field whose value
	 * is the index of the first Unicode locale extension sequence within the request
	 * locale language tag.
	 */
	function /* 9.2.4 */BestFitMatcher (availableLocales, requestedLocales) {
	    return LookupMatcher(availableLocales, requestedLocales);
	}
	
	/**
	 * The ResolveLocale abstract operation compares a BCP 47 language priority list
	 * requestedLocales against the locales in availableLocales and determines the
	 * best available language to meet the request. availableLocales and
	 * requestedLocales must be provided as List values, options as a Record.
	 */
	function /* 9.2.5 */ResolveLocale (availableLocales, requestedLocales, options, relevantExtensionKeys, localeData) {
	    if (availableLocales.length === 0) {
	        throw new ReferenceError('No locale data has been provided for this object yet.');
	    }
	
	    // The following steps are taken:
	    var
	        // 1. Let matcher be the value of options.[[localeMatcher]].
	        matcher = options['[[localeMatcher]]'];
	
	    // 2. If matcher is "lookup", then
	    if (matcher === 'lookup')
	        var
	            // a. Let r be the result of calling the LookupMatcher abstract operation
	            //    (defined in 9.2.3) with arguments availableLocales and
	            //    requestedLocales.
	            r = LookupMatcher(availableLocales, requestedLocales);
	
	    // 3. Else
	    else
	        var
	            // a. Let r be the result of calling the BestFitMatcher abstract
	            //    operation (defined in 9.2.4) with arguments availableLocales and
	            //    requestedLocales.
	            r = BestFitMatcher(availableLocales, requestedLocales);
	
	    var
	        // 4. Let foundLocale be the value of r.[[locale]].
	        foundLocale = r['[[locale]]'];
	
	    // 5. If r has an [[extension]] field, then
	    if (hop.call(r, '[[extension]]'))
	        var
	            // a. Let extension be the value of r.[[extension]].
	            extension = r['[[extension]]'],
	            // b. Let extensionIndex be the value of r.[[extensionIndex]].
	            extensionIndex = r['[[extensionIndex]]'],
	            // c. Let split be the standard built-in function object defined in ES5,
	            //    15.5.4.14.
	            split = String.prototype.split,
	            // d. Let extensionSubtags be the result of calling the [[Call]] internal
	            //    method of split with extension as the this value and an argument
	            //    list containing the single item "-".
	            extensionSubtags = split.call(extension, '-'),
	            // e. Let extensionSubtagsLength be the result of calling the [[Get]]
	            //    internal method of extensionSubtags with argument "length".
	            extensionSubtagsLength = extensionSubtags.length;
	
	    var
	        // 6. Let result be a new Record.
	        result = new Record();
	
	    // 7. Set result.[[dataLocale]] to foundLocale.
	    result['[[dataLocale]]'] = foundLocale;
	
	    var
	        // 8. Let supportedExtension be "-u".
	        supportedExtension = '-u',
	        // 9. Let i be 0.
	        i = 0,
	        // 10. Let len be the result of calling the [[Get]] internal method of
	        //     relevantExtensionKeys with argument "length".
	        len = relevantExtensionKeys.length;
	
	    // 11 Repeat while i < len:
	    while (i < len) {
	        var
	            // a. Let key be the result of calling the [[Get]] internal method of
	            //    relevantExtensionKeys with argument ToString(i).
	            key = relevantExtensionKeys[i],
	            // b. Let foundLocaleData be the result of calling the [[Get]] internal
	            //    method of localeData with the argument foundLocale.
	            foundLocaleData = localeData[foundLocale],
	            // c. Let keyLocaleData be the result of calling the [[Get]] internal
	            //    method of foundLocaleData with the argument key.
	            keyLocaleData = foundLocaleData[key],
	            // d. Let value be the result of calling the [[Get]] internal method of
	            //    keyLocaleData with argument "0".
	            value = keyLocaleData['0'],
	            // e. Let supportedExtensionAddition be "".
	            supportedExtensionAddition = '',
	            // f. Let indexOf be the standard built-in function object defined in
	            //    ES5, 15.4.4.14.
	            indexOf = arrIndexOf;
	
	        // g. If extensionSubtags is not undefined, then
	        if (extensionSubtags !== undefined) {
	            var
	                // i. Let keyPos be the result of calling the [[Call]] internal
	                //    method of indexOf with extensionSubtags as the this value and
	                // an argument list containing the single item key.
	                keyPos = indexOf.call(extensionSubtags, key);
	
	            // ii. If keyPos ≠ -1, then
	            if (keyPos !== -1) {
	                // 1. If keyPos + 1 < extensionSubtagsLength and the length of the
	                //    result of calling the [[Get]] internal method of
	                //    extensionSubtags with argument ToString(keyPos +1) is greater
	                //    than 2, then
	                if (keyPos + 1 < extensionSubtagsLength
	                        && extensionSubtags[keyPos + 1].length > 2) {
	                    var
	                        // a. Let requestedValue be the result of calling the [[Get]]
	                        //    internal method of extensionSubtags with argument
	                        //    ToString(keyPos + 1).
	                        requestedValue = extensionSubtags[keyPos + 1],
	                        // b. Let valuePos be the result of calling the [[Call]]
	                        //    internal method of indexOf with keyLocaleData as the
	                        //    this value and an argument list containing the single
	                        //    item requestedValue.
	                        valuePos = indexOf.call(keyLocaleData, requestedValue);
	
	                    // c. If valuePos ≠ -1, then
	                    if (valuePos !== -1)
	                        var
	                            // i. Let value be requestedValue.
	                            value = requestedValue,
	                            // ii. Let supportedExtensionAddition be the
	                            //     concatenation of "-", key, "-", and value.
	                            supportedExtensionAddition = '-' + key + '-' + value;
	                }
	                // 2. Else
	                else {
	                    var
	                        // a. Let valuePos be the result of calling the [[Call]]
	                        // internal method of indexOf with keyLocaleData as the this
	                        // value and an argument list containing the single item
	                        // "true".
	                        valuePos = indexOf(keyLocaleData, 'true');
	
	                    // b. If valuePos ≠ -1, then
	                    if (valuePos !== -1)
	                        var
	                            // i. Let value be "true".
	                            value = 'true';
	                }
	            }
	        }
	        // h. If options has a field [[<key>]], then
	        if (hop.call(options, '[[' + key + ']]')) {
	            var
	                // i. Let optionsValue be the value of options.[[<key>]].
	                optionsValue = options['[[' + key + ']]'];
	
	            // ii. If the result of calling the [[Call]] internal method of indexOf
	            //     with keyLocaleData as the this value and an argument list
	            //     containing the single item optionsValue is not -1, then
	            if (indexOf.call(keyLocaleData, optionsValue) !== -1) {
	                // 1. If optionsValue is not equal to value, then
	                if (optionsValue !== value) {
	                    // a. Let value be optionsValue.
	                    value = optionsValue;
	                    // b. Let supportedExtensionAddition be "".
	                    supportedExtensionAddition = '';
	                }
	            }
	        }
	        // i. Set result.[[<key>]] to value.
	        result['[[' + key + ']]'] = value;
	
	        // j. Append supportedExtensionAddition to supportedExtension.
	        supportedExtension += supportedExtensionAddition;
	
	        // k. Increase i by 1.
	        i++;
	    }
	    // 12. If the length of supportedExtension is greater than 2, then
	    if (supportedExtension.length > 2) {
	        var
	            // a. Let preExtension be the substring of foundLocale from position 0,
	            //    inclusive, to position extensionIndex, exclusive.
	            preExtension = foundLocale.substring(0, extensionIndex),
	            // b. Let postExtension be the substring of foundLocale from position
	            //    extensionIndex to the end of the string.
	            postExtension = foundLocale.substring(extensionIndex),
	            // c. Let foundLocale be the concatenation of preExtension,
	            //    supportedExtension, and postExtension.
	            foundLocale = preExtension + supportedExtension + postExtension;
	    }
	    // 13. Set result.[[locale]] to foundLocale.
	    result['[[locale]]'] = foundLocale;
	
	    // 14. Return result.
	    return result;
	}
	
	/**
	 * The LookupSupportedLocales abstract operation returns the subset of the
	 * provided BCP 47 language priority list requestedLocales for which
	 * availableLocales has a matching locale when using the BCP 47 Lookup algorithm.
	 * Locales appear in the same order in the returned list as in requestedLocales.
	 * The following steps are taken:
	 */
	function /* 9.2.6 */LookupSupportedLocales (availableLocales, requestedLocales) {
	    var
	        // 1. Let len be the number of elements in requestedLocales.
	        len = requestedLocales.length,
	        // 2. Let subset be a new empty List.
	        subset = new List(),
	        // 3. Let k be 0.
	        k = 0;
	
	    // 4. Repeat while k < len
	    while (k < len) {
	        var
	            // a. Let locale be the element of requestedLocales at 0-origined list
	            //    position k.
	            locale = requestedLocales[k],
	            // b. Let noExtensionsLocale be the String value that is locale with all
	            //    Unicode locale extension sequences removed.
	            noExtensionsLocale = String(locale).replace(expUnicodeExSeq, ''),
	            // c. Let availableLocale be the result of calling the
	            //    BestAvailableLocale abstract operation (defined in 9.2.2) with
	            //    arguments availableLocales and noExtensionsLocale.
	            availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);
	
	        // d. If availableLocale is not undefined, then append locale to the end of
	        //    subset.
	        if (availableLocale !== undefined)
	            arrPush.call(subset, locale);
	
	        // e. Increment k by 1.
	        k++;
	    }
	
	    var
	        // 5. Let subsetArray be a new Array object whose elements are the same
	        //    values in the same order as the elements of subset.
	        subsetArray = arrSlice.call(subset);
	
	    // 6. Return subsetArray.
	    return subsetArray;
	}
	
	/**
	 * The BestFitSupportedLocales abstract operation returns the subset of the
	 * provided BCP 47 language priority list requestedLocales for which
	 * availableLocales has a matching locale when using the Best Fit Matcher
	 * algorithm. Locales appear in the same order in the returned list as in
	 * requestedLocales. The steps taken are implementation dependent.
	 */
	function /*9.2.7 */BestFitSupportedLocales (availableLocales, requestedLocales) {
	    // ###TODO: implement this function as described by the specification###
	    return LookupSupportedLocales(availableLocales, requestedLocales);
	}
	
	/**
	 * The SupportedLocales abstract operation returns the subset of the provided BCP
	 * 47 language priority list requestedLocales for which availableLocales has a
	 * matching locale. Two algorithms are available to match the locales: the Lookup
	 * algorithm described in RFC 4647 section 3.4, and an implementation dependent
	 * best-fit algorithm. Locales appear in the same order in the returned list as
	 * in requestedLocales. The following steps are taken:
	 */
	function /*9.2.8 */SupportedLocales (availableLocales, requestedLocales, options) {
	    // 1. If options is not undefined, then
	    if (options !== undefined) {
	        var
	            // a. Let options be ToObject(options).
	            options = new Record(toObject(options)),
	            // b. Let matcher be the result of calling the [[Get]] internal method of
	            //    options with argument "localeMatcher".
	            matcher = options.localeMatcher;
	
	        // c. If matcher is not undefined, then
	        if (matcher !== undefined) {
	            // i. Let matcher be ToString(matcher).
	            matcher = String(matcher);
	
	            // ii. If matcher is not "lookup" or "best fit", then throw a RangeError
	            //     exception.
	            if (matcher !== 'lookup' && matcher !== 'best fit')
	                throw new RangeError('matcher should be "lookup" or "best fit"');
	        }
	    }
	    // 2. If matcher is undefined or "best fit", then
	    if (matcher === undefined || matcher === 'best fit')
	        var
	            // a. Let subset be the result of calling the BestFitSupportedLocales
	            //    abstract operation (defined in 9.2.7) with arguments
	            //    availableLocales and requestedLocales.
	            subset = BestFitSupportedLocales(availableLocales, requestedLocales);
	    // 3. Else
	    else
	        var
	            // a. Let subset be the result of calling the LookupSupportedLocales
	            //    abstract operation (defined in 9.2.6) with arguments
	            //    availableLocales and requestedLocales.
	            subset = LookupSupportedLocales(availableLocales, requestedLocales);
	
	    // 4. For each named own property name P of subset,
	    for (var P in subset) {
	        if (!hop.call(subset, P))
	            continue;
	
	        // a. Let desc be the result of calling the [[GetOwnProperty]] internal
	        //    method of subset with P.
	        // b. Set desc.[[Writable]] to false.
	        // c. Set desc.[[Configurable]] to false.
	        // d. Call the [[DefineOwnProperty]] internal method of subset with P, desc,
	        //    and true as arguments.
	        defineProperty(subset, P, {
	            writable: false, configurable: false, value: subset[P]
	        });
	    }
	    // "Freeze" the array so no new elements can be added
	    defineProperty(subset, 'length', { writable: false });
	
	    // 5. Return subset
	    return subset;
	}
	
	/**
	 * The GetOption abstract operation extracts the value of the property named
	 * property from the provided options object, converts it to the required type,
	 * checks whether it is one of a List of allowed values, and fills in a fallback
	 * value if necessary.
	 */
	function /*9.2.9 */GetOption (options, property, type, values, fallback) {
	    var
	        // 1. Let value be the result of calling the [[Get]] internal method of
	        //    options with argument property.
	        value = options[property];
	
	    // 2. If value is not undefined, then
	    if (value !== undefined) {
	        // a. Assert: type is "boolean" or "string".
	        // b. If type is "boolean", then let value be ToBoolean(value).
	        // c. If type is "string", then let value be ToString(value).
	        value = type === 'boolean' ? Boolean(value)
	                  : (type === 'string' ? String(value) : value);
	
	        // d. If values is not undefined, then
	        if (values !== undefined) {
	            // i. If values does not contain an element equal to value, then throw a
	            //    RangeError exception.
	            if (arrIndexOf.call(values, value) === -1)
	                throw new RangeError("'" + value + "' is not an allowed value for `" + property +'`');
	        }
	
	        // e. Return value.
	        return value;
	    }
	    // Else return fallback.
	    return fallback;
	}
	
	/**
	 * The GetNumberOption abstract operation extracts a property value from the
	 * provided options object, converts it to a Number value, checks whether it is
	 * in the allowed range, and fills in a fallback value if necessary.
	 */
	function /* 9.2.10 */GetNumberOption (options, property, minimum, maximum, fallback) {
	    var
	        // 1. Let value be the result of calling the [[Get]] internal method of
	        //    options with argument property.
	        value = options[property];
	
	    // 2. If value is not undefined, then
	    if (value !== undefined) {
	        // a. Let value be ToNumber(value).
	        value = Number(value);
	
	        // b. If value is NaN or less than minimum or greater than maximum, throw a
	        //    RangeError exception.
	        if (isNaN(value) || value < minimum || value > maximum)
	            throw new RangeError('Value is not a number or outside accepted range');
	
	        // c. Return floor(value).
	        return Math.floor(value);
	    }
	    // 3. Else return fallback.
	    return fallback;
	}
	
	// 11.1 The Intl.NumberFormat constructor
	// ======================================
	
	// Define the NumberFormat constructor internally so it cannot be tainted
	function NumberFormatConstructor () {
	    var locales = arguments[0];
	    var options = arguments[1];
	
	    if (!this || this === Intl) {
	        return new Intl.NumberFormat(locales, options);
	    }
	
	    return InitializeNumberFormat(toObject(this), locales, options);
	}
	
	defineProperty(Intl, 'NumberFormat', {
	    configurable: true,
	    writable: true,
	    value: NumberFormatConstructor
	});
	
	// Must explicitly set prototypes as unwritable
	defineProperty(Intl.NumberFormat, 'prototype', {
	    writable: false
	});
	
	/**
	 * The abstract operation InitializeNumberFormat accepts the arguments
	 * numberFormat (which must be an object), locales, and options. It initializes
	 * numberFormat as a NumberFormat object.
	 */
	function /*11.1.1.1 */InitializeNumberFormat (numberFormat, locales, options) {
	    var
	    // This will be a internal properties object if we're not already initialized
	        internal = getInternalProperties(numberFormat),
	
	    // Create an object whose props can be used to restore the values of RegExp props
	        regexpState = createRegExpRestore();
	
	    // 1. If numberFormat has an [[initializedIntlObject]] internal property with
	    // value true, throw a TypeError exception.
	    if (internal['[[initializedIntlObject]]'] === true)
	        throw new TypeError('`this` object has already been initialized as an Intl object');
	
	    // Need this to access the `internal` object
	    defineProperty(numberFormat, '__getInternalProperties', {
	        value: function () {
	            // NOTE: Non-standard, for internal use only
	            if (arguments[0] === secret)
	                return internal;
	        }
	    });
	
	    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
	    internal['[[initializedIntlObject]]'] = true;
	
	    var
	    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	    //    abstract operation (defined in 9.2.1) with argument locales.
	        requestedLocales = CanonicalizeLocaleList(locales);
	
	    // 4. If options is undefined, then
	    if (options === undefined)
	        // a. Let options be the result of creating a new object as if by the
	        // expression new Object() where Object is the standard built-in constructor
	        // with that name.
	        options = {};
	
	    // 5. Else
	    else
	        // a. Let options be ToObject(options).
	        options = toObject(options);
	
	    var
	    // 6. Let opt be a new Record.
	        opt = new Record(),
	
	    // 7. Let matcher be the result of calling the GetOption abstract operation
	    //    (defined in 9.2.9) with the arguments options, "localeMatcher", "string",
	    //    a List containing the two String values "lookup" and "best fit", and
	    //    "best fit".
	        matcher =  GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');
	
	    // 8. Set opt.[[localeMatcher]] to matcher.
	    opt['[[localeMatcher]]'] = matcher;
	
	    var
	    // 9. Let NumberFormat be the standard built-in object that is the initial value
	    //    of Intl.NumberFormat.
	    // 10. Let localeData be the value of the [[localeData]] internal property of
	    //     NumberFormat.
	        localeData = internals.NumberFormat['[[localeData]]'],
	
	    // 11. Let r be the result of calling the ResolveLocale abstract operation
	    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
	    //     NumberFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
	    //     internal property of NumberFormat, and localeData.
	        r = ResolveLocale(
	                internals.NumberFormat['[[availableLocales]]'], requestedLocales,
	                opt, internals.NumberFormat['[[relevantExtensionKeys]]'], localeData
	            );
	
	    // 12. Set the [[locale]] internal property of numberFormat to the value of
	    //     r.[[locale]].
	    internal['[[locale]]'] = r['[[locale]]'];
	
	    // 13. Set the [[numberingSystem]] internal property of numberFormat to the value
	    //     of r.[[nu]].
	    internal['[[numberingSystem]]'] = r['[[nu]]'];
	
	    // The specification doesn't tell us to do this, but it's helpful later on
	    internal['[[dataLocale]]'] = r['[[dataLocale]]'];
	
	    var
	    // 14. Let dataLocale be the value of r.[[dataLocale]].
	        dataLocale = r['[[dataLocale]]'],
	
	    // 15. Let s be the result of calling the GetOption abstract operation with the
	    //     arguments options, "style", "string", a List containing the three String
	    //     values "decimal", "percent", and "currency", and "decimal".
	        s = GetOption(options, 'style', 'string', new List('decimal', 'percent', 'currency'), 'decimal');
	
	    // 16. Set the [[style]] internal property of numberFormat to s.
	    internal['[[style]]'] = s;
	
	    var
	    // 17. Let c be the result of calling the GetOption abstract operation with the
	    //     arguments options, "currency", "string", undefined, and undefined.
	        c = GetOption(options, 'currency', 'string');
	
	    // 18. If c is not undefined and the result of calling the
	    //     IsWellFormedCurrencyCode abstract operation (defined in 6.3.1) with
	    //     argument c is false, then throw a RangeError exception.
	    if (c !== undefined && !IsWellFormedCurrencyCode(c))
	        throw new RangeError("'" + c + "' is not a valid currency code");
	
	    // 19. If s is "currency" and c is undefined, throw a TypeError exception.
	    if (s === 'currency' && c === undefined)
	        throw new TypeError('Currency code is required when style is currency');
	
	    // 20. If s is "currency", then
	    if (s === 'currency') {
	        // a. Let c be the result of converting c to upper case as specified in 6.1.
	        c = c.toUpperCase();
	
	        // b. Set the [[currency]] internal property of numberFormat to c.
	        internal['[[currency]]'] = c;
	
	        var
	        // c. Let cDigits be the result of calling the CurrencyDigits abstract
	        //    operation (defined below) with argument c.
	            cDigits = CurrencyDigits(c);
	    }
	
	    var
	    // 21. Let cd be the result of calling the GetOption abstract operation with the
	    //     arguments options, "currencyDisplay", "string", a List containing the
	    //     three String values "code", "symbol", and "name", and "symbol".
	        cd = GetOption(options, 'currencyDisplay', 'string', new List('code', 'symbol', 'name'), 'symbol');
	
	    // 22. If s is "currency", then set the [[currencyDisplay]] internal property of
	    //     numberFormat to cd.
	    if (s === 'currency')
	        internal['[[currencyDisplay]]'] = cd;
	
	    var
	    // 23. Let mnid be the result of calling the GetNumberOption abstract operation
	    //     (defined in 9.2.10) with arguments options, "minimumIntegerDigits", 1, 21,
	    //     and 1.
	        mnid = GetNumberOption(options, 'minimumIntegerDigits', 1, 21, 1);
	
	    // 24. Set the [[minimumIntegerDigits]] internal property of numberFormat to mnid.
	    internal['[[minimumIntegerDigits]]'] = mnid;
	
	    var
	    // 25. If s is "currency", then let mnfdDefault be cDigits; else let mnfdDefault
	    //     be 0.
	        mnfdDefault = s === 'currency' ? cDigits : 0,
	
	    // 26. Let mnfd be the result of calling the GetNumberOption abstract operation
	    //     with arguments options, "minimumFractionDigits", 0, 20, and mnfdDefault.
	        mnfd = GetNumberOption(options, 'minimumFractionDigits', 0, 20, mnfdDefault);
	
	    // 27. Set the [[minimumFractionDigits]] internal property of numberFormat to mnfd.
	    internal['[[minimumFractionDigits]]'] = mnfd;
	
	    var
	    // 28. If s is "currency", then let mxfdDefault be max(mnfd, cDigits); else if s
	    //     is "percent", then let mxfdDefault be max(mnfd, 0); else let mxfdDefault
	    //     be max(mnfd, 3).
	        mxfdDefault = s === 'currency' ? Math.max(mnfd, cDigits)
	                    : (s === 'percent' ? Math.max(mnfd, 0) : Math.max(mnfd, 3)),
	
	    // 29. Let mxfd be the result of calling the GetNumberOption abstract operation
	    //     with arguments options, "maximumFractionDigits", mnfd, 20, and mxfdDefault.
	        mxfd = GetNumberOption(options, 'maximumFractionDigits', mnfd, 20, mxfdDefault);
	
	    // 30. Set the [[maximumFractionDigits]] internal property of numberFormat to mxfd.
	    internal['[[maximumFractionDigits]]'] = mxfd;
	
	    var
	    // 31. Let mnsd be the result of calling the [[Get]] internal method of options
	    //     with argument "minimumSignificantDigits".
	        mnsd = options.minimumSignificantDigits,
	
	    // 32. Let mxsd be the result of calling the [[Get]] internal method of options
	    //     with argument "maximumSignificantDigits".
	        mxsd = options.maximumSignificantDigits;
	
	    // 33. If mnsd is not undefined or mxsd is not undefined, then:
	    if (mnsd !== undefined || mxsd !== undefined) {
	        // a. Let mnsd be the result of calling the GetNumberOption abstract
	        //    operation with arguments options, "minimumSignificantDigits", 1, 21,
	        //    and 1.
	        mnsd = GetNumberOption(options, 'minimumSignificantDigits', 1, 21, 1);
	
	        // b. Let mxsd be the result of calling the GetNumberOption abstract
	        //     operation with arguments options, "maximumSignificantDigits", mnsd,
	        //     21, and 21.
	        mxsd = GetNumberOption(options, 'maximumSignificantDigits', mnsd, 21, 21);
	
	        // c. Set the [[minimumSignificantDigits]] internal property of numberFormat
	        //    to mnsd, and the [[maximumSignificantDigits]] internal property of
	        //    numberFormat to mxsd.
	        internal['[[minimumSignificantDigits]]'] = mnsd;
	        internal['[[maximumSignificantDigits]]'] = mxsd;
	    }
	    var
	    // 34. Let g be the result of calling the GetOption abstract operation with the
	    //     arguments options, "useGrouping", "boolean", undefined, and true.
	        g = GetOption(options, 'useGrouping', 'boolean', undefined, true);
	
	    // 35. Set the [[useGrouping]] internal property of numberFormat to g.
	    internal['[[useGrouping]]'] = g;
	
	    var
	    // 36. Let dataLocaleData be the result of calling the [[Get]] internal method of
	    //     localeData with argument dataLocale.
	        dataLocaleData = localeData[dataLocale],
	
	    // 37. Let patterns be the result of calling the [[Get]] internal method of
	    //     dataLocaleData with argument "patterns".
	        patterns = dataLocaleData.patterns;
	
	    // 38. Assert: patterns is an object (see 11.2.3)
	
	    var
	    // 39. Let stylePatterns be the result of calling the [[Get]] internal method of
	    //     patterns with argument s.
	        stylePatterns = patterns[s];
	
	    // 40. Set the [[positivePattern]] internal property of numberFormat to the
	    //     result of calling the [[Get]] internal method of stylePatterns with the
	    //     argument "positivePattern".
	    internal['[[positivePattern]]'] = stylePatterns.positivePattern;
	
	    // 41. Set the [[negativePattern]] internal property of numberFormat to the
	    //     result of calling the [[Get]] internal method of stylePatterns with the
	    //     argument "negativePattern".
	    internal['[[negativePattern]]'] = stylePatterns.negativePattern;
	
	    // 42. Set the [[boundFormat]] internal property of numberFormat to undefined.
	    internal['[[boundFormat]]'] = undefined;
	
	    // 43. Set the [[initializedNumberFormat]] internal property of numberFormat to
	    //     true.
	    internal['[[initializedNumberFormat]]'] = true;
	
	    // In ES3, we need to pre-bind the format() function
	    if (es3)
	        numberFormat.format = GetFormatNumber.call(numberFormat);
	
	    // Restore the RegExp properties
	    regexpState.exp.test(regexpState.input);
	
	    // Return the newly initialised object
	    return numberFormat;
	}
	
	function CurrencyDigits(currency) {
	    // When the CurrencyDigits abstract operation is called with an argument currency
	    // (which must be an upper case String value), the following steps are taken:
	
	    // 1. If the ISO 4217 currency and funds code list contains currency as an
	    // alphabetic code, then return the minor unit value corresponding to the
	    // currency from the list; else return 2.
	    return currencyMinorUnits[currency] !== undefined
	                ? currencyMinorUnits[currency]
	                : 2;
	}
	
	/* 11.2.3 */internals.NumberFormat = {
	    '[[availableLocales]]': [],
	    '[[relevantExtensionKeys]]': ['nu'],
	    '[[localeData]]': {}
	};
	
	/**
	 * When the supportedLocalesOf method of Intl.NumberFormat is called, the
	 * following steps are taken:
	 */
	/* 11.2.2 */defineProperty(Intl.NumberFormat, 'supportedLocalesOf', {
	    configurable: true,
	    writable: true,
	    value: fnBind.call(supportedLocalesOf, internals.NumberFormat)
	});
	
	/**
	 * This named accessor property returns a function that formats a number
	 * according to the effective locale and the formatting options of this
	 * NumberFormat object.
	 */
	/* 11.3.2 */defineProperty(Intl.NumberFormat.prototype, 'format', {
	    configurable: true,
	    get: GetFormatNumber
	});
	
	function GetFormatNumber() {
	        var internal = this != null && typeof this === 'object' && getInternalProperties(this);
	
	        // Satisfy test 11.3_b
	        if (!internal || !internal['[[initializedNumberFormat]]'])
	            throw new TypeError('`this` value for format() is not an initialized Intl.NumberFormat object.');
	
	        // The value of the [[Get]] attribute is a function that takes the following
	        // steps:
	
	        // 1. If the [[boundFormat]] internal property of this NumberFormat object
	        //    is undefined, then:
	        if (internal['[[boundFormat]]'] === undefined) {
	            var
	            // a. Let F be a Function object, with internal properties set as
	            //    specified for built-in functions in ES5, 15, or successor, and the
	            //    length property set to 1, that takes the argument value and
	            //    performs the following steps:
	                F = function (value) {
	                    // i. If value is not provided, then let value be undefined.
	                    // ii. Let x be ToNumber(value).
	                    // iii. Return the result of calling the FormatNumber abstract
	                    //      operation (defined below) with arguments this and x.
	                    return FormatNumber(this, /* x = */Number(value));
	                },
	
	            // b. Let bind be the standard built-in function object defined in ES5,
	            //    15.3.4.5.
	            // c. Let bf be the result of calling the [[Call]] internal method of
	            //    bind with F as the this value and an argument list containing
	            //    the single item this.
	                bf = fnBind.call(F, this);
	
	            // d. Set the [[boundFormat]] internal property of this NumberFormat
	            //    object to bf.
	            internal['[[boundFormat]]'] = bf;
	        }
	        // Return the value of the [[boundFormat]] internal property of this
	        // NumberFormat object.
	        return internal['[[boundFormat]]'];
	    }
	
	/**
	 * When the FormatNumber abstract operation is called with arguments numberFormat
	 * (which must be an object initialized as a NumberFormat) and x (which must be a
	 * Number value), it returns a String value representing x according to the
	 * effective locale and the formatting options of numberFormat.
	 */
	function FormatNumber (numberFormat, x) {
	    var n,
	
	    // Create an object whose props can be used to restore the values of RegExp props
	        regexpState = createRegExpRestore(),
	
	        internal = getInternalProperties(numberFormat),
	        locale = internal['[[dataLocale]]'],
	        nums   = internal['[[numberingSystem]]'],
	        data   = internals.NumberFormat['[[localeData]]'][locale],
	        ild    = data.symbols[nums] || data.symbols.latn,
	
	    // 1. Let negative be false.
	        negative = false;
	
	    // 2. If the result of isFinite(x) is false, then
	    if (isFinite(x) === false) {
	        // a. If x is NaN, then let n be an ILD String value indicating the NaN value.
	        if (isNaN(x))
	            n = ild.nan;
	
	        // b. Else
	        else {
	            // a. Let n be an ILD String value indicating infinity.
	            n = ild.infinity;
	            // b. If x < 0, then let negative be true.
	            if (x < 0)
	                negative = true;
	        }
	    }
	    // 3. Else
	    else {
	        // a. If x < 0, then
	        if (x < 0) {
	            // i. Let negative be true.
	            negative = true;
	            // ii. Let x be -x.
	            x = -x;
	        }
	
	        // b. If the value of the [[style]] internal property of numberFormat is
	        //    "percent", let x be 100 × x.
	        if (internal['[[style]]'] === 'percent')
	            x *= 100;
	
	        // c. If the [[minimumSignificantDigits]] and [[maximumSignificantDigits]]
	        //    internal properties of numberFormat are present, then
	        if (hop.call(internal, '[[minimumSignificantDigits]]') &&
	                hop.call(internal, '[[maximumSignificantDigits]]'))
	            // i. Let n be the result of calling the ToRawPrecision abstract operation
	            //    (defined below), passing as arguments x and the values of the
	            //    [[minimumSignificantDigits]] and [[maximumSignificantDigits]]
	            //    internal properties of numberFormat.
	            n = ToRawPrecision(x,
	                  internal['[[minimumSignificantDigits]]'],
	                  internal['[[maximumSignificantDigits]]']);
	        // d. Else
	        else
	            // i. Let n be the result of calling the ToRawFixed abstract operation
	            //    (defined below), passing as arguments x and the values of the
	            //    [[minimumIntegerDigits]], [[minimumFractionDigits]], and
	            //    [[maximumFractionDigits]] internal properties of numberFormat.
	            n = ToRawFixed(x,
	                  internal['[[minimumIntegerDigits]]'],
	                  internal['[[minimumFractionDigits]]'],
	                  internal['[[maximumFractionDigits]]']);
	
	        // e. If the value of the [[numberingSystem]] internal property of
	        //    numberFormat matches one of the values in the “Numbering System” column
	        //    of Table 2 below, then
	        if (numSys[nums]) {
	            // i. Let digits be an array whose 10 String valued elements are the
	            //    UTF-16 string representations of the 10 digits specified in the
	            //    “Digits” column of Table 2 in the row containing the value of the
	            //    [[numberingSystem]] internal property.
	            var digits = numSys[internal['[[numberingSystem]]']];
	            // ii. Replace each digit in n with the value of digits[digit].
	            n = String(n).replace(/\d/g, function (digit) {
	                return digits[digit];
	            });
	        }
	        // f. Else use an implementation dependent algorithm to map n to the
	        //    appropriate representation of n in the given numbering system.
	        else
	            n = String(n); // ###TODO###
	
	        // g. If n contains the character ".", then replace it with an ILND String
	        //    representing the decimal separator.
	        n = n.replace(/\./g, ild.decimal);
	
	        // h. If the value of the [[useGrouping]] internal property of numberFormat
	        //    is true, then insert an ILND String representing a grouping separator
	        //    into an ILND set of locations within the integer part of n.
	        if (internal['[[useGrouping]]'] === true) {
	            var
	                parts  = n.split(ild.decimal),
	                igr    = parts[0],
	
	                // Primary group represents the group closest to the decimal
	                pgSize = data.patterns.primaryGroupSize || 3,
	
	                // Secondary group is every other group
	                sgSize = data.patterns.secondaryGroupSize || pgSize;
	
	            // Group only if necessary
	            if (igr.length > pgSize) {
	                var
	                    groups = new List(),
	
	                    // Index of the primary grouping separator
	                    end    = igr.length - pgSize,
	
	                    // Starting index for our loop
	                    idx    = end % sgSize,
	
	                    start  = igr.slice(0, idx);
	
	                if (start.length)
	                    arrPush.call(groups, start);
	
	                // Loop to separate into secondary grouping digits
	                while (idx < end) {
	                    arrPush.call(groups, igr.slice(idx, idx + sgSize));
	                    idx += sgSize;
	                }
	
	                // Add the primary grouping digits
	                arrPush.call(groups, igr.slice(end));
	
	                parts[0] = arrJoin.call(groups, ild.group);
	            }
	
	            n = arrJoin.call(parts, ild.decimal);
	        }
	    }
	
	    var
	    // 4. If negative is true, then let result be the value of the [[negativePattern]]
	    //    internal property of numberFormat; else let result be the value of the
	    //    [[positivePattern]] internal property of numberFormat.
	        result = internal[negative === true ? '[[negativePattern]]' : '[[positivePattern]]'];
	
	    // 5. Replace the substring "{number}" within result with n.
	    result = result.replace('{number}', n);
	
	    // 6. If the value of the [[style]] internal property of numberFormat is
	    //    "currency", then:
	    if (internal['[[style]]'] === 'currency') {
	        var cd,
	        // a. Let currency be the value of the [[currency]] internal property of
	        //    numberFormat.
	            currency = internal['[[currency]]'],
	
	        // Shorthand for the currency data
	            cData = data.currencies[currency];
	
	        // b. If the value of the [[currencyDisplay]] internal property of
	        //    numberFormat is "code", then let cd be currency.
	        // c. Else if the value of the [[currencyDisplay]] internal property of
	        //    numberFormat is "symbol", then let cd be an ILD string representing
	        //    currency in short form. If the implementation does not have such a
	        //    representation of currency, then use currency itself.
	        // d. Else if the value of the [[currencyDisplay]] internal property of
	        //    numberFormat is "name", then let cd be an ILD string representing
	        //    currency in long form. If the implementation does not have such a
	        //    representation of currency, then use currency itself.
	        switch (internal['[[currencyDisplay]]']) {
	            case 'symbol':
	                cd = cData || currency;
	                break;
	
	            default:
	            case 'code':
	            case 'name':
	                cd = currency;
	        }
	
	        // e. Replace the substring "{currency}" within result with cd.
	        result = result.replace('{currency}', cd);
	    }
	
	    // Restore the RegExp properties
	    regexpState.exp.test(regexpState.input);
	
	    // 7. Return result.
	    return result;
	}
	
	/**
	 * When the ToRawPrecision abstract operation is called with arguments x (which
	 * must be a finite non-negative number), minPrecision, and maxPrecision (both
	 * must be integers between 1 and 21) the following steps are taken:
	 */
	function ToRawPrecision (x, minPrecision, maxPrecision) {
	    var
	    // 1. Let p be maxPrecision.
	        p = maxPrecision;
	
	    // 2. If x = 0, then
	    if (x === 0) {
	        var
	        // a. Let m be the String consisting of p occurrences of the character "0".
	            m = arrJoin.call(Array (p + 1), '0'),
	        // b. Let e be 0.
	            e = 0;
	    }
	    // 3. Else
	    else {
	        // a. Let e and n be integers such that 10ᵖ⁻¹ ≤ n < 10ᵖ and for which the
	        //    exact mathematical value of n × 10ᵉ⁻ᵖ⁺¹ – x is as close to zero as
	        //    possible. If there are two such sets of e and n, pick the e and n for
	        //    which n × 10ᵉ⁻ᵖ⁺¹ is larger.
	        var
	            e = log10Floor(Math.abs(x)),
	
	            // Easier to get to m from here
	            f = Math.round(Math.exp((Math.abs(e - p + 1)) * Math.LN10)),
	
	        // b. Let m be the String consisting of the digits of the decimal
	        //    representation of n (in order, with no leading zeroes)
	            m = String(Math.round(e - p + 1 < 0 ? x * f : x / f));
	    }
	
	    // 4. If e ≥ p, then
	    if (e >= p)
	        // a. Return the concatenation of m and e-p+1 occurrences of the character "0".
	        return m + arrJoin.call(Array(e-p+1 + 1), '0');
	
	    // 5. If e = p-1, then
	    else if (e === p - 1)
	        // a. Return m.
	        return m;
	
	    // 6. If e ≥ 0, then
	    else if (e >= 0)
	        // a. Let m be the concatenation of the first e+1 characters of m, the character
	        //    ".", and the remaining p–(e+1) characters of m.
	        m = m.slice(0, e + 1) + '.' + m.slice(e + 1);
	
	    // 7. If e < 0, then
	    else if (e < 0)
	        // a. Let m be the concatenation of the String "0.", –(e+1) occurrences of the
	        //    character "0", and the string m.
	        m = '0.' + arrJoin.call(Array (-(e+1) + 1), '0') + m;
	
	    // 8. If m contains the character ".", and maxPrecision > minPrecision, then
	    if (m.indexOf(".") >= 0 && maxPrecision > minPrecision) {
	        var
	        // a. Let cut be maxPrecision – minPrecision.
	            cut = maxPrecision - minPrecision;
	
	        // b. Repeat while cut > 0 and the last character of m is "0":
	        while (cut > 0 && m.charAt(m.length-1) === '0') {
	            //  i. Remove the last character from m.
	            m = m.slice(0, -1);
	
	            //  ii. Decrease cut by 1.
	            cut--;
	        }
	
	        // c. If the last character of m is ".", then
	        if (m.charAt(m.length-1) === '.')
	            //    i. Remove the last character from m.
	            m = m.slice(0, -1);
	    }
	    // 9. Return m.
	    return m;
	}
	
	/**
	 * When the ToRawFixed abstract operation is called with arguments x (which must
	 * be a finite non-negative number), minInteger (which must be an integer between
	 * 1 and 21), minFraction, and maxFraction (which must be integers between 0 and
	 * 20) the following steps are taken:
	 */
	function ToRawFixed (x, minInteger, minFraction, maxFraction) {
	    // (or not because Number.toPrototype.toFixed does a lot of it for us)
	    var idx,
	
	        // We can pick up after the fixed formatted string (m) is created
	        m   = Number.prototype.toFixed.call(x, maxFraction),
	
	        // 4. If [maxFraction] ≠ 0, then
	        //    ...
	        //    e. Let int be the number of characters in a.
	        //
	        // 5. Else let int be the number of characters in m.
	        igr = m.split(".")[0].length,  // int is a reserved word
	
	        // 6. Let cut be maxFraction – minFraction.
	        cut = maxFraction - minFraction,
	
	        exp = (idx = m.indexOf('e')) > -1 ? m.slice(idx + 1) : 0;
	
	    if (exp) {
	        m = m.slice(0, idx).replace('.', '');
	        m += arrJoin.call(Array(exp - (m.length - 1) + 1), '0')
	          + '.' + arrJoin.call(Array(maxFraction + 1), '0');
	
	        igr = m.length;
	    }
	
	    // 7. Repeat while cut > 0 and the last character of m is "0":
	    while (cut > 0 && m.slice(-1) === "0") {
	        // a. Remove the last character from m.
	        m = m.slice(0, -1);
	
	        // b. Decrease cut by 1.
	        cut--;
	    }
	
	    // 8. If the last character of m is ".", then
	    if (m.slice(-1) === ".")
	        // a. Remove the last character from m.
	        m = m.slice(0, -1);
	
	    // 9. If int < minInteger, then
	    if (igr < minInteger)
	        // a. Let z be the String consisting of minInteger–int occurrences of the
	        //    character "0".
	        var z = arrJoin.call(Array(minInteger - igr + 1), '0');
	
	    // 10. Let m be the concatenation of Strings z and m.
	    // 11. Return m.
	    return (z ? z : '') + m;
	}
	
	// Sect 11.3.2 Table 2, Numbering systems
	// ======================================
	var numSys = {
	    arab:    [ '\u0660', '\u0661', '\u0662', '\u0663', '\u0664', '\u0665', '\u0666', '\u0667', '\u0668', '\u0669' ],
	    arabext: [ '\u06F0', '\u06F1', '\u06F2', '\u06F3', '\u06F4', '\u06F5', '\u06F6', '\u06F7', '\u06F8', '\u06F9' ],
	    bali:    [ '\u1B50', '\u1B51', '\u1B52', '\u1B53', '\u1B54', '\u1B55', '\u1B56', '\u1B57', '\u1B58', '\u1B59' ],
	    beng:    [ '\u09E6', '\u09E7', '\u09E8', '\u09E9', '\u09EA', '\u09EB', '\u09EC', '\u09ED', '\u09EE', '\u09EF' ],
	    deva:    [ '\u0966', '\u0967', '\u0968', '\u0969', '\u096A', '\u096B', '\u096C', '\u096D', '\u096E', '\u096F' ],
	    fullwide:[ '\uFF10', '\uFF11', '\uFF12', '\uFF13', '\uFF14', '\uFF15', '\uFF16', '\uFF17', '\uFF18', '\uFF19' ],
	    gujr:    [ '\u0AE6', '\u0AE7', '\u0AE8', '\u0AE9', '\u0AEA', '\u0AEB', '\u0AEC', '\u0AED', '\u0AEE', '\u0AEF' ],
	    guru:    [ '\u0A66', '\u0A67', '\u0A68', '\u0A69', '\u0A6A', '\u0A6B', '\u0A6C', '\u0A6D', '\u0A6E', '\u0A6F' ],
	    hanidec: [ '\u3007', '\u4E00', '\u4E8C', '\u4E09', '\u56DB', '\u4E94', '\u516D', '\u4E03', '\u516B', '\u4E5D' ],
	    khmr:    [ '\u17E0', '\u17E1', '\u17E2', '\u17E3', '\u17E4', '\u17E5', '\u17E6', '\u17E7', '\u17E8', '\u17E9' ],
	    knda:    [ '\u0CE6', '\u0CE7', '\u0CE8', '\u0CE9', '\u0CEA', '\u0CEB', '\u0CEC', '\u0CED', '\u0CEE', '\u0CEF' ],
	    laoo:    [ '\u0ED0', '\u0ED1', '\u0ED2', '\u0ED3', '\u0ED4', '\u0ED5', '\u0ED6', '\u0ED7', '\u0ED8', '\u0ED9' ],
	    latn:    [ '\u0030', '\u0031', '\u0032', '\u0033', '\u0034', '\u0035', '\u0036', '\u0037', '\u0038', '\u0039' ],
	    limb:    [ '\u1946', '\u1947', '\u1948', '\u1949', '\u194A', '\u194B', '\u194C', '\u194D', '\u194E', '\u194F' ],
	    mlym:    [ '\u0D66', '\u0D67', '\u0D68', '\u0D69', '\u0D6A', '\u0D6B', '\u0D6C', '\u0D6D', '\u0D6E', '\u0D6F' ],
	    mong:    [ '\u1810', '\u1811', '\u1812', '\u1813', '\u1814', '\u1815', '\u1816', '\u1817', '\u1818', '\u1819' ],
	    mymr:    [ '\u1040', '\u1041', '\u1042', '\u1043', '\u1044', '\u1045', '\u1046', '\u1047', '\u1048', '\u1049' ],
	    orya:    [ '\u0B66', '\u0B67', '\u0B68', '\u0B69', '\u0B6A', '\u0B6B', '\u0B6C', '\u0B6D', '\u0B6E', '\u0B6F' ],
	    tamldec: [ '\u0BE6', '\u0BE7', '\u0BE8', '\u0BE9', '\u0BEA', '\u0BEB', '\u0BEC', '\u0BED', '\u0BEE', '\u0BEF' ],
	    telu:    [ '\u0C66', '\u0C67', '\u0C68', '\u0C69', '\u0C6A', '\u0C6B', '\u0C6C', '\u0C6D', '\u0C6E', '\u0C6F' ],
	    thai:    [ '\u0E50', '\u0E51', '\u0E52', '\u0E53', '\u0E54', '\u0E55', '\u0E56', '\u0E57', '\u0E58', '\u0E59' ],
	    tibt:    [ '\u0F20', '\u0F21', '\u0F22', '\u0F23', '\u0F24', '\u0F25', '\u0F26', '\u0F27', '\u0F28', '\u0F29' ]
	};
	
	/**
	 * This function provides access to the locale and formatting options computed
	 * during initialization of the object.
	 *
	 * The function returns a new object whose properties and attributes are set as
	 * if constructed by an object literal assigning to each of the following
	 * properties the value of the corresponding internal property of this
	 * NumberFormat object (see 11.4): locale, numberingSystem, style, currency,
	 * currencyDisplay, minimumIntegerDigits, minimumFractionDigits,
	 * maximumFractionDigits, minimumSignificantDigits, maximumSignificantDigits, and
	 * useGrouping. Properties whose corresponding internal properties are not present
	 * are not assigned.
	 */
	/* 11.3.3 */defineProperty(Intl.NumberFormat.prototype, 'resolvedOptions', {
	    configurable: true,
	    writable: true,
	    value: function () {
	        var prop,
	            descs = new Record(),
	            props = [
	                'locale', 'numberingSystem', 'style', 'currency', 'currencyDisplay',
	                'minimumIntegerDigits', 'minimumFractionDigits', 'maximumFractionDigits',
	                'minimumSignificantDigits', 'maximumSignificantDigits', 'useGrouping'
	            ],
	            internal = this != null && typeof this === 'object' && getInternalProperties(this);
	
	        // Satisfy test 11.3_b
	        if (!internal || !internal['[[initializedNumberFormat]]'])
	            throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.NumberFormat object.');
	
	        for (var i = 0, max = props.length; i < max; i++) {
	            if (hop.call(internal, prop = '[['+ props[i] +']]'))
	                descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
	        }
	
	        return objCreate({}, descs);
	    }
	});
	
	// 12.1 The Intl.DateTimeFormat constructor
	// ==================================
	
	// Define the DateTimeFormat constructor internally so it cannot be tainted
	function DateTimeFormatConstructor () {
	    var locales = arguments[0];
	    var options = arguments[1];
	
	    if (!this || this === Intl) {
	        return new Intl.DateTimeFormat(locales, options);
	    }
	    return InitializeDateTimeFormat(toObject(this), locales, options);
	}
	
	defineProperty(Intl, 'DateTimeFormat', {
	    configurable: true,
	    writable: true,
	    value: DateTimeFormatConstructor
	});
	
	// Must explicitly set prototypes as unwritable
	defineProperty(DateTimeFormatConstructor, 'prototype', {
	    writable: false
	});
	
	/**
	 * The abstract operation InitializeDateTimeFormat accepts the arguments dateTimeFormat
	 * (which must be an object), locales, and options. It initializes dateTimeFormat as a
	 * DateTimeFormat object.
	 */
	function/* 12.1.1.1 */InitializeDateTimeFormat (dateTimeFormat, locales, options) {
	    var
	    // This will be a internal properties object if we're not already initialized
	        internal = getInternalProperties(dateTimeFormat),
	
	    // Create an object whose props can be used to restore the values of RegExp props
	        regexpState = createRegExpRestore();
	
	    // 1. If dateTimeFormat has an [[initializedIntlObject]] internal property with
	    //    value true, throw a TypeError exception.
	    if (internal['[[initializedIntlObject]]'] === true)
	        throw new TypeError('`this` object has already been initialized as an Intl object');
	
	    // Need this to access the `internal` object
	    defineProperty(dateTimeFormat, '__getInternalProperties', {
	        value: function () {
	            // NOTE: Non-standard, for internal use only
	            if (arguments[0] === secret)
	                return internal;
	        }
	    });
	
	    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
	    internal['[[initializedIntlObject]]'] = true;
	
	    var
	    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	    //    abstract operation (defined in 9.2.1) with argument locales.
	        requestedLocales = CanonicalizeLocaleList(locales),
	
	    // 4. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined below) with arguments options, "any", and "date".
	        options = ToDateTimeOptions(options, 'any', 'date'),
	
	    // 5. Let opt be a new Record.
	        opt = new Record();
	
	    // 6. Let matcher be the result of calling the GetOption abstract operation
	    //    (defined in 9.2.9) with arguments options, "localeMatcher", "string", a List
	    //    containing the two String values "lookup" and "best fit", and "best fit".
	        matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');
	
	    // 7. Set opt.[[localeMatcher]] to matcher.
	    opt['[[localeMatcher]]'] = matcher;
	
	    var
	    // 8. Let DateTimeFormat be the standard built-in object that is the initial
	    //    value of Intl.DateTimeFormat.
	        DateTimeFormat = internals.DateTimeFormat, // This is what we *really* need
	
	    // 9. Let localeData be the value of the [[localeData]] internal property of
	    //    DateTimeFormat.
	        localeData = DateTimeFormat['[[localeData]]'],
	
	    // 10. Let r be the result of calling the ResolveLocale abstract operation
	    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
	    //      DateTimeFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
	    //      internal property of DateTimeFormat, and localeData.
	        r = ResolveLocale(DateTimeFormat['[[availableLocales]]'], requestedLocales,
	                opt, DateTimeFormat['[[relevantExtensionKeys]]'], localeData);
	
	    // 11. Set the [[locale]] internal property of dateTimeFormat to the value of
	    //     r.[[locale]].
	    internal['[[locale]]'] = r['[[locale]]'];
	
	    // 12. Set the [[calendar]] internal property of dateTimeFormat to the value of
	    //     r.[[ca]].
	    internal['[[calendar]]'] = r['[[ca]]'];
	
	    // 13. Set the [[numberingSystem]] internal property of dateTimeFormat to the value of
	    //     r.[[nu]].
	    internal['[[numberingSystem]]'] = r['[[nu]]'];
	
	    // The specification doesn't tell us to do this, but it's helpful later on
	    internal['[[dataLocale]]'] = r['[[dataLocale]]'];
	
	    var
	    // 14. Let dataLocale be the value of r.[[dataLocale]].
	        dataLocale = r['[[dataLocale]]'],
	
	    // 15. Let tz be the result of calling the [[Get]] internal method of options with
	    //     argument "timeZone".
	        tz = options.timeZone;
	
	    // 16. If tz is not undefined, then
	    if (tz !== undefined) {
	        // a. Let tz be ToString(tz).
	        // b. Convert tz to upper case as described in 6.1.
	        //    NOTE: If an implementation accepts additional time zone values, as permitted
	        //          under certain conditions by the Conformance clause, different casing
	        //          rules apply.
	        tz = toLatinUpperCase(tz);
	
	        // c. If tz is not "UTC", then throw a RangeError exception.
	        // ###TODO: accept more time zones###
	        if (tz !== 'UTC')
	            throw new RangeError('timeZone is not supported.');
	    }
	
	    // 17. Set the [[timeZone]] internal property of dateTimeFormat to tz.
	    internal['[[timeZone]]'] = tz;
	
	    // 18. Let opt be a new Record.
	    opt = new Record();
	
	    // 19. For each row of Table 3, except the header row, do:
	    for (var prop in dateTimeComponents) {
	        if (!hop.call(dateTimeComponents, prop))
	            continue;
	
	        var
	        // 20. Let prop be the name given in the Property column of the row.
	        // 21. Let value be the result of calling the GetOption abstract operation,
	        //     passing as argument options, the name given in the Property column of the
	        //     row, "string", a List containing the strings given in the Values column of
	        //     the row, and undefined.
	            value = GetOption(options, prop, 'string', dateTimeComponents[prop]);
	
	        // 22. Set opt.[[<prop>]] to value.
	        opt['[['+prop+']]'] = value;
	    }
	
	    var
	        // Assigned a value below
	        bestFormat,
	
	        // 23. Let dataLocaleData be the result of calling the [[Get]] internal method of
	        //     localeData with argument dataLocale.
	        dataLocaleData = localeData[dataLocale],
	
	        // 24. Let formats be the result of calling the [[Get]] internal method of
	        //     dataLocaleData with argument "formats".
	        //     Note: we process the CLDR formats into the spec'd structure
	        formats = ToDateTimeFormats(dataLocaleData.formats),
	
	        // 25. Let matcher be the result of calling the GetOption abstract operation with
	        //     arguments options, "formatMatcher", "string", a List containing the two String
	        //     values "basic" and "best fit", and "best fit".
	        matcher = GetOption(options, 'formatMatcher', 'string', new List('basic', 'best fit'), 'best fit');
	
	    // Optimization: caching the processed formats as a one time operation by
	    // replacing the initial structure from localeData
	    dataLocaleData.formats = formats;
	
	    // 26. If matcher is "basic", then
	    if (matcher === 'basic')
	        // 27. Let bestFormat be the result of calling the BasicFormatMatcher abstract
	        //     operation (defined below) with opt and formats.
	        bestFormat = BasicFormatMatcher(opt, formats);
	
	    // 28. Else
	    else
	        // 29. Let bestFormat be the result of calling the BestFitFormatMatcher
	        //     abstract operation (defined below) with opt and formats.
	        bestFormat = BestFitFormatMatcher(opt, formats);
	
	    // 30. For each row in Table 3, except the header row, do
	    for (var prop in dateTimeComponents) {
	        if (!hop.call(dateTimeComponents, prop))
	            continue;
	
	        // a. Let prop be the name given in the Property column of the row.
	        // b. Let pDesc be the result of calling the [[GetOwnProperty]] internal method of
	        //    bestFormat with argument prop.
	        // c. If pDesc is not undefined, then
	        if (hop.call(bestFormat, prop)) {
	            var
	            // i. Let p be the result of calling the [[Get]] internal method of bestFormat
	            //    with argument prop.
	                p = bestFormat[prop];
	
	            // ii. Set the [[<prop>]] internal property of dateTimeFormat to p.
	            internal['[['+prop+']]'] = p;
	        }
	    }
	
	    var
	        // Assigned a value below
	        pattern,
	
	    // 31. Let hr12 be the result of calling the GetOption abstract operation with
	    //     arguments options, "hour12", "boolean", undefined, and undefined.
	        hr12 = GetOption(options, 'hour12', 'boolean'/*, undefined, undefined*/);
	
	    // 32. If dateTimeFormat has an internal property [[hour]], then
	    if (internal['[[hour]]']) {
	        // a. If hr12 is undefined, then let hr12 be the result of calling the [[Get]]
	        //    internal method of dataLocaleData with argument "hour12".
	        hr12 = hr12 === undefined ? dataLocaleData.hour12 : hr12;
	
	        // b. Set the [[hour12]] internal property of dateTimeFormat to hr12.
	        internal['[[hour12]]'] = hr12;
	
	        // c. If hr12 is true, then
	        if (hr12 === true) {
	            var
	            // i. Let hourNo0 be the result of calling the [[Get]] internal method of
	            //    dataLocaleData with argument "hourNo0".
	                hourNo0 = dataLocaleData.hourNo0;
	
	            // ii. Set the [[hourNo0]] internal property of dateTimeFormat to hourNo0.
	            internal['[[hourNo0]]'] = hourNo0;
	
	            // iii. Let pattern be the result of calling the [[Get]] internal method of
	            //      bestFormat with argument "pattern12".
	            pattern = bestFormat.pattern12;
	        }
	
	        // d. Else
	        else
	            // i. Let pattern be the result of calling the [[Get]] internal method of
	            //    bestFormat with argument "pattern".
	            pattern = bestFormat.pattern;
	    }
	
	    // 33. Else
	    else
	        // a. Let pattern be the result of calling the [[Get]] internal method of
	        //    bestFormat with argument "pattern".
	        pattern = bestFormat.pattern;
	
	    // 34. Set the [[pattern]] internal property of dateTimeFormat to pattern.
	    internal['[[pattern]]'] = pattern;
	
	    // 35. Set the [[boundFormat]] internal property of dateTimeFormat to undefined.
	    internal['[[boundFormat]]'] = undefined;
	
	    // 36. Set the [[initializedDateTimeFormat]] internal property of dateTimeFormat to
	    //     true.
	    internal['[[initializedDateTimeFormat]]'] = true;
	
	    // In ES3, we need to pre-bind the format() function
	    if (es3)
	        dateTimeFormat.format = GetFormatDateTime.call(dateTimeFormat);
	
	    // Restore the RegExp properties
	    regexpState.exp.test(regexpState.input);
	
	    // Return the newly initialised object
	    return dateTimeFormat;
	}
	
	/**
	 * Several DateTimeFormat algorithms use values from the following table, which provides
	 * property names and allowable values for the components of date and time formats:
	 */
	var dateTimeComponents = {
	         weekday: [ "narrow", "short", "long" ],
	             era: [ "narrow", "short", "long" ],
	            year: [ "2-digit", "numeric" ],
	           month: [ "2-digit", "numeric", "narrow", "short", "long" ],
	             day: [ "2-digit", "numeric" ],
	            hour: [ "2-digit", "numeric" ],
	          minute: [ "2-digit", "numeric" ],
	          second: [ "2-digit", "numeric" ],
	    timeZoneName: [ "short", "long" ]
	};
	
	/**
	 * When the ToDateTimeOptions abstract operation is called with arguments options,
	 * required, and defaults, the following steps are taken:
	 */
	function ToDateTimeFormats(formats) {
	    if (Object.prototype.toString.call(formats) === '[object Array]') {
	        return formats;
	    }
	    return src$cldr$$.createDateTimeFormats(formats);
	}
	
	/**
	 * When the ToDateTimeOptions abstract operation is called with arguments options,
	 * required, and defaults, the following steps are taken:
	 */
	function ToDateTimeOptions (options, required, defaults) {
	    // 1. If options is undefined, then let options be null, else let options be
	    //    ToObject(options).
	    if (options === undefined)
	        options = null;
	
	    else {
	        // (#12) options needs to be a Record, but it also needs to inherit properties
	        var opt2 = toObject(options);
	        options = new Record();
	
	        for (var k in opt2)
	            options[k] = opt2[k];
	    }
	
	    var
	    // 2. Let create be the standard built-in function object defined in ES5, 15.2.3.5.
	        create = objCreate,
	
	    // 3. Let options be the result of calling the [[Call]] internal method of create with
	    //    undefined as the this value and an argument list containing the single item
	    //    options.
	        options = create(options),
	
	    // 4. Let needDefaults be true.
	        needDefaults = true;
	
	    // 5. If required is "date" or "any", then
	    if (required === 'date' || required === 'any') {
	        // a. For each of the property names "weekday", "year", "month", "day":
	            // i. If the result of calling the [[Get]] internal method of options with the
	            //    property name is not undefined, then let needDefaults be false.
	        if (options.weekday !== undefined || options.year !== undefined
	                || options.month !== undefined || options.day !== undefined)
	            needDefaults = false;
	    }
	
	    // 6. If required is "time" or "any", then
	    if (required === 'time' || required === 'any') {
	        // a. For each of the property names "hour", "minute", "second":
	            // i. If the result of calling the [[Get]] internal method of options with the
	            //    property name is not undefined, then let needDefaults be false.
	        if (options.hour !== undefined || options.minute !== undefined || options.second !== undefined)
	                needDefaults = false;
	    }
	
	    // 7. If needDefaults is true and defaults is either "date" or "all", then
	    if (needDefaults && (defaults === 'date' || defaults === 'all'))
	        // a. For each of the property names "year", "month", "day":
	            // i. Call the [[DefineOwnProperty]] internal method of options with the
	            //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
	            //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
	        options.year = options.month = options.day = 'numeric';
	
	    // 8. If needDefaults is true and defaults is either "time" or "all", then
	    if (needDefaults && (defaults === 'time' || defaults === 'all'))
	        // a. For each of the property names "hour", "minute", "second":
	            // i. Call the [[DefineOwnProperty]] internal method of options with the
	            //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
	            //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
	        options.hour = options.minute = options.second = 'numeric';
	
	    // 9. Return options.
	    return options;
	}
	
	/**
	 * When the BasicFormatMatcher abstract operation is called with two arguments options and
	 * formats, the following steps are taken:
	 */
	function BasicFormatMatcher (options, formats) {
	    return calculateScore(options, formats);
	}
	
	/**
	 * Calculates score for BestFitFormatMatcher and BasicFormatMatcher.
	 * Abstracted from BasicFormatMatcher section.
	 */
	function calculateScore (options, formats, bestFit) {
	    var
	    // Additional penalty type when bestFit === true
	       diffDataTypePenalty = 8,
	
	    // 1. Let removalPenalty be 120.
	        removalPenalty = 120,
	
	    // 2. Let additionPenalty be 20.
	        additionPenalty = 20,
	
	    // 3. Let longLessPenalty be 8.
	        longLessPenalty = 8,
	
	    // 4. Let longMorePenalty be 6.
	        longMorePenalty = 6,
	
	    // 5. Let shortLessPenalty be 6.
	        shortLessPenalty = 6,
	
	    // 6. Let shortMorePenalty be 3.
	        shortMorePenalty = 3,
	
	    // 7. Let bestScore be -Infinity.
	        bestScore = -Infinity,
	
	    // 8. Let bestFormat be undefined.
	        bestFormat,
	
	    // 9. Let i be 0.
	        i = 0,
	
	    // 10. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
	        len = formats.length;
	
	    // 11. Repeat while i < len:
	    while (i < len) {
	        var
	        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
	            format = formats[i],
	
	        // b. Let score be 0.
	            score = 0;
	
	        // c. For each property shown in Table 3:
	        for (var property in dateTimeComponents) {
	            if (!hop.call(dateTimeComponents, property))
	                continue;
	
	            var
	            // i. Let optionsProp be options.[[<property>]].
	                optionsProp = options['[['+ property +']]'],
	
	            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
	            //     with argument property.
	            // iii. If formatPropDesc is not undefined, then
	            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
	                formatProp = hop.call(format, property) ? format[property] : undefined;
	
	            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
	            //     additionPenalty.
	            if (optionsProp === undefined && formatProp !== undefined)
	                score -= additionPenalty;
	
	            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
	            //    removalPenalty.
	            else if (optionsProp !== undefined && formatProp === undefined)
	                score -= removalPenalty;
	
	            // vi. Else
	            else {
	                var
	                // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
	                //    "long"].
	                    values = [ '2-digit', 'numeric', 'narrow', 'short', 'long' ],
	
	                // 2. Let optionsPropIndex be the index of optionsProp within values.
	                    optionsPropIndex = arrIndexOf.call(values, optionsProp),
	
	                // 3. Let formatPropIndex be the index of formatProp within values.
	                    formatPropIndex = arrIndexOf.call(values, formatProp),
	
	                // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
	                    delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);
	
	                // When the bestFit argument is true, subtract additional penalty where data types are not the same
	                if (bestFit && (
	                    ((optionsProp === 'numeric' || optionsProp === '2-digit') && (formatProp !== 'numeric' && formatProp !== '2-digit') || (optionsProp !== 'numeric' && optionsProp !== '2-digit') && (formatProp === '2-digit' || formatProp === 'numeric'))
	                ))
	                    score -= diffDataTypePenalty;
	
	                // 5. If delta = 2, decrease score by longMorePenalty.
	                if (delta === 2)
	                    score -= longMorePenalty;
	
	                // 6. Else if delta = 1, decrease score by shortMorePenalty.
	                else if (delta === 1)
	                    score -= shortMorePenalty;
	
	                // 7. Else if delta = -1, decrease score by shortLessPenalty.
	                else if (delta === -1)
	                    score -= shortLessPenalty;
	
	                // 8. Else if delta = -2, decrease score by longLessPenalty.
	                else if (delta === -2)
	                    score -= longLessPenalty;
	            }
	        }
	
	        // d. If score > bestScore, then
	        if (score > bestScore) {
	            // i. Let bestScore be score.
	            bestScore = score;
	
	            // ii. Let bestFormat be format.
	            bestFormat = format;
	        }
	
	        // e. Increase i by 1.
	        i++;
	    }
	
	    // 12. Return bestFormat.
	    return bestFormat;
	}
	
	/**
	 * When the BestFitFormatMatcher abstract operation is called with two arguments options
	 * and formats, it performs implementation dependent steps, which should return a set of
	 * component representations that a typical user of the selected locale would perceive as
	 * at least as good as the one returned by BasicFormatMatcher.
	 *
	 * This polyfill defines the algorithm to be the same as BasicFormatMatcher,
	 * with the addition of bonus points awarded where the requested format is of
	 * the same data type as the potentially matching format.
	 *
	 * For example,
	 *
	 *     { month: 'numeric', day: 'numeric' }
	 *
	 * should match
	 *
	 *     { month: '2-digit', day: '2-digit' }
	 *
	 * rather than
	 *
	 *     { month: 'short', day: 'numeric' }
	 *
	 * This makes sense because a user requesting a formatted date with numeric parts would
	 * not expect to see the returned format containing narrow, short or long part names
	 */
	function BestFitFormatMatcher (options, formats) {
	    return calculateScore(options, formats, true);
	}
	
	/* 12.2.3 */internals.DateTimeFormat = {
	    '[[availableLocales]]': [],
	    '[[relevantExtensionKeys]]': ['ca', 'nu'],
	    '[[localeData]]': {}
	};
	
	/**
	 * When the supportedLocalesOf method of Intl.DateTimeFormat is called, the
	 * following steps are taken:
	 */
	/* 12.2.2 */defineProperty(Intl.DateTimeFormat, 'supportedLocalesOf', {
	    configurable: true,
	    writable: true,
	    value: fnBind.call(supportedLocalesOf, internals.DateTimeFormat)
	});
	
	/**
	 * This named accessor property returns a function that formats a number
	 * according to the effective locale and the formatting options of this
	 * DateTimeFormat object.
	 */
	/* 12.3.2 */defineProperty(Intl.DateTimeFormat.prototype, 'format', {
	    configurable: true,
	    get: GetFormatDateTime
	});
	
	function GetFormatDateTime() {
	    var internal = this != null && typeof this === 'object' && getInternalProperties(this);
	
	    // Satisfy test 12.3_b
	    if (!internal || !internal['[[initializedDateTimeFormat]]'])
	        throw new TypeError('`this` value for format() is not an initialized Intl.DateTimeFormat object.');
	
	    // The value of the [[Get]] attribute is a function that takes the following
	    // steps:
	
	    // 1. If the [[boundFormat]] internal property of this DateTimeFormat object
	    //    is undefined, then:
	    if (internal['[[boundFormat]]'] === undefined) {
	        var
	        // a. Let F be a Function object, with internal properties set as
	        //    specified for built-in functions in ES5, 15, or successor, and the
	        //    length property set to 0, that takes the argument date and
	        //    performs the following steps:
	            F = function () {
	                //   i. If date is not provided or is undefined, then let x be the
	                //      result as if by the expression Date.now() where Date.now is
	                //      the standard built-in function defined in ES5, 15.9.4.4.
	                //  ii. Else let x be ToNumber(date).
	                // iii. Return the result of calling the FormatDateTime abstract
	                //      operation (defined below) with arguments this and x.
	                var x = Number(arguments.length === 0 ? Date.now() : arguments[0]);
	                return FormatDateTime(this, x);
	            },
	        // b. Let bind be the standard built-in function object defined in ES5,
	        //    15.3.4.5.
	        // c. Let bf be the result of calling the [[Call]] internal method of
	        //    bind with F as the this value and an argument list containing
	        //    the single item this.
	            bf = fnBind.call(F, this);
	        // d. Set the [[boundFormat]] internal property of this NumberFormat
	        //    object to bf.
	        internal['[[boundFormat]]'] = bf;
	    }
	    // Return the value of the [[boundFormat]] internal property of this
	    // NumberFormat object.
	    return internal['[[boundFormat]]'];
	}
	
	/**
	 * When the FormatDateTime abstract operation is called with arguments dateTimeFormat
	 * (which must be an object initialized as a DateTimeFormat) and x (which must be a Number
	 * value), it returns a String value representing x (interpreted as a time value as
	 * specified in ES5, 15.9.1.1) according to the effective locale and the formatting
	 * options of dateTimeFormat.
	 */
	function FormatDateTime(dateTimeFormat, x) {
	    // 1. If x is not a finite Number, then throw a RangeError exception.
	    if (!isFinite(x))
	        throw new RangeError('Invalid valid date passed to format');
	
	    var
	        internal = dateTimeFormat.__getInternalProperties(secret),
	
	    // Creating restore point for properties on the RegExp object... please wait
	        regexpState = createRegExpRestore(),
	
	    // 2. Let locale be the value of the [[locale]] internal property of dateTimeFormat.
	        locale = internal['[[locale]]'],
	
	    // 3. Let nf be the result of creating a new NumberFormat object as if by the
	    // expression new Intl.NumberFormat([locale], {useGrouping: false}) where
	    // Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
	        nf = new Intl.NumberFormat([locale], {useGrouping: false}),
	
	    // 4. Let nf2 be the result of creating a new NumberFormat object as if by the
	    // expression new Intl.NumberFormat([locale], {minimumIntegerDigits: 2, useGrouping:
	    // false}) where Intl.NumberFormat is the standard built-in constructor defined in
	    // 11.1.3.
	        nf2 = new Intl.NumberFormat([locale], {minimumIntegerDigits: 2, useGrouping: false}),
	
	    // 5. Let tm be the result of calling the ToLocalTime abstract operation (defined
	    // below) with x, the value of the [[calendar]] internal property of dateTimeFormat,
	    // and the value of the [[timeZone]] internal property of dateTimeFormat.
	        tm = ToLocalTime(x, internal['[[calendar]]'], internal['[[timeZone]]']),
	
	    // 6. Let result be the value of the [[pattern]] internal property of dateTimeFormat.
	        result = internal['[[pattern]]'],
	
	    // Need the locale minus any extensions
	        dataLocale = internal['[[dataLocale]]'],
	
	    // Need the calendar data from CLDR
	        localeData = internals.DateTimeFormat['[[localeData]]'][dataLocale].calendars,
	        ca = internal['[[calendar]]'];
	
	    // 7. For each row of Table 3, except the header row, do:
	    for (var p in dateTimeComponents) {
	        // a. If dateTimeFormat has an internal property with the name given in the
	        //    Property column of the row, then:
	        if (hop.call(internal, '[['+ p +']]')) {
	            var
	            // Assigned values below
	                pm, fv,
	
	            //   i. Let p be the name given in the Property column of the row.
	            //  ii. Let f be the value of the [[<p>]] internal property of dateTimeFormat.
	                f = internal['[['+ p +']]'],
	
	            // iii. Let v be the value of tm.[[<p>]].
	                v = tm['[['+ p +']]'];
	
	            //  iv. If p is "year" and v ≤ 0, then let v be 1 - v.
	            if (p === 'year' && v <= 0)
	                v = 1 - v;
	
	            //   v. If p is "month", then increase v by 1.
	            else if (p === 'month')
	                v++;
	
	            //  vi. If p is "hour" and the value of the [[hour12]] internal property of
	            //      dateTimeFormat is true, then
	            else if (p === 'hour' && internal['[[hour12]]'] === true) {
	                // 1. Let v be v modulo 12.
	                v = v % 12;
	
	                // 2. If v is equal to the value of tm.[[<p>]], then let pm be false; else
	                //    let pm be true.
	                pm = v !== tm['[['+ p +']]'];
	
	                // 3. If v is 0 and the value of the [[hourNo0]] internal property of
	                //    dateTimeFormat is true, then let v be 12.
	                if (v === 0 && internal['[[hourNo0]]'] === true)
	                    v = 12;
	            }
	
	            // vii. If f is "numeric", then
	            if (f === 'numeric')
	                // 1. Let fv be the result of calling the FormatNumber abstract operation
	                //    (defined in 11.3.2) with arguments nf and v.
	                fv = FormatNumber(nf, v);
	
	            // viii. Else if f is "2-digit", then
	            else if (f === '2-digit') {
	                // 1. Let fv be the result of calling the FormatNumber abstract operation
	                //    with arguments nf2 and v.
	                fv = FormatNumber(nf2, v);
	
	                // 2. If the length of fv is greater than 2, let fv be the substring of fv
	                //    containing the last two characters.
	                if (fv.length > 2)
	                    fv = fv.slice(-2);
	            }
	
	            // ix. Else if f is "narrow", "short", or "long", then let fv be a String
	            //     value representing f in the desired form; the String value depends upon
	            //     the implementation and the effective locale and calendar of
	            //     dateTimeFormat. If p is "month", then the String value may also depend
	            //     on whether dateTimeFormat has a [[day]] internal property. If p is
	            //     "timeZoneName", then the String value may also depend on the value of
	            //     the [[inDST]] field of tm.
	            else if (f in dateWidths) {
	                switch (p) {
	                    case 'month':
	                        fv = resolveDateString(localeData, ca, 'months', f, tm['[['+ p +']]']);
	                        break;
	
	                    case 'weekday':
	                        try {
	                            fv = resolveDateString(localeData, ca, 'days', f, tm['[['+ p +']]']);
	                            // fv = resolveDateString(ca.days, f)[tm['[['+ p +']]']];
	                        } catch (e) {
	                            throw new Error('Could not find weekday data for locale '+locale);
	                        }
	                        break;
	
	                    case 'timeZoneName':
	                        fv = ''; // TODO
	                        break;
	
	                    // TODO: Era
	                    default:
	                        fv = tm['[['+ p +']]'];
	                }
	            }
	
	            // x. Replace the substring of result that consists of "{", p, and "}", with
	            //    fv.
	            result = result.replace('{'+ p +'}', fv);
	        }
	    }
	    // 8. If dateTimeFormat has an internal property [[hour12]] whose value is true, then
	    if (internal['[[hour12]]'] === true) {
	        // a. If pm is true, then let fv be an implementation and locale dependent String
	        //    value representing “post meridiem”; else let fv be an implementation and
	        //    locale dependent String value representing “ante meridiem”.
	        fv = resolveDateString(localeData, ca, 'dayPeriods', pm ? 'pm' : 'am');
	
	        // b. Replace the substring of result that consists of "{ampm}", with fv.
	        result = result.replace('{ampm}', fv);
	    }
	
	    // Restore properties of the RegExp object
	    regexpState.exp.test(regexpState.input);
	
	    // 9. Return result.
	    return result;
	}
	
	/**
	 * When the ToLocalTime abstract operation is called with arguments date, calendar, and
	 * timeZone, the following steps are taken:
	 */
	function ToLocalTime(date, calendar, timeZone) {
	    // 1. Apply calendrical calculations on date for the given calendar and time zone to
	    //    produce weekday, era, year, month, day, hour, minute, second, and inDST values.
	    //    The calculations should use best available information about the specified
	    //    calendar and time zone. If the calendar is "gregory", then the calculations must
	    //    match the algorithms specified in ES5, 15.9.1, except that calculations are not
	    //    bound by the restrictions on the use of best available information on time zones
	    //    for local time zone adjustment and daylight saving time adjustment imposed by
	    //    ES5, 15.9.1.7 and 15.9.1.8.
	    // ###TODO###
	    var d = new Date(date),
	        m = 'get' + (timeZone || '');
	
	    // 2. Return a Record with fields [[weekday]], [[era]], [[year]], [[month]], [[day]],
	    //    [[hour]], [[minute]], [[second]], and [[inDST]], each with the corresponding
	    //    calculated value.
	    return new Record({
	        '[[weekday]]': d[m + 'Day'](),
	        '[[era]]'    : +(d[m + 'FullYear']() >= 0),
	        '[[year]]'   : d[m + 'FullYear'](),
	        '[[month]]'  : d[m + 'Month'](),
	        '[[day]]'    : d[m + 'Date'](),
	        '[[hour]]'   : d[m + 'Hours'](),
	        '[[minute]]' : d[m + 'Minutes'](),
	        '[[second]]' : d[m + 'Seconds'](),
	        '[[inDST]]'  : false // ###TODO###
	    });
	}
	
	/**
	 * The function returns a new object whose properties and attributes are set as if
	 * constructed by an object literal assigning to each of the following properties the
	 * value of the corresponding internal property of this DateTimeFormat object (see 12.4):
	 * locale, calendar, numberingSystem, timeZone, hour12, weekday, era, year, month, day,
	 * hour, minute, second, and timeZoneName. Properties whose corresponding internal
	 * properties are not present are not assigned.
	 */
	/* 12.3.3 */defineProperty(Intl.DateTimeFormat.prototype, 'resolvedOptions', {
	    writable: true,
	    configurable: true,
	    value: function () {
	        var prop,
	            descs = new Record(),
	            props = [
	                'locale', 'calendar', 'numberingSystem', 'timeZone', 'hour12', 'weekday',
	                'era', 'year', 'month', 'day', 'hour', 'minute', 'second', 'timeZoneName'
	            ],
	            internal = this != null && typeof this === 'object' && getInternalProperties(this);
	
	        // Satisfy test 12.3_b
	        if (!internal || !internal['[[initializedDateTimeFormat]]'])
	            throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.DateTimeFormat object.');
	
	        for (var i = 0, max = props.length; i < max; i++) {
	            if (hop.call(internal, prop = '[[' + props[i] + ']]'))
	                descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
	        }
	
	        return objCreate({}, descs);
	    }
	});
	
	// Sect 13 Locale Sensitive Functions of the ECMAScript Language Specification
	// ===========================================================================
	
	var ls = Intl.__localeSensitiveProtos = {
	    Number: {},
	    Date:   {}
	};
	
	/**
	 * When the toLocaleString method is called with optional arguments locales and options,
	 * the following steps are taken:
	 */
	/* 13.2.1 */ls.Number.toLocaleString = function () {
	    // Satisfy test 13.2.1_1
	    if (Object.prototype.toString.call(this) !== '[object Number]')
	        throw new TypeError('`this` value must be a number for Number.prototype.toLocaleString()');
	
	    // 1. Let x be this Number value (as defined in ES5, 15.7.4).
	    // 2. If locales is not provided, then let locales be undefined.
	    // 3. If options is not provided, then let options be undefined.
	    // 4. Let numberFormat be the result of creating a new object as if by the
	    //    expression new Intl.NumberFormat(locales, options) where
	    //    Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
	    // 5. Return the result of calling the FormatNumber abstract operation
	    //    (defined in 11.3.2) with arguments numberFormat and x.
	    return FormatNumber(new NumberFormatConstructor(arguments[0], arguments[1]), this);
	};
	
	/**
	 * When the toLocaleString method is called with optional arguments locales and options,
	 * the following steps are taken:
	 */
	/* 13.3.1 */ls.Date.toLocaleString = function () {
	    // Satisfy test 13.3.0_1
	    if (Object.prototype.toString.call(this) !== '[object Date]')
	        throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleString()');
	
	    var
	    // 1. Let x be this time value (as defined in ES5, 15.9.5).
	        x = +this;
	
	    // 2. If x is NaN, then return "Invalid Date".
	    if (isNaN(x))
	        return 'Invalid Date';
	
	    var
	    // 3. If locales is not provided, then let locales be undefined.
	        locales = arguments[0],
	
	    // 4. If options is not provided, then let options be undefined.
	        options = arguments[1],
	
	    // 5. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined in 12.1.1) with arguments options, "any", and "all".
	        options = ToDateTimeOptions(options, 'any', 'all'),
	
	    // 6. Let dateTimeFormat be the result of creating a new object as if by the
	    //    expression new Intl.DateTimeFormat(locales, options) where
	    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
	        dateTimeFormat = new DateTimeFormatConstructor(locales, options);
	
	    // 7. Return the result of calling the FormatDateTime abstract operation (defined
	    //    in 12.3.2) with arguments dateTimeFormat and x.
	    return FormatDateTime(dateTimeFormat, x);
	};
	
	/**
	 * When the toLocaleDateString method is called with optional arguments locales and
	 * options, the following steps are taken:
	 */
	/* 13.3.2 */ls.Date.toLocaleDateString = function () {
	    // Satisfy test 13.3.0_1
	    if (Object.prototype.toString.call(this) !== '[object Date]')
	        throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleDateString()');
	
	    var
	    // 1. Let x be this time value (as defined in ES5, 15.9.5).
	        x = +this;
	
	    // 2. If x is NaN, then return "Invalid Date".
	    if (isNaN(x))
	        return 'Invalid Date';
	
	    var
	    // 3. If locales is not provided, then let locales be undefined.
	        locales = arguments[0],
	
	    // 4. If options is not provided, then let options be undefined.
	        options = arguments[1],
	
	    // 5. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined in 12.1.1) with arguments options, "date", and "date".
	        options = ToDateTimeOptions(options, 'date', 'date'),
	
	    // 6. Let dateTimeFormat be the result of creating a new object as if by the
	    //    expression new Intl.DateTimeFormat(locales, options) where
	    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
	        dateTimeFormat = new DateTimeFormatConstructor(locales, options);
	
	    // 7. Return the result of calling the FormatDateTime abstract operation (defined
	    //    in 12.3.2) with arguments dateTimeFormat and x.
	    return FormatDateTime(dateTimeFormat, x);
	};
	
	/**
	 * When the toLocaleTimeString method is called with optional arguments locales and
	 * options, the following steps are taken:
	 */
	/* 13.3.3 */ls.Date.toLocaleTimeString = function () {
	    // Satisfy test 13.3.0_1
	    if (Object.prototype.toString.call(this) !== '[object Date]')
	        throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleTimeString()');
	
	    var
	    // 1. Let x be this time value (as defined in ES5, 15.9.5).
	        x = +this;
	
	    // 2. If x is NaN, then return "Invalid Date".
	    if (isNaN(x))
	        return 'Invalid Date';
	
	    var
	    // 3. If locales is not provided, then let locales be undefined.
	        locales = arguments[0],
	
	    // 4. If options is not provided, then let options be undefined.
	        options = arguments[1],
	
	    // 5. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined in 12.1.1) with arguments options, "time", and "time".
	        options = ToDateTimeOptions(options, 'time', 'time'),
	
	    // 6. Let dateTimeFormat be the result of creating a new object as if by the
	    //    expression new Intl.DateTimeFormat(locales, options) where
	    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
	        dateTimeFormat = new DateTimeFormatConstructor(locales, options);
	
	    // 7. Return the result of calling the FormatDateTime abstract operation (defined
	    //    in 12.3.2) with arguments dateTimeFormat and x.
	    return FormatDateTime(dateTimeFormat, x);
	};
	
	defineProperty(Intl, '__applyLocaleSensitivePrototypes', {
	    writable: true,
	    configurable: true,
	    value: function () {
	        defineProperty(Number.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Number.toLocaleString });
	        // Need this here for IE 8, to avoid the _DontEnum_ bug
	        defineProperty(Date.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Date.toLocaleString });
	
	        for (var k in ls.Date) {
	            if (hop.call(ls.Date, k))
	                defineProperty(Date.prototype, k, { writable: true, configurable: true, value: ls.Date[k] });
	        }
	    }
	});
	
	/**
	 * Can't really ship a single script with data for hundreds of locales, so we provide
	 * this __addLocaleData method as a means for the developer to add the data on an
	 * as-needed basis
	 */
	defineProperty(Intl, '__addLocaleData', {
	    value: function (data) {
	        if (!IsStructurallyValidLanguageTag(data.locale))
	            throw new Error("Object passed doesn't identify itself with a valid language tag");
	
	        addLocaleData(data, data.locale);
	    }
	});
	
	function addLocaleData (data, tag) {
	    // Both NumberFormat and DateTimeFormat require number data, so throw if it isn't present
	    if (!data.number)
	        throw new Error("Object passed doesn't contain locale data for Intl.NumberFormat");
	
	    var locale,
	        locales = [ tag ],
	        parts   = tag.split('-');
	
	    // Create fallbacks for locale data with scripts, e.g. Latn, Hans, Vaii, etc
	    if (parts.length > 2 && parts[1].length === 4)
	        arrPush.call(locales, parts[0] + '-' + parts[2]);
	
	    while (locale = arrShift.call(locales)) {
	        // Add to NumberFormat internal properties as per 11.2.3
	        arrPush.call(internals.NumberFormat['[[availableLocales]]'], locale);
	        internals.NumberFormat['[[localeData]]'][locale] = data.number;
	
	        // ...and DateTimeFormat internal properties as per 12.2.3
	        if (data.date) {
	            data.date.nu = data.number.nu;
	            arrPush.call(internals.DateTimeFormat['[[availableLocales]]'], locale);
	            internals.DateTimeFormat['[[localeData]]'][locale] = data.date;
	        }
	    }
	
	    // If this is the first set of locale data added, make it the default
	    if (defaultLocale === undefined)
	        defaultLocale = tag;
	
	    // 11.3 (the NumberFormat prototype object is an Intl.NumberFormat instance)
	    if (!numberFormatProtoInitialised) {
	        InitializeNumberFormat(Intl.NumberFormat.prototype);
	        numberFormatProtoInitialised = true;
	    }
	
	    // 11.3 (the NumberFormat prototype object is an Intl.NumberFormat instance)
	    if (data.date && !dateTimeFormatProtoInitialised) {
	        InitializeDateTimeFormat(Intl.DateTimeFormat.prototype);
	        dateTimeFormatProtoInitialised = true;
	    }
	}
	
	// Helper functions
	// ================
	
	/**
	 * A function to deal with the inaccuracy of calculating log10 in pre-ES6
	 * JavaScript environments. Math.log(num) / Math.LN10 was responsible for
	 * causing issue #62.
	 */
	function log10Floor (n) {
	    // ES6 provides the more accurate Math.log10
	    if (typeof Math.log10 === 'function')
	        return Math.floor(Math.log10(n));
	
	    var x = Math.round(Math.log(n) * Math.LOG10E);
	    return x - (Number('1e' + x) > n);
	}
	
	/**
	 * A merge of the Intl.{Constructor}.supportedLocalesOf functions
	 * To make life easier, the function should be bound to the constructor's internal
	 * properties object.
	 */
	function supportedLocalesOf(locales) {
	    /*jshint validthis:true */
	
	    // Bound functions only have the `this` value altered if being used as a constructor,
	    // this lets us imitate a native function that has no constructor
	    if (!hop.call(this, '[[availableLocales]]'))
	        throw new TypeError('supportedLocalesOf() is not a constructor');
	
	    var
	    // Create an object whose props can be used to restore the values of RegExp props
	        regexpState = createRegExpRestore(),
	
	    // 1. If options is not provided, then let options be undefined.
	        options = arguments[1],
	
	    // 2. Let availableLocales be the value of the [[availableLocales]] internal
	    //    property of the standard built-in object that is the initial value of
	    //    Intl.NumberFormat.
	
	        availableLocales = this['[[availableLocales]]'],
	
	    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	    //    abstract operation (defined in 9.2.1) with argument locales.
	        requestedLocales = CanonicalizeLocaleList(locales);
	
	    // Restore the RegExp properties
	    regexpState.exp.test(regexpState.input);
	
	    // 4. Return the result of calling the SupportedLocales abstract operation
	    //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
	    //    and options.
	    return SupportedLocales(availableLocales, requestedLocales, options);
	}
	
	/**
	 * Returns a string for a date component, resolved using multiple inheritance as specified
	 * as specified in the Unicode Technical Standard 35.
	 */
	function resolveDateString(data, ca, component, width, key) {
	    // From http://www.unicode.org/reports/tr35/tr35.html#Multiple_Inheritance:
	    // 'In clearly specified instances, resources may inherit from within the same locale.
	    //  For example, ... the Buddhist calendar inherits from the Gregorian calendar.'
	    var obj = data[ca] && data[ca][component]
	                ? data[ca][component]
	                : data.gregory[component],
	
	        // "sideways" inheritance resolves strings when a key doesn't exist
	        alts = {
	            narrow: ['short', 'long'],
	            short:  ['long', 'narrow'],
	            long:   ['short', 'narrow']
	        },
	
	        //
	        resolved = hop.call(obj, width)
	                  ? obj[width]
	                  : hop.call(obj, alts[width][0])
	                      ? obj[alts[width][0]]
	                      : obj[alts[width][1]];
	
	    // `key` wouldn't be specified for components 'dayPeriods'
	    return key != null ? resolved[key] : resolved;
	}
	
	/**
	 * A map that doesn't contain Object in its prototype chain
	 */
	Record.prototype = objCreate(null);
	function Record (obj) {
	    // Copy only own properties over unless this object is already a Record instance
	    for (var k in obj) {
	        if (obj instanceof Record || hop.call(obj, k))
	            defineProperty(this, k, { value: obj[k], enumerable: true, writable: true, configurable: true });
	    }
	}
	
	/**
	 * An ordered list
	 */
	List.prototype = objCreate(null);
	function List() {
	    defineProperty(this, 'length', { writable:true, value: 0 });
	
	    if (arguments.length)
	        arrPush.apply(this, arrSlice.call(arguments));
	}
	
	/**
	 * Constructs a regular expression to restore tainted RegExp properties
	 */
	function createRegExpRestore () {
	    var esc = /[.?*+^$[\]\\(){}|-]/g,
	        lm  = RegExp.lastMatch || '',
	        ml  = RegExp.multiline ? 'm' : '',
	        ret = { input: RegExp.input },
	        reg = new List(),
	        has = false,
	        cap = {};
	
	    // Create a snapshot of all the 'captured' properties
	    for (var i = 1; i <= 9; i++)
	        has = (cap['$'+i] = RegExp['$'+i]) || has;
	
	    // Now we've snapshotted some properties, escape the lastMatch string
	    lm = lm.replace(esc, '\\$&');
	
	    // If any of the captured strings were non-empty, iterate over them all
	    if (has) {
	        for (var i = 1; i <= 9; i++) {
	            var m = cap['$'+i];
	
	            // If it's empty, add an empty capturing group
	            if (!m)
	                lm = '()' + lm;
	
	            // Else find the string in lm and escape & wrap it to capture it
	            else {
	                m = m.replace(esc, '\\$&');
	                lm = lm.replace(m, '(' + m + ')');
	            }
	
	            // Push it to the reg and chop lm to make sure further groups come after
	            arrPush.call(reg, lm.slice(0, lm.indexOf('(') + 1));
	            lm = lm.slice(lm.indexOf('(') + 1);
	        }
	    }
	
	    // Create the regular expression that will reconstruct the RegExp properties
	    ret.exp = new RegExp(arrJoin.call(reg, '') + lm, ml);
	
	    return ret;
	}
	
	/**
	 * Convert only a-z to uppercase as per section 6.1 of the spec
	 */
	function toLatinUpperCase (str) {
	    var i = str.length;
	
	    while (i--) {
	        var ch = str.charAt(i);
	
	        if (ch >= "a" && ch <= "z")
	            str = str.slice(0, i) + ch.toUpperCase() + str.slice(i+1);
	    }
	
	    return str;
	}
	
	/**
	 * Mimics ES5's abstract ToObject() function
	 */
	function toObject (arg) {
	    if (arg == null)
	        throw new TypeError('Cannot convert null or undefined to object');
	
	    return Object(arg);
	}
	
	/**
	 * Returns "internal" properties for an object
	 */
	function getInternalProperties (obj) {
	    if (hop.call(obj, '__getInternalProperties'))
	        return obj.__getInternalProperties(secret);
	    else
	        return objCreate(null);
	}
	
	exports["default"] = Intl;
	
	//# sourceMappingURL=core.js.map

/***/ },
/* 478 */
/***/ function(module, exports) {

	/* jshint esnext: true, laxbreak:true */
	
	/**
	* Defines regular expressions for various operations related to the BCP 47 syntax,
	* as defined at http://tools.ietf.org/html/bcp47#section-2.1
	*/
	
	"use strict";
	
	var
	    // extlang       = 3ALPHA              ; selected ISO 639 codes
	    //                 *2("-" 3ALPHA)      ; permanently reserved
	    extlang = '[a-z]{3}(?:-[a-z]{3}){0,2}',
	
	    // language      = 2*3ALPHA            ; shortest ISO 639 code
	    //                 ["-" extlang]       ; sometimes followed by
	    //                                     ; extended language subtags
	    //               / 4ALPHA              ; or reserved for future use
	    //               / 5*8ALPHA            ; or registered language subtag
	    language = '(?:[a-z]{2,3}(?:-' + extlang + ')?|[a-z]{4}|[a-z]{5,8})',
	
	    // script        = 4ALPHA              ; ISO 15924 code
	    script = '[a-z]{4}',
	
	    // region        = 2ALPHA              ; ISO 3166-1 code
	    //               / 3DIGIT              ; UN M.49 code
	    region = '(?:[a-z]{2}|\\d{3})',
	
	    // variant       = 5*8alphanum         ; registered variants
	    //               / (DIGIT 3alphanum)
	    variant = '(?:[a-z0-9]{5,8}|\\d[a-z0-9]{3})',
	
	    //                                     ; Single alphanumerics
	    //                                     ; "x" reserved for private use
	    // singleton     = DIGIT               ; 0 - 9
	    //               / %x41-57             ; A - W
	    //               / %x59-5A             ; Y - Z
	    //               / %x61-77             ; a - w
	    //               / %x79-7A             ; y - z
	    singleton = '[0-9a-wy-z]',
	
	    // extension     = singleton 1*("-" (2*8alphanum))
	    extension = singleton + '(?:-[a-z0-9]{2,8})+',
	
	    // privateuse    = "x" 1*("-" (1*8alphanum))
	    privateuse = 'x(?:-[a-z0-9]{1,8})+',
	
	    // irregular     = "en-GB-oed"         ; irregular tags do not match
	    //               / "i-ami"             ; the 'langtag' production and
	    //               / "i-bnn"             ; would not otherwise be
	    //               / "i-default"         ; considered 'well-formed'
	    //               / "i-enochian"        ; These tags are all valid,
	    //               / "i-hak"             ; but most are deprecated
	    //               / "i-klingon"         ; in favor of more modern
	    //               / "i-lux"             ; subtags or subtag
	    //               / "i-mingo"           ; combination
	    //               / "i-navajo"
	    //               / "i-pwn"
	    //               / "i-tao"
	    //               / "i-tay"
	    //               / "i-tsu"
	    //               / "sgn-BE-FR"
	    //               / "sgn-BE-NL"
	    //               / "sgn-CH-DE"
	    irregular = '(?:en-GB-oed'
	              + '|i-(?:ami|bnn|default|enochian|hak|klingon|lux|mingo|navajo|pwn|tao|tay|tsu)'
	              + '|sgn-(?:BE-FR|BE-NL|CH-DE))',
	
	    // regular       = "art-lojban"        ; these tags match the 'langtag'
	    //               / "cel-gaulish"       ; production, but their subtags
	    //               / "no-bok"            ; are not extended language
	    //               / "no-nyn"            ; or variant subtags: their meaning
	    //               / "zh-guoyu"          ; is defined by their registration
	    //               / "zh-hakka"          ; and all of these are deprecated
	    //               / "zh-min"            ; in favor of a more modern
	    //               / "zh-min-nan"        ; subtag or sequence of subtags
	    //               / "zh-xiang"
	    regular = '(?:art-lojban|cel-gaulish|no-bok|no-nyn'
	            + '|zh-(?:guoyu|hakka|min|min-nan|xiang))',
	
	    // grandfathered = irregular           ; non-redundant tags registered
	    //               / regular             ; during the RFC 3066 era
	    grandfathered = '(?:' + irregular + '|' + regular + ')',
	
	    // langtag       = language
	    //                 ["-" script]
	    //                 ["-" region]
	    //                 *("-" variant)
	    //                 *("-" extension)
	    //                 ["-" privateuse]
	    langtag = language + '(?:-' + script + ')?(?:-' + region + ')?(?:-'
	            + variant + ')*(?:-' + extension + ')*(?:-' + privateuse + ')?';
	
	var expBCP47Syntax = RegExp('^(?:'+langtag+'|'+privateuse+'|'+grandfathered+')$', 'i');
	
	var expVariantDupes = RegExp('^(?!x).*?-('+variant+')-(?:\\w{4,8}-(?!x-))*\\1\\b', 'i');
	
	var expSingletonDupes = RegExp('^(?!x).*?-('+singleton+')-(?:\\w+-(?!x-))*\\1\\b', 'i');
	
	var expExtSequences = RegExp('-'+extension, 'ig');
	exports.expBCP47Syntax = expBCP47Syntax, exports.expVariantDupes = expVariantDupes, exports.expSingletonDupes = expSingletonDupes, exports.expExtSequences = expExtSequences;
	
	//# sourceMappingURL=exp.js.map

/***/ },
/* 479 */
/***/ function(module, exports) {

	/* jslint esnext: true */
	
	// Match these datetime components in a CLDR pattern, except those in single quotes
	"use strict";
	exports.createDateTimeFormat = createDateTimeFormat, exports.createDateTimeFormats = createDateTimeFormats;
	var expDTComponents = /(?:[Eec]{1,6}|G{1,5}|(?:[yYu]+|U{1,5})|[ML]{1,5}|d{1,2}|a|[hkHK]{1,2}|m{1,2}|s{1,2}|z{1,4})(?=([^']*'[^']*')*[^']*$)/g;
	
	// Skip over patterns with these datetime components
	var unwantedDTCs = /[QxXVOvZASjgFDwWIQqH]/;
	
	// Maps the number of characters in a CLDR pattern to the specification
	var dtcLengthMap = {
	        month:   [ 'numeric', '2-digit', 'short', 'long', 'narrow' ],
	        weekday: [ 'short', 'short', 'short', 'long', 'narrow' ],
	        era:     [ 'short', 'short', 'short', 'long', 'narrow' ]
	    };
	
	var dtKeys = ["weekday", "era", "year", "month", "day"];
	var tmKeys = ["hour", "minute", "second", "timeZoneName"];
	
	function isDateFormatOnly(obj) {
	    for (var i = 0; i < tmKeys.length; i += 1) {
	        if (obj.hasOwnProperty(tmKeys[i])) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function isTimeFormatOnly(obj) {
	    for (var i = 0; i < dtKeys.length; i += 1) {
	        if (obj.hasOwnProperty(dtKeys[i])) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function createDateTimeFormat(format) {
	    if (unwantedDTCs.test(format))
	        return undefined;
	
	    var formatObj = {};
	
	    // Replace the pattern string with the one required by the specification, whilst
	    // at the same time evaluating it for the subsets and formats
	    formatObj.pattern = format.replace(expDTComponents, function ($0) {
	        // See which symbol we're dealing with
	        switch ($0.charAt(0)) {
	            case 'E':
	            case 'e':
	            case 'c':
	                formatObj.weekday = dtcLengthMap.weekday[$0.length-1];
	                return '{weekday}';
	
	            // Not supported yet
	            case 'G':
	                formatObj.era = dtcLengthMap.era[$0.length-1];
	                return '{era}';
	
	            case 'y':
	            case 'Y':
	            case 'u':
	            case 'U':
	                formatObj.year = $0.length === 2 ? '2-digit' : 'numeric';
	                return '{year}';
	
	            case 'M':
	            case 'L':
	                formatObj.month = dtcLengthMap.month[$0.length-1];
	                return '{month}';
	
	            case 'd':
	                formatObj.day = $0.length === 2 ? '2-digit' : 'numeric';
	                return '{day}';
	
	            case 'a':
	                return '{ampm}';
	
	            case 'h':
	            case 'H':
	            case 'k':
	            case 'K':
	                formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
	                return '{hour}';
	
	            case 'm':
	                formatObj.minute = $0.length === 2 ? '2-digit' : 'numeric';
	                return '{minute}';
	
	            case 's':
	                formatObj.second = $0.length === 2 ? '2-digit' : 'numeric';
	                return '{second}';
	
	            case 'z':
	                formatObj.timeZoneName = $0.length < 4 ? 'short' : 'long';
	                return '{timeZoneName}';
	        }
	    });
	
	    // From http://www.unicode.org/reports/tr35/tr35-dates.html#Date_Format_Patterns:
	    //  'In patterns, two single quotes represents a literal single quote, either
	    //   inside or outside single quotes. Text within single quotes is not
	    //   interpreted in any way (except for two adjacent single quotes).'
	    formatObj.pattern = formatObj.pattern.replace(/'([^']*)'/g, function ($0, literal) {
	        return literal ? literal : "'";
	    });
	
	    if (formatObj.pattern.indexOf('{ampm}') > -1) {
	        formatObj.hour12 = true;
	        formatObj.pattern12 = formatObj.pattern;
	        formatObj.pattern = formatObj.pattern.replace('{ampm}', '').replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
	    }
	
	    return formatObj;
	}
	
	function createDateTimeFormats(formats) {
	    var availableFormats = formats.availableFormats;
	    var timeFormats = formats.timeFormats;
	    var dateFormats = formats.dateFormats;
	    var order = formats.medium;
	    var result = [];
	    var key, format, computed, i, j;
	    var timeRelatedFormats = [];
	    var dateRelatedFormats = [];
	
	    function expandFormat(key, pattern) {
	        // Expand component lengths if necessary, as allowed in the LDML spec
	        // Get the lengths of 'M' and 'E' substrings in the date pattern
	        // as arrays that can be joined to create a new substring
	        var M = new Array((key.match(/M/g)||[]).length + 1);
	        var E = new Array((key.match(/E/g)||[]).length + 1);
	
	        // note from caridy: I'm not sure we really need this, seems to be
	        //                   useless since it relies on the keys from CLDR
	        //                   instead of the actual format pattern, but I'm not sure.
	        if (M.length > 2)
	            pattern = pattern.replace(/(M|L)+/, M.join('$1'));
	
	        if (E.length > 2)
	            pattern = pattern.replace(/([Eec])+/, E.join('$1'));
	
	        return pattern;
	    }
	
	    // Map available (custom) formats into a pattern for createDateTimeFormats
	    for (key in availableFormats) {
	        if (availableFormats.hasOwnProperty(key)) {
	            format = expandFormat(key, availableFormats[key]);
	            computed = createDateTimeFormat(format);
	            if (computed) {
	                result.push(computed);
	                // in some cases, the format is only displaying date specific props
	                // or time specific props, in which case we need to also produce the
	                // combined formats.
	                if (isDateFormatOnly(computed)) {
	                    dateRelatedFormats.push(format);
	                } else if (isTimeFormatOnly(computed)) {
	                    timeRelatedFormats.push(format);
	                }
	            }
	        }
	    }
	
	    // combine custom time and custom date formats when they are orthogonals to complete the
	    // formats supported by browsers by relying on the value of "formats.medium" which defines
	    // how to join custom formats into a single pattern.
	    for (i = 0; i < timeRelatedFormats.length; i += 1) {
	        for (j = 0; j < dateRelatedFormats.length; j += 1) {
	            format = order
	                .replace('{0}', timeRelatedFormats[i])
	                .replace('{1}', dateRelatedFormats[j])
	                .replace(/^[,\s]+|[,\s]+$/gi, '');
	            computed = createDateTimeFormat(format);
	            if (computed) {
	                result.push(computed);
	            }
	        }
	    }
	
	    // Map time formats into a pattern for createDateTimeFormats
	    for (key in timeFormats) {
	        if (timeFormats.hasOwnProperty(key)) {
	            format = expandFormat(key, timeFormats[key]);
	            computed = createDateTimeFormat(format);
	            if (computed) {
	                result.push(computed);
	            }
	        }
	    }
	
	    // Map date formats into a pattern for createDateTimeFormats
	    for (key in dateFormats) {
	        if (dateFormats.hasOwnProperty(key)) {
	            format = expandFormat(key, dateFormats[key]);
	            computed = createDateTimeFormat(format);
	            if (computed) {
	                result.push(computed);
	            }
	        }
	    }
	
	    return result;
	}
	
	//# sourceMappingURL=cldr.js.map

/***/ },
/* 480 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _logger = __webpack_require__(482);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// catch any global unhandled promise rejections
	window.onunhandledrejection = function (event) {
	    var isTesting = ("production") === 'test';
	    var rethrowUnhandled = (undefined);
	    if (isTesting) {
	        if (!rethrowUnhandled) {
	            event.preventDefault();
	        }
	    } else {
	        _logger2['default'].error('An unexpected error occurred. This has been reported to our engineering team. For further support, please contact apisupport@hellosign.com.', event.reason);
	    }
	};

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _levels = __webpack_require__(483);
	
	var _levels2 = _interopRequireDefault(_levels);
	
	var _events = __webpack_require__(484);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 */
	
	function Logger() {
	    var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _events.EventEmitter.call(this);
	    Object.assign(this, properties);
	
	    this._silent = properties.silent !== undefined ? properties.silent : false;
	}
	
	/**
	 */
	
	Object.assign(Logger.prototype, _events.EventEmitter.prototype, {
	
	    /**
	     */
	
	    level: _levels2['default'].ALL,
	
	    /**
	     */
	
	    track: function track() {
	        this.emit.apply(this, ['track'].concat(Array.prototype.slice.call(arguments)));
	    },
	    setSilent: function setSilent(silence) {
	        this._silent = silence;
	    },
	    getSilent: function getSilent() {
	        return this._silent;
	    }
	});
	
	/**
	 * attach the notice, error, warn, info, verbose methods
	 */
	
	Object.keys(_levels2['default']).forEach(function (key) {
	    var code = _levels2['default'][key];
	    if (!(code & _levels2['default'].NONE)) {
	        var type = key.toLowerCase();
	        Logger.prototype[type] = function () {
	            if (!(this.level & code)) return;
	            this.emit('log', {
	
	                // add english term to log
	                type: type,
	
	                // maintain consistent property
	                level: code,
	
	                // don't do anything to the arguments
	                args: Array.prototype.slice.call(arguments, 0),
	
	                // Allow for logs to be silent and now output anything to the
	                // console.  This allows for testing the logger without making a
	                // bunch of noise in the test output.
	                silent: this.getSilent()
	            });
	        };
	    }
	});
	
	Logger.create = function (properties) {
	    return new this(properties);
	};
	
	module.exports = new Logger();
	module.exports.Logger = Logger;

/***/ },
/* 483 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	// TODO - use 'export' instead
	// export var NONE = 1;
	
	exports.NONE = 1;
	exports.NOTICE = exports.NONE << 1;
	exports.INFO = exports.NOTICE << 1;
	exports.WARN = exports.INFO << 1;
	exports.ERROR = exports.WARN << 1;
	exports.VERBOSE = exports.ERROR << 1;
	
	exports.ALL = exports.NONE | exports.INFO | exports.NOTICE | exports.WARN | exports.ERROR | exports.VERBOSE;
	exports.PRODUCTION = exports.NONE | exports.WARN | exports.ERROR;
	exports.STAGING = exports.NOTICE | exports.INFO | exports.PRODUCTION;
	exports.DEVELOPMENT = exports.ALL;
	
	exports.fromString = function (level) {
	    return level.toUpperCase().split('|').map(function (level) {
	        return exports[level] || exports.NONE;
	    }).reduce(function (a, b) {
	        return a | b;
	    });
	};
	
	exports['default'] = module.exports;

/***/ },
/* 484 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var logger = global.logger = __webpack_require__(482);
	var pkg = __webpack_require__(486);
	
	/**
	 * Helper function to return the URL of the parent window.
	 *
	 * This is required for cross-window messaging (XWM).
	 *
	 * @return string|null
	 */
	function getParentUrl() {
	    // If the embedded page has loaded completely, the parent URL will be
	    // stored in the window context.
	    if (typeof window.parentUrl === 'string') {
	        return window.parentUrl;
	    }
	    // Look for the parent URL in this page's GET parameters
	    var parts = document.location.search.replace(/^\?/, '').split('&');
	    var p;
	    for (var i = 0; i < parts.length; i++) {
	        p = parts[i].split('=');
	        if (p && p.length === 2 && p[0] === 'parent_url') {
	            return decodeURIComponent(p[1]);
	        }
	    }
	    return null;
	}
	
	/**
	 * Handler for 'error' events.
	 *
	 * Called on logger.error('message');
	 */
	logger.on('error', function (err) {
	    var message = err.args.join(' ');
	
	    // Report the error to the parent window, if it exists
	    if (typeof HelloSign !== 'undefined' && typeof HelloSign.reportError === 'function') {
	        var parent_url = getParentUrl();
	        if (parent_url) {
	            HelloSign.reportError(message, parent_url);
	        }
	    }
	
	    // Report the error to Sentry
	    if (typeof Raven !== 'undefined') {
	        Raven.captureMessage(message);
	    }
	
	    // TODO: POST back to HS to track error for analytics
	});
	
	/**
	 * Handler for 'log' events.
	 *
	 * Called on logger.log/info/warn/error('message')
	 */
	logger.on('log', function (log) {
	    log.type = log.type || 'log';
	    var msg = ['[' + log.type.toUpperCase() + ']'].concat(log.args);
	    var method = console[log.type] || console.log;
	
	    if (!log.silent) {
	        method.apply(console, msg);
	    }
	
	    if (log.type !== 'log') {
	        // Trigger any level-specific events
	        this.emit.apply(this, [log.type].concat(Array.prototype.slice.call(arguments)));
	    }
	});
	
	/**
	 * Handler for 'track' events. Sends the eventName and eventData
	 * to Heap Analytics.
	 *
	 * Called on logger.track('eventName', { data });
	 */
	logger.on('track', function (eventName, eventData) {
	    // heap may throw an exception if we're calling track() and it
	    // has not loaded yet. Re-track if this happens up to N times (CC)
	    eventData = Object.assign({}, eventData, {
	        appVersion: pkg.version
	    });
	
	    function trackNow(callsLeft, trackFn) {
	        if (!callsLeft) return;
	        try {
	            trackFn();
	        } catch (e) {
	            setTimeout(trackNow, 1000, callsLeft - 1, trackFn);
	        }
	    }
	    var maxAttempts = 3;
	    if (global.ga) {
	        trackNow(maxAttempts, function () {
	            // docs: https://developers.google.com/analytics/devguides/collection/analyticsjs/events
	            global.ga('send', 'event', 'Views', eventName, eventName, eventData);
	        });
	    }
	
	    if (global.heap) {
	        trackNow(maxAttempts, function () {
	            global.heap.track(eventName, eventData);
	        });
	    }
	});
	
	if (false) module.exports = logger;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 486 */
/***/ function(module, exports) {

	module.exports = {
		"name": "common",
		"version": "1.0.509",
		"private": true,
		"description": "",
		"es6": true,
		"main": "./application.js",
		"scripts": {
			"test": "echo \"Error: no test specified\" && exit 1"
		},
		"author": "",
		"license": "ISC"
	};

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _detachedApplication = __webpack_require__(488);
	
	var _detachedApplication2 = _interopRequireDefault(_detachedApplication);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	__webpack_require__(476); // needed for react intl otherwise stuff busts
	
	module.exports = _detachedApplication2['default'];
	
	// All HelloSign components need to be attached to the application for legacy
	// purposes.
	_detachedApplication2['default'].components = __webpack_require__(695);
	_detachedApplication2['default'].mixins = {
	    'AdjustScrollingMixin': __webpack_require__(866)
	};

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _models = __webpack_require__(489);
	
	var _models2 = _interopRequireDefault(_models);
	
	var _actions = __webpack_require__(526);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _api = __webpack_require__(665);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _endpoints = __webpack_require__(672);
	
	var _endpoints2 = _interopRequireDefault(_endpoints);
	
	var _endpoints3 = __webpack_require__(681);
	
	var _endpoints4 = _interopRequireDefault(_endpoints3);
	
	var _application = __webpack_require__(682);
	
	var _application2 = _interopRequireDefault(_application);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * This is a standealone version of the legacy application constructor.  It's
	 * separated here so that it can be imported without dragging along _all_ of the
	 * hellosign components into the bundle.  Attaching all of the app components
	 * is necessary in the legacy architecture because they need to be available on
	 * the window, but it's no longer necessary with the new architecture. This is a
	 * transitory step towards making the hellosign app into more modular,
	 * spa-style apps.
	 */
	function Application(properties) {
	    _application2['default'].call(this, _extends({}, properties));
	
	    this.models = _models2['default'];
	
	    this.notifier = this.notifierCollection;
	
	    // set data here to prevent undefined exceptions in api/endpoints
	    this.serverSideGeneratedData = {};
	
	    this.actions = _actions2['default'].create({ app: this });
	
	    // the API service is added as a global notifier so that any
	    // part of the application can implicitly execute a message to the API
	    // service and receive a response.
	    // I.E: the API service is decoupled from the APP.
	    // I.E: the app is more testable.
	    this.notifier.push(_api2['default'].create({
	
	        // attach notifier so that the API service can announce
	        // when there is a response from the service
	        notifier: this.notifier,
	
	        // combine both endpoints
	        endpoints: Object.assign(_endpoints2['default'].create(this), _endpoints4['default'].create(this))
	    }));
	
	    this.user = _models2['default'].User.create({
	        notifier: this.notifier
	    });
	}
	
	_application2['default'].extend(Application, {
	    hydrate: function hydrate(data) {
	
	        // this stuff should be an API at some point
	        this.user.emailAddress = data.emailAddress;
	        this.serverSideGeneratedData = data;
	    }
	});
	
	module.exports = Application;

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	    User: __webpack_require__(490),
	    Team: __webpack_require__(491),
	    File: __webpack_require__(525),
	    TeamMember: __webpack_require__(495),
	    TeamMembers: __webpack_require__(508)
	};

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _team = __webpack_require__(491);
	
	var _team2 = _interopRequireDefault(_team);
	
	var _extend = __webpack_require__(497);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _recycle = __webpack_require__(512);
	
	var _recycle2 = _interopRequireDefault(_recycle);
	
	var _faxLines = __webpack_require__(513);
	
	var _faxLines2 = _interopRequireDefault(_faxLines);
	
	var _model = __webpack_require__(492);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _signatures = __webpack_require__(515);
	
	var _signatures2 = _interopRequireDefault(_signatures);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = _model2['default'].extend({
	
	    signatures: void 0,
	    settings: {},
	
	    apiEndpointAlias: 'user',
	
	    mixins: [__webpack_require__(496)],
	
	    /**
	    */
	
	    getSignatures: function getSignatures(type) {
	
	        if (!this.signatures) this.signatures = {};
	
	        if (!this.signatures[type]) {
	            this.signatures[type] = _signatures2['default'].create({
	                type: type,
	                notifier: this.notifier
	            });
	        }
	
	        return this.signatures[type];
	    },
	
	
	    /**
	     *
	     */
	
	    setSignatures: function setSignatures(type, signatures) {
	        this.signatures = this.signatures || {};
	        this.signatures[type] = signatures;
	    },
	
	
	    /**
	    */
	
	    getFirstName: function getFirstName() {
	        return this.settings.firstName || '';
	    },
	
	
	    /**
	    */
	
	    getLastName: function getLastName() {
	        return this.settings.lastName || '';
	    },
	
	
	    /**
	    */
	
	    getFullName: function getFullName() {
	        return _hfReactHelper2['default'].trim(this.getFirstName() + ' ' + this.getLastName());
	    },
	
	
	    /**
	    */
	
	    setFullName: function setFullName(fullName) {
	        if (fullName) {
	            var parts = fullName.split(' ');
	            this.settings.firstName = parts[0];
	            this.settings.lastName = parts.slice(1).join(' ');
	        } else {
	            this.settings.firstName = null;
	            this.settings.lastName = null;
	        }
	    },
	
	
	    /**
	    */
	
	    getInitials: function getInitials() {
	        var v = '';
	        var fn = this.getFirstName();
	        var ln = this.getLastName();
	        if (fn) {
	            v += fn[0];
	        }
	        if (ln) {
	            v += ln[0];
	        }
	        return v.toUpperCase();
	    },
	
	
	    /**
	    */
	
	    getFaxLines: function getFaxLines() {
	
	        if (!this._faxLines) {
	            this._faxLines = _faxLines2['default'].create({
	                user: this,
	                notifier: this.notifier
	            });
	            this._faxLines.load();
	        }
	
	        return this._faxLines;
	    },
	
	
	    /**
	    */
	
	    getTeam: function getTeam() {
	
	        if (!this._team) {
	            this._team = _team2['default'].create({
	                user: this,
	                notifier: this.notifier
	            });
	
	            this._team.load();
	        }
	
	        return this._team;
	    },
	
	
	    /**
	    */
	
	    fromData: function fromData(data) {
	        return {
	            'emailAddress': data.emailAddress,
	            'features': (0, _recycle2['default'])(this.features, _model2['default'], (0, _extend2['default'])({ user: this, notifier: this.notifier }, data.features))
	        };
	    }
	});

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _model = __webpack_require__(492);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _teamMember = __webpack_require__(495);
	
	var _teamMember2 = _interopRequireDefault(_teamMember);
	
	var _teamMembers = __webpack_require__(508);
	
	var _teamMembers2 = _interopRequireDefault(_teamMembers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = _model2['default'].extend({
	
	    /**
	    */
	
	    mixins: [__webpack_require__(496), __webpack_require__(511)],
	
	    /**
	    */
	
	    apiEndpointAlias: 'team',
	
	    /**
	    */
	
	    getMembers: function getMembers() {
	
	        var members = _teamMembers2['default'].create({
	            user: this.user,
	            team: this,
	            app: this.app,
	            notifier: this.notifier
	        });
	
	        members.load();
	
	        return members;
	    },
	
	
	    /**
	    */
	
	    onDataChange: function onDataChange(data) {
	
	        var properties = {
	            // might exist
	            hasTransferDocsAdmin: data.hasTransferDocsAdmin,
	            isTransferDocsAdmin: data.isTransferDocsAdmin,
	            isHighMrrEnterprise: data.isHighMrrEnterprise,
	            enterpriseProRateAmount: data.enterpriseProRateAmount,
	            enterprisePrice: data.enterprisePrice,
	            enterprisePeriod: data.enterprisePeriod,
	
	            // Note that Infinity is proper since we can do conditional operations against it.
	            // See addMember() method below (CC)
	            maxSize: Number(data.maxTeamSize == void 0 ? Infinity : data.maxTeamSize),
	
	            // minimum team size. Agreed amount when paying for seats (enterprise only)
	            minSize: Number(data.minTeamSize || 0),
	
	            // Note that the number of team members can exceed the total number of member objects in the app
	            size: data.teamSize || (data.members || []).length
	        };
	
	        var isOwner = data.isOwner,
	            name = data.name;
	
	
	        if (typeof isOwner !== 'undefined') properties.isOwner = !!isOwner;
	        if (typeof name !== 'undefined') properties.name = name;
	
	        this.setProperties(properties);
	    },
	
	
	    /**
	    */
	
	    toData: function toData() {
	        return {
	            name: this.name,
	            isOwner: this.isOwner,
	            hasTransferDocsAdmin: this.hasTransferDocsAdmin,
	            isTransferDocsAdmin: this.isTransferDocsAdmin,
	            isHighMrrEnterprise: this.isHighMrrEnterprise,
	            enterpriseProRateAmount: this.enterpriseProRateAmount,
	            enterprisePrice: this.enterprisePrice,
	            enterprisePeriod: this.enterprisePeriod,
	            maxTeamSize: this.maxSize,
	            minTeamSize: this.minSize,
	            teamSize: this.size
	        };
	    },
	
	
	    /**
	     * notification incoming from some other part of the app
	     */
	
	    notify: function notify(message) {
	        if (message.apiEndpointAlias === 'teamMembers') {
	            if (message.type === 'remove') {
	                this.setProperties({ size: this.size - 1 });
	            } else if (message.type === 'insert') {
	                this.setProperties({ size: this.size + 1 });
	            } else if (message.type === 'update') {
	
	                var tm = _teamMember2['default'].create({
	                    notifier: this.notifier,
	                    data: message.target.data
	                });
	
	                if (tm.isUser(this.user)) {
	                    this.setProperties({ isOwner: tm.canModifyTeam() });
	                }
	            }
	        }
	    },
	
	
	    /**
	    */
	
	    pastTeamMemberLimit: function pastTeamMemberLimit() {
	        return this.size >= (this.minSize || this.maxSize || 0);
	    },
	
	
	    /**
	    */
	
	    isEnterprise: function isEnterprise() {
	        return this.minSize !== void 0 && (this.maxSize === Infinity || this.maxSize === void 0);
	    },
	
	
	    /**
	    */
	
	    addMember: function addMember(properties) {
	        if (this.isEnterprise() && this.pastTeamMemberLimit()) {
	            this.minSize++;
	        }
	        return _teamMember2['default'].create(Object.assign({ notifier: this.notifier }, properties)).save();
	    },
	
	
	    /**
	    */
	
	    importTeamMembers: function importTeamMembers(file) {
	        // do nothing for now - currently causes redirect
	        return file.upload('/home/csvFileImport');
	    }
	});

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _protoclass = __webpack_require__(493);
	
	var _protoclass2 = _interopRequireDefault(_protoclass);
	
	var _mixin2 = __webpack_require__(494);
	
	var _mixin3 = _interopRequireDefault(_mixin2);
	
	var _events = __webpack_require__(484);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	*/
	
	function BaseModel(properties) {
	
	    // TODO - remove this - use notifier pattern instead (CC)
	    _events.EventEmitter.call(this);
	    this._disposables = [];
	    if (properties) this.setProperties(properties);
	    this.initialize();
	}
	
	/**
	*/
	
	(0, _protoclass2['default'])(BaseModel, _events.EventEmitter.prototype, {
	
	    /**
	     */
	
	    idProperty: 'guid',
	
	    /**
	    */
	
	    __isWatchableObject: true,
	
	    /**
	    */
	
	    initialize: function initialize() {},
	
	
	    /**
	     */
	
	    addDisposable: function addDisposable(disposable) {
	        this._disposables.push(disposable);
	        return disposable;
	    },
	
	
	    /**
	    */
	
	    equals: function equals(model) {
	        return model[this.idProperty] === this[this.idProperty];
	    },
	
	
	    /**
	    */
	
	    set: function set(key, value) {
	        if (this[key] !== value) {
	            var oldProps = {};
	            var newProps = {};
	            oldProps[key] = this[key];
	            this[key] = newProps[key] = value;
	            this.onPropertiesChange(oldProps, newProps);
	        }
	    },
	
	
	    /**
	    */
	
	    setProperties: function setProperties(properties) {
	
	        var oldValues = {};
	        var hasChange = false;
	
	        for (var key in properties) {
	            var newValue = properties[key];
	            if (newValue !== this[key]) {
	                oldValues[key] = this[key];
	                this[key] = properties[key];
	                hasChange = true;
	            }
	        }
	
	        if (hasChange) {
	            this.onPropertiesChange(oldValues, properties);
	        }
	    },
	
	
	    /**
	     * disposes the model
	     */
	
	    dispose: function dispose() {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = this._disposables.concat()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var disposable = _step.value;
	
	                disposable.dispose();
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator['return']) {
	                    _iterator['return']();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	    },
	
	
	    /**
	    */
	
	    onPropertiesChange: function onPropertiesChange(oldProps, newProps) {
	        if (newProps.data) {
	            this.onDataChange(newProps.data);
	        }
	    },
	
	
	    /**
	     */
	
	    onDataChange: function onDataChange(data) {
	        var props = this.fromData(data);
	        this.setProperties(props);
	    },
	
	
	    /**
	    */
	
	    fromData: function fromData(data) {
	        return data;
	    },
	
	
	    /**
	    */
	
	    toData: function toData() {
	        var data = {};
	        var target = this.data ? this.data : this;
	        for (var key in target) {
	            if (target.hasOwnProperty(key)) {
	                data[key] = this[key];
	            }
	        }
	        return data;
	    },
	
	
	    /**
	    */
	
	    toJSON: function toJSON() {
	        return this.toData();
	    }
	});
	
	var oldExtend = BaseModel.extend;
	
	BaseModel.extend = function (properties) {
	
	    var self = this;
	
	    function ChildModel() {
	        self.apply(this, arguments);
	    }
	
	    if (properties && properties.mixins) {
	        properties = (0, _mixin3['default'])([properties].concat(properties.mixins));
	    }
	
	    oldExtend.call(self, ChildModel, properties);
	    ChildModel.extend = self.extend;
	    ChildModel.create = self.create;
	    return ChildModel;
	};
	
	BaseModel.createClass = BaseModel.extend.bind(BaseModel);
	
	// factory method
	BaseModel.create = function (properties) {
	    return new this(properties);
	};
	
	module.exports = BaseModel;

/***/ },
/* 493 */
/***/ function(module, exports) {

	function _copy (to, from) {
	
	  for (var i = 0, n = from.length; i < n; i++) {
	
	    var target = from[i];
	
	    for (var property in target) {
	      to[property] = target[property];
	    }
	  }
	
	  return to;
	}
	
	function protoclass (parent, child) {
	
	  var mixins = Array.prototype.slice.call(arguments, 2);
	
	  if (typeof child !== "function") {
	    if(child) mixins.unshift(child); // constructor is a mixin
	    child   = parent;
	    parent  = function() { };
	  }
	
	  _copy(child, parent); 
	
	  function ctor () {
	    this.constructor = child;
	  }
	
	  ctor.prototype  = parent.prototype;
	  child.prototype = new ctor();
	  child.__super__ = parent.prototype;
	  child.parent    = child.superclass = parent;
	
	  _copy(child.prototype, mixins);
	
	  protoclass.setup(child);
	
	  return child;
	}
	
	protoclass.setup = function (child) {
	
	
	  if (!child.extend) {
	    child.extend = function(constructor) {
	
	      var args = Array.prototype.slice.call(arguments, 0);
	
	      if (typeof constructor !== "function") {
	        args.unshift(constructor = function () {
	          constructor.parent.apply(this, arguments);
	        });
	      }
	
	      return protoclass.apply(this, [this].concat(args));
	    }
	
	    child.mixin = function(proto) {
	      _copy(this.prototype, arguments);
	    }
	
	    child.create = function () {
	      var obj = Object.create(child.prototype);
	      child.apply(obj, arguments);
	      return obj;
	    }
	  }
	
	  return child;
	}
	
	
	module.exports = protoclass;

/***/ },
/* 494 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	*/
	
	module.exports = function (mixins) {
	
	    var prototype = {};
	
	    for (var i = 0, n = mixins.length; i < n; i++) {
	
	        var mixin = mixins[i];
	        var keys = Object.keys(mixin);
	
	        for (var j = 0, n2 = keys.length; j < n2; j++) {
	            var key = keys[j];
	            var value = mixin[key];
	            var tov = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	
	            if (tov === 'function') {
	                if (prototype[key]) {
	                    value = combineFunction(prototype[key], value);
	                }
	            }
	
	            prototype[key] = value;
	        }
	    }
	
	    return prototype;
	};
	
	/**
	*/
	
	function combineFunction(oldFn, newFn) {
	    return function () {
	        oldFn.apply(this, arguments);
	        return newFn.apply(this, arguments);
	    };
	}

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _model = __webpack_require__(492);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	*/
	
	module.exports = _model2['default'].extend({
	
	    /**
	    */
	
	    ROLE_CODE_ADMIN: 'a',
	    ROLE_CODE_DEVELOPER: 'd',
	    ROLE_CODE_MEMBER: 'm',
	    ROLE_NAMES: {
	        'a': 'Admin',
	        'd': 'Developer',
	        'm': 'Member'
	    },
	
	    numTemplates: 0,
	    roleCode: 'm',
	
	    mixins: [__webpack_require__(496)],
	
	    apiEndpointAlias: 'teamMembers',
	    shouldResetPassword: false,
	
	    /**
	    */
	
	    toData: function toData() {
	        return {
	            guid: this.guid,
	            emailAddress: this.emailAddress,
	            isLocked: this.isLocked,
	            roleCode: this.roleCode,
	            pending: this.pending,
	
	            // TODO - remove this!!
	            csrfToken: this.csrfToken
	        };
	    },
	
	
	    /**
	    * promotes or demotes a user depending on the new role code
	    */
	
	    promote: function promote(newRoleCode, event) {
	        this.setProperties({ roleCode: newRoleCode });
	        this.save(event);
	    },
	
	
	    /**
	    */
	
	    resetPassword: function resetPassword(event) {
	        this.shouldResetPassword = true;
	        this.save(event).then(function (resp) {
	            window.location.reload();
	        });
	    },
	
	
	    /**
	    */
	
	    unlock: function unlock(event) {
	        this.setProperties({ isLocked: false });
	        this.save(event);
	    },
	
	
	    /**
	    */
	
	    lock: function lock(event) {
	        this.setProperties({ isLocked: true });
	        this.save(event);
	    },
	
	
	    /**
	    */
	
	    getRoleTypeLabel: function getRoleTypeLabel() {
	        return this.ROLE_NAMES[this.roleCode || this.ROLE_CODE_MEMBER];
	    },
	
	
	    /**
	    */
	
	    canModifyTeam: function canModifyTeam() {
	        return this.isAdmin() || this.isDeveloper();
	    },
	
	
	    /**
	    */
	
	    isLoggedInUser: function isLoggedInUser() {
	
	        // ideally we'd go off user ids, but this works for now (CC)
	        return this.isUser(this.user);
	    },
	
	
	    /**
	    */
	
	    isUser: function isUser(user) {
	        if (!user) return false;
	        // ideally we'd go off user ids, but this works for now (CC)
	        return this.emailAddress === user.emailAddress;
	    },
	
	
	    /**
	    */
	
	    equals: function equals(model) {
	        return model.guid === this.guid && model.emailAddress === this.emailAddress;
	    },
	
	
	    /**
	    */
	
	    isAdmin: function isAdmin() {
	        return this.roleCode === this.ROLE_CODE_ADMIN;
	    },
	
	
	    /**
	    */
	
	    isDeveloper: function isDeveloper() {
	        return this.roleCode === this.ROLE_CODE_DEVELOPER;
	    },
	
	
	    /**
	    */
	
	    isMember: function isMember() {
	        return this.roleCode === this.ROLE_CODE_MEMBER;
	    }
	});

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extend = __webpack_require__(497);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _messages = __webpack_require__(503);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	module.exports = {
	
	    /**
	    * isNew is either explicitly set by you, or set via the existence of the data property, which is always set when when we have retrieved from the backend.
	    */
	
	    initialize: function initialize() {
	
	        if (!this.notifier && !("production") === 'test') {
	            console.error('notifier does not exist for model apiEndpoints: %s, data: ', this.apiEndpoints, this.data);
	        }
	
	        if (!this.isNew) {
	            this.isNew = function () {
	                return !this.data;
	            };
	        }
	    },
	
	
	    /**
	    */
	
	    toJSON: function toJSON() {
	        return this.toData();
	    },
	
	
	    /**
	    */
	
	    save: function save() {
	        var method = this.isNew() ? this.insert : this.update;
	        return method.apply(this, arguments);
	    },
	
	
	    /**
	    */
	
	    insert: function insert() {
	        return this._run.apply(this, [_messages.INSERT].concat(Array.prototype.slice.call(arguments)));
	    },
	
	
	    /**
	    */
	
	    update: function update() {
	        return this._run.apply(this, [_messages.UPDATE].concat(Array.prototype.slice.call(arguments)));
	    },
	
	
	    /**
	    */
	
	    load: function load() {
	        return this._run.apply(this, [_messages.LOAD].concat(Array.prototype.slice.call(arguments)));
	    },
	
	
	    /**
	    */
	
	    remove: function remove() {
	        return this._run.apply(this, [_messages.REMOVE].concat(Array.prototype.slice.call(arguments)));
	    },
	
	
	    /**
	    */
	
	    fetch: function fetch(operationName, options, onRun) {
	        var _this = this;
	
	        return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	            var _ref, _ref2, data;
	
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	
	                            if (typeof options === 'function') {
	                                onRun = options;
	                                options = {};
	                            }
	                            // KEEP THIS HERE. If notifier does not exist, throw a very descriptive & debuggable message. (CC)
	
	                            if (_this.notifier) {
	                                _context.next = 3;
	                                break;
	                            }
	
	                            throw new Error('notifier does not exist for model with apiEndpointAlias: ' + _this.apiEndpointAlias);
	
	                        case 3:
	                            _context.prev = 3;
	                            _context.next = 6;
	                            return _this.notifier.notify(_messages.RequestMessage.create(operationName, _this.apiEndpointAlias, _extends({ target: _this }, options)));
	
	                        case 6:
	                            _ref = _context.sent;
	                            _ref2 = _slicedToArray(_ref, 1);
	                            data = _ref2[0];
	
	
	                            if (onRun) onRun(void 0, _this);
	                            _context.next = 16;
	                            break;
	
	                        case 12:
	                            _context.prev = 12;
	                            _context.t0 = _context['catch'](3);
	
	                            if (onRun) onRun(_context.t0);
	                            throw _context.t0;
	
	                        case 16:
	                            return _context.abrupt('return', data || {});
	
	                        case 17:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, _this, [[3, 12]]);
	        }))();
	    },
	
	
	    /**
	    */
	
	    _run: function _run(operationName, options, onRun) {
	
	        if (typeof options === 'function') {
	            onRun = options;
	            options = {};
	        }
	
	        if (!onRun) {
	            onRun = function onRun() {};
	        }
	
	        var beforeOnRun = function (error, data) {
	
	            var props = {
	                loading: false
	            };
	
	            if (error) {
	                props.error = error;
	
	                // check if there's any data at all
	            } else if (!!Object.keys(data).length) {
	                props.data = (0, _extend2['default'])({}, data);
	            }
	
	            this.setProperties(props);
	            onRun.apply(this, arguments);
	        }.bind(this);
	
	        this.setProperties({
	            'error': void 0,
	            'loading': true
	        });
	
	        var ret = this.fetch(operationName, options);
	        ret.then(beforeOnRun.bind(this, void 0), beforeOnRun);
	        return ret;
	    }
	};

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(498);


/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	var assignWith = __webpack_require__(499),
	    baseAssign = __webpack_require__(500),
	    createAssigner = __webpack_require__(502);
	
	/**
	 * Assigns own enumerable properties of source object(s) to the destination
	 * object. Subsequent sources overwrite property assignments of previous sources.
	 * If `customizer` is provided it is invoked to produce the assigned values.
	 * The `customizer` is bound to `thisArg` and invoked with five arguments:
	 * (objectValue, sourceValue, key, object, source).
	 *
	 * **Note:** This method mutates `object` and is based on
	 * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
	 *
	 * @static
	 * @memberOf _
	 * @alias extend
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {*} [thisArg] The `this` binding of `customizer`.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	 * // => { 'user': 'fred', 'age': 40 }
	 *
	 * // using a customizer callback
	 * var defaults = _.partialRight(_.assign, function(value, other) {
	 *   return _.isUndefined(value) ? other : value;
	 * });
	 *
	 * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	 * // => { 'user': 'barney', 'age': 36 }
	 */
	var assign = createAssigner(function(object, source, customizer) {
	  return customizer
	    ? assignWith(object, source, customizer)
	    : baseAssign(object, source);
	});
	
	module.exports = assign;


/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(351);
	
	/**
	 * A specialized version of `_.assign` for customizing assigned values without
	 * support for argument juggling, multiple sources, and `this` binding `customizer`
	 * functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {Function} customizer The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 */
	function assignWith(object, source, customizer) {
	  var index = -1,
	      props = keys(source),
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index],
	        value = object[key],
	        result = customizer(value, source[key], key, object, source);
	
	    if ((result === result ? (result !== value) : (value === value)) ||
	        (value === undefined && !(key in object))) {
	      object[key] = result;
	    }
	  }
	  return object;
	}
	
	module.exports = assignWith;


/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	var baseCopy = __webpack_require__(501),
	    keys = __webpack_require__(351);
	
	/**
	 * The base implementation of `_.assign` without support for argument juggling,
	 * multiple sources, and `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return source == null
	    ? object
	    : baseCopy(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 501 */
/***/ function(module, exports) {

	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property names to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @returns {Object} Returns `object`.
	 */
	function baseCopy(source, props, object) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	    object[key] = source[key];
	  }
	  return object;
	}
	
	module.exports = baseCopy;


/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	var bindCallback = __webpack_require__(376),
	    isIterateeCall = __webpack_require__(348),
	    restParam = __webpack_require__(411);
	
	/**
	 * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return restParam(function(object, sources) {
	    var index = -1,
	        length = object == null ? 0 : sources.length,
	        customizer = length > 2 ? sources[length - 2] : undefined,
	        guard = length > 2 ? sources[2] : undefined,
	        thisArg = length > 1 ? sources[length - 1] : undefined;
	
	    if (typeof customizer == 'function') {
	      customizer = bindCallback(customizer, thisArg, 5);
	      length -= 2;
	    } else {
	      customizer = typeof thisArg == 'function' ? thisArg : undefined;
	      length -= (customizer ? 1 : 0);
	    }
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.INITIALIZE = exports.REMOVE = exports.UPDATE = exports.INSERT = exports.LOAD = exports.ERROR = exports.RESPONSE = exports.CHANGE = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.BaseMessage = BaseMessage;
	exports.ChangeMessage = ChangeMessage;
	exports.ResponseMessage = ResponseMessage;
	exports.RequestMessage = RequestMessage;
	exports.ErrorMessage = ErrorMessage;
	exports.InitializeMessage = InitializeMessage;
	
	var _class = __webpack_require__(504);
	
	// cannot use const - doesn't work in IE. Use var instead.
	var CHANGE = exports.CHANGE = 'change';
	var RESPONSE = exports.RESPONSE = 'response';
	var ERROR = exports.ERROR = 'error';
	
	var LOAD = exports.LOAD = 'load';
	var INSERT = exports.INSERT = 'insert';
	var UPDATE = exports.UPDATE = 'update';
	var REMOVE = exports.REMOVE = 'remove';
	
	var INITIALIZE = exports.INITIALIZE = 'initialize';
	
	function BaseMessage(type) {
	    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    Object.assign(this, _extends({
	        type: type
	    }, props));
	}
	
	BaseMessage.create = _class.create;
	BaseMessage.extend = _class.extend;
	
	function ChangeMessage(target) {
	    var changes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    BaseMessage.call(this, CHANGE, {
	        target: target,
	        changes: changes
	    });
	}
	
	// make instanceof work
	BaseMessage.extend(ChangeMessage);
	
	function ResponseMessage(response, requestMessage) {
	    BaseMessage.call(this, RESPONSE, {
	        data: response,
	        requestMessage: requestMessage
	    });
	}
	
	BaseMessage.extend(ResponseMessage);
	
	function RequestMessage(type, apiEndpointAlias, props) {
	    BaseMessage.call(this, type, _extends({
	        apiEndpointAlias: apiEndpointAlias
	    }, props));
	}
	
	BaseMessage.extend(RequestMessage, {
	    resolve: function resolve() {},
	    reject: function reject() {}
	});
	
	function ErrorMessage(error, target) {
	    BaseMessage.call(this, ERROR, {
	        error: error,
	        target: target
	    });
	}
	
	BaseMessage.extend(ErrorMessage);
	
	function InitializeMessage() {
	    BaseMessage.call(this, INITIALIZE);
	}
	
	BaseMessage.extend(InitializeMessage);

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.extend = exports.create = exports.createFactory = undefined;
	
	var _createFactory2 = __webpack_require__(505);
	
	var _createFactory3 = _interopRequireDefault(_createFactory2);
	
	var _create2 = __webpack_require__(506);
	
	var _create3 = _interopRequireDefault(_create2);
	
	var _extend2 = __webpack_require__(507);
	
	var _extend3 = _interopRequireDefault(_extend2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.createFactory = _createFactory3['default'];
	exports.create = _create3['default'];
	exports.extend = _extend3['default'];

/***/ },
/* 505 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports["default"] = function (contextClass) {
	    if (!contextClass) contextClass = Object;
	
	    // creates a new object from a class
	    function create(arg1, arg2, arg3, arg4) {
	
	        // dirty but fast
	        switch (arguments.length) {
	            case 1:
	                return new this(arg1);
	            case 2:
	                return new this(arg1, arg2);
	            case 3:
	                return new this(arg1, arg2, arg3);
	            case 4:
	                return new this(arg1, arg2, arg3, arg4);
	        }
	
	        // handle edge here.
	        // TODO - make this faster.
	        return createFromContext.apply(this, arguments);
	    }
	
	    // creates an object from *any* native class
	    function createFromContext() {
	        var context = new contextClass();
	        context.__proto__ = this.prototype;
	        this.apply(context, arguments);
	        return context;
	    }
	
	    function createAndCopyToContext() {
	        var context = new contextClass();
	        for (var k in this.prototype) {
	            context[k] = this.prototype[k];
	        }this.apply(context, arguments);
	        return context;
	    }
	
	    // context class Object? Use the faster method instead.
	    return contextClass === Object ? create : contextClass === Array ? createAndCopyToContext : createFromContext;
	};

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createFactory = __webpack_require__(505);
	
	var _createFactory2 = _interopRequireDefault(_createFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * expose class creation function
	 */
	
	exports['default'] = (0, _createFactory2['default'])(Object);

/***/ },
/* 507 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * IE8+ compatible subclassing. See https://babeljs.io/docs/advanced/caveats/
	 */
	
	module.exports = function (parent, child) {
	
	    var props;
	    var pi;
	
	    var c = child;
	    var p = parent;
	
	    if (typeof c === 'function') {
	        pi = 2;
	    } else {
	        if ((typeof p === 'undefined' ? 'undefined' : _typeof(p)) === 'object') {
	            c = function c() {
	                p.apply(this, arguments);
	            };
	            pi = 0;
	        } else {
	            c = p || function () {};
	            pi = 1;
	        }
	
	        p = typeof this === 'function' ? this : Object;
	    }
	
	    props = Array.prototype.slice.call(arguments, pi);
	
	    function Ctor() {
	        this.constructor = c;
	    }
	
	    Object.assign(c, p); // copy static props
	
	    Ctor.prototype = p.prototype;
	    c.prototype = new Ctor();
	
	    Object.assign(c.prototype, Object.assign.apply(Object, [{}].concat(props)));
	
	    return c;
	};

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _collection = __webpack_require__(509);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _teamMember = __webpack_require__(495);
	
	var _teamMember2 = _interopRequireDefault(_teamMember);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = _collection2['default'].extend({
	
	    apiEndpointAlias: 'teamMembers',
	
	    /**
	    */
	
	    mixins: [__webpack_require__(510)],
	
	    /**
	    */
	
	    createModel: function createModel(properties) {
	        properties.user = this.user;
	        properties.notifier = this.notifier;
	        return _teamMember2['default'].create(properties);
	    },
	
	
	    /**
	    */
	
	    loggedInUserCanModifyTeam: function loggedInUserCanModifyTeam() {
	        // return !!this.filter(function(member) {
	        //   return member.isLoggedInUser() && member.canModifyTeam();
	        // }.bind(this)).length;
	        return this.team.isOwner;
	    },
	
	
	    /**
	    */
	    getLoggedInUser: function getLoggedInUser() {
	        return this.filter(function (member) {
	            return member.isLoggedInUser();
	        }.bind(this))[0];
	    },
	
	
	    /**
	    */
	    loggedInUserIsDeveloper: function loggedInUserIsDeveloper() {
	        return !!this.filter(function (member) {
	            return member.isLoggedInUser() && member.isDeveloper();
	        }.bind(this)).length;
	    },
	
	
	    /**
	    */
	    loggedInUserIsAdmin: function loggedInUserIsAdmin() {
	        return this.team.isOwner;
	    },
	
	
	    /**
	    */
	
	    addMember: function addMember(properties) {
	        return this.createModel(properties).save();
	    }
	});

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _model = __webpack_require__(492);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function Collection(properties) {
	
	    // collections CANNOT be an instanceof Array if the "new" operator is involved. See below create() implementation.
	    if (!(this instanceof Array)) {
	        throw new Error('you must instantiate collections via Collection.create()');
	    }
	
	    _model2['default'].call(this, properties);
	}
	
	Object.assign(Collection.prototype, Array.prototype, _model2['default'].prototype, {
	    length: 0,
	    modelClass: _model2['default'],
	
	    // DEPRECATED  - use bracket syntax instead
	    at: function at(index) {
	        return this[index];
	    },
	    createModel: function createModel(properties) {
	        var Model = this.modelClass;
	
	        // use factory method if it exists (newer). Otherwise use older method here
	        return Model.create ? Model.create(properties) : new Model(properties);
	    },
	    toJSON: function toJSON() {
	        return this.toData();
	    },
	    toData: function toData() {
	        return this.map(function (item) {
	            return item && item.toJSON ? item.toJSON() : item;
	        });
	    },
	    onDataChange: function onDataChange(data) {
	        this.mergeSourceData(data);
	    },
	    mergeSourceData: function mergeSourceData(data) {
	
	        var mergedSource = [];
	
	        for (var i = 0, n = data.length; i < n; i++) {
	            var newItem = data[i];
	
	            // always create a new model so we can do a proper comparison
	            var model = this.createModel({ data: newItem });
	
	            // check existing models to see if we need to update anything
	            for (var j = this.length; j--;) {
	                var existingItem = this[j];
	
	                // item found? Use that instance instead
	                if (existingItem.equals(model)) {
	                    existingItem.setProperties({ data: newItem });
	                    model = existingItem;
	                    break;
	                }
	            }
	
	            mergedSource.push(model);
	        }
	
	        var removedItems = this.filter(function (item) {
	            return mergedSource.indexOf(item) === -1;
	        });
	
	        this.splice.apply(this, [0, this.length].concat(mergedSource));
	
	        removedItems.forEach(function (item) {
	            item.dispose();
	        });
	    },
	    dispose: function dispose() {
	        _model2['default'].prototype.dispose.call(this);
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = this[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var i = _step.value;
	                this[i].dispose();
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator['return']) {
	                    _iterator['return']();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        return this;
	    }
	});
	
	Collection.extend = _model2['default'].extend;
	
	/**
	* creates a new observable collection. This should be used instead of the 'new' operator.
	*/
	
	Collection.create = function () {
	    var context = [];
	    for (var k in this.prototype) {
	        context[k] = this.prototype[k];
	    }this.apply(context, arguments);
	    return context;
	};
	
	module.exports = Collection;

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	/**
	*/
	
	module.exports = Object.assign({}, __webpack_require__(511), {
	
	    /**
	    */
	
	    onCreateModel: function onCreateModel(model) {
	        model.notifier = this.notifier;
	    },
	
	
	    /**
	    */
	
	    getQuery: function getQuery() {
	        return {};
	    },
	
	
	    /**
	     */
	
	    notify: function notify(message) {
	        if (message.apiEndpoints !== this.apiEndpoints || !/response/.test(message.type)) return;
	        if (!/insert|update|remove/.test(message.requestMessage.type)) return;
	
	        // In the `/upload` endpoint, we always resolve the API response even if
	        // it was unsuccessful.  Checking if the data is actually an error here
	        // prevents making another HTTP call when the upload endpoint fails.
	        if (message.data instanceof Error) return;
	
	        // just reload. Any caching should be done by the service layer.
	        this.load();
	    },
	
	
	    /**
	    */
	
	    load: function load(onLoad) {
	        if (!onLoad) onLoad = function onLoad() {};
	
	        this.setProperties({
	            'error': void 0,
	            'loading': true
	        });
	
	        var beforeOnLoad = function (error, data) {
	
	            if (!error) {
	                this.setProperties({
	                    data: data
	                });
	            }
	
	            this.setProperties({
	                'error': error,
	                'loading': false
	            });
	
	            onLoad.apply(this, arguments);
	        }.bind(this);
	
	        return Promise.resolve(this.notifier.notify({
	            type: 'load',
	            multi: true,
	            apiEndpointAlias: this.apiEndpointAlias,
	            target: this,
	            query: this.getQuery()
	        })).then(function (_ref) {
	            var _ref2 = _slicedToArray(_ref, 1),
	                data = _ref2[0];
	
	            beforeOnLoad(void 0, data);
	        }, beforeOnLoad);
	    }
	});

/***/ },
/* 511 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	    initialize: function initialize() {
	        var _this = this;
	
	        // attach to the global notifier
	        this.notifier.push(this);
	
	        this.addDisposable({
	            dispose: function dispose() {
	                _this.notifier.remove(_this);
	            }
	        });
	    },
	    notify: function notify() {
	        // OVERRIDE ME
	    }
	};

/***/ },
/* 512 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function (instance, factory, properties) {
	    if (!instance || !instance.setProperties) return factory.create(properties);
	    instance.setProperties(properties);
	    return instance;
	};

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _faxLine = __webpack_require__(514);
	
	var _faxLine2 = _interopRequireDefault(_faxLine);
	
	var _collection = __webpack_require__(509);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = _collection2['default'].extend({
	
	    /**
	    */
	
	    mixins: [__webpack_require__(510)],
	
	    /**
	    */
	
	    apiEndpointAlias: 'faxLines',
	
	    /**
	    */
	
	    createModel: function createModel(properties) {
	        properties.notifier = this.notifier;
	        properties.user = this.user;
	        return _faxLine2['default'].create(properties);
	    },
	
	
	    /**
	    */
	
	    addFaxLine: function addFaxLine(properties) {
	        return this.createModel(properties).insert();
	    }
	});

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _model = __webpack_require__(492);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	
	'STATUS_CODE_ACTIVE': 'A',
	'STATUS_CODE_PORTING_DENIED': 'D',
	'STATUS_CODE_PORTING_LOA_COMPLETED': '4',
	'STATUS_CODE_PORTING_ACCEPTED': '2',
	'STATUS_CODE_PORTING_STARTED': '1'
	*/
	
	module.exports = _model2['default'].extend({
	
	    /**
	     */
	
	    apiEndpointAlias: 'faxLines',
	
	    /**
	    */
	
	    mixins: [__webpack_require__(496)],
	
	    /**
	    */
	
	    fromData: function fromData(data) {
	        return {
	            guid: data.guid,
	            number: '+' + String(data.number).replace(/^\+/, ''),
	            statusCode: data.statusCode || data.status,
	            teamMembers: data.teamMembers || []
	        };
	    },
	
	
	    /**
	    */
	
	    toData: function toData() {
	        return {
	            guid: this.guid,
	            number: this.number,
	            statusCode: this.statusCode,
	            teamMembers: this.teamMembers || []
	        };
	    },
	
	
	    /**
	    * TODO - this works for now. Ideally we'd have faxline.getMembers() in the future. (CC)
	    */
	
	    setMembers: function setMembers(members) {
	        this.teamMembers = members;
	        return this.save();
	    },
	
	
	    /**
	    */
	
	    isDenied: function isDenied() {
	        return this.statusCode === 'D';
	    },
	
	
	    /**
	    */
	
	    isActive: function isActive() {
	        return (/A/.test(String(this.statusCode))
	        );
	    },
	
	
	    /**
	    */
	
	    isAccepted: function isAccepted() {
	        return (/4|2/.test(String(this.statusCode))
	        );
	    },
	
	
	    /**
	    */
	
	    isPorting: function isPorting() {
	        return (/1/.test(String(this.statusCode))
	        );
	    }
	});

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _collection = __webpack_require__(509);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _signature = __webpack_require__(516);
	
	var _signature2 = _interopRequireDefault(_signature);
	
	var _extend = __webpack_require__(497);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Signatures = _collection2['default'].extend({
	
	    apiEndpointAlias: 'signatures',
	
	    mixins: [__webpack_require__(510)],
	
	    createModel: function createModel(properties) {
	        return _signature2['default'].create((0, _extend2['default'])({
	            'notifier': this.notifier
	        }, properties));
	    },
	    add: function add(properties) {
	        var _this = this;
	
	        var signature = this.createModel({
	            'data': properties
	        });
	
	        return signature.insert().then(function (errOrResponse) {
	
	            // The response here may actually be an error because all API calls
	            // to the /upload endpoint are always resolved.  We do this so we
	            // can prevent the signer API service from sending a global error
	            // message and re-rendering
	            if (errOrResponse.error || errOrResponse instanceof Error) {
	                return Promise.reject(errOrResponse);
	            }
	            _this.unshift(signature);
	            return Promise.resolve(signature);
	        });
	    },
	    addFromEdit: function addFromEdit(signature) {
	        var _this2 = this;
	
	        return signature.edit().then(function () {
	            _this2.unshift(signature);
	            return Promise.resolve(signature);
	        });
	    },
	    find: function find(guid) {
	        for (var i = 0; i < this.length; i++) {
	            var sig = this[i];
	            if (sig && sig.guid === guid) {
	                return sig;
	            }
	        }
	    },
	
	
	    //  ----  DATA  ---------------------------------------
	
	    onDataChange: function onDataChange(data) {
	
	        var signatures = [];
	        if (data && data.count) {
	            for (var i = 0; i < data.count; i++) {
	                signatures.push(this.createModel({ 'data': data.list[i] }));
	            }
	        }
	
	        // this.mergeSourceData(signatures); // TODO - more optimial
	        this.splice.apply(this, [0, this.length].concat(signatures));
	    }
	});
	
	module.exports = Signatures;

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _model = __webpack_require__(492);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Signature object
	 *
	 * @property String type               Signature or initials
	 * @property String createType         Method used to create the signature
	 * @property Array signature           Raw signature data (only set when new)
	 * @property String guid               Identifier
	 * @property Date createdAt            Creation time
	 * @property Date lastUsedAt           Last time it was used (null = never)
	 * @property Integer width             Image width in pixels
	 * @property Integer height            Image height in pixels
	 * @property String  file              File path to upload (null except when uploading)
	 * @property Object  editParams        Parameters (x, y, width, height, threshold, degrees) to send for image editing (null when not editing)
	 * @property String  emailGuid         signature_email_guid or initials_email_guid
	 */
	
	module.exports = _model2['default'].extend({
	
	    apiEndpointAlias: 'signature',
	
	    TYPE_INITIALS: 'I',
	    TYPE_SIGNATURE: 'S',
	
	    mixins: [__webpack_require__(496)],
	
	    /*
	     * Takes optional threshold parameters for signature editing
	     */
	    getUrl: function getUrl(threshold, degrees) {
	
	        var uri = '/attachment/view?sig_guid=' + this.guid;
	
	        if (arguments.length > 0) {
	            uri = '/attachment/view?sig_guid=' + this.guid;
	            uri += '&threshold=' + threshold + '&degrees=' + (degrees || 0);
	        }
	
	        return _hfReactHelper2['default'].attachSessionInfoToUrl(uri);
	    },
	
	
	    //  ----  DATA  ---------------------------------------
	
	    toData: function toData() {
	        return {
	            'guid': this.guid,
	            'createdAt': this.createdAt,
	            'lastUsedAt': this.lastUsedAt,
	            'width': this.width,
	            'height': this.height,
	            'type': this.type,
	            'signature': this.signature,
	            'file': this.file,
	            'emailGuid': this.emailGuid
	        };
	    },
	    fromData: function fromData(data) {
	        if (data) {
	            return {
	                'type': data.type_code,
	                'createType': data.create_type_code,
	                'guid': data.signature_id,
	                'createdAt': data.created_at ? new Date(data.created_at * 1000) : null,
	                'lastUsedAt': data.last_used_at ? new Date(data.last_used_at * 1000) : null,
	                'width': data.width,
	                'height': data.height,
	                'signature': data.signature || null
	            };
	        }
	    },
	    getEditParams: function getEditParams() {
	        return {
	            'width': this.width,
	            'height': this.height,
	            'editParams': this.editParams
	        };
	    },
	
	
	    //  ----  ACTIONS  ------------------------------------
	
	    rotate: function rotate(onRotate) {
	        onRotate = onRotate || function () {};
	        return this.fetch('rotate').then(onRotate.bind(null, void 0))['catch'](onRotate);
	    },
	    markAsPrimary: function markAsPrimary() {
	        return this.fetch('markAsPrimary');
	    },
	
	
	    /*
	     * Used for saving cropping / contrast / rotation results
	     * TODO - make this more descriptive -- edit() is a bit vague (CC)
	     */
	
	    edit: function edit() {
	        return this.fetch('edit');
	    },
	
	
	    /*
	     * Sets options for the crop endpoint edit step
	     */
	    setEditParams: function setEditParams(editParams) {
	        this.editParams = editParams;
	    },
	
	
	    /*
	     * Gets status / signature guids / new email guids
	     */
	    checkEmailSignatureStatus: function checkEmailSignatureStatus() {
	        return this.fetch('checkEmailSignatureStatus');
	    },
	
	
	    //  ----  HELPERS  ------------------------------------
	
	    isInitials: function isInitials() {
	        return this.type === this.TYPE_INITIALS;
	    },
	    isSignature: function isSignature() {
	        return this.type === this.TYPE_SIGNATURE;
	    }
	});

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _config = __webpack_require__(518);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _merge = __webpack_require__(519);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// fixes exception thrown in IE
	// from this: http://stackoverflow.com/questions/25754622/reveal-standalone-module-not-working
	if (typeof Foundation !== 'undefined') {
	    Foundation.global.namespace = '';
	}
	
	var fontCharMapDecode = function fontCharMapDecode(str) {
	    var row;
	    var key;
	    var rows = str.split('\n');
	    var chunks = {};
	    for (var i = 0; i < rows.length; i++) {
	        row = rows[i];
	        // find the row identifier
	        key = row.match(/^([a-z0-9]{4}): /)[1];
	        if (key.length != 4) {
	            throw new Error('Key not found');
	        }
	        // find the 32 bit chunks
	        chunks[key] = row.match(/[a-z0-9]{8}/g);
	        for (var j = 0; j < chunks[key].length; j++) {
	            chunks[key][j] = parseInt(chunks[key][j], 16);
	        }
	        if (chunks[key].length != 8) {
	            throw new Error('Row data not found');
	        }
	    }
	    return chunks;
	};
	
	var HfReactHelper = module.exports = (0, _merge2['default'])({}, _config2['default'], {
	    imgHelper: function imgHelper(input_string) {
	
	        var domain = HfReactHelper.hfCdn;
	        if (typeof location !== 'undefined') {
	            domain = String(location.hostname).indexOf('hellofax') !== -1 ? HfReactHelper.hfCdn : HfReactHelper.hsCdn;
	        }
	
	        return '//' + domain + '/images/' + input_string;
	    },
	    urlHelper: function urlHelper(input_string, site, use_subdomain) {
	        if (site !== HfReactHelper.HfSites.SITE_CODE_HF && site !== HfReactHelper.HfSites.SITE_CODE_HS) {
	            site = HfReactHelper.isHelloSign ? HfReactHelper.HfSites.SITE_CODE_HS : HfReactHelper.HfSites.SITE_CODE_HF;
	        }
	        var subDomain = use_subdomain || HfReactHelper.getCurrentSubdomain();
	        var url = HfReactHelper.urlHelperUrl ? HfReactHelper.urlHelperUrl.replace('__subdomain__', subDomain).replace('__site__', site) + '/' + input_string : input_string;
	        return url;
	    },
	    getCurrentSubdomain: function getCurrentSubdomain() {
	        var hostParts = window.location.host.split('.');
	        if (hostParts.length > 1) {
	            return hostParts[0];
	        } else {
	            return HfReactHelper.defaultSubdomain;
	        }
	    },
	    extend: function extend() {
	        for (var i = 1; i < arguments.length; i++) {
	            for (var key in arguments[i]) {
	                if (arguments[i].hasOwnProperty(key)) {
	                    arguments[0][key] = arguments[i][key];
	                }
	            }
	        }
	        return arguments[0];
	    },
	    trim: function trim(s) {
	        if (s && s.length > 0) {
	            for (var a = 0; a < s.length; a++) {
	                if (s[a] !== ' ') {
	                    break;
	                }
	            }
	            for (var b = s.length - 1; b >= 0; b--) {
	                if (s[b] !== ' ') {
	                    break;
	                }
	            }
	            return s.slice(a, b + 1);
	        } else {
	            return '';
	        }
	    },
	    inArray: function inArray(elem, array) {
	        if (array.indexOf) {
	            return array.indexOf(elem);
	        }
	
	        for (var i = 0, length = array.length; i < length; i++) {
	            if (array[i] === elem) {
	                return i;
	            }
	        }
	
	        return -1;
	    },
	    isValidEmailAddress: function isValidEmailAddress(email) {
	        var re = /^(([^<>()\[\]\\.,;:\s@\']+(\.[^<>()\[\]\\.,;:\s@\']+)*)|(\'.+\'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	        return re.test(email);
	    },
	    isValidPhoneNumber: function isValidPhoneNumber(number) {
	        var re = /^(1[\s-]?)?[\(\[\s-]{0,2}?\d{3}[\)\]\s-]{0,2}?\d{3}[\s-]?\d{4}$/;
	        return re.test(number);
	    },
	
	
	    /*
	    * Helper function for Foundation modals - cf: http://foundation.zurb.com/sites/docs/v/5.5.3/components/reveal.html
	    */
	    getRevealAttachPoint: function getRevealAttachPoint(element_id, size, showCloseButton, className) {
	
	        var attachPoint;
	        var modalContainer = document.getElementById(element_id);
	
	        if (modalContainer === null) {
	            modalContainer = document.createElement('div');
	            modalContainer.id = element_id;
	            var sizeClass = 'm-modal-restricted-size';
	            if (typeof size !== 'undefined') {
	                sizeClass = 'm-modal ' + size;
	            }
	            modalContainer.className = 'reveal-modal ' + sizeClass;
	            if (typeof className !== 'undefined') {
	                modalContainer.className += ' ' + className;
	            }
	            modalContainer.setAttribute('data-reveal', '');
	            document.body.appendChild(modalContainer);
	
	            if (typeof showCloseButton === 'undefined' || showCloseButton !== false) {
	                var closeButton = document.createElement('a');
	                closeButton.className = 'close-reveal-modal m-modal--close';
	                closeButton.innerHTML = '&#215;';
	                modalContainer.appendChild(closeButton);
	            }
	
	            attachPoint = document.createElement('div');
	            attachPoint.className = 'm-modal--container';
	            modalContainer.appendChild(attachPoint);
	        } else {
	            attachPoint = modalContainer.getElementsByTagName('div')[0];
	        }
	
	        return attachPoint;
	    },
	    formatMoney: function formatMoney(amount, currency, isInCents) {
	
	        if (isInCents === true) {
	            amount = amount / 100.0;
	        }
	
	        var rounded = parseInt(amount, 10);
	        var cents = parseInt((amount - rounded) * 100, 10);
	
	        return (currency !== undefined ? currency : '') + rounded + (cents > 0 ? '.' + cents : '');
	    },
	    isHelloFax: function isHelloFax() {
	        return !!~location.hostname.indexOf('hellofax');
	    },
	    isHelloSign: function isHelloSign() {
	        return !!~location.hostname.indexOf('hellosign');
	    },
	
	
	    // deprecate this (CC)
	    HfSites: {
	        isHelloFax: function isHelloFax(siteOrSiteCode) {
	            return siteOrSiteCode === HfReactHelper.HfSites.SITE_CODES[0] || siteOrSiteCode === HfReactHelper.HfSites.SITE_CODE_HF;
	        },
	        isHelloSign: function isHelloSign(siteOrSiteCode) {
	            return siteOrSiteCode === HfReactHelper.HfSites.SITE_CODES[1] || siteOrSiteCode === HfReactHelper.HfSites.SITE_CODE_HS;
	        },
	        getSite: function getSite(siteCode) {
	            return this['SITE_CODE_H' + siteCode];
	        }
	    },
	
	    hasLocalStorage: function hasLocalStorage() {
	        // in a try/catch block since this method of checking is more compatible with
	        // other browsers. See http://stackoverflow.com/questions/16427636/check-if-localstorage-is-available.
	        try {
	            var k = '__local_storage_check__';
	            localStorage.setItem(k, true);
	            localStorage.removeItem(k);
	            return true;
	        } catch (e) {
	            return false;
	        }
	    },
	
	
	    FONT_CHAR_MAP: {
	        'La Belle Aurore': fontCharMapDecode('0000: 00000000 ffffffff ffffffff 7fffffff 00000000 ffffffff ffffffff ffffffff\n' + '0001: 00000000 00000000 000c0000 01000000 00000000 00000000 00000000 00000000\n' + '0002: 00000000 00000000 00000000 00000000 00000000 00000000 10000040 00000000\n' + '0020: 771f07ff 06008044 80000000 00000000 00000000 00001000 00000000 00000000\n' + '0021: 00000000 00000004 00000000 00000000 00000000 00000000 00000000 00000000\n' + '00e0: 00000001 00000000 00000000 00000000 00000000 00000000 00000000 00000000\n' + '00fb: 00000006 00000000 00000000 00000000 00000000 00000000 00000000 00000000'),
	        'Mr De Haviland': fontCharMapDecode('0000: 00000000 ffffffff ffffffff 7fffffff 00000000 ffffffff ffffffff ffffffff\n' + '0001: 00000000 00000000 000c0000 01000000 00000000 00000000 00000000 00000000\n' + '0002: 00000000 00000000 00000000 00000000 00000000 00000000 10000040 00000000\n' + '0020: 771f07ff 06008044 80000000 00000000 00000000 00001000 00000000 00000000\n' + '0021: 00000000 00000004 00000000 00000000 00000000 00000000 00000000 00000000\n' + '00e0: 00000001 00000000 00000000 00000000 00000000 00000000 00000000 00000000\n' + '00fb: 00000006 00000000 00000000 00000000 00000000 00000000 00000000 00000000'),
	        'Nothing You Could Do': fontCharMapDecode('0000: 00000000 ffffffff ffffffff 7fffffff 00000000 ffff7fff ffffffff ffffffff\n' + '0001: 00000000 00000000 000c0000 01000000 00000000 00000000 00000000 00000000\n' + '0002: 00000000 00000000 00000000 00000000 00000000 00000000 10000040 00000000\n' + '0020: 771f07ff 06008044 80000000 00000000 00000000 00001000 00000000 00000000\n' + '0021: 00000000 00000004 00000000 00000000 00000000 00000000 00000000 00000000\n' + '00e0: 00000001 00000000 00000000 00000000 00000000 00000000 00000000 00000000\n' + '00fb: 00000006 00000000 00000000 00000000 00000000 00000000 00000000 00000000'),
	        'Zeyada': fontCharMapDecode('0000: 00000000 ffffffff ffffffff 7fffffff 00000000 ffffffff ffffffff ffffffff\n' + '0001: 00000000 00000000 000c0000 01000000 00000000 00000000 00000000 00000000\n' + '0002: 00000000 00000000 00000000 00000000 00000000 00000000 10000040 00000000\n' + '0020: 771f07ff 06008044 80000000 00000000 00000000 00001000 00000000 00000000\n' + '0021: 00000000 00000004 00000000 00000000 00000000 00000000 00000000 00000000\n' + '00e0: 00000001 00000000 00000000 00000000 00000000 00000000 00000000 00000000\n' + '00fb: 00000006 00000000 00000000 00000000 00000000 00000000 00000000 00000000'),
	        'Dawning of a New Day': fontCharMapDecode('0000: 00000000 ffffffff ffffffff 7fffffff 00000000 ffff7fff ffffffff ffffffff\n' + '0001: 00000000 00000000 000c0000 01000000 00000000 00000000 00000000 00000000\n' + '0002: 00000000 00000000 00000000 00000000 00000000 00000000 10000040 00000000\n' + '0020: 771f07ff 06008044 80000000 00000000 00000000 00001000 00000000 00000000\n' + '0021: 00000000 00000004 00000000 00000000 00000000 00000000 00000000 00000000\n' + '00e0: 00000001 00000000 00000000 00000000 00000000 00000000 00000000 00000000\n' + '00fb: 00000006 00000000 00000000 00000000 00000000 00000000 00000000 00000000'),
	        'Herr Von Muellerhoff': fontCharMapDecode('0000: 00000000 ffffffff bfffffff 7fffffff 00000000 ffffffff ffffffff ffffffff\n' + '0001: 00000000 00000000 000c0000 01000000 00000000 00000000 00000000 00000000\n' + '0002: 00000000 00000000 00000000 00000000 00000000 00000000 10000040 00000000\n' + '0020: 771f07ff 06008044 80000000 00000000 00000000 00001000 00000000 00000000\n' + '0021: 00000000 00000004 00000000 00000000 00000000 00000000 00000000 00000000\n' + '00e0: 00000001 00000000 00000000 00000000 00000000 00000000 00000000 00000000\n' + '00fb: 00000006 00000000 00000000 00000000 00000000 00000000 00000000 00000000'),
	        'Over the Rainbow': fontCharMapDecode('0000: 00000000 ffffffff ffffffff 7fffffff 00000000 ffffffff ffffffff ffffffff\n' + '0001: 00000000 00000000 000c0000 01000000 00000000 00000000 00000000 00000000\n' + '0002: 00000000 00000000 00000000 00000000 00000000 00000000 10000040 00000000\n' + '0020: 771f07ff 06008044 80000000 00000000 00000000 00001000 00000000 00000000\n' + '0021: 00000000 00000004 00000000 00000000 00000000 00000000 00000000 00000000\n' + '00e0: 00000001 00000000 00000000 00000000 00000000 00000000 00000000 00000000\n' + '00fb: 00000006 00000000 00000000 00000000 00000000 00000000 00000000 00000000')
	    },
	
	    // Getter to safely retrieve localStorage and avoid throwing tons of exceptions
	    // in private browsing mode or when stricter security rules are in application
	    getLocalStorage: function getLocalStorage() {
	
	        try {
	            if (typeof localStorage !== 'undefined') {
	                return localStorage;
	            }
	        } catch (e) {
	            if (e.name !== 'SecurityError') {
	                // Only skip if it's a security error
	                throw e;
	            }
	        }
	
	        // Return stub
	        return {
	            setItem: function setItem() {},
	            getItem: function getItem() {},
	            removeItem: function removeItem() {}
	        };
	    },
	    attachSessionInfoToUrl: function attachSessionInfoToUrl(url) {
	        if (window.hellofaxJS) {
	            url = hellofaxJS.attachSessionInfoToUrl(url);
	        }
	        return url;
	    },
	
	
	    Cookie: {
	        get: function get(key) {
	            var parts,
	                pairs = document.cookie.split(';');
	            for (var k in pairs) {
	                parts = $.trim(pairs[k]).split('=');
	                if (parts.shift() == key) {
	                    return parts.join('=');
	                }
	            }
	        },
	        set: function set(key, value, ttl_ms, path) {
	            var c = key + '=' + value;
	            if (ttl_ms !== undefined) {
	                var d = new Date();
	                d.setTime(d.getTime() + ttl_ms);
	                c += '; expires=' + d.toUTCString();
	            }
	            if (path === undefined) {
	                // Strip any characters that don't conform to RFC 3986 (http://www.ietf.org/rfc/rfc3986.txt) 
	                path = document.location.pathname.replace(/^[A-Za-z0-9\-\._~\:\/\?#\[\]\@\!\$\&\'\(\)\*\+,;\=]/g, '');
	            }
	            if (path) {
	                // This way we can skip setting path by using path=null
	                c += '; path=' + path;
	            }
	            c += '; domain=' + document.domain + ';';
	            document.cookie = c;
	        }
	    }
	
	});
	
	// IE9 shim
	// TODO - move this to ./shims
	if (typeof window !== 'undefined' && !window.console) {
	    window.console = {};window.console.log = function () {};
	}

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hsHost = ("app.hellosign.com");
	var hfHost = ("app.hellofax.com");
	var cdnHost = ("s3.amazonaws.com/cdn.hellosign.com/1.40.0");
	
	// find something like dev-hellosign
	var prefix = hsHost.match(/(\w+-)\w+.com/);
	if (prefix) prefix = prefix[1];
	
	var subdomain = hsHost.match(/^(\w+)/)[1];
	
	module.exports = {
	    'hfCdn': cdnHost,
	    'hsCdn': cdnHost,
	    'defaultSubdomain': subdomain,
	    'urlHelperUrl': '\/\/__subdomain__.' + (prefix || '') + '__site__.com',
	    'HfSites': {
	        'SITE_CODE_HF': 'hellofax',
	        'SITE_CODE_HS': 'hellosign',
	        'SITE_CODES': ['F', 'S']
	    },
	    'HfConstants': {
	        'csrfFieldName': '_csrf_token',
	        'supportPhoneNumber': '(415) 766-0273',
	        'supportEmail': {
	            'hellosign': 'support@hellosign.com',
	            'hellofax': 'support@hellofax.com'
	        },
	        'team_fax_lines': {
	            'STATUS_CODES': {
	                'STATUS_CODE_ACTIVE': 'A',
	                'STATUS_CODE_PORTING_DENIED': 'D',
	                'STATUS_CODE_PORTING_LOA_COMPLETED': '4',
	                'STATUS_CODE_PORTING_ACCEPTED': '2',
	                'STATUS_CODE_PORTING_STARTED': '1'
	            },
	            'URLS': {
	                'cancelPortingRequestUrl': '\/\/' + hfHost + '\/content\/cancelPortingRequestUrl',
	                'removeFaxLineUrl': '\/\/' + hfHost + '\/content\/removeFaxLine',
	                'updateFaxLinePermissionsUrl': '\/\/' + hfHost + '\/home\/updateFaxLinePermissions',
	                'checkPortabilityStatusUrl': '\/\/' + hfHost + '\/content\/checkPortabilityStatus',
	                'testUrl': '\/\/' + hfHost + '\/home\/manage',
	                'spinnerUrl': '\/\/' + cdnHost + '\/images\/loading-spinner-16.gif'
	            }
	        },
	        'URLS': {
	            'cancelPortingRequestUrl': '\/\/' + hfHost + '\/content\/cancelPortingRequestUrl',
	            'removeFaxLineUrl': '\/\/' + hfHost + '\/content\/removeFaxLine',
	            'updateFaxLinePermissionsUrl': '\/\/' + hfHost + '\/home\/updateFaxLinePermissions',
	            'checkPortabilityStatusUrl': '\/\/' + hfHost + '\/content\/checkPortabilityStatus',
	            'testUrl': '\/\/' + hfHost + '\/home\/manage',
	            'spinnerUrl': '\/\/' + cdnHost + '\/\/images\/loading-spinner-16.gif'
	        },
	        'api_pricing': {
	            'URLS': {
	                'contactUsUrl': 'mailto:apisupport@hellosign.com',
	                'salesUrl': 'mailto:sales@hellosign.com'
	            }
	        },
	        'enterpriseFeatures': {
	            'HIPAA': 'HIPAA'
	        }
	    }
	};

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(520),
	    createAssigner = __webpack_require__(502);
	
	/**
	 * Recursively merges own enumerable properties of the source object(s), that
	 * don't resolve to `undefined` into the destination object. Subsequent sources
	 * overwrite property assignments of previous sources. If `customizer` is
	 * provided it is invoked to produce the merged values of the destination and
	 * source properties. If `customizer` returns `undefined` merging is handled
	 * by the method instead. The `customizer` is bound to `thisArg` and invoked
	 * with five arguments: (objectValue, sourceValue, key, object, source).
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {*} [thisArg] The `this` binding of `customizer`.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var users = {
	 *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	 * };
	 *
	 * var ages = {
	 *   'data': [{ 'age': 36 }, { 'age': 40 }]
	 * };
	 *
	 * _.merge(users, ages);
	 * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	 *
	 * // using a customizer callback
	 * var object = {
	 *   'fruits': ['apple'],
	 *   'vegetables': ['beet']
	 * };
	 *
	 * var other = {
	 *   'fruits': ['banana'],
	 *   'vegetables': ['carrot']
	 * };
	 *
	 * _.merge(object, other, function(a, b) {
	 *   if (_.isArray(a)) {
	 *     return a.concat(b);
	 *   }
	 * });
	 * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	 */
	var merge = createAssigner(baseMerge);
	
	module.exports = merge;


/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(521),
	    baseMergeDeep = __webpack_require__(522),
	    isArray = __webpack_require__(343),
	    isArrayLike = __webpack_require__(338),
	    isObject = __webpack_require__(347),
	    isObjectLike = __webpack_require__(342),
	    isTypedArray = __webpack_require__(366),
	    keys = __webpack_require__(351);
	
	/**
	 * The base implementation of `_.merge` without support for argument juggling,
	 * multiple sources, and `this` binding `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Array} [stackA=[]] Tracks traversed source objects.
	 * @param {Array} [stackB=[]] Associates values with source counterparts.
	 * @returns {Object} Returns `object`.
	 */
	function baseMerge(object, source, customizer, stackA, stackB) {
	  if (!isObject(object)) {
	    return object;
	  }
	  var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
	      props = isSrcArr ? undefined : keys(source);
	
	  arrayEach(props || source, function(srcValue, key) {
	    if (props) {
	      key = srcValue;
	      srcValue = source[key];
	    }
	    if (isObjectLike(srcValue)) {
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	      baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
	    }
	    else {
	      var value = object[key],
	          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	          isCommon = result === undefined;
	
	      if (isCommon) {
	        result = srcValue;
	      }
	      if ((result !== undefined || (isSrcArr && !(key in object))) &&
	          (isCommon || (result === result ? (result !== value) : (value === value)))) {
	        object[key] = result;
	      }
	    }
	  });
	  return object;
	}
	
	module.exports = baseMerge;


/***/ },
/* 521 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	var arrayCopy = __webpack_require__(400),
	    isArguments = __webpack_require__(337),
	    isArray = __webpack_require__(343),
	    isArrayLike = __webpack_require__(338),
	    isPlainObject = __webpack_require__(523),
	    isTypedArray = __webpack_require__(366),
	    toPlainObject = __webpack_require__(524);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Array} [stackA=[]] Tracks traversed source objects.
	 * @param {Array} [stackB=[]] Associates values with source counterparts.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
	  var length = stackA.length,
	      srcValue = source[key];
	
	  while (length--) {
	    if (stackA[length] == srcValue) {
	      object[key] = stackB[length];
	      return;
	    }
	  }
	  var value = object[key],
	      result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	      isCommon = result === undefined;
	
	  if (isCommon) {
	    result = srcValue;
	    if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
	      result = isArray(value)
	        ? value
	        : (isArrayLike(value) ? arrayCopy(value) : []);
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      result = isArguments(value)
	        ? toPlainObject(value)
	        : (isPlainObject(value) ? value : {});
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  // Add the source value to the stack of traversed objects and associate
	  // it with its merged value.
	  stackA.push(srcValue);
	  stackB.push(result);
	
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
	  } else if (result === result ? (result !== value) : (value === value)) {
	    object[key] = result;
	  }
	}
	
	module.exports = baseMergeDeep;


/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	var baseForIn = __webpack_require__(410),
	    isArguments = __webpack_require__(337),
	    isObjectLike = __webpack_require__(342);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * **Note:** This method assumes objects created by the `Object` constructor
	 * have no inherited enumerable properties.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  var Ctor;
	
	  // Exit early for non `Object` objects.
	  if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	      (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	    return false;
	  }
	  // IE < 9 iterates inherited properties before own properties. If the first
	  // iterated property is an object's own property then there are no inherited
	  // enumerable properties.
	  var result;
	  // In most environments an object's own properties are iterated before
	  // its inherited properties. If the last iterated property is an object's
	  // own property then there are no inherited enumerable properties.
	  baseForIn(value, function(subValue, key) {
	    result = key;
	  });
	  return result === undefined || hasOwnProperty.call(value, result);
	}
	
	module.exports = isPlainObject;


/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	var baseCopy = __webpack_require__(501),
	    keysIn = __webpack_require__(353);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable
	 * properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return baseCopy(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _model = __webpack_require__(492);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	* wrapper around multiform submit. Note that
	* this file is generally created by a component, and
	* emitted to listener which most would most likely pass this
	* back to a model. (CC)
	*/
	
	// TODO - bind upload path
	// TODO - ability to change upload path
	module.exports = _model2['default'].extend({
	
	    /**
	    * properties
	    */
	
	    // private property on file - this is the form object submitting multipart data. Only way to do
	    // this in the browser. (CC)
	    _form: void 0,
	
	    // the physical file content. We'll want to use this later when using pure JS
	    // to upload files
	    content: void 0,
	
	    // name of the file to upload
	    name: void 0,
	
	    /**
	    */
	
	    initialize: function initialize() {
	        if (!this._form) throw new Error('_form must exist for file models');
	    },
	
	
	    /**
	    * uploads the file to the browser
	    */
	
	    upload: function upload() {
	
	        // currently unused
	        // // jquery required to properly emit onsubmit
	        // this._form.action = app.service.transport.getAPIPath(pathname);
	        // $(this._form).submit();
	        //
	        // // nothing for now
	        // return Promise.resolve();
	    }
	});

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ui = __webpack_require__(527);
	
	var _ui2 = _interopRequireDefault(_ui);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * global
	 */
	
	exports['default'] = {
	    create: function create() {
	        return {
	            ui: _ui2['default']
	        };
	    }
	};

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * ui specific actions
	 */
	
	module.exports = {
	
	    /**
	     */
	
	    showModal: function showModal(modalComponent, options, modalClassName) {
	        var div = document.createElement('div');
	        div.setAttribute('padding', '15px');
	
	        _reactDom2['default'].render(modalComponent, div);
	
	        var $div = $(div);
	
	        // not very react-like. Works for now
	        $div.find('.close').click(function () {
	            $.fancybox.close();
	        });
	
	        var baseOptions = {
	            //'type'            : 'iframe',
	            'showCloseButton': true,
	            'height': 300,
	            'width': 490
	        };
	
	        if (options) {
	            for (var k in options) {
	                baseOptions[k] = options[k];
	            }
	        }
	
	        baseOptions.onStart = function () {
	            $('#fancybox-overlay').addClass('m-fancybox-modal-overlay ' + modalClassName + ' is-hidden');
	            $('#fancybox-wrap').addClass('m-fancybox-modal-wrap ' + modalClassName + ' is-hidden');
	            $('#fancybox-inner').addClass('m-fancybox-modal-inner ' + modalClassName);
	        };
	
	        baseOptions.onComplete = function () {
	            $.fancybox.center();
	            $('#fancybox-overlay, #fancybox-wrap').removeClass('is-hidden');
	            if (options && options.onComplete && typeof options.onComplete === 'function') {
	                options.onComplete();
	            }
	        };
	
	        baseOptions.onClosed = function () {
	            $('#fancybox-overlay, #fancybox-wrap, #fancybox-inner').attr('class', '');
	            if (options && options.onClosed && typeof options.onClosed === 'function') {
	                options.onClosed();
	            }
	        };
	
	        $div.fancybox(baseOptions).click();
	        $div.fancybox(baseOptions).unbind("click");
	    },
	
	
	    /**
	     */
	
	    alert: function alert() {}
	};

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(529);


/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(530);
	var ReactDefaultInjection = __webpack_require__(534);
	var ReactMount = __webpack_require__(656);
	var ReactReconciler = __webpack_require__(555);
	var ReactUpdates = __webpack_require__(552);
	var ReactVersion = __webpack_require__(661);
	
	var findDOMNode = __webpack_require__(662);
	var getHostComponentFromComposite = __webpack_require__(663);
	var renderSubtreeIntoContainer = __webpack_require__(664);
	var warning = __webpack_require__(313);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(531);
	
	var DOMProperty = __webpack_require__(532);
	var ReactDOMComponentFlags = __webpack_require__(533);
	
	var invariant = __webpack_require__(310);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (childNode.nodeType === 1 && childNode.getAttribute(ATTR_NAME) === String(childID) || childNode.nodeType === 8 && childNode.nodeValue === ' react-text: ' + childID + ' ' || childNode.nodeType === 8 && childNode.nodeValue === ' react-empty: ' + childID + ' ') {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 531 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(531);
	
	var invariant = __webpack_require__(310);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 533 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(535);
	var BeforeInputEventPlugin = __webpack_require__(536);
	var ChangeEventPlugin = __webpack_require__(551);
	var DefaultEventPluginOrder = __webpack_require__(563);
	var EnterLeaveEventPlugin = __webpack_require__(564);
	var HTMLDOMPropertyConfig = __webpack_require__(569);
	var ReactComponentBrowserEnvironment = __webpack_require__(570);
	var ReactDOMComponent = __webpack_require__(583);
	var ReactDOMComponentTree = __webpack_require__(530);
	var ReactDOMEmptyComponent = __webpack_require__(627);
	var ReactDOMTreeTraversal = __webpack_require__(628);
	var ReactDOMTextComponent = __webpack_require__(629);
	var ReactDefaultBatchingStrategy = __webpack_require__(630);
	var ReactEventListener = __webpack_require__(631);
	var ReactInjection = __webpack_require__(634);
	var ReactReconcileTransaction = __webpack_require__(635);
	var SVGDOMPropertyConfig = __webpack_require__(643);
	var SelectEventPlugin = __webpack_require__(644);
	var SimpleEventPlugin = __webpack_require__(645);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 535 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(537);
	var ExecutionEnvironment = __webpack_require__(544);
	var FallbackCompositionState = __webpack_require__(545);
	var SyntheticCompositionEvent = __webpack_require__(548);
	var SyntheticInputEvent = __webpack_require__(550);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(538);
	var EventPluginUtils = __webpack_require__(540);
	
	var accumulateInto = __webpack_require__(542);
	var forEachAccumulated = __webpack_require__(543);
	var warning = __webpack_require__(313);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(531);
	
	var EventPluginRegistry = __webpack_require__(539);
	var EventPluginUtils = __webpack_require__(540);
	var ReactErrorUtils = __webpack_require__(541);
	
	var accumulateInto = __webpack_require__(542);
	var forEachAccumulated = __webpack_require__(543);
	var invariant = __webpack_require__(310);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(531);
	
	var invariant = __webpack_require__(310);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(531);
	
	var ReactErrorUtils = __webpack_require__(541);
	
	var invariant = __webpack_require__(310);
	var warning = __webpack_require__(313);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      // $FlowFixMe https://github.com/facebook/flow/issues/2336
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(531);
	
	var invariant = __webpack_require__(310);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 543 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 544 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(306);
	
	var PooledClass = __webpack_require__(546);
	
	var getTextContentAccessor = __webpack_require__(547);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(531);
	
	var invariant = __webpack_require__(310);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(544);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(549);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(306);
	
	var PooledClass = __webpack_require__(546);
	
	var emptyFunction = __webpack_require__(314);
	var warning = __webpack_require__(313);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else if (typeof event.returnValue !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(549);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(538);
	var EventPropagators = __webpack_require__(537);
	var ExecutionEnvironment = __webpack_require__(544);
	var ReactDOMComponentTree = __webpack_require__(530);
	var ReactUpdates = __webpack_require__(552);
	var SyntheticEvent = __webpack_require__(549);
	
	var getEventTarget = __webpack_require__(560);
	var isEventSupported = __webpack_require__(561);
	var isTextInputElement = __webpack_require__(562);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topInput') {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topClick') {
	    return targetInst;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(531),
	    _assign = __webpack_require__(306);
	
	var CallbackQueue = __webpack_require__(553);
	var PooledClass = __webpack_require__(546);
	var ReactFeatureFlags = __webpack_require__(554);
	var ReactReconciler = __webpack_require__(555);
	var Transaction = __webpack_require__(559);
	
	var invariant = __webpack_require__(310);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(531);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(546);
	
	var invariant = __webpack_require__(310);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 554 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(556);
	var ReactInstrumentation = __webpack_require__(558);
	
	var warning = __webpack_require__(313);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
	  ) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(557);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(531);
	
	var invariant = __webpack_require__(310);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(531);
	
	var invariant = __webpack_require__(310);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 560 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(544);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 562 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 563 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(537);
	var ReactDOMComponentTree = __webpack_require__(530);
	var SyntheticMouseEvent = __webpack_require__(565);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(566);
	var ViewportMetrics = __webpack_require__(567);
	
	var getEventModifierState = __webpack_require__(568);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(549);
	
	var getEventTarget = __webpack_require__(560);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 567 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 568 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(532);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {}
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(571);
	var ReactDOMIDOperations = __webpack_require__(582);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(572);
	var Danger = __webpack_require__(578);
	var ReactDOMComponentTree = __webpack_require__(530);
	var ReactInstrumentation = __webpack_require__(558);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(575);
	var setInnerHTML = __webpack_require__(574);
	var setTextContent = __webpack_require__(576);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: { toIndex: update.toIndex, content: update.content.toString() }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(573);
	var setInnerHTML = __webpack_require__(574);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(575);
	var setTextContent = __webpack_require__(576);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 573 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(544);
	var DOMNamespaces = __webpack_require__(573);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(575);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 575 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(544);
	var escapeTextContentForBrowser = __webpack_require__(577);
	var setInnerHTML = __webpack_require__(574);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 577 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(531);
	
	var DOMLazyTree = __webpack_require__(572);
	var ExecutionEnvironment = __webpack_require__(544);
	
	var createNodesFromMarkup = __webpack_require__(579);
	var emptyFunction = __webpack_require__(314);
	var invariant = __webpack_require__(310);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(544);
	
	var createArrayFromMixed = __webpack_require__(580);
	var getMarkupWrap = __webpack_require__(581);
	var invariant = __webpack_require__(310);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(310);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(544);
	
	var invariant = __webpack_require__(310);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(571);
	var ReactDOMComponentTree = __webpack_require__(530);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(531),
	    _assign = __webpack_require__(306);
	
	var AutoFocusUtils = __webpack_require__(584);
	var CSSPropertyOperations = __webpack_require__(586);
	var DOMLazyTree = __webpack_require__(572);
	var DOMNamespaces = __webpack_require__(573);
	var DOMProperty = __webpack_require__(532);
	var DOMPropertyOperations = __webpack_require__(594);
	var EventPluginHub = __webpack_require__(538);
	var EventPluginRegistry = __webpack_require__(539);
	var ReactBrowserEventEmitter = __webpack_require__(596);
	var ReactDOMComponentFlags = __webpack_require__(533);
	var ReactDOMComponentTree = __webpack_require__(530);
	var ReactDOMInput = __webpack_require__(599);
	var ReactDOMOption = __webpack_require__(602);
	var ReactDOMSelect = __webpack_require__(603);
	var ReactDOMTextarea = __webpack_require__(604);
	var ReactInstrumentation = __webpack_require__(558);
	var ReactMultiChild = __webpack_require__(605);
	var ReactServerRenderingTransaction = __webpack_require__(623);
	
	var emptyFunction = __webpack_require__(314);
	var escapeTextContentForBrowser = __webpack_require__(577);
	var invariant = __webpack_require__(310);
	var isEventSupported = __webpack_require__(561);
	var shallowEqual = __webpack_require__(612);
	var validateDOMNesting = __webpack_require__(626);
	var warning = __webpack_require__(313);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	        DOMLazyTree.queueText(lazyTree, contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(530);
	
	var focusNode = __webpack_require__(585);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 585 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(587);
	var ExecutionEnvironment = __webpack_require__(544);
	var ReactInstrumentation = __webpack_require__(558);
	
	var camelizeStyleName = __webpack_require__(588);
	var dangerousStyleValue = __webpack_require__(590);
	var hyphenateStyleName = __webpack_require__(591);
	var memoizeStringOnly = __webpack_require__(593);
	var warning = __webpack_require__(313);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 587 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(589);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 589 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(587);
	var warning = __webpack_require__(313);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(592);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 592 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 593 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(532);
	var ReactDOMComponentTree = __webpack_require__(530);
	var ReactInstrumentation = __webpack_require__(558);
	
	var quoteAttributeValueForBrowser = __webpack_require__(595);
	var warning = __webpack_require__(313);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(577);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(306);
	
	var EventPluginRegistry = __webpack_require__(539);
	var ReactEventEmitterMixin = __webpack_require__(597);
	var ViewportMetrics = __webpack_require__(567);
	
	var getVendorPrefixedEventName = __webpack_require__(598);
	var isEventSupported = __webpack_require__(561);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(538);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(544);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(531),
	    _assign = __webpack_require__(306);
	
	var DOMPropertyOperations = __webpack_require__(594);
	var LinkedValueUtils = __webpack_require__(600);
	var ReactDOMComponentTree = __webpack_require__(530);
	var ReactUpdates = __webpack_require__(552);
	
	var invariant = __webpack_require__(310);
	var warning = __webpack_require__(313);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	
	    if (false) {
	      inst._wrapperState.controlled = isControlled(props);
	    }
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        node.defaultValue = '' + props.defaultValue;
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(531);
	
	var React = __webpack_require__(305);
	var ReactPropTypesSecret = __webpack_require__(601);
	
	var invariant = __webpack_require__(310);
	var warning = __webpack_require__(313);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: React.PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 601 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(306);
	
	var React = __webpack_require__(305);
	var ReactDOMComponentTree = __webpack_require__(530);
	var ReactDOMSelect = __webpack_require__(603);
	
	var warning = __webpack_require__(313);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(306);
	
	var LinkedValueUtils = __webpack_require__(600);
	var ReactDOMComponentTree = __webpack_require__(530);
	var ReactUpdates = __webpack_require__(552);
	
	var warning = __webpack_require__(313);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(531),
	    _assign = __webpack_require__(306);
	
	var LinkedValueUtils = __webpack_require__(600);
	var ReactDOMComponentTree = __webpack_require__(530);
	var ReactUpdates = __webpack_require__(552);
	
	var invariant = __webpack_require__(310);
	var warning = __webpack_require__(313);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Warning: node.value may be the empty string at this point (IE11) if placeholder is set.
	    node.value = node.textContent; // Detach value from defaultValue
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(531);
	
	var ReactComponentEnvironment = __webpack_require__(606);
	var ReactInstanceMap = __webpack_require__(607);
	var ReactInstrumentation = __webpack_require__(558);
	
	var ReactCurrentOwner = __webpack_require__(312);
	var ReactReconciler = __webpack_require__(555);
	var ReactChildReconciler = __webpack_require__(608);
	
	var emptyFunction = __webpack_require__(314);
	var flattenChildren = __webpack_require__(622);
	var invariant = __webpack_require__(310);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(531);
	
	var invariant = __webpack_require__(310);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 607 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(555);
	
	var instantiateReactComponent = __webpack_require__(609);
	var KeyEscapeUtils = __webpack_require__(617);
	var shouldUpdateReactComponent = __webpack_require__(613);
	var traverseAllChildren = __webpack_require__(618);
	var warning = __webpack_require__(313);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(621);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
	  ) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(297)))

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(531),
	    _assign = __webpack_require__(306);
	
	var ReactCompositeComponent = __webpack_require__(610);
	var ReactEmptyComponent = __webpack_require__(614);
	var ReactHostComponent = __webpack_require__(615);
	
	var getNextDebugID = __webpack_require__(616);
	var invariant = __webpack_require__(310);
	var warning = __webpack_require__(313);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : _prodInvariant('130', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : void 0;
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(531),
	    _assign = __webpack_require__(306);
	
	var React = __webpack_require__(305);
	var ReactComponentEnvironment = __webpack_require__(606);
	var ReactCurrentOwner = __webpack_require__(312);
	var ReactErrorUtils = __webpack_require__(541);
	var ReactInstanceMap = __webpack_require__(607);
	var ReactInstrumentation = __webpack_require__(558);
	var ReactNodeTypes = __webpack_require__(611);
	var ReactReconciler = __webpack_require__(555);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(322);
	var invariant = __webpack_require__(310);
	var shallowEqual = __webpack_require__(612);
	var shouldUpdateReactComponent = __webpack_require__(613);
	var warning = __webpack_require__(313);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'childContext');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(531);
	
	var React = __webpack_require__(305);
	
	var invariant = __webpack_require__(310);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 612 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 613 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 614 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(531),
	    _assign = __webpack_require__(306);
	
	var invariant = __webpack_require__(310);
	
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around host tags.
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function (componentClasses) {
	    _assign(tagToComponentClass, componentClasses);
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 616 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 617 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(531);
	
	var ReactCurrentOwner = __webpack_require__(312);
	var REACT_ELEMENT_TYPE = __webpack_require__(619);
	
	var getIteratorFn = __webpack_require__(620);
	var invariant = __webpack_require__(310);
	var KeyEscapeUtils = __webpack_require__(617);
	var warning = __webpack_require__(313);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 619 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 620 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(309);
	
	var ReactCurrentOwner = __webpack_require__(312);
	
	var invariant = __webpack_require__(310);
	var warning = __webpack_require__(313);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(617);
	var traverseAllChildren = __webpack_require__(618);
	var warning = __webpack_require__(313);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(621);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(297)))

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(306);
	
	var PooledClass = __webpack_require__(546);
	var Transaction = __webpack_require__(559);
	var ReactInstrumentation = __webpack_require__(558);
	var ReactServerUpdateQueue = __webpack_require__(624);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(625);
	
	var warning = __webpack_require__(313);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(531);
	
	var ReactCurrentOwner = __webpack_require__(312);
	var ReactInstanceMap = __webpack_require__(607);
	var ReactInstrumentation = __webpack_require__(558);
	var ReactUpdates = __webpack_require__(552);
	
	var invariant = __webpack_require__(310);
	var warning = __webpack_require__(313);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(306);
	
	var emptyFunction = __webpack_require__(314);
	var warning = __webpack_require__(313);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(306);
	
	var DOMLazyTree = __webpack_require__(572);
	var ReactDOMComponentTree = __webpack_require__(530);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(531);
	
	var invariant = __webpack_require__(310);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(531),
	    _assign = __webpack_require__(306);
	
	var DOMChildrenOperations = __webpack_require__(571);
	var DOMLazyTree = __webpack_require__(572);
	var ReactDOMComponentTree = __webpack_require__(530);
	
	var escapeTextContentForBrowser = __webpack_require__(577);
	var invariant = __webpack_require__(310);
	var validateDOMNesting = __webpack_require__(626);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(306);
	
	var ReactUpdates = __webpack_require__(552);
	var Transaction = __webpack_require__(559);
	
	var emptyFunction = __webpack_require__(314);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(306);
	
	var EventListener = __webpack_require__(632);
	var ExecutionEnvironment = __webpack_require__(544);
	var PooledClass = __webpack_require__(546);
	var ReactDOMComponentTree = __webpack_require__(530);
	var ReactUpdates = __webpack_require__(552);
	
	var getEventTarget = __webpack_require__(560);
	var getUnboundedScrollPosition = __webpack_require__(633);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(314);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 633 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable === window) {
	    return {
	      x: window.pageXOffset || document.documentElement.scrollLeft,
	      y: window.pageYOffset || document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(532);
	var EventPluginHub = __webpack_require__(538);
	var EventPluginUtils = __webpack_require__(540);
	var ReactComponentEnvironment = __webpack_require__(606);
	var ReactEmptyComponent = __webpack_require__(614);
	var ReactBrowserEventEmitter = __webpack_require__(596);
	var ReactHostComponent = __webpack_require__(615);
	var ReactUpdates = __webpack_require__(552);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(306);
	
	var CallbackQueue = __webpack_require__(553);
	var PooledClass = __webpack_require__(546);
	var ReactBrowserEventEmitter = __webpack_require__(596);
	var ReactInputSelection = __webpack_require__(636);
	var ReactInstrumentation = __webpack_require__(558);
	var Transaction = __webpack_require__(559);
	var ReactUpdateQueue = __webpack_require__(625);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(637);
	
	var containsNode = __webpack_require__(639);
	var focusNode = __webpack_require__(585);
	var getActiveElement = __webpack_require__(642);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(544);
	
	var getNodeForCharacterOffset = __webpack_require__(638);
	var getTextContentAccessor = __webpack_require__(547);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 638 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(640);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(641);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 641 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 642 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 */
	function getActiveElement() /*?DOMElement*/{
	  if (typeof document === 'undefined') {
	    return null;
	  }
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 643 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(537);
	var ExecutionEnvironment = __webpack_require__(544);
	var ReactDOMComponentTree = __webpack_require__(530);
	var ReactInputSelection = __webpack_require__(636);
	var SyntheticEvent = __webpack_require__(549);
	
	var getActiveElement = __webpack_require__(642);
	var isTextInputElement = __webpack_require__(562);
	var shallowEqual = __webpack_require__(612);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(531);
	
	var EventListener = __webpack_require__(632);
	var EventPropagators = __webpack_require__(537);
	var ReactDOMComponentTree = __webpack_require__(530);
	var SyntheticAnimationEvent = __webpack_require__(646);
	var SyntheticClipboardEvent = __webpack_require__(647);
	var SyntheticEvent = __webpack_require__(549);
	var SyntheticFocusEvent = __webpack_require__(648);
	var SyntheticKeyboardEvent = __webpack_require__(649);
	var SyntheticMouseEvent = __webpack_require__(565);
	var SyntheticDragEvent = __webpack_require__(652);
	var SyntheticTouchEvent = __webpack_require__(653);
	var SyntheticTransitionEvent = __webpack_require__(654);
	var SyntheticUIEvent = __webpack_require__(566);
	var SyntheticWheelEvent = __webpack_require__(655);
	
	var emptyFunction = __webpack_require__(314);
	var getEventCharCode = __webpack_require__(650);
	var invariant = __webpack_require__(310);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(549);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(549);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(566);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(566);
	
	var getEventCharCode = __webpack_require__(650);
	var getEventKey = __webpack_require__(651);
	var getEventModifierState = __webpack_require__(568);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 650 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(650);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(565);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(566);
	
	var getEventModifierState = __webpack_require__(568);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(549);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(565);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(531);
	
	var DOMLazyTree = __webpack_require__(572);
	var DOMProperty = __webpack_require__(532);
	var React = __webpack_require__(305);
	var ReactBrowserEventEmitter = __webpack_require__(596);
	var ReactCurrentOwner = __webpack_require__(312);
	var ReactDOMComponentTree = __webpack_require__(530);
	var ReactDOMContainerInfo = __webpack_require__(657);
	var ReactDOMFeatureFlags = __webpack_require__(658);
	var ReactFeatureFlags = __webpack_require__(554);
	var ReactInstanceMap = __webpack_require__(607);
	var ReactInstrumentation = __webpack_require__(558);
	var ReactMarkupChecksum = __webpack_require__(659);
	var ReactReconciler = __webpack_require__(555);
	var ReactUpdateQueue = __webpack_require__(625);
	var ReactUpdates = __webpack_require__(552);
	
	var emptyObject = __webpack_require__(322);
	var instantiateReactComponent = __webpack_require__(609);
	var invariant = __webpack_require__(310);
	var setInnerHTML = __webpack_require__(574);
	var shouldUpdateReactComponent = __webpack_require__(613);
	var warning = __webpack_require__(313);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(626);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 658 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(660);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 660 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 661 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.4.1';

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(531);
	
	var ReactCurrentOwner = __webpack_require__(312);
	var ReactDOMComponentTree = __webpack_require__(530);
	var ReactInstanceMap = __webpack_require__(607);
	
	var getHostComponentFromComposite = __webpack_require__(663);
	var invariant = __webpack_require__(310);
	var warning = __webpack_require__(313);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(611);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(656);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extend = __webpack_require__(497);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _request2 = __webpack_require__(666);
	
	var _request3 = _interopRequireDefault(_request2);
	
	var _errors = __webpack_require__(670);
	
	var _errors2 = _interopRequireDefault(_errors);
	
	var _base = __webpack_require__(671);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _messages = __webpack_require__(503);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	* TODO: possibly move this file over to the common directory (CC)
	*/
	
	/*
	
	Usage:
	
	var service = new Service();
	
	service.execute({
	name: 'getProgress',
	apiEndpointAlias: 'signatureRequest'
	}).then(function(data) {
	
	}, catchError);
	
	*/
	
	function isValidJson(text) {
	    try {
	        JSON.parse(text);
	        return true;
	    } catch (e) {
	        return false;
	    }
	}
	
	function APIService() {
	
	    _base2['default'].apply(this, arguments);
	
	    //  makes the actual call the the API server. This method
	    //  is exposed here so that it can be stubbed out. It should not be called directly within the
	    //  app (CC)
	
	    if (!this._request) {
	        this._request = _request3['default'];
	    }
	}
	
	_base2['default'].extend(APIService, {
	
	    /**
	     */
	
	    notify: function notify(message) {
	        if (message.apiEndpointAlias != void 0 && message.type != void 0) {
	            return this.execute(message);
	        }
	    },
	
	
	    /**
	    */
	
	    execute: function execute(request) {
	
	        var type = request.type || request.name;
	        var apiEndpointAlias = request.apiEndpointAlias;
	
	        var endpoint = this.endpoints[apiEndpointAlias];
	
	        // look for an endpoint such as { signatureRequest: { getStatus() { }}}
	        if (!endpoint) {
	            throw new Error('apiEndpointAlias "' + apiEndpointAlias + '" does not exist');
	        }
	
	        // from the endpoint, pull out the mapping function. e.g: signatureRequest.getStatus
	        var mapRequestOptions = endpoint[type];
	
	        if (!mapRequestOptions) {
	            throw new Error('action "' + type + '" does not exist on "' + apiEndpointAlias + '" endpoint');
	        }
	
	        // get the information that needs to get blasted off to the server
	        var requestOptions = mapRequestOptions(request);
	
	        // some cases where requestOps is the actual request
	        var response = requestOptions.then ? requestOptions : null;
	        if (!response) {
	
	            // add cache buster to every API request.
	            // Note that some query params are strings - wanna ignore those (CC)
	            if (typeof requestOptions.query !== 'string') {
	                requestOptions.query = Object.assign({}, requestOptions.query, {
	                    _c: Date.now()
	                });
	            }
	
	            response = this._request(requestOptions).then(function (resp) {
	                if (resp.success !== false) {
	                    return Promise.resolve(resp.data || resp);
	                } else {
	                    return Promise.reject(resp.error);
	                }
	            });
	        }
	
	        if (requestOptions.transformResponse) {
	            response = response.then(requestOptions.transformResponse);
	        }
	
	        // check if handleError is false -- this maybe the case when 
	        // parts of the app needs to handle error responses from the server. Otherwise
	        // the error will be dispatched by the this object and handled by a global listener (CC)
	        if (request.handleError !== false) {
	            response['catch'](this._onRequestError.bind(this));
	        }
	
	        response.then(this._onRequestComplete.bind(this, request));
	
	        return response;
	    },
	
	
	    /**
	    */
	
	    _onRequestComplete: function _onRequestComplete(request, response) {
	        var _this = this;
	
	        // slight hack. Need to delay notification until after the requestor
	        // recieves response. (CC)
	        setTimeout(function () {
	            _this.notifier.notify(_messages.ResponseMessage.create(response, request));
	        }, 10);
	    },
	
	
	    /**
	    */
	
	    _onRequestError: function _onRequestError(error) {
	
	        // Format error
	        var ex;
	        if (error && error.crossDomain === true) {
	            // NOTE: SuperAgent returns a Cross-Domain exception when there's no network
	            // TODO: Switch to using error.xhr.statusCode
	            ex = {
	                'code': _errors2['default'].NETWORK
	            };
	        } else if (error && error.response && isValidJson(error.response.text)) {
	            try {
	                ex = JSON.parse(error.response.text);
	                ex = ex.error;
	            } catch (e) {}
	        } else {
	            ex = {
	                'code': _errors2['default'].UNKNOWN
	            };
	        }
	
	        // Merge the decoded api error into the generic error
	        // so we can access info from the api error in then/catch callbacks
	        (0, _extend2['default'])(error, ex);
	
	        // emit an error so that components & other parts of the app can update their state (CC)
	        this.notifier.notify(_messages.ErrorMessage.create(error, this));
	    }
	});
	
	/**
	*/
	
	module.exports = APIService;

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _superagent = __webpack_require__(667);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * actually makes the requests to the server
	 */
	
	module.exports = function (ops) {
	    return new Promise(function (resolve, reject) {
	
	        var method = ops.method.toLowerCase();
	
	        var r = _superagent2['default'][{
	            'delete': 'del'
	        }[method] || method](ops.url);
	
	        if (ops.form) {
	            r.type('form');
	        }
	
	        if (ops.headers) {
	            for (var key in ops.headers) {
	                r.set(key, ops.headers[key]);
	            }
	        }
	
	        if (ops.query) {
	            r.query(ops.query);
	        }
	
	        if (ops.data) {
	            r.send(ops.data);
	        }
	
	        r.end(function (err, res) {
	
	            if (err) {
	                return reject(err);
	            }
	
	            res = res.text;
	
	            try {
	                res = JSON.parse(res);
	            } catch (e) {}
	
	            resolve(res);
	        });
	    });
	};

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var Emitter = __webpack_require__(668);
	var reduce = __webpack_require__(669);
	
	/**
	 * Root reference for iframes.
	 */
	
	var root = 'undefined' == typeof window
	  ? this
	  : window;
	
	/**
	 * Noop.
	 */
	
	function noop(){};
	
	/**
	 * Check if `obj` is a host object,
	 * we don't want to serialize these :)
	 *
	 * TODO: future proof, move to compoent land
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isHost(obj) {
	  var str = {}.toString.call(obj);
	
	  switch (str) {
	    case '[object File]':
	    case '[object Blob]':
	    case '[object FormData]':
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Determine XHR.
	 */
	
	request.getXHR = function () {
	  if (root.XMLHttpRequest
	    && ('file:' != root.location.protocol || !root.ActiveXObject)) {
	    return new XMLHttpRequest;
	  } else {
	    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
	  }
	  return false;
	};
	
	/**
	 * Removes leading and trailing whitespace, added to support IE.
	 *
	 * @param {String} s
	 * @return {String}
	 * @api private
	 */
	
	var trim = ''.trim
	  ? function(s) { return s.trim(); }
	  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };
	
	/**
	 * Check if `obj` is an object.
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isObject(obj) {
	  return obj === Object(obj);
	}
	
	/**
	 * Serialize the given `obj`.
	 *
	 * @param {Object} obj
	 * @return {String}
	 * @api private
	 */
	
	function serialize(obj) {
	  if (!isObject(obj)) return obj;
	  var pairs = [];
	  for (var key in obj) {
	    if (null != obj[key]) {
	      pairs.push(encodeURIComponent(key)
	        + '=' + encodeURIComponent(obj[key]));
	    }
	  }
	  return pairs.join('&');
	}
	
	/**
	 * Expose serialization method.
	 */
	
	 request.serializeObject = serialize;
	
	 /**
	  * Parse the given x-www-form-urlencoded `str`.
	  *
	  * @param {String} str
	  * @return {Object}
	  * @api private
	  */
	
	function parseString(str) {
	  var obj = {};
	  var pairs = str.split('&');
	  var parts;
	  var pair;
	
	  for (var i = 0, len = pairs.length; i < len; ++i) {
	    pair = pairs[i];
	    parts = pair.split('=');
	    obj[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
	  }
	
	  return obj;
	}
	
	/**
	 * Expose parser.
	 */
	
	request.parseString = parseString;
	
	/**
	 * Default MIME type map.
	 *
	 *     superagent.types.xml = 'application/xml';
	 *
	 */
	
	request.types = {
	  html: 'text/html',
	  json: 'application/json',
	  xml: 'application/xml',
	  urlencoded: 'application/x-www-form-urlencoded',
	  'form': 'application/x-www-form-urlencoded',
	  'form-data': 'application/x-www-form-urlencoded'
	};
	
	/**
	 * Default serialization map.
	 *
	 *     superagent.serialize['application/xml'] = function(obj){
	 *       return 'generated xml here';
	 *     };
	 *
	 */
	
	 request.serialize = {
	   'application/x-www-form-urlencoded': serialize,
	   'application/json': JSON.stringify
	 };
	
	 /**
	  * Default parsers.
	  *
	  *     superagent.parse['application/xml'] = function(str){
	  *       return { object parsed from str };
	  *     };
	  *
	  */
	
	request.parse = {
	  'application/x-www-form-urlencoded': parseString,
	  'application/json': JSON.parse
	};
	
	/**
	 * Parse the given header `str` into
	 * an object containing the mapped fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function parseHeader(str) {
	  var lines = str.split(/\r?\n/);
	  var fields = {};
	  var index;
	  var line;
	  var field;
	  var val;
	
	  lines.pop(); // trailing CRLF
	
	  for (var i = 0, len = lines.length; i < len; ++i) {
	    line = lines[i];
	    index = line.indexOf(':');
	    field = line.slice(0, index).toLowerCase();
	    val = trim(line.slice(index + 1));
	    fields[field] = val;
	  }
	
	  return fields;
	}
	
	/**
	 * Return the mime type for the given `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	function type(str){
	  return str.split(/ *; */).shift();
	};
	
	/**
	 * Return header field parameters.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function params(str){
	  return reduce(str.split(/ *; */), function(obj, str){
	    var parts = str.split(/ *= */)
	      , key = parts.shift()
	      , val = parts.shift();
	
	    if (key && val) obj[key] = val;
	    return obj;
	  }, {});
	};
	
	/**
	 * Initialize a new `Response` with the given `xhr`.
	 *
	 *  - set flags (.ok, .error, etc)
	 *  - parse header
	 *
	 * Examples:
	 *
	 *  Aliasing `superagent` as `request` is nice:
	 *
	 *      request = superagent;
	 *
	 *  We can use the promise-like API, or pass callbacks:
	 *
	 *      request.get('/').end(function(res){});
	 *      request.get('/', function(res){});
	 *
	 *  Sending data can be chained:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' })
	 *        .end(function(res){});
	 *
	 *  Or passed to `.send()`:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' }, function(res){});
	 *
	 *  Or passed to `.post()`:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' })
	 *        .end(function(res){});
	 *
	 * Or further reduced to a single call for simple cases:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' }, function(res){});
	 *
	 * @param {XMLHTTPRequest} xhr
	 * @param {Object} options
	 * @api private
	 */
	
	function Response(req, options) {
	  options = options || {};
	  this.req = req;
	  this.xhr = this.req.xhr;
	  // responseText is accessible only if responseType is '' or 'text' and on older browsers
	  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
	     ? this.xhr.responseText
	     : null;
	  this.statusText = this.req.xhr.statusText;
	  this.setStatusProperties(this.xhr.status);
	  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
	  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
	  // getResponseHeader still works. so we get content-type even if getting
	  // other headers fails.
	  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
	  this.setHeaderProperties(this.header);
	  this.body = this.req.method != 'HEAD'
	    ? this.parseBody(this.text ? this.text : this.xhr.response)
	    : null;
	}
	
	/**
	 * Get case-insensitive `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	Response.prototype.get = function(field){
	  return this.header[field.toLowerCase()];
	};
	
	/**
	 * Set header related properties:
	 *
	 *   - `.type` the content type without params
	 *
	 * A response of "Content-Type: text/plain; charset=utf-8"
	 * will provide you with a `.type` of "text/plain".
	 *
	 * @param {Object} header
	 * @api private
	 */
	
	Response.prototype.setHeaderProperties = function(header){
	  // content-type
	  var ct = this.header['content-type'] || '';
	  this.type = type(ct);
	
	  // params
	  var obj = params(ct);
	  for (var key in obj) this[key] = obj[key];
	};
	
	/**
	 * Parse the given body `str`.
	 *
	 * Used for auto-parsing of bodies. Parsers
	 * are defined on the `superagent.parse` object.
	 *
	 * @param {String} str
	 * @return {Mixed}
	 * @api private
	 */
	
	Response.prototype.parseBody = function(str){
	  var parse = request.parse[this.type];
	  return parse && str && (str.length || str instanceof Object)
	    ? parse(str)
	    : null;
	};
	
	/**
	 * Set flags such as `.ok` based on `status`.
	 *
	 * For example a 2xx response will give you a `.ok` of __true__
	 * whereas 5xx will be __false__ and `.error` will be __true__. The
	 * `.clientError` and `.serverError` are also available to be more
	 * specific, and `.statusType` is the class of error ranging from 1..5
	 * sometimes useful for mapping respond colors etc.
	 *
	 * "sugar" properties are also defined for common cases. Currently providing:
	 *
	 *   - .noContent
	 *   - .badRequest
	 *   - .unauthorized
	 *   - .notAcceptable
	 *   - .notFound
	 *
	 * @param {Number} status
	 * @api private
	 */
	
	Response.prototype.setStatusProperties = function(status){
	  var type = status / 100 | 0;
	
	  // status / class
	  this.status = status;
	  this.statusType = type;
	
	  // basics
	  this.info = 1 == type;
	  this.ok = 2 == type;
	  this.clientError = 4 == type;
	  this.serverError = 5 == type;
	  this.error = (4 == type || 5 == type)
	    ? this.toError()
	    : false;
	
	  // sugar
	  this.accepted = 202 == status;
	  this.noContent = 204 == status || 1223 == status;
	  this.badRequest = 400 == status;
	  this.unauthorized = 401 == status;
	  this.notAcceptable = 406 == status;
	  this.notFound = 404 == status;
	  this.forbidden = 403 == status;
	};
	
	/**
	 * Return an `Error` representative of this response.
	 *
	 * @return {Error}
	 * @api public
	 */
	
	Response.prototype.toError = function(){
	  var req = this.req;
	  var method = req.method;
	  var url = req.url;
	
	  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
	  var err = new Error(msg);
	  err.status = this.status;
	  err.method = method;
	  err.url = url;
	
	  return err;
	};
	
	/**
	 * Expose `Response`.
	 */
	
	request.Response = Response;
	
	/**
	 * Initialize a new `Request` with the given `method` and `url`.
	 *
	 * @param {String} method
	 * @param {String} url
	 * @api public
	 */
	
	function Request(method, url) {
	  var self = this;
	  Emitter.call(this);
	  this._query = this._query || [];
	  this.method = method;
	  this.url = url;
	  this.header = {};
	  this._header = {};
	  this.on('end', function(){
	    var err = null;
	    var res = null;
	
	    try {
	      res = new Response(self);
	    } catch(e) {
	      err = new Error('Parser is unable to parse the response');
	      err.parse = true;
	      err.original = e;
	      return self.callback(err);
	    }
	
	    self.emit('response', res);
	
	    if (err) {
	      return self.callback(err, res);
	    }
	
	    if (res.status >= 200 && res.status < 300) {
	      return self.callback(err, res);
	    }
	
	    var new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
	    new_err.original = err;
	    new_err.response = res;
	    new_err.status = res.status;
	
	    self.callback(err || new_err, res);
	  });
	}
	
	/**
	 * Mixin `Emitter`.
	 */
	
	Emitter(Request.prototype);
	
	/**
	 * Allow for extension
	 */
	
	Request.prototype.use = function(fn) {
	  fn(this);
	  return this;
	}
	
	/**
	 * Set timeout to `ms`.
	 *
	 * @param {Number} ms
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.timeout = function(ms){
	  this._timeout = ms;
	  return this;
	};
	
	/**
	 * Clear previous timeout.
	 *
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.clearTimeout = function(){
	  this._timeout = 0;
	  clearTimeout(this._timer);
	  return this;
	};
	
	/**
	 * Abort the request, and clear potential timeout.
	 *
	 * @return {Request}
	 * @api public
	 */
	
	Request.prototype.abort = function(){
	  if (this.aborted) return;
	  this.aborted = true;
	  this.xhr.abort();
	  this.clearTimeout();
	  this.emit('abort');
	  return this;
	};
	
	/**
	 * Set header `field` to `val`, or multiple fields with one object.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .set('Accept', 'application/json')
	 *        .set('X-API-Key', 'foobar')
	 *        .end(callback);
	 *
	 *      req.get('/')
	 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
	 *        .end(callback);
	 *
	 * @param {String|Object} field
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.set = function(field, val){
	  if (isObject(field)) {
	    for (var key in field) {
	      this.set(key, field[key]);
	    }
	    return this;
	  }
	  this._header[field.toLowerCase()] = val;
	  this.header[field] = val;
	  return this;
	};
	
	/**
	 * Remove header `field`.
	 *
	 * Example:
	 *
	 *      req.get('/')
	 *        .unset('User-Agent')
	 *        .end(callback);
	 *
	 * @param {String} field
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.unset = function(field){
	  delete this._header[field.toLowerCase()];
	  delete this.header[field];
	  return this;
	};
	
	/**
	 * Get case-insensitive header `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api private
	 */
	
	Request.prototype.getHeader = function(field){
	  return this._header[field.toLowerCase()];
	};
	
	/**
	 * Set Content-Type to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.xml = 'application/xml';
	 *
	 *      request.post('/')
	 *        .type('xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 *      request.post('/')
	 *        .type('application/xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 * @param {String} type
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.type = function(type){
	  this.set('Content-Type', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Accept to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.json = 'application/json';
	 *
	 *      request.get('/agent')
	 *        .accept('json')
	 *        .end(callback);
	 *
	 *      request.get('/agent')
	 *        .accept('application/json')
	 *        .end(callback);
	 *
	 * @param {String} accept
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.accept = function(type){
	  this.set('Accept', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Authorization field value with `user` and `pass`.
	 *
	 * @param {String} user
	 * @param {String} pass
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.auth = function(user, pass){
	  var str = btoa(user + ':' + pass);
	  this.set('Authorization', 'Basic ' + str);
	  return this;
	};
	
	/**
	* Add query-string `val`.
	*
	* Examples:
	*
	*   request.get('/shoes')
	*     .query('size=10')
	*     .query({ color: 'blue' })
	*
	* @param {Object|String} val
	* @return {Request} for chaining
	* @api public
	*/
	
	Request.prototype.query = function(val){
	  if ('string' != typeof val) val = serialize(val);
	  if (val) this._query.push(val);
	  return this;
	};
	
	/**
	 * Write the field `name` and `val` for "multipart/form-data"
	 * request bodies.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .field('foo', 'bar')
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} name
	 * @param {String|Blob|File} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.field = function(name, val){
	  if (!this._formData) this._formData = new root.FormData();
	  this._formData.append(name, val);
	  return this;
	};
	
	/**
	 * Queue the given `file` as an attachment to the specified `field`,
	 * with optional `filename`.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .attach(new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} field
	 * @param {Blob|File} file
	 * @param {String} filename
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.attach = function(field, file, filename){
	  if (!this._formData) this._formData = new root.FormData();
	  this._formData.append(field, file, filename);
	  return this;
	};
	
	/**
	 * Send `data`, defaulting the `.type()` to "json" when
	 * an object is given.
	 *
	 * Examples:
	 *
	 *       // querystring
	 *       request.get('/search')
	 *         .end(callback)
	 *
	 *       // multiple data "writes"
	 *       request.get('/search')
	 *         .send({ search: 'query' })
	 *         .send({ range: '1..5' })
	 *         .send({ order: 'desc' })
	 *         .end(callback)
	 *
	 *       // manual json
	 *       request.post('/user')
	 *         .type('json')
	 *         .send('{"name":"tj"})
	 *         .end(callback)
	 *
	 *       // auto json
	 *       request.post('/user')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // manual x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send('name=tj')
	 *         .end(callback)
	 *
	 *       // auto x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // defaults to x-www-form-urlencoded
	  *      request.post('/user')
	  *        .send('name=tobi')
	  *        .send('species=ferret')
	  *        .end(callback)
	 *
	 * @param {String|Object} data
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.send = function(data){
	  var obj = isObject(data);
	  var type = this.getHeader('Content-Type');
	
	  // merge
	  if (obj && isObject(this._data)) {
	    for (var key in data) {
	      this._data[key] = data[key];
	    }
	  } else if ('string' == typeof data) {
	    if (!type) this.type('form');
	    type = this.getHeader('Content-Type');
	    if ('application/x-www-form-urlencoded' == type) {
	      this._data = this._data
	        ? this._data + '&' + data
	        : data;
	    } else {
	      this._data = (this._data || '') + data;
	    }
	  } else {
	    this._data = data;
	  }
	
	  if (!obj || isHost(data)) return this;
	  if (!type) this.type('json');
	  return this;
	};
	
	/**
	 * Invoke the callback with `err` and `res`
	 * and handle arity check.
	 *
	 * @param {Error} err
	 * @param {Response} res
	 * @api private
	 */
	
	Request.prototype.callback = function(err, res){
	  var fn = this._callback;
	  this.clearTimeout();
	  fn(err, res);
	};
	
	/**
	 * Invoke callback with x-domain error.
	 *
	 * @api private
	 */
	
	Request.prototype.crossDomainError = function(){
	  var err = new Error('Origin is not allowed by Access-Control-Allow-Origin');
	  err.crossDomain = true;
	  this.callback(err);
	};
	
	/**
	 * Invoke callback with timeout error.
	 *
	 * @api private
	 */
	
	Request.prototype.timeoutError = function(){
	  var timeout = this._timeout;
	  var err = new Error('timeout of ' + timeout + 'ms exceeded');
	  err.timeout = timeout;
	  this.callback(err);
	};
	
	/**
	 * Enable transmission of cookies with x-domain requests.
	 *
	 * Note that for this to work the origin must not be
	 * using "Access-Control-Allow-Origin" with a wildcard,
	 * and also must set "Access-Control-Allow-Credentials"
	 * to "true".
	 *
	 * @api public
	 */
	
	Request.prototype.withCredentials = function(){
	  this._withCredentials = true;
	  return this;
	};
	
	/**
	 * Initiate request, invoking callback `fn(res)`
	 * with an instanceof `Response`.
	 *
	 * @param {Function} fn
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.end = function(fn){
	  var self = this;
	  var xhr = this.xhr = request.getXHR();
	  var query = this._query.join('&');
	  var timeout = this._timeout;
	  var data = this._formData || this._data;
	
	  // store callback
	  this._callback = fn || noop;
	
	  // state change
	  xhr.onreadystatechange = function(){
	    if (4 != xhr.readyState) return;
	
	    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
	    // result in the error "Could not complete the operation due to error c00c023f"
	    var status;
	    try { status = xhr.status } catch(e) { status = 0; }
	
	    if (0 == status) {
	      if (self.timedout) return self.timeoutError();
	      if (self.aborted) return;
	      return self.crossDomainError();
	    }
	    self.emit('end');
	  };
	
	  // progress
	  try {
	    if (xhr.upload && this.hasListeners('progress')) {
	      xhr.upload.onprogress = function(e){
	        e.percent = e.loaded / e.total * 100;
	        self.emit('progress', e);
	      };
	    }
	  } catch(e) {
	    // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
	    // Reported here:
	    // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
	  }
	
	  // timeout
	  if (timeout && !this._timer) {
	    this._timer = setTimeout(function(){
	      self.timedout = true;
	      self.abort();
	    }, timeout);
	  }
	
	  // querystring
	  if (query) {
	    query = request.serializeObject(query);
	    this.url += ~this.url.indexOf('?')
	      ? '&' + query
	      : '?' + query;
	  }
	
	  // initiate request
	  xhr.open(this.method, this.url, true);
	
	  // CORS
	  if (this._withCredentials) xhr.withCredentials = true;
	
	  // body
	  if ('GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !isHost(data)) {
	    // serialize stuff
	    var serialize = request.serialize[this.getHeader('Content-Type')];
	    if (serialize) data = serialize(data);
	  }
	
	  // set header fields
	  for (var field in this.header) {
	    if (null == this.header[field]) continue;
	    xhr.setRequestHeader(field, this.header[field]);
	  }
	
	  // send stuff
	  this.emit('request', this);
	  xhr.send(data);
	  return this;
	};
	
	/**
	 * Expose `Request`.
	 */
	
	request.Request = Request;
	
	/**
	 * Issue a request:
	 *
	 * Examples:
	 *
	 *    request('GET', '/users').end(callback)
	 *    request('/users').end(callback)
	 *    request('/users', callback)
	 *
	 * @param {String} method
	 * @param {String|Function} url or callback
	 * @return {Request}
	 * @api public
	 */
	
	function request(method, url) {
	  // callback
	  if ('function' == typeof url) {
	    return new Request('GET', method).end(url);
	  }
	
	  // url first
	  if (1 == arguments.length) {
	    return new Request('GET', method);
	  }
	
	  return new Request(method, url);
	}
	
	/**
	 * GET `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.get = function(url, data, fn){
	  var req = request('GET', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.query(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * HEAD `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.head = function(url, data, fn){
	  var req = request('HEAD', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * DELETE `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.del = function(url, fn){
	  var req = request('DELETE', url);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * PATCH `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} data
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.patch = function(url, data, fn){
	  var req = request('PATCH', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * POST `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} data
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.post = function(url, data, fn){
	  var req = request('POST', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * PUT `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.put = function(url, data, fn){
	  var req = request('PUT', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * Expose `request`.
	 */
	
	module.exports = request;


/***/ },
/* 668 */
/***/ function(module, exports) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	module.exports = Emitter;
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks[event] = this._callbacks[event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  var self = this;
	  this._callbacks = this._callbacks || {};
	
	  function on() {
	    self.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks[event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks[event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks[event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks[event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ },
/* 669 */
/***/ function(module, exports) {

	
	/**
	 * Reduce `arr` with `fn`.
	 *
	 * @param {Array} arr
	 * @param {Function} fn
	 * @param {Mixed} initial
	 *
	 * TODO: combatible error handling?
	 */
	
	module.exports = function(arr, fn, initial){  
	  var idx = 0;
	  var len = arr.length;
	  var curr = arguments.length == 3
	    ? initial
	    : arr[idx++];
	
	  while (idx < len) {
	    curr = fn.call(null, curr, arr[idx], ++idx, arr);
	  }
	  
	  return curr;
	};

/***/ },
/* 670 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	    NETWORK: 'network_error', // Lost connectivity
	    CREDENTIALS: 'credentials_required', // Login required
	    VERIFY_EMAIL: 'verify_email', // Verify email step for template links
	    NOT_FOUND: 'not_found', // Resource not found
	    SIGNER_CHOICE: 'signer_choice', // Must specify which signer they are
	    NO_VALID_SIG_TYPES: 'no_valid_signature_types', // No signature type allowed due to settings
	    SERVER: 'server_error', // Generic server error
	    ACCESS_CODE_REQUIRED: 'access_code_required', // Must enter access code
	    ACCESS_CODE_INVALID: 'access_code_invalid', // Access code entered is invalid
	    ACCESS_CODE_BLOCKED: 'access_code_blocked', // Invalid access code entered too many times
	    NOTHING_TO_SIGN: 'nothing_to_sign', // Nothing to signer or already signer
	    BAD_REQUEST: 'bad_request', // Invalid request parameter(s)
	    BAD_METHOD: 'bad_method', // Unexpected HTTP method
	    UNKNOWN: 'unknown' // Unknown exception
	};

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _class = __webpack_require__(504);
	
	var _messages = __webpack_require__(503);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * BaseObject
	 */
	
	function BaseObject(properties) {
	    if (properties) {
	        this.setProperties(properties);
	    }
	}
	
	Object.assign(BaseObject.prototype, {
	
	    /**
	     * Sets properties on the object, and broadcasts a change
	     * notification if the object has changed.
	     */
	
	    setProperties: function setProperties(properties) {
	        Object.assign(this, properties);
	
	        // TODO - need to diff properties here to see if anything has actually changed (CC)
	        if (this.notifier) {
	            this.notifier.notify(_messages.ChangeMessage.create(this));
	        }
	    },
	
	
	    /**
	     * Sets one property on the object.
	     * @deprecated use setProperties() instead
	     */
	
	    set: function set(keypath, value) {
	        console.error('DEPRECATED: calling set() on object. Use setProperties instead');
	        this.setProperties(_defineProperty({}, keypath, value));
	    }
	});
	
	BaseObject.extend = _class.extend;
	BaseObject.create = _class.create;
	
	exports['default'] = BaseObject;

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _qs = __webpack_require__(673);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _serializeSignatureRequest = __webpack_require__(678);
	
	var _serializeSignatureRequest2 = _interopRequireDefault(_serializeSignatureRequest);
	
	var _mapHttpOperation = __webpack_require__(680);
	
	var _mapHttpOperation2 = _interopRequireDefault(_mapHttpOperation);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	var _superagent = __webpack_require__(667);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function makeUrl(uri) {
	    var prefix = '';
	    if (document.location && document.location.href.indexOf('/webapp_dev.php') > 0) {
	        prefix = '/webapp_dev.php';
	    }
	    return prefix + _hfReactHelper2['default'].attachSessionInfoToUrl(uri);
	} //TODO - break these endpoints out to separate files
	
	/**
	* API Mappings. These are typically used in ../routes/index.js
	*/
	
	function deserializeAPIResponseText(serialized) {
	    var deserialized = {};
	    if (serialized) {
	        try {
	            deserialized = JSON.parse(serialized.text);
	            if (deserialized.data) {
	                deserialized = deserialized.data;
	            }
	        } catch (e) {
	            console.error('Error parsing JSON response', e);
	        }
	    }
	    return deserialized;
	}
	
	/**
	* Defines the various backend APIs/endpoints that get called via XHR in the app
	*/
	
	exports['default'] = {
	    create: function create(app) {
	
	        return {
	
	            /**
	            * Signature object
	            */
	
	            // TODO: Convert insert to use new superagent helper and remove superagent require from this file
	
	            signature: {
	                insert: function insert(op) {
	                    return new Promise(function (resolve, reject) {
	
	                        var model = op.target;
	                        var url = makeUrl('/signature/upload');
	
	                        if (model.file) {
	                            _superagent2['default'].post(url).attach('qq_file', model.file, model.file.name).field('create_type_code', model.createType).field('type_code', model.type).field('ux_version', 2).field('csrf_token', app.csrfToken).end(function (err, data) {
	                                if (err) {
	                                    // we need to handle this more cleanly and display an error specific to the signature upload, potentially reusing signModal.upload.instructions.fileFormats
	                                    return reject(err);
	                                } else {
	                                    model.file = void 0;
	                                }
	                                resolve(deserializeAPIResponseText(data));
	                            });
	
	                            return;
	                        }
	
	                        var body = _qs2['default'].stringify({
	                            'create_type_code': model.createType,
	                            'type_code': model.type,
	                            'data': model.signature,
	                            'ux_version': 2,
	                            'csrf_token': app.csrfToken
	                        });
	
	                        _superagent2['default'].post(url).send(body).end(function (err, data) {
	
	                            // If we get back an error _without_ any data, we'll
	                            // treat that as a general network error and just
	                            // resolve the error itself.  However, if we get
	                            // data back, we'll deserialize it to handle
	                            // expected error cases from the server, e.g.
	                            // signatures that are too small.  Without this,
	                            // network errors in the signature modal cause all
	                            // sorts of other side effects because the app
	                            // thinks the call to /upload was successful.  This
	                            // needs to be part of the TODO refactoring listed
	                            // above.
	                            var response = !data && err ? err : deserializeAPIResponseText(data);
	
	                            resolve(response);
	                        });
	                    });
	                },
	                remove: function remove(op) {
	                    return (0, _mapHttpOperation2['default'])({
	                        'url': makeUrl('/signature/remove'),
	                        'method': 'POST',
	                        'query': {
	                            'guid': op.target.guid,
	                            'ux_version': 2,
	                            'csrf_token': app.csrfToken
	                        },
	                        transformResponse: function transformResponse() {
	                            // API doesn't give anything useful - return a blank object - this
	                            // will get ignored by the model calling it (CC)
	                            return Promise.resolve({});
	                        }
	                    });
	                },
	                rotate: function rotate(op) {
	                    return {
	                        'url': makeUrl('/signature/rotate'),
	                        'method': 'POST',
	                        'query': {
	                            'guid': op.target.guid,
	                            'ux_version': 2
	                        }
	                    };
	                },
	                markAsPrimary: function markAsPrimary(op) {
	                    return {
	                        'url': makeUrl('/signature/markAsPrimary'),
	                        'method': 'POST',
	                        'query': {
	                            'guid': op.target.guid,
	                            'ux_version': 2
	                        }
	                    };
	                },
	                edit: function edit(op) {
	
	                    var model = op.target;
	                    var type = model.type || 'S';
	
	                    return {
	                        'url': makeUrl('/signature/upload'),
	                        'method': 'POST',
	                        'data': _qs2['default'].stringify({
	                            'is_edit': true,
	                            'guid': model.guid,
	                            'create_type_code': model.createType,
	                            'type_code': type,
	                            'data': model.getEditParams(),
	                            'ux_version': 2,
	                            'csrf_token': app.csrfToken
	                        })
	                    };
	                },
	                checkEmailSignatureStatus: function checkEmailSignatureStatus(op) {
	
	                    var model = op.target;
	
	                    return {
	                        'url': makeUrl('/signature/emailSignatureStatus'),
	                        'method': 'POST',
	                        'query': {
	                            'email_guid': model.emailGuid,
	                            'ux_version': 2
	                        }
	                    };
	                }
	            },
	
	            /**
	            * Signature collection
	            */
	
	            signatures: {
	                load: function load(op) {
	                    var type = op.target.type;
	                    return {
	                        'url': makeUrl('/signature/list'),
	                        'method': 'GET',
	                        'query': {
	                            'type_code': type,
	                            'ux_version': 2
	                        }
	                    };
	                }
	            },
	
	            /**
	            */
	
	            signatureRequest: {
	                load: function load(op) {
	                    var model = op.target;
	
	                    return {
	                        'url': makeUrl('/signer/load'),
	                        'method': 'GET',
	                        'query': {
	                            'guid': model.guid,
	                            'access_code': model.accessCode,
	                            'signature_id': model.embeddedData.signatureId,
	                            'selected_signer': model.selectedSigner || void 0,
	                            'tsm_guid': model.transmissionGuid || void 0,
	                            'status_token': app.statusToken
	                        }
	                    };
	                },
	                update: function update(op) {
	
	                    var model = op.target;
	                    var data = model.toData();
	
	                    data = (0, _serializeSignatureRequest2['default'])(data);
	
	                    return (0, _mapHttpOperation2['default'])({
	                        'url': makeUrl('/signer/save'),
	                        'method': 'POST',
	                        'data': {
	                            'guid': data.guid,
	                            'data': JSON.stringify(data.data)
	                        },
	                        transformResponse: function transformResponse() {
	                            // API doesn't give anything useful - return a blank object - this
	                            // will get ignored by the model calling it (CC)
	                            return Promise.resolve({});
	                        }
	                    });
	                },
	                getSignatureRequestProgress: function getSignatureRequestProgress(op) {
	
	                    return {
	                        'url': makeUrl('/signer/ready'),
	                        'method': 'GET',
	                        'query': {
	                            'tsm_guid': op.transmissionGuid,
	                            'token': app.statusToken
	                        }
	                    };
	                },
	                decline: function decline(op) {
	
	                    var model = op.target;
	                    var data = model.toData();
	                    data = (0, _serializeSignatureRequest2['default'])(data);
	
	                    return (0, _mapHttpOperation2['default'])({
	                        'url': makeUrl('/signer/decline'),
	                        'method': 'POST',
	                        'query': {
	                            'tsm_guid': model.transmissionGuid,
	                            'access_code': model.accessCode,
	                            'decline_reason': model.declineReason,
	                            'selected_signer': model.selectedSigner
	                        },
	                        'data': {
	                            'data': JSON.stringify(data.data)
	                        },
	                        transformResponse: function transformResponse(ret) {
	
	                            if (ret.success === false) {
	                                var error = new Error('error.general.message');
	                                return Promise.reject(error);
	                            }
	
	                            return Promise.resolve(ret);
	                        }
	                    });
	                },
	                delegate: function delegate(op) {
	
	                    var model = op.target;
	                    var data = model.toData();
	                    data = (0, _serializeSignatureRequest2['default'])(data);
	
	                    return (0, _mapHttpOperation2['default'])({
	                        'url': makeUrl('/signer/delegate'),
	                        'method': 'POST',
	                        'query': {
	                            'tsm_guid': model.transmissionGuid,
	                            'access_code': model.accessCode,
	                            'new_signer_email': model.newSignerEmail,
	                            'new_signer_name': model.newSignerName,
	                            'delegate_reason': model.delegateReason
	                        },
	                        'data': {
	                            'data': JSON.stringify(data.data)
	                        },
	                        transformResponse: function transformResponse(ret) {
	
	                            if (ret.success === false) {
	                                var error = new Error('error.general.message');
	                                return Promise.reject(error);
	                            }
	
	                            return Promise.resolve(ret);
	                        }
	                    });
	                },
	                complete: function complete(op) {
	
	                    var model = op.target;
	                    var data = model.toData();
	
	                    data = (0, _serializeSignatureRequest2['default'])(data);
	
	                    return (0, _mapHttpOperation2['default'])({
	                        'url': makeUrl('/signer/finalize'),
	                        'method': 'POST',
	                        'query': {
	                            'tsm_guid': model.transmissionGuid,
	                            'access_code': model.accessCode
	                        },
	                        'data': {
	                            'data': JSON.stringify(data.data)
	                        },
	                        transformResponse: function transformResponse(ret) {
	
	                            if (ret.is_valid === false) {
	
	                                // If fields are missing, they'll be returned in the error map
	                                // listed as components
	                                var fieldsMissing = ret.error_msg_map && Object.keys(ret.error_msg_map).filter(function (key) {
	                                    return key.indexOf('component') !== -1;
	                                }).length;
	
	                                var errorType = fieldsMissing ? 'error.field.fieldsMissing' : 'error.general.message';
	                                return Promise.reject(new Error(errorType));
	                            }
	
	                            return Promise.resolve(ret);
	                        }
	                    });
	                }
	            }
	        };
	    }
	};

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(674);


/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Stringify = __webpack_require__(675);
	var Parse = __webpack_require__(677);
	
	
	// Declare internals
	
	var internals = {};
	
	
	module.exports = {
	    stringify: Stringify,
	    parse: Parse
	};


/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Utils = __webpack_require__(676);
	
	
	// Declare internals
	
	var internals = {
	    delimiter: '&',
	    arrayPrefixGenerators: {
	        brackets: function (prefix, key) {
	            return prefix + '[]';
	        },
	        indices: function (prefix, key) {
	            return prefix + '[' + key + ']';
	        },
	        repeat: function (prefix, key) {
	            return prefix;
	        }
	    }
	};
	
	
	internals.stringify = function (obj, prefix, generateArrayPrefix) {
	
	    if (Utils.isBuffer(obj)) {
	        obj = obj.toString();
	    }
	    else if (obj instanceof Date) {
	        obj = obj.toISOString();
	    }
	    else if (obj === null) {
	        obj = '';
	    }
	
	    if (typeof obj === 'string' ||
	        typeof obj === 'number' ||
	        typeof obj === 'boolean') {
	
	        return [encodeURIComponent(prefix) + '=' + encodeURIComponent(obj)];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys = Object.keys(obj);
	    for (var i = 0, il = objKeys.length; i < il; ++i) {
	        var key = objKeys[i];
	        if (Array.isArray(obj)) {
	            values = values.concat(internals.stringify(obj[key], generateArrayPrefix(prefix, key), generateArrayPrefix));
	        }
	        else {
	            values = values.concat(internals.stringify(obj[key], prefix + '[' + key + ']', generateArrayPrefix));
	        }
	    }
	
	    return values;
	};
	
	
	module.exports = function (obj, options) {
	
	    options = options || {};
	    var delimiter = typeof options.delimiter === 'undefined' ? internals.delimiter : options.delimiter;
	
	    var keys = [];
	
	    if (typeof obj !== 'object' ||
	        obj === null) {
	
	        return '';
	    }
	
	    var arrayFormat;
	    if (options.arrayFormat in internals.arrayPrefixGenerators) {
	        arrayFormat = options.arrayFormat;
	    }
	    else if ('indices' in options) {
	        arrayFormat = options.indices ? 'indices' : 'repeat';
	    }
	    else {
	        arrayFormat = 'indices';
	    }
	
	    var generateArrayPrefix = internals.arrayPrefixGenerators[arrayFormat];
	
	    var objKeys = Object.keys(obj);
	    for (var i = 0, il = objKeys.length; i < il; ++i) {
	        var key = objKeys[i];
	        keys = keys.concat(internals.stringify(obj[key], key, generateArrayPrefix));
	    }
	
	    return keys.join(delimiter);
	};


/***/ },
/* 676 */
/***/ function(module, exports) {

	// Load modules
	
	
	// Declare internals
	
	var internals = {};
	
	
	exports.arrayToObject = function (source) {
	
	    var obj = {};
	    for (var i = 0, il = source.length; i < il; ++i) {
	        if (typeof source[i] !== 'undefined') {
	
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	
	exports.merge = function (target, source) {
	
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object') {
	        if (Array.isArray(target)) {
	            target.push(source);
	        }
	        else {
	            target[source] = true;
	        }
	
	        return target;
	    }
	
	    if (typeof target !== 'object') {
	        target = [target].concat(source);
	        return target;
	    }
	
	    if (Array.isArray(target) &&
	        !Array.isArray(source)) {
	
	        target = exports.arrayToObject(target);
	    }
	
	    var keys = Object.keys(source);
	    for (var k = 0, kl = keys.length; k < kl; ++k) {
	        var key = keys[k];
	        var value = source[key];
	
	        if (!target[key]) {
	            target[key] = value;
	        }
	        else {
	            target[key] = exports.merge(target[key], value);
	        }
	    }
	
	    return target;
	};
	
	
	exports.decode = function (str) {
	
	    try {
	        return decodeURIComponent(str.replace(/\+/g, ' '));
	    } catch (e) {
	        return str;
	    }
	};
	
	
	exports.compact = function (obj, refs) {
	
	    if (typeof obj !== 'object' ||
	        obj === null) {
	
	        return obj;
	    }
	
	    refs = refs || [];
	    var lookup = refs.indexOf(obj);
	    if (lookup !== -1) {
	        return refs[lookup];
	    }
	
	    refs.push(obj);
	
	    if (Array.isArray(obj)) {
	        var compacted = [];
	
	        for (var i = 0, il = obj.length; i < il; ++i) {
	            if (typeof obj[i] !== 'undefined') {
	                compacted.push(obj[i]);
	            }
	        }
	
	        return compacted;
	    }
	
	    var keys = Object.keys(obj);
	    for (i = 0, il = keys.length; i < il; ++i) {
	        var key = keys[i];
	        obj[key] = exports.compact(obj[key], refs);
	    }
	
	    return obj;
	};
	
	
	exports.isRegExp = function (obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	
	exports.isBuffer = function (obj) {
	
	    if (obj === null ||
	        typeof obj === 'undefined') {
	
	        return false;
	    }
	
	    return !!(obj.constructor &&
	        obj.constructor.isBuffer &&
	        obj.constructor.isBuffer(obj));
	};


/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Utils = __webpack_require__(676);
	
	
	// Declare internals
	
	var internals = {
	    delimiter: '&',
	    depth: 5,
	    arrayLimit: 20,
	    parameterLimit: 1000
	};
	
	
	internals.parseValues = function (str, options) {
	
	    var obj = {};
	    var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? undefined : options.parameterLimit);
	
	    for (var i = 0, il = parts.length; i < il; ++i) {
	        var part = parts[i];
	        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;
	
	        if (pos === -1) {
	            obj[Utils.decode(part)] = '';
	        }
	        else {
	            var key = Utils.decode(part.slice(0, pos));
	            var val = Utils.decode(part.slice(pos + 1));
	
	            if (Object.prototype.hasOwnProperty(key)) {
	                continue;
	            }
	
	            if (!obj.hasOwnProperty(key)) {
	                obj[key] = val;
	            }
	            else {
	                obj[key] = [].concat(obj[key]).concat(val);
	            }
	        }
	    }
	
	    return obj;
	};
	
	
	internals.parseObject = function (chain, val, options) {
	
	    if (!chain.length) {
	        return val;
	    }
	
	    var root = chain.shift();
	
	    var obj = {};
	    if (root === '[]') {
	        obj = [];
	        obj = obj.concat(internals.parseObject(chain, val, options));
	    }
	    else {
	        var cleanRoot = root[0] === '[' && root[root.length - 1] === ']' ? root.slice(1, root.length - 1) : root;
	        var index = parseInt(cleanRoot, 10);
	        var indexString = '' + index;
	        if (!isNaN(index) &&
	            root !== cleanRoot &&
	            indexString === cleanRoot &&
	            index >= 0 &&
	            index <= options.arrayLimit) {
	
	            obj = [];
	            obj[index] = internals.parseObject(chain, val, options);
	        }
	        else {
	            obj[cleanRoot] = internals.parseObject(chain, val, options);
	        }
	    }
	
	    return obj;
	};
	
	
	internals.parseKeys = function (key, val, options) {
	
	    if (!key) {
	        return;
	    }
	
	    // The regex chunks
	
	    var parent = /^([^\[\]]*)/;
	    var child = /(\[[^\[\]]*\])/g;
	
	    // Get the parent
	
	    var segment = parent.exec(key);
	
	    // Don't allow them to overwrite object prototype properties
	
	    if (Object.prototype.hasOwnProperty(segment[1])) {
	        return;
	    }
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (segment[1]) {
	        keys.push(segment[1]);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while ((segment = child.exec(key)) !== null && i < options.depth) {
	
	        ++i;
	        if (!Object.prototype.hasOwnProperty(segment[1].replace(/\[|\]/g, ''))) {
	            keys.push(segment[1]);
	        }
	    }
	
	    // If there's a remainder, just add whatever is left
	
	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return internals.parseObject(keys, val, options);
	};
	
	
	module.exports = function (str, options) {
	
	    if (str === '' ||
	        str === null ||
	        typeof str === 'undefined') {
	
	        return {};
	    }
	
	    options = options || {};
	    options.delimiter = typeof options.delimiter === 'string' || Utils.isRegExp(options.delimiter) ? options.delimiter : internals.delimiter;
	    options.depth = typeof options.depth === 'number' ? options.depth : internals.depth;
	    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : internals.arrayLimit;
	    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : internals.parameterLimit;
	
	    var tempObj = typeof str === 'string' ? internals.parseValues(str, options) : str;
	    var obj = {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0, il = keys.length; i < il; ++i) {
	        var key = keys[i];
	        var newObj = internals.parseKeys(key, tempObj[key], options);
	        obj = Utils.merge(obj, newObj);
	    }
	
	    return Utils.compact(obj);
	};


/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _merge = __webpack_require__(519);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _fecha = __webpack_require__(679);
	
	var _fecha2 = _interopRequireDefault(_fecha);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	*/
	
	module.exports = function (data) {
	    return {
	        'data': data.snapshots.map(serializeSnapshot),
	        'guid': data.id
	    };
	};
	
	/**
	*/
	
	function serializeSnapshot(snapshot) {
	
	    var signerFields = [];
	    var groups = {};
	    var fields = snapshot.fields;
	
	    fields.forEach(function (field, i) {
	        if (field.type === 'group') {
	
	            var groupName = 'group' + i;
	            field.children.forEach(function (child) {
	                child.group = groupName;
	                signerFields.push(child);
	            });
	
	            groups[groupName] = 'required_' + (field.validate.min || 0) + '-' + (field.validate.max || 'ormore');
	        } else if (field.signer !== void 0 && field.signer !== null) {
	            signerFields.push(field);
	        }
	    });
	
	    // Ensures ordering is kept
	    signerFields = signerFields.sort(function (a, b) {
	        return a.order > b.order ? 1 : -1;
	    });
	
	    return {
	        'guid': snapshot.guid,
	        'data': signerFields.map(serializeField),
	        'signers': [],
	        'signer_names': null,
	        'order_map': null,
	        'ccs': [],
	        'groups': groups,
	        'merge_fields': []
	    };
	}
	
	/**
	*/
	
	function serializeField(field) {
	
	    var serializers = {
	        'def': serializeDefaultField,
	        'signature': serializeSignatureField,
	        'initials': serializeSignatureField,
	        'checkbox': serializeCheckboxField,
	        'date': serializeDateField,
	        'text': serializeTextField
	    };
	
	    return (0, _merge2['default'])(serializers.def(field), serializers[field.type] ? serializers[field.type](field) : {}, serializeFieldType(field));
	}
	
	/**
	*/
	
	function serializeSignatureField(field) {
	    // NOTE: The back-end expects '' when it's not been filled in
	    // see HFOverlayUtils::overlaySigOrInitials()
	    return {
	        'data': {
	            'imgSrc': field.value ? '/attachment/view?sig_guid=' + field.value : ''
	        }
	    };
	}
	
	/**
	*/
	
	function serializeCheckboxField(field) {
	    return {
	        'data': {
	            'checked': field.value || false,
	            'group': field.group
	        }
	    };
	}
	
	/**
	*/
	
	function serializeDateField(field) {
	    return {
	        'data': {
	            'fontSize': field.fontSize,
	            'content': _fecha2['default'].format(new Date(field.value), 'MM / DD / YYYY')
	        }
	    };
	}
	
	/**
	*/
	
	function serializeTextField(field) {
	    return {
	        'data': {
	            'content': field.value ? field.value.trim() : null,
	            'validation_type': field.validationType || null
	        }
	    };
	}
	
	/**
	*/
	
	function serializeDefaultField(field) {
	    return {
	        'data': {
	            'id': field.id,
	            'width': field.width,
	            'height': field.height,
	            'required': field.required,
	            'api_id': field.apiId || 'api',
	            'fontSize': field.fontSize,
	            'lineHeight': field.lineHeight,
	            'padding': field.padding
	        },
	        'x': field.x,
	        'y': field.y,
	        'z': 500
	    };
	}
	
	/**
	*/
	
	function serializeFieldType(field) {
	    return {
	        componentType: {
	            'signature': 'inputsignature',
	            'date': 'inputdate',
	            'initials': 'inputinitials',
	            'text': 'inputtextbox',
	            'checkbox': 'inputcheckmark'
	        }[field.type]
	    };
	}

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;(function (main) {
		'use strict';
	
		/**
		 * Parse or format dates
		 * @class fecha
		 */
		var fecha = {},
			token = /d{1,4}|M{1,4}|YY(?:YY)?|S{1,3}|Do|ZZ|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g,
			dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
			monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
			amPm = ['am', 'pm'],
			twoDigits = /\d\d?/, threeDigits = /\d{3}/, fourDigits = /\d{4}/,
			word = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i,
			noop = function () {},
			dayNamesShort = [], monthNamesShort = [],
			parseFlags = {
				D: [twoDigits, function (d, v) {
					d.day = v;
				}],
				M: [twoDigits, function (d, v) {
					d.month = v - 1;
				}],
				YY: [twoDigits, function (d, v) {
					var da = new Date(), cent = +('' + da.getFullYear()).substr(0, 2);
					d.year = '' + (v > 68 ? cent - 1 : cent) + v;
				}],
				h: [twoDigits, function (d, v) {
					d.hour = v;
				}],
				m: [twoDigits, function (d, v) {
					d.minute = v;
				}],
				s: [twoDigits, function (d, v) {
					d.second = v;
				}],
				YYYY: [fourDigits, function (d, v) {
					d.year = v;
				}],
				S: [/\d/, function (d, v) {
					d.millisecond = v * 100;
				}],
				SS: [/\d{2}/, function (d, v) {
					d.millisecond = v * 10;
				}],
				SSS: [threeDigits, function (d, v) {
					d.millisecond = v;
				}],
				d: [twoDigits, noop],
				ddd: [word, noop],
				MMM: [word, monthUpdate('monthNamesShort')],
				MMMM: [word, monthUpdate('monthNames')],
				a: [word, function (d, v) {
					if (amPm.indexOf(v.toLowerCase())) {
						d.isPm = true;
					}
				}],
				ZZ: [/[\+\-]\d\d:?\d\d/, function (d, v) {
					var parts = (v + '').match(/([\+\-]|\d\d)/gi), minutes;
	
					if (parts) {
						minutes = +(parts[1] * 60) + parseInt(parts[2], 10);
						d.timezoneOffset = parts[0] === '+' ? minutes : -minutes;
					}
	
				}]
			};
		parseFlags.dd = parseFlags.d;
		parseFlags.dddd = parseFlags.ddd;
		parseFlags.Do = parseFlags.DD = parseFlags.D;
		parseFlags.mm = parseFlags.m;
		parseFlags.hh = parseFlags.H = parseFlags.HH = parseFlags.h;
		parseFlags.MM = parseFlags.M;
		parseFlags.ss = parseFlags.s;
		parseFlags.A = parseFlags.a;
	
		shorten(monthNames, monthNamesShort, 3);
		shorten(dayNames, dayNamesShort, 3);
	
		function monthUpdate(arrName) {
			return function (d, v) {
				var index = fecha.i18n[arrName].indexOf(v.charAt(0).toUpperCase() + v.substr(1).toLowerCase());
				if (~index) {
					d.month = index;
				}
			}
		}
	
		function pad(val, len) {
			val = String(val);
			len = len || 2;
			while (val.length < len) {
				val = '0' + val;
			}
			return val;
		}
	
		function shorten(arr, newArr, sLen) {
			for (var i = 0, len = arr.length; i < len; i++) {
				newArr.push(arr[i].substr(0, sLen));
			}
		}
	
		function DoFn(D) {
			return D + [ 'th', 'st', 'nd', 'rd' ][ D % 10 > 3 ? 0 : (D - D % 10 !== 10) * D % 10 ];
		}
	
		fecha.i18n = {
			dayNamesShort: dayNamesShort,
			dayNames: dayNames,
			monthNamesShort: monthNamesShort,
			monthNames: monthNames,
			amPm: amPm,
			DoFn: DoFn
		};
	
		// Some common format strings
		fecha.masks = {
			'default': 'ddd MMM DD YYYY HH:mm:ss',
			shortDate: 'M/D/YY',
			mediumDate: 'MMM D, YYYY',
			longDate: 'MMMM D, YYYY',
			fullDate: 'dddd, MMMM D, YYYY',
			shortTime: 'HH:mm',
			mediumTime: 'HH:mm:ss',
			longTime: 'HH:mm:ss.SSS'
		};
	
		/***
		 * Format a date
		 * @method format
		 * @param {Date|string} dateObj
		 * @param {string} mask Format of the date, i.e. 'mm-dd-yy' or 'shortDate'
		 */
		fecha.format = function (dateObj, mask) {
			// Passing date through Date applies Date.parse, if necessary
			if (typeof dateObj === 'string') {
				dateObj = fecha.parse(dateObj);
			} else if (!dateObj) {
				dateObj = new Date();
			}
			if (isNaN(dateObj)) {
				throw new SyntaxError('invalid date');
			}
	
			mask = fecha.masks[mask] || mask || fecha.masks['default'];
	
			var D = dateObj.getDate(), d = dateObj.getDay(), M = dateObj.getMonth(), y = dateObj.getFullYear(), H = dateObj.getHours(), m = dateObj.getMinutes(), s = dateObj.getSeconds(), S = dateObj.getMilliseconds(), o = dateObj.getTimezoneOffset(), flags = {
					D: D,
					DD: pad(D),
					Do: fecha.i18n.DoFn(D),
					d: d,
					dd: pad(d),
					ddd: fecha.i18n.dayNamesShort[d],
					dddd: fecha.i18n.dayNames[d],
					M: M + 1,
					MM: pad(M + 1),
					MMM: fecha.i18n.monthNamesShort[M],
					MMMM: fecha.i18n.monthNames[M],
					YY: String(y).slice(2),
					YYYY: y,
					h: H % 12 || 12,
					hh: pad(H % 12 || 12),
					H: H,
					HH: pad(H),
					m: m,
					mm: pad(m),
					s: s,
					ss: pad(s),
					S: Math.round(S / 100),
					SS: pad(Math.round(S / 10), 2),
					SSS: pad(S, 3),
					a: H < 12 ? fecha.i18n.amPm[0] : fecha.i18n.amPm[1],
					A: H < 12 ? fecha.i18n.amPm[0].toUpperCase() : fecha.i18n.amPm[1].toUpperCase(),
					ZZ: (o > 0 ? '-' : '+') + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4)
				};
	
			return mask.replace(token, function ($0) {
				return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
			});
		};
	
		/**
		 * Parse a date string into an object, changes - into /
		 * @method parse
		 * @param {string} dateStr Date string
		 * @param {string} format Date parse format
		 * @returns {Date}
		 */
		fecha.parse = function (dateStr, format) {
			if (!format) {
				return new Date(dateStr.replace(/\-/g, '/'));
			} else {
				format = fecha.masks[format] || format;
	
				var isValid = true, dateInfo = {};
				format.replace(token, function ($0) {
					if (parseFlags[$0]) {
						var info = parseFlags[$0];
						var index = dateStr.search(info[0]);
						if (!~index) {
							isValid = false;
						} else {
							dateStr.replace(info[0], function (result) {
								info[1](dateInfo, result);
								dateStr = dateStr.substr(index + result.length);
								return result;
							});
						}
					}
	
					return parseFlags[$0] ? '' : $0.slice(1, $0.length - 1);
				});
			}
	
			if (!isValid) {
				return false;
			}
	
			var today = new Date(), date;
			if (dateInfo.isPm && dateInfo.hour) {
				dateInfo.hour = +dateInfo.hour + 12
			}
	
			if (dateInfo.timezoneOffset) {
				dateInfo.minute = +(dateInfo.minute || 0) - +dateInfo.timezoneOffset;
				date = new Date(Date.UTC(dateInfo.year || today.getFullYear(), dateInfo.month || 0, dateInfo.day || 1,
					dateInfo.hour || 0, dateInfo.minute || 0, dateInfo.second || 0, dateInfo.millisecond || 0));
			} else {
				date = new Date(dateInfo.year || today.getFullYear(), dateInfo.month || 0, dateInfo.day || 1,
					dateInfo.hour || 0, dateInfo.minute || 0, dateInfo.second || 0, dateInfo.millisecond || 0);
			}
			return date;
		};
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = fecha;
		} else if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return fecha;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			main.fecha = fecha;
		}
	})(this);


/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _qs = __webpack_require__(673);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _extend = __webpack_require__(497);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = function (operation) {
	
	    return (0, _extend2['default'])(operation, {
	
	        // is multipart form data
	        form: true,
	
	        // cache buster
	        query: _qs2['default'].stringify((0, _extend2['default'])({ c: Date.now() }, operation.query || {}), { arrayFormat: 'brackets' }),
	
	        // multipart form data
	        data: operation.data && _typeof(operation.data) === 'object' ? _qs2['default'].stringify((0, _extend2['default'])({}, operation.data, { csrf_token: getCSRFToken(operation.data || {}) }), { arrayFormat: 'brackets' }) : operation.data,
	
	        // must return an object - for now - do not return anything from API
	        transform: operation.transform || function (ret) {
	            return ret ? ret[0] || ret : void 0;
	        },
	        headers: {
	            'accept': 'application/json, text/javascript, */*'
	        }
	    });
	};
	
	function getCSRFToken(data) {
	
	    // Grab from model first...
	    if (data && data.csrf_token) {
	        return data.csrf_token;
	    }
	
	    // And fall back to global if absernt
	    var csrfTag = Array.prototype.filter.call(document.head.childNodes, function (tag) {
	        return tag.nodeName === 'META' && tag.getAttribute('name') === 'csrf-token';
	    }).pop();
	
	    if (csrfTag) return csrfTag.getAttribute('content');
	}

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _mapHttpOperation = __webpack_require__(680);
	
	var _mapHttpOperation2 = _interopRequireDefault(_mapHttpOperation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _clone(data) {
	    return data != void 0 ? JSON.parse(JSON.stringify(data)) : void 0;
	}
	
	exports['default'] = {
	    create: function create(app) {
	
	        return {
	            user: {
	                load: function load() {
	                    return Promise.resolve(_clone(app.serverSideGeneratedData.users[0]));
	                }
	            },
	            team: {
	                load: function load() {
	                    return Promise.resolve(_clone(app.serverSideGeneratedData.teams[0]));
	                },
	                update: function update(message) {
	                    return (0, _mapHttpOperation2['default'])({
	                        url: '/account/editTeamName',
	                        method: 'POST',
	                        data: {
	                            team_name: message.target.name,
	                            csrfToken: message.target.data.csrfToken
	                        }
	                    });
	                }
	            },
	            faxLines: {
	                load: function load() {
	                    return Promise.resolve(_clone(app.serverSideGeneratedData.faxLines));
	                },
	                insert: function insert(message) {
	                    return (0, _mapHttpOperation2['default'])({
	                        url: '/content/registerFaxLine',
	                        method: 'POST',
	                        data: {
	                            register_fax_line: {
	                                _csrf_token: message.target.csrfToken
	                            },
	                            fax_line_guid: message.target.guid
	                        }
	                    });
	                },
	                update: function update(message) {
	                    return (0, _mapHttpOperation2['default'])({
	                        url: '/home/updateFaxLinePermissions',
	                        method: 'POST',
	                        data: {
	                            account_guids: message.target.teamMembers.map(function (tm) {
	                                return tm.guid;
	                            }),
	                            fax_line_guid: message.target.guid
	                        }
	                    });
	                },
	                remove: function remove(message) {
	                    return (0, _mapHttpOperation2['default'])({
	                        url: '/content/removeFaxLine',
	                        method: 'POST',
	                        data: {
	                            guid: message.target.guid
	                        }
	                    });
	                }
	            },
	            teamMembers: {
	                load: function load() {
	                    // check for pagination count
	                    return Promise.resolve(_clone(app.serverSideGeneratedData.teamMembers));
	                },
	                insert: function insert(message) {
	
	                    var modelData = message.target.toData();
	
	                    // update local cache
	                    app.serverSideGeneratedData.teamMembers.push(modelData);
	
	                    return (0, _mapHttpOperation2['default'])({
	                        url: '/account/addTeamMember',
	                        method: 'POST',
	                        data: {
	                            emails: [message.target.emailAddress],
	                            csrf_token: message.target.csrfToken
	                        },
	                        transformResponse: function transformResponse(data) {
	
	                            var result = {
	                                guid: data[0].acct_guid,
	                                pending: !!data[0].pending_acceptance || data[0].pending_email_confirmation,
	                                pending_acceptance: data[0].pending_acceptance,
	                                pending_email_confirmation: data[0].pending_email_confirmation,
	                                warning: data[0].warning
	                            };
	
	                            Object.assign(modelData, result);
	
	                            return result;
	                        }
	                    });
	                },
	                update: function update(message) {
	
	                    // for role changes
	                    var pathname = {
	
	                        'ma': '/account/promoteMemberToAdmin',
	                        'md': '/account/promoteMemberToDeveloper',
	
	                        'da': '/account/promoteMemberToAdmin',
	                        'dm': '/account/demoteAdminToMember',
	
	                        'am': '/account/demoteAdminToMember',
	                        'ad': '/account/promoteMemberToDeveloper'
	
	                    }[message.target.data.roleCode + message.target.roleCode];
	
	                    // for lock changes
	                    var isLockChange = message.target.data.isLocked != message.target.isLocked;
	                    if (isLockChange) {
	                        pathname = message.target.isLocked ? '/account/lockTeamMember' : '/account/unlockTeamMember';
	                    }
	
	                    // for password reset
	                    if (message.target.shouldResetPassword) {
	                        pathname = '/account/resetPasswordTeamMember';
	                    }
	
	                    // update model
	                    var data = { isLocked: message.target.isLocked,
	                        roleCode: message.target.roleCode,
	                        shouldResetPassword: false };
	                    app.serverSideGeneratedData.teamMembers.forEach(function (record) {
	                        if (record.guid === message.target.data.guid) {
	                            Object.assign(record, data);
	                        }
	                    });
	
	                    return (0, _mapHttpOperation2['default'])({
	                        url: pathname,
	                        method: 'POST',
	                        data: {
	                            team_member_email: message.target.emailAddress,
	                            csrf_token: message.target.csrfToken
	                        }
	                    });
	                },
	                remove: function remove(message) {
	
	                    app.serverSideGeneratedData.teamMembers.forEach(function (record, i) {
	                        if (record.guid === message.target.data.guid && record.emailAddress === message.target.data.emailAddress) {
	                            app.serverSideGeneratedData.teamMembers.splice(i, 1);
	                        }
	                    });
	
	                    return (0, _mapHttpOperation2['default'])({
	                        url: '/account/removeTeamMember',
	                        method: 'POST',
	                        data: {
	                            team_member_email: message.target.emailAddress,
	                            is_invite: message.target.pending ? 1 : void 0,
	                            csrf_token: message.target.csrfToken,
	                            transfer_to_id: message.target.moveDataToAcct || null
	                        }
	                    });
	                }
	            }
	        };
	    }
	};

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _base = __webpack_require__(671);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _messages = __webpack_require__(503);
	
	var _notifiers = __webpack_require__(683);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * BaseApplication is the main entry point into the application - it initializes everything from the root component, routing,
	 * messaging systems, and so forth.
	 */
	
	function BaseApplication() {
	    var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	
	    _base2['default'].call(this, _extends({
	
	        // collection of registered notifiers throughout the application
	        notifierCollection: _notifiers.NotifierCollection.create()
	
	    }, properties));
	
	    this.notifierCollection.push(_notifiers.TypeNotifier.create(_messages.INITIALIZE, this._renderRootComponent.bind(this)));
	}
	
	_base2['default'].extend(BaseApplication, {
	
	    /**
	     */
	
	    dispose: function dispose() {
	        this._unmount();
	    },
	
	
	    /**
	     */
	
	    _unmount: function _unmount() {
	        if (!this._mounted) return;
	        this._mounted = false;
	        _reactDom2['default'].unmountComponentAtNode(this.element);
	    },
	
	
	    /**
	     * Dispatches an initialization message to the rest of the application
	     */
	
	    initialize: function initialize() {
	        this.notifierCollection.notify(_messages.InitializeMessage.create());
	        return this;
	    },
	
	
	    /**
	     * called immediately after initialization. Renders the *root* component to the element property
	     * defined in this application instance.
	     */
	
	    _renderRootComponent: function _renderRootComponent() {
	
	        if (!this.element) return;
	
	        this._unmount();
	        this._mounted = true;
	        _reactDom2['default'].render(this._createRootComponent(this._createRootComponentProps()), this.element);
	    },
	
	
	    /**
	     */
	
	    _createRootComponent: function _createRootComponent(props) {
	        return _react2['default'].createElement(this.rootComponentClass, props);
	    },
	
	
	    /**
	     */
	
	    _createRootComponentProps: function _createRootComponentProps() {
	        return _extends({}, this.rootComponentProps || {}, {
	            app: this
	        });
	    }
	});
	
	module.exports = BaseApplication;

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AttachDefaultsNotifier = exports.NotifierCollection = exports.CallbackNotifier = exports.BaseNotifier = exports.TypeNotifier = exports.noopNotifier = exports.NoopNotifier = undefined;
	
	var _noop = __webpack_require__(684);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	var _type = __webpack_require__(686);
	
	var _type2 = _interopRequireDefault(_type);
	
	var _base = __webpack_require__(685);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _callback = __webpack_require__(691);
	
	var _callback2 = _interopRequireDefault(_callback);
	
	var _collection = __webpack_require__(692);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _attachDefaults = __webpack_require__(694);
	
	var _attachDefaults2 = _interopRequireDefault(_attachDefaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.NoopNotifier = _noop2['default'];
	var noopNotifier = exports.noopNotifier = _noop2['default'].create();
	
	exports.TypeNotifier = _type2['default'];
	exports.BaseNotifier = _base2['default'];
	exports.CallbackNotifier = _callback2['default'];
	exports.NotifierCollection = _collection2['default'];
	exports.AttachDefaultsNotifier = _attachDefaults2['default'];

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _base = __webpack_require__(685);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function NoopNotifier() {}
	
	_base2['default'].extend(NoopNotifier, {
	    notify: function notify() {}
	});
	
	exports['default'] = NoopNotifier;

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _class = __webpack_require__(504);
	
	function BaseNotifier() {}
	
	(0, _class.extend)(BaseNotifier, {
	    notify: function notify() {
	        // OVERRRIDE ME
	    }
	});
	
	BaseNotifier.create = _class.create;
	BaseNotifier.extend = _class.extend;
	
	exports['default'] = BaseNotifier;

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _assert = __webpack_require__(687);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	var _base = __webpack_require__(685);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _callback = __webpack_require__(691);
	
	var _callback2 = _interopRequireDefault(_callback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function TypeNotifier(type, notifier) {
	    _assert2['default'].notEqual(type, void 0, 'type value cannot be undefined');
	
	    _base2['default'].call(this);
	
	    this.type = type;
	
	    if (typeof notifier === 'function') {
	        notifier = _callback2['default'].create(notifier);
	    }
	
	    this.notifier = notifier;
	}
	
	_base2['default'].extend(TypeNotifier, {
	    notify: function notify(message) {
	        if (message.type !== this.type) return;
	        return this.notifier.notify(message);
	    }
	});
	
	exports['default'] = TypeNotifier;

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
	// original notice:
	
	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	function compare(a, b) {
	  if (a === b) {
	    return 0;
	  }
	
	  var x = a.length;
	  var y = b.length;
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i];
	      y = b[i];
	      break;
	    }
	  }
	
	  if (x < y) {
	    return -1;
	  }
	  if (y < x) {
	    return 1;
	  }
	  return 0;
	}
	function isBuffer(b) {
	  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
	    return global.Buffer.isBuffer(b);
	  }
	  return !!(b != null && b._isBuffer);
	}
	
	// based on node assert, original notice:
	
	// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
	//
	// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
	//
	// Originally from narwhal.js (http://narwhaljs.org)
	// Copyright (c) 2009 Thomas Robinson <280north.com>
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the 'Software'), to
	// deal in the Software without restriction, including without limitation the
	// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
	// sell copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var util = __webpack_require__(688);
	var hasOwn = Object.prototype.hasOwnProperty;
	var pSlice = Array.prototype.slice;
	var functionsHaveNames = (function () {
	  return function foo() {}.name === 'foo';
	}());
	function pToString (obj) {
	  return Object.prototype.toString.call(obj);
	}
	function isView(arrbuf) {
	  if (isBuffer(arrbuf)) {
	    return false;
	  }
	  if (typeof global.ArrayBuffer !== 'function') {
	    return false;
	  }
	  if (typeof ArrayBuffer.isView === 'function') {
	    return ArrayBuffer.isView(arrbuf);
	  }
	  if (!arrbuf) {
	    return false;
	  }
	  if (arrbuf instanceof DataView) {
	    return true;
	  }
	  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
	    return true;
	  }
	  return false;
	}
	// 1. The assert module provides functions that throw
	// AssertionError's when particular conditions are not met. The
	// assert module must conform to the following interface.
	
	var assert = module.exports = ok;
	
	// 2. The AssertionError is defined in assert.
	// new assert.AssertionError({ message: message,
	//                             actual: actual,
	//                             expected: expected })
	
	var regex = /\s*function\s+([^\(\s]*)\s*/;
	// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
	function getName(func) {
	  if (!util.isFunction(func)) {
	    return;
	  }
	  if (functionsHaveNames) {
	    return func.name;
	  }
	  var str = func.toString();
	  var match = str.match(regex);
	  return match && match[1];
	}
	assert.AssertionError = function AssertionError(options) {
	  this.name = 'AssertionError';
	  this.actual = options.actual;
	  this.expected = options.expected;
	  this.operator = options.operator;
	  if (options.message) {
	    this.message = options.message;
	    this.generatedMessage = false;
	  } else {
	    this.message = getMessage(this);
	    this.generatedMessage = true;
	  }
	  var stackStartFunction = options.stackStartFunction || fail;
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, stackStartFunction);
	  } else {
	    // non v8 browsers so we can have a stacktrace
	    var err = new Error();
	    if (err.stack) {
	      var out = err.stack;
	
	      // try to strip useless frames
	      var fn_name = getName(stackStartFunction);
	      var idx = out.indexOf('\n' + fn_name);
	      if (idx >= 0) {
	        // once we have located the function frame
	        // we need to strip out everything before it (and its line)
	        var next_line = out.indexOf('\n', idx + 1);
	        out = out.substring(next_line + 1);
	      }
	
	      this.stack = out;
	    }
	  }
	};
	
	// assert.AssertionError instanceof Error
	util.inherits(assert.AssertionError, Error);
	
	function truncate(s, n) {
	  if (typeof s === 'string') {
	    return s.length < n ? s : s.slice(0, n);
	  } else {
	    return s;
	  }
	}
	function inspect(something) {
	  if (functionsHaveNames || !util.isFunction(something)) {
	    return util.inspect(something);
	  }
	  var rawname = getName(something);
	  var name = rawname ? ': ' + rawname : '';
	  return '[Function' +  name + ']';
	}
	function getMessage(self) {
	  return truncate(inspect(self.actual), 128) + ' ' +
	         self.operator + ' ' +
	         truncate(inspect(self.expected), 128);
	}
	
	// At present only the three keys mentioned above are used and
	// understood by the spec. Implementations or sub modules can pass
	// other keys to the AssertionError's constructor - they will be
	// ignored.
	
	// 3. All of the following functions must throw an AssertionError
	// when a corresponding condition is not met, with a message that
	// may be undefined if not provided.  All assertion methods provide
	// both the actual and expected values to the assertion error for
	// display purposes.
	
	function fail(actual, expected, message, operator, stackStartFunction) {
	  throw new assert.AssertionError({
	    message: message,
	    actual: actual,
	    expected: expected,
	    operator: operator,
	    stackStartFunction: stackStartFunction
	  });
	}
	
	// EXTENSION! allows for well behaved errors defined elsewhere.
	assert.fail = fail;
	
	// 4. Pure assertion tests whether a value is truthy, as determined
	// by !!guard.
	// assert.ok(guard, message_opt);
	// This statement is equivalent to assert.equal(true, !!guard,
	// message_opt);. To test strictly for the value true, use
	// assert.strictEqual(true, guard, message_opt);.
	
	function ok(value, message) {
	  if (!value) fail(value, true, message, '==', assert.ok);
	}
	assert.ok = ok;
	
	// 5. The equality assertion tests shallow, coercive equality with
	// ==.
	// assert.equal(actual, expected, message_opt);
	
	assert.equal = function equal(actual, expected, message) {
	  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
	};
	
	// 6. The non-equality assertion tests for whether two objects are not equal
	// with != assert.notEqual(actual, expected, message_opt);
	
	assert.notEqual = function notEqual(actual, expected, message) {
	  if (actual == expected) {
	    fail(actual, expected, message, '!=', assert.notEqual);
	  }
	};
	
	// 7. The equivalence assertion tests a deep equality relation.
	// assert.deepEqual(actual, expected, message_opt);
	
	assert.deepEqual = function deepEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
	  }
	};
	
	assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
	  }
	};
	
	function _deepEqual(actual, expected, strict, memos) {
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	  } else if (isBuffer(actual) && isBuffer(expected)) {
	    return compare(actual, expected) === 0;
	
	  // 7.2. If the expected value is a Date object, the actual value is
	  // equivalent if it is also a Date object that refers to the same time.
	  } else if (util.isDate(actual) && util.isDate(expected)) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3 If the expected value is a RegExp object, the actual value is
	  // equivalent if it is also a RegExp object with the same source and
	  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
	  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
	    return actual.source === expected.source &&
	           actual.global === expected.global &&
	           actual.multiline === expected.multiline &&
	           actual.lastIndex === expected.lastIndex &&
	           actual.ignoreCase === expected.ignoreCase;
	
	  // 7.4. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if ((actual === null || typeof actual !== 'object') &&
	             (expected === null || typeof expected !== 'object')) {
	    return strict ? actual === expected : actual == expected;
	
	  // If both values are instances of typed arrays, wrap their underlying
	  // ArrayBuffers in a Buffer each to increase performance
	  // This optimization requires the arrays to have the same type as checked by
	  // Object.prototype.toString (aka pToString). Never perform binary
	  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
	  // bit patterns are not identical.
	  } else if (isView(actual) && isView(expected) &&
	             pToString(actual) === pToString(expected) &&
	             !(actual instanceof Float32Array ||
	               actual instanceof Float64Array)) {
	    return compare(new Uint8Array(actual.buffer),
	                   new Uint8Array(expected.buffer)) === 0;
	
	  // 7.5 For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else if (isBuffer(actual) !== isBuffer(expected)) {
	    return false;
	  } else {
	    memos = memos || {actual: [], expected: []};
	
	    var actualIndex = memos.actual.indexOf(actual);
	    if (actualIndex !== -1) {
	      if (actualIndex === memos.expected.indexOf(expected)) {
	        return true;
	      }
	    }
	
	    memos.actual.push(actual);
	    memos.expected.push(expected);
	
	    return objEquiv(actual, expected, strict, memos);
	  }
	}
	
	function isArguments(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	}
	
	function objEquiv(a, b, strict, actualVisitedObjects) {
	  if (a === null || a === undefined || b === null || b === undefined)
	    return false;
	  // if one is a primitive, the other must be same
	  if (util.isPrimitive(a) || util.isPrimitive(b))
	    return a === b;
	  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
	    return false;
	  var aIsArgs = isArguments(a);
	  var bIsArgs = isArguments(b);
	  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
	    return false;
	  if (aIsArgs) {
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return _deepEqual(a, b, strict);
	  }
	  var ka = objectKeys(a);
	  var kb = objectKeys(b);
	  var key, i;
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length !== kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] !== kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
	      return false;
	  }
	  return true;
	}
	
	// 8. The non-equivalence assertion tests for any deep inequality.
	// assert.notDeepEqual(actual, expected, message_opt);
	
	assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
	  }
	};
	
	assert.notDeepStrictEqual = notDeepStrictEqual;
	function notDeepStrictEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
	  }
	}
	
	
	// 9. The strict equality assertion tests strict equality, as determined by ===.
	// assert.strictEqual(actual, expected, message_opt);
	
	assert.strictEqual = function strictEqual(actual, expected, message) {
	  if (actual !== expected) {
	    fail(actual, expected, message, '===', assert.strictEqual);
	  }
	};
	
	// 10. The strict non-equality assertion tests for strict inequality, as
	// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
	
	assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
	  if (actual === expected) {
	    fail(actual, expected, message, '!==', assert.notStrictEqual);
	  }
	};
	
	function expectedException(actual, expected) {
	  if (!actual || !expected) {
	    return false;
	  }
	
	  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
	    return expected.test(actual);
	  }
	
	  try {
	    if (actual instanceof expected) {
	      return true;
	    }
	  } catch (e) {
	    // Ignore.  The instanceof check doesn't work for arrow functions.
	  }
	
	  if (Error.isPrototypeOf(expected)) {
	    return false;
	  }
	
	  return expected.call({}, actual) === true;
	}
	
	function _tryBlock(block) {
	  var error;
	  try {
	    block();
	  } catch (e) {
	    error = e;
	  }
	  return error;
	}
	
	function _throws(shouldThrow, block, expected, message) {
	  var actual;
	
	  if (typeof block !== 'function') {
	    throw new TypeError('"block" argument must be a function');
	  }
	
	  if (typeof expected === 'string') {
	    message = expected;
	    expected = null;
	  }
	
	  actual = _tryBlock(block);
	
	  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
	            (message ? ' ' + message : '.');
	
	  if (shouldThrow && !actual) {
	    fail(actual, expected, 'Missing expected exception' + message);
	  }
	
	  var userProvidedMessage = typeof message === 'string';
	  var isUnwantedException = !shouldThrow && util.isError(actual);
	  var isUnexpectedException = !shouldThrow && actual && !expected;
	
	  if ((isUnwantedException &&
	      userProvidedMessage &&
	      expectedException(actual, expected)) ||
	      isUnexpectedException) {
	    fail(actual, expected, 'Got unwanted exception' + message);
	  }
	
	  if ((shouldThrow && actual && expected &&
	      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
	    throw actual;
	  }
	}
	
	// 11. Expected to throw an error:
	// assert.throws(block, Error_opt, message_opt);
	
	assert.throws = function(block, /*optional*/error, /*optional*/message) {
	  _throws(true, block, error, message);
	};
	
	// EXTENSION! This is annoying to write outside this module.
	assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
	  _throws(false, block, error, message);
	};
	
	assert.ifError = function(err) { if (err) throw err; };
	
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    if (hasOwn.call(obj, key)) keys.push(key);
	  }
	  return keys;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = process.env.NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(689);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(690);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(297)))

/***/ },
/* 689 */
/***/ function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ },
/* 690 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _base = __webpack_require__(685);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function CallbackNotifier(callback) {
	    this.callback = callback;
	}
	
	_base2['default'].extend(CallbackNotifier, {
	    notify: function notify(message) {
	        return this.callback(message);
	    }
	});
	
	exports['default'] = CallbackNotifier;

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _collection = __webpack_require__(693);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function NotifierCollection() {}
	
	_collection2['default'].extend(NotifierCollection, {
	    notify: function notify(message) {
	
	        var promises = [];
	
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = this[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var notifier = _step.value;
	
	                promises.push(notifier.notify(message));
	            }
	
	            // some notifiers might not return anything, so filter them out
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator['return']) {
	                    _iterator['return']();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        return Promise.all(promises).then(function (responses) {
	            return responses.filter(function (response) {
	                return response != void 0;
	            });
	        });
	    }
	});
	
	exports['default'] = NotifierCollection;

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _class = __webpack_require__(504);
	
	var _messages = __webpack_require__(503);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function BaseCollection(properties) {
	    var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    this.push.apply(this, _toConsumableArray(values));
	    this.setProperties(properties);
	}
	
	Object.assign(BaseCollection.prototype, {
	    setProperties: function setProperties(properties) {
	        Object.assign(this, properties);
	    },
	    push: function push() {
	        return this.splice.apply(this, [this.length, 0].concat(Array.prototype.slice.call(arguments)));
	    },
	    unshift: function unshift() {
	        return this.splice.apply(this, [0, 0].concat(Array.prototype.slice.call(arguments)));
	    },
	    shift: function shift() {
	        return this.splice(0, 1);
	    },
	    pop: function pop() {
	        return this.splice(this.length - 1, 1);
	    },
	    remove: function remove() {
	        for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
	            values[_key] = arguments[_key];
	        }
	
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var value = _step.value;
	
	                var i = this.indexOf(value);
	                if (~i) this.splice(i, 1);
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator['return']) {
	                    _iterator['return']();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	    },
	
	
	    /**
	    * all mutation methods go through here
	    */
	
	    splice: function splice() {
	        var ret = Array.prototype.splice.apply(this, arguments);
	        if (this.notifier) this.notifier.notify(_messages.ChangeMessage.create(this));
	        return ret;
	    }
	});
	
	BaseCollection.create = (0, _class.createFactory)(Array);
	BaseCollection.extend = _class.extend;
	
	// CANNOT extend array. Copy props instead
	var _iteratorNormalCompletion2 = true;
	var _didIteratorError2 = false;
	var _iteratorError2 = undefined;
	
	try {
	    for (var _iterator2 = Object.getOwnPropertyNames(Array.prototype)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	        var prop = _step2.value;
	
	        if (BaseCollection.prototype[prop]) continue;
	        var value = Array.prototype[prop];
	        if (typeof value === 'function') BaseCollection.prototype[prop] = value;
	    }
	} catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	} finally {
	    try {
	        if (!_iteratorNormalCompletion2 && _iterator2['return']) {
	            _iterator2['return']();
	        }
	    } finally {
	        if (_didIteratorError2) {
	            throw _iteratorError2;
	        }
	    }
	}
	
	BaseCollection.prototype[Symbol.iterator] = Array.prototype[Symbol.iterator];
	
	exports['default'] = BaseCollection;

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _base = __webpack_require__(685);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function AttachDefaultsNotifier(defaults, notifier) {
	    this.defaults = defaults;
	    this.notifier = notifier;
	}
	
	_base2['default'].extend(AttachDefaultsNotifier, {
	    notify: function notify(message) {
	        Object.assign(message, this.defaults, message);
	        return this.notifier.notify(message);
	    },
	    push: function push() {
	        var _notifier;
	
	        return (_notifier = this.notifier).push.apply(_notifier, arguments);
	    }
	});
	
	exports['default'] = AttachDefaultsNotifier;

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
	// You must register a React component here before calling
	// render_react_component in PHP
	// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
	
	module.exports = {
	
	  /**
	  * common components used between HS and HF
	  */
	
	  Button: __webpack_require__(696),
	  ButtonTextSubmit: __webpack_require__(698),
	  Input: __webpack_require__(699),
	  FillEmptySpace: __webpack_require__(706),
	  PeekABoo: __webpack_require__(707),
	  DropDownMenu: __webpack_require__(708),
	  MobileLinkSubmit: __webpack_require__(709),
	  Notification: __webpack_require__(711),
	  CloseFancyBoxButton: __webpack_require__(721),
	  IntegrationActivationButton: __webpack_require__(722),
	  Banner: __webpack_require__(724),
	  Tooltip: __webpack_require__(727),
	  FixedModal: __webpack_require__(728),
	  SimpleGrayLayout: __webpack_require__(762),
	
	  /**
	   * HS
	   */
	
	  AppTopBar: __webpack_require__(770),
	  AppLeftMenu: __webpack_require__(834),
	  AppFooter: __webpack_require__(836),
	  HSTeamPage: __webpack_require__(846),
	
	  TwoOptionTabPane: __webpack_require__(860),
	  StandardTabPane: __webpack_require__(862),
	
	  ApiMenu: __webpack_require__(863),
	  CodeTabPane: __webpack_require__(868),
	  CodeTabPaneWithResponse: __webpack_require__(869),
	  ImageModalTrigger: __webpack_require__(870),
	
	  CreateAccount: __webpack_require__(872),
	  LogInVerificationForm: __webpack_require__(882),
	  LogInModal: __webpack_require__(876),
	  CreateAccountTrigger: __webpack_require__(883),
	  LogInTrigger: __webpack_require__(875),
	  GoogleLoginOrSignup: __webpack_require__(874),
	  LogInForm: __webpack_require__(877),
	  VerifyEmail: __webpack_require__(884),
	  LogInInPerson: __webpack_require__(886),
	  SignUpPage: __webpack_require__(887),
	  RecoverPasswordPage: __webpack_require__(1012),
	  LogInPage: __webpack_require__(1016),
	  LogInCaptcha: __webpack_require__(881),
	
	  HomePageSignup: __webpack_require__(1024),
	  HomePageManualSignup: __webpack_require__(1025),
	  TopBarMenu: __webpack_require__(1026),
	  TopBarMenuLink: __webpack_require__(1029),
	  LogInButton: __webpack_require__(1027),
	  SignUpButton: __webpack_require__(1028),
	  CancelSubscriptionPage: __webpack_require__(1031),
	  CustomerCancelOffer: __webpack_require__(1036),
	  BlackBarAnnouncements: __webpack_require__(1042),
	
	  PricingArea: __webpack_require__(1048),
	  PaymentModal: __webpack_require__(1062),
	  PaymentPage: __webpack_require__(1087),
	  EnterpriseAgreement: __webpack_require__(1125),
	  TabbedArea: __webpack_require__(1133),
	  MarketoForm: __webpack_require__(1075),
	
	  ChooseSignupPlan: __webpack_require__(1139),
	  CollectInfo: __webpack_require__(1186),
	  TeamReporting: __webpack_require__(853)['default'],
	  DownloadPage: __webpack_require__(1191)['default'],
	
	  /**
	   * HF
	   */
	
	  FaxLineConfigList: __webpack_require__(1201),
	
	  /**
	   * Landing Pages
	   */
	  ESignatureFree: __webpack_require__(1208),
	  AutomatePaperwork: __webpack_require__(1216),
	  AutomateWorkflow: __webpack_require__(1217),
	  OnlineDigitalSignatures: __webpack_require__(1218),
	  OnlineContract: __webpack_require__(1219),
	  FreeEsignatureTool: __webpack_require__(1220),
	  SignDocumentsElectronically: __webpack_require__(1221),
	  HowCreateElectronicSignature: __webpack_require__(1222),
	  HowToSignOnline: __webpack_require__(1223),
	  OnlineSignatureApp: __webpack_require__(1224),
	  ElectronicSignature: __webpack_require__(1225),
	  DigitalSignature: __webpack_require__(1227),
	  ESignaturesSEO: __webpack_require__(1228),
	  ESignSEO: __webpack_require__(1229),
	  PDFESignatureSEO: __webpack_require__(1230),
	  Dropbox: __webpack_require__(1231),
	  Box: __webpack_require__(1251),
	  Evernote: __webpack_require__(1255),
	  OneDrive: __webpack_require__(1259),
	  EventbriteLandingPage: __webpack_require__(1263),
	  WhiteLabelingLandingPage: __webpack_require__(1271),
	  HubSpotCRMLandingPage: __webpack_require__(1523),
	  DocusignSwitch: __webpack_require__(1532),
	  CareersPage: __webpack_require__(1553),
	  Integrations: __webpack_require__(1594),
	  Salesforce: __webpack_require__(1615),
	  Oracle: __webpack_require__(1620),
	  RealEstate: __webpack_require__(1628),
	  Slack: __webpack_require__(1635),
	  Gmail: __webpack_require__(1641),
	  GoogleDrive: __webpack_require__(1647),
	  GoogleDocs: __webpack_require__(1654)
	};

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Button = _react2['default'].createClass({
	    displayName: 'Button',
	
	
	    propTypes: {
	        'buttonText': _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.array, _react2['default'].PropTypes.node]).isRequired,
	        'buttonLink': _react2['default'].PropTypes.string,
	        'buttonColor': _react2['default'].PropTypes.string,
	        'buttonHoverColor': _react2['default'].PropTypes.string,
	        'throbber': _react2['default'].PropTypes.bool,
	        'buttonTextColor': _react2['default'].PropTypes.string,
	        'buttonTextUppercase': _react2['default'].PropTypes.bool,
	        'buttonLinkUsePost': _react2['default'].PropTypes.bool,
	        'buttonLinkPostParams': _react2['default'].PropTypes.object,
	        'buttonAttrs': _react2['default'].PropTypes.object,
	        'buttonHoverTextColor': _react2['default'].PropTypes.string,
	        'buttonHoverBorderColor': _react2['default'].PropTypes.string,
	        'buttonBorderColor': _react2['default'].PropTypes.string,
	        'buttonBorderWidth': _react2['default'].PropTypes.string,
	        'buttonFont': _react2['default'].PropTypes.string,
	        'buttonClass': _react2['default'].PropTypes.string,
	        'buttonId': _react2['default'].PropTypes.string,
	        'buttonModuleClass': _react2['default'].PropTypes.string,
	        'buttonTabIndex': _react2['default'].PropTypes.any,
	        'buttonMountPoint': _react2['default'].PropTypes.string,
	        'type': _react2['default'].PropTypes.string,
	        'wrapText': _react2['default'].PropTypes.bool,
	        'buttonInner': _react2['default'].PropTypes.object,
	        'iconUri': _react2['default'].PropTypes.string,
	        'openInNewWindow': _react2['default'].PropTypes.bool,
	        'disabled': _react2['default'].PropTypes.bool
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            isProcessing: false
	        };
	    },
	    getDefaultProps: function getDefaultProps() {
	        return {
	            'buttonColor': 'ashen',
	            'buttonHoverColor': 'castle-rock',
	            'buttonTextColor': 'white',
	            'buttonTextUppercase': true,
	            'buttonModuleClass': '',
	            'buttonTabIndex': 0,
	            'type': 'button',
	            'wrapText': false,
	            'buttonLinkInNewWindow': false,
	            'iconUri': null
	        };
	    },
	    linkToLocation: function linkToLocation(evt) {
	
	        if (this.props.throbber) {
	            this.setState({ 'isProcessing': true });
	        }
	        document.location.href = this.props.buttonLink;
	
	        // TODO: don't do this - users cannot ctrl+click a link and open a new
	        // tab with this approach (CC)
	        evt.preventDefault();
	    },
	
	
	    // TODO: Button should call onClick handler instead of handling service-level calls. (CC)
	    submitAsPost: function submitAsPost(evt) {
	        evt.preventDefault();
	        var form = $(document.createElement('form')).attr('action', this.props.buttonLink).attr('method', 'POST');
	        $('body').append(form);
	        for (var i in this.props.buttonLinkPostParams) {
	            if (this.props.buttonLinkPostParams.hasOwnProperty(i)) {
	                var key = i;
	                var value = this.props.buttonLinkPostParams[i];
	            }
	            $(document.createElement('input')).attr('type', 'hidden').attr('name', key).attr('value', value).appendTo(form);
	        }
	        $(form).submit();
	    },
	    componentDidMount: function componentDidMount() {
	        if (this.props.buttonAttrs) {
	            var node = this.props.openInNewWindow ? _reactDom2['default'].findDOMNode(this).firstElementChild : _reactDom2['default'].findDOMNode(this);
	            for (var attr in this.props.buttonAttrs) {
	                node.setAttribute(attr, this.props.buttonAttrs[attr]);
	            }
	        }
	
	        if (this.props.throbber) {
	
	            // TODO: remove? No idea where this is actually coming from. This sorta functionality
	            // should be left up to the parent where the parent is setting 'isProcessing' explicitly (CC)
	            $(document).bind('cancelProcessing', function () {
	                this.setState({
	                    'isProcessing': false
	                });
	            }.bind(this));
	        }
	    },
	    render: function render() {
	        var buttonColorClass = 'bg-' + this.props.buttonColor;
	        var buttonHoverTextColorClass = this.props.buttonHoverTextColor ? 'hc-' + this.props.buttonHoverTextColor : '';
	        var buttonBorderColorClass = this.props.buttonBorderColor ? 'border-' + (this.props.buttonBorderWidth ? this.props.buttonBorderWidth : '1') + '-' + this.props.buttonBorderColor : '';
	        var buttonHoverBorderColorClass = this.props.buttonHoverBorderColor ? 'hborder-' + (this.props.buttonBorderWidth ? this.props.buttonBorderWidth : '1') + '-' + this.props.buttonHoverBorderColor : '';
	        var buttonHoverColorClass = 'hbg-' + this.props.buttonHoverColor;
	        var buttonTextColor = 'c-' + this.props.buttonTextColor;
	        var buttonTextUppercase = this.props.buttonTextUppercase ? '' : 'm-button-normalcase';
	
	        var buttonClasses = { 'm-button': true };
	
	        if (typeof this.props.className != 'undefined') {
	            buttonClasses[this.props.className] = true;
	        }
	
	        buttonClasses[buttonColorClass] = true;
	        buttonClasses[this.props.buttonModuleClass] = true;
	        buttonClasses[buttonHoverTextColorClass] = this.props.buttonHoverTextColor;
	        buttonClasses[buttonBorderColorClass] = this.props.buttonBorderColor;
	        buttonClasses[buttonHoverBorderColorClass] = this.props.buttonHoverBorderColor;
	        buttonClasses[buttonHoverColorClass] = true;
	        buttonClasses[buttonTextColor] = true;
	        buttonClasses[buttonTextUppercase] = true;
	        buttonClasses['progress-button'] = true;
	        buttonClasses['state-loading'] = true;
	
	        if (typeof this.props.buttonClass != 'undefined') {
	            buttonClasses[this.props.buttonClass] = true;
	        }
	
	        buttonClasses['with-icon'] = this.props.iconUri !== null;
	
	        var innerSpanClasses = (0, _classnames2['default'])({
	            'l-nowrap': !this.props.wrapText
	        });
	
	        var throbber;
	        var font = this.props.buttonFont ? { 'fontFamily': this.props.buttonFont } : {};
	        if (this.props.throbber) {
	            var throbberUrl = __webpack_require__(697);
	            var throbberClassName = 'm-button-throbber';
	            throbber = _react2['default'].createElement('img', { src: throbberUrl, className: throbberClassName, width: '16', height: '16' });
	        }
	
	        var inner;
	        if (this.props.buttonInner) {
	            inner = _react2['default'].createElement(
	                'span',
	                { className: innerSpanClasses, style: font },
	                this.props.buttonInner
	            );
	        } else if (this.props.iconUri) {
	            var iconUrl = _hfReactHelper2['default'].imgHelper(this.props.iconUri);
	            inner = _react2['default'].createElement(
	                'span',
	                { className: innerSpanClasses, style: font },
	                _react2['default'].createElement('img', { src: iconUrl, className: 'm-button--icon' }),
	                this.props.buttonText
	            );
	        } else {
	            inner = _react2['default'].createElement(
	                'span',
	                { className: innerSpanClasses, style: font },
	                this.props.buttonText
	            );
	        }
	
	        var hasButtonLink = this.props.buttonLink && typeof this.props.buttonLink === 'string';
	        var handlerProvided = !!(this.props.onClick || this.state.onClick);
	
	        // TODO: This has been refactored for clarity, but we still need to move the submit handler totally out of this
	        // per (CC)'s comment above (DB)
	        var onClick;
	        if (!handlerProvided) {
	            if (this.props.buttonLinkUsePost) {
	                onClick = this.submitAsPost;
	            } else if (hasButtonLink && this.props.openInNewWindow) {
	                onClick = void 0; // Use native link logic
	            } else if (hasButtonLink) {
	                onClick = this.linkToLocation; // Our specific link logic
	            }
	        } else {
	            onClick = this.props.onClick || this.state.onClick;
	        }
	
	        var btn = _react2['default'].createElement(
	            'button',
	            {
	                className: (0, _classnames2['default'])(buttonClasses),
	                onClick: onClick,
	                id: this.props.buttonId,
	                type: this.props.type,
	                disabled: this.props.disabled,
	                tabIndex: this.props.buttonTabIndex },
	            inner
	        );
	
	        if (this.props.openInNewWindow) {
	            btn = _react2['default'].createElement(
	                'a',
	                { href: this.props.buttonLink, target: '_blank', rel: 'noopener noreferrer' },
	                btn
	            );
	        }
	
	        if (this.props.throbber && this.state.isProcessing) {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'm-button-submit' },
	                throbber
	            );
	        } else {
	            return btn;
	        }
	    }
	});
	
	module.exports = Button;

/***/ },
/* 697 */
/***/ function(module, exports) {

	module.exports = "data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _input = __webpack_require__(699);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _baseForm = __webpack_require__(703);
	
	var _baseForm2 = _interopRequireDefault(_baseForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ButtonTextSubmit = _baseForm2['default'].createFormClass({
	
	    displayName: 'ButtonTextSubmit',
	
	    propTypes: {
	        'actionButton': _react2['default'].PropTypes.element.isRequired,
	        'initialValue': _react2['default'].PropTypes.string,
	        'textPlaceholder': _react2['default'].PropTypes.string,
	        'textClass': _react2['default'].PropTypes.string,
	        'inputName': _react2['default'].PropTypes.string,
	        'additionalFormData': _react2['default'].PropTypes.object,
	        'validate': _react2['default'].PropTypes.func,
	        'initialErrorMessage': _react2['default'].PropTypes.string,
	        'errorClass': _react2['default'].PropTypes.string,
	        'divClass': _react2['default'].PropTypes.string,
	        'url': _react2['default'].PropTypes.string.isRequired,
	        'formName': _react2['default'].PropTypes.string.isRequired,
	        'initiallyShowField': _react2['default'].PropTypes.bool,
	        'tabOffset': _react2['default'].PropTypes.number
	    },
	
	    onSubmit: function onSubmit(evt) {
	        // always validate before acting
	        evt.preventDefault();
	        var isValid = this.doValidation();
	        if (!isValid) {
	            return false;
	        }
	
	        this.setState({
	            'isSending': true,
	            'inputError': false
	        });
	
	        if (this.props.additionalFormData) {
	            for (var key in this.props.additionalFormData) {
	                var input = $('<input>').attr('type', 'hidden').attr('key', key).attr('name', key).val(this.props.additionalFormData[key]);
	                $(document.forms[name = this.props.formName]).append($(input));
	            }
	        }
	
	        document.forms[name = this.props.formName].submit();
	
	        return false;
	    },
	    getInitialState: function getInitialState() {
	        return {
	            isSending: false,
	            inputError: false,
	            errorMessage: this.props.initialErrorMessage
	        };
	    },
	    handleKeyDown: function handleKeyDown(evt) {
	        this.setState({ inputError: false, errorMessage: null });
	        if (evt.keyCode == 13) {
	            return this.onSubmit();
	        }
	    },
	    handleTextInput: function handleTextInput(value) {
	        this.setState({ text: value.trim() });
	    },
	    handleOnBlur: function handleOnBlur() {
	        if (typeof this.state.text !== 'undefined') {
	            this.doValidation();
	        }
	    },
	    doValidation: function doValidation() {
	        //FIXME: should probably move validation down into the Input component
	        if (this.props.validate) {
	            var inputError = this.props.validate(this.state.text);
	            if (inputError) {
	                this.setState({ inputError: inputError !== false, errorMessage: inputError });
	                return false;
	            }
	        }
	        return true;
	    },
	    render: function render() {
	
	        var tabOffset = parseInt(this.props.tabOffset || 0, 10);
	
	        var divClasses = {
	            'm-button-submit': true,
	            'is-active': true
	        };
	        divClasses[this.props.divClass] = true;
	        var standardInput = _react2['default'].createElement(_input2['default'], {
	            ref: 'textEntry',
	            inputName: this.props.inputName,
	            handleChange: this.handleTextInput,
	            className: this.props.textClass,
	            defaultValue: this.props.initialValue,
	            placeholder: this.props.textPlaceholder,
	            onBlur: this.handleOnBlur,
	            onKeyDown: this.handleKeyDown,
	            disabled: this.state.isSending,
	            error: this.state.inputError,
	            errorClass: this.props.errorClass,
	            errorMessage: this.state.errorMessage,
	            tabIndex: tabOffset });
	
	        divClasses = (0, _classnames2['default'])(divClasses);
	
	        var newBtnProps = {
	            'onClick': this.onSubmit,
	            'disabled': this.state.isSending
	        };
	        if (this.state.isSending) {
	            newBtnProps.buttonText = 'Sending';
	        }
	        var btn = _react2['default'].cloneElement(this.props.actionButton, newBtnProps);
	
	        return _react2['default'].createElement(
	            'form',
	            { name: this.props.formName, method: 'POST', action: this.props.url },
	            _react2['default'].createElement(
	                'div',
	                { className: divClasses },
	                this.renderCsrfField(),
	                standardInput,
	                btn,
	                this.props.children
	            )
	        );
	    }
	});
	module.exports = ButtonTextSubmit;

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(700);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Input = _react2['default'].createClass({
	    displayName: 'Input',
	
	    propTypes: {
	        autoFocus: _react2['default'].PropTypes.bool,
	        defaultValue: _react2['default'].PropTypes.string,
	        placeholder: _react2['default'].PropTypes.string,
	        className: _react2['default'].PropTypes.string,
	        inputName: _react2['default'].PropTypes.string,
	        error: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.bool]),
	        errorMessage: _react2['default'].PropTypes.string,
	        errorClass: _react2['default'].PropTypes.string,
	        handleChange: _react2['default'].PropTypes.func,
	        onKeyDown: _react2['default'].PropTypes.func,
	        onBlur: _react2['default'].PropTypes.func,
	        onFocus: _react2['default'].PropTypes.func,
	        disabled: _react2['default'].PropTypes.bool,
	        type: _react2['default'].PropTypes.string,
	        value: _react2['default'].PropTypes.string
	    },
	    getDefaultProps: function getDefaultProps() {
	        return {
	            disabled: false,
	            errorClass: 'c-red',
	            type: 'text'
	        };
	    },
	    getInitialState: function getInitialState() {
	        return { error: false };
	    },
	    handleChange: function handleChange(event) {
	        this.props.handleChange(event.target.value, event);
	    },
	    setDisabled: function setDisabled(val) {
	        this.props.disabled = val;
	    },
	    setErrorMessage: function setErrorMessage(val) {
	        if (typeof val === 'string') {
	            this.props.errorMessage = val;
	        }
	    },
	    render: function render() {
	        var _React$createElement;
	
	        var errorMsg = '';
	
	        var divClasses = {
	            'm-input': true,
	            'm-input-error': this.props.error
	        };
	        divClasses[this.props.className] = this.props.className;
	        divClasses = (0, _classnames2['default'])(divClasses);
	        if (this.props.errorMessage) {
	            var errorDivClasses = {
	                'm-input-error-message': true
	            };
	            if (this.props.errorClass) {
	                errorDivClasses[this.props.errorClass] = true;
	            }
	            errorDivClasses = (0, _classnames2['default'])(errorDivClasses);
	
	            errorMsg = _react2['default'].createElement(
	                'div',
	                { className: 'm-input-error' },
	                _react2['default'].createElement('img', { src: __webpack_require__(702), className: 'm-input-error-message-img' }),
	                _react2['default'].createElement(
	                    'p',
	                    { className: errorDivClasses },
	                    this.props.errorMessage
	                )
	            );
	        }
	
	        return _react2['default'].createElement(
	            'div',
	            { className: divClasses },
	            _react2['default'].createElement('input', (_React$createElement = { type: 'text',
	                autoFocus: this.props.autoFocus,
	                name: this.props.inputName,
	                className: 'm-input-text',
	                maxLength: '99',
	                placeholder: this.props.placeholder,
	                disabled: this.props.disabled,
	                onFocus: this.props.onFocus,
	                onBlur: this.props.onBlur,
	                onKeyDown: this.props.onKeyDown,
	                onChange: this.handleChange,
	                defaultValue: this.props.defaultValue,
	                tabIndex: this.props.tabIndex || 0
	            }, _defineProperty(_React$createElement, 'type', this.props.type), _defineProperty(_React$createElement, 'value', this.props.value), _React$createElement)),
	            errorMsg
	        );
	    }
	});
	module.exports = Input;

/***/ },
/* 700 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 701 */,
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/ff705ca1b25f00d4851c0160fd9c08dc.png";

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(704);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var FormHiddenField = _react2['default'].createClass({
	    displayName: 'FormHiddenField',
	
	
	    propTypes: {
	        'name': _react2['default'].PropTypes.string,
	        'value': _react2['default'].PropTypes.string
	    },
	
	    render: function render() {
	        // Cannot pass null to React input fields. Either pass in undefined for
	        // uncontrolled components or an empty string for controlled components
	        var value = this.props.value || undefined;
	
	        return _react2['default'].createElement('input', { type: 'hidden', name: this.props.name, value: value });
	    }
	});
	
	var FormField = _react2['default'].createClass({
	    displayName: 'FormField',
	
	
	    propTypes: {
	        'type': _react2['default'].PropTypes.string.isRequired,
	        'name': _react2['default'].PropTypes.string.isRequired,
	        'value': _react2['default'].PropTypes.string,
	        'attributes': _react2['default'].PropTypes.object,
	        'options': _react2['default'].PropTypes.object
	    },
	
	    // Populates <option> children for a select element
	    // Assumes that the data coming from Symfony is formatted as either:
	    // type 'select': [value,value,value] (array index is value)
	    // type 'hfwidgetformchoice': [{ value: value, label: label},...]
	    // Use the latter when you need to preserve the ordering of the list
	    generateSelectOptions: function generateSelectOptions() {
	        var options = [];
	        var choices = void 0,
	            choicesAsOrderedObjects = void 0;
	        if (this.props.type === 'hfwidgetformchoice') {
	            choices = this.props.options.ordered_choices;
	            choicesAsOrderedObjects = true;
	        } else {
	            choices = this.props.options.choices;
	        }
	
	        if (choices) {
	            options = choices.map(function (item, index) {
	                var value = void 0,
	                    label = void 0;
	                if (choicesAsOrderedObjects) {
	                    value = item.value;
	                    label = item.label;
	                } else {
	                    value = index;
	                    label = item;
	                }
	
	                return _react2['default'].createElement(
	                    'option',
	                    { key: 'option-value-' + index, value: value },
	                    label
	                );
	            });
	        }
	        return options;
	    },
	    render: function render() {
	
	        var tag;
	        var children;
	        var attrs = this.props.attributes || {};
	
	        switch (this.props.type) {
	
	            case 'input':
	                attrs.type = 'text';
	                // Cannot pass null to React input fields. Either pass in undefined for
	                // uncontrolled components or an empty string for controlled components
	                attrs.value = attrs.value || this.props.value || undefined;
	                attrs.name = this.props.name;
	                tag = _react2['default'].DOM.input;
	                break;
	
	            case 'inputcheckbox':
	                attrs.type = 'checkbox';
	                attrs.checked = attrs.checked || (this.props.value ? 'checked' : undefined);
	                attrs.name = this.props.name;
	                tag = _react2['default'].DOM.input;
	                break;
	
	            case 'inputfile':
	                attrs.type = 'file';
	                attrs.value = attrs.value || this.props.value;
	                attrs.name = this.props.name;
	                tag = _react2['default'].DOM.input;
	                break;
	
	            case 'inputpassword':
	                attrs.type = 'password';
	                // Cannot pass null to React input fields. Either pass in undefined for
	                // uncontrolled components or an empty string for controlled components
	                attrs.value = attrs.value || this.props.value || undefined;
	                attrs.name = this.props.name;
	                tag = _react2['default'].DOM.input;
	                break;
	
	            case 'select':
	            case 'hfwidgetformchoice':
	            case 'selectmany':
	                attrs.value = attrs.value || this.props.value || undefined;
	                attrs.name = this.props.name;
	                if (this.props.type == 'selectmany') {
	                    attrs.multiple = 'multiple';
	                }
	                children = this.generateSelectOptions();
	                tag = _react2['default'].DOM.select;
	                break;
	
	            case 'selectradio':
	                attrs.type = 'radio';
	                attrs.value = attrs.value || this.props.value;
	                attrs.name = this.props.name;
	                tag = _react2['default'].DOM.input;
	                break;
	
	            case 'textarea':
	                // Cannot pass null to React textarea fields. Either pass in
	                // undefined for uncontrolled components or an empty string for
	                // controlled components
	                attrs.value = attrs.value || this.props.value || undefined;
	                attrs.name = this.props.name;
	                tag = _react2['default'].DOM.textarea;
	                break;
	
	            default:
	                throw new Error('Form field type not supported: ' + this.props.type);
	
	        }
	
	        return tag(attrs, children); // Tag function is selected from ReactDOM above
	    }
	});
	
	var BaseFormSpecs = {
	
	    displayName: 'CustomForm',
	
	    propTypes: {
	        'name': _react2['default'].PropTypes.string, // Form name
	        'method': _react2['default'].PropTypes.string, // Form method (POST, GET, ...)
	        'action': _react2['default'].PropTypes.string, // Form target
	        'fields': _react2['default'].PropTypes.array, // name => field info
	        'values': _react2['default'].PropTypes.object, // name => value
	        'errors': _react2['default'].PropTypes.object, // { 'global': [...], 'named': { name => message } }
	        'namespace': _react2['default'].PropTypes.string // Namespace pattern for field names
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            'errors': this.props.errors,
	            'hasErrors': this.props.errors && (this.props.errors.global || this.props.errors.named)
	        };
	    },
	    getFieldName: function getFieldName(field) {
	        if (field) {
	            var token = (field.options ? field.options.id_format : undefined) || '%s';
	            return this.props.namespace.replace(token, field.name);
	        }
	    },
	    getFieldValue: function getFieldValue(field) {
	        var v = this.props.values ? this.props.values[field.name] : undefined;
	        if (v === undefined && field['default']) {
	            v = field['default'];
	        }
	        return v;
	    },
	
	
	    /**
	        Grabs the user-entered value using the React refs for the field
	        @param string fieldname - the non-namespaced name of the field
	        @return mixed | undefined;
	    */
	    getDOMValueForFieldname: function getDOMValueForFieldname(fieldname) {
	
	        var field = void 0,
	            value = void 0;
	
	        var filtered = this.props.fields.filter(function (field) {
	            return field.name === fieldname;
	        });
	        if (filtered.length > 0) {
	            field = filtered[0];
	        }
	
	        if (field) {
	            var namespacedName = this.getFieldName(field);
	            var node = _reactDom2['default'].findDOMNode(this.refs[namespacedName]);
	            if (node) {
	                if (node.type === 'checkbox') {
	                    value = node.checked;
	                } else {
	                    value = node.value;
	                }
	            }
	        }
	        return value;
	    },
	    renderHiddenFields: function renderHiddenFields() {
	
	        var hiddenFields = [];
	        var k;
	        var v;
	        var t;
	        var field;
	
	        // Render hidden input fields
	        // FIXME: calling "in" operator on array. This will break with es5 shims (CC)
	        for (k in this.props.fields) {
	            field = this.props.fields[k];
	            if (field && field.options.is_hidden) {
	                v = this.getFieldValue(field);
	                t = parseInt(Math.random() * Math.pow(10, 6), 10);
	                hiddenFields.push(_react2['default'].createElement(FormHiddenField, { key: 'hidden-field-' + t, name: this.getFieldName(field), value: v }));
	            }
	        }
	
	        return hiddenFields;
	    },
	    renderCsrfField: function renderCsrfField() {
	
	        var k;
	        var v;
	        var field;
	
	        // FIXME: calling "in" operator on array. This will break with es5 shims (CC)
	        for (k in this.props.fields) {
	            field = this.props.fields[k];
	            if (field && field.name === _hfReactHelper2['default'].HfConstants.csrfFieldName) {
	                v = this.getFieldValue(field);
	                return _react2['default'].createElement(FormHiddenField, { name: this.getFieldName(field), value: v });
	            }
	        }
	    },
	    renderField: function renderField(name, attributes) {
	        if (this.props.fields) {
	
	            var field;
	            var k;
	
	            for (k in this.props.fields) {
	                if (this.props.fields[k] && this.props.fields[k].name === name) {
	                    field = this.props.fields[k];
	                    break;
	                }
	            }
	
	            if (field) {
	
	                if (field.attributes) {
	                    // Rewrite some of the attributes to deal with React
	                    for (k in field.attributes) {
	                        if (k === 'class') {
	                            field.attributes.className = field.attributes['class'];
	                            delete field.attributes['class'];
	                        }
	                    }
	                }
	
	                var v = this.getFieldValue(field);
	
	                return _react2['default'].createElement(FormField, {
	                    name: this.getFieldName(field),
	                    ref: this.getFieldName(field),
	                    type: field.type,
	                    value: v,
	                    options: field.options,
	                    attributes: attributes });
	            }
	        }
	    },
	    renderErrorText: function renderErrorText() {
	        if (this.state.errors) {
	            if (this.state.errors.global) {
	                return _react2['default'].createElement(
	                    'p',
	                    null,
	                    this.state.errors.global
	                );
	            } else if (this.state.errors.named) {
	                var errs = [];
	                for (var k in this.state.errors.named) {
	                    if (this.state.errors.named[k]) {
	                        errs.push(_react2['default'].createElement(
	                            'p',
	                            { key: 'error-' + k },
	                            this.state.errors.named[k]
	                        ));
	                    }
	                }
	                return errs;
	            }
	        }
	    },
	    renderFormTag: function renderFormTag(formContent) {
	        return _react2['default'].createElement(
	            'form',
	            { name: this.props.name, method: this.props.method, action: this.props.action },
	            formContent
	        );
	    },
	    getFormData: function getFormData() {
	        // Should be implemented by the actual form component
	        return null;
	    },
	    submitAsync: function submitAsync(okCallback, errCallback) {
	
	        var data = this.getFormData();
	
	        if (data === null) {
	            data = {};
	            $('input, select, textarea', _reactDom2['default'].findDOMNode(this)).each(function () {
	                var el = $(this);
	                var name = el.attr('name');
	                if (name) {
	                    if (el.attr('type') === 'checkbox') {
	                        var isChecked = false;
	                        if (typeof el.prop === 'function') {
	                            if (el.prop('checked')) {
	                                isChecked = true;
	                            }
	                        } else if (el.attr('checked') === 'checked' || el.attr('checked') === true) {
	                            isChecked = true;
	                        }
	                        data[name] = isChecked;
	                    } else {
	                        data[name] = el.val();
	                    }
	                }
	            });
	        }
	
	        $.ajax({
	            'context': this,
	            'url': this.props.action,
	            'type': this.props.method || 'POST',
	            'dataType': 'json',
	            'data': data,
	            'success': okCallback,
	            'error': errCallback
	        });
	    }
	};
	
	exports.createFormClass = function () {
	    var specs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	
	    // Copy to prevent the original from being altered
	    var baseSpecs = (0, _lodash.extend)({}, BaseFormSpecs);
	
	    if (specs.getInitialState) {
	        var baseGetInitialStates = baseSpecs.getInitialState;
	        var extGetInitialStates = specs.getInitialState;
	        specs.getInitialState = function () {
	            var baseStates = baseGetInitialStates.call(this);
	            var extStates = extGetInitialStates.call(this);
	            return (0, _lodash.extend)(baseStates, extStates);
	        };
	    }
	
	    if (specs.propTypes) {
	        var basePropTypes = (0, _lodash.extend)({}, baseSpecs.propTypes); // Copy
	        specs.propTypes = (0, _lodash.extend)(basePropTypes, specs.propTypes);
	    }
	
	    var comp = _react2['default'].createClass((0, _lodash.extend)(baseSpecs, specs));
	
	    return comp;
	};

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * @license
	 * lodash 3.10.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern -d -o ./index.js`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '3.10.0';
	
	  /** Used to compose bitmasks for wrapper metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      ARY_FLAG = 128,
	      REARG_FLAG = 256;
	
	  /** Used as default options for `_.trunc`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect when a function becomes hot. */
	  var HOT_COUNT = 150,
	      HOT_SPAN = 16;
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2;
	
	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      weakMapTag = '[object WeakMap]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
	      reUnescapedHtml = /[&<>"'`]/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	
	  /**
	   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
	   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
	   */
	  var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,
	      reHasRegExpChars = RegExp(reRegExpChars.source);
	
	  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
	  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect hexadecimal string values. */
	  var reHasHexPrefix = /^0[xX]/;
	
	  /** Used to detect host constructors (Safari > 5). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^\d+$/;
	
	  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
	  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to match words to create compound words. */
	  var reWords = (function() {
	    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
	        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';
	
	    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
	  }());
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
	    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'isFinite',
	    'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
	  cloneableTags[dateTag] = cloneableTags[float32Tag] =
	  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
	  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[stringTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[mapTag] = cloneableTags[setTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map latin-1 supplementary letters to basic latin letters. */
	  var deburredLetters = {
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '`': '&#96;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'",
	    '&#96;': '`'
	  };
	
	  /** Used to determine if values are of the language type `Object`. */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };
	
	  /** Used to escape characters for inclusion in compiled regexes. */
	  var regexpEscapes = {
	    '0': 'x30', '1': 'x31', '2': 'x32', '3': 'x33', '4': 'x34',
	    '5': 'x35', '6': 'x36', '7': 'x37', '8': 'x38', '9': 'x39',
	    'A': 'x41', 'B': 'x42', 'C': 'x43', 'D': 'x44', 'E': 'x45', 'F': 'x46',
	    'a': 'x61', 'b': 'x62', 'c': 'x63', 'd': 'x64', 'e': 'x65', 'f': 'x66',
	    'n': 'x6e', 'r': 'x72', 't': 'x74', 'u': 'x75', 'v': 'x76', 'x': 'x78'
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Detect free variable `exports`. */
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = objectTypes[typeof self] && self && self.Object && self;
	
	  /** Detect free variable `window`. */
	  var freeWindow = objectTypes[typeof window] && window && window.Object && window;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;
	
	  /**
	   * Used as a reference to the global object.
	   *
	   * The `this` value is used if it's the global object to avoid Greasemonkey's
	   * restricted `window` object, otherwise the `window` object is used.
	   */
	  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * The base implementation of `compareAscending` which compares values and
	   * sorts them in ascending order without guaranteeing a stable sort.
	   *
	   * @private
	   * @param {*} value The value to compare.
	   * @param {*} other The other value to compare.
	   * @returns {number} Returns the sort order indicator for `value`.
	   */
	  function baseCompareAscending(value, other) {
	    if (value !== other) {
	      var valIsNull = value === null,
	          valIsUndef = value === undefined,
	          valIsReflexive = value === value;
	
	      var othIsNull = other === null,
	          othIsUndef = other === undefined,
	          othIsReflexive = other === other;
	
	      if ((value > other && !othIsNull) || !valIsReflexive ||
	          (valIsNull && !othIsUndef && othIsReflexive) ||
	          (valIsUndef && othIsReflexive)) {
	        return 1;
	      }
	      if ((value < other && !valIsNull) || !othIsReflexive ||
	          (othIsNull && !valIsUndef && valIsReflexive) ||
	          (othIsUndef && valIsReflexive)) {
	        return -1;
	      }
	    }
	    return 0;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromRight) {
	    var length = array.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without support for binary searches.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    if (value !== value) {
	      return indexOfNaN(array, fromIndex);
	    }
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isFunction` without support for environments
	   * with incorrect `typeof` results.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	   */
	  function baseIsFunction(value) {
	    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
	    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
	    return typeof value == 'function' || false;
	  }
	
	  /**
	   * Converts `value` to a string if it's not one. An empty string is returned
	   * for `null` or `undefined` values.
	   *
	   * @private
	   * @param {*} value The value to process.
	   * @returns {string} Returns the string.
	   */
	  function baseToString(value) {
	    return value == null ? '' : (value + '');
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the first character not found in `chars`.
	   */
	  function charsLeftIndex(string, chars) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the last character not found in `chars`.
	   */
	  function charsRightIndex(string, chars) {
	    var index = string.length;
	
	    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.sortBy` to compare transformed elements of a collection and stable
	   * sort them in ascending order.
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareAscending(object, other) {
	    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
	  }
	
	  /**
	   * Used by `_.sortByOrder` to compare multiple properties of a value to another
	   * and stable sort them.
	   *
	   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
	   * a value is sorted in ascending order if its corresponding order is "asc", and
	   * descending if "desc".
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @param {boolean[]} orders The order to sort by for each property.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareMultiple(object, other, orders) {
	    var index = -1,
	        objCriteria = object.criteria,
	        othCriteria = other.criteria,
	        length = objCriteria.length,
	        ordersLength = orders.length;
	
	    while (++index < length) {
	      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
	      if (result) {
	        if (index >= ordersLength) {
	          return result;
	        }
	        var order = orders[index];
	        return result * ((order === 'asc' || order === true) ? 1 : -1);
	      }
	    }
	    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	    // that causes it, under certain circumstances, to provide the same value for
	    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	    // for more details.
	    //
	    // This also ensures a stable sort in V8 and other engines.
	    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
	    return object.index - other.index;
	  }
	
	  /**
	   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  function deburrLetter(letter) {
	    return deburredLetters[letter];
	  }
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeHtmlChar(chr) {
	    return htmlEscapes[chr];
	  }
	
	  /**
	   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @param {string} leadingChar The capture group for a leading character.
	   * @param {string} whitespaceChar The capture group for a whitespace character.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
	    if (leadingChar) {
	      chr = regexpEscapes[chr];
	    } else if (whitespaceChar) {
	      chr = stringEscapes[chr];
	    }
	    return '\\' + chr;
	  }
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the index at which the first occurrence of `NaN` is found in `array`.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	   */
	  function indexOfNaN(array, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 0 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var other = array[index];
	      if (other !== other) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * Checks if `value` is object-like.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	   */
	  function isObjectLike(value) {
	    return !!value && typeof value == 'object';
	  }
	
	  /**
	   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
	   * character code is whitespace.
	   *
	   * @private
	   * @param {number} charCode The character code to inspect.
	   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
	   */
	  function isSpace(charCode) {
	    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
	      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      if (array[index] === placeholder) {
	        array[index] = PLACEHOLDER;
	        result[++resIndex] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * An implementation of `_.uniq` optimized for sorted arrays without support
	   * for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} [iteratee] The function invoked per iteration.
	   * @returns {Array} Returns the new duplicate-value-free array.
	   */
	  function sortedUniq(array, iteratee) {
	    var seen,
	        index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index],
	          computed = iteratee ? iteratee(value, index, array) : value;
	
	      if (!index || seen !== computed) {
	        seen = computed;
	        result[++resIndex] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the first non-whitespace character.
	   */
	  function trimmedLeftIndex(string) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedRightIndex(string) {
	    var index = string.length;
	
	    while (index-- && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  function unescapeHtmlChar(chr) {
	    return htmlUnescapes[chr];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the given `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @category Utility
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // using `context` to mock `Date#getTime` use in `_.now`
	   * var mock = _.runInContext({
	   *   'Date': function() {
	   *     return { 'getTime': getTimeMock };
	   *   }
	   * });
	   *
	   * // or creating a suped-up `defer` in Node.js
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  function runInContext(context) {
	    // Avoid issues with some ES3 environments that attempt to use values, named
	    // after built-in constructors like `Object`, for the creation of literals.
	    // ES5 clears this up by stating that literals must use built-in constructors.
	    // See https://es5.github.io/#x11.1.5 for more details.
	    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;
	
	    /** Native constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Number = context.Number,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for native method references. */
	    var arrayProto = Array.prototype,
	        objectProto = Object.prototype,
	        stringProto = String.prototype;
	
	    /** Used to resolve the decompiled source of functions. */
	    var fnToString = Function.prototype.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /**
	     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objToString = objectProto.toString;
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Native method references. */
	    var ArrayBuffer = context.ArrayBuffer,
	        clearTimeout = context.clearTimeout,
	        parseFloat = context.parseFloat,
	        pow = Math.pow,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        Set = getNative(context, 'Set'),
	        setTimeout = context.setTimeout,
	        splice = arrayProto.splice,
	        Uint8Array = context.Uint8Array,
	        WeakMap = getNative(context, 'WeakMap');
	
	    /* Native method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeCreate = getNative(Object, 'create'),
	        nativeFloor = Math.floor,
	        nativeIsArray = getNative(Array, 'isArray'),
	        nativeIsFinite = context.isFinite,
	        nativeKeys = getNative(Object, 'keys'),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = getNative(Date, 'now'),
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random;
	
	    /** Used as references for `-Infinity` and `Infinity`. */
	    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
	        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;
	
	    /** Used as references for the maximum length and index of an array. */
	    var MAX_ARRAY_LENGTH = 4294967295,
	        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	    /**
	     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	     * of an array-like value.
	     */
	    var MAX_SAFE_INTEGER = 9007199254740991;
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
	     * Methods that operate on and return arrays, collections, and functions can
	     * be chained together. Methods that retrieve a single value or may return a
	     * primitive value will automatically end the chain returning the unwrapped
	     * value. Explicit chaining may be enabled using `_.chain`. The execution of
	     * chained methods is lazy, that is, execution is deferred until `_#value`
	     * is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
	     * fusion is an optimization strategy which merge iteratee calls; this can help
	     * to avoid the creation of intermediate data structures and greatly reduce the
	     * number of iteratee executions.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
	     * `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
	     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
	     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
	     * and `where`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
	     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
	     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
	     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
	     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
	     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
	     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
	     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
	     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
	     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
	     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
	     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
	     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
	     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
	     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
	     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
	     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
	     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
	     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
	     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
	     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
	     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
	     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
	     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
	     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
	     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
	     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
	     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
	     * `unescape`, `uniqueId`, `value`, and `words`
	     *
	     * The wrapper method `sample` will return a wrapped value when `n` is provided,
	     * otherwise an unwrapped value is returned.
	     *
	     * @name _
	     * @constructor
	     * @category Chain
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // returns an unwrapped value
	     * wrapped.reduce(function(total, n) {
	     *   return total + n;
	     * });
	     * // => 6
	     *
	     * // returns a wrapped value
	     * var squares = wrapped.map(function(n) {
	     *   return n * n;
	     * });
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The function whose prototype all chaining wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
	     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
	     */
	    function LodashWrapper(value, chainAll, actions) {
	      this.__wrapped__ = value;
	      this.__actions__ = actions || [];
	      this.__chain__ = !!chainAll;
	    }
	
	    /**
	     * An object environment feature flags.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    var support = lodash.support = {};
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type string
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type Object
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type Function
	         */
	        '_': lodash
	      }
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = POSITIVE_INFINITY;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = arrayCopy(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = arrayCopy(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = arrayCopy(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
	        return baseWrapperValue((isRight && isArr) ? array.reverse() : array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a cache object to store key/value pairs.
	     *
	     * @private
	     * @static
	     * @name Cache
	     * @memberOf _.memoize
	     */
	    function MapCache() {
	      this.__data__ = {};
	    }
	
	    /**
	     * Removes `key` and its value from the cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
	     */
	    function mapDelete(key) {
	      return this.has(key) && delete this.__data__[key];
	    }
	
	    /**
	     * Gets the cached value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the cached value.
	     */
	    function mapGet(key) {
	      return key == '__proto__' ? undefined : this.__data__[key];
	    }
	
	    /**
	     * Checks if a cached value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapHas(key) {
	      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
	    }
	
	    /**
	     * Sets `value` to `key` of the cache.
	     *
	     * @private
	     * @name set
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to cache.
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache object.
	     */
	    function mapSet(key, value) {
	      if (key != '__proto__') {
	        this.__data__[key] = value;
	      }
	      return this;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates a cache object to store unique values.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var length = values ? values.length : 0;
	
	      this.data = { 'hash': nativeCreate(null), 'set': new Set };
	      while (length--) {
	        this.push(values[length]);
	      }
	    }
	
	    /**
	     * Checks if `value` is in `cache` mimicking the return signature of
	     * `_.indexOf` by returning `0` if the value is found, else `-1`.
	     *
	     * @private
	     * @param {Object} cache The cache to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `0` if `value` is found, else `-1`.
	     */
	    function cacheIndexOf(cache, value) {
	      var data = cache.data,
	          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
	
	      return result ? 0 : -1;
	    }
	
	    /**
	     * Adds `value` to the cache.
	     *
	     * @private
	     * @name push
	     * @memberOf SetCache
	     * @param {*} value The value to cache.
	     */
	    function cachePush(value) {
	      var data = this.data;
	      if (typeof value == 'string' || isObject(value)) {
	        data.set.add(value);
	      } else {
	        data.hash[value] = true;
	      }
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a new array joining `array` with `other`.
	     *
	     * @private
	     * @param {Array} array The array to join.
	     * @param {Array} other The other array to join.
	     * @returns {Array} Returns the new concatenated array.
	     */
	    function arrayConcat(array, other) {
	      var index = -1,
	          length = array.length,
	          othIndex = -1,
	          othLength = other.length,
	          result = Array(length + othLength);
	
	      while (++index < length) {
	        result[index] = array[index];
	      }
	      while (++othIndex < othLength) {
	        result[index++] = other[othIndex];
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayCopy(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEach` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEach(array, iteratee) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (iteratee(array[index], index, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEachRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEachRight(array, iteratee) {
	      var length = array.length;
	
	      while (length--) {
	        if (iteratee(array[length], length, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.every` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     */
	    function arrayEvery(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (!predicate(array[index], index, array)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
	     * with one argument: (value).
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function arrayExtremum(array, iteratee, comparator, exValue) {
	      var index = -1,
	          length = array.length,
	          computed = exValue,
	          result = computed;
	
	      while (++index < length) {
	        var value = array[index],
	            current = +iteratee(value);
	
	        if (comparator(current, computed)) {
	          computed = current;
	          result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.filter` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function arrayFilter(array, predicate) {
	      var index = -1,
	          length = array.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.map` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function arrayMap(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = iteratee(array[index], index, array);
	      }
	      return result;
	    }
	
	    /**
	     * Appends the elements of `values` to `array`.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to append.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayPush(array, values) {
	      var index = -1,
	          length = values.length,
	          offset = array.length;
	
	      while (++index < length) {
	        array[offset + index] = values[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.reduce` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the first element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduce(array, iteratee, accumulator, initFromArray) {
	      var index = -1,
	          length = array.length;
	
	      if (initFromArray && length) {
	        accumulator = array[++index];
	      }
	      while (++index < length) {
	        accumulator = iteratee(accumulator, array[index], index, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.reduceRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the last element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
	      var length = array.length;
	      if (initFromArray && length) {
	        accumulator = array[--length];
	      }
	      while (length--) {
	        accumulator = iteratee(accumulator, array[length], length, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.some` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function arraySome(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (predicate(array[index], index, array)) {
	          return true;
	        }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `_.sum` for arrays without support for callback
	     * shorthands and `this` binding..
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function arraySum(array, iteratee) {
	      var length = array.length,
	          result = 0;
	
	      while (length--) {
	        result += +iteratee(array[length]) || 0;
	      }
	      return result;
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assign` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : objectValue;
	    }
	
	    /**
	     * Used by `_.template` to customize its `_.assign` use.
	     *
	     * **Note:** This function is like `assignDefaults` except that it ignores
	     * inherited property values when checking if a property is `undefined`.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @param {string} key The key associated with the object and source values.
	     * @param {Object} object The destination object.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignOwnDefaults(objectValue, sourceValue, key, object) {
	      return (objectValue === undefined || !hasOwnProperty.call(object, key))
	        ? sourceValue
	        : objectValue;
	    }
	
	    /**
	     * A specialized version of `_.assign` for customizing assigned values without
	     * support for argument juggling, multiple sources, and `this` binding `customizer`
	     * functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     */
	    function assignWith(object, source, customizer) {
	      var index = -1,
	          props = keys(source),
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key],
	            result = customizer(value, source[key], key, object, source);
	
	        if ((result === result ? (result !== value) : (value === value)) ||
	            (value === undefined && !(key in object))) {
	          object[key] = result;
	        }
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for argument juggling,
	     * multiple sources, and `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return source == null
	        ? object
	        : baseCopy(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.at` without support for string collections
	     * and individual key arguments.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {number[]|string[]} props The property names or indexes of elements to pick.
	     * @returns {Array} Returns the new array of picked elements.
	     */
	    function baseAt(collection, props) {
	      var index = -1,
	          isNil = collection == null,
	          isArr = !isNil && isArrayLike(collection),
	          length = isArr ? collection.length : 0,
	          propsLength = props.length,
	          result = Array(propsLength);
	
	      while(++index < propsLength) {
	        var key = props[index];
	        if (isArr) {
	          result[index] = isIndex(key, length) ? collection[key] : undefined;
	        } else {
	          result[index] = isNil ? undefined : collection[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property names to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @returns {Object} Returns `object`.
	     */
	    function baseCopy(source, props, object) {
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	        object[key] = source[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.callback` which supports specifying the
	     * number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function baseCallback(func, thisArg, argCount) {
	      var type = typeof func;
	      if (type == 'function') {
	        return thisArg === undefined
	          ? func
	          : bindCallback(func, thisArg, argCount);
	      }
	      if (func == null) {
	        return identity;
	      }
	      if (type == 'object') {
	        return baseMatches(func);
	      }
	      return thisArg === undefined
	        ? property(func)
	        : baseMatchesProperty(func, thisArg);
	    }
	
	    /**
	     * The base implementation of `_.clone` without support for argument juggling
	     * and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The object `value` belongs to.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates clones with source counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
	      var result;
	      if (customizer) {
	        result = object ? customizer(value, key, object) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return arrayCopy(value, result);
	        }
	      } else {
	        var tag = objToString.call(value),
	            isFunc = tag == funcTag;
	
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = initCloneObject(isFunc ? {} : value);
	          if (!isDeep) {
	            return baseAssign(result, value);
	          }
	        } else {
	          return cloneableTags[tag]
	            ? initCloneByTag(value, tag, isDeep)
	            : (object ? value : {});
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == value) {
	          return stackB[length];
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate it with its clone.
	      stackA.push(value);
	      stackB.push(result);
	
	      // Recursively populate clone (susceptible to call stack limits).
	      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
	        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} prototype The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(prototype) {
	        if (isObject(prototype)) {
	          object.prototype = prototype;
	          var result = new object;
	          object.prototype = undefined;
	        }
	        return result || {};
	      };
	    }());
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts an index
	     * of where to slice the arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Object} args The arguments provide to `func`.
	     * @returns {number} Returns the timer id.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of `_.difference` which accepts a single array
	     * of values to exclude.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values) {
	      var length = array ? array.length : 0,
	          result = [];
	
	      if (!length) {
	        return result;
	      }
	      var index = -1,
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
	          valuesLength = values.length;
	
	      if (cache) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	        values = cache;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index];
	
	        if (isCommon && value === value) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === value) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (indexOf(values, value, 0) < 0) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * Gets the extremum value of `collection` invoking `iteratee` for each value
	     * in `collection` to generate the criterion by which the value is ranked.
	     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(collection, iteratee, comparator, exValue) {
	      var computed = exValue,
	          result = computed;
	
	      baseEach(collection, function(value, index, collection) {
	        var current = +iteratee(value, index, collection);
	        if (comparator(current, computed) || (current === exValue && current === result)) {
	          computed = current;
	          result = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : (end >>> 0);
	      start >>>= 0;
	
	      while (start < length) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	     * without support for callback shorthands and `this` binding, which iterates
	     * over `collection` using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @param {boolean} [retKey] Specify returning the key of the found element
	     *  instead of the element itself.
	     * @returns {*} Returns the found element or its key, else `undefined`.
	     */
	    function baseFind(collection, predicate, eachFunc, retKey) {
	      var result;
	      eachFunc(collection, function(value, key, collection) {
	        if (predicate(value, key, collection)) {
	          result = retKey ? key : value;
	          return false;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with added support for restricting
	     * flattening and specifying the start index.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, isDeep, isStrict, result) {
	      result || (result = []);
	
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index];
	        if (isObjectLike(value) && isArrayLike(value) &&
	            (isStrict || isArray(value) || isArguments(value))) {
	          if (isDeep) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, isDeep, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForIn` and `baseForOwn` which iterates
	     * over `object` properties returned by `keysFunc` invoking `iteratee` for
	     * each property. Iteratee functions may exit iteration early by explicitly
	     * returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forIn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForIn(object, iteratee) {
	      return baseFor(object, iteratee, keysIn);
	    }
	
	    /**
	     * The base implementation of `_.forOwn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from those provided.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the new array of filtered property names.
	     */
	    function baseFunctions(object, props) {
	      var index = -1,
	          length = props.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var key = props[index];
	        if (isFunction(object[key])) {
	          result[++resIndex] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `get` without support for string paths
	     * and default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path of the property to get.
	     * @param {string} [pathKey] The key representation of path.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path, pathKey) {
	      if (object == null) {
	        return;
	      }
	      if (pathKey !== undefined && pathKey in toObject(object)) {
	        path = [pathKey];
	      }
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[path[index++]];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` without support for `this` binding
	     * `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = arrayTag,
	          othTag = arrayTag;
	
	      if (!objIsArr) {
	        objTag = objToString.call(object);
	        if (objTag == argsTag) {
	          objTag = objectTag;
	        } else if (objTag != objectTag) {
	          objIsArr = isTypedArray(object);
	        }
	      }
	      if (!othIsArr) {
	        othTag = objToString.call(other);
	        if (othTag == argsTag) {
	          othTag = objectTag;
	        } else if (othTag != objectTag) {
	          othIsArr = isTypedArray(other);
	        }
	      }
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && !(objIsArr || objIsObj)) {
	        return equalByTag(object, other, objTag);
	      }
	      if (!isLoose) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      // For more information on detecting circular references see https://es5.github.io/#JO.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == object) {
	          return stackB[length] == other;
	        }
	      }
	      // Add `object` and `other` to the stack of traversed objects.
	      stackA.push(object);
	      stackB.push(other);
	
	      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
	
	      stackA.pop();
	      stackB.pop();
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} matchData The propery names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = toObject(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which does not clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        var key = matchData[0][0],
	            value = matchData[0][1];
	
	        return function(object) {
	          if (object == null) {
	            return false;
	          }
	          return object[key] === value && (value !== undefined || (key in toObject(object)));
	        };
	      }
	      return function(object) {
	        return baseIsMatch(object, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to compare.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      var isArr = isArray(path),
	          isCommon = isKey(path) && isStrictComparable(srcValue),
	          pathKey = (path + '');
	
	      path = toPath(path);
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        var key = pathKey;
	        object = toObject(object);
	        if ((isArr || !isCommon) && !(key in object)) {
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          if (object == null) {
	            return false;
	          }
	          key = last(path);
	          object = toObject(object);
	        }
	        return object[key] === srcValue
	          ? (srcValue !== undefined || (key in object))
	          : baseIsEqual(srcValue, object[key], undefined, true);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for argument juggling,
	     * multiple sources, and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {Object} Returns `object`.
	     */
	    function baseMerge(object, source, customizer, stackA, stackB) {
	      if (!isObject(object)) {
	        return object;
	      }
	      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
	          props = isSrcArr ? undefined : keys(source);
	
	      arrayEach(props || source, function(srcValue, key) {
	        if (props) {
	          key = srcValue;
	          srcValue = source[key];
	        }
	        if (isObjectLike(srcValue)) {
	          stackA || (stackA = []);
	          stackB || (stackB = []);
	          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
	        }
	        else {
	          var value = object[key],
	              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	              isCommon = result === undefined;
	
	          if (isCommon) {
	            result = srcValue;
	          }
	          if ((result !== undefined || (isSrcArr && !(key in object))) &&
	              (isCommon || (result === result ? (result !== value) : (value === value)))) {
	            object[key] = result;
	          }
	        }
	      });
	      return object;
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
	      var length = stackA.length,
	          srcValue = source[key];
	
	      while (length--) {
	        if (stackA[length] == srcValue) {
	          object[key] = stackB[length];
	          return;
	        }
	      }
	      var value = object[key],
	          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	          isCommon = result === undefined;
	
	      if (isCommon) {
	        result = srcValue;
	        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
	          result = isArray(value)
	            ? value
	            : (isArrayLike(value) ? arrayCopy(value) : []);
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          result = isArguments(value)
	            ? toPlainObject(value)
	            : (isPlainObject(value) ? value : {});
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate
	      // it with its merged value.
	      stackA.push(srcValue);
	      stackB.push(result);
	
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
	      } else if (result === result ? (result !== value) : (value === value)) {
	        object[key] = result;
	      }
	    }
	
	    /**
	     * The base implementation of `_.property` without support for deep paths.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function baseProperty(key) {
	      return function(object) {
	        return object == null ? undefined : object[key];
	      };
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function basePropertyDeep(path) {
	      var pathKey = (path + '');
	      path = toPath(path);
	      return function(object) {
	        return baseGet(object, path, pathKey);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * index arguments and capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0;
	      while (length--) {
	        var index = indexes[length];
	        if (index != previous && isIndex(index)) {
	          var previous = index;
	          splice.call(array, index, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for argument juggling
	     * and returning floating-point numbers.
	     *
	     * @private
	     * @param {number} min The minimum possible value.
	     * @param {number} max The maximum possible value.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(min, max) {
	      return min + nativeFloor(nativeRandom() * (max - min + 1));
	    }
	
	    /**
	     * The base implementation of `_.reduce` and `_.reduceRight` without support
	     * for callback shorthands and `this` binding, which iterates over `collection`
	     * using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} accumulator The initial value.
	     * @param {boolean} initFromCollection Specify using the first or last element
	     *  of `collection` as the initial value.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @returns {*} Returns the accumulated value.
	     */
	    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
	      eachFunc(collection, function(value, index, collection) {
	        accumulator = initFromCollection
	          ? (initFromCollection = false, value)
	          : iteratee(accumulator, value, index, collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop detection.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortBy` which uses `comparer` to define
	     * the sort order of `array` and replaces criteria objects with their
	     * corresponding values.
	     *
	     * @private
	     * @param {Array} array The array to sort.
	     * @param {Function} comparer The function to define sort order.
	     * @returns {Array} Returns `array`.
	     */
	    function baseSortBy(array, comparer) {
	      var length = array.length;
	
	      array.sort(comparer);
	      while (length--) {
	        array[length] = array[length].value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.sortByOrder` without param guards.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseSortByOrder(collection, iteratees, orders) {
	      var callback = getCallback(),
	          index = -1;
	
	      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });
	
	      var result = baseMap(collection, function(value) {
	        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.sum` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function baseSum(collection, iteratee) {
	      var result = 0;
	      baseEach(collection, function(value, index, collection) {
	        result += +iteratee(value, index, collection) || 0;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.uniq` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The function invoked per iteration.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     */
	    function baseUniq(array, iteratee) {
	      var index = -1,
	          indexOf = getIndexOf(),
	          length = array.length,
	          isCommon = indexOf == baseIndexOf,
	          isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
	          seen = isLarge ? createCache() : null,
	          result = [];
	
	      if (seen) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	      } else {
	        isLarge = false;
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value, index, array) : value;
	
	        if (isCommon && value === value) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (indexOf(seen, computed, 0) < 0) {
	          if (iteratee || isLarge) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.values` and `_.valuesIn` which creates an
	     * array of `object` property values corresponding to the property names
	     * of `props`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} props The property names to get values for.
	     * @returns {Object} Returns the array of property values.
	     */
	    function baseValues(object, props) {
	      var index = -1,
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = object[props[index]];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
	     * and `_.takeWhile` without support for callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to peform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      var index = -1,
	          length = actions.length;
	
	      while (++index < length) {
	        var action = actions[index];
	        result = action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }
	      return result;
	    }
	
	    /**
	     * Performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndex(array, value, retHighest) {
	      var low = 0,
	          high = array ? array.length : low;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return binaryIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * This function is like `binaryIndex` except that it invokes `iteratee` for
	     * `value` and each element of `array` to compute their sort ranking. The
	     * iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array ? array.length : 0,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsUndef = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            isDef = computed !== undefined,
	            isReflexive = computed === computed;
	
	        if (valIsNaN) {
	          var setLow = isReflexive || retHighest;
	        } else if (valIsNull) {
	          setLow = isReflexive && isDef && (retHighest || computed != null);
	        } else if (valIsUndef) {
	          setLow = isReflexive && (retHighest || isDef);
	        } else if (computed == null) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * A specialized version of `baseCallback` which only supports `this` binding
	     * and specifying the number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function bindCallback(func, thisArg, argCount) {
	      if (typeof func != 'function') {
	        return identity;
	      }
	      if (thisArg === undefined) {
	        return func;
	      }
	      switch (argCount) {
	        case 1: return function(value) {
	          return func.call(thisArg, value);
	        };
	        case 3: return function(value, index, collection) {
	          return func.call(thisArg, value, index, collection);
	        };
	        case 4: return function(accumulator, value, index, collection) {
	          return func.call(thisArg, accumulator, value, index, collection);
	        };
	        case 5: return function(value, other, key, object, source) {
	          return func.call(thisArg, value, other, key, object, source);
	        };
	      }
	      return function() {
	        return func.apply(thisArg, arguments);
	      };
	    }
	
	    /**
	     * Creates a clone of the given array buffer.
	     *
	     * @private
	     * @param {ArrayBuffer} buffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function bufferClone(buffer) {
	      var result = new ArrayBuffer(buffer.byteLength),
	          view = new Uint8Array(result);
	
	      view.set(new Uint8Array(buffer));
	      return result;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders) {
	      var holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          leftIndex = -1,
	          leftLength = partials.length,
	          result = Array(leftLength + argsLength);
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        result[holders[argsIndex]] = args[argsIndex];
	      }
	      while (argsLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders) {
	      var holdersIndex = -1,
	          holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          rightIndex = -1,
	          rightLength = partials.length,
	          result = Array(argsLength + rightLength);
	
	      while (++argsIndex < argsLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        result[offset + holders[holdersIndex]] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
	     *
	     * @private
	     * @param {Function} setter The function to set keys and values of the accumulator object.
	     * @param {Function} [initializer] The function to initialize the accumulator object.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee, thisArg) {
	        var result = initializer ? initializer() : {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        if (isArray(collection)) {
	          var index = -1,
	              length = collection.length;
	
	          while (++index < length) {
	            var value = collection[index];
	            setter(result, value, iteratee(value, index, collection), collection);
	          }
	        } else {
	          baseEach(collection, function(value, key, collection) {
	            setter(result, value, iteratee(value, key, collection), collection);
	          });
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return restParam(function(object, sources) {
	        var index = -1,
	            length = object == null ? 0 : sources.length,
	            customizer = length > 2 ? sources[length - 2] : undefined,
	            guard = length > 2 ? sources[2] : undefined,
	            thisArg = length > 1 ? sources[length - 1] : undefined;
	
	        if (typeof customizer == 'function') {
	          customizer = bindCallback(customizer, thisArg, 5);
	          length -= 2;
	        } else {
	          customizer = typeof thisArg == 'function' ? thisArg : undefined;
	          length -= (customizer ? 1 : 0);
	        }
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        var length = collection ? getLength(collection) : 0;
	        if (!isLength(length)) {
	          return eachFunc(collection, iteratee);
	        }
	        var index = fromRight ? length : -1,
	            iterable = toObject(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var iterable = toObject(object),
	            props = keysFunc(object),
	            length = props.length,
	            index = fromRight ? length : -1;
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var key = props[index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createBindWrapper(func, thisArg) {
	      var Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(thisArg, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `Set` cache object to optimize linear searches of large arrays.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	     */
	    function createCache(values) {
	      return (nativeCreate && Set) ? new SetCache(values) : null;
	    }
	
	    /**
	     * Creates a function that produces compound words out of the words in a
	     * given string.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        var index = -1,
	            array = words(deburr(string)),
	            length = array.length,
	            result = '';
	
	        while (++index < length) {
	          result = callback(result, array[index], index);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtorWrapper(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors.
	        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a `_.curry` or `_.curryRight` function.
	     *
	     * @private
	     * @param {boolean} flag The curry bit flag.
	     * @returns {Function} Returns the new curry function.
	     */
	    function createCurry(flag) {
	      function curryFunc(func, arity, guard) {
	        if (guard && isIterateeCall(func, arity, guard)) {
	          arity = undefined;
	        }
	        var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
	        result.placeholder = curryFunc.placeholder;
	        return result;
	      }
	      return curryFunc;
	    }
	
	    /**
	     * Creates a `_.defaults` or `_.defaultsDeep` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Function} Returns the new defaults function.
	     */
	    function createDefaults(assigner, customizer) {
	      return restParam(function(args) {
	        var object = args[0];
	        if (object == null) {
	          return object;
	        }
	        args.push(customizer);
	        return assigner.apply(undefined, args);
	      });
	    }
	
	    /**
	     * Creates a `_.max` or `_.min` function.
	     *
	     * @private
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {Function} Returns the new extremum function.
	     */
	    function createExtremum(comparator, exValue) {
	      return function(collection, iteratee, thisArg) {
	        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	          iteratee = undefined;
	        }
	        iteratee = getCallback(iteratee, thisArg, 3);
	        if (iteratee.length == 1) {
	          collection = isArray(collection) ? collection : toIterable(collection);
	          var result = arrayExtremum(collection, iteratee, comparator, exValue);
	          if (!(collection.length && result === exValue)) {
	            return result;
	          }
	        }
	        return baseExtremum(collection, iteratee, comparator, exValue);
	      };
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(eachFunc, fromRight) {
	      return function(collection, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        if (isArray(collection)) {
	          var index = baseFindIndex(collection, predicate, fromRight);
	          return index > -1 ? collection[index] : undefined;
	        }
	        return baseFind(collection, predicate, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a `_.findIndex` or `_.findLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindIndex(fromRight) {
	      return function(array, predicate, thisArg) {
	        if (!(array && array.length)) {
	          return -1;
	        }
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFindIndex(array, predicate, fromRight);
	      };
	    }
	
	    /**
	     * Creates a `_.findKey` or `_.findLastKey` function.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindKey(objectFunc) {
	      return function(object, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFind(object, predicate, objectFunc, true);
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return function() {
	        var wrapper,
	            length = arguments.length,
	            index = fromRight ? length : -1,
	            leftIndex = 0,
	            funcs = Array(length);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var func = funcs[leftIndex++] = arguments[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
	            wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? -1 : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      };
	    }
	
	    /**
	     * Creates a function for `_.forEach` or `_.forEachRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForEach(arrayFunc, eachFunc) {
	      return function(collection, iteratee, thisArg) {
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee)
	          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
	      };
	    }
	
	    /**
	     * Creates a function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForIn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee, keysIn);
	      };
	    }
	
	    /**
	     * Creates a function for `_.forOwn` or `_.forOwnRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForOwn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee);
	      };
	    }
	
	    /**
	     * Creates a function for `_.mapKeys` or `_.mapValues`.
	     *
	     * @private
	     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
	     * @returns {Function} Returns the new map function.
	     */
	    function createObjectMapper(isMapKeys) {
	      return function(object, iteratee, thisArg) {
	        var result = {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        baseForOwn(object, function(value, key, object) {
	          var mapped = iteratee(value, key, object);
	          key = isMapKeys ? mapped : key;
	          value = isMapKeys ? value : mapped;
	          result[key] = value;
	        });
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function for `_.padLeft` or `_.padRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify padding from the right.
	     * @returns {Function} Returns the new pad function.
	     */
	    function createPadDir(fromRight) {
	      return function(string, length, chars) {
	        string = baseToString(string);
	        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
	      };
	    }
	
	    /**
	     * Creates a `_.partial` or `_.partialRight` function.
	     *
	     * @private
	     * @param {boolean} flag The partial bit flag.
	     * @returns {Function} Returns the new partial function.
	     */
	    function createPartial(flag) {
	      var partialFunc = restParam(function(func, partials) {
	        var holders = replaceHolders(partials, partialFunc.placeholder);
	        return createWrapper(func, flag, undefined, partials, holders);
	      });
	      return partialFunc;
	    }
	
	    /**
	     * Creates a function for `_.reduce` or `_.reduceRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createReduce(arrayFunc, eachFunc) {
	      return function(collection, iteratee, accumulator, thisArg) {
	        var initFromArray = arguments.length < 3;
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
	          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with optional `this`
	     * binding of, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & ARY_FLAG,
	          isBind = bitmask & BIND_FLAG,
	          isBindKey = bitmask & BIND_KEY_FLAG,
	          isCurry = bitmask & CURRY_FLAG,
	          isCurryBound = bitmask & CURRY_BOUND_FLAG,
	          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
	          Ctor = isBindKey ? undefined : createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it to other functions.
	        var length = arguments.length,
	            index = length,
	            args = Array(length);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight);
	        }
	        if (isCurry || isCurryRight) {
	          var placeholder = wrapper.placeholder,
	              argsHolders = replaceHolders(args, placeholder);
	
	          length -= argsHolders.length;
	          if (length < arity) {
	            var newArgPos = argPos ? arrayCopy(argPos) : undefined,
	                newArity = nativeMax(arity - length, 0),
	                newsHolders = isCurry ? argsHolders : undefined,
	                newHoldersRight = isCurry ? undefined : argsHolders,
	                newPartials = isCurry ? args : undefined,
	                newPartialsRight = isCurry ? undefined : args;
	
	            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	            if (!isCurryBound) {
	              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	            }
	            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
	                result = createHybridWrapper.apply(undefined, newData);
	
	            if (isLaziable(func)) {
	              setData(result, newData);
	            }
	            result.placeholder = placeholder;
	            return result;
	          }
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        if (argPos) {
	          args = reorder(args, argPos);
	        }
	        if (isAry && ary < args.length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtorWrapper(func);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates the padding required for `string` based on the given `length`.
	     * The `chars` string is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {string} string The string to create padding for.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the pad for `string`.
	     */
	    function createPadding(string, length, chars) {
	      var strLength = string.length;
	      length = +length;
	
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return '';
	      }
	      var padLength = length - strLength;
	      chars = chars == null ? ' ' : (chars + '');
	      return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the optional `this`
	     * binding of `thisArg` and the `partials` prepended to those provided to
	     * the wrapper.
	     *
	     * @private
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to the new function.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createPartialWrapper(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it `func`.
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength);
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        precision = precision === undefined ? 0 : (+precision || 0);
	        if (precision) {
	          precision = pow(10, precision);
	          return func(number * precision) / precision;
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {Function} Returns the new index function.
	     */
	    function createSortedIndex(retHighest) {
	      return function(array, value, iteratee, thisArg) {
	        var callback = getCallback(iteratee);
	        return (iteratee == null && callback === baseCallback)
	          ? binaryIndex(array, value, retHighest)
	          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      length -= (holders ? holders.length : 0);
	      if (bitmask & PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func),
	          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];
	
	      if (data) {
	        mergeData(newData, data);
	        bitmask = newData[1];
	        arity = newData[9];
	      }
	      newData[9] = arity == null
	        ? (isBindKey ? 0 : func.length)
	        : (nativeMax(arity - length, 0) || 0);
	
	      if (bitmask == BIND_FLAG) {
	        var result = createBindWrapper(newData[0], newData[2]);
	      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
	        result = createPartialWrapper.apply(undefined, newData);
	      } else {
	        result = createHybridWrapper.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setter(result, newData);
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing arrays.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var index = -1,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	        return false;
	      }
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index],
	            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
	
	        if (result !== undefined) {
	          if (result) {
	            continue;
	          }
	          return false;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (isLoose) {
	          if (!arraySome(other, function(othValue) {
	                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	              })) {
	            return false;
	          }
	        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag) {
	      switch (tag) {
	        case boolTag:
	        case dateTag:
	          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	          return +object == +other;
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case numberTag:
	          // Treat `NaN` vs. `NaN` as equal.
	          return (object != +object)
	            ? other != +other
	            : object == +other;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings primitives and string
	          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	          return object == (other + '');
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objProps = keys(object),
	          objLength = objProps.length,
	          othProps = keys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isLoose) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      var skipCtor = isLoose;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key],
	            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
	
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	          return false;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (!skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Gets the appropriate "callback" function. If the `_.callback` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseCallback` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getCallback(func, thisArg, argCount) {
	      var result = lodash.callback || callback;
	      result = result === callback ? baseCallback : result;
	      return argCount ? result(func, thisArg, argCount) : result;
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = func.name,
	          array = realNames[result],
	          length = array ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseIndexOf` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function|number} Returns the chosen function or its result.
	     */
	    function getIndexOf(collection, target, fromIndex) {
	      var result = lodash.indexOf || indexOf;
	      result = result === indexOf ? baseIndexOf : result;
	      return collection ? result(collection, target, fromIndex) : result;
	    }
	
	    /**
	     * Gets the "length" property value of `object`.
	     *
	     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	     * that affects Safari on at least iOS 8.1-8.3 ARM64.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {*} Returns the "length" value.
	     */
	    var getLength = baseProperty('length');
	
	    /**
	     * Gets the propery names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = pairs(object),
	          length = result.length;
	
	      while (length--) {
	        result[length][2] = isStrictComparable(result[length][1]);
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = object == null ? undefined : object[key];
	      return isNative(value) ? value : undefined;
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add array properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      var Ctor = object.constructor;
	      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
	        Ctor = Object;
	      }
	      return new Ctor;
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return bufferClone(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          var buffer = object.buffer;
	          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          var result = new Ctor(object.source, reFlags.exec(object));
	          result.lastIndex = object.lastIndex;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the method at `path` on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function invokePath(object, path, args) {
	      if (object != null && !isKey(path, object)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        path = last(path);
	      }
	      var func = object == null ? object : object[path];
	      return func == null ? undefined : func.apply(object, args);
	    }
	
	    /**
	     * Checks if `value` is array-like.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(getLength(value));
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return value > -1 && value % 1 == 0 && value < length;
	    }
	
	    /**
	     * Checks if the provided arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	          ? (isArrayLike(object) && isIndex(index, object.length))
	          : (type == 'string' && index in object)) {
	        var other = object[index];
	        return value === value ? (value === other) : (other !== other);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      var type = typeof value;
	      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	        return true;
	      }
	      if (isArray(value)) {
	        return false;
	      }
	      var result = !reIsDeepProp.test(value);
	      return result || (object != null && value in toObject(object));
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func);
	      if (!(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      var other = lodash[funcName];
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     */
	    function isLength(value) {
	      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers required to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
	     * augment function arguments, making the order in which they are executed important,
	     * preventing the merging of metadata. However, we make an exception for a safe
	     * common case where curried functions have `_.ary` and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < ARY_FLAG;
	
	      var isCombo =
	        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
	        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
	        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = arrayCopy(value);
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function mergeDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties specified
	     * by `props`.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property names to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByArray(object, props) {
	      object = toObject(object);
	
	      var index = -1,
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index];
	        if (key in object) {
	          result[key] = object[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties `predicate`
	     * returns truthy for.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByCallback(object, predicate) {
	      var result = {};
	      baseForIn(object, function(value, key, object) {
	        if (predicate(value, key, object)) {
	          result[key] = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = arrayCopy(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity function
	     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = (function() {
	      var count = 0,
	          lastCalled = 0;
	
	      return function(key, value) {
	        var stamp = now(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return key;
	          }
	        } else {
	          count = 0;
	        }
	        return baseSetData(key, value);
	      };
	    }());
	
	    /**
	     * A fallback implementation of `Object.keys` which creates an array of the
	     * own enumerable property names of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function shimKeys(object) {
	      var props = keysIn(object),
	          propsLength = props.length,
	          length = propsLength && object.length;
	
	      var allowIndexes = !!length && isLength(length) &&
	        (isArray(object) || isArguments(object));
	
	      var index = -1,
	          result = [];
	
	      while (++index < propsLength) {
	        var key = props[index];
	        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to an array-like object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array|Object} Returns the array-like object.
	     */
	    function toIterable(value) {
	      if (value == null) {
	        return [];
	      }
	      if (!isArrayLike(value)) {
	        return values(value);
	      }
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to an object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Object} Returns the object.
	     */
	    function toObject(value) {
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to property path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array} Returns the property path array.
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return value;
	      }
	      var result = [];
	      baseToString(value).replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      return wrapper instanceof LazyWrapper
	        ? wrapper.clone()
	        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `collection` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new array containing chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if (guard ? isIterateeCall(array, size, guard) : size == null) {
	        size = 1;
	      } else {
	        size = nativeMax(nativeFloor(size) || 1, 1);
	      }
	      var index = 0,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[++resIndex] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of unique `array` values not included in the other
	     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The arrays of values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.difference([1, 2, 3], [4, 2]);
	     * // => [1, 3]
	     */
	    var difference = restParam(function(array, values) {
	      return (isObjectLike(array) && isArrayLike(array))
	        ? baseDifference(array, baseFlatten(values, false, true))
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that match the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [1]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active', false), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8], '*', 1, 2);
	     * // => [4, '*', 8]
	     */
	    function fill(array, value, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(chr) {
	     *   return chr.user == 'barney';
	     * });
	     * // => 0
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findIndex(users, 'active', false);
	     * // => 0
	     *
	     * // using the `_.property` callback shorthand
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    var findIndex = createFindIndex();
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(chr) {
	     *   return chr.user == 'pebbles';
	     * });
	     * // => 2
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastIndex(users, 'active', false);
	     * // => 2
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    var findLastIndex = createFindIndex(true);
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias head
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.first([1, 2, 3]);
	     * // => 1
	     *
	     * _.first([]);
	     * // => undefined
	     */
	    function first(array) {
	      return array ? array[0] : undefined;
	    }
	
	    /**
	     * Flattens a nested array. If `isDeep` is `true` the array is recursively
	     * flattened, otherwise it is only flattened a single level.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, [4]]
	     *
	     * // using `isDeep`
	     * _.flatten([1, [2, 3, [4]]], true);
	     * // => [1, 2, 3, 4]
	     */
	    function flatten(array, isDeep, guard) {
	      var length = array ? array.length : 0;
	      if (guard && isIterateeCall(array, isDeep, guard)) {
	        isDeep = false;
	      }
	      return length ? baseFlatten(array, isDeep) : [];
	    }
	
	    /**
	     * Recursively flattens a nested array.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to recursively flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, 4]
	     */
	    function flattenDeep(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, true) : [];
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
	     * performs a faster binary search.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
	     *  to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // using `fromIndex`
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     *
	     * // performing a binary search
	     * _.indexOf([1, 1, 2, 2], 2, true);
	     * // => 2
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      if (typeof fromIndex == 'number') {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
	      } else if (fromIndex) {
	        var index = binaryIndex(array, value);
	        if (index < length &&
	            (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
	          return index;
	        }
	        return -1;
	      }
	      return baseIndexOf(array, value, fromIndex || 0);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      return dropRight(array, 1);
	    }
	
	    /**
	     * Creates an array of unique values that are included in all of the provided
	     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of shared values.
	     * @example
	     * _.intersection([1, 2], [4, 2], [2, 1]);
	     * // => [2]
	     */
	    var intersection = restParam(function(arrays) {
	      var othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(length),
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          result = [];
	
	      while (othIndex--) {
	        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
	        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
	      }
	      var array = arrays[0],
	          index = -1,
	          length = array ? array.length : 0,
	          seen = caches[0];
	
	      outer:
	      while (++index < length) {
	        value = array[index];
	        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
	          var othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(value);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    });
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array ? array.length : 0;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
	     *  or `true` to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // using `fromIndex`
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     *
	     * // performing a binary search
	     * _.lastIndexOf([1, 1, 2, 2], 2, true);
	     * // => 3
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (typeof fromIndex == 'number') {
	        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
	      } else if (fromIndex) {
	        index = binaryIndex(array, value, true) - 1;
	        var other = array[index];
	        if (value === value ? (value === other) : (other !== other)) {
	          return index;
	        }
	        return -1;
	      }
	      if (value !== value) {
	        return indexOfNaN(array, index, true);
	      }
	      while (index--) {
	        if (array[index] === value) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Removes all provided values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3, 1, 2, 3];
	     *
	     * _.pull(array, 2, 3);
	     * console.log(array);
	     * // => [1, 1]
	     */
	    function pull() {
	      var args = arguments,
	          array = args[0];
	
	      if (!(array && array.length)) {
	        return array;
	      }
	      var index = 0,
	          indexOf = getIndexOf(),
	          length = args.length;
	
	      while (++index < length) {
	        var fromIndex = 0,
	            value = args[index];
	
	        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to the given indexes and returns
	     * an array of the removed elements. Indexes may be specified as an array of
	     * indexes or as individual arguments.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [5, 10, 15, 20];
	     * var evens = _.pullAt(array, 1, 3);
	     *
	     * console.log(array);
	     * // => [5, 15]
	     *
	     * console.log(evens);
	     * // => [10, 20]
	     */
	    var pullAt = restParam(function(array, indexes) {
	      indexes = baseFlatten(indexes);
	
	      var result = baseAt(array, indexes);
	      basePullAt(array, indexes.sort(baseCompareAscending));
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate, thisArg) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getCallback(predicate, thisArg, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias tail
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.rest([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function rest(array) {
	      return drop(array, 1);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of `Array#slice` to support node
	     * lists in IE < 9 and to ensure dense arrays are returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value` should
	     * be inserted into `array` in order to maintain its sort order. If an iteratee
	     * function is provided it is invoked for `value` and each element of `array`
	     * to compute their sort ranking. The iteratee is bound to `thisArg` and
	     * invoked with one argument; (value).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     *
	     * _.sortedIndex([4, 4, 5, 5], 5);
	     * // => 2
	     *
	     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
	     *
	     * // using an iteratee function
	     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
	     *   return this.data[word];
	     * }, dict);
	     * // => 1
	     *
	     * // using the `_.property` callback shorthand
	     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
	     * // => 1
	     */
	    var sortedIndex = createSortedIndex();
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 4, 5, 5], 5);
	     * // => 4
	     */
	    var sortedLastIndex = createSortedIndex(true);
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
	     * and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [2, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [1, 2]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active', false), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all of the provided arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([1, 2], [4, 2], [2, 1]);
	     * // => [1, 2, 4]
	     */
	    var union = restParam(function(arrays) {
	      return baseUniq(baseFlatten(arrays, false, true));
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurence of each element
	     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
	     * for sorted arrays. If an iteratee function is provided it is invoked for
	     * each element in the array to generate the criterion by which uniqueness
	     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, array).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias unique
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {boolean} [isSorted] Specify the array is sorted.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     *
	     * // using `isSorted`
	     * _.uniq([1, 1, 2], true);
	     * // => [1, 2]
	     *
	     * // using an iteratee function
	     * _.uniq([1, 2.5, 1.5, 2], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => [1, 2.5]
	     *
	     * // using the `_.property` callback shorthand
	     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniq(array, isSorted, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (isSorted != null && typeof isSorted != 'boolean') {
	        thisArg = iteratee;
	        iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
	        isSorted = false;
	      }
	      var callback = getCallback();
	      if (!(iteratee == null && callback === baseCallback)) {
	        iteratee = callback(iteratee, thisArg, 3);
	      }
	      return (isSorted && getIndexOf() == baseIndexOf)
	        ? sortedUniq(array, iteratee)
	        : baseUniq(array, iteratee);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['fred', 'barney'], [30, 40], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var index = -1,
	          length = 0;
	
	      array = arrayFilter(array, function(group) {
	        if (isArrayLike(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = arrayMap(array, baseProperty(index));
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts an iteratee to specify
	     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee] The function to combine regrouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      iteratee = bindCallback(iteratee, thisArg, 4);
	      return arrayMap(result, function(group) {
	        return arrayReduce(group, iteratee, undefined, true);
	      });
	    }
	
	    /**
	     * Creates an array excluding all provided values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to filter.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.without([1, 2, 1, 3], 1, 2);
	     * // => [3]
	     */
	    var without = restParam(function(array, values) {
	      return isArrayLike(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the provided arrays.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of values.
	     * @example
	     *
	     * _.xor([1, 2], [4, 2]);
	     * // => [1, 4]
	     */
	    function xor() {
	      var index = -1,
	          length = arguments.length;
	
	      while (++index < length) {
	        var array = arguments[index];
	        if (isArrayLike(array)) {
	          var result = result
	            ? arrayPush(baseDifference(result, array), baseDifference(array, result))
	            : array;
	        }
	      }
	      return result ? baseUniq(result) : [];
	    }
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the first
	     * elements of the given arrays, the second of which contains the second elements
	     * of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     */
	    var zip = restParam(unzip);
	
	    /**
	     * The inverse of `_.pairs`; this method returns an object composed from arrays
	     * of property names and values. Provide either a single two dimensional array,
	     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
	     * and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @alias object
	     * @category Array
	     * @param {Array} props The property names.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject([['fred', 30], ['barney', 40]]);
	     * // => { 'fred': 30, 'barney': 40 }
	     *
	     * _.zipObject(['fred', 'barney'], [30, 40]);
	     * // => { 'fred': 30, 'barney': 40 }
	     */
	    function zipObject(props, values) {
	      var index = -1,
	          length = props ? props.length : 0,
	          result = {};
	
	      if (length && !values && !isArray(props[0])) {
	        values = [];
	      }
	      while (++index < length) {
	        var key = props[index];
	        if (values) {
	          result[key] = values[index];
	        } else if (key) {
	          result[key[0]] = key[1];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an iteratee to specify
	     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee] The function to combine grouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
	     * // => [111, 222]
	     */
	    var zipWith = restParam(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 2 ? arrays[length - 2] : undefined,
	          thisArg = length > 1 ? arrays[length - 1] : undefined;
	
	      if (length > 2 && typeof iteratee == 'function') {
	        length -= 2;
	      } else {
	        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
	        thisArg = undefined;
	      }
	      arrays.length = length;
	      return unzipWith(arrays, iteratee, thisArg);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object that wraps `value` with explicit method
	     * chaining enabled.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _.chain(users)
	     *   .sortBy('age')
	     *   .map(function(chr) {
	     *     return chr.user + ' is ' + chr.age;
	     *   })
	     *   .first()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor is
	     * bound to `thisArg` and invoked with one argument; (value). The purpose of
	     * this method is to "tap into" a method chain in order to perform operations
	     * on intermediate results within the chain.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor, thisArg) {
	      interceptor.call(thisArg, value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor, thisArg) {
	      return interceptor.call(thisArg, value);
	    }
	
	    /**
	     * Enables explicit method chaining on the wrapper object.
	     *
	     * @name chain
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // without explicit chaining
	     * _(users).first();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // with explicit chaining
	     * _(users).chain()
	     *   .first()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chained sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Creates a new array joining a wrapped array with any additional arrays
	     * and/or values.
	     *
	     * @name concat
	     * @memberOf _
	     * @category Chain
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var wrapped = _(array).concat(2, [3], [[4]]);
	     *
	     * console.log(wrapped.value());
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    var wrapperConcat = restParam(function(values) {
	      values = baseFlatten(values);
	      return this.thru(function(array) {
	        return arrayConcat(isArray(array) ? array : [toObject(array)], values);
	      });
	    });
	
	    /**
	     * Creates a clone of the chained sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).map(function(value) {
	     *   return Math.pow(value, 2);
	     * });
	     *
	     * var other = [3, 4];
	     * var otherWrapped = wrapped.plant(other);
	     *
	     * otherWrapped.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * Reverses the wrapped array so the first element becomes the last, the
	     * second element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	
	      var interceptor = function(value) {
	        return (wrapped && wrapped.__dir__ < 0) ? value : value.reverse();
	      };
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(interceptor);
	    }
	
	    /**
	     * Produces the result of coercing the unwrapped value to a string.
	     *
	     * @name toString
	     * @memberOf _
	     * @category Chain
	     * @returns {string} Returns the coerced string value.
	     * @example
	     *
	     * _([1, 2, 3]).toString();
	     * // => '1,2,3'
	     */
	    function wrapperToString() {
	      return (this.value() + '');
	    }
	
	    /**
	     * Executes the chained sequence to extract the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @alias run, toJSON, valueOf
	     * @category Chain
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements corresponding to the given keys, or indexes,
	     * of `collection`. Keys may be specified as individual arguments or as arrays
	     * of keys.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(number|number[]|string|string[])} [props] The property names
	     *  or indexes of elements to pick, specified individually or in arrays.
	     * @returns {Array} Returns the new array of picked elements.
	     * @example
	     *
	     * _.at(['a', 'b', 'c'], [0, 2]);
	     * // => ['a', 'c']
	     *
	     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
	     * // => ['barney', 'pebbles']
	     */
	    var at = restParam(function(collection, props) {
	      return baseAt(collection, baseFlatten(props));
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the number of times the key was returned by `iteratee`.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * The predicate is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias all
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': false },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.every(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias select
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.filter([4, 5, 6], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 6]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.filter(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.filter(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function filter(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias detect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.result(_.find(users, function(chr) {
	     *   return chr.age < 40;
	     * }), 'user');
	     * // => 'barney'
	     *
	     * // using the `_.matches` callback shorthand
	     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.result(_.find(users, 'active', false), 'user');
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.result(_.find(users, 'active'), 'user');
	     * // => 'barney'
	     */
	    var find = createFind(baseEach);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(baseEachRight, true);
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning the first element that has equivalent property
	     * values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
	     * // => 'barney'
	     *
	     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
	     * // => 'fred'
	     */
	    function findWhere(collection, source) {
	      return find(collection, baseMatches(source));
	    }
	
	    /**
	     * Iterates over elements of `collection` invoking `iteratee` for each element.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection). Iteratee functions may exit iteration early
	     * by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length" property
	     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
	     * may be used for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @alias each
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEach(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from left to right and returns the array
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
	     *   console.log(n, key);
	     * });
	     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
	     */
	    var forEach = createForEach(arrayEach, baseEach);
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEachRight(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from right to left and returns the array
	     */
	    var forEachRight = createForEach(arrayEachRight, baseEachRight);
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is an array of the elements responsible for generating the key.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * // using the `_.property` callback shorthand
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        result[key] = [value];
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @alias contains, include
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {*} target The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
	     * // => true
	     *
	     * _.includes('pebbles', 'eb');
	     * // => true
	     */
	    function includes(collection, target, fromIndex, guard) {
	      var length = collection ? getLength(collection) : 0;
	      if (!isLength(length)) {
	        collection = values(collection);
	        length = collection.length;
	      }
	      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
	        fromIndex = 0;
	      } else {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
	      }
	      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
	        ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
	        : (!!length && getIndexOf(collection, target, fromIndex) > -1);
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the last element responsible for generating the key. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var keyData = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.indexBy(keyData, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return String.fromCharCode(object.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return this.fromCharCode(object.code);
	     * }, String);
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     */
	    var indexBy = createAggregator(function(result, value, key) {
	      result[key] = value;
	    });
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `methodName` is a function it is
	     * invoked for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invoke([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invoke = restParam(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          isProp = isKey(path),
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
	        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` through
	     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
	     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
	     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
	     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
	     * `sum`, `uniq`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @alias collect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function timesThree(n) {
	     *   return n * 3;
	     * }
	     *
	     * _.map([1, 2], timesThree);
	     * // => [3, 6]
	     *
	     * _.map({ 'a': 1, 'b': 2 }, timesThree);
	     * // => [3, 6] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee, thisArg) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return func(collection, iteratee);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, while the second of which
	     * contains elements `predicate` returns falsey for. The predicate is bound
	     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * _.partition([1, 2, 3], function(n) {
	     *   return n % 2;
	     * });
	     * // => [[1, 3], [2]]
	     *
	     * _.partition([1.2, 2.3, 3.4], function(n) {
	     *   return this.floor(n) % 2;
	     * }, Math);
	     * // => [[1.2, 3.4], [2.3]]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * var mapper = function(array) {
	     *   return _.pluck(array, 'user');
	     * };
	     *
	     * // using the `_.matches` callback shorthand
	     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
	     * // => [['pebbles'], ['barney', 'fred']]
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.map(_.partition(users, 'active', false), mapper);
	     * // => [['barney', 'pebbles'], ['fred']]
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(_.partition(users, 'active'), mapper);
	     * // => [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Gets the property value of `path` from all elements in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|string} path The path of the property to pluck.
	     * @returns {Array} Returns the property values.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.pluck(users, 'user');
	     * // => ['barney', 'fred']
	     *
	     * var userIndex = _.indexBy(users, 'user');
	     * _.pluck(userIndex, 'age');
	     * // => [36, 40] (iteration order is not guaranteed)
	     */
	    function pluck(collection, path) {
	      return map(collection, property(path));
	    }
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` through `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not provided the first element of `collection` is used as the initial
	     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
	     * and `sortByOrder`
	     *
	     * @static
	     * @memberOf _
	     * @alias foldl, inject
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.reduce([1, 2], function(total, n) {
	     *   return total + n;
	     * });
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     *   return result;
	     * }, {});
	     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
	     */
	    var reduce = createReduce(arrayReduce, baseEach);
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias foldr
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    var reduceRight = createReduce(arrayReduceRight, baseEachRight);
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.reject([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [1, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.reject(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.reject(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function reject(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, function(value, index, collection) {
	        return !predicate(value, index, collection);
	      });
	    }
	
	    /**
	     * Gets a random element or `n` random elements from a collection.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to sample.
	     * @param {number} [n] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {*} Returns the random sample(s).
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     *
	     * _.sample([1, 2, 3, 4], 2);
	     * // => [3, 1]
	     */
	    function sample(collection, n, guard) {
	      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
	        collection = toIterable(collection);
	        var length = collection.length;
	        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
	      }
	      var index = -1,
	          result = toArray(collection),
	          length = result.length,
	          lastIndex = length - 1;
	
	      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
	      while (++index < n) {
	        var rand = baseRandom(index, lastIndex),
	            value = result[rand];
	
	        result[rand] = result[index];
	        result[index] = value;
	      }
	      result.length = n;
	      return result;
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      return sample(collection, POSITIVE_INFINITY);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the size of `collection`.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      var length = collection ? getLength(collection) : 0;
	      return isLength(length) ? length : keys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * The function returns as soon as it finds a passing value and does not iterate
	     * over the entire collection. The predicate is bound to `thisArg` and invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias any
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.some(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection through `iteratee`. This method performs
	     * a stable sort, that is, it preserves the original sort order of equal elements.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return Math.sin(n);
	     * });
	     * // => [3, 1, 2]
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return this.sin(n);
	     * }, Math);
	     * // => [3, 1, 2]
	     *
	     * var users = [
	     *   { 'user': 'fred' },
	     *   { 'user': 'pebbles' },
	     *   { 'user': 'barney' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.sortBy(users, 'user'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function sortBy(collection, iteratee, thisArg) {
	      if (collection == null) {
	        return [];
	      }
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      var index = -1;
	      iteratee = getCallback(iteratee, thisArg, 3);
	
	      var result = baseMap(collection, function(value, key, collection) {
	        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
	      });
	      return baseSortBy(result, compareAscending);
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it can sort by multiple iteratees
	     * or property names.
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
	     *  The iteratees to sort by, specified as individual values or arrays of values.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
	     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
	     *
	     * _.map(_.sortByAll(users, 'user', function(chr) {
	     *   return Math.floor(chr.age / 10);
	     * }), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    var sortByAll = restParam(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var guard = iteratees[2];
	      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
	        iteratees.length = 1;
	      }
	      return baseSortByOrder(collection, baseFlatten(iteratees), []);
	    });
	
	    /**
	     * This method is like `_.sortByAll` except that it allows specifying the
	     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
	     * values are sorted in ascending order. Otherwise, a value is sorted in
	     * ascending order if its corresponding order is "asc", and descending if "desc".
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // sort by `user` in ascending order and by `age` in descending order
	     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    function sortByOrder(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (guard && isIterateeCall(iteratees, orders, guard)) {
	        orders = undefined;
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseSortByOrder(collection, iteratees, orders);
	    }
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning an array of all elements that have equivalent
	     * property values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
	     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
	     * ];
	     *
	     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
	     * // => ['fred']
	     */
	    function where(collection, source) {
	      return filter(collection, baseMatches(source));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the number of milliseconds that have elapsed since the Unix epoch
	     * (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @category Date
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => logs the number of milliseconds it took for the deferred function to be invoked
	     */
	    var now = nativeNow || function() {
	      return new Date().getTime();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it is called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => logs 'done saving!' after the two async saves have completed
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      n = nativeIsFinite(n = +n) ? n : 0;
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that accepts up to `n` arguments ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      if (guard && isIterateeCall(func, n, guard)) {
	        n = undefined;
	      }
	      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
	      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it is called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery('#add').on('click', _.before(5, addContactToList));
	     * // => allows adding up to 4 contacts to the list
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and prepends any additional `_.bind` arguments to those provided to the
	     * bound function.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind` this method does not set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var greet = function(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * };
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // using placeholders
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = restParam(function(func, thisArg, partials) {
	      var bitmask = BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bind.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method. Method names may be specified as individual arguments or as arrays
	     * of method names. If no method names are provided all enumerable function
	     * properties, own and inherited, of `object` are bound.
	     *
	     * **Note:** This method does not set the "length" property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} [methodNames] The object method names to bind,
	     *  specified as individual method names or arrays of method names.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'onClick': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view);
	     * jQuery('#docs').on('click', view.onClick);
	     * // => logs 'clicked docs' when the element is clicked
	     */
	    var bindAll = restParam(function(object, methodNames) {
	      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);
	
	      var index = -1,
	          length = methodNames.length;
	
	      while (++index < length) {
	        var key = methodNames[index];
	        object[key] = createWrapper(object[key], BIND_FLAG, object);
	      }
	      return object;
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` and prepends
	     * any additional `_.bindKey` arguments to those provided to the bound function.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist.
	     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object the method belongs to.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // using placeholders
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = restParam(function(object, key, partials) {
	      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bindKey.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts one or more arguments of `func` that when
	     * called either invokes `func` returning its result, if all `func` arguments
	     * have been provided, or returns a function that accepts one or more of the
	     * remaining `func` arguments, and so on. The arity of `func` may be specified
	     * if `func.length` is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    var curry = createCurry(CURRY_FLAG);
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    var curryRight = createCurry(CURRY_RIGHT_FLAG);
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed invocations. Provide an options object to indicate that `func`
	     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
	     * Subsequent calls to the debounced function return the result of the last
	     * `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the debounced function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=false] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
	     *  delayed before it is invoked.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // avoid costly calculations while the window size is in flux
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
	     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // ensure `batchLog` is invoked once after 1 second of debounced calls
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', _.debounce(batchLog, 250, {
	     *   'maxWait': 1000
	     * }));
	     *
	     * // cancel a debounced call
	     * var todoChanges = _.debounce(batchLog, 1000);
	     * Object.observe(models.todo, todoChanges);
	     *
	     * Object.observe(models, function(changes) {
	     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
	     *     todoChanges.cancel();
	     *   }
	     * }, ['delete']);
	     *
	     * // ...at some point `models.todo` is changed
	     * models.todo.completed = true;
	     *
	     * // ...before 1 second has passed `models.todo` is deleted
	     * // which cancels the debounced `todoChanges` call
	     * delete models.todo;
	     */
	    function debounce(func, wait, options) {
	      var args,
	          maxTimeoutId,
	          result,
	          stamp,
	          thisArg,
	          timeoutId,
	          trailingCall,
	          lastCalled = 0,
	          maxWait = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = wait < 0 ? 0 : (+wait || 0);
	      if (options === true) {
	        var leading = true;
	        trailing = false;
	      } else if (isObject(options)) {
	        leading = !!options.leading;
	        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function cancel() {
	        if (timeoutId) {
	          clearTimeout(timeoutId);
	        }
	        if (maxTimeoutId) {
	          clearTimeout(maxTimeoutId);
	        }
	        lastCalled = 0;
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	      }
	
	      function complete(isCalled, id) {
	        if (id) {
	          clearTimeout(id);
	        }
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	        if (isCalled) {
	          lastCalled = now();
	          result = func.apply(thisArg, args);
	          if (!timeoutId && !maxTimeoutId) {
	            args = thisArg = undefined;
	          }
	        }
	      }
	
	      function delayed() {
	        var remaining = wait - (now() - stamp);
	        if (remaining <= 0 || remaining > wait) {
	          complete(trailingCall, maxTimeoutId);
	        } else {
	          timeoutId = setTimeout(delayed, remaining);
	        }
	      }
	
	      function maxDelayed() {
	        complete(trailing, timeoutId);
	      }
	
	      function debounced() {
	        args = arguments;
	        stamp = now();
	        thisArg = this;
	        trailingCall = trailing && (timeoutId || !leading);
	
	        if (maxWait === false) {
	          var leadingCall = leading && !timeoutId;
	        } else {
	          if (!maxTimeoutId && !leading) {
	            lastCalled = stamp;
	          }
	          var remaining = maxWait - (stamp - lastCalled),
	              isCalled = remaining <= 0 || remaining > maxWait;
	
	          if (isCalled) {
	            if (maxTimeoutId) {
	              maxTimeoutId = clearTimeout(maxTimeoutId);
	            }
	            lastCalled = stamp;
	            result = func.apply(thisArg, args);
	          }
	          else if (!maxTimeoutId) {
	            maxTimeoutId = setTimeout(maxDelayed, remaining);
	          }
	        }
	        if (isCalled && timeoutId) {
	          timeoutId = clearTimeout(timeoutId);
	        }
	        else if (!timeoutId && wait !== maxWait) {
	          timeoutId = setTimeout(delayed, wait);
	        }
	        if (leadingCall) {
	          isCalled = true;
	          result = func.apply(thisArg, args);
	        }
	        if (isCalled && !timeoutId && !maxTimeoutId) {
	          args = thisArg = undefined;
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // logs 'deferred' after one or more milliseconds
	     */
	    var defer = restParam(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => logs 'later' after one second
	     */
	    var delay = restParam(function(func, wait, args) {
	      return baseDelay(func, wait, args);
	    });
	
	    /**
	     * Creates a function that returns the result of invoking the provided
	     * functions with the `this` binding of the created function, where each
	     * successive invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow(_.add, square);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the provided functions from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias backflow, compose
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight(square, _.add);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is coerced to a string and used as the
	     * cache key. The `func` is invoked with the `this` binding of the memoized
	     * function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoizing function.
	     * @example
	     *
	     * var upperCase = _.memoize(function(string) {
	     *   return string.toUpperCase();
	     * });
	     *
	     * upperCase('fred');
	     * // => 'FRED'
	     *
	     * // modifying the result cache
	     * upperCase.cache.set('fred', 'BARNEY');
	     * upperCase('fred');
	     * // => 'BARNEY'
	     *
	     * // replacing `_.memoize.Cache`
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'barney' };
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'fred' }
	     *
	     * _.memoize.Cache = WeakMap;
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'barney' }
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result);
	        return result;
	      };
	      memoized.cache = new memoize.Cache;
	      return memoized;
	    }
	
	    /**
	     * Creates a function that runs each argument through a corresponding
	     * transform function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms] The functions to transform
	     * arguments, specified as individual functions or arrays of functions.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var modded = _.modArgs(function(x, y) {
	     *   return [x, y];
	     * }, square, doubled);
	     *
	     * modded(1, 2);
	     * // => [1, 4]
	     *
	     * modded(5, 10);
	     * // => [25, 20]
	     */
	    var modArgs = restParam(function(func, transforms) {
	      transforms = baseFlatten(transforms);
	      if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = transforms.length;
	      return restParam(function(args) {
	        var index = nativeMin(args.length, length);
	        while (index--) {
	          args[index] = transforms[index](args[index]);
	        }
	        return func.apply(this, args);
	      });
	    });
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        return !predicate.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first call. The `func` is invoked
	     * with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // `initialize` invokes `createApplication` once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with `partial` arguments prepended
	     * to those provided to the new function. This method is like `_.bind` except
	     * it does **not** alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // using placeholders
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = createPartial(PARTIAL_FLAG);
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to those provided to the new function.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // using placeholders
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified indexes where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, 2, 0, 1);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     *
	     * var map = _.rearg(_.map, [1, 0]);
	     * map(function(n) {
	     *   return n * 3;
	     * }, [1, 2, 3]);
	     * // => [3, 6, 9]
	     */
	    var rearg = restParam(function(func, indexes) {
	      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as an array.
	     *
	     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.restParam(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function restParam(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            rest = Array(length);
	
	        while (++index < length) {
	          rest[index] = args[start + index];
	        }
	        switch (start) {
	          case 0: return func.call(this, rest);
	          case 1: return func.call(this, args[0], rest);
	          case 2: return func.call(this, args[0], args[1], rest);
	        }
	        var otherArgs = Array(start + 1);
	        index = -1;
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = rest;
	        return func.apply(this, otherArgs);
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the created
	     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
	     *
	     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * // with a Promise
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function(array) {
	        return func.apply(this, array);
	      };
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed invocations. Provide an options object to indicate
	     * that `func` should be invoked on the leading and/or trailing edge of the
	     * `wait` timeout. Subsequent calls to the throttled function return the
	     * result of the last `func` call.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the throttled function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=true] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // avoid excessively updating the position while scrolling
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
	     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
	     *   'trailing': false
	     * }));
	     *
	     * // cancel a trailing throttled call
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (options === false) {
	        leading = false;
	      } else if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
	    }
	
	    /**
	     * Creates a function that provides `value` to the wrapper function as its
	     * first argument. Any additional arguments provided to the function are
	     * appended to those provided to the wrapper function. The wrapper is invoked
	     * with the `this` binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} wrapper The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      wrapper = wrapper == null ? identity : wrapper;
	      return createWrapper(wrapper, PARTIAL_FLAG, undefined, [value], []);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
	     * otherwise they are assigned by reference. If `customizer` is provided it is
	     * invoked to produce the cloned values. If `customizer` returns `undefined`
	     * cloning is handled by the method instead. The `customizer` is bound to
	     * `thisArg` and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var shallow = _.clone(users);
	     * shallow[0] === users[0];
	     * // => true
	     *
	     * var deep = _.clone(users, true);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.clone(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 0
	     */
	    function clone(value, isDeep, customizer, thisArg) {
	      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
	        isDeep = false;
	      }
	      else if (typeof isDeep == 'function') {
	        thisArg = customizer;
	        customizer = isDeep;
	        isDeep = false;
	      }
	      return typeof customizer == 'function'
	        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, isDeep);
	    }
	
	    /**
	     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
	     * to produce the cloned values. If `customizer` returns `undefined` cloning
	     * is handled by the method instead. The `customizer` is bound to `thisArg`
	     * and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the deep cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var deep = _.cloneDeep(users);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.cloneDeep(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 20
	     */
	    function cloneDeep(value, customizer, thisArg) {
	      return typeof customizer == 'function'
	        ? baseClone(value, true, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, true);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    function gt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    function gte(value, other) {
	      return value >= other;
	    }
	
	    /**
	     * Checks if `value` is classified as an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    function isArguments(value) {
	      return isObjectLike(value) && isArrayLike(value) &&
	        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	    }
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(function() { return arguments; }());
	     * // => false
	     */
	    var isArray = nativeIsArray || function(value) {
	      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	    };
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    function isDate(value) {
	      return isObjectLike(value) && objToString.call(value) == dateTag;
	    }
	
	    /**
	     * Checks if `value` is a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is empty. A value is considered empty unless it is an
	     * `arguments` object, array, string, or jQuery-like collection with a length
	     * greater than `0` or an object with own enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Array|Object|string} value The value to inspect.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
	          (isObjectLike(value) && isFunction(value.splice)))) {
	        return !value.length;
	      }
	      return !keys(value).length;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent. If `customizer` is provided it is invoked to compare values.
	     * If `customizer` returns `undefined` comparisons are handled by the method
	     * instead. The `customizer` is bound to `thisArg` and invoked with three
	     * arguments: (value, other [, index|key]).
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. Functions and DOM nodes
	     * are **not** supported. Provide a customizer function to extend support
	     * for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @alias eq
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * object == other;
	     * // => false
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * // using a customizer callback
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqual(array, other, function(value, other) {
	     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
	     *     return true;
	     *   }
	     * });
	     * // => true
	     */
	    function isEqual(value, other, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(10);
	     * // => true
	     *
	     * _.isFinite('10');
	     * // => false
	     *
	     * _.isFinite(true);
	     * // => false
	     *
	     * _.isFinite(Object(10));
	     * // => false
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in older versions of Chrome and Safari which return 'function' for regexes
	      // and Safari 8 equivalents which return 'object' for typed array constructors.
	      return isObject(value) && objToString.call(value) == funcTag;
	    }
	
	    /**
	     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(1);
	     * // => false
	     */
	    function isObject(value) {
	      // Avoid a V8 JIT bug in Chrome 19-20.
	      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	      var type = typeof value;
	      return !!value && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Performs a deep comparison between `object` and `source` to determine if
	     * `object` contains equivalent property values. If `customizer` is provided
	     * it is invoked to compare values. If `customizer` returns `undefined`
	     * comparisons are handled by the method instead. The `customizer` is bound
	     * to `thisArg` and invoked with three arguments: (value, other, index|key).
	     *
	     * **Note:** This method supports comparing properties of arrays, booleans,
	     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
	     * and DOM nodes are **not** supported. Provide a customizer function to extend
	     * support for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.isMatch(object, { 'age': 40 });
	     * // => true
	     *
	     * _.isMatch(object, { 'age': 36 });
	     * // => false
	     *
	     * // using a customizer callback
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatch(object, source, function(value, other) {
	     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
	     * });
	     * // => true
	     */
	    function isMatch(object, source, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      return baseIsMatch(object, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
	     * which returns `true` for `undefined` and other non-numeric values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a native function.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (value == null) {
	        return false;
	      }
	      if (isFunction(value)) {
	        return reIsNative.test(fnToString.call(value));
	      }
	      return isObjectLike(value) && reIsHostCtor.test(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
	     * as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isNumber(8.4);
	     * // => true
	     *
	     * _.isNumber(NaN);
	     * // => true
	     *
	     * _.isNumber('8.4');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * **Note:** This method assumes objects created by the `Object` constructor
	     * have no inherited enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      var Ctor;
	
	      // Exit early for non `Object` objects.
	      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	          (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	        return false;
	      }
	      // IE < 9 iterates inherited properties before own properties. If the first
	      // iterated property is an object's own property then there are no inherited
	      // enumerable properties.
	      var result;
	      // In most environments an object's own properties are iterated before
	      // its inherited properties. If the last iterated property is an object's
	      // own property then there are no inherited enumerable properties.
	      baseForIn(value, function(subValue, key) {
	        result = key;
	      });
	      return result === undefined || hasOwnProperty.call(value, result);
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    function isRegExp(value) {
	      return isObject(value) && objToString.call(value) == regexpTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    function isTypedArray(value) {
	      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	    }
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    function lt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    function lte(value, other) {
	      return value <= other;
	    }
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * (function() {
	     *   return _.toArray(arguments).slice(1);
	     * }(1, 2, 3));
	     * // => [2, 3]
	     */
	    function toArray(value) {
	      var length = value ? getLength(value) : 0;
	      if (!isLength(length)) {
	        return values(value);
	      }
	      if (!length) {
	        return [];
	      }
	      return arrayCopy(value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable
	     * properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return baseCopy(value, keysIn(value));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Recursively merges own enumerable properties of the source object(s), that
	     * don't resolve to `undefined` into the destination object. Subsequent sources
	     * overwrite property assignments of previous sources. If `customizer` is
	     * provided it is invoked to produce the merged values of the destination and
	     * source properties. If `customizer` returns `undefined` merging is handled
	     * by the method instead. The `customizer` is bound to `thisArg` and invoked
	     * with five arguments: (objectValue, sourceValue, key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var users = {
	     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	     * };
	     *
	     * var ages = {
	     *   'data': [{ 'age': 36 }, { 'age': 40 }]
	     * };
	     *
	     * _.merge(users, ages);
	     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	     *
	     * // using a customizer callback
	     * var object = {
	     *   'fruits': ['apple'],
	     *   'vegetables': ['beet']
	     * };
	     *
	     * var other = {
	     *   'fruits': ['banana'],
	     *   'vegetables': ['carrot']
	     * };
	     *
	     * _.merge(object, other, function(a, b) {
	     *   if (_.isArray(a)) {
	     *     return a.concat(b);
	     *   }
	     * });
	     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	     */
	    var merge = createAssigner(baseMerge);
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object. Subsequent sources overwrite property assignments of previous sources.
	     * If `customizer` is provided it is invoked to produce the assigned values.
	     * The `customizer` is bound to `thisArg` and invoked with five arguments:
	     * (objectValue, sourceValue, key, object, source).
	     *
	     * **Note:** This method mutates `object` and is based on
	     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
	     *
	     * @static
	     * @memberOf _
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using a customizer callback
	     * var defaults = _.partialRight(_.assign, function(value, other) {
	     *   return _.isUndefined(value) ? other : value;
	     * });
	     *
	     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var assign = createAssigner(function(object, source, customizer) {
	      return customizer
	        ? assignWith(object, source, customizer)
	        : baseAssign(object, source);
	    });
	
	    /**
	     * Creates an object that inherits from the given `prototype` object. If a
	     * `properties` object is provided its own enumerable properties are assigned
	     * to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties, guard) {
	      var result = baseCreate(prototype);
	      if (guard && isIterateeCall(prototype, properties, guard)) {
	        properties = undefined;
	      }
	      return properties ? baseAssign(result, properties) : result;
	    }
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object for all destination properties that resolve to `undefined`. Once a
	     * property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var defaults = createDefaults(assign, assignDefaults);
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
	     * // => { 'user': { 'name': 'barney', 'age': 36 } }
	     *
	     */
	    var defaultsDeep = createDefaults(merge, mergeDefaults);
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    var findKey = createFindKey(baseForOwn);
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => returns `pebbles` assuming `_.findKey` returns `barney`
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    var findLastKey = createFindKey(baseForOwnRight);
	
	    /**
	     * Iterates over own and inherited enumerable properties of an object invoking
	     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
	     */
	    var forIn = createForIn(baseFor);
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
	     */
	    var forInRight = createForIn(baseForRight);
	
	    /**
	     * Iterates over own enumerable properties of an object invoking `iteratee`
	     * for each property. The `iteratee` is bound to `thisArg` and invoked with
	     * three arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a' and 'b' (iteration order is not guaranteed)
	     */
	    var forOwn = createForOwn(baseForOwn);
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
	     */
	    var forOwnRight = createForOwn(baseForOwnRight);
	
	    /**
	     * Creates an array of function property names from all enumerable properties,
	     * own and inherited, of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @alias methods
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the new array of property names.
	     * @example
	     *
	     * _.functions(_);
	     * // => ['after', 'ary', 'assign', ...]
	     */
	    function functions(object) {
	      return baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the property value at `path` of `object`. If the resolved value is
	     * `undefined` the `defaultValue` is used in its place.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': { 'c': 3 } } };
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b.c');
	     * // => true
	     *
	     * _.has(object, ['a', 'b', 'c']);
	     * // => true
	     */
	    function has(object, path) {
	      if (object == null) {
	        return false;
	      }
	      var result = hasOwnProperty.call(object, path);
	      if (!result && !isKey(path)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        if (object == null) {
	          return false;
	        }
	        path = last(path);
	        result = hasOwnProperty.call(object, path);
	      }
	      return result || (isLength(object.length) && isIndex(path, object.length) &&
	        (isArray(object) || isArguments(object)));
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite property
	     * assignments of previous values unless `multiValue` is `true`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {boolean} [multiValue] Allow multiple values per key.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     *
	     * // with `multiValue`
	     * _.invert(object, true);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function invert(object, multiValue, guard) {
	      if (guard && isIterateeCall(object, multiValue, guard)) {
	        multiValue = undefined;
	      }
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key];
	
	        if (multiValue) {
	          if (hasOwnProperty.call(result, value)) {
	            result[value].push(key);
	          } else {
	            result[value] = [key];
	          }
	        }
	        else {
	          result[value] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    var keys = !nativeKeys ? shimKeys : function(object) {
	      var Ctor = object == null ? undefined : object.constructor;
	      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	          (typeof object != 'function' && isArrayLike(object))) {
	        return shimKeys(object);
	      }
	      return isObject(object) ? nativeKeys(object) : [];
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      if (object == null) {
	        return [];
	      }
	      if (!isObject(object)) {
	        object = Object(object);
	      }
	      var length = object.length;
	      length = (length && isLength(length) &&
	        (isArray(object) || isArguments(object)) && length) || 0;
	
	      var Ctor = object.constructor,
	          index = -1,
	          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	          result = Array(length),
	          skipIndexes = length > 0;
	
	      while (++index < length) {
	        result[index] = (index + '');
	      }
	      for (var key in object) {
	        if (!(skipIndexes && isIndex(key, length)) &&
	            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * property of `object` through `iteratee`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    var mapKeys = createObjectMapper(true);
	
	    /**
	     * Creates an object with the same keys as `object` and values generated by
	     * running each own enumerable property of `object` through `iteratee`. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, key, object).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
	     *   return n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * // using the `_.property` callback shorthand
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    var mapValues = createObjectMapper();
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable properties of `object` that are not omitted.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to omit, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.omit(object, 'age');
	     * // => { 'user': 'fred' }
	     *
	     * _.omit(object, _.isNumber);
	     * // => { 'user': 'fred' }
	     */
	    var omit = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      if (typeof props[0] != 'function') {
	        var props = arrayMap(baseFlatten(props), String);
	        return pickByArray(object, baseDifference(keysIn(object), props));
	      }
	      var predicate = bindCallback(props[0], props[1], 3);
	      return pickByCallback(object, function(value, key, object) {
	        return !predicate(value, key, object);
	      });
	    });
	
	    /**
	     * Creates a two dimensional array of the key-value pairs for `object`,
	     * e.g. `[[key1, value1], [key2, value2]]`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the new array of key-value pairs.
	     * @example
	     *
	     * _.pairs({ 'barney': 36, 'fred': 40 });
	     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	     */
	    function pairs(object) {
	      object = toObject(object);
	
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        var key = props[index];
	        result[index] = [key, object[key]];
	      }
	      return result;
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties. Property
	     * names may be specified as individual arguments or as arrays of property
	     * names. If `predicate` is provided it is invoked for each property of `object`
	     * picking the properties `predicate` returns truthy for. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to pick, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.pick(object, 'user');
	     * // => { 'user': 'fred' }
	     *
	     * _.pick(object, _.isString);
	     * // => { 'user': 'fred' }
	     */
	    var pick = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      return typeof props[0] == 'function'
	        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
	        : pickByArray(object, baseFlatten(props));
	    });
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a function
	     * it is invoked with the `this` binding of its parent object and its result
	     * is returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a.b.c', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a.b.c', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      var result = object == null ? undefined : object[path];
	      if (result === undefined) {
	        if (object != null && !isKey(path, object)) {
	          path = toPath(path);
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          result = object == null ? undefined : object[last(path)];
	        }
	        result = result === undefined ? defaultValue : result;
	      }
	      return isFunction(result) ? result.call(object) : result;
	    }
	
	    /**
	     * Sets the property value of `path` on `object`. If a portion of `path`
	     * does not exist it is created.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to augment.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, 'x[0].y.z', 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      if (object == null) {
	        return object;
	      }
	      var pathKey = (path + '');
	      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = path[index];
	        if (isObject(nested)) {
	          if (index == lastIndex) {
	            nested[key] = value;
	          } else if (nested[key] == null) {
	            nested[key] = isIndex(path[index + 1]) ? [] : {};
	          }
	        }
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own enumerable
	     * properties through `iteratee`, with each invocation potentially mutating
	     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
	     * with four arguments: (accumulator, value, key, object). Iteratee functions
	     * may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Array|Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     */
	    function transform(object, iteratee, accumulator, thisArg) {
	      var isArr = isArray(object) || isTypedArray(object);
	      iteratee = getCallback(iteratee, thisArg, 4);
	
	      if (accumulator == null) {
	        if (isArr || isObject(object)) {
	          var Ctor = object.constructor;
	          if (isArr) {
	            accumulator = isArray(object) ? new Ctor : [];
	          } else {
	            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
	          }
	        } else {
	          accumulator = {};
	        }
	      }
	      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Creates an array of the own enumerable property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property values
	     * of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Checks if `n` is between `start` and up to but not including, `end`. If
	     * `end` is not specified it is set to `start` with `start` then set to `0`.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} n The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     */
	    function inRange(value, start, end) {
	      start = +start || 0;
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      return value >= nativeMin(start, end) && value < nativeMax(start, end);
	    }
	
	    /**
	     * Produces a random number between `min` and `max` (inclusive). If only one
	     * argument is provided a number between `0` and the given number is returned.
	     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
	     * number is returned instead of an integer.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} [min=0] The minimum possible value.
	     * @param {number} [max=1] The maximum possible value.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(min, max, floating) {
	      if (floating && isIterateeCall(min, max, floating)) {
	        max = floating = undefined;
	      }
	      var noMin = min == null,
	          noMax = max == null;
	
	      if (floating == null) {
	        if (noMax && typeof min == 'boolean') {
	          floating = min;
	          min = 1;
	        }
	        else if (typeof max == 'boolean') {
	          floating = max;
	          noMax = true;
	        }
	      }
	      if (noMin && noMax) {
	        max = 1;
	        noMax = false;
	      }
	      min = +min || 0;
	      if (noMax) {
	        max = min;
	        min = 0;
	      } else {
	        max = +max || 0;
	      }
	      if (floating || min % 1 || max % 1) {
	        var rand = nativeRandom();
	        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
	      }
	      return baseRandom(min, max);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__foo_bar__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
	    });
	
	    /**
	     * Capitalizes the first character of `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('fred');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      string = baseToString(string);
	      return string && (string.charAt(0).toUpperCase() + string.slice(1));
	    }
	
	    /**
	     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = baseToString(string);
	      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search from.
	     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = baseToString(string);
	      target = (target + '');
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : nativeMin(position < 0 ? 0 : (+position || 0), length);
	
	      position -= target.length;
	      return position >= 0 && string.indexOf(target, position) == position;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
	     * their corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional characters
	     * use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value.
	     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * Backticks are escaped because in Internet Explorer < 9, they can break out
	     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
	     * for more details.
	     *
	     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
	     * to reduce XSS vectors.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
	      string = baseToString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
	     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
	     */
	    function escapeRegExp(string) {
	      string = baseToString(string);
	      return (string && reHasRegExpChars.test(string))
	        ? string.replace(reRegExpChars, escapeRegExpChar)
	        : (string || '(?:)');
	    }
	
	    /**
	     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__foo_bar__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = baseToString(string);
	      length = +length;
	
	      var strLength = string.length;
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return string;
	      }
	      var mid = (length - strLength) / 2,
	          leftLength = nativeFloor(mid),
	          rightLength = nativeCeil(mid);
	
	      chars = createPadding('', rightLength, chars);
	      return chars.slice(0, leftLength) + string + chars;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padLeft('abc', 6);
	     * // => '   abc'
	     *
	     * _.padLeft('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padLeft('abc', 3);
	     * // => 'abc'
	     */
	    var padLeft = createPadDir();
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padRight('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padRight('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padRight('abc', 3);
	     * // => 'abc'
	     */
	    var padRight = createPadDir(true);
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
	     * in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
	     * of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
	      // Chrome fails to trim leading <BOM> whitespace characters.
	      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
	      if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      string = trim(string);
	      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=0] The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n) {
	      var result = '';
	      string = baseToString(string);
	      n = +n;
	      if (n < 1 || !string || !nativeIsFinite(n)) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        string += string;
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--foo-bar');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__foo_bar__');
	     * // => 'Foo Bar'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = baseToString(string);
	      position = position == null
	        ? 0
	        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);
	
	      return string.lastIndexOf(target, position) == position;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is provided it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options] The options object.
	     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
	     * @param {Object} [options.imports] An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
	     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
	     * @param {string} [options.variable] The data object variable name.
	     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // using the "interpolate" delimiter to create a compiled template
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // using the HTML "escape" delimiter to escape data property values
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the internal `print` function in "evaluate" delimiters
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // using custom template delimiters
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // using backslashes to treat delimiters as plain text
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // using the `imports` option to import `jQuery` as `jq`
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the `sourceURL` option to specify a custom sourceURL for the template
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
	     *
	     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // using the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and a stack trace
	     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, otherOptions) {
	      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
	        options = otherOptions = undefined;
	      }
	      string = baseToString(string);
	      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);
	
	      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products requires returning the `match`
	        // string in order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
	      }
	      chars = (chars + '');
	      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimLeft('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimLeft('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimLeft(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string));
	      }
	      return string.slice(charsLeftIndex(string, (chars + '')));
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimRight('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimRight('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimRight(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(0, trimmedRightIndex(string) + 1);
	      }
	      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object|number} [options] The options object or maximum string length.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.trunc('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', 24);
	     * // => 'hi-diddly-ho there, n...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function trunc(string, options, guard) {
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (options != null) {
	        if (isObject(options)) {
	          var separator = 'separator' in options ? options.separator : separator;
	          length = 'length' in options ? (+options.length || 0) : length;
	          omission = 'omission' in options ? baseToString(options.omission) : omission;
	        } else {
	          length = +options || 0;
	        }
	      }
	      string = baseToString(string);
	      if (length >= string.length) {
	        return string;
	      }
	      var end = length - omission.length;
	      if (end < 1) {
	        return omission;
	      }
	      var result = string.slice(0, end);
	      if (separator == null) {
	        return result + omission;
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              newEnd,
	              substring = string.slice(0, end);
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            newEnd = match.index;
	          }
	          result = result.slice(0, newEnd == null ? end : newEnd);
	        }
	      } else if (string.indexOf(separator, end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
	     * corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
	     * entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = baseToString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      if (guard && isIterateeCall(string, pattern, guard)) {
	        pattern = undefined;
	      }
	      string = baseToString(string);
	      return string.match(pattern || reWords) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function} func The function to attempt.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // avoid throwing errors for invalid selectors
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = restParam(function(func, args) {
	      try {
	        return func.apply(undefined, args);
	      } catch(e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and arguments of the created function. If `func` is a property name the
	     * created callback returns the property value for a given element. If `func`
	     * is an object the created callback returns `true` for elements that contain
	     * the equivalent object properties, otherwise it returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias iteratee
	     * @category Utility
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // wrap to create custom callback shorthands
	     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
	     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
	     *   if (!match) {
	     *     return callback(func, thisArg);
	     *   }
	     *   return function(object) {
	     *     return match[2] == 'gt'
	     *       ? object[match[1]] > match[3]
	     *       : object[match[1]] < match[3];
	     *   };
	     * });
	     *
	     * _.filter(users, 'age__gt36');
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     */
	    function callback(func, thisArg, guard) {
	      if (guard && isIterateeCall(func, thisArg, guard)) {
	        thisArg = undefined;
	      }
	      return isObjectLike(func)
	        ? matches(func)
	        : baseCallback(func, thisArg);
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var getter = _.constant(object);
	     *
	     * getter() === object;
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * This method returns the first argument provided to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.identity(object) === object;
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that performs a deep comparison between a given object
	     * and `source`, returning `true` if the given object has equivalent property
	     * values, else `false`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
	     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that compares the property value of `path` on a given
	     * object to `value`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * _.find(users, _.matchesProperty('user', 'fred'));
	     * // => { 'user': 'fred' }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, true));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` on a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': _.constant(2) } } },
	     *   { 'a': { 'b': { 'c': _.constant(1) } } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    var method = restParam(function(path, args) {
	      return function(object) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path on `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = restParam(function(object, args) {
	      return function(path) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable function properties of a source object to the
	     * destination object. If `object` is a function then methods are added to
	     * its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.chain=true] Specify whether the functions added
	     *  are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      if (options == null) {
	        var isObj = isObject(source),
	            props = isObj ? keys(source) : undefined,
	            methodNames = (props && props.length) ? baseFunctions(source, props) : undefined;
	
	        if (!(methodNames ? methodNames.length : isObj)) {
	          methodNames = false;
	          options = source;
	          source = object;
	          object = this;
	        }
	      }
	      if (!methodNames) {
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = true,
	          index = -1,
	          isFunc = isFunction(object),
	          length = methodNames.length;
	
	      if (options === false) {
	        chain = false;
	      } else if (isObject(options) && 'chain' in options) {
	        chain = options.chain;
	      }
	      while (++index < length) {
	        var methodName = methodNames[index],
	            func = source[methodName];
	
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = (function(func) {
	            return function() {
	              var chainAll = this.__chain__;
	              if (chain || chainAll) {
	                var result = object(this.__wrapped__),
	                    actions = result.__actions__ = arrayCopy(this.__actions__);
	
	                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	                result.__chain__ = chainAll;
	                return result;
	              }
	              return func.apply(object, arrayPush([this.value()], arguments));
	            };
	          }(func));
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      root._ = oldDash;
	      return this;
	    }
	
	    /**
	     * A no-operation function that returns `undefined` regardless of the
	     * arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.noop(object) === undefined;
	     * // => true
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that returns the property value at `path` on a
	     * given object.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': 2 } } },
	     *   { 'a': { 'b': { 'c': 1 } } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the property value at a given path on `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return baseGet(object, toPath(path), path + '');
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. If `end` is not specified it is
	     * set to `start` with `start` then set to `0`. If `end` is less than `start`
	     * a zero-length range is created unless a negative `step` is specified.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the new array of numbers.
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    function range(start, end, step) {
	      if (step && isIterateeCall(start, end, step)) {
	        end = step = undefined;
	      }
	      start = +start || 0;
	      step = step == null ? 1 : (+step || 0);
	
	      if (end == null) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
	      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the iteratee function `n` times, returning an array of the results
	     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
	     * one argument; (index).
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
	     * // => [3, 6, 4]
	     *
	     * _.times(3, function(n) {
	     *   mage.castSpell(n);
	     * });
	     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
	     *
	     * _.times(3, function(n) {
	     *   this.cast(n);
	     * }, mage);
	     * // => also invokes `mage.castSpell(n)` three times
	     */
	    function times(n, iteratee, thisArg) {
	      n = nativeFloor(n);
	
	      // Exit early to avoid a JSC JIT bug in Safari 8
	      // where `Array(0)` is treated as `Array(1)`.
	      if (n < 1 || !nativeIsFinite(n)) {
	        return [];
	      }
	      var index = -1,
	          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));
	
	      iteratee = bindCallback(iteratee, thisArg, 1);
	      while (++index < n) {
	        if (index < MAX_ARRAY_LENGTH) {
	          result[index] = iteratee(index);
	        } else {
	          iteratee(index);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {string} [prefix] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return baseToString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} augend The first number to add.
	     * @param {number} addend The second number to add.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    function add(augend, addend) {
	      return (+augend || 0) + (+addend || 0);
	    }
	
	    /**
	     * Calculates `n` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Calculates `n` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Gets the maximum value of `collection`. If `collection` is empty or falsey
	     * `-Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => -Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.max(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.max(users, 'age');
	     * // => { 'user': 'fred', 'age': 40 }
	     */
	    var max = createExtremum(gt, NEGATIVE_INFINITY);
	
	    /**
	     * Gets the minimum value of `collection`. If `collection` is empty or falsey
	     * `Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.min(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.min(users, 'age');
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var min = createExtremum(lt, POSITIVE_INFINITY);
	
	    /**
	     * Calculates `n` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Gets the sum of the values in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 6]);
	     * // => 10
	     *
	     * _.sum({ 'a': 4, 'b': 6 });
	     * // => 10
	     *
	     * var objects = [
	     *   { 'n': 4 },
	     *   { 'n': 6 }
	     * ];
	     *
	     * _.sum(objects, function(object) {
	     *   return object.n;
	     * });
	     * // => 10
	     *
	     * // using the `_.property` callback shorthand
	     * _.sum(objects, 'n');
	     * // => 10
	     */
	    function sum(collection, iteratee, thisArg) {
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return iteratee.length == 1
	        ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee)
	        : baseSum(collection, iteratee);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    // Add functions to the `Map` cache.
	    MapCache.prototype['delete'] = mapDelete;
	    MapCache.prototype.get = mapGet;
	    MapCache.prototype.has = mapHas;
	    MapCache.prototype.set = mapSet;
	
	    // Add functions to the `Set` cache.
	    SetCache.prototype.push = cachePush;
	
	    // Assign cache to `_.memoize`.
	    memoize.Cache = MapCache;
	
	    // Add functions that return wrapped values when chaining.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.callback = callback;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.functions = functions;
	    lodash.groupBy = groupBy;
	    lodash.indexBy = indexBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.invert = invert;
	    lodash.invoke = invoke;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.modArgs = modArgs;
	    lodash.negate = negate;
	    lodash.omit = omit;
	    lodash.once = once;
	    lodash.pairs = pairs;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pluck = pluck;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.restParam = restParam;
	    lodash.set = set;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortByAll = sortByAll;
	    lodash.sortByOrder = sortByOrder;
	    lodash.spread = spread;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.times = times;
	    lodash.toArray = toArray;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.union = union;
	    lodash.uniq = uniq;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.where = where;
	    lodash.without = without;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.backflow = flowRight;
	    lodash.collect = map;
	    lodash.compose = flowRight;
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.extend = assign;
	    lodash.iteratee = callback;
	    lodash.methods = functions;
	    lodash.object = zipObject;
	    lodash.select = filter;
	    lodash.tail = rest;
	    lodash.unique = uniq;
	
	    // Add functions to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions that return unwrapped values when chaining.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.deburr = deburr;
	    lodash.endsWith = endsWith;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.findWhere = findWhere;
	    lodash.first = first;
	    lodash.floor = floor;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isBoolean = isBoolean;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isMatch = isMatch;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isString = isString;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.min = min;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padLeft = padLeft;
	    lodash.padRight = padRight;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.sum = sum;
	    lodash.template = template;
	    lodash.trim = trim;
	    lodash.trimLeft = trimLeft;
	    lodash.trimRight = trimRight;
	    lodash.trunc = trunc;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.words = words;
	
	    // Add aliases.
	    lodash.all = every;
	    lodash.any = some;
	    lodash.contains = includes;
	    lodash.eq = isEqual;
	    lodash.detect = find;
	    lodash.foldl = reduce;
	    lodash.foldr = reduceRight;
	    lodash.head = first;
	    lodash.include = includes;
	    lodash.inject = reduce;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!lodash.prototype[methodName]) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), false);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions capable of returning wrapped and unwrapped values when chaining.
	    lodash.sample = sample;
	
	    lodash.prototype.sample = function(n) {
	      if (!this.__chain__ && n == null) {
	        return sample(this.value());
	      }
	      return this.thru(function(value) {
	        return sample(value, n);
	      });
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type string
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        var filtered = this.__filtered__;
	        if (filtered && !index) {
	          return new LazyWrapper(this);
	        }
	        n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);
	
	        var result = this.clone();
	        if (filtered) {
	          result.__takeCount__ = nativeMin(result.__takeCount__, n);
	        } else {
	          result.__views__.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type != LAZY_MAP_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
	        var result = this.clone();
	        result.__iteratees__.push({ 'iteratee': getCallback(iteratee, thisArg, 1), 'type': type });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.first` and `_.last`.
	    arrayEach(['first', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
	    arrayEach(['initial', 'rest'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
	    arrayEach(['pluck', 'where'], function(methodName, index) {
	      var operationName = index ? 'filter' : 'map',
	          createCallback = index ? baseMatches : property;
	
	      LazyWrapper.prototype[methodName] = function(value) {
	        return this[operationName](createCallback(value));
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.reject = function(predicate, thisArg) {
	      predicate = getCallback(predicate, thisArg, 1);
	      return this.filter(function(value) {
	        return !predicate(value);
	      });
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = start == null ? 0 : (+start || 0);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = (+end || 0);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
	      return this.reverse().takeWhile(predicate, thisArg).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(POSITIVE_INFINITY);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
	          retUnwrapped = /^(?:first|last)$/.test(methodName),
	          lodashFunc = lodash[retUnwrapped ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName];
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var args = retUnwrapped ? [1] : arguments,
	            chainAll = this.__chain__,
	            value = this.__wrapped__,
	            isHybrid = !!this.__actions__.length,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var interceptor = function(value) {
	          return (retUnwrapped && chainAll)
	            ? lodashFunc(value, 1)[0]
	            : lodashFunc.apply(undefined, arrayPush([value], args));
	        };
	
	        var action = { 'func': thru, 'args': [interceptor], 'thisArg': undefined },
	            onlyLazy = isLazy && !isHybrid;
	
	        if (retUnwrapped && !chainAll) {
	          if (onlyLazy) {
	            value = value.clone();
	            value.__actions__.push(action);
	            return func.call(value);
	          }
	          return lodashFunc.call(undefined, this.value())[0];
	        }
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push(action);
	          return new LodashWrapper(result, chainAll);
	        }
	        return this.thru(interceptor);
	      };
	    });
	
	    // Add `Array` and `String` methods to `lodash.prototype`.
	    arrayEach(['join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
	      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          return func.apply(this.value(), args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(value, args);
	        });
	      };
	    });
	
	    // Map minified function names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name,
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }];
	
	    // Add functions to the lazy wrapper.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chaining functions to the `lodash` wrapper.
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.concat = wrapperConcat;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toString = wrapperToString;
	    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add function aliases to the `lodash` wrapper.
	    lodash.prototype.collect = lodash.prototype.map;
	    lodash.prototype.head = lodash.prototype.first;
	    lodash.prototype.select = lodash.prototype.filter;
	    lodash.prototype.tail = lodash.prototype.rest;
	
	    return lodash;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers like r.js check for condition patterns like the following:
	  if (true) {
	    // Expose lodash to the global object when an AMD loader is present to avoid
	    // errors in cases where lodash is loaded by a script tag and not intended
	    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
	    // more details.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeExports && freeModule) {
	    // Export for Node.js or RingoJS.
	    if (moduleExports) {
	      (freeModule.exports = _)._ = _;
	    }
	    // Export for Rhino with CommonJS support.
	    else {
	      freeExports._ = _;
	    }
	  }
	  else {
	    // Export for a browser or Rhino.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(705)(module), (function() { return this; }())))

/***/ },
/* 705 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var FillEmptySpace = _react2['default'].createClass({
	    displayName: 'FillEmptySpace',
	
	
	    propTypes: {
	        footerClass: _react2['default'].PropTypes.string //NOTE: If another React component is leveraging this component, include a unique key for each generated message. See MultiSelect for more info.
	    },
	
	    expandSpace: function expandSpace() {
	
	        var footerClass = this.props.footerClass || '.m-footer';
	
	        var thisNode = $(_reactDom2['default'].findDOMNode(this));
	        var windowHeight = $(window).height();
	        var componentYPos = thisNode.offset().top;
	        var footerHeight = $(footerClass).outerHeight();
	        var twitterHeight = $('.m-footer') && $('.m-twitter').outerHeight(); // this should probably be passed in as a prop for more flexibility like the line above
	        var spaceToFill = windowHeight - componentYPos - footerHeight - twitterHeight - 5;
	        thisNode.height(spaceToFill);
	    },
	    componentDidMount: function componentDidMount() {
	
	        var self = this;
	        this.expandSpace();
	        if (window) {
	            window.onresize = function () {
	                self.expandSpace();
	            };
	        }
	        $(document).bind('repositionFooter', function () {
	            this.expandSpace();
	        }.bind(this));
	    },
	    render: function render() {
	        return _react2['default'].createElement('div', null);
	    }
	});
	module.exports = FillEmptySpace;

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PeekABoo = _react2['default'].createClass({
	    displayName: 'PeekABoo',
	
	
	    propTypes: {
	        imageUrl: _react2['default'].PropTypes.string,
	        imageHeight: _react2['default'].PropTypes.number,
	        imageWidth: _react2['default'].PropTypes.number
	    },
	
	    componentDidMount: function componentDidMount() {
	        var offset = $('.m-peek-a-boo--parallax img').offset();
	        if (offset) {
	            var peekYPos = offset.top;
	            var scrollBottom = $(window).scrollTop() + $(window).height();
	            if (scrollBottom > peekYPos - 150) {
	                $('.m-peek-a-boo--parallax img').addClass('is-visible');
	            }
	            $(window).scroll(function () {
	                var scrollBottom = $(window).scrollTop() + $(window).height();
	                if (scrollBottom > peekYPos - 150) {
	                    $('.m-peek-a-boo--parallax img').addClass('is-visible');
	                }
	            });
	        }
	    },
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            { className: 'm-peek-a-boo ', 'data-equalizer-watch': true },
	            _react2['default'].createElement(
	                'div',
	                { className: 'l-vertical-align m-peek-a-boo--parallax m-feature--outer-container' },
	                _react2['default'].createElement('img', { className: 'm-peek-a-boo--image', 'data-speed': '.4', height: this.props.imageHeight, width: this.props.imageWidth, src: _hfReactHelper2['default'].imgHelper(this.props.imageUrl) })
	            )
	        );
	    }
	});
	module.exports = PeekABoo;

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var DropDownMenu = _react2['default'].createClass({
	    displayName: 'DropDownMenu',
	
	
	    propTypes: {
	        dropDownMenuLinkData: _react2['default'].PropTypes.array.isRequired,
	        className: _react2['default'].PropTypes.string,
	        style: _react2['default'].PropTypes.object,
	        id: _react2['default'].PropTypes.string
	    },
	
	    render: function render() {
	        var dropDownMenuLinks = this.props.dropDownMenuLinkData.map(function (dropDownMenuLink, i, linkArray) {
	            if (!dropDownMenuLink.hasOwnProperty('options') || dropDownMenuLink.hasOwnProperty('options') && !dropDownMenuLink.options.mobileMenuOnly) {
	                var target = dropDownMenuLink.options ? dropDownMenuLink.options.target : null;
	                return _react2['default'].createElement(
	                    'a',
	                    { key: i, className: 'm-arrow-box--link hc-cerulean c-ashen' + (i == linkArray.length - 1 ? ' last' : ''), href: dropDownMenuLink.url, target: target },
	                    dropDownMenuLink.text
	                );
	            }
	        }.bind(this));
	        return _react2['default'].createElement(
	            'div',
	            {
	                style: this.props.style,
	                className: 'm-arrow-box ' + (this.props.className || ''), id: this.props.id || 'google-dropdown-menu' },
	            dropDownMenuLinks
	        );
	    }
	});
	module.exports = DropDownMenu;

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _swapOutButton = __webpack_require__(710);
	
	var _swapOutButton2 = _interopRequireDefault(_swapOutButton);
	
	var _buttonTextSubmit = __webpack_require__(698);
	
	var _buttonTextSubmit2 = _interopRequireDefault(_buttonTextSubmit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MobileLinkSubmit = _react2['default'].createClass({
	    displayName: 'MobileLinkSubmit',
	
	
	    propTypes: {},
	
	    render: function render() {
	        var initialBtn = _react2['default'].createElement(_button2['default'], { buttonText: 'EMAIL ME THE LINK', buttonClass: 'm-sign-mobile--send', buttonColor: 'grasshopper' });
	
	        var submitUrl = _hfReactHelper2['default'].urlHelper('info/sendDownloadLink', _hfReactHelper2['default'].HfSites.SITE_CODE_HS);
	        var actionBtn = _react2['default'].createElement(_button2['default'], { buttonText: 'SEND', buttonColor: 'grasshopper' });
	        var validateFunc = function validateFunc(val) {
	            if (!_hfReactHelper2['default'].isValidEmailAddress(val)) {
	                return 'Invalid email address.';
	            } else {
	                return false;
	            }
	        };
	        var swapInChildren = _react2['default'].createElement(_buttonTextSubmit2['default'], {
	            actionButton: actionBtn,
	            textPlaceholder: 'Enter email address',
	            inputName: 'email',
	            textClass: 'm-sign-mobile--text-field',
	            url: submitUrl,
	            divClass: 'm-sign-mobile--send',
	            formName: 'mobileLinkFrm',
	            validate: validateFunc });
	        return _react2['default'].createElement(_swapOutButton2['default'], { initialButton: initialBtn, swapInChildren: swapInChildren });
	    }
	});
	module.exports = MobileLinkSubmit;

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var SwapOutButton = _react2['default'].createClass({
	    displayName: 'SwapOutButton',
	
	
	    propTypes: {
	        initialButton: _react2['default'].PropTypes.element.isRequired,
	        swapInChildren: _react2['default'].PropTypes.element.isRequired
	    },
	
	    getInitialState: function getInitialState() {
	        return { isSwapped: false };
	    },
	    doSwap: function doSwap() {
	        this.setState({ isSwapped: true });
	    },
	    render: function render() {
	        var children;
	        if (this.state.isSwapped) {
	            children = this.props.swapInChildren;
	        } else {
	            children = _react2['default'].cloneElement(this.props.initialButton, {
	                'onClick': this.doSwap
	            });
	        }
	        return _react2['default'].createElement(
	            'span',
	            null,
	            children
	        );
	    }
	});
	module.exports = SwapOutButton;

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(712);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cookieWrapper = __webpack_require__(714);
	
	var _cookieWrapper2 = _interopRequireDefault(_cookieWrapper);
	
	var _message = __webpack_require__(715);
	
	var _message2 = _interopRequireDefault(_message);
	
	var _legacyNotification = __webpack_require__(716);
	
	var _legacyNotification2 = _interopRequireDefault(_legacyNotification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = _react2['default'].createClass({
	    displayName: 'NotificationHandler',
	
	    cookie: new _cookieWrapper2['default'](),
	
	    getInitialState: function getInitialState() {
	        var notifications = this.cookie.notifications;
	        return {
	            notifications: notifications,
	            siteTransform: 0
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.cookie.removeNotifications();
	        _legacyNotification2['default'].attach();
	    },
	    renderNotification: function renderNotification(notification, index) {
	        var styles = Object.assign({ zIndex: this.state.notifications.length - index }, notification.styles);
	        return _react2['default'].createElement(_message2['default'], {
	            key: index,
	            ref: index,
	            notification: notification,
	            handleRemove: this.removeNotification.bind(this, index),
	            style: styles
	        });
	    },
	    removeNotification: function removeNotification(notificationIndex) {
	        var notificationHeight = this.refs[notificationIndex].scrollHeight;
	        var siteTransform = this.state.siteTransform + notificationHeight;
	        var notifications = this.slideOtherNotifications(notificationIndex, siteTransform);
	
	        this.slideSiteWrapper(siteTransform);
	
	        this.setState({
	            siteTransform: siteTransform,
	            notifications: notifications
	        });
	    },
	    slideSiteWrapper: function slideSiteWrapper(siteTransform) {
	        var siteWrapper = document.getElementById('site-wrapper');
	        siteWrapper.style.transform = 'translateY(' + -siteTransform + 'px)';
	    },
	    slideOtherNotifications: function slideOtherNotifications(notificationIndex, siteTransform) {
	        return this.state.notifications.map(function (notification, index) {
	            if (index > notificationIndex) {
	                notification.styles = {
	                    transform: 'translateY(' + -siteTransform + 'px)'
	                };
	            }
	            return notification;
	        });
	    },
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            { className: 'm-notification' },
	            this.state.notifications.map(this.renderNotification)
	        );
	    }
	});

/***/ },
/* 712 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 713 */,
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	module.exports = function () {
	    function CookieWrapper(cookie) {
	        _classCallCheck(this, CookieWrapper);
	
	        this.cookie = cookie || (typeof document !== 'undefined' ? document.cookie : '');
	        this.notifications = this._parseNotifications();
	    }
	
	    _createClass(CookieWrapper, [{
	        key: 'removeNotifications',
	        value: function removeNotifications() {
	            var _this = this;
	
	            this.notifications.forEach(function (notification) {
	                _this.removeNotification(notification.id);
	            });
	        }
	    }, {
	        key: 'removeNotification',
	        value: function removeNotification(id) {
	            if (typeof document !== 'undefined') {
	                document.cookie = id + '=; expires=Thu, 01-Jan-70 00:00:01 GMT; path=/; domain=' + document.domain + ';';
	            }
	        }
	
	        /**
	            "Private" Methods
	         */
	
	    }, {
	        key: '_parseNotifications',
	        value: function _parseNotifications() {
	            return (this.cookie.match(this._getRegExp()) || []).map(this._parseNotification.bind(this)).filter(function (notification) {
	                return typeof notification !== 'undefined';
	            });
	        }
	    }, {
	        key: '_parseNotification',
	        value: function _parseNotification(notification) {
	            var parsedNotification = this._getRegExp().exec(notification);
	            try {
	                return {
	                    id: parsedNotification[1],
	                    data: JSON.parse(Base64.decode(parsedNotification[2]))
	                };
	            } catch (e) {
	                if (!("production") === 'test') {
	                    console.error('Could not parse notification data', e);
	                }
	            }
	        }
	    }, {
	        key: '_getRegExp',
	        value: function _getRegExp() {
	            return (/(notification\[\d+\])=([\w=\+\/]*)/g
	            );
	        }
	    }]);
	
	    return CookieWrapper;
	}();

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = _react2['default'].createClass({
	    displayName: 'NotificationMessage',
	
	    getInitialState: function getInitialState() {
	        return { isShowing: true };
	    },
	    hideNotification: function hideNotification() {
	        this.props.handleRemove();
	        this.setState({ isShowing: false });
	    },
	    getClassName: function getClassName() {
	        var className = this.props.notification.data.class_name || 'info';
	        className += this.state.isShowing ? ' notification-enter' : ' notification-leave';
	        return className;
	    },
	    render: function render() {
	
	        var notification = this.props.notification;
	        var className = this.getClassName();
	        var styles = this.props.style;
	        var text = {
	            '__html': notification.data.text || '' // NOTE: We trust this content since it's hard-coded messages
	        };
	
	        return _react2['default'].createElement(
	            'div',
	            { id: notification.id, className: className, style: styles },
	            _react2['default'].createElement(
	                'div',
	                { className: 'columns small-12 text-center' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'l-vertical-align-wrapper' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'l-vertical-align' },
	                        _react2['default'].createElement(
	                            'span',
	                            { className: 'm-notification--close', onClick: this.hideNotification },
	                            '\xD7'
	                        ),
	                        _react2['default'].createElement(
	                            'p',
	                            null,
	                            _react2['default'].createElement(
	                                'strong',
	                                null,
	                                notification.data.header
	                            )
	                        ),
	                        _react2['default'].createElement('p', { dangerouslySetInnerHTML: text })
	                    )
	                )
	            )
	        );
	    }
	});

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _hellosign = __webpack_require__(717);
	
	var _hellosign2 = _interopRequireDefault(_hellosign);
	
	var _setTimeout = __webpack_require__(718);
	
	var _setTimeout2 = _interopRequireDefault(_setTimeout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = {
	
	    INIT_OPEN_DELAY_MS: 200,
	    ANIMATION_SPEED_MS: 400,
	
	    _createShowFunction: function _createShowFunction(height, displayTime, _hideFn) {
	        var self = this;
	        return function () {
	            window.scrollTo(0, 0); // Scroll to the top of the page
	            $('body').animate({
	                top: '+=' + height
	            }, self.ANIMATION_SPEED_MS, function (displayTime, _hideFn) {
	                return function () {
	                    if (displayTime > 0) {
	                        (0, _setTimeout2['default'])(_hideFn, displayTime);
	                    }
	                };
	            }(displayTime, _hideFn));
	        };
	    },
	    _createHideFunction: function _createHideFunction() {
	        var self = this;
	        return function () {
	            var container = $('#notification'); // $('body');
	            container.animate({
	                'height': '0' // '-=' + height
	            }, self.ANIMATION_SPEED_MS, function _hideFnCallback() {
	                // Fast way to remove child DOM elements
	                $('#notification>div.m-notification').empty();
	                container[0].removeAttribute('style'); // remove the height: 0px style that's left over from the animation
	                $('body').css('top', 0);
	            });
	        };
	    },
	
	
	    /**
	     * Display a notification
	     *
	     * @param {Object} options
	     *  - class_name: 'success', 'error', or 'info'
	     *  - header: String to be used as the heading inside the notification
	     *  - text: String to be used as the normal text beneath the heading
	     *  - display_time: Duration to display before auto-dismissal, in ms (0 for persistent)
	     */
	    displayNotification: function displayNotification(options) {
	        // Merge defaults and options
	        var settings = $.extend({
	            class_name: 'info',
	            box_id: 'notification_' + Math.round(Math.random() * 99999),
	            icon: '',
	            header: '',
	            text: '',
	            display_time: 5000
	        }, options);
	
	        // Build the notification HTML using a template
	        var notification_html = '<div id="{{box_id}}" class="{{class_name}}">' + '<div class="columns small-12 text-center" style="height:100%;">' + // height 100% to allow for vertical centering
	        '<div class="l-vertical-align-wrapper" style="height:100%;">' + '<div class="l-vertical-align">' + '<span class="m-notification--close">&#215;</span>' + '<p><strong>' + '{{header}}' + '</strong></p>' + '<p>' + '{{text}}' + '</p>' + '</div>' + '</div>' + '</div>' + '</div>';
	
	        // Replace template variables
	        for (var i in settings) {
	            notification_html = notification_html.replace(new RegExp('{{' + i + '}}', 'g'), settings[i]);
	        }
	
	        // Add to the page, but initially we will set it off-page and
	        // allow it to render naturally, so that we can calculate its height
	        var notification = $(notification_html).css({
	            'height': 'auto',
	            'width': '100%',
	            'position': 'absolute',
	            'top': '-1000px'
	        });
	        $('#notification>div.m-notification').append(notification);
	        var height = $(notification).height() + 10; // 20px to account for 10px vertical padding
	
	        // Once we have the 'natural' height, let's set it in stone we can
	        // animate the element and also center the notification text vertically
	        // inside the div.
	        $(notification).css({
	            'height': height + 'px',
	            'position': 'relative',
	            'left': '0px',
	            'top': '0px'
	        });
	
	        // Offset the page container by the notification height so that the
	        // notification element appears to 'push' the container into place.
	        $('body').css({
	            'position': 'relative',
	            'top': '-' + height + 'px'
	        });
	
	        // Create a closure we can pass around to close the notification
	        // (we'll use this for closing after a timeout and for closing when
	        // the user clicks on the notification)
	        var _hideNotification = this._createHideFunction(height);
	
	        // Add the click handler to close the notification
	        $(notification).click(_hideNotification);
	
	        // Delay the notification slightly to attract the user's attention
	        (0, _setTimeout2['default'])(this._createShowFunction(height, settings.display_time, _hideNotification), this.INIT_OPEN_DELAY_MS);
	    },
	    displayModalNotification: function displayModalNotification() {
	        // TODO: Implement
	    },
	    attach: function attach() {
	        if (window.location.search.indexOf('aliId=') >= 0) {
	            this.displayNotification({
	                'class_name': 'success',
	                'header': 'Thank you. Your request has been received.'
	            });
	        }
	        if (window) {
	            _hellosign2['default'].displayNotification = this.displayNotification;
	        }
	    }
	};

/***/ },
/* 717 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// TODO - add HS code here. This file exists to keep other app bundle files from
	// accessing the HS global object. (CC)
	module.exports = global.HelloSign || {};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(719).setTimeout;

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _sift = __webpack_require__(720);
	
	var _sift2 = _interopRequireDefault(_sift);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _timerInfos = [];
	
	var timerTypes = {
	    TIMEOUT: 1,
	    INTERVAL: 2
	};
	
	/**
	
	 */
	
	function _wrapTimerCallback(cb, args) {
	    return function () {
	        cb.apply(this, args);
	    };
	}
	
	/**
	 */
	
	function _addTimer(timer, fn, type) {
	    var info = {
	        timer: timer,
	        type: type,
	        call: fn,
	        stop: type === timerTypes.TIMEOUT ? clearTimeout.bind(global, timer) : clearInterval.bind(global, timer)
	    };
	    _timerInfos.push(info);
	    return info;
	}
	
	/**
	 * triggers all timers immediately. Used for testing
	 */
	
	function _triggerTimers(filter) {
	    var filteredTimerInfos = _timerInfos;
	    if (filter) filteredTimerInfos = filteredTimerInfos.filter(filter);
	    filteredTimerInfos.forEach(function (timerInfo) {
	        timerInfo.call();
	    });
	}
	
	/**
	 * This is a utility to be used with app code. It gives us strict control over timers that are defined in the application, making
	 * it easier to test. (CC)
	 */
	
	module.exports = {
	
	    /**
	     */
	
	    testUtils: {
	
	        /**
	         * clears all timer objects (intervals & timeouts). This is a TESTING utility. Use it wisely! (CC)
	         */
	
	        clearAllTimers: function clearAllTimers() {
	            _timerInfos.forEach(function (timerInfo) {
	                timerInfo.stop();
	            });
	            _timerInfos = [];
	        },
	
	
	        /**
	         * triggers just intervals.
	         */
	
	        triggerAllIntervals: function triggerAllIntervals() {
	            _triggerTimers((0, _sift2['default'])({ type: timerTypes.INTERVAL }));
	        },
	
	
	        /**
	         * triggers just timeouts
	         */
	
	        triggerAllTimeouts: function triggerAllTimeouts() {
	            _triggerTimers((0, _sift2['default'])({ type: timerTypes.INTERVAL }));
	        },
	
	
	        /**
	         * timeouts & intervals
	         */
	
	        triggerAllTimers: function triggerAllTimers() {
	            _triggerTimers();
	        }
	    },
	
	    /**
	     */
	
	    setTimeout: function (_setTimeout) {
	        function setTimeout(_x, _x2) {
	            return _setTimeout.apply(this, arguments);
	        }
	
	        setTimeout.toString = function () {
	            return _setTimeout.toString();
	        };
	
	        return setTimeout;
	    }(function (callback, ms) {
	        var fn = _wrapTimerCallback(callback, Array.prototype.slice.call(arguments, 2));
	        var info;
	        var timer = setTimeout(function () {
	            var i = _timerInfos.indexOf(info);
	            if (i > -1) _timerInfos.splice(i, 1);
	            fn();
	        }, ms);
	        info = _addTimer(timer, fn, timerTypes.TIMEOUT);
	        return timer;
	    }),
	
	
	    /**
	     */
	
	    setInterval: function (_setInterval) {
	        function setInterval(_x3, _x4) {
	            return _setInterval.apply(this, arguments);
	        }
	
	        setInterval.toString = function () {
	            return _setInterval.toString();
	        };
	
	        return setInterval;
	    }(function (callback, ms) {
	        var fn = _wrapTimerCallback(callback, Array.prototype.slice.call(arguments, 2));
	        return _addTimer(setInterval(fn, ms), fn, timerTypes.INTERVAL).timer;
	    })
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 720 */
/***/ function(module, exports) {

	/*
	 * Sift
	 *
	 * Copryright 2011, Craig Condon
	 * Licensed under MIT
	 *
	 * Inspired by mongodb's query language
	 */
	
	(function() {
	
	  "use strict";
	
	  //traversable statements
	  var TRAV_OP = {
	    $and  : true,
	    $or   : true,
	    $nor  : true,
	    $trav : true,
	    $not  : true
	  };
	
	  var _testers = {
	
	    /**
	     */
	
	    $eq: function(a, b) {
	      return a.test(b);
	    },
	
	    /**
	     */
	
	    $ne: function(a, b) {
	      return !a.test(b);
	    },
	
	    /**
	     */
	
	    $lt: function(a, b) {
	      return a > b;
	    },
	
	    /**
	     */
	
	    $gt: function(a, b) {
	      return a < b;
	    },
	
	    /**
	     */
	
	    $lte: function(a, b) {
	      return a >= b;
	    },
	
	    /**
	     */
	
	    $gte: function(a, b) {
	      return a <= b;
	    },
	
	    /**
	     */
	
	    $exists: function(a, b) {
	      return a === (b != null);
	    },
	
	    /**
	     */
	
	    $in: function(a, b) {
	
	      //intersecting an array
	      if (b instanceof Array) {
	
	        for (var i = b.length; i--;) {
	          if (~a.indexOf(b[i])) return true;
	        }
	
	      } else {
	        return ~a.indexOf(b);
	      }
	
	      return false;
	    },
	
	    /**
	     */
	
	    $not: function(a, b) {
	      if (!a.test) throw new Error("$not test should include an expression, not a value. Use $ne instead.");
	      return !a.test(b);
	    },
	
	    /**
	     */
	
	    $type: function(a, b, org) {
	      //instanceof doesn't work for strings / boolean. instanceof works with inheritance
	      return org != null ? org instanceof a || org.constructor == a : false;
	    },
	
	    /**
	     */
	
	    $nin: function(a, b) {
	      return !_testers.$in(a, b);
	    },
	
	    /**
	     */
	
	    $mod: function(a, b) {
	      return b % a[0] == a[1];
	    },
	
	    /**
	     */
	
	    $all: function(a, b) {
	      if (!b) b = [];
	      for (var i = a.length; i--;) {
	        var a1 = a[i];
	        var indexInB = ~b.indexOf(a1);
	        if (!indexInB) return false;
	      }
	
	      return true;
	    },
	
	    /**
	     */
	
	    $size: function(a, b) {
	      return b ? a === b.length : false;
	    },
	
	    /**
	     */
	
	    $or: function(a, b) {
	
	      var i = a.length;
	      var n = i;
	
	      for (; i--;) {
	        if (test(a[i], b)) {
	          return true;
	        }
	      }
	
	      return n === 0;
	    },
	
	    /**
	     */
	
	    $nor: function(a, b) {
	
	      var i = a.length;
	
	      for (; i--;) {
	        if (test(a[i], b)) {
	          return false;
	        }
	      }
	
	      return true;
	    },
	
	    /**
	     */
	
	    $and: function(a, b) {
	
	      for (var i = a.length; i--;) {
	        if (!test(a[i], b)) {
	          return false;
	        }
	      }
	
	      return true;
	    },
	
	    /**
	     */
	
	    $trav: function(a, b) {
	
	      if (b instanceof Array) {
	
	        for (var i = b.length; i--;) {
	          var subb = b[i];
	          if (subb[a.k] && test(a, subb[a.k])) return true;
	        }
	
	        return false;
	      }
	
	      //continue to traverse even if there isn't a value - this is needed for
	      //something like name:{$exists:false}
	      return test(a, b ? b[a.k] : void 0);
	    },
	
	    /**
	     */
	
	    $regex: function(a, b) {
	      var aRE = new RegExp(a);
	      return aRE.test(b);
	    },
	
	    /**
	     */
	
	    $where: function(a, b) {
	      return a.call(b, b);
	    },
	
	    /**
	     */
	
	    $elemMatch: function (a, b) {
	      return a.test(b);
	    }
	  };
	
	  var _prepare = {
	
	    /**
	     */
	
	    $eq: function(a) {
	
	      var fn;
	
	      if (a instanceof RegExp) {
	        return a;
	      } else if (a instanceof Function) {
	        fn = a;
	      } else {
	        fn = function(b) {
	          if (b instanceof Array) {
	            return ~b.indexOf(a);
	          } else {
	            return a === b;
	          }
	        };
	      }
	
	      return {
	        test: fn
	      };
	    },
	
	    /**
	     */
	
	    $ne: function(a) {
	      return _prepare.$eq(a);
	    },
	
	     /**
	      */
	
	    $where: function(a) {
	
	      if (typeof a === "string") {
	        return new Function("obj", "return " + a);
	      }
	
	      return a;
	    },
	
	    /**
	     */
	
	    $elemMatch: function (a) {
	      return parse(a);
	    }
	  };
	
	  /**
	   */
	
	  function getExpr(type, key, value) {
	
	    var v = comparable(value);
	
	    return {
	
	      //k key
	      k: key,
	
	      //v value
	      v: _prepare[type] ? _prepare[type](v) : v,
	
	      //e eval
	      e: _testers[type]
	    };
	  }
	
	  /**
	   * tests against data
	   */
	
	  function test(statement, data) {
	
	    var exprs    = statement.exprs;
	
	    //generally, expressions are ordered from least efficient, to most efficient.
	    for (var i = 0, n = exprs.length; i < n; i++) {
	
	      var expr = exprs[i];
	
	      if (!expr.e(expr.v, comparable(data), data)) return false;
	
	    }
	
	    return true;
	  }
	
	  /**
	   * parses a statement into something evaluable
	   */
	
	  function parse(statement, key) {
	
	    //fixes sift(null, []) issue
	    if (!statement) statement = { $eq: statement };
	
	    var testers = [];
	
	    //if the statement is an object, then we're looking at something like: { key: match }
	    if (statement && statement.constructor === Object) {
	
	      for (var k in statement) {
	
	        //find the apropriate operator. If one doesn't exist and the key does not start
	        //with a $ character, then it's a property, which means we create a new statement
	        //(traversing)
	        var operator;
	        if (!!_testers[k]) {
	          operator = k;
	
	        // $ == 36
	        } else if (k.charCodeAt(0) !== 36) {
	          operator = "$trav";
	        } else {
	          throw new Error("Unknown operator " + k + ".");
	        }
	
	        //value of given statement (the match)
	        var value = statement[k];
	
	        //default = match
	        var exprValue = value;
	
	        //if we're working with a traversable operator, then set the expr value
	        if (TRAV_OP[operator]) {
	
	          //using dot notation? convert into a sub-object
	          if (~k.indexOf(".")) {
	            var keyParts = k.split(".");
	            k = keyParts.shift(); //we're using the first key, so remove it
	
	            exprValue = value = convertDotToSubObject(keyParts, value);
	          }
	
	          //*if* the value is an array, then we're dealing with something like: $or, $and
	          if (value instanceof Array) {
	
	            exprValue = [];
	
	            for (var i = value.length; i--;) {
	              exprValue.push(parse(value[i]));
	            }
	
	          //otherwise we're dealing with $trav
	          } else {
	            exprValue = parse(value, k);
	          }
	        }
	
	        testers.push(getExpr(operator, k, exprValue));
	      }
	
	    //otherwise we're comparing a particular value, so set to eq
	    } else {
	      testers.push(getExpr("$eq", key, statement));
	    }
	
	    var stmt =  {
	      exprs: testers,
	      k: key,
	      test: function(value) {
	        return test(stmt, value);
	      }
	    };
	
	    return stmt;
	  }
	
	  /**
	   */
	
	  function comparable(value) {
	    if (value instanceof Date) {
	      return value.getTime();
	    } else if (value instanceof Array) {
	      return value.map(comparable);
	    } else {
	      return value;
	    }
	  }
	
	  /**
	   */
	
	  function convertDotToSubObject(keyParts, value) {
	
	    var subObject    = {};
	    var currentValue = subObject;
	
	    for (var i = 0, n = keyParts.length - 1; i < n; i++) {
	      currentValue = currentValue[keyParts[i]] = {};
	    }
	
	    currentValue[keyParts[i]] = value;
	
	    return subObject;
	  }
	
	  /**
	   */
	
	  function getSelector(selector) {
	
	    if (!selector) {
	
	      return function(value) {
	        return value;
	      };
	
	    } else if (typeof selector == "function") {
	      return selector;
	    }
	
	    throw new Error("Unknown sift selector " + selector);
	  }
	
	  /**
	   * sifts the given function
	   * @param query the mongodb query
	   * @param target the target array
	   * @param rawSelector the selector for plucking data from the given target
	   */
	
	  function sift(query, target, rawSelector) {
	
	    //must be an array
	    if (typeof target != "object") {
	      rawSelector = target;
	      target = void 0;
	    }
	
	    var selector = getSelector(rawSelector);
	
	    //build the filter for the sifter
	    var sifter = parse(query);
	
	    function filter(value) {
	      return sifter.test(selector(value));
	    }
	
	    if (target) return target.filter(filter);
	
	    filter.query = query;
	
	    return filter;
	  }
	
	  sift.use = function(options) {
	    if (options.operators) sift.useOperators(options.operators);
	    if (typeof options === "function") options(sift);
	  };
	
	  sift.useOperators = function(operators) {
	    for (var key in operators) {
	      sift.useOperator(key, operators[key]);
	    }
	  };
	
	  sift.useOperator = function(operator, optionsOrFn) {
	
	    var options = {};
	
	    if (typeof optionsOrFn == "object") {
	      options = optionsOrFn;
	    } else {
	      options = { test: optionsOrFn };
	    }
	
	    var key = "$" + operator;
	    _testers[key] = options.test;
	
	    if (options.traversable || options.traverse) {
	      TRAV_OP[key] = true;
	    }
	  };
	
	  /* istanbul ignore next */
	  if ((typeof module != "undefined") && (typeof module.exports != "undefined")) {
	    module.exports = sift;
	  } else
	  if (typeof window != "undefined") {
	    window.sift = sift;
	  }
	})();


/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var CloseFancyBoxButton = _react2['default'].createClass({
	    displayName: 'CloseFancyBoxButton',
	    render: function render() {
	        var closeFancyBox = function closeFancyBox() {
	            parent.$.fancybox.close();
	        };
	        return _react2['default'].createElement(_button2['default'], _extends({}, this.props, { onClick: closeFancyBox }));
	    }
	});
	
	module.exports = CloseFancyBoxButton;

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _ExternalServiceTypes = __webpack_require__(723);
	
	var _ExternalServiceTypes2 = _interopRequireDefault(_ExternalServiceTypes);
	
	var _logger = __webpack_require__(482);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ExternalServiceUpdateURL = '/account/updateExternalService';
	var MyAccountIntegrationsHomeURL = '/home/myAccount?current_tab=integrations';
	
	var IntegrationActivationButton = _react2['default'].createClass({
	    displayName: 'IntegrationActivationButton',
	
	
	    propTypes: {
	        'isActive': _react2['default'].PropTypes.bool.isRequired,
	        'serviceTypeCode': _react2['default'].PropTypes.string,
	        'buttonLink': _react2['default'].PropTypes.string
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            'buttonLink': '#'
	        };
	    },
	
	
	    // Original logic moved from myAccount.php
	    clickHandler: function clickHandler(event) {
	        event.stopPropagation();
	        event.preventDefault();
	
	        var el = $(event.target).closest('div');
	        var isActivated = el.hasClass('is-activated');
	        var textContainer = $('button .l-nowrap > span', el);
	        var text = $.trim(textContainer.text());
	        var servTypeCode = $(' > a button', el).attr('rel');
	
	        var postData = {
	            'service_type': servTypeCode,
	            'is_deactivate': isActivated ? '1' : '0',
	            'csrf_token': $('#update_ext_serv_csrf_token').val()
	        };
	
	        // If activating Google Drive
	        if (!isActivated && servTypeCode == _ExternalServiceTypes2['default'].GOOGLE_DRIVE) {
	            if ($.browser.msie && parseInt($.browser.version, 10) < 8) {
	                $.fancybox('<div class="browser_warning"><strong>This option requires a more up to date browser</strong><p>Download the latest <a href="http://windows.microsoft.com/en-US/internet-explorer/downloads/ie" target="_blank" rel="noopener noreferrer">Microsoft Internet Explorer</a> or <a href="http://www.google.com/chrome/" target="_blank" rel="noopener noreferrer">Google Chrome</a></p></div>', { 'padding': 20 });
	                return;
	            }
	        }
	
	        var showAsBusy = function showAsBusy(isBusy) {
	            textContainer.html(isBusy ? 'Activating...' : text);
	        };
	
	        showAsBusy(true);
	
	        $.ajax({
	            'dataType': 'json',
	            'type': 'POST',
	            'url': ExternalServiceUpdateURL,
	            'data': postData,
	            success: function success(data) {
	
	                var integration;
	                for (var key in _ExternalServiceTypes2['default']) {
	                    if (_ExternalServiceTypes2['default'][key] === postData.service_type) {
	                        integration = key;
	                    }
	                }
	                var eventType = postData.is_deactivate == 0 ? 'activate' : 'deactivate';
	                _logger2['default'].track('IntegrationActivationButton._' + eventType, {
	                    integration: integration
	                });
	
	                showAsBusy(false);
	                if (data.auth_url) {
	                    window.location = data.auth_url.replace(/&amp;/g, '&'); // FIXME: Needed because it gets returned HTML-encoded
	                } else {
	                    window.location = MyAccountIntegrationsHomeURL;
	                }
	            },
	            error: function error() {
	                showAsBusy(false);
	                alert('An error occurred, try again or contact support at support@hellosign.com'); // FIXME - get email address dynamically, and localize text (DB)
	            }
	        });
	    },
	    render: function render() {
	        var hasCustomButtonLink = this.props.buttonLink !== '#';
	        var btn = _react2['default'].createElement(_button2['default'], { buttonText: this.props.isActive ? 'Deactivate' : 'Activate',
	            buttonLink: hasCustomButtonLink ? this.props.buttonLink : void 0,
	            buttonClass: 'border-1-grasshopper',
	            buttonColor: this.props.isActive ? 'grasshopper' : 'white',
	            buttonTextColor: this.props.isActive ? 'white' : 'grasshopper',
	            buttonHoverTextColor: 'white',
	            buttonHoverColor: 'grasshopper',
	            openInNewWindow: true,
	            buttonAttrs: this.props.serviceTypeCode ? { 'rel': this.props.serviceTypeCode } : null,
	            buttonLinkUsePost: false,
	            onClick: hasCustomButtonLink ? void 0 : this.clickHandler
	        });
	
	        return btn;
	    }
	});
	
	module.exports = IntegrationActivationButton;

/***/ },
/* 723 */
/***/ function(module, exports) {

	'use strict';
	
	// Keep this in sync with AccountExternalService.class.php
	
	module.exports = {
	    'BOXNET': 'B',
	    'DROPBOX': 'D',
	    'GOOGLE_DRIVE': 'G',
	    'GOOGLE_APPS': 'A',
	    'GOOGLE_DOCS': 'F',
	    'EVERNOTE': 'E',
	    'MS_SP': 'S',
	    'MS_OFFICE': 'O',
	    'MS_OUTLOOK': 'L',
	    'SKYDRIVE': 'K', // OneDrive
	    'QQ_CATALYST': 'Q',
	    'HUBSPOT': 'H',
	    'SLACK': 'C',
	    'EVENTBRITE': 'V',
	    'SALESFORCE': 'M',
	    'ORACLECLOUD': 'R',
	    'ALL': 'ALL' // used when calling syncFileWrapper.php worker
	};

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Banner = _react2['default'].createClass({
	    displayName: 'Banner',
	
	
	    /**
	     */
	
	    ANIMATION_SPEED_MS: 400,
	
	    /**
	     */
	
	    propTypes: {
	        'bannerID': _react2['default'].PropTypes.any,
	        'bannerText': _react2['default'].PropTypes.string,
	        'bannerLink': _react2['default'].PropTypes.string,
	        'display': _react2['default'].PropTypes.bool
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            'bannerID': -1,
	            'bannerText': '',
	            'display': false
	        };
	    },
	    getInitialState: function getInitialState() {
	        var cookie = Cookie.get('hide_banner');
	        var isDismissed = cookie != undefined ? cookie.split(',').some(function (e) {
	            return e == this.props.bannerID;
	        }, this) : false; // don't display if this specific banner was dismissed (not just any banner)
	        return {
	            'display': !isDismissed && this.props.display
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.isMounted = true;
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        this.isMounted = false;
	    },
	    hide: function hide() {
	        // set cookie to hide in the future
	        var cookie = Cookie.get('hide_banner');
	        cookie = cookie != undefined ? cookie + ',' + this.props.bannerID : this.props.bannerID; // store this banner's id in csv in the cookie
	        Cookie.set('hide_banner', cookie);
	
	        // hide now
	        var self = this;
	        $('.m-banner').animate({ opacity: 0 }, this.ANIMATION_SPEED_MS, function hideCallback() {
	            if (this.isMounted) {
	                self.setState({
	                    'display': false
	                });
	            }
	        });
	    },
	    render: function render() {
	        var banner;
	        var link;
	
	        if (this.props.bannerLink !== null) {
	            link = _react2['default'].createElement(
	                'a',
	                { className: 'm-banner--link', href: this.props.bannerLink, target: '_blank', rel: 'noopener noreferrer' },
	                'LEARN MORE'
	            );
	        }
	
	        if (this.state.display) {
	            banner = _react2['default'].createElement(
	                'div',
	                { className: 'm-banner' },
	                _react2['default'].createElement('img', { className: 'm-banner--notification-icon', src: __webpack_require__(725) }),
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'm-banner--text' },
	                    this.props.bannerText
	                ),
	                link,
	                _react2['default'].createElement(
	                    'a',
	                    { className: 'm-banner--dismiss', onClick: this.hide },
	                    _react2['default'].createElement('img', { className: 'm-banner--dismiss-icon', src: __webpack_require__(726) })
	                )
	            );
	        } else {
	            banner = _react2['default'].createElement('div', { className: 'm-banner-placeholder' });
	        }
	
	        return banner;
	    }
	});
	
	module.exports = Banner;

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/f6439ecf8db6c9f35ea880e5987a141b.png";

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/d638b5962cd1f15e843b40ad0aef944e.png";

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var SHOW_EVENTS = {
	    hover: 'mouseenter',
	    focus: 'focus'
	};
	
	var HIDE_EVENTS = {
	    hover: 'mouseleave',
	    focus: 'blur'
	};
	
	/**
	 * Tooltip
	 *
	 * @example
	 *
	 * // Showing on hover (default)
	 * <Tooltip content='my tooltip' arrowPosition='left' />
	 *
	 * // Showing on focus (default)
	 * <input id='some-input' />
	 * <Tooltip
	 *      content='my tooltip'
	 *      arrowPosition='left'
	 *      trigger='focus'
	 *      lockToElement='#some-input'
	 *  />
	 */
	var Tooltip = _react2['default'].createClass({
	    displayName: 'Tooltip',
	
	
	    propTypes: {
	        'content': _react2['default'].PropTypes.string.isRequired,
	        'text': _react2['default'].PropTypes.string,
	        'arrowPosition': _react2['default'].PropTypes.string,
	        'isToggled': _react2['default'].PropTypes.bool,
	        'isToggleable': _react2['default'].PropTypes.bool, // If false, tooltip will always be permanently displayed
	        'classes': _react2['default'].PropTypes.string,
	        'cta': _react2['default'].PropTypes.object,
	        'lockToElement': _react2['default'].PropTypes.string, // Optional element to lock to
	
	        /**
	         * DEPRECATED
	         *
	         * To change how the tooltip is toggled, use the `trigger` prop below.
	         */
	        'toggleOn': _react2['default'].PropTypes.string, // Events to toggle on (change/blur/etc) if using the above
	        'contentStyle': _react2['default'].PropTypes.object, // Additional styles for tooltip content
	        'minWidth': _react2['default'].PropTypes.string,
	
	        /**
	         * Sets the appropriate show/hide listeners on the trigger element.  The
	         * default is hover.
	         *
	         *  - `hover` will show the tooltip on mouseover and hide on mouseleave
	         *  - `focus` should be used for input elements.  The tooltip will be
	         *  shown on focus and hidden on blur.
	         */
	        'trigger': _react2['default'].PropTypes.oneOf(['hover', 'focus'])
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            'text': '?',
	            'arrowPosition': 'bottom',
	            'isToggled': false,
	            'isToggleable': true,
	            'lockToElement': null,
	            'trigger': 'hover'
	        };
	    },
	    getInitialState: function getInitialState() {
	        return {
	            'toggled': this.props.isToggled,
	            'isToggleable': this.props.isToggleable
	        };
	    },
	
	    // TODO: refactor the jQuery out of this
	    componentDidMount: function componentDidMount() {
	        var root = $(_reactDom2['default'].findDOMNode(this));
	
	        if (this.state.isToggleable && !this.props.lockToElement) {
	            this.bindToggleEvents('.m-tooltip--text', root);
	        } else if (this.state.isToggleable) {
	            // Using an element to lock to
	            this.bindToggleEvents(this.props.lockToElement);
	        }
	        this.adjustTooltipPosition();
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        if (typeof this.unBindToggleEvents === 'function') {
	            this.unBindToggleEvents();
	        }
	    },
	    bindToggleEvents: function bindToggleEvents() {
	        var _this = this;
	
	        var $toggler = $.apply(undefined, arguments);
	
	        // Kept for legacy reasons
	        if (this.props.toggleOn) {
	            $toggler.bind(this.props.toggleOn, this.toggleTip);
	
	            this.unbindToggleEvents = function () {
	                return $toggler.unbind(_this.props.toggleOn, _this.toggleTip);
	            };
	        } else {
	            var showEvent = this.getShowEvent();
	            var hideEvent = this.getHideEvent();
	
	            $toggler.bind(showEvent, this.show);
	            $toggler.bind(hideEvent, this.hide);
	
	            this.unbindToggleEvents = function () {
	                $toggler.unbind(showEvent, _this.show);
	                $toggler.unbind(hideEvent, _this.hide);
	            };
	        }
	    },
	    getShowEvent: function getShowEvent() {
	        return SHOW_EVENTS[this.props.trigger] || SHOW_EVENTS.hover;
	    },
	    getHideEvent: function getHideEvent() {
	        return HIDE_EVENTS[this.props.trigger] || HIDE_EVENTS.hover;
	    },
	    show: function show() {
	        this.setState({
	            toggled: true
	        }, this.adjustTooltipPosition);
	    },
	    hide: function hide() {
	        this.setState({
	            toggled: false
	        }, this.adjustTooltipPosition);
	    },
	    adjustTooltipPosition: function adjustTooltipPosition() {
	
	        var root = $(_reactDom2['default'].findDOMNode(this));
	        var parent = root.parent();
	        var isVisible = parent.css('display') !== 'none';
	        var tooltipBubbleEl;
	        var newTop;
	        var newLeft;
	
	        if (!isVisible) {
	            // Display the tooltip container so we can correctly size it
	            parent.show();
	        }
	
	        // Adjust vertical positioning if the tooltip is toggled on
	        if (this.state.toggled && !this.props.lockToElement) {
	            if ($.inArray(this.props.arrowPosition, ['left', 'right']) >= 0) {
	                tooltipBubbleEl = $('.m-tooltip--bubble', root);
	                tooltipBubbleEl.css({ 'min-width': this.props.minWidth });
	                var currentTop = tooltipBubbleEl.offset().top;
	                var offsetParentTop = tooltipBubbleEl.offsetParent().offset().top;
	                if (offsetParentTop === 0) {
	                    newTop = currentTop - tooltipBubbleEl.height() / 2 + 7;
	                    tooltipBubbleEl.css('top', newTop);
	                } else {
	                    var tooltipTextEl = $('.m-tooltip--text', root);
	                    var tooltipTextCenter = tooltipTextEl.offset().top + tooltipTextEl.height() / 2;
	                    var vertAdjustment = tooltipTextCenter - (currentTop + tooltipBubbleEl.height() / 2);
	                    newTop = currentTop - offsetParentTop + vertAdjustment;
	                    tooltipBubbleEl.css('top', newTop);
	                }
	            }
	        } else if (this.state.toggled && this.props.lockToElement) {
	
	            // height of box - offset of element
	            var lockedElNode = $(this.props.lockToElement);
	            var lockedElPosition = lockedElNode.position();
	            var lockedElWidth = lockedElNode.outerWidth();
	            var lockedElHeight = lockedElNode.innerHeight();
	            tooltipBubbleEl = $('.m-tooltip--bubble', root);
	
	            // Currently only used for left arrow positioning vs an element
	            if (this.props.arrowPosition == 'left') {
	                newLeft = lockedElPosition.left + lockedElWidth;
	                tooltipBubbleEl.css({ 'left': newLeft });
	                tooltipBubbleEl.css({ 'min-width': this.props.minWidth });
	                // Set top value after setting left to account for the new width of the
	                // tooltip bubble, since it's auto-width. This puts the vertical center in
	                // the correct location
	                var lockedElVertMiddle = lockedElPosition.top + lockedElHeight / 2;
	                newTop = lockedElVertMiddle - tooltipBubbleEl.innerHeight() / 2;
	                tooltipBubbleEl.css({ 'top': newTop });
	            } else if (this.props.arrowPosition == 'bottom') {
	                newLeft = Math.abs(lockedElPosition.left + lockedElWidth / 2 - tooltipBubbleEl.outerWidth() / 2);
	                tooltipBubbleEl.css({ 'left': newLeft });
	                newTop = lockedElPosition.top - tooltipBubbleEl.height() - 10;
	                tooltipBubbleEl.css({ 'top': newTop });
	            }
	        }
	
	        if (!isVisible) {
	            parent.hide();
	        }
	    },
	
	
	    /*
	    * Function to toggle tooltip. If using custom events, you can attach a value payload  - 'show' will show the tooltip, anything else will hide
	    * This is useful in implementing more complex display logic.
	    */
	
	    toggleTip: function toggleTip(e) {
	
	        // Using custom event payload
	        if (e && e.value) {
	            this.setState({
	                'toggled': e.value === 'show'
	            });
	            // Every other case
	        } else {
	            this.setState({
	                'toggled': !this.state.toggled
	            });
	        }
	
	        this.adjustTooltipPosition();
	    },
	    render: function render() {
	
	        var classes = 'm-tooltip';
	        if (this.props.classes) {
	            classes += ' ' + this.props.classes;
	        }
	
	        var cta;
	        var ctaClass;
	        if (this.props.cta) {
	            ctaClass = 'm-tooltip--bubble--content--cta ' + (this.props.cta['class'] || '');
	            cta = _react2['default'].createElement(
	                'a',
	                { href: this.props.cta.url, className: ctaClass },
	                this.props.cta.text
	            );
	        }
	
	        var bubble;
	        if (!this.state.isToggleable || this.state.isToggleable && this.state.toggled) {
	            bubble = _react2['default'].createElement(
	                'span',
	                { className: 'm-tooltip--bubble ' + this.props.arrowPosition },
	                _react2['default'].createElement('span', { className: 'm-tooltip--bubble--arrow left' }),
	                _react2['default'].createElement('span', { className: 'm-tooltip--bubble--arrow top' }),
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'm-tooltip--bubble--content' },
	                    this.props.content,
	                    ' ',
	                    cta
	                ),
	                _react2['default'].createElement('span', { className: 'm-tooltip--bubble--arrow right' }),
	                _react2['default'].createElement('span', { className: 'm-tooltip--bubble--arrow bottom' })
	            );
	        }
	
	        var renderText = this.props.lockToElement ? '' : this.props.text;
	        return _react2['default'].createElement(
	            'span',
	            { className: classes },
	            _react2['default'].createElement(
	                'span',
	                { className: 'm-tooltip--text' },
	                renderText
	            ),
	            bubble
	        );
	    }
	});
	
	module.exports = Tooltip;

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(729);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modal = __webpack_require__(731);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _checkPlatform = __webpack_require__(761);
	
	var _checkPlatform2 = _interopRequireDefault(_checkPlatform);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               *   FixedModal
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               *   Intented to be a drop in replacement for Foundation/Fancybox. Use this instead.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               **/
	
	var FixedModal = function (_Component) {
	    _inherits(FixedModal, _Component);
	
	    function FixedModal(props) {
	        _classCallCheck(this, FixedModal);
	
	        var _this = _possibleConstructorReturn(this, (FixedModal.__proto__ || Object.getPrototypeOf(FixedModal)).call(this, props));
	
	        _this.state = { hide: false };
	        _this.onOverlayClick = _this.onOverlayClick.bind(_this);
	        return _this;
	    }
	
	    _createClass(FixedModal, [{
	        key: 'onOverlayClick',
	        value: function onOverlayClick(e) {
	            var overlayClass = 'm-common-modal'; // From the inner modal
	            var overlayClicked = e.target.classList.contains(overlayClass);
	            if (this.props.hideOnOverlayClick && overlayClicked) {
	                // TODO this should trigger on ESC keypress too
	                this.setState({
	                    hide: true
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            var style = void 0;
	            if (this.state.hide === true) {
	                style = { display: 'none' };
	            }
	
	            var modalStyle = this.props.modalStyle || {};
	
	            var width = this.props.width;
	            var fixedModalClass = 'm-fixed-modal';
	            if ((0, _checkPlatform2['default'])() === 'mobile') {
	                width = '100%';
	                fixedModalClass += ' mobile';
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                { className: fixedModalClass, style: style, onClick: this.onOverlayClick },
	                _react2['default'].createElement(
	                    _modal2['default'],
	                    _extends({}, this.props, { width: width, style: modalStyle, className: this.props.modalClassName }),
	                    this.props.children
	                )
	            );
	        }
	    }]);
	
	    return FixedModal;
	}(_react.Component);
	
	FixedModal.propTypes = {
	    'width': _react.PropTypes.number,
	    'hideOnOverlayClick': _react.PropTypes.bool
	};
	
	
	module.exports = FixedModal;

/***/ },
/* 729 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 730 */,
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(732);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _makeComponentIntl = __webpack_require__(734);
	
	var _makeComponentIntl2 = _interopRequireDefault(_makeComponentIntl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Modal = _react2['default'].createClass({
	    displayName: 'Modal',
	    render: function render() {
	
	        var className = 'm-common-modal--center-content';
	        var style = {};
	        style.backgroundColor = 'white'; // Default
	        // Merge with supplied style props
	        style = Object.assign(style, this.props.style);
	
	        if (this.props.className) {
	            className += ' ' + this.props.className;
	        }
	
	        if (this.props.width) {
	            style.width = this.props.width;
	        }
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'm-common-modal' },
	            _react2['default'].createElement(
	                'div',
	                { style: style, className: className },
	                this.props.children
	            )
	        );
	    }
	});
	
	module.exports = (0, _makeComponentIntl2['default'])(Modal);

/***/ },
/* 732 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 733 */,
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(735);
	
	var _merge = __webpack_require__(519);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _flattenMessages = __webpack_require__(758);
	
	var _flattenMessages2 = _interopRequireDefault(_flattenMessages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDefaultMessages = function getDefaultMessages() {
	    return (0, _flattenMessages2['default'])((0, _merge2['default'])(__webpack_require__(759), __webpack_require__(760)));
	};
	
	var makeComponentIntl = function makeComponentIntl(component) {
	    var InjectedComponent = (0, _reactIntl.injectIntl)(component);
	
	    // Needs to be a class because refs are added by React Intl
	
	    var IntlComponent = function (_React$Component) {
	        _inherits(IntlComponent, _React$Component);
	
	        function IntlComponent() {
	            _classCallCheck(this, IntlComponent);
	
	            return _possibleConstructorReturn(this, (IntlComponent.__proto__ || Object.getPrototypeOf(IntlComponent)).apply(this, arguments));
	        }
	
	        _createClass(IntlComponent, [{
	            key: 'render',
	            value: function render() {
	                var intlMessages = this.props.intl ? (0, _flattenMessages2['default'])(this.props.intl.messages) : null;
	                var messages = this.props.messages || intlMessages || getDefaultMessages();
	
	                return _react2['default'].createElement(
	                    _reactIntl.IntlProvider,
	                    { locale: 'en-US', messages: messages },
	                    _react2['default'].createElement(InjectedComponent, this.props)
	                );
	            }
	        }]);
	
	        return IntlComponent;
	    }(_react2['default'].Component);
	
	    return IntlComponent;
	};
	
	exports['default'] = makeComponentIntl;
	
	module.exports = makeComponentIntl;

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*
	 * Copyright 2016, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var allLocaleData = _interopDefault(__webpack_require__(736));
	var IntlMessageFormat = _interopDefault(__webpack_require__(737));
	var IntlRelativeFormat = _interopDefault(__webpack_require__(747));
	var React = __webpack_require__(304);
	var React__default = _interopDefault(React);
	var invariant = _interopDefault(__webpack_require__(754));
	var memoizeIntlConstructor = _interopDefault(__webpack_require__(755));
	
	// GENERATED FILE
	var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
	    var s = String(n).split("."),
	        v0 = !s[1],
	        t0 = Number(s[0]) == n,
	        n10 = t0 && s[0].slice(-1),
	        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
	  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "minute": { "displayName": "minute", "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } } } };
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	function addLocaleData() {
	    var data = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    var locales = Array.isArray(data) ? data : [data];
	
	    locales.forEach(function (localeData) {
	        if (localeData && localeData.locale) {
	            IntlMessageFormat.__addLocaleData(localeData);
	            IntlRelativeFormat.__addLocaleData(localeData);
	        }
	    });
	}
	
	function hasLocaleData(locale) {
	    var localeParts = (locale || '').split('-');
	
	    while (localeParts.length > 0) {
	        if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
	            return true;
	        }
	
	        localeParts.pop();
	    }
	
	    return false;
	}
	
	function hasIMFAndIRFLocaleData(locale) {
	    var normalizedLocale = locale && locale.toLowerCase();
	
	    return !!(IntlMessageFormat.__localeData__[normalizedLocale] && IntlRelativeFormat.__localeData__[normalizedLocale]);
	}
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
	};
	
	var jsx = function () {
	  var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7;
	  return function createRawReactElement(type, props, key, children) {
	    var defaultProps = type && type.defaultProps;
	    var childrenLength = arguments.length - 3;
	
	    if (!props && childrenLength !== 0) {
	      props = {};
	    }
	
	    if (props && defaultProps) {
	      for (var propName in defaultProps) {
	        if (props[propName] === void 0) {
	          props[propName] = defaultProps[propName];
	        }
	      }
	    } else if (!props) {
	      props = defaultProps || {};
	    }
	
	    if (childrenLength === 1) {
	      props.children = children;
	    } else if (childrenLength > 1) {
	      var childArray = Array(childrenLength);
	
	      for (var i = 0; i < childrenLength; i++) {
	        childArray[i] = arguments[i + 3];
	      }
	
	      props.children = childArray;
	    }
	
	    return {
	      $$typeof: REACT_ELEMENT_TYPE,
	      type: type,
	      key: key === undefined ? null : '' + key,
	      ref: null,
	      props: props,
	      _owner: null
	    };
	  };
	}();
	
	var asyncToGenerator = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new Promise(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }
	
	        if (info.done) {
	          resolve(value);
	        } else {
	          return Promise.resolve(value).then(function (value) {
	            return step("next", value);
	          }, function (err) {
	            return step("throw", err);
	          });
	        }
	      }
	
	      return step("next");
	    });
	  };
	};
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var defineEnumerableProperties = function (obj, descs) {
	  for (var key in descs) {
	    var desc = descs[key];
	    desc.configurable = desc.enumerable = true;
	    if ("value" in desc) desc.writable = true;
	    Object.defineProperty(obj, key, desc);
	  }
	
	  return obj;
	};
	
	var defaults = function (obj, defaults) {
	  var keys = Object.getOwnPropertyNames(defaults);
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var value = Object.getOwnPropertyDescriptor(defaults, key);
	
	    if (value && value.configurable && obj[key] === undefined) {
	      Object.defineProperty(obj, key, value);
	    }
	  }
	
	  return obj;
	};
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var get = function get(object, property, receiver) {
	  if (object === null) object = Function.prototype;
	  var desc = Object.getOwnPropertyDescriptor(object, property);
	
	  if (desc === undefined) {
	    var parent = Object.getPrototypeOf(object);
	
	    if (parent === null) {
	      return undefined;
	    } else {
	      return get(parent, property, receiver);
	    }
	  } else if ("value" in desc) {
	    return desc.value;
	  } else {
	    var getter = desc.get;
	
	    if (getter === undefined) {
	      return undefined;
	    }
	
	    return getter.call(receiver);
	  }
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var _instanceof = function (left, right) {
	  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
	    return right[Symbol.hasInstance](left);
	  } else {
	    return left instanceof right;
	  }
	};
	
	var interopRequireDefault = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	};
	
	var interopRequireWildcard = function (obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};
	
	    if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }
	
	    newObj.default = obj;
	    return newObj;
	  }
	};
	
	var newArrowCheck = function (innerThis, boundThis) {
	  if (innerThis !== boundThis) {
	    throw new TypeError("Cannot instantiate an arrow function");
	  }
	};
	
	var objectDestructuringEmpty = function (obj) {
	  if (obj == null) throw new TypeError("Cannot destructure undefined");
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var selfGlobal = typeof global === "undefined" ? self : global;
	
	var set = function set(object, property, value, receiver) {
	  var desc = Object.getOwnPropertyDescriptor(object, property);
	
	  if (desc === undefined) {
	    var parent = Object.getPrototypeOf(object);
	
	    if (parent !== null) {
	      set(parent, property, value, receiver);
	    }
	  } else if ("value" in desc && desc.writable) {
	    desc.value = value;
	  } else {
	    var setter = desc.set;
	
	    if (setter !== undefined) {
	      setter.call(receiver, value);
	    }
	  }
	
	  return value;
	};
	
	var slicedToArray = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if (Symbol.iterator in Object(arr)) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();
	
	var slicedToArrayLoose = function (arr, i) {
	  if (Array.isArray(arr)) {
	    return arr;
	  } else if (Symbol.iterator in Object(arr)) {
	    var _arr = [];
	
	    for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) {
	      _arr.push(_step.value);
	
	      if (i && _arr.length === i) break;
	    }
	
	    return _arr;
	  } else {
	    throw new TypeError("Invalid attempt to destructure non-iterable instance");
	  }
	};
	
	var taggedTemplateLiteral = function (strings, raw) {
	  return Object.freeze(Object.defineProperties(strings, {
	    raw: {
	      value: Object.freeze(raw)
	    }
	  }));
	};
	
	var taggedTemplateLiteralLoose = function (strings, raw) {
	  strings.raw = raw;
	  return strings;
	};
	
	var temporalRef = function (val, name, undef) {
	  if (val === undef) {
	    throw new ReferenceError(name + " is not defined - temporal dead zone");
	  } else {
	    return val;
	  }
	};
	
	var temporalUndefined = {};
	
	var toArray = function (arr) {
	  return Array.isArray(arr) ? arr : Array.from(arr);
	};
	
	var toConsumableArray = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	
	
	var babelHelpers$1 = Object.freeze({
	  jsx: jsx,
	  asyncToGenerator: asyncToGenerator,
	  classCallCheck: classCallCheck,
	  createClass: createClass,
	  defineEnumerableProperties: defineEnumerableProperties,
	  defaults: defaults,
	  defineProperty: defineProperty,
	  get: get,
	  inherits: inherits,
	  interopRequireDefault: interopRequireDefault,
	  interopRequireWildcard: interopRequireWildcard,
	  newArrowCheck: newArrowCheck,
	  objectDestructuringEmpty: objectDestructuringEmpty,
	  objectWithoutProperties: objectWithoutProperties,
	  possibleConstructorReturn: possibleConstructorReturn,
	  selfGlobal: selfGlobal,
	  set: set,
	  slicedToArray: slicedToArray,
	  slicedToArrayLoose: slicedToArrayLoose,
	  taggedTemplateLiteral: taggedTemplateLiteral,
	  taggedTemplateLiteralLoose: taggedTemplateLiteralLoose,
	  temporalRef: temporalRef,
	  temporalUndefined: temporalUndefined,
	  toArray: toArray,
	  toConsumableArray: toConsumableArray,
	  typeof: _typeof,
	  extends: _extends,
	  instanceof: _instanceof
	});
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var bool = React.PropTypes.bool;
	var number = React.PropTypes.number;
	var string = React.PropTypes.string;
	var func = React.PropTypes.func;
	var object = React.PropTypes.object;
	var oneOf = React.PropTypes.oneOf;
	var shape = React.PropTypes.shape;
	
	
	var intlConfigPropTypes = {
	    locale: string,
	    formats: object,
	    messages: object,
	
	    defaultLocale: string,
	    defaultFormats: object
	};
	
	var intlFormatPropTypes = {
	    formatDate: func.isRequired,
	    formatTime: func.isRequired,
	    formatRelative: func.isRequired,
	    formatNumber: func.isRequired,
	    formatPlural: func.isRequired,
	    formatMessage: func.isRequired,
	    formatHTMLMessage: func.isRequired
	};
	
	var intlShape = shape(babelHelpers$1['extends']({}, intlConfigPropTypes, intlFormatPropTypes, {
	    formatters: object,
	    now: func.isRequired
	}));
	
	var messageDescriptorPropTypes = {
	    id: string.isRequired,
	    description: string,
	    defaultMessage: string
	};
	
	var dateTimeFormatPropTypes = {
	    localeMatcher: oneOf(['best fit', 'lookup']),
	    formatMatcher: oneOf(['basic', 'best fit']),
	
	    timeZone: string,
	    hour12: bool,
	
	    weekday: oneOf(['narrow', 'short', 'long']),
	    era: oneOf(['narrow', 'short', 'long']),
	    year: oneOf(['numeric', '2-digit']),
	    month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
	    day: oneOf(['numeric', '2-digit']),
	    hour: oneOf(['numeric', '2-digit']),
	    minute: oneOf(['numeric', '2-digit']),
	    second: oneOf(['numeric', '2-digit']),
	    timeZoneName: oneOf(['short', 'long'])
	};
	
	var numberFormatPropTypes = {
	    localeMatcher: oneOf(['best fit', 'lookup']),
	
	    style: oneOf(['decimal', 'currency', 'percent']),
	    currency: string,
	    currencyDisplay: oneOf(['symbol', 'code', 'name']),
	    useGrouping: bool,
	
	    minimumIntegerDigits: number,
	    minimumFractionDigits: number,
	    maximumFractionDigits: number,
	    minimumSignificantDigits: number,
	    maximumSignificantDigits: number
	};
	
	var relativeFormatPropTypes = {
	    style: oneOf(['best fit', 'numeric']),
	    units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year'])
	};
	
	var pluralFormatPropTypes = {
	    style: oneOf(['cardinal', 'ordinal'])
	};
	
	/*
	HTML escaping and shallow-equals implementations are the same as React's
	(on purpose.) Therefore, it has the following Copyright and Licensing:
	
	Copyright 2013-2014, Facebook, Inc.
	All rights reserved.
	
	This source code is licensed under the BSD-style license found in the LICENSE
	file in the root directory of React's source tree.
	*/
	
	var intlConfigPropNames = Object.keys(intlConfigPropTypes);
	
	var ESCAPED_CHARS = {
	    '&': '&amp;',
	    '>': '&gt;',
	    '<': '&lt;',
	    '"': '&quot;',
	    '\'': '&#x27;'
	};
	
	var UNSAFE_CHARS_REGEX = /[&><"']/g;
	
	function escape(str) {
	    return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
	        return ESCAPED_CHARS[match];
	    });
	}
	
	function filterProps(props, whitelist) {
	    var defaults = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	    return whitelist.reduce(function (filtered, name) {
	        if (props.hasOwnProperty(name)) {
	            filtered[name] = props[name];
	        } else if (defaults.hasOwnProperty(name)) {
	            filtered[name] = defaults[name];
	        }
	
	        return filtered;
	    }, {});
	}
	
	function invariantIntlContext() {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var intl = _ref.intl;
	
	    invariant(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
	}
	
	function shallowEquals(objA, objB) {
	    if (objA === objB) {
	        return true;
	    }
	
	    if ((typeof objA === 'undefined' ? 'undefined' : babelHelpers$1['typeof'](objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : babelHelpers$1['typeof'](objB)) !== 'object' || objB === null) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if (keysA.length !== keysB.length) {
	        return false;
	    }
	
	    // Test for A's keys different from B.
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	    for (var i = 0; i < keysA.length; i++) {
	        if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	            return false;
	        }
	    }
	
	    return true;
	}
	
	function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
	    var props = _ref2.props;
	    var state = _ref2.state;
	    var _ref2$context = _ref2.context;
	    var context = _ref2$context === undefined ? {} : _ref2$context;
	    var nextContext = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var _context$intl = context.intl;
	    var intl = _context$intl === undefined ? {} : _context$intl;
	    var _nextContext$intl = nextContext.intl;
	    var nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;
	
	
	    return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	// Inspired by react-redux's `connect()` HOC factory function implementation:
	// https://github.com/rackt/react-redux
	
	function getDisplayName(Component) {
	    return Component.displayName || Component.name || 'Component';
	}
	
	function injectIntl(WrappedComponent) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	    var _options$intlPropName = options.intlPropName;
	    var intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName;
	    var _options$withRef = options.withRef;
	    var withRef = _options$withRef === undefined ? false : _options$withRef;
	
	    var InjectIntl = function (_Component) {
	        inherits(InjectIntl, _Component);
	
	        function InjectIntl(props, context) {
	            classCallCheck(this, InjectIntl);
	
	            var _this = possibleConstructorReturn(this, Object.getPrototypeOf(InjectIntl).call(this, props, context));
	
	            invariantIntlContext(context);
	            return _this;
	        }
	
	        createClass(InjectIntl, [{
	            key: 'getWrappedInstance',
	            value: function getWrappedInstance() {
	                invariant(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');
	
	                return this.refs.wrappedInstance;
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                return React__default.createElement(WrappedComponent, babelHelpers$1['extends']({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
	                    ref: withRef ? 'wrappedInstance' : null
	                }));
	            }
	        }]);
	        return InjectIntl;
	    }(React.Component);
	
	    InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
	
	    InjectIntl.contextTypes = {
	        intl: intlShape
	    };
	
	    InjectIntl.WrappedComponent = WrappedComponent;
	
	    return InjectIntl;
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	function defineMessages(messageDescriptors) {
	  // This simply returns what's passed-in because it's meant to be a hook for
	  // babel-plugin-react-intl.
	  return messageDescriptors;
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	// This is a "hack" until a proper `intl-pluralformat` package is created.
	
	function resolveLocale(locales) {
	    // IntlMessageFormat#_resolveLocale() does not depend on `this`.
	    return IntlMessageFormat.prototype._resolveLocale(locales);
	}
	
	function findPluralFunction(locale) {
	    // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
	    return IntlMessageFormat.prototype._findPluralRuleFunction(locale);
	}
	
	var IntlPluralFormat = function IntlPluralFormat(locales) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	    classCallCheck(this, IntlPluralFormat);
	
	    var useOrdinal = options.style === 'ordinal';
	    var pluralFn = findPluralFunction(resolveLocale(locales));
	
	    this.format = function (value) {
	        return pluralFn(value, useOrdinal);
	    };
	};
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
	var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
	var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
	var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);
	
	var RELATIVE_FORMAT_THRESHOLDS = {
	    second: 60, // seconds to minute
	    minute: 60, // minutes to hour
	    hour: 24, // hours to day
	    day: 30, // days to month
	    month: 12 };
	
	function updateRelativeFormatThresholds(newThresholds) {
	    var thresholds = IntlRelativeFormat.thresholds;
	    thresholds.second = newThresholds.second;
	    thresholds.minute = newThresholds.minute;
	    thresholds.hour = newThresholds.hour;
	    thresholds.day = newThresholds.day;
	    thresholds.month = newThresholds.month;
	}
	
	function getNamedFormat(formats, type, name) {
	    var format = formats && formats[type] && formats[type][name];
	    if (format) {
	        return format;
	    }
	
	    if (false) {
	        console.error('[React Intl] No ' + type + ' format named: ' + name);
	    }
	}
	
	function formatDate(config, state, value) {
	    var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	    var formats = config.formats;
	    var format = options.format;
	
	
	    var date = new Date(value);
	    var defaults = format && getNamedFormat(formats, 'date', format);
	    var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults);
	
	    try {
	        return state.getDateTimeFormat(locale, filteredOptions).format(date);
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting date.\n' + e);
	        }
	    }
	
	    return String(date);
	}
	
	function formatTime(config, state, value) {
	    var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	    var formats = config.formats;
	    var format = options.format;
	
	
	    var date = new Date(value);
	    var defaults = format && getNamedFormat(formats, 'time', format);
	    var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults);
	
	    if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
	        // Add default formatting options if hour, minute, or second isn't defined.
	        filteredOptions = babelHelpers$1['extends']({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
	    }
	
	    try {
	        return state.getDateTimeFormat(locale, filteredOptions).format(date);
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting time.\n' + e);
	        }
	    }
	
	    return String(date);
	}
	
	function formatRelative(config, state, value) {
	    var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	    var formats = config.formats;
	    var format = options.format;
	
	
	    var date = new Date(value);
	    var now = new Date(options.now);
	    var defaults = format && getNamedFormat(formats, 'relative', format);
	    var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults);
	
	    // Capture the current threshold values, then temporarily override them with
	    // specific values just for this render.
	    var oldThresholds = babelHelpers$1['extends']({}, IntlRelativeFormat.thresholds);
	    updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);
	
	    try {
	        return state.getRelativeFormat(locale, filteredOptions).format(date, {
	            now: isFinite(now) ? now : state.now()
	        });
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting relative time.\n' + e);
	        }
	    } finally {
	        updateRelativeFormatThresholds(oldThresholds);
	    }
	
	    return String(date);
	}
	
	function formatNumber(config, state, value) {
	    var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	    var formats = config.formats;
	    var format = options.format;
	
	
	    var defaults = format && getNamedFormat(formats, 'number', format);
	    var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults);
	
	    try {
	        return state.getNumberFormat(locale, filteredOptions).format(value);
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting number.\n' + e);
	        }
	    }
	
	    return String(value);
	}
	
	function formatPlural(config, state, value) {
	    var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	
	
	    var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
	
	    try {
	        return state.getPluralFormat(locale, filteredOptions).format(value);
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting plural.\n' + e);
	        }
	    }
	
	    return 'other';
	}
	
	function formatMessage(config, state) {
	    var messageDescriptor = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	    var values = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	    var formats = config.formats;
	    var messages = config.messages;
	    var defaultLocale = config.defaultLocale;
	    var defaultFormats = config.defaultFormats;
	    var id = messageDescriptor.id;
	    var defaultMessage = messageDescriptor.defaultMessage;
	
	    // `id` is a required field of a Message Descriptor.
	
	    invariant(id, '[React Intl] An `id` must be provided to format a message.');
	
	    var message = messages && messages[id];
	    var hasValues = Object.keys(values).length > 0;
	
	    // Avoid expensive message formatting for simple messages without values. In
	    // development messages will always be formatted in case of missing values.
	    if (!hasValues && ("production") === 'production') {
	        return message || defaultMessage || id;
	    }
	
	    var formattedMessage = void 0;
	
	    if (message) {
	        try {
	            var formatter = state.getMessageFormat(message, locale, formats);
	
	            formattedMessage = formatter.format(values);
	        } catch (e) {
	            if (false) {
	                console.error('[React Intl] Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '') + ('\n' + e));
	            }
	        }
	    } else {
	        if (false) {
	            // This prevents warnings from littering the console in development
	            // when no `messages` are passed into the <IntlProvider> for the
	            // default locale, and a default message is in the source.
	            if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
	
	                console.error('[React Intl] Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''));
	            }
	        }
	    }
	
	    if (!formattedMessage && defaultMessage) {
	        try {
	            var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);
	
	            formattedMessage = _formatter.format(values);
	        } catch (e) {
	            if (false) {
	                console.error('[React Intl] Error formatting the default message for: "' + id + '"' + ('\n' + e));
	            }
	        }
	    }
	
	    if (!formattedMessage) {
	        if (false) {
	            console.error('[React Intl] Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.'));
	        }
	    }
	
	    return formattedMessage || message || defaultMessage || id;
	}
	
	function formatHTMLMessage(config, state, messageDescriptor) {
	    var rawValues = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	    // Process all the values before they are used when formatting the ICU
	    // Message string. Since the formatted message might be injected via
	    // `innerHTML`, all String-based values need to be HTML-escaped.
	    var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
	        var value = rawValues[name];
	        escaped[name] = typeof value === 'string' ? escape(value) : value;
	        return escaped;
	    }, {});
	
	    return formatMessage(config, state, messageDescriptor, escapedValues);
	}
	
	
	
	var format = Object.freeze({
	    formatDate: formatDate,
	    formatTime: formatTime,
	    formatRelative: formatRelative,
	    formatNumber: formatNumber,
	    formatPlural: formatPlural,
	    formatMessage: formatMessage,
	    formatHTMLMessage: formatHTMLMessage
	});
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
	var intlFormatPropNames = Object.keys(intlFormatPropTypes);
	
	// These are not a static property on the `IntlProvider` class so the intl
	// config values can be inherited from an <IntlProvider> ancestor.
	var defaultProps = {
	    formats: {},
	    messages: {},
	
	    defaultLocale: 'en',
	    defaultFormats: {}
	};
	
	var IntlProvider = function (_Component) {
	    inherits(IntlProvider, _Component);
	
	    function IntlProvider(props, context) {
	        classCallCheck(this, IntlProvider);
	
	        var _this = possibleConstructorReturn(this, Object.getPrototypeOf(IntlProvider).call(this, props, context));
	
	        invariant(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');
	
	        var intlContext = context.intl;
	
	        // Used to stabilize time when performing an initial rendering so that
	        // all relative times use the same reference "now" time.
	
	        var initialNow = void 0;
	        if (isFinite(props.initialNow)) {
	            initialNow = Number(props.initialNow);
	        } else {
	            // When an `initialNow` isn't provided via `props`, look to see an
	            // <IntlProvider> exists in the ancestry and call its `now()`
	            // function to propagate its value for "now".
	            initialNow = intlContext ? intlContext.now() : Date.now();
	        }
	
	        // Creating `Intl*` formatters is expensive. If there's a parent
	        // `<IntlProvider>`, then its formatters will be used. Otherwise, this
	        // memoize the `Intl*` constructors and cache them for the lifecycle of
	        // this IntlProvider instance.
	
	        var _ref = intlContext || {};
	
	        var _ref$formatters = _ref.formatters;
	        var formatters = _ref$formatters === undefined ? {
	            getDateTimeFormat: memoizeIntlConstructor(Intl.DateTimeFormat),
	            getNumberFormat: memoizeIntlConstructor(Intl.NumberFormat),
	            getMessageFormat: memoizeIntlConstructor(IntlMessageFormat),
	            getRelativeFormat: memoizeIntlConstructor(IntlRelativeFormat),
	            getPluralFormat: memoizeIntlConstructor(IntlPluralFormat)
	        } : _ref$formatters;
	
	
	        _this.state = babelHelpers$1['extends']({}, formatters, {
	
	            // Wrapper to provide stable "now" time for initial render.
	            now: function now() {
	                return _this._didDisplay ? Date.now() : initialNow;
	            }
	        });
	        return _this;
	    }
	
	    createClass(IntlProvider, [{
	        key: 'getConfig',
	        value: function getConfig() {
	            var intlContext = this.context.intl;
	
	            // Build a whitelisted config object from `props`, defaults, and
	            // `context.intl`, if an <IntlProvider> exists in the ancestry.
	
	            var config = filterProps(this.props, intlConfigPropNames$1, intlContext);
	
	            // Apply default props. This must be applied last after the props have
	            // been resolved and inherited from any <IntlProvider> in the ancestry.
	            // This matches how React resolves `defaultProps`.
	            for (var propName in defaultProps) {
	                if (config[propName] === undefined) {
	                    config[propName] = defaultProps[propName];
	                }
	            }
	
	            if (!hasLocaleData(config.locale)) {
	                var _config = config;
	                var locale = _config.locale;
	                var defaultLocale = _config.defaultLocale;
	                var defaultFormats = _config.defaultFormats;
	
	
	                if (false) {
	                    console.error('[React Intl] Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.'));
	                }
	
	                // Since there's no registered locale data for `locale`, this will
	                // fallback to the `defaultLocale` to make sure things can render.
	                // The `messages` are overridden to the `defaultProps` empty object
	                // to maintain referential equality across re-renders. It's assumed
	                // each <FormattedMessage> contains a `defaultMessage` prop.
	                config = babelHelpers$1['extends']({}, config, {
	                    locale: defaultLocale,
	                    formats: defaultFormats,
	                    messages: defaultProps.messages
	                });
	            }
	
	            return config;
	        }
	    }, {
	        key: 'getBoundFormatFns',
	        value: function getBoundFormatFns(config, state) {
	            return intlFormatPropNames.reduce(function (boundFormatFns, name) {
	                boundFormatFns[name] = format[name].bind(null, config, state);
	                return boundFormatFns;
	            }, {});
	        }
	    }, {
	        key: 'getChildContext',
	        value: function getChildContext() {
	            var config = this.getConfig();
	
	            // Bind intl factories and current config to the format functions.
	            var boundFormatFns = this.getBoundFormatFns(config, this.state);
	
	            var _state = this.state;
	            var now = _state.now;
	            var formatters = objectWithoutProperties(_state, ['now']);
	
	
	            return {
	                intl: babelHelpers$1['extends']({}, config, boundFormatFns, {
	                    formatters: formatters,
	                    now: now
	                })
	            };
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this._didDisplay = true;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return React.Children.only(this.props.children);
	        }
	    }]);
	    return IntlProvider;
	}(React.Component);
	
	IntlProvider.displayName = 'IntlProvider';
	
	IntlProvider.contextTypes = {
	    intl: intlShape
	};
	
	IntlProvider.childContextTypes = {
	    intl: intlShape.isRequired
	};
	
	IntlProvider.propTypes = babelHelpers$1['extends']({}, intlConfigPropTypes, {
	    children: React.PropTypes.element.isRequired,
	    initialNow: React.PropTypes.any
	});
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedDate = function (_Component) {
	    inherits(FormattedDate, _Component);
	
	    function FormattedDate(props, context) {
	        classCallCheck(this, FormattedDate);
	
	        var _this = possibleConstructorReturn(this, Object.getPrototypeOf(FormattedDate).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    createClass(FormattedDate, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatDate = this.context.intl.formatDate;
	            var _props = this.props;
	            var value = _props.value;
	            var children = _props.children;
	
	
	            var formattedDate = formatDate(value, this.props);
	
	            if (typeof children === 'function') {
	                return children(formattedDate);
	            }
	
	            return React__default.createElement(
	                'span',
	                null,
	                formattedDate
	            );
	        }
	    }]);
	    return FormattedDate;
	}(React.Component);
	
	FormattedDate.displayName = 'FormattedDate';
	
	FormattedDate.contextTypes = {
	    intl: intlShape
	};
	
	FormattedDate.propTypes = babelHelpers$1['extends']({}, dateTimeFormatPropTypes, {
	    value: React.PropTypes.any.isRequired,
	    format: React.PropTypes.string,
	    children: React.PropTypes.func
	});
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedTime = function (_Component) {
	    inherits(FormattedTime, _Component);
	
	    function FormattedTime(props, context) {
	        classCallCheck(this, FormattedTime);
	
	        var _this = possibleConstructorReturn(this, Object.getPrototypeOf(FormattedTime).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    createClass(FormattedTime, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatTime = this.context.intl.formatTime;
	            var _props = this.props;
	            var value = _props.value;
	            var children = _props.children;
	
	
	            var formattedTime = formatTime(value, this.props);
	
	            if (typeof children === 'function') {
	                return children(formattedTime);
	            }
	
	            return React__default.createElement(
	                'span',
	                null,
	                formattedTime
	            );
	        }
	    }]);
	    return FormattedTime;
	}(React.Component);
	
	FormattedTime.displayName = 'FormattedTime';
	
	FormattedTime.contextTypes = {
	    intl: intlShape
	};
	
	FormattedTime.propTypes = babelHelpers$1['extends']({}, dateTimeFormatPropTypes, {
	    value: React.PropTypes.any.isRequired,
	    format: React.PropTypes.string,
	    children: React.PropTypes.func
	});
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var SECOND = 1000;
	var MINUTE = 1000 * 60;
	var HOUR = 1000 * 60 * 60;
	var DAY = 1000 * 60 * 60 * 24;
	
	// The maximum timer delay value is a 32-bit signed integer.
	// See: https://mdn.io/setTimeout
	var MAX_TIMER_DELAY = 2147483647;
	
	function selectUnits(delta) {
	    var absDelta = Math.abs(delta);
	
	    if (absDelta < MINUTE) {
	        return 'second';
	    }
	
	    if (absDelta < HOUR) {
	        return 'minute';
	    }
	
	    if (absDelta < DAY) {
	        return 'hour';
	    }
	
	    // The maximum scheduled delay will be measured in days since the maximum
	    // timer delay is less than the number of milliseconds in 25 days.
	    return 'day';
	}
	
	function getUnitDelay(units) {
	    switch (units) {
	        case 'second':
	            return SECOND;
	        case 'minute':
	            return MINUTE;
	        case 'hour':
	            return HOUR;
	        case 'day':
	            return DAY;
	        default:
	            return MAX_TIMER_DELAY;
	    }
	}
	
	function isSameDate(a, b) {
	    if (a === b) {
	        return true;
	    }
	
	    var aTime = new Date(a).getTime();
	    var bTime = new Date(b).getTime();
	
	    return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
	}
	
	var FormattedRelative = function (_Component) {
	    inherits(FormattedRelative, _Component);
	
	    function FormattedRelative(props, context) {
	        classCallCheck(this, FormattedRelative);
	
	        var _this = possibleConstructorReturn(this, Object.getPrototypeOf(FormattedRelative).call(this, props, context));
	
	        invariantIntlContext(context);
	
	        var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();
	
	        // `now` is stored as state so that `render()` remains a function of
	        // props + state, instead of accessing `Date.now()` inside `render()`.
	        _this.state = { now: now };
	        return _this;
	    }
	
	    createClass(FormattedRelative, [{
	        key: 'scheduleNextUpdate',
	        value: function scheduleNextUpdate(props, state) {
	            var _this2 = this;
	
	            var updateInterval = props.updateInterval;
	
	            // If the `updateInterval` is falsy, including `0`, then auto updates
	            // have been turned off, so we bail and skip scheduling an update.
	
	            if (!updateInterval) {
	                return;
	            }
	
	            var time = new Date(props.value).getTime();
	            var delta = time - state.now;
	            var units = props.units || selectUnits(delta);
	
	            var unitDelay = getUnitDelay(units);
	            var unitRemainder = Math.abs(delta % unitDelay);
	
	            // We want the largest possible timer delay which will still display
	            // accurate information while reducing unnecessary re-renders. The delay
	            // should be until the next "interesting" moment, like a tick from
	            // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
	            var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);
	
	            clearTimeout(this._timer);
	
	            this._timer = setTimeout(function () {
	                _this2.setState({ now: _this2.context.intl.now() });
	            }, delay);
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.scheduleNextUpdate(this.props, this.state);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref) {
	            var nextValue = _ref.value;
	
	            // When the `props.value` date changes, `state.now` needs to be updated,
	            // and the next update can be rescheduled.
	            if (!isSameDate(nextValue, this.props.value)) {
	                this.setState({ now: this.context.intl.now() });
	            }
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'componentWillUpdate',
	        value: function componentWillUpdate(nextProps, nextState) {
	            this.scheduleNextUpdate(nextProps, nextState);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearTimeout(this._timer);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatRelative = this.context.intl.formatRelative;
	            var _props = this.props;
	            var value = _props.value;
	            var children = _props.children;
	
	
	            var formattedRelative = formatRelative(value, babelHelpers$1['extends']({}, this.props, this.state));
	
	            if (typeof children === 'function') {
	                return children(formattedRelative);
	            }
	
	            return React__default.createElement(
	                'span',
	                null,
	                formattedRelative
	            );
	        }
	    }]);
	    return FormattedRelative;
	}(React.Component);
	
	FormattedRelative.displayName = 'FormattedRelative';
	
	FormattedRelative.contextTypes = {
	    intl: intlShape
	};
	
	FormattedRelative.propTypes = babelHelpers$1['extends']({}, relativeFormatPropTypes, {
	    value: React.PropTypes.any.isRequired,
	    format: React.PropTypes.string,
	    updateInterval: React.PropTypes.number,
	    initialNow: React.PropTypes.any,
	    children: React.PropTypes.func
	});
	
	FormattedRelative.defaultProps = {
	    updateInterval: 1000 * 10
	};
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedNumber = function (_Component) {
	    inherits(FormattedNumber, _Component);
	
	    function FormattedNumber(props, context) {
	        classCallCheck(this, FormattedNumber);
	
	        var _this = possibleConstructorReturn(this, Object.getPrototypeOf(FormattedNumber).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    createClass(FormattedNumber, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatNumber = this.context.intl.formatNumber;
	            var _props = this.props;
	            var value = _props.value;
	            var children = _props.children;
	
	
	            var formattedNumber = formatNumber(value, this.props);
	
	            if (typeof children === 'function') {
	                return children(formattedNumber);
	            }
	
	            return React__default.createElement(
	                'span',
	                null,
	                formattedNumber
	            );
	        }
	    }]);
	    return FormattedNumber;
	}(React.Component);
	
	FormattedNumber.displayName = 'FormattedNumber';
	
	FormattedNumber.contextTypes = {
	    intl: intlShape
	};
	
	FormattedNumber.propTypes = babelHelpers$1['extends']({}, numberFormatPropTypes, {
	    value: React.PropTypes.any.isRequired,
	    format: React.PropTypes.string,
	    children: React.PropTypes.func
	});
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedPlural = function (_Component) {
	    inherits(FormattedPlural, _Component);
	
	    function FormattedPlural(props, context) {
	        classCallCheck(this, FormattedPlural);
	
	        var _this = possibleConstructorReturn(this, Object.getPrototypeOf(FormattedPlural).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    createClass(FormattedPlural, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatPlural = this.context.intl.formatPlural;
	            var _props = this.props;
	            var value = _props.value;
	            var other = _props.other;
	            var children = _props.children;
	
	
	            var pluralCategory = formatPlural(value, this.props);
	            var formattedPlural = this.props[pluralCategory] || other;
	
	            if (typeof children === 'function') {
	                return children(formattedPlural);
	            }
	
	            return React__default.createElement(
	                'span',
	                null,
	                formattedPlural
	            );
	        }
	    }]);
	    return FormattedPlural;
	}(React.Component);
	
	FormattedPlural.displayName = 'FormattedPlural';
	
	FormattedPlural.contextTypes = {
	    intl: intlShape
	};
	
	FormattedPlural.propTypes = babelHelpers$1['extends']({}, pluralFormatPropTypes, {
	    value: React.PropTypes.any.isRequired,
	
	    other: React.PropTypes.node.isRequired,
	    zero: React.PropTypes.node,
	    one: React.PropTypes.node,
	    two: React.PropTypes.node,
	    few: React.PropTypes.node,
	    many: React.PropTypes.node,
	
	    children: React.PropTypes.func
	});
	
	FormattedPlural.defaultProps = {
	    style: 'cardinal'
	};
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedMessage = function (_Component) {
	    inherits(FormattedMessage, _Component);
	
	    function FormattedMessage(props, context) {
	        classCallCheck(this, FormattedMessage);
	
	        var _this = possibleConstructorReturn(this, Object.getPrototypeOf(FormattedMessage).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    createClass(FormattedMessage, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            var values = this.props.values;
	            var nextValues = nextProps.values;
	
	
	            if (!shallowEquals(nextValues, values)) {
	                return true;
	            }
	
	            // Since `values` has already been checked, we know they're not
	            // different, so the current `values` are carried over so the shallow
	            // equals comparison on the other props isn't affected by the `values`.
	            var nextPropsToCheck = babelHelpers$1['extends']({}, nextProps, {
	                values: values
	            });
	
	            for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	                next[_key - 1] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatMessage = this.context.intl.formatMessage;
	            var _props = this.props;
	            var id = _props.id;
	            var description = _props.description;
	            var defaultMessage = _props.defaultMessage;
	            var values = _props.values;
	            var tagName = _props.tagName;
	            var children = _props.children;
	
	
	            var tokenDelimiter = void 0;
	            var tokenizedValues = void 0;
	            var elements = void 0;
	
	            var hasValues = values && Object.keys(values).length > 0;
	            if (hasValues) {
	                (function () {
	                    // Creates a token with a random UID that should not be guessable or
	                    // conflict with other parts of the `message` string.
	                    var uid = Math.floor(Math.random() * 0x10000000000).toString(16);
	
	                    var generateToken = function () {
	                        var counter = 0;
	                        return function () {
	                            return 'ELEMENT-' + uid + '-' + (counter += 1);
	                        };
	                    }();
	
	                    // Splitting with a delimiter to support IE8. When using a regex
	                    // with a capture group IE8 does not include the capture group in
	                    // the resulting array.
	                    tokenDelimiter = '@__' + uid + '__@';
	                    tokenizedValues = {};
	                    elements = {};
	
	                    // Iterates over the `props` to keep track of any React Element
	                    // values so they can be represented by the `token` as a placeholder
	                    // when the `message` is formatted. This allows the formatted
	                    // message to then be broken-up into parts with references to the
	                    // React Elements inserted back in.
	                    Object.keys(values).forEach(function (name) {
	                        var value = values[name];
	
	                        if (React.isValidElement(value)) {
	                            var token = generateToken();
	                            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
	                            elements[token] = value;
	                        } else {
	                            tokenizedValues[name] = value;
	                        }
	                    });
	                })();
	            }
	
	            var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
	            var formattedMessage = formatMessage(descriptor, tokenizedValues || values);
	
	            var nodes = void 0;
	
	            var hasElements = elements && Object.keys(elements).length > 0;
	            if (hasElements) {
	                // Split the message into parts so the React Element values captured
	                // above can be inserted back into the rendered message. This
	                // approach allows messages to render with React Elements while
	                // keeping React's virtual diffing working properly.
	                nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
	                    return !!part;
	                }).map(function (part) {
	                    return elements[part] || part;
	                });
	            } else {
	                nodes = [formattedMessage];
	            }
	
	            if (typeof children === 'function') {
	                return children.apply(undefined, toConsumableArray(nodes));
	            }
	
	            return React.createElement.apply(undefined, [tagName, null].concat(toConsumableArray(nodes)));
	        }
	    }]);
	    return FormattedMessage;
	}(React.Component);
	
	FormattedMessage.displayName = 'FormattedMessage';
	
	FormattedMessage.contextTypes = {
	    intl: intlShape
	};
	
	FormattedMessage.propTypes = babelHelpers$1['extends']({}, messageDescriptorPropTypes, {
	    values: React.PropTypes.object,
	    tagName: React.PropTypes.string,
	    children: React.PropTypes.func
	});
	
	FormattedMessage.defaultProps = {
	    values: {},
	    tagName: 'span'
	};
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedHTMLMessage = function (_Component) {
	    inherits(FormattedHTMLMessage, _Component);
	
	    function FormattedHTMLMessage(props, context) {
	        classCallCheck(this, FormattedHTMLMessage);
	
	        var _this = possibleConstructorReturn(this, Object.getPrototypeOf(FormattedHTMLMessage).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    createClass(FormattedHTMLMessage, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            var values = this.props.values;
	            var nextValues = nextProps.values;
	
	
	            if (!shallowEquals(nextValues, values)) {
	                return true;
	            }
	
	            // Since `values` has already been checked, we know they're not
	            // different, so the current `values` are carried over so the shallow
	            // equals comparison on the other props isn't affected by the `values`.
	            var nextPropsToCheck = babelHelpers$1['extends']({}, nextProps, {
	                values: values
	            });
	
	            for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	                next[_key - 1] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatHTMLMessage = this.context.intl.formatHTMLMessage;
	            var _props = this.props;
	            var id = _props.id;
	            var description = _props.description;
	            var defaultMessage = _props.defaultMessage;
	            var rawValues = _props.values;
	            var tagName = _props.tagName;
	            var children = _props.children;
	
	
	            var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
	            var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);
	
	            if (typeof children === 'function') {
	                return children(formattedHTMLMessage);
	            }
	
	            // Since the message presumably has HTML in it, we need to set
	            // `innerHTML` in order for it to be rendered and not escaped by React.
	            // To be safe, all string prop values were escaped when formatting the
	            // message. It is assumed that the message is not UGC, and came from the
	            // developer making it more like a template.
	            //
	            // Note: There's a perf impact of using this component since there's no
	            // way for React to do its virtual DOM diffing.
	            return React.createElement(tagName, {
	                dangerouslySetInnerHTML: {
	                    __html: formattedHTMLMessage
	                }
	            });
	        }
	    }]);
	    return FormattedHTMLMessage;
	}(React.Component);
	
	FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
	
	FormattedHTMLMessage.contextTypes = {
	    intl: intlShape
	};
	
	FormattedHTMLMessage.propTypes = babelHelpers$1['extends']({}, messageDescriptorPropTypes, {
	    values: React.PropTypes.object,
	    tagName: React.PropTypes.string,
	    children: React.PropTypes.func
	});
	
	FormattedHTMLMessage.defaultProps = {
	    values: {},
	    tagName: 'span'
	};
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	addLocaleData(defaultLocaleData);
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	addLocaleData(allLocaleData);
	
	exports.addLocaleData = addLocaleData;
	exports.intlShape = intlShape;
	exports.injectIntl = injectIntl;
	exports.defineMessages = defineMessages;
	exports.IntlProvider = IntlProvider;
	exports.FormattedDate = FormattedDate;
	exports.FormattedTime = FormattedTime;
	exports.FormattedRelative = FormattedRelative;
	exports.FormattedNumber = FormattedNumber;
	exports.FormattedPlural = FormattedPlural;
	exports.FormattedMessage = FormattedMessage;
	exports.FormattedHTMLMessage = FormattedHTMLMessage;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 736 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	
	'use strict';
	
	var IntlMessageFormat = __webpack_require__(738)['default'];
	
	// Add all locale data to `IntlMessageFormat`. This module will be ignored when
	// bundling for the browser with Browserify/Webpack.
	__webpack_require__(746);
	
	// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
	// locale data registered, and with English set as the default locale. Define
	// the `default` prop for use with other compiled ES6 Modules.
	exports = module.exports = IntlMessageFormat;
	exports['default'] = exports;


/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	/* jslint esnext: true */
	
	"use strict";
	var src$core$$ = __webpack_require__(739), src$en$$ = __webpack_require__(745);
	
	src$core$$["default"].__addLocaleData(src$en$$["default"]);
	src$core$$["default"].defaultLocale = 'en';
	
	exports["default"] = src$core$$["default"];
	
	//# sourceMappingURL=main.js.map

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var src$utils$$ = __webpack_require__(740), src$es5$$ = __webpack_require__(741), src$compiler$$ = __webpack_require__(742), intl$messageformat$parser$$ = __webpack_require__(743);
	exports["default"] = MessageFormat;
	
	// -- MessageFormat --------------------------------------------------------
	
	function MessageFormat(message, locales, formats) {
	    // Parse string messages into an AST.
	    var ast = typeof message === 'string' ?
	            MessageFormat.__parse(message) : message;
	
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new TypeError('A message must be provided as a String or AST.');
	    }
	
	    // Creates a new object with the specified `formats` merged with the default
	    // formats.
	    formats = this._mergeFormats(MessageFormat.formats, formats);
	
	    // Defined first because it's used to build the format pattern.
	    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});
	
	    // Compile the `ast` to a pattern that is highly optimized for repeated
	    // `format()` invocations. **Note:** This passes the `locales` set provided
	    // to the constructor instead of just the resolved locale.
	    var pluralFn = this._findPluralRuleFunction(this._locale);
	    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);
	
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var messageFormat = this;
	    this.format = function (values) {
	        return messageFormat._format(pattern, values);
	    };
	}
	
	// Default format options used as the prototype of the `formats` provided to the
	// constructor. These are used when constructing the internal Intl.NumberFormat
	// and Intl.DateTimeFormat instances.
	src$es5$$.defineProperty(MessageFormat, 'formats', {
	    enumerable: true,
	
	    value: {
	        number: {
	            'currency': {
	                style: 'currency'
	            },
	
	            'percent': {
	                style: 'percent'
	            }
	        },
	
	        date: {
	            'short': {
	                month: 'numeric',
	                day  : 'numeric',
	                year : '2-digit'
	            },
	
	            'medium': {
	                month: 'short',
	                day  : 'numeric',
	                year : 'numeric'
	            },
	
	            'long': {
	                month: 'long',
	                day  : 'numeric',
	                year : 'numeric'
	            },
	
	            'full': {
	                weekday: 'long',
	                month  : 'long',
	                day    : 'numeric',
	                year   : 'numeric'
	            }
	        },
	
	        time: {
	            'short': {
	                hour  : 'numeric',
	                minute: 'numeric'
	            },
	
	            'medium':  {
	                hour  : 'numeric',
	                minute: 'numeric',
	                second: 'numeric'
	            },
	
	            'long': {
	                hour        : 'numeric',
	                minute      : 'numeric',
	                second      : 'numeric',
	                timeZoneName: 'short'
	            },
	
	            'full': {
	                hour        : 'numeric',
	                minute      : 'numeric',
	                second      : 'numeric',
	                timeZoneName: 'short'
	            }
	        }
	    }
	});
	
	// Define internal private properties for dealing with locale data.
	src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
	src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
	    if (!(data && data.locale)) {
	        throw new Error(
	            'Locale data provided to IntlMessageFormat is missing a ' +
	            '`locale` property'
	        );
	    }
	
	    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
	}});
	
	// Defines `__parse()` static method as an exposed private.
	src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});
	
	// Define public `defaultLocale` property which defaults to English, but can be
	// set by the developer.
	src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
	    enumerable: true,
	    writable  : true,
	    value     : undefined
	});
	
	MessageFormat.prototype.resolvedOptions = function () {
	    // TODO: Provide anything else?
	    return {
	        locale: this._locale
	    };
	};
	
	MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
	    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
	    return compiler.compile(ast);
	};
	
	MessageFormat.prototype._findPluralRuleFunction = function (locale) {
	    var localeData = MessageFormat.__localeData__;
	    var data       = localeData[locale.toLowerCase()];
	
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find a `pluralRuleFunction` to return.
	    while (data) {
	        if (data.pluralRuleFunction) {
	            return data.pluralRuleFunction;
	        }
	
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	
	    throw new Error(
	        'Locale data added to IntlMessageFormat is missing a ' +
	        '`pluralRuleFunction` for :' + locale
	    );
	};
	
	MessageFormat.prototype._format = function (pattern, values) {
	    var result = '',
	        i, len, part, id, value;
	
	    for (i = 0, len = pattern.length; i < len; i += 1) {
	        part = pattern[i];
	
	        // Exist early for string parts.
	        if (typeof part === 'string') {
	            result += part;
	            continue;
	        }
	
	        id = part.id;
	
	        // Enforce that all required values are provided by the caller.
	        if (!(values && src$utils$$.hop.call(values, id))) {
	            throw new Error('A value must be provided for: ' + id);
	        }
	
	        value = values[id];
	
	        // Recursively format plural and select parts' option — which can be a
	        // nested pattern structure. The choosing of the option to use is
	        // abstracted-by and delegated-to the part helper object.
	        if (part.options) {
	            result += this._format(part.getOption(value), values);
	        } else {
	            result += part.format(value);
	        }
	    }
	
	    return result;
	};
	
	MessageFormat.prototype._mergeFormats = function (defaults, formats) {
	    var mergedFormats = {},
	        type, mergedType;
	
	    for (type in defaults) {
	        if (!src$utils$$.hop.call(defaults, type)) { continue; }
	
	        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);
	
	        if (formats && src$utils$$.hop.call(formats, type)) {
	            src$utils$$.extend(mergedType, formats[type]);
	        }
	    }
	
	    return mergedFormats;
	};
	
	MessageFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(MessageFormat.defaultLocale);
	
	    var localeData = MessageFormat.__localeData__;
	    var i, len, localeParts, data;
	
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	
	            localeParts.pop();
	        }
	    }
	
	    var defaultLocale = locales.pop();
	    throw new Error(
	        'No locale data has been added to IntlMessageFormat for: ' +
	        locales.join(', ') + ', or the default locale: ' + defaultLocale
	    );
	};
	
	//# sourceMappingURL=core.js.map

/***/ },
/* 740 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	exports.extend = extend;
	var hop = Object.prototype.hasOwnProperty;
	
	function extend(obj) {
	    var sources = Array.prototype.slice.call(arguments, 1),
	        i, len, source, key;
	
	    for (i = 0, len = sources.length; i < len; i += 1) {
	        source = sources[i];
	        if (!source) { continue; }
	
	        for (key in source) {
	            if (hop.call(source, key)) {
	                obj[key] = source[key];
	            }
	        }
	    }
	
	    return obj;
	}
	exports.hop = hop;
	
	//# sourceMappingURL=utils.js.map

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var src$utils$$ = __webpack_require__(740);
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (src$utils$$.hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	exports.defineProperty = defineProperty, exports.objCreate = objCreate;
	
	//# sourceMappingURL=es5.js.map

/***/ },
/* 742 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	exports["default"] = Compiler;
	
	function Compiler(locales, formats, pluralFn) {
	    this.locales  = locales;
	    this.formats  = formats;
	    this.pluralFn = pluralFn;
	}
	
	Compiler.prototype.compile = function (ast) {
	    this.pluralStack        = [];
	    this.currentPlural      = null;
	    this.pluralNumberFormat = null;
	
	    return this.compileMessage(ast);
	};
	
	Compiler.prototype.compileMessage = function (ast) {
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new Error('Message AST is not of type: "messageFormatPattern"');
	    }
	
	    var elements = ast.elements,
	        pattern  = [];
	
	    var i, len, element;
	
	    for (i = 0, len = elements.length; i < len; i += 1) {
	        element = elements[i];
	
	        switch (element.type) {
	            case 'messageTextElement':
	                pattern.push(this.compileMessageText(element));
	                break;
	
	            case 'argumentElement':
	                pattern.push(this.compileArgument(element));
	                break;
	
	            default:
	                throw new Error('Message element does not have a valid type');
	        }
	    }
	
	    return pattern;
	};
	
	Compiler.prototype.compileMessageText = function (element) {
	    // When this `element` is part of plural sub-pattern and its value contains
	    // an unescaped '#', use a `PluralOffsetString` helper to properly output
	    // the number with the correct offset in the string.
	    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
	        // Create a cache a NumberFormat instance that can be reused for any
	        // PluralOffsetString instance in this message.
	        if (!this.pluralNumberFormat) {
	            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
	        }
	
	        return new PluralOffsetString(
	                this.currentPlural.id,
	                this.currentPlural.format.offset,
	                this.pluralNumberFormat,
	                element.value);
	    }
	
	    // Unescape the escaped '#'s in the message text.
	    return element.value.replace(/\\#/g, '#');
	};
	
	Compiler.prototype.compileArgument = function (element) {
	    var format = element.format;
	
	    if (!format) {
	        return new StringFormat(element.id);
	    }
	
	    var formats  = this.formats,
	        locales  = this.locales,
	        pluralFn = this.pluralFn,
	        options;
	
	    switch (format.type) {
	        case 'numberFormat':
	            options = formats.number[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.NumberFormat(locales, options).format
	            };
	
	        case 'dateFormat':
	            options = formats.date[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'timeFormat':
	            options = formats.time[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'pluralFormat':
	            options = this.compileOptions(element);
	            return new PluralFormat(
	                element.id, format.ordinal, format.offset, options, pluralFn
	            );
	
	        case 'selectFormat':
	            options = this.compileOptions(element);
	            return new SelectFormat(element.id, options);
	
	        default:
	            throw new Error('Message element does not have a valid format type');
	    }
	};
	
	Compiler.prototype.compileOptions = function (element) {
	    var format      = element.format,
	        options     = format.options,
	        optionsHash = {};
	
	    // Save the current plural element, if any, then set it to a new value when
	    // compiling the options sub-patterns. This conforms the spec's algorithm
	    // for handling `"#"` syntax in message text.
	    this.pluralStack.push(this.currentPlural);
	    this.currentPlural = format.type === 'pluralFormat' ? element : null;
	
	    var i, len, option;
	
	    for (i = 0, len = options.length; i < len; i += 1) {
	        option = options[i];
	
	        // Compile the sub-pattern and save it under the options's selector.
	        optionsHash[option.selector] = this.compileMessage(option.value);
	    }
	
	    // Pop the plural stack to put back the original current plural value.
	    this.currentPlural = this.pluralStack.pop();
	
	    return optionsHash;
	};
	
	// -- Compiler Helper Classes --------------------------------------------------
	
	function StringFormat(id) {
	    this.id = id;
	}
	
	StringFormat.prototype.format = function (value) {
	    if (!value) {
	        return '';
	    }
	
	    return typeof value === 'string' ? value : String(value);
	};
	
	function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
	    this.id         = id;
	    this.useOrdinal = useOrdinal;
	    this.offset     = offset;
	    this.options    = options;
	    this.pluralFn   = pluralFn;
	}
	
	PluralFormat.prototype.getOption = function (value) {
	    var options = this.options;
	
	    var option = options['=' + value] ||
	            options[this.pluralFn(value - this.offset, this.useOrdinal)];
	
	    return option || options.other;
	};
	
	function PluralOffsetString(id, offset, numberFormat, string) {
	    this.id           = id;
	    this.offset       = offset;
	    this.numberFormat = numberFormat;
	    this.string       = string;
	}
	
	PluralOffsetString.prototype.format = function (value) {
	    var number = this.numberFormat.format(value - this.offset);
	
	    return this.string
	            .replace(/(^|[^\\])#/g, '$1' + number)
	            .replace(/\\#/g, '#');
	};
	
	function SelectFormat(id, options) {
	    this.id      = id;
	    this.options = options;
	}
	
	SelectFormat.prototype.getOption = function (value) {
	    var options = this.options;
	    return options[value] || options.other;
	};
	
	//# sourceMappingURL=compiler.js.map

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports = module.exports = __webpack_require__(744)['default'];
	exports['default'] = exports;


/***/ },
/* 744 */
/***/ function(module, exports) {

	"use strict";
	
	exports["default"] = (function() {
	  /*
	   * Generated by PEG.js 0.8.0.
	   *
	   * http://pegjs.majda.cz/
	   */
	
	  function peg$subclass(child, parent) {
	    function ctor() { this.constructor = child; }
	    ctor.prototype = parent.prototype;
	    child.prototype = new ctor();
	  }
	
	  function SyntaxError(message, expected, found, offset, line, column) {
	    this.message  = message;
	    this.expected = expected;
	    this.found    = found;
	    this.offset   = offset;
	    this.line     = line;
	    this.column   = column;
	
	    this.name     = "SyntaxError";
	  }
	
	  peg$subclass(SyntaxError, Error);
	
	  function parse(input) {
	    var options = arguments.length > 1 ? arguments[1] : {},
	
	        peg$FAILED = {},
	
	        peg$startRuleFunctions = { start: peg$parsestart },
	        peg$startRuleFunction  = peg$parsestart,
	
	        peg$c0 = [],
	        peg$c1 = function(elements) {
	                return {
	                    type    : 'messageFormatPattern',
	                    elements: elements
	                };
	            },
	        peg$c2 = peg$FAILED,
	        peg$c3 = function(text) {
	                var string = '',
	                    i, j, outerLen, inner, innerLen;
	
	                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
	                    inner = text[i];
	
	                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
	                        string += inner[j];
	                    }
	                }
	
	                return string;
	            },
	        peg$c4 = function(messageText) {
	                return {
	                    type : 'messageTextElement',
	                    value: messageText
	                };
	            },
	        peg$c5 = /^[^ \t\n\r,.+={}#]/,
	        peg$c6 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
	        peg$c7 = "{",
	        peg$c8 = { type: "literal", value: "{", description: "\"{\"" },
	        peg$c9 = null,
	        peg$c10 = ",",
	        peg$c11 = { type: "literal", value: ",", description: "\",\"" },
	        peg$c12 = "}",
	        peg$c13 = { type: "literal", value: "}", description: "\"}\"" },
	        peg$c14 = function(id, format) {
	                return {
	                    type  : 'argumentElement',
	                    id    : id,
	                    format: format && format[2]
	                };
	            },
	        peg$c15 = "number",
	        peg$c16 = { type: "literal", value: "number", description: "\"number\"" },
	        peg$c17 = "date",
	        peg$c18 = { type: "literal", value: "date", description: "\"date\"" },
	        peg$c19 = "time",
	        peg$c20 = { type: "literal", value: "time", description: "\"time\"" },
	        peg$c21 = function(type, style) {
	                return {
	                    type : type + 'Format',
	                    style: style && style[2]
	                };
	            },
	        peg$c22 = "plural",
	        peg$c23 = { type: "literal", value: "plural", description: "\"plural\"" },
	        peg$c24 = function(pluralStyle) {
	                return {
	                    type   : pluralStyle.type,
	                    ordinal: false,
	                    offset : pluralStyle.offset || 0,
	                    options: pluralStyle.options
	                };
	            },
	        peg$c25 = "selectordinal",
	        peg$c26 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
	        peg$c27 = function(pluralStyle) {
	                return {
	                    type   : pluralStyle.type,
	                    ordinal: true,
	                    offset : pluralStyle.offset || 0,
	                    options: pluralStyle.options
	                }
	            },
	        peg$c28 = "select",
	        peg$c29 = { type: "literal", value: "select", description: "\"select\"" },
	        peg$c30 = function(options) {
	                return {
	                    type   : 'selectFormat',
	                    options: options
	                };
	            },
	        peg$c31 = "=",
	        peg$c32 = { type: "literal", value: "=", description: "\"=\"" },
	        peg$c33 = function(selector, pattern) {
	                return {
	                    type    : 'optionalFormatPattern',
	                    selector: selector,
	                    value   : pattern
	                };
	            },
	        peg$c34 = "offset:",
	        peg$c35 = { type: "literal", value: "offset:", description: "\"offset:\"" },
	        peg$c36 = function(number) {
	                return number;
	            },
	        peg$c37 = function(offset, options) {
	                return {
	                    type   : 'pluralFormat',
	                    offset : offset,
	                    options: options
	                };
	            },
	        peg$c38 = { type: "other", description: "whitespace" },
	        peg$c39 = /^[ \t\n\r]/,
	        peg$c40 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
	        peg$c41 = { type: "other", description: "optionalWhitespace" },
	        peg$c42 = /^[0-9]/,
	        peg$c43 = { type: "class", value: "[0-9]", description: "[0-9]" },
	        peg$c44 = /^[0-9a-f]/i,
	        peg$c45 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
	        peg$c46 = "0",
	        peg$c47 = { type: "literal", value: "0", description: "\"0\"" },
	        peg$c48 = /^[1-9]/,
	        peg$c49 = { type: "class", value: "[1-9]", description: "[1-9]" },
	        peg$c50 = function(digits) {
	            return parseInt(digits, 10);
	        },
	        peg$c51 = /^[^{}\\\0-\x1F \t\n\r]/,
	        peg$c52 = { type: "class", value: "[^{}\\\\\\0-\\x1F \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F \\t\\n\\r]" },
	        peg$c53 = "\\\\",
	        peg$c54 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
	        peg$c55 = function() { return '\\'; },
	        peg$c56 = "\\#",
	        peg$c57 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
	        peg$c58 = function() { return '\\#'; },
	        peg$c59 = "\\{",
	        peg$c60 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
	        peg$c61 = function() { return '\u007B'; },
	        peg$c62 = "\\}",
	        peg$c63 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
	        peg$c64 = function() { return '\u007D'; },
	        peg$c65 = "\\u",
	        peg$c66 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
	        peg$c67 = function(digits) {
	                return String.fromCharCode(parseInt(digits, 16));
	            },
	        peg$c68 = function(chars) { return chars.join(''); },
	
	        peg$currPos          = 0,
	        peg$reportedPos      = 0,
	        peg$cachedPos        = 0,
	        peg$cachedPosDetails = { line: 1, column: 1, seenCR: false },
	        peg$maxFailPos       = 0,
	        peg$maxFailExpected  = [],
	        peg$silentFails      = 0,
	
	        peg$result;
	
	    if ("startRule" in options) {
	      if (!(options.startRule in peg$startRuleFunctions)) {
	        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
	      }
	
	      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
	    }
	
	    function text() {
	      return input.substring(peg$reportedPos, peg$currPos);
	    }
	
	    function offset() {
	      return peg$reportedPos;
	    }
	
	    function line() {
	      return peg$computePosDetails(peg$reportedPos).line;
	    }
	
	    function column() {
	      return peg$computePosDetails(peg$reportedPos).column;
	    }
	
	    function expected(description) {
	      throw peg$buildException(
	        null,
	        [{ type: "other", description: description }],
	        peg$reportedPos
	      );
	    }
	
	    function error(message) {
	      throw peg$buildException(message, null, peg$reportedPos);
	    }
	
	    function peg$computePosDetails(pos) {
	      function advance(details, startPos, endPos) {
	        var p, ch;
	
	        for (p = startPos; p < endPos; p++) {
	          ch = input.charAt(p);
	          if (ch === "\n") {
	            if (!details.seenCR) { details.line++; }
	            details.column = 1;
	            details.seenCR = false;
	          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
	            details.line++;
	            details.column = 1;
	            details.seenCR = true;
	          } else {
	            details.column++;
	            details.seenCR = false;
	          }
	        }
	      }
	
	      if (peg$cachedPos !== pos) {
	        if (peg$cachedPos > pos) {
	          peg$cachedPos = 0;
	          peg$cachedPosDetails = { line: 1, column: 1, seenCR: false };
	        }
	        advance(peg$cachedPosDetails, peg$cachedPos, pos);
	        peg$cachedPos = pos;
	      }
	
	      return peg$cachedPosDetails;
	    }
	
	    function peg$fail(expected) {
	      if (peg$currPos < peg$maxFailPos) { return; }
	
	      if (peg$currPos > peg$maxFailPos) {
	        peg$maxFailPos = peg$currPos;
	        peg$maxFailExpected = [];
	      }
	
	      peg$maxFailExpected.push(expected);
	    }
	
	    function peg$buildException(message, expected, pos) {
	      function cleanupExpected(expected) {
	        var i = 1;
	
	        expected.sort(function(a, b) {
	          if (a.description < b.description) {
	            return -1;
	          } else if (a.description > b.description) {
	            return 1;
	          } else {
	            return 0;
	          }
	        });
	
	        while (i < expected.length) {
	          if (expected[i - 1] === expected[i]) {
	            expected.splice(i, 1);
	          } else {
	            i++;
	          }
	        }
	      }
	
	      function buildMessage(expected, found) {
	        function stringEscape(s) {
	          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }
	
	          return s
	            .replace(/\\/g,   '\\\\')
	            .replace(/"/g,    '\\"')
	            .replace(/\x08/g, '\\b')
	            .replace(/\t/g,   '\\t')
	            .replace(/\n/g,   '\\n')
	            .replace(/\f/g,   '\\f')
	            .replace(/\r/g,   '\\r')
	            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
	            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
	            .replace(/[\u0180-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
	            .replace(/[\u1080-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
	        }
	
	        var expectedDescs = new Array(expected.length),
	            expectedDesc, foundDesc, i;
	
	        for (i = 0; i < expected.length; i++) {
	          expectedDescs[i] = expected[i].description;
	        }
	
	        expectedDesc = expected.length > 1
	          ? expectedDescs.slice(0, -1).join(", ")
	              + " or "
	              + expectedDescs[expected.length - 1]
	          : expectedDescs[0];
	
	        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";
	
	        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
	      }
	
	      var posDetails = peg$computePosDetails(pos),
	          found      = pos < input.length ? input.charAt(pos) : null;
	
	      if (expected !== null) {
	        cleanupExpected(expected);
	      }
	
	      return new SyntaxError(
	        message !== null ? message : buildMessage(expected, found),
	        expected,
	        found,
	        pos,
	        posDetails.line,
	        posDetails.column
	      );
	    }
	
	    function peg$parsestart() {
	      var s0;
	
	      s0 = peg$parsemessageFormatPattern();
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatPattern() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsemessageFormatElement();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsemessageFormatElement();
	      }
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c1(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatElement() {
	      var s0;
	
	      s0 = peg$parsemessageTextElement();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parseargumentElement();
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageText() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$currPos;
	      s3 = peg$parse_();
	      if (s3 !== peg$FAILED) {
	        s4 = peg$parsechars();
	        if (s4 !== peg$FAILED) {
	          s5 = peg$parse_();
	          if (s5 !== peg$FAILED) {
	            s3 = [s3, s4, s5];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$c2;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$c2;
	        }
	      } else {
	        peg$currPos = s2;
	        s2 = peg$c2;
	      }
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$currPos;
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parsechars();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s3 = [s3, s4, s5];
	                s2 = s3;
	              } else {
	                peg$currPos = s2;
	                s2 = peg$c2;
	              }
	            } else {
	              peg$currPos = s2;
	              s2 = peg$c2;
	            }
	          } else {
	            peg$currPos = s2;
	            s2 = peg$c2;
	          }
	        }
	      } else {
	        s1 = peg$c2;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c3(s1);
	      }
	      s0 = s1;
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = peg$parsews();
	        if (s1 !== peg$FAILED) {
	          s1 = input.substring(s0, peg$currPos);
	        }
	        s0 = s1;
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageTextElement() {
	      var s0, s1;
	
	      s0 = peg$currPos;
	      s1 = peg$parsemessageText();
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c4(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parseargument() {
	      var s0, s1, s2;
	
	      s0 = peg$parsenumber();
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = [];
	        if (peg$c5.test(input.charAt(peg$currPos))) {
	          s2 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s2 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c6); }
	        }
	        if (s2 !== peg$FAILED) {
	          while (s2 !== peg$FAILED) {
	            s1.push(s2);
	            if (peg$c5.test(input.charAt(peg$currPos))) {
	              s2 = input.charAt(peg$currPos);
	              peg$currPos++;
	            } else {
	              s2 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c6); }
	            }
	          }
	        } else {
	          s1 = peg$c2;
	        }
	        if (s1 !== peg$FAILED) {
	          s1 = input.substring(s0, peg$currPos);
	        }
	        s0 = s1;
	      }
	
	      return s0;
	    }
	
	    function peg$parseargumentElement() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 123) {
	        s1 = peg$c7;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c8); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parseargument();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$currPos;
	              if (input.charCodeAt(peg$currPos) === 44) {
	                s6 = peg$c10;
	                peg$currPos++;
	              } else {
	                s6 = peg$FAILED;
	                if (peg$silentFails === 0) { peg$fail(peg$c11); }
	              }
	              if (s6 !== peg$FAILED) {
	                s7 = peg$parse_();
	                if (s7 !== peg$FAILED) {
	                  s8 = peg$parseelementFormat();
	                  if (s8 !== peg$FAILED) {
	                    s6 = [s6, s7, s8];
	                    s5 = s6;
	                  } else {
	                    peg$currPos = s5;
	                    s5 = peg$c2;
	                  }
	                } else {
	                  peg$currPos = s5;
	                  s5 = peg$c2;
	                }
	              } else {
	                peg$currPos = s5;
	                s5 = peg$c2;
	              }
	              if (s5 === peg$FAILED) {
	                s5 = peg$c9;
	              }
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parse_();
	                if (s6 !== peg$FAILED) {
	                  if (input.charCodeAt(peg$currPos) === 125) {
	                    s7 = peg$c12;
	                    peg$currPos++;
	                  } else {
	                    s7 = peg$FAILED;
	                    if (peg$silentFails === 0) { peg$fail(peg$c13); }
	                  }
	                  if (s7 !== peg$FAILED) {
	                    peg$reportedPos = s0;
	                    s1 = peg$c14(s3, s5);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$c2;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$c2;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseelementFormat() {
	      var s0;
	
	      s0 = peg$parsesimpleFormat();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsepluralFormat();
	        if (s0 === peg$FAILED) {
	          s0 = peg$parseselectOrdinalFormat();
	          if (s0 === peg$FAILED) {
	            s0 = peg$parseselectFormat();
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsesimpleFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c15) {
	        s1 = peg$c15;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c16); }
	      }
	      if (s1 === peg$FAILED) {
	        if (input.substr(peg$currPos, 4) === peg$c17) {
	          s1 = peg$c17;
	          peg$currPos += 4;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c18); }
	        }
	        if (s1 === peg$FAILED) {
	          if (input.substr(peg$currPos, 4) === peg$c19) {
	            s1 = peg$c19;
	            peg$currPos += 4;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c20); }
	          }
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$currPos;
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s4 = peg$c10;
	            peg$currPos++;
	          } else {
	            s4 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c11); }
	          }
	          if (s4 !== peg$FAILED) {
	            s5 = peg$parse_();
	            if (s5 !== peg$FAILED) {
	              s6 = peg$parsechars();
	              if (s6 !== peg$FAILED) {
	                s4 = [s4, s5, s6];
	                s3 = s4;
	              } else {
	                peg$currPos = s3;
	                s3 = peg$c2;
	              }
	            } else {
	              peg$currPos = s3;
	              s3 = peg$c2;
	            }
	          } else {
	            peg$currPos = s3;
	            s3 = peg$c2;
	          }
	          if (s3 === peg$FAILED) {
	            s3 = peg$c9;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$reportedPos = s0;
	            s1 = peg$c21(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c22) {
	        s1 = peg$c22;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c23); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c10;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c11); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$reportedPos = s0;
	                s1 = peg$c24(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectOrdinalFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 13) === peg$c25) {
	        s1 = peg$c25;
	        peg$currPos += 13;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c26); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c10;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c11); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$reportedPos = s0;
	                s1 = peg$c27(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c28) {
	        s1 = peg$c28;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c29); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c10;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c11); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = [];
	              s6 = peg$parseoptionalFormatPattern();
	              if (s6 !== peg$FAILED) {
	                while (s6 !== peg$FAILED) {
	                  s5.push(s6);
	                  s6 = peg$parseoptionalFormatPattern();
	                }
	              } else {
	                s5 = peg$c2;
	              }
	              if (s5 !== peg$FAILED) {
	                peg$reportedPos = s0;
	                s1 = peg$c30(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselector() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      s1 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 61) {
	        s2 = peg$c31;
	        peg$currPos++;
	      } else {
	        s2 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c32); }
	      }
	      if (s2 !== peg$FAILED) {
	        s3 = peg$parsenumber();
	        if (s3 !== peg$FAILED) {
	          s2 = [s2, s3];
	          s1 = s2;
	        } else {
	          peg$currPos = s1;
	          s1 = peg$c2;
	        }
	      } else {
	        peg$currPos = s1;
	        s1 = peg$c2;
	      }
	      if (s1 !== peg$FAILED) {
	        s1 = input.substring(s0, peg$currPos);
	      }
	      s0 = s1;
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsechars();
	      }
	
	      return s0;
	    }
	
	    function peg$parseoptionalFormatPattern() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      s1 = peg$parse_();
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parseselector();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            if (input.charCodeAt(peg$currPos) === 123) {
	              s4 = peg$c7;
	              peg$currPos++;
	            } else {
	              s4 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c8); }
	            }
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parsemessageFormatPattern();
	                if (s6 !== peg$FAILED) {
	                  s7 = peg$parse_();
	                  if (s7 !== peg$FAILED) {
	                    if (input.charCodeAt(peg$currPos) === 125) {
	                      s8 = peg$c12;
	                      peg$currPos++;
	                    } else {
	                      s8 = peg$FAILED;
	                      if (peg$silentFails === 0) { peg$fail(peg$c13); }
	                    }
	                    if (s8 !== peg$FAILED) {
	                      peg$reportedPos = s0;
	                      s1 = peg$c33(s2, s6);
	                      s0 = s1;
	                    } else {
	                      peg$currPos = s0;
	                      s0 = peg$c2;
	                    }
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$c2;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$c2;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseoffset() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 7) === peg$c34) {
	        s1 = peg$c34;
	        peg$currPos += 7;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c35); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parsenumber();
	          if (s3 !== peg$FAILED) {
	            peg$reportedPos = s0;
	            s1 = peg$c36(s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralStyle() {
	      var s0, s1, s2, s3, s4;
	
	      s0 = peg$currPos;
	      s1 = peg$parseoffset();
	      if (s1 === peg$FAILED) {
	        s1 = peg$c9;
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = [];
	          s4 = peg$parseoptionalFormatPattern();
	          if (s4 !== peg$FAILED) {
	            while (s4 !== peg$FAILED) {
	              s3.push(s4);
	              s4 = peg$parseoptionalFormatPattern();
	            }
	          } else {
	            s3 = peg$c2;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$reportedPos = s0;
	            s1 = peg$c37(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parsews() {
	      var s0, s1;
	
	      peg$silentFails++;
	      s0 = [];
	      if (peg$c39.test(input.charAt(peg$currPos))) {
	        s1 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c40); }
	      }
	      if (s1 !== peg$FAILED) {
	        while (s1 !== peg$FAILED) {
	          s0.push(s1);
	          if (peg$c39.test(input.charAt(peg$currPos))) {
	            s1 = input.charAt(peg$currPos);
	            peg$currPos++;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c40); }
	          }
	        }
	      } else {
	        s0 = peg$c2;
	      }
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c38); }
	      }
	
	      return s0;
	    }
	
	    function peg$parse_() {
	      var s0, s1, s2;
	
	      peg$silentFails++;
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsews();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsews();
	      }
	      if (s1 !== peg$FAILED) {
	        s1 = input.substring(s0, peg$currPos);
	      }
	      s0 = s1;
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c41); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsedigit() {
	      var s0;
	
	      if (peg$c42.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c43); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsehexDigit() {
	      var s0;
	
	      if (peg$c44.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c45); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsenumber() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 48) {
	        s1 = peg$c46;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c47); }
	      }
	      if (s1 === peg$FAILED) {
	        s1 = peg$currPos;
	        s2 = peg$currPos;
	        if (peg$c48.test(input.charAt(peg$currPos))) {
	          s3 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s3 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c49); }
	        }
	        if (s3 !== peg$FAILED) {
	          s4 = [];
	          s5 = peg$parsedigit();
	          while (s5 !== peg$FAILED) {
	            s4.push(s5);
	            s5 = peg$parsedigit();
	          }
	          if (s4 !== peg$FAILED) {
	            s3 = [s3, s4];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$c2;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$c2;
	        }
	        if (s2 !== peg$FAILED) {
	          s2 = input.substring(s1, peg$currPos);
	        }
	        s1 = s2;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c50(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsechar() {
	      var s0, s1, s2, s3, s4, s5, s6, s7;
	
	      if (peg$c51.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c52); }
	      }
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        if (input.substr(peg$currPos, 2) === peg$c53) {
	          s1 = peg$c53;
	          peg$currPos += 2;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c54); }
	        }
	        if (s1 !== peg$FAILED) {
	          peg$reportedPos = s0;
	          s1 = peg$c55();
	        }
	        s0 = s1;
	        if (s0 === peg$FAILED) {
	          s0 = peg$currPos;
	          if (input.substr(peg$currPos, 2) === peg$c56) {
	            s1 = peg$c56;
	            peg$currPos += 2;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c57); }
	          }
	          if (s1 !== peg$FAILED) {
	            peg$reportedPos = s0;
	            s1 = peg$c58();
	          }
	          s0 = s1;
	          if (s0 === peg$FAILED) {
	            s0 = peg$currPos;
	            if (input.substr(peg$currPos, 2) === peg$c59) {
	              s1 = peg$c59;
	              peg$currPos += 2;
	            } else {
	              s1 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c60); }
	            }
	            if (s1 !== peg$FAILED) {
	              peg$reportedPos = s0;
	              s1 = peg$c61();
	            }
	            s0 = s1;
	            if (s0 === peg$FAILED) {
	              s0 = peg$currPos;
	              if (input.substr(peg$currPos, 2) === peg$c62) {
	                s1 = peg$c62;
	                peg$currPos += 2;
	              } else {
	                s1 = peg$FAILED;
	                if (peg$silentFails === 0) { peg$fail(peg$c63); }
	              }
	              if (s1 !== peg$FAILED) {
	                peg$reportedPos = s0;
	                s1 = peg$c64();
	              }
	              s0 = s1;
	              if (s0 === peg$FAILED) {
	                s0 = peg$currPos;
	                if (input.substr(peg$currPos, 2) === peg$c65) {
	                  s1 = peg$c65;
	                  peg$currPos += 2;
	                } else {
	                  s1 = peg$FAILED;
	                  if (peg$silentFails === 0) { peg$fail(peg$c66); }
	                }
	                if (s1 !== peg$FAILED) {
	                  s2 = peg$currPos;
	                  s3 = peg$currPos;
	                  s4 = peg$parsehexDigit();
	                  if (s4 !== peg$FAILED) {
	                    s5 = peg$parsehexDigit();
	                    if (s5 !== peg$FAILED) {
	                      s6 = peg$parsehexDigit();
	                      if (s6 !== peg$FAILED) {
	                        s7 = peg$parsehexDigit();
	                        if (s7 !== peg$FAILED) {
	                          s4 = [s4, s5, s6, s7];
	                          s3 = s4;
	                        } else {
	                          peg$currPos = s3;
	                          s3 = peg$c2;
	                        }
	                      } else {
	                        peg$currPos = s3;
	                        s3 = peg$c2;
	                      }
	                    } else {
	                      peg$currPos = s3;
	                      s3 = peg$c2;
	                    }
	                  } else {
	                    peg$currPos = s3;
	                    s3 = peg$c2;
	                  }
	                  if (s3 !== peg$FAILED) {
	                    s3 = input.substring(s2, peg$currPos);
	                  }
	                  s2 = s3;
	                  if (s2 !== peg$FAILED) {
	                    peg$reportedPos = s0;
	                    s1 = peg$c67(s2);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$c2;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$c2;
	                }
	              }
	            }
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsechars() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsechar();
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$parsechar();
	        }
	      } else {
	        s1 = peg$c2;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c68(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    peg$result = peg$startRuleFunction();
	
	    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
	      return peg$result;
	    } else {
	      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
	        peg$fail({ type: "end", description: "end of input" });
	      }
	
	      throw peg$buildException(null, peg$maxFailExpected, peg$maxFailPos);
	    }
	  }
	
	  return {
	    SyntaxError: SyntaxError,
	    parse:       parse
	  };
	})();
	
	//# sourceMappingURL=parser.js.map

/***/ },
/* 745 */
/***/ function(module, exports) {

	// GENERATED FILE
	"use strict";
	exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};
	
	//# sourceMappingURL=en.js.map

/***/ },
/* 746 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	
	'use strict';
	
	var IntlRelativeFormat = __webpack_require__(748)['default'];
	
	// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
	// bundling for the browser with Browserify/Webpack.
	__webpack_require__(753);
	
	// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
	// locale data registered, and with English set as the default locale. Define
	// the `default` prop for use with other compiled ES6 Modules.
	exports = module.exports = IntlRelativeFormat;
	exports['default'] = exports;


/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	/* jslint esnext: true */
	
	"use strict";
	var src$core$$ = __webpack_require__(749), src$en$$ = __webpack_require__(752);
	
	src$core$$["default"].__addLocaleData(src$en$$["default"]);
	src$core$$["default"].defaultLocale = 'en';
	
	exports["default"] = src$core$$["default"];
	
	//# sourceMappingURL=main.js.map

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var intl$messageformat$$ = __webpack_require__(737), src$diff$$ = __webpack_require__(750), src$es5$$ = __webpack_require__(751);
	exports["default"] = RelativeFormat;
	
	// -----------------------------------------------------------------------------
	
	var FIELDS = ['second', 'minute', 'hour', 'day', 'month', 'year'];
	var STYLES = ['best fit', 'numeric'];
	
	// -- RelativeFormat -----------------------------------------------------------
	
	function RelativeFormat(locales, options) {
	    options = options || {};
	
	    // Make a copy of `locales` if it's an array, so that it doesn't change
	    // since it's used lazily.
	    if (src$es5$$.isArray(locales)) {
	        locales = locales.concat();
	    }
	
	    src$es5$$.defineProperty(this, '_locale', {value: this._resolveLocale(locales)});
	    src$es5$$.defineProperty(this, '_options', {value: {
	        style: this._resolveStyle(options.style),
	        units: this._isValidUnits(options.units) && options.units
	    }});
	
	    src$es5$$.defineProperty(this, '_locales', {value: locales});
	    src$es5$$.defineProperty(this, '_fields', {value: this._findFields(this._locale)});
	    src$es5$$.defineProperty(this, '_messages', {value: src$es5$$.objCreate(null)});
	
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var relativeFormat = this;
	    this.format = function format(date, options) {
	        return relativeFormat._format(date, options);
	    };
	}
	
	// Define internal private properties for dealing with locale data.
	src$es5$$.defineProperty(RelativeFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
	src$es5$$.defineProperty(RelativeFormat, '__addLocaleData', {value: function (data) {
	    if (!(data && data.locale)) {
	        throw new Error(
	            'Locale data provided to IntlRelativeFormat is missing a ' +
	            '`locale` property value'
	        );
	    }
	
	    RelativeFormat.__localeData__[data.locale.toLowerCase()] = data;
	
	    // Add data to IntlMessageFormat.
	    intl$messageformat$$["default"].__addLocaleData(data);
	}});
	
	// Define public `defaultLocale` property which can be set by the developer, or
	// it will be set when the first RelativeFormat instance is created by
	// leveraging the resolved locale from `Intl`.
	src$es5$$.defineProperty(RelativeFormat, 'defaultLocale', {
	    enumerable: true,
	    writable  : true,
	    value     : undefined
	});
	
	// Define public `thresholds` property which can be set by the developer, and
	// defaults to relative time thresholds from moment.js.
	src$es5$$.defineProperty(RelativeFormat, 'thresholds', {
	    enumerable: true,
	
	    value: {
	        second: 45,  // seconds to minute
	        minute: 45,  // minutes to hour
	        hour  : 22,  // hours to day
	        day   : 26,  // days to month
	        month : 11   // months to year
	    }
	});
	
	RelativeFormat.prototype.resolvedOptions = function () {
	    return {
	        locale: this._locale,
	        style : this._options.style,
	        units : this._options.units
	    };
	};
	
	RelativeFormat.prototype._compileMessage = function (units) {
	    // `this._locales` is the original set of locales the user specified to the
	    // constructor, while `this._locale` is the resolved root locale.
	    var locales        = this._locales;
	    var resolvedLocale = this._locale;
	
	    var field        = this._fields[units];
	    var relativeTime = field.relativeTime;
	    var future       = '';
	    var past         = '';
	    var i;
	
	    for (i in relativeTime.future) {
	        if (relativeTime.future.hasOwnProperty(i)) {
	            future += ' ' + i + ' {' +
	                relativeTime.future[i].replace('{0}', '#') + '}';
	        }
	    }
	
	    for (i in relativeTime.past) {
	        if (relativeTime.past.hasOwnProperty(i)) {
	            past += ' ' + i + ' {' +
	                relativeTime.past[i].replace('{0}', '#') + '}';
	        }
	    }
	
	    var message = '{when, select, future {{0, plural, ' + future + '}}' +
	                                 'past {{0, plural, ' + past + '}}}';
	
	    // Create the synthetic IntlMessageFormat instance using the original
	    // locales value specified by the user when constructing the the parent
	    // IntlRelativeFormat instance.
	    return new intl$messageformat$$["default"](message, locales);
	};
	
	RelativeFormat.prototype._getMessage = function (units) {
	    var messages = this._messages;
	
	    // Create a new synthetic message based on the locale data from CLDR.
	    if (!messages[units]) {
	        messages[units] = this._compileMessage(units);
	    }
	
	    return messages[units];
	};
	
	RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
	    var field = this._fields[units];
	
	    if (field.relative) {
	        return field.relative[diff];
	    }
	};
	
	RelativeFormat.prototype._findFields = function (locale) {
	    var localeData = RelativeFormat.__localeData__;
	    var data       = localeData[locale.toLowerCase()];
	
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find `fields` to return.
	    while (data) {
	        if (data.fields) {
	            return data.fields;
	        }
	
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	
	    throw new Error(
	        'Locale data added to IntlRelativeFormat is missing `fields` for :' +
	        locale
	    );
	};
	
	RelativeFormat.prototype._format = function (date, options) {
	    var now = options && options.now !== undefined ? options.now : src$es5$$.dateNow();
	
	    if (date === undefined) {
	        date = now;
	    }
	
	    // Determine if the `date` and optional `now` values are valid, and throw a
	    // similar error to what `Intl.DateTimeFormat#format()` would throw.
	    if (!isFinite(now)) {
	        throw new RangeError(
	            'The `now` option provided to IntlRelativeFormat#format() is not ' +
	            'in valid range.'
	        );
	    }
	
	    if (!isFinite(date)) {
	        throw new RangeError(
	            'The date value provided to IntlRelativeFormat#format() is not ' +
	            'in valid range.'
	        );
	    }
	
	    var diffReport  = src$diff$$["default"](now, date);
	    var units       = this._options.units || this._selectUnits(diffReport);
	    var diffInUnits = diffReport[units];
	
	    if (this._options.style !== 'numeric') {
	        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
	        if (relativeUnits) {
	            return relativeUnits;
	        }
	    }
	
	    return this._getMessage(units).format({
	        '0' : Math.abs(diffInUnits),
	        when: diffInUnits < 0 ? 'past' : 'future'
	    });
	};
	
	RelativeFormat.prototype._isValidUnits = function (units) {
	    if (!units || src$es5$$.arrIndexOf.call(FIELDS, units) >= 0) {
	        return true;
	    }
	
	    if (typeof units === 'string') {
	        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
	        if (suggestion && src$es5$$.arrIndexOf.call(FIELDS, suggestion) >= 0) {
	            throw new Error(
	                '"' + units + '" is not a valid IntlRelativeFormat `units` ' +
	                'value, did you mean: ' + suggestion
	            );
	        }
	    }
	
	    throw new Error(
	        '"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
	        'must be one of: "' + FIELDS.join('", "') + '"'
	    );
	};
	
	RelativeFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(RelativeFormat.defaultLocale);
	
	    var localeData = RelativeFormat.__localeData__;
	    var i, len, localeParts, data;
	
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	
	            localeParts.pop();
	        }
	    }
	
	    var defaultLocale = locales.pop();
	    throw new Error(
	        'No locale data has been added to IntlRelativeFormat for: ' +
	        locales.join(', ') + ', or the default locale: ' + defaultLocale
	    );
	};
	
	RelativeFormat.prototype._resolveStyle = function (style) {
	    // Default to "best fit" style.
	    if (!style) {
	        return STYLES[0];
	    }
	
	    if (src$es5$$.arrIndexOf.call(STYLES, style) >= 0) {
	        return style;
	    }
	
	    throw new Error(
	        '"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
	        'must be one of: "' + STYLES.join('", "') + '"'
	    );
	};
	
	RelativeFormat.prototype._selectUnits = function (diffReport) {
	    var i, l, units;
	
	    for (i = 0, l = FIELDS.length; i < l; i += 1) {
	        units = FIELDS[i];
	
	        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
	            break;
	        }
	    }
	
	    return units;
	};
	
	//# sourceMappingURL=core.js.map

/***/ },
/* 750 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	
	var round = Math.round;
	
	function daysToYears(days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    return days * 400 / 146097;
	}
	
	exports["default"] = function (from, to) {
	    // Convert to ms timestamps.
	    from = +from;
	    to   = +to;
	
	    var millisecond = round(to - from),
	        second      = round(millisecond / 1000),
	        minute      = round(second / 60),
	        hour        = round(minute / 60),
	        day         = round(hour / 24),
	        week        = round(day / 7);
	
	    var rawYears = daysToYears(day),
	        month    = round(rawYears * 12),
	        year     = round(rawYears);
	
	    return {
	        millisecond: millisecond,
	        second     : second,
	        minute     : minute,
	        hour       : hour,
	        day        : day,
	        week       : week,
	        month      : month,
	        year       : year
	    };
	};
	
	//# sourceMappingURL=diff.js.map

/***/ },
/* 751 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var hop = Object.prototype.hasOwnProperty;
	var toString = Object.prototype.toString;
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	
	var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
	    /*jshint validthis:true */
	    var arr = this;
	    if (!arr.length) {
	        return -1;
	    }
	
	    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
	        if (arr[i] === search) {
	            return i;
	        }
	    }
	
	    return -1;
	};
	
	var isArray = Array.isArray || function (obj) {
	    return toString.call(obj) === '[object Array]';
	};
	
	var dateNow = Date.now || function () {
	    return new Date().getTime();
	};
	exports.defineProperty = defineProperty, exports.objCreate = objCreate, exports.arrIndexOf = arrIndexOf, exports.isArray = isArray, exports.dateNow = dateNow;
	
	//# sourceMappingURL=es5.js.map

/***/ },
/* 752 */
/***/ function(module, exports) {

	// GENERATED FILE
	"use strict";
	exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"},"fields":{"year":{"displayName":"year","relative":{"0":"this year","1":"next year","-1":"last year"},"relativeTime":{"future":{"one":"in {0} year","other":"in {0} years"},"past":{"one":"{0} year ago","other":"{0} years ago"}}},"month":{"displayName":"month","relative":{"0":"this month","1":"next month","-1":"last month"},"relativeTime":{"future":{"one":"in {0} month","other":"in {0} months"},"past":{"one":"{0} month ago","other":"{0} months ago"}}},"day":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"hour":{"displayName":"hour","relativeTime":{"future":{"one":"in {0} hour","other":"in {0} hours"},"past":{"one":"{0} hour ago","other":"{0} hours ago"}}},"minute":{"displayName":"minute","relativeTime":{"future":{"one":"in {0} minute","other":"in {0} minutes"},"past":{"one":"{0} minute ago","other":"{0} minutes ago"}}},"second":{"displayName":"second","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} second","other":"in {0} seconds"},"past":{"one":"{0} second ago","other":"{0} seconds ago"}}}}};
	
	//# sourceMappingURL=en.js.map

/***/ },
/* 753 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports = module.exports = __webpack_require__(756)['default'];
	exports['default'] = exports;


/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var src$es5$$ = __webpack_require__(757);
	exports["default"] = createFormatCache;
	
	// -----------------------------------------------------------------------------
	
	function createFormatCache(FormatConstructor) {
	    var cache = src$es5$$.objCreate(null);
	
	    return function () {
	        var args    = Array.prototype.slice.call(arguments);
	        var cacheId = getCacheId(args);
	        var format  = cacheId && cache[cacheId];
	
	        if (!format) {
	            format = new (src$es5$$.bind.apply(FormatConstructor, [null].concat(args)))();
	
	            if (cacheId) {
	                cache[cacheId] = format;
	            }
	        }
	
	        return format;
	    };
	}
	
	// -- Utilities ----------------------------------------------------------------
	
	function getCacheId(inputs) {
	    // When JSON is not available in the runtime, we will not create a cache id.
	    if (typeof JSON === 'undefined') { return; }
	
	    var cacheId = [];
	
	    var i, len, input;
	
	    for (i = 0, len = inputs.length; i < len; i += 1) {
	        input = inputs[i];
	
	        if (input && typeof input === 'object') {
	            cacheId.push(orderedProps(input));
	        } else {
	            cacheId.push(input);
	        }
	    }
	
	    return JSON.stringify(cacheId);
	}
	
	function orderedProps(obj) {
	    var props = [],
	        keys  = [];
	
	    var key, i, len, prop;
	
	    for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	            keys.push(key);
	        }
	    }
	
	    var orderedKeys = keys.sort();
	
	    for (i = 0, len = orderedKeys.length; i < len; i += 1) {
	        key  = orderedKeys[i];
	        prop = {};
	
	        prop[key] = obj[key];
	        props[i]  = prop;
	    }
	
	    return props;
	}
	
	//# sourceMappingURL=memoizer.js.map

/***/ },
/* 757 */
/***/ function(module, exports) {

	"use strict";
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	// Function.prototype.bind implementation from Mozilla Developer Network:
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill
	
	var bind = Function.prototype.bind || function (oThis) {
	    if (typeof this !== 'function') {
	      // closest thing possible to the ECMAScript 5
	      // internal IsCallable function
	      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
	    }
	
	    var aArgs   = Array.prototype.slice.call(arguments, 1),
	        fToBind = this,
	        fNOP    = function() {},
	        fBound  = function() {
	          return fToBind.apply(this instanceof fNOP
	                 ? this
	                 : oThis,
	                 aArgs.concat(Array.prototype.slice.call(arguments)));
	        };
	
	    if (this.prototype) {
	      // native functions don't have a prototype
	      fNOP.prototype = this.prototype;
	    }
	    fBound.prototype = new fNOP();
	
	    return fBound;
	};
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var hop = Object.prototype.hasOwnProperty;
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	
	exports.bind = bind, exports.defineProperty = defineProperty, exports.objCreate = objCreate;
	
	//# sourceMappingURL=es5.js.map

/***/ },
/* 758 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports['default'] = flattenMessages;
	function flattenMessages(nestedMessages) {
	    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	    return Object.keys(nestedMessages).reduce(function (messages, key) {
	        var value = nestedMessages[key];
	        var prefixedKey = prefix ? prefix + '.' + key : key;
	
	        if (typeof value === 'string') {
	            messages[prefixedKey] = value;
	        } else {
	            Object.assign(messages, flattenMessages(value, prefixedKey));
	        }
	
	        return messages;
	    }, {});
	}

/***/ },
/* 759 */
/***/ function(module, exports) {

	module.exports = {
		"common": {
			"nextButton": {
				"labelText": "Next"
			},
			"continueButton": {
				"labelText": "Continue"
			},
			"closeButton": {
				"labelText": "Close"
			}
		},
		"error": {
			"general": {
				"message": "An error occurred"
			},
			"notFound": {
				"message": "Page not found"
			},
			"nothingToSign": {
				"message": "Nothing to sign"
			},
			"field": {
				"minNotMetMessage": "Please select at least {min} { min, plural, =1 {item} other {items} }",
				"maxExceededMessage": "You have selected too many boxes. Please uncheck one.",
				"requiredMessage": "This field is required",
				"fieldsMissing": "Required fields are missing. Please click 'Edit'."
			},
			"network": {
				"title": "Your connection has been lost.",
				"message": "Please wait until your connection is reestablished to continue."
			},
			"noValidSignatureTypes": {
				"title": "Can't sign on mobile",
				"message": "Warning: This document can only be completed from a computer due to the settings set by the person that sent you this document."
			},
			"validation": {
				"numbers_only": "This field only accepts numbers",
				"letters_only": "This field only accepts letters",
				"phone_number": "Please enter a 10- or 11-digit telephone number",
				"bank_routing_number": "Please enter a 9-digit routing number",
				"bank_account_number": "Please enter a minimum of 6 digits",
				"email_address": "Please enter a valid email address",
				"zip_code": "Please enter a 5- or 9-digit zip code",
				"social_security_number": "Please enter a 9-digit social security number",
				"employer_identification_number": "Please enter a 9-digit employer identification number"
			},
			"accountSignup": {
				"existingAccount": "That account already exists!"
			}
		},
		"signer": {
			"choice": {
				"message": {
					"welcomeText": "Hi {emailAddress},",
					"instructionsText": "More than one person has been associated with your email address, please identify yourself and click &quot;continue&quot;."
				},
				"continueButton": {
					"labelText": "Continue"
				}
			},
			"document": {
				"alert": {
					"insertedInAllFieldsMessage": "Your { type, select, signature {signature has} initials {initials have} } been inserted everywhere",
					"testRequestMessage": "This is a mock signature request and it has no legal value",
					"allRequiredFieldsCompleted": "{ isDesktop, select, 1 {You have completed all required fields. Please click 'Continue'.} 0 {Required fields are done. Tap 'Continue'.} }"
				},
				"signature": {
					"insertEverywhereLabelText": "Insert everywhere",
					"editLabelText": "Edit",
					"clearLabelText": "Clear"
				},
				"loader": {
					"text": "Preparing document",
					"finalizing": "We&apos;re finalizing your document"
				}
			},
			"field": {
				"label": {
					"mobileText": "{ type, select, signature {Signature} initials {Initials} text {} date {} }",
					"desktopText": "{ type, select, signature {Click to sign} initials {Click to initial} text {} date {} }"
				},
				"groupMinReqText": "At least {min} { min, plural, =1 {checkbox is} other {checkboxes are} } required",
				"groupMinMaxReqText": "{min} to {max} { max, plural, =1 {checkbox} other {checkboxes} } can be selected",
				"groupMaxReqText": "At most {max} checkboxes can be selected",
				"groupSameMinMaxReqText": "{min} { min, plural, =1 {checkbox} other {checkboxes} } must be selected"
			},
			"nav": {
				"fieldsLeftMessage": "REQ<span class='m-signature-request--header-required-field'>*</span> { fieldsLeft, plural, =1 { field } other { fields } } left <span class='m-signature-request--header-fields-left-count'>{fieldsLeft}</span>",
				"fieldsLeftMiniMessage": "REQ<span class='m-signature-request--header-required-field'>*</span> { fieldsLeft, plural, =1 { field } other { fields } } left <span class='m-signature-request--header-fields-left-count'>{fieldsLeft}</span>",
				"nextReqMessage": "Next Req*",
				"nextMessage": "Next"
			},
			"download": {
				"tooltip": {
					"text": "Download file"
				}
			},
			"headerMenu": {
				"download": "Download",
				"decline": "Decline",
				"close": "Close",
				"delegate": "Reassign"
			},
			"subheader": {
				"delegate": {
					"message": "Not the authorized signer?",
					"ctaMessage": "Assign to someone else"
				}
			},
			"enterCode": {
				"title": "Please enter access code to view",
				"note": "Note: the access code is case sensitive.",
				"checkingText": "Checking...",
				"error": {
					"incorrectText": "The access code you've entered is incorrect. {attemptsRemaining} {attemptsRemaining, plural, =1 {attempt} other {attempts}} remaining.",
					"maxAttemptsText": "You have reached the maximum number of attempts."
				}
			},
			"preview": {
				"title": "Please fill out & sign this document.",
				"desktopHeaderInfoMessage": {
					"siteUi": "Hello {name},<br />Click 'Get Started' to fill out and sign '<strong>{title}</strong>', or <a href='{downloadLink}'>download</a> the original.",
					"embedded": "Hello {name},<br />Click 'Get Started' to fill out and sign '<strong>{title}</strong>'."
				},
				"getStartedButton": {
					"labelText": "Get Started"
				}
			},
			"confirm": {
				"title": "Almost done.",
				"legalMessage1": "I agree to be legally bound by this document and the <a href='https://www.hellosign.com/info/tos' class='whitelabel-link' target='_blank' rel='noopener noreferrer'>HelloSign Terms of Service</a>. Click on 'I Agree' to sign this document.",
				"legalMessage2": "Almost done. By clicking \"I Agree\" you are legally signing this document and agreeing to the <a href='https://www.hellosign.com/info/tos' class='whitelabel-link' target='_blank' rel='noopener noreferrer'>eSignature Terms of Service</a>.",
				"agreeButton": {
					"labelText": "I agree"
				},
				"backButton": {
					"labelText": "back",
					"desktopText": "Edit"
				}
			},
			"decline": {
				"modal": {
					"title": "Decline to sign this document",
					"description": "Declining this document will clear anything you have entered and notify the sender.",
					"reasonTitle": "Reason for declining",
					"sharedOnlyWithSender": "This information will be shared only with the sender.",
					"declineButton": "Decline",
					"cancelButton": "Cancel",
					"noReasonError": "Please provide a reason."
				},
				"complete": {
					"documentClosed": "This document is now closed.",
					"emailConfirmation": "You'll receive an email confirmation shortly."
				}
			},
			"delegate": {
				"modal": {
					"title": "Reassign this document",
					"description": "If you’re not the authorized signer for this document, you can assign it to someone else. By reassigning, the document will be cleared of anything you have entered.",
					"reasonTitle": "Reason for reassigning",
					"sharedOnlyWithSender": "This information will only be shared with the requester and the recipient.",
					"confirmButton": "Reassign",
					"cancelButton": "Cancel",
					"name": "Name",
					"email": "Email",
					"noReasonError": "Please provide a reason.",
					"noEmailError": "Please provide an email.",
					"noNameError": "Please provide a name.",
					"ctaMessage": "In completing this step, the requester and the recipient will receive a notification of the changes.  You will no longer have access to sign this document and you will receive a copy of the completed document once all parties have signed."
				},
				"complete": {
					"documentDelegated": "This document has now been reassigned to {newSignerName}",
					"emailConfirmation": "You'll receive a confirmation email shortly."
				}
			},
			"complete": {
				"thanksMessage": "Thanks for submitting your document!",
				"willReceiveCopyMessage": "You'll receive a copy in your inbox shortly.",
				"aboutHelloSignMessage": "Need someone to sign a document? <br /> Send it with HelloSign.",
				"takeTourButton": {
					"labelText": "Learn More"
				},
				"inPerson": {
					"thanks": "Thanks for signing this document!",
					"farewell": "Have a fantastic day.",
					"signAgain": "Start Another Signature Process"
				},
				"convertSigners": {
					"header": "Thanks for submitting your document. You'll receive a copy in your inbox shortly.",
					"title": "Fundraising is hard. Make agreements easy.",
					"subtitle": {
						"preLink": "With HelloSign, founders get",
						"link": "3 free",
						"postLink": "documents per month."
					},
					"signupForm": {
						"text": "Activate Your Free Account",
						"placeholder": "Enter your email",
						"optInLabel": "Send me HelloSign updates",
						"buttonText": "Submit",
						"successTitle": "Success!",
						"successText": "Please check your email for the confirmation link."
					},
					"apiMessage": "Integrate eSignatures into your website or workflow within hours.",
					"apiButtonText": "Learn about our API"
				}
			}
		}
	};

/***/ },
/* 760 */
/***/ function(module, exports) {

	module.exports = {
		"signModal": {
			"saved": {
				"title": "Your saved { type, select, S {signatures} I {initials} }",
				"header": {
					"text": "Your Saved Signatures"
				},
				"tip": {
					"label": "Tip",
					"text": "If you save another { type, select, S {signature} I {set of initials} }, you will be able to access it here."
				},
				"delete": {
					"linkText": "delete",
					"confirmMessage": {
						"S": "Are you sure you want to delete this signature?\nYou will not be able to access it in the future.",
						"I": "Are you sure you want to delete these initials?\nYou will not be able to access it in the future."
					}
				},
				"empty": {
					"text": "You do not have any saved { type, select, S {signatures} I {initials} }",
					"subText": "Please select an option from the left to create your { type, select, S {signature} I {initials} }."
				}
			},
			"drawn": {
				"title": "CREATE {type, select, S {SIGNATURE} I {INITIALS}}",
				"clear": {
					"linkText": "Clear"
				},
				"tip": {
					"labelText": "Rotate to have more room"
				},
				"error": {
					"signature_too_small": "Please make your { type, select, S {signature} I {initials} } larger. It doesn't meet the minimum size requirement.",
					"no_signature": "Please draw your { type, select, S {signature} I {initials} } using your finger."
				}
			},
			"typed": {
				"title": "CREATE {type, select, S {SIGNATURE} I {INITIALS}}",
				"changeFonts": {
					"linkText": "Change font"
				},
				"error": {
					"S": "You must type your signature",
					"I": "You must type your initials"
				},
				"placeholder": {
					"S": "Your name",
					"I": "Your initials"
				}
			},
			"upload": {
				"title": "CREATE {type, select, S {SIGNATURE} I {INITIALS}}",
				"button": {
					"text": "UPLOAD"
				},
				"instructions": {
					"header": "Upload a picture of your {type, select, S {signature} I {initials}}",
					"fileSize": "Maximum file size: 40 MB",
					"fileFormats": "Acceptable file formats: png, jpg, jpeg, bmp, gif"
				},
				"error": {
					"fileType": "Invalid file type '{fileType}' supplied.",
					"fileSize": "File is too large ({fileSize})!"
				}
			},
			"email": {
				"title": "CREATE {type, select, S {SIGNATURE} I {INITIALS}}",
				"instructions": {
					"header": "Please follow the instructions below:",
					"step_1": "1. Take a photo of your {type, select, S {signature} I {initials}}.",
					"step_2": "2. Email the photo to:",
					"subject": "    With a subject of:",
					"step_3": "3. Click 'Continue'"
				}
			},
			"error": {
				"title": "ERROR",
				"header": "Sorry!",
				"body": "Something went wrong. Please try again.",
				"unknown": "An unexpected error occurred. Please contact support@hellosign.com."
			},
			"actions": {
				"back": {
					"linkText": "back"
				},
				"insert": {
					"linkText": "Insert { everywhere, select, 0 {} 1 {everywhere} }"
				},
				"legal": {
					"labelText": "I understand this is a legal representation of my { type, select, S {signature} I {initials} }."
				},
				"continue": {
					"labelText": "Continue"
				}
			},
			"signatureEditArea": {
				"instructions": "To crop your {type, select, S {signature} I {initials}}, click and drag to create a bounding box.",
				"controls": {
					"contrast": {
						"labelText": "Adjust Contrast"
					},
					"rotate": {
						"labelText": "Rotate {type, select, S {signature} I {initials}}"
					}
				}
			},
			"menu": {
				"labelText": "{ tabId, select, SS {Saved signatures} SI {Saved initials} C {Draw it in} T {Type it in} U {Upload image} E {Use smartphone} }"
			},
			"loader": {
				"text": "Saving your { type, select, S {signature} I {initials} }"
			}
		}
	};

/***/ },
/* 761 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports['default'] = checkPlatform;
	function checkPlatform(forceMobile) {
	
	    var platform;
	
	    // for mobile testing
	    if (forceMobile) {
	        platform = 'mobile';
	    } else {
	
	        var w = window.innerWidth;
	        var ua = navigator.userAgent;
	
	        // c.f. http://stackoverflow.com/questions/16443380/common-css-media-queries-break-points
	        if (w < 767 || ua.match(/iphone/gi) !== null) {
	            // Mobile phone
	            platform = 'mobile';
	        } else {
	            if (ua.match(/ipad|android|tablet/gi) !== null) {
	                // Tablet
	                platform = 'mobile';
	            } else {
	                // Desktop
	                platform = 'desktop';
	            }
	        }
	    }
	
	    return platform;
	}

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _logo = __webpack_require__(763);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	__webpack_require__(768);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A top-level page layout component which tries to fill the entire page.
	 * Features a simple header, a small centered card containing child content, and no footer.
	 */
	var SimpleGrayLayout = function (_React$Component) {
	    _inherits(SimpleGrayLayout, _React$Component);
	
	    function SimpleGrayLayout() {
	        _classCallCheck(this, SimpleGrayLayout);
	
	        return _possibleConstructorReturn(this, (SimpleGrayLayout.__proto__ || Object.getPrototypeOf(SimpleGrayLayout)).apply(this, arguments));
	    }
	
	    _createClass(SimpleGrayLayout, [{
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'm-simple-gray-layout' },
	                _react2['default'].createElement(_logo2['default'], { siteCode: 'S' }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-simple-gray-layout--card' },
	                    this.props.children
	                )
	            );
	        }
	    }]);
	
	    return SimpleGrayLayout;
	}(_react2['default'].Component);
	
	exports['default'] = SimpleGrayLayout;

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(764);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Map site codes to alt/title text versions of logo
	var textVersions = {
	    S: 'HelloSign',
	    F: 'HelloFax'
	};
	
	/**
	 * A scalable HelloSign/HelloFax logo that uses SVG. Can be given size/layout styling via CSS.
	 * This could be extended later to include props for overriding the color, e.g. all-white/all-black versions.
	 */
	
	var Logo = function (_React$Component) {
	    _inherits(Logo, _React$Component);
	
	    function Logo() {
	        _classCallCheck(this, Logo);
	
	        return _possibleConstructorReturn(this, (Logo.__proto__ || Object.getPrototypeOf(Logo)).apply(this, arguments));
	    }
	
	    _createClass(Logo, [{
	        key: 'render',
	        value: function render() {
	            var text = textVersions[this.props.siteCode];
	            var hsSrc = __webpack_require__(766);
	            var hfSrc = __webpack_require__(767);
	            var src = this.props.siteCode === 'S' ? hsSrc : hfSrc;
	            var contents = _react2['default'].createElement('img', { src: src, alt: text, title: text });
	
	            if (this.props.isLink) {
	                contents = _react2['default'].createElement(
	                    'a',
	                    { href: this.props.href },
	                    contents
	                );
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'm-logo' },
	                contents
	            );
	        }
	    }]);
	
	    return Logo;
	}(_react2['default'].Component);
	
	Logo.propTypes = {
	    // Site code to determine which product's logo to use
	    siteCode: _react2['default'].PropTypes.oneOf(['S', 'F']).isRequired,
	    // If set, the <img> will be wrapped in a <a> which links to the homepage by default
	    isLink: _react2['default'].PropTypes.bool,
	    // Optional override for the href of the <a> tag
	    href: _react2['default'].PropTypes.string
	};
	
	Logo.defaultProps = {
	    isLink: false,
	    href: '/'
	};
	exports['default'] = Logo;

/***/ },
/* 764 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 765 */,
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/ed3c22feb6fd107ef6b2057679be9496.svg";

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/8f818cb8a793d0cf9a1bcbd7f5849abf.svg";

/***/ },
/* 768 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 769 */,
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _makeComponentIntl = __webpack_require__(734);
	
	var _makeComponentIntl2 = _interopRequireDefault(_makeComponentIntl);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	var _constants = __webpack_require__(771);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _tetherToggle = __webpack_require__(773);
	
	var _tetherToggle2 = _interopRequireDefault(_tetherToggle);
	
	var _editSignatureModal = __webpack_require__(779);
	
	var _editSignatureModal2 = _interopRequireDefault(_editSignatureModal);
	
	var _logo = __webpack_require__(818);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _blocks = __webpack_require__(302);
	
	__webpack_require__(827);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MenuLink = function MenuLink(props) {
	    return _react2['default'].createElement(_blocks.Box, _extends({
	        className: 'm-app-header--menu-item m-app-header--menu-item--hoverable',
	        color: 'ashen',
	        hoverColor: 'black',
	        is: 'a',
	        py: 3,
	        px: 3,
	        fontSize: 6,
	        display: 'block'
	    }, props));
	};
	
	// TODO: HelloFax & HelloSign header files should NOT be together - separate this stuff (CC)
	// In-app top bar
	var AppTopBar = _react2['default'].createClass({
	    displayName: 'AppTopBar',
	
	
	    propTypes: {
	        'siteCode': _react.PropTypes.string.isRequired, // S or F
	        'showUpgradeButton': _react.PropTypes.bool,
	        'emailAddress': _react.PropTypes.string,
	        'name': _react.PropTypes.string,
	        'primarySignatureGuid': _react.PropTypes.string,
	        'numDocsLeft': _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	        'numApiDocsLeft': _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	        'numTemplatesLeft': _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	        'numFaxPagesLeft': _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	        'minimalDisplay': _react.PropTypes.bool, // Only show the account menu (default is false)
	        'disableAccountMenu': _react.PropTypes.bool, // Disable the account menu dropdown menu (default is false)
	        'hideEmailAddress': _react.PropTypes.bool, // Hide the email address (default is false)
	        'signatureModalProps': _react.PropTypes.object, // Signature modal props
	        'showApiCredits': _react.PropTypes.bool
	    },
	
	    //  ----  LIFECYCLE  ----------------------------------
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            'showUpgradeButton': true,
	            'minimalDisplay': false,
	            'hideEmailAddress': false,
	            'disableAccountMenu': false,
	            'showApiCredits': false
	        };
	    },
	    getInitialState: function getInitialState() {
	        return {
	            'signatureModalIsShown': false,
	            'signatureModalTab': _constants2['default'].TAB_SAVED
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        // CSRF Token is used in the in-app signature modal.
	        if (this.props.app && this.props.signatureModalProps) {
	            this.props.app.csrfToken = this.props.signatureModalProps.csrfToken;
	        }
	    },
	
	
	    //  ----  BEHAVIOR  -----------------------------------
	
	    showHowItWorks: function showHowItWorks() {
	        var site = _hfReactHelper2['default'].HfSites.getSite(this.props.siteCode);
	        document.location = _hfReactHelper2['default'].urlHelper('account/sendDemo', site);
	    },
	    showSignatureModal: function showSignatureModal(evt) {
	
	        evt.preventDefault();
	        evt.stopPropagation();
	
	        this.setState({
	            'signatureModalIsShown': true
	        });
	    },
	    hideSignatureModal: function hideSignatureModal() {
	        this.setState({
	            'signatureModalIsShown': false,
	            'signatureModalTab': _constants2['default'].TAB_SAVED
	        });
	    },
	    showInviteFriendsModal: function showInviteFriendsModal(evt) {
	
	        evt.preventDefault();
	
	        var site = _hfReactHelper2['default'].HfSites.getSite(this.props.siteCode);
	        var url = _hfReactHelper2['default'].urlHelper('home/inviteFriends', site);
	
	        $.fancybox({
	            'type': 'iframe',
	            'showCloseButton': false,
	            'scrolling': 'no',
	            'href': url,
	            'padding': 0,
	            'margin': 0,
	            'autoDimensions': true,
	            onStart: function onStart() {
	                $('#fancybox-overlay').addClass('m-fancybox-modal-overlay settings-modal invite-friends is-hidden');
	                $('#fancybox-wrap').addClass('m-fancybox-modal-wrap settings-modal invite-friends is-hidden');
	                $('#fancybox-inner').addClass('m-fancybox-modal-inner settings-modal invite-friends');
	            },
	            onComplete: function onComplete() {
	                $.fancybox.center();
	                $('#fancybox-overlay, #fancybox-wrap').removeClass('is-hidden');
	            },
	            onClosed: function onClosed() {
	                $('#fancybox-overlay, #fancybox-wrap, #fancybox-inner').attr('class', '');
	            }
	        });
	    },
	    updatePrimarySignature: function updatePrimarySignature(signature) {
	
	        window.primarySignatureGuid = signature ? signature.guid : void 0;
	
	        if (this.state.signatureModalTab == _constants2['default'].TAB_SAVED) {
	
	            // Mark the current signature as primary and close the modal
	            signature.markAsPrimary().then(function () {
	                this.hideSignatureModal();
	            }.bind(this))['catch'](function (err) {
	                // Fail silently
	                console.error('Could not mark signature as primary', err);
	            }.bind(this));
	        } else {
	
	            // Show the saved signature tab after a new one has been created
	            this.setState({
	                'signatureModalTab': _constants2['default'].TAB_SAVED
	            });
	        }
	    },
	    onSignatureModalTabSelected: function onSignatureModalTabSelected(tabId) {
	        this.setState({
	            'signatureModalTab': tabId
	        });
	    },
	
	
	    //  ----  RENDERING  ----------------------------------
	
	    renderAccountMenu: function renderAccountMenu(site, trigger) {
	        var disableAccountMenu = this.props.disableAccountMenu;
	
	        var settingsUrl = _hfReactHelper2['default'].urlHelper('home/myAccount', site);
	        var logoutUrl = _hfReactHelper2['default'].urlHelper('account/logOut', site);
	        var signatureGuid;
	        var freeDocsLink;
	
	        if (window.primarySignatureGuid === null) {
	            // In this case we don't have a primary signature because it just got deleted
	            signatureGuid = null;
	        } else {
	            signatureGuid = window.primarySignatureGuid || this.props.primarySignatureGuid;
	        }
	
	        var items = [undefined, undefined, _react2['default'].createElement(
	            MenuLink,
	            { key: 2, href: settingsUrl, fontWeight: 'normal' },
	            'Settings'
	        ), _react2['default'].createElement(
	            MenuLink,
	            { key: 3, href: logoutUrl, fontWeight: 'normal' },
	            'Logout'
	        )];
	
	        if (_hfReactHelper2['default'].HfSites.isHelloSign(site)) {
	
	            // Signature
	            var name;
	            var sig;
	            var sigClassNames = (0, _classnames2['default'])({
	                'm-app-topbar--menu--signature--sig': true,
	                'no-sig': !signatureGuid,
	                'l-margin-t-20': !this.props.name
	            });
	            if (this.props.name) {
	                name = _react2['default'].createElement(
	                    _blocks.Box,
	                    { fontSize: 6, className: 'm-app-topbar--menu--signature--name' },
	                    this.props.name
	                );
	            }
	            if (signatureGuid) {
	                sig = _react2['default'].createElement(
	                    'div',
	                    { className: sigClassNames },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-app-topbar--menu--signature--image' },
	                        _react2['default'].createElement('img', { src: _hfReactHelper2['default'].urlHelper('attachment/view?sig_guid=' + signatureGuid, site) })
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-app-topbar--menu--signature--edit' },
	                        _react2['default'].createElement(
	                            'a',
	                            { href: 'javascript:;', onClick: this.showSignatureModal },
	                            'Edit signature'
	                        )
	                    )
	                );
	            } else {
	                sig = _react2['default'].createElement(
	                    'div',
	                    { className: sigClassNames, onClick: this.showSignatureModal },
	                    _react2['default'].createElement('img', { src: __webpack_require__(829) }),
	                    _react2['default'].createElement(
	                        _blocks.Box,
	                        { is: 'span', fontSize: 6 },
	                        'Create a signature'
	                    )
	                );
	            }
	            items[0] = _react2['default'].createElement(
	                _blocks.Box,
	                { px: 3, key: 0, className: 'm-app-header--menu-item' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-app-topbar--menu--signature' },
	                    name,
	                    sig
	                )
	            );
	
	            // HS Credits
	            var numDocsLeft = this.props.numDocsLeft === null ? 'Unlimited' : this.props.numDocsLeft;
	            var numTemplatesLeft = this.props.numTemplatesLeft === null ? 'Unlimited' : this.props.numTemplatesLeft;
	            if (this.props.showUpgradeButton) {
	                freeDocsLink = _react2['default'].createElement(
	                    _blocks.Box,
	                    { is: 'a', display: 'block', py: 2, href: '', onClick: this.showInviteFriendsModal },
	                    'Get free documents'
	                );
	            }
	
	            var apiCredits = '';
	            if (this.props.showApiCredits) {
	                var numApiDocsLeft = this.props.numApiDocsLeft === null ? 'Unlimited' : this.props.numApiDocsLeft;
	                apiCredits = _react2['default'].createElement(
	                    'div',
	                    null,
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-app-topbar--menu--credits--title' },
	                        'REMAINING API CREDITS'
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-app-topbar--menu--credits--line' },
	                        numApiDocsLeft + ' API document' + (numApiDocsLeft !== 1 ? 's' : '')
	                    )
	                );
	            }
	
	            items[1] = _react2['default'].createElement(
	                _blocks.Box,
	                { px: 3, key: 1, className: 'm-app-header--menu-item' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-app-topbar--menu--credits' },
	                    apiCredits,
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-app-topbar--menu--credits--title' },
	                        'REMAINING CREDITS'
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-app-topbar--menu--credits--line' },
	                        numDocsLeft + ' document' + (numDocsLeft !== 1 ? 's' : '')
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-app-topbar--menu--credits--line' },
	                        numTemplatesLeft + ' template' + (numTemplatesLeft !== 1 ? 's' : '')
	                    ),
	                    freeDocsLink
	                )
	            );
	        } else {
	
	            // HF Credits
	            var getFreePagesUrl = _hfReactHelper2['default'].urlHelper('account/gettingStarted', site);
	            var numFaxPagesLeft = this.props.numFaxPagesLeft === null ? 'Unlimited' : this.props.numFaxPagesLeft;
	            items[1] = _react2['default'].createElement(
	                _blocks.Box,
	                { px: 3, key: 1, className: 'm-app-header--menu-item' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-app-topbar--menu--credits', key: 1 },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-app-topbar--menu--credits--title' },
	                        'REMAINING CREDITS'
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-app-topbar--menu--credits--line' },
	                        numFaxPagesLeft + ' fax page' + (numFaxPagesLeft !== 1 ? 's' : '')
	                    ),
	                    _react2['default'].createElement(
	                        _blocks.Box,
	                        { display: 'block ', is: 'a', py: 2, href: getFreePagesUrl },
	                        'Get free pages'
	                    )
	                )
	            );
	        }
	
	        return _react2['default'].createElement(
	            _tetherToggle2['default'],
	            {
	                anchor: trigger,
	                justify: 'right',
	                disabled: disableAccountMenu
	            },
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-app-topbar--account-menu' },
	                items
	            )
	        );
	    },
	    signatureModalProps: function signatureModalProps() {
	        var app = this.props.app || window.app;
	        if (this.props.signatureModalProps.settings) {
	            app.isMobile = false;
	            app.user.settings = Object.assign(app.user.settings || {}, this.props.signatureModalProps.settings);
	        }
	        return {
	            'app': app,
	            'buttonText': this.state.signatureModalTab === _constants2['default'].TAB_SAVED ? 'Select' : 'Save',
	            'emailGuid': this.props.signatureModalProps.emailGuid,
	            'emailUploadAddress': this.props.signatureModalProps.emailUploadAddress,
	            'type': this.props.signatureModalProps.signatureType,
	            'onComplete': this.updatePrimarySignature,
	            'onSelectTab': this.onSignatureModalTabSelected,
	            'onClose': this.hideSignatureModal,
	            'initialTab': this.state.signatureModalTab,
	            'intl': this.props.intl
	        };
	    },
	    render: function render() {
	        var responsive = this.props.responsive;
	
	
	        var isHf = _hfReactHelper2['default'].HfSites.isHelloFax(this.props.siteCode);
	        var site = _hfReactHelper2['default'].HfSites.getSite(this.props.siteCode);
	        var homeUrl = _hfReactHelper2['default'].urlHelper('home/index', site);
	        var logoUrl = isHf ? __webpack_require__(830) : __webpack_require__(831);
	        var signDocs;
	        var seeHowBtn;
	        var upgradeBtn;
	        var acctMenu;
	        var emailAddressLink;
	        var signatureModal;
	
	        var topBarMenuClasses = (0, _classnames2['default'])({
	            'm-app-topbar--menu': true,
	            'is-disabled': this.props.disableAccountMenu
	        });
	
	        var meAndOthersParams = 'me=1';
	
	        if (!this.props.minimalDisplay) {
	
	            if (isHf) {
	
	                seeHowBtn = _react2['default'].createElement(_button2['default'], {
	                    key: 'see-how-it-works-button',
	                    buttonText: 'See how it works',
	                    buttonLink: '',
	                    buttonColor: 'white',
	                    buttonTextColor: 'ashen',
	                    buttonClass: 'border-1-ashen',
	                    buttonModuleClass: 'm-app-topbar--see-how-btn',
	                    onClick: this.showHowItWorks });
	            } else {
	
	                var items = [_react2['default'].createElement(
	                    MenuLink,
	                    { key: 'me', href: _hfReactHelper2['default'].urlHelper('sign', site) },
	                    'Just me'
	                ), _react2['default'].createElement(
	                    MenuLink,
	                    { key: 'me-and-others', href: _hfReactHelper2['default'].urlHelper('home/request?' + meAndOthersParams, site) },
	                    'Me & others'
	                ), _react2['default'].createElement(
	                    MenuLink,
	                    { key: 'others', href: _hfReactHelper2['default'].urlHelper('home/request', site) },
	                    'Just others'
	                )];
	
	                var signDocsTrigger = _react2['default'].createElement(
	                    'div',
	                    { className: 'm-app-topbar--signdocs' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-app-topbar--signdocs--title' },
	                        _react2['default'].createElement(
	                            'span',
	                            { className: 'm-app-topbar--signdocs--icon' },
	                            _react2['default'].createElement('img', { className: 'm-app-topbar--signdocs--icon--img', src: __webpack_require__(832) })
	                        ),
	                        _react2['default'].createElement(
	                            'span',
	                            { className: 'm-app-topbar--signdocs--title--text' },
	                            'Sign documents'
	                        )
	                    )
	                );
	
	                signDocs = _react2['default'].createElement(
	                    _blocks.Box,
	                    { display: 'inline-block' },
	                    _react2['default'].createElement(
	                        _tetherToggle2['default'],
	                        {
	                            anchor: signDocsTrigger,
	                            justify: 'right'
	                        },
	                        items
	                    )
	                );
	            }
	        }
	
	        if (!this.props.minimalDisplay && this.props.showUpgradeButton) {
	            upgradeBtn = _react2['default'].createElement(
	                'a',
	                { href: _hfReactHelper2['default'].urlHelper('info/pricing', site), className: 'm-button bg-cerulean m-app-topbar--upgrade-btn hbg-castle-rock hc-white c-white progress-button state-loading' },
	                'Upgrade'
	            );
	        }
	
	        if (!this.props.hideEmailAddress) {
	
	            // Hidden signature modal
	            if (!isHf && this.state.signatureModalIsShown) {
	                signatureModal = _react2['default'].createElement(_editSignatureModal2['default'], this.signatureModalProps());
	            }
	
	            // Render the email address link
	            emailAddressLink = _react2['default'].createElement(
	                'div',
	                { className: 'm-app-topbar--menu--title m-app-topbar--menu--title-email' },
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'm-app-topbar--menu--title--text' },
	                    this.props.emailAddress
	                ),
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'm-app-topbar--menu--title--icon' },
	                    _react2['default'].createElement('img', { src: __webpack_require__(833) })
	                )
	            );
	
	            acctMenu = this.renderAccountMenu(site, emailAddressLink);
	        }
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'm-app-topbar' },
	            signatureModal,
	            _react2['default'].createElement(
	                _blocks.Flex,
	                { justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' },
	                _react2['default'].createElement(_logo2['default'], { href: homeUrl, src: logoUrl, alt: isHf ? 'HelloFax' : 'HelloSign', width: '229', height: '35' }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-app-topbar--actions' },
	                    signDocs,
	                    seeHowBtn,
	                    upgradeBtn,
	                    _react2['default'].createElement(
	                        'div',
	                        { className: topBarMenuClasses },
	                        _react2['default'].createElement(
	                            _blocks.Box,
	                            { display: 'inline-block' },
	                            acctMenu
	                        )
	                    )
	                )
	            )
	        );
	    }
	});
	
	module.exports = (0, _makeComponentIntl2['default'])(AppTopBar);

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _hfReactHelper = __webpack_require__(772);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = {
	    TYPE_SIGNATURE: 'S',
	    TYPE_INITIALS: 'I',
	    ORIENTATION_PORTRAIT: 'P',
	    ORIENTATION_LANDSCAPE: 'L',
	    SCREEN_SMALL: 'small',
	    SCREEN_MEDIUM: 'medium',
	    SCREEN_LARGE: 'large',
	    TAB_SAVED: 'S',
	    TAB_DRAW: 'C',
	    TAB_TYPE: 'T',
	    TAB_UPLOAD: 'U',
	    TAB_EMAIL: 'E',
	    TAB_ERROR: 'ERROR',
	    TABS: ['S', 'C', 'T', 'U', 'E', 'ERROR'],
	    MOBILE_TABS: ['S', 'C', 'T'], // FIXME: remove once tests are revised
	    SIGNATURE_TYPE_CANVAS: 'C',
	    SIGNATURE_TYPE_TYPED: 'T',
	    SIGNATURE_TYPE_UPLOAD: 'U',
	    SIGNATURE_TYPE_EMAIL: 'E',
	    CAROUSEL_LENGTH: 3,
	    CURSIVE_FONTS: Object.keys(_hfReactHelper2['default'].FONT_CHAR_MAP),
	    CONTRAST_MIN_THRESHOLD: 16,
	    CONTRAST_MAX_THRESHOLD: 64,
	    CONTRAST_STEP_AMOUNT: 12,
	    ROTATE_DEGREES_AMOUNT: 90,
	    EMAIL_STATUS_MAX_RETRIES: 20,
	    EMAIL_STATUS_RETRY_PERIOD: 3000,
	    DRAW_TAB_REDRAW_MAX_RETRIES: 4,
	    DRAW_TAB_REDRAW_INITIAL_INTERVAL: 100, // ms
	    ACCEPTED_UPLOAD_TYPES: ['image/jpg', 'image/jpeg', 'image/png', 'image/gif', 'image/bmp'],
	    MAX_UPLOAD_SIZE: 40000000 //40MB
	};

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(517);

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tetherToggle = __webpack_require__(774);
	
	var _tetherToggle2 = _interopRequireDefault(_tetherToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _tetherToggle2['default'];

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TetherToggle = exports.DELAY = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tethered = __webpack_require__(775);
	
	var _tethered2 = _interopRequireDefault(_tethered);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = _react2['default'].Component,
	    PropTypes = _react2['default'].PropTypes;
	var DELAY = exports.DELAY = 100;
	
	/**
	 * This component takes the same props as the `Tethered` component, but toggles
	 * the content when the `anchor` is interacted with.
	 */
	
	var TetherToggle = exports.TetherToggle = function (_Component) {
	    _inherits(TetherToggle, _Component);
	
	    function TetherToggle(props) {
	        _classCallCheck(this, TetherToggle);
	
	        var _this = _possibleConstructorReturn(this, (TetherToggle.__proto__ || Object.getPrototypeOf(TetherToggle)).call(this, props));
	
	        _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
	        _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
	
	        _this.state = {
	            active: false
	        };
	        return _this;
	    }
	
	    /**
	     * We wrap the mouse events in a short timer to prevent sudden closures of
	     * the menu if the user moves outside of the component.  This can
	     * happen if there's some space between the anchor and the menu itself.
	     */
	
	
	    _createClass(TetherToggle, [{
	        key: 'handleMouseEnter',
	        value: function handleMouseEnter() {
	            var _this2 = this;
	
	            clearTimeout(this.timeout);
	
	            this.timeout = setTimeout(function () {
	                _this2.setState({ active: true });
	            }, DELAY);
	        }
	    }, {
	        key: 'handleMouseLeave',
	        value: function handleMouseLeave() {
	            var _this3 = this;
	
	            clearTimeout(this.timeout);
	
	            this.timeout = setTimeout(function () {
	                _this3.setState({ active: false });
	            }, DELAY);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearTimeout(this.timeout);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var active = this.state.active;
	
	            var _props = this.props,
	                anchor = _props.anchor,
	                children = _props.children,
	                disabled = _props.disabled,
	                rest = _objectWithoutProperties(_props, ['anchor', 'children', 'disabled']);
	
	            return _react2['default'].createElement(
	                'div',
	                {
	                    onMouseEnter: !disabled && this.handleMouseEnter,
	                    onMouseLeave: !disabled && this.handleMouseLeave
	                },
	                _react2['default'].createElement(
	                    _tethered2['default'],
	                    _extends({
	                        active: active,
	                        anchor: anchor
	                    }, rest),
	                    children
	                )
	            );
	        }
	    }]);
	
	    return TetherToggle;
	}(Component);
	
	TetherToggle.propTypes = {
	    anchor: PropTypes.node.isRequired,
	    children: PropTypes.any,
	    disabled: PropTypes.bool
	};
	
	exports['default'] = TetherToggle;

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tethered = __webpack_require__(776);
	
	var _tethered2 = _interopRequireDefault(_tethered);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _tethered2['default'];

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TetheredComponent = TetheredComponent;
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(777);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PropTypes = _react2['default'].PropTypes;
	
	
	var leftOrRight = function leftOrRight(pos) {
	    return pos === 'left' || pos === 'right';
	};
	var topOrBottom = function topOrBottom(pos) {
	    return pos === 'top' || pos === 'bottom';
	};
	
	/**
	 * Tethered Component
	 *
	 * A tethered component is a component that positions itself around another
	 * element on the page.  Things like tooltips and dropdown menus can be tethered
	 * compoents.  This component takes in an `anchor` and renders the provided
	 * children around the anchor in different locations depending on the props.
	 */
	function TetheredComponent(props) {
	    var active = props.active,
	        align = props.align,
	        anchor = props.anchor,
	        children = props.children,
	        justify = props.justify,
	        position = props.position,
	        theme = props.theme;
	
	
	    var className = (0, _classnames2['default'])('hs-ui-tethered', { 'hs-ui-tethered--light': theme === 'light' }, { 'hs-ui-tethered--pos-bottom': position === 'bottom' }, { 'hs-ui-tethered--pos-top': position === 'top' }, { 'hs-ui-tethered--pos-bottom': position === 'bottom' }, { 'hs-ui-tethered--pos-right': position === 'right' }, { 'hs-ui-tethered--pos-left': position === 'left' }, { 'hs-ui-tethered--justify-left': topOrBottom(position) && justify === 'left' }, { 'hs-ui-tethered--justify-center': topOrBottom(position) && justify === 'center' }, { 'hs-ui-tethered--justify-right': topOrBottom(position) && justify === 'right' }, { 'hs-ui-tethered--align-top': leftOrRight(position) && align === 'top' }, { 'hs-ui-tethered--align-center': leftOrRight(position) && align === 'center' }, { 'hs-ui-tethered--align-bottom': leftOrRight(position) && align === 'bottom' });
	
	    return _react2['default'].createElement(
	        'div',
	        { className: className },
	        anchor,
	        active && _react2['default'].createElement(
	            'div',
	            { className: 'hs-ui-tethered__content' },
	            children
	        )
	    );
	}
	
	TetheredComponent.propTypes = {
	
	    /**
	     * If true, the content will be rendered
	     */
	    active: PropTypes.bool,
	
	    /**
	     * Aligns the content vertically.  This only takes effect when the position
	     * is 'left' or 'right'.
	     */
	    align: PropTypes.oneOf(['top', 'center', 'bottom']),
	
	    /**
	     * Aligns the content horizontally.  This only takes effect when the
	     * position is 'top' or 'bottom'.
	     *
	     */
	    justify: PropTypes.oneOf(['left', 'center', 'right']),
	
	    /**
	     * The element to position the content around.
	     */
	    anchor: PropTypes.node.isRequired,
	
	    /**
	     * The position of the content around the anchor.
	     */
	    position: PropTypes.oneOf(['top', 'bottom', 'right', 'left']),
	
	    /**
	     * The theme of the content.  The theme defines any baseline style for the
	     * content wrapper.  Right now there's just "light" but in the future this
	     * here for future additions.
	     */
	    theme: PropTypes.oneOf(['light'])
	};
	
	TetheredComponent.defaultProps = {
	    align: 'top',
	    justify: 'left',
	    position: 'bottom',
	    theme: 'light'
	};
	
	exports['default'] = TetheredComponent;

/***/ },
/* 777 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 778 */,
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(771);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _signatureModal = __webpack_require__(780);
	
	var _signatureModal2 = _interopRequireDefault(_signatureModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	__webpack_require__(816);
	
	var EditSignatureModal = _react2['default'].createClass({
	    displayName: 'EditSignatureModal',
	
	
	    propTypes: {
	        'app': _react2['default'].PropTypes.object.isRequired, // Application
	        'type': _react2['default'].PropTypes.string, // Signature or initials (see SignatureModal.TYPE_*)
	        'isMobile': _react2['default'].PropTypes.bool, // Whether it should have mobile behavior
	        'initialTab': _react2['default'].PropTypes.string, // The tab shown at first (see SignatureModal.TAB_*)
	        'onComplete': _react2['default'].PropTypes.func.isRequired, // Callback to interact with the opener function(signature, insertEverywhere, shouldClose)
	        'locales': _react2['default'].PropTypes.array, // Selected locale (list of one)
	        'buttonText': _react2['default'].PropTypes.string, // Text to be displayed on the CTA
	        'emailGuid': _react2['default'].PropTypes.string // Email guid for signature upload
	    },
	
	    //  ----  LIFECYCLE  ----------------------------------
	
	    getDefaultProps: function getDefaultProps() {
	
	        // NOTE: It does not make sense for canInsertEverywhere to be true here
	        // since this component is meant to be used outside the signer page.
	
	        return {
	            'type': _constants2['default'].TYPE_SIGNATURE,
	            'isMobile': false,
	            'initialTab': _constants2['default'].TAB_SAVED,
	            'settings': {},
	            'canInsertEverywhere': false,
	            'locales': ['en-US']
	        };
	    },
	
	
	    //  ----  RENDERING  ----------------------------------
	
	    render: function render() {
	
	        // Render the signature modal
	        return _react2['default'].createElement(
	            'div',
	            { className: 'm-edit-signature-modal' },
	            _react2['default'].createElement(_signatureModal2['default'], this.props)
	        );
	    }
	});
	
	module.exports = EditSignatureModal;

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _makeComponentIntl = __webpack_require__(734);
	
	var _makeComponentIntl2 = _interopRequireDefault(_makeComponentIntl);
	
	var _legacyAppConnector = __webpack_require__(781);
	
	var _legacyAppConnector2 = _interopRequireDefault(_legacyAppConnector);
	
	var _signatureModal = __webpack_require__(782);
	
	var _signatureModal2 = _interopRequireDefault(_signatureModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = (0, _makeComponentIntl2['default'])((0, _legacyAppConnector2['default'])(_signatureModal2['default']));

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.connectToLegacyApp = connectToLegacyApp;
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(771);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _get = __webpack_require__(406);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _errors = __webpack_require__(670);
	
	var _errors2 = _interopRequireDefault(_errors);
	
	var _reactIntl = __webpack_require__(735);
	
	var _signature = __webpack_require__(516);
	
	var _signature2 = _interopRequireDefault(_signature);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var PropTypes = _react2['default'].PropTypes;
	
	/**
	 * Legacy application connector
	 *
	 * This is a wrapper component that handles the business logic for the legacy
	 * application.  It is, for the most part, a direct rip of the logic in the
	 * previous signature modal.  We prepare and handle all state in this component
	 * and pass down any props needed to the "detached" signature modal.
	 */
	
	function connectToLegacyApp(SignatureModal) {
	    return _react2['default'].createClass({
	        displayName: 'connectToLegacyApp(SignatureModal)',
	
	        propTypes: {
	
	            /**
	             * Application
	             */
	            app: PropTypes.object.isRequired,
	
	            /**
	             * Text to be displayed on the CTA (only when canInsertEverywhere=false)
	             */
	            buttonText: PropTypes.string,
	
	            /**
	             * Whether to show the option to insert everywhere
	             */
	            canInsertEverywhere: PropTypes.bool,
	
	            /**
	             * Email guid for signature upload,
	             */
	            emailGuid: PropTypes.string,
	
	            /**
	             * Email address to send signatures to
	             */
	            emailUploadAddress: PropTypes.string,
	
	            /**
	             * Whether it should have mobile behavior
	             */
	            isMobile: PropTypes.bool,
	
	            /**
	             * The tab shown at first (see SignatureModal.TAB_*)
	             */
	            initialTab: PropTypes.string,
	
	            /**
	             * True if the modal is within the embedded context
	             */
	            isEmbedded: PropTypes.bool,
	
	            /**
	             * DO NOT USE
	             *
	             * This is here as a workaround for the smart forms demo.  It should not be
	             * used for other apps.
	             */
	            onBeforeInsert: PropTypes.func,
	
	            /**
	             * Called when the signature modal is closed by the user
	             */
	            onClose: PropTypes.func,
	
	            /**
	             * Called when the user has selected a signature for action(signature, insertEverywhere)
	             */
	            onComplete: PropTypes.func,
	
	            /**
	             * Define which tabs should be shown { tabId => true/false }
	             */
	            settings: PropTypes.object,
	
	            /**
	             * Signature or initials (see SignatureModal.TYPE_*)
	             */
	            type: _react2['default'].PropTypes.string
	        },
	
	        getDefaultProps: function getDefaultProps() {
	            return {
	                initialTab: _constants2['default'].TAB_SAVED
	            };
	        },
	        getInitialState: function getInitialState() {
	            return Object.assign({
	                isCreatingDrawnSignature: false,
	                isCreatingTypedSignature: false,
	                isUploadingSignature: false,
	                isCheckingEmailedSignatureStatus: false,
	                selectedSavedSignature: null,
	                uploadedSignature: null,
	                emailedSignature: null
	            }, this.getStates());
	        },
	        componentDidMount: function componentDidMount() {
	            var _this = this;
	
	            this.mounted = true;
	
	            var isLoading = this.isLoading();
	            if (isLoading) {
	                // Load the user signatures (will only fetch them if not already cached)
	                this.props.app.user.getSignatures(this.props.type).load().then(function () {
	
	                    if (_this.mounted) {
	                        _this.setState(_this.getStates());
	                    }
	                });
	            }
	        },
	        componentWillUnmount: function componentWillUnmount() {
	            this.mounted = false;
	        },
	        componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	            this.setState(this.getStates(newProps));
	        },
	        createSignature: function createSignature(signatureData) {
	            return this.props.app.user.getSignatures(this.props.type).add(signatureData);
	        },
	        editSignature: function editSignature(signature, signatureData) {
	            // Set parameters from edit pane
	            signature.setEditParams(signatureData);
	            // Then get list of signatures, and use the edit endpoint to add
	            return this.props.app.user.getSignatures(this.props.type).addFromEdit(signature);
	        },
	        getEmailGuid: function getEmailGuid() {
	            var guid = this.props.emailGuid;
	
	            if (!guid) {
	                guid = this.props.type === _constants2['default'].TYPE_SIGNATURE ? (0, _get2['default'])(this.props.app, ['emailGuids', 'signature_email_guid']) : (0, _get2['default'])(this.props.app, ['emailGuids', 'initials_email_guid']);
	            }
	
	            return guid;
	        },
	        getEmailUploadAddress: function getEmailUploadAddress() {
	            return this.props.emailUploadAddress || this.props.app.emailUploadAddress;
	        },
	        getEnabledTabs: function getEnabledTabs() {
	            var settings = this.props.settings;
	
	
	            return _constants2['default'].TABS.filter(function (tabId) {
	                return settings[tabId] !== false;
	            });
	        },
	        getInitialTab: function getInitialTab(props, signatures) {
	
	            var tabId = props.initialTab;
	            var hasVisibleTab = false;
	            var i;
	
	            for (i in _constants2['default'].TABS) {
	                if (props.settings[_constants2['default'].TABS[i]] !== false) {
	                    hasVisibleTab = true;
	                    break;
	                }
	            }
	
	            if (!hasVisibleTab) {
	                // No visible tab due to restrictions from settings
	                tabId = _constants2['default'].TAB_DRAW;
	            } else if (tabId === _constants2['default'].TAB_SAVED && signatures.length === 0) {
	                // Default to the next visible tab if there aren't any saved signatures
	                for (i in _constants2['default'].TABS) {
	                    if (_constants2['default'].TABS[i] !== _constants2['default'].TAB_SAVED && props.settings[_constants2['default'].TABS[i]] !== false) {
	                        tabId = _constants2['default'].TABS[i];
	                        break;
	                    }
	                }
	            } else if (props.settings[tabId] === false) {
	                // Select the first visible tab if the specified can't be displayed
	                for (i in _constants2['default'].TABS) {
	                    if (_constants2['default'].TABS[i] !== tabId && props.settings[_constants2['default'].TABS[i]] !== false) {
	                        tabId = _constants2['default'].TABS[i];
	                        break;
	                    }
	                }
	            }
	
	            return tabId;
	        },
	        getInitialTypeInValue: function getInitialTypeInValue() {
	            var _props = this.props,
	                app = _props.app,
	                type = _props.type;
	
	            var user = app.user;
	            var fullName = user.getFullName();
	            var value = (type === _constants2['default'].TYPE_INITIALS ? user.getInitials() : fullName) || '';
	
	            return value;
	        },
	        getLoaderContent: function getLoaderContent() {
	            var _state = this.state,
	                isCreatingDrawnSignature = _state.isCreatingDrawnSignature,
	                isCreatingTypedSignature = _state.isCreatingTypedSignature;
	
	
	            if (isCreatingDrawnSignature || isCreatingTypedSignature) {
	                return _react2['default'].createElement(_reactIntl.FormattedMessage, {
	                    id: 'signModal.loader.text',
	                    values: { type: this.props.type }
	                });
	            }
	        },
	        getStates: function getStates(newProps) {
	            var props = newProps || this.props;
	            var user = props.app.user;
	            var signatures = user.getSignatures(props.type);
	            var isLoading = !signatures.data || signatures.loading === true;
	
	            var hasSignatures = signatures && signatures.length > 0;
	            var selectedSignatureIndex = 0;
	            if (window.primarySignatureGuid && hasSignatures) {
	                for (var i = 0; i < signatures.length; i++) {
	                    if (signatures[i].guid === window.primarySignatureGuid) {
	                        selectedSignatureIndex = i;
	                        break;
	                    }
	                }
	            }
	
	            var selectedSavedSignature = hasSignatures ? signatures[selectedSignatureIndex] : null;
	
	            return {
	                isLoadingSignatures: isLoading,
	                'selectedTab': isLoading ? null : this.getInitialTab(props, signatures),
	                'savedSignatures': isLoading ? [] : signatures,
	                selectedSavedSignature: selectedSavedSignature
	            };
	        },
	        handleCheckEmailedSignatureStatus: function handleCheckEmailedSignatureStatus() {
	            var _props2 = this.props,
	                type = _props2.type,
	                app = _props2.app;
	
	            var emailGuid = this.getEmailGuid();
	
	            this.setState({ isCheckingEmailedSignatureStatus: true });
	
	            var sig = _signature2['default'].create({
	                'notifier': app.notifier,
	                'emailGuid': emailGuid,
	                'type': type,
	                'createType': _constants2['default'].SIGNATURE_TYPE_EMAIL
	            });
	
	            var callback = function (err, data) {
	
	                if (err) {
	                    this.handleError(err);
	                }
	
	                if (data.status) {
	
	                    if (data.status == 'pending') {
	
	                        // Repeat the cycle as retries permit
	                        this.retries++;
	                        if (this.retries < this.retryLimit) {
	                            setTimeout(function () {
	                                sig.checkEmailSignatureStatus().then(callback.bind(this, void 0))['catch'](callback);
	                            }, this.retryPeriod);
	                        } else {
	                            this.setState({ isCheckingEmailedSignatureStatus: false });
	                            this.handleError(new Error('Retries timed out'));
	                        }
	                    }
	
	                    if (data.status == 'ok') {
	
	                        // End and assign id
	                        sig.guid = data.signature_guid;
	                        sig.width = data.width;
	                        sig.height = data.height;
	
	                        this.setState({
	                            emailedSignature: sig,
	                            isCheckingEmailedSignatureStatus: false
	                        });
	
	                        // Refresh Guids
	                        this.refreshGuids(data);
	                    }
	
	                    if (data.status == 'error') {
	                        this.refreshGuids(data);
	                        this.handleError(new Error('Server Error'));
	
	                        this.setState({ isCheckingEmailedSignatureStatus: false });
	                    }
	                }
	            }.bind(this);
	
	            sig.checkEmailSignatureStatus().then(function () {
	                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                    args[_key] = arguments[_key];
	                }
	
	                return callback.apply(undefined, [undefined].concat(args));
	            });
	        },
	
	
	        /**
	         * This is not the ideal way to handle this.  In the type-in tab, we're
	         * first trying to save the signature request to see if we're online or
	         * not.  We do this because if this request fails, we'll show a nice
	         * error message to the user.  But, it's only handled for mobile and
	         * only when there's a signature request present.  It's very specialized
	         * for this one scenario.  Leaving it in for now for legacy reasons.
	         */
	        handleCheckNetworkHealth: function handleCheckNetworkHealth(cb) {
	            if (this.props.isMobile && this.props.app.signatureRequest) {
	                // Make sure we have connectivity before loading fonts on mobile
	                // NOTE: We need to trigger a save beforehand because loading font does not
	                // go through the API service and will not bring up the connectivity screen
	                // when network is down.
	                this.props.app.signatureRequest.save(cb);
	            } else {
	                cb();
	            }
	        },
	        handleDrawnSignatureInsert: function handleDrawnSignatureInsert(signatureData, insertEverywhere) {
	            var _this2 = this;
	
	            this.setState({ isCreatingDrawnSignature: true });
	
	            this.createSignature(signatureData).then(function (signature) {
	                _this2.setState({ isCreatingDrawnSignature: false });
	                _this2.props.onComplete(signature, insertEverywhere);
	            })['catch'](function (error) {
	                _this2.setState({ isCreatingDrawnSignature: false });
	                var errorMessage = void 0;
	
	                // Lodash `get` is a safe way to dig deeply into the error
	                // object.  If any of these properties are not defined there
	                // will be no error code and we'll just display a general
	                // message.
	                var originalCode = (0, _get2['default'])(error, ['error', 'data', 'original_code']);
	
	                if (originalCode) {
	                    errorMessage = _this2.props.intl.formatMessage({ id: 'signModal.drawn.error.' + originalCode }, { 'type': _this2.props.type });
	                } else {
	                    errorMessage = _this2.props.intl.formatMessage({ id: 'error.general.message' });
	                }
	
	                _this2.handleError({ message: errorMessage });
	            });
	        },
	        handleEmailedSignatureInsert: function handleEmailedSignatureInsert(signatureData, insertEverywhere) {
	            var _this3 = this;
	
	            var emailedSignature = this.state.emailedSignature;
	
	            var finalSignatureData = _extends({}, emailedSignature.data, {
	                guid: emailedSignature.guid
	            }, signatureData);
	
	            this.setState({ isCreatingEmailedSignature: true });
	
	            this.editSignature(emailedSignature, finalSignatureData).then(function (signature) {
	                _this3.setState({ isCreatingEmailedSignature: false });
	                _this3.props.onComplete(signature, insertEverywhere);
	            })['catch'](function (e) {
	                return _this3.handleError(e);
	            });
	        },
	        handleError: function handleError(error) {
	            this.setState({ error: error });
	
	            if (error.code === _errors2['default'].NETWORK || error.code === _errors2['default'].CREDENTIALS) {
	                // No need to trigger error reporting in this case since a special error screen
	                // will be shown instead.
	                return;
	            }
	
	            // Right now, tabbed error handling is only turned on for Desktop clients
	            if (!this.props.isMobile) {
	                this.selectTab(_constants2['default'].TAB_ERROR);
	            } else {
	                console.error('Signature Modal Error: ' + (error ? error.message : ''));
	            }
	        },
	        handleSavedSignatureRemove: function handleSavedSignatureRemove(signature) {
	            var _this4 = this;
	
	            if (!window.confirm(this.props.intl.formatMessage({ id: 'signModal.saved.delete.confirmMessage.' + this.props.type }))) {
	                return;
	            }
	            var signatures = this.state.savedSignatures;
	            var selectedSignature = this.state.selectedSavedSignature;
	
	            signature.remove(function (error) {
	                if (error) _this4.props.onError(error);else {
	
	                    // If the signature we're removing is the current selected sig
	                    if (signature.guid === selectedSignature.guid) {
	
	                        // If there are signatures other than the one that just got
	                        // deleted
	                        if (signatures.length > 1) {
	
	                            // Find the signature in the state that matches the
	                            // selected signature
	                            var selectedIndex = 0;
	                            for (var i = 0; i < signatures.length; i++) {
	                                if (signatures[i].guid === selectedSignature.guid) {
	                                    selectedIndex = i;
	                                    break;
	                                }
	                            }
	
	                            // Make the selected signature the signature after the
	                            // removed signature
	                            selectedSignature = signatures[selectedIndex + 1];
	                            if (selectedSignature === undefined) {
	                                selectedSignature = signatures[selectedIndex - 1];
	                            }
	
	                            // TODO - remove this - this is breaking encapsulation majorly. This sort
	                            // of logic should be within the signatures collection (CC)
	                            signatures.splice(selectedIndex, 1);
	                        } else {
	
	                            // The last signature just got deleted so pop the last one out
	                            signatures.splice(0, 1);
	                            selectedSignature = null;
	                            window.primarySignatureGuid = void 0;
	                        }
	                    }
	
	                    var sigReq = _this4.props.app.signatureRequest;
	                    var selectedSig;
	                    if (sigReq) selectedSig = sigReq.getSelectedSignature(_this4.props.type);
	                    if (selectedSig && selectedSig.guid === signature.guid) {
	                        // Reset the selected signature if it'a been deleted
	                        sigReq.setSelectedSignature(_this4.props.type, null);
	                    }
	
	                    _this4.setState({
	                        'savedSignatures': signatures,
	                        selectedSavedSignature: selectedSignature
	                    });
	                }
	            });
	        },
	        handleSignatureRotate: function handleSignatureRotate(signature) {
	            signature.rotate();
	        },
	        handleSavedSignatureSelect: function handleSavedSignatureSelect(signature) {
	            this.setState({
	                selectedSavedSignature: signature
	            });
	        },
	        handleSignatureData: function handleSignatureData(signatureData, insertEverywhere) {
	            var type = signatureData.create_type_code;
	
	            // Keeps support for the smart-forms demo
	
	            if (typeof this.props.onBeforeInsert === 'function') {
	                return this.props.onBeforeInsert(signatureData, insertEverywhere);
	            }
	
	            if (type === _constants2['default'].SIGNATURE_TYPE_CANVAS) {
	                return this.handleDrawnSignatureInsert(signatureData, insertEverywhere);
	            } else if (type === _constants2['default'].SIGNATURE_TYPE_TYPED) {
	                return this.handleTypedSignatureInsert(signatureData, insertEverywhere);
	            } else if (type === _constants2['default'].SIGNATURE_TYPE_UPLOAD) {
	                return this.handleUploadedSignatureInsert(signatureData, insertEverywhere);
	            } else if (type === _constants2['default'].SIGNATURE_TYPE_EMAIL) {
	                return this.handleEmailedSignatureInsert(signatureData, insertEverywhere);
	            }
	        },
	        handleSignatureUpload: function handleSignatureUpload(data) {
	            var _this5 = this;
	
	            return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                var sig;
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _this5.setState({ isUploadingSignature: true });
	
	                                sig = _signature2['default'].create({
	                                    'notifier': _this5.props.app.notifier,
	                                    'file': data
	                                });
	
	
	                                sig.createType = _constants2['default'].SIGNATURE_TYPE_UPLOAD;
	                                sig.type = _this5.props.type;
	
	                                _context.prev = 4;
	                                _context.next = 7;
	                                return sig.save({ handleError: false });
	
	                            case 7:
	
	                                _this5.setState({
	                                    uploadedSignature: sig
	                                });
	
	                                _context.next = 13;
	                                break;
	
	                            case 10:
	                                _context.prev = 10;
	                                _context.t0 = _context['catch'](4);
	
	                                _this5.handleError(_context.t0);
	
	                            case 13:
	
	                                _this5.setState({ isUploadingSignature: false });
	
	                            case 14:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, _this5, [[4, 10]]);
	            }))();
	        },
	        handleTypedSignatureInsert: function handleTypedSignatureInsert(signatureData, insertEverywhere) {
	            var _this6 = this;
	
	            this.setState({ isCreatingTypedSignature: true });
	
	            this.createSignature(signatureData).then(function (signature) {
	                _this6.setState({ isCreatingTypedSignature: false });
	                _this6.props.onComplete(signature, insertEverywhere);
	            })['catch'](function (error) {
	                // The error here may not be parseable, so if not just
	                // display the general message
	                var err = error.response ? JSON.parse(error.response.text) : error;
	                var msg = err.response ? _this6.props.intl.formatMessage({ id: 'signModal.typed.error.' + err.name }) : _this6.props.intl.formatMessage({ id: 'error.general.message' });
	                _this6.handleError({ 'message': msg });
	            });
	        },
	        handleUploadedSignatureInsert: function handleUploadedSignatureInsert(signatureData, insertEverywhere) {
	            var _this7 = this;
	
	            var uploadedSignature = this.state.uploadedSignature;
	
	            var finalSignatureData = _extends({}, uploadedSignature.data, {
	                guid: uploadedSignature.guid
	            }, signatureData);
	
	            this.setState({ isCreatingUploadedSignature: true });
	
	            this.editSignature(uploadedSignature, finalSignatureData).then(function (signature) {
	                _this7.setState({ isCreatingUploadedSignature: false });
	                _this7.props.onComplete(signature, insertEverywhere);
	            })['catch'](function (e) {
	                return _this7.handleError(e);
	            });
	        },
	        isLoading: function isLoading() {
	            var _state2 = this.state,
	                isCreatingDrawnSignature = _state2.isCreatingDrawnSignature,
	                isCreatingTypedSignature = _state2.isCreatingTypedSignature,
	                isLoadingSignatures = _state2.isLoadingSignatures;
	
	
	            return isLoadingSignatures || isCreatingDrawnSignature || isCreatingTypedSignature;
	        },
	        refreshGuids: function refreshGuids(data) {
	            if (data.hasOwnProperty('new_email_guid')) {
	
	                var newGuid = data.new_email_guid;
	
	                if (typeof this.props.app.emailGuids === 'undefined') {
	                    this.props.app.emailGuids = [];
	                }
	                if (this.props.type === _constants2['default'].TYPE_SIGNATURE) {
	                    this.props.app.emailGuids.signature_email_guid = newGuid;
	                } else {
	                    this.props.app.emailGuids.initials_email_guid = newGuid;
	                }
	            }
	        },
	
	
	        retries: 0,
	        retryLimit: _constants2['default'].EMAIL_STATUS_MAX_RETRIES,
	        retryPeriod: _constants2['default'].EMAIL_STATUS_RETRY_PERIOD,
	
	        selectSavedSignature: function selectSavedSignature(signature) {
	            this.setState({
	                'selectedSignature': signature
	            });
	        },
	        selectTab: function selectTab(tabId) {
	            this.setState({
	                'selectedTab': tabId
	            });
	        },
	        render: function render() {
	            var _state3 = this.state,
	                error = _state3.error,
	                savedSignatures = _state3.savedSignatures,
	                selectedSavedSignature = _state3.selectedSavedSignature,
	                selectedTab = _state3.selectedTab,
	                uploadedSignature = _state3.uploadedSignature,
	                isUploadingSignature = _state3.isUploadingSignature,
	                isCheckingEmailedSignatureStatus = _state3.isCheckingEmailedSignatureStatus,
	                emailedSignature = _state3.emailedSignature;
	            var _props3 = this.props,
	                app = _props3.app,
	                buttonText = _props3.buttonText,
	                canInsertEverywhere = _props3.canInsertEverywhere,
	                intl = _props3.intl,
	                isEmbedded = _props3.isEmbedded,
	                isMobile = _props3.isMobile,
	                onClose = _props3.onClose,
	                onComplete = _props3.onComplete,
	                settings = _props3.settings,
	                type = _props3.type;
	
	
	            var loading = this.isLoading();
	            var loaderContent = this.getLoaderContent();
	            var emailGuid = this.getEmailGuid();
	            var emailUploadAddress = this.getEmailUploadAddress();
	            var enabledTabs = this.getEnabledTabs();
	            var filteredSavedSignatures = savedSignatures.filter(function (sig) {
	                return settings[sig.createType] !== false;
	            });
	
	            return _react2['default'].createElement(SignatureModal, {
	                buttonText: buttonText,
	                canInsertEverywhere: canInsertEverywhere,
	                emailedSignature: emailedSignature,
	                emailGuid: emailGuid,
	                emailUploadAddress: emailUploadAddress,
	                enabledTabs: enabledTabs,
	                error: error,
	                getSignatureUrl: function getSignatureUrl(signature) {
	                    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	                        args[_key2 - 1] = arguments[_key2];
	                    }
	
	                    return signature.getUrl.apply(signature, args);
	                },
	                initialTypeInValue: this.getInitialTypeInValue(),
	                isCheckingEmailedSignatureStatus: isCheckingEmailedSignatureStatus,
	                isEmbedded: isEmbedded,
	                isMobile: isMobile || app.isMobile,
	                intl: intl,
	                isUploadingSignature: isUploadingSignature,
	                loaderContent: loaderContent,
	                loading: loading,
	                onCheckEmailedSignatureStatus: this.handleCheckEmailedSignatureStatus,
	                onClose: onClose,
	                onError: this.handleError,
	                onInsert: onComplete,
	                onCheckNetworkHealth: this.handleCheckNetworkHealth,
	                onRotateSignature: this.handleSignatureRotate,
	                onSignatureData: this.handleSignatureData,
	                onSavedSignatureRemove: this.handleSavedSignatureRemove,
	                onSavedSignatureSelect: this.handleSavedSignatureSelect,
	                onTabSelect: this.selectTab,
	                onUploadSignature: this.handleSignatureUpload,
	                savedSignatures: filteredSavedSignatures,
	                settings: settings,
	                selectedSavedSignature: selectedSavedSignature,
	                selectedTab: selectedTab,
	                type: type,
	                uploadedSignature: uploadedSignature
	            });
	        }
	    });
	}
	
	exports['default'] = connectToLegacyApp;

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CONSTANTS = undefined;
	
	var _constants = __webpack_require__(771);
	
	Object.defineProperty(exports, 'CONSTANTS', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_constants)['default'];
	  }
	});
	
	var _signatureModal = __webpack_require__(783);
	
	var _signatureModal2 = _interopRequireDefault(_signatureModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _signatureModal2['default'];

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(784);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactIntl = __webpack_require__(735);
	
	var _drawTab = __webpack_require__(792);
	
	var _drawTab2 = _interopRequireDefault(_drawTab);
	
	var _savedTab = __webpack_require__(795);
	
	var _savedTab2 = _interopRequireDefault(_savedTab);
	
	var _errorTab = __webpack_require__(796);
	
	var _errorTab2 = _interopRequireDefault(_errorTab);
	
	var _emailTab = __webpack_require__(797);
	
	var _emailTab2 = _interopRequireDefault(_emailTab);
	
	var _typeInTab = __webpack_require__(810);
	
	var _typeInTab2 = _interopRequireDefault(_typeInTab);
	
	var _uploadTab = __webpack_require__(812);
	
	var _uploadTab2 = _interopRequireDefault(_uploadTab);
	
	var _constants = __webpack_require__(771);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _loader = __webpack_require__(798);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _setInterval = __webpack_require__(799);
	
	var _setInterval2 = _interopRequireDefault(_setInterval);
	
	var _propTypes = __webpack_require__(794);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // 'Use Smartphone'
	
	
	var PropTypes = _react2['default'].PropTypes;
	
	/**
	 * UI Signature Modal
	 *
	 * This component is a presentational version of the signature modal.  It
	 * expects all state management to be handled by a parent component.
	 *
	 * NOTE: This component assumes that it has been wrapped within an Intl
	 * Provider _and_ a component injected with the imperative intl API.
	 *
	 * @example
	 *
	 * import { IntlProvider, injectIntl } from 'react-intl';
	 *
	 * // Wraps the UI signature modal and handles all the state logic
	 * class MyStatefulSignatureModal extends React.Component {
	 *      render() {
	 *          return <SignatureModal
	 *              //...props
	 *          />
	 *      }
	 *
	 * }
	 * const IntlSignatureModal = injectIntl(MyStatefulSignatureModal);
	 *
	 * <IntlProvider locale='en-US' messages={messages}>
	 *      <IntlSignatureModal />
	 * </IntlProvider>
	 */
	
	var UiSignatureModal = function (_React$Component) {
	    _inherits(UiSignatureModal, _React$Component);
	
	    function UiSignatureModal() {
	        var _ref;
	
	        _classCallCheck(this, UiSignatureModal);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        var _this = _possibleConstructorReturn(this, (_ref = UiSignatureModal.__proto__ || Object.getPrototypeOf(UiSignatureModal)).call.apply(_ref, [this].concat(args)));
	
	        _this.captureMenu = _this.captureMenu.bind(_this);
	        _this.captureActiveTab = _this.captureActiveTab.bind(_this);
	        _this.getTopOffset = _this.getTopOffset.bind(_this);
	        _this.detectDeviceOrientation = _this.detectDeviceOrientation.bind(_this);
	        _this.detectScreenSize = _this.detectScreenSize.bind(_this);
	        _this.adjustDimensions = _this.adjustDimensions.bind(_this);
	        _this.shouldShowTab = _this.shouldShowTab.bind(_this);
	        _this.errorOnContinue = _this.errorOnContinue.bind(_this);
	        _this.renderMenu = _this.renderMenu.bind(_this);
	        _this.renderTabs = _this.renderTabs.bind(_this);
	        _this.renderTab = _this.renderTab.bind(_this);
	
	        _this.state = {
	            deviceOrientation: _this.detectDeviceOrientation(),
	            screenSize: _this.detectScreenSize()
	        };
	        return _this;
	    }
	
	    _createClass(UiSignatureModal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this.mounted = true;
	
	            if (this.props.isMobile) {
	                var adjTimer;
	
	                var adjustOrientationAndSize = function adjustOrientationAndSize() {
	
	                    if (!_this2.mounted) return clearInterval(adjTimer);
	
	                    var orientation = _this2.detectDeviceOrientation();
	                    var screenSize = _this2.detectScreenSize();
	
	                    _this2.adjustDimensions();
	
	                    _this2.setState({
	                        'deviceOrientation': orientation,
	                        'screenSize': screenSize
	                    });
	                };
	
	                // Orientation and size detection
	                // adjust size on a timer. Do NOT use listeners! This fixes strange iOS bugs (CC)
	                adjTimer = (0, _setInterval2['default'])(adjustOrientationAndSize, 250);
	                adjustOrientationAndSize();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.mounted = false;
	        }
	
	        //  ----  HELPERS  ------------------------------------
	
	    }, {
	        key: 'captureMenu',
	        value: function captureMenu(node) {
	            this.menuRef = node;
	        }
	    }, {
	        key: 'captureActiveTab',
	        value: function captureActiveTab(node) {
	            this.activeTabRef = node;
	        }
	
	        /**
	         * Returns the max of the following two numbers:
	         *  - The bottom offset of the menu node
	         *  - The bottom offset of the tab content node
	         *
	         * We use this calculation to display the `ActionBar` at the correct height
	         * below the lower of the two nodes.  In some cases, the tab content may be shorter
	         * than the menu, so in those cases we don't want the menu to overlap with
	         * the action bar.  This only happes for mobile devices
	         */
	
	    }, {
	        key: 'getTopOffset',
	        value: function getTopOffset() {
	
	            // Note, React may provide `undefined` for ref callbacks if the nodes
	            // have been unmounted, so we need to check for their existence before
	            // trying to call DOM methods.
	            if (this.props.isMobile && this.menuRef && this.activeTabRef) {
	                var menuBottom = this.menuRef.getBoundingClientRect().bottom;
	                var activeTabBottom = this.activeTabRef.getBoundingClientRect().bottom;
	
	                return Math.max(menuBottom, activeTabBottom);
	            }
	        }
	    }, {
	        key: 'detectDeviceOrientation',
	        value: function detectDeviceOrientation() {
	            if (this.props.isMobile && window.screen) {
	                if (window.orientation !== void 0 && Math.abs(window.orientation) === 90 || window.screen && window.screen.width > window.screen.height) {
	                    // NOTE: Only used for in-browser mobile simulators because they don't emulate orientation changes correctly
	                    return _constants2['default'].ORIENTATION_LANDSCAPE;
	                } else {
	                    return _constants2['default'].ORIENTATION_PORTRAIT;
	                }
	            } else {
	                return _constants2['default'].ORIENTATION_LANDSCAPE;
	            }
	        }
	    }, {
	        key: 'detectScreenSize',
	        value: function detectScreenSize() {
	            if (window.screen) {
	                var w = window.screen.width;
	                if (w <= 690) {
	                    return _constants2['default'].SCREEN_SMALL;
	                } else if (w > 690 && w <= 900) {
	                    return _constants2['default'].SCREEN_MEDIUM;
	                }
	            }
	            return _constants2['default'].SCREEN_LARGE;
	        }
	    }, {
	        key: 'adjustDimensions',
	        value: function adjustDimensions() {
	            if (window.screen && this.props.isMobile && this.state.screenSize === _constants2['default'].SCREEN_SMALL) {
	
	                // NOTE: The height is must be at least 270px to prevent the action bar from running into the menu.
	                // Also, in such case, the keyboard is most likely up, so the user can dismiss it to see the rest of the modal.
	
	                var root = $(_reactDom2['default'].findDOMNode(this));
	                var h = Math.max(270, window.innerHeight);
	                var w = window.innerWidth;
	                var isEmbedded = this.props.isEmbedded;
	
	                if (isEmbedded) {
	                    // Set full width for embedded. Avoids mobile iframe issues.
	                    root.css({
	                        'width': '100vw',
	                        'height': '100vh',
	                        'min-height': '270px',
	                        'top': 0,
	                        'left': 0
	                    });
	                } else {
	                    root.css({
	                        'width': w + 'px',
	                        'height': h + 'px',
	                        'top': 0,
	                        'left': 0
	                    });
	                }
	            }
	        }
	    }, {
	        key: 'shouldShowTab',
	        value: function shouldShowTab(tabId) {
	            var enabledTabs = this.props.enabledTabs;
	
	            // Block Upload and Smartphone (email) on mobile
	
	            if (this.props.isMobile && (tabId === _constants2['default'].TAB_UPLOAD || tabId === _constants2['default'].TAB_EMAIL)) {
	                return false;
	            }
	
	            // Never show error tab in menu
	            if (tabId === _constants2['default'].TAB_ERROR) return false;
	
	            // Show if true or not specified
	            return this.props.selectedTab === tabId || enabledTabs.includes(tabId);
	        }
	
	        //  ----  BEHAVIOR  -----------------------------------
	
	    }, {
	        key: 'errorOnContinue',
	        value: function errorOnContinue() {
	            this.props.onTabSelect(_constants2['default'].TAB_SAVED);
	        }
	
	        //  ----  RENDERING  ----------------------------------
	
	    }, {
	        key: 'renderMenu',
	        value: function renderMenu() {
	
	            var menuItems = [];
	            var classes;
	
	            for (var k in _constants2['default'].TABS) {
	
	                var tabId = _constants2['default'].TABS[k];
	                if (!this.shouldShowTab(tabId)) {
	                    continue;
	                }
	
	                if (this.props.isEmbedded && tabId === _constants2['default'].TAB_SAVED) {
	                    // use placeholder and don't show saved menu if embedded signing -- DEV-1718
	                    menuItems.push(_react2['default'].createElement('div', { key: 'sign-modal-menuitem-' + tabId }));
	                } else {
	                    classes = {
	                        'm-sign-modal--menu--item': true,
	                        'is-compact': this.props.isMobile,
	                        'is-selected': this.props.selectedTab === tabId,
	                        'whitelabel-signature-modal-tab': true
	                    };
	
	                    classes[tabId] = true;
	
	                    menuItems.push(_react2['default'].createElement(
	                        'div',
	                        { key: 'sign-modal-menuitem-' + tabId, className: (0, _classnames2['default'])(classes), onClick: this.props.onTabSelect.bind(null, tabId) },
	                        _react2['default'].createElement('span', { className: 'm-sign-modal--menu--item--icon' }),
	                        _react2['default'].createElement(
	                            'span',
	                            { className: 'm-sign-modal--menu--item--label' },
	                            _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.menu.labelText',
	                                values: { tabId: tabId + (tabId == _constants2['default'].TAB_SAVED ? this.props.type : '') } })
	                        )
	                    ));
	                }
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'm-sign-modal--menu', ref: this.captureMenu },
	                menuItems
	            );
	        }
	    }, {
	        key: 'renderTabs',
	        value: function renderTabs() {
	            var _this3 = this;
	
	            var tabs = _constants2['default'].TABS.filter(function (id) {
	                return _this3.props.selectedTab === id;
	            }).map(function (id) {
	                return _this3.renderTab(id);
	            });
	            return _react2['default'].createElement(
	                'div',
	                { className: 'm-sign-modal--tabs' },
	                tabs
	            );
	        }
	    }, {
	        key: 'renderTab',
	        value: function renderTab(tabId) {
	            var _props = this.props,
	                buttonText = _props.buttonText,
	                canInsertEverywhere = _props.canInsertEverywhere,
	                emailedSignature = _props.emailedSignature,
	                emailGuid = _props.emailGuid,
	                emailUploadAddress = _props.emailUploadAddress,
	                error = _props.error,
	                getSignatureUrl = _props.getSignatureUrl,
	                initialTypeInValue = _props.initialTypeInValue,
	                intl = _props.intl,
	                isCheckingEmailedSignatureStatus = _props.isCheckingEmailedSignatureStatus,
	                isMobile = _props.isMobile,
	                isUploadingSignature = _props.isUploadingSignature,
	                onCheckEmailedSignatureStatus = _props.onCheckEmailedSignatureStatus,
	                onCheckNetworkHealth = _props.onCheckNetworkHealth,
	                onClose = _props.onClose,
	                onError = _props.onError,
	                onInsert = _props.onInsert,
	                onRotateSignature = _props.onRotateSignature,
	                onSavedSignatureRemove = _props.onSavedSignatureRemove,
	                onSavedSignatureSelect = _props.onSavedSignatureSelect,
	                onSignatureData = _props.onSignatureData,
	                onUploadSignature = _props.onUploadSignature,
	                savedSignatures = _props.savedSignatures,
	                selectedSavedSignature = _props.selectedSavedSignature,
	                selectedTab = _props.selectedTab,
	                type = _props.type,
	                uploadedSignature = _props.uploadedSignature;
	            var _state = this.state,
	                deviceOrientation = _state.deviceOrientation,
	                screenSize = _state.screenSize;
	
	
	            var topOffset = this.getTopOffset();
	            var displayOrientation = isMobile ? _constants2['default'].ORIENTATION_PORTRAIT : _constants2['default'].ORIENTATION_LANDSCAPE;
	
	            var tab;
	            var key = 'tab-' + tabId;
	            var isSelected = selectedTab === tabId;
	
	            var commonActionBarProps = {
	                buttonText: buttonText,
	                canInsertEverywhere: canInsertEverywhere,
	                intl: intl,
	                isMobile: isMobile,
	                onClose: onClose,
	                topOffset: topOffset,
	                type: type
	            };
	
	            var commonProps = {
	                actionBarProps: commonActionBarProps,
	                buttonText: buttonText,
	                canInsertEverywhere: canInsertEverywhere,
	
	                // Provided to the Tab components so that they can report their
	                // content to this component.  The tabs should apply this as a ref
	                // callback on the div that wraps the content, e.g.
	                // <div ref={this.props.captureTabContentRef}>
	                captureTabContentRef: this.captureActiveTab,
	                deviceOrientation: deviceOrientation,
	                emailGuid: emailGuid,
	                emailUploadAddress: emailUploadAddress,
	                isMobile: isMobile,
	                intl: intl,
	                isSelected: isSelected,
	                onClose: onClose,
	                onError: onError,
	                screenSize: screenSize,
	                topOffset: topOffset,
	                type: type
	            };
	
	            switch (tabId) {
	
	                case _constants2['default'].TAB_SAVED:
	                    tab = _react2['default'].createElement(_savedTab2['default'], _extends({}, commonProps, {
	                        key: key,
	                        getSignatureUrl: getSignatureUrl,
	                        onInsert: onInsert,
	                        onRemove: onSavedSignatureRemove,
	                        onSelect: onSavedSignatureSelect,
	                        selectedSignature: selectedSavedSignature,
	                        signatures: savedSignatures
	                    }));
	                    break;
	
	                case _constants2['default'].TAB_DRAW:
	                    tab = _react2['default'].createElement(_drawTab2['default'], _extends({}, commonProps, {
	                        displayOrientation: displayOrientation,
	                        key: key,
	                        onSignatureData: onSignatureData
	                    }));
	                    break;
	
	                case _constants2['default'].TAB_TYPE:
	                    tab = _react2['default'].createElement(_typeInTab2['default'], _extends({}, commonProps, {
	                        key: key,
	                        initialValue: initialTypeInValue,
	                        onCheckNetworkHealth: onCheckNetworkHealth,
	                        onSignatureData: onSignatureData
	                    }));
	                    break;
	
	                case _constants2['default'].TAB_UPLOAD:
	                    tab = _react2['default'].createElement(_uploadTab2['default'], _extends({}, commonProps, {
	                        getSignatureUrl: getSignatureUrl,
	                        key: key,
	                        isUploading: isUploadingSignature,
	                        onRotateSignature: onRotateSignature,
	                        onSignatureData: onSignatureData,
	                        onUpload: onUploadSignature,
	                        signature: uploadedSignature
	                    }));
	                    break;
	
	                case _constants2['default'].TAB_EMAIL:
	                    tab = _react2['default'].createElement(_emailTab2['default'], _extends({}, commonProps, {
	                        emailGuid: emailGuid,
	                        key: key,
	                        getSignatureUrl: getSignatureUrl,
	                        isCheckingStatus: isCheckingEmailedSignatureStatus,
	                        onCheckStatus: onCheckEmailedSignatureStatus,
	                        onRotateSignature: onRotateSignature,
	                        onSignatureData: onSignatureData,
	                        signature: emailedSignature,
	                        uploadAddress: emailUploadAddress
	                    }));
	                    break;
	
	                case _constants2['default'].TAB_ERROR:
	                    tab = _react2['default'].createElement(_errorTab2['default'], _extends({
	                        key: key
	                    }, commonProps, {
	                        error: error,
	                        onContinue: this.errorOnContinue
	                    }));
	                    break;
	
	                default:
	                    throw new Error('Invalid tab id: ' + tabId);
	
	            }
	
	            return tab;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                isLoading = _props2.loading,
	                loaderContent = _props2.loaderContent,
	                onClose = _props2.onClose;
	
	            var classes = {
	                'm-sign-modal': true,
	                'is-mobile': this.props.isMobile,
	                'is-desktop': !this.props.isMobile,
	                'can-insert-everywhere': this.props.canInsertEverywhere
	            };
	            classes['screen-' + this.state.screenSize] = true;
	            classes['orientation-' + this.state.deviceOrientation] = true;
	
	            var loader = _react2['default'].createElement(
	                'div',
	                { className: 'm-sign-modal--loader' },
	                _react2['default'].createElement(_loader2['default'], { className: 'm-sign-modal--loader--image whitelabel-dot-loader' }),
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'm-sign-modal--loader--text' },
	                    loaderContent
	                )
	            );
	
	            var closeBox = _react2['default'].createElement(
	                'div',
	                { className: 'm-sign-modal--close-box', onClick: onClose },
	                _react2['default'].createElement('img', { src: __webpack_require__(815) })
	            );
	
	            // Render the signature modal
	            return _react2['default'].createElement(
	                'div',
	                { className: (0, _classnames2['default'])(classes) },
	                isLoading ? loader : null,
	                isLoading ? null : this.renderMenu(),
	                isLoading || this.props.isMobile ? null : closeBox,
	                isLoading ? null : this.renderTabs()
	            );
	        }
	    }]);
	
	    return UiSignatureModal;
	}(_react2['default'].Component);
	
	UiSignatureModal.propTypes = {
	
	    /**
	        * Text to be displayed on the CTA (only when canInsertEverywhere=false)
	        */
	    buttonText: _react2['default'].PropTypes.string,
	
	    /**
	        * If true, there will be a button displayed to insert everywhere
	        */
	    canInsertEverywhere: PropTypes.bool,
	
	    /**
	        * The emailed signature that's been sent in by the user.
	        */
	    emailedSignature: _propTypes.SignatureType,
	
	    /**
	        * For signature upload
	        */
	    emailGuid: PropTypes.string,
	    emailUploadAddress: PropTypes.string,
	
	    enabledTabs: PropTypes.arrayOf(_propTypes.Tab),
	
	    /**
	        * Provided to the error tab if present.
	        */
	    error: PropTypes.shape({
	        message: PropTypes.string
	    }),
	
	    getSignatureUrl: _propTypes.GetSignatureUrl,
	
	    /**
	     * Provided to the TypeInTab
	     */
	    initialTypeInValue: PropTypes.string.isRequired,
	
	    /**
	     * Intl object provided by react-intl
	     */
	    intl: PropTypes.object.isRequired,
	
	    /**
	        * If true, it will signal to the email tab that we're awaiting an
	        * emailed signature.
	        */
	    isCheckingEmailedSignatureStatus: PropTypes.bool,
	    isEmbedded: PropTypes.bool,
	    isMobile: PropTypes.bool,
	
	    /**
	        * If true, it will signal to the upload tab that we're awaiting a
	        * signature upload.
	        */
	    isUploadingSignature: PropTypes.bool,
	
	    /**
	        * If provided and the `loading` prop is true, it will be used as the
	        * content for the loading section.  Can be used to pass custom copy,
	        * e.g. "Creating your signature..."
	        */
	    loaderContent: PropTypes.element,
	    loading: PropTypes.bool,
	
	    /**
	        * This will kick off the API poll to check for emailed signatures.
	        */
	    onCheckEmailedSignatureStatus: PropTypes.func,
	
	    /**
	        * Called to close the modal
	        */
	    onClose: PropTypes.func,
	
	    /**
	        * Called with the finalized created signature from one of the tabs.
	        */
	    onInsert: PropTypes.func,
	
	    /**
	        * This prop should be used with caution. It's expected to take a
	        * callback and somehow check if we're currently online.  If so, it
	        * calls the callback.  It's used with the Webfont Loader in the type in
	        * tab because we load the webfonts because they load using their own
	        * network layer logic.
	        */
	    onCheckNetworkHealth: PropTypes.func,
	
	    onRotateSignature: PropTypes.func,
	
	    /**
	        * Called with the siganture data from one of the tabs.  Each type will
	        * have a "create_type_code" indicating which tab the data came from.
	        * Use this to create or edit a signature.
	        */
	    onSignatureData: PropTypes.func.isRequired,
	
	    /**
	        * Called to remove a saved signature from the Saved Tab
	        */
	    onSavedSignatureRemove: PropTypes.func.isRequired,
	
	    /**
	        * Called to select a saved signature from the saved tab carousel
	        */
	    onSavedSignatureSelect: PropTypes.func.isRequired,
	    onTabSelect: PropTypes.func.isRequired,
	    onUploadSignature: PropTypes.func,
	
	    /**
	        * Provided to the saved tab to display as a carousel or list
	        */
	    savedSignatures: PropTypes.arrayOf(_propTypes.SignatureType).isRequired,
	
	    /**
	        * The signature in the saved tab that's currently selected
	        */
	    selectedSavedSignature: _propTypes.SignatureType,
	
	    /**
	        * The currently selected tab
	        */
	    selectedTab: PropTypes.oneOf(_constants2['default'].TABS),
	    type: _propTypes.Type,
	    uploadedSignature: _propTypes.SignatureType
	};
	
	UiSignatureModal.defaultProps = {
	    enabledTabs: _constants2['default'].TABS.filter(function (tab) {
	        return tab !== _constants2['default'].TAB_ERROR;
	    }),
	    type: _constants2['default'].TYPE_SIGNATURE,
	    isMobile: true,
	    canInsertEverywhere: true,
	    isEmbedded: false
	};
	
	exports['default'] = UiSignatureModal;

/***/ },
/* 784 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _actionBar = __webpack_require__(793);
	
	var _actionBar2 = _interopRequireDefault(_actionBar);
	
	var _constants = __webpack_require__(771);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _setTimeout = __webpack_require__(718);
	
	var _setTimeout2 = _interopRequireDefault(_setTimeout);
	
	var _propTypes = __webpack_require__(794);
	
	var _reactIntl = __webpack_require__(735);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var DrawTab = _react2['default'].createClass({
	    displayName: 'DrawTab',
	
	
	    triesRemaining: _constants2['default'].DRAW_TAB_REDRAW_MAX_RETRIES,
	    retryTime: _constants2['default'].DRAW_TAB_REDRAW_INITIAL_INTERVAL,
	
	    propTypes: _extends({}, _propTypes.CommonTabProps, {
	        displayOrientation: _propTypes.DeviceOrientation,
	        onSignatureData: _propTypes.OnSignatureData
	    }),
	
	    //  ----  LIFECYCLE  ----------------------------------
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            'canInsertEverywhere': true
	        };
	    },
	    getInitialState: function getInitialState() {
	        return {
	            'isSignature': this.props.type === _constants2['default'].TYPE_SIGNATURE,
	            'isInitials': this.props.type === _constants2['default'].TYPE_INITIALS,
	            'hasDrawn': false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.initCanvas();
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        clearTimeout(this.redrawTimer);
	    },
	    componentDidUpdate: function componentDidUpdate(prevProps) {
	        var orientationHasChanged = prevProps.deviceOrientation != this.props.deviceOrientation || prevProps.displayOrientation != this.props.displayOrientation;
	        var screenSizeHasChanged = prevProps.screenSize != this.props.screenSize;
	        if (orientationHasChanged || screenSizeHasChanged) {
	            // Only reset the canvas if the orientation or size of the screen has changed
	            if (this.props.isMobile) {
	                this.redrawCanvas();
	            } else {
	                this.initCanvas();
	            }
	        }
	    },
	
	
	    //  ----  BEHAVIOR  -----------------------------------
	
	    initCanvas: function initCanvas() {
	
	        var canvasElement = this._getDrawSignatureCanvasElement();
	        var canvas = $(canvasElement);
	
	        if (!this.isCanvasNativelySupported() && window.G_vmlCanvasManager) {
	            G_vmlCanvasManager.initElement(canvasElement);
	        }
	
	        // Preventive reset
	        if (canvas.data('canvas')) {
	            canvas.canvas('clearCanvas');
	            canvas.canvas('destroy');
	        }
	
	        // Init
	        if (canvas.canvas) {
	            // NOTE: Necessary for running unit tests
	            canvas.canvas({
	                'callback': this.canvasCallback
	            });
	        }
	
	        canvas.attr('height', parseInt(canvas.height(), 10)).attr('width', parseInt(canvas.width(), 10) + 10); // NOTE: +10 to account for the padding on canvas-holder
	    },
	
	
	    /**
	    * redrawCanvas
	    *
	    * These handle making sure any user entered paths remain during phone rotation
	    * We do this by:
	    * 1) Saving off the Base64 data from the canvas
	    * 2) Reinitializing the canvas to the new, rotated dimensions
	    * 3) Set our previous data on the canvas again (with retries to account for animation)
	    */
	
	    redrawCanvas: function redrawCanvas() {
	
	        var hasDrawn = !!this.state.hasDrawn;
	
	        // Grab existing signature paths as Base64
	        var data = this.getCanvasData();
	
	        // Then reset
	        this.initCanvas();
	
	        // Reapply changes
	        this._redraw(data);
	
	        // Make sure we show the clear button if we had real data before
	        if (hasDrawn) {
	            this.setState({
	                'hasDrawn': true
	            });
	        }
	    },
	    _redraw: function _redraw(imageData) {
	
	        var sourceImage = new Image();
	        sourceImage.src = imageData;
	
	        var ctx = this._getDrawSignatureCanvasElement().getContext('2d');
	        ctx.drawImage(sourceImage, 0, 0);
	
	        var currentData = this.getCanvasData();
	
	        // Set a timeout to retry if the data doesn't match what we've intended to insert
	        // This handles cases where the phone rotation animation hasn't finished
	        if (currentData !== imageData && this.triesRemaining > 0) {
	            this.retryTime += this.retryTime;
	            this.redrawTimer = (0, _setTimeout2['default'])(this._redraw.bind(this, imageData), this.retryTime);
	            this.triesRemaining--;
	        } else {
	            this.retryTime = _constants2['default'].DRAW_TAB_REDRAW_INITIAL_INTERVAL;
	            this.triesRemaining = _constants2['default'].DRAW_TAB_REDRAW_MAX_RETRIES;
	        }
	    },
	    _getDrawSignatureCanvasElement: function _getDrawSignatureCanvasElement() {
	        var canvas = this.refs.drawSignatureCanvas;
	
	        // this should not happen, but if it does, throw a descriptive error message (CC)
	        if (!canvas) {
	
	            if (!this.isMounted()) {
	                throw new Error('canvas does not exist since the DrawTab is unmounted.');
	            } else {
	
	                // this should definitely not happen (CC)
	                throw new Error('canvas does not exist, but the DrawTab is mounted.');
	            }
	        }
	
	        return canvas;
	    },
	    canvasCallback: function canvasCallback(eventName) {
	
	        // NOTE: We can't use setState() to keep track of hasDrawn
	        // because change a state value triggers render(), which resets the canvas.
	
	        switch (eventName) {
	
	            case 'start':
	                this.setState({
	                    'hasDrawn': true
	                });
	                break;
	
	            case 'drag':
	                break;
	
	            case 'stop':
	                break;
	
	            case 'clear':
	                this.setState({
	                    'hasDrawn': false
	                });
	                break;
	
	        }
	    },
	    clearCanvas: function clearCanvas() {
	        var canvas = $(this._getDrawSignatureCanvasElement());
	        if (canvas.data('canvas')) {
	            canvas.canvas('clearCanvas');
	        }
	        if (this.redrawTimer) {
	            clearTimeout(this.redrawTimer);
	        }
	        if (this.props.onClear) {
	            this.props.onClear();
	        }
	    },
	    insertSignature: function insertSignature(insertEverywhere) {
	
	        var signatureData = {
	            'type_code': this.props.type,
	            'create_type_code': _constants2['default'].SIGNATURE_TYPE_CANVAS,
	            'signature': {
	                'image': this.getCanvasData(),
	                'is_vml': this.isCanvasNativelySupported() ? 0 : 1
	            }
	
	        };
	
	        return this.props.onSignatureData(signatureData, insertEverywhere);
	    },
	
	
	    //  ----  HELPERS  ------------------------------------
	
	    isCanvasNativelySupported: function isCanvasNativelySupported() {
	        return !!document.createElement('canvas').getContext;
	    },
	    getCanvasData: function getCanvasData() {
	        var canvasElement = this._getDrawSignatureCanvasElement();
	        if (canvasElement) {
	            return this.isCanvasNativelySupported() ? canvasElement.toDataURL() : canvasElement.innerHTML;
	        }
	    },
	
	
	    //  ----  RENDERING  ----------------------------------
	
	    render: function render() {
	        var actionBarProps = this.props.actionBarProps;
	
	        var containerClasses = {
	            'm-sign-modal--tabs--tab': true,
	            'is-selected': this.props.isSelected
	        };
	
	        var clearBtnClasses = {
	            'm-sign-modal--tabs--draw--clear-link': true,
	            'm-button': true,
	            'bg-white': true,
	            'border-1-light-grey': true,
	            'hbg-white': true,
	            'hc-light-grey': true,
	            'c-light-grey': true
	        };
	
	        var tip = this.props.isMobile ? _react2['default'].createElement(
	            'div',
	            { className: 'm-sign-modal--tabs--draw--tip' },
	            _react2['default'].createElement('span', { className: 'm-sign-modal--tabs--draw--tip--icon' }),
	            _react2['default'].createElement(
	                'span',
	                { className: 'm-sign-modal--tabs--draw--tip--text' },
	                this.props.intl.formatMessage({ id: 'signModal.drawn.tip.labelText' })
	            )
	        ) : null;
	
	        containerClasses[_constants2['default'].TAB_DRAW] = true;
	
	        var clearBtn = this.state.hasDrawn ? _react2['default'].createElement(
	            'div',
	            {
	                'data-test-ref': 'clear-btn',
	                ref: 'clearbtn',
	                onClick: this.clearCanvas,
	                className: (0, _classnames2['default'])(clearBtnClasses) },
	            _react2['default'].createElement(
	                'a',
	                { href: 'javascript:;' },
	                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.drawn.clear.linkText' })
	            )
	        ) : null;
	
	        return _react2['default'].createElement(
	            'div',
	            { className: (0, _classnames2['default'])(containerClasses) },
	            _react2['default'].createElement(
	                'span',
	                { className: 'm-sign-modal--tabs--tab-title' },
	                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.drawn.title', values: { type: this.props.type } })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-sign-modal--tabs--draw' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-sign-modal--tabs--content', ref: this.props.captureTabContentRef },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-sign-modal--tabs--draw--canvas-holder' },
	                        this.renderCanvas(),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'm-sign-modal--tabs--draw--x' },
	                            '\xD7'
	                        ),
	                        clearBtn
	                    ),
	                    tip
	                )
	            ),
	            _react2['default'].createElement(_actionBar2['default'], _extends({
	                'data-test-ref': 'action-bar'
	            }, actionBarProps, {
	                disableButtons: !this.state.hasDrawn,
	                onInsert: this.insertSignature
	            }))
	        );
	    },
	    renderCanvas: function renderCanvas() {
	        return _react2['default'].createElement('canvas', { ref: 'drawSignatureCanvas',
	            id: 'drawSignatureCanvas',
	            className: 'm-sign-modal--tabs--draw--canvas' });
	    }
	});
	
	module.exports = DrawTab;

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(735);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _propTypes = __webpack_require__(794);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var OFFSET_MARGIN = 65;
	var DEFAULT_STYLE = {
	    top: 'auto',
	    bottom: 0
	};
	
	var ActionBar = _react2['default'].createClass({
	    displayName: 'ActionBar',
	
	
	    propTypes: _propTypes.ActionBar,
	
	    //  ----  LIFECYCLE  ----------------------------------
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            'canInsertEverywhere': true,
	            'disableButtons': false,
	            'continueInsteadOfInsert': false,
	            'onContinue': null
	        };
	    },
	
	
	    //  ----  BEHAVIOR  -----------------------------------
	
	    insertSignature: function insertSignature(insertEverywhere) {
	        this.props.onInsert(insertEverywhere);
	    },
	    close: function close() {
	        this.props.onClose();
	    },
	    captureRef: function captureRef(node) {
	        if (node) {
	            this.node = node;
	        }
	    },
	    getStyle: function getStyle() {
	        var topOffset = this.props.topOffset;
	
	        // If no offset provided, use the default styles to fix the bar to the
	        // bottom of the window
	
	        if (!topOffset) {
	            return DEFAULT_STYLE;
	        }
	
	        if (topOffset) {
	            var windowHeight = window.innerHeight;
	            var elemHeight = this.node ? this.node.clientHeight : 0;
	
	            // If element will be pushed off the screen with this new offset,
	            // then use the default style to fix to the bottom of the window
	            // instead
	            if (elemHeight + topOffset + OFFSET_MARGIN > windowHeight) {
	                return DEFAULT_STYLE;
	            }
	
	            return {
	                top: topOffset + OFFSET_MARGIN,
	                bottom: 'auto'
	            };
	        }
	    },
	
	
	    //  ----  RENDERING  ----------------------------------
	
	    render: function render() {
	
	        var style = this.getStyle();
	        var buttons = [];
	        var buttonProps = [{
	            'buttonId': 'insertButton',
	            'buttonColor': 'white',
	            'buttonHoverColor': this.props.isMobile ? 'white' : 'cerulean',
	            'buttonTextColor': 'cerulean',
	            'buttonHoverTextColor': this.props.isMobile ? 'cerulean' : 'white',
	            'className': this.props.disableButtons ? void 0 : 'whitelabel-secondary-button',
	            'buttonBorderColor': this.props.disableButtons ? 'cinder-block' : 'cerulean',
	            'disabled': this.props.disableButtons,
	            'intl': this.props.intl
	        }, this.props.canInsertEverywhere ? {
	            'buttonId': 'insertEverywhereButton',
	            'buttonColor': 'cerulean',
	            'buttonTextColor': 'white',
	            'buttonHoverColor': this.props.isMobile ? 'cerulean' : null,
	            'buttonHoverTextColor': 'white',
	            'className': this.props.disableButtons ? void 0 : 'whitelabel-primary-button',
	            'buttonBorderColor': this.props.disableButtons ? 'cinder-block' : 'cerulean',
	            'disabled': this.props.disableButtons,
	            'intl': this.props.intl
	        } : void 0];
	
	        var continueButtonProps = {
	            'buttonId': 'continueButton',
	            'buttonColor': 'cerulean',
	            'buttonTextColor': 'white',
	            'buttonHoverColor': this.props.isMobile ? 'cerulean' : null,
	            'buttonBorderColor': this.props.disableButtons ? 'cinder-block' : 'cerulean',
	            'buttonHoverTextColor': 'white',
	            'className': 'whitelabel-primary-button',
	            'intl': this.props.intl
	        };
	
	        if (this.props.continueInsteadOfInsert) {
	
	            buttons.push(_react2['default'].createElement(_button2['default'], _extends({
	                key: 'sign-modal-button-continue',
	                buttonText: this.props.intl.formatMessage({ id: 'signModal.actions.continue.labelText' }, { 'everywhere': i }),
	                disabled: this.props.disableButtons,
	                onClick: this.props.onContinue
	            }, continueButtonProps)));
	        } else {
	
	            // Normal insert buttons
	            for (var i = 0; i < 2; i++) {
	                if (buttonProps[i]) {
	                    var buttonText;
	                    if (i === 0 && !this.props.canInsertEverywhere && this.props.buttonText) {
	                        buttonText = this.props.buttonText;
	                    } else {
	                        buttonText = this.props.intl.formatMessage({ id: 'signModal.actions.insert.linkText' }, { 'everywhere': i });
	                    }
	                    buttons.push(_react2['default'].createElement(_button2['default'], _extends({
	                        key: 'sign-modal-button-' + i,
	                        buttonText: buttonText,
	                        onClick: this.props.disableButtons ? null : this.insertSignature.bind(null, i === 1)
	                    }, buttonProps[i])));
	                }
	            }
	        }
	
	        var message = this.props.message;
	        if (message == void 0) {
	            // null = don't show a message
	            message = _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.actions.legal.labelText', values: { type: this.props.type } });
	        }
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'm-sign-modal--action-bar', style: style, ref: this.captureRef },
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-sign-modal--action-bar--inner' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-sign-modal--action-bar--close-link m-sign-modal--action--bar--left' },
	                    _react2['default'].createElement(
	                        'a',
	                        { href: 'javascript:;', onClick: this.close },
	                        _react2['default'].createElement('span', { className: 'm-sign-modal--action-bar--close-link--arrow' }),
	                        _react2['default'].createElement(
	                            'span',
	                            { className: 'm-sign-modal--action-bar--close-link--text' },
	                            _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.actions.back.linkText' })
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-sign-modal--action-bar--right' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-sign-modal--action-bar--message' },
	                        message || ''
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-sign-modal--action-bar--buttons' },
	                        buttons
	                    )
	                )
	            )
	        );
	    }
	});
	
	module.exports = ActionBar;

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CommonTabProps = exports.GetSignatureUrl = exports.OnSignatureData = exports.ActionBar = exports.Tab = exports.ScreenSize = exports.DeviceOrientation = exports.Type = exports.SignatureType = undefined;
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(771);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PropTypes = _react2['default'].PropTypes;
	var SignatureType = exports.SignatureType = PropTypes.shape({
	    width: PropTypes.number.isRequired,
	    height: PropTypes.number.isRequired,
	    guid: PropTypes.string.isRequired
	});
	
	var Type = exports.Type = PropTypes.oneOf([_constants2['default'].TYPE_SIGNATURE, _constants2['default'].TYPE_INITIALS]);
	
	var DeviceOrientation = exports.DeviceOrientation = PropTypes.oneOf([_constants2['default'].ORIENTATION_PORTRAIT, _constants2['default'].ORIENTATION_LANDSCAPE]);
	
	var ScreenSize = exports.ScreenSize = PropTypes.oneOf([_constants2['default'].SCREEN_SMALL, _constants2['default'].SCREEN_MEDIUM, _constants2['default'].SCREEN_LARGE]);
	
	var Tab = exports.Tab = PropTypes.oneOf(_constants2['default'].TABS);
	
	var ActionBar = exports.ActionBar = {
	
	    // Text to be displayed on the CTA (only when canInsertEverywhere=false)
	    buttonText: PropTypes.string,
	    canInsertEverywhere: PropTypes.bool,
	    continueInsteadOfInsert: PropTypes.bool,
	    disableButtons: PropTypes.bool,
	    intl: PropTypes.object.isRequired,
	    isMobile: PropTypes.bool,
	    onClose: PropTypes.func.isRequired,
	    onContinue: PropTypes.func,
	    onInsert: PropTypes.func,
	    type: Type,
	
	    // If provided, this indicates that the action bar should be absolutely
	    // positioned starting from this point.  If it's not provided, then it
	    // will be absolutely positioned at the bottom of the screen
	    topOffset: _react2['default'].PropTypes.number
	};
	
	var OnSignatureData = exports.OnSignatureData = PropTypes.func;
	
	var GetSignatureUrl = exports.GetSignatureUrl = PropTypes.func.isRequired;
	
	var CommonTabProps = exports.CommonTabProps = {
	    actionBarProps: PropTypes.shape(ActionBar),
	    buttonText: PropTypes.string,
	    canInsertEverywhere: PropTypes.bool,
	
	    // Provided to the Tab components so that they can report their
	    // content to this component.  The tabs should apply this as a ref
	    // callback on the div that wraps the content, e.g.
	    // <div ref={this.props.captureTabContentRef}>
	    captureTabContentRef: PropTypes.func,
	    deviceOrientation: DeviceOrientation,
	    emailGuid: PropTypes.string,
	    emailUploadAddress: PropTypes.string,
	    intl: PropTypes.object,
	    isMobile: PropTypes.bool,
	    isSelected: PropTypes.bool,
	    onClose: PropTypes.func.isRequired,
	    onError: PropTypes.func.isRequired,
	    screenSize: ScreenSize,
	    topOffset: PropTypes.number,
	    type: Type
	};

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(735);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _actionBar = __webpack_require__(793);
	
	var _actionBar2 = _interopRequireDefault(_actionBar);
	
	var _constants = __webpack_require__(771);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _propTypes = __webpack_require__(794);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PropTypes = _react2['default'].PropTypes;
	
	
	var SavedTab = _react2['default'].createClass({
	    displayName: 'SavedTab',
	
	
	    propTypes: _extends({}, _propTypes.CommonTabProps, {
	        getSignatureUrl: _propTypes.GetSignatureUrl,
	        onInsert: PropTypes.func.isRequired,
	        onRemove: _react2['default'].PropTypes.func.isRequired,
	        onSelect: _react2['default'].PropTypes.func.isRequired,
	        selectedSignature: _propTypes.SignatureType,
	        signatures: PropTypes.arrayOf(_propTypes.SignatureType).isRequired
	    }),
	
	    //  ----  LIFECYCLE  ----------------------------------
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            'canInsertEverywhere': true
	        };
	    },
	    getInitialState: function getInitialState() {
	
	        var carouselLength = this.detectCarouselLength(this.props.deviceOrientation, this.props.screenSize);
	
	        return {
	            'isSignature': this.props.type === _constants2['default'].TYPE_SIGNATURE,
	            'isInitials': this.props.type === _constants2['default'].TYPE_INITIALS,
	            'carouselLength': carouselLength,
	            'carouselRange': [0, carouselLength - 1]
	        };
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	
	        var signatures = newProps.signatures;
	        var hasSignatures = signatures && signatures.length > 0;
	        var carouselLength = 0;
	
	        if (hasSignatures) {
	            carouselLength = this.detectCarouselLength(newProps.deviceOrientation, newProps.screenSize);
	        }
	
	        this.setState({
	            'carouselLength': carouselLength
	        });
	    },
	
	
	    //  ----  BEHAVIOR  -----------------------------------
	
	    insertSignature: function insertSignature(insertEverywhere) {
	        var signature = this.props.selectedSignature;
	
	        return this.props.onInsert(signature, insertEverywhere);
	    },
	    shiftCarousel: function shiftCarousel(dir) {
	        var _this = this;
	
	        var range;
	        var numItems = this.props.signatures.length;
	        var selectedIndex = this.getSelectedCarouselIndex();
	
	        switch (dir) {
	
	            case 'next':
	                range = [this.state.carouselRange[0] + 1, Math.min(this.state.carouselRange[1] + 1, numItems - 1)];
	                break;
	
	            case 'prev':
	                range = [Math.max(0, this.state.carouselRange[0] - 1), this.state.carouselRange[1] - 1];
	                break;
	
	            default:
	                throw new Error('Invalid direction: ' + dir);
	        }
	
	        // Ensure the current selected signature is still visible in the carousel.
	        // Find the closest visible if not.
	        // var selectedIndex = this.getSelectedCarouselIndex();
	        var nextSignature = void 0;
	
	        if (!this.isInCarouselRange(selectedIndex, range)) {
	            if (selectedIndex < range[0]) {
	                nextSignature = this.props.signatures[range[0]];
	            }
	            if (selectedIndex > range[1]) {
	                nextSignature = this.props.signatures[range[1]];
	            }
	        }
	
	        this.setState({
	            'carouselRange': range
	        }, function () {
	            if (nextSignature) {
	                _this.props.onSelect(nextSignature);
	            }
	        });
	    },
	
	
	    //  ----  HELPERS  ------------------------------------
	
	    getSelectedCarouselIndex: function getSelectedCarouselIndex() {
	        if (typeof this.props.selectedSignature === 'undefined' || this.props.selectedSignature === null) {
	            return 0;
	        }
	        var selectedSignature = this.props.selectedSignature;
	        var selectedIndex = 0;
	        for (var i = 0; i < this.props.signatures.length; i++) {
	            if (this.props.signatures[i].guid === selectedSignature.guid) {
	                selectedIndex = i;
	                break;
	            }
	        }
	        return selectedIndex;
	    },
	    detectCarouselLength: function detectCarouselLength(orientation, screenSize) {
	        if (screenSize === _constants2['default'].SCREEN_SMALL) {
	            if (orientation === _constants2['default'].ORIENTATION_PORTRAIT) {
	                // Only show one on small screen when in portrait mode
	                return 1;
	            } else {
	                // But show two when in landscape mode
	                return 3;
	            }
	        } else {
	            // Default
	            return _constants2['default'].CAROUSEL_LENGTH;
	        }
	    },
	    scaleSignatureToFit: function scaleSignatureToFit(origDims, restrictDims) {
	        origDims = Object.assign({}, origDims);
	        origDims.ratio = parseFloat(origDims.width / origDims.height);
	        if (origDims.width > origDims.height) {
	            origDims.width = restrictDims.width;
	            origDims.height = parseInt(origDims.width / origDims.ratio, 10);
	            if (origDims.height > restrictDims.height) {
	                origDims.height = restrictDims.height;
	                origDims.width = parseInt(origDims.height * origDims.ratio, 10);
	            }
	        } else {
	            origDims.height = restrictDims.height;
	            origDims.width = parseInt(origDims.height * origDims.ratio, 10);
	            if (origDims.width > restrictDims.width) {
	                origDims.width = restrictDims.width;
	                origDims.height = parseInt(origDims.width / origDims.ratio, 10);
	            }
	        }
	        return origDims;
	    },
	    isInCarouselRange: function isInCarouselRange(i, range) {
	        if (range === undefined) {
	            range = this.state.carouselRange;
	        }
	        return i >= range[0] && i <= range[1];
	    },
	
	
	    //  ----  RENDERING  ----------------------------------
	
	    renderSignatureImage: function renderSignatureImage(signature, isThumbnail) {
	
	        if (!signature) return;
	
	        var url = this.props.getSignatureUrl(signature);
	        var dims;
	        var containerDims = {
	            'width': 75,
	            'height': 40
	        };
	
	        if (isThumbnail) {
	            dims = this.scaleSignatureToFit({
	                'width': signature.width,
	                'height': signature.height
	            }, containerDims);
	        } else {
	            dims = {
	                'width': 2 * signature.width,
	                'height': 2 * signature.height
	            };
	        }
	
	        var topMargin = Math.max(0, parseInt((containerDims.height - dims.height) / 2, 10));
	        var style = {
	            'marginTop': topMargin + 'px',
	            'width': dims.width + 'px',
	            'height': dims.height + 'px'
	        };
	
	        return _react2['default'].createElement('img', {
	            src: url,
	            style: style });
	    },
	    renderSignatureCarousel: function renderSignatureCarousel() {
	        var onRemove = this.props.onRemove;
	
	        var carouselItems = [];
	        var classes;
	        var signature;
	        var carouselRange = this.state.carouselRange;
	
	        var selectedSignature = this.props.selectedSignature ? this.props.selectedSignature.guid : void 0;
	
	        for (var i = 0; i < this.props.signatures.length; i++) {
	
	            signature = this.props.signatures[i];
	
	            classes = {
	                'm-sign-modal--tabs--saved--carousel--item': true,
	                'whitelabel-signature-modal-save-carousel-tab-item': true,
	                'is-selected': selectedSignature === signature.guid,
	                'is-hidden': !this.isInCarouselRange(i, carouselRange)
	            };
	
	            carouselItems.push(_react2['default'].createElement(
	                'li',
	                { key: 'carousel-item-' + i, className: (0, _classnames2['default'])(classes) },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-sign-modal--tabs--saved--carousel--item--content', onClick: this.props.onSelect.bind(null, signature) },
	                    this.renderSignatureImage(signature, true)
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-sign-modal--tabs--saved--carousel--item--delete', onClick: onRemove.bind(null, signature) },
	                    _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.saved.delete.linkText' })
	                )
	            ));
	        }
	
	        classes = {
	            'm-sign-modal--tabs--saved--carousel--list': true,
	            'with-arrows': this.props.signatures.length > _constants2['default'].CAROUSEL_LENGTH
	        };
	
	        if (carouselRange[0] > 0) {
	            leftArrow = _react2['default'].createElement('li', {
	                'data-test-ref': 'signature-carousel-left-arrow',
	                className: 'm-sign-modal--tabs--saved--carousel--arrow prev',
	                onClick: this.shiftCarousel.bind(null, 'prev') });
	        }
	
	        // Arrows
	        var leftArrowEnabled = carouselRange[0] > 0;
	        var rightArrowEnabled = carouselRange[1] < this.props.signatures.length - 1;
	        var leftArrow = _react2['default'].createElement('li', {
	            'data-test-ref': 'signature-carousel-left-arrow',
	            className: (0, _classnames2['default'])({
	                'm-sign-modal--tabs--saved--carousel--arrow': true,
	                'prev': true,
	                'is-disabled': !leftArrowEnabled
	            }), onClick: leftArrowEnabled ? this.shiftCarousel.bind(null, 'prev') : null });
	        var rightArrow = _react2['default'].createElement('li', {
	            'data-test-ref': 'signature-carousel-right-arrow',
	            className: (0, _classnames2['default'])({
	                'm-sign-modal--tabs--saved--carousel--arrow': true,
	                'next': true,
	                'is-disabled': !rightArrowEnabled
	            }), onClick: rightArrowEnabled ? this.shiftCarousel.bind(null, 'next') : null });
	
	        return _react2['default'].createElement(
	            'div',
	            {
	                className: 'm-sign-modal--tabs--saved--carousel--clip',
	                'data-test-ref': 'signature-carousel' },
	            _react2['default'].createElement(
	                'ul',
	                { className: (0, _classnames2['default'])(classes) },
	                leftArrow,
	                carouselItems,
	                rightArrow
	            )
	        );
	    },
	    renderSignatureList: function renderSignatureList() {
	
	        var listItems = [];
	        var classes;
	        var isSelected;
	        var signature;
	        var deleteBtn;
	        var onRemove = this.props.onRemove;
	
	
	        var selectedSignature = this.props.selectedSignature ? this.props.selectedSignature.guid : void 0;
	
	        for (var i = 0; i < this.props.signatures.length; i++) {
	
	            signature = this.props.signatures[i];
	            isSelected = signature.guid === selectedSignature;
	            deleteBtn = isSelected ? _react2['default'].createElement(
	                'div',
	                { className: 'm-sign-modal--tabs--saved--list--item--delete', onClick: onRemove.bind(null, signature) },
	                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.saved.delete.linkText' })
	            ) : null;
	            classes = {
	                'm-sign-modal--tabs--saved--list--item': true,
	                'is-selected': isSelected
	            };
	            listItems.push(_react2['default'].createElement(
	                'div',
	                { key: 'sig-' + i, className: (0, _classnames2['default'])(classes), onClick: this.props.onSelect.bind(null, signature) },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-sign-modal--tabs--saved--list--item--image' },
	                    this.renderSignatureImage(signature)
	                ),
	                deleteBtn
	            ));
	        }
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'm-sign-modal--tabs--saved--list', 'data-test-ref': 'signature-list' },
	            listItems
	        );
	    },
	    render: function render() {
	        var actionBarProps = this.props.actionBarProps;
	
	        var emptyMessage;
	        var featuredSignature;
	        var carousel;
	        var carouselTip;
	        var tabTitle;
	        var hasSignatures = this.props.signatures.length;
	
	        if (hasSignatures) {
	
	            if (this.props.isMobile) {
	
	                // Render the list of signatures
	                carousel = this.renderSignatureList();
	            } else {
	
	                tabTitle = _react2['default'].createElement(
	                    'span',
	                    { className: 'm-sign-modal--tabs--tab-title' },
	                    _react2['default'].createElement(_reactIntl.FormattedMessage, {
	                        id: 'signModal.saved.title',
	                        values: { type: this.props.type }
	                    })
	                );
	
	                // Featured signature or initials
	                featuredSignature = _react2['default'].createElement(
	                    'div',
	                    { className: 'm-sign-modal--tabs--saved--featured' },
	                    this.renderSignatureImage(this.props.selectedSignature)
	                );
	
	                // Carousel tip
	                carouselTip = _react2['default'].createElement(
	                    'div',
	                    { className: 'm-sign-modal--tabs--saved--carousel--tip' },
	                    _react2['default'].createElement(
	                        'p',
	                        null,
	                        _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.saved.tip.label' }),
	                        ': ',
	                        _react2['default'].createElement('br', null),
	                        _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.saved.tip.text', values: { type: this.props.type } })
	                    )
	                );
	
	                // Carousel
	                carousel = _react2['default'].createElement(
	                    'div',
	                    { className: 'm-sign-modal--tabs--saved--carousel' },
	                    carouselTip,
	                    this.renderSignatureCarousel()
	                );
	            }
	        } else {
	
	            // No signatures or initials
	            emptyMessage = _react2['default'].createElement(
	                'div',
	                { className: 'm-sign-modal--tabs--saved--empty', 'data-test-ref': 'empty-message' },
	                _react2['default'].createElement(
	                    'h2',
	                    null,
	                    _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.saved.empty.text', values: { type: this.props.type } })
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.saved.empty.subText', values: { type: this.props.type } })
	                )
	            );
	        }
	
	        var containerClasses = {
	            'm-sign-modal--tabs--tab': true,
	            'is-selected': this.props.isSelected
	        };
	
	        containerClasses[_constants2['default'].TAB_SAVED] = true;
	
	        var classes = {
	            'm-sign-modal--tabs--saved': true,
	            'has-signatures': this.props.signatures.length
	        };
	
	        return _react2['default'].createElement(
	            'div',
	            { className: (0, _classnames2['default'])(containerClasses) },
	            tabTitle,
	            _react2['default'].createElement(
	                'div',
	                { className: (0, _classnames2['default'])(classes) },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-sign-modal--tabs--content', ref: this.props.captureTabContentRef },
	                    emptyMessage,
	                    featuredSignature,
	                    carousel
	                )
	            ),
	            _react2['default'].createElement(_actionBar2['default'], _extends({
	                'data-test-ref': 'action-bar'
	            }, actionBarProps, {
	                onInsert: this.insertSignature,
	                disableButtons: !hasSignatures
	            }))
	        );
	    }
	});
	
	module.exports = SavedTab;

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(735);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _actionBar = __webpack_require__(793);
	
	var _actionBar2 = _interopRequireDefault(_actionBar);
	
	var _constants = __webpack_require__(771);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _propTypes = __webpack_require__(794);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ErrorTab = _react2['default'].createClass({
	    displayName: 'ErrorTab',
	
	
	    propTypes: _extends({}, _propTypes.CommonTabProps, {
	        error: _react2['default'].PropTypes.object,
	        onContinue: _react2['default'].PropTypes.func.isRequired
	    }),
	
	    //  ----  LIFECYCLE  ----------------------------------
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            'error': new Error('Unknown error')
	        };
	    },
	    getInitialState: function getInitialState() {
	        return {
	            'isSignature': this.props.type === _constants2['default'].TYPE_SIGNATURE,
	            'isInitials': this.props.type === _constants2['default'].TYPE_INITIALS
	        };
	    },
	
	
	    //  ----  RENDERING  ----------------------------------
	
	    render: function render() {
	        var _props = this.props,
	            actionBarProps = _props.actionBarProps,
	            onContinue = _props.onContinue;
	
	
	        var inputClasses = {
	            'm-sign-modal--tabs--error--input': true
	        };
	        var classes = {
	            'm-sign-modal--tabs--error': true
	        };
	        var containerClasses = {
	            'm-sign-modal--tabs--tab': true,
	            'is-selected': this.props.isSelected
	        };
	        var errorClasses = {
	            'm-sign-modal--tabs--error-content': true
	        };
	
	        var errorMessage = this.props.error.message || '';
	
	        return _react2['default'].createElement(
	            'div',
	            { className: (0, _classnames2['default'])(containerClasses) },
	            _react2['default'].createElement(
	                'span',
	                { className: 'm-sign-modal--tabs--tab-title' },
	                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.error.title' })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: (0, _classnames2['default'])(classes) },
	                _react2['default'].createElement(
	                    'div',
	                    { className: (0, _classnames2['default'])(inputClasses) },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-sign-modal--tabs--content' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: (0, _classnames2['default'])(errorClasses) },
	                            _react2['default'].createElement(
	                                'h1',
	                                null,
	                                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.error.header' })
	                            ),
	                            _react2['default'].createElement(
	                                'p',
	                                null,
	                                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.error.body' })
	                            ),
	                            _react2['default'].createElement(
	                                'p',
	                                { 'data-test-ref': 'error-message' },
	                                errorMessage
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2['default'].createElement(_actionBar2['default'], _extends({
	                'data-test-ref': 'action-bar'
	            }, actionBarProps, {
	                continueInsteadOfInsert: true,
	                onContinue: onContinue
	            }))
	        );
	    }
	});
	
	module.exports = ErrorTab;

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _loader = __webpack_require__(798);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _actionBar = __webpack_require__(793);
	
	var _actionBar2 = _interopRequireDefault(_actionBar);
	
	var _constants = __webpack_require__(771);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _signatureEditArea = __webpack_require__(802);
	
	var _signatureEditArea2 = _interopRequireDefault(_signatureEditArea);
	
	var _reactIntl = __webpack_require__(735);
	
	var _propTypes = __webpack_require__(794);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PropTypes = _react2['default'].PropTypes;
	
	
	var EmailTab = _react2['default'].createClass({
	    displayName: 'EmailTab',
	
	
	    propTypes: _extends({}, _propTypes.CommonTabProps, {
	        isCheckingStatus: PropTypes.bool,
	        onCheckStatus: PropTypes.func.isRequired,
	        onSignatureData: _propTypes.OnSignatureData,
	        onRotateSignature: PropTypes.func.isRequired,
	        signature: _propTypes.SignatureType,
	        uploadAddress: PropTypes.string.isRequired
	    }),
	
	    //  ----  BEHAVIOR  -----------------------------------
	
	    insertSignature: function insertSignature(insertEverywhere) {
	
	        var emailEditArea = this.refs.emailEditArea;
	        var signatureData = {};
	        var isCropped = emailEditArea.state.isCropped;
	
	        if (isCropped) {
	            signatureData = {
	                'is_cropped': isCropped,
	                'x': emailEditArea.state.cropX,
	                'y': emailEditArea.state.cropY,
	                'width': emailEditArea.state.cropWidth,
	                'height': emailEditArea.state.cropHeight
	            };
	        }
	
	        signatureData.create_type_code = _constants2['default'].SIGNATURE_TYPE_EMAIL;
	        signatureData.threshold = emailEditArea.state.contrastValue;
	        signatureData.degrees = emailEditArea.state.degreesValue;
	
	        return this.props.onSignatureData(signatureData, insertEverywhere);
	    },
	
	
	    //  ----  HELPERS  ------------------------------------
	
	    startSignatureFlow: function startSignatureFlow() {
	        return this.props.onCheckStatus();
	    },
	    shouldDisableButtons: function shouldDisableButtons() {
	        return !!this.props.signature;
	    },
	    onContinue: function onContinue() {
	        this.startSignatureFlow();
	    },
	
	
	    //  ----  RENDERING  ----------------------------------
	
	    render: function render() {
	        var _props = this.props,
	            actionBarProps = _props.actionBarProps,
	            getSignatureUrl = _props.getSignatureUrl,
	            intl = _props.intl,
	            isCheckingStatus = _props.isCheckingStatus,
	            onRotateSignature = _props.onRotateSignature,
	            signature = _props.signature,
	            type = _props.type;
	
	
	        var spinner;
	
	        var emailAddress = this.props.uploadAddress;
	
	        var inputClasses = {
	            'm-sign-modal--tabs--email--input': true };var classes = { 'm-sign-modal--tabs--email': true
	        };
	        var containerClasses = {
	            'm-sign-modal--tabs--tab': true,
	            'is-selected': this.props.isSelected
	        };
	
	        containerClasses[_constants2['default'].TAB_EMAIL] = true;
	
	        if (isCheckingStatus) {
	            spinner = _react2['default'].createElement(_loader2['default'], {
	                className: 'm-sign-modal--tabs--email--loader',
	                'data-test-ref': 'loader' });
	        }
	
	        var steps = _react2['default'].createElement(
	            'div',
	            { className: 'm-sign-modal--tabs--email--steps' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-sign-modal--tabs--email--steps--header' },
	                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.email.instructions.header' })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-sign-modal--tabs--email--steps--step' },
	                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.email.instructions.step_1', values: { type: this.props.type } })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-sign-modal--tabs--email--steps--step' },
	                _react2['default'].createElement(
	                    'p',
	                    { style: { display: 'inline-block', width: 180, fontWeight: 'normal', lineHeight: '18px', fontSize: '14px' } },
	                    _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.email.instructions.step_2' })
	                ),
	                _react2['default'].createElement(
	                    'strong',
	                    null,
	                    emailAddress
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-sign-modal--tabs--email--steps--subject' },
	                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.email.instructions.subject' }),
	                _react2['default'].createElement(
	                    'strong',
	                    null,
	                    this.props.emailGuid
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-sign-modal--tabs--email--steps--step' },
	                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.email.instructions.step_3' })
	            )
	        );
	
	        return _react2['default'].createElement(
	            'div',
	            { className: (0, _classnames2['default'])(containerClasses) },
	            _react2['default'].createElement(
	                'span',
	                { className: 'm-sign-modal--tabs--tab-title' },
	                _react2['default'].createElement(_reactIntl.FormattedMessage, {
	                    id: 'signModal.email.title',
	                    values: { type: this.props.type }
	                })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: (0, _classnames2['default'])(classes) },
	                _react2['default'].createElement(
	                    'div',
	                    { className: (0, _classnames2['default'])(inputClasses) },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-sign-modal--tabs--content', ref: this.props.captureTabContentRef },
	                        !signature && !isCheckingStatus && _react2['default'].createElement(
	                            'div',
	                            {
	                                'data-test-ref': 'instructions',
	                                className: 'm-sign-modal--tabs--email--part1' },
	                            steps
	                        ),
	                        isCheckingStatus && spinner,
	                        signature && _react2['default'].createElement(_signatureEditArea2['default'], {
	                            'data-test-ref': 'edit-area',
	                            getSignatureUrl: getSignatureUrl,
	                            intl: intl,
	                            onRotate: onRotateSignature,
	                            ref: 'emailEditArea',
	                            signature: signature,
	                            type: type
	                        })
	                    )
	                )
	            ),
	            _react2['default'].createElement(_actionBar2['default'], _extends({}, actionBarProps, {
	                continueInsteadOfInsert: !signature,
	                disableButtons: isCheckingStatus,
	                onContinue: this.onContinue,
	                onInsert: this.insertSignature
	            }))
	        );
	    }
	});
	
	module.exports = EmailTab;

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _setInterval = __webpack_require__(799);
	
	var _setInterval2 = _interopRequireDefault(_setInterval);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	__webpack_require__(800);
	
	var Loader = _react2['default'].createClass({
	    displayName: 'Loader',
	    getInitialState: function getInitialState() {
	        return {
	            'numCircles': 5,
	            'currentIndex': 0,
	            'circleRadius': 10
	        };
	    },
	    componentDidMount: function componentDidMount() {
	
	        var numBubbles = this.refs.dots.querySelectorAll('circle').length;
	        var i = 0;
	
	        this._timer = (0, _setInterval2['default'])(function () {
	            this.setState({
	                'currentCircleIndex': i
	            });
	            i = (i + 1) % numBubbles;
	        }.bind(this), 500);
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        clearInterval(this._timer);
	    },
	    render: function render() {
	
	        var circles = [];
	        var radius = this.state.circleRadius;
	        var circWidth = radius * 2;
	        var padding = radius;
	
	        // width and padding
	        var wandp = circWidth + padding;
	
	        for (var i = this.state.numCircles; i--;) {
	            circles.push(_react2['default'].createElement('circle', {
	                key: 'circle' + i,
	                className: i === this.state.currentCircleIndex ? 'current-dot' : void 0,
	                ref: '5',
	                cx: wandp * i + radius,
	                cy: radius,
	                r: radius }));
	        }
	
	        var width = wandp * circles.length - padding;
	        var classNames = ' m-loader-dots whitelabel-dot-loader';
	
	        if (this.props.className) {
	            classNames += ' ' + this.props.className;
	        }
	
	        return _react2['default'].createElement(
	            'div',
	            { className: classNames },
	            _react2['default'].createElement(
	                'svg',
	                { width: '100%', viewBox: '0 0 ' + width + ' ' + circWidth, version: '1.1' },
	                _react2['default'].createElement(
	                    'g',
	                    { ref: 'dots' },
	                    circles
	                )
	            ),
	            this.props.children ? _react2['default'].createElement(
	                'span',
	                { className: 'message' },
	                this.props.children
	            ) : void 0
	        );
	    }
	});
	
	module.exports = Loader;

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(719).setInterval;

/***/ },
/* 800 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 801 */,
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	// Named so as not to have collisions with the native Image, which we use here too
	
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(735);
	
	var _constants = __webpack_require__(771);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _croppable = __webpack_require__(803);
	
	var _croppable2 = _interopRequireDefault(_croppable);
	
	var _extend = __webpack_require__(497);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _throttle = __webpack_require__(805);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _image = __webpack_require__(808);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _propTypes = __webpack_require__(794);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var SignatureEditArea = _react2['default'].createClass({
	    displayName: 'SignatureEditArea',
	
	
	    propTypes: {
	        getSignatureUrl: _propTypes.GetSignatureUrl,
	        intl: _react2['default'].PropTypes.object.isRequired,
	        onRotate: _react2['default'].PropTypes.func.isRequired,
	        signature: _propTypes.SignatureType,
	        type: _propTypes.Type
	    },
	
	    //  ----  LIFECYCLE  ----------------------------------
	
	    getInitialState: function getInitialState() {
	        return {
	            'isSignature': this.props.type === _constants2['default'].TYPE_SIGNATURE,
	            'isInitials': this.props.type === _constants2['default'].TYPE_INITIALS,
	            'selectedFontIndex': 2,
	            'isSpinnerShown': false,
	            'contrastValue': this.getContrastMidValue(),
	            'degreesValue': 0,
	            'isCropped': false,
	            'cropX': null,
	            'cropY': null,
	            'cropWidth': null,
	            'cropHeight': null
	        };
	    },
	    componentDidMount: function componentDidMount() {},
	    componentDidUpdate: function componentDidUpdate() {},
	
	
	    //  ----  BEHAVIOR  -----------------------------------
	
	    getContrastMidValue: function getContrastMidValue() {
	        return (_constants2['default'].CONTRAST_MAX_THRESHOLD + _constants2['default'].CONTRAST_MIN_THRESHOLD) / 2;
	    },
	    scaleSignatureToFit: function scaleSignatureToFit(origDims, restrictDims) {
	        var origDims = (0, _extend2['default'])({}, origDims);
	
	        origDims.ratio = parseFloat(origDims.width / origDims.height);
	
	        if (origDims.width > origDims.height) {
	
	            origDims.width = restrictDims.width;
	            origDims.height = parseInt(origDims.width / origDims.ratio, 10);
	
	            if (origDims.height > restrictDims.height) {
	
	                origDims.height = restrictDims.height;
	                origDims.width = parseInt(origDims.height * origDims.ratio, 10);
	            }
	        } else {
	            origDims.height = restrictDims.height;
	            origDims.width = parseInt(origDims.height * origDims.ratio, 10);
	
	            if (origDims.width > restrictDims.width) {
	
	                origDims.width = restrictDims.width;
	                origDims.height = parseInt(origDims.width / origDims.ratio, 10);
	            }
	        }
	
	        return origDims;
	    },
	
	
	    // Stores prefeched images
	    images: {},
	
	    /*
	    * Throttled for performance. This may need to be adjusted in the future to > 1s
	    */
	
	    prefetchImages: (0, _throttle2['default'])(function () {
	        this._prefetchImages();
	    }, 1000),
	
	    /*
	    * Private prefetch images function
	    *
	    * Simply gets and stores all contrast variants on load or rotate.
	    * The browser will take care of using the cached images instead of reloading from
	    * the server each time.
	    */
	
	    _prefetchImages: function _prefetchImages() {
	        if (!this.props.signature) {
	            return;
	        }
	
	        var degrees = this.state.degreesValue || 0;
	        var contrastStep = _constants2['default'].CONTRAST_MIN_THRESHOLD;
	
	        while (contrastStep <= _constants2['default'].CONTRAST_MAX_THRESHOLD) {
	
	            var key = 'c' + contrastStep + 'd' + degrees;
	
	            // Don't even need to check if already set - we want to overwrite on
	            // subsequent uploads
	            this.images[key] = new window.Image();
	            this.images[key].src = this.props.getSignatureUrl(this.props.signature, contrastStep, degrees);
	
	            contrastStep += _constants2['default'].CONTRAST_STEP_AMOUNT;
	        }
	    },
	    renderSignatureImage: function renderSignatureImage() {
	
	        this.prefetchImages();
	
	        var threshold = this.state.contrastValue || 100;
	        var degrees = this.state.degreesValue || 0;
	
	        var url;
	        if (this.props.signature) {
	            url = this.props.getSignatureUrl(this.props.signature, threshold, degrees);
	        }
	
	        var style = {};
	
	        // Hardcoded to preview container area size, with 2px padding
	        var previewAreaDimensions = {
	            'width': 398,
	            'height': 120
	        };
	
	        if (this.props.signature) {
	
	            var imageDims = {
	                'width': this.props.signature.width,
	                'height': this.props.signature.height
	            };
	
	            // flip dimensions if rotating vs saved wh
	            if (degrees == 90 || degrees == 270) {
	                imageDims.height = this.props.signature.width;
	                imageDims.width = this.props.signature.height;
	            }
	
	            style = this.scaleSignatureToFit(imageDims, previewAreaDimensions);
	        }
	
	        style.backgroundImage = 'url(' + url + ')';
	        style.backgroundSize = '100%';
	
	        return _react2['default'].createElement('div', { className: 'm-sign-modal--signature-edit-area--preview--image',
	            ref: 'uploadSignaturePreviewImage',
	            style: style });
	    },
	    rotateSignature: function rotateSignature() {
	        this.props.onRotate(this.props.signature);
	
	        this.incrementDegrees();
	    },
	
	
	    // Reset to 0 if we come full circle
	    incrementDegrees: function incrementDegrees() {
	        var newValue;
	
	        if (this.state.degreesValue + _constants2['default'].ROTATE_DEGREES_AMOUNT >= 360) {
	            newValue = 0;
	        } else {
	            newValue = this.state.degreesValue + _constants2['default'].ROTATE_DEGREES_AMOUNT;
	        }
	
	        this.setState({
	            'degreesValue': newValue
	        });
	    },
	    adjustContrast: function adjustContrast(event) {
	        this.setState({
	            'contrastValue': event.target.value
	        });
	    },
	    setCropBounds: function setCropBounds(cropRect) {
	
	        var imageBounds = this.refs.uploadSignaturePreviewImage.getBoundingClientRect();
	
	        var preScaledCrop = {
	            x: cropRect.left - imageBounds.left,
	            y: cropRect.top - imageBounds.top,
	            width: cropRect.width,
	            height: cropRect.height
	        };
	
	        if (preScaledCrop.width > 0 && preScaledCrop.height > 0) {
	
	            var originalImageBounds = { width: this.props.signature.width, height: this.props.signature.height };
	
	            var scaledParams = this.scaleCrop(imageBounds, originalImageBounds, preScaledCrop);
	
	            this.setState({
	                'isCropped': true,
	                'cropX': scaledParams.x,
	                'cropY': scaledParams.y,
	                'cropWidth': scaledParams.width,
	                'cropHeight': scaledParams.height
	            });
	        } else {
	            this.setState({
	                'isCropped': false
	            });
	        }
	    },
	    scaleCrop: function scaleCrop(imageScaledSize, imageOriginalSize, cropSize) {
	
	        var scaledCropParams = {};
	
	        var scaleY = parseFloat(imageOriginalSize.height / imageScaledSize.height);
	        var scaleX = parseFloat(imageOriginalSize.width / imageScaledSize.width);
	        var scaledPositionX = 0;
	        var scaledPositionY = 0;
	        var scaledWidth = imageOriginalSize.width;
	        var scaledHeight = imageOriginalSize.height;
	
	        scaledPositionX = parseInt(scaleX * cropSize.x, 10);
	        scaledPositionY = parseInt(scaleY * cropSize.y, 10);
	        scaledWidth = parseInt(scaleX * cropSize.width, 10);
	        scaledHeight = parseInt(scaleY * cropSize.height, 10);
	
	        if (scaledWidth > imageOriginalSize.width) {
	            scaledWidth = imageOriginalSize.width;
	        }
	
	        if (scaledWidth + scaledPositionX > imageOriginalSize.width) {
	            scaledWidth = imageOriginalSize.width - scaledPositionX;
	        }
	
	        if (scaledHeight > imageOriginalSize.height) {
	            scaledHeight = imageOriginalSize.height;
	        }
	
	        if (scaledHeight + scaledPositionY > imageOriginalSize.height) {
	            scaledHeight = imageOriginalSize.height - scaledPositionY;
	        }
	
	        scaledCropParams.x = scaledPositionX;
	        scaledCropParams.y = scaledPositionY;
	        scaledCropParams.width = scaledWidth;
	        scaledCropParams.height = scaledHeight;
	
	        return scaledCropParams;
	    },
	
	
	    //  ----  RENDERING  ----------------------------------
	
	    renderControls: function renderControls() {
	
	        var type = this.props.type;
	
	        var contrastControl = _react2['default'].createElement(
	            'div',
	            { className: 'm-sign-modal--signature-edit-area--controls--contrast' },
	            _react2['default'].createElement('input', { type: 'range',
	                min: _constants2['default'].CONTRAST_MIN_THRESHOLD,
	                max: _constants2['default'].CONTRAST_MAX_THRESHOLD,
	                step: _constants2['default'].CONTRAST_STEP_AMOUNT,
	                defaultValue: this.getContrastMidValue(),
	                onMouseUp: this.adjustContrast }),
	            _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(_reactIntl.FormattedMessage, {
	                    id: 'signModal.signatureEditArea.controls.contrast.labelText' })
	            )
	        );
	
	        var rotationControl = _react2['default'].createElement(
	            'div',
	            { className: 'm-sign-modal--signature-edit-area--controls--rotate',
	                onClick: this.rotateSignature },
	            _react2['default'].createElement(_image2['default'], { src: __webpack_require__(809) }),
	            _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(_reactIntl.FormattedMessage, {
	                    id: 'signModal.signatureEditArea.controls.rotate.labelText',
	                    values: { type: type } })
	            )
	        );
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'm-sign-modal--signature-edit-area--controls' },
	            contrastControl,
	            rotationControl
	        );
	    },
	    render: function render() {
	
	        var type = this.props.type;
	
	        var instructions = _react2['default'].createElement(
	            'div',
	            { className: 'm-sign-modal--signature-edit-area--instructions' },
	            _react2['default'].createElement(_reactIntl.FormattedMessage, {
	                id: 'signModal.signatureEditArea.instructions',
	                values: { type: type } })
	        );
	
	        var previewAndCrop = _react2['default'].createElement(
	            _croppable2['default'],
	            _extends({}, this.props, {
	                restrictToParent: true,
	                callback: this.setCropBounds,
	                containerClassName: 'm-sign-modal--signature-edit-area--preview' }),
	            this.renderSignatureImage()
	        );
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'm-sign-modal--signature-edit-area' },
	            instructions,
	            previewAndCrop,
	            this.renderControls()
	        );
	    }
	});
	
	module.exports = SignatureEditArea;

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _portal = __webpack_require__(804);
	
	var _portal2 = _interopRequireDefault(_portal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Croppable = _react2['default'].createClass({
	    displayName: 'Croppable',
	
	
	    propTypes: {
	        'restrictToParent': _react2['default'].PropTypes.bool,
	        'callback': _react2['default'].PropTypes.func,
	        'className': _react2['default'].PropTypes.string
	    },
	
	    //  ----  LIFECYCLE  ----------------------------------
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            'restrictToParent': false,
	            'callback': function callback() {},
	
	            'containerClassName': 'croppable-container'
	        };
	    },
	    getInitialState: function getInitialState() {
	        return {
	            'startX': null,
	            'startY': null,
	            'endX': null,
	            'endY': null,
	            'dragging': false,
	            'boxIsShown': false
	        };
	    },
	    componentDidMount: function componentDidMount() {},
	    componentDidUpdate: function componentDidUpdate(props, state) {
	        this.addListeners(state);
	    },
	
	
	    //  ----  BEHAVIOR  -----------------------------------
	
	    // point is {x: x, y: y}
	    isInBounds: function isInBounds(point) {
	
	        if (!this.props.restrictToParent) {
	            return true;
	        }
	
	        var parent = _reactDom2['default'].findDOMNode(this).parentNode;
	
	        if (parent) {
	
	            var rect = parent.getBoundingClientRect();
	
	            if (rect.left < point.x && point.x < rect.right && rect.top < point.y && point.y < rect.bottom) {
	                return true;
	            }
	        } else {
	            console.error('restrictToParent specified, but no parent found');
	        }
	
	        return false;
	    },
	    mousedown: function mousedown(e) {
	
	        var point = {
	            x: e.pageX,
	            y: e.pageY
	        };
	
	        if (this.isInBounds(point)) {
	            this.setState({
	                'dragging': true,
	                'boxIsShown': true,
	                'startX': point.x,
	                'startY': point.y,
	                'endX': point.x,
	                'endY': point.y
	            });
	        }
	
	        e.stopPropagation();
	        e.preventDefault();
	    },
	    mouseup: function mouseup(e) {
	
	        this.setState({
	            'dragging': false
	        });
	
	        this.props.callback({
	            'left': this.state.startX,
	            'top': this.state.startY,
	            'width': this.state.endX - this.state.startX,
	            'height': this.state.endY - this.state.startY
	        });
	
	        e.stopPropagation();
	        e.preventDefault();
	    },
	    mousemove: function mousemove(e) {
	        if (this.state.dragging) {
	
	            var point = {
	                x: e.pageX,
	                y: e.pageY
	            };
	
	            if (this.isInBounds(point)) {
	                this.updateEndpoint(point);
	            }
	
	            e.stopPropagation();
	            e.preventDefault();
	        }
	    },
	    updateEndpoint: function updateEndpoint(point) {
	        this.setState({
	            'endX': point.x,
	            'endY': point.y
	        });
	    },
	    addListeners: function addListeners(state) {
	        var state = state || {};
	        if (this.state.dragging && !state.dragging) {
	            document.addEventListener('mousemove', this.mousemove);
	            document.addEventListener('mouseup', this.mouseup);
	        } else if (!this.state.dragging && state.dragging) {
	            document.removeEventListener('mousemove', this.mousemove);
	            document.removeEventListener('mouseup', this.mouseup);
	        }
	    },
	
	
	    //  ----  RENDERING  ----------------------------------
	
	    render: function render() {
	
	        var style = {};
	
	        if (this.state.boxIsShown) {
	
	            style.display = 'block';
	
	            style = {
	                'border': 'dashed 1px black',
	                'position': 'absolute',
	                zIndex: 50000,
	                'width': this.state.endX - this.state.startX,
	                'height': this.state.endY - this.state.startY,
	                'left': this.state.startX,
	                'top': this.state.startY
	            };
	        } else {
	            style.display = 'none';
	        }
	
	        var cropBox = _react2['default'].createElement('div', { className: 'cropbox', style: style });
	
	        return _react2['default'].createElement(
	            'div',
	            { className: this.props.containerClassName,
	                onMouseDown: this.mousedown },
	            this.props.children,
	            _react2['default'].createElement(
	                _portal2['default'],
	                { rerenderOnUpdate: true },
	                cropBox
	            )
	        );
	    }
	});
	
	module.exports = Croppable;

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* A utility class that allows you to place elements directly on the body of the document, instead of placed
	*   normally in the DOM. Useful for Modals, Popups, and other elements that need absolute screen positioning.
	* See http://joecritchley.svbtle.com/portals-in-reactjs for the Portal concept
	*/
	
	var Portal = _react2['default'].createClass({
	    displayName: 'Portal',
	
	
	    propTypes: {
	        'rerenderOnUpdate': _react2['default'].PropTypes.bool, // For dynamic components
	        'className': _react2['default'].PropTypes.string // Optionally, creates a div to with specified class to wrap child components
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            'rerenderOnUpdate': false,
	            'className': null
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.element = document.createElement('div');
	        document.body.appendChild(this.element);
	        this._renderLayer();
	    },
	
	
	    // FIXME: This should be filled in to adapt to property changes
	    componentWillReceiveProps: function componentWillReceiveProps() {},
	    componentDidUpdate: function componentDidUpdate() {
	        if (this.props.rerenderOnUpdate) {
	            this._renderLayer();
	        }
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        _reactDom2['default'].unmountComponentAtNode(this.element);
	        document.body.removeChild(this.element);
	    },
	    _renderLayer: function _renderLayer() {
	        if (this.props.className) {
	            _reactDom2['default'].render(_react2['default'].createElement(
	                'div',
	                { className: this.props.className },
	                this.props.children
	            ), this.element);
	        } else {
	            _reactDom2['default'].render(this.props.children, this.element);
	        }
	    },
	
	
	    // Placeholder to satisfy render
	    render: function render() {
	        return null;
	    }
	});
	
	module.exports = Portal;

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(806),
	    isObject = __webpack_require__(347);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed invocations. Provide an options object to indicate
	 * that `func` should be invoked on the leading and/or trailing edge of the
	 * `wait` timeout. Subsequent calls to the throttled function return the
	 * result of the last `func` call.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	 * on the trailing edge of the timeout only if the the throttled function is
	 * invoked more than once during the `wait` timeout.
	 *
	 * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options] The options object.
	 * @param {boolean} [options.leading=true] Specify invoking on the leading
	 *  edge of the timeout.
	 * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	 *  edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // avoid excessively updating the position while scrolling
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
	 * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
	 *   'trailing': false
	 * }));
	 *
	 * // cancel a trailing throttled call
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (options === false) {
	    leading = false;
	  } else if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
	}
	
	module.exports = throttle;


/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(347),
	    now = __webpack_require__(807);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed invocations. Provide an options object to indicate that `func`
	 * should be invoked on the leading and/or trailing edge of the `wait` timeout.
	 * Subsequent calls to the debounced function return the result of the last
	 * `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	 * on the trailing edge of the timeout only if the the debounced function is
	 * invoked more than once during the `wait` timeout.
	 *
	 * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options] The options object.
	 * @param {boolean} [options.leading=false] Specify invoking on the leading
	 *  edge of the timeout.
	 * @param {number} [options.maxWait] The maximum time `func` is allowed to be
	 *  delayed before it is invoked.
	 * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	 *  edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // avoid costly calculations while the window size is in flux
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
	 * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // ensure `batchLog` is invoked once after 1 second of debounced calls
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', _.debounce(batchLog, 250, {
	 *   'maxWait': 1000
	 * }));
	 *
	 * // cancel a debounced call
	 * var todoChanges = _.debounce(batchLog, 1000);
	 * Object.observe(models.todo, todoChanges);
	 *
	 * Object.observe(models, function(changes) {
	 *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
	 *     todoChanges.cancel();
	 *   }
	 * }, ['delete']);
	 *
	 * // ...at some point `models.todo` is changed
	 * models.todo.completed = true;
	 *
	 * // ...before 1 second has passed `models.todo` is deleted
	 * // which cancels the debounced `todoChanges` call
	 * delete models.todo;
	 */
	function debounce(func, wait, options) {
	  var args,
	      maxTimeoutId,
	      result,
	      stamp,
	      thisArg,
	      timeoutId,
	      trailingCall,
	      lastCalled = 0,
	      maxWait = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = wait < 0 ? 0 : (+wait || 0);
	  if (options === true) {
	    var leading = true;
	    trailing = false;
	  } else if (isObject(options)) {
	    leading = !!options.leading;
	    maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function cancel() {
	    if (timeoutId) {
	      clearTimeout(timeoutId);
	    }
	    if (maxTimeoutId) {
	      clearTimeout(maxTimeoutId);
	    }
	    lastCalled = 0;
	    maxTimeoutId = timeoutId = trailingCall = undefined;
	  }
	
	  function complete(isCalled, id) {
	    if (id) {
	      clearTimeout(id);
	    }
	    maxTimeoutId = timeoutId = trailingCall = undefined;
	    if (isCalled) {
	      lastCalled = now();
	      result = func.apply(thisArg, args);
	      if (!timeoutId && !maxTimeoutId) {
	        args = thisArg = undefined;
	      }
	    }
	  }
	
	  function delayed() {
	    var remaining = wait - (now() - stamp);
	    if (remaining <= 0 || remaining > wait) {
	      complete(trailingCall, maxTimeoutId);
	    } else {
	      timeoutId = setTimeout(delayed, remaining);
	    }
	  }
	
	  function maxDelayed() {
	    complete(trailing, timeoutId);
	  }
	
	  function debounced() {
	    args = arguments;
	    stamp = now();
	    thisArg = this;
	    trailingCall = trailing && (timeoutId || !leading);
	
	    if (maxWait === false) {
	      var leadingCall = leading && !timeoutId;
	    } else {
	      if (!maxTimeoutId && !leading) {
	        lastCalled = stamp;
	      }
	      var remaining = maxWait - (stamp - lastCalled),
	          isCalled = remaining <= 0 || remaining > maxWait;
	
	      if (isCalled) {
	        if (maxTimeoutId) {
	          maxTimeoutId = clearTimeout(maxTimeoutId);
	        }
	        lastCalled = stamp;
	        result = func.apply(thisArg, args);
	      }
	      else if (!maxTimeoutId) {
	        maxTimeoutId = setTimeout(maxDelayed, remaining);
	      }
	    }
	    if (isCalled && timeoutId) {
	      timeoutId = clearTimeout(timeoutId);
	    }
	    else if (!timeoutId && wait !== maxWait) {
	      timeoutId = setTimeout(delayed, wait);
	    }
	    if (leadingCall) {
	      isCalled = true;
	      result = func.apply(thisArg, args);
	    }
	    if (isCalled && !timeoutId && !maxTimeoutId) {
	      args = thisArg = undefined;
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(344);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeNow = getNative(Date, 'now');
	
	/**
	 * Gets the number of milliseconds that have elapsed since the Unix epoch
	 * (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @category Date
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => logs the number of milliseconds it took for the deferred function to be invoked
	 */
	var now = nativeNow || function() {
	  return new Date().getTime();
	};
	
	module.exports = now;


/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* Wrapper class for images on HelloSign.
	* Deprecated - <img /> elements work just fine now since image sources are resolved via webpack. (CC)
	*/
	
	var VALID_IMAGE_PROPS = { 'src': true, 'className': true, 'style': true, 'meta': true };
	
	var Image = _react2['default'].createClass({
	    displayName: 'Image',
	
	
	    propTypes: {
	        'src': _react2['default'].PropTypes.any,
	        'className': _react2['default'].PropTypes.string,
	        'style': _react2['default'].PropTypes.object
	    },
	
	    //  ----  LIFECYCLE  ----------------------------------
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            'src': null,
	            'className': '',
	            'style': {}
	        };
	    },
	    getInitialState: function getInitialState() {
	        return {};
	    },
	    render: function render() {
	        var _this = this;
	
	        // Only add valid keys; prevents browser warnings
	        var propsKeys = Object.keys(this.props);
	        var imageProps = {};
	        propsKeys.filter(function (key) {
	            if (VALID_IMAGE_PROPS[key] === true) {
	                imageProps[key] = _this.props[key];
	            }
	        });
	
	        return _react2['default'].createElement('img', imageProps);
	    }
	});
	
	module.exports = Image;

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/6a812413c6343cc64cc499ee02778b2f.png";

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactIntl = __webpack_require__(735);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hfReactHelper = __webpack_require__(772);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	var _actionBar = __webpack_require__(793);
	
	var _actionBar2 = _interopRequireDefault(_actionBar);
	
	var _constants = __webpack_require__(771);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _propTypes = __webpack_require__(794);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PropTypes = _react2['default'].PropTypes;
	
	
	function ChangeFontButton(props) {
	    var changeLinkClasses = {
	        'm-sign-modal--tabs--type--output--change-link': true,
	        'm-button': true,
	        'bg-white': true,
	        'border-1-light-grey': true,
	        'hbg-white': true,
	        'hc-light-grey': true,
	        'c-light-grey': true
	    };
	    var spinner = _react2['default'].createElement('img', { src: __webpack_require__(811),
	        className: 'm-sign-modal--tabs--type--output--spinner' });
	
	    var changeLink = _react2['default'].createElement(
	        'a',
	        { className: (0, _classnames2['default'])(changeLinkClasses), onClick: props.handleClick },
	        _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.typed.changeFonts.linkText' })
	    );
	    return _react2['default'].createElement(
	        'div',
	        { className: 'm-sign-modal--tabs--type--output' },
	        changeLink,
	        props.showSpinner ? spinner : null
	    );
	}
	
	var TypeInTab = _react2['default'].createClass({
	    displayName: 'TypeInTab',
	
	
	    propTypes: _extends({}, _propTypes.CommonTabProps, {
	
	        /**
	         * Takes a callback that will be called when the network is checked and
	         * verified to be working.
	         */
	        onCheckNetworkHealth: PropTypes.func,
	        onSignatureData: _propTypes.OnSignatureData,
	        initialValue: PropTypes.string.isRequired
	    }),
	
	    //  ----  LIFECYCLE  ----------------------------------
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            'canInsertEverywhere': true,
	            onCheckNetworkHealth: function onCheckNetworkHealth(cb) {
	                return cb();
	            }
	        };
	    },
	    getInitialState: function getInitialState() {
	        var initialValue = this.props.initialValue;
	
	
	        return {
	            'hasValue': !!initialValue,
	            'isSignature': this.props.type === _constants2['default'].TYPE_SIGNATURE,
	            'isInitials': this.props.type === _constants2['default'].TYPE_INITIALS,
	            'selectedFontIndex': 2,
	            'showSpinner': false,
	            'textValue': initialValue
	        };
	    },
	    componentDidMount: function componentDidMount() {
	
	        this.adjustInputWidth();
	
	        // Load the initial font family
	        var n = this.state.selectedFontIndex % _constants2['default'].CURSIVE_FONTS.length;
	        var chosenFamily = _constants2['default'].CURSIVE_FONTS[n];
	        this.loadFontFamily(chosenFamily);
	    },
	    componentDidUpdate: function componentDidUpdate() {
	        this.adjustInputWidth();
	    },
	
	
	    //  ----  BEHAVIOR  -----------------------------------
	
	    loadFontFamily: function loadFontFamily(fontFamily, okCallback) {
	
	        var onActive = function onActive() {
	            if (okCallback) {
	                okCallback();
	            }
	        };
	
	        var onInactive = function onInactive(stop) {
	
	            if (stop === true) {
	                console.error('Could not load font ' + fontFamily + ' at all');
	                return;
	            }
	
	            if (true) {
	                console.error('Could not get font ' + fontFamily + ' from Google, loading from our servers instead');
	            }
	
	            // Load from CDN
	            var cdnFontUrl = _hfReactHelper2['default'].urlHelper('/fonts/' + fontFamily.toLowerCase().replace(/\s/g, '-') + '.css', 'hellosign');
	            WebFont.load({
	                'custom': {
	                    'families': [fontFamily],
	                    'urls': [cdnFontUrl]
	                },
	                'active': onActive,
	                'fontinactive': onInactive.bind(this, true)
	            });
	        };
	
	        // Load font from google
	        if (window.WebFont) {
	            WebFont.load({
	                'google': {
	                    'families': [fontFamily]
	                },
	                'active': onActive,
	                'fontinactive': onInactive
	            });
	        } else if (okCallback) {
	            okCallback();
	        }
	    },
	    selectNextFontFamily: function selectNextFontFamily() {
	
	        var self = this;
	        var n = (this.state.selectedFontIndex + 1) % _constants2['default'].CURSIVE_FONTS.length;
	        var chosenFamily = _constants2['default'].CURSIVE_FONTS[n];
	
	        this.setState({
	            'showSpinner': true
	        });
	
	        var loadFont = function loadFont() {
	            self.loadFontFamily(chosenFamily, function () {
	                self.setState({
	                    'showSpinner': false,
	                    'selectedFontIndex': n // Will trigger the new css font-family to change
	                });
	            });
	        };
	
	        this.props.onCheckNetworkHealth(loadFont);
	    },
	    handleInput: function handleInput(evt) {
	        var v = evt.target.value;
	        this.setState({
	            'textValue': v,
	            'hasValue': v.replace(/\s/g, '').length > 0
	        });
	    },
	    insertSignature: function insertSignature(insertEverywhere) {
	
	        var text = _hfReactHelper2['default'].trim(this.state.textValue);
	
	        var signatureData = {
	            'type_code': this.props.type,
	            'create_type_code': _constants2['default'].SIGNATURE_TYPE_TYPED,
	            'signature': {
	                'text': text,
	                'font_family': _constants2['default'].CURSIVE_FONTS[this.state.selectedFontIndex]
	            }
	        };
	
	        return this.props.onSignatureData(signatureData, insertEverywhere);
	    },
	
	
	    //  ----  HELPERS  ------------------------------------
	
	    adjustInputWidth: function adjustInputWidth() {
	        var root = this.node;
	        var w = '385px';
	        if (this.props.isMobile) {
	            w = this.props.deviceOrientation === _constants2['default'].ORIENTATION_LANDSCAPE ? $('.m-sign-modal--tabs--type', root).width() - 140 + 'px' : '100%'; // 140 = size of the btn
	        }
	        $('#typedSignatureInput', root).css('width', w);
	    },
	    isChinese: function isChinese() {
	        var intl = this.props.intl;
	        var locale = intl ? intl.locale : null;
	        return locale === 'zh-CN';
	    },
	
	
	    //  ----  RENDERING  ----------------------------------
	
	    render: function render() {
	        var _this = this;
	
	        var actionBarProps = this.props.actionBarProps;
	
	
	        var fontFamily = _constants2['default'].CURSIVE_FONTS[this.state.selectedFontIndex];
	        var inputStyle = {
	            'fontFamily': fontFamily
	        };
	        var inputClasses = {
	            'm-sign-modal--tabs--type--input': true
	        };
	        var classes = {
	            'm-sign-modal--tabs--type': true,
	            'has-value': this.state.hasValue
	        };
	        var containerClasses = {
	            'm-sign-modal--tabs--tab': true,
	            'is-selected': this.props.isSelected
	        };
	
	        containerClasses[_constants2['default'].TAB_TYPE] = true;
	        inputClasses['font-' + fontFamily.replace(/\s/g, '-')] = true;
	
	        var changeFontButton = _react2['default'].createElement(ChangeFontButton, _extends({}, this.props, {
	            'data-test-ref': 'change-button',
	            handleClick: this.selectNextFontFamily,
	            showSpinner: this.state.showSpinner }));
	
	        return _react2['default'].createElement(
	            'div',
	            { className: (0, _classnames2['default'])(containerClasses), ref: function ref(node) {
	                    return _this.node = node;
	                } },
	            _react2['default'].createElement(
	                'span',
	                { className: 'm-sign-modal--tabs--tab-title' },
	                _react2['default'].createElement(_reactIntl.FormattedMessage, {
	                    id: 'signModal.typed.title',
	                    values: { type: this.props.type }
	                })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: (0, _classnames2['default'])(classes) },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-sign-modal--tabs--content', ref: this.props.captureTabContentRef },
	                    _react2['default'].createElement('input', {
	                        'data-test-ref': 'input',
	                        id: 'typedSignatureInput',
	                        ref: 'typedSignatureInput',
	                        type: 'text',
	                        className: (0, _classnames2['default'])(inputClasses),
	                        style: inputStyle,
	                        value: this.state.textValue,
	                        onChange: this.handleInput,
	                        onKeyUp: this.handleInput,
	                        placeholder: this.props.intl.formatMessage({ id: 'signModal.typed.placeholder.' + this.props.type })
	                    }),
	                    !this.isChinese() ? changeFontButton : null
	                )
	            ),
	            _react2['default'].createElement(_actionBar2['default'], _extends({}, actionBarProps, {
	                'data-test-ref': 'action-bar',
	                disableButtons: !this.state.hasValue,
	                onInsert: this.insertSignature
	            }))
	        );
	    }
	});
	
	module.exports = TypeInTab;

/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/aed48fbef19b3ec6af0ecd7f182b84d1.gif";

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _image = __webpack_require__(808);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _reactDropzone = __webpack_require__(813);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _actionBar = __webpack_require__(793);
	
	var _actionBar2 = _interopRequireDefault(_actionBar);
	
	var _constants = __webpack_require__(771);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _signatureEditArea = __webpack_require__(802);
	
	var _signatureEditArea2 = _interopRequireDefault(_signatureEditArea);
	
	var _propTypes = __webpack_require__(794);
	
	var _reactIntl = __webpack_require__(735);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var PropTypes = _react2['default'].PropTypes;
	
	
	var UploadTab = _react2['default'].createClass({
	    displayName: 'UploadTab',
	
	
	    propTypes: _extends({}, _propTypes.CommonTabProps, {
	        getSignatureUrl: _propTypes.GetSignatureUrl,
	        isUploading: PropTypes.bool,
	        onRotateSignature: PropTypes.func.isRequired,
	        onSignatureData: _propTypes.OnSignatureData,
	        onUpload: PropTypes.func.isRequired,
	        signature: _propTypes.SignatureType
	    }),
	
	    //  ----  LIFECYCLE  ----------------------------------
	
	    getInitialState: function getInitialState() {
	        return {
	            'isSignature': this.props.type === _constants2['default'].TYPE_SIGNATURE,
	            'isInitials': this.props.type === _constants2['default'].TYPE_INITIALS,
	            'isSpinnerShown': false,
	            'isEditAreaShown': false,
	            'signature': null
	        };
	    },
	
	
	    //  ----  BEHAVIOR  -----------------------------------
	
	    insertSignature: function insertSignature(insertEverywhere) {
	
	        var uploadEditArea = this.refs.uploadEditArea;
	        var signatureData = {};
	        var isCropped = uploadEditArea.state.isCropped;
	
	        if (isCropped) {
	            signatureData = {
	                'is_cropped': isCropped,
	                'x': uploadEditArea.state.cropX,
	                'y': uploadEditArea.state.cropY,
	                'width': uploadEditArea.state.cropWidth,
	                'height': uploadEditArea.state.cropHeight
	            };
	        }
	
	        signatureData.create_type_code = _constants2['default'].SIGNATURE_TYPE_UPLOAD;
	        signatureData.threshold = uploadEditArea.state.contrastValue;
	        signatureData.degrees = uploadEditArea.state.degreesValue;
	
	        return this.props.onSignatureData(signatureData, insertEverywhere);
	    },
	
	
	    //  ----  HELPERS  ------------------------------------
	
	    onDrop: function onDrop(files) {
	        var _this = this;
	
	        return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	            var file, has_errors;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            file = files[0]; // We only accept one
	
	                            has_errors = !_this.checkTypeAndSize(file);
	
	                            if (has_errors) {
	                                _context.next = 4;
	                                break;
	                            }
	
	                            return _context.abrupt('return', _this.props.onUpload(file));
	
	                        case 4:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, _this);
	        }))();
	    },
	    showEditArea: function showEditArea() {
	        this.setState({
	            'isEditAreaShown': true
	        });
	    },
	    hideEditArea: function hideEditArea() {
	        this.setState({
	            'isEditAreaShown': false
	        });
	    },
	    showSpinner: function showSpinner() {
	        this.setState({
	            'isSpinnerShown': true
	        });
	    },
	    hideSpinner: function hideSpinner() {
	        this.setState({
	            'isSpinnerShown': false
	        });
	    },
	    checkTypeAndSize: function checkTypeAndSize(file) {
	        return this.checkFileExtension(file) && this.checkFileSize(file);
	    },
	    checkFileExtension: function checkFileExtension(file) {
	        if (file.type && _constants2['default'].ACCEPTED_UPLOAD_TYPES.indexOf(file.type) === -1) {
	
	            var errorMessage = this.props.intl.formatMessage({ id: 'signModal.upload.error.fileType' }, { 'fileType': file.type }) + ' ' + this.props.intl.formatMessage({ id: 'signModal.upload.instructions.fileFormats' });
	
	            this.props.onError(new Error(errorMessage));
	            return false;
	        }
	        return true;
	    },
	    checkFileSize: function checkFileSize(file) {
	        if (file.size && file.size > _constants2['default'].MAX_UPLOAD_SIZE) {
	
	            var formattedSize = Math.round(file.size / 1000000) + 'MB';
	
	            var errorMessage = this.props.intl.formatMessage({ id: 'signModal.upload.error.fileSize' }, { 'fileSize': formattedSize }) + ' ' + this.props.intl.formatMessage({ id: 'signModal.upload.instructions.fileSize' });
	
	            this.props.onError(new Error(errorMessage));
	            return false;
	        }
	        return true;
	    },
	
	
	    //  ----  RENDERING  ----------------------------------
	
	    renderUploadArea: function renderUploadArea() {
	
	        var show = this.props.signature ? { 'display': 'none' } : {};
	        var btnText = this.props.intl.formatMessage({ id: 'signModal.upload.button.text' });
	
	        var uploadButton = _react2['default'].createElement(
	            _reactDropzone2['default'],
	            { onDrop: this.onDrop,
	                onClick: this.onDrop,
	                multiple: false,
	                ref: 'dropzone', className: 'whitelabel-primary-button dropzone',
	                style: {
	                    'width': 60 + btnText.length * 10,
	                    'height': 40
	                } },
	            _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(_image2['default'], { src: __webpack_require__(814) }),
	                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.upload.button.text' })
	            )
	        );
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'm-sign-modal--tabs--upload--fileupload', style: show },
	            _react2['default'].createElement(
	                'span',
	                { className: 'm-sign-modal--tabs--upload--header-text' },
	                _react2['default'].createElement(_reactIntl.FormattedMessage, {
	                    id: 'signModal.upload.instructions.header',
	                    values: { type: this.props.type } })
	            ),
	            uploadButton,
	            _react2['default'].createElement(
	                'span',
	                { className: 'm-sign-modal--tabs--upload--file-formats-text' },
	                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.upload.instructions.fileSize' }),
	                _react2['default'].createElement('br', null),
	                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.upload.instructions.fileFormats' })
	            )
	        );
	    },
	    renderEditArea: function renderEditArea() {
	        var _props = this.props,
	            getSignatureUrl = _props.getSignatureUrl,
	            intl = _props.intl,
	            onRotateSignature = _props.onRotateSignature,
	            signature = _props.signature,
	            type = _props.type;
	
	
	        var show = !signature ? { display: 'none' } : {};
	
	        return _react2['default'].createElement(
	            'div',
	            { style: show },
	            _react2['default'].createElement(_signatureEditArea2['default'], {
	                getSignatureUrl: getSignatureUrl,
	                intl: intl,
	                onRotate: onRotateSignature,
	                ref: 'uploadEditArea',
	                signature: signature,
	                type: type
	            })
	        );
	    },
	    render: function render() {
	        var _props2 = this.props,
	            actionBarProps = _props2.actionBarProps,
	            isUploading = _props2.isUploading;
	
	
	        var spinner;
	
	        var inputClasses = {
	            'm-sign-modal--tabs--upload--input': true
	        };
	        var classes = {
	            'm-sign-modal--tabs--upload': true
	        };
	        var containerClasses = {
	            'm-sign-modal--tabs--tab': true,
	            'is-selected': this.props.isSelected
	        };
	
	        containerClasses[_constants2['default'].TAB_UPLOAD] = true;
	
	        if (isUploading) {
	            spinner = _react2['default'].createElement('img', { src: __webpack_require__(811), className: 'm-sign-modal--tabs--upload--output--spinner' });
	        }
	
	        return _react2['default'].createElement(
	            'div',
	            { className: (0, _classnames2['default'])(containerClasses), ref: 'uploadTab' },
	            _react2['default'].createElement(
	                'span',
	                { className: 'm-sign-modal--tabs--tab-title' },
	                _react2['default'].createElement(_reactIntl.FormattedMessage, {
	                    id: 'signModal.upload.title',
	                    values: { type: this.props.type }
	                })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: (0, _classnames2['default'])(classes) },
	                _react2['default'].createElement(
	                    'div',
	                    { className: (0, _classnames2['default'])(inputClasses) },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-sign-modal--tabs--content', ref: this.props.captureTabContentRef },
	                        this.renderUploadArea(),
	                        spinner,
	                        this.renderEditArea()
	                    )
	                )
	            ),
	            _react2['default'].createElement(_actionBar2['default'], _extends({}, actionBarProps, {
	                disableButtons: !this.props.signature,
	                onInsert: this.insertSignature,
	                values: { type: this.props.type }
	            }))
	        );
	    }
	});
	
	module.exports = UploadTab;

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(304));
		else if(typeof define === 'function' && define.amd)
			define(["react"], factory);
		else if(typeof exports === 'object')
			exports["Dropzone"] = factory(require("react"));
		else
			root["Dropzone"] = factory(root["react"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_2__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
		
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
		
		var _attrAccept = __webpack_require__(1);
		
		var _attrAccept2 = _interopRequireDefault(_attrAccept);
		
		var _react = __webpack_require__(2);
		
		var _react2 = _interopRequireDefault(_react);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint prefer-template: 0 */
		
		var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;
		
		var Dropzone = function (_React$Component) {
		  _inherits(Dropzone, _React$Component);
		
		  function Dropzone(props, context) {
		    _classCallCheck(this, Dropzone);
		
		    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Dropzone).call(this, props, context));
		
		    _this.onClick = _this.onClick.bind(_this);
		    _this.onDragStart = _this.onDragStart.bind(_this);
		    _this.onDragEnter = _this.onDragEnter.bind(_this);
		    _this.onDragLeave = _this.onDragLeave.bind(_this);
		    _this.onDragOver = _this.onDragOver.bind(_this);
		    _this.onDrop = _this.onDrop.bind(_this);
		
		    _this.state = {
		      isDragActive: false
		    };
		    return _this;
		  }
		
		  _createClass(Dropzone, [{
		    key: 'componentDidMount',
		    value: function componentDidMount() {
		      this.enterCounter = 0;
		    }
		  }, {
		    key: 'onDragStart',
		    value: function onDragStart(e) {
		      if (this.props.onDragStart) {
		        this.props.onDragStart.call(this, e);
		      }
		    }
		  }, {
		    key: 'onDragEnter',
		    value: function onDragEnter(e) {
		      e.preventDefault();
		
		      // Count the dropzone and any children that are entered.
		      ++this.enterCounter;
		
		      // This is tricky. During the drag even the dataTransfer.files is null
		      // But Chrome implements some drag store, which is accesible via dataTransfer.items
		      var dataTransferItems = e.dataTransfer && e.dataTransfer.items ? e.dataTransfer.items : [];
		
		      // Now we need to convert the DataTransferList to Array
		      var allFilesAccepted = this.allFilesAccepted(Array.prototype.slice.call(dataTransferItems));
		
		      this.setState({
		        isDragActive: allFilesAccepted,
		        isDragReject: !allFilesAccepted
		      });
		
		      if (this.props.onDragEnter) {
		        this.props.onDragEnter.call(this, e);
		      }
		    }
		  }, {
		    key: 'onDragOver',
		    value: function onDragOver(e) {
		      e.preventDefault();
		      e.stopPropagation();
		      return false;
		    }
		  }, {
		    key: 'onDragLeave',
		    value: function onDragLeave(e) {
		      e.preventDefault();
		
		      // Only deactivate once the dropzone and all children was left.
		      if (--this.enterCounter > 0) {
		        return;
		      }
		
		      this.setState({
		        isDragActive: false,
		        isDragReject: false
		      });
		
		      if (this.props.onDragLeave) {
		        this.props.onDragLeave.call(this, e);
		      }
		    }
		  }, {
		    key: 'onDrop',
		    value: function onDrop(e) {
		      e.preventDefault();
		
		      // Reset the counter along with the drag on a drop.
		      this.enterCounter = 0;
		
		      this.setState({
		        isDragActive: false,
		        isDragReject: false
		      });
		
		      var droppedFiles = e.dataTransfer ? e.dataTransfer.files : e.target.files;
		      var max = this.props.multiple ? droppedFiles.length : Math.min(droppedFiles.length, 1);
		      var files = [];
		
		      for (var i = 0; i < max; i++) {
		        var file = droppedFiles[i];
		        // We might want to disable the preview creation to support big files
		        if (!this.props.disablePreview) {
		          file.preview = window.URL.createObjectURL(file);
		        }
		        files.push(file);
		      }
		
		      if (this.allFilesAccepted(files)) {
		        if (this.props.onDrop) {
		          this.props.onDrop.call(this, files, e);
		        }
		
		        if (this.props.onDropAccepted) {
		          this.props.onDropAccepted.call(this, files, e);
		        }
		      } else {
		        if (this.props.onDropRejected) {
		          this.props.onDropRejected.call(this, files, e);
		        }
		      }
		    }
		  }, {
		    key: 'onClick',
		    value: function onClick() {
		      if (!this.props.disableClick) {
		        this.open();
		      }
		    }
		  }, {
		    key: 'allFilesAccepted',
		    value: function allFilesAccepted(files) {
		      var _this2 = this;
		
		      return files.every(function (file) {
		        return (0, _attrAccept2.default)(file, _this2.props.accept);
		      });
		    }
		  }, {
		    key: 'open',
		    value: function open() {
		      this.fileInputEl.value = null;
		      this.fileInputEl.click();
		    }
		  }, {
		    key: 'render',
		    value: function render() {
		      var _this3 = this;
		
		      var _props = this.props;
		      var accept = _props.accept;
		      var activeClassName = _props.activeClassName;
		      var inputProps = _props.inputProps;
		      var multiple = _props.multiple;
		      var name = _props.name;
		      var rejectClassName = _props.rejectClassName;
		
		      var rest = _objectWithoutProperties(_props, ['accept', 'activeClassName', 'inputProps', 'multiple', 'name', 'rejectClassName']);
		
		      var activeStyle = rest.activeStyle;
		      var className = rest.className;
		      var rejectStyle = rest.rejectStyle;
		      var style = rest.style;
		
		      var props = _objectWithoutProperties(rest, ['activeStyle', 'className', 'rejectStyle', 'style']);
		
		      var _state = this.state;
		      var isDragActive = _state.isDragActive;
		      var isDragReject = _state.isDragReject;
		
		
		      className = className || '';
		
		      if (isDragActive && activeClassName) {
		        className += ' ' + activeClassName;
		      }
		      if (isDragReject && rejectClassName) {
		        className += ' ' + rejectClassName;
		      }
		
		      if (!className && !style && !activeStyle && !rejectStyle) {
		        style = {
		          width: 200,
		          height: 200,
		          borderWidth: 2,
		          borderColor: '#666',
		          borderStyle: 'dashed',
		          borderRadius: 5
		        };
		        activeStyle = {
		          borderStyle: 'solid',
		          backgroundColor: '#eee'
		        };
		        rejectStyle = {
		          borderStyle: 'solid',
		          backgroundColor: '#ffdddd'
		        };
		      }
		
		      var appliedStyle = void 0;
		      if (activeStyle && isDragActive) {
		        appliedStyle = _extends({}, style, activeStyle);
		      } else if (rejectStyle && isDragReject) {
		        appliedStyle = _extends({}, style, rejectStyle);
		      } else {
		        appliedStyle = _extends({}, style);
		      }
		
		      var inputAttributes = {
		        accept: accept,
		        type: 'file',
		        style: { display: 'none' },
		        multiple: supportMultiple && multiple,
		        ref: function ref(el) {
		          return _this3.fileInputEl = el;
		        }, // eslint-disable-line
		        onChange: this.onDrop
		      };
		
		      if (name && name.length) {
		        inputAttributes.name = name;
		      }
		
		      // Remove custom properties before passing them to the wrapper div element
		      var customProps = ['disablePreview', 'disableClick', 'onDropAccepted', 'onDropRejected'];
		      var divProps = _extends({}, props);
		      customProps.forEach(function (prop) {
		        return delete divProps[prop];
		      });
		
		      return _react2.default.createElement(
		        'div',
		        _extends({
		          className: className,
		          style: appliedStyle
		        }, divProps /* expand user provided props first so event handlers are never overridden */, {
		          onClick: this.onClick,
		          onDragStart: this.onDragStart,
		          onDragEnter: this.onDragEnter,
		          onDragOver: this.onDragOver,
		          onDragLeave: this.onDragLeave,
		          onDrop: this.onDrop
		        }),
		        this.props.children,
		        _react2.default.createElement('input', _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */, inputAttributes))
		      );
		    }
		  }]);
		
		  return Dropzone;
		}(_react2.default.Component);
		
		Dropzone.defaultProps = {
		  disablePreview: false,
		  disableClick: false,
		  multiple: true
		};
		
		Dropzone.propTypes = {
		  // Overriding drop behavior
		  onDrop: _react2.default.PropTypes.func,
		  onDropAccepted: _react2.default.PropTypes.func,
		  onDropRejected: _react2.default.PropTypes.func,
		
		  // Overriding drag behavior
		  onDragStart: _react2.default.PropTypes.func,
		  onDragEnter: _react2.default.PropTypes.func,
		  onDragLeave: _react2.default.PropTypes.func,
		
		  children: _react2.default.PropTypes.node, // Contents of the dropzone
		  style: _react2.default.PropTypes.object, // CSS styles to apply
		  activeStyle: _react2.default.PropTypes.object, // CSS styles to apply when drop will be accepted
		  rejectStyle: _react2.default.PropTypes.object, // CSS styles to apply when drop will be rejected
		  className: _react2.default.PropTypes.string, // Optional className
		  activeClassName: _react2.default.PropTypes.string, // className for accepted state
		  rejectClassName: _react2.default.PropTypes.string, // className for rejected state
		
		  disablePreview: _react2.default.PropTypes.bool, // Enable/disable preview generation
		  disableClick: _react2.default.PropTypes.bool, // Disallow clicking on the dropzone container to open file dialog
		
		  inputProps: _react2.default.PropTypes.object, // Pass additional attributes to the <input type="file"/> tag
		  multiple: _react2.default.PropTypes.bool, // Allow dropping multiple files
		  accept: _react2.default.PropTypes.string, // Allow specific types of files. See https://github.com/okonet/attr-accept for more information
		  name: _react2.default.PropTypes.string // name attribute for the input tag
		};
		
		exports.default = Dropzone;
		module.exports = exports['default'];
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={exports:{},id:e,loaded:!1};return t[e].call(o.exports,o,o.exports,n),o.loaded=!0,o.exports}var r={};return n.m=t,n.c=r,n.p="",n(0)}([function(t,n,r){"use strict";n.__esModule=!0,r(8),r(9),n["default"]=function(t,n){if(t&&n){var r=function(){var r=n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return{v:r.some(function(t){var n=t.trim();return"."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):/\/\*$/.test(n)?i===n.replace(/\/.*$/,""):o===n})}}();if("object"==typeof r)return r.v}return!0},t.exports=n["default"]},function(t,n){var r=t.exports={version:"1.2.2"};"number"==typeof __e&&(__e=r)},function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,n,r){var e=r(2),o=r(1),i=r(4),u=r(19),c="prototype",f=function(t,n){return function(){return t.apply(n,arguments)}},s=function(t,n,r){var a,p,l,d,y=t&s.G,h=t&s.P,v=y?e:t&s.S?e[n]||(e[n]={}):(e[n]||{})[c],x=y?o:o[n]||(o[n]={});y&&(r=n);for(a in r)p=!(t&s.F)&&v&&a in v,l=(p?v:r)[a],d=t&s.B&&p?f(l,e):h&&"function"==typeof l?f(Function.call,l):l,v&&!p&&u(v,a,l),x[a]!=l&&i(x,a,d),h&&((x[c]||(x[c]={}))[a]=l)};e.core=o,s.F=1,s.G=2,s.S=4,s.P=8,s.B=16,s.W=32,t.exports=s},function(t,n,r){var e=r(5),o=r(18);t.exports=r(22)?function(t,n,r){return e.setDesc(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){var r=Object;t.exports={create:r.create,getProto:r.getPrototypeOf,isEnum:{}.propertyIsEnumerable,getDesc:r.getOwnPropertyDescriptor,setDesc:r.defineProperty,setDescs:r.defineProperties,getKeys:r.keys,getNames:r.getOwnPropertyNames,getSymbols:r.getOwnPropertySymbols,each:[].forEach}},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))}},function(t,n,r){var e=r(20)("wks"),o=r(2).Symbol;t.exports=function(t){return e[t]||(e[t]=o&&o[t]||(o||r(6))("Symbol."+t))}},function(t,n,r){r(26),t.exports=r(1).Array.some},function(t,n,r){r(25),t.exports=r(1).String.endsWith},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,n,r){var e=r(10);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,r){t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(e){try{return n[r(7)("match")]=!1,!"/./"[t](n)}catch(o){}}return!0}},function(t,n){t.exports=function(t){try{return!!t()}catch(n){return!0}}},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n,r){var e=r(16),o=r(11),i=r(7)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(2),o=r(4),i=r(6)("src"),u="toString",c=Function[u],f=(""+c).split(u);r(1).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,u){"function"==typeof r&&(o(r,i,t[n]?""+t[n]:f.join(String(n))),"name"in r||(r.name=n)),t===e?t[n]=r:(u||delete t[n],o(t,n,r))})(Function.prototype,u,function(){return"function"==typeof this&&this[i]||c.call(this)})},function(t,n,r){var e=r(2),o="__core-js_shared__",i=e[o]||(e[o]={});t.exports=function(t){return i[t]||(i[t]={})}},function(t,n,r){var e=r(17),o=r(13);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))}},function(t,n,r){t.exports=!r(15)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)}},function(t,n,r){var e=r(23),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){"use strict";var e=r(3),o=r(24),i=r(21),u="endsWith",c=""[u];e(e.P+e.F*r(14)(u),"String",{endsWith:function(t){var n=i(this,t,u),r=arguments,e=r.length>1?r[1]:void 0,f=o(n.length),s=void 0===e?f:Math.min(o(e),f),a=String(t);return c?c.call(n,a,s):n.slice(s-a.length,s)===a}})},function(t,n,r){var e=r(5),o=r(3),i=r(1).Array||Array,u={},c=function(t,n){e.each.call(t.split(","),function(t){void 0==n&&t in i?u[t]=i[t]:t in[]&&(u[t]=r(12)(Function.call,[][t],n))})};c("pop,reverse,shift,keys,values,entries",1),c("indexOf,every,some,forEach,map,filter,find,findIndex,includes",3),c("join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill"),o(o.S,"Array",u)}]);
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
	
	/***/ }
	/******/ ])
	});
	;
	//# sourceMappingURL=index.js.map

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/c910c94c874682ea3433eceb29a4494f.png";

/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/d638b5962cd1f15e843b40ad0aef944e.png";

/***/ },
/* 816 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 817 */,
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _omit = __webpack_require__(819);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Logo = _react2['default'].createClass({
	    displayName: 'Logo',
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            { className: 'm-app-topbar--logo' },
	            _react2['default'].createElement(
	                'a',
	                { href: this.props.href },
	                _react2['default'].createElement('img', (0, _omit2['default'])(this.props, ['app']))
	            )
	        );
	    }
	});
	
	module.exports = Logo;

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(356),
	    baseDifference = __webpack_require__(820),
	    baseFlatten = __webpack_require__(335),
	    bindCallback = __webpack_require__(376),
	    keysIn = __webpack_require__(353),
	    pickByArray = __webpack_require__(408),
	    pickByCallback = __webpack_require__(409),
	    restParam = __webpack_require__(411);
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable properties of `object` that are not omitted.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function|...(string|string[])} [predicate] The function invoked per
	 *  iteration or property names to omit, specified as individual property
	 *  names or arrays of property names.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'user': 'fred', 'age': 40 };
	 *
	 * _.omit(object, 'age');
	 * // => { 'user': 'fred' }
	 *
	 * _.omit(object, _.isNumber);
	 * // => { 'user': 'fred' }
	 */
	var omit = restParam(function(object, props) {
	  if (object == null) {
	    return {};
	  }
	  if (typeof props[0] != 'function') {
	    var props = arrayMap(baseFlatten(props), String);
	    return pickByArray(object, baseDifference(keysIn(object), props));
	  }
	  var predicate = bindCallback(props[0], props[1], 3);
	  return pickByCallback(object, function(value, key, object) {
	    return !predicate(value, key, object);
	  });
	});
	
	module.exports = omit;


/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(821),
	    cacheIndexOf = __webpack_require__(823),
	    createCache = __webpack_require__(824);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.difference` which accepts a single array
	 * of values to exclude.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values) {
	  var length = array ? array.length : 0,
	      result = [];
	
	  if (!length) {
	    return result;
	  }
	  var index = -1,
	      indexOf = baseIndexOf,
	      isCommon = true,
	      cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
	      valuesLength = values.length;
	
	  if (cache) {
	    indexOf = cacheIndexOf;
	    isCommon = false;
	    values = cache;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index];
	
	    if (isCommon && value === value) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === value) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (indexOf(values, value, 0) < 0) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	var indexOfNaN = __webpack_require__(822);
	
	/**
	 * The base implementation of `_.indexOf` without support for binary searches.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return indexOfNaN(array, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 822 */
/***/ function(module, exports) {

	/**
	 * Gets the index at which the first occurrence of `NaN` is found in `array`.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	 */
	function indexOfNaN(array, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 0 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    var other = array[index];
	    if (other !== other) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = indexOfNaN;


/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(347);
	
	/**
	 * Checks if `value` is in `cache` mimicking the return signature of
	 * `_.indexOf` by returning `0` if the value is found, else `-1`.
	 *
	 * @private
	 * @param {Object} cache The cache to search.
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `0` if `value` is found, else `-1`.
	 */
	function cacheIndexOf(cache, value) {
	  var data = cache.data,
	      result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
	
	  return result ? 0 : -1;
	}
	
	module.exports = cacheIndexOf;


/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var SetCache = __webpack_require__(825),
	    getNative = __webpack_require__(344);
	
	/** Native method references. */
	var Set = getNative(global, 'Set');
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeCreate = getNative(Object, 'create');
	
	/**
	 * Creates a `Set` cache object to optimize linear searches of large arrays.
	 *
	 * @private
	 * @param {Array} [values] The values to cache.
	 * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	 */
	function createCache(values) {
	  return (nativeCreate && Set) ? new SetCache(values) : null;
	}
	
	module.exports = createCache;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var cachePush = __webpack_require__(826),
	    getNative = __webpack_require__(344);
	
	/** Native method references. */
	var Set = getNative(global, 'Set');
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeCreate = getNative(Object, 'create');
	
	/**
	 *
	 * Creates a cache object to store unique values.
	 *
	 * @private
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var length = values ? values.length : 0;
	
	  this.data = { 'hash': nativeCreate(null), 'set': new Set };
	  while (length--) {
	    this.push(values[length]);
	  }
	}
	
	// Add functions to the `Set` cache.
	SetCache.prototype.push = cachePush;
	
	module.exports = SetCache;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(347);
	
	/**
	 * Adds `value` to the cache.
	 *
	 * @private
	 * @name push
	 * @memberOf SetCache
	 * @param {*} value The value to cache.
	 */
	function cachePush(value) {
	  var data = this.data;
	  if (typeof value == 'string' || isObject(value)) {
	    data.set.add(value);
	  } else {
	    data.hash[value] = true;
	  }
	}
	
	module.exports = cachePush;


/***/ },
/* 827 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 828 */,
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/bc35899cc10d4f1cfd3d1ec162ef121f.png";

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/7d7aff31d75f2f5977a407231bab6062.svg";

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/4673609434d99102b569566f4b7c4be9.svg";

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/48bd7cfac26b69463eca574486bdb97c.png";

/***/ },
/* 833 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAMCAMAAABYzB2OAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAANlBMVEUAAABOT09OT09OT09OT09OT09OT09OT09OT09OT09OT09OT09OT09OT09OT09OT09OT08AAABMAGakAAAAEHRSTlMAXu/rU/pOY2n3Qm72eHuIdBVsHQAAAAFiS0dEAIgFHUgAAAAJcEhZcwAACxIAAAsSAdLdfvwAAABaSURBVAjXXc1LDsAgCATQEf9YlfuftqLRtLKZySMBGLIOZ5wlAxLxYUvwIqR0TGVQlGNTJAJJMzPAWVvSZdH2MD+aZZ2o06bU/WjaT4C2pOEzXaUDl10y7MgLjlsFh8ZPamgAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTQtMTEtMThUMTY6Mzg6NTUtMDg6MDDeAtGyAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE0LTExLTE4VDE2OjM4OjU1LTA4OjAwr19pDgAAAABJRU5ErkJggg=="

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _watchAppNotifier = __webpack_require__(835);
	
	var _watchAppNotifier2 = _interopRequireDefault(_watchAppNotifier);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// In-app left side menu
	var AppLeftMenu = _react2['default'].createClass({
	    displayName: 'AppLeftMenu',
	
	
	    mixins: [_watchAppNotifier2['default']],
	
	    propTypes: {
	        'siteCode': _react2['default'].PropTypes.string.isRequired, // S or F
	        'pageSize': _react2['default'].PropTypes.number, // List size
	        'searchBackend': _react2['default'].PropTypes.string, // Type of search backend to use
	        'activeItemId': _react2['default'].PropTypes.string, // Menu item currently active
	        'hasTeamFilter': _react2['default'].PropTypes.bool, // Whether the user can view all team docs
	        'hasCompletedFilter': _react2['default'].PropTypes.bool, // Whether the completed filter is visible currently
	        'emailAddress': _react2['default'].PropTypes.string.isRequired, // Email address for the current user
	        'faxNumbers': _react2['default'].PropTypes.array, // List of fax numbers
	        'name': _react2['default'].PropTypes.string // Name of the user
	    },
	
	    FILTERS: {
	        'documentsallteam': 'all_team',
	        'documentsoutforsignature': 'out_for_signature',
	        'documentsawaiting': 'awaiting_my_signature',
	        'documentscompleted': 'completed',
	        'documentsdeclined': 'declined',
	        'documentstemplates': 'template',
	        'documentstemplatelinks': 'template_link',
	        'documentsdrafts': 'draft',
	        'documentssent': 'sent',
	        'documentsreceived': 'received'
	    },
	
	    getInitialState: function getInitialState() {
	
	        var isHf = _hfReactHelper2['default'].HfSites.isHelloFax(this.props.siteCode);
	        var defaultItemId = isHf ? 'sendfax' : 'signdocs';
	        var activeItemId = this.props.activeItemId || defaultItemId;
	
	        // Convert filters to section item ref
	        for (var k in this.FILTERS) {
	            if (this.FILTERS[k] === activeItemId) {
	                activeItemId = k;
	                break;
	            }
	        }
	
	        return {
	            'activeItemId': activeItemId,
	            faxLines: this.props.app.user.getFaxLines()
	        };
	    },
	    componentDidMount: function componentDidMount() {
	
	        var root = $(_reactDom2['default'].findDOMNode(this));
	        var self = this;
	
	        $('.m-app-leftmenu--section--title > a, .m-app-leftmenu--section--item > a', root).click(function (evt) {
	
	            if (evt.target.tagName === 'A' || evt.target.parentNode.tagName === 'A') {
	                return;
	            }
	
	            evt.preventDefault();
	
	            var el = $(this);
	            var itemId = el.attr('id');
	
	            if (!itemId) {
	                itemId = el.parent().attr('id');
	            }
	
	            self.setState({
	                'activeItemId': itemId
	            });
	        });
	    },
	    getItemClassName: function getItemClassName(sectionName, isItem) {
	        var s = 'm-app-leftmenu--section' + (isItem ? '--item' : '');
	        if (sectionName === 'signdocs' && $.inArray(this.state.activeItemId, ['signjustme', 'signmeandothers', 'signjustothers']) >= 0 || sectionName === 'templates' && $.inArray(this.state.activeItemId, ['createtemplate', 'createtemplatelink', 'usetemplate', 'usetemplatelink']) >= 0 || sectionName === 'documents' && $.inArray(this.state.activeItemId, Object.keys(this.FILTERS)) >= 0) {
	            s += ' is-expanded';
	        } else if (this.state.activeItemId === sectionName) {
	            s += ' is-active';
	        }
	        return s;
	    },
	    makeFilter: function makeFilter(id, label, noDot) {
	
	        var params = ['filter=' + this.FILTERS[id]];
	        if (this.props.searchBackend) {
	            params.push('search_backend=' + this.props.searchBackend);
	        }
	        if (this.props.pageSize) {
	            params.push('page_size=' + this.props.pageSize);
	        }
	
	        var site = _hfReactHelper2['default'].HfSites.getSite(this.props.siteCode);
	        var url = _hfReactHelper2['default'].urlHelper('home/manage?' + params.join('&'), site);
	
	        var dotImg;
	        if (noDot !== true) {
	            dotImg = _react2['default'].createElement('img', { src: _hfReactHelper2['default'].imgHelper('v2/layout/filters/' + id.replace('documents', '') + '@2x.png') });
	        }
	
	        return _react2['default'].createElement(
	            'div',
	            { id: id, className: this.getItemClassName(id, true) },
	            _react2['default'].createElement(
	                'span',
	                { className: 'm-app-leftmenu--section--item--dot' + (noDot === true ? ' is-blank' : '') },
	                dotImg
	            ),
	            _react2['default'].createElement(
	                'a',
	                { href: url },
	                label
	            )
	        );
	    },
	    render: function render() {
	
	        var isHf = _hfReactHelper2['default'].HfSites.isHelloFax(this.props.siteCode);
	        var templates;
	        var sendFax;
	        var recvFax;
	        var getFreePages;
	        var signDocs;
	        var allTeamDocsFilter;
	        var completedFilter;
	        var faxNumbers;
	        var siteSpecificFilters;
	
	        var meAndOthersParams = 'me=1';
	
	        var site = _hfReactHelper2['default'].HfSites.getSite(this.props.siteCode);
	        var teamUrl = _hfReactHelper2['default'].urlHelper('home/team', site);
	        var createTemplateUrl = _hfReactHelper2['default'].urlHelper('home/createTemplate', site);
	        var createLinkUrl = _hfReactHelper2['default'].urlHelper('home/createReusableLink', site);
	        var sendFaxUrl = _hfReactHelper2['default'].urlHelper('home/index', site);
	        var recvFaxUrl = _hfReactHelper2['default'].urlHelper('home/upgrade', site);
	        var freePagesUrl = _hfReactHelper2['default'].urlHelper('account/gettingStarted', site);
	        var useTemplateUrl = _hfReactHelper2['default'].urlHelper('home/manage?filter=template', site);
	        var useLinkUrl = _hfReactHelper2['default'].urlHelper('home/manage?filter=template_link', site);
	        var justMeUrl = _hfReactHelper2['default'].urlHelper('sign', site);
	        var meAndOthersUrl = _hfReactHelper2['default'].urlHelper('home/request?' + meAndOthersParams, site);
	        var justOthersUrl = _hfReactHelper2['default'].urlHelper('home/request', site);
	        var signUrl = _hfReactHelper2['default'].urlHelper('home/index', site);
	        var templateUrl = _hfReactHelper2['default'].urlHelper('home/createReusableDocs', site);
	        var docsUrl = _hfReactHelper2['default'].urlHelper('home/manage', site);
	        var integrationsUrl = _hfReactHelper2['default'].urlHelper('home/myAccount?current_tab=integrations', site);
	        var documentsName = 'Documents';
	
	        if (isHf) {
	
	            documentsName = 'Faxes';
	
	            sendFax = _react2['default'].createElement(
	                'div',
	                { id: 'sendfax', className: this.getItemClassName('sendfax') },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-app-leftmenu--section--title' },
	                    _react2['default'].createElement(
	                        'a',
	                        { href: sendFaxUrl },
	                        _react2['default'].createElement(
	                            'span',
	                            null,
	                            'Send a fax'
	                        )
	                    )
	                )
	            );
	
	            if (this.props.showUpgradeButton == true) {
	                recvFax = _react2['default'].createElement(
	                    'div',
	                    { id: 'recvfax', className: this.getItemClassName('recvfax') },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-app-leftmenu--section--title' },
	                        _react2['default'].createElement(
	                            'a',
	                            { href: recvFaxUrl },
	                            _react2['default'].createElement(
	                                'span',
	                                null,
	                                'Receive faxes'
	                            )
	                        )
	                    )
	                );
	            } else {
	                recvFax = '';
	            }
	
	            signDocs = _react2['default'].createElement(
	                'div',
	                { id: 'signdocs', className: this.getItemClassName('signdocs') },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-app-leftmenu--section--title' },
	                    _react2['default'].createElement(
	                        'a',
	                        { href: justOthersUrl },
	                        _react2['default'].createElement(
	                            'span',
	                            null,
	                            'Sign documents'
	                        )
	                    )
	                )
	            );
	
	            getFreePages = _react2['default'].createElement(
	                'div',
	                { id: 'getfreepages', className: 'l-margin-t-50 ' + this.getItemClassName('getfreepages') },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-app-leftmenu--section--title' },
	                    _react2['default'].createElement(
	                        'a',
	                        { href: freePagesUrl },
	                        _react2['default'].createElement(
	                            'span',
	                            null,
	                            'Get free pages'
	                        )
	                    )
	                )
	            );
	            if (this.props.hasTeamFilter) {
	                allTeamDocsFilter = this.makeFilter('documentsallteam', 'All team faxes');
	            }
	            siteSpecificFilters = _react2['default'].createElement(
	                'div',
	                { className: 'm-app-leftmenu--section--items' },
	                allTeamDocsFilter,
	                this.makeFilter('documentssent', 'Sent'),
	                this.makeFilter('documentsreceived', 'Received'),
	                this.makeFilter('documentsdrafts', 'Drafts')
	            );
	
	            if (this.state.faxLines && this.state.faxLines.length > 0) {
	
	                var numbers = this.state.faxLines.map(function (faxLine, index) {
	                    return _react2['default'].createElement(
	                        'div',
	                        { key: index, className: 'm-app-leftmenu--fax-numbers--list--item' },
	                        faxLine.number
	                    );
	                });
	
	                var listClasses = (0, _classnames2['default'])({
	                    'm-app-leftmenu--fax-numbers--list': true,
	                    'is-scrollable': this.state.faxLines.length > 12
	                });
	
	                faxNumbers = _react2['default'].createElement(
	                    'div',
	                    { className: 'm-app-leftmenu--fax-numbers' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-app-leftmenu--fax-numbers--title' },
	                        this.state.faxLines.length > 1 ? 'YOUR FAX NUMBERS' : 'YOUR FAX NUMBER'
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: listClasses },
	                        numbers
	                    )
	                );
	            }
	        } else {
	
	            signDocs = _react2['default'].createElement(
	                'div',
	                { id: 'signdocs', className: this.getItemClassName('signdocs') },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-app-leftmenu--section--title' },
	                    _react2['default'].createElement(
	                        'a',
	                        { href: signUrl },
	                        _react2['default'].createElement(
	                            'span',
	                            null,
	                            'Sign documents'
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-app-leftmenu--section--items' },
	                    _react2['default'].createElement(
	                        'div',
	                        { id: 'signjustme', className: this.getItemClassName('signjustme', true) },
	                        _react2['default'].createElement(
	                            'a',
	                            { href: justMeUrl },
	                            'Just me'
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { id: 'signmeandothers', className: this.getItemClassName('signmeandothers', true) },
	                        _react2['default'].createElement(
	                            'a',
	                            { href: meAndOthersUrl },
	                            'Me & others'
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { id: 'signjustothers', className: this.getItemClassName('signjustothers', true) },
	                        _react2['default'].createElement(
	                            'a',
	                            { href: justOthersUrl },
	                            'Just others'
	                        )
	                    )
	                )
	            );
	
	            templates = _react2['default'].createElement(
	                'div',
	                { id: 'templates', className: this.getItemClassName('templates') },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-app-leftmenu--section--title m-app-leftmenu--templates' },
	                    _react2['default'].createElement(
	                        'a',
	                        { href: templateUrl },
	                        _react2['default'].createElement(
	                            'span',
	                            null,
	                            'Templates'
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-app-leftmenu--section--items' },
	                    _react2['default'].createElement(
	                        'div',
	                        { id: 'createtemplate', className: this.getItemClassName('createtemplate', true) },
	                        _react2['default'].createElement(
	                            'a',
	                            { href: createTemplateUrl },
	                            'Create template'
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { id: 'createtemplatelink', className: this.getItemClassName('createtemplatelink', true) },
	                        _react2['default'].createElement(
	                            'a',
	                            { href: createLinkUrl },
	                            'Create link'
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { id: 'usetemplate', className: this.getItemClassName('usetemplate', true) },
	                        _react2['default'].createElement(
	                            'a',
	                            { href: useTemplateUrl },
	                            'Use template'
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { id: 'usetemplatelink', className: this.getItemClassName('usetemplatelink', true) },
	                        _react2['default'].createElement(
	                            'a',
	                            { href: useLinkUrl },
	                            'Use link'
	                        )
	                    )
	                )
	            );
	
	            if (this.props.hasTeamFilter) {
	                allTeamDocsFilter = this.makeFilter('documentsallteam', 'All team documents');
	            }
	            if (this.props.hasCompletedFilter) {
	                completedFilter = this.makeFilter('documentscompleted', 'Completed');
	            }
	            siteSpecificFilters = _react2['default'].createElement(
	                'div',
	                { className: 'm-app-leftmenu--section--items' },
	                allTeamDocsFilter,
	                this.makeFilter('documentsoutforsignature', 'Out for signature'),
	                this.makeFilter('documentsawaiting', 'Awaiting my signature'),
	                completedFilter,
	                this.makeFilter('documentsdeclined', 'Declined'),
	                this.makeFilter('documentstemplates', 'Templates'),
	                this.makeFilter('documentstemplatelinks', 'Template links'),
	                this.makeFilter('documentsdrafts', 'Draft')
	            );
	        }
	
	        var res = _react2['default'].createElement(
	            'div',
	            { className: 'm-app-leftmenu' },
	            sendFax,
	            recvFax,
	            signDocs,
	            templates,
	            _react2['default'].createElement(
	                'div',
	                { id: 'documents', className: this.getItemClassName('documents') },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-app-leftmenu--section--title m-app-leftmenu--documents' },
	                    _react2['default'].createElement(
	                        'a',
	                        { href: docsUrl },
	                        _react2['default'].createElement(
	                            'span',
	                            null,
	                            documentsName
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-app-leftmenu--section--items' },
	                    siteSpecificFilters
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { id: 'manageteam', className: this.getItemClassName('manageteam') },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-app-leftmenu--section--title m-app-leftmenu--team' },
	                    _react2['default'].createElement(
	                        'a',
	                        { href: teamUrl },
	                        _react2['default'].createElement(
	                            'span',
	                            null,
	                            'Team'
	                        )
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { id: 'manage_integrations', className: this.getItemClassName('manage_integrations') },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-app-leftmenu--section--title m-app-leftmenu--integrations' },
	                    _react2['default'].createElement(
	                        'a',
	                        { href: integrationsUrl },
	                        _react2['default'].createElement(
	                            'span',
	                            null,
	                            'Integrations'
	                        )
	                    )
	                )
	            ),
	            getFreePages,
	            faxNumbers
	        );
	
	        return res;
	    }
	});
	
	module.exports = AppLeftMenu;

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _timers = __webpack_require__(719);
	
	module.exports = {
	    componentDidMount: function componentDidMount() {
	        this.props.app.notifier.push(this);
	    },
	    notify: function notify() {
	        var _this = this;
	
	        clearTimeout(this._updateTimer);
	        this._updateTimer = (0, _timers.setTimeout)(function () {
	            if (_this.isMounted()) {
	                _this.forceUpdate();
	            }
	        }, this.props.app.testMode ? 1 : 100);
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        this.props.app.notifier.remove(this);
	    }
	};

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	var _activator = __webpack_require__(837);
	
	var _activator2 = _interopRequireDefault(_activator);
	
	var _blocks = __webpack_require__(302);
	
	var _tetherToggle = __webpack_require__(773);
	
	var _tetherToggle2 = _interopRequireDefault(_tetherToggle);
	
	__webpack_require__(839);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MenuLink = function MenuLink(props) {
	    return _react2['default'].createElement(_blocks.Box, _extends({
	        className: 'm-app-footer--menu-item',
	        color: 'grey',
	        hoverColor: 'ashen',
	        is: 'a',
	        display: 'block',
	        textAlign: 'left',
	        px: 3,
	        py: 2
	    }, props));
	};
	
	function HelpLink(_ref) {
	    var onActivate = _ref.onActivate;
	
	    return _react2['default'].createElement(
	        _blocks.Box,
	        { p: 3, className: 'm-app-footer--links--link', onClick: onActivate },
	        _react2['default'].createElement(
	            _blocks.Box,
	            { is: 'a', href: 'javascript:;', id: 'footer_help', color: 'grey', hoverColor: 'ashen' },
	            'Help'
	        )
	    );
	}
	
	var ZendeskActivator = (0, _activator2['default'])(HelpLink);
	
	// In-app footer
	var AppFooter = _react2['default'].createClass({
	    displayName: 'AppFooter',
	
	    propTypes: {
	        'siteCode': _react2['default'].PropTypes.string.isRequired // S or F
	    },
	
	    SOCIAL_NAMES: ['linkedin', 'fb', 'twitter'],
	    SOCIAL_URLS: {
	        'twitter': 'https://twitter.com/hellosign',
	        'fb': 'https://www.facebook.com/hellosignapp',
	        'linkedin': 'https://www.linkedin.com/company/hellosign'
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            'showProductMenu': false,
	            'showFinePrintMenu': false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        var root = $(_reactDom2['default'].findDOMNode(this));
	        $('.product-link', root).hover(this.toggleProductMenu);
	        $('.fine-print-link', root).hover(this.toggleFinePrintMenu);
	    },
	    toggleProductMenu: function toggleProductMenu() {
	        var show = !this.state.showProductMenu;
	        this.setState({
	            'showProductMenu': show
	        });
	    },
	    toggleFinePrintMenu: function toggleFinePrintMenu() {
	        var show = !this.state.showFinePrintMenu;
	        this.setState({
	            'showFinePrintMenu': show
	        });
	    },
	    render: function render() {
	        var _props = this.props,
	            className = _props.className,
	            responsive = _props.responsive;
	
	        var cmsSubDomain = 'www';
	        var site = _hfReactHelper2['default'].HfSites.getSite(this.props.siteCode);
	        var isHf = _hfReactHelper2['default'].HfSites.isHelloFax(this.props.siteCode);
	        var pricingUrl = _hfReactHelper2['default'].urlHelper('info/pricing', site);
	        var homeUrl = _hfReactHelper2['default'].urlHelper('home/index', site);
	        var faqUrl = isHf ? 'http://faq.hellosign.com/hc/en-us/categories/200353237-HelloFax-Help' : 'http://faq.hellosign.com';
	        var hfHomeUrl = _hfReactHelper2['default'].urlHelper('home/bridge/to/F', _hfReactHelper2['default'].HfSites.SITE_CODE_HS);
	        var hsHomeUrl = _hfReactHelper2['default'].urlHelper('home/bridge/to/S', _hfReactHelper2['default'].HfSites.SITE_CODE_HF);
	        var bridgeUrl = isHf ? hsHomeUrl : hfHomeUrl;
	
	        var socialImageUrls = {
	            twitter: __webpack_require__(841),
	            fb: __webpack_require__(842),
	            linkedin: __webpack_require__(843)
	        };
	
	        // Social links
	        var name;
	        var social = [];
	        for (var i in this.SOCIAL_NAMES) {
	            name = this.SOCIAL_NAMES[i];
	            social.push(_react2['default'].createElement(
	                _blocks.Box,
	                { px: [3, 0], py: 3, ml: [0, 1], key: 'social-' + i, className: 'm-app-footer--social--icon' },
	                _react2['default'].createElement(
	                    _blocks.Box,
	                    { is: 'a', href: this.SOCIAL_URLS[name], target: '_blank', rel: 'noopener noreferrer', display: 'block' },
	                    _react2['default'].createElement(_blocks.Box, { is: 'img', verticalAlign: 'middle', className: 'm-app-footer--social--icon--img', src: socialImageUrls[name] })
	                )
	            ));
	        }
	
	        // Product menu
	        var items = [isHf ? undefined : _react2['default'].createElement(
	            MenuLink,
	            { key: 0, href: _hfReactHelper2['default'].urlHelper('api', site, cmsSubDomain) },
	            'API'
	        ), isHf ? undefined : _react2['default'].createElement(
	            MenuLink,
	            { key: 1, href: _hfReactHelper2['default'].urlHelper('gmail', site, cmsSubDomain) },
	            'Gmail'
	        ), _react2['default'].createElement(
	            MenuLink,
	            { key: 2, href: _hfReactHelper2['default'].urlHelper('googledocs', site, cmsSubDomain) },
	            'Google Docs'
	        ), _react2['default'].createElement(
	            MenuLink,
	            { key: 3, href: _hfReactHelper2['default'].urlHelper('googledrive', site, cmsSubDomain) },
	            'Google Drive'
	        ), isHf ? undefined : _react2['default'].createElement(
	            MenuLink,
	            { key: 4, href: _hfReactHelper2['default'].urlHelper('info/mobile', site, cmsSubDomain) },
	            'Mobile'
	        ), _react2['default'].createElement(
	            MenuLink,
	            { key: 5, href: bridgeUrl, target: '_blank', rel: 'noopener noreferrer' },
	            'Hello' + (isHf ? 'Sign' : 'Fax')
	        )];
	
	        // Fine print menu
	        var finePrintItems = [_react2['default'].createElement(
	            MenuLink,
	            { key: 0, href: _hfReactHelper2['default'].urlHelper('info/security', site, cmsSubDomain) },
	            'Security'
	        ), _react2['default'].createElement(
	            MenuLink,
	            { key: 1, href: _hfReactHelper2['default'].urlHelper('info/legal', site, cmsSubDomain) },
	            'Legal'
	        ), _react2['default'].createElement(
	            MenuLink,
	            { key: 2, href: _hfReactHelper2['default'].urlHelper('info/privacyPolicy', site, cmsSubDomain) },
	            'Privacy'
	        ), _react2['default'].createElement(
	            MenuLink,
	            { key: 3, href: _hfReactHelper2['default'].urlHelper('info/tos', site, cmsSubDomain) },
	            'Terms'
	        )];
	
	        return _react2['default'].createElement(
	            _blocks.Flex,
	            {
	                className: className,
	                flexDirection: responsive ? ['column', 'row'] : 'row',
	                justifyContent: responsive ? [null, 'space-between'] : 'space-between',
	                borderTop: 1,
	                marginBottom: 3,
	                borderColor: 'warm-chinchilla' },
	            _react2['default'].createElement(
	                _blocks.Flex,
	                {
	                    textAlign: responsive ? ['center', 'left'] : 'center',
	                    flexDirection: responsive ? ['column', 'row'] : 'row',
	                    alignItems: 'center' },
	                _react2['default'].createElement(
	                    _blocks.Box,
	                    {
	                        px: responsive ? [3, 0] : 0,
	                        py: responsive ? [3, 0] : 0,
	                        className: 'm-app-footer--logo' },
	                    _react2['default'].createElement(
	                        _blocks.Box,
	                        { is: 'a', href: homeUrl, display: 'block' },
	                        _react2['default'].createElement(_blocks.Box, { is: 'img', className: '_footer__logo', src: isHf ? __webpack_require__(844) : __webpack_require__(845), verticalAlign: 'middle' })
	                    )
	                ),
	                _react2['default'].createElement(
	                    _blocks.Flex,
	                    { flexWrap: 'wrap', justifyContent: 'center', className: '_footer__links' },
	                    _react2['default'].createElement(
	                        _blocks.Box,
	                        { p: 3, className: 'm-app-footer--links--link' },
	                        _react2['default'].createElement(
	                            _blocks.Box,
	                            { is: 'a', href: pricingUrl, color: 'grey', hoverColor: 'ashen' },
	                            'Pricing'
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        _blocks.Box,
	                        { p: 3, className: 'm-app-footer--links--link product-link' },
	                        _react2['default'].createElement(
	                            _tetherToggle2['default'],
	                            {
	                                anchor: _react2['default'].createElement(
	                                    _blocks.Box,
	                                    { is: 'a', color: 'grey', hoverColor: 'ashen' },
	                                    'Products'
	                                ),
	                                position: 'top',
	                                justify: 'center'
	                            },
	                            items
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        _blocks.Box,
	                        { p: 3, className: 'm-app-footer--links--link fine-print-link' },
	                        _react2['default'].createElement(
	                            _tetherToggle2['default'],
	                            {
	                                anchor: _react2['default'].createElement(
	                                    _blocks.Box,
	                                    { is: 'a', color: 'grey', hoverColor: 'ashen' },
	                                    'Fine print'
	                                ),
	                                position: 'top',
	                                justify: 'center'
	                            },
	                            finePrintItems
	                        )
	                    ),
	                    _react2['default'].createElement(ZendeskActivator, null),
	                    _react2['default'].createElement(
	                        _blocks.Box,
	                        { p: 3, className: 'm-app-footer--links--link' },
	                        _react2['default'].createElement(
	                            _blocks.Box,
	                            { is: 'a', href: faqUrl, target: '_blank', rel: 'noopener noreferrer', color: 'grey', hoverColor: 'a' },
	                            'FAQ'
	                        )
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                _blocks.Flex,
	                { justifyContent: 'center', className: '_footer__social m-app-footer--social' },
	                social
	            )
	        );
	    }
	});
	
	module.exports = AppFooter;

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _widget = __webpack_require__(838);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * A higher-order component for turning a component into a zendesk widget
	 * activator.
	 *
	 * @example
	 *
	 * // The `onActivate` prop is available because we've wrapped the component
	 * // with the `asZendeskActivator` function
	 * const MyComponent = function(props) {
	 *      return <div onClick={props.onActivate}>Whatever I want here</div>;
	 * }
	 *
	 * const MyWrappedComponent = asZendeskActivator(MyComponent);
	 *
	 * // later, in a render function....
	 * render() {
	 *      return <div>
	 *          <MyWrappedComponent />
	 *      </div>;
	 * }
	 *
	 */
	function asZendeskActivator(Component) {
	    function ZendeskActivator(props) {
	        return _react2['default'].createElement(Component, _extends({}, props, { onActivate: _widget.activate }));
	    }
	
	    var wrappedComponentName = Component.displayName || Component.name || 'Component';
	
	    ZendeskActivator.displayName = 'asZendeskActivator(' + wrappedComponentName + ')';
	
	    return ZendeskActivator;
	}
	
	exports['default'] = asZendeskActivator;

/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.identify = identify;
	exports.activate = activate;
	/**
	 * Zendesk widget
	 *
	 * Include this file in a bundle to enable the Zendesk widget  I prefer having
	 * this on the client so that it can be easily configured.  The widget API is a
	 * little strange to work with so I've exposed this file to use as an interface.
	 */
	
	/* eslint-disable */
	function init() {
	    /*<![CDATA[*/
	    window.zEmbed || function (e, t) {
	        var n,
	            o,
	            d,
	            i,
	            s,
	            a = [],
	            r = document.createElement("iframe");
	        window.zEmbed = function () {
	            a.push(arguments);
	        }, window.zE = window.zE || window.zEmbed, r.src = "javascript:false", r.title = "", r.role = "presentation", (r.frameElement || r).style.cssText = "display: none", d = document.getElementsByTagName("script"), d = d[d.length - 1], d.parentNode.insertBefore(r, d), i = r.contentWindow, s = i.document;
	        try {
	            o = s;
	        } catch (c) {
	            n = document.domain, r.src = "javascript:var d=document.open();d.domain=\"" + n + "\";void(0);", o = s;
	        }
	        o.open()._l = function () {
	            var o = this.createElement("script");
	            n && (this.domain = n), o.id = "js-iframe-async", o.src = e, this.t = +new Date(), this.zendeskHost = t, this.zEQueue = a, this.body.appendChild(o);
	        }, o.write("<body onload=\"document._l();\">"), o.close();
	    }("https://assets.zendesk.com/embeddable_framework/main.js", "hellosign.zendesk.com"); /*]]>*/
	    /* eslint-enable */
	
	    // Hide zendesk by default
	    zE(function () {
	        zE.hide();
	    });
	}
	
	function identify(info) {
	    zE(function () {
	        zE.identify(info);
	        zE.activateIpm();
	    });
	}
	
	function activate() {
	    zE(function () {
	        zE.activate({
	            hideOnClose: true
	        });
	    });
	}
	
	if (true) {
	    init();
	}

/***/ },
/* 839 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 840 */,
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/ecf9c0b950f991bb64a916881104a288.png";

/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/d12c3494336a7de68c0335127966e6f1.png";

/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/e90e57ceace6125194eabcfa376f1cf3.png";

/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/68c3f34dd621854f806ae903cd348ede.png";

/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/9834059605751d771a6b996f90db89e0.png";

/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _watchAppNotifier = __webpack_require__(835);
	
	var _watchAppNotifier2 = _interopRequireDefault(_watchAppNotifier);
	
	var _member = __webpack_require__(847);
	
	var _member2 = _interopRequireDefault(_member);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _teamReporting = __webpack_require__(853);
	
	var _teamReporting2 = _interopRequireDefault(_teamReporting);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var TeamPage = _react2['default'].createClass({
	    displayName: 'TeamPage',
	
	
	    /**
	    */
	
	    mixins: [_watchAppNotifier2['default']],
	
	    /**
	    */
	
	    propTypes: {
	        csrfToken: _react2['default'].PropTypes.string,
	        baseFormCsrfToken: _react2['default'].PropTypes.string.isRequired
	    },
	
	    /**
	    */
	
	    getInitialState: function getInitialState() {
	        var app = this.props.app;
	        return {
	            app: app,
	            user: app.user,
	            team: app.user.getTeam(),
	            teamMembers: app.user.getTeam().getMembers()
	        };
	    },
	
	
	    /**
	    */
	
	    toggleEditTeamName: function toggleEditTeamName() {
	        this.setState({ editTeamName: !this.state.editTeamName }, function () {
	            var node = this.refs.teamNameInput;
	            node.focus();
	            node.setSelectionRange(this.state.team.name.length, this.state.team.name.length);
	        }.bind(this));
	    },
	
	
	    /**
	    */
	
	    saveTeamName: function saveTeamName(event) {
	        var _this = this;
	
	        var teamName = this.refs.teamNameInput.value.trim();
	
	        if (teamName.length === 0) {
	            teamName = 'Untitled Team';
	        }
	
	        this.state.team.set('name', teamName);
	        this.setState({ editTeamName: false });
	        this.state.team.save().then(function (err) {
	
	            if (err.error_msg) {
	                var err = new Error(err.error_msg);
	                _this.setState({ 'error': err });
	            }
	        });
	        event.preventDefault();
	    },
	
	
	    /**
	    */
	
	    addTeamMember: function addTeamMember(event) {
	        var _this2 = this;
	
	        return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	            var ref, teamMemberEmail, i;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	
	                            _this2.setState({ 'error': void 0 });
	
	                            event.preventDefault();
	
	                            if (!_this2.state.csvFile) {
	                                _context.next = 12;
	                                break;
	                            }
	
	                            _context.prev = 3;
	                            _context.next = 6;
	                            return _this2.state.team.importTeamMembers(_this2.state.csvFile);
	
	                        case 6:
	                            _context.next = 11;
	                            break;
	
	                        case 8:
	                            _context.prev = 8;
	                            _context.t0 = _context['catch'](3);
	
	                            _this2.setState({ 'error': _context.t0 });
	
	                        case 11:
	                            return _context.abrupt('return');
	
	                        case 12:
	                            ref = _this2.refs.newMemberEmailAddress;
	                            teamMemberEmail = ref.value || '';
	
	                            // TODO - move this to model
	
	                            if (_hfReactHelper2['default'].isValidEmailAddress(teamMemberEmail)) {
	                                _context.next = 16;
	                                break;
	                            }
	
	                            return _context.abrupt('return', _this2.setState({
	                                'error': new Error('Please enter a valid email address!')
	                            }));
	
	                        case 16:
	                            i = 0;
	
	                        case 17:
	                            if (!(i < _this2.state.teamMembers.length)) {
	                                _context.next = 23;
	                                break;
	                            }
	
	                            if (!(_this2.state.teamMembers.at(i).emailAddress === teamMemberEmail)) {
	                                _context.next = 20;
	                                break;
	                            }
	
	                            return _context.abrupt('return', _this2.setState({
	                                'error': new Error('That user is already on your team.')
	                            }));
	
	                        case 20:
	                            i++;
	                            _context.next = 17;
	                            break;
	
	                        case 23:
	                            if (!_this2.state.team.pastTeamMemberLimit()) {
	                                _context.next = 29;
	                                break;
	                            }
	
	                            if (!_this2.state.team.enterpriseProRateAmount) {
	                                _context.next = 28;
	                                break;
	                            }
	
	                            return _context.abrupt('return', _this2.state.app.actions.ui.showModal(_react2['default'].createElement(
	                                'div',
	                                { className: 'l-new-modal' },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: 'l-new-modal--content-wrap' },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: 'l-new-modal--title' },
	                                        'New seat needed'
	                                    ),
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: 'l-new-modal--content' },
	                                        _react2['default'].createElement(
	                                            'p',
	                                            null,
	                                            'To invite this person to your team, please purchase a new seat.'
	                                        ),
	                                        _react2['default'].createElement(
	                                            'p',
	                                            null,
	                                            'Each seat you add will be billed at your rate of ',
	                                            _react2['default'].createElement(
	                                                'b',
	                                                null,
	                                                _this2.state.team.enterprisePrice,
	                                                '/',
	                                                _this2.state.team.enterprisePeriod
	                                            ),
	                                            '.',
	                                            _react2['default'].createElement('br', null),
	                                            'This seat will be prorated at ',
	                                            _react2['default'].createElement(
	                                                'b',
	                                                null,
	                                                _this2.state.team.enterpriseProRateAmount
	                                            ),
	                                            ' for this ',
	                                            _this2.state.team.enterprisePeriod,
	                                            '.'
	                                        )
	                                    ),
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: 'l-new-modal--actions' },
	                                        _react2['default'].createElement(_button2['default'], {
	                                            buttonText: 'Cancel',
	                                            buttonColor: 'white',
	                                            buttonTextColor: 'grasshopper',
	                                            buttonHoverColor: 'grasshopper',
	                                            buttonClass: 'm-button-butmit close',
	                                            buttonBorderColor: 'grasshopper',
	                                            buttonHoverTextColor: 'white' }),
	                                        _react2['default'].createElement(_button2['default'], {
	                                            buttonText: 'Continue',
	                                            onClick: _this2._addTeamMember.bind(_this2, teamMemberEmail, ref),
	                                            buttonColor: 'grasshopper',
	                                            buttonHoverColor: 'ashen',
	                                            buttonClass: 'm-button-butmit close',
	                                            buttonHoverTextColor: 'white' })
	                                    )
	                                )
	                            ), { 'showCloseButton': false }, 'new-enterprise-seat'));
	
	                        case 28:
	                            return _context.abrupt('return', _this2.setState({
	                                error: new Error('You need to upgrade to add more team members.')
	                            }));
	
	                        case 29:
	
	                            _this2._addTeamMember(teamMemberEmail, ref);
	
	                        case 30:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, _this2, [[3, 8]]);
	        }))();
	    },
	
	
	    /**
	    */
	
	    _addTeamMember: function _addTeamMember(teamMemberEmail, ref) {
	        var _this3 = this;
	
	        return _asyncToGenerator(regeneratorRuntime.mark(function _callee2() {
	            var member, title, msg;
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	
	                            _this3.setState({ 'addingTeamMember': true });
	
	                            _context2.prev = 1;
	                            _context2.next = 4;
	                            return _this3.state.team.addMember({
	                                emailAddress: teamMemberEmail,
	                                csrfToken: _this3.props.csrfToken
	                            });
	
	                        case 4:
	                            member = _context2.sent;
	                            _context2.next = 10;
	                            break;
	
	                        case 7:
	                            _context2.prev = 7;
	                            _context2.t0 = _context2['catch'](1);
	                            return _context2.abrupt('return', _this3.setState({ error: _context2.t0, addingTeamMember: false }));
	
	                        case 10:
	
	                            _this3.setState({
	                                error: void 0,
	                                addingTeamMember: false
	                            });
	
	                            // Clear the input field
	                            ref.value = '';
	
	                            // Generate dialog modal with outcome message
	                            if (member) {
	                                if (typeof member.warning !== "undefined") {
	                                    title = member.pending_email_confirmation ? "Invitation Pending" : "Invitation Sent";
	                                    msg = member.warning;
	                                } else {
	                                    title = "Member Added";
	                                    msg = "The new member was added successfully.";
	                                }
	                                _this3.state.app.actions.ui.showModal(_react2['default'].createElement(
	                                    'div',
	                                    { className: 'l-new-modal' },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: 'l-new-modal--content-wrap' },
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: 'l-new-modal--title' },
	                                            title
	                                        ),
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: 'l-new-modal--content' },
	                                            _react2['default'].createElement(
	                                                'p',
	                                                null,
	                                                msg
	                                            )
	                                        ),
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: 'l-new-modal--actions' },
	                                            _react2['default'].createElement(_button2['default'], {
	                                                buttonText: 'Close',
	                                                buttonColor: 'grasshopper',
	                                                buttonHoverColor: 'ashen',
	                                                buttonClass: 'm-button-submit close',
	                                                buttonHoverTextColor: 'white' })
	                                        )
	                                    )
	                                ), { 'showCloseButton': false }, 'invite-existing-account');
	                            }
	
	                        case 13:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, _this3, [[1, 7]]);
	        }))();
	    },
	
	
	    /**
	    */
	
	    onCSVFile: function onCSVFile(file) {
	        this.setState({ csvFile: file });
	    },
	
	
	    /**
	    */
	
	    render: function render() {
	
	        var canModifyTeam = this.state.team.isOwner && this.state.team.maxSize > 1;
	        var sections = {};
	
	        if (this.state.team.maxSize < Infinity) {
	            sections.bucketUsage = _react2['default'].createElement(
	                'p',
	                { className: 'bucket-usage' },
	                'You have used ',
	                _react2['default'].createElement(
	                    'span',
	                    { id: 'team_size_display' },
	                    this.state.team.size
	                ),
	                ' of ',
	                this.state.team.maxSize,
	                ' team seats.',
	                _react2['default'].createElement(
	                    'a',
	                    { className: 'team-page-more-seats', href: '/info/pricing' },
	                    'UPGRADE FOR MORE SEATS'
	                )
	            );
	        }
	
	        if (this.props.showReportingLink) {
	            sections.reporting = _react2['default'].createElement(
	                'p',
	                { className: 'bucket-usage' },
	                _react2['default'].createElement(_teamReporting2['default'], {
	                    csrfToken: this.props.baseFormCsrfToken,
	                    isEnabled: this.props.isReportingEnabled,
	                    canRequestUsage: this.props.canRequestUsageReport
	                })
	            );
	        }
	
	        // still not done - don't impl for now (CC)
	        /*
	        if (this.state.csvFile) {
	        sections.uploadCSVButton = <form className='csv_import'>
	        <span onClick={this.onCSVFile.bind(this, void 0)} id='csv_import_link'>Cancel</span>
	        </form>
	        } else {
	        sections.uploadCSVButton = <UploadCSVButton onFile={this.onCSVFile} />;
	        }
	        */
	
	        if (canModifyTeam) {
	            sections.editTeamName = _react2['default'].createElement(
	                'a',
	                { href: '#', id: 'edit_team_name_link', onClick: this.toggleEditTeamName },
	                _react2['default'].createElement('img', { className: 'team-page-edit-title', src: __webpack_require__(859) })
	            );
	
	            sections.addTeamMember = _react2['default'].createElement(
	                'div',
	                null,
	                sections.bucketUsage,
	                sections.reporting,
	                _react2['default'].createElement(
	                    'form',
	                    { className: 'add_team_member', onSubmit: this.addTeamMember },
	                    _react2['default'].createElement('input', {
	                        ref: 'newMemberEmailAddress',
	                        type: 'text', name: 'new_member_email_address',
	                        placeholder: this.state.csvFile ? this.state.csvFile.name : void 0,
	                        className: 'required email new_member_email_address no_focus',
	                        disabled: !!this.state.csvFile || this.state.addingTeamMember }),
	                    _react2['default'].createElement(
	                        'div',
	                        { id: 'add-team-member-submit-react-holder' },
	                        _react2['default'].createElement(_button2['default'], {
	                            buttonId: this.state.csvFile ? 'csv_import_submit' : 'add_team_member_submit',
	                            buttonText: this.state.csvFile ? 'Invite People' : this.state.addingTeamMember ? 'Inviting...' : 'Invite',
	                            buttonColor: 'grasshopper',
	                            buttonHoverColor: 'ashen',
	                            buttonClass: 'm-button-butmit',
	                            buttonHoverTextColor: 'white',
	                            type: 'submit' })
	                    )
	                ),
	                sections.uploadCSVButton
	            );
	        } else if (this.state.team.isOwner) {
	            sections.addTeamMember = _react2['default'].createElement(
	                'div',
	                null,
	                sections.bucketUsage
	            );
	        }
	
	        if (this.state.editTeamName) {
	            sections.editTeamName = _react2['default'].createElement(
	                'form',
	                { onSubmit: this.saveTeamName, className: 'edit-team-title-form' },
	                _react2['default'].createElement('input', { type: 'text', ref: 'teamNameInput', defaultValue: this.state.team.name }),
	                _react2['default'].createElement(_button2['default'], { buttonText: 'Save', onClick: this.saveTeamName, buttonColor: 'grasshopper', buttonHoverColor: 'ashen', buttonClass: 'm-button-butmit', buttonHoverTextColor: 'white' })
	            );
	        } else {
	            sections.editTeamName = _react2['default'].createElement(
	                'h1',
	                null,
	                _react2['default'].createElement(
	                    'span',
	                    { id: 'team_name' },
	                    this.state.team.name || 'Untitled Team'
	                ),
	                sections.editTeamName
	            );
	        }
	
	        if (this.state.error) {
	            sections.error = _react2['default'].createElement(
	                'div',
	                { id: 'error_container' },
	                _react2['default'].createElement(
	                    'label',
	                    { htmlFor: 'new_member_email_address', className: 'error' },
	                    this.state.error.message
	                )
	            );
	        }
	
	        sections.teamMembers = this.state.teamMembers.map(function (teamMember, i) {
	            return _react2['default'].createElement(_member2['default'], { app: this.props.app, key: teamMember.emailAddress + i, member: teamMember, teamMembers: this.state.teamMembers });
	        }.bind(this));
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'team-page' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'team-accounts-column ' + (_hfReactHelper2['default'].isHelloSign() ? 'hs' : 'hf') },
	                sections.editTeamName,
	                sections.addTeamMember,
	                sections.error,
	                _react2['default'].createElement(
	                    'div',
	                    { id: 'team_list_header' },
	                    _react2['default'].createElement(
	                        'div',
	                        { id: 'member_email' },
	                        'Member Email'
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { id: 'role' },
	                        'Role'
	                    ),
	                    _hfReactHelper2['default'].isHelloSign() ? _react2['default'].createElement(
	                        'div',
	                        { id: 'templates' },
	                        'Templates Owned'
	                    ) : void 0
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { id: 'team_list_container' },
	                    _react2['default'].createElement(
	                        'table',
	                        { className: 'team_list' },
	                        _react2['default'].createElement(
	                            'tbody',
	                            null,
	                            sections.teamMembers
	                        )
	                    )
	                )
	            )
	        );
	    }
	});
	
	module.exports = TeamPage;

/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _setTimeout = __webpack_require__(718);
	
	var _setTimeout2 = _interopRequireDefault(_setTimeout);
	
	var _tooltip = __webpack_require__(727);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _removeEnterpriseMember = __webpack_require__(848);
	
	var _removeEnterpriseMember2 = _interopRequireDefault(_removeEnterpriseMember);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TeamMember = _react2['default'].createClass({
	    displayName: 'TeamMember',
	
	
	    /**
	     */
	
	    propTypes: {
	        'member': _react2['default'].PropTypes.object.isRequired
	    },
	
	    /**
	     */
	
	    getInitialState: function getInitialState() {
	        return {};
	    },
	
	
	    /**
	     */
	
	    setMemberRole: function setMemberRole(code, event) {
	
	        if (this.props.member.isLoggedInUser() && this.props.member.canModifyTeam() && !confirm('Are you sure you want to revoke your Admin privileges? You will no longer be able to modify your team.')) {
	            return;
	        }
	
	        this.props.member.promote(code);
	        event.preventDefault();
	        event.stopPropagation();
	    },
	
	
	    /**
	     */
	
	    resetPassword: function resetPassword(event) {
	
	        event.preventDefault();
	        if (!confirm('Are you sure you want to reset the password for this account?')) {
	            return;
	        }
	
	        this.props.member.resetPassword();
	    },
	
	
	    /**
	     */
	
	    unlockMember: function unlockMember(event) {
	
	        event.preventDefault();
	        this.props.member.unlock();
	    },
	
	
	    /**
	     */
	
	    lockMember: function lockMember(event) {
	
	        event.preventDefault();
	        if (!confirm('Are you sure you want to lock this account?')) {
	            return;
	        }
	
	        this.props.member.lock();
	    },
	
	
	    /**
	     */
	
	    removeMember: function removeMember(event) {
	
	        event.preventDefault();
	
	        var removeText = 'Are you sure you want to remove this user from your team? Note: this user\'s account will still exist. However, they will no longer be';
	        removeText += this.props.member.pending ? ' invited to join your team.' : ' part of your team.';
	        if (_hfReactHelper2['default'].isHelloSign() && !this.props.member.pending) {
	            removeText += ' IMPORTANT: Any templates this user created will be transferred to you and their signatures will be removed from them.';
	        }
	
	        if (!confirm(removeText)) {
	            return;
	        }
	
	        this.props.member.remove();
	    },
	
	
	    /**
	     */
	
	    removeEnterpriseMember: function removeEnterpriseMember(event) {
	
	        event.preventDefault();
	
	        this.props.app.actions.ui.showModal(_react2['default'].createElement(_removeEnterpriseMember2['default'], this.props), { 'showCloseButton': false }, 'remove-enterprise-member');
	    },
	
	
	    /**
	     */
	
	    toggleMenu: function toggleMenu(show) {
	        clearTimeout(this._hideTimeout);
	
	        // TODO: clean me - hack to prevent menu from hiding too quickly - this
	        // needs to be placed within a menu component (CC)
	        var self = this;
	        if (show) {
	            this.setState({ 'showMenu': show });
	        } else {
	            this._hideTimeout = (0, _setTimeout2['default'])(function () {
	                self.setState({ 'showMenu': show });
	            }, 100);
	        }
	    },
	
	
	    /**
	     */
	
	    showTemplates: function showTemplates() {
	
	        // TODO: reactify this component - here to support legacy stuff
	        // for now
	        var a = document.createElement('a');
	        var guid = this.props.member.guid || this.props.member.uid;
	        a.setAttribute('href', '/home/viewTemplatePermissionsForAccount?guid=' + guid);
	
	        $(a).fancybox({
	            'showCloseButton': false,
	            'type': 'iframe',
	            'height': 375,
	            'width': 500
	        }).click();
	    },
	
	
	    /**
	     */
	
	    toggleCloseButton: function toggleCloseButton(show) {
	        this.setState({
	            'showClose': show
	        });
	    },
	
	
	    /**
	    * Returns true for Admins (owners) and Developers
	    */
	    shouldShowActionMenu: function shouldShowActionMenu() {
	        return this.props.teamMembers && this.props.teamMembers.loggedInUserCanModifyTeam();
	    },
	
	
	    /**
	    *
	    */
	    userIsAdmin: function userIsAdmin() {
	        return this.props.teamMembers && this.props.teamMembers.loggedInUserIsAdmin();
	    },
	
	
	    /**
	     */
	
	    isEnterprise: function isEnterprise() {
	        return this.props.app.user.getTeam().isEnterprise();
	    },
	
	
	    /**
	     */
	
	    isHighPayingEnterprise: function isHighPayingEnterprise() {
	        return this.props.app.user.getTeam().isHighMrrEnterprise;
	    },
	
	
	    /**
	     */
	
	    isTransferDocsAdmin: function isTransferDocsAdmin() {
	        return this.props.app.user.getTeam().isTransferDocsAdmin;
	    },
	
	
	    /**
	     */
	
	    hasTransferDocsAdmin: function hasTransferDocsAdmin() {
	        return this.props.app.user.getTeam().hasTransferDocsAdmin;
	    },
	
	
	    /**
	     */
	
	    isRemovable: function isRemovable() {
	        var isAdmin = this.userIsAdmin();
	        var isEnterprise = this.isEnterprise();
	        var isLoggedInUser = this.props.member.isLoggedInUser();
	
	        return isAdmin && !(isEnterprise && isLoggedInUser);
	    },
	    getNumUnlockedAdmins: function getNumUnlockedAdmins() {
	        var count = 0;
	        var members = this.props.teamMembers;
	        for (var i = 0; i < members.length; i++) {
	            if (members.at(i).isAdmin() && !members.at(i).isLocked) {
	                count++;
	            }
	        }
	        return count;
	    },
	
	
	    /**
	     */
	
	    render: function render() {
	        var member = this.props.member;
	        var loggedInUser = this.props.teamMembers.getLoggedInUser();
	        var isSoleUnlockedAdmin = typeof loggedInUser != 'undefined' && member.emailAddress === loggedInUser.emailAddress && this.getNumUnlockedAdmins() < 2;
	
	        var classNames = (0, _classnames2['default'])({
	            'team_member': true,
	            'show': this.state.showMenu
	        });
	
	        var sections = {};
	
	        // Templates
	        if (_hfReactHelper2['default'].isHelloSign() && !member.isLocked) {
	            sections.templateMenuItem = _react2['default'].createElement(
	                'li',
	                { key: 'menu', className: 'menuLink template_access' },
	                _react2['default'].createElement(
	                    'a',
	                    { href: '#', className: 'show_template_access_link', onClick: this.showTemplates },
	                    _react2['default'].createElement('b', { className: 'ico' }),
	                    'Templates'
	                )
	            );
	        }
	
	        // User administration functions only available to Admins, not Devs
	        if (this.userIsAdmin()) {
	            // Make Admin
	            if (!member.isAdmin() && !member.isLocked) {
	                sections.adminMenuItem = _react2['default'].createElement(
	                    'li',
	                    { key: 'make-admin', className: 'menuLink make-admin' },
	                    _react2['default'].createElement(
	                        'a',
	                        { href: '#', onClick: this.setMemberRole.bind(this, 'a') },
	                        _react2['default'].createElement('b', { className: 'ico' }),
	                        'Make Admin'
	                    )
	                );
	            }
	
	            // Make Developer
	            if (!member.isDeveloper() && !member.isLocked && !isSoleUnlockedAdmin) {
	                sections.devMenuItem = _react2['default'].createElement(
	                    'li',
	                    { key: 'make-developer', className: 'menuLink make-developer' },
	                    _react2['default'].createElement(
	                        'a',
	                        { href: '#', onClick: this.setMemberRole.bind(this, 'd') },
	                        _react2['default'].createElement('b', { className: 'ico' }),
	                        'Make Developer'
	                    )
	                );
	            }
	
	            // Make Member
	            if (!member.isMember() && !member.isLocked && !isSoleUnlockedAdmin) {
	                sections.memberMenuItem = _react2['default'].createElement(
	                    'li',
	                    { key: 'make-member', className: 'menuLink make-member' },
	                    _react2['default'].createElement(
	                        'a',
	                        { href: '#', onClick: this.setMemberRole.bind(this, 'm'), style: { 'fontSize': '10px' } },
	                        _react2['default'].createElement('b', { className: 'ico' }),
	                        'Make Member'
	                    )
	                );
	            }
	
	            // high paying enterprise options
	            if (this.isHighPayingEnterprise() && !member.isLocked && !this.props.member.isLoggedInUser()) {
	                // Lock Account
	                sections.lockMenuItem = _react2['default'].createElement(
	                    'li',
	                    { className: 'menuLink' },
	                    _react2['default'].createElement(
	                        'a',
	                        { href: '#', className: 'lock_team_member', onClick: this.lockMember },
	                        _react2['default'].createElement('b', { className: 'ico' }),
	                        'Lock Account'
	                    )
	                );
	
	                // Reset Password
	                sections.resetPasswordMenuItem = _react2['default'].createElement(
	                    'li',
	                    { className: 'menuLink' },
	                    _react2['default'].createElement(
	                        'a',
	                        { href: '#', className: 'reset_password_team_member', onClick: this.resetPassword },
	                        _react2['default'].createElement('b', { className: 'ico' }),
	                        'Reset Password'
	                    )
	                );
	            }
	        }
	
	        // Unlock Account
	        if (member.isLocked) {
	            sections.unlockMenuItem = _react2['default'].createElement(
	                'li',
	                { className: 'menuLink' },
	                _react2['default'].createElement(
	                    'a',
	                    { href: '#', className: 'unlock_team_member', onClick: this.unlockMember },
	                    _react2['default'].createElement('b', { className: 'ico' }),
	                    'Unlock Account'
	                )
	            );
	        }
	
	        // Remove
	        if (this.isRemovable()) {
	            var removeHandler = this.isEnterprise() && this.isTransferDocsAdmin() ? this.removeEnterpriseMember : this.removeMember;
	            sections.removeMenuItem = _react2['default'].createElement(
	                'li',
	                { className: 'menuLink' },
	                _react2['default'].createElement(
	                    'a',
	                    { href: '#', className: 'remove_team_member', onClick: removeHandler },
	                    _react2['default'].createElement('b', { className: 'ico' }),
	                    'Remove'
	                )
	            );
	        }
	
	        if (member.pending) {
	
	            var closClassNames = (0, _classnames2['default'])({
	                'action_col': true,
	                'show': this.state.showClose
	            });
	
	            // TODO - move to scss file when scss is organized (CC)
	            sections.actionsColumn = _react2['default'].createElement(
	                'td',
	                { className: closClassNames, onMouseOver: this.toggleCloseButton.bind(this, true), onMouseOut: this.toggleCloseButton.bind(this, false) },
	                _react2['default'].createElement('img', { src: __webpack_require__(851), onClick: this.removeMember, title: 'Remove', alt: 'Remove', className: 'delete_team_invite_link' })
	            );
	        } else {
	            sections.actionsColumn = _react2['default'].createElement(
	                'td',
	                { className: 'action_col', style: { opacity: 1 } },
	                this.shouldShowActionMenu() ? _react2['default'].createElement(
	                    'div',
	                    { className: 'arrow', onMouseOver: this.toggleMenu.bind(this, true), onMouseOut: this.toggleMenu.bind(this, false) },
	                    _react2['default'].createElement(
	                        'ul',
	                        null,
	                        sections.templateMenuItem,
	                        sections.adminMenuItem,
	                        sections.devMenuItem,
	                        sections.memberMenuItem,
	                        sections.resetPasswordMenuItem,
	                        sections.lockMenuItem,
	                        sections.unlockMenuItem,
	                        sections.removeMenuItem
	                    )
	                ) : void 0
	            );
	        }
	
	        // TODO - don't do this - need to use CSS ellipsis instead
	        var emailAddress = member.emailAddress.toLowerCase();
	        if (emailAddress.length > 30) {
	            emailAddress = emailAddress.substring(0, 27) + '...';
	        }
	
	        var role_label;
	        if (member.pending) {
	            role_label = member.pending_email_confirmation ? "(Pending)" : "(Invited)";
	        } else {
	            role_label = member.getRoleTypeLabel();
	        }
	
	        var lockId = 'lock_' + this.props.member.guid;
	        var lockedIcon = _react2['default'].createElement('img', { id: lockId, className: 'team-page-lock', src: __webpack_require__(852) });
	        var tooltip = _react2['default'].createElement(_tooltip2['default'], {
	            content: 'This user is currently locked',
	            lockToElement: '#' + lockId,
	            arrowPosition: 'left'
	        });
	        var emailStyle = member.isLocked ? { position: 'relative', top: '-2px' } : {};
	        return _react2['default'].createElement(
	            'tr',
	            { className: classNames, style: { display: 'table-row' } },
	            _react2['default'].createElement(
	                'td',
	                { className: 'email_col' },
	                _react2['default'].createElement(
	                    'span',
	                    { style: emailStyle },
	                    member.emailAddress
	                ),
	                member.isLocked ? lockedIcon : void 0,
	                member.isLocked ? tooltip : void 0
	            ),
	            _react2['default'].createElement(
	                'td',
	                { className: 'role_col' },
	                role_label
	            ),
	            _hfReactHelper2['default'].isHelloSign() ? _react2['default'].createElement(
	                'td',
	                { className: 'templates_col' },
	                member.numTemplates
	            ) : void 0,
	            sections.actionsColumn
	        );
	    }
	});
	
	module.exports = TeamMember;

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(849);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _logger = __webpack_require__(482);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var RemoveEnterpriseMember = _react2['default'].createClass({
	    displayName: 'RemoveEnterpriseMember',
	    getInitialState: function getInitialState() {
	        return {
	            moveDataToAcct: null
	        };
	    },
	    handleChange: function handleChange(e) {
	        this.setState({
	            moveDataToAcct: e.target.value
	        });
	    },
	    handleSubmit: function handleSubmit() {
	        this.props.member.setProperties({ moveDataToAcct: this.state.moveDataToAcct });
	        if (this.props.member.moveDataToAcct) _logger2['default'].track('RemoveEnterpriseMember.transferred');
	        this.props.member.remove();
	    },
	    makeDropdown: function makeDropdown() {
	        var _this = this;
	
	        return _react2['default'].createElement(
	            'select',
	            { onChange: function onChange(e) {
	                    return _this.handleChange(e);
	                } },
	            _react2['default'].createElement(
	                'option',
	                { value: '' },
	                'No transfer'
	            ),
	            this.props.teamMembers.map(function (member, i) {
	                return _this.props.member.guid == member.guid || member.pending ? null : _react2['default'].createElement(
	                    'option',
	                    { key: i, value: member.guid },
	                    member.emailAddress
	                );
	            })
	        );
	    },
	    makeLabel: function makeLabel() {
	        var label = 'Who would you like to receive <span class=\'shortened\'>' + this.props.member.emailAddress + '</span>\'s documents';
	        label += this.props.member.hasTeamApiKey ? ' and API key? If they are a member, they will be promoted to developer.' : '?';
	        return label;
	    },
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            { className: 'l-new-modal remove-enterprise-member' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'l-new-modal--content-wrap' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'l-new-modal--title' },
	                    'Remove User'
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'l-new-modal--content' },
	                    _react2['default'].createElement('label', { dangerouslySetInnerHTML: { __html: this.makeLabel() } }),
	                    this.makeDropdown()
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'l-new-modal--actions' },
	                    _react2['default'].createElement(_button2['default'], {
	                        buttonText: 'Confirm',
	                        buttonColor: 'grasshopper',
	                        buttonHoverColor: 'ashen',
	                        buttonClass: 'm-button-submit close',
	                        buttonHoverTextColor: 'white',
	                        onClick: this.handleSubmit }),
	                    _react2['default'].createElement(_button2['default'], {
	                        buttonText: 'Cancel',
	                        buttonColor: 'black',
	                        buttonClass: 'm-button-submit close' })
	                )
	            )
	        );
	    }
	});
	
	module.exports = RemoveEnterpriseMember;

/***/ },
/* 849 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 850 */,
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/0c4e0f63aeb6496ec2c38a9facd585f6.png";

/***/ },
/* 852 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAA0CAYAAAD46nqNAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAcdJREFUeNrsmetxwjAMgB0uA2QD0g3YgLBBu0EyQcMEwASlE5BOUDoB6QYZwd0ANqjUk+98LiTxI48f0p3OMfHjs+xIthGCxU+iEI1U1SmDJKPsEvQKegOVoHWeF3J0QIBKIClBX0GTjuI16AFA61EAAQ7BdhoYWuwM+kPP6ve1ZlkFWthYNHKAO0GSU7Yhy5xbyqdUfqcNZgN1muCABhyC7S3qIugn6MoGMrLoYK9ZAaepcly3Fw3yCdq5ttVZWIxewW1d4FAIZkNLA2Hfuuoserat4NBlHH1cEkEWKkuDdwfUFrnQGhaekGjByhi8swWfNetJEU4+jPadAdeUfoUMYeS0/3wmzNLKBzDRfF5oaYw+nADV6OSAgJm3BQOvPyW3UG5mMmFABpzFlt8IZ4/i8GGA/tWGFp329533MqaHtCsm9njvI9kDX1jHJrEWI6eUpZrRf4A2u+ShhE6JOX/FDMiADDiCxIH9F55zS3L4L32vN0axIB18SovQOfoUJx35aQHpGFlTFo+T73P8SNSWrGm7kmM3w4AMOFdAcjVb0vmFOoI88hQzIANOuGFN6R+lOdws3AcUw97BOFtQimFur3xF/gowANxli0U96dVbAAAAAElFTkSuQmCC"

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TeamReporting = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _qs = __webpack_require__(673);
	
	var _modal = __webpack_require__(854);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _superagent = __webpack_require__(667);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	var _legacyNotification = __webpack_require__(716);
	
	var _legacyNotification2 = _interopRequireDefault(_legacyNotification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2['default'].PropTypes,
	    Component = _react2['default'].Component;
	
	var TeamReporting = exports.TeamReporting = function (_Component) {
	    _inherits(TeamReporting, _Component);
	
	    function TeamReporting(props) {
	        _classCallCheck(this, TeamReporting);
	
	        var _this = _possibleConstructorReturn(this, (TeamReporting.__proto__ || Object.getPrototypeOf(TeamReporting)).call(this, props));
	
	        _this.handleModalOpen = _this.handleModalOpen.bind(_this);
	        _this.handleModalClose = _this.handleModalClose.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.handleResponse = _this.handleResponse.bind(_this);
	
	        _this.state = {
	            modalActive: false,
	            busy: false,
	            canRequestUsage: props.canRequestUsage
	        };
	        return _this;
	    }
	
	    _createClass(TeamReporting, [{
	        key: 'handleError',
	        value: function handleError() /* error */{
	            this.handleModalClose(function () {
	                _legacyNotification2['default'].displayNotification({
	                    class_name: 'error',
	                    text: 'Sorry, we are unable to process your request at this time. Please try again later',
	                    display_time: 10000
	                });
	            });
	        }
	    }, {
	        key: 'handleModalOpen',
	        value: function handleModalOpen() {
	            this.setState({ modalActive: true });
	        }
	    }, {
	        key: 'handleModalClose',
	        value: function handleModalClose(cb) {
	            this.setState({
	                modalActive: false,
	                busy: false
	            }, typeof cb === 'function' && cb());
	        }
	    }, {
	        key: 'handleResponse',
	        value: function handleResponse(err, response) {
	            if (err) {
	                return this.handleError(err);
	            }
	
	            // Check for response.success?
	            this.handleModalClose(function () {
	                _legacyNotification2['default'].displayNotification({
	                    class_name: 'success',
	                    text: 'Your request is being processed. We will send you an email when the report is ready.',
	                    display_time: 10000
	                });
	            });
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(options) {
	            var _this2 = this;
	
	            var csrfToken = this.props.csrfToken;
	
	            var url = _hfReactHelper2['default'].urlHelper('home/requestReport', _hfReactHelper2['default'].HfSites.SITE_CODE_HS);
	
	            var data = (0, _qs.stringify)({
	                options: options,
	                csrf_token: csrfToken
	            });
	
	            this.setState({
	                error: undefined,
	                successful: false,
	                busy: true
	            });
	
	            // If requesting usage report, disallow further usage report requests
	            if (options['usage'] == true) {
	                this.setState({ canRequestUsage: false });
	            }
	
	            return _superagent2['default'].post(url).type('form').send(data).on('request', function () {
	                return _this2.setState({ busy: true });
	            }).end(this.handleResponse);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var isEnabled = this.props.isEnabled;
	            var _state = this.state,
	                busy = _state.busy,
	                modalActive = _state.modalActive,
	                canRequestUsage = _state.canRequestUsage;
	
	
	            return _react2['default'].createElement(
	                'span',
	                null,
	                _react2['default'].createElement(
	                    'a',
	                    {
	                        className: 'team-page-more-seats',
	                        onClick: this.handleModalOpen,
	                        style: { padding: '0' }
	                    },
	                    'DOWNLOAD A REPORT'
	                ),
	                modalActive && _react2['default'].createElement(_modal2['default'], {
	                    busy: busy,
	                    allowedOptions: canRequestUsage ? ['usage', 'compliance'] : ['compliance'],
	                    isEnabled: isEnabled,
	                    onClose: this.handleModalClose,
	                    onSubmit: this.handleSubmit
	                })
	            );
	        }
	    }]);
	
	    return TeamReporting;
	}(Component);
	
	TeamReporting.propTypes = {
	    canRequestUsage: PropTypes.bool.isRequired,
	    csrfToken: PropTypes.string.isRequired,
	    isEnabled: PropTypes.bool.isRequired
	};
	exports['default'] = TeamReporting;

/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.UsageReportingModal = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fixedModal = __webpack_require__(728);
	
	var _fixedModal2 = _interopRequireDefault(_fixedModal);
	
	var _blocks = __webpack_require__(302);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _modalClose2x = __webpack_require__(855);
	
	var _modalClose2x2 = _interopRequireDefault(_modalClose2x);
	
	__webpack_require__(856);
	
	var _info = __webpack_require__(858);
	
	var _info2 = _interopRequireDefault(_info);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = _react2['default'].Component,
	    PropTypes = _react2['default'].PropTypes;
	
	var UsageReportingModal = exports.UsageReportingModal = function (_Component) {
	    _inherits(UsageReportingModal, _Component);
	
	    function UsageReportingModal(props) {
	        _classCallCheck(this, UsageReportingModal);
	
	        var _this = _possibleConstructorReturn(this, (UsageReportingModal.__proto__ || Object.getPrototypeOf(UsageReportingModal)).call(this, props));
	
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	
	        _this.state = {
	            values: {
	                compliance: false,
	                usage: false
	            }
	        };
	        return _this;
	    }
	
	    _createClass(UsageReportingModal, [{
	        key: 'handleChange',
	        value: function handleChange(option) {
	            var _this2 = this;
	
	            return function (e) {
	                _this2.setState(function (previousState) {
	                    return _extends({}, previousState, {
	                        values: _extends({}, previousState.values, _defineProperty({}, option, !previousState.values[option]))
	                    });
	                });
	            };
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(e) {
	            e.preventDefault();
	
	            this.props.onSubmit(this.state.values);
	        }
	    }, {
	        key: 'isValid',
	        value: function isValid() {
	            var values = this.state.values;
	
	
	            return values.compliance || values.usage;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _React$createElement, _React$createElement2;
	
	            var _props = this.props,
	                allowedOptions = _props.allowedOptions,
	                busy = _props.busy,
	                isEnabled = _props.isEnabled,
	                onClose = _props.onClose,
	                rounded = _props.rounded;
	            var values = this.state.values;
	
	            var valid = this.isValid();
	
	            var modalStyle = { borderRadius: rounded ? 5 : 0 };
	            var usageAllowed = allowedOptions.includes('usage');
	            var complianceDisabled = !isEnabled || !allowedOptions.includes('compliance') || busy;
	            var usageDisabled = !isEnabled || !usageAllowed || busy;
	            var submitDisabled = !isEnabled || !valid;
	
	            var pricingUrl = _hfReactHelper2['default'].urlHelper('info/pricing?contact_sales=1', _hfReactHelper2['default'].HfSites.SITE_CODE_HS);
	
	            return _react2['default'].createElement(
	                _fixedModal2['default'],
	                { width: 600, modalStyle: modalStyle },
	                _react2['default'].createElement(
	                    'div',
	                    {
	                        className: 'team-reporting-modal-close-button',
	                        onClick: onClose
	                    },
	                    _react2['default'].createElement('img', { src: _modalClose2x2['default'] })
	                ),
	                _react2['default'].createElement(
	                    'form',
	                    { onSubmit: this.handleSubmit },
	                    _react2['default'].createElement(
	                        _blocks.Box,
	                        { py: 4, px: 3 },
	                        _react2['default'].createElement(
	                            _blocks.Text,
	                            {
	                                fontSize: 4,
	                                fontWeight: 'semibold',
	                                textTransform: 'uppercase',
	                                textAlign: 'center',
	                                mb: 3
	                            },
	                            'Reporting: Select Report'
	                        ),
	                        _react2['default'].createElement(
	                            _blocks.Box,
	                            { p: 3 },
	                            _react2['default'].createElement(
	                                _blocks.Box,
	                                { mb: 4 },
	                                _react2['default'].createElement('input', {
	                                    type: 'checkbox',
	                                    value: 'compliance',
	                                    name: 'compliance',
	                                    onChange: this.handleChange('compliance'),
	                                    checked: values.compliance,
	                                    id: 'teams-report-compliance',
	                                    disabled: complianceDisabled
	                                }),
	                                _react2['default'].createElement(
	                                    _blocks.Box,
	                                    {
	                                        is: 'label',
	                                        htmlFor: 'teams-report-compliance',
	                                        color: complianceDisabled ? 'light-grey' : '',
	                                        fontWeight: 'normal',
	                                        fontSize: 4
	                                    },
	                                    'Compliance'
	                                ),
	                                _react2['default'].createElement(
	                                    _blocks.Text,
	                                    {
	                                        color: complianceDisabled ? 'light-grey' : ''
	                                    },
	                                    'The compliance report includes your team\'s account status and last login date.'
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                _blocks.Box,
	                                null,
	                                _react2['default'].createElement('input', {
	                                    type: 'checkbox',
	                                    value: 'usage',
	                                    name: 'usage',
	                                    checked: values.usage,
	                                    onChange: this.handleChange('usage'),
	                                    id: 'teams-report-usage',
	                                    disabled: usageDisabled
	                                }),
	                                _react2['default'].createElement(
	                                    _blocks.Box,
	                                    {
	                                        is: 'label',
	                                        htmlFor: 'teams-report-usage',
	                                        color: usageDisabled ? 'light-grey' : '',
	                                        fontWeight: 'normal',
	                                        fontSize: 4
	                                    },
	                                    'Usage'
	                                ),
	                                _react2['default'].createElement(
	                                    _blocks.Text,
	                                    { color: usageDisabled ? 'light-grey' : '' },
	                                    'The usage report includes templates owned, requests sent over the last 6 months, and signed documents over the last 6 months.'
	                                )
	                            )
	                        ),
	                        isEnabled && !usageAllowed && _react2['default'].createElement(
	                            _blocks.Box,
	                            { my: 2, px: 3 },
	                            _react2['default'].createElement(
	                                _blocks.Flex,
	                                { alignItems: 'center' },
	                                _react2['default'].createElement(_blocks.Box, (_React$createElement = {
	                                    mr: 2,
	                                    is: 'img',
	                                    src: _info2['default']
	                                }, _defineProperty(_React$createElement, 'mr', 2), _defineProperty(_React$createElement, 'className', 'team-reporting-modal__info-icon'), _React$createElement)),
	                                _react2['default'].createElement(
	                                    _blocks.Text,
	                                    { fontSize: 6 },
	                                    'Usage report was generated within the last hour. Please try again later.'
	                                )
	                            )
	                        ),
	                        !isEnabled && _react2['default'].createElement(
	                            _blocks.Box,
	                            { my: 2, px: 3 },
	                            _react2['default'].createElement(
	                                _blocks.Flex,
	                                { alignItems: 'center' },
	                                _react2['default'].createElement(_blocks.Box, (_React$createElement2 = {
	                                    mr: 2,
	                                    is: 'img',
	                                    src: _info2['default']
	                                }, _defineProperty(_React$createElement2, 'mr', 2), _defineProperty(_React$createElement2, 'className', 'team-reporting-modal__info-icon'), _React$createElement2)),
	                                _react2['default'].createElement(
	                                    _blocks.Text,
	                                    { fontSize: 6 },
	                                    'This feature isn\'t available on your current plan.',
	                                    _react2['default'].createElement('br', null),
	                                    'Please',
	                                    ' ',
	                                    _react2['default'].createElement(
	                                        'a',
	                                        { href: pricingUrl },
	                                        'contact our Sales team'
	                                    ),
	                                    ' ',
	                                    'for more information about this and other HelloSign Enterprise features.'
	                                )
	                            )
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        _blocks.Box,
	                        { p: 3, className: 'team-reporting-modal-bar' },
	                        _react2['default'].createElement(
	                            _blocks.Flex,
	                            { justifyContent: 'end', alignItems: 'center' },
	                            _react2['default'].createElement(
	                                _blocks.Text,
	                                {
	                                    color: 'grey',
	                                    is: 'a',
	                                    fontSize: 6,
	                                    px: 2,
	                                    onClick: onClose
	                                },
	                                'Cancel'
	                            ),
	                            _react2['default'].createElement(_button2['default'], {
	                                buttonColor: 'cerulean',
	                                buttonText: busy ? 'Submitting...' : 'Submit',
	                                disabled: submitDisabled,
	                                type: 'submit'
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UsageReportingModal;
	}(Component);
	
	UsageReportingModal.defaultProps = {
	    allowedOptions: ['compliance', 'usage'],
	    rounded: true
	};
	UsageReportingModal.propTypes = {
	    allowedOptions: PropTypes.arrayOf(PropTypes.oneOf(['compliance', 'usage'])),
	    error: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	    onClose: PropTypes.func,
	    onSubmit: PropTypes.func,
	    rounded: PropTypes.bool,
	    successful: PropTypes.bool
	};
	exports['default'] = UsageReportingModal;

/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/d638b5962cd1f15e843b40ad0aef944e.png";

/***/ },
/* 856 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 857 */,
/* 858 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjggMTI4Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzIzMWYyMDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmV4Y2xhbWF0aW9uX2ljb248L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTY0LjAwMDA2LDQuMDAwMDdhNjAsNjAsMCwxLDEtNjAsNjAsNjAuMDY3OCw2MC4wNjc4LDAsMCwxLDYwLTYwbTAtM2E2Myw2MywwLDEsMCw2Myw2Myw2Myw2MywwLDAsMC02My02M2gwWiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTYzLjY0MjUsODcuOTA0OEEzLjkxMTg2LDMuOTExODYsMCwxLDAsNjcuNTk3NTgsOTEuNzcsMy45NjUsMy45NjUsMCwwLDAsNjMuNjQyNSw4Ny45MDQ4WiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTYxLjU0NjgsNzkuODIyNzNMNjAuNjAyNDYsMzIuNDQ0NTJoNi40NzMxNEw2Ni4xMzE3Niw3OS44MjI3M2gtNC41ODVaIi8+PC9zdmc+"

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/218434093e3279841060f0b92429514d.png";

/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _setTimeout = __webpack_require__(718);
	
	var _setTimeout2 = _interopRequireDefault(_setTimeout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TwoOptionTabPane = _react2['default'].createClass({
	    displayName: 'TwoOptionTabPane',
	
	    propTypes: {
	        image: _react2['default'].PropTypes.string,
	        frozenImage: _react2['default'].PropTypes.string,
	        title: _react2['default'].PropTypes.string.isRequired,
	        heading_1: _react2['default'].PropTypes.string.isRequired,
	        description_1: _react2['default'].PropTypes.string.isRequired,
	        heading_2: _react2['default'].PropTypes.string.isRequired,
	        description_2: _react2['default'].PropTypes.string.isRequired
	    },
	    getInitialState: function getInitialState() {
	        return {
	            animating: true
	        };
	    },
	    componentDidMount: function componentDidMount() {
	
	        // TODO: refactor this bit - defer animation handling to whatever
	        // is actually animating this component vs making this assumption (CC)
	        (0, _setTimeout2['default'])(function () {
	            this.setState({ animating: false });
	        }.bind(this), 15000);
	    },
	    render: function render() {
	        var button = _react2['default'].createElement(_button2['default'], {
	            buttonText: 'Learn more',
	            buttonLink: this.props.link || 'http://info.hellosign.com/api-demo.html',
	            openInNewWindow: true });
	
	        return _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	                'div',
	                { className: 'show-for-large-up large-6 columns' },
	                _react2['default'].createElement('img', { src: this.state.animating ? this.props.image : this.props.frozenImage, className: 'embedded-image' })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'small-12 large-6 small-text-center large-text-left columns' },
	                _react2['default'].createElement(
	                    'h3',
	                    null,
	                    this.props.title
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'row l-padding-v-20' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'small-10 large-12 small-centered large-uncentered columns' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'small-5 columns l-no-gutter' },
	                            _react2['default'].createElement(
	                                'p',
	                                { className: 'b' },
	                                this.props.heading_1
	                            ),
	                            _react2['default'].createElement(
	                                'p',
	                                null,
	                                this.props.description_1
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'small-2 columns' },
	                            _react2['default'].createElement('img', { src: __webpack_require__(861), className: 'or-image' })
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'small-5 columns l-no-gutter' },
	                            _react2['default'].createElement(
	                                'p',
	                                { className: 'b' },
	                                this.props.heading_2
	                            ),
	                            _react2['default'].createElement(
	                                'p',
	                                null,
	                                this.props.description_2
	                            )
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'small-12 columns' },
	                        button
	                    )
	                )
	            )
	        );
	    }
	});
	
	module.exports = TwoOptionTabPane;

/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/1d71ede1908e1f7cb2dcc5beb8fd6dd5.png";

/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var StandardTabPane = _react2['default'].createClass({
	    displayName: 'StandardTabPane',
	
	    propTypes: {
	        image: _react2['default'].PropTypes.string,
	        title: _react2['default'].PropTypes.string.isRequired,
	        description: _react2['default'].PropTypes.node.isRequired,
	        link: _react2['default'].PropTypes.string,
	        linkText: _react2['default'].PropTypes.string,
	
	        // TODO: this prop needs to be required, otherwise React
	        // will throw an exception since render() will return undefined (CC)
	        paneType: _react2['default'].PropTypes.string,
	        bottomImage: _react2['default'].PropTypes.string
	    },
	
	    render: function render() {
	
	        var tileLinkButton = null;
	        if (this.props.link && this.props.linkText) {
	            tileLinkButton = _react2['default'].createElement(
	                'div',
	                { className: 'l-margin-t-15' },
	                _react2['default'].createElement(_button2['default'], {
	                    buttonText: this.props.linkText,
	                    buttonLink: this.props.link,
	                    buttonHoverColor: 'cerulean',
	                    wrapText: true,
	                    openInNewWindow: true })
	            );
	        }
	
	        var tileReturnType = _react2['default'].createElement(
	            'div',
	            { className: 'columns small-8 small-text-center small-centered' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-tabs_tiles--copy-container' },
	                _react2['default'].createElement(
	                    'h4',
	                    { className: 'm-tabs_tiles--pane-header b' },
	                    this.props.title
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    this.props.description
	                ),
	                tileLinkButton
	            )
	        );
	        var tabReturnType = _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	                'div',
	                { className: 'show-for-large-up large-6 columns' },
	                _react2['default'].createElement('img', { src: this.props.image, className: 'embedded-image' })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'small-12 large-6 small-text-center large-text-left columns' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'small-10 small-centered large-uncentered columns' },
	                        _react2['default'].createElement(
	                            'h3',
	                            null,
	                            this.props.title
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'small-10 small-centered large-uncentered columns' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'l-padding-v-20' },
	                            _react2['default'].createElement(
	                                'p',
	                                null,
	                                this.props.description
	                            )
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'small-12 columns' },
	                        _react2['default'].createElement(_button2['default'], {
	                            buttonText: this.props.linkText ? this.props.linkText : 'LEARN MORE',
	                            buttonLink: this.props.link ? this.props.link : '/api/features',
	                            onMouseEnter: this.onMouseEnter,
	                            onMouseLeave: this.onMouseLeave,
	                            openInNewWindow: true })
	                    )
	                )
	            )
	        );
	
	        if (this.props.paneType == 'tile') {
	            return tileReturnType;
	        } else if (this.props.paneType == 'tab') {
	            return tabReturnType;
	        }
	    }
	});
	
	module.exports = StandardTabPane;

/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	var _section = __webpack_require__(864);
	
	var _section2 = _interopRequireDefault(_section);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _setInterval = __webpack_require__(799);
	
	var _setInterval2 = _interopRequireDefault(_setInterval);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ApiMenu = _react2['default'].createClass({
	    displayName: 'ApiMenu',
	
	
	    propTypes: {
	        sections: _react2['default'].PropTypes.array.isRequired, // A list of objects formatted as { title, url, reference, items: [{ title, reference, url, subItems: [{ title, reference, url }] }] }
	        initiallyActiveSection: _react2['default'].PropTypes.string, // Reference of the section intially active
	        initiallyActiveItem: _react2['default'].PropTypes.string, // Reference of the section item initially active
	        initiallyActiveSubItem: _react2['default'].PropTypes.string, // Reference of the section sub item initially active
	        isInitiallyCollapsed: _react2['default'].PropTypes.bool
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            'isInitiallyCollapsed': false
	        };
	    },
	    getInitialState: function getInitialState() {
	        return {
	            isFixed: false,
	            isCollapsed: this.props.isInitiallyCollapsed,
	            activeSection: this.props.initiallyActiveSection,
	            activeItem: this.props.initiallyActiveItem,
	            activeSubItem: this.props.initiallyActiveSubItem
	        };
	    },
	    stickMenu: function stickMenu() {
	        this.setState({
	            'isFixed': true
	        });
	    },
	    unstickMenu: function unstickMenu() {
	        this.setState({
	            'isFixed': false
	        });
	    },
	    startHashSpy: function startHashSpy(interval) {
	
	        var self = this;
	
	        // NOTE: Initialize to null so we detect a 'changed' event right after loading the page
	        this.__hash = null;
	        this.__ref = null;
	
	        var getSelectionFromRef = function getSelectionFromRef(ref) {
	            var selection = {
	                'activeSection': undefined,
	                'activeItem': undefined,
	                'activeSubItem': undefined
	            };
	
	            var s;
	            var i;
	            var j;
	            var k;
	            for (i = 0; i < self.props.sections.length; i++) {
	                s = self.props.sections[i];
	
	                // Try to match a section
	                if (s.reference.toLowerCase() == ref) {
	                    selection.activeSection = ref;
	                }
	
	                // Try to match a section item
	                if (!selection.activeSection && s.items && s.items.length > 0) {
	                    for (j = 0; j < s.items.length; j++) {
	                        if (s.items[j].reference.toLowerCase() == ref) {
	                            selection.activeSection = s.reference;
	                            selection.activeItem = ref;
	                            break;
	                        }
	                    }
	                }
	
	                // Try to match a sub item if nothing else matched
	                if (!selection.activeSection) {
	                    for (j = 0; j < s.items.length; j++) {
	                        if (s.items[j].subItems && s.items[j].subItems.length > 0) {
	                            for (k = 0; k < s.items[j].subItems.length; k++) {
	                                if (s.items[j].subItems[k].reference.toLowerCase() == ref) {
	                                    selection.activeSection = s.reference;
	                                    selection.activeItem = s.items[j].reference;
	                                    selection.activeSubItem = s.items[j].subItems[k].reference;
	                                    break;
	                                }
	                            }
	                        }
	                        if (selection.activeSection) {
	                            break;
	                        }
	                    }
	                }
	
	                // Match found
	                if (selection.activeSection) {
	                    break;
	                }
	            }
	
	            // Update menu selection
	            if (selection.activeSection) {
	
	                var newStates = _hfReactHelper2['default'].extend(selection, {
	                    'isFixed': self.state.isFixed
	                });
	                self.setState(newStates);
	            }
	        };
	
	        // Listen for for hash changes
	        (0, _setInterval2['default'])(function () {
	
	            var h = document.location.hash;
	            if (h != self.__hash) {
	
	                self.__hash = h;
	
	                var path = document.location.pathname.split('/').pop();
	                var ref = h ? h.replace('#', '') : path;
	                if (!h && path == 'documentation') {
	                    ref = 'quickstart';
	                } else if (ref) {
	                    ref = ref.toLowerCase();
	                }
	
	                getSelectionFromRef(ref);
	            }
	        }, interval);
	
	        // Listen for selection change from scrolling
	        $(document).bind('menu_selection_change', function (evt, evtData) {
	            if (evtData && evtData.ref && (!this.__ref || evtData.ref != this.__ref)) {
	                getSelectionFromRef(evtData.ref.toLowerCase());
	                this.__ref = evtData.ref;
	            }
	        });
	    },
	
	
	    /**
	     * If user scrolls down a certain distance, update this.state.isFixed to
	     * true. Also, if the window is smaller than the menu, the menu should be
	     * fixed, otherwise you the user can't see the whole menu without scrolling
	     * all the way down the page.
	    */
	    startStickinessSpy: function startStickinessSpy(interval) {
	
	        var self = this;
	        var lastTopOffset = 0;
	        var fixedPadding = 16;
	        var fixed = false;
	        var menu = $(_reactDom2['default'].findDOMNode(this));
	
	        var el = $(document.body);
	        var ua = navigator.userAgent.toLocaleLowerCase();
	        if (/firefox/.test(ua) || /msie/.test(ua) || /Windows NT 6.3.*rv\:11\.0/gi.test(ua)) {
	            // Special case for FF and IE (scrollTop is defined on html and not body)
	            el = $('html');
	        }
	
	        (0, _setInterval2['default'])(function () {
	
	            var topOffset = el.scrollTop();
	
	            if (topOffset != lastTopOffset) {
	
	                lastTopOffset = topOffset;
	                var menuContainer = $('#api-docs-menu-container');
	                var componentHeight = self.refs.apiDocMenu.scrollHeight;
	                var windowHeight = window.innerHeight;
	
	                var shouldEnableStick = !fixed && topOffset > menuContainer.offset().top - fixedPadding && windowHeight > componentHeight;
	
	                var shouldDisableStick = fixed && topOffset <= menuContainer.offset().top - fixedPadding;
	
	                if (shouldEnableStick) {
	                    self.stickMenu(menu);
	                    fixed = true;
	                }
	
	                if (shouldDisableStick) {
	                    self.unstickMenu(menu);
	                    fixed = false;
	                }
	            }
	        }, interval);
	    },
	    startScrollSpy: function startScrollSpy(interval) {
	
	        var sections = $('.m-api-docs-section, .m-api-ref-section, .m-api-docs-sub-section[id]');
	        var hasRefSections = {};
	        var hasSubSections = {};
	        var currentSection = null;
	        var w = $(window);
	
	        sections.each(function () {
	            var el = $(this);
	            var ref = el.attr('id');
	            if ($('.m-api-ref-section', el).length > 0) {
	                hasRefSections[ref] = true;
	            }
	            if ($('.m-api-docs-sub-section[id]', el).length > 0) {
	                hasSubSections[ref] = true;
	            }
	        });
	
	        (0, _setInterval2['default'])(function () {
	
	            var t;
	            var top = w.scrollTop();
	
	            // Check if it has changed before doing anything
	            if (currentSection !== null) {
	                var r = currentSection.attr('id');
	                if (!hasSubSections[r] && !hasRefSections[r]) {
	                    t = currentSection.offset().top;
	                    if (top >= t && top < t + currentSection.height()) {
	                        // No change
	                        return;
	                    }
	                }
	            }
	
	            // Reset current selection
	            currentSection = null;
	
	            var s;
	            var delta = void 0;
	            for (var i = 0; i < sections.length; i++) {
	
	                s = $(sections[i]);
	                t = s.offset().top;
	
	                if (top >= t && top < t + s.height() && (delta === null || Math.abs(top - t) < delta)) {
	
	                    var ref = s.attr('id');
	
	                    delta = Math.abs(top - t);
	                    currentSection = s;
	
	                    if (hasRefSections[ref] || hasSubSections[ref]) {
	                        // Keep going there could be a sub section that's a better match
	                        continue;
	                    } else {
	                        break;
	                    }
	                }
	            }
	
	            if (currentSection !== null) {
	                // Update menu
	                $(document).trigger('menu_selection_change', { 'ref': currentSection.attr('id') });
	            }
	        }, interval);
	    },
	
	
	    /**
	     * After component mounts, initialize spies
	    */
	    componentDidMount: function componentDidMount() {
	        this.startHashSpy(200);
	        this.startScrollSpy(100);
	        this.startStickinessSpy(100);
	    },
	    renderApiMenuSections: function renderApiMenuSections(section) {
	        var isActive = this.state.activeSection && this.state.activeSection.toLowerCase() == section.reference.toLowerCase();
	        var isCollapsed = !isActive && section.items && this.state.isCollapsed;
	
	        return _react2['default'].createElement(_section2['default'], {
	            key: 'section_' + section.reference,
	            title: section.title,
	            reference: section.reference,
	            url: section.url,
	            items: section.items,
	            initiallyActiveItem: this.state.activeItem,
	            initiallyActiveSubItem: this.state.activeSubItem,
	            isInitiallyActive: isActive,
	            isInitiallyCollapsed: isCollapsed,
	            menuIsFixed: this.state.isFixed });
	    },
	    render: function render() {
	        var sections = this.props.sections.map(this.renderApiMenuSections);
	        var classes = (0, _classnames2['default'])({
	            'l-api-docs-menu': true,
	            'is-fixed': this.state.isFixed
	        });
	
	        return _react2['default'].createElement(
	            'div',
	            { ref: 'apiDocMenu', className: classes },
	            sections
	        );
	    }
	});
	
	module.exports = ApiMenu;

/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sectionItem = __webpack_require__(865);
	
	var _sectionItem2 = _interopRequireDefault(_sectionItem);
	
	var _adjustScrollingMixin = __webpack_require__(866);
	
	var _adjustScrollingMixin2 = _interopRequireDefault(_adjustScrollingMixin);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ApiMenuSection = _react2['default'].createClass({
	    displayName: 'ApiMenuSection',
	
	
	    mixins: [_adjustScrollingMixin2['default']],
	
	    propTypes: {
	        title: _react2['default'].PropTypes.string.isRequired,
	        url: _react2['default'].PropTypes.string,
	        reference: _react2['default'].PropTypes.string.isRequired,
	        items: _react2['default'].PropTypes.array,
	        initiallyActiveItem: _react2['default'].PropTypes.string,
	        initiallyActiveSubItem: _react2['default'].PropTypes.string,
	        isInitiallyActive: _react2['default'].PropTypes.bool,
	        isInitiallyCollapsed: _react2['default'].PropTypes.bool.isRequired,
	        menuIsFixed: _react2['default'].PropTypes.bool
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            isActive: this.props.isInitiallyActive,
	            isCollapsed: this.props.isInitiallyCollapsed,
	            activeItem: this.props.initiallyActiveItem,
	            activeSubItem: this.props.initiallyActiveSubItem
	        };
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	        this.setState({
	            'isActive': newProps.isInitiallyActive,
	            'isCollapsed': newProps.isInitiallyCollapsed,
	            'activeItem': newProps.initiallyActiveItem,
	            'activeSubItem': newProps.initiallyActiveSubItem
	        });
	    },
	    componentDidUpdate: function componentDidUpdate() {
	        this.adjustScrolling();
	    },
	    toggleSection: function toggleSection() {
	        this.setState({
	            'isCollapsed': !this.state.isCollapsed
	        });
	    },
	    render: function render() {
	
	        var title = this.props.title;
	
	        var classes = (0, _classnames2['default'])({
	            'l-api-docs-menu--section': true,
	            'small-6': true,
	            'medium-12': true,
	            'large-12': true,
	            'is-active': this.state.isActive,
	            'is-expandable': this.props.items && this.props.items.length > 0,
	            'is-collapsed': this.state.isCollapsed
	        });
	
	        var items = this.props.items ? this.props.items.map(function (item) {
	
	            var isActive = this.state.activeItem != null && this.state.activeItem.toLowerCase() == item.reference.toLowerCase();
	
	            return _react2['default'].createElement(_sectionItem2['default'], {
	                key: 'item_' + item.reference,
	                title: item.title,
	                reference: item.reference,
	                url: item.url,
	                subItems: item.subItems,
	                initiallyActiveSubItem: this.state.activeSubItem,
	                isInitiallyActive: isActive });
	        }.bind(this)) : null;
	
	        return _react2['default'].createElement(
	            'div',
	            { className: classes, 'data-ref': this.props.reference },
	            _react2['default'].createElement(
	                'div',
	                { className: 'l-api-docs-menu--section--title', onClick: items ? this.toggleSection : null },
	                title
	            ),
	            items && items.length ? _react2['default'].createElement(
	                'div',
	                { className: 'l-api-docs-menu--items' },
	                items
	            ) : null
	        );
	    }
	});
	
	module.exports = ApiMenuSection;

/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _adjustScrollingMixin = __webpack_require__(866);
	
	var _adjustScrollingMixin2 = _interopRequireDefault(_adjustScrollingMixin);
	
	var _sectionSubItem = __webpack_require__(867);
	
	var _sectionSubItem2 = _interopRequireDefault(_sectionSubItem);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ApiMenuSectionItem = _react2['default'].createClass({
	    displayName: 'ApiMenuSectionItem',
	
	
	    mixins: [_adjustScrollingMixin2['default']],
	
	    propTypes: {
	        title: _react2['default'].PropTypes.string.isRequired,
	        reference: _react2['default'].PropTypes.string.isRequired,
	        url: _react2['default'].PropTypes.string.isRequired,
	        subItems: _react2['default'].PropTypes.array,
	        initiallyActiveSubItem: _react2['default'].PropTypes.string,
	        isInitiallyActive: _react2['default'].PropTypes.bool,
	        isInitiallyExpanded: _react2['default'].PropTypes.bool
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            'isActive': this.props.isInitiallyActive,
	            'isExpanded': this.props.isInitiallyExpanded || this.props.isInitiallyActive,
	            'activeSubItem': this.props.initiallyActiveSubItem
	        };
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	        this.setState({
	            'isActive': newProps.isInitiallyActive,
	            'isExpanded': newProps.isInitiallyExpanded,
	            'activeSubItem': newProps.initiallyActiveSubItem
	        });
	    },
	    componentDidUpdate: function componentDidUpdate() {
	        this.adjustScrolling();
	    },
	    expand: function expand() {
	        this.setState({
	            'isExpanded': !this.state.isExpanded
	        });
	    },
	    render: function render() {
	
	        var arrow = this.props.subItems ? _react2['default'].createElement('span', { className: 'l-api-docs-menu--arrow', onClick: this.expand }) : null;
	
	        var classes = (0, _classnames2['default'])({
	            'l-api-docs-menu--items--item': true,
	            'is-active': this.state.isActive,
	            'is-expanded': this.state.isActive || this.state.isExpanded,
	            'is-expandable': this.props.subItems && this.props.subItems.length > 0
	        });
	
	        var subItems = this.props.subItems ? this.props.subItems.map(function (subItem) {
	
	            var isActive = this.state.activeSubItem != null && this.state.activeSubItem.toLowerCase() == subItem.reference.toLowerCase();
	
	            return _react2['default'].createElement(_sectionSubItem2['default'], {
	                key: 'sub_item_' + subItem.reference,
	                title: subItem.title,
	                reference: subItem.reference,
	                url: subItem.url,
	                isInitiallyActive: isActive });
	        }.bind(this)) : null;
	
	        return _react2['default'].createElement(
	            'div',
	            { className: classes, 'data-ref': this.props.reference },
	            arrow,
	            _react2['default'].createElement(
	                'a',
	                { href: this.props.url },
	                this.props.title
	            ),
	            subItems && subItems.length ? _react2['default'].createElement(
	                'div',
	                { className: 'l-api-docs-menu--sub-items' },
	                subItems
	            ) : null
	        );
	    }
	});
	
	module.exports = ApiMenuSectionItem;

/***/ },
/* 866 */
/***/ function(module, exports) {

	'use strict';
	
	//  ----------  MENU  -------------------------------------
	
	var AdjustScrollingMixin = {
	    adjustScrolling: function adjustScrolling() {
	
	        var footer = $('.l-footer');
	        var menu = $('.l-api-docs-menu');
	        var isFixed = menu.attr('class').includes('is-fixed');
	        var threshold = 50;
	        var defaultMenuTop = 100;
	        var footerTop = footer.offset().top;
	        var menuBottom = menu.offset().top + menu.height();
	
	        var menuTop = parseInt(menu.css('top'), 10);
	        var delta = Math.round(footerTop - menuBottom);
	
	        if (!isFixed) {
	            menu.css('top', '');
	        } else if (delta < threshold) {
	            // Move menu up
	            menu.css('top', menuTop - (threshold - delta));
	        } else if (menuTop < defaultMenuTop) {
	            // Move menu down
	            menu.css('top', menuTop + (footerTop - threshold - menuBottom));
	        }
	    }
	};
	
	module.exports = AdjustScrollingMixin;

/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ApiMenuSectionSubItem = _react2['default'].createClass({
	    displayName: 'ApiMenuSectionSubItem',
	
	
	    propTypes: {
	        title: _react2['default'].PropTypes.string.isRequired,
	        reference: _react2['default'].PropTypes.string.isRequired,
	        url: _react2['default'].PropTypes.string.isRequired,
	        isInitiallyActive: _react2['default'].PropTypes.bool
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            'isActive': this.props.isInitiallyActive
	        };
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	        this.setState({
	            'isActive': newProps.isInitiallyActive
	        });
	    },
	    render: function render() {
	
	        var classes = (0, _classnames2['default'])({
	            'l-api-docs-menu--sub-items--sub-item': true,
	            'is-active': this.state.isActive
	        });
	
	        return _react2['default'].createElement(
	            'div',
	            { className: classes, 'data-ref': this.props.reference },
	            _react2['default'].createElement(
	                'a',
	                { href: this.props.url },
	                this.props.title
	            )
	        );
	    }
	});
	
	module.exports = ApiMenuSectionSubItem;

/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	//  ----------  CODE EXAMPLES  ----------------------------
	
	var CodeTabPane = _react2['default'].createClass({
	    displayName: 'CodeTabPane',
	
	
	    propTypes: {
	        languageName: _react2['default'].PropTypes.string.isRequired,
	        codeStringLines: _react2['default'].PropTypes.array.isRequired,
	        codeClassNames: _react2['default'].PropTypes.string
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            'codeClassNames': ''
	        };
	    },
	    render: function render() {
	
	        var classes = (0, _classnames2['default'])('m-code-example', this.props.languageName.replace(/\#|\./g, ''));
	        var preClasses = (0, _classnames2['default'])('m-code-example--code', 'prettyprint', this.props.codeClassNames);
	
	        return _react2['default'].createElement(
	            'div',
	            { className: classes },
	            _react2['default'].createElement(
	                'pre',
	                { className: preClasses },
	                this.props.codeStringLines.join('\n').replace(/\&quot\;/g, '"')
	            )
	        );
	    }
	});
	
	module.exports = CodeTabPane;

/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var CodeContainer = _react2['default'].createClass({
	    displayName: 'CodeContainer',
	
	
	    propTypes: {
	        codeStringLines: _react2['default'].PropTypes.array.isRequired,
	        classNames: _react2['default'].PropTypes.string
	    },
	
	    render: function render() {
	        var lines = this.props.codeStringLines.join('\n').replace(/\&quot\;/g, '"');
	        return _react2['default'].createElement(
	            'pre',
	            { className: this.props.classNames },
	            lines
	        );
	    }
	});
	
	var CodeTabPaneWithResponse = _react2['default'].createClass({
	    displayName: 'CodeTabPaneWithResponse',
	
	
	    propTypes: {
	        languageName: _react2['default'].PropTypes.string.isRequired,
	        requestCodeStringLines: _react2['default'].PropTypes.array.isRequired,
	        responseCodeStringLines: _react2['default'].PropTypes.array.isRequired,
	        containerClassNames: _react2['default'].PropTypes.string,
	        codeClassNames: _react2['default'].PropTypes.string,
	        isCollapsed: _react2['default'].PropTypes.bool
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            'containerClassNames': '',
	            'codeClassNames': '',
	            'isCollapsed': true
	        };
	    },
	    getInitialState: function getInitialState() {
	        return {
	            isCollapsed: this.props.isCollapsed
	        };
	    },
	    toggleResponse: function toggleResponse(evt) {
	        evt.preventDefault();
	        this.setState({
	            'isCollapsed': !this.state.isCollapsed
	        });
	    },
	    render: function render() {
	
	        var classes = [(0, _classnames2['default'])({
	            'm-code-example': true,
	            'with-response': true,
	            'is-collapsed': this.state.isCollapsed
	        }), this.props.containerClassNames].join(' ');
	
	        var reqClassNames = [(0, _classnames2['default'])({
	            'm-code-example--code': true,
	            'prettyprint': true
	        }), this.props.codeClassNames].join(' ');
	
	        var respClassNames = [(0, _classnames2['default'])({
	            'm-code-example--code--json': true
	        }), this.props.codeClassNames].join(' ');
	
	        var request = _react2['default'].createElement(CodeContainer, { classNames: reqClassNames, codeStringLines: this.props.requestCodeStringLines });
	        var response = '';
	
	        // TODO: At some point, we'll want to create custom "response" examples
	        // for each wrapper. For now, since the response is JSON, let's only display
	        // this if the example is using cURL. -Chris (5/21/15)
	        if (this.props.languageName === 'curl') {
	            response = _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(CodeContainer, { classNames: respClassNames, codeStringLines: this.props.responseCodeStringLines }),
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'm-code-example--expand-link', onClick: this.toggleResponse },
	                    _react2['default'].createElement(
	                        'span',
	                        { className: 'm-code-example--expand-link--dots' },
	                        '...'
	                    ),
	                    _react2['default'].createElement(
	                        'a',
	                        { className: 'm-code-example--expand-link--link', href: '#' },
	                        'Show response'
	                    )
	                )
	            );
	        }
	
	        return _react2['default'].createElement(
	            'div',
	            { className: classes },
	            request,
	            response
	        );
	    }
	});
	
	module.exports = CodeTabPaneWithResponse;

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _imageModal = __webpack_require__(871);
	
	var _imageModal2 = _interopRequireDefault(_imageModal);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ImageModalTrigger = _react2['default'].createClass({
	    displayName: 'ImageModalTrigger',
	
	
	    propTypes: {
	        'imagePath': _react2['default'].PropTypes.string,
	        'classNames': _react2['default'].PropTypes.string
	    },
	
	    handleClick: function handleClick(e) {
	        if (e != null) {
	            e.preventDefault();
	        }
	        var attachPoint = _hfReactHelper2['default'].getRevealAttachPoint('image_modal', 'small', true, 'l-margin-t--80 text-center');
	        _reactDom2['default'].unmountComponentAtNode(attachPoint);
	        _reactDom2['default'].render(_react2['default'].createElement(_imageModal2['default'], { imagePath: this.props.imagePath }), attachPoint);
	    },
	    render: function render() {
	        return _react2['default'].createElement(
	            'span',
	            { onClick: this.handleClick },
	            _react2['default'].createElement('img', { src: this.props.imagePath, className: this.props.classNames, style: { cursor: 'pointer' } })
	        );
	    }
	});
	
	module.exports = ImageModalTrigger;

/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ImageModal = _react2['default'].createClass({
	    displayName: 'ImageModal',
	
	
	    propTypes: {
	        'imagePath': _react2['default'].PropTypes.string
	    },
	
	    componentDidMount: function componentDidMount() {
	        if (true) {
	            $(document).foundation();
	            $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
	        }
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	        if (true) {
	            $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
	        }
	    },
	    render: function render() {
	        return _react2['default'].createElement('img', { src: this.props.imagePath });
	    }
	});
	
	module.exports = ImageModal;

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _createAccountForm = __webpack_require__(873);
	
	var _createAccountForm2 = _interopRequireDefault(_createAccountForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var CreateAccount = _react2['default'].createClass({
	    displayName: 'CreateAccount',
	
	
	    propTypes: {
	        'header': _react2['default'].PropTypes.string.isRequired,
	        'googleOpenIdUrl': _react2['default'].PropTypes.string,
	        'isFromApiPricing': _react2['default'].PropTypes.bool,
	        'isInline': _react2['default'].PropTypes.bool,
	        'isVertical': _react2['default'].PropTypes.bool, // only for inline
	        'inlineSideText': _react2['default'].PropTypes.string,
	        'tabOffset': _react2['default'].PropTypes.number,
	        'signupForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
	        'signupUrl': _react2['default'].PropTypes.string,
	        'redirectUrl': _react2['default'].PropTypes.string,
	        'recoverPasswordForm': _react2['default'].PropTypes.object, // Serialized sfForm
	        'loginForm': _react2['default'].PropTypes.object, // Serialized sfForm
	        'hideRememberMe': _react2['default'].PropTypes.bool,
	        'hideGoogleOpenId': _react2['default'].PropTypes.bool,
	        'async': _react2['default'].PropTypes.bool
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            'signupUrl': '/account/signUp'
	        };
	    },
	    getInitialState: function getInitialState() {
	        return {
	            'password': '',
	            'emailAddress': '',
	            'isProcessing': false,
	            'isInline': false,
	            'isVertical': false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        if (!this.props.isInline && ("production") !== 'test') {
	            $(document).foundation();
	            $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
	        }
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (!nextProps.isInline && ("production") !== 'test') {
	            $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
	        }
	    },
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(_createAccountForm2['default'], {
	                header: this.props.header,
	                buttonText: this.props.buttonText,
	                isInline: this.props.isInline,
	                isVertical: this.props.isVertical,
	                inlineSideText: this.props.inlineSideText,
	                googleOpenIdUrl: this.props.googleOpenIdUrl,
	                redirectUrl: this.props.redirectUrl,
	                isFromApiPricing: this.props.isFromApiPricing,
	                planId: this.props.planId,
	                tabOffset: this.props.tabOffset,
	                fields: this.props.signupForm.fields,
	                values: this.props.signupForm.values,
	                namespace: this.props.signupForm.namespace,
	                action: this.props.signupUrl,
	                recoverPasswordForm: this.props.recoverPasswordForm,
	                loginForm: this.props.loginForm,
	                hideRememberMe: this.props.hideRememberMe,
	                hideGoogleOpenId: this.props.hideGoogleOpenId,
	                async: this.props.async })
	        );
	    }
	});
	
	module.exports = CreateAccount;

/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _baseForm = __webpack_require__(703);
	
	var _baseForm2 = _interopRequireDefault(_baseForm);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _googleLoginOrSignup = __webpack_require__(874);
	
	var _googleLoginOrSignup2 = _interopRequireDefault(_googleLoginOrSignup);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _setTimeout = __webpack_require__(718);
	
	var _setTimeout2 = _interopRequireDefault(_setTimeout);
	
	var _loginTrigger = __webpack_require__(875);
	
	var _loginTrigger2 = _interopRequireDefault(_loginTrigger);
	
	var _logger = __webpack_require__(482);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/* -----------  SIGNUP  ----------------------------------- */
	
	/**
	 * NOTE: This form does not follow the proper way to use
	 * React and Symfony Forms, a better example can be found
	 * by looking at ForgotPasswordForm
	 */
	
	function getDefaultGoogleOpenIdUrl() {
	    // encode '/' endpoint -- we'd use btoa, except IE10 and below doesn't support it
	    var redirectUrl = 'Lw==';
	    return '/account/openid/connect/google?on_login_redirect_url=' + redirectUrl;
	}
	
	var CreateAccountForm = _baseForm2['default'].createFormClass({
	
	    displayName: 'CreateAccountForm',
	
	    propTypes: {
	        'header': _react.PropTypes.string,
	        'buttonText': _react.PropTypes.string,
	        'isInline': _react.PropTypes.bool,
	        'isVertical': _react.PropTypes.bool, // only works for inline
	        'inlineSideText': _react.PropTypes.string,
	        'googleOpenIdUrl': _react.PropTypes.string,
	        'redirectUrl': _react.PropTypes.string,
	        'isFromApiPricing': _react.PropTypes.bool,
	        'planId': _react.PropTypes.string,
	        'tabOffset': _react.PropTypes.number,
	        'async': _react.PropTypes.bool,
	        'recoverPasswordForm': _react.PropTypes.object, // Serialized sfForm
	        'loginForm': _react.PropTypes.object, // Serialized sfForm
	        'hideRememberMe': _react.PropTypes.bool,
	        'hideGoogleOpenId': _react.PropTypes.bool
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            'async': true,
	            'googleOpenIdUrl': getDefaultGoogleOpenIdUrl()
	        };
	    },
	    getInitialState: function getInitialState() {
	        return {
	            'errors': this.props.errors,
	            'emailAddress': '',
	            'isProcessing': false,
	            'isInline': false,
	            'isVertical': false,
	            'isOptedIn': true
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        _logger2['default'].track('CreateAccountForm.componentDidMount', {
	            location: location.pathname
	        });
	
	        if (!this.props.isInline) {
	            // This is a modal, so focus on the email address input element
	            (0, _setTimeout2['default'])(function () {
	                $(_reactDom2['default'].findDOMNode(this)).find('input[name="signup[email_address]"]').focus();
	            }.bind(this), 500);
	        }
	    },
	    onEmailChange: function onEmailChange(event) {
	        this.setState({
	            'emailAddress': event.target.value.trim()
	        });
	    },
	    onOptInChange: function onOptInChange(event) {
	        this.setState({
	            'isOptedIn': event.target.checked
	        });
	    },
	    onSubmit: function onSubmit(evt) {
	        evt.preventDefault();
	
	        if (this.state.isProcessing === false) {
	
	            // Retrieve the values from the email field one more time
	            // prior to submit. This fixes an issue where Safari auto-complete
	            // would not trigger the on*Change events for these fields.
	            var root = _reactDom2['default'].findDOMNode(this);
	            var emailAddress = $('#sign_up_email_address_input', root).val();
	
	            this.setState({
	                'errors': null,
	                'isProcessing': true,
	                'emailAddress': emailAddress
	            });
	
	            if (!_hfReactHelper2['default'].isValidEmailAddress(emailAddress)) {
	
	                this.setState({
	                    'errors': { 'named': { 'email_address': 'Invalid email address' } },
	                    'isProcessing': false
	                });
	            } else if (!this.props.async) {
	                _logger2['default'].track('CreateAccountForm._onSubmit');
	                // Inline submit
	                $('#sign_up_form', root).submit();
	            } else {
	
	                // Async submit
	                this.submitAsync(function (resp) {
	
	                    this.setState({
	                        'isProcessing': false
	                    });
	
	                    // Display notification
	                    if (resp.notification) {
	                        hellofaxJS.createNotification({
	                            'text': resp.notification.message,
	                            'class_name': resp.notification.type
	                        });
	                    }
	
	                    // Close the signup modal and show the login one
	                    if (resp.show_login_form) {
	                        $('.m-modal--close', '#create_account_modal').click();
	                        $(document).trigger('login-trigger', { 'displayCaptcha': resp.display_captcha });
	                        return;
	                    }
	
	                    // Redirect to redirect_url
	                    if (resp.success === true) {
	                        _logger2['default'].track('CreateAccountForm._onSubmit');
	                        if (resp.redirect_url) {
	                            document.location = resp.redirect_url;
	                        }
	                    }
	
	                    // Failure
	                    if (!resp.success) {
	
	                        // Display error message
	                        if (resp.error && !resp.notification_message) {
	                            this.setState({
	                                'errors': { 'global': resp.error.message }
	                            });
	                        }
	                    }
	                }, function () {
	
	                    // Unexpected error
	                    this.setState({
	                        'errors': { 'global': 'An unexpected error occurred' },
	                        'isProcessing': false
	                    });
	                });
	            }
	        }
	
	        return false;
	    },
	    render: function render() {
	        var isVertical = !this.props.isInline || this.props.isVertical; // is vertical (even if not inline)
	        var tabOffset = parseInt(this.props.tabOffset || 0, 10);
	        var rowClassNames = (0, _classnames2['default'])({
	            'row': true,
	            'text-center': true,
	            'bg-plume': this.props.isInline ? true : false,
	            'm-create-account--inline-container': this.props.isInline && !this.props.isVertical,
	            'm-create-account--inline-container-vertical': this.props.isInline && this.props.isVertical,
	            'l-padding-v-20': this.props.isInline ? true : false
	        });
	
	        var includeInlineText = function includeInlineText(text) {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'm-create-account--login-side-text columns small-12 large-4 l-margin-v-20 ' },
	                _react2['default'].createElement(
	                    'h2',
	                    { className: 'c-ashen' },
	                    text
	                )
	            );
	        };
	
	        var formColumnClassNames = (0, _classnames2['default'])({
	            'text-left m-create-account--sign-up': !isVertical,
	            'columns small-12 l-margin-v-20 text-center': true,
	            'large-5 large-left': !isVertical
	        });
	        var buttonColumnClassNames = (0, _classnames2['default'])({
	            'columns small-12 l-margin-v-20 text-center': true,
	            'large-3 large-left': !isVertical,
	            'm-create-account--inline-google-login': !isVertical,
	            'm-create-account--modal-google-login': isVertical
	        });
	        var submitButtonClassNames = (0, _classnames2['default'])({
	            'm-create-account--inline-create-account-button': !isVertical,
	            'm-create-account--modal-create-account-button': isVertical
	        });
	
	        var redirectUrl;
	        if (this.props.redirectUrl) {
	            redirectUrl = _react2['default'].createElement('input', { type: 'hidden', name: 'signup[redirect_url]', value: this.props.redirectUrl });
	        }
	
	        var isFromApiPricing;
	        if (this.props.isFromApiPricing) {
	            isFromApiPricing = _react2['default'].createElement('input', { type: 'hidden', name: 'is_from_api_pricing', value: this.props.isFromApiPricing ? '1' : '' });
	        }
	
	        var planId;
	        if (this.props.planId) {
	            planId = _react2['default'].createElement('input', { type: 'hidden', name: 'plan_id', value: this.props.planId });
	        }
	
	        var errors;
	        if (this.state.errors) {
	            errors = _react2['default'].createElement(
	                'div',
	                { className: 'row' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'columns l-margin-b-10 small-10 small-offset-1 text-center m-modal--error' },
	                    this.renderErrorText()
	                )
	            );
	        }
	
	        var buttonText = this.props.buttonText ? this.props.buttonText : 'SIGN UP FREE';
	        if (this.state.isProcessing) {
	            buttonText = 'PROCESSING...';
	        }
	
	        var loginUrl = _hfReactHelper2['default'].urlHelper('account/logIn');
	        var loginTrigger, loginPrompt;
	        if (this.props.loginForm) {
	            var loginTrigger = _react2['default'].createElement(_loginTrigger2['default'], {
	                linkText: 'Login',
	                buttonText: 'Sign In',
	                header: 'Welcome back',
	                googleOpenIdUrl: this.props.googleOpenIdUrl,
	                loginUrl: loginUrl,
	                redirectUrl: this.props.redirectUrl,
	                recoverPasswordForm: this.props.recoverPasswordForm,
	                loginForm: this.props.loginForm,
	                hideRememberMe: this.props.hideRememberMe,
	                hideGoogleOpenId: this.props.hideGoogleOpenId });
	
	            var loginPrompt = _react2['default'].createElement(
	                'div',
	                { className: 'columns small-12' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-create-account--login-prompt' },
	                    'Already have an account? ',
	                    loginTrigger
	                )
	            );
	        }
	
	        var googleOpenId;
	        if (!this.props.hideGoogleOpenId) {
	            var googleLoginImage = _react2['default'].createElement(
	                'div',
	                { className: !isVertical ? 'm-create-account--inline-google-login-border' : 'm-create-account--modal-google-login-border' },
	                _react2['default'].createElement('div', { className: !isVertical ? 'm-create-account--inline-google-login-or-image' : 'm-create-account--modal-google-login-or-image' })
	            );
	            googleOpenId = _react2['default'].createElement(
	                'div',
	                { className: buttonColumnClassNames },
	                this.props.fields ? googleLoginImage : null,
	                _react2['default'].createElement(
	                    'div',
	                    { className: !isVertical ? 'm-create-account--inline-google-login-button' : 'm-create-account--modal-google-login-button' },
	                    _react2['default'].createElement(_googleLoginOrSignup2['default'], {
	                        openIdUrl: this.props.googleOpenIdUrl,
	                        isOptedIn: this.state.isOptedIn,
	                        isLogIn: false })
	                )
	            );
	        }
	        var signupForm = _react2['default'].createElement(
	            'div',
	            { className: formColumnClassNames },
	            _react2['default'].createElement(
	                'div',
	                { className: 'small-10 small-offset-1 text-center' },
	                this.renderField('email_address', {
	                    'id': 'sign_up_email_address_input',
	                    'className': 'm-create-account--text-input ' + (isVertical ? 'm-create-account--email-vertical' : ''),
	                    'maxLength': '99',
	                    'placeholder': 'Enter your email',
	                    'onChange': this.onEmailChange,
	                    'tabIndex': tabOffset,
	                    'data-format': 'email'
	                })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'small-10 small-offset-1 small-text-left' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-create-account--opt-in-container' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-create-account--opt-in-align' + (isVertical ? '-vertical' : '') },
	                        _react2['default'].createElement(
	                            'label',
	                            null,
	                            this.renderField('is_opted_in_marketing_emails', {
	                                'className': 'm-create-account--text-input',
	                                'defaultChecked': 'checked',
	                                'tabIndex': tabOffset + 2,
	                                'onChange': this.onOptInChange
	                            }),
	                            '\xA0Send me HelloSign updates'
	                        )
	                    )
	                )
	            ),
	            errors,
	            this.renderHiddenFields(),
	            _react2['default'].createElement('input', { type: 'hidden', name: 'async', value: this.props.async ? '1' : '0' }),
	            _react2['default'].createElement('input', { type: 'hidden', name: 'force_delay_analytics_js', value: 'true' }),
	            _react2['default'].createElement(
	                'div',
	                { className: 'l-margin-b-10 small-10 small-offset-1 small-text-center ' + (!isVertical ? 'large-text-left' : '') },
	                _react2['default'].createElement(_button2['default'], { onClick: this.onSubmit,
	                    buttonClass: submitButtonClassNames,
	                    buttonText: buttonText,
	                    buttonColor: 'grasshopper',
	                    buttonHoverColor: 'castle-rock',
	                    buttonTabIndex: tabOffset + 3 })
	            )
	        );
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'm-create-account' },
	            _react2['default'].createElement(
	                'form',
	                { id: 'sign_up_form', className: 'm-create-account--form', action: this.props.action, method: 'POST' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: rowClassNames },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'columns small-12' },
	                        _react2['default'].createElement(
	                            'h4',
	                            null,
	                            this.props.header
	                        )
	                    ),
	                    !isVertical ? includeInlineText(this.props.inlineSideText) : '',
	                    googleOpenId,
	                    this.props.fields ? signupForm : null,
	                    isVertical && this.props.loginForm ? loginPrompt : ''
	                ),
	                redirectUrl,
	                isFromApiPricing,
	                planId
	            )
	        );
	    }
	});
	
	module.exports = CreateAccountForm;

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Deprecated in favor of GoogleSigninButton
	var GoogleLoginOrSignup = _react2['default'].createClass({
	    displayName: 'GoogleLoginOrSignup',
	
	
	    propTypes: {
	        'openIdUrl': _react2['default'].PropTypes.string.isRequired,
	        'isLogIn': _react2['default'].PropTypes.bool,
	        'isOptedIn': _react2['default'].PropTypes.bool
	    },
	
	    onClickHandler: function onClickHandler() {
	        var url = this.props.openIdUrl + '&optIn=' + (this.props.isOptedIn ? '1' : '0');
	        var w = window.open(url, '_blank', 'width=640, height=480');
	        window.hsGoogleOpenIdWindow = w;
	    },
	    render: function render() {
	        var classSet = (0, _classnames2['default'])({
	            'm-google-button': true,
	            'm-button': true
	        });
	        return _react2['default'].createElement(
	            'a',
	            { className: classSet, onClick: this.onClickHandler },
	            _react2['default'].createElement('i', null),
	            _react2['default'].createElement(
	                'span',
	                null,
	                this.props.isLogIn ? 'Sign in with Google' : 'Sign up with Google'
	            )
	        );
	    }
	});
	
	module.exports = GoogleLoginOrSignup;

/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _loginModal = __webpack_require__(876);
	
	var _loginModal2 = _interopRequireDefault(_loginModal);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var LogInTrigger = _react2['default'].createClass({
	    displayName: 'LogInTrigger',
	
	
	    propTypes: {
	        'header': _react2['default'].PropTypes.string.isRequired,
	        'linkText': _react2['default'].PropTypes.string,
	        'trigger': _react2['default'].PropTypes.element,
	        'googleOpenIdUrl': _react2['default'].PropTypes.string,
	        'buttonText': _react2['default'].PropTypes.string,
	        'tabOffset': _react2['default'].PropTypes.number,
	        'emailAddress': _react2['default'].PropTypes.string,
	        'loginUrl': _react2['default'].PropTypes.string.isRequired,
	        'redirectUrl': _react2['default'].PropTypes.string,
	        'recaptchaPublicKey': _react2['default'].PropTypes.string,
	        'displayCaptcha': _react2['default'].PropTypes.bool,
	        'recoverPasswordForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
	        'loginForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
	        'hideRememberMe': _react2['default'].PropTypes.bool,
	        'hideGoogleOpenId': _react2['default'].PropTypes.bool
	    },
	
	    componentDidMount: function componentDidMount() {
	
	        var self = this;
	
	        if (window.handlingLogInTriggers) {
	            // We only want to process this once per page
	            return;
	        }
	        // If the 'login=1' URL parameter is present, display the modal
	        if (/\?display_login\=1|&display_login\=1/i.test(location.href)) {
	            window.handlingLogInTriggers = true;
	            this.handleClick();
	        }
	
	        // Listen for trigger events
	        $(document).bind('login-trigger', function (evt, params) {
	            self.handleClick(null, null, {
	                'displayCaptcha': params && params.displayCaptcha || false
	            });
	        });
	    },
	    handleClick: function handleClick(evt, react_id, extraProps) {
	        var tabOffset = parseInt(this.props.tabOffset || 1000, 10);
	        var attachPoint = _hfReactHelper2['default'].getRevealAttachPoint('login_modal');
	        var props = extraProps ? _hfReactHelper2['default'].extend({}, this.props, extraProps) : this.props;
	        _reactDom2['default'].render(_react2['default'].createElement(_loginModal2['default'], {
	            header: props.header,
	            buttonText: props.buttonText,
	            googleOpenIdUrl: props.googleOpenIdUrl,
	            isFromApiPricing: props.isFromApiPricing,
	            tabOffset: tabOffset,
	            recaptchaPublicKey: props.recaptchaPublicKey,
	            displayCaptcha: props.displayCaptcha,
	            emailAddress: props.emailAddress,
	            loginUrl: props.loginUrl,
	            recoverPasswordForm: props.recoverPasswordForm,
	            redirectUrl: props.redirectUrl,
	            loginForm: props.loginForm,
	            hideRememberMe: props.hideRememberMe,
	            hideGoogleOpenId: props.hideGoogleOpenId }), attachPoint);
	    },
	    renderTrigger: function renderTrigger() {
	        if (this.props.trigger) {
	            return this.props.trigger;
	        } else {
	            return _react2['default'].createElement(
	                'a',
	                { href: '#' },
	                this.props.linkText
	            );
	        }
	    },
	    render: function render() {
	        return _react2['default'].createElement(
	            'span',
	            { className: 'log-in-trigger', onClick: this.handleClick },
	            this.renderTrigger()
	        );
	    }
	});
	
	module.exports = LogInTrigger;

/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _loginForm = __webpack_require__(877);
	
	var _loginForm2 = _interopRequireDefault(_loginForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LogInModal = function (_Component) {
	    _inherits(LogInModal, _Component);
	
	    function LogInModal(props) {
	        _classCallCheck(this, LogInModal);
	
	        var _this = _possibleConstructorReturn(this, (LogInModal.__proto__ || Object.getPrototypeOf(LogInModal)).call(this, props));
	
	        _this.state = {
	            'password': '',
	            'emailAddress': _this.props.emailAddress,
	            'isProcessing': false
	        };
	        return _this;
	    }
	
	    _createClass(LogInModal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (!this.props.isInline && this.isFoundationFriendly()) {
	                $(document).foundation();
	                $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (!nextProps.isInline && this.isFoundationFriendly()) {
	                $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
	            }
	        }
	
	        // Note: version 1.4.4 of jQuery is incompatible with Foundation.
	
	    }, {
	        key: 'isFoundationFriendly',
	        value: function isFoundationFriendly() {
	            return window.$ && $.fn.jquery !== '1.4.4';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var props = this.props;
	            var loginFormProps = {
	                header: props.header,
	                buttonText: props.buttonText,
	                isInline: props.isInline,
	                inlineSideText: props.inlineSideText,
	                googleOpenIdUrl: props.googleOpenIdUrl,
	                redirectUrl: props.redirectUrl,
	                recaptchaPublicKey: props.recaptchaPublicKey,
	                displayCaptcha: props.displayCaptcha,
	                isFromApiPricing: props.isFromApiPricing,
	                planId: props.planId,
	                tabOffset: props.tabOffset,
	                emailAddress: props.emailAddress,
	                recoverPasswordForm: props.recoverPasswordForm,
	                action: props.loginUrl,
	                fields: props.loginForm.fields,
	                values: props.loginForm.values,
	                namespace: props.loginForm.namespace,
	                hideRememberMe: props.hideRememberMe,
	                hideGoogleOpenId: props.hideGoogleOpenId
	            };
	
	            return _react2['default'].createElement(_loginForm2['default'], loginFormProps);
	        }
	    }]);
	
	    return LogInModal;
	}(_react.Component);
	
	LogInModal.propTypes = {
	    'header': _react.PropTypes.string.isRequired,
	    'googleOpenIdUrl': _react.PropTypes.string,
	    'tabOffset': _react.PropTypes.number,
	    'emailAddress': _react.PropTypes.string,
	    'loginUrl': _react.PropTypes.string,
	    'recaptchaPublicKey': _react.PropTypes.string,
	    'displayCaptcha': _react.PropTypes.bool,
	    'recoverPasswordForm': _react.PropTypes.object.isRequired, // Serialized sfForm
	    'loginForm': _react.PropTypes.object.isRequired, // Serialized sfForm
	    'redirectUrl': _react.PropTypes.string,
	    'hideRememberMe': _react.PropTypes.bool,
	    'hideGoogleOpenId': _react.PropTypes.bool
	};
	
	
	module.exports = LogInModal;

/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	var _forgotPasswordModal = __webpack_require__(878);
	
	var _forgotPasswordModal2 = _interopRequireDefault(_forgotPasswordModal);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _googleLoginOrSignup = __webpack_require__(874);
	
	var _googleLoginOrSignup2 = _interopRequireDefault(_googleLoginOrSignup);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _loginCaptcha = __webpack_require__(881);
	
	var _loginCaptcha2 = _interopRequireDefault(_loginCaptcha);
	
	var _setTimeout = __webpack_require__(718);
	
	var _setTimeout2 = _interopRequireDefault(_setTimeout);
	
	var _baseForm = __webpack_require__(703);
	
	var _baseForm2 = _interopRequireDefault(_baseForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * NOTE: This form does not follow the proper way to use
	 * React and Symfony Forms, a better example can be found
	 * by looking at ForgotPasswordForm
	 */
	var LogInForm = _baseForm2['default'].createFormClass({
	
	    displayName: 'LogInForm',
	
	    propTypes: {
	        'header': _react2['default'].PropTypes.string,
	        'buttonText': _react2['default'].PropTypes.string,
	        'googleOpenIdUrl': _react2['default'].PropTypes.string,
	        'redirectUrl': _react2['default'].PropTypes.string,
	        'onErrorRedirectUrl': _react2['default'].PropTypes.string,
	        'tabOffset': _react2['default'].PropTypes.number,
	        'closeAfterLogin': _react2['default'].PropTypes.bool,
	        'emailAddress': _react2['default'].PropTypes.string, // FIXME: Should be refactored to come from loginForm.values (same with errors instead of parsing if from the URL)
	        'recaptchaPublicKey': _react2['default'].PropTypes.string,
	        'displayCaptcha': _react2['default'].PropTypes.bool,
	        'recoverPasswordForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
	        'async': _react2['default'].PropTypes.bool,
	        'hideRememberMe': _react2['default'].PropTypes.bool,
	        'hideGoogleOpenId': _react2['default'].PropTypes.bool
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            'async': true,
	            'displayCaptcha': false,
	            'action': '/account/logIn'
	        };
	    },
	    getInitialState: function getInitialState() {
	        var emailAddress = this.props.emailAddress;
	        var href = decodeURIComponent(location.href);
	
	        var matches = href.match(/email\=([^&]+)/i);
	        if (matches && matches.length > 1) {
	            emailAddress = matches[1];
	        }
	
	        if (!emailAddress) {
	            matches = href.match(/login_default_email\=([^&]+)/i);
	            if (matches && matches.length > 1) {
	                emailAddress = matches[1];
	            }
	        }
	
	        var redirectUrl = this.props.redirectUrl;
	        if (!redirectUrl) {
	            matches = href.match(/on_login_redirect_url\=([^&]+)/i);
	            if (matches && matches.length > 1) {
	                redirectUrl = matches[1];
	            }
	        }
	
	        return {
	            'password': '',
	            'emailAddress': emailAddress,
	            'isProcessing': false,
	            'redirectUrl': redirectUrl,
	            'closeAfterLogin': /\?close_after_login\=1|&close_after_login\=1/i.test(href),
	            'isCaptchaDisplayed': this.props.displayCaptcha
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        var root = $(_reactDom2['default'].findDOMNode(this));
	        var emailInput = root.find('input[name=\'login[email_address]\']');
	        var pwdInput = root.find('input[name=\'login[password]\']');
	        if (emailInput.length === 1 && !this.state.emailAddress) {
	            (0, _setTimeout2['default'])(function () {
	                emailInput.focus();
	            }, 500);
	        } else if (this.state.emailAddress && pwdInput.length === 1) {
	            (0, _setTimeout2['default'])(function () {
	                pwdInput.focus();
	            }, 500);
	        }
	    },
	    onEmailChange: function onEmailChange(event) {
	        this.setState({
	            'emailAddress': event.target.value.trim()
	        });
	    },
	    onPasswordChange: function onPasswordChange(event) {
	        this.setState({
	            'password': event.target.value
	        });
	    },
	    onSubmit: function onSubmit(evt) {
	
	        evt.preventDefault();
	
	        if (this.state.isProcessing === false) {
	
	            // Retrieve the values from the email/password field one more time
	            // prior to submit. This fixes an issue where Safari auto-complete
	            // would not trigger the on*Change events for these fields.
	            var root = _reactDom2['default'].findDOMNode(this);
	            var minPasswordLength = _hfReactHelper2['default'].HfConstants.minPasswordLength;
	            var emailAddress = $('#login_email_address_input', root).val();
	            var password = $('#login_password_input', root).val();
	
	            this.setState({
	                'errors': null,
	                'isProcessing': true,
	                'emailAddress': emailAddress,
	                'password': password
	            });
	
	            if (!_hfReactHelper2['default'].isValidEmailAddress(emailAddress)) {
	
	                this.setState({
	                    'errors': { 'named': { 'email_address': 'Invalid email address' } },
	                    'isProcessing': false
	                });
	            } else if (password.length < minPasswordLength) {
	
	                this.setState({
	                    'errors': { 'named': { 'password': 'Your password must be at least ' + minPasswordLength + ' characters long' } },
	                    'isProcessing': false
	                });
	            } else if (!this.props.async) {
	
	                // Inline submit
	                $('#login_form', root).submit();
	            } else {
	
	                // Async submit
	                this.submitAsync(function (resp) {
	
	                    this.setState({
	                        'isProcessing': false
	                    });
	
	                    // Close the login modal
	                    if (resp.success) {
	                        $('.m-modal--close', '#login_modal').click();
	                    }
	
	                    // Display notification
	                    if (resp.notification) {
	                        hellofaxJS.createNotification({
	                            'text': resp.notification.message,
	                            'class_name': resp.notification.type
	                        });
	                    }
	
	                    // Redirect to on_login_redirect_url
	                    if (resp.success === true && resp.on_login_redirect_url) {
	                        document.location = resp.on_login_redirect_url;
	                    }
	
	                    // Failure
	                    if (!resp.success) {
	
	                        var hasErrorMsg = resp.error && resp.error.message;
	
	                        if (this.state.isCaptchaDisplayed) {
	                            // Refresh CAPTCHA
	                            grecaptcha.reset();
	
	                            if (hasErrorMsg) {
	                                this.setState({
	                                    'errors': { 'global': resp.error.message }
	                                });
	                            }
	                        }
	
	                        if (resp.display_captcha) {
	                            if (!this.state.isCaptchaDisplayed) {
	                                // Show CAPTCHA
	                                this.setState({
	                                    'isCaptchaDisplayed': true
	                                });
	                            }
	                        } else if (resp.on_error_redirect_url) {
	                            // Redirect to on_error_redirect_url
	                            document.location = resp.on_error_redirect_url;
	                        } else if (hasErrorMsg && !resp.notification_message) {
	                            // Display error message
	                            this.setState({
	                                'isCaptchaDisplayed': resp.display_captcha,
	                                'errors': { 'global': resp.error.message }
	                            });
	                        }
	                    }
	                }, function () {
	
	                    // Unexpected error
	                    this.setState({
	                        'errors': { 'global': 'An unexpected error occurred' },
	                        'isProcessing': false
	                    });
	                });
	            }
	        }
	    },
	    displayForgotPasswordModal: function displayForgotPasswordModal() {
	
	        // Note: version 1.4.4 of jQuery is incompatible with Foundation.
	        // In this case we'll want to redirect to / to use the regular login form
	        if ($.fn.jquery === '1.4.4') {
	            window.location = '/';
	            return;
	        }
	
	        $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'close');
	        var attachPoint = _hfReactHelper2['default'].getRevealAttachPoint('forgot_password_modal', 'tiny');
	        _reactDom2['default'].render(_react2['default'].createElement(_forgotPasswordModal2['default'], {
	            emailAddress: this.state.emailAddress,
	            recoverPasswordForm: this.props.recoverPasswordForm }), attachPoint);
	    },
	    render: function render() {
	
	        var tabOffset = parseInt(this.props.tabOffset || 0, 10);
	        var rowClassNames = (0, _classnames2['default'])({
	            'row': true,
	            'text-center': true
	        });
	
	        var isCaptchaDisplayed = this.props.displayCaptcha || this.state.isCaptchaDisplayed;
	        var buttonColumnClassNames = 'columns small-12 l-margin-v-20';
	        var formColumnClassNames = buttonColumnClassNames + ' text-left m-login--sign-up';
	        formColumnClassNames = isCaptchaDisplayed ? formColumnClassNames + ' m-login--sign-up-tall' : formColumnClassNames;
	
	        var captcha;
	        var errors;
	        if (isCaptchaDisplayed) {
	            captcha = _react2['default'].createElement(
	                'div',
	                { className: 'l-margin-b-5 small-10 small-offset-1 text-center' },
	                _react2['default'].createElement(_loginCaptcha2['default'], { recaptchaPublicKey: this.props.recaptchaPublicKey, tabIndex: tabOffset + 4 })
	            );
	        }
	
	        if (this.state.errors) {
	            errors = _react2['default'].createElement(
	                'div',
	                { className: 'row' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'columns l-margin-b-10 small-10 small-offset-1 text-center m-modal--error' },
	                    this.renderErrorText()
	                )
	            );
	        }
	
	        var buttonText = this.props.buttonText ? this.props.buttonText : 'SIGN UP FREE';
	        if (this.props.async && this.state.isProcessing) {
	            buttonText = 'PROCESSING...';
	        }
	
	        var googleOpenId;
	        if (!this.props.hideGoogleOpenId) {
	            googleOpenId = _react2['default'].createElement(
	                'div',
	                { className: buttonColumnClassNames + ' m-login--modal-google-login' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-login--modal-google-login-border' },
	                    _react2['default'].createElement('div', { className: 'm-login--modal-google-login-or-image' })
	                ),
	                _react2['default'].createElement(_googleLoginOrSignup2['default'], { openIdUrl: this.props.googleOpenIdUrl, isLogIn: true })
	            );
	        }
	
	        var rememberMe;
	        if (!this.props.hideRememberMe) {
	            rememberMe = _react2['default'].createElement(
	                'div',
	                { className: 'l-margin-b-10 small-10 small-offset-1 small-text-left' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-login--centering-container' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-login--alignment-wrapper' },
	                        this.renderField('should_remember_me', {
	                            'id': 'login[should_remember_me]',
	                            'defaultChecked': 'checked',
	                            'tabIndex': tabOffset + 3,
	                            'className': 'm-login--text-input'
	                        }),
	                        _react2['default'].createElement(
	                            'label',
	                            { htmlFor: 'login[should_remember_me]' },
	                            'Remember me'
	                        )
	                    )
	                )
	            );
	        }
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'm-login' },
	            _react2['default'].createElement(
	                'form',
	                { ref: 'login_form', className: 'm-login--form', id: 'login_form', action: this.props.action, method: 'POST', onSubmit: this.onSubmit },
	                _react2['default'].createElement(
	                    'div',
	                    { className: rowClassNames },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'columns small-12' },
	                        _react2['default'].createElement(
	                            'h3',
	                            null,
	                            this.props.header
	                        )
	                    ),
	                    googleOpenId,
	                    _react2['default'].createElement(
	                        'div',
	                        { className: formColumnClassNames },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'l-margin-b-10 small-10 small-offset-1 text-center' },
	                            this.renderField('email_address', {
	                                'id': 'login_email_address_input',
	                                'className': 'm-login--text-input',
	                                'placeholder': 'Email',
	                                'onChange': this.onEmailChange,
	                                'tabIndex': tabOffset,
	                                'value': this.state.emailAddress
	                            })
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'l-margin-b-5 small-10 small-offset-1 text-center' },
	                            this.renderField('password', {
	                                'id': 'login_password_input',
	                                'className': 'm-login--text-input m-login--login-password',
	                                'placeholder': 'Password',
	                                'onChange': this.onPasswordChange,
	                                'tabIndex': tabOffset + 1
	                            })
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'm-login--forgot-pwd-link l-margin-b-10 small-10 small-offset-1 small-text-left' },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'm-login--centering-container' },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: 'm-login--alignment-wrapper' },
	                                    _react2['default'].createElement(
	                                        'a',
	                                        { href: 'javascript:;', tabIndex: tabOffset + 2, onClick: this.displayForgotPasswordModal },
	                                        'Forgot password?'
	                                    )
	                                )
	                            )
	                        ),
	                        rememberMe,
	                        this.renderHiddenFields(),
	                        captcha,
	                        errors,
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'small-10 small-offset-1 text-center' + (this.props.isInline ? ' m-login--inline-google-login-button-container' : ' m-login--modal-google-login-button-container') },
	                            _react2['default'].createElement(_button2['default'], { onClick: this.onSubmit,
	                                buttonClass: this.props.isInline ? 'm-login--inline-google-login-button' : 'm-login--modal-google-login-button',
	                                buttonText: buttonText,
	                                buttonColor: 'grasshopper',
	                                buttonHoverColor: 'castle-rock',
	                                buttonTabIndex: tabOffset + 5 })
	                        )
	                    )
	                ),
	                _react2['default'].createElement('input', { type: 'hidden', name: 'on_error_redirect_url', value: this.props.onErrorRedirectUrl }),
	                _react2['default'].createElement('input', { type: 'hidden', name: 'close_after_login', value: this.state.closeAfterLogin ? '1' : '0' }),
	                _react2['default'].createElement('input', { type: 'hidden', name: 'login[redirect_url]', value: this.state.redirectUrl }),
	                _react2['default'].createElement('input', { type: 'hidden', name: 'async', value: this.props.async ? '1' : '0' })
	            )
	        );
	    }
	});
	
	module.exports = LogInForm;

/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _forgotPasswordForm = __webpack_require__(879);
	
	var _forgotPasswordForm2 = _interopRequireDefault(_forgotPasswordForm);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ForgotPasswordModal = _react2['default'].createClass({
	    displayName: 'ForgotPasswordModal',
	
	
	    propTypes: {
	        'tabOffset': _react2['default'].PropTypes.number,
	        'recoverPasswordForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
	        'emailAddress': _react2['default'].PropTypes.string
	    },
	
	    getInitialState: function getInitialState() {
	        return {};
	    },
	    componentDidMount: function componentDidMount() {
	        if (true) {
	            $(document).foundation();
	            $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
	        }
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	        if (true) {
	            $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
	        }
	    },
	    render: function render() {
	
	        var form = _react2['default'].createElement(_forgotPasswordForm2['default'], {
	            tabOffset: this.props.tabOffset,
	            method: 'POST',
	            namespace: this.props.recoverPasswordForm.namespace,
	            action: _hfReactHelper2['default'].urlHelper('account/recoverPassword', _hfReactHelper2['default'].HfSites.SITE_CODE_HS),
	            fields: this.props.recoverPasswordForm.fields,
	            values: this.props.recoverPasswordForm.values,
	            emailAddress: this.props.emailAddress,
	            errors: { 'global': this.state.error } });
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'row text-center' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'columns small-12' },
	                _react2['default'].createElement(
	                    'h4',
	                    null,
	                    'No worries.'
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    { className: 'l-padding-b-10' },
	                    'Enter your email address to request a password reset.',
	                    _react2['default'].createElement('br', null)
	                ),
	                form
	            )
	        );
	    }
	});
	
	module.exports = ForgotPasswordModal;

/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _baseForm = __webpack_require__(703);
	
	var _baseForm2 = _interopRequireDefault(_baseForm);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _passwordRecoveryResponse = __webpack_require__(880);
	
	var _passwordRecoveryResponse2 = _interopRequireDefault(_passwordRecoveryResponse);
	
	var _setTimeout = __webpack_require__(718);
	
	var _setTimeout2 = _interopRequireDefault(_setTimeout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * NOTE: This form is a good example of how to use
	 * Symfony and React forms together
	 */
	var ForgotPasswordForm = _baseForm2['default'].createFormClass({
	
	    displayName: 'ForgotPasswordForm',
	
	    propTypes: {
	        'tabOffset': _react2['default'].PropTypes.number,
	        'emailAddress': _react2['default'].PropTypes.string
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            emailAddress: this.props.emailAddress
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        var root = $(_reactDom2['default'].findDOMNode(this));
	        (0, _setTimeout2['default'])(function () {
	            root.find('input').focus();
	        }, 500);
	    },
	    onEmailChange: function onEmailChange(event) {
	        this.setState({ 'emailAddress': event.target.value.trim() });
	    },
	    onSubmit: function onSubmit(evt) {
	
	        evt.preventDefault();
	
	        // Validate email
	        if (!_hfReactHelper2['default'].isValidEmailAddress(this.state.emailAddress)) {
	            this.setState({
	                'errors': { 'named': { 'email_address': 'Please enter a valid email address' } },
	                'hasErrors': true
	            });
	            return;
	        }
	
	        this.setState({
	            'errors': null,
	            'hasErrors': false
	        });
	
	        var root = $(_reactDom2['default'].findDOMNode(this));
	
	        this.submitAsync(function (resp) {
	
	            root.closest('.reveal-modal').foundation('reveal', 'close');
	            var attachPoint = _hfReactHelper2['default'].getRevealAttachPoint('password_recovery_success', 'tiny');
	            _reactDom2['default'].render(_react2['default'].createElement(_passwordRecoveryResponse2['default'], {
	                isSuccessful: resp.success }), attachPoint);
	        });
	    },
	    render: function render() {
	
	        var tabOffset = parseInt(this.props.tabOffset || 0, 10);
	
	        var inputField = this.renderField('email_address', {
	            'tabIndex': tabOffset + 1,
	            'className': 'm-modal--text-input',
	            'placeholder': 'Email',
	            'data-format': 'email',
	            'onChange': this.onEmailChange,
	            'value': this.state.emailAddress
	        });
	
	        return _react2['default'].createElement(
	            'form',
	            null,
	            inputField,
	            this.renderHiddenFields(),
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-modal--error' },
	                this.renderErrorText()
	            ),
	            _react2['default'].createElement(_button2['default'], { buttonText: 'Reset Password', buttonTabIndex: tabOffset + 2, onClick: this.onSubmit, buttonColor: 'grasshopper' })
	        );
	    }
	});
	
	module.exports = ForgotPasswordForm;

/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/* -----------  PASSWORD RECOVERY  ------------------------ */
	
	var PasswordRecoveryResponse = _react2['default'].createClass({
	    displayName: 'PasswordRecoveryResponse',
	
	
	    propTypes: {
	        // Currently ignored for security reasons (message ambiguity)
	        'isSuccessful': _react2['default'].PropTypes.bool
	    },
	
	    componentDidMount: function componentDidMount() {
	        if (true) {
	            $(document).foundation();
	            $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
	        }
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	        if (true) {
	            $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
	        }
	    },
	    render: function render() {
	
	        var supportEmail = _hfReactHelper2['default'].HfConstants.supportEmail[_hfReactHelper2['default'].HfSites.SITE_CODE_HS];
	        var mailtoLink = 'mailto:' + supportEmail + '?subject=' + encodeURIComponent('Password Reset');
	        var msg = _react2['default'].createElement(
	            'span',
	            null,
	            _react2['default'].createElement(
	                'p',
	                null,
	                'If that is a valid address, we have sent an email to it to reset your password.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'If you\'re still experiencing difficulties, please contact us at\xA0',
	                _react2['default'].createElement(
	                    'a',
	                    { href: mailtoLink },
	                    supportEmail
	                ),
	                '.'
	            )
	        );
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'row text-center' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'columns small-12' },
	                _react2['default'].createElement(
	                    'h4',
	                    null,
	                    'Thanks!'
	                ),
	                msg
	            )
	        );
	    }
	});
	
	module.exports = PasswordRecoveryResponse;

/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var LogInCaptcha = _react2['default'].createClass({
	    displayName: 'LogInCaptcha',
	
	
	    propTypes: {
	        'recaptchaPublicKey': _react2['default'].PropTypes.string.isRequired,
	        'tabIndex': _react2['default'].PropTypes.number
	    },
	
	    componentDidMount: function componentDidMount() {
	        // We need to determine if recaptcha has already loaded or if we need to wait for it
	        if (window.grecaptcha) {
	            this.recaptchaDidLoad();
	        } else {
	            // Register for an event letting us know that it has been loaded, and then do the thing
	            window.addEventListener('hs-recaptcha-did-load', this.recaptchaDidLoad);
	        }
	    },
	    recaptchaDidLoad: function recaptchaDidLoad() {
	        if (window.grecaptcha) {
	            // Render the captcha
	            var container = document.querySelector('.g-recaptcha');
	            grecaptcha.render(container, {
	                'sitekey': this.props.recaptchaPublicKey,
	                'theme': 'custom'
	            });
	        }
	    },
	    captchaReload: function captchaReload(e) {
	        e.preventDefault();
	        if (window.grecaptcha) {
	            grecaptcha.reset();
	        }
	    },
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            { id: 'recaptcha_widget', className: 'm-login--captcha' },
	            _react2['default'].createElement('div', { className: 'g-recaptcha',
	                'data-sitekey': this.props.recaptchaPublicKey,
	                'data-theme': 'custom' })
	        );
	    }
	});
	
	module.exports = LogInCaptcha;

/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _setTimeout = __webpack_require__(718);
	
	var _setTimeout2 = _interopRequireDefault(_setTimeout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/* -----------  LOGIN  ------------------------------------ */
	
	var LogInVerificationForm = _react2['default'].createClass({
	    displayName: 'LogInVerificationForm',
	
	
	    propTypes: {
	        'errorMsg': _react2['default'].PropTypes.string,
	        'redirectUrl': _react2['default'].PropTypes.string,
	        'tabOffset': _react2['default'].PropTypes.number,
	        'emailAddress': _react2['default'].PropTypes.string.isRequired,
	        'rememberMe': _react2['default'].PropTypes.bool.isRequired,
	        'phoneNumberLast2': _react2['default'].PropTypes.string.isRequired,
	        'siteCode': _react2['default'].PropTypes.string.isRequired,
	        'signature': _react2['default'].PropTypes.string.isRequired,
	        'zendeskWidgetEnabled': _react2['default'].PropTypes.bool.isRequired
	    },
	
	    componentDidMount: function componentDidMount() {
	
	        var self = this;
	        var root = $(_reactDom2['default'].findDOMNode(this));
	        var codeInput = root.find('.m-login--verification--code input');
	
	        (0, _setTimeout2['default'])(function () {
	            codeInput.focus();
	        }, 500);
	
	        $('.m-login--verification--links--modal').overlay({
	            mask: 'rgba(100, 100, 100, 0.65)',
	            speed: 0,
	            onClose: function onClose() {
	                self.hideHelp();
	            }
	        });
	    },
	    onSubmit: function onSubmit() {},
	    resendCode: function resendCode(evt) {
	        evt.preventDefault();
	        var root = $(_reactDom2['default'].findDOMNode(this));
	        $('input[name=\'resend\']', root).val('1');
	        $('#login_form', root).submit();
	    },
	    enterRecoveryCode: function enterRecoveryCode(evt) {
	        evt.preventDefault();
	        var root = $(_reactDom2['default'].findDOMNode(this));
	        $('.m-login--verification--instructions', root).hide();
	        $('.m-login--verification--recovery', root).show();
	        $('.m-login--verification--code input', root).attr('placeholder', 'Enter recovery code');
	        this.hideHelp();
	    },
	    contactSupport: function contactSupport(evt) {
	        evt.preventDefault();
	        this.hideHelp();
	        if (this.props.zendeskWidgetEnabled) {
	            zE(function () {
	                zE.activate({ hideOnClose: true });
	            });
	        } else {
	            UserVoice.showLightbox();
	        }
	    },
	    showHelp: function showHelp(evt) {
	        evt.preventDefault();
	        var root = $(_reactDom2['default'].findDOMNode(this));
	        $('.m-login--verification--links--modal', root).overlay().load();
	        $('#problemLink', root).hide();
	    },
	    hideHelp: function hideHelp() {
	        var root = $(_reactDom2['default'].findDOMNode(this));
	        $('.m-login--verification--links--modal', root).overlay().close();
	        $('#problemLink', root).show();
	    },
	    getPhoneNumberLast2Safe: function getPhoneNumberLast2Safe() {
	        //Make sure we're only getting 2 characters. Since we're getting the prop from query params, it prevents text injection. (DEV-2313)
	        return this.props.phoneNumberLast2.substr(0, 2);
	    },
	    render: function render() {
	
	        var targetUrl = _hfReactHelper2['default'].urlHelper('account/logInVerification', this.props.siteCode);
	        var tabOffset = parseInt(this.props.tabOffset || 0, 10);
	        var err = this.props.errorMsg ? _react2['default'].createElement(
	            'p',
	            { className: 'm-login--verification--error' },
	            this.props.errorMsg
	        ) : null;
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'm-login is-verification' },
	            _react2['default'].createElement(
	                'form',
	                { ref: 'login_form', className: 'm-login--form', id: 'login_form', action: targetUrl, method: 'POST' },
	                _react2['default'].createElement(
	                    'div',
	                    null,
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'columns small-12' },
	                        _react2['default'].createElement(
	                            'h3',
	                            { className: 'm-login--verification--title' },
	                            '2-step account verification'
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'p',
	                        { className: 'columns small-12 l-text-centered m-login--verification--instructions' },
	                        'We just sent you a text message to (***) ***-**',
	                        this.getPhoneNumberLast2Safe(),
	                        ' with your code. Please enter the code to log in.'
	                    ),
	                    _react2['default'].createElement(
	                        'p',
	                        { className: 'columns small-12 l-text-centered m-login--verification--recovery' },
	                        'Enter the recovery code that was given to you when you enabled 2-Factor Authentication.\xA0',
	                        _react2['default'].createElement(
	                            'b',
	                            null,
	                            'The code will become void and 2-Factor Authentication will be disabled.'
	                        )
	                    ),
	                    _react2['default'].createElement('input', { type: 'hidden', name: 'verification[last2]', value: this.getPhoneNumberLast2Safe() }),
	                    _react2['default'].createElement('input', { type: 'hidden', name: 'verification[email_address]', value: this.props.emailAddress }),
	                    _react2['default'].createElement('input', { type: 'hidden', name: 'verification[rm]', value: this.props.rememberMe ? '1' : '0' }),
	                    _react2['default'].createElement('input', { type: 'hidden', name: 'verification[redirect_url]', value: this.props.redirectUrl }),
	                    _react2['default'].createElement('input', { type: 'hidden', name: 'verification[signature]', value: this.props.signature }),
	                    _react2['default'].createElement('input', { type: 'hidden', name: 'resend', value: '0' }),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-login--verification--code' },
	                        _react2['default'].createElement('input', { type: 'text',
	                            name: 'verification[code]',
	                            className: 'm-login--text-input',
	                            placeholder: 'Enter code',
	                            maxLength: '6',
	                            tabIndex: tabOffset }),
	                        err
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'small-10 small-offset-1 text-center' },
	                        _react2['default'].createElement(_button2['default'], { onClick: this.onSubmit,
	                            type: 'submit',
	                            buttonClass: '',
	                            buttonText: 'VERIFY',
	                            buttonColor: 'grasshopper',
	                            buttonHoverColor: 'castle-rock',
	                            buttonTabIndex: tabOffset + 1 })
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-login--verification--links' },
	                        _react2['default'].createElement(
	                            'a',
	                            { href: 'javascript:;', id: 'problemLink', onClick: this.showHelp },
	                            'Problems receiving your code?'
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'm-login--verification--links--modal form-overlay' },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'm-login--verification--links--modal--title' },
	                                'Try one of these methods'
	                            ),
	                            _react2['default'].createElement(
	                                'a',
	                                { href: 'javascript:;', id: 'resendCodeLink', className: 'first small-4 column', onClick: this.resendCode },
	                                'Resend me the code'
	                            ),
	                            _react2['default'].createElement(
	                                'a',
	                                { href: 'javascript:;', id: 'recoveryLink', className: 'middle small-4 column', onClick: this.enterRecoveryCode },
	                                'Use my recovery code'
	                            ),
	                            _react2['default'].createElement(
	                                'a',
	                                { href: 'javascript:;', id: 'helpLink', className: 'last small-4 column', onClick: this.contactSupport },
	                                'Contact support for help'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    }
	});
	
	module.exports = LogInVerificationForm;

/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _createAccount = __webpack_require__(872);
	
	var _createAccount2 = _interopRequireDefault(_createAccount);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var CreateAccountTrigger = _react2['default'].createClass({
	    displayName: 'CreateAccountTrigger',
	
	
	    propTypes: {
	        'linkText': _react2['default'].PropTypes.string,
	        'trigger': _react2['default'].PropTypes.element,
	        'triggerSelector': _react2['default'].PropTypes.string,
	        'googleOpenIdUrl': _react2['default'].PropTypes.string,
	        'buttonText': _react2['default'].PropTypes.string,
	        'tabOffset': _react2['default'].PropTypes.number,
	        'redirectUrl': _react2['default'].PropTypes.string,
	        'signupUrl': _react2['default'].PropTypes.string,
	        'signupForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
	        'loginForm': _react2['default'].PropTypes.object, // Serialized sfForm
	        'recoverPasswordForm': _react2['default'].PropTypes.object, // Serialized sfForm
	        'hideRememberMe': _react2['default'].PropTypes.bool,
	        'hideGoogleOpenId': _react2['default'].PropTypes.bool,
	        'async': _react2['default'].PropTypes.bool
	    },
	
	    componentDidMount: function componentDidMount() {
	        if (window.handlingLogInTriggers) {
	            // We only want to process this once per page
	            return;
	        }
	        // If the 'login=1' URL parameter is present, display the modal
	        if (/\?display_signup\=1|&display_signup\=1/i.test(location.href)) {
	            window.handlingSignupTriggers = true;
	            this.handleClick(null);
	        }
	    },
	    handleClick: function handleClick(e) {
	        if (e != null) {
	            e.preventDefault();
	        }
	        var tabOffset = parseInt(this.props.tabOffset || 1000, 10);
	        var attachPoint = _hfReactHelper2['default'].getRevealAttachPoint('create_account_modal');
	        _reactDom2['default'].render(_react2['default'].createElement(_createAccount2['default'], {
	            header: this.props.header,
	            buttonText: this.props.buttonText,
	            googleOpenIdUrl: this.props.googleOpenIdUrl,
	            isFromApiPricing: this.props.isFromApiPricing,
	            tabOffset: tabOffset,
	            redirectUrl: this.props.redirectUrl,
	            signupUrl: this.props.signupUrl,
	            signupForm: this.props.signupForm,
	            loginForm: this.props.loginForm,
	            recoverPasswordForm: this.props.recoverPasswordForm,
	            hideRememberMe: this.props.hideRememberMe,
	            hideGoogleOpenId: this.props.hideGoogleOpenId,
	            async: this.props.async }), attachPoint);
	    },
	    renderTrigger: function renderTrigger() {
	        if (this.props.triggerSelector) {
	            return _react2['default'].createElement(DOMElementWrapper, { element: this.props.triggerSelector });
	        } else if (this.props.trigger) {
	            return this.props.trigger;
	        } else {
	            return _react2['default'].createElement(
	                'a',
	                { href: '#' },
	                this.props.linkText
	            );
	        }
	    },
	    render: function render() {
	        var trigger = this.renderTrigger();
	        return _react2['default'].createElement(
	            'span',
	            { ref: 'signUpTrigger', className: 'sign-up-trigger', onClick: this.handleClick },
	            trigger
	        );
	    }
	});
	
	var DOMElementWrapper = _react2['default'].createClass({
	    displayName: 'DOMElementWrapper',
	    componentDidMount: function componentDidMount() {
	        var signUpTrigger = this.refs.container;
	        signUpTrigger.appendChild($(this.props.element)[0]);
	    },
	    render: function render() {
	        return _react2['default'].createElement('span', { ref: 'container' });
	    }
	});
	
	module.exports = CreateAccountTrigger;

/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _superagent = __webpack_require__(667);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var VerifyEmail = _react2['default'].createClass({
	    displayName: 'VerifyEmail',
	
	
	    propTypes: {
	        'shortGuid': _react2['default'].PropTypes.string,
	        'emailAddress': _react2['default'].PropTypes.string,
	        'csrf_token': _react2['default'].PropTypes.string
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            processing: false
	        };
	    },
	    onSuccess: function onSuccess() {
	        this.setState({ processing: false });
	    },
	    onResendClick: function onResendClick(e) {
	
	        e.preventDefault();
	        var self = this;
	
	        this.setState({ processing: true });
	
	        var resendAddress = '/signer/sendTemplateLinkEmail';
	
	        _superagent2['default'].post(resendAddress).type('form').send({ email_address: this.props.emailAddress }).send({ guid: this.props.shortGuid }).send({ csrf_token: this.props.csrf_token }).end(function (err, res) {
	            if (!err) {
	                var data = JSON.parse(res.text);
	                self.onSuccess(data);
	            }
	        });
	    },
	    render: function render() {
	        var spinner = this.state.processing ? _react2['default'].createElement('img', {
	            className: 'spinner',
	            style: { position: 'absolute', left: '10%' },
	            src: __webpack_require__(811),
	            width: '16',
	            height: '16' }) : void 0;
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'm-verify-email row' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-verify-email--container' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-verify-email--text' },
	                    _react2['default'].createElement(
	                        'h4',
	                        null,
	                        'One last thing'
	                    ),
	                    _react2['default'].createElement('img', { src: __webpack_require__(885) }),
	                    _react2['default'].createElement(
	                        'div',
	                        null,
	                        'We just sent you an email.'
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        null,
	                        'Please open it and click \'Review Document\'.'
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-verify-email--resend' },
	                    spinner,
	                    'Don\'t see it in your inbox? ',
	                    _react2['default'].createElement(
	                        'a',
	                        { href: '#', onClick: this.onResendClick },
	                        'Click here to resend.'
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                'span',
	                { className: 'm-verify-email--legal' },
	                'Note: This step is required to comply with eSignature laws.'
	            )
	        );
	    }
	});
	
	module.exports = VerifyEmail;

/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/af74f1a7078ef1c814cccbb8a5fa34d9.png";

/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _baseForm = __webpack_require__(703);
	
	var _baseForm2 = _interopRequireDefault(_baseForm);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var LogInInPerson = _baseForm2['default'].createFormClass({
	
	    propTypes: {
	        'guid': _react2['default'].PropTypes.string.isRequired,
	        'title': _react2['default'].PropTypes.string.isRequired
	    },
	
	    onEmailChange: function onEmailChange(event) {
	        this.setState({
	            'emailAddress': event.target.value.trim()
	        });
	    },
	    onSubmit: function onSubmit(e) {
	        e.preventDefault();
	
	        var emailAddress = $('#email_address').val();
	
	        if (!_hfReactHelper2['default'].isValidEmailAddress(emailAddress)) {
	            this.setState({
	                'errors': { 'named': { 'email_address': 'Invalid email address' } }
	            });
	        } else {
	            $('#login-form').submit();
	        }
	    },
	    render: function render() {
	        var errors = '';
	        if (this.state.errors) {
	            errors = _react2['default'].createElement(
	                'div',
	                { className: 'row' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'columns small-12 text-center m-login-in-person--errors' },
	                    this.renderErrorText()
	                )
	            );
	        }
	        return _react2['default'].createElement(
	            'div',
	            { className: 'm-login-in-person row' },
	            _react2['default'].createElement(
	                'h4',
	                null,
	                this.props.title
	            ),
	            _react2['default'].createElement(
	                'div',
	                null,
	                'To review and sign this document, enter your email address:'
	            ),
	            _react2['default'].createElement(
	                'form',
	                { id: 'login-form', className: 'm-login-in-person--form', action: _hfReactHelper2['default'].urlHelper('signer/signInPerson'), method: 'POST' },
	                this.renderField('email_address', {
	                    'id': 'email_address',
	                    'className': '',
	                    'maxLength': '99',
	                    'placeholder': 'email@example.com',
	                    'onChange': this.onEmailChange,
	                    'tabIndex': '0',
	                    'data-format': 'email'
	                }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'columns small-12' },
	                        _react2['default'].createElement(_button2['default'], { onClick: this.onSubmit,
	                            buttonClass: 'right',
	                            buttonText: 'Continue',
	                            buttonColor: 'cerulean',
	                            buttonHoverColor: 'castle-rock',
	                            buttonTabIndex: '1' })
	                    )
	                ),
	                _react2['default'].createElement('input', { type: 'hidden', name: 'short_guid', value: this.props.guid })
	            ),
	            errors
	        );
	    }
	});
	
	module.exports = LogInInPerson;

/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(888);
	
	var _reactRedux = __webpack_require__(907);
	
	var _reactReduxForm = __webpack_require__(925);
	
	var _reduxThunk = __webpack_require__(1001);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _simpleGrayLayout = __webpack_require__(762);
	
	var _simpleGrayLayout2 = _interopRequireDefault(_simpleGrayLayout);
	
	var _signUpForm = __webpack_require__(1002);
	
	var _signUpForm2 = _interopRequireDefault(_signUpForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Top-level component for standalone Sign Up page.
	 * Expects some props from the backend, such as CSRF token.
	 */
	var SignUpPage = function (_React$Component) {
	    _inherits(SignUpPage, _React$Component);
	
	    function SignUpPage(props) {
	        _classCallCheck(this, SignUpPage);
	
	        var _this = _possibleConstructorReturn(this, (SignUpPage.__proto__ || Object.getPrototypeOf(SignUpPage)).call(this, props));
	
	        var initialState = {
	            email: _this.props.emailAddress,
	            marketingOptIn: !(_this.props.marketingOptIn === false),
	            csrfToken: _this.props.csrfToken,
	            redirectUrl: _this.props.redirectUrl,
	            pendingTsmGroupGuid: _this.props.pendingTsmGroupGuid
	        };
	
	        // This is a hack for OAuth flows and ensures that we redirect
	        // back to the referrer when the user signs up. This fixes an issue
	        // where new users would be taken out of the OAuth flow when attempting
	        // to create a new account (DEV-2687)
	        var ref = document.referrer;
	        if (ref.indexOf('oauth') > 0) {
	            initialState.redirectUrl = ref;
	        }
	
	        _this.store = (0, _redux.createStore)((0, _reactReduxForm.combineForms)({
	            signUp: initialState
	        }), (0, _redux.applyMiddleware)(_reduxThunk2['default']));
	        return _this;
	    }
	
	    _createClass(SignUpPage, [{
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(
	                _reactRedux.Provider,
	                { store: this.store },
	                _react2['default'].createElement(
	                    _simpleGrayLayout2['default'],
	                    null,
	                    _react2['default'].createElement(_signUpForm2['default'], this.props)
	                )
	            );
	        }
	    }]);
	
	    return SignUpPage;
	}(_react2['default'].Component);
	
	SignUpPage.propTypes = {
	    // CSRF Token - Sent from the server
	    csrfToken: _react2['default'].PropTypes.string.isRequired,
	
	    // Email value - This is useful to provide for testing purposes
	    emailAddress: _react2['default'].PropTypes.string,
	
	    marketingOptIn: _react2['default'].PropTypes.bool,
	    redirectUrl: _react2['default'].PropTypes.string,
	    pendingTsmGroupGuid: _react2['default'].PropTypes.string
	};
	
	
	module.exports = SignUpPage;

/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(889);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(902);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(904);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(905);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(906);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(903);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2["default"])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2["default"];
	exports.combineReducers = _combineReducers2["default"];
	exports.bindActionCreators = _bindActionCreators2["default"];
	exports.applyMiddleware = _applyMiddleware2["default"];
	exports.compose = _compose2["default"];

/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports["default"] = createStore;
	
	var _isPlainObject = __webpack_require__(890);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(900);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	};
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [initialState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} enhancer The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	function createStore(reducer, initialState, enhancer) {
	  var _ref2;
	
	  if (typeof initialState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = initialState;
	    initialState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, initialState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = initialState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2["default"])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/zenparsing/es-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2["default"]] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2["default"]] = observable, _ref2;
	}

/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(891),
	    getPrototype = __webpack_require__(897),
	    isObjectLike = __webpack_require__(899);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(892),
	    getRawTag = __webpack_require__(895),
	    objectToString = __webpack_require__(896);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(893);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(894);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 894 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(892);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 896 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(898);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 898 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 899 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* global window */
	'use strict';
	
	module.exports = __webpack_require__(901)(global || window || this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 901 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function symbolObservablePonyfill(root) {
		var result;
		var Symbol = root.Symbol;
	
		if (typeof Symbol === 'function') {
			if (Symbol.observable) {
				result = Symbol.observable;
			} else {
				result = Symbol('observable');
				Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};


/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = combineReducers;
	
	var _createStore = __webpack_require__(889);
	
	var _isPlainObject = __webpack_require__(890);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(903);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'initialState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2["default"])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key);
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerSanity(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var sanityError;
	  try {
	    assertReducerSanity(finalReducers);
	  } catch (e) {
	    sanityError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var action = arguments[1];
	
	    if (sanityError) {
	      throw sanityError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action);
	      if (warningMessage) {
	        (0, _warning2["default"])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var i = 0; i < finalReducerKeys.length; i++) {
	      var key = finalReducerKeys[i];
	      var reducer = finalReducers[key];
	      var previousStateForKey = state[key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 903 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 904 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = applyMiddleware;
	
	var _compose = __webpack_require__(906);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, initialState, enhancer) {
	      var store = createStore(reducer, initialState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2["default"].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 906 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  } else {
	    var _ret = function () {
	      var last = funcs[funcs.length - 1];
	      var rest = funcs.slice(0, -1);
	      return {
	        v: function v() {
	          return rest.reduceRight(function (composed, f) {
	            return f(composed);
	          }, last.apply(undefined, arguments));
	        }
	      };
	    }();
	
	    if (typeof _ret === "object") return _ret.v;
	  }
	}

/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(908);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(911);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(304);
	
	var _storeShape = __webpack_require__(909);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(910);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    var children = this.props.children;
	
	    return _react.Children.only(children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _react.PropTypes.element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(304);
	
	exports["default"] = _react.PropTypes.shape({
	  subscribe: _react.PropTypes.func.isRequired,
	  dispatch: _react.PropTypes.func.isRequired,
	  getState: _react.PropTypes.func.isRequired
	});

/***/ },
/* 910 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that you can use this stack
	    // to find the callsite that caused this warning to fire.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	exports["default"] = connect;
	
	var _react = __webpack_require__(304);
	
	var _storeShape = __webpack_require__(909);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(912);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(913);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(910);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(914);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(924);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(754);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = undefined;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure;
	  var pure = _options$pure === undefined ? true : _options$pure;
	  var _options$withRef = options.withRef;
	  var withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (false) {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (false) {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (false) {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged;
	        var hasStoreStateChanged = this.hasStoreStateChanged;
	        var haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated;
	        var statePropsPrecalculationError = this.statePropsPrecalculationError;
	        var renderedElement = this.renderedElement;
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 912 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(888);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(915),
	    getPrototype = __webpack_require__(921),
	    isObjectLike = __webpack_require__(923);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(916),
	    getRawTag = __webpack_require__(919),
	    objectToString = __webpack_require__(920);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(917);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(918);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 918 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(916);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 920 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(922);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 922 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 923 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 924 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.track = exports.getModel = exports.getField = exports.form = exports.batched = exports.modeled = exports.createFieldClass = exports.Fieldset = exports.Errors = exports.LocalForm = exports.Form = exports.Control = exports.Field = exports.controls = exports.actionTypes = exports.actions = exports.initialFieldState = exports.createForms = exports.combineForms = exports.modelReducer = exports.formReducer = undefined;
	
	var _actions = __webpack_require__(926);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _actionTypes = __webpack_require__(932);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _fieldComponent = __webpack_require__(955);
	
	var _fieldComponent2 = _interopRequireDefault(_fieldComponent);
	
	var _fieldsetComponent = __webpack_require__(972);
	
	var _fieldsetComponent2 = _interopRequireDefault(_fieldsetComponent);
	
	var _controlComponent = __webpack_require__(958);
	
	var _controlComponent2 = _interopRequireDefault(_controlComponent);
	
	var _formComponent = __webpack_require__(973);
	
	var _formComponent2 = _interopRequireDefault(_formComponent);
	
	var _localFormComponent = __webpack_require__(978);
	
	var _localFormComponent2 = _interopRequireDefault(_localFormComponent);
	
	var _errorsComponent = __webpack_require__(996);
	
	var _errorsComponent2 = _interopRequireDefault(_errorsComponent);
	
	var _controlPropsMap = __webpack_require__(964);
	
	var _controlPropsMap2 = _interopRequireDefault(_controlPropsMap);
	
	var _modeledEnhancer = __webpack_require__(980);
	
	var _modeledEnhancer2 = _interopRequireDefault(_modeledEnhancer);
	
	var _batchedEnhancer = __webpack_require__(983);
	
	var _batchedEnhancer2 = _interopRequireDefault(_batchedEnhancer);
	
	var _formReducer = __webpack_require__(984);
	
	var _formReducer2 = _interopRequireDefault(_formReducer);
	
	var _initialFieldState = __webpack_require__(967);
	
	var _initialFieldState2 = _interopRequireDefault(_initialFieldState);
	
	var _formsReducer = __webpack_require__(979);
	
	var _formsReducer2 = _interopRequireDefault(_formsReducer);
	
	var _modelReducer = __webpack_require__(981);
	
	var _modelReducer2 = _interopRequireDefault(_modelReducer);
	
	var _track = __webpack_require__(936);
	
	var _track2 = _interopRequireDefault(_track);
	
	var _getFieldFromState = __webpack_require__(949);
	
	var _getFieldFromState2 = _interopRequireDefault(_getFieldFromState);
	
	var _get = __webpack_require__(928);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _form = __webpack_require__(997);
	
	var _form2 = _interopRequireDefault(_form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.formReducer = _formReducer2.default;
	exports.modelReducer = _modelReducer2.default;
	exports.combineForms = _formsReducer2.default;
	exports.createForms = _formsReducer.createForms;
	exports.initialFieldState = _initialFieldState2.default;
	exports.actions = _actions2.default;
	exports.actionTypes = _actionTypes2.default;
	exports.controls = _controlPropsMap2.default;
	exports.Field = _fieldComponent2.default;
	exports.Control = _controlComponent2.default;
	exports.Form = _formComponent2.default;
	exports.LocalForm = _localFormComponent2.default;
	exports.Errors = _errorsComponent2.default;
	exports.Fieldset = _fieldsetComponent2.default;
	exports.createFieldClass = _fieldComponent.createFieldClass;
	exports.modeled = _modeledEnhancer2.default;
	exports.batched = _batchedEnhancer2.default;
	exports.form = _form2.default;
	exports.getField = _getFieldFromState2.default;
	exports.getModel = _get2.default;
	exports.track = _track2.default;

/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _fieldActions = __webpack_require__(927);
	
	var _fieldActions2 = _interopRequireDefault(_fieldActions);
	
	var _modelActions = __webpack_require__(952);
	
	var _modelActions2 = _interopRequireDefault(_modelActions);
	
	var _batchActions = __webpack_require__(933);
	
	var _batchActions2 = _interopRequireDefault(_batchActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actions = _extends({}, _fieldActions2.default, _modelActions2.default, {
	  batch: _batchActions2.default
	});
	
	exports.default = actions;

/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createFieldActions = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _get2 = __webpack_require__(928);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _mapValues = __webpack_require__(931);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _actionTypes = __webpack_require__(932);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _batchActions = __webpack_require__(933);
	
	var _batchActions2 = _interopRequireDefault(_batchActions);
	
	var _getValidity = __webpack_require__(941);
	
	var _getValidity2 = _interopRequireDefault(_getValidity);
	
	var _isValidityValid = __webpack_require__(943);
	
	var _isValidityValid2 = _interopRequireDefault(_isValidityValid);
	
	var _isValidityInvalid = __webpack_require__(944);
	
	var _isValidityInvalid2 = _interopRequireDefault(_isValidityInvalid);
	
	var _invertValidity = __webpack_require__(945);
	
	var _invertValidity2 = _interopRequireDefault(_invertValidity);
	
	var _track = __webpack_require__(936);
	
	var _getForm = __webpack_require__(946);
	
	var _getForm2 = _interopRequireDefault(_getForm);
	
	var _getFieldFromState = __webpack_require__(949);
	
	var _getFieldFromState2 = _interopRequireDefault(_getFieldFromState);
	
	var _nullAction = __webpack_require__(940);
	
	var _nullAction2 = _interopRequireDefault(_nullAction);
	
	var _isNative = __webpack_require__(951);
	
	var _isNative2 = _interopRequireDefault(_isNative);
	
	var _invariant = __webpack_require__(754);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defaultStrategies = {
	  get: _get3.default,
	  getForm: _getForm2.default,
	  getFieldFromState: _getFieldFromState2.default
	};
	
	function createFieldActions() {
	  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultStrategies;
	
	  var addIntent = function addIntent(model, intent) {
	    return {
	      type: _actionTypes2.default.ADD_INTENT,
	      model: model,
	      intent: intent
	    };
	  };
	
	  var clearIntents = function clearIntents(model, intents) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return {
	      type: _actionTypes2.default.CLEAR_INTENTS,
	      model: model,
	      intents: intents,
	      options: options
	    };
	  };
	
	  var focus = function focus(model, value) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return _extends({
	      type: _actionTypes2.default.FOCUS,
	      model: model,
	      value: value
	    }, options);
	  };
	
	  var silentFocus = function silentFocus(model, value) {
	    return focus(model, value, {
	      silent: true
	    });
	  };
	
	  var blur = function blur(model) {
	    return {
	      type: _actionTypes2.default.BLUR,
	      model: model
	    };
	  };
	
	  var setPristine = function setPristine(model) {
	    return {
	      type: _actionTypes2.default.SET_PRISTINE,
	      model: model
	    };
	  };
	
	  var setDirty = function setDirty(model) {
	    return {
	      type: _actionTypes2.default.SET_DIRTY,
	      model: model
	    };
	  };
	
	  var setInitial = function setInitial(model) {
	    return {
	      type: _actionTypes2.default.SET_INITIAL,
	      model: model
	    };
	  };
	
	  var setPending = function setPending(model) {
	    var pending = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	    return {
	      type: _actionTypes2.default.SET_PENDING,
	      model: model,
	      pending: pending
	    };
	  };
	
	  var setValidating = function setValidating(model) {
	    var validating = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	    return {
	      type: _actionTypes2.default.SET_VALIDATING,
	      model: model,
	      validating: validating
	    };
	  };
	
	  var setValidity = function setValidity(model, validity) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return _extends({
	      type: options.errors ? _actionTypes2.default.SET_ERRORS : _actionTypes2.default.SET_VALIDITY,
	      model: model
	    }, options, _defineProperty({}, options.errors ? 'errors' : 'validity', validity));
	  };
	
	  var resetValidity = function resetValidity(model) {
	    var omitKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    return {
	      type: _actionTypes2.default.RESET_VALIDITY,
	      model: model,
	      omitKeys: omitKeys
	    };
	  };
	
	  var setFieldsValidity = function setFieldsValidity(model, fieldsValidity) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return {
	      type: _actionTypes2.default.SET_FIELDS_VALIDITY,
	      model: model,
	      fieldsValidity: fieldsValidity,
	      options: options
	    };
	  };
	
	  var setErrors = function setErrors(model, errors) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return setValidity(model, errors, _extends({}, options, {
	      errors: true
	    }));
	  };
	
	  var setFieldsErrors = function setFieldsErrors(model, fieldsErrors, options) {
	    return setFieldsValidity(model, fieldsErrors, _extends({}, options, {
	      errors: true
	    }));
	  };
	
	  var resetErrors = resetValidity;
	
	  var setTouched = function setTouched(model) {
	    return {
	      type: _actionTypes2.default.SET_TOUCHED,
	      model: model
	    };
	  };
	
	  var setUntouched = function setUntouched(model) {
	    return {
	      type: _actionTypes2.default.SET_UNTOUCHED,
	      model: model
	    };
	  };
	
	  var asyncSetValidity = function asyncSetValidity(model, validator) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return function (dispatch, getState) {
	      var value = s.get(getState(), model);
	
	      dispatch(setValidating(model, true));
	
	      var done = function done(validity) {
	        dispatch(setValidity(model, validity, _extends({
	          async: true
	        }, options)));
	      };
	
	      var immediateResult = validator(value, done);
	
	      if (typeof immediateResult !== 'undefined') {
	        done(immediateResult);
	      }
	    };
	  };
	
	  var asyncSetErrors = function asyncSetErrors(model, validator) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return asyncSetValidity(model, validator, _extends({
	      errors: true
	    }, options));
	  };
	
	  var setSubmitted = function setSubmitted(model) {
	    var submitted = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	    return {
	      type: _actionTypes2.default.SET_SUBMITTED,
	      model: model,
	      submitted: submitted
	    };
	  };
	
	  var setSubmitFailed = function setSubmitFailed(model) {
	    var submitFailed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	    return {
	      type: _actionTypes2.default.SET_SUBMIT_FAILED,
	      model: model,
	      submitFailed: submitFailed
	    };
	  };
	
	  var submit = function submit(model, promise) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    if (typeof promise === 'undefined') {
	      return addIntent(model, { type: 'submit' });
	    }
	
	    return function (dispatch, getState) {
	      if (options.validate) {
	        var form = s.getForm(getState(), model);
	
	        (0, _invariant2.default)(form, 'Unable to submit form with validation. ' + 'Could not find form for "%s" in the store.', model);
	
	        if (!form.$form.valid) {
	          return dispatch(_nullAction2.default);
	        }
	
	        dispatch(setPending(model, true));
	      } else if (options.validators || options.errors) {
	        var validators = options.validators || options.errors;
	        var isErrors = options.errors;
	        var value = s.get(getState(), model);
	        var validity = (0, _getValidity2.default)(validators, value);
	        var valid = options.errors ? !(0, _isValidityInvalid2.default)(validity) : (0, _isValidityValid2.default)(validity);
	
	        if (!valid) {
	          return dispatch(isErrors ? setErrors(model, validity) : setValidity(model, validity));
	        }
	
	        dispatch((0, _batchActions2.default)(model, [setValidity(model, isErrors ? (0, _invertValidity2.default)(validity) : validity), setPending(model, true)]));
	      } else {
	        dispatch(setPending(model, true));
	      }
	
	      var errorsAction = options.fields ? setFieldsErrors : setErrors;
	
	      promise.then(function (response) {
	        dispatch((0, _batchActions2.default)(model, [setSubmitted(model, true), setValidity(model, response)]));
	      }).catch(function (error) {
	        if (!_isNative2.default) console.error(error);
	
	        dispatch((0, _batchActions2.default)(model, [setSubmitFailed(model), errorsAction(model, error, { async: true })]));
	      });
	
	      return promise;
	    };
	  };
	
	  var submitFields = function submitFields(model, promise) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return submit(model, promise, _extends({}, options, {
	      fields: true
	    }));
	  };
	
	  var validSubmit = function validSubmit(model, promise) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return submit(model, promise, _extends({}, options, {
	      validate: true
	    }));
	  };
	
	  var validate = function validate(model, validators) {
	    return function (dispatch, getState) {
	      var value = s.get(getState(), model);
	      var validity = (0, _getValidity2.default)(validators, value);
	
	      dispatch(setValidity(model, validity));
	    };
	  };
	
	  var validateErrors = function validateErrors(model, errorValidators) {
	    return function (dispatch, getState) {
	      var value = s.get(getState(), model);
	      var errors = (0, _getValidity2.default)(errorValidators, value);
	
	      dispatch(setValidity(model, errors, { errors: true }));
	    };
	  };
	
	  var validateFields = function validateFields(model, fieldValidators) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return function (dispatch, getState) {
	      var modelValue = s.get(getState(), model);
	
	      var fieldsValidity = (0, _mapValues2.default)(fieldValidators, function (validator, field) {
	        var fieldValue = field ? s.get(modelValue, field) : modelValue;
	
	        var fieldValidity = (0, _getValidity2.default)(validator, fieldValue);
	
	        return fieldValidity;
	      });
	
	      var fieldsValiditySetter = options.errors ? setFieldsErrors : setFieldsValidity;
	
	      dispatch(fieldsValiditySetter(model, fieldsValidity));
	    };
	  };
	
	  var validateFieldsErrors = function validateFieldsErrors(model, fieldErrorsValidators) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return validateFields(model, fieldErrorsValidators, _extends({}, options, {
	      errors: true
	    }));
	  };
	
	  return (0, _mapValues2.default)({
	    blur: blur,
	    focus: focus,
	    silentFocus: silentFocus,
	    submit: submit,
	    submitFields: submitFields,
	    validSubmit: validSubmit,
	    setDirty: setDirty,
	    setErrors: setErrors,
	    setInitial: setInitial,
	    setPending: setPending,
	    setValidating: setValidating,
	    setPristine: setPristine,
	    setSubmitted: setSubmitted,
	    setSubmitFailed: setSubmitFailed,
	    setTouched: setTouched,
	    setUntouched: setUntouched,
	    setValidity: setValidity,
	    setFieldsValidity: setFieldsValidity,
	    setFieldsErrors: setFieldsErrors,
	    resetValidity: resetValidity,
	    resetErrors: resetErrors,
	    validate: validate,
	    validateErrors: validateErrors,
	    validateFields: validateFields,
	    validateFieldsErrors: validateFieldsErrors,
	    asyncSetValidity: asyncSetValidity,
	    asyncSetErrors: asyncSetErrors,
	    addIntent: addIntent,
	    clearIntents: clearIntents
	  }, _track.trackable);
	}
	
	exports.createFieldActions = createFieldActions;
	exports.default = createFieldActions();

/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = get;
	
	var _lodash = __webpack_require__(929);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _endsWith = __webpack_require__(930);
	
	var _endsWith2 = _interopRequireDefault(_endsWith);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function get(object, path, defaultValue) {
	  var modelString = path;
	
	  if (typeof path === 'number') {
	    var result = object[path];
	
	    return result === undefined ? defaultValue : result;
	  }
	
	  if (!path.length) return object;
	
	  if ((0, _endsWith2.default)(modelString, '.')) {
	    modelString = modelString.slice(0, -1);
	  } else if ((0, _endsWith2.default)(modelString, '[]')) {
	    modelString = modelString.slice(0, -2);
	  }
	
	  return (0, _lodash2.default)(object, modelString, defaultValue);
	}

/***/ },
/* 929 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/,
	    reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    splice = arrayProto.splice;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  string = toString(string);
	
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 930 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endsWith;
	function endsWith(string, subString) {
	  if (typeof string !== 'string') return false;
	
	  var lastIndex = string.lastIndexOf(subString);
	
	  return lastIndex !== -1 && lastIndex + subString.length === string.length;
	}

/***/ },
/* 931 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function mapValues(object, iteratee) {
	  var result = {};
	
	  Object.keys(object || {}).forEach(function (key) {
	    result[key] = iteratee(object[key], key, object);
	  });
	
	  return result;
	}
	
	exports.default = mapValues;

/***/ },
/* 932 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actionTypes = {
	  BLUR: 'rrf/blur',
	  CHANGE: 'rrf/change',
	  FOCUS: 'rrf/focus',
	  RESET: 'rrf/reset',
	  VALIDATE: 'rrf/validate',
	  SET_DIRTY: 'rrf/setDirty',
	  SET_ERRORS: 'rrf/setErrors',
	  SET_INITIAL: 'rrf/setInitial',
	  SET_PENDING: 'rrf/setPending',
	  SET_PRISTINE: 'rrf/setPristine',
	  SET_SUBMITTED: 'rrf/setSubmitted',
	  SET_SUBMIT_FAILED: 'rrf/setSubmitFailed',
	  SET_TOUCHED: 'rrf/setTouched',
	  SET_UNTOUCHED: 'rrf/setUntouched',
	  SET_VALIDITY: 'rrf/setValidity',
	  SET_VALIDATING: 'rrf/setValidating',
	  SET_FIELDS_VALIDITY: 'rrf/setFieldsValidity',
	  SET_VIEW_VALUE: 'rrf/setViewValue',
	  RESET_VALIDITY: 'rrf/resetValidity',
	  BATCH: 'rrf/batch',
	  NULL: null,
	  ADD_INTENT: 'rrf/addIntent',
	  CLEAR_INTENTS: 'rrf/clearIntents'
	};
	
	exports.default = actionTypes;

/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dispatchBatchIfNeeded = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _actionTypes = __webpack_require__(932);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _partition3 = __webpack_require__(934);
	
	var _partition4 = _interopRequireDefault(_partition3);
	
	var _isPlainObject = __webpack_require__(935);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _track = __webpack_require__(936);
	
	var _nullAction = __webpack_require__(940);
	
	var _nullAction2 = _interopRequireDefault(_nullAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var batch = (0, _track.trackable)(function (model, actions) {
	  var dispatchableActions = actions.filter(function (action) {
	    return !!action;
	  });
	
	  if (!dispatchableActions.length) return _nullAction2.default;
	
	  if (dispatchableActions.length && dispatchableActions.every(_isPlainObject2.default)) {
	    if (dispatchableActions.length === 1) {
	      return dispatchableActions[0];
	    }
	
	    return {
	      type: _actionTypes2.default.BATCH,
	      model: model,
	      actions: dispatchableActions
	    };
	  }
	
	  var _partition = (0, _partition4.default)(dispatchableActions, function (action) {
	    return typeof action !== 'function';
	  }),
	      _partition2 = _slicedToArray(_partition, 2),
	      plainActions = _partition2[0],
	      actionThunks = _partition2[1];
	
	  if (!actionThunks.length) {
	    if (plainActions.length > 1) {
	      return {
	        type: _actionTypes2.default.BATCH,
	        model: model,
	        actions: plainActions
	      };
	    } else if (plainActions.length === 1) {
	      return plainActions[0];
	    }
	  }
	
	  return function (dispatch) {
	    if (plainActions.length > 1) {
	      dispatch({
	        type: _actionTypes2.default.BATCH,
	        model: model,
	        actions: plainActions
	      });
	    } else if (plainActions.length === 1) {
	      dispatch(plainActions[0]);
	    }
	    actionThunks.forEach(dispatch);
	  };
	});
	
	function dispatchBatchIfNeeded(model, actions, dispatch) {
	  if (!actions.length) return void 0;
	
	  var dispatchableActions = actions.filter(function (action) {
	    return !!action;
	  });
	
	  if (!dispatchableActions.length) return void 0;
	
	  return dispatch(batch(model, dispatchableActions));
	}
	
	exports.default = batch;
	exports.dispatchBatchIfNeeded = dispatchBatchIfNeeded;

/***/ },
/* 934 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = partition;
	function partition(collection, predicate) {
	  var result = [[], []];
	
	  collection.forEach(function (item, index) {
	    if (predicate(item, index, collection)) {
	      result[0].push(item);
	    } else {
	      result[1].push(item);
	    }
	  });
	
	  return result;
	}

/***/ },
/* 935 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isPlainObject;
	// Adapted from https://github.com/jonschlinkert/is-plain-object
	function isObject(val) {
	  return val != null && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && Array.isArray(val) === false;
	}
	
	function isObjectObject(o) {
	  return isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
	}
	
	function isPlainObject(o) {
	  if (isObjectObject(o) === false) return false;
	
	  // If has modified constructor
	  var ctor = o.constructor;
	  if (typeof ctor !== 'function') return false;
	
	  // If has modified prototype
	  var prot = ctor.prototype;
	  if (isObjectObject(prot) === false) return false;
	
	  // If constructor does not have an Object-specific method
	  if (prot.hasOwnProperty('isPrototypeOf') === false) {
	    return false;
	  }
	
	  // Most likely a plain Object
	  return true;
	}

/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.trackable = exports.createTrack = undefined;
	
	var _findKey = __webpack_require__(937);
	
	var _findKey2 = _interopRequireDefault(_findKey);
	
	var _get2 = __webpack_require__(928);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _iteratee = __webpack_require__(938);
	
	var _iteratee2 = _interopRequireDefault(_iteratee);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	var defaultStrategy = {
	  get: _get3.default
	};
	
	function createTrack() {
	  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultStrategy;
	
	  return function track(model) {
	    for (var _len = arguments.length, predicates = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      predicates[_key - 1] = arguments[_key];
	    }
	
	    var isPartial = model[0] === '.';
	
	    return function (fullState, parentModel) {
	      var childModel = isPartial ? model.slice(1) : model;
	      var state = isPartial ? s.get(fullState, parentModel) : fullState;
	
	      var _childModel$split = childModel.split(/\[\]\.?/),
	          _childModel$split2 = _toArray(_childModel$split),
	          parentModelPath = _childModel$split2[0],
	          childModelPaths = _childModel$split2.slice(1);
	
	      var fullPath = parentModelPath;
	      var subState = s.get(state, fullPath);
	
	      predicates.forEach(function (predicate, i) {
	        var childModelPath = childModelPaths[i];
	        var predicateIteratee = (0, _iteratee2.default)(predicate);
	
	        var subPath = childModelPath ? (0, _findKey2.default)(subState, predicateIteratee) + '.' + childModelPath : '' + (0, _findKey2.default)(subState, predicateIteratee);
	
	        subState = s.get(subState, subPath);
	        fullPath += '.' + subPath;
	      });
	
	      return isPartial ? [parentModel, fullPath].join('.') : fullPath;
	    };
	  };
	}
	
	var track = createTrack();
	
	function trackable(actionCreator) {
	  return function (model) {
	    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      args[_key2 - 1] = arguments[_key2];
	    }
	
	    if (typeof model === 'function') {
	      return function (dispatch, getState) {
	        var modelPath = model(getState());
	
	        dispatch(actionCreator.apply(undefined, [modelPath].concat(args)));
	      };
	    }
	
	    return actionCreator.apply(undefined, [model].concat(args));
	  };
	}
	
	exports.default = track;
	exports.createTrack = createTrack;
	exports.trackable = trackable;

/***/ },
/* 937 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = findKey;
	function findKey(object, predicate) {
	  var resultKey = void 0;
	
	  Object.keys(object).some(function (key) {
	    var isKey = predicate(object[key], key, object);
	
	    if (isKey) {
	      resultKey = key;
	      return true;
	    }
	
	    return false;
	  });
	
	  return resultKey;
	}

/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = iteratee;
	exports.iterateeValue = iterateeValue;
	
	var _identity = __webpack_require__(939);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function matcher(object) {
	  return function (compareObject) {
	    if (compareObject === object) return true;
	
	    return Object.keys(object).every(function (key) {
	      return object[key] === compareObject[key];
	    });
	  };
	}
	
	function propChecker(prop) {
	  return function (object) {
	    return object && !!object[prop];
	  };
	}
	
	function iteratee(value) {
	  if (typeof value === 'function') {
	    return value;
	  }
	
	  if (value === null) {
	    return _identity2.default;
	  }
	
	  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	    return matcher(value);
	  }
	
	  return propChecker(value);
	}
	
	function iterateeValue(data, value) {
	  if (typeof value === 'function') {
	    return value(data);
	  }
	
	  if (!Array.isArray(value) && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' && typeof value !== 'string') {
	    return !!value;
	  }
	
	  return iteratee(value)(data);
	}

/***/ },
/* 939 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = identity;
	function identity(a) {
	  return a;
	}

/***/ },
/* 940 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NULL_ACTION = { type: null };
	
	exports.default = NULL_ACTION;

/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getValidity;
	
	var _getValue = __webpack_require__(942);
	
	var _getValue2 = _interopRequireDefault(_getValue);
	
	var _mapValues = __webpack_require__(931);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getValidity(validators, value) {
	  var modelValue = (0, _getValue2.default)(value);
	
	  if (typeof validators === 'function') {
	    return validators(modelValue);
	  }
	
	  return (0, _mapValues2.default)(validators, function (validator) {
	    return getValidity(validator, modelValue);
	  });
	}

/***/ },
/* 942 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getValue;
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function isEvent(event) {
	  return !!(event && event.stopPropagation && event.preventDefault);
	}
	
	function getEventValue(event) {
	  var target = event.target;
	
	
	  if (!target) {
	    if (!event.nativeEvent) {
	      return undefined;
	    }
	
	    return event.nativeEvent.text;
	  }
	
	  if (target.type === 'file') {
	    return [].concat(_toConsumableArray(target.files)) || target.dataTransfer && [].concat(_toConsumableArray(target.dataTransfer.files));
	  }
	
	  if (target.multiple) {
	    return [].concat(_toConsumableArray(target.selectedOptions)).map(function (option) {
	      return option.value;
	    });
	  }
	
	  return target.value;
	}
	
	function getValue(value) {
	  return isEvent(value) ? getEventValue(value) : value;
	}

/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isValidityValid;
	
	var _isPlainObject = __webpack_require__(935);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidityValid(validity) {
	  if ((0, _isPlainObject2.default)(validity)) {
	    return Object.keys(validity).every(function (key) {
	      return isValidityValid(validity[key]);
	    });
	  }
	
	  return !!validity;
	}

/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isValidityInvalid;
	
	var _isPlainObject = __webpack_require__(935);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidityInvalid(errors) {
	  if (Array.isArray(errors)) {
	    return errors.some(isValidityInvalid);
	  }
	
	  if ((0, _isPlainObject2.default)(errors)) {
	    return Object.keys(errors).some(function (key) {
	      return isValidityInvalid(errors[key]);
	    });
	  }
	
	  return !!errors;
	}

/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = invertValidity;
	
	var _isPlainObject = __webpack_require__(935);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _mapValues = __webpack_require__(931);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function invertValidity(validity) {
	  if ((0, _isPlainObject2.default)(validity)) {
	    return (0, _mapValues2.default)(validity, invertValidity);
	  }
	
	  return !validity;
	}

/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.clearGetFormCache = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.getFormStateKey = getFormStateKey;
	
	var _get = __webpack_require__(928);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _isPlainObject = __webpack_require__(935);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _pathStartsWith = __webpack_require__(947);
	
	var _pathStartsWith2 = _interopRequireDefault(_pathStartsWith);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStrategy = {
	  get: _get2.default,
	  keys: function keys(state) {
	    return Object.keys(state);
	  },
	  isObject: function isObject(state) {
	    return (0, _isPlainObject2.default)(state);
	  }
	};
	
	function joinPaths() {
	  for (var _len = arguments.length, paths = Array(_len), _key = 0; _key < _len; _key++) {
	    paths[_key] = arguments[_key];
	  }
	
	  return paths.filter(function (path) {
	    return !!path && path.length;
	  }).join('.');
	}
	
	function getFormStateKey(state, model) {
	  var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultStrategy;
	  var currentPath = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	
	  var deepCandidateKeys = [];
	  var result = null;
	
	  s.keys(state).some(function (key) {
	    var subState = s.get(state, key);
	
	    if (subState && s.get(subState, '$form')) {
	      var subStateModel = s.get(subState, '$form.model');
	
	      if ((0, _pathStartsWith2.default)(model, subStateModel) || subStateModel === '') {
	        var _ret = function () {
	          var localPath = (0, _pathStartsWith.pathDifference)(model, subStateModel);
	
	          var resultPath = [currentPath, key];
	          var currentState = subState;
	
	          localPath.every(function (segment) {
	            if (s.get(currentState, segment) && s.get(currentState, segment + '.$form')) {
	              currentState = s.get(currentState, segment);
	              resultPath.push(segment);
	
	              return true;
	            }
	
	            return false;
	          });
	
	          result = joinPaths.apply(undefined, resultPath);
	
	          return {
	            v: true
	          };
	        }();
	
	        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	      }
	
	      return false;
	    }
	
	    if (s.isObject(subState)) {
	      deepCandidateKeys.push(key);
	    }
	
	    return false;
	  });
	
	  if (result) return result;
	
	  deepCandidateKeys.some(function (key) {
	    result = getFormStateKey(s.get(state, key), model, s, joinPaths(currentPath, key));
	
	    return !!result;
	  });
	
	  if (result) return result;
	
	  return null;
	}
	
	var formStateKeyCache = {};
	
	var clearGetFormCache = exports.clearGetFormCache = function clearGetFormCache() {
	  return formStateKeyCache = {};
	}; // eslint-disable-line no-return-assign
	
	var getFormStateKeyCached = function () {
	  return function (state, modelString) {
	    var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultStrategy;
	
	    if (formStateKeyCache[modelString]) return formStateKeyCache[modelString];
	
	    var result = getFormStateKey(state, modelString, s);
	
	    formStateKeyCache[modelString] = result; // eslint-disable-line no-return-assign
	
	    return result;
	  };
	}();
	
	function getForm(state, modelString) {
	  var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultStrategy;
	
	  var formStateKey = getFormStateKeyCached(state, modelString, s);
	
	  if (!formStateKey) {
	    return null;
	  }
	
	  var form = s.get(state, formStateKey);
	
	  return form;
	}
	
	exports.default = getForm;

/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = pathStartsWith;
	exports.pathDifference = pathDifference;
	
	var _lodash = __webpack_require__(948);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function pathStartsWith(pathString, subPathString) {
	  if (pathString === subPathString) return true;
	
	  var path = (0, _lodash2.default)(pathString);
	  var subPath = (0, _lodash2.default)(subPathString);
	
	  var startsWithSubPath = subPath.every(function (segment, index) {
	    return path[index] === segment;
	  });
	
	  return startsWithSubPath;
	}
	
	function pathDifference(pathString, subPathString) {
	  if (pathString === subPathString) return [];
	
	  var path = (0, _lodash2.default)(pathString);
	  var subPath = (0, _lodash2.default)(subPathString);
	
	  var difference = path.reduce(function (acc, segment, index) {
	    if (segment === subPath[index]) return acc;
	
	    acc.push(segment);
	
	    return acc;
	  }, []);
	
	  return difference;
	}

/***/ },
/* 948 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    splice = arrayProto.splice;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  string = toString(string);
	
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Converts `value` to a property path array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Util
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the new property path array.
	 * @example
	 *
	 * _.toPath('a.b.c');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toPath('a[0].b.c');
	 * // => ['a', '0', 'b', 'c']
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return arrayMap(value, toKey);
	  }
	  return isSymbol(value) ? [value] : copyArray(stringToPath(value));
	}
	
	module.exports = toPath;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getFieldFromState;
	
	var _get = __webpack_require__(928);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _toPath = __webpack_require__(950);
	
	var _toPath2 = _interopRequireDefault(_toPath);
	
	var _getForm = __webpack_require__(946);
	
	var _getForm2 = _interopRequireDefault(_getForm);
	
	var _isPlainObject = __webpack_require__(935);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _invariant = __webpack_require__(754);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStrategy = {
	  getForm: _getForm2.default
	};
	
	function getFieldFromState(state, modelString) {
	  var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultStrategy;
	
	  var form = state && '$form' in state ? state : s.getForm(state, modelString);
	
	  if (!form) return null;
	
	  if (!modelString.length) return form;
	
	  (0, _invariant2.default)(form, 'Could not find form for "%s" in the store.', modelString);
	
	  var formPath = (0, _toPath2.default)(form.$form.model);
	  var fieldPath = (0, _toPath2.default)(modelString).slice(formPath.length);
	  var field = (0, _get2.default)(form, fieldPath);
	
	  if (!field) return null;
	  if ((0, _isPlainObject2.default)(field) && '$form' in field) return field.$form;
	
	  return field;
	}

/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toPath;
	
	var _lodash = __webpack_require__(948);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _endsWith = __webpack_require__(930);
	
	var _endsWith2 = _interopRequireDefault(_endsWith);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toPath(value) {
	  var path = value;
	
	  if ((0, _endsWith2.default)(path, '.')) {
	    path = path.slice(0, -1);
	  } else if ((0, _endsWith2.default)(path, '[]')) {
	    path = path.slice(0, -2);
	  }
	
	  return (0, _lodash2.default)(path);
	}

/***/ },
/* 951 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';
	
	exports.default = isReactNative;

/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createModelActions = createModelActions;
	
	var _get2 = __webpack_require__(928);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _identity = __webpack_require__(939);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _icepick = __webpack_require__(953);
	
	var _icepick2 = _interopRequireDefault(_icepick);
	
	var _getValue = __webpack_require__(942);
	
	var _getValue2 = _interopRequireDefault(_getValue);
	
	var _isMulti = __webpack_require__(954);
	
	var _isMulti2 = _interopRequireDefault(_isMulti);
	
	var _actionTypes = __webpack_require__(932);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _mapValues = __webpack_require__(931);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _track = __webpack_require__(936);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var defaultStrategies = {
	  get: _get3.default,
	  getValue: _getValue2.default,
	  splice: _icepick2.default.splice,
	  merge: _icepick2.default.merge,
	  remove: _icepick2.default.dissoc,
	  push: _icepick2.default.push,
	  length: function length(value) {
	    return value.length;
	  },
	  object: {},
	  array: []
	};
	
	function optionsFromArgs(args, index) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  if (typeof index === 'undefined') return undefined;
	
	  return _extends({}, options, args[index]);
	}
	
	function createModelActions() {
	  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultStrategies;
	
	  var change = function change(model, value) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    // option defaults
	    var changeOptions = _extends({
	      silent: false,
	      multi: (0, _isMulti2.default)(model),
	      external: true
	    }, options);
	
	    if (typeof value === 'function') {
	      return function (dispatch, getState) {
	        var modelValue = s.get(getState(), model);
	
	        return dispatch(change(model, value(modelValue), options));
	      };
	    }
	
	    return _extends({
	      type: _actionTypes2.default.CHANGE,
	      model: model,
	      value: s.getValue(value)
	    }, changeOptions);
	  };
	
	  function createModifierAction(modifier, defaultValue, optionsIndex, getOptions) {
	    var actionCreator = function actionCreator(model) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return function (dispatch, getState) {
	        var modelValue = s.get(getState(), model, defaultValue);
	        var value = modifier.apply(undefined, [modelValue].concat(args));
	
	        var options = getOptions ? getOptions.apply(undefined, [value].concat(args)) : undefined;
	
	        dispatch(change(model, value, optionsFromArgs(args, optionsIndex - 1, options)));
	      };
	    };
	
	    return actionCreator;
	  }
	
	  var xor = createModifierAction(function (value, item) {
	    var iteratee = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (_item) {
	      return _item === item;
	    };
	
	    var valueWithoutItem = value.filter(function (_item) {
	      return !iteratee(_item);
	    });
	
	    return s.length(value) === s.length(valueWithoutItem) ? [].concat(_toConsumableArray(value), [item]) : valueWithoutItem;
	  }, s.array, 3);
	
	  var push = createModifierAction(function (value, item) {
	    return s.push(value || s.array, item);
	  }, s.array, 2);
	
	  var toggle = createModifierAction(function (value) {
	    return !value;
	  }, undefined, 1);
	
	  var checkWithValue = function checkWithValue(model, value) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var currentValue = options.currentValue;
	
	
	    if ((0, _isMulti2.default)(model)) {
	      var valueWithItem = currentValue || s.array;
	      var valueWithoutItem = (valueWithItem || s.array).filter(function (item) {
	        return item !== value;
	      });
	      var multiValue = s.length(valueWithoutItem) === s.length(valueWithItem) ? s.push(valueWithItem, value) : valueWithoutItem;
	
	      return change(model, multiValue);
	    }
	
	    return change(model, !currentValue);
	  };
	
	  var check = function check(model, value) {
	    return function (dispatch, getState) {
	      var modelValue = s.get(getState(), model);
	
	      var action = checkWithValue(model, value, {
	        currentValue: modelValue
	      });
	
	      dispatch(action);
	    };
	  };
	
	  var filter = createModifierAction(function (value, iteratee) {
	    return value.filter(iteratee);
	  }, s.array, 2);
	
	  var reset = function reset(model) {
	    return {
	      type: _actionTypes2.default.RESET,
	      model: model
	    };
	  };
	
	  var map = createModifierAction(function (value) {
	    var iteratee = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _identity2.default;
	    return value.map(iteratee);
	  }, s.array, 2);
	
	  var remove = createModifierAction(function (value, index) {
	    return s.splice(value, index, 1);
	  }, s.array, 2, function (_, index) {
	    return { removeKeys: [index] };
	  });
	
	  var move = createModifierAction(function (value, indexFrom, indexTo) {
	    if (indexFrom >= s.length(value) || indexTo >= s.length(value)) {
	      throw new Error('Error moving array item: invalid bounds ' + indexFrom + ', ' + indexTo);
	    }
	
	    var item = s.get(value, indexFrom);
	    var removed = s.splice(value, indexFrom, 1);
	    var inserted = s.splice(removed, indexTo, 0, item);
	
	    return inserted;
	  }, s.array, 3);
	
	  var merge = createModifierAction(s.merge, {}, 2);
	
	  var omit = createModifierAction(function (value) {
	    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    var propsArray = typeof props === 'string' ? [props] : props;
	
	    var newValue = propsArray.reduce(function (acc, prop) {
	      return s.remove(acc, prop);
	    }, value);
	
	    return newValue;
	  }, {}, 2, function (_, props) {
	    return { removeKeys: props };
	  });
	
	  var load = function load(model, values) {
	    return change(model, values, {
	      silent: true,
	      load: true
	    });
	  };
	
	  return (0, _mapValues2.default)({
	    change: change,
	    xor: xor,
	    push: push,
	    toggle: toggle,
	    check: check,
	    checkWithValue: checkWithValue,
	    filter: filter,
	    reset: reset,
	    map: map,
	    remove: remove,
	    move: move,
	    merge: merge,
	    omit: omit,
	    load: load
	  }, _track.trackable);
	}
	
	exports.default = createModelActions();

/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * This allows you to work with object hierarchies that have been frozen
	 * with Object.freeze().  "get" operations can use the normal JS syntax,
	 * but operations that modify the data will have to return partial copies of
	 * the structure. The portions of the structure that did not change will
	 * === their previous values.
	 *
	 * Inspired by clojure/mori and Immutable.js
	 */
	
	"use strict";
	
	var i = exports;
	
	// we only care about objects or arrays for now
	function weCareAbout(val) {
	  return null !== val &&
	    (Array.isArray(val) ||
	      // This will skip objects created with `new Foo()`
	      // and objects created with `Object.create(proto)`
	      // The benefit is ignoring DOM elements and event emitters,
	      // which are often circular.
	      isObjectLike(val));
	}
	
	function isObjectLike(val) {
	  return typeof val === "object" &&
	    val.constructor === Object &&
	    Object.getPrototypeOf(val) === Object.prototype;
	}
	
	
	function arrayClone(arr) {
	  var index = 0,
	    length = arr.length,
	    result = Array(length);
	
	  for (; index < length; index += 1) {
	    result[index] = arr[index];
	  }
	  return result;
	}
	
	function objClone(obj) {
	  var index = 0,
	    keys = Object.keys(obj),
	    length = keys.length,
	    key,
	    result = {};
	
	  for (; index < length; index += 1) {
	    key = keys[index];
	    result[key] = obj[key];
	  }
	  return result;
	}
	
	function clone(coll) {
	  if (Array.isArray(coll)) {
	    return arrayClone(coll);
	  } else {
	    return objClone(coll);
	  }
	}
	
	function freezeIfNeeded(coll) {
	  if (
	      weCareAbout(coll) &&
	      (
	        !Object.isFrozen(coll) &&
	        ("production") !== "production"
	      )) {
	    return baseFreeze(coll, []);
	  }
	  return coll;
	}
	
	function _freeze(coll) {
	  if (true) {
	    return coll;
	  }
	  if (typeof coll === "object") {
	    return Object.freeze(coll);
	  } else {
	    return coll;
	  }
	}
	
	function baseFreeze(coll, prevNodes) {
	  if (prevNodes.some(function (node) { return node === coll; })) {
	    throw new Error("object has a reference cycle");
	  }
	
	  Object.freeze(coll);
	  prevNodes.push(coll);
	  Object.keys(coll).forEach(function (key) {
	    var prop = coll[key];
	    if (weCareAbout(prop)) {
	      baseFreeze(prop, prevNodes);
	    }
	  });
	  prevNodes.pop();
	
	  return coll;
	}
	
	/**
	 * recrursively freeze an object and all its child objects
	 * @param  {Object|Array} coll
	 * @return {Object|Array}
	 */
	exports.freeze = function freeze(coll) {
	  if (true) {
	    return coll;
	  }
	  return baseFreeze(coll, []);
	};
	
	/**
	 * recursively un-freeze an object, by cloning frozen collections
	 * @param  {[type]} coll [description]
	 * @return {[type]}      [description]
	 */
	exports.thaw = function thaw(coll) {
	  if (weCareAbout(coll) && Object.isFrozen(coll)) {
	    var newColl = clone(coll);
	    Object.keys(newColl).forEach(function (key) {
	      newColl[key] = thaw(newColl[key]);
	    });
	    return newColl;
	  }
	  return coll;
	};
	
	/**
	 * set a value on an object or array
	 * @param  {Object|Array}  coll
	 * @param  {String|Number} key   Key or index
	 * @param  {Object}        value
	 * @return {Object|Array}        new object hierarchy with modifications
	 */
	exports.assoc = function assoc(coll, key, value) {
	  if (coll[key] === value) {
	    return _freeze(coll);
	  }
	
	  var newObj = clone(coll);
	
	  newObj[key] = freezeIfNeeded(value);
	
	  return _freeze(newObj);
	
	};
	exports.set = exports.assoc;
	
	/**
	 * un-set a value on an object or array
	 * @param  {Object|Array}  coll
	 * @param  {String|Number} key  Key or Index
	 * @return {Object|Array}       New object or array
	 */
	exports.dissoc = function dissoc(coll, key) {
	  var newObj = clone(coll);
	
	  delete newObj[key];
	
	  return _freeze(newObj);
	};
	exports.unset = exports.dissoc;
	
	/**
	 * set a value deep in a hierarchical structure
	 * @param  {Object|Array} coll
	 * @param  {Array}        path    A list of keys to traverse
	 * @param  {Object}       value
	 * @return {Object|Array}       new object hierarchy with modifications
	 */
	exports.assocIn = function assocIn(coll, path, value) {
	  var key0 = path[0];
	  if (path.length === 1) {
	    // simplest case is a 1-element array.  Just a simple assoc.
	    return i.assoc(coll, key0, value);
	  } else {
	    // break the problem down.  Assoc this object with the first key
	    // and the result of assocIn with the rest of the keys
	    return i.assoc(coll, key0, assocIn(coll[key0] || {}, path.slice(1), value));
	  }
	};
	exports.setIn = exports.assocIn;
	
	/**
	 * get an object from a hierachy based on an array of keys
	 * @param  {Object|Array} coll
	 * @param  {Array}        path    list of keys
	 * @return {Object}       value, or undefined
	 */
	function baseGet(coll, path) {
	  return (path || []).reduce(function (curr, key) {
	    if (!curr) { return; }
	    return curr[key];
	  }, coll);
	}
	
	exports.getIn = baseGet;
	
	/**
	 * Update a value in a hierarchy
	 * @param  {Object|Array}   coll
	 * @param  {Array}          path     list of keys
	 * @param  {Function} callback The existing value with be passed to this.
	 *                             Return the new value to set
	 * @return {Object|Array}      new object hierarchy with modifications
	 */
	exports.updateIn = function updateIn(coll, path, callback) {
	  var existingVal = baseGet(coll, path);
	  return i.assocIn(coll, path, callback(existingVal));
	};
	
	
	// generate wrappers for the mutative array methods
	["push", "unshift", "pop", "shift", "reverse", "sort"]
	.forEach(function (methodName) {
	  exports[methodName] = function (arr, val) {
	    var newArr = arrayClone(arr);
	
	    newArr[methodName](freezeIfNeeded(val));
	
	    return _freeze(newArr);
	  };
	
	  exports[methodName].displayName = "icepick." + methodName;
	});
	
	// splice is special because it is variadic
	exports.splice = function splice(arr/*, args*/) {
	  var newArr = arrayClone(arr),
	    args = rest(arguments).map(freezeIfNeeded);
	
	  newArr.splice.apply(newArr, args);
	
	  return _freeze(newArr);
	};
	
	// slice is non-mutative
	exports.slice = function slice(arr, arg1, arg2) {
	  var newArr = arr.slice(arg1, arg2);
	
	  return _freeze(newArr);
	};
	
	["map", "filter"].forEach(function (methodName) {
	  exports[methodName] = function (fn, arr) {
	    var newArr = arr[methodName](fn);
	
	    return _freeze(newArr);
	  };
	
	  exports[methodName].displayName = "icepick." + methodName;
	});
	
	exports.extend =
	exports.assign = function assign(/*...objs*/) {
	  var newObj = rest(arguments).reduce(singleAssign, arguments[0]);
	
	  return _freeze(newObj);
	};
	
	function singleAssign(obj1, obj2) {
	  return Object.keys(obj2).reduce(function (obj, key) {
	    return i.assoc(obj, key, obj2[key]);
	  }, obj1);
	}
	
	exports.merge = merge;
	function merge(target, source, resolver) {
	  if (target == null || source == null) {
	    return target;
	  }
	  return Object.keys(source).reduce(function (obj, key) {
	    var sourceVal = source[key];
	    var targetVal = obj[key];
	
	    var resolvedSourceVal =
	      resolver ? resolver(targetVal, sourceVal, key) : sourceVal;
	
	    if (weCareAbout(sourceVal) && weCareAbout(targetVal)) {
	      // if they are both frozen and reference equal, assume they are deep equal
	      if ((
	            (Object.isFrozen(resolvedSourceVal) &&
	              Object.isFrozen(targetVal)) ||
	            ("production") === "production"
	          ) &&
	          resolvedSourceVal === targetVal) {
	        return obj;
	      }
	      if (Array.isArray(sourceVal)) {
	        return i.assoc(obj, key, resolvedSourceVal);
	      }
	      // recursively merge pairs of objects
	      return assocIfDifferent(obj, key,
	        merge(targetVal, resolvedSourceVal, resolver));
	    }
	
	    // primitive values, stuff with prototypes
	    return assocIfDifferent(obj, key, resolvedSourceVal);
	  }, target);
	}
	
	function assocIfDifferent(target, key, value) {
	  if (target[key] === value) {
	    return target;
	  }
	  return i.assoc(target, key, value);
	}
	
	function _slice(array, start) {
	  var begin = start || 0;
	  var len = array.length;
	  len -= begin;
	  len = len < 0 ? 0 : len;
	  var result = new Array(len);
	  for (var i = 0; i < len; i += 1) {
	    result[i] = array[i + begin];
	  }
	  return result;
	}
	
	
	function rest(args) {
	  return _slice(args, 1);
	}
	
	
	var chainProto = {
	  value: function value() {
	    return this.val;
	  },
	  thru: function thru(fn) {
	    this.val = freezeIfNeeded(fn(this.val));
	    return this;
	  }
	};
	
	Object.keys(exports).forEach(function (methodName) {
	  chainProto[methodName] = function (/*...args*/) {
	    var args = _slice(arguments);
	    args.unshift(this.val);
	    this.val = exports[methodName].apply(null, args);
	    return this;
	  };
	});
	
	exports.chain = function chain(val) {
	  var wrapped = Object.create(chainProto);
	  wrapped.val = val;
	  return wrapped;
	};
	
	// for testing
	exports._weCareAbout = weCareAbout;
	exports._slice = _slice;


/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMulti;
	
	var _endsWith = __webpack_require__(930);
	
	var _endsWith2 = _interopRequireDefault(_endsWith);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isMulti(model) {
	  return (0, _endsWith2.default)(model, '[]');
	}

/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createFieldClass = exports.controlPropsMap = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get2 = __webpack_require__(928);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _identity = __webpack_require__(939);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _omit = __webpack_require__(956);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _isPlainObject = __webpack_require__(935);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _pick = __webpack_require__(957);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _reactRedux = __webpack_require__(907);
	
	var _invariant = __webpack_require__(754);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _actions = __webpack_require__(926);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _controlComponent = __webpack_require__(958);
	
	var _controlComponent2 = _interopRequireDefault(_controlComponent);
	
	var _controlPropsMap2 = __webpack_require__(964);
	
	var _controlPropsMap3 = _interopRequireDefault(_controlPropsMap2);
	
	var _deepCompareChildren = __webpack_require__(969);
	
	var _deepCompareChildren2 = _interopRequireDefault(_deepCompareChildren);
	
	var _shallowCompareWithoutChildren = __webpack_require__(971);
	
	var _shallowCompareWithoutChildren2 = _interopRequireDefault(_shallowCompareWithoutChildren);
	
	var _getModel = __webpack_require__(962);
	
	var _getModel2 = _interopRequireDefault(_getModel);
	
	var _getFieldFromState = __webpack_require__(949);
	
	var _getFieldFromState2 = _interopRequireDefault(_getFieldFromState);
	
	var _resolveModel = __webpack_require__(966);
	
	var _resolveModel2 = _interopRequireDefault(_resolveModel);
	
	var _initialFieldState = __webpack_require__(967);
	
	var _initialFieldState2 = _interopRequireDefault(_initialFieldState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fieldPropTypes = {
	  model: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	  component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]),
	  parser: _react.PropTypes.func,
	  updateOn: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.string), _react.PropTypes.string]),
	  changeAction: _react.PropTypes.func,
	  validators: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.object]),
	  asyncValidators: _react.PropTypes.object,
	  validateOn: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.string), _react.PropTypes.string]),
	  asyncValidateOn: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.string), _react.PropTypes.string]),
	  errors: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.object]),
	  mapProps: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.object]),
	  componentMap: _react.PropTypes.object,
	  dynamic: _react.PropTypes.bool,
	  dispatch: _react.PropTypes.func,
	  getRef: _react.PropTypes.func,
	
	  // Calculated props
	  fieldValue: _react.PropTypes.object,
	  store: _react.PropTypes.shape({
	    subscribe: _react.PropTypes.func,
	    dispatch: _react.PropTypes.func,
	    getState: _react.PropTypes.func
	  })
	};
	
	function getControlType(control, props, options) {
	  var _controlPropsMap = options.controlPropsMap;
	
	
	  var controlDisplayNames = Object.keys(_controlPropsMap).filter(function (controlKey) {
	    var propsMap = _controlPropsMap[controlKey];
	
	    if ((0, _isPlainObject2.default)(propsMap) && propsMap.component) {
	      return control.type === propsMap.component;
	    }
	
	    return false;
	  });
	
	  if (controlDisplayNames.length) return controlDisplayNames[0];
	
	  try {
	    var controlDisplayName = control.constructor.displayName || control.type.displayName || control.type.name || control.type;
	
	    if (controlDisplayName === 'input') {
	      controlDisplayName = _controlPropsMap[control.props.type] ? control.props.type : 'text';
	    }
	
	    return _controlPropsMap[controlDisplayName] ? controlDisplayName : null;
	  } catch (error) {
	    return undefined;
	  }
	}
	
	var defaultStrategy = {
	  Control: _controlComponent2.default,
	  controlPropTypes: fieldPropTypes,
	  getFieldFromState: _getFieldFromState2.default,
	  actions: _actions2.default
	};
	
	function createFieldClass() {
	  var customControlPropsMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultStrategy;
	
	  // Use the fieldPropTypes if no controlProptypes have been defined to
	  // maintain backwards compatibiltiy.
	  var controlPropTypes = s.controlPropTypes || fieldPropTypes;
	
	  function mapStateToProps(state, props) {
	    var model = props.model;
	
	
	    var modelString = (0, _getModel2.default)(model, state);
	    var fieldValue = s.getFieldFromState(state, modelString) || _initialFieldState2.default;
	
	    return {
	      model: modelString,
	      fieldValue: fieldValue
	    };
	  }
	
	  var options = {
	    controlPropsMap: _extends({}, _controlPropsMap3.default, customControlPropsMap)
	  };
	
	  // TODO: refactor
	  var defaultControlPropsMap = {
	    checkbox: {
	      changeAction: s.actions.checkWithValue
	    }
	  };
	
	  var Field = function (_Component) {
	    _inherits(Field, _Component);
	
	    function Field() {
	      _classCallCheck(this, Field);
	
	      return _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).apply(this, arguments));
	    }
	
	    _createClass(Field, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        var dynamic = this.props.dynamic;
	
	
	        if (dynamic) {
	          return (0, _deepCompareChildren2.default)(this, nextProps);
	        }
	
	        return (0, _shallowCompareWithoutChildren2.default)(this, nextProps);
	      }
	    }, {
	      key: 'createControlComponent',
	      value: function createControlComponent(control) {
	        var props = this.props;
	
	
	        if (!control || !control.props || control instanceof _controlComponent2.default) {
	          return control;
	        }
	
	        var controlType = getControlType(control, props, options);
	        var _props$mapProps = props.mapProps,
	            mapProps = _props$mapProps === undefined ? options.controlPropsMap[controlType] : _props$mapProps;
	
	
	        var controlProps = (0, _pick2.default)(props, Object.keys(controlPropTypes));
	
	        if (!mapProps) {
	          return _react2.default.cloneElement(control, null, this.mapChildrenToControl(control.props.children));
	        }
	
	        return _react2.default.createElement(s.Control, _extends({}, controlProps, {
	          control: control,
	          controlProps: control.props,
	          component: control.type,
	          mapProps: mapProps
	        }, defaultControlPropsMap[controlType] || {}));
	      }
	    }, {
	      key: 'mapChildrenToControl',
	      value: function mapChildrenToControl(children) {
	        var _this2 = this;
	
	        if (_react2.default.Children.count(children) > 1) {
	          return _react2.default.Children.map(children, function (child) {
	            return _this2.createControlComponent(child);
	          });
	        }
	
	        return this.createControlComponent(children);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            component = _props.component,
	            children = _props.children,
	            fieldValue = _props.fieldValue;
	
	
	        var allowedProps = (0, _omit2.default)(this.props, Object.keys(controlPropTypes));
	        var renderableChildren = typeof children === 'function' ? children(fieldValue) : children;
	
	        if (!component) {
	          (0, _invariant2.default)(_react2.default.Children.count(renderableChildren) === 1, 'Empty wrapper components for <Field> are only possible' + 'when there is a single child. Please check the children' + ('passed into <Field model="' + this.props.model + '">.'));
	
	          return this.createControlComponent(renderableChildren);
	        }
	
	        return _react2.default.createElement(component, allowedProps, this.mapChildrenToControl(renderableChildren));
	      }
	    }]);
	
	    return Field;
	  }(_react.Component);
	
	  if (false) {
	    process.env.NODE_ENV !== "production" ? Field.propTypes = fieldPropTypes : void 0;
	  }
	
	  Field.defaultProps = {
	    updateOn: 'change',
	    asyncValidateOn: 'blur',
	    parser: _identity2.default,
	    changeAction: _actions2.default.change,
	    dynamic: true,
	    component: 'div'
	  };
	
	  return (0, _resolveModel2.default)((0, _reactRedux.connect)(mapStateToProps)(Field));
	}
	
	exports.controlPropsMap = _controlPropsMap3.default;
	exports.createFieldClass = createFieldClass;
	exports.default = createFieldClass(_controlPropsMap3.default);

/***/ },
/* 956 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = omit;
	function omit(object, props) {
	  if (object == null) {
	    return {};
	  }
	  var newObject = _extends({}, object);
	
	  if (typeof props === 'string') {
	    delete newObject[props];
	  } else {
	    props.forEach(function (prop) {
	      delete newObject[prop];
	    });
	  }
	
	  return newObject;
	}

/***/ },
/* 957 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = pick;
	function pick(object, props) {
	  var result = {};
	
	  for (var i = 0; i < props.length; i++) {
	    var prop = props[i];
	    result[prop] = object[prop];
	  }
	
	  return result;
	}

/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createControlClass = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(907);
	
	var _redux = __webpack_require__(888);
	
	var _identity = __webpack_require__(939);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _shallowEqual = __webpack_require__(959);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _get2 = __webpack_require__(928);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _merge = __webpack_require__(960);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _mapValues = __webpack_require__(931);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _isPlainObject = __webpack_require__(935);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _icepick = __webpack_require__(953);
	
	var _icepick2 = _interopRequireDefault(_icepick);
	
	var _omit = __webpack_require__(956);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _actionTypes = __webpack_require__(932);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _debounce = __webpack_require__(961);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _getValue = __webpack_require__(942);
	
	var _getValue2 = _interopRequireDefault(_getValue);
	
	var _getValidity = __webpack_require__(941);
	
	var _getValidity2 = _interopRequireDefault(_getValidity);
	
	var _invertValidity = __webpack_require__(945);
	
	var _invertValidity2 = _interopRequireDefault(_invertValidity);
	
	var _getFieldFromState = __webpack_require__(949);
	
	var _getFieldFromState2 = _interopRequireDefault(_getFieldFromState);
	
	var _getModel = __webpack_require__(962);
	
	var _getModel2 = _interopRequireDefault(_getModel);
	
	var _persistEventWithCallback = __webpack_require__(963);
	
	var _persistEventWithCallback2 = _interopRequireDefault(_persistEventWithCallback);
	
	var _actions = __webpack_require__(926);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _controlPropsMap = __webpack_require__(964);
	
	var _controlPropsMap2 = _interopRequireDefault(_controlPropsMap);
	
	var _validityKeys = __webpack_require__(965);
	
	var _validityKeys2 = _interopRequireDefault(_validityKeys);
	
	var _batchActions = __webpack_require__(933);
	
	var _resolveModel = __webpack_require__(966);
	
	var _resolveModel2 = _interopRequireDefault(_resolveModel);
	
	var _isNative = __webpack_require__(951);
	
	var _isNative2 = _interopRequireDefault(_isNative);
	
	var _initialFieldState = __webpack_require__(967);
	
	var _initialFieldState2 = _interopRequireDefault(_initialFieldState);
	
	var _containsEvent = __webpack_require__(968);
	
	var _containsEvent2 = _interopRequireDefault(_containsEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var findDOMNode = !_isNative2.default ? __webpack_require__(528).findDOMNode : null;
	
	var disallowedProps = ['changeAction', 'getFieldFromState', 'store'];
	
	function getReadOnlyValue(props) {
	  var modelValue = props.modelValue,
	      controlProps = props.controlProps;
	
	
	  switch (controlProps.type) {
	    case 'checkbox':
	      return typeof controlProps.value !== 'undefined' ? controlProps.value : !modelValue; // simple checkbox
	
	    case 'radio':
	    default:
	      return controlProps.value;
	  }
	}
	
	function mergeOrSetErrors(model, errors) {
	  return _actions2.default.setErrors(model, errors, {
	    merge: (0, _isPlainObject2.default)(errors)
	  });
	}
	
	var propTypes = {
	  model: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	  modelValue: _react.PropTypes.any,
	  viewValue: _react.PropTypes.any,
	  control: _react.PropTypes.any,
	  onLoad: _react.PropTypes.func,
	  onSubmit: _react.PropTypes.func,
	  fieldValue: _react.PropTypes.object,
	  mapProps: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.object]),
	  changeAction: _react.PropTypes.func,
	  updateOn: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.string), _react.PropTypes.string]),
	  validateOn: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.string), _react.PropTypes.string]),
	  validators: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.object]),
	  asyncValidateOn: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.string), _react.PropTypes.string]),
	  asyncValidators: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.object]),
	  errors: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.object]),
	  controlProps: _react.PropTypes.object,
	  component: _react.PropTypes.any,
	  dispatch: _react.PropTypes.func,
	  parser: _react.PropTypes.func,
	  ignore: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.string), _react.PropTypes.string]),
	  dynamic: _react.PropTypes.bool,
	  store: _react.PropTypes.shape({
	    subscribe: _react.PropTypes.func,
	    dispatch: _react.PropTypes.func,
	    getState: _react.PropTypes.func
	  }),
	  getRef: _react.PropTypes.func,
	  withField: _react.PropTypes.bool,
	  debounce: _react.PropTypes.number,
	  persist: _react.PropTypes.bool
	};
	
	var defaultStrategy = {
	  get: _get3.default,
	  getFieldFromState: _getFieldFromState2.default,
	  actions: _actions2.default
	};
	
	function createControlClass() {
	  var customControlPropsMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultStrategy;
	
	  var controlPropsMap = _extends({}, _controlPropsMap2.default, customControlPropsMap);
	
	  var emptyControlProps = {};
	
	  var Control = function (_Component) {
	    _inherits(Control, _Component);
	
	    function Control(props) {
	      _classCallCheck(this, Control);
	
	      var _this = _possibleConstructorReturn(this, (Control.__proto__ || Object.getPrototypeOf(Control)).call(this, props));
	
	      _this.getChangeAction = _this.getChangeAction.bind(_this);
	      _this.getValidateAction = _this.getValidateAction.bind(_this);
	
	      _this.handleKeyPress = _this.handleKeyPress.bind(_this);
	      _this.createEventHandler = _this.createEventHandler.bind(_this);
	      _this.handleFocus = _this.createEventHandler('focus').bind(_this);
	      _this.handleBlur = _this.createEventHandler('blur').bind(_this);
	      _this.handleUpdate = _this.createEventHandler('change').bind(_this);
	      _this.handleChange = _this.handleChange.bind(_this);
	      _this.handleLoad = _this.handleLoad.bind(_this);
	      _this.getMappedProps = _this.getMappedProps.bind(_this);
	      _this.attachNode = _this.attachNode.bind(_this);
	
	      if (props.debounce) {
	        _this.handleUpdate = (0, _debounce2.default)(_this.handleUpdate, props.debounce);
	      }
	
	      _this.willValidate = false;
	
	      _this.state = {
	        viewValue: props.modelValue
	      };
	      return _this;
	    }
	
	    _createClass(Control, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        this.attachNode();
	        this.handleLoad();
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (nextProps.modelValue !== this.props.modelValue) {
	          this.setViewValue(nextProps.modelValue);
	        }
	      }
	    }, {
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps, nextState) {
	        return !(0, _shallowEqual2.default)(this.props, nextProps, {
	          deepKeys: ['controlProps'],
	          omitKeys: ['mapProps']
	        }) || !(0, _shallowEqual2.default)(this.state.viewValue, nextState.viewValue);
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate() {
	        this.handleIntents();
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        var _props = this.props,
	            model = _props.model,
	            fieldValue = _props.fieldValue,
	            dispatch = _props.dispatch,
	            _props$validators = _props.validators,
	            validators = _props$validators === undefined ? {} : _props$validators,
	            _props$errors = _props.errors,
	            errors = _props$errors === undefined ? {} : _props$errors,
	            persist = _props.persist;
	
	
	        if (!persist && fieldValue && !fieldValue.valid) {
	          var keys = Object.keys(validators).concat(Object.keys(errors), this.willValidate ? _validityKeys2.default : []);
	
	          dispatch(_actions2.default.resetValidity(model, keys));
	        }
	      }
	    }, {
	      key: 'getMappedProps',
	      value: function getMappedProps() {
	        var props = this.props;
	        var mapProps = props.mapProps;
	        var viewValue = this.state.viewValue;
	
	        var originalProps = _extends({}, props, props.controlProps, {
	          onFocus: this.handleFocus,
	          onBlur: this.handleBlur,
	          onChange: this.handleChange,
	          onKeyPress: this.handleKeyPress,
	          viewValue: viewValue
	        });
	
	        if ((0, _isPlainObject2.default)(mapProps)) {
	          return (0, _mapValues2.default)(mapProps, function (value, key) {
	            if (typeof value === 'function' && key !== 'component') {
	              return value(originalProps);
	            }
	
	            return value;
	          });
	        }
	
	        return mapProps(originalProps);
	      }
	    }, {
	      key: 'getChangeAction',
	      value: function getChangeAction(event) {
	        var _props2 = this.props,
	            model = _props2.model,
	            modelValue = _props2.modelValue,
	            changeAction = _props2.changeAction;
	
	        var value = this.isReadOnlyValue() ? getReadOnlyValue(this.props) : event;
	
	        return changeAction(model, (0, _getValue2.default)(value), {
	          currentValue: modelValue,
	          external: false
	        });
	      }
	    }, {
	      key: 'getValidateAction',
	      value: function getValidateAction(value, eventName) {
	        var _props3 = this.props,
	            validators = _props3.validators,
	            errors = _props3.errors,
	            model = _props3.model,
	            modelValue = _props3.modelValue,
	            updateOn = _props3.updateOn,
	            fieldValue = _props3.fieldValue;
	
	
	        if (!validators && !errors) return false;
	
	        var nodeErrors = this.getNodeErrors();
	
	        // If it is not a change event, use the model value.
	        var valueToValidate = (0, _containsEvent2.default)(updateOn, eventName) ? value : modelValue;
	
	        if (validators || errors) {
	          var fieldValidity = (0, _getValidity2.default)(validators, valueToValidate);
	          var fieldErrors = (0, _merge2.default)((0, _getValidity2.default)(errors, valueToValidate), nodeErrors);
	
	          var mergedErrors = validators ? (0, _merge2.default)((0, _invertValidity2.default)(fieldValidity), fieldErrors) : fieldErrors;
	
	          if (!fieldValue || !(0, _shallowEqual2.default)(mergedErrors, fieldValue.errors)) {
	            return mergeOrSetErrors(model, mergedErrors);
	          }
	        } else if (nodeErrors && Object.keys(nodeErrors).length) {
	          return mergeOrSetErrors(model, nodeErrors);
	        }
	
	        return false;
	      }
	    }, {
	      key: 'getAsyncValidateAction',
	      value: function getAsyncValidateAction(value, eventName) {
	        var _props4 = this.props,
	            asyncValidators = _props4.asyncValidators,
	            fieldValue = _props4.fieldValue,
	            model = _props4.model,
	            modelValue = _props4.modelValue,
	            updateOn = _props4.updateOn,
	            dispatch = _props4.dispatch;
	
	        // If there are no async validators,
	        // do not run async validation
	
	        if (!asyncValidators) return false;
	
	        // If it is not a change event, use the model value.
	        var valueToValidate = (0, _containsEvent2.default)(updateOn, eventName) ? value : modelValue;
	
	        // If any sync validity is invalid,
	        // do not run async validation
	        var asyncValidatorKeys = Object.keys(asyncValidators);
	        var syncValid = Object.keys(fieldValue.validity).every(function (key) {
	          // If validity is based on async validator, skip
	          if (!!~asyncValidatorKeys.indexOf(key)) return true;
	
	          return fieldValue.validity[key];
	        });
	
	        if (!syncValid) return false;
	
	        dispatch(_actions2.default.setValidating(model, true));
	
	        (0, _mapValues2.default)(asyncValidators, function (validator, key) {
	          var outerDone = function outerDone(valid) {
	            var validity = _icepick2.default.merge(fieldValue.validity, _defineProperty({}, key, valid));
	
	            dispatch(_actions2.default.setValidity(model, validity));
	          };
	
	          validator((0, _getValue2.default)(valueToValidate), outerDone);
	        });
	
	        return valueToValidate;
	      }
	    }, {
	      key: 'getNodeErrors',
	      value: function getNodeErrors() {
	        var node = this.node,
	            fieldValue = this.props.fieldValue;
	
	
	        if (!node || !node.willValidate) {
	          this.willValidate = false;
	          return null;
	        }
	
	        this.willValidate = true;
	
	        var nodeErrors = {};
	
	        _validityKeys2.default.forEach(function (key) {
	          var errorValidity = node.validity[key];
	
	          // If the key is invalid or they key was
	          // previously invalid and is now valid,
	          // set its validity
	          if (errorValidity || fieldValue && fieldValue.errors[key]) {
	            nodeErrors[key] = errorValidity;
	          }
	        });
	
	        return nodeErrors;
	      }
	    }, {
	      key: 'setViewValue',
	      value: function setViewValue(viewValue) {
	        if (!this.isReadOnlyValue()) {
	          this.setState({ viewValue: this.parse(viewValue) });
	        }
	      }
	    }, {
	      key: 'isReadOnlyValue',
	      value: function isReadOnlyValue() {
	        var _props5 = this.props,
	            component = _props5.component,
	            controlProps = _props5.controlProps;
	
	
	        return component === 'input' && ~['radio', 'checkbox'].indexOf(controlProps.type);
	      }
	    }, {
	      key: 'handleIntents',
	      value: function handleIntents() {
	        var _this2 = this;
	
	        var _props6 = this.props,
	            model = _props6.model,
	            modelValue = _props6.modelValue,
	            fieldValue = _props6.fieldValue,
	            intents = _props6.fieldValue.intents,
	            controlProps = _props6.controlProps,
	            dispatch = _props6.dispatch,
	            updateOn = _props6.updateOn,
	            _props6$validateOn = _props6.validateOn,
	            validateOn = _props6$validateOn === undefined ? updateOn : _props6$validateOn;
	
	
	        if (!intents.length) return;
	
	        intents.forEach(function (intent) {
	          switch (intent.type) {
	            case _actionTypes2.default.FOCUS:
	              {
	                if (_isNative2.default) return;
	
	                var focused = fieldValue.focus;
	
	                if (focused && _this2.node.focus && (!_this2.isReadOnlyValue() || typeof intent.value === 'undefined' || intent.value === controlProps.value)) {
	                  _this2.node.focus();
	
	                  dispatch(_actions2.default.clearIntents(model, intent));
	                }
	
	                return;
	              }
	            case 'validate':
	              if ((0, _containsEvent2.default)(validateOn, 'change')) {
	                dispatch(_actions2.default.clearIntents(model, intent));
	                _this2.validate();
	              }
	              return;
	
	            case 'load':
	              if (!(0, _shallowEqual2.default)(modelValue, fieldValue.value)) {
	                dispatch(_actions2.default.clearIntents(model, intent));
	                dispatch(_actions2.default.load(model, fieldValue.value));
	              }
	              return;
	
	            default:
	              return;
	          }
	        });
	      }
	    }, {
	      key: 'parse',
	      value: function parse(value) {
	        return this.props.parser ? this.props.parser(value) : value;
	      }
	    }, {
	      key: 'handleChange',
	      value: function handleChange(event) {
	        this.setViewValue((0, _getValue2.default)(event));
	        this.handleUpdate(event);
	      }
	    }, {
	      key: 'handleKeyPress',
	      value: function handleKeyPress(event) {
	        var _props7 = this.props,
	            onKeyPress = _props7.controlProps.onKeyPress,
	            dispatch = _props7.dispatch;
	
	        // Get the value from the event
	        // in case updateOn="blur" (or something other than "change")
	
	        var parsedValue = this.parse((0, _getValue2.default)(event));
	
	        if (event.key === 'Enter') {
	          dispatch(this.getChangeAction(parsedValue));
	        }
	
	        if (onKeyPress) onKeyPress(event);
	      }
	    }, {
	      key: 'handleLoad',
	      value: function handleLoad() {
	        var _props8 = this.props,
	            model = _props8.model,
	            modelValue = _props8.modelValue,
	            fieldValue = _props8.fieldValue,
	            _props8$controlProps = _props8.controlProps,
	            controlProps = _props8$controlProps === undefined ? emptyControlProps : _props8$controlProps,
	            onLoad = _props8.onLoad,
	            dispatch = _props8.dispatch,
	            changeAction = _props8.changeAction,
	            parser = _props8.parser;
	
	        var defaultValue = undefined;
	
	        if (controlProps.hasOwnProperty('defaultValue')) {
	          defaultValue = controlProps.defaultValue;
	        } else if (controlProps.hasOwnProperty('defaultChecked')) {
	          defaultValue = controlProps.defaultChecked;
	        }
	
	        var loadActions = [this.getValidateAction(defaultValue)];
	
	        if (typeof defaultValue !== 'undefined') {
	          loadActions.push(changeAction(model, defaultValue));
	        } else {
	          if (parser) {
	            var parsedValue = parser(modelValue);
	
	            if (parsedValue !== modelValue) {
	              loadActions.push(changeAction(model, parsedValue));
	            }
	          }
	        }
	
	        (0, _batchActions.dispatchBatchIfNeeded)(model, loadActions, dispatch);
	
	        if (onLoad) onLoad(modelValue, fieldValue, this.node);
	      }
	    }, {
	      key: 'createEventHandler',
	      value: function createEventHandler(eventName) {
	        var _this3 = this;
	
	        var _props9 = this.props,
	            dispatch = _props9.dispatch,
	            model = _props9.model,
	            updateOn = _props9.updateOn,
	            _props9$validateOn = _props9.validateOn,
	            validateOn = _props9$validateOn === undefined ? updateOn : _props9$validateOn,
	            asyncValidateOn = _props9.asyncValidateOn,
	            _props9$controlProps = _props9.controlProps,
	            controlProps = _props9$controlProps === undefined ? emptyControlProps : _props9$controlProps,
	            parser = _props9.parser,
	            ignore = _props9.ignore,
	            withField = _props9.withField,
	            fieldValue = _props9.fieldValue;
	
	
	        var eventAction = {
	          focus: _actions2.default.silentFocus,
	          blur: _actions2.default.blur
	        }[eventName];
	
	        var controlEventHandler = {
	          focus: controlProps.onFocus,
	          blur: controlProps.onBlur,
	          change: controlProps.onChange
	        }[eventName];
	
	        var dispatchBatchActions = function dispatchBatchActions(persistedEvent) {
	          var eventActions = [eventAction && eventAction(model), (0, _containsEvent2.default)(validateOn, eventName) && _this3.getValidateAction(persistedEvent, eventName), (0, _containsEvent2.default)(updateOn, eventName) && _this3.getChangeAction(persistedEvent)];
	
	          (0, _batchActions.dispatchBatchIfNeeded)(model, eventActions, dispatch);
	
	          return persistedEvent;
	        };
	
	        return function (event) {
	          if ((0, _containsEvent2.default)(ignore, eventName)) {
	            return controlEventHandler ? controlEventHandler(event) : event;
	          }
	
	          if (_this3.isReadOnlyValue()) {
	            return (0, _redux.compose)(dispatchBatchActions, (0, _persistEventWithCallback2.default)(controlEventHandler || _identity2.default))(event);
	          }
	
	          return (0, _redux.compose)(function (e) {
	            if ((0, _containsEvent2.default)(asyncValidateOn, eventName)) {
	              _this3.getAsyncValidateAction(e, eventName);
	            }
	
	            return e;
	          }, dispatchBatchActions, parser, _getValue2.default, (0, _persistEventWithCallback2.default)(controlEventHandler || _identity2.default))(event, withField ? fieldValue : undefined);
	        };
	      }
	    }, {
	      key: 'attachNode',
	      value: function attachNode() {
	        var node = findDOMNode && findDOMNode(this);
	
	        if (node) this.node = node;
	      }
	    }, {
	      key: 'validate',
	      value: function validate() {
	        var _props10 = this.props,
	            model = _props10.model,
	            modelValue = _props10.modelValue,
	            fieldValue = _props10.fieldValue,
	            validators = _props10.validators,
	            errorValidators = _props10.errors,
	            dispatch = _props10.dispatch;
	
	
	        if (!validators && !errorValidators) return modelValue;
	        if (!fieldValue) return modelValue;
	
	        var fieldValidity = (0, _getValidity2.default)(validators, modelValue);
	        var fieldErrors = (0, _getValidity2.default)(errorValidators, modelValue);
	
	        var errors = validators ? (0, _merge2.default)((0, _invertValidity2.default)(fieldValidity), fieldErrors) : fieldErrors;
	
	        if (!(0, _shallowEqual2.default)(errors, fieldValue.errors)) {
	          dispatch(mergeOrSetErrors(model, errors));
	        }
	
	        return modelValue;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props11 = this.props,
	            _props11$controlProps = _props11.controlProps,
	            controlProps = _props11$controlProps === undefined ? emptyControlProps : _props11$controlProps,
	            component = _props11.component,
	            control = _props11.control,
	            getRef = _props11.getRef;
	
	
	        var mappedProps = (0, _omit2.default)(this.getMappedProps(), disallowedProps);
	
	        if (getRef) {
	          mappedProps.ref = getRef;
	        }
	
	        // If there is an existing control, clone it
	        if (control) {
	          return (0, _react.cloneElement)(control, mappedProps, controlProps.children);
	        }
	
	        return (0, _react.createElement)(component, _extends({}, controlProps, mappedProps));
	      }
	    }]);
	
	    return Control;
	  }(_react.Component);
	
	  Control.displayName = 'Control';
	
	   false ? Control.propTypes = propTypes : void 0;
	
	  Control.defaultProps = {
	    changeAction: s.actions.change,
	    updateOn: 'change',
	    asyncValidateOn: 'blur',
	    parser: _identity2.default,
	    controlProps: emptyControlProps,
	    ignore: [],
	    dynamic: false,
	    mapProps: controlPropsMap.default,
	    component: 'input',
	    withField: true,
	    persist: false
	  };
	
	  function mapStateToProps(state, props) {
	    var model = props.model,
	        _props$controlProps = props.controlProps,
	        controlProps = _props$controlProps === undefined ? (0, _omit2.default)(props, Object.keys(propTypes)) : _props$controlProps;
	
	
	    var modelString = (0, _getModel2.default)(model, state);
	    var fieldValue = s.getFieldFromState(state, modelString) || _initialFieldState2.default;
	
	    return {
	      model: modelString,
	      modelValue: s.get(state, modelString),
	      fieldValue: fieldValue,
	      controlProps: controlProps
	    };
	  }
	
	  var ConnectedControl = (0, _resolveModel2.default)((0, _reactRedux.connect)(mapStateToProps)(Control));
	
	  /* eslint-disable react/prop-types */
	  var DefaultConnectedControl = function DefaultConnectedControl(props) {
	    return _react2.default.createElement(ConnectedControl, _extends({
	      mapProps: _extends({}, controlPropsMap.default, props.mapProps)
	    }, (0, _omit2.default)(props, 'mapProps')));
	  };
	
	  DefaultConnectedControl.input = function (props) {
	    return _react2.default.createElement(ConnectedControl, _extends({
	      component: 'input',
	      mapProps: _extends({}, controlPropsMap.default, props.mapProps)
	    }, (0, _omit2.default)(props, 'mapProps')));
	  };
	
	  DefaultConnectedControl.text = function (props) {
	    return _react2.default.createElement(ConnectedControl, _extends({
	      component: 'input',
	      mapProps: _extends({}, controlPropsMap.text, {
	        type: 'text'
	      }, props.mapProps)
	    }, (0, _omit2.default)(props, 'mapProps')));
	  };
	
	  DefaultConnectedControl.textarea = function (props) {
	    return _react2.default.createElement(ConnectedControl, _extends({
	      component: 'textarea',
	      mapProps: _extends({}, controlPropsMap.textarea, props.mapProps)
	    }, (0, _omit2.default)(props, 'mapProps')));
	  };
	
	  DefaultConnectedControl.radio = function (props) {
	    return _react2.default.createElement(ConnectedControl, _extends({
	      component: 'input',
	      type: 'radio',
	      mapProps: _extends({}, controlPropsMap.radio, props.mapProps)
	    }, (0, _omit2.default)(props, 'mapProps')));
	  };
	
	  DefaultConnectedControl.checkbox = function (props) {
	    return _react2.default.createElement(ConnectedControl, _extends({
	      component: 'input',
	      type: 'checkbox',
	      mapProps: _extends({}, controlPropsMap.checkbox, props.mapProps),
	      changeAction: props.changeAction || s.actions.checkWithValue
	    }, (0, _omit2.default)(props, 'mapProps')));
	  };
	
	  DefaultConnectedControl.file = function (props) {
	    return _react2.default.createElement(ConnectedControl, _extends({
	      component: 'input',
	      type: 'file',
	      mapProps: _extends({}, controlPropsMap.file, props.mapProps)
	    }, (0, _omit2.default)(props, 'mapProps')));
	  };
	
	  DefaultConnectedControl.select = function (props) {
	    return _react2.default.createElement(ConnectedControl, _extends({
	      component: 'select',
	      mapProps: _extends({}, controlPropsMap.select, props.mapProps)
	    }, (0, _omit2.default)(props, 'mapProps')));
	  };
	
	  DefaultConnectedControl.button = function (props) {
	    return _react2.default.createElement(ConnectedControl, _extends({
	      component: 'button',
	      mapProps: _extends({}, controlPropsMap.button, props.mapProps)
	    }, (0, _omit2.default)(props, 'mapProps')));
	  };
	
	  DefaultConnectedControl.reset = function (props) {
	    return _react2.default.createElement(ConnectedControl, _extends({
	      component: 'button',
	      type: 'reset',
	      mapProps: _extends({}, controlPropsMap.reset, props.mapProps)
	    }, (0, _omit2.default)(props, 'mapProps')));
	  };
	
	  return DefaultConnectedControl;
	}
	
	exports.createControlClass = createControlClass;
	exports.default = createControlClass();

/***/ },
/* 959 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/* eslint-disable */
	
	var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	};
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
	    return false;
	  }
	
	  if (objA instanceof Date && objB instanceof Date) {
	    return objA === objB;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var omitKeys = options.omitKeys,
	      deepKeys = options.deepKeys;
	
	  // Test for A's keys different from B.
	
	  for (var i = 0; i < keysA.length; i++) {
	    // if key is an omitted key, skip comparison
	    if (omitKeys && omitKeys.length && ~omitKeys.indexOf(keysA[i])) continue;
	
	    if (deepKeys && deepKeys.length && ~deepKeys.indexOf(keysA[i])) {
	      var result = shallowEqual(objA[keysA[i]], objB[keysA[i]]);
	
	      if (!result) return false;
	    } else if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	exports.default = shallowEqual;

/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mergeDeep;
	
	var _icepick = __webpack_require__(953);
	
	var _icepick2 = _interopRequireDefault(_icepick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mergeDeep(target, source) {
	  return _icepick2.default.merge(target, source);
	}

/***/ },
/* 961 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = debounce;
	function debounce(func, delay) {
	  var timeout = void 0;
	
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var later = function later() {
	      timeout = null;
	      func.apply(null, args);
	    };
	
	    clearTimeout(timeout);
	    timeout = setTimeout(later, delay);
	  };
	}

/***/ },
/* 962 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getModel;
	function getModel(model, state) {
	  return typeof model === 'function' && state ? model(state) : model;
	}

/***/ },
/* 963 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = persistEventWithCallback;
	function persistEventWithCallback(callback) {
	  return function (event) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    if (event && event.persist) {
	      event.persist();
	    }
	
	    callback.apply(undefined, [event].concat(args));
	    return event;
	  };
	}

/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createControlPropsMap = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _isMulti = __webpack_require__(954);
	
	var _isMulti2 = _interopRequireDefault(_isMulti);
	
	var _iteratee = __webpack_require__(938);
	
	var _actions = __webpack_require__(926);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createControlPropsMap() {
	  function getTextValue(value) {
	    if (typeof value === 'string') {
	      return '' + value;
	    } else if (typeof value === 'number') {
	      return value;
	    }
	
	    return '';
	  }
	
	  function isChecked(props) {
	    if ((0, _isMulti2.default)(props.model)) {
	      if (!props.modelValue) return false;
	
	      return props.modelValue.some(function (item) {
	        return item === props.value;
	      });
	    }
	
	    return !!props.modelValue;
	  }
	
	  var standardPropsMap = {
	    name: function name(props) {
	      return props.name || props.model;
	    },
	    disabled: function disabled(_ref) {
	      var fieldValue = _ref.fieldValue,
	          _disabled = _ref.disabled;
	      return (0, _iteratee.iterateeValue)(fieldValue, _disabled);
	    },
	    onChange: function onChange(_ref2) {
	      var _onChange = _ref2.onChange;
	      return _onChange;
	    },
	    onBlur: function onBlur(_ref3) {
	      var _onBlur = _ref3.onBlur;
	      return _onBlur;
	    },
	    onFocus: function onFocus(_ref4) {
	      var _onFocus = _ref4.onFocus;
	      return _onFocus;
	    },
	    onKeyPress: function onKeyPress(_ref5) {
	      var _onKeyPress = _ref5.onKeyPress;
	      return _onKeyPress;
	    }
	  };
	
	  var textPropsMap = _extends({}, standardPropsMap, {
	    value: function value(props) {
	      return !props.defaultValue && !props.hasOwnProperty('value') ? getTextValue(props.viewValue) : props.value;
	    }
	  });
	
	  var getModelValue = function getModelValue(_ref6) {
	    var modelValue = _ref6.modelValue;
	    return modelValue;
	  };
	
	  return {
	    default: textPropsMap,
	    checkbox: _extends({}, standardPropsMap, {
	      checked: function checked(props) {
	        return props.defaultChecked ? props.checked : isChecked(props);
	      }
	    }),
	    radio: _extends({}, standardPropsMap, {
	      checked: function checked(props) {
	        return props.defaultChecked ? props.checked : props.modelValue === props.value;
	      },
	      value: function value(props) {
	        return props.value;
	      }
	    }),
	    select: _extends({}, standardPropsMap, {
	      value: getModelValue
	    }),
	    text: textPropsMap,
	    textarea: textPropsMap,
	    file: standardPropsMap,
	    button: _extends({}, standardPropsMap, {
	      value: getModelValue
	    }),
	    reset: _extends({}, standardPropsMap, {
	      onClick: function onClick(props) {
	        return function (event) {
	          event.preventDefault();
	          props.dispatch(_actions2.default.reset(props.model));
	        };
	      }
	    })
	  };
	}
	
	var controlPropsMap = createControlPropsMap();
	
	exports.default = controlPropsMap;
	exports.createControlPropsMap = createControlPropsMap;

/***/ },
/* 965 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var validityKeys = ['badInput', 'customError', 'patternMismatch', 'rangeOverflow', 'rangeUnderflow', 'stepMismatch', 'tooLong', 'tooShort', 'typeMismatch', 'valueMissing'];
	
	exports.default = validityKeys;

/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = wrapWithModelResolver;
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shallowEqual = __webpack_require__(959);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactComponent = _react.PureComponent || _react.Component;
	
	function resolveModel(model, parentModel) {
	  if (parentModel) {
	    if (model[0] === '.' || model[0] === '[') {
	      return '' + parentModel + model;
	    }
	
	    if (typeof model === 'function') {
	      return function (state) {
	        return model(state, parentModel);
	      };
	    }
	  }
	
	  return model;
	}
	
	function wrapWithModelResolver(WrappedComponent) {
	  var ResolvedModelWrapper = function (_ReactComponent) {
	    _inherits(ResolvedModelWrapper, _ReactComponent);
	
	    function ResolvedModelWrapper(props, context) {
	      _classCallCheck(this, ResolvedModelWrapper);
	
	      var _this = _possibleConstructorReturn(this, (ResolvedModelWrapper.__proto__ || Object.getPrototypeOf(ResolvedModelWrapper)).call(this, props, context));
	
	      _this.model = context.model;
	      _this.store = context.localStore;
	      return _this;
	    }
	
	    _createClass(ResolvedModelWrapper, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowEqual2.default)(this.props, nextProps);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var resolvedModel = resolveModel(this.props.model, this.model);
	
	        return _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
	          model: resolvedModel,
	          store: this.store || undefined
	        }));
	      }
	    }]);
	
	    return ResolvedModelWrapper;
	  }(ReactComponent);
	
	  ResolvedModelWrapper.displayName = 'Modeled(' + WrappedComponent.displayName + ')';
	
	  ResolvedModelWrapper.propTypes = {
	    model: _react.PropTypes.any
	  };
	
	  ResolvedModelWrapper.contextTypes = {
	    model: _react.PropTypes.any,
	    localStore: _react.PropTypes.shape({
	      subscribe: _react.PropTypes.func,
	      dispatch: _react.PropTypes.func,
	      getState: _react.PropTypes.func
	    })
	  };
	
	  return ResolvedModelWrapper;
	}

/***/ },
/* 967 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var initialFieldState = {
	  focus: false,
	  pending: false,
	  pristine: true,
	  submitted: false,
	  submitFailed: false,
	  retouched: false,
	  touched: false,
	  valid: true,
	  validating: false,
	  validated: false,
	  validity: {},
	  errors: {},
	  intents: []
	};
	
	exports.default = initialFieldState;

/***/ },
/* 968 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = containsEvent;
	function containsEvent(events, event) {
	  if (typeof events === 'string') {
	    return events === event;
	  }
	
	  return !!~events.indexOf(event);
	}

/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.compareChildren = compareChildren;
	exports.default = deepCompareChildren;
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shallowCompare = __webpack_require__(970);
	
	var _shallowCompare2 = _interopRequireDefault(_shallowCompare);
	
	var _shallowEqual = __webpack_require__(959);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function compareChildren(props, nextProps) {
	  var children = props.children;
	  var nextChildren = nextProps.children;
	
	  // If the number of children changed, then children are different.
	  // If there are no children, use shallowCompare in parent function
	  // to determine if component should update (false && true == false)
	
	  if (_react2.default.Children.count(children) !== _react2.default.Children.count(nextChildren) || !_react2.default.Children.count(children) || !_react2.default.Children.count(nextChildren)) {
	    return true;
	  }
	
	  var childrenArray = _react2.default.Children.toArray(children);
	  var nextChildrenArray = _react2.default.Children.toArray(nextChildren);
	
	  // React.Children.toArray strip's `false` children so lengths
	  // can change
	  if (childrenArray.length !== nextChildrenArray.length) {
	    return false;
	  }
	
	  return [].concat(childrenArray).some(function (child, i) {
	    var nextChild = nextChildrenArray[i];
	
	    if (!child.props || !nextChild.props) {
	      return !(0, _shallowEqual2.default)(child, nextChild);
	    }
	
	    /* eslint-disable no-use-before-define */
	    return deepCompareChildren(child, nextChild.props, nextChild.state);
	  });
	}
	
	function deepCompareChildren(instance, nextProps, nextState) {
	  if (!instance.props.children) return (0, _shallowCompare2.default)(instance, nextProps, nextState);
	
	  return (0, _shallowCompare2.default)(instance, nextProps, nextState) || compareChildren(instance.props, nextProps);
	}

/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	!function(global, factory) {
	     true ? module.exports = factory() : "function" == typeof define && define.amd ? define(factory) : global.shallowCompare = factory();
	}(this, function() {
	    "use strict";
	    function shallowDiffers(a, b) {
	        for (var i in a) if (!(i in b)) return !0;
	        for (var _i in b) if (a[_i] !== b[_i]) return !0;
	        return !1;
	    }
	    var index = function(instance, nextProps, nextState) {
	        return shallowDiffers(instance.props, nextProps) || shallowDiffers(instance.state, nextState);
	    };
	    return index;
	});
	//# sourceMappingURL=shallow-compare.js.map

/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = shallowCompareWithoutChildren;
	
	var _react = __webpack_require__(304);
	
	var _shallowEqual = __webpack_require__(959);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function shallowCompareWithoutChildren(instance, nextProps) {
	  return !(0, _shallowEqual2.default)(instance.props, nextProps, { omitKeys: ['children'] }) || _react.Children.count(instance.props.children) !== _react.Children.count(nextProps.children);
	}

/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(907);
	
	var _getModel = __webpack_require__(962);
	
	var _getModel2 = _interopRequireDefault(_getModel);
	
	var _omit = __webpack_require__(956);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _resolveModel = __webpack_require__(966);
	
	var _resolveModel2 = _interopRequireDefault(_resolveModel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  model: _react.PropTypes.string.isRequired,
	  component: _react.PropTypes.any,
	  dispatch: _react.PropTypes.func,
	  store: _react.PropTypes.shape({
	    subscribe: _react.PropTypes.func,
	    dispatch: _react.PropTypes.func,
	    getState: _react.PropTypes.func
	  })
	};
	
	var Fieldset = function (_Component) {
	  _inherits(Fieldset, _Component);
	
	  function Fieldset() {
	    _classCallCheck(this, Fieldset);
	
	    return _possibleConstructorReturn(this, (Fieldset.__proto__ || Object.getPrototypeOf(Fieldset)).apply(this, arguments));
	  }
	
	  _createClass(Fieldset, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return { model: this.props.model };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var component = this.props.component;
	
	
	      var allowedProps = (0, _omit2.default)(this.props, Object.keys(propTypes));
	
	      return _react2.default.createElement(component, allowedProps);
	    }
	  }]);
	
	  return Fieldset;
	}(_react.Component);
	
	Fieldset.displayName = 'Fieldset';
	
	Fieldset.childContextTypes = {
	  model: _react.PropTypes.any
	};
	
	 false ? Fieldset.propTypes = propTypes : void 0;
	
	Fieldset.defaultProps = {
	  component: 'div'
	};
	
	function mapStateToProps(state, _ref) {
	  var model = _ref.model;
	
	  var modelString = (0, _getModel2.default)(model, state);
	
	  return {
	    model: modelString
	  };
	}
	
	exports.default = (0, _resolveModel2.default)((0, _reactRedux.connect)(mapStateToProps)(Fieldset));

/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createFormClass = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(907);
	
	var _shallowEqual = __webpack_require__(959);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _get2 = __webpack_require__(928);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _omit = __webpack_require__(956);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _actions = __webpack_require__(926);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _getValidity = __webpack_require__(941);
	
	var _getValidity2 = _interopRequireDefault(_getValidity);
	
	var _invertValidators = __webpack_require__(974);
	
	var _invertValidators2 = _interopRequireDefault(_invertValidators);
	
	var _isValidityInvalid = __webpack_require__(944);
	
	var _isValidityInvalid2 = _interopRequireDefault(_isValidityInvalid);
	
	var _isValid = __webpack_require__(975);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _getForm = __webpack_require__(946);
	
	var _getForm2 = _interopRequireDefault(_getForm);
	
	var _getModel = __webpack_require__(962);
	
	var _getModel2 = _interopRequireDefault(_getModel);
	
	var _getField = __webpack_require__(976);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _deepCompareChildren = __webpack_require__(969);
	
	var _deepCompareChildren2 = _interopRequireDefault(_deepCompareChildren);
	
	var _containsEvent = __webpack_require__(968);
	
	var _containsEvent2 = _interopRequireDefault(_containsEvent);
	
	var _mergeValidity = __webpack_require__(977);
	
	var _mergeValidity2 = _interopRequireDefault(_mergeValidity);
	
	var _invariant = __webpack_require__(754);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _react.PropTypes.any,
	  validators: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.func]),
	  errors: _react.PropTypes.object,
	  validateOn: _react.PropTypes.oneOf(['change', 'submit']),
	  model: _react.PropTypes.string.isRequired,
	  modelValue: _react.PropTypes.any,
	  formValue: _react.PropTypes.object,
	  onSubmit: _react.PropTypes.func,
	  onSubmitFailed: _react.PropTypes.func,
	  dispatch: _react.PropTypes.func,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.node]),
	  store: _react.PropTypes.shape({
	    subscribe: _react.PropTypes.func,
	    dispatch: _react.PropTypes.func,
	    getState: _react.PropTypes.func
	  }),
	  onUpdate: _react.PropTypes.func,
	  onChange: _react.PropTypes.func,
	  getRef: _react.PropTypes.func,
	  getDispatch: _react.PropTypes.func,
	  onBeforeSubmit: _react.PropTypes.func,
	
	  // standard HTML attributes
	  action: _react.PropTypes.string
	};
	
	var defaultStrategy = {
	  get: _get3.default,
	  getForm: _getForm2.default,
	  actions: _actions2.default
	};
	
	function createFormClass() {
	  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultStrategy;
	
	  var Form = function (_Component) {
	    _inherits(Form, _Component);
	
	    function Form(props) {
	      _classCallCheck(this, Form);
	
	      var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));
	
	      _this.handleSubmit = _this.handleSubmit.bind(_this);
	      _this.handleReset = _this.handleReset.bind(_this);
	      _this.handleValidSubmit = _this.handleValidSubmit.bind(_this);
	      _this.handleInvalidSubmit = _this.handleInvalidSubmit.bind(_this);
	      _this.attachNode = _this.attachNode.bind(_this);
	      return _this;
	    }
	
	    _createClass(Form, [{
	      key: 'getChildContext',
	      value: function getChildContext() {
	        return {
	          model: this.props.model,
	          localStore: this.props.store
	        };
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        this.handleUpdate();
	        this.handleChange();
	
	        if ((0, _containsEvent2.default)(this.props.validateOn, 'change')) {
	          this.validate(this.props, true);
	        }
	
	        if (this.props.getDispatch) {
	          this.props.getDispatch(this.props.dispatch);
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if ((0, _containsEvent2.default)(nextProps.validateOn, 'change')) {
	          this.validate(nextProps);
	        }
	      }
	    }, {
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        return (0, _deepCompareChildren2.default)(this, nextProps);
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate(prevProps) {
	        this.handleIntents();
	
	        if (!(0, _shallowEqual2.default)(prevProps.formValue, this.props.formValue)) {
	          this.handleUpdate();
	        }
	
	        if (!(0, _shallowEqual2.default)(prevProps.modelValue, this.props.modelValue)) {
	          this.handleChange();
	        }
	      }
	    }, {
	      key: 'handleUpdate',
	      value: function handleUpdate() {
	        if (this.props.onUpdate) {
	          this.props.onUpdate(this.props.formValue);
	        }
	      }
	    }, {
	      key: 'handleChange',
	      value: function handleChange() {
	        if (this.props.onChange) {
	          this.props.onChange(this.props.modelValue);
	        }
	      }
	    }, {
	      key: 'attachNode',
	      value: function attachNode(node) {
	        if (!node) return;
	
	        this._node = node;
	
	        this._node.submit = this.handleSubmit;
	        if (this.props.getRef) this.props.getRef(node);
	      }
	    }, {
	      key: 'validate',
	      value: function validate(nextProps) {
	        var _this2 = this;
	
	        var initial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	        var submit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	        var _props = this.props,
	            model = _props.model,
	            dispatch = _props.dispatch,
	            formValue = _props.formValue,
	            modelValue = _props.modelValue;
	        var validators = nextProps.validators,
	            errors = nextProps.errors;
	
	
	        if (!formValue) return;
	
	        if (!validators && !errors && modelValue !== nextProps.modelValue) {
	          // If the form is invalid (due to async validity)
	          // but its fields are valid and the value has changed,
	          // the form should be "valid" again.
	          if (!formValue.$form.valid && (0, _isValid2.default)(formValue, { async: false })) {
	            dispatch(s.actions.setValidity(model, true));
	          }
	
	          return;
	        }
	
	        var validatorsChanged = validators !== this.props.validators || errors !== this.props.errors;
	        var fieldKeys = (validators ? Object.keys(validators) : []).concat(errors ? Object.keys(errors) : []);
	
	        var fieldsErrors = {};
	        var validityChanged = false;
	
	        var keysToValidate = [];
	
	        fieldKeys.forEach(function (key) {
	          if (!!~keysToValidate.indexOf(key)) return;
	
	          var valuesChanged = key === '' ? modelValue !== nextProps.modelValue : s.get(modelValue, key) !== s.get(nextProps.modelValue, key);
	
	          if (submit || initial || valuesChanged || validators && _this2.props.validators[key] !== validators[key] || errors && _this2.props.errors[key] !== errors[key] || !!~key.indexOf('[]')) {
	            keysToValidate.push(key);
	          }
	        });
	
	        var validateField = function validateField(field, errorValidator) {
	          if (!!~field.indexOf('[]')) {
	            (function () {
	              var _field$split = field.split('[]'),
	                  _field$split2 = _slicedToArray(_field$split, 2),
	                  parentModel = _field$split2[0],
	                  childModel = _field$split2[1];
	
	              var nextValue = parentModel ? s.get(nextProps.modelValue, parentModel) : nextProps.modelValue;
	
	              nextValue.forEach(function (subValue, index) {
	                validateField(parentModel + '[' + index + ']' + childModel, errorValidator);
	              });
	            })();
	          } else {
	            var nextValue = field ? s.get(nextProps.modelValue, field) : nextProps.modelValue;
	
	            var currentErrors = (0, _getField2.default)(formValue, field).errors;
	            var fieldErrors = (0, _getValidity2.default)(errorValidator, nextValue);
	
	            if (!validityChanged && !(0, _shallowEqual2.default)(fieldErrors, currentErrors)) {
	              validityChanged = true;
	            }
	
	            fieldsErrors[field] = (0, _mergeValidity2.default)(fieldsErrors[field], fieldErrors);
	          }
	        };
	
	        keysToValidate.forEach(function (field) {
	          if (validators && validators[field]) {
	            validateField(field, (0, _invertValidators2.default)(validators[field]));
	          }
	          if (errors && errors[field]) {
	            validateField(field, errors[field]);
	          }
	        });
	
	        if (typeof validators === 'function') {
	          var _ret2 = function () {
	            var nextValue = nextProps.modelValue;
	            var currentValue = modelValue;
	
	            if (!submit && !initial && !validatorsChanged && nextValue === currentValue) {
	              // If neither the validators nor the values have changed,
	              // the validity didn't change.
	              return {
	                v: void 0
	              };
	            }
	
	            var multiFieldErrors = (0, _getValidity2.default)(validators, nextValue);
	
	            if (multiFieldErrors) {
	              Object.keys(multiFieldErrors).forEach(function (key) {
	                // key will be the model value to apply errors to.
	                var fieldErrors = multiFieldErrors[key];
	                var currentErrors = (0, _getField2.default)(formValue, key).errors;
	
	                // Invert validators
	                Object.keys(fieldErrors).forEach(function (validationName) {
	                  fieldErrors[validationName] = !fieldErrors[validationName];
	                });
	
	                if (!validityChanged && !(0, _shallowEqual2.default)(fieldErrors, currentErrors)) {
	                  validityChanged = true;
	                }
	
	                fieldsErrors[key] = (0, _mergeValidity2.default)(fieldsErrors[key], fieldErrors);
	              });
	            }
	          }();
	
	          if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	        }
	
	        // Compute form-level validity
	        if (!fieldsErrors.hasOwnProperty('') && !~fieldKeys.indexOf('')) {
	          fieldsErrors[''] = false;
	          validityChanged = validityChanged || (0, _isValidityInvalid2.default)(formValue.$form.errors);
	        }
	
	        if (validityChanged) {
	          dispatch(s.actions.setFieldsErrors(model, fieldsErrors, { merge: true }));
	        }
	
	        if (submit) {
	          dispatch(s.actions.addIntent(model, { type: 'submit' }));
	        }
	      }
	    }, {
	      key: 'handleValidSubmit',
	      value: function handleValidSubmit() {
	        var _props2 = this.props,
	            dispatch = _props2.dispatch,
	            model = _props2.model,
	            modelValue = _props2.modelValue,
	            onSubmit = _props2.onSubmit;
	
	
	        dispatch(s.actions.setPending(model));
	
	        if (onSubmit) onSubmit(modelValue);
	      }
	    }, {
	      key: 'handleInvalidSubmit',
	      value: function handleInvalidSubmit() {
	        var _props3 = this.props,
	            onSubmitFailed = _props3.onSubmitFailed,
	            formValue = _props3.formValue,
	            dispatch = _props3.dispatch;
	
	
	        if (onSubmitFailed) {
	          onSubmitFailed(formValue);
	        }
	
	        dispatch(s.actions.setSubmitFailed(this.props.model));
	      }
	    }, {
	      key: 'handleReset',
	      value: function handleReset(e) {
	        if (e) e.preventDefault();
	
	        this.props.dispatch(s.actions.reset(this.props.model));
	      }
	    }, {
	      key: 'handleIntents',
	      value: function handleIntents() {
	        var _this3 = this;
	
	        var _props4 = this.props,
	            model = _props4.model,
	            formValue = _props4.formValue,
	            dispatch = _props4.dispatch;
	
	
	        formValue.$form.intents.forEach(function (intent) {
	          switch (intent.type) {
	            case 'submit':
	              {
	                dispatch(s.actions.clearIntents(model, intent));
	
	                if ((0, _isValid2.default)(formValue, { async: false })) {
	                  _this3.handleValidSubmit();
	                } else {
	                  _this3.handleInvalidSubmit();
	                }
	
	                return;
	              }
	
	            default:
	              return;
	          }
	        });
	      }
	    }, {
	      key: 'handleSubmit',
	      value: function handleSubmit(e) {
	        if (e && !this.props.action) e.preventDefault();
	
	        var _props5 = this.props,
	            modelValue = _props5.modelValue,
	            formValue = _props5.formValue,
	            onSubmit = _props5.onSubmit,
	            validators = _props5.validators,
	            onBeforeSubmit = _props5.onBeforeSubmit;
	
	
	        if (onBeforeSubmit) onBeforeSubmit(e);
	
	        var formValid = formValue ? formValue.$form.valid : true;
	
	        if (!validators && onSubmit && formValid) {
	          onSubmit(modelValue);
	
	          return modelValue;
	        }
	
	        this.validate(this.props, false, true);
	
	        return modelValue;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props6 = this.props,
	            component = _props6.component,
	            children = _props6.children,
	            formValue = _props6.formValue;
	
	
	        var allowedProps = (0, _omit2.default)(this.props, Object.keys(propTypes));
	        var renderableChildren = typeof children === 'function' ? children(formValue) : children;
	
	        return _react2.default.createElement(component, _extends({}, allowedProps, {
	          onSubmit: this.handleSubmit,
	          onReset: this.handleReset,
	          ref: this.attachNode
	        }), renderableChildren);
	      }
	    }]);
	
	    return Form;
	  }(_react.Component);
	
	   false ? Form.propTypes = propTypes : void 0;
	
	  Form.defaultProps = {
	    validateOn: 'change',
	    component: 'form'
	  };
	
	  Form.childContextTypes = {
	    model: _react.PropTypes.any,
	    localStore: _react.PropTypes.shape({
	      subscribe: _react.PropTypes.func,
	      dispatch: _react.PropTypes.func,
	      getState: _react.PropTypes.func
	    })
	  };
	
	  function mapStateToProps(state, _ref) {
	    var model = _ref.model;
	
	    var modelString = (0, _getModel2.default)(model, state);
	    var form = s.getForm(state, modelString);
	
	    (0, _invariant2.default)(form, 'Unable to create Form component. ' + 'Could not find form for "%s" in the store.', modelString);
	
	    return {
	      model: modelString,
	      modelValue: s.get(state, modelString),
	      formValue: form
	    };
	  }
	
	  return (0, _reactRedux.connect)(mapStateToProps)(Form);
	}
	
	exports.createFormClass = createFormClass;
	exports.default = createFormClass();

/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = invertValidators;
	
	var _mapValues = __webpack_require__(931);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _invertValidity = __webpack_require__(945);
	
	var _invertValidity2 = _interopRequireDefault(_invertValidity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function invertValidators(validators) {
	  if (typeof validators === 'function') {
	    return function (val) {
	      return (0, _invertValidity2.default)(validators(val));
	    };
	  }
	
	  return (0, _mapValues2.default)(validators, invertValidators);
	}

/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isValid;
	exports.fieldsValid = fieldsValid;
	
	var _isPlainObject = __webpack_require__(935);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValid(formState) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { async: true };
	
	  if (!formState) return true;
	
	  if (!formState.$form) {
	    var errors = formState.errors;
	
	
	    if (!Array.isArray(errors) && !(0, _isPlainObject2.default)(errors)) {
	      // If asyncKeys = true and the error is not an
	      // array or object (e.g. string), form errors are entirely async
	      // and should be ignored when async = true.
	      return !options.async && formState.asyncKeys || !errors;
	    }
	
	    return Object.keys(formState.errors).every(function (errorKey) {
	      // if specified to ignore async validator keys and
	      // current error key is an async validator key,
	      // treat key as valid
	      if (!options.async && formState.asyncKeys && !!~formState.asyncKeys.indexOf(errorKey)) {
	        return true;
	      }
	
	      var valid = !formState.errors[errorKey];
	
	      return valid;
	    });
	  }
	
	  return Object.keys(formState).every(function (key) {
	    return isValid(formState[key], options);
	  });
	}
	
	function fieldsValid(formState) {
	  return Object.keys(formState).every(function (key) {
	    return key === '$form' || isValid(formState[key]);
	  });
	}

/***/ },
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getField;
	
	var _isPlainObject = __webpack_require__(935);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _get = __webpack_require__(928);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _initialFieldState = __webpack_require__(967);
	
	var _initialFieldState2 = _interopRequireDefault(_initialFieldState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getField(state, path) {
	  if (false) {
	    if (!(0, _isPlainObject2.default)(state)) {
	      throw new Error('Could not retrieve field \'' + path + '\' ' + 'from an invalid/empty form state.');
	    }
	  }
	
	  var result = (0, _get2.default)(state, path, _initialFieldState2.default);
	
	  if ('$form' in result) return result.$form;
	
	  return result;
	}

/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = mergeValidity;
	
	var _isPlainObject = __webpack_require__(935);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _merge = __webpack_require__(960);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mergeValidity(fieldValidity, actionValidity) {
	  if (!(0, _isPlainObject2.default)(fieldValidity) || !(0, _isPlainObject2.default)(actionValidity)) {
	    // can't merge string/boolean validity with keyed validity
	    return actionValidity;
	  }
	
	  return (0, _merge2.default)(_extends({}, fieldValidity), actionValidity);
	}

/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formComponent = __webpack_require__(973);
	
	var _formComponent2 = _interopRequireDefault(_formComponent);
	
	var _formsReducer = __webpack_require__(979);
	
	var _formsReducer2 = _interopRequireDefault(_formsReducer);
	
	var _redux = __webpack_require__(888);
	
	var _omit = __webpack_require__(956);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LocalForm = function (_React$Component) {
	  _inherits(LocalForm, _React$Component);
	
	  function LocalForm(props) {
	    _classCallCheck(this, LocalForm);
	
	    var _this = _possibleConstructorReturn(this, (LocalForm.__proto__ || Object.getPrototypeOf(LocalForm)).call(this, props));
	
	    _this.store = props.store || (0, _redux.createStore)((0, _formsReducer2.default)(_defineProperty({}, props.model, props.initialState)));
	    return _this;
	  }
	
	  _createClass(LocalForm, [{
	    key: 'render',
	    value: function render() {
	      var allowedProps = (0, _omit2.default)(this.props, ['store', 'initialState']);
	
	      return _react2.default.createElement(_formComponent2.default, _extends({ store: this.store }, allowedProps));
	    }
	  }]);
	
	  return LocalForm;
	}(_react2.default.Component);
	
	LocalForm.displayName = 'LocalForm';
	
	 false ? LocalForm.propTypes = {
	  store: _react.PropTypes.shape({
	    subscribe: _react.PropTypes.func,
	    dispatch: _react.PropTypes.func,
	    getState: _react.PropTypes.func
	  }),
	
	  // provided props
	  initialState: _react.PropTypes.any,
	  model: _react.PropTypes.string.isRequired
	} : void 0;
	
	LocalForm.defaultProps = {
	  initialState: {},
	  model: 'local'
	};
	
	exports.default = LocalForm;

/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createForms = exports.createFormCombiner = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _modeledEnhancer = __webpack_require__(980);
	
	var _modeledEnhancer2 = _interopRequireDefault(_modeledEnhancer);
	
	var _modelReducer = __webpack_require__(981);
	
	var _modelReducer2 = _interopRequireDefault(_modelReducer);
	
	var _formReducer = __webpack_require__(984);
	
	var _formReducer2 = _interopRequireDefault(_formReducer);
	
	var _redux = __webpack_require__(888);
	
	var _identity = __webpack_require__(939);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _nullAction = __webpack_require__(940);
	
	var _nullAction2 = _interopRequireDefault(_nullAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var defaults = {
	  key: 'forms',
	  plugins: []
	};
	
	function getSubModelString(model, subModel) {
	  if (!model) return subModel;
	
	  return model + '.' + subModel;
	}
	
	var defaultStrategy = {
	  modelReducer: _modelReducer2.default,
	  formReducer: _formReducer2.default,
	  modeled: _modeledEnhancer2.default,
	  toJS: _identity2.default
	};
	
	function createFormCombiner() {
	  var strategy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultStrategy;
	
	  function createForms(forms) {
	    var model = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var formKeys = Object.keys(forms);
	    var modelReducers = {};
	    var initialFormState = {};
	    var optionsWithDefaults = _extends({}, defaults, options);
	
	    var key = optionsWithDefaults.key,
	        plugins = optionsWithDefaults.plugins,
	        formOptions = _objectWithoutProperties(optionsWithDefaults, ['key', 'plugins']);
	
	    formKeys.forEach(function (formKey) {
	      var formValue = forms[formKey];
	      var subModel = getSubModelString(model, formKey);
	
	      if (typeof formValue === 'function') {
	        var initialState = void 0;
	        try {
	          initialState = formValue(undefined, _nullAction2.default);
	        } catch (error) {
	          initialState = null;
	        }
	
	        modelReducers[formKey] = strategy.modeled(formValue, subModel);
	        initialFormState[formKey] = initialState;
	      } else {
	        modelReducers[formKey] = strategy.modelReducer(subModel, formValue);
	        initialFormState[formKey] = strategy.toJS(formValue);
	      }
	    });
	
	    return _extends({}, modelReducers, _defineProperty({}, key, strategy.formReducer(model, initialFormState, _extends({
	      plugins: plugins
	    }, formOptions))));
	  }
	
	  function combineForms(forms) {
	    var model = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var mappedReducers = createForms(forms, model, options);
	
	    return (0, _redux.combineReducers)(mappedReducers);
	  }
	
	  return {
	    createForms: createForms,
	    combineForms: combineForms
	  };
	}
	
	var _createFormCombiner = createFormCombiner(),
	    defaultCombineForms = _createFormCombiner.combineForms,
	    defaultCreateForms = _createFormCombiner.createForms;
	
	exports.default = defaultCombineForms;
	exports.createFormCombiner = createFormCombiner;
	exports.createForms = defaultCreateForms;

/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createModelReducerEnhancer = undefined;
	
	var _modelReducer2 = __webpack_require__(981);
	
	var _modelReducer3 = _interopRequireDefault(_modelReducer2);
	
	var _nullAction = __webpack_require__(940);
	
	var _nullAction2 = _interopRequireDefault(_nullAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createModelReducerEnhancer() {
	  var modelReducerCreator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _modelReducer3.default;
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return function modelReducerEnhancer(reducer, model) {
	    var initialState = void 0;
	    try {
	      initialState = reducer(undefined, _nullAction2.default);
	    } catch (error) {
	      initialState = null;
	    }
	
	    var _modelReducer = modelReducerCreator(model, initialState, options);
	
	    return function () {
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	      var action = arguments[1];
	
	      var updatedState = _modelReducer(state, action);
	
	      return reducer(updatedState, action);
	    };
	  };
	}
	
	var modelReducerEnhancer = createModelReducerEnhancer(_modelReducer3.default);
	
	exports.createModelReducerEnhancer = createModelReducerEnhancer;
	exports.default = modelReducerEnhancer;

/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createModeler = undefined;
	
	var _get2 = __webpack_require__(928);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _icepick = __webpack_require__(953);
	
	var _icepick2 = _interopRequireDefault(_icepick);
	
	var _arraysEqual = __webpack_require__(982);
	
	var _arraysEqual2 = _interopRequireDefault(_arraysEqual);
	
	var _toPath = __webpack_require__(950);
	
	var _toPath2 = _interopRequireDefault(_toPath);
	
	var _actionTypes = __webpack_require__(932);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _batchedEnhancer = __webpack_require__(983);
	
	var _batchedEnhancer2 = _interopRequireDefault(_batchedEnhancer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function icepickSet(state, path, value) {
	  return _icepick2.default.setIn(state, path, value);
	}
	
	var defaultStrategy = {
	  get: _get3.default,
	  set: icepickSet,
	  object: {}
	};
	
	function createModeler() {
	  var strategy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultStrategy;
	  var getter = strategy.get,
	      setter = strategy.set,
	      object = strategy.object;
	
	
	  return function _createModelReducer(model) {
	    var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : object;
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var modelPath = (0, _toPath2.default)(model);
	
	    var modelReducer = function modelReducer() {
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	      var action = arguments[1];
	
	      if (!action.model) {
	        return state;
	      }
	
	      var path = (0, _toPath2.default)(action.model);
	
	      if (!(0, _arraysEqual2.default)(path.slice(0, modelPath.length), modelPath)) {
	        return state;
	      }
	
	      var localPath = path.slice(modelPath.length);
	
	      switch (action.type) {
	        case _actionTypes2.default.CHANGE:
	        case _actionTypes2.default.LOAD:
	          if (!localPath.length) {
	            return action.value;
	          }
	
	          if (getter(state, localPath) === action.value) {
	            return state;
	          }
	
	          return setter(state, localPath, action.value);
	
	        case _actionTypes2.default.RESET:
	          if (!localPath.length) {
	            return initialState;
	          }
	
	          if (getter(state, localPath) === getter(initialState, localPath)) {
	            return state;
	          }
	
	          return setter(state, localPath, getter(initialState, localPath));
	
	        default:
	          return state;
	      }
	    };
	
	    return (0, _batchedEnhancer2.default)(modelReducer, initialState, options);
	  };
	}
	
	var modelReducer = createModeler();
	
	exports.createModeler = createModeler;
	exports.default = modelReducer;

/***/ },
/* 982 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = arraysEqual;
	function arraysEqual(firstArray, secondArray) {
	  return firstArray && secondArray && firstArray.length === secondArray.length && firstArray.every(function (item, index) {
	    return item === secondArray[index];
	  });
	}

/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actionTypes = __webpack_require__(932);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createBatchReducer(reducer, initialState) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var transformAction = options.transformAction;
	
	
	  return function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    var transformedAction = transformAction ? transformAction(action) : action;
	
	    if (transformedAction.type === _actionTypes2.default.BATCH) {
	      return transformedAction.actions.reduce(reducer, state);
	    }
	
	    return reducer(state, transformedAction);
	  };
	}
	
	exports.default = createBatchReducer;

/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createInitialState = createInitialState;
	exports.default = createFormReducer;
	
	var _get2 = __webpack_require__(928);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _arraysEqual = __webpack_require__(982);
	
	var _arraysEqual2 = _interopRequireDefault(_arraysEqual);
	
	var _isPlainObject = __webpack_require__(935);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _toPath = __webpack_require__(950);
	
	var _toPath2 = _interopRequireDefault(_toPath);
	
	var _composeReducers = __webpack_require__(985);
	
	var _composeReducers2 = _interopRequireDefault(_composeReducers);
	
	var _batchedEnhancer = __webpack_require__(983);
	
	var _batchedEnhancer2 = _interopRequireDefault(_batchedEnhancer);
	
	var _changeActionReducer = __webpack_require__(986);
	
	var _changeActionReducer2 = _interopRequireDefault(_changeActionReducer);
	
	var _formActionsReducer = __webpack_require__(988);
	
	var _formActionsReducer2 = _interopRequireDefault(_formActionsReducer);
	
	var _createField = __webpack_require__(995);
	
	var _createField2 = _interopRequireDefault(_createField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function createInitialState(model, state) {
	  var customInitialFieldState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  if (Array.isArray(state) || (0, _isPlainObject2.default)(state)) {
	    return (0, _createField.createFormState)(model, state, customInitialFieldState, options);
	  }
	
	  return (0, _createField2.default)(model, state, customInitialFieldState, options);
	}
	
	function wrapFormReducer(plugin, modelPath, initialState) {
	  return function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    if (!action.model) return state;
	
	    var path = (0, _toPath2.default)(action.model);
	
	    if (modelPath.length && !(0, _arraysEqual2.default)(path.slice(0, modelPath.length), modelPath)) {
	      return state;
	    }
	
	    var localPath = path.slice(modelPath.length);
	
	    return plugin(state, action, localPath);
	  };
	}
	
	var defaultPlugins = [_formActionsReducer2.default, _changeActionReducer2.default];
	
	function createFormReducer(model) {
	  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var _options$plugins = options.plugins,
	      plugins = _options$plugins === undefined ? [] : _options$plugins,
	      customInitialFieldState = options.initialFieldState,
	      _options$transformAct = options.transformAction,
	      transformAction = _options$transformAct === undefined ? null : _options$transformAct;
	
	  var modelPath = (0, _toPath2.default)(model);
	  var initialFormState = createInitialState(model, initialState, customInitialFieldState, options);
	
	  var wrappedPlugins = plugins.concat(defaultPlugins).map(function (plugin) {
	    return wrapFormReducer(plugin, modelPath, initialFormState);
	  });
	
	  return (0, _batchedEnhancer2.default)(_composeReducers2.default.apply(undefined, _toConsumableArray(wrappedPlugins)), undefined, {
	    transformAction: transformAction
	  });
	}

/***/ },
/* 985 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = compose;
	function compose() {
	  for (var _len = arguments.length, reducers = Array(_len), _key = 0; _key < _len; _key++) {
	    reducers[_key] = arguments[_key];
	  }
	
	  return function (state, action) {
	    return reducers.reduceRight(function (prevState, reducer) {
	      return reducer(prevState, action);
	    }, state);
	  };
	}

/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = changeActionReducer;
	
	var _actionTypes = __webpack_require__(932);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _icepick = __webpack_require__(953);
	
	var _icepick2 = _interopRequireDefault(_icepick);
	
	var _get = __webpack_require__(928);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _shallowEqual = __webpack_require__(959);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _isPlainObject = __webpack_require__(935);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _mapValues = __webpack_require__(931);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _formReducer = __webpack_require__(984);
	
	var _initialFieldState = __webpack_require__(967);
	
	var _initialFieldState2 = _interopRequireDefault(_initialFieldState);
	
	var _updateParentForms = __webpack_require__(987);
	
	var _updateParentForms2 = _interopRequireDefault(_updateParentForms);
	
	var _invariant = __webpack_require__(754);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function updateFieldValue(field, action) {
	  var parentModel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
	  var value = action.value,
	      removeKeys = action.removeKeys,
	      silent = action.silent,
	      load = action.load,
	      model = action.model,
	      external = action.external;
	
	
	  var fieldState = field && field.$form ? field.$form : field;
	
	  var changedFieldProps = {
	    validated: false,
	    retouched: fieldState.submitted ? true : fieldState.retouched,
	    // If change originated from Control component (not externally),
	    // then there is no need to remind Control to validate itself.
	    intents: external ? [{ type: 'validate' }] : [],
	    pristine: silent ? fieldState.pristine : false,
	    value: value,
	    loadedValue: load ? value : fieldState.loadedValue
	  };
	
	  if ((0, _shallowEqual2.default)(field.value, value)) {
	    return _icepick2.default.merge(field, changedFieldProps);
	  }
	
	  if (removeKeys) {
	    var _ret = function () {
	      (0, _invariant2.default)(field && field.$form, 'Unable to remove keys. ' + 'Field for "%s" in store is not an array/object.', model);
	
	      var valueIsArray = Array.isArray(field.$form.value);
	      var removeKeysArray = Array.isArray(removeKeys) ? removeKeys : [removeKeys];
	
	      var result = void 0;
	
	      if (valueIsArray) {
	        result = [];
	
	        Object.keys(field).forEach(function (key) {
	          if (!!~removeKeysArray.indexOf(+key) || key === '$form') return;
	
	          result[key] = field[key];
	        });
	
	        return {
	          v: _extends({}, _icepick2.default.set(result.filter(function (f) {
	            return f;
	          }), '$form', field.$form))
	        };
	      }
	
	      result = _extends({}, field);
	
	      Object.keys(field).forEach(function (key) {
	        if (!!~removeKeysArray.indexOf(key)) {
	          delete result['' + key];
	        }
	      });
	
	      return {
	        v: result
	      };
	    }();
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	  }
	
	  if (!Array.isArray(value) && !(0, _isPlainObject2.default)(value)) {
	    return _icepick2.default.merge(field, _icepick2.default.set(changedFieldProps, 'value', value));
	  }
	
	  var updatedField = (0, _mapValues2.default)(value, function (subValue, index) {
	    // TODO: refactor
	    var subField = field[index] || (0, _formReducer.createInitialState)('' + (parentModel ? parentModel + '.' : '') + model + '.' + index, subValue);
	
	    if (Object.hasOwnProperty.call(subField, '$form')) {
	      return updateFieldValue(subField, {
	        model: index,
	        value: subValue,
	        load: load
	      }, parentModel ? parentModel + '.' + model : model);
	    }
	
	    if ((0, _shallowEqual2.default)(subValue, subField.value)) {
	      return subField;
	    }
	
	    return _icepick2.default.merge(subField, _icepick2.default.assign(changedFieldProps, {
	      value: subValue,
	      loadedValue: load ? subValue : subField.loadedValue
	    }));
	  });
	
	  // console.log('FIELD', field);
	
	  var dirtyFormState = _icepick2.default.merge(field.$form || _initialFieldState2.default, _icepick2.default.set(changedFieldProps, 'retouched', field.submitted || field.$form && field.$form.retouched));
	
	  // console.log('DIRTY', dirtyFormState);
	
	  return _icepick2.default.set(updatedField, '$form', dirtyFormState);
	}
	
	function getFormValue(form) {
	  if (form && !form.$form) {
	    return typeof form.loadedValue !== 'undefined' ? form.loadedValue : form.initialValue;
	  }
	
	  var result = (0, _mapValues2.default)(form, function (field, key) {
	    if (key === '$form') return undefined;
	
	    return getFormValue(field);
	  });
	
	  delete result.$form;
	
	  return result;
	}
	
	function changeActionReducer(state, action, localPath) {
	  if (action.type !== _actionTypes2.default.CHANGE) return state;
	
	  var field = (0, _get2.default)(state, localPath, (0, _formReducer.createInitialState)(action.model, action.value));
	
	  var updatedField = updateFieldValue(field, action);
	
	  if (!localPath.length) return updatedField;
	
	  var updatedState = _icepick2.default.setIn(state, localPath, updatedField);
	
	  if (action.silent) {
	    return (0, _updateParentForms2.default)(updatedState, localPath, function (form) {
	      var formValue = getFormValue(form);
	
	      return {
	        value: formValue,
	        loadedValue: formValue
	      };
	    });
	  }
	
	  return (0, _updateParentForms2.default)(updatedState, localPath, { pristine: false });
	}

/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = updateParentForms;
	
	var _icepick = __webpack_require__(953);
	
	var _icepick2 = _interopRequireDefault(_icepick);
	
	var _get = __webpack_require__(928);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function updateParentForms(state, localPath, updater) {
	  var parentLocalPath = localPath.slice(0, -1);
	
	  var value = parentLocalPath.length ? (0, _get2.default)(state, parentLocalPath) : state;
	
	  if (!value) return state;
	
	  var form = value.$form;
	
	  var updatedValue = typeof updater === 'function' ? updater(value) : updater;
	
	  var newState = _icepick2.default.setIn(state, [].concat(_toConsumableArray(parentLocalPath), ['$form']), _icepick2.default.merge(form, updatedValue));
	
	  if (!parentLocalPath.length) return newState;
	
	  return updateParentForms(newState, parentLocalPath, updater);
	}

/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = formActionsReducer;
	
	var _actionTypes = __webpack_require__(932);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _updateField = __webpack_require__(989);
	
	var _updateField2 = _interopRequireDefault(_updateField);
	
	var _updateParentForms = __webpack_require__(987);
	
	var _updateParentForms2 = _interopRequireDefault(_updateParentForms);
	
	var _updateSubFields = __webpack_require__(990);
	
	var _updateSubFields2 = _interopRequireDefault(_updateSubFields);
	
	var _getFieldForm = __webpack_require__(991);
	
	var _getFieldForm2 = _interopRequireDefault(_getFieldForm);
	
	var _isPristine = __webpack_require__(992);
	
	var _isPristine2 = _interopRequireDefault(_isPristine);
	
	var _map = __webpack_require__(993);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _isPlainObject = __webpack_require__(935);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _mapValues = __webpack_require__(931);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _inverse = __webpack_require__(994);
	
	var _inverse2 = _interopRequireDefault(_inverse);
	
	var _mergeValidity = __webpack_require__(977);
	
	var _mergeValidity2 = _interopRequireDefault(_mergeValidity);
	
	var _isValid = __webpack_require__(975);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _isValidityValid = __webpack_require__(943);
	
	var _isValidityValid2 = _interopRequireDefault(_isValidityValid);
	
	var _isValidityInvalid = __webpack_require__(944);
	
	var _isValidityInvalid2 = _interopRequireDefault(_isValidityInvalid);
	
	var _fieldActions = __webpack_require__(927);
	
	var _fieldActions2 = _interopRequireDefault(_fieldActions);
	
	var _toPath = __webpack_require__(950);
	
	var _toPath2 = _interopRequireDefault(_toPath);
	
	var _initialFieldState = __webpack_require__(967);
	
	var _initialFieldState2 = _interopRequireDefault(_initialFieldState);
	
	var _icepick = __webpack_require__(953);
	
	var _icepick2 = _interopRequireDefault(_icepick);
	
	var _createField = __webpack_require__(995);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var resetFieldState = function resetFieldState(field) {
	  if (!(0, _isPlainObject2.default)(field)) return field;
	
	  var intents = [{ type: 'validate' }];
	  var resetValue = (0, _createField.getMeta)(field, 'initialValue');
	
	  var loadedValue = (0, _createField.getMeta)(field, 'loadedValue');
	
	  if (loadedValue && resetValue !== loadedValue) {
	    intents.push({ type: 'load' });
	    resetValue = loadedValue;
	  }
	
	  return (0, _createField.fieldOrForm)((0, _createField.getMeta)(field, 'model'), resetValue, { intents: intents });
	};
	
	var setInitialFieldState = function setInitialFieldState(field, key) {
	  if (!(0, _isPlainObject2.default)(field)) return field;
	
	  if (key === '$form') {
	    return _icepick2.default.assign(_initialFieldState2.default, {
	      value: field.value,
	      model: field.model
	    });
	  }
	
	  if (field.$form) return (0, _mapValues2.default)(field, resetFieldState);
	
	  return _icepick2.default.assign(_initialFieldState2.default, {
	    value: field.value,
	    model: field.model
	  });
	};
	
	var addIntent = function addIntent(intents, newIntent) {
	  if (!intents) return [newIntent];
	  if (intents.some(function (intent) {
	    return intent.type === newIntent.type;
	  })) return intents;
	
	  return intents.concat(newIntent);
	};
	
	var clearIntents = function clearIntents(intents, oldIntent) {
	  if (!intents || typeof oldIntent === 'undefined') return [];
	  return intents.filter(function (intent) {
	    return intent.type !== oldIntent.type;
	  });
	};
	
	function formActionsReducer(state, action, localPath) {
	  var _getFieldAndForm = (0, _updateField.getFieldAndForm)(state, localPath),
	      _getFieldAndForm2 = _slicedToArray(_getFieldAndForm, 1),
	      field = _getFieldAndForm2[0];
	
	  var fieldState = field && field.$form ? field.$form : field;
	  var intents = fieldState.intents;
	
	
	  var fieldUpdates = {};
	  var subFieldUpdates = {};
	  var parentFormUpdates = void 0;
	
	  switch (action.type) {
	    case _actionTypes2.default.FOCUS:
	      {
	        fieldUpdates = {
	          focus: true,
	          intents: action.silent ? intents : addIntent(intents, action)
	        };
	
	        break;
	      }
	
	    case _actionTypes2.default.BLUR:
	    case _actionTypes2.default.SET_TOUCHED:
	      {
	        var fieldForm = (0, _getFieldForm2.default)(state, localPath).$form;
	
	        fieldUpdates = {
	          focus: action.type === _actionTypes2.default.BLUR ? false : field.focus,
	          touched: true,
	          retouched: fieldForm ? !!(fieldForm.submitted || fieldForm.submitFailed) : false
	        };
	
	        parentFormUpdates = {
	          touched: true,
	          retouched: fieldUpdates.retouched
	        };
	
	        break;
	      }
	
	    case _actionTypes2.default.SET_UNTOUCHED:
	      {
	        fieldUpdates = {
	          focus: false,
	          touched: false
	        };
	
	        break;
	      }
	
	    case _actionTypes2.default.SET_PRISTINE:
	    case _actionTypes2.default.SET_DIRTY:
	      {
	        var pristine = action.type === _actionTypes2.default.SET_PRISTINE;
	
	        fieldUpdates = {
	          pristine: pristine
	        };
	
	        subFieldUpdates = {
	          pristine: pristine
	        };
	
	        parentFormUpdates = function parentFormUpdates(form) {
	          return { pristine: (0, _isPristine2.default)(form) };
	        };
	
	        break;
	      }
	
	    case _actionTypes2.default.SET_VALIDATING:
	      {
	        fieldUpdates = {
	          validating: action.validating,
	          validated: !action.validating
	        };
	
	        break;
	      }
	
	    case _actionTypes2.default.SET_VALIDITY:
	    case _actionTypes2.default.SET_ERRORS:
	      {
	        var _fieldUpdates;
	
	        var isErrors = action.type === _actionTypes2.default.SET_ERRORS;
	        var validity = void 0;
	        if (isErrors) {
	          validity = action.merge ? (0, _mergeValidity2.default)(fieldState.errors, action.errors) : action.errors;
	        } else {
	          validity = action.merge ? (0, _mergeValidity2.default)(fieldState.validity, action.validity) : action.validity;
	        }
	
	        var inverseValidity = (0, _isPlainObject2.default)(validity) ? (0, _mapValues2.default)(validity, _inverse2.default) : !validity;
	
	        // If the field is a form, its validity is
	        // also based on whether its fields are all valid.
	        var areFieldsValid = field && field.$form ? (0, _isValid.fieldsValid)(field) : true;
	
	        fieldUpdates = (_fieldUpdates = {}, _defineProperty(_fieldUpdates, isErrors ? 'errors' : 'validity', validity), _defineProperty(_fieldUpdates, isErrors ? 'validity' : 'errors', inverseValidity), _defineProperty(_fieldUpdates, 'validating', false), _defineProperty(_fieldUpdates, 'validated', true), _defineProperty(_fieldUpdates, 'valid', areFieldsValid && (isErrors ? !(0, _isValidityInvalid2.default)(validity) : (0, _isValidityValid2.default)(validity))), _fieldUpdates);
	
	        if (action.async) {
	          var actionValidity = isErrors ? action.errors : action.validity;
	
	          fieldUpdates.asyncKeys = (0, _isPlainObject2.default)(actionValidity) || Array.isArray(actionValidity) ? Object.keys(actionValidity) : true;
	        }
	
	        parentFormUpdates = function parentFormUpdates(form) {
	          return { valid: (0, _isValid2.default)(form) };
	        };
	
	        break;
	      }
	
	    case _actionTypes2.default.SET_FIELDS_VALIDITY:
	      {
	        return (0, _map2.default)(action.fieldsValidity, function (fieldValidity, subField) {
	          return _fieldActions2.default.setValidity(subField, fieldValidity, action.options);
	        }).reduce(function (accState, subAction) {
	          return formActionsReducer(accState, subAction, localPath.concat((0, _toPath2.default)(subAction.model)));
	        }, state);
	      }
	
	    case _actionTypes2.default.RESET_VALIDITY:
	      {
	        var _ret = function () {
	          var validity = _extends({}, fieldState.validity);
	          var errors = _extends({}, fieldState.errors);
	          var valid = void 0;
	
	          if (action.omitKeys) {
	            action.omitKeys.forEach(function (key) {
	              delete validity[key];
	              delete errors[key];
	            });
	            valid = (0, _isValidityValid2.default)(validity);
	          } else {
	            validity = _initialFieldState2.default.validity;
	            errors = _initialFieldState2.default.errors;
	            valid = _initialFieldState2.default.valid;
	          }
	
	          fieldUpdates = {
	            valid: valid,
	            validity: validity,
	            errors: errors
	          };
	
	          subFieldUpdates = {
	            valid: _initialFieldState2.default.valid,
	            validity: _initialFieldState2.default.validity,
	            errors: _initialFieldState2.default.errors
	          };
	
	          return 'break';
	        }();
	
	        if (_ret === 'break') break;
	      }
	
	    case _actionTypes2.default.SET_PENDING:
	      {
	        fieldUpdates = {
	          pending: action.pending,
	          submitted: false,
	          submitFailed: false,
	          retouched: false
	        };
	
	        parentFormUpdates = { pending: action.pending };
	
	        break;
	      }
	
	    case _actionTypes2.default.SET_SUBMITTED:
	      {
	        var submitted = !!action.submitted;
	
	        fieldUpdates = {
	          pending: false,
	          submitted: submitted,
	          submitFailed: submitted ? false : fieldState && fieldState.submitFailed,
	          touched: true,
	          retouched: false
	        };
	
	        subFieldUpdates = {
	          submitted: submitted,
	          submitFailed: submitted ? false : fieldUpdates.submitFailed,
	          retouched: false
	        };
	
	        break;
	      }
	
	    case _actionTypes2.default.SET_SUBMIT_FAILED:
	      {
	        fieldUpdates = {
	          pending: false,
	          submitted: fieldState.submitted && !action.submitFailed,
	          submitFailed: !!action.submitFailed,
	          touched: true,
	          retouched: false
	        };
	
	        subFieldUpdates = {
	          pending: false,
	          submitted: !action.submitFailed,
	          submitFailed: !!action.submitFailed,
	          touched: true,
	          retouched: false
	        };
	
	        break;
	      }
	
	    case _actionTypes2.default.RESET:
	      {
	        return localPath.length ? _icepick2.default.setIn(state, localPath, resetFieldState(field)) : resetFieldState(field);
	      }
	
	    case _actionTypes2.default.SET_INITIAL:
	      {
	        return (0, _updateField2.default)(state, localPath, setInitialFieldState, setInitialFieldState);
	      }
	
	    case _actionTypes2.default.ADD_INTENT:
	      {
	        fieldUpdates = {
	          intents: addIntent(intents, action.intent)
	        };
	
	        break;
	      }
	
	    case _actionTypes2.default.CLEAR_INTENTS:
	      {
	        fieldUpdates = {
	          intents: clearIntents(intents, action.intent)
	        };
	
	        break;
	      }
	
	    default:
	      return state;
	  }
	
	  var updatedField = (0, _updateField2.default)(state, localPath, fieldUpdates);
	  var updatedSubFields = Object.keys(subFieldUpdates).length ? (0, _updateSubFields2.default)(updatedField, localPath, subFieldUpdates) : updatedField;
	  var updatedParentForms = parentFormUpdates ? (0, _updateParentForms2.default)(updatedSubFields, localPath, parentFormUpdates) : updatedSubFields;
	
	  return updatedParentForms;
	}

/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.getFieldAndForm = getFieldAndForm;
	exports.default = updateField;
	
	var _icepick = __webpack_require__(953);
	
	var _icepick2 = _interopRequireDefault(_icepick);
	
	var _get = __webpack_require__(928);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _mapValues = __webpack_require__(931);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _formReducer = __webpack_require__(984);
	
	var _invariant = __webpack_require__(754);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function assocIn(state, path, value, fn) {
	  if (!path.length) return _icepick2.default.assign(state, value);
	  if (!fn) return _icepick2.default.assocIn(state, path, value);
	
	  var key0 = path[0];
	
	  if (path.length === 1) {
	    return fn(_icepick2.default.assoc(state, key0, value));
	  }
	
	  return fn(_icepick2.default.assoc(state, key0, assocIn(state[key0] || {}, path.slice(1), value, fn)));
	}
	
	function tempInitialState(path) {
	  var initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	  if (path.length === 1) return _defineProperty({}, path[0], initialValue);
	
	  return _defineProperty({}, path[0], tempInitialState(path.slice(1), initialValue));
	}
	
	function getFieldAndForm(formState, modelPath) {
	  var field = (0, _get2.default)(formState, modelPath);
	  var form = formState;
	
	  (0, _invariant2.default)(form, 'Could not find form for "%s" in the store.', modelPath);
	
	  if (!field) {
	    var initialValue = (0, _get2.default)(formState.$form.initialValue, modelPath);
	
	    form = _icepick2.default.merge((0, _formReducer.createInitialState)(formState.$form.model, tempInitialState(modelPath, initialValue)), formState);
	
	    field = (0, _get2.default)(form, modelPath);
	  }
	
	  return [field, form];
	}
	
	function updateField(state, path, newState, newSubState, updater) {
	  var _getFieldAndForm = getFieldAndForm(state, path),
	      _getFieldAndForm2 = _slicedToArray(_getFieldAndForm, 2),
	      field = _getFieldAndForm2[0],
	      fullState = _getFieldAndForm2[1];
	
	  if (!field) return state;
	
	  var isForm = field.hasOwnProperty('$form');
	  var fieldPath = isForm ? _icepick2.default.push(path, '$form') : path;
	
	  var fieldState = isForm ? field.$form : field;
	
	  var updatedFieldState = typeof newState === 'function' ? newState(fieldState) : newState;
	
	  if (isForm && newSubState) {
	    var formState = (0, _mapValues2.default)(field, function (subState, key) {
	      if (key === '$form') {
	        return _icepick2.default.assign(fieldState, updatedFieldState);
	      }
	
	      var updatedSubState = typeof newSubState === 'function' ? newSubState(subState, updatedFieldState) : newSubState;
	
	      return _icepick2.default.assign(subState, updatedSubState);
	    });
	
	    if (!path.length) return formState;
	
	    return assocIn(fullState, path, formState, updater);
	  }
	
	  return assocIn(fullState, fieldPath, _icepick2.default.assign(fieldState, updatedFieldState), updater);
	}

/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = updateSubFields;
	
	var _get = __webpack_require__(928);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _icepick = __webpack_require__(953);
	
	var _icepick2 = _interopRequireDefault(_icepick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function updateSubField(subField, newSubState) {
	  // Form
	  if (subField && subField.$form) {
	    var _ret = function () {
	      // intermediate value - not mutated outside function
	      var result = {};
	
	      Object.keys(subField).forEach(function (key) {
	        if (key === '$form') {
	          result.$form = _icepick2.default.assign(subField.$form, newSubState);
	        } else {
	          result[key] = updateSubField(subField[key], newSubState);
	        }
	      });
	
	      return {
	        v: result
	      };
	    }();
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	  }
	
	  // Field
	  return _icepick2.default.assign(subField, newSubState);
	}
	
	function updateSubFields(state, localPath, newState) {
	  var field = (0, _get2.default)(state, localPath);
	
	  // only forms can have fields -
	  // skip if field is not a form
	  if (!field || !field.$form) return state;
	
	  // intermediate value - not mutated outside function
	  var updatedField = {};
	
	  Object.keys(field).forEach(function (key) {
	    if (key === '$form') {
	      updatedField.$form = field.$form;
	    } else {
	      updatedField[key] = updateSubField(field[key], newState);
	    }
	  });
	
	  if (!localPath.length) return updatedField;
	
	  return _icepick2.default.assocIn(state, localPath, updatedField);
	}

/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getFieldForm;
	
	var _get = __webpack_require__(928);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _invariant = __webpack_require__(754);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getFieldForm(state, path) {
	  var formPath = path.slice(0, -1);
	
	  if (!formPath.length) return state;
	
	  var form = (0, _get2.default)(state, formPath);
	
	  (0, _invariant2.default)(form, 'Could not find form for "%s" in the store.', formPath.join('.'));
	
	  return form;
	}

/***/ },
/* 992 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isPristine;
	function isPristine(formState) {
	  if (!formState) return false;
	
	  // Form is pristine
	  if (!formState.$form) {
	    return formState.pristine;
	  }
	
	  // Every field in form is pristine
	  return Object.keys(formState).every(function (key) {
	    if (key === '$form') return true;
	
	    return isPristine(formState[key]);
	  });
	}

/***/ },
/* 993 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = map;
	function map(values, iteratee) {
	  if (Array.isArray(values)) {
	    return values.map(iteratee);
	  }
	
	  var result = Object.keys(values).map(function (key) {
	    return iteratee(values[key], key, values);
	  });
	
	  return result;
	}

/***/ },
/* 994 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = inverse;
	function inverse(value) {
	  return !value;
	}

/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fieldOrForm = fieldOrForm;
	exports.getMeta = getMeta;
	exports.default = createFieldState;
	exports.createFormState = createFormState;
	
	var _initialFieldState = __webpack_require__(967);
	
	var _initialFieldState2 = _interopRequireDefault(_initialFieldState);
	
	var _isPlainObject = __webpack_require__(935);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _mapValues = __webpack_require__(931);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	function fieldOrForm(model, value, customInitialFieldState) {
	  if (Array.isArray(value) || (0, _isPlainObject2.default)(value)) {
	    return createFormState(model, value, customInitialFieldState);
	  }
	
	  return createFieldState(model, value, customInitialFieldState);
	}
	/* eslint-enable no-use-before-define */
	
	function getMeta(fieldLike, prop) {
	  if (fieldLike && fieldLike.$form) return fieldLike.$form[prop];
	
	  return fieldLike[prop];
	}
	
	function getSubModelString(model, subModel) {
	  if (!model) return subModel;
	
	  return model + '.' + subModel;
	}
	
	function createFieldState(model, value, customInitialFieldState) {
	  return _extends({}, _initialFieldState2.default, customInitialFieldState, {
	    model: model,
	    value: value,
	    initialValue: value
	  });
	}
	
	function createFormState(model, values, customInitialFieldState) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var state = {
	    $form: createFieldState(model, values, customInitialFieldState, options)
	  };
	
	  if (options.lazy) return state;
	
	  Object.assign(state, (0, _mapValues2.default)(values, function (value, key) {
	    var subModel = getSubModelString(model, key);
	
	    return fieldOrForm(subModel, value, customInitialFieldState);
	  }));
	
	  return state;
	}

/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createErrorsClass = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(907);
	
	var _get2 = __webpack_require__(928);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _map = __webpack_require__(993);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _iteratee = __webpack_require__(938);
	
	var _iteratee2 = _interopRequireDefault(_iteratee);
	
	var _isPlainObject = __webpack_require__(935);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _omit = __webpack_require__(956);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _getForm = __webpack_require__(946);
	
	var _getForm2 = _interopRequireDefault(_getForm);
	
	var _getFieldFromState = __webpack_require__(949);
	
	var _getFieldFromState2 = _interopRequireDefault(_getFieldFromState);
	
	var _getModel = __webpack_require__(962);
	
	var _getModel2 = _interopRequireDefault(_getModel);
	
	var _isValid = __webpack_require__(975);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _resolveModel = __webpack_require__(966);
	
	var _resolveModel2 = _interopRequireDefault(_resolveModel);
	
	var _initialFieldState = __webpack_require__(967);
	
	var _initialFieldState2 = _interopRequireDefault(_initialFieldState);
	
	var _shallowEqual = __webpack_require__(959);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _invariant = __webpack_require__(754);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultStrategy = {
	  get: _get3.default,
	  getForm: _getForm2.default,
	  getFieldFromState: _getFieldFromState2.default
	};
	
	var propTypes = {
	  // Computed props
	  modelValue: _react.PropTypes.any,
	  formValue: _react.PropTypes.object,
	  fieldValue: _react.PropTypes.object,
	
	  // Provided props
	  model: _react.PropTypes.string.isRequired,
	  messages: _react.PropTypes.objectOf(_react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func, _react.PropTypes.bool])),
	  show: _react.PropTypes.any,
	  wrapper: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func, _react.PropTypes.element]),
	  component: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func, _react.PropTypes.element]),
	  dispatch: _react.PropTypes.func,
	  dynamic: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.arrayOf(_react.PropTypes.string)]),
	  store: _react.PropTypes.shape({
	    subscribe: _react.PropTypes.func,
	    dispatch: _react.PropTypes.func,
	    getState: _react.PropTypes.func
	  })
	};
	
	function showErrors(field, form) {
	  var show = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (typeof show === 'function') {
	    return show(field, form);
	  }
	
	  if (!Array.isArray(show) && (typeof show === 'undefined' ? 'undefined' : _typeof(show)) !== 'object' && typeof show !== 'string') {
	    return !!show;
	  }
	
	  return (0, _iteratee2.default)(show)(field);
	}
	
	function createErrorsClass() {
	  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultStrategy;
	
	  var Errors = function (_Component) {
	    _inherits(Errors, _Component);
	
	    function Errors() {
	      _classCallCheck(this, Errors);
	
	      return _possibleConstructorReturn(this, (Errors.__proto__ || Object.getPrototypeOf(Errors)).apply(this, arguments));
	    }
	
	    _createClass(Errors, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        var fieldValue = nextProps.fieldValue,
	            formValue = nextProps.formValue;
	        var dynamic = this.props.dynamic;
	
	
	        if (dynamic) {
	          return !(0, _shallowEqual2.default)(this.props, nextProps);
	        }
	
	        return fieldValue !== this.props.fieldValue || formValue !== this.props.formValue;
	      }
	    }, {
	      key: 'mapErrorMessages',
	      value: function mapErrorMessages(errors) {
	        var _this2 = this;
	
	        var messages = this.props.messages;
	
	
	        if (typeof errors === 'string') {
	          return this.renderError(errors, 'error');
	        }
	
	        if (!errors) return null;
	
	        return (0, _map2.default)(errors, function (error, key) {
	          var message = messages[key];
	
	          if (error) {
	            if (message || typeof error === 'string') {
	              return _this2.renderError(message || error, key);
	            } else if ((0, _isPlainObject2.default)(error)) {
	              return _this2.mapErrorMessages(error);
	            }
	          }
	
	          return false;
	        }).reduce(function (a, b) {
	          return b ? a.concat(b) : a;
	        }, []);
	      }
	    }, {
	      key: 'renderError',
	      value: function renderError(message, key) {
	        var _props = this.props,
	            component = _props.component,
	            model = _props.model,
	            modelValue = _props.modelValue,
	            fieldValue = _props.fieldValue,
	            errors = _props.fieldValue.errors;
	
	
	        var errorProps = {
	          key: key,
	          model: model,
	          modelValue: modelValue,
	          fieldValue: fieldValue
	        };
	
	        var messageString = typeof message === 'function' ? message(modelValue, errors[key]) : message;
	
	        if (!messageString) return null;
	
	        var allowedProps = typeof component === 'function' ? errorProps : { key: key };
	
	        return _react2.default.createElement(component, allowedProps, messageString);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props2 = this.props,
	            fieldValue = _props2.fieldValue,
	            formValue = _props2.formValue,
	            show = _props2.show,
	            wrapper = _props2.wrapper;
	
	
	        var allowedProps = typeof wrapper === 'function' ? this.props : (0, _omit2.default)(this.props, Object.keys(propTypes));
	
	        if (!showErrors(fieldValue, formValue, show)) {
	          return null;
	        }
	
	        var errorMessages = (0, _isValid2.default)(fieldValue) ? null : this.mapErrorMessages(fieldValue.errors);
	
	        if (!errorMessages) return null;
	
	        return _react2.default.createElement(wrapper, allowedProps, errorMessages);
	      }
	    }]);
	
	    return Errors;
	  }(_react.Component);
	
	   false ? Errors.propTypes = propTypes : void 0;
	
	  Errors.defaultProps = {
	    wrapper: 'div',
	    component: 'span',
	    messages: {},
	    show: true,
	    dynamic: true
	  };
	
	  function mapStateToProps(state, _ref) {
	    var model = _ref.model;
	
	    var modelString = (0, _getModel2.default)(model, state);
	
	    var form = s.getForm(state, modelString);
	    (0, _invariant2.default)(form, 'Unable to retrieve errors. ' + 'Could not find form for "%s" in the store.', modelString);
	
	    var formValue = form.$form;
	    var fieldValue = s.getFieldFromState(state, modelString) || _initialFieldState2.default;
	
	    return {
	      model: modelString,
	      modelValue: s.get(state, modelString),
	      formValue: formValue,
	      fieldValue: fieldValue
	    };
	  }
	
	  return (0, _resolveModel2.default)((0, _reactRedux.connect)(mapStateToProps)(Errors));
	}
	
	exports.createErrorsClass = createErrorsClass;
	exports.default = createErrorsClass();

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isRetouched = exports.isTouched = exports.isPending = exports.isValid = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = formSelector;
	
	var _isValid = __webpack_require__(975);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _isPending = __webpack_require__(998);
	
	var _isPending2 = _interopRequireDefault(_isPending);
	
	var _isTouched = __webpack_require__(999);
	
	var _isTouched2 = _interopRequireDefault(_isTouched);
	
	var _isRetouched = __webpack_require__(1000);
	
	var _isRetouched2 = _interopRequireDefault(_isRetouched);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formSelector(formState) {
	  return _extends({}, formState, {
	    get valid() {
	      return (0, _isValid2.default)(formState);
	    },
	    get pending() {
	      return (0, _isPending2.default)(formState);
	    },
	    get touched() {
	      return (0, _isTouched2.default)(formState);
	    },
	    get retouched() {
	      return (0, _isRetouched2.default)(formState);
	    }
	  });
	}
	
	exports.isValid = _isValid2.default;
	exports.isPending = _isPending2.default;
	exports.isTouched = _isTouched2.default;
	exports.isRetouched = _isRetouched2.default;

/***/ },
/* 998 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isPending;
	function isPending(formState) {
	  if (!formState) return false;
	
	  // Field is pending
	  if (!formState.$form) {
	    return formState.pending;
	  }
	
	  // Any field in form is pending
	  return Object.keys(formState).some(function (key) {
	    return isPending(formState[key]);
	  });
	}

/***/ },
/* 999 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isTouched;
	function isTouched(formState) {
	  if (!formState) return false;
	
	  // Field is touched
	  if (!formState.$form) {
	    return formState.touched;
	  }
	
	  // Any field in form is touched
	  return Object.keys(formState).some(function (key) {
	    return isTouched(formState[key]);
	  });
	}

/***/ },
/* 1000 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isRetouched;
	function isRetouched(formState) {
	  if (!formState) return false;
	
	  // Field is pending
	  if (!formState.$form) {
	    return formState.retouched;
	  }
	
	  // Any field in form is pending
	  return Object.keys(formState).some(function (key) {
	    return isRetouched(formState[key]);
	  });
	}

/***/ },
/* 1001 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch;
	    var getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SignUpForm = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _forms = __webpack_require__(1003);
	
	var _reactReduxForm = __webpack_require__(925);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	var _qs = __webpack_require__(673);
	
	var _superagent = __webpack_require__(667);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _reactRedux = __webpack_require__(907);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _googleLoginOrSignup = __webpack_require__(874);
	
	var _googleLoginOrSignup2 = _interopRequireDefault(_googleLoginOrSignup);
	
	var _orDivider = __webpack_require__(1007);
	
	var _orDivider2 = _interopRequireDefault(_orDivider);
	
	__webpack_require__(1010);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import GoogleSigninButton   from './google-signin-button';
	
	
	var FORM_NAME = 'signUp';
	
	var tosLink = _hfReactHelper2['default'].urlHelper('info/tos', _hfReactHelper2['default'].HfSites.SITE_CODE_HS, 'www');
	var privacyPolicyLink = _hfReactHelper2['default'].urlHelper('info/privacyPolicy', _hfReactHelper2['default'].HfSites.SITE_CODE_HS, 'www');
	
	var SignUpForm = exports.SignUpForm = function (_React$Component) {
	    _inherits(SignUpForm, _React$Component);
	
	    function SignUpForm(props) {
	        _classCallCheck(this, SignUpForm);
	
	        var _this = _possibleConstructorReturn(this, (SignUpForm.__proto__ || Object.getPrototypeOf(SignUpForm)).call(this, props));
	
	        _this.handleGeneralError = _this.handleGeneralError.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.handleResponse = _this.handleResponse.bind(_this);
	        return _this;
	    }
	
	    /**
	     * Handles any generic/fallback errors we want to handle
	     */
	
	
	    _createClass(SignUpForm, [{
	        key: 'handleGeneralError',
	        value: function handleGeneralError(error) {
	            this.props.dispatch(_reactReduxForm.actions.setSubmitFailed(FORM_NAME));
	        }
	    }, {
	        key: 'handleResponse',
	        value: function handleResponse(err, response) {
	            // Error here means some kind of network error (4xx or 5xx)
	            if (err) {
	                return this.handleGeneralError(err);
	            }
	
	            try {
	                var resp = response.body;
	
	                // Create notification if backend provided one
	                if (resp.notification) {
	                    hellofaxJS.createNotification({
	                        'text': resp.notification.message,
	                        'class_name': resp.notification.type
	                    });
	                }
	
	                // Handle success and failure
	                if (resp.success === true) {
	                    this.props.dispatch(_reactReduxForm.actions.setSubmitted(FORM_NAME));
	
	                    // Redirect to redirect_url
	                    if (resp.redirect_url) {
	                        window.location = resp.redirect_url;
	                    }
	                } else {
	                    this.props.dispatch(_reactReduxForm.actions.setSubmitFailed(FORM_NAME));
	
	                    var hasErrorMsg = !!(resp.error && resp.error.message);
	                    if (hasErrorMsg && !resp.notification_message) {
	                        // Display error message
	                        this.props.dispatch(_reactReduxForm.actions.setErrors(FORM_NAME, {
	                            server: resp.error.message
	                        }));
	                    }
	                }
	
	                if (response.error) {
	                    this.props.dispatch(_reactReduxForm.actions.setErrors(FORM_NAME, {
	                        server: resp.error.message
	                    }));
	                }
	            } catch (e) {
	                return this.handleGeneralError(err);
	            }
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(values) {
	            var _this2 = this;
	
	            // Prepare the POST
	            var url = _hfReactHelper2['default'].urlHelper('account/signUp', _hfReactHelper2['default'].HfSites.SITE_CODE_HS);
	            var data = (0, _qs.stringify)({
	                signup: {
	                    email_address: values.email,
	                    is_opted_in_marketing_emails: values.marketingOptIn,
	                    redirect_url: values.redirectUrl,
	                    pending_tsm_group_guid: values.pendingTsmGroupGuid,
	                    _csrf_token: values.csrfToken
	                },
	                force_delay_analytics_js: true,
	                async: 1
	            });
	
	            // POST to the server
	            return _superagent2['default'].post(url).type('form').send(data).on('request', function () {
	                _this2.props.dispatch(_reactReduxForm.actions.setPending(FORM_NAME));
	            }).end(this.handleResponse);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var logInUrl = _hfReactHelper2['default'].urlHelper('account/logIn', _hfReactHelper2['default'].HfSites.SITE_CODE_HS);
	
	            // Old-style Google Signin Button (TODO: Replace with new GoogleSigninButton component)
	            var googleLoginImage = _react2['default'].createElement(
	                'div',
	                { className: 'm-create-account--modal-google-login-border' },
	                _react2['default'].createElement('div', { className: 'm-create-account--modal-google-login-or-image' })
	            );
	            var googleOpenId = _react2['default'].createElement(
	                'div',
	                { className: 'm-create-account--modal-google-login text-center' },
	                googleLoginImage,
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-create-account--modal-google-login-button' },
	                    _react2['default'].createElement(_googleLoginOrSignup2['default'], {
	                        openIdUrl: this.props.googleOpenIdUrl,
	                        isOptedIn: this.props.isOptedIn,
	                        isLogIn: false })
	                )
	            );
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'm-sign-up-form' },
	                _react2['default'].createElement(
	                    _reactReduxForm.Form,
	                    { model: FORM_NAME, onSubmit: this.handleSubmit },
	                    _react2['default'].createElement(
	                        'h2',
	                        null,
	                        'Let\'s get started'
	                    ),
	                    googleOpenId,
	                    _react2['default'].createElement(_orDivider2['default'], null),
	                    _react2['default'].createElement(
	                        _forms.Field,
	                        { label: 'Email Address' },
	                        _react2['default'].createElement(_reactReduxForm.Control.input, {
	                            type: 'email',
	                            model: 'signUp.email',
	                            validators: { isEmail: _hfReactHelper2['default'].isValidEmailAddress }
	                        }),
	                        _react2['default'].createElement(_reactReduxForm.Errors, {
	                            model: 'signUp.email',
	                            show: 'touched',
	                            messages: {
	                                isEmail: 'Please enter a valid email address'
	                            },
	                            className: 'm-field--error'
	                        })
	                    ),
	                    _react2['default'].createElement(_button2['default'], {
	                        buttonText: 'Create an account',
	                        buttonColor: 'cerulean',
	                        type: 'submit',
	                        disabled: this.props.pending
	                    }),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-sign-up-form--marketing-opt-in' },
	                        _react2['default'].createElement(
	                            'label',
	                            null,
	                            _react2['default'].createElement(_reactReduxForm.Control.checkbox, { model: 'signUp.marketingOptIn' }),
	                            ' Send me HelloSign updates'
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'l-margin-v-20' },
	                        _react2['default'].createElement(_reactReduxForm.Errors, {
	                            model: FORM_NAME,
	                            show: true,
	                            className: 'c-red'
	                        })
	                    ),
	                    _react2['default'].createElement(
	                        'p',
	                        { className: 'l-margin-t-40 l-margin-b-20 m-sign-up-form--tos' },
	                        'By signing up, I accept the ',
	                        _react2['default'].createElement(
	                            'a',
	                            { href: tosLink },
	                            'HelloSign TOS'
	                        ),
	                        ' & ',
	                        _react2['default'].createElement(
	                            'a',
	                            { href: privacyPolicyLink },
	                            'Privacy Policy'
	                        ),
	                        '.'
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-sign-up-form--sign-in-link' },
	                        _react2['default'].createElement('hr', null),
	                        _react2['default'].createElement(
	                            'p',
	                            null,
	                            'Already have an account? ',
	                            _react2['default'].createElement(
	                                'a',
	                                { href: logInUrl },
	                                'Sign in \u203A'
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SignUpForm;
	}(_react2['default'].Component);
	
	SignUpForm.propTypes = {
	    // Provided from Redux state by connect
	    pending: _react2['default'].PropTypes.bool.isRequired,
	
	    // Needed by the GoogleSigninButton component
	    isOptedIn: _react2['default'].PropTypes.bool.isRequired,
	
	    // Redux dispatcher object, provided from Redux by connect
	    dispatch: _react2['default'].PropTypes.func.isRequired,
	
	    // Needed by the GoogleLoginOrSignup component
	    googleOpenIdUrl: _react2['default'].PropTypes.string.isRequired
	};
	
	
	function mapStateToProps(state) {
	    var $form = state.forms.signUp.$form;
	
	
	    return {
	        pending: $form.pending,
	        isOptedIn: state.signUp.marketingOptIn
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps)(SignUpForm);

/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _field = __webpack_require__(1004);
	
	Object.defineProperty(exports, 'Field', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_field)['default'];
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FormField = FormField;
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1005);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Form Field
	 *
	 * This is a low-level component meant to display a label and form control
	 * combination.
	 *
	 * @example
	 * import { Field } from 'common/components/forms';
	 * import Input from 'common/components/input';
	 *
	 * <Field label='Email Address'>
	 *      <Input {...someProps} />
	 * </Field>
	 */
	function FormField(props) {
	    var label = props.label;
	
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'm-field' },
	        label && _react2['default'].createElement(
	            'label',
	            { className: 'm-field--label' },
	            label
	        ),
	        props.children
	    );
	}
	
	FormField.propTypes = {
	    label: _react.PropTypes.string,
	    children: _react.PropTypes.node
	};
	
	exports['default'] = FormField;

/***/ },
/* 1005 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1006 */,
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1008);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A horizontal rule with the word "OR" appearing over the center
	 */
	var OrDivider = function (_React$Component) {
	    _inherits(OrDivider, _React$Component);
	
	    function OrDivider() {
	        _classCallCheck(this, OrDivider);
	
	        return _possibleConstructorReturn(this, (OrDivider.__proto__ || Object.getPrototypeOf(OrDivider)).apply(this, arguments));
	    }
	
	    _createClass(OrDivider, [{
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'm-or-divider' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-or-divider--or' },
	                    'or'
	                ),
	                _react2['default'].createElement('div', { className: 'm-or-divider--rule' })
	            );
	        }
	    }]);
	
	    return OrDivider;
	}(_react2['default'].Component);
	
	exports['default'] = OrDivider;

/***/ },
/* 1008 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1009 */,
/* 1010 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1011 */,
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(888);
	
	var _reactRedux = __webpack_require__(907);
	
	var _reactReduxForm = __webpack_require__(925);
	
	var _reduxThunk = __webpack_require__(1001);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _simpleGrayLayout = __webpack_require__(762);
	
	var _simpleGrayLayout2 = _interopRequireDefault(_simpleGrayLayout);
	
	var _recoverPasswordForm = __webpack_require__(1013);
	
	var _recoverPasswordForm2 = _interopRequireDefault(_recoverPasswordForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Top-level component for standalone Recover Password (Forgot Password) page.
	 * Expects some props from the backend, such as CSRF token.
	 */
	var RecoverPasswordPage = function (_React$Component) {
	    _inherits(RecoverPasswordPage, _React$Component);
	
	    function RecoverPasswordPage(props) {
	        _classCallCheck(this, RecoverPasswordPage);
	
	        // Prepare initial form state
	        var _this = _possibleConstructorReturn(this, (RecoverPasswordPage.__proto__ || Object.getPrototypeOf(RecoverPasswordPage)).call(this, props));
	
	        var initialState = {
	            email: _this.props.email || window.sessionStorage['email'],
	            csrfToken: _this.props.csrfToken
	        };
	        window.sessionStorage.removeItem('email');
	
	        // Set up Redux store
	        _this.store = (0, _redux.createStore)((0, _reactReduxForm.combineForms)({
	            recoverPassword: initialState
	        }), (0, _redux.applyMiddleware)(_reduxThunk2['default']));
	        return _this;
	    }
	
	    _createClass(RecoverPasswordPage, [{
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(
	                _reactRedux.Provider,
	                { store: this.store },
	                _react2['default'].createElement(
	                    _simpleGrayLayout2['default'],
	                    null,
	                    _react2['default'].createElement(_recoverPasswordForm2['default'], null)
	                )
	            );
	        }
	    }]);
	
	    return RecoverPasswordPage;
	}(_react2['default'].Component);
	
	RecoverPasswordPage.propTypes = {
	    // CSRF Token - Sent from the server
	    csrfToken: _react2['default'].PropTypes.string.isRequired,
	
	    // Email value - This is useful to provide for testing purposes
	    email: _react2['default'].PropTypes.string
	};
	
	
	module.exports = RecoverPasswordPage;

/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(907);
	
	var _reactReduxForm = __webpack_require__(925);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _qs = __webpack_require__(673);
	
	var _superagent = __webpack_require__(667);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _forms = __webpack_require__(1003);
	
	__webpack_require__(1014);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FORM_NAME = 'recoverPassword';
	
	var supportEmail = _hfReactHelper2['default'].HfConstants.supportEmail[_hfReactHelper2['default'].HfSites.SITE_CODE_HS];
	var mailToLink = _react2['default'].createElement(
	    'a',
	    { href: 'mailto:' + supportEmail + '?subject=' + encodeURIComponent('Password Reset') },
	    supportEmail
	);
	
	/**
	 * Confirmation message, displayed after the form is submitted
	 */
	function RecoveryMessage() {
	    return _react2['default'].createElement(
	        'div',
	        { className: 'row text-center', 'data-test-ref': 'recovery-message' },
	        _react2['default'].createElement(
	            'div',
	            { className: 'columns small-12' },
	            _react2['default'].createElement(
	                'h2',
	                null,
	                'Check your inbox'
	            ),
	            _react2['default'].createElement(
	                'span',
	                null,
	                _react2['default'].createElement(
	                    'p',
	                    { className: 'l-400' },
	                    'If that is a valid address, we have sent an email to it to reset your password.'
	                ),
	                _react2['default'].createElement('hr', { className: 'm-recover-password-form--rule' }),
	                _react2['default'].createElement(
	                    'p',
	                    { className: 'l-400' },
	                    'If you\'re still experiencing difficulties, please contact us at\xA0',
	                    mailToLink,
	                    '.'
	                )
	            )
	        )
	    );
	}
	
	/**
	 * Recover Password Form
	 *
	 * Allows a user to submit an email address for a password reset, then shows a confirmation message.
	 */
	
	var RecoverPasswordForm = function (_React$Component) {
	    _inherits(RecoverPasswordForm, _React$Component);
	
	    function RecoverPasswordForm(props) {
	        _classCallCheck(this, RecoverPasswordForm);
	
	        // Pre-bind custom methods
	        var _this = _possibleConstructorReturn(this, (RecoverPasswordForm.__proto__ || Object.getPrototypeOf(RecoverPasswordForm)).call(this, props));
	
	        _this.handleGeneralError = _this.handleGeneralError.bind(_this);
	        _this.handleResponse = _this.handleResponse.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        return _this;
	    }
	
	    /**
	     * Handle any generic/fallback errors
	     */
	
	
	    _createClass(RecoverPasswordForm, [{
	        key: 'handleGeneralError',
	        value: function handleGeneralError(error) {
	            this.props.dispatch(_reactReduxForm.actions.setSubmitFailed(FORM_NAME));
	
	            // Display error message
	            this.props.dispatch(_reactReduxForm.actions.setErrors(FORM_NAME, {
	                server: 'derp'
	            }));
	        }
	
	        /**
	         * Handles the response from the server after submitting the form
	         */
	
	    }, {
	        key: 'handleResponse',
	        value: function handleResponse(err, response) {
	            // Error here means some kind of network error (4xx or 5xx)
	            if (err) {
	                return this.handleGeneralError(err);
	            }
	
	            try {
	                // Here we can get errors back from the server and display errors if necessary
	                // (This particular form never returns anything useful, so just proceed to the confirmation message now)
	                this.props.dispatch(_reactReduxForm.actions.setSubmitted(FORM_NAME));
	            } catch (e) {
	                return this.handleGeneralError(err);
	            }
	        }
	
	        /**
	         * This handler is called _after_ react-redux-form has validated the form.
	         */
	
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(values) {
	            var _this2 = this;
	
	            // Prepare POST payload
	            var url = _hfReactHelper2['default'].urlHelper('account/recoverPassword', _hfReactHelper2['default'].HfSites.SITE_CODE_HS);
	            var data = (0, _qs.stringify)({
	                recover: {
	                    email_address: values.email,
	                    _csrf_token: values.csrfToken
	                }
	            });
	
	            // Submit the POST
	            return _superagent2['default'].post(url).type('form').send(data).on('request', function () {
	                _this2.props.dispatch(_reactReduxForm.actions.setPending(FORM_NAME));
	            }).end(this.handleResponse);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props$form$$form = this.props.form['$form'],
	                submitted = _props$form$$form.submitted,
	                submitting = _props$form$$form.pending;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'm-recover-password-form' },
	                !submitted && _react2['default'].createElement(
	                    'div',
	                    { 'data-test-ref': 'form-div' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'l-text-centered' },
	                        _react2['default'].createElement(
	                            'h2',
	                            null,
	                            'Reset password'
	                        ),
	                        _react2['default'].createElement(
	                            'p',
	                            { className: 'l-400' },
	                            'Please enter your email address to request a password reset.'
	                        )
	                    ),
	                    _react2['default'].createElement('hr', { className: 'm-recover-password-form--rule' }),
	                    _react2['default'].createElement(
	                        _reactReduxForm.Form,
	                        {
	                            model: FORM_NAME,
	                            onSubmit: this.handleSubmit,
	                            'data-test-ref': 'form' },
	                        _react2['default'].createElement(
	                            _forms.Field,
	                            { label: 'Email Address' },
	                            _react2['default'].createElement(_reactReduxForm.Control.input, {
	                                type: 'email',
	                                model: 'recoverPassword.email',
	                                validators: { isEmail: _hfReactHelper2['default'].isValidEmailAddress }
	                            }),
	                            _react2['default'].createElement(_reactReduxForm.Errors, {
	                                model: 'recoverPassword.email',
	                                show: 'touched',
	                                messages: { isEmail: 'Please enter a valid email address' },
	                                className: 'm-field--error',
	                                'data-test-ref': 'email-input-errors'
	                            })
	                        ),
	                        _react2['default'].createElement(_button2['default'], {
	                            buttonText: 'Reset Password',
	                            buttonColor: 'azure',
	                            buttonClass: 'm-recover-password-form--button',
	                            type: 'submit',
	                            disabled: submitting
	                        }),
	                        _react2['default'].createElement(_reactReduxForm.Errors, {
	                            model: FORM_NAME,
	                            show: true,
	                            className: 'c-blood'
	                        })
	                    )
	                ),
	                submitted && _react2['default'].createElement(RecoveryMessage, null)
	            );
	        }
	    }]);
	
	    return RecoverPasswordForm;
	}(_react2['default'].Component);
	
	// This mapping is used by connect to expose (as props) parts of state that we need in this component
	
	
	RecoverPasswordForm.propTypes = {
	    // React Redux Form object, provided from Redux state by connect
	    form: _react2['default'].PropTypes.object.isRequired,
	
	    // Redux dispatcher object, provided from Redux by connect
	    dispatch: _react2['default'].PropTypes.func.isRequired
	};
	function mapStateToProps(state) {
	    return {
	        form: state.forms.recoverPassword
	    };
	}
	
	// Export as default the connected form
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps)(RecoverPasswordForm);

/***/ },
/* 1014 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1015 */,
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(888);
	
	var _reactRedux = __webpack_require__(907);
	
	var _reactReduxForm = __webpack_require__(925);
	
	var _reduxThunk = __webpack_require__(1001);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	var _logo = __webpack_require__(763);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _logInForm = __webpack_require__(1017);
	
	var _logInForm2 = _interopRequireDefault(_logInForm);
	
	__webpack_require__(1020);
	
	var _hello = __webpack_require__(1022);
	
	var _hello2 = _interopRequireDefault(_hello);
	
	var _g2_crowd_smallbiz_ = __webpack_require__(1023);
	
	var _g2_crowd_smallbiz_2 = _interopRequireDefault(_g2_crowd_smallbiz_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Top-level component for standalone Log In page.
	 * Expects some props from the backend, such as CSRF token.
	 */
	var LogInPage = function (_React$Component) {
	    _inherits(LogInPage, _React$Component);
	
	    function LogInPage(props) {
	        _classCallCheck(this, LogInPage);
	
	        var _this = _possibleConstructorReturn(this, (LogInPage.__proto__ || Object.getPrototypeOf(LogInPage)).call(this, props));
	
	        var initialState = {
	            emailAddress: _this.props.emailAddress,
	            password: '',
	            csrfToken: _this.props.csrfToken,
	            rememberMe: false,
	            pendingTsmGroupGuid: _this.props.pendingTsmGroupGuid,
	            redirectUrl: _this.props.redirectUrl
	        };
	
	        _this.store = (0, _redux.createStore)((0, _reactReduxForm.combineForms)({
	            logIn: initialState
	        }), (0, _redux.applyMiddleware)(_reduxThunk2['default']));
	        return _this;
	    }
	
	    _createClass(LogInPage, [{
	        key: 'render',
	        value: function render() {
	            var externalHomepageUrl = _hfReactHelper2['default'].urlHelper('', _hfReactHelper2['default'].HfSites.SITE_CODE_HS, 'www');
	            return _react2['default'].createElement(
	                _reactRedux.Provider,
	                { store: this.store },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-log-in' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'row l-padding-b-30 l-padding-t-40' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'small-12 columns' },
	                            _react2['default'].createElement(_logo2['default'], { siteCode: 'S', isLink: true, href: externalHomepageUrl })
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'row m-log-in--greeting l-margin-v-35' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'columns push-6 medium-6 text-centered m-log-in--right' },
	                            _react2['default'].createElement('img', { className: 'l-img-centered', src: _hello2['default'] })
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'columns medium-6 m-log-in--left' },
	                            _react2['default'].createElement(
	                                'div',
	                                null,
	                                _react2['default'].createElement(
	                                    'p',
	                                    { className: 'l-margin-v-20' },
	                                    'HelloSign Ranked #1 eSignature Solution for Small Business in G2 Crowd'
	                                ),
	                                _react2['default'].createElement('img', { className: 'l-margin-v-20', src: _g2_crowd_smallbiz_2['default'] })
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'columns medium-6 small-12 m-log-in--right' },
	                            _react2['default'].createElement(_logInForm2['default'], this.props),
	                            _react2['default'].createElement('hr', { className: 'l-margin-t-40 l-margin-b-15' }),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'l-text-centered c-ashen m-log-in--sign-up-copy' },
	                                'Don\'t have an account?\xA0',
	                                _react2['default'].createElement(
	                                    'a',
	                                    { className: 'm-log-in--sign-up-link', href: '/account/signUp' },
	                                    'Sign up now \u203A'
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return LogInPage;
	}(_react2['default'].Component);
	
	LogInPage.propTypes = {
	    // CSRF Token - Sent from the server
	    csrfToken: _react2['default'].PropTypes.string.isRequired,
	
	    // Email value - This is useful to provide for testing purposes
	    emailAddress: _react2['default'].PropTypes.string,
	
	    // Needed by the LogInCaptcha component
	    recaptchaPublicKey: _react2['default'].PropTypes.string.isRequired,
	
	    // Needed by the GoogleLoginOrSignup component
	    googleOpenIdUrl: _react2['default'].PropTypes.string.isRequired,
	
	    redirectUrl: _react2['default'].PropTypes.string,
	    pendingTsmGroupGuid: _react2['default'].PropTypes.string
	};
	
	
	module.exports = LogInPage;

/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.LogInForm = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _forms = __webpack_require__(1003);
	
	var _reactReduxForm = __webpack_require__(925);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	var _qs = __webpack_require__(673);
	
	var _superagent = __webpack_require__(667);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _reactRedux = __webpack_require__(907);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _googleLoginOrSignup = __webpack_require__(874);
	
	var _googleLoginOrSignup2 = _interopRequireDefault(_googleLoginOrSignup);
	
	var _loginCaptcha = __webpack_require__(881);
	
	var _loginCaptcha2 = _interopRequireDefault(_loginCaptcha);
	
	__webpack_require__(1018);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import GoogleSigninButton   from './google-signin-button';
	
	
	var FORM_NAME = 'logIn';
	
	var LogInForm = exports.LogInForm = function (_Component) {
	    _inherits(LogInForm, _Component);
	
	    function LogInForm(props) {
	        _classCallCheck(this, LogInForm);
	
	        var _this = _possibleConstructorReturn(this, (LogInForm.__proto__ || Object.getPrototypeOf(LogInForm)).call(this, props));
	
	        _this.state = {
	            displayCaptcha: _this.props.displayCaptcha
	        };
	
	        _this.handleGeneralError = _this.handleGeneralError.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.handleResponse = _this.handleResponse.bind(_this);
	        return _this;
	    }
	
	    /**
	     * Handles any generic/fallback errors we want to handle
	     */
	
	
	    _createClass(LogInForm, [{
	        key: 'handleGeneralError',
	        value: function handleGeneralError(error) {
	            this.props.dispatch(_reactReduxForm.actions.setSubmitFailed(FORM_NAME));
	        }
	    }, {
	        key: 'handleResponse',
	        value: function handleResponse(err, response) {
	            // Error here means some kind of network error (4xx or 5xx)
	            if (err) {
	                return this.handleGeneralError(err);
	            }
	
	            try {
	                // Here we can errors back from the server and display errors if
	                // necessary
	                var resp = response.body;
	
	                // Create notification if backend provided one
	                if (resp.notification) {
	                    hellofaxJS.createNotification({
	                        'text': resp.notification.message,
	                        'class_name': resp.notification.type
	                    });
	                }
	
	                // Handle success and failure
	                if (resp.success === true) {
	                    this.props.dispatch(_reactReduxForm.actions.setSubmitted(FORM_NAME));
	
	                    // Redirect to on_login_redirect_url
	                    if (resp.on_login_redirect_url) {
	                        window.location = resp.on_login_redirect_url;
	                    }
	                } else {
	                    this.props.dispatch(_reactReduxForm.actions.setSubmitFailed(FORM_NAME));
	
	                    var hasErrorMsg = !!(resp.error && resp.error.message);
	
	                    if (this.state.displayCaptcha) {
	                        // Refresh CAPTCHA
	                        grecaptcha.reset();
	                    }
	
	                    if (resp.display_captcha) {
	                        if (!this.state.displayCaptcha) {
	                            // Show CAPTCHA
	                            this.setState({
	                                'displayCaptcha': true
	                            });
	                        }
	                    } else if (resp.on_error_redirect_url) {
	                        // Redirect to on_error_redirect_url
	                        window.location = resp.on_error_redirect_url;
	                    } else if (hasErrorMsg && !resp.notification_message) {
	                        // Show CAPTCHA if backend said to
	                        this.setState({
	                            'displayCaptcha': resp.display_captcha
	                        });
	
	                        // Display error message
	                        this.props.dispatch(_reactReduxForm.actions.setErrors(FORM_NAME, {
	                            server: resp.error.message
	                        }));
	                    }
	                }
	
	                if (response.error) {
	                    this.props.dispatch(_reactReduxForm.actions.setErrors(FORM_NAME, {
	                        server: resp.error.message
	                    }));
	                }
	            } catch (e) {
	                return this.handleGeneralError(err);
	            }
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(values) {
	            var _this2 = this;
	
	            var url = _hfReactHelper2['default'].urlHelper('account/logIn', _hfReactHelper2['default'].HfSites.SITE_CODE_HS);
	
	            // Grab recaptcha response if present
	            var captcha = document.getElementById('g-recaptcha-response');
	            var captcha_response = captcha ? captcha.value : null;
	
	            var data = (0, _qs.stringify)({
	                login: {
	                    email_address: values.emailAddress,
	                    password: values.password,
	                    should_remember_me: values.rememberMe,
	                    _csrf_token: values.csrfToken,
	                    pending_tsm_group_guid: values.pendingTsmGroupGuid,
	                    redirect_url: values.redirectUrl
	                },
	                async: 1,
	                'g-recaptcha-response': captcha_response
	            });
	
	            return _superagent2['default'].post(url).type('form').send(data).on('request', function () {
	                _this2.props.dispatch(_reactReduxForm.actions.setPending(FORM_NAME));
	            }).end(this.handleResponse);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var pending = this.props.pending;
	
	
	            var captcha = this.state.displayCaptcha ? _react2['default'].createElement(
	                'div',
	                { className: 'l-margin-v-20' },
	                _react2['default'].createElement(_loginCaptcha2['default'], { recaptchaPublicKey: this.props.recaptchaPublicKey, tabIndex: 4 })
	            ) : null;
	
	            var samlHint = this.props.displaySamlHint ? _react2['default'].createElement(
	                'div',
	                { className: 'm-log-in-form--saml-label' },
	                'To log in via SAML, just enter your email address.'
	            ) : null;
	
	            // Old-style Google Signin Button (TODO: Replace with new GoogleSigninButton component)
	            var googleLoginImage = _react2['default'].createElement(
	                'div',
	                { className: 'm-create-account--modal-google-login-border' },
	                _react2['default'].createElement('div', { className: 'm-create-account--modal-google-login-or-image' })
	            );
	            var googleOpenId = _react2['default'].createElement(
	                'div',
	                { className: 'm-create-account--modal-google-login text-center' },
	                this.props.fields ? googleLoginImage : null,
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-create-account--modal-google-login-button' },
	                    _react2['default'].createElement(_googleLoginOrSignup2['default'], {
	                        openIdUrl: this.props.googleOpenIdUrl,
	                        isOptedIn: this.props.isOptedIn,
	                        isLogIn: true })
	                )
	            );
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'm-log-in-form' },
	                googleOpenId,
	                _react2['default'].createElement('hr', { className: 'l-margin-v-40' }),
	                _react2['default'].createElement(
	                    _reactReduxForm.Form,
	                    { model: FORM_NAME, onSubmit: this.handleSubmit },
	                    _react2['default'].createElement(
	                        _forms.Field,
	                        { label: 'Email Address' },
	                        _react2['default'].createElement(_reactReduxForm.Control.input, {
	                            type: 'email',
	                            model: 'logIn.emailAddress',
	                            validators: { isEmail: _hfReactHelper2['default'].isValidEmailAddress }
	                        }),
	                        _react2['default'].createElement(_reactReduxForm.Errors, {
	                            model: 'logIn.emailAddress',
	                            show: 'touched',
	                            messages: { isEmail: 'Please enter a valid email address' },
	                            className: 'm-field--error'
	                        }),
	                        samlHint
	                    ),
	                    _react2['default'].createElement(
	                        _forms.Field,
	                        { label: 'Password' },
	                        _react2['default'].createElement(_reactReduxForm.Control.input, {
	                            type: 'password',
	                            model: 'logIn.password'
	                        }),
	                        _react2['default'].createElement(
	                            'a',
	                            {
	                                className: 'm-log-in-form--forgot-password-link',
	                                href: '/account/recoverPassword',
	                                onClick: function onClick(e) {
	                                    // Save email field value to sessionStorage for prefill on the next page
	                                    // (Only if emailAddress is not null, since sessionStorage casts that to "null")
	                                    if (_this3.props.emailAddress) {
	                                        window.sessionStorage['email'] = _this3.props.emailAddress;
	                                    }
	                                    return true;
	                                }
	                            },
	                            'Forgot password?'
	                        )
	                    ),
	                    captcha,
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'l-margin-v-20' },
	                        _react2['default'].createElement(_reactReduxForm.Errors, {
	                            model: FORM_NAME,
	                            show: true,
	                            className: 'c-blood'
	                        })
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-log-in-form--submit-controls row' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'm-log-in-form--remember-me small-6 columns' },
	                            _react2['default'].createElement(
	                                'label',
	                                null,
	                                _react2['default'].createElement(_reactReduxForm.Control.checkbox, { model: 'logIn.rememberMe' }),
	                                ' Remember me'
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'm-log-in-form--submit small-6 columns' },
	                            _react2['default'].createElement(_button2['default'], {
	                                buttonText: 'Login',
	                                buttonColor: 'azure',
	                                type: 'submit',
	                                disabled: pending
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return LogInForm;
	}(_react.Component);
	
	LogInForm.propTypes = {
	    // Provided from Redux state by connect
	    pending: _react2['default'].PropTypes.bool.isRequired,
	
	    // Redux dispatcher object, provided from Redux by connect
	    dispatch: _react2['default'].PropTypes.func.isRequired,
	
	    // Needed by the GoogleSigninButton component
	    googleSignInClientId: _react2['default'].PropTypes.string.isRequired,
	
	    // Needed by the LogInCaptcha component
	    recaptchaPublicKey: _react2['default'].PropTypes.string.isRequired,
	
	    // Decides whether the CAPTCHA should be displayed initially
	    displayCaptcha: _react2['default'].PropTypes.bool,
	
	    // Needed by the GoogleLoginOrSignup component
	    googleOpenIdUrl: _react2['default'].PropTypes.string.isRequired
	};
	
	
	function mapStateToProps(state) {
	    var $form = state.forms.logIn.$form;
	
	
	    return {
	        pending: $form.pending,
	        emailAddress: state.logIn.emailAddress
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps)(LogInForm);

/***/ },
/* 1018 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1019 */,
/* 1020 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1021 */,
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/d58ad3a77f60df89e43cefa5cffd9b98.svg";

/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/8b0581c24553d82146f7c5d81a9f84f6.png";

/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _googleLoginOrSignup = __webpack_require__(874);
	
	var _googleLoginOrSignup2 = _interopRequireDefault(_googleLoginOrSignup);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _manualSignup = __webpack_require__(1025);
	
	var _manualSignup2 = _interopRequireDefault(_manualSignup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var HomePageSignup = _react2['default'].createClass({
	    displayName: 'HomePageSignup',
	
	
	    propTypes: {
	        'signupForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
	        'googleOpenIdUrl': _react2['default'].PropTypes.string.isRequired,
	        'redirectUrl': _react2['default'].PropTypes.string,
	        'initialErrorMessage': _react2['default'].PropTypes.string,
	        'initialValue': _react2['default'].PropTypes.string,
	        'utmCampaign': _react2['default'].PropTypes.string,
	        'utmMedium': _react2['default'].PropTypes.string,
	        'utmSource': _react2['default'].PropTypes.string,
	        'utmTerm': _react2['default'].PropTypes.string,
	        'campaignCode': _react2['default'].PropTypes.string,
	        'tabOffset': _react2['default'].PropTypes.number,
	        'targetUrl': _react2['default'].PropTypes.string
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            'isOptedIn': true,
	            'homePageVersion': 'A'
	        };
	    },
	    onOptInChange: function onOptInChange(event) {
	        this.setState({
	            'isOptedIn': event.target.checked
	        });
	    },
	    componentDidMount: function componentDidMount() {
	        document.addEventListener('toggleVersion', function () {
	            this.setState({
	                'homePageVersion': 'B'
	            });
	        }.bind(this));
	    },
	    render: function render() {
	        var initialValue = this.props.initialValue;
	
	        // Cannot pass null to React input fields. Either pass in undefined for
	        // uncontrolled components or an empty string for controlled components
	
	        initialValue = this.props.initialValue || undefined;
	
	        var homePageManualSignup = _react2['default'].createElement(_manualSignup2['default'], _extends({ onOptInChange: this.onOptInChange
	        }, this.props, {
	            initialValue: initialValue }));
	
	        if (this.state.homePageVersion === 'A') {
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'columns small-12 large-12 small-text-centered large-centered' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'small-12 small-text-centered large-4 columns m-login-or-signup--left-button-container' },
	                    _react2['default'].createElement(
	                        'div',
	                        { id: 'google-login-button-top', className: 'm-login-or-signup--left-button' },
	                        _react2['default'].createElement(_googleLoginOrSignup2['default'], { openIdUrl: this.props.googleOpenIdUrl, isOptedIn: this.state.isOptedIn })
	                    )
	                ),
	                _react2['default'].createElement('div', { className: 'small-12 small-text-centered large-1 m-login-or-signup--or-graphic-container columns' }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-login-or-signup--right-button-container small-12 small-centered large-uncentered small-text-centered large-7 last columns large-text-left' },
	                    homePageManualSignup
	                )
	            );
	        } else if (this.state.homePageVersion === 'B') {
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'columns small-12 large-10 small-text-centered large-centered' },
	                _react2['default'].createElement(_button2['default'], { buttonClass: 'm-login-or-signup--takeATourButton',
	                    buttonColor: 'white',
	                    buttonText: 'TAKE A TOUR',
	                    buttonLink: HfReactHelper.urlHelper('info/tour', 'hellosign'),
	                    buttonHoverColor: 'warm-chinchilla',
	                    buttonHoverTextColor: 'velvet-evening',
	                    buttonTextColor: 'velvet-evening' })
	            );
	        }
	    }
	});
	
	module.exports = HomePageSignup;

/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _buttonTextSubmit = __webpack_require__(698);
	
	var _buttonTextSubmit2 = _interopRequireDefault(_buttonTextSubmit);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var HomePageManualSignup = _react2['default'].createClass({
	    displayName: 'HomePageManualSignup',
	
	
	    propTypes: {
	        'redirectUrl': _react2['default'].PropTypes.string,
	        'initialErrorMessage': _react2['default'].PropTypes.string,
	        'initialValue': _react2['default'].PropTypes.string,
	        'utmCampaign': _react2['default'].PropTypes.string,
	        'utmMedium': _react2['default'].PropTypes.string,
	        'utmSource': _react2['default'].PropTypes.string,
	        'utmTerm': _react2['default'].PropTypes.string,
	        'campaignCode': _react2['default'].PropTypes.string,
	        'onOptInChange': _react2['default'].PropTypes.func,
	        'tabOffset': _react2['default'].PropTypes.number,
	        'targetUrl': _react2['default'].PropTypes.string,
	        'signupForm': _react2['default'].PropTypes.object.isRequired // Serialized sfForm
	    },
	
	    render: function render() {
	
	        var targetUrl = this.props.targetUrl || '/account/signUp';
	        var tabOffset = parseInt(this.props.tabOffset || 0, 10);
	
	        var formData = {
	            'signup[redirect_url]': this.props.redirectUrl,
	            'signup[pending_tsm_group_guid]': this.props.pendingTsmGroupGuid, // for if the user sends a TsmGroup after they've gotten logged out somehow
	            'signup[utm_campaign]': this.props.utmCampaign,
	            'signup[utm_medium]': this.props.utmMedium,
	            'signup[utm_source]': this.props.utmSource,
	            'signup[utm_term]': this.props.utmTerm,
	            'signup[campaign_code]': this.props.campaignCode,
	            'signup[coupon_code]': '',
	            'signup[billing_plan_quota_short_guid]': '',
	            'signup[billing_period]': '',
	            'signup[first_name]': '',
	            'signup[last_name]': '',
	            'signup[is_from_external]': '',
	            'should_show_password': '0'
	        };
	
	        var validate = function validate(val) {
	            if (!_hfReactHelper2['default'].isValidEmailAddress(val)) {
	                return 'The email address that you\'ve entered is invalid. Please try again.';
	            } else {
	                return false;
	            }
	        };
	
	        var actionBtn = _react2['default'].createElement(_button2['default'], {
	            buttonText: 'SIGN UP FREE',
	            buttonClass: 'm-login-or-signup--sign-up-button',
	            buttonColor: 'cerulean',
	            buttonTabIndex: tabOffset + 1 });
	
	        // FIXME: too hardcoded to signup[] for my taste
	        // FIXME: There's lot of things that could be refactored in here to make better use of BaseForm
	        return _react2['default'].createElement(
	            _buttonTextSubmit2['default'],
	            {
	                formName: 'newaccount',
	                textPlaceholder: 'Email',
	                textClass: 'm-login-or-signup--text-field',
	                inputName: 'signup[email_address]',
	                additionalFormData: formData,
	                validate: validate,
	                divClass: 'm-sign-mobile--send',
	                url: targetUrl,
	                initialValue: this.props.initialValue,
	                actionButton: actionBtn,
	                initialErrorMessage: this.props.initialErrorMessage,
	                errorClass: 'c-warm-chinchilla',
	                tabOffset: tabOffset,
	                namespace: this.props.signupForm.namespace,
	                fields: this.props.signupForm.fields,
	                values: this.props.signupForm.values },
	            _react2['default'].createElement('br', null),
	            _react2['default'].createElement('input', { id: 'homepage_opt_in',
	                type: 'checkbox',
	                name: 'signup[is_opted_in_marketing_emails]',
	                value: '1',
	                defaultChecked: true,
	                onChange: this.props.onOptInChange,
	                tabIndex: tabOffset + 2 }),
	            _react2['default'].createElement(
	                'label',
	                { htmlFor: 'homepage_opt_in', className: 'm-login-or-signup--opt-in-label' },
	                'Send me HelloSign updates'
	            )
	        );
	    }
	
	    //FIXME: 'Send me HelloSign updates' should be a constant since it is used elsewhere
	
	});
	
	module.exports = HomePageManualSignup;

/***/ },
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dropDownMenu = __webpack_require__(708);
	
	var _dropDownMenu2 = _interopRequireDefault(_dropDownMenu);
	
	var _loginButton = __webpack_require__(1027);
	
	var _loginButton2 = _interopRequireDefault(_loginButton);
	
	var _signupButton = __webpack_require__(1028);
	
	var _signupButton2 = _interopRequireDefault(_signupButton);
	
	var _topBarMenuLink = __webpack_require__(1029);
	
	var _topBarMenuLink2 = _interopRequireDefault(_topBarMenuLink);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _topBarV = __webpack_require__(1030);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TopBarMenu = _react2['default'].createClass({
	    displayName: 'TopBarMenu',
	
	
	    propTypes: {
	        'topBarMenuLinkData': _react2['default'].PropTypes.array.isRequired,
	        'dropDownMenuLinkData': _react2['default'].PropTypes.array.isRequired,
	        'pageToHighLight': _react2['default'].PropTypes.string,
	        'useWhite': _react2['default'].PropTypes.bool,
	        'useBlack': _react2['default'].PropTypes.bool,
	        'isCompact': _react2['default'].PropTypes.bool,
	        'isLogInButtonVisible': _react2['default'].PropTypes.bool,
	        'isSignUpButtonVisible': _react2['default'].PropTypes.bool,
	        'googleOpenIdUrl': _react2['default'].PropTypes.string,
	        'loginEmailAddress': _react2['default'].PropTypes.string,
	        'loginTargetUrl': _react2['default'].PropTypes.string,
	        'signupTargetUrl': _react2['default'].PropTypes.string,
	        'useRegularLink': _react2['default'].PropTypes.bool,
	        'loginHeaderText': _react2['default'].PropTypes.string,
	        'recaptchaPublicKey': _react2['default'].PropTypes.string,
	        'displayCaptcha': _react2['default'].PropTypes.bool,
	        'hideDropDownMenu': _react2['default'].PropTypes.bool,
	        'recoverPasswordForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
	        'loginForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
	        'signupForm': _react2['default'].PropTypes.object.isRequired // Serialized sfForm
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            'menuOpen': false
	        };
	    },
	    toggleMenu: function toggleMenu() {
	        this.setState({
	            'menuOpen': !this.state.menuOpen
	        });
	    },
	    componentDidMount: function componentDidMount() {
	        var container = $('.google-collapse');
	        $(document).click(function (e) {
	            if (container.html() != $(e.target).parent().parent().html()) {
	                if (this.state.menuOpen) {
	                    this.setState({
	                        'menuOpen': false
	                    });
	                }
	            }
	        }.bind(this));
	    },
	    openMenu: function openMenu() {
	        this.setState({
	            'menuOpen': true
	        });
	    },
	    setStateMousedOverDropDownMenuTrue: function setStateMousedOverDropDownMenuTrue() {
	        this.setState({
	            'mousedOverDropDownMenu': true
	        });
	    },
	    setStateMousedOverDropDownMenuFalse: function setStateMousedOverDropDownMenuFalse() {
	        this.setState({
	            'mousedOverDropDownMenu': false
	        });
	    },
	    closeMenu: function closeMenu() {
	        var self = this;
	        window.setTimeout(function () {
	            if (self.state.mousedOverDropDownMenu !== true) {
	                self.setState({
	                    'menuOpen': false
	                });
	            }
	        }, 200);
	    },
	    shouldRenderV2experiement: function shouldRenderV2experiement() {
	        // Use v2 for desktop, and v1 for devices with view widths lower than threshold
	        return window.innerWidth >= _topBarV.TOP_BAR_V2_EXPERIMENT_SCREEN_THRESHOLD;
	    },
	    render: function render() {
	
	        var topBarMenuLinkDataSource = this.props.topBarMenuLinkData;
	
	        if (this.shouldRenderV2experiement()) {
	            Cookie.set(_topBarV.TOP_BAR_V2_EXPERIMENT_COOKIE_NAME, _topBarV.TOP_BAR_V2_EXPERIMENT_COOKIE_VALUE);
	            return this.renderV2();
	        }
	
	        var cx = _classnames2['default'];
	        var linkClasses = {
	            'm-link-list--link': true,
	            'menu-link': true,
	            'google-collapse': true,
	            'c-white': this.props.useWhite ? true : false,
	            'c-ashen': this.props.useWhite ? false : true,
	            'hc-cerulean': this.props.useWhite ? false : true,
	            'hc-warm-chinchilla': this.props.useWhite ? true : false,
	            'show-for-medium-up': true
	        };
	
	        var mobileMenuIconClasses = {
	            'm-link-list--menu-link-mobile-icon': true,
	            'c-white': this.props.useWhite ? true : false,
	            'c-ashen': this.props.useWhite ? false : true
	        };
	
	        var topBarMenuLinks = topBarMenuLinkDataSource.map(function (topBarMenuLink, i) {
	            return _react2['default'].createElement(_topBarMenuLink2['default'], {
	                key: i,
	                componentName: topBarMenuLink.componentName ? topBarMenuLink.componentName : '',
	                linkOptions: topBarMenuLink.options,
	                linkOverrideColors: topBarMenuLink.linkOverrideColors,
	                useWhite: this.props.useWhite,
	                linkText: topBarMenuLink.text,
	                linkUrl: topBarMenuLink.url,
	                pageToHighLight: this.props.pageToHighLight ? this.props.pageToHighLight : '' });
	        }.bind(this));
	
	        var menuIfOpen;
	        if (this.state.menuOpen) {
	            menuIfOpen = _react2['default'].createElement(_dropDownMenu2['default'], {
	                style: { right: 40 },
	                dropDownMenuLinkData: this.props.dropDownMenuLinkData });
	        }
	
	        var menu = _react2['default'].createElement(
	            'div',
	            { className: 'm-link-list--link--container menu-container ' + (this.props.hideDropDownMenu ? 'is-hidden-on-large' : ''), onMouseEnter: this.openMenu, onMouseLeave: this.closeMenu },
	            _react2['default'].createElement(
	                'a',
	                { href: 'javascript:;', className: cx(linkClasses), onClick: this.toggleMenu, tabIndex: '-1' },
	                _react2['default'].createElement(
	                    'span',
	                    null,
	                    'MENU',
	                    _react2['default'].createElement(
	                        'span',
	                        { className: 'm-link-list--menu-arrow' },
	                        '\u25BE'
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { onMouseEnter: this.setStateMousedOverDropDownMenuTrue, onMouseLeave: this.setStateMousedOverDropDownMenuFalse },
	                menuIfOpen
	            )
	        );
	
	        var signUpButton;
	        if (this.props.isSignUpButtonVisible && this.props.googleOpenIdUrl) {
	            signUpButton = _react2['default'].createElement(_signupButton2['default'], {
	                googleOpenIdUrl: this.props.googleOpenIdUrl,
	                useWhite: this.props.useWhite,
	                useBlack: this.props.useBlack,
	                isCompact: this.props.isCompact,
	                signupForm: this.props.signupForm,
	                loginForm: this.props.loginForm,
	                recoverPasswordForm: this.props.recoverPasswordForm,
	                async: false
	            });
	        }
	        if (this.props.isSignUpButtonVisible && this.props.googleOpenIdUrl) {
	            signUpButton = _react2['default'].createElement(_signupButton2['default'], {
	                googleOpenIdUrl: this.props.googleOpenIdUrl,
	                useWhite: this.props.useWhite,
	                useBlack: this.props.useBlack,
	                isCompact: this.props.isCompact,
	                signupUrl: this.props.signupTargetUrl,
	                useRegularLink: this.props.useRegularLink,
	                loginForm: this.props.loginForm,
	                recoverPasswordForm: this.props.recoverPasswordForm,
	                signupForm: this.props.signupForm,
	                async: false
	            });
	        }
	
	        var logInButton;
	        if (this.props.isLogInButtonVisible && this.props.googleOpenIdUrl) {
	            logInButton = _react2['default'].createElement(_loginButton2['default'], {
	                recaptchaPublicKey: this.props.recaptchaPublicKey,
	                emailAddress: this.props.loginEmailAddress,
	                googleOpenIdUrl: this.props.googleOpenIdUrl,
	                useWhite: this.props.useWhite,
	                useBlack: this.props.useBlack,
	                isCompact: this.props.isCompact || this.props.hideDropDownMenu,
	                recoverPasswordForm: this.props.recoverPasswordForm,
	                loginForm: this.props.loginForm });
	        }
	        if (this.props.isLogInButtonVisible && this.props.googleOpenIdUrl) {
	            logInButton = _react2['default'].createElement(_loginButton2['default'], {
	                emailAddress: this.props.loginEmailAddress,
	                googleOpenIdUrl: this.props.googleOpenIdUrl,
	                useWhite: this.props.useWhite,
	                useBlack: this.props.useBlack,
	                isCompact: this.props.isCompact || this.props.hideDropDownMenu,
	                loginUrl: this.props.loginTargetUrl,
	                headerText: this.props.loginHeaderText,
	                recaptchaPublicKey: this.props.recaptchaPublicKey,
	                displayCaptcha: this.props.displayCaptcha,
	                useRegularLink: this.props.useRegularLink,
	                recoverPasswordForm: this.props.recoverPasswordForm,
	                loginForm: this.props.loginForm
	            });
	        }
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'm-link-list small-9 columns text-center ' + (!this.props.isLogInButtonVisible && !this.props.isSignUpButtonVisible && this.props.hideDropDownMenu ? 'is-compact' : ''), 'data-equalizer-watch': true },
	            menu,
	            _react2['default'].createElement(
	                'a',
	                { href: 'javascript:;', className: 'toggle-nav m-link-list--menu-link-mobile' + (this.props.useWhite ? ' c-white hc-warm-chinchilla' : ' c-castle-rock hc-cerulean'), tabIndex: '-1' },
	                _react2['default'].createElement('span', { className: cx(mobileMenuIconClasses) })
	            ),
	            logInButton,
	            signUpButton,
	            topBarMenuLinks
	        );
	    },
	    renderV2: function renderV2() {
	
	        var topBarMenuLinkDataSource = _topBarV.TOP_BAR_V2_EXPERIMENT_LINK_DATA;
	
	        var topBarMenuLinks = topBarMenuLinkDataSource.map(function (topBarMenuLink, i) {
	            return _react2['default'].createElement(_topBarMenuLink2['default'], {
	                key: i,
	                componentName: topBarMenuLink.componentName ? topBarMenuLink.componentName : '',
	                linkOptions: topBarMenuLink.options,
	                linkOverrideColors: topBarMenuLink.linkOverrideColors,
	                useWhite: this.props.useWhite,
	                linkText: topBarMenuLink.text,
	                linkUrl: topBarMenuLink.url,
	                pageToHighLight: this.props.pageToHighLight ? this.props.pageToHighLight : ''
	            });
	        }.bind(this));
	
	        var signUpButton;
	        if (this.props.isSignUpButtonVisible && this.props.googleOpenIdUrl) {
	            signUpButton = _react2['default'].createElement(_signupButton2['default'], {
	                googleOpenIdUrl: this.props.googleOpenIdUrl,
	                useWhite: this.props.useWhite,
	                useBlack: this.props.useBlack,
	                isCompact: this.props.isCompact,
	                signupUrl: this.props.signupTargetUrl,
	                useRegularLink: this.props.useRegularLink,
	                signupForm: this.props.signupForm,
	                buttonText: 'SIGN UP FREE',
	                recoverPasswordForm: this.props.recoverPasswordForm,
	                loginForm: this.props.loginForm,
	                async: false
	            });
	        }
	
	        var logInButton;
	        if (this.props.isLogInButtonVisible && this.props.googleOpenIdUrl) {
	            logInButton = _react2['default'].createElement(_loginButton2['default'], {
	                emailAddress: this.props.loginEmailAddress,
	                googleOpenIdUrl: this.props.googleOpenIdUrl,
	                useWhite: this.props.useWhite,
	                useBlack: this.props.useBlack,
	                isCompact: this.props.isCompact || this.props.hideDropDownMenu,
	                loginUrl: this.props.loginTargetUrl,
	                headerText: this.props.loginHeaderText,
	                recaptchaPublicKey: this.props.recaptchaPublicKey,
	                displayCaptcha: this.props.displayCaptcha,
	                useRegularLink: this.props.useRegularLink,
	                recoverPasswordForm: this.props.recoverPasswordForm,
	                loginForm: this.props.loginForm,
	                className: 'external-top-bar' });
	        }
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'm-link-list small-9 large-10 columns text-center ', 'data-equalizer-watch': true },
	            logInButton,
	            signUpButton,
	            topBarMenuLinks
	        );
	    }
	});
	
	module.exports = TopBarMenu;

/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _loginTrigger = __webpack_require__(875);
	
	var _loginTrigger2 = _interopRequireDefault(_loginTrigger);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: Is there a way to extend the TopBarMenuLink component so that we don't
	// have to duplicate the class designations?
	
	var LogInButton = _react2['default'].createClass({
	    displayName: 'LogInButton',
	
	
	    propTypes: {
	        'googleOpenIdUrl': _react2['default'].PropTypes.string.isRequired,
	        'useWhite': _react2['default'].PropTypes.bool,
	        'useBlack': _react2['default'].PropTypes.bool,
	        'isMobile': _react2['default'].PropTypes.bool,
	        'isCompact': _react2['default'].PropTypes.bool,
	        'emailAddress': _react2['default'].PropTypes.string,
	        'loginUrl': _react2['default'].PropTypes.string,
	        'useRegularLink': _react2['default'].PropTypes.bool,
	        'headerText': _react2['default'].PropTypes.string,
	        'recaptchaPublicKey': _react2['default'].PropTypes.string,
	        'displayCaptcha': _react2['default'].PropTypes.bool,
	        'className': _react2['default'].PropTypes.string,
	        'recoverPasswordForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
	        'loginForm': _react2['default'].PropTypes.object.isRequired // Serialized sfForm
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            'useWhite': false
	        };
	    },
	    getDefaultProps: function getDefaultProps() {
	        return {
	            'headerText': 'Welcome back'
	        };
	    },
	    render: function render() {
	        var classSet = (0, _classnames2['default'])({
	            'm-link-list--link': !this.props.isMobile,
	            'm-link-list--log-in': !this.props.isMobile,
	            'm-link-list--link-break-2': !this.props.isMobile,
	            'm-mobile-menu--signin-link': this.props.isMobile,
	            'is-compact': !this.props.isMobile && this.props.isCompact,
	            'c-white': this.props.useWhite,
	            'hc-warm-chinchilla': this.props.useWhite,
	            'c-ashen': this.props.useBlack || !this.props.useWhite,
	            'hc-cerulean': !this.props.useWhite
	        });
	
	        if (this.props.className) {
	            classSet += ' ' + this.props.className;
	        }
	
	        var trigger = _react2['default'].createElement(
	            'div',
	            { className: 'm-link-list--link--container' },
	            _react2['default'].createElement(
	                'a',
	                { className: classSet, href: this.props.useRegularLink ? this.props.loginUrl : 'javascript:;', tabIndex: '-1' },
	                'Log In'
	            )
	        );
	
	        if (this.props.useRegularLink) {
	            var returnValue = trigger;
	        } else {
	            var returnValue = _react2['default'].createElement(_loginTrigger2['default'], {
	                trigger: trigger,
	                header: this.props.headerText,
	                buttonText: 'Sign In',
	                recaptchaPublicKey: this.props.recaptchaPublicKey,
	                displayCaptcha: this.props.displayCaptcha,
	                googleOpenIdUrl: this.props.googleOpenIdUrl,
	                emailAddress: this.props.emailAddress,
	                loginUrl: this.props.loginUrl,
	                recoverPasswordForm: this.props.recoverPasswordForm,
	                loginForm: this.props.loginForm });
	        }
	        return returnValue;
	    }
	});
	
	module.exports = LogInButton;

/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createAccountTrigger = __webpack_require__(883);
	
	var _createAccountTrigger2 = _interopRequireDefault(_createAccountTrigger);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var SignUpButton = _react2['default'].createClass({
	    displayName: 'SignUpButton',
	
	
	    propTypes: {
	        'googleOpenIdUrl': _react2['default'].PropTypes.string.isRequired,
	        'useWhite': _react2['default'].PropTypes.bool,
	        'useBlack': _react2['default'].PropTypes.bool,
	        'isCompact': _react2['default'].PropTypes.bool,
	        'isMobile': _react2['default'].PropTypes.bool,
	        'signupUrl': _react2['default'].PropTypes.string,
	        'useRegularLink': _react2['default'].PropTypes.bool,
	        'buttonText': _react2['default'].PropTypes.string,
	        'signupForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
	        'async': _react2['default'].PropTypes.bool
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            useWhite: false
	        };
	    },
	    render: function render() {
	
	        var classSet = (0, _classnames2['default'])({
	            'm-link-list--link': !this.props.isMobile,
	            'm-link-list--signup': !this.props.isMobile,
	            'm-link-list--link-break-2': !this.props.isMobile,
	            'm-mobile-menu--signup-link': this.props.isMobile,
	            'bg-cerulean': !this.props.useWhite,
	            'bg-white': this.props.useWhite && !this.props.useBlack,
	            'bg-ashen': this.props.useBlack,
	            'c-white': !this.props.useWhite || this.props.useBlack,
	            'c-cerulean': this.props.useWhite,
	            'hc-cerulean': this.props.useWhite,
	            'hc-white': !this.props.useWhite,
	            'hbg-velvet-evening': !this.props.useWhite,
	            'hbg-warm-chinchilla': !this.props.useBlack && this.props.useWhite,
	            'hbg-ashen': this.props.useBlack
	        });
	
	        var triggerClasses = (0, _classnames2['default'])({
	            'm-link-list--link--container': true,
	            'is-compact': this.props.isCompact
	        });
	        var trigger = _react2['default'].createElement(
	            'div',
	            { className: triggerClasses },
	            _react2['default'].createElement(
	                'a',
	                { className: classSet, href: this.props.useRegularLink ? this.props.signupUrl : 'javascript:;', tabIndex: '-1' },
	                this.props.buttonText ? this.props.buttonText : 'Sign Up'
	            )
	        );
	
	        if (this.props.useRegularLink) {
	            var returnValue = trigger;
	        } else {
	            var returnValue = _react2['default'].createElement(_createAccountTrigger2['default'], {
	                key: 'signup_trigger',
	                trigger: trigger,
	                header: 'Let\'s get started',
	                buttonText: 'Create an account',
	                googleOpenIdUrl: this.props.googleOpenIdUrl,
	                signupUrl: this.props.signupUrl,
	                signupForm: this.props.signupForm,
	                loginForm: this.props.loginForm,
	                recoverPasswordForm: this.props.recoverPasswordForm,
	                async: this.props.async
	            });
	        }
	
	        return returnValue;
	    }
	});
	
	module.exports = SignUpButton;

/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _dropDownMenu = __webpack_require__(708);
	
	var _dropDownMenu2 = _interopRequireDefault(_dropDownMenu);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TopBarMenuLink = _react2['default'].createClass({
	    displayName: 'TopBarMenuLink',
	
	
	    propTypes: {
	        'linkText': _react2['default'].PropTypes.string.isRequired,
	        'linkUrl': _react2['default'].PropTypes.string,
	        'linkOptions': _react2['default'].PropTypes.object,
	        'linkOverrideColors': _react2['default'].PropTypes.object,
	        'pageToHighLight': _react2['default'].PropTypes.string,
	        'useWhite': _react2['default'].PropTypes.bool
	    },
	
	    componentDidMount: function componentDidMount() {
	        if (this.state.menuLeft == null) {
	            // Only set once
	            this.getMenuLeft();
	        }
	    },
	
	
	    // dropdown menu-related functions
	    getInitialState: function getInitialState() {
	        return {
	            'menuOpen': false,
	            'menuLeft': null
	        };
	    },
	    getMenuLeft: function getMenuLeft() {
	        var node = _reactDom2['default'].findDOMNode(this);
	        var parent = node.offsetParent;
	        if (node && parent) {
	            var rect = node.getBoundingClientRect();
	            var parentRect = parent.getBoundingClientRect();
	            this.setState({
	                menuLeft: rect.left - parentRect.left
	            });
	        }
	    },
	    openMenu: function openMenu() {
	        this.setState({ menuOpen: true });
	    },
	    setStateMousedOverDropDownMenuTrue: function setStateMousedOverDropDownMenuTrue() {
	        this.setState({ mousedOverDropDownMenu: true });
	    },
	    setStateMousedOverDropDownMenuFalse: function setStateMousedOverDropDownMenuFalse() {
	        this.setState({ mousedOverDropDownMenu: false });
	    },
	    closeMenu: function closeMenu() {
	        this.setState({ menuOpen: false });
	        var self = this;
	        window.setTimeout(function () {
	            if (self.state.mousedOverDropDownMenu !== true) {
	                self.setState({ menuOpen: false });
	            }
	        }, 200);
	    },
	    render: function render() {
	
	        var cx = _classnames2['default'];
	        var rowClasses = {
	            'm-link-list--link--container': true,
	            'm-link-list--link-break-1': false
	        };
	        var linkClasses = {
	            'm-link-list--link': true
	        };
	        var linkDefaultColors = {
	            'c-white': this.props.useWhite ? true : false,
	            'hc-warm-chinchilla': this.props.useWhite ? true : false,
	            'hc-cerulean': this.props.useWhite ? false : true,
	            'c-ashen': this.props.useWhite ? false : true
	        };
	
	        var linkColors = this.props.linkOverrideColors ? this.props.linkOverrideColors : linkDefaultColors;
	
	        if (this.props.linkOptions && this.props.linkOptions.hasOwnProperty('class')) {
	            var newProperty = {};
	            var newPropertyKey = this.props.linkOptions['class'];
	            newProperty[newPropertyKey] = true;
	            linkClasses = _hfReactHelper2['default'].extend(newProperty, linkClasses);
	        }
	
	        if (this.props.linkUrl == this.props.pageToHighLight) {
	            linkClasses = _hfReactHelper2['default'].extend({
	                'm-link-list--currentPage': true
	            }, linkClasses);
	        }
	
	        if (this.props.linkOptions && this.props.linkOptions.hasOwnProperty('colors')) {
	            var propertyColorOverride = {};
	            var propertyColorOverrideKey = this.props.linkOptions.colors;
	            propertyColorOverride[propertyColorOverrideKey] = true;
	            linkClasses = _hfReactHelper2['default'].extend(propertyColorOverride, linkClasses);
	        } else {
	            linkClasses = _hfReactHelper2['default'].extend(linkColors, linkClasses);
	        }
	
	        if (this.props.linkOptions && this.props.linkOptions.hasOwnProperty('container_class')) {
	            var containerClasses = this.props.linkOptions.container_class.split(' ');
	            for (var i = 0; i < containerClasses.length; i++) {
	                var clazz = containerClasses[i];
	                rowClasses[clazz] = true;
	            }
	        }
	
	        // Stringify classes
	        linkClasses = cx(linkClasses);
	        rowClasses = cx(rowClasses);
	
	        var dropDownMenu;
	        if (this.props.linkOptions.hasOwnProperty('sub_menu_items') && this.state.menuOpen) {
	
	            var style;
	            if (this.props.linkOptions.hasOwnProperty('sub_menu_lock_to_parent') && this.props.linkOptions.sub_menu_lock_to_parent) {
	                style = {};
	                style.left = this.state.menuLeft ? this.state.menuLeft + 15 : 0;
	                style.transform = 'translateX(-30%)';
	            } else {
	                style = { right: 40 }; // Default, right side menu
	            }
	
	            dropDownMenu = _react2['default'].createElement(
	                'div',
	                {
	                    onMouseEnter: this.setStateMousedOverDropDownMenuTrue, onMouseLeave: this.setStateMousedOverDropDownMenuFalse },
	                _react2['default'].createElement(_dropDownMenu2['default'], {
	                    id: this.props.linkOptions.sub_menu_id,
	                    ref: 'dropDownMenu',
	                    style: style,
	                    dropDownMenuLinkData: this.props.linkOptions.sub_menu_items,
	                    className: this.props.linkOptions.sub_menu_class })
	            );
	        }
	
	        var dropDownArrow;
	        if (this.props.linkOptions.hasOwnProperty('show_menu_drop_down_arrow') && this.props.linkOptions.show_menu_drop_down_arrow) {
	            dropDownArrow = _react2['default'].createElement(
	                'span',
	                { className: 'm-drop-down-menu--drop-down-arrow' },
	                '\u25BE'
	            );
	        }
	
	        return _react2['default'].createElement(
	            'div',
	            { className: rowClasses, onMouseEnter: this.openMenu, onMouseLeave: this.closeMenu },
	            _react2['default'].createElement(
	                'a',
	                { className: linkClasses, href: this.props.linkUrl, target: this.props.linkOptions.target, tabIndex: '-1' },
	                this.props.linkText,
	                dropDownArrow
	            ),
	            dropDownMenu
	        );
	    }
	});
	
	module.exports = TopBarMenuLink;

/***/ },
/* 1030 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var TOP_BAR_V2_EXPERIMENT_LINK_DATA = exports.TOP_BAR_V2_EXPERIMENT_LINK_DATA = [{
	    'url': '/api',
	    'text': 'API',
	    'options': {
	        'class': 'm-link-list--link-break-1',
	        'container_class': 'external-top-bar',
	        'sub_menu_items': [{
	            'url': '/api/documentation',
	            'text': 'Documentation'
	        }, {
	            'url': '/api/features',
	            'text': 'Features'
	        }, {
	            'url': '/api/libraries',
	            'text': 'Libraries'
	        }, {
	            'url': '/api/pricing',
	            'text': 'Pricing'
	        }, {
	            'url': '/api/reference',
	            'text': 'API Help'
	        }, {
	            'url': '/api/terms',
	            'text': 'API Terms'
	        }],
	        'sub_menu_class': 'external-top-bar',
	        'sub_menu_lock_to_parent': true,
	        'show_menu_drop_down_arrow': true
	    }
	}, {
	    'url': 'javascript:;',
	    'text': 'Customers',
	    'options': {
	        'class': 'm-link-list--link-break-1',
	        'container_class': 'external-top-bar',
	        'sub_menu_items': [{
	            'url': 'http://info.hellosign.com/instacart-case-study.html',
	            'text': 'Instacart',
	            'options': {
	                'target': '_blank'
	            }
	        }, {
	            'url': 'http://info.hellosign.com/simplyinsured-case-study.html',
	            'text': 'Simply Insured',
	            'options': {
	                'target': '_blank'
	            }
	        }, {
	            'url': 'http://info.hellosign.com/openlegal-case-study.html',
	            'text': 'OpenLegal',
	            'options': {
	                'target': '_blank'
	            }
	        }, {
	            'url': 'http://info.hellosign.com/trxade-case-study.html',
	            'text': 'Trxade',
	            'options': {
	                'target': '_blank'
	            }
	        }],
	        'sub_menu_class': 'external-top-bar',
	        'sub_menu_lock_to_parent': true,
	        'show_menu_drop_down_arrow': true
	    }
	}, {
	    'url': 'javascript:;',
	    'text': 'Solutions',
	    'options': {
	        'class': 'm-link-list--link-break-1',
	        'container_class': 'external-top-bar',
	        'sub_menu_items': [{
	            'url': '/solutions/insurance',
	            'text': 'Insurance'
	        }, {
	            'url': '/solutions/real-estate',
	            'text': 'Real Estate'
	        }, {
	            'url': '/solutions/marketplaces',
	            'text': 'On-Demand Platforms'
	        }],
	        'sub_menu_class': 'external-top-bar',
	        'sub_menu_lock_to_parent': true,
	        'show_menu_drop_down_arrow': true
	    }
	}, {
	    'url': 'javascript:;',
	    'text': 'Pricing',
	    'options': {
	        'class': 'm-link-list--link-break-1',
	        'container_class': 'external-top-bar',
	        'sub_menu_items': [{
	            'url': '/info/pricing',
	            'text': 'HelloSign'
	        }, {
	            'url': '/api/pricing',
	            'text': 'API'
	        }],
	        'sub_menu_class': 'external-top-bar',
	        'sub_menu_lock_to_parent': true,
	        'show_menu_drop_down_arrow': true
	    }
	}, {
	    'url': 'javascript:;',
	    'text': 'Products',
	    'options': {
	        'class': 'm-link-list--link-break-1',
	        'container_class': 'external-top-bar',
	        'sub_menu_items': [{
	            'url': '/info/tour',
	            'text': 'HelloSign'
	        }, {
	            'url': '/api',
	            'text': 'API'
	        }, {
	            'url': '/integrations',
	            'text': 'Integrations'
	        }, {
	            'url': '/info/tour#googleIntegrations',
	            'text': 'Google Apps'
	        }],
	        'sub_menu_class': 'external-top-bar',
	        'sub_menu_lock_to_parent': true,
	        'show_menu_drop_down_arrow': true
	    }
	}];
	
	var TOP_BAR_V2_EXPERIMENT_SCREEN_THRESHOLD = exports.TOP_BAR_V2_EXPERIMENT_SCREEN_THRESHOLD = 1050; // pixels
	
	var TOP_BAR_V2_EXPERIMENT_COOKIE_NAME = exports.TOP_BAR_V2_EXPERIMENT_COOKIE_NAME = 'hs_experiment_top_bar_v2'; // Used for analytics
	var TOP_BAR_V2_EXPERIMENT_COOKIE_VALUE = exports.TOP_BAR_V2_EXPERIMENT_COOKIE_VALUE = 'top_bar_v2_enabled'; // Used for analytics
	var TOP_BAR_V2_EXPERIMENT_NAME = exports.TOP_BAR_V2_EXPERIMENT_NAME = 'top_bar_v2_enabled';

/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _cancelSubscriptionForm = __webpack_require__(1032);
	
	var _cancelSubscriptionForm2 = _interopRequireDefault(_cancelSubscriptionForm);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var CancelSubscriptionPage = _react2['default'].createClass({
	
	    displayName: 'CancelSubscriptionPage',
	
	    propTypes: {
	        'tabOffset': _react2['default'].PropTypes.number,
	        'cancelSubscriptionForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
	        'isHf': _react2['default'].PropTypes.bool, // maybe get dynamically from helpers
	        'isTeamAdmin': _react2['default'].PropTypes.bool,
	        'hasHipaa': _react2['default'].PropTypes.bool,
	        'hasBothApiAndUiPlans': _react2['default'].PropTypes.bool,
	        'redirectUrl': _react2['default'].PropTypes.string,
	        'showCustomerCancelOffer': _react2['default'].PropTypes.bool
	    },
	
	    getInitialState: function getInitialState() {
	        return {};
	    },
	    getDefaultProps: function getDefaultProps() {
	        return {
	            'isIFrame': false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        if (this.props.isIFrame) {
	            parent.hellofaxJS.resizeFancyBoxPopup({ width: 500, height: 450 });
	            parent.$('#fancybox-frame').width(480);
	        }
	    },
	    render: function render() {
	        var siteCode = this.props.isHf ? _hfReactHelper2['default'].HfSites.SITE_CODE_HF : _hfReactHelper2['default'].HfSites.SITE_CODE_HS;
	
	        var form = _react2['default'].createElement(_cancelSubscriptionForm2['default'], {
	            tabOffset: this.props.tabOffset,
	            isHf: this.props.isHf,
	            isTeamAdmin: this.props.isTeamAdmin,
	            hasHipaa: this.props.hasHipaa,
	            hasBothApiAndUiPlans: this.props.hasBothApiAndUiPlans,
	            redirectUrl: this.props.redirectUrl,
	            showCustomerCancelOffer: this.props.showCustomerCancelOffer,
	            method: 'POST',
	            namespace: this.props.cancelSubscriptionForm.namespace,
	            action: _hfReactHelper2['default'].urlHelper('account/cancelSubscription', siteCode),
	            fields: this.props.cancelSubscriptionForm.fields,
	            values: this.props.cancelSubscriptionForm.values,
	            errors: { 'global': this.state.error } });
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'm-settings--cancel' },
	            form
	        );
	    }
	});
	
	module.exports = CancelSubscriptionPage;

/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _baseForm = __webpack_require__(703);
	
	var _baseForm2 = _interopRequireDefault(_baseForm);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _stringsAndConstants = __webpack_require__(1033);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	__webpack_require__(1034);
	
	
	var CancelSubscriptionForm = _baseForm2['default'].createFormClass({
	
	    displayName: 'CancelSubscriptionForm',
	
	    propTypes: {
	        'isHf': _react2['default'].PropTypes.bool, // maybe get dynamically from helpers
	        'isTeamAdmin': _react2['default'].PropTypes.bool,
	        'hasHipaa': _react2['default'].PropTypes.bool,
	        'hasBothApiAndUiPlans': _react2['default'].PropTypes.bool,
	        'redirectUrl': _react2['default'].PropTypes.string,
	        'showCustomerCancelOffer': _react2['default'].PropTypes.bool
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            supportMessage: '',
	            justApi: false,
	            justUi: false,
	            // Individual fields to hide (not sections, such as competitor or support contact)
	            showFields: {
	                'cancel_reason_features-detail': false
	            },
	            // Competitor info
	            cancelForCompetitor: false,
	            competitorName: '',
	            competitorAutocompleteMatches: [],
	            shouldShowCompetitorAutocomplete: false,
	            shouldShowCompetitorReasons: false,
	            // Validation
	            hasAttemptedSubmit: false,
	            supportShouldContactFilled: false,
	            atLeastOneReasonChecked: false,
	            errors: {},
	            // Null means don't set it to be selected to begin with
	            supportShouldContact: null,
	            canWeFollowUp: null
	        };
	    },
	
	
	    /**
	    * Handlers
	    */
	
	    onCompetitorAutocompleteItemClick: function onCompetitorAutocompleteItemClick(e) {
	        var text = e.target.innerHTML;
	        this.setState({
	            competitorName: text,
	            shouldShowCompetitorAutocomplete: false
	        });
	    },
	    onSupportMessageChange: function onSupportMessageChange(e) {
	        var message = e.target.value;
	
	        this.setState({
	            supportMessage: message
	        });
	    },
	    onPlanSwitchChange: function onPlanSwitchChange(e) {
	
	        var newState = {};
	
	        if (e.target.name === 'cancel[just_ui]') {
	            newState.justUi = e.target.checked;
	        } else if (e.target.name === 'cancel[just_api]') {
	            newState.justApi = e.target.checked;
	        }
	
	        this.setState(newState);
	    },
	    onReasonListChange: function onReasonListChange(e) {
	
	        var newState = {};
	        newState.atLeastOneReasonChecked = document.querySelectorAll('input[type="checkbox"]:checked').length > 0;
	
	        if (e.target.name === 'cancel[cancel_reason_features]') {
	            newState.showFields = {};
	            newState.showFields['cancel_reason_features-detail'] = e.target.checked;
	        }
	
	        if (e.target.name === 'cancel[cancel_reason_competitor]') {
	            newState.cancelForCompetitor = e.target.checked;
	        }
	
	        this.setState(newState);
	    },
	    onCompetitorNameChange: function onCompetitorNameChange(e) {
	        var name = e.target.value;
	        var list = [];
	
	        if (name.length > _stringsAndConstants.cancelConstants.AUTOCOMPLETE_MIN_THRESHOLD) {
	            // Cheap implentation of autocomplete, but enough for this case
	            var re = new RegExp(name, 'i');
	            list = _stringsAndConstants.cancelConstants.competitorList.filter(function (competitor) {
	                return competitor.match(re);
	            });
	        }
	
	        this.setState({
	            competitorName: name,
	            competitorAutocompleteMatches: list,
	            shouldShowCompetitorAutocomplete: name.length > _stringsAndConstants.cancelConstants.AUTOCOMPLETE_MIN_THRESHOLD,
	            shouldShowCompetitorReasons: name.length > _stringsAndConstants.cancelConstants.AUTOCOMPLETE_MIN_THRESHOLD
	        });
	    },
	    onSupportShouldContactChange: function onSupportShouldContactChange(e) {
	        var shouldContact = e.target.value === 'yes' ? true : false;
	        this.setState({
	            supportShouldContactFilled: true,
	            supportShouldContact: shouldContact
	        });
	    },
	    onCanWeFollowUpChange: function onCanWeFollowUpChange(e) {
	        var canWeFollowUp = e.target.value === 'yes' ? true : false;
	        this.setState({
	            canWeFollowUp: canWeFollowUp
	        });
	    },
	    onSubmit: function onSubmit(e) {
	
	        // Validation
	        this.setState({ hasAttemptedSubmit: true });
	        var valid = this.validateForm() && this.validateSupportMessage() && this.validatePlanSwitch();
	
	        e.preventDefault();
	        if (valid) {
	            $('#cancel_form').submit();
	        }
	    },
	
	
	    /**
	    * Validation
	    */
	
	    validateForm: function validateForm() {
	        if (this.state.supportShouldContactFilled && this.state.atLeastOneReasonChecked) {
	            return true;
	        }
	        return false;
	    },
	    validateSupportMessage: function validateSupportMessage() {
	
	        // Don't need to fill in if no contact needed
	        if (!this.state.supportShouldContact) {
	            return true;
	        }
	
	        if (this.state.supportMessage.length >= _stringsAndConstants.cancelConstants.SUPPORT_MESSAGE_MIN_THRESHOLD) {
	            return true;
	        }
	
	        return false;
	    },
	    validatePlanSwitch: function validatePlanSwitch() {
	
	        if (!this.props.hasBothApiAndUiPlans) {
	            return true;
	        }
	
	        if (this.state.justUi || this.state.justApi) {
	            return true;
	        }
	
	        return false;
	    },
	
	
	    /**
	    * Sub render methods
	    */
	
	    renderCancelWarning: function renderCancelWarning() {
	        var legalText = this.props.isHf ? _stringsAndConstants.cancelStrings.legalText.HF : _stringsAndConstants.cancelStrings.legalText.HS;
	        return _react2['default'].createElement(
	            'span',
	            null,
	            legalText.head,
	            _react2['default'].createElement(
	                'a',
	                { href: '/info/tos' },
	                ' ',
	                legalText.link,
	                ' '
	            ),
	            legalText.tail
	        );
	    },
	    renderPlanSwitch: function renderPlanSwitch() {
	
	        var self = this;
	
	        var error = this.state.hasAttemptedSubmit && !this.state.justUi && !this.state.justApi;
	
	        var justApiToggle = this.renderField('just_api', {
	            'data-format': 'inputcheckbox',
	            'value': this.state.justApi,
	            'onChange': self.onPlanSwitchChange
	        });
	
	        var justUiToggle = this.renderField('just_ui', {
	            'data-format': 'inputcheckbox',
	            'value': this.state.justUi,
	            'onChange': self.onPlanSwitchChange
	        });
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'm-settings--cancel--plan-switch-container' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-settings--cancel--api-option' },
	                justApiToggle,
	                _react2['default'].createElement(
	                    'label',
	                    { htmlFor: 'cancel_just_api' },
	                    'Cancel API plan \xA0'
	                ),
	                justUiToggle,
	                _react2['default'].createElement(
	                    'label',
	                    { htmlFor: 'cancel_just_ui' },
	                    'Cancel web plan'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-settings--cancel--error' },
	                error ? _stringsAndConstants.cancelStrings.errors.noSelection : void 0
	            )
	        );
	    },
	    renderYesNoToggle: function renderYesNoToggle(fieldName, sectionLabelName, onChange) {
	
	        var sectionLabel = _react2['default'].createElement(
	            'h2',
	            null,
	            sectionLabelName
	        );
	
	        var yesSelected = false,
	            noSelected = false;
	        if (fieldName === 'support_should_contact' && this.state.supportShouldContact !== null) {
	            yesSelected = this.state.supportShouldContact;
	            noSelected = !yesSelected;
	        } else if (fieldName === 'can_provide_more_info' && this.state.canWeFollowUp !== null) {
	            yesSelected = this.state.canWeFollowUp;
	            noSelected = !yesSelected;
	        }
	
	        var yes = this.renderField(fieldName, {
	            'tabIndex': 2,
	            'data-format': 'selectradio',
	            'onChange': onChange,
	            'name': fieldName,
	            'value': 'yes',
	            'checked': yesSelected
	        });
	        var yesLabel = _react2['default'].createElement(
	            'label',
	            { htmlFor: fieldName },
	            'Yes'
	        );
	        var no = this.renderField(fieldName, {
	            'tabIndex': 2,
	            'data-format': 'selectradio',
	            'onChange': onChange,
	            'name': fieldName,
	            'value': 'no',
	            'checked': noSelected
	        });
	        var noLabel = _react2['default'].createElement(
	            'label',
	            { htmlFor: fieldName },
	            'No'
	        );
	        return _react2['default'].createElement(
	            'div',
	            { className: 'm-settings--cancel--toggle-container' },
	            sectionLabel,
	            yes,
	            yesLabel,
	            no,
	            noLabel
	        );
	    },
	    renderReasonForCancelList: function renderReasonForCancelList() {
	        return this.renderReasonsList('cancel_reason', _stringsAndConstants.cancelStrings.cancelReasons);
	    },
	    renderCompetitorReasonList: function renderCompetitorReasonList() {
	        return this.renderReasonsList('competitor_reason', _stringsAndConstants.cancelStrings.competitorReasons);
	    },
	    renderReasonsList: function renderReasonsList(namePrefix, namesToReasonLabelMap) {
	        var self = this;
	        var regex = new RegExp(namePrefix);
	        var reasons = this.props.fields.filter(function (field) {
	            return field.name && field.name.match(regex);
	        });
	
	        var list = [];
	        reasons.forEach(function (reason, index) {
	            var component;
	            switch (reason.type) {
	
	                case 'inputcheckbox':
	                    var field = self.renderField(reason.name, {
	                        'tabIndex': 2,
	                        'data-format': 'inputcheckbox',
	                        'onChange': self.onReasonListChange,
	                        'name': reason.name,
	                        'key': reason.name
	                    });
	                    var label = _react2['default'].createElement(
	                        'label',
	                        {
	                            htmlFor: reason.name },
	                        namesToReasonLabelMap[reason.name]
	                    );
	                    component = _react2['default'].createElement(
	                        'li',
	                        { key: index, className: 'm-settings--cancel--reason-list--item' },
	                        field,
	                        label
	                    );
	                    break;
	
	                case 'textarea':
	                    if (self.state.showFields.hasOwnProperty(reason.name) && !self.state.showFields[reason.name]) {
	                        component = void 0;
	                    } else {
	                        var field = self.renderField(reason.name, {
	                            'tabIndex': 2,
	                            'data-format': 'textarea',
	                            'onChange': self.onReasonListChange,
	                            'name': reason.name,
	                            'key': reason.name,
	                            'placeholder': _stringsAndConstants.cancelStrings.placeholders[reason.name]
	                        });
	                        component = _react2['default'].createElement(
	                            'li',
	                            { key: index },
	                            field
	                        );
	                    }
	                    break;
	
	                default:
	                    component = _react2['default'].createElement('li', { key: index });
	
	            }
	            if (component) {
	                list.push(component);
	            }
	        });
	
	        return _react2['default'].createElement(
	            'ul',
	            { className: 'm-settings--cancel--reason-list' },
	            list
	        );
	    },
	    renderTeamAdminWarning: function renderTeamAdminWarning() {
	        return _react2['default'].createElement(
	            'span',
	            null,
	            _react2['default'].createElement('br', null),
	            _stringsAndConstants.cancelStrings.teamAdminWarning
	        );
	    },
	    renderCompetitorAutocomplete: function renderCompetitorAutocomplete() {
	        var _this = this;
	
	        var matches = this.state.competitorAutocompleteMatches;
	        if (this.state.shouldShowCompetitorAutocomplete) {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'm-settings--cancel--competitor-autocomplete' },
	                _react2['default'].createElement(
	                    'ul',
	                    null,
	                    matches.map(function (match) {
	                        return _react2['default'].createElement(
	                            'li',
	                            { className: 'm-settings--cancel--competitor-autocomplete--item',
	                                onClick: _this.onCompetitorAutocompleteItemClick },
	                            match
	                        );
	                    })
	                )
	            );
	        }
	    },
	
	
	    /**
	    * Main render
	    */
	
	    render: function render() {
	
	        var tabOffset = parseInt(this.props.tabOffset || 0, 10);
	        var siteCode = this.props.isHf ? _hfReactHelper2['default'].HfSites.SITE_CODE_HF : _hfReactHelper2['default'].HfSites.SITE_CODE_HS;
	
	        var reminderList = this.props.isHf ? void 0 : _react2['default'].createElement(
	            'div',
	            { className: 'm-settings--cancel--reminder' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-settings--cancel--reminder--title' },
	                'FREE ACCOUNTS DON\'T INCLUDE'
	            ),
	            _react2['default'].createElement(
	                'ul',
	                null,
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Unlimited documents'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Templates'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'In-person signing'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Two-factor Authentication'
	                ),
	                this.props.hasHipaa ? _react2['default'].createElement(
	                    'li',
	                    null,
	                    'HIPAA compliance'
	                ) : void 0
	            )
	        );
	
	        var supportShouldContactToggle = this.renderYesNoToggle('support_should_contact', 'Do you need a Support Representative to follow up with you?', this.onSupportShouldContactChange);
	
	        var supportMessageTextArea = this.renderField('support_message', {
	            'tabIndex': tabOffset + 1,
	            'placeholder': 'Please briefly describe the issue',
	            'data-format': 'textarea',
	            'onChange': this.onSupportMessageChange
	        });
	
	        var supportError = !this.state.supportShouldContactFilled && this.state.hasAttemptedSubmit ? _stringsAndConstants.cancelStrings.errors.noSelection : void 0;
	        var supportMessageError = !this.validateSupportMessage() && this.state.hasAttemptedSubmit ? _stringsAndConstants.cancelStrings.errors.messageTooShort : void 0;
	
	        var customerSupportInfo = _react2['default'].createElement(
	            'div',
	            { className: 'm-settings--cancel--support' },
	            supportShouldContactToggle,
	            this.state.supportShouldContact ? supportMessageTextArea : void 0,
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-settings--cancel--error' },
	                supportError,
	                supportMessageError
	            )
	        );
	
	        var canWeFollowUpToggle = this.renderYesNoToggle('can_provide_more_info', 'Would you be willing to provide more information about your experience if needed?', this.onCanWeFollowUpChange);
	
	        var competitorNameField = this.renderField('competitor_name', {
	            'tabIndex': tabOffset + 1,
	            'placeholder': 'Please enter the name of the company you\'ve chosen',
	            'data-format': 'input',
	            'onChange': this.onCompetitorNameChange,
	            'value': this.state.competitorName
	        });
	
	        var competitorAutocomplete = this.renderCompetitorAutocomplete();
	
	        var competitorReasons = this.state.shouldShowCompetitorReasons ? _react2['default'].createElement(
	            'div',
	            { className: 'm-settings--cancel--reason-container' },
	            _react2['default'].createElement(
	                'h2',
	                null,
	                'Please indicate your reasons for choosing them :'
	            ),
	            _react2['default'].createElement(
	                'h4',
	                null,
	                'Please select all that apply.'
	            ),
	            this.renderCompetitorReasonList()
	        ) : void 0;
	
	        var competitorInfo = this.state.cancelForCompetitor ? _react2['default'].createElement(
	            'div',
	            { className: 'm-settings--cancel--competitor-info' },
	            competitorNameField,
	            competitorAutocomplete,
	            competitorReasons
	        ) : void 0;
	
	        var reasonsError = !this.state.atLeastOneReasonChecked && this.state.hasAttemptedSubmit ? _stringsAndConstants.cancelStrings.errors.noSelection : void 0;
	
	        var cancellationAndCompetitorReasons = _react2['default'].createElement(
	            'div',
	            { className: 'm-settings--cancel--reason-container' },
	            _react2['default'].createElement(
	                'h2',
	                null,
	                'Why are you canceling your service with us?'
	            ),
	            _react2['default'].createElement(
	                'h4',
	                null,
	                'Please select all that apply.'
	            ),
	            this.renderReasonForCancelList(),
	            competitorInfo,
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-settings--cancel--error' },
	                reasonsError
	            )
	        );
	
	        var customerComments = _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	                'h2',
	                null,
	                'Anything else you\'d like to tell us?'
	            ),
	            this.renderField('customer_comments', {
	                'tabIndex': tabOffset + 1,
	                'placeholder': 'Thank you so much for taking the time to provide us with feedback.',
	                'data-format': 'textarea'
	            })
	        );
	
	        var cancelLegalWarning = _react2['default'].createElement(
	            'p',
	            { className: 'm-settings--cancel--warning' },
	            this.renderCancelWarning(),
	            this.props.isTeamAdmin ? this.renderTeamAdminWarning() : void 0
	        );
	
	        var cancelButtonText = this.props.showCustomerCancelOffer ? 'Continue' : 'Cancel my subscription';
	        var ctaButtons = _react2['default'].createElement(
	            'div',
	            { className: 'm-settings--cancel--actions' },
	            _react2['default'].createElement(
	                'div',
	                { id: 'cancelSubscriptionButton' },
	                _react2['default'].createElement(_button2['default'], {
	                    buttonText: cancelButtonText,
	                    buttonLink: '#',
	                    buttonColor: 'grasshopper',
	                    buttonClass: 'border-1-grasshopper',
	                    buttonTextColor: 'white',
	                    buttonHoverTextColor: 'white',
	                    buttonHoverColor: 'castle-rock',
	                    buttonHoverBorderColor: 'castle-rock',
	                    type: 'submit',
	                    onClick: this.onSubmit })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { id: 'nevermindButton' },
	                _react2['default'].createElement(_button2['default'], {
	                    buttonText: 'Never mind',
	                    buttonLink: _hfReactHelper2['default'].urlHelper('home/myAccount?current_tab=billing', siteCode),
	                    buttonColor: 'white',
	                    buttonClass: 'border-1-grasshopper',
	                    buttonTextColor: 'grasshopper',
	                    buttonHoverTextColor: 'white',
	                    buttonHoverColor: 'grasshopper' })
	            )
	        );
	
	        return _react2['default'].createElement(
	            'form',
	            { id: 'cancel_form', name: 'cancel_form', className: 'account-form', method: 'POST' },
	            this.renderHiddenFields(),
	            _react2['default'].createElement(
	                'h1',
	                null,
	                'Are you sure you want to cancel?'
	            ),
	            _react2['default'].createElement(
	                'h3',
	                { className: 'm-cancel--subtitle' },
	                'Canceling your paid account will downgrade your service to a Free account.'
	            ),
	            reminderList,
	            _react2['default'].createElement('div', { className: 'm-settings--cancel--hr' }),
	            _react2['default'].createElement(
	                'h3',
	                null,
	                'If you do decide to cancel, we would really appreciate learning about your experience using HelloSign.'
	            ),
	            customerSupportInfo,
	            cancellationAndCompetitorReasons,
	            canWeFollowUpToggle,
	            customerComments,
	            cancelLegalWarning,
	            this.props.hasBothApiAndUiPlans ? this.renderPlanSwitch() : void 0,
	            _react2['default'].createElement('input', { type: 'hidden', name: 'redirect_url', value: this.props.redirectUrl ? this.props.redirectUrl : '' }),
	            this.renderErrorText(),
	            ctaButtons
	        );
	    }
	});
	
	module.exports = CancelSubscriptionForm;

/***/ },
/* 1033 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	// These should eventually be put in a React.Intl translations file,
	// when we have frontend app support
	var cancelStrings = exports.cancelStrings = {
	    legalText: {
	        HS: {
	            'head': 'By canceling, you will retain access to business features through the remainder of the period already paid. When this expires, you will lose access to these features. You will not receive a free trial if you choose to sign up for a new subscription. View our ',
	            'link': 'Terms of Service',
	            'tail': ' for more details. Also, we\'ll have to stop providing our employees with free cookies.'
	        },
	        HF: {
	            'head': 'By canceling, you will retain access to your paid features for the remainder of the period already paid. When this expires, you will lose your fax number(s), the ability to receive faxes, and your monthly allotment of fax pages. You will not receive a free trial if you choose to sign up for a new subscription. View our ',
	            'link': 'Terms of Service',
	            'tail': 'for more details. Also, we\'ll have to stop providing our employees with free cookies.'
	        }
	    },
	    cancelReasons: {
	        'cancel_reason_no_use': 'Not using this service frequently',
	        'cancel_reason_ux': 'Service was hard to use',
	        'cancel_reason_customer_service': 'Unhappy with the customer service I received',
	        'cancel_reason_cost': 'The cost of this service',
	        'cancel_reason_features': 'The service did not have the features I need',
	        'cancel_reason_competitor': 'I started using a different service'
	    },
	    competitorReasons: {
	        'competitor_reason_ux': 'Their tool was easier to use',
	        'competitor_reason_customer_service': 'Better customer service',
	        'competitor_reason_features': 'More features',
	        'competitor_reason_cost': 'Better price',
	        'competitor_reason_quality': 'Better quality'
	    },
	    placeholders: {
	        'cancel_reason_features-detail': 'What was missing?'
	    },
	    teamAdminWarning: 'Canceling your subscription will also disband your team and shared access to documents will be revoked.',
	    errors: {
	        'noSelection': 'Please select at least one option',
	        'messageTooShort': 'Please enter a brief message for support'
	    }
	};
	
	var cancelConstants = exports.cancelConstants = {
	    competitorList: ['17 Hats', 'Adobe EchoSign', 'AssureSign', 'Cudasign', 'DocuSign', 'DotLoop', 'eSignLive', 'Legalesign', 'Other', 'PandaDoc', 'RightSignature', 'Sertifi', 'Silanis'],
	    AUTOCOMPLETE_MIN_THRESHOLD: 2,
	    SUPPORT_MESSAGE_MIN_THRESHOLD: 3
	};

/***/ },
/* 1034 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1035 */,
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(1037);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cancelOfferPlanDescription = __webpack_require__(1039);
	
	var _cancelOfferPlanDescription2 = _interopRequireDefault(_cancelOfferPlanDescription);
	
	var _cancelOfferPricingLevel = __webpack_require__(1041);
	
	var _cancelOfferPricingLevel2 = _interopRequireDefault(_cancelOfferPricingLevel);
	
	var _logger = __webpack_require__(482);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CustomerCancelOffer = function (_Component) {
	    _inherits(CustomerCancelOffer, _Component);
	
	    function CustomerCancelOffer() {
	        _classCallCheck(this, CustomerCancelOffer);
	
	        return _possibleConstructorReturn(this, (CustomerCancelOffer.__proto__ || Object.getPrototypeOf(CustomerCancelOffer)).apply(this, arguments));
	    }
	
	    _createClass(CustomerCancelOffer, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            _logger2['default'].track('CustomerCancelOffer.load');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            var headerText = _react2['default'].createElement(
	                'div',
	                { className: 'm-customer-cancel-offer--header-text text-center' },
	                _react2['default'].createElement(
	                    'h1',
	                    null,
	                    'Wait. Before you leave...'
	                ),
	                _react2['default'].createElement(
	                    'h2',
	                    { className: 'subheader-text' },
	                    'Canceling your account will prevent you from accessing some of our greatest features'
	                )
	            );
	
	            var mainContent = _react2['default'].createElement(
	                'div',
	                { className: 'm-customer-cancel-offer--main-content' },
	                _react2['default'].createElement(_cancelOfferPlanDescription2['default'], this.props),
	                _react2['default'].createElement(_cancelOfferPricingLevel2['default'], this.props)
	            );
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'm-customer-cancel-offer' },
	                headerText,
	                mainContent
	            );
	        }
	    }]);
	
	    return CustomerCancelOffer;
	}(_react.Component);
	
	module.exports = CustomerCancelOffer;

/***/ },
/* 1037 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1038 */,
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports['default'] = CancelOfferPlanDescription;
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _kite = __webpack_require__(1040);
	
	var _kite2 = _interopRequireDefault(_kite);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function CancelOfferPlanDescription(p) {
	
	    var planName = p.currentPlanInfo.name;
	    var calloutText = 'If you downgrade, you\'ll miss out on these great ' + planName + ' features:';
	
	    var callout = _react2['default'].createElement(
	        'div',
	        { className: 'm-cancel-offer-plan-description--callout' },
	        calloutText
	    );
	
	    var planFeatures = p.offerPlanInfo.features;
	    var features = _react2['default'].createElement(
	        'ul',
	        null,
	        planFeatures.map(function (feat, index) {
	            return _react2['default'].createElement(
	                'li',
	                { key: 'feature-' + index },
	                feat
	            );
	        })
	    );
	
	    var readMoreLink = _react2['default'].createElement(
	        'a',
	        { href: '/info/tour' },
	        'Read more about our features.'
	    );
	
	    var imageStyle = { marginTop: -5, marginLeft: -15 };
	    var kiteImage = _react2['default'].createElement('img', { src: _kite2['default'], style: imageStyle });
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'm-cancel-offer-plan-description' },
	        callout,
	        features,
	        readMoreLink,
	        kiteImage
	    );
	}

/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/e26648bb750595e0939694aa649f4141.svg";

/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports['default'] = CancelOfferPricingLevel;
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function CancelOfferPricingLevel(p) {
	
	    var stayWithUsText = _react2['default'].createElement(
	        'p',
	        null,
	        'Stay with us and enjoy an exclusive annual discount:'
	    );
	
	    var previousPrice = _react2['default'].createElement(
	        'div',
	        { className: 'previous-price' },
	        _react2['default'].createElement(
	            'span',
	            { className: 'dollar' },
	            '$'
	        ),
	        _react2['default'].createElement(
	            'span',
	            { className: 'price' },
	            p.offerPlanInfo.originalPrice
	        )
	    );
	
	    var largePrice = _react2['default'].createElement(
	        'div',
	        { className: 'large-price' },
	        _react2['default'].createElement(
	            'span',
	            { className: 'dollar' },
	            '$'
	        ),
	        _react2['default'].createElement(
	            'span',
	            { className: 'price' },
	            p.offerPlanInfo.discountedPrice
	        )
	    );
	
	    var selectOfferButton = _react2['default'].createElement(_button2['default'], {
	        buttonText: 'Select Offer',
	        buttonColor: 'cerulean',
	        buttonClass: 'select-offer-button',
	        buttonLink: '/account/acceptCustomerCancelOffer'
	    });
	
	    var or = _react2['default'].createElement(
	        'div',
	        { className: 'round-or' },
	        'OR'
	    );
	
	    var continueToCancelButton = _react2['default'].createElement(_button2['default'], {
	        buttonText: 'No thank you, cancel my plan',
	        buttonColor: 'plume',
	        buttonBorderColor: 'cerulean',
	        buttonTextColor: 'cerulean',
	        buttonClass: 'continue-to-cancel-button',
	        buttonLink: '/account/declineCustomerCancelOffer'
	    });
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'm-cancel-offer-pricing-level text-center' },
	        _react2['default'].createElement(
	            'div',
	            { className: 'm-cancel-offer-pricing-level--offer' },
	            stayWithUsText,
	            previousPrice,
	            largePrice,
	            selectOfferButton,
	            or,
	            continueToCancelButton
	        )
	    );
	}

/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(1043);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _apiIconWhite2x = __webpack_require__(1045);
	
	var _apiIconWhite2x2 = _interopRequireDefault(_apiIconWhite2x);
	
	var _eventbrite_logo = __webpack_require__(1046);
	
	var _eventbrite_logo2 = _interopRequireDefault(_eventbrite_logo);
	
	var _number_ = __webpack_require__(1047);
	
	var _number_2 = _interopRequireDefault(_number_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ANIMATION_INTERVAL = 7000;
	var ANIMATION_FADEOUT_SPEED = 320;
	var ANIMATE_IN = 'animate-in';
	var ANIMATE_OUT = 'animate-out';
	var ANNOUNCEMENTS = [G2CrowdMediumBar, G2CrowdSmallBar, EventbriteBar, APIBar];
	
	var baseButtonProps = {
	    buttonText: 'Learn more',
	    buttonColor: 'white',
	    buttonHoverColor: 'grasshopper',
	    buttonTextColor: 'black',
	    buttonHoverTextColor: 'white'
	};
	
	function G2CrowdMediumBar(props) {
	    var animation = props.animation;
	
	    var buttonProps = Object.assign({}, baseButtonProps, { buttonLink: 'http://blog.hellosign.com/hellosign-number-one-esignature-solution-for-SMBs-and-mid-market-businesses' });
	    return _react2['default'].createElement(
	        'div',
	        { className: 'm-home-api--inner row ' + animation },
	        _react2['default'].createElement(
	            'span',
	            { className: 'm-home-api--icon' },
	            _react2['default'].createElement('img', { src: _number_2['default'] })
	        ),
	        _react2['default'].createElement(
	            'span',
	            { className: 'm-home-api--text' },
	            'Voted #1 Software Product for Mid-Market Businesses'
	        ),
	        _react2['default'].createElement(
	            'span',
	            { className: 'm-home-api--cta' },
	            _react2['default'].createElement(_button2['default'], buttonProps)
	        )
	    );
	}
	
	function G2CrowdSmallBar(props) {
	    var animation = props.animation;
	
	    var buttonProps = Object.assign({}, baseButtonProps, { buttonLink: 'http://blog.hellosign.com/hellosign-ranked-top-esignature-solution-by-g2-crowd' });
	    return _react2['default'].createElement(
	        'div',
	        { className: 'm-home-api--inner row ' + animation },
	        _react2['default'].createElement(
	            'span',
	            { className: 'm-home-api--icon' },
	            _react2['default'].createElement('img', { src: _number_2['default'] })
	        ),
	        _react2['default'].createElement(
	            'span',
	            { className: 'm-home-api--text' },
	            'HelloSign Ranked #1 eSignature Solution for Small Businesses.'
	        ),
	        _react2['default'].createElement(
	            'span',
	            { className: 'm-home-api--cta' },
	            _react2['default'].createElement(_button2['default'], buttonProps)
	        )
	    );
	}
	
	function EventbriteBar(props) {
	    var animation = props.animation;
	
	    var buttonProps = Object.assign({}, baseButtonProps, { buttonLink: 'https://www.hellosign.com/eventbrite' });
	    return _react2['default'].createElement(
	        'div',
	        { className: 'm-home-api--inner row ' + animation },
	        _react2['default'].createElement(
	            'span',
	            { className: 'm-home-api--icon', style: { width: 125 } },
	            _react2['default'].createElement('img', { src: _eventbrite_logo2['default'], style: { minWidth: 125 } })
	        ),
	        _react2['default'].createElement(
	            'span',
	            { className: 'm-home-api--text' },
	            'We\'ve integrated with Eventbrite to simplify waivers and forms for event organizers.'
	        ),
	        _react2['default'].createElement(
	            'span',
	            { className: 'm-home-api--cta' },
	            _react2['default'].createElement(_button2['default'], buttonProps)
	        )
	    );
	}
	
	function APIBar(props) {
	    var animation = props.animation;
	
	    var buttonProps = Object.assign({}, baseButtonProps, { buttonLink: '/info/api' });
	    return _react2['default'].createElement(
	        'div',
	        { className: 'm-home-api--inner row ' + animation },
	        _react2['default'].createElement(
	            'span',
	            { className: 'm-home-api--icon' },
	            _react2['default'].createElement('img', { src: _apiIconWhite2x2['default'] })
	        ),
	        _react2['default'].createElement(
	            'span',
	            { className: 'm-home-api--text' },
	            'Integrate eSignatures into your website with our API.'
	        ),
	        _react2['default'].createElement(
	            'span',
	            { className: 'm-home-api--cta' },
	            _react2['default'].createElement(_button2['default'], buttonProps)
	        )
	    );
	}
	
	var BlackBarAnnouncements = function (_React$Component) {
	    _inherits(BlackBarAnnouncements, _React$Component);
	
	    function BlackBarAnnouncements(props) {
	        _classCallCheck(this, BlackBarAnnouncements);
	
	        var _this = _possibleConstructorReturn(this, (BlackBarAnnouncements.__proto__ || Object.getPrototypeOf(BlackBarAnnouncements)).call(this, props));
	
	        _this.clearInterval = _this.clearInterval.bind(_this);
	        _this.initiateAnimations = _this.initiateAnimations.bind(_this);
	        _this.animate = _this.animate.bind(_this);
	        _this.incrementIndex = _this.incrementIndex.bind(_this);
	        _this.state = {
	            currentComponentIndex: _this.props.initialComponentIndex || 0,
	            currentAnimation: _this.props.shouldAnimate ? ANIMATE_IN : null,
	            timerId: null
	        };
	        return _this;
	    }
	
	    _createClass(BlackBarAnnouncements, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.props.shouldAnimate) this.initiateAnimations();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.clearInterval();
	        }
	    }, {
	        key: 'initiateAnimations',
	        value: function initiateAnimations() {
	            var _this2 = this;
	
	            var interval = setInterval(function () {
	                return _this2.animate();
	            }, ANIMATION_INTERVAL);
	            this.setState({ timerId: interval });
	        }
	    }, {
	        key: 'clearInterval',
	        value: function clearInterval() {
	            var timerId = this.state.timerId;
	
	            if (timerId) clearTimeout(timerId);
	            this.setState({ timerId: null });
	        }
	    }, {
	        key: 'animate',
	        value: function animate() {
	            var _this3 = this;
	
	            this.setState({ currentAnimation: ANIMATE_OUT });
	            setTimeout(function () {
	                return _this3.incrementIndex();
	            }, ANIMATION_FADEOUT_SPEED);
	        }
	    }, {
	        key: 'incrementIndex',
	        value: function incrementIndex() {
	            var currentComponentIndex = this.state.currentComponentIndex;
	
	            var nextComponentIndex = (currentComponentIndex + 1) % ANNOUNCEMENTS.length;
	            this.setState({
	                currentComponentIndex: nextComponentIndex,
	                currentAnimation: ANIMATE_IN
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state = this.state,
	                currentComponentIndex = _state.currentComponentIndex,
	                currentAnimation = _state.currentAnimation;
	
	            var CurrentAnnouncement = ANNOUNCEMENTS[currentComponentIndex];
	            return _react2['default'].createElement(CurrentAnnouncement, { animation: currentAnimation });
	        }
	    }]);
	
	    return BlackBarAnnouncements;
	}(_react2['default'].Component);
	
	module.exports = BlackBarAnnouncements;

/***/ },
/* 1043 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1044 */,
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/a5b6bc54c22578f33f59929472bb6ab0.png";

/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/a5f56ace114b026f33460b447155136c.png";

/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/ec1da482c0dc92d6c61757ed6584426d.svg";

/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pricingLevels = __webpack_require__(1049);
	
	var _pricingLevels2 = _interopRequireDefault(_pricingLevels);
	
	var _couponDisplay = __webpack_require__(1085);
	
	var _couponDisplay2 = _interopRequireDefault(_couponDisplay);
	
	var _toggle = __webpack_require__(1086);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PricingArea = function (_React$Component) {
	    _inherits(PricingArea, _React$Component);
	
	    function PricingArea(props) {
	        _classCallCheck(this, PricingArea);
	
	        var _this = _possibleConstructorReturn(this, (PricingArea.__proto__ || Object.getPrototypeOf(PricingArea)).call(this, props));
	
	        _initialiseProps.call(_this);
	
	        var _this$props = _this.props,
	            selectedTimePeriod = _this$props.selectedTimePeriod,
	            timePeriodChoices = _this$props.timePeriodChoices;
	
	        _this.state = {
	            'timePeriod': selectedTimePeriod || timePeriodChoices[1].value
	        };
	        return _this;
	    }
	
	    _createClass(PricingArea, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.props.mustContactSales) $('#contactUsButton').click();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'row' },
	                    this.hasValidCoupon() ? this.couponDisplay() : null,
	                    this.shouldDisplayToggle() ? this.toggleButton() : null
	                ),
	                this.errorMessage(),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'row levels l-padding-v-60 text-center', style: { paddingTop: 0 } },
	                    _react2['default'].createElement(_pricingLevels2['default'], _extends({ isMonthly: this.isMonthly(),
	                        hasValidCoupon: this.hasValidCoupon(),
	                        billingPlans: this.billingPlans()
	                    }, this.props, this.state))
	                )
	            );
	        }
	    }]);
	
	    return PricingArea;
	}(_react2['default'].Component);
	
	PricingArea.propTypes = {
	    'signupUrl': _react.PropTypes.string,
	    'pricingSource': _react.PropTypes.string,
	    'paymentForm': _react.PropTypes.object.isRequired, // Serialized sfForm
	    'signupForm': _react.PropTypes.object.isRequired, // Serialized sfForm
	    'mustContactSales': _react.PropTypes.bool,
	    'corpsLevelName': _react.PropTypes.string
	};
	
	var _initialiseProps = function _initialiseProps() {
	    var _this2 = this;
	
	    this.onSelection = function (selection) {
	        return _this2.setState({ 'timePeriod': selection });
	    };
	
	    this.isAnnual = function () {
	        return _this2.state.timePeriod == 'Y';
	    };
	
	    this.isMonthly = function () {
	        return _this2.state.timePeriod == 'M';
	    };
	
	    this.isEventbrite = function () {
	        return _this2.props.pricingSource === 'eventbrite';
	    };
	
	    this.billingPlans = function () {
	        return _this2.props.pricingData.billing_plans;
	    };
	
	    this.pricingLevelCount = function () {
	        return _this2.billingPlans().length;
	    };
	
	    this.shouldDisplayToggle = function () {
	        return _this2.props.timePeriodChoices.length > 1;
	    };
	
	    this.hasValidCoupon = function () {
	        var isAnnual = _this2.isAnnual();
	        var isMonthly = _this2.isMonthly();
	        var coupon = _this2.props.coupon;
	
	        if (coupon) {
	            var monthly_rate = coupon.monthly_rate,
	                annual_rate = coupon.annual_rate;
	
	            var invalidMonthlyRate = isMonthly && monthly_rate == 0;
	            var invalidAnnualRate = isAnnual && annual_rate == 0;
	            var invalidCouponCode = !coupon.coupon_code;
	            if (invalidMonthlyRate || invalidAnnualRate || invalidCouponCode) return false;
	        }
	        return !!coupon;
	    };
	
	    this.couponDisplay = function () {
	        var coupon = _this2.props.coupon;
	
	        return _react2['default'].createElement(_couponDisplay2['default'], { couponCode: coupon.coupon_code, couponDescription: coupon.description });
	    };
	
	    this.toggleButton = function () {
	        var _props = _this2.props,
	            timePeriodChoices = _props.timePeriodChoices,
	            selectedTimePeriod = _props.selectedTimePeriod;
	
	
	        return _react2['default'].createElement(_toggle.Toggle, { choices: timePeriodChoices,
	            initialSelection: selectedTimePeriod,
	            onSelection: _this2.onSelection,
	            isEventbrite: _this2.isEventbrite()
	        });
	    };
	
	    this.errorMessage = function () {
	        var errors;
	        if (_this2.props.errors) {
	            var errorMsg = 'Sorry, we could not process your payment.';
	            if (_this2.props.errors['payment[submit]']) {
	                errorMsg += ' ' + _this2.props.errors['payment[submit]'];
	            }
	            if (_this2.props.errors['payment[cc_number]']) {
	                errorMsg += ' ' + _this2.props.errors['payment[cc_number]'];
	            }
	            if (_this2.props.errors['payment[0]']) {
	                errorMsg += ' ' + _this2.props.errors['payment[0]'];
	            }
	            errors = _react2['default'].createElement(
	                'div',
	                { 'data-test-id': 'errors', className: 'row text-center l-padding-v-20' },
	                _react2['default'].createElement(
	                    'p',
	                    { className: 'c-red' },
	                    errorMsg
	                )
	            );
	        }
	        return errors;
	    };
	};
	
	module.exports = PricingArea;

/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(1050);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(1052);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _pricingLevel = __webpack_require__(1061);
	
	var _pricingLevel2 = _interopRequireDefault(_pricingLevel);
	
	var _corporatePricingLevel = __webpack_require__(1066);
	
	var _corporatePricingLevel2 = _interopRequireDefault(_corporatePricingLevel);
	
	var _arrow = __webpack_require__(1081);
	
	var _arrow2 = _interopRequireDefault(_arrow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PricingLevels = function (_React$Component) {
	    _inherits(PricingLevels, _React$Component);
	
	    function PricingLevels(props) {
	        _classCallCheck(this, PricingLevels);
	
	        var _this = _possibleConstructorReturn(this, (PricingLevels.__proto__ || Object.getPrototypeOf(PricingLevels)).call(this, props));
	
	        _this.shouldBeCarousel = function () {
	            return _this.props.billingPlans.length;
	        };
	
	        _this.shouldRenderLevel = function (level) {
	            return level && level.name && level.is_displayed == 'true';
	        };
	
	        _this.validBillingPlans = function () {
	            return _this.props.billingPlans.filter(_this.shouldRenderLevel);
	        };
	
	        _this.rows = function () {
	            return _this.validBillingPlans().map(pricingLevel.bind(_this, _this.props)).reduce(function (previousValue, currentValue) {
	                var lastRow = previousValue[previousValue.length - 1];
	                if (lastRow && lastRow.length < 3) {
	                    lastRow.push(currentValue);
	                    previousValue[previousValue.lenth - 1] = lastRow;
	                    return previousValue;
	                } else {
	                    previousValue.push([currentValue]);
	                    return previousValue;
	                }
	            }, []).map(function (row, index) {
	                return _react2['default'].createElement(
	                    'div',
	                    { className: 'row', key: index },
	                    row
	                );
	            });
	        };
	
	        _this.handleClick = function () {
	            var nextIndex = (_this.state.currentRowIndex + 1) % _this.rows().length;
	            _this.setState({ currentRowIndex: nextIndex });
	        };
	
	        _this.shouldRenderArrow = function () {
	            return _this.rows().length > 1;
	        };
	
	        _this.state = {
	            currentRowIndex: 0
	        };
	        return _this;
	    }
	
	    _createClass(PricingLevels, [{
	        key: 'render',
	        value: function render() {
	            var currentRow = this.rows()[this.state.currentRowIndex];
	            var animationDirection = this.state.currentRowIndex === 1 ? 'left' : 'right';
	            var arrow = _react2['default'].createElement(_arrow2['default'], { handleClick: this.handleClick, direction: animationDirection });
	            var totalColumns = this.props.billingPlans.length;
	            var className = (0, _classnames2['default'])(_defineProperty({
	                'm-pricing-level': true,
	                'large-9': totalColumns >= 3,
	                'large-8': totalColumns == 2,
	                'large-6': totalColumns == 1,
	                'columns': true
	            }, 'pricing-animation-' + animationDirection, true));
	            var wrapperStyle = {
	                overflow: 'hidden',
	                position: 'relative',
	                paddingTop: 60
	            };
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    'div',
	                    { className: className, style: wrapperStyle },
	                    _react2['default'].createElement(
	                        _reactAddonsCssTransitionGroup2['default'],
	                        { transitionName: 'pricing-row',
	                            transitionEnterTimeout: 240,
	                            transitionLeaveTimeout: 240 },
	                        currentRow
	                    )
	                ),
	                this.shouldRenderArrow() ? arrow : null,
	                corporatePricingLevel(this.props)
	            );
	        }
	    }]);
	
	    return PricingLevels;
	}(_react2['default'].Component);
	
	PricingLevels.propTypes = {
	    billingPlans: _react.PropTypes.array.isRequired
	};
	
	
	function pricingLevel(props, level, i) {
	    // TODO:  Refactor PricingLevel so all you need to is pass "level" to
	    // "PricingLevel" and let "PricingLevel" figure out all these props. In
	    // other words, don't tell "PricingLevel" what it needs. "PricingLevel"
	    // should be the one that know's what it needs. (FR)
	    return _react2['default'].createElement(_pricingLevel2['default'], { key: i,
	        isEventbrite: props.pricingSource === 'eventbrite',
	        totalColumns: props.billingPlans.length,
	        signupUrl: props.signupUrl,
	        cardHolderName: props.cardHolderName,
	        errors: props.errors,
	        paymentForm: props.paymentForm,
	        signupForm: props.signupForm,
	        mustContactSales: props.mustContactSales,
	        isAdmin: props.isAdmin,
	        isDelinquent: props.isDelinquent,
	        timePeriod: props.timePeriod,
	        name: level.name,
	        isApi: level.is_api,
	        isUpgrade: level.is_upgrade,
	        mainFeature: level.main_feature,
	        features: level.features,
	        monthlyPrice: level.monthly_price,
	        annualPrice: (level.annual_price / 12).toFixed(0),
	        monthlyCouponPrice: level.coupon_monthly_price && level.coupon_monthly_price.toFixed(0),
	        annualCouponPrice: level.coupon_annual_price && (level.coupon_annual_price / 12).toFixed(0),
	        price: props.isMonthly ? level.monthly_price : (level.annual_price / 12).toFixed(0),
	        couponPrice: props.isMonthly ? level.coupon_monthly_price && level.coupon_monthly_price.toFixed(0) : level.coupon_annual_price && (level.coupon_annual_price / 12).toFixed(0),
	        monthlyExpectedRate: level.monthly_expected_rate,
	        annualExpectedRate: level.annual_expected_rate,
	        monthlyProratedRate: level.monthly_prorated_rate,
	        annualProratedRate: level.annual_prorated_rate,
	        maxSeats: level.max_seats,
	        mostPopular: level.is_api && i == 1,
	        coupon: props.hasValidCoupon,
	        couponCode: props.hasValidCoupon ? level.coupon_code : null,
	        isFreeTrialEligible: level.is_free_trial_eligible,
	        numFreeDays: level.num_free_days,
	        isTrialing: level.is_trialing,
	        proratio: level.proratio,
	        planId: level.plan_id,
	        isDisplayed: level.is_displayed,
	        googleOpenIdUrlAnnual: level.google_open_id_url_annual,
	        googleOpenIdUrlMonthly: level.google_open_id_url_monthly,
	        ccSuffix: level.cc_suffix,
	        ccExpiration: level.cc_expiration,
	        isCurrentPlan: level.current_plan == level.plan_id,
	        ApiPendingCancel: level.api_pending_cancel,
	        UiPendingCancel: level.ui_pending_cancel,
	        currentMonthlyRate: level.current_monthly_rate,
	        currentAnnualRate: level.current_annual_rate,
	        currentPlanName: props.pricingData.current_plan_name,
	        isLoggedIn: level.is_logged_in,
	        acctModalError: level.acct_modal_error,
	        wasSelectedBeforeLogIn: level.is_logged_in && level.was_selected_before_login
	    });
	}
	
	function corporatePricingLevel(props) {
	    return _react2['default'].createElement(_corporatePricingLevel2['default'], { key: 'corporate',
	        isApi: props.isApi,
	        pricingSource: props.pricingSource,
	        coupon: props.coupon,
	        corporateFeatures: props.corporateFeatures,
	        timePeriod: props.timePeriod,
	        totalColumns: props.billingPlans.length,
	        corpLevelName: props.corpLevelName
	    });
	}
	
	module.exports = PricingLevels;

/***/ },
/* 1050 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1051 */,
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1053);

/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(306);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(305);
	
	var ReactTransitionGroup = __webpack_require__(1054);
	var ReactCSSTransitionGroupChild = __webpack_require__(1058);
	
	function createTransitionTimeoutPropValidator(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to ReactCSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	  };
	}
	
	/**
	 * An easy way to perform CSS transitions and animations when a React component
	 * enters or leaves the DOM.
	 * See https://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup
	 */
	
	var ReactCSSTransitionGroup = function (_React$Component) {
	  _inherits(ReactCSSTransitionGroup, _React$Component);
	
	  function ReactCSSTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactCSSTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
	      // We need to provide this childFactory so that
	      // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	      // leave while it is leaving.
	      return React.createElement(ReactCSSTransitionGroupChild, {
	        name: _this.props.transitionName,
	        appear: _this.props.transitionAppear,
	        enter: _this.props.transitionEnter,
	        leave: _this.props.transitionLeave,
	        appearTimeout: _this.props.transitionAppearTimeout,
	        enterTimeout: _this.props.transitionEnterTimeout,
	        leaveTimeout: _this.props.transitionLeaveTimeout
	      }, child);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ReactCSSTransitionGroup.prototype.render = function render() {
	    return React.createElement(ReactTransitionGroup, _assign({}, this.props, { childFactory: this._wrapChild }));
	  };
	
	  return ReactCSSTransitionGroup;
	}(React.Component);
	
	ReactCSSTransitionGroup.displayName = 'ReactCSSTransitionGroup';
	ReactCSSTransitionGroup.propTypes = {
	  transitionName: ReactCSSTransitionGroupChild.propTypes.name,
	
	  transitionAppear: React.PropTypes.bool,
	  transitionEnter: React.PropTypes.bool,
	  transitionLeave: React.PropTypes.bool,
	  transitionAppearTimeout: createTransitionTimeoutPropValidator('Appear'),
	  transitionEnterTimeout: createTransitionTimeoutPropValidator('Enter'),
	  transitionLeaveTimeout: createTransitionTimeoutPropValidator('Leave')
	};
	ReactCSSTransitionGroup.defaultProps = {
	  transitionAppear: false,
	  transitionEnter: true,
	  transitionLeave: true
	};
	
	
	module.exports = ReactCSSTransitionGroup;

/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(306);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(305);
	var ReactAddonsDOMDependencies = __webpack_require__(1055);
	var ReactTransitionChildMapping = __webpack_require__(1056);
	
	var emptyFunction = __webpack_require__(314);
	
	/**
	 * A basis for animations. When children are declaratively added or removed,
	 * special lifecycle hooks are called.
	 * See https://facebook.github.io/react/docs/animation.html#low-level-api-reacttransitiongroup
	 */
	
	var ReactTransitionGroup = function (_React$Component) {
	  _inherits(ReactTransitionGroup, _React$Component);
	
	  function ReactTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      // TODO: can we get useful debug information to show at this point?
	      children: ReactTransitionChildMapping.getChildMapping(_this.props.children)
	    }, _this.performAppear = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.refs[key];
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key));
	      } else {
	        _this._handleDoneAppearing(key);
	      }
	    }, _this._handleDoneAppearing = function (key) {
	      var component = _this.refs[key];
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping;
	      if (false) {
	        currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children, ReactAddonsDOMDependencies.getReactInstanceMap().get(_this)._debugID);
	      } else {
	        currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);
	      }
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key);
	      }
	    }, _this.performEnter = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.refs[key];
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key));
	      } else {
	        _this._handleDoneEntering(key);
	      }
	    }, _this._handleDoneEntering = function (key) {
	      var component = _this.refs[key];
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping;
	      if (false) {
	        currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children, ReactAddonsDOMDependencies.getReactInstanceMap().get(_this)._debugID);
	      } else {
	        currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);
	      }
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key);
	      }
	    }, _this.performLeave = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.refs[key];
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key);
	      }
	    }, _this._handleDoneLeaving = function (key) {
	      var component = _this.refs[key];
	
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping;
	      if (false) {
	        currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children, ReactAddonsDOMDependencies.getReactInstanceMap().get(_this)._debugID);
	      } else {
	        currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);
	      }
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.performEnter(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _assign({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ReactTransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  ReactTransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key);
	      }
	    }
	  };
	
	  ReactTransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping;
	    if (false) {
	      nextChildMapping = ReactTransitionChildMapping.getChildMapping(nextProps.children, ReactAddonsDOMDependencies.getReactInstanceMap().get(this)._debugID);
	    } else {
	      nextChildMapping = ReactTransitionChildMapping.getChildMapping(nextProps.children);
	    }
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: ReactTransitionChildMapping.mergeChildMappings(prevChildMapping, nextChildMapping)
	    });
	
	    var key;
	
	    for (key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
	      if (prevChildMapping[key] && !hasNext && !this.currentlyTransitioningKeys[key]) {
	        this.keysToLeave.push(key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  ReactTransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(this.performEnter);
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(this.performLeave);
	  };
	
	  ReactTransitionGroup.prototype.render = function render() {
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	    for (var key in this.state.children) {
	      var child = this.state.children[key];
	      if (child) {
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(React.cloneElement(this.props.childFactory(child), { ref: key, key: key }));
	      }
	    }
	
	    // Do not forward ReactTransitionGroup props to primitive DOM nodes
	    var props = _assign({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return React.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return ReactTransitionGroup;
	}(React.Component);
	
	ReactTransitionGroup.displayName = 'ReactTransitionGroup';
	ReactTransitionGroup.propTypes = {
	  component: React.PropTypes.any,
	  childFactory: React.PropTypes.func
	};
	ReactTransitionGroup.defaultProps = {
	  component: 'span',
	  childFactory: emptyFunction.thatReturnsArgument
	};
	
	
	module.exports = ReactTransitionGroup;

/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOM = __webpack_require__(529);
	var ReactInstanceMap = __webpack_require__(607);
	
	exports.getReactDOM = function () {
	  return ReactDOM;
	};
	
	exports.getReactInstanceMap = function () {
	  return ReactInstanceMap;
	};
	
	if (false) {
	  var ReactPerf = require('react-dom/lib/ReactPerf');
	  var ReactTestUtils = require('react-dom/lib/ReactTestUtils');
	
	  exports.getReactPerf = function () {
	    return ReactPerf;
	  };
	
	  exports.getReactTestUtils = function () {
	    return ReactTestUtils;
	  };
	}

/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var flattenChildren = __webpack_require__(1057);
	
	var ReactTransitionChildMapping = {
	  /**
	   * Given `this.props.children`, return an object mapping key to child. Just
	   * simple syntactic sugar around flattenChildren().
	   *
	   * @param {*} children `this.props.children`
	   * @param {number=} selfDebugID Optional debugID of the current internal instance.
	   * @return {object} Mapping of key to child
	   */
	  getChildMapping: function (children, selfDebugID) {
	    if (!children) {
	      return children;
	    }
	
	    if (false) {
	      return flattenChildren(children, selfDebugID);
	    }
	
	    return flattenChildren(children);
	  },
	
	  /**
	   * When you're adding or removing children some may be added or removed in the
	   * same render pass. We want to show *both* since we want to simultaneously
	   * animate elements in and out. This function takes a previous set of keys
	   * and a new set of keys and merges them with its best guess of the correct
	   * ordering. In the future we may expose some of the utilities in
	   * ReactMultiChild to make this easy, but for now React itself does not
	   * directly have this concept of the union of prevChildren and nextChildren
	   * so we implement it here.
	   *
	   * @param {object} prev prev children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @param {object} next next children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @return {object} a key set that contains all keys in `prev` and all keys
	   * in `next` in a reasonable order.
	   */
	  mergeChildMappings: function (prev, next) {
	    prev = prev || {};
	    next = next || {};
	
	    function getValueForKey(key) {
	      if (next.hasOwnProperty(key)) {
	        return next[key];
	      } else {
	        return prev[key];
	      }
	    }
	
	    // For each key of `next`, the list of keys to insert before that key in
	    // the combined list
	    var nextKeysPending = {};
	
	    var pendingKeys = [];
	    for (var prevKey in prev) {
	      if (next.hasOwnProperty(prevKey)) {
	        if (pendingKeys.length) {
	          nextKeysPending[prevKey] = pendingKeys;
	          pendingKeys = [];
	        }
	      } else {
	        pendingKeys.push(prevKey);
	      }
	    }
	
	    var i;
	    var childMapping = {};
	    for (var nextKey in next) {
	      if (nextKeysPending.hasOwnProperty(nextKey)) {
	        for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	          var pendingNextKey = nextKeysPending[nextKey][i];
	          childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	        }
	      }
	      childMapping[nextKey] = getValueForKey(nextKey);
	    }
	
	    // Finally, add the keys which didn't appear before any key in `next`
	    for (i = 0; i < pendingKeys.length; i++) {
	      childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	    }
	
	    return childMapping;
	  }
	};
	
	module.exports = ReactTransitionChildMapping;

/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(319);
	var traverseAllChildren = __webpack_require__(317);
	var warning = __webpack_require__(313);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(621);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('./ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(297)))

/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(305);
	var ReactAddonsDOMDependencies = __webpack_require__(1055);
	
	var CSSCore = __webpack_require__(1059);
	var ReactTransitionEvents = __webpack_require__(1060);
	
	var onlyChild = __webpack_require__(330);
	
	var TICK = 17;
	
	var ReactCSSTransitionGroupChild = React.createClass({
	  displayName: 'ReactCSSTransitionGroupChild',
	
	  propTypes: {
	    name: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.shape({
	      enter: React.PropTypes.string,
	      leave: React.PropTypes.string,
	      active: React.PropTypes.string
	    }), React.PropTypes.shape({
	      enter: React.PropTypes.string,
	      enterActive: React.PropTypes.string,
	      leave: React.PropTypes.string,
	      leaveActive: React.PropTypes.string,
	      appear: React.PropTypes.string,
	      appearActive: React.PropTypes.string
	    })]).isRequired,
	
	    // Once we require timeouts to be specified, we can remove the
	    // boolean flags (appear etc.) and just accept a number
	    // or a bool for the timeout flags (appearTimeout etc.)
	    appear: React.PropTypes.bool,
	    enter: React.PropTypes.bool,
	    leave: React.PropTypes.bool,
	    appearTimeout: React.PropTypes.number,
	    enterTimeout: React.PropTypes.number,
	    leaveTimeout: React.PropTypes.number
	  },
	
	  transition: function (animationType, finishCallback, userSpecifiedDelay) {
	    var node = ReactAddonsDOMDependencies.getReactDOM().findDOMNode(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timeout = null;
	
	    var endListener = function (e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timeout);
	
	      CSSCore.removeClass(node, className);
	      CSSCore.removeClass(node, activeClassName);
	
	      ReactTransitionEvents.removeEndEventListener(node, endListener);
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    CSSCore.addClass(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClassAndNode(activeClassName, node);
	
	    // If the user specified a timeout delay.
	    if (userSpecifiedDelay) {
	      // Clean-up the animation after the specified delay
	      timeout = setTimeout(endListener, userSpecifiedDelay);
	      this.transitionTimeouts.push(timeout);
	    } else {
	      // DEPRECATED: this listener will be removed in a future version of react
	      ReactTransitionEvents.addEndEventListener(node, endListener);
	    }
	  },
	
	  queueClassAndNode: function (className, node) {
	    this.classNameAndNodeQueue.push({
	      className: className,
	      node: node
	    });
	
	    if (!this.timeout) {
	      this.timeout = setTimeout(this.flushClassNameAndNodeQueue, TICK);
	    }
	  },
	
	  flushClassNameAndNodeQueue: function () {
	    if (this.isMounted()) {
	      this.classNameAndNodeQueue.forEach(function (obj) {
	        CSSCore.addClass(obj.node, obj.className);
	      });
	    }
	    this.classNameAndNodeQueue.length = 0;
	    this.timeout = null;
	  },
	
	  componentWillMount: function () {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  },
	
	  componentWillUnmount: function () {
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  },
	
	  componentWillAppear: function (done) {
	    if (this.props.appear) {
	      this.transition('appear', done, this.props.appearTimeout);
	    } else {
	      done();
	    }
	  },
	
	  componentWillEnter: function (done) {
	    if (this.props.enter) {
	      this.transition('enter', done, this.props.enterTimeout);
	    } else {
	      done();
	    }
	  },
	
	  componentWillLeave: function (done) {
	    if (this.props.leave) {
	      this.transition('leave', done, this.props.leaveTimeout);
	    } else {
	      done();
	    }
	  },
	
	  render: function () {
	    return onlyChild(this.props.children);
	  }
	});
	
	module.exports = ReactCSSTransitionGroupChild;

/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(310);
	
	/**
	 * The CSSCore module specifies the API (and implements most of the methods)
	 * that should be used when dealing with the display of elements (via their
	 * CSS classes and visibility on screen. It is an API focused on mutating the
	 * display and not reading it as no logical state should be encoded in the
	 * display of elements.
	 */
	
	/* Slow implementation for browsers that don't natively support .matches() */
	function matchesSelector_SLOW(element, selector) {
	  var root = element;
	  while (root.parentNode) {
	    root = root.parentNode;
	  }
	
	  var all = root.querySelectorAll(selector);
	  return Array.prototype.indexOf.call(all, element) !== -1;
	}
	
	var CSSCore = {
	
	  /**
	   * Adds the class passed in to the element if it doesn't already have it.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  addClass: function addClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSSCore.addClass takes only a single class name. "%s" contains ' + 'multiple classes.', className) : invariant(false) : void 0;
	
	    if (className) {
	      if (element.classList) {
	        element.classList.add(className);
	      } else if (!CSSCore.hasClass(element, className)) {
	        element.className = element.className + ' ' + className;
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Removes the class passed in from the element
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  removeClass: function removeClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSSCore.removeClass takes only a single class name. "%s" contains ' + 'multiple classes.', className) : invariant(false) : void 0;
	
	    if (className) {
	      if (element.classList) {
	        element.classList.remove(className);
	      } else if (CSSCore.hasClass(element, className)) {
	        element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ') // multiple spaces to one
	        .replace(/^\s*|\s*$/g, ''); // trim the ends
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Helper to add or remove a class from an element based on a condition.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @param {*} bool condition to whether to add or remove the class
	   * @return {DOMElement} the element passed in
	   */
	  conditionClass: function conditionClass(element, className, bool) {
	    return (bool ? CSSCore.addClass : CSSCore.removeClass)(element, className);
	  },
	
	  /**
	   * Tests whether the element has the class specified.
	   *
	   * @param {DOMNode|DOMWindow} element the element to check the class on
	   * @param {string} className the CSS className
	   * @return {boolean} true if the element has the class, false if not
	   */
	  hasClass: function hasClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSS.hasClass takes only a single class name.') : invariant(false) : void 0;
	    if (element.classList) {
	      return !!className && element.classList.contains(className);
	    }
	    return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
	  },
	
	  /**
	   * Tests whether the element matches the selector specified
	   *
	   * @param {DOMNode|DOMWindow} element the element that we are querying
	   * @param {string} selector the CSS selector
	   * @return {boolean} true if the element matches the selector, false if not
	   */
	  matchesSelector: function matchesSelector(element, selector) {
	    var matchesImpl = element.matches || element.webkitMatchesSelector || element.mozMatchesSelector || element.msMatchesSelector || function (s) {
	      return matchesSelector_SLOW(element, s);
	    };
	    return matchesImpl.call(element, selector);
	  }
	
	};
	
	module.exports = CSSCore;

/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(544);
	
	var getVendorPrefixedEventName = __webpack_require__(598);
	
	var endEvents = [];
	
	function detectEvents() {
	  var animEnd = getVendorPrefixedEventName('animationend');
	  var transEnd = getVendorPrefixedEventName('transitionend');
	
	  if (animEnd) {
	    endEvents.push(animEnd);
	  }
	
	  if (transEnd) {
	    endEvents.push(transEnd);
	  }
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function (node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	
	  removeEndEventListener: function (node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	module.exports = ReactTransitionEvents;

/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _createAccount = __webpack_require__(872);
	
	var _createAccount2 = _interopRequireDefault(_createAccount);
	
	var _paymentModal = __webpack_require__(1062);
	
	var _paymentModal2 = _interopRequireDefault(_paymentModal);
	
	var _pricingLevelFeature = __webpack_require__(1064);
	
	var _pricingLevelFeature2 = _interopRequireDefault(_pricingLevelFeature);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PricingLevel = _react2['default'].createClass({
	    displayName: 'PricingLevel',
	
	
	    propTypes: {
	        'signupUrl': _react2['default'].PropTypes.string,
	        'paymentForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
	        'signupForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
	        'mustContactSales': _react2['default'].PropTypes.bool,
	        'isUpgrade': _react2['default'].PropTypes.bool,
	        'isDelinquent': _react2['default'].PropTypes.bool
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            'expanded': false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        if (this.props.acctModalError) {
	            this.launchCreateAccountModal();
	        }
	        if (this.props.wasSelectedBeforeLogIn) {
	            this.launchPaymentModal();
	        }
	    },
	    onLevelClick: function onLevelClick() {
	        this.setState({
	            'expanded': !this.state.expanded
	        });
	    },
	    launchPaymentModal: function launchPaymentModal() {
	        var attachPoint = _hfReactHelper2['default'].getRevealAttachPoint('payment_modal', 'medium');
	        _reactDom2['default'].render(_react2['default'].createElement(_paymentModal2['default'], { key: this.props.planId,
	            isUpgrade: this.props.isUpgrade,
	            planId: this.props.planId,
	            isFreeTrialEligible: this.props.isFreeTrialEligible,
	            numFreeDays: this.props.numFreeDays,
	            price: this.props.price,
	            timePeriod: this.props.timePeriod,
	            monthlyExpectedRate: this.props.monthlyExpectedRate,
	            annualExpectedRate: this.props.annualExpectedRate,
	            monthlyProratedRate: this.props.monthlyProratedRate,
	            annualProratedRate: this.props.annualProratedRate,
	            currentMonthlyRate: this.props.currentMonthlyRate,
	            currentAnnualRate: this.props.currentAnnualRate,
	            isTrialing: this.props.isTrialing,
	            proratio: this.props.proratio,
	            couponCode: this.props.couponCode,
	            ccSuffix: this.props.ccSuffix,
	            ccExpiration: this.props.ccExpiration,
	            cardHolderName: this.props.cardHolderName ? this.props.cardHolderName : '',
	            name: this.props.name,
	            isApi: this.props.isApi,
	            isEventbrite: this.props.isEventbrite,
	            termsAccepted: this.props.currentAnnualRate > 0,
	            paymentForm: this.props.paymentForm,
	            errors: this.props.errors,
	            currentPlanName: this.props.currentPlanName }), attachPoint);
	    },
	    launchCreateAccountModal: function launchCreateAccountModal() {
	
	        var attachPoint = _hfReactHelper2['default'].getRevealAttachPoint('create_account_modal');
	
	        var redirectUrl = 'onboarding/start';
	        if (this.props.monthlyExpectedRate > 0) {
	            redirectUrl = (this.props.isApi ? 'api/' : 'info/') + 'pricing?plan_id=' + this.props.planId + '&period=' + this.props.timePeriod + (this.props.couponCode ? '&coupon_code=' + this.props.couponCode : '');
	        }
	        if (this.props.isEventbrite) {
	            redirectUrl += '&is_eventbrite=true';
	        }
	
	        var googleOpenIdUrl = this.props.timePeriod == 'M' ? this.props.googleOpenIdUrlMonthly : this.props.googleOpenIdUrlAnnual;
	
	        _reactDom2['default'].render(_react2['default'].createElement(_createAccount2['default'], { planId: this.props.planId,
	            googleOpenIdUrl: googleOpenIdUrl,
	            errorMsg: this.props.acctModalError,
	            header: 'Let\'s get started',
	            buttonText: 'Continue',
	            isFromApiPricing: this.props.isApi,
	            isFromPricing: !this.props.isApi,
	            redirectUrl: redirectUrl,
	            tabOffset: 1000,
	            signupUrl: this.props.signupUrl,
	            signupForm: this.props.signupForm }), attachPoint);
	    },
	    launchSalesModal: function launchSalesModal() {
	        $('#contactUsButton').click();
	    },
	    resumeSub: function resumeSub() {
	        var plan_param = this.props.isApi ? 'plan_type=api' : 'plan_type=ui';
	        window.location.href = '/account/revertPendingCancellation?' + plan_param;
	    },
	    redirectToCardUpdate: function redirectToCardUpdate() {
	        window.location.href = '/account/updateCard';
	    },
	    render: function render() {
	        var isFree = this.props.monthlyExpectedRate <= 0;
	        var mostPopular = this.props.mostPopular ? _react2['default'].createElement('img', { className: 'most-popular show-for-large-up', src: __webpack_require__(1065) }) : '';
	        var bodyClasses = (0, _classnames2['default'])({
	            'm-pricing-level--body': true,
	            'small-12': true,
	            'columns': true,
	            'expanded': this.state.expanded
	        });
	
	        var seatBadge;
	        if (this.props.maxSeats && parseInt(this.props.maxSeats) > 1) {
	            var seatBadgeText = '1 - ' + this.props.maxSeats + ' SENDERS';
	            seatBadge = _react2['default'].createElement(
	                'div',
	                { className: 'm-pricing-level--seat-range hide-for-medium-down' },
	                _react2['default'].createElement(
	                    'p',
	                    { className: 'max-seats-badge' },
	                    seatBadgeText
	                )
	            );
	        }
	
	        var price = '0',
	            period = '',
	            billingPeriod;
	        if (!isFree) {
	            if (this.props.timePeriod == 'M') {
	                price = this.props.monthlyCouponPrice ? this.props.monthlyCouponPrice : this.props.monthlyPrice;
	                period = 'per month';
	            } else {
	                price = this.props.annualCouponPrice ? this.props.annualCouponPrice : this.props.annualPrice;
	                period = 'per month when paid annually';
	            }
	            billingPeriod = _react2['default'].createElement(
	                'div',
	                { className: 'billing-period' },
	                period
	            );
	        } else {
	            billingPeriod = _react2['default'].createElement('div', { className: 'no-billing-period' });
	        }
	
	        var oldPrice, oldPriceMobile;
	        if (this.props.coupon) {
	            oldPrice = _react2['default'].createElement(
	                'div',
	                { className: 'm-pricing-level--body small-4 large-12 small-centered columns level-price' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'dollar crossed' },
	                    '$'
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'price crossed' },
	                    this.props.price
	                )
	            );
	            var oldPriceMobileClasses = (0, _classnames2['default'])({
	                'show-for-medium-only': true,
	                'small-1': true,
	                'medium-3': true,
	                'columns': true,
	                'level-price': true,
	                'l-padding-t-35': true
	            });
	            oldPriceMobile = _react2['default'].createElement(
	                'div',
	                { className: oldPriceMobileClasses },
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'dollar crossed' },
	                    '$'
	                ),
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'price crossed' },
	                    this.props.price
	                )
	            );
	        }
	
	        // Get started button logic
	        var getStarted;
	        if (this.props.isCurrentPlan && !this.props.isDelinquent && (!this.props.isApi && this.props.UiPendingCancel || this.props.isApi && this.props.ApiPendingCancel) && this.props.isAdmin) {
	            var buttonText = 'Resume';
	            var buttonFunc = this.resumeSub;
	            getStarted = _react2['default'].createElement(_button2['default'], { buttonText: buttonText, onClick: buttonFunc, buttonHoverColor: 'cerulean' });
	            // Special cases for delinquent subscriptions
	        } else if (this.props.isDelinquent) {
	            var buttonText, buttonColor, buttonHoverColor, buttonFunc;
	            // Allow access to CC update only on current plan
	            if (this.props.isCurrentPlan) {
	                buttonText = 'Update payment info';
	                buttonFunc = this.redirectToCardUpdate;
	                buttonColor = 'ashen';
	                buttonHoverColor = 'cerulean';
	                // Disallow plan change
	            } else {
	                buttonText = 'Unavailable';
	                buttonFunc = function buttonFunc() {}; // noop
	                buttonColor = 'cinder-block';
	                buttonHoverColor = 'cinder-block';
	            }
	            getStarted = _react2['default'].createElement(_button2['default'], { buttonText: buttonText, onClick: buttonFunc, buttonColor: buttonColor, buttonHoverColor: buttonHoverColor });
	        } else if (this.props.isCurrentPlan) {
	            getStarted = _react2['default'].createElement(
	                'div',
	                { className: 'current-plan' },
	                'You are currently on this plan'
	            );
	        } else if (this.props.isAdmin && (!this.props.isApi && !this.props.UiPendingCancel || this.props.isApi && !this.props.ApiPendingCancel)) {
	            var buttonText = isFree || this.props.isApi ? 'Get Started' : 'Start Free Trial';
	            var buttonFunc = this.launchCreateAccountModal;
	            if (this.props.isLoggedIn) {
	                buttonText = 'Get Started';
	                buttonFunc = this.launchPaymentModal;
	            }
	            if (this.props.mustContactSales && this.props.isUpgrade) {
	                buttonFunc = this.launchSalesModal;
	            }
	            getStarted = _react2['default'].createElement(_button2['default'], { buttonText: buttonText, onClick: buttonFunc, buttonHoverColor: 'cerulean' }); //FIXME: test
	        } else {
	            getStarted = _react2['default'].createElement('div', { className: 'no-plan-option' });
	        }
	
	        var freeTrial = '';
	        if (this.props.isAdmin && this.props.isFreeTrialEligible && !this.props.isApi && !this.props.isCurrentPlan && !isFree) {
	            freeTrial = _react2['default'].createElement(
	                'div',
	                { className: 'm-pricing-level--num-trial-days' },
	                '' + this.props.numFreeDays + '-day free trial'
	            );
	        } else {
	            var freeTrialClasses = (0, _classnames2['default'])({
	                'current-plan': this.props.isCurrentPlan,
	                'm-pricing-level--no-free-trial': true
	            });
	            freeTrial = _react2['default'].createElement('div', { className: freeTrialClasses });
	        }
	
	        var mainFeature;
	        if (this.props.mainFeature) {
	            var name = this.props.mainFeature.name ? this.props.mainFeature.name : name;
	            var detail = this.props.mainFeature.detail ? this.props.mainFeature.detail : null;
	            var number = this.props.mainFeature.number ? this.props.mainFeature.number : null;
	            mainFeature = _react2['default'].createElement(_pricingLevelFeature2['default'], { name: name, planName: this.props.name, detail: detail, number: number, isFree: isFree, key: 'main-feature', expanded: this.state.expanded });
	        }
	
	        var features = this.props.features.map(function (feature, i) {
	            var name = feature.name ? feature.name : name;
	            var detail = feature.detail ? feature.detail : null;
	            var number = feature.number ? feature.number : null;
	            return _react2['default'].createElement(_pricingLevelFeature2['default'], { name: name, planName: this.props.name, detail: detail, number: number, key: 'feature' + i, isFree: isFree, expanded: this.state.expanded });
	        }.bind(this));
	
	        var name = this.props.name;
	        if (this.props.isEventbrite) {
	            name = name.replace('Eventbrite ', '');
	        }
	
	        var levelClasses = (0, _classnames2['default'])({
	            'small-5': true,
	            'medium-4': !this.props.coupon,
	            'medium-offset-1': true,
	            'medium-3': this.props.coupon,
	            'large-12': true,
	            'large-offset-0': true,
	            'columns': true,
	            'level-title': true
	        });
	        var priceClasses = (0, _classnames2['default'])({
	            'hide-for-large-up': true,
	            'small-7': true,
	            'medium-5': true,
	            'medium-offset-0': this.props.coupon,
	            'medium-offset-1': !this.props.coupon,
	            'columns': true,
	            'level-price': true
	        });
	        var arrowContainerClasses = (0, _classnames2['default'])({
	            'arrow-container': true,
	            'hide-for-large-up': true,
	            'hide-for-small': true,
	            'small-2': true,
	            'medium-1': true,
	            'columns': true
	        });
	        var arrowClasses = (0, _classnames2['default'])({
	            'l-vertical-align': true,
	            'arrow': true,
	            'expanded': this.state.expanded
	        });
	        var pricingLevelColumnClasses = (0, _classnames2['default'])({
	            'm-pricing-level': true,
	            'small-12': true,
	            'medium-12': true,
	            'large-4': this.props.totalColumns >= 3,
	            'large-6': this.props.totalColumns == 2,
	            'large-12': this.props.totalColumns == 1,
	            'columns': true
	        });
	        return _react2['default'].createElement(
	            'div',
	            { 'data-test-id': 'pricing-level', className: pricingLevelColumnClasses },
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-pricing-level--header small-12 medium-12 columns block', onClick: this.onLevelClick },
	                _react2['default'].createElement(
	                    'div',
	                    { className: levelClasses },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'level-title l-vertical-align-wrapper' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'l-vertical-align' },
	                            name ? name.toUpperCase() : ''
	                        )
	                    )
	                ),
	                seatBadge,
	                oldPriceMobile,
	                _react2['default'].createElement(
	                    'div',
	                    { className: priceClasses },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'level-title l-vertical-align-wrapper' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'l-vertical-align' },
	                            _react2['default'].createElement(
	                                'span',
	                                { className: 'dollar' },
	                                '$'
	                            ),
	                            _react2['default'].createElement(
	                                'span',
	                                { className: 'price' },
	                                price,
	                                _react2['default'].createElement(
	                                    'span',
	                                    { className: 'billing-period' },
	                                    period
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: arrowContainerClasses },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'level-title l-vertical-align-wrapper' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: arrowClasses },
	                            '\xA0'
	                        )
	                    )
	                ),
	                mostPopular
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: bodyClasses },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'first-section block' },
	                    oldPrice,
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-pricing-level--body small-3 large-12 small-centered columns block' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'dollar' },
	                            '$'
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'price' },
	                            price
	                        ),
	                        billingPeriod
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'block' },
	                        getStarted,
	                        freeTrial
	                    ),
	                    mainFeature
	                )
	            ),
	            features
	        );
	    }
	});
	
	module.exports = PricingLevel;

/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _paymentForm = __webpack_require__(1063);
	
	var _paymentForm2 = _interopRequireDefault(_paymentForm);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	var _setTimeout = __webpack_require__(718);
	
	var _setTimeout2 = _interopRequireDefault(_setTimeout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PaymentModal = _react2['default'].createClass({
	    displayName: 'PaymentModal',
	
	
	    // NOTE: These propTypes are incomplete - see render() for all props
	    propTypes: {
	        'tabOffset': _react2['default'].PropTypes.number,
	        'paymentForm': _react2['default'].PropTypes.object,
	        'numSeats': _react2['default'].PropTypes.number,
	        'formAction': _react2['default'].PropTypes.string,
	        'headerText': _react2['default'].PropTypes.string,
	        'forceFreeTrial': _react2['default'].PropTypes.bool
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            'cardType': 'Unknown',
	            'cardNumber': '0',
	            'cardCvv': '000',
	            'cardExpMonth': '01',
	            'cardExpYear': '2015',
	            'stripe_token': '',
	            'termsAccepted': false,
	            'isProcessing': false,
	            'isApi': true,
	            'cardHolderName': this.props.cardHolderName ? this.props.cardHolderName : ''
	
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        if (true) {
	            var root = $(_reactDom2['default'].findDOMNode(this));
	
	            $(document).foundation();
	
	            root.closest('.reveal-modal').foundation('reveal', 'open');
	
	            (0, _setTimeout2['default'])(function () {
	                var input = root.find('input:first');
	                input.focus();
	            }, 500);
	        }
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	        if (true) {
	            $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
	        }
	    },
	    checkIfDowngrade: function checkIfDowngrade() {
	        return this.props.timePeriod == 'M' ? this.props.currentMonthlyRate > this.props.monthlyExpectedRate : this.props.currentAnnualRate > this.props.annualExpectedRate;
	    },
	    render: function render() {
	
	        var rateString = _hfReactHelper2['default'].formatMoney(this.props.timePeriod == 'M' ? this.props.monthlyExpectedRate : this.props.annualExpectedRate, '$');
	
	        var billingString = 'Your 30 day trial starts today. Within those 30 days, if you change your mind, you can cancel your account and you won\'t be charged. After your free trial, we\'ll begin billing you ' + rateString + '/' + (this.props.timePeriod == 'M' ? 'mo' : 'yr') + '.';
	        var downgradingToFree = false;
	        if (!this.props.forceFreeTrial && this.props.isApi) {
	            billingString = 'You will be billed ' + rateString + ' today. We will refund you in full within 30 days of your purchase if you are unhappy with our service for any reason.';
	        } else if (this.props.isTrialing) {
	            if (rateString === '$0') {
	                billingString = 'Downgrading will end your free trial and you will not be charged. You can upgrade at any time.';
	                downgradingToFree = true;
	            } else {
	                billingString = 'You will be billed ' + rateString + ' at the end of your existing free trial.';
	            }
	        } else if (this.props.timePeriod == 'M' && this.props.monthlyExpectedRate !== this.props.monthlyProratedRate || this.props.timePeriod == 'Y' && this.props.annualExpectedRate !== this.props.annualProratedRate) {
	            // need to display prorated information
	            var isDowngrade = this.checkIfDowngrade();
	            if (isDowngrade) {
	                billingString = 'At the beginning of your next billing cycle you will be billed ' + rateString + '.';
	            } else {
	                var proratedRateString = _hfReactHelper2['default'].formatMoney(this.props.timePeriod == 'M' ? this.props.monthlyProratedRate : this.props.annualProratedRate, '$');
	                billingString = 'You will be charged ' + proratedRateString + ' for your current pro-rated billing cycle. Starting with your next billing cycle, you will be charged ' + rateString + '/' + (this.props.timePeriod == 'M' ? 'mo' : 'yr') + '.';
	            }
	        } else if (!this.props.isFreeTrialEligible) {
	            var isDowngrade = this.checkIfDowngrade();
	            if (isDowngrade) {
	                billingString = 'At the beginning of your next billing cycle you will be billed ' + rateString + '.';
	            } else {
	                billingString = 'You will be billed ' + rateString + ' today.';
	            }
	        } else if (!this.props.forceFreeTrial && this.props.monthlyExpectedRate <= 0) {
	            billingString = _react2['default'].createElement(
	                'span',
	                null,
	                'When you downgrade to a Free plan you will lose access to our paid features, including templates. But fear not! You will still have full access to your account and any signed documents you\'ve saved.',
	                _react2['default'].createElement('br', null),
	                _react2['default'].createElement('br', null),
	                'You can upgrade at any time to restore the applicable paid features and increase the number of documents and templates you can use.'
	            );
	        }
	
	        if (!downgradingToFree) {
	            var supportEmail = _hfReactHelper2['default'].HfConstants.supportEmail[_hfReactHelper2['default'].HfSites.SITE_CODE_HS];
	            billingString = _react2['default'].createElement(
	                'span',
	                null,
	                billingString,
	                _react2['default'].createElement('br', null),
	                _react2['default'].createElement('br', null),
	                'If you have any questions, you can reach our support team at\xA0',
	                _react2['default'].createElement(
	                    'a',
	                    { href: 'mailto:' + supportEmail },
	                    supportEmail
	                ),
	                '.'
	            );
	        }
	
	        var headerText;
	        if (this.props.headerText) {
	            headerText = this.props.headerText;
	        } else {
	            headerText = 'Sign up for ' + this.props.name;
	            var currentRate = this.props.timePeriod == 'Y' ? parseFloat(this.props.currentAnnualRate) : parseFloat(this.props.currentMonthlyRate);
	            if (!this.props.isApi && currentRate == 0.0 && this.props.isFreeTrialEligible) {
	                headerText = 'Start ' + this.props.name + ' Trial';
	            } else if (this.props.isUpgrade) {
	                headerText = 'Upgrade to ' + this.props.name;
	            } else {
	                headerText = 'Downgrade to ' + this.props.name;
	            }
	        }
	
	        var card = {
	            'name': this.props.cardHolderName,
	            'suffix': this.props.ccSuffix
	        };
	
	        return _react2['default'].createElement(_paymentForm2['default'], { fields: this.props.paymentForm.fields,
	            values: this.props.paymentForm.values,
	            errors: this.props.errors,
	            namespace: this.props.paymentForm.namespace,
	            stripeToken: this.state.stripe_token,
	            planId: this.props.planId,
	            couponCode: this.props.couponCode,
	            timePeriod: this.props.timePeriod,
	            tabOffset: this.props.tabOffset,
	            card: card,
	            isApi: this.props.isApi,
	            isEventbrite: this.props.isEventbrite,
	            termsAccepted: this.props.termsAccepted,
	            buttonText: this.props.buttonText,
	            headerText: headerText,
	            billingString: billingString,
	            ccExpiration: this.props.ccExpiration,
	            numSeats: this.props.numSeats,
	            formAction: this.props.formAction,
	            currentPlanName: this.props.currentPlanName,
	            name: this.props.name });
	    }
	});
	
	module.exports = PaymentModal;

/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _baseForm = __webpack_require__(703);
	
	var _baseForm2 = _interopRequireDefault(_baseForm);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	var _logger = __webpack_require__(482);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * NOTE: This form does not follow the proper way to use
	 * React and Symfony Forms, a better example can be found
	 * by looking at ForgotPasswordForm
	 */
	var PaymentForm = _baseForm2['default'].createFormClass({
	
	    displayName: 'PaymentForm',
	
	    propTypes: {
	        'stripeToken': _react2['default'].PropTypes.string,
	        'planId': _react2['default'].PropTypes.string,
	        'couponCode': _react2['default'].PropTypes.string,
	        'timePeriod': _react2['default'].PropTypes.string,
	        'tabOffset': _react2['default'].PropTypes.number,
	        'card': _react2['default'].PropTypes.object,
	        'isApi': _react2['default'].PropTypes.bool,
	        'isEventbrite': _react2['default'].PropTypes.bool,
	        'termsAccepted': _react2['default'].PropTypes.bool,
	        'buttonText': _react2['default'].PropTypes.string,
	        'headerText': _react2['default'].PropTypes.string,
	        'billingString': _react2['default'].PropTypes.object,
	        'ccExpiration': _react2['default'].PropTypes.string,
	        'formAction': _react2['default'].PropTypes.string,
	        'numSeats': _react2['default'].PropTypes.number,
	        'currentPlanName': _react2['default'].PropTypes.string,
	        'errors': _react2['default'].PropTypes.object
	    },
	
	    CARD_TYPES: [{ 'long': 'MasterCard', 'short': 'mastercard' }, { 'long': 'Visa', 'short': 'visa' }, { 'long': 'American Express', 'short': 'amex' }, { 'long': 'Discover', 'short': 'discover' }],
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            'formAction': '',
	            'numSeats': 1
	        };
	    },
	    getInitialState: function getInitialState() {
	        var globalError = this.props.errors && this.props.errors['payment[submit]'] || null;
	        return {
	            'card': $.extend({
	                'expYear': new Date().getFullYear() + 1,
	                'expMonth': '01',
	                'number': '0',
	                'cvv': '000',
	                'type': 'Unknown'
	            }, this.props.card),
	            'isProcessing': false,
	            'termsAccepted': this.props.termsAccepted || false,
	            'stripeToken': this.props.stripeToken || '',
	            'errors': { 'global': globalError }
	        };
	    },
	    onContinueClick: function onContinueClick(evt) {
	
	        evt.preventDefault();
	
	        var card = this.state.card;
	
	        if (!card.suffix && (!card.name || card.name.length < 1)) {
	            this.setState({
	                'errors': { 'global': 'Cardholder name is required.' },
	                'isProcessing': false
	            });
	            return;
	        }
	
	        if (this.state.isProcessing === false) {
	
	            this.setState({
	                'errors': null,
	                'isProcessing': true
	            });
	
	            if (this.props.isApi && !this.props.isEventbrite && this.state.termsAccepted === false) {
	                this.setState({
	                    'errors': { 'global': 'You need to accept the terms to sign up.' },
	                    'isProcessing': false
	                });
	                return;
	            }
	
	            if (card.suffix) {
	                this.submitForm();
	                return;
	            }
	
	            Stripe.card.createToken({
	                'number': card.number,
	                'cvc': card.cvv,
	                'exp_month': card.expMonth,
	                'exp_year': card.expYear,
	                'address_zip': card.zip,
	                'name': card.name
	            }, function (status, response) {
	                if (response.error) {
	                    this.setState({
	                        'errors': { 'global': response.error.message },
	                        'isProcessing': false
	                    });
	                } else {
	                    var token = response.id;
	                    this.setState({
	                        'stripeToken': token
	                    });
	                    this.submitForm();
	                }
	            }.bind(this));
	        }
	
	        return false;
	    },
	    submitForm: function submitForm() {
	        _logger2['default'].track('PaymentForm._onSuccess', {
	            previousPlanName: this.props.currentPlanName,
	            newPlanName: this.props.name
	        });
	        $('#payment_form').submit();
	    },
	    onCardType: function onCardType(event) {
	        var card = this.state.card;
	        card.type = Stripe.cardType(event.target.value);
	        card.number = event.target.value;
	        this.setState({ 'card': card });
	    },
	    onExpMonthChange: function onExpMonthChange(event) {
	        var card = this.state.card;
	        card.expMonth = event.target.value;
	        this.setState({ 'card': card });
	    },
	    onExpYearChange: function onExpYearChange(event) {
	        var card = this.state.card;
	        card.expYear = event.target.value;
	        this.setState({ 'card': card });
	    },
	    onCvvChange: function onCvvChange(event) {
	        var card = this.state.card;
	        card.cvv = event.target.value;
	        this.setState({ 'card': card });
	    },
	    onZipChange: function onZipChange(event) {
	        var card = this.state.card;
	        card.zip = event.target.value;
	        this.setState({ 'card': card });
	    },
	    onCardholderNameChange: function onCardholderNameChange(event) {
	        var card = this.state.card;
	        card.name = event.target.value;
	        this.setState({ 'card': card });
	    },
	    onTermsChange: function onTermsChange(event) {
	        this.setState({
	            'termsAccepted': event.target.checked,
	            'errors': null
	        });
	    },
	    render: function render() {
	        var formFields;
	        var termsAgreement;
	        var stripeTokenField;
	        var card = this.state.card;
	        var tabOffset = parseInt(this.props.tabOffset || 1000, 10);
	
	        // Stripe token
	        if (this.state.stripeToken) {
	            stripeTokenField = _react2['default'].createElement('input', { type: 'hidden', name: 'payment[stripe_token]', value: this.state.stripeToken });
	        }
	
	        // Terms agreement
	        if (this.props.isApi && !this.props.isEventbrite) {
	            termsAgreement = _react2['default'].createElement(
	                'div',
	                { className: 'l-padding-b-20 columns small-12 text-left' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-payment--api-terms' },
	                    _react2['default'].createElement('input', { id: 'payment_terms', type: 'checkbox', onChange: this.onTermsChange, tabIndex: tabOffset + 6, checked: this.state.termsAccepted }),
	                    _react2['default'].createElement(
	                        'label',
	                        { htmlFor: 'payment_terms' },
	                        '\xA0By using our API, you agree to our ',
	                        _react2['default'].createElement(
	                            'a',
	                            { target: '_blank', rel: 'noopener noreferrer', href: '/api/terms' },
	                            'API Terms of Service'
	                        ),
	                        '.'
	                    )
	                )
	            );
	        }
	
	        var longDescription = _react2['default'].createElement(
	            'div',
	            { className: 'm-payment--left-border columns small-12 text-left' },
	            _react2['default'].createElement(
	                'p',
	                null,
	                this.props.billingString
	            )
	        );
	
	        var cardDisplays = this.CARD_TYPES.map(function (type, i) {
	            return _react2['default'].createElement('img', { key: i, src: _hfReactHelper2['default'].imgHelper('api/pricing/upgrade_popup/' + type.short + '_' + (card.type == type.long ? '' : 'in') + 'active.png') });
	        }.bind(this));
	
	        // Form fields
	        if (!card.suffix) {
	
	            var curYear = new Date().getFullYear();
	            var numYears = 10;
	            var yearOptions = Array.apply(null, Array(numYears)).map(function (val, offset) {
	                var year = curYear + offset;
	                return _react2['default'].createElement(
	                    'option',
	                    { value: year, key: offset },
	                    year
	                );
	            });
	
	            formFields = _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'columns small-12 text-left' },
	                        _react2['default'].createElement(
	                            'p',
	                            null,
	                            'Enter your credit card information'
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'columns small-12 large-7' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'columns small-12' },
	                                _react2['default'].createElement('input', { type: 'text', placeholder: 'Cardholder Name', className: 'm-payment--cardholder-name columns small-8', value: card.name, onChange: this.onCardholderNameChange, tabIndex: tabOffset })
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'columns small-12 m-payment--cc' },
	                                _react2['default'].createElement('input', { type: 'text', placeholder: 'Credit card number', onInput: this.onCardType, tabIndex: tabOffset + 1 }),
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: 'm-payment--ccs show-for-medium-up' },
	                                    cardDisplays
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'columns small-12 large-6 small-text-left large-text-right' },
	                                _react2['default'].createElement(
	                                    'select',
	                                    { className: 'm-payment--cc-exp-month columns small-4', value: card.expMonth, onChange: this.onExpMonthChange, tabIndex: tabOffset + 2 },
	                                    _react2['default'].createElement(
	                                        'option',
	                                        { value: '01' },
	                                        '01'
	                                    ),
	                                    _react2['default'].createElement(
	                                        'option',
	                                        { value: '02' },
	                                        '02'
	                                    ),
	                                    _react2['default'].createElement(
	                                        'option',
	                                        { value: '03' },
	                                        '03'
	                                    ),
	                                    _react2['default'].createElement(
	                                        'option',
	                                        { value: '04' },
	                                        '04'
	                                    ),
	                                    _react2['default'].createElement(
	                                        'option',
	                                        { value: '05' },
	                                        '05'
	                                    ),
	                                    _react2['default'].createElement(
	                                        'option',
	                                        { value: '06' },
	                                        '06'
	                                    ),
	                                    _react2['default'].createElement(
	                                        'option',
	                                        { value: '07' },
	                                        '07'
	                                    ),
	                                    _react2['default'].createElement(
	                                        'option',
	                                        { value: '08' },
	                                        '08'
	                                    ),
	                                    _react2['default'].createElement(
	                                        'option',
	                                        { value: '09' },
	                                        '09'
	                                    ),
	                                    _react2['default'].createElement(
	                                        'option',
	                                        { value: '10' },
	                                        '10'
	                                    ),
	                                    _react2['default'].createElement(
	                                        'option',
	                                        { value: '11' },
	                                        '11'
	                                    ),
	                                    _react2['default'].createElement(
	                                        'option',
	                                        { value: '12' },
	                                        '12'
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    'select',
	                                    { className: 'm-payment--cc-exp-year columns small-8', value: card.expYear, onChange: this.onExpYearChange, tabIndex: tabOffset + 3 },
	                                    yearOptions
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'columns small-12 large-6 large-text-left small-text-right' },
	                                _react2['default'].createElement('input', { type: 'text', placeholder: 'CVV', className: 'm-payment--cvv columns small-4', onChange: this.onCvvChange, tabIndex: tabOffset + 4 }),
	                                _react2['default'].createElement('input', { type: 'text', placeholder: 'Zip code', name: 'payment[cc_zip]', className: 'm-payment--zip columns small-8', onChange: this.onZipChange, tabIndex: tabOffset + 5 })
	                            )
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'columns small-12 large-5' },
	                        longDescription
	                    )
	                )
	            );
	        } else if (this.props.monthlyExpectedRate == 0) {
	            formFields = _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'columns small-12 text-left' },
	                        _react2['default'].createElement(
	                            'p',
	                            null,
	                            this.props.billingString
	                        )
	                    )
	                )
	            );
	        } else {
	            formFields = _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'columns small-12 text-left' },
	                        _react2['default'].createElement(
	                            'p',
	                            null,
	                            'The following card will be charged:'
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'columns small-12 text-left' },
	                        _react2['default'].createElement(
	                            'h4',
	                            null,
	                            'xxxx xxxx xxxx ',
	                            this.state.card.suffix
	                        ),
	                        _react2['default'].createElement(
	                            'h4',
	                            null,
	                            'Expires ',
	                            this.props.ccExpiration,
	                            ' '
	                        )
	                    ),
	                    longDescription
	                )
	            );
	        }
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'm-payment' },
	            _react2['default'].createElement(
	                'form',
	                { id: 'payment_form', action: this.props.formAction, method: 'POST', onSubmit: this.onContinueClick },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'columns small-12 text-center l-padding-v-20' },
	                        _react2['default'].createElement(
	                            'h3',
	                            null,
	                            this.props.headerText
	                        )
	                    )
	                ),
	                formFields,
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'row l-margin-v-10' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'columns small-12 large-7 text-left m-payment--error' },
	                        this.renderErrorText()
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'row l-padding-v-20' },
	                    termsAgreement,
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'columns small-12 text-center' },
	                        _react2['default'].createElement(_button2['default'], { onClick: this.onContinueClick,
	                            buttonText: this.props.buttonText || 'Continue',
	                            buttonColor: 'grasshopper',
	                            buttonHoverColor: 'castle-rock',
	                            buttonTabIndex: tabOffset + 7 })
	                    )
	                ),
	                stripeTokenField,
	                this.renderCsrfField(),
	                _react2['default'].createElement('input', { type: 'hidden', name: 'cardHolderName', value: card.name }),
	                _react2['default'].createElement('input', { type: 'hidden', name: 'payment[num_seats]', value: this.props.numSeats }),
	                _react2['default'].createElement('input', { type: 'hidden', name: 'payment[target_plan]', value: this.props.planId }),
	                _react2['default'].createElement('input', { type: 'hidden', name: 'payment[coupon_code]', value: this.props.couponCode || '' }),
	                _react2['default'].createElement('input', { type: 'hidden', name: 'payment[period]', value: this.props.timePeriod })
	            )
	        );
	    }
	});
	
	module.exports = PaymentForm;

/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PricingLevelFeature = _react2['default'].createClass({
	    displayName: 'PricingLevelFeature',
	    render: function render() {
	        var classes = (0, _classnames2['default'])({
	            'm-pricing-level--feature': true,
	            'small-12': true,
	            'columns': true,
	            'block': true,
	            'expanded': this.props.expanded
	        });
	
	        if (this.props.planName && this.props.planName.toLowerCase().indexOf('pro') === 0) {
	            var numberClasses = (0, _classnames2['default'])({
	                'number': true,
	                'c-cerulean': this.props.name.toLowerCase().indexOf('documents per month') === 0
	            });
	        } else {
	            var numberClasses = (0, _classnames2['default'])({
	                'number': true,
	                'c-cerulean': !this.props.isFree
	            });
	        }
	
	        var nameClasses = (0, _classnames2['default'])({
	            'name': true
	        });
	
	        var number = _react2['default'].createElement(
	            'div',
	            { className: numberClasses },
	            this.props.number
	        );
	        var name = _react2['default'].createElement(
	            'div',
	            { className: nameClasses },
	            this.props.name
	        );
	        var detail = _react2['default'].createElement(
	            'div',
	            { className: 'detail' },
	            this.props.detail
	        );
	        return _react2['default'].createElement(
	            'div',
	            { className: classes },
	            number,
	            name,
	            detail
	        );
	    }
	});
	
	module.exports = PricingLevelFeature;

/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/8a1c9c821026aef71017c011102ccf6e.png";

/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1067);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	var _pricingLevelFeature = __webpack_require__(1064);
	
	var _pricingLevelFeature2 = _interopRequireDefault(_pricingLevelFeature);
	
	var _contactUsButton = __webpack_require__(1069);
	
	var _contactUsButton2 = _interopRequireDefault(_contactUsButton);
	
	var _pricingIconPhone2x = __webpack_require__(1080);
	
	var _pricingIconPhone2x2 = _interopRequireDefault(_pricingIconPhone2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var CorporatePricingLevel = _react2['default'].createClass({
	    displayName: 'CorporatePricingLevel',
	    getInitialState: function getInitialState() {
	        return { expanded: false };
	    },
	    getDefaultProps: function getDefaultProps() {
	        return {
	            'corpLevelName': 'Enterprise'
	        };
	    },
	    onLevelClick: function onLevelClick() {
	        this.setState({ expanded: !this.state.expanded });
	    },
	    render: function render() {
	        var bodyClasses = (0, _classnames2['default'])({
	            'm-pricing-level--body': true,
	            'small-12': true,
	            'columns': true,
	            'expanded': this.state.expanded
	        });
	        var levelClasses = (0, _classnames2['default'])({
	            'small-6': true,
	            'medium-4': true,
	            'medium-offset-1': true,
	            'large-12': true,
	            'large-offset-0': true,
	            'columns': true,
	            'level-title': true
	        });
	        var arrowContainerClasses = (0, _classnames2['default'])({
	            'arrow-container': true,
	            'hide-for-large-up': true,
	            'hide-for-small': true,
	            'small-2': true,
	            'medium-1': true,
	            'columns': true
	        });
	        var arrowClasses = (0, _classnames2['default'])({
	            'l-vertical-align': true,
	            'arrow': true,
	            'expanded': this.state.expanded
	        });
	        var contactUsClasses = (0, _classnames2['default'])({
	            'phone-container': true,
	            'hide-for-large-up': true,
	            'small-6': true,
	            'medium-5': true,
	            'medium-offset-1': true,
	            'columns': true,
	            'level-price': true
	        });
	        var lookingForMoreClasses = (0, _classnames2['default'])({
	            'm-pricing-level--body': true,
	            'small-10': true,
	            'small-centered': true,
	            'columns': true,
	            'looking-for-more': true,
	            'l-padding-t-50': this.props.coupon && this.props.coupon !== null
	        });
	
	        var mainFeature = '';
	        var noFeatures = true;
	        if (this.props.corporateFeatures && this.props.corporateFeatures.main_feature) {
	            var name = this.props.corporateFeatures.main_feature.name ? this.props.corporateFeatures.main_feature.name : name;
	            var detail = this.props.corporateFeatures.main_feature.detail ? this.props.corporateFeatures.main_feature.detail : null;
	            var number = this.props.corporateFeatures.main_feature.number ? this.props.corporateFeatures.main_feature.number : null;
	            mainFeature = _react2['default'].createElement(_pricingLevelFeature2['default'], { name: name, planName: this.props.name, detail: detail, number: number, key: 'main-feature', expanded: this.state.expanded });
	            noFeatures = false;
	        }
	
	        var features = '';
	        if (this.props.corporateFeatures && this.props.corporateFeatures.features) {
	            features = this.props.corporateFeatures.features.map(function (feature, i) {
	                var name = feature.name ? feature.name : name;
	                var detail = feature.detail ? feature.detail : null;
	                var number = feature.number ? feature.number : null;
	                return _react2['default'].createElement(_pricingLevelFeature2['default'], { name: name, planName: this.props.name, detail: detail, number: number, key: 'feature' + i, expanded: this.state.expanded });
	            }.bind(this));
	        }
	
	        var phoneNumberClasses = (0, _classnames2['default'])({
	            'contact-us-phone-number': true,
	            'l-nowrap': true,
	            'no-features-padding': noFeatures
	        });
	        var corpLevelColumnClasses = (0, _classnames2['default'])({
	            'm-pricing-level': true,
	            'small-12': true,
	            'medium-12': true,
	            'large-3': this.props.totalColumns >= 3,
	            'large-4': this.props.totalColumns == 2,
	            'large-6': this.props.totalColumns == 1,
	            'columns': true,
	            'end': true,
	            'corporate-pricing-level': true
	        });
	        return _react2['default'].createElement(
	            'div',
	            { className: corpLevelColumnClasses },
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-pricing-level--header small-12 columns block', onClick: this.onLevelClick },
	                _react2['default'].createElement(
	                    'div',
	                    { className: levelClasses },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'level-title l-vertical-align-wrapper' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'l-vertical-align' },
	                            this.props.corpLevelName.toUpperCase()
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: contactUsClasses },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'phone-container l-vertical-align-wrapper' },
	                        !this.state.expanded && _react2['default'].createElement(_contactUsButton2['default'], {
	                            timePeriod: this.state.timePeriod,
	                            pricingSource: this.props.pricingSource,
	                            onClick: function onClick(e) {
	                                return e.stopPropagation();
	                            }
	                        })
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: arrowContainerClasses },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'level-title l-vertical-align-wrapper' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: arrowClasses },
	                            '\xA0'
	                        )
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: bodyClasses },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'first-section block' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: lookingForMoreClasses },
	                        'Looking for more?'
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'block' },
	                        _react2['default'].createElement(_contactUsButton2['default'], { timePeriod: this.state.timePeriod, pricingSource: this.props.pricingSource })
	                    ),
	                    mainFeature
	                )
	            ),
	            features
	        );
	    }
	});
	
	module.exports = CorporatePricingLevel;

/***/ },
/* 1067 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1068 */,
/* 1069 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _contactUsModal = __webpack_require__(1070);
	
	var _contactUsModal2 = _interopRequireDefault(_contactUsModal);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ContactUsButton = _react2['default'].createClass({
	    displayName: 'ContactUsButton',
	
	    propTypes: {
	        'timePeriod': _react2['default'].PropTypes.string,
	        'pricingSource': _react2['default'].PropTypes.string,
	        'buttonText': _react2['default'].PropTypes.string,
	        'modalHeaderText': _react2['default'].PropTypes.string,
	        'onSuccess': _react2['default'].PropTypes.func
	    },
	    componentDidMount: function componentDidMount() {
	
	        if (window.location.search.indexOf('showContactUs=1') > -1) {
	            this.handleClick();
	        }
	    },
	    getInitialState: function getInitialState() {
	        return {
	            'timePeriod': 'Y'
	        };
	    },
	    handleClick: function handleClick(e) {
	        var attachPoint = _hfReactHelper2['default'].getRevealAttachPoint('contact_us_modal');
	        _reactDom2['default'].render(_react2['default'].createElement(_contactUsModal2['default'], {
	            timePeriod: this.state.timePeriod,
	            pricingSource: this.props.pricingSource,
	            headerText: this.props.modalHeaderText,
	            onSuccess: this.props.onSuccess }), attachPoint);
	
	        // Pass the event to a click handler if it was provided.
	        if (this.props.onClick) {
	            this.props.onClick(e);
	        }
	    },
	    render: function render() {
	        var text = this.props.buttonText !== undefined ? this.props.buttonText : 'Contact Us';
	        return _react2['default'].createElement(_button2['default'], { ref: 'contactUsButton', buttonId: 'contactUsButton', buttonText: text, buttonHoverColor: 'cerulean', onClick: this.handleClick });
	    }
	});
	
	module.exports = ContactUsButton;

/***/ },
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1071);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	var _contactUsSuccess = __webpack_require__(1073);
	
	var _contactUsSuccess2 = _interopRequireDefault(_contactUsSuccess);
	
	var _marketoForm = __webpack_require__(1075);
	
	var _marketoForm2 = _interopRequireDefault(_marketoForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * This is a Contact Us modal used on the HelloSign web and API pricing pages.
	 */
	var ContactUsModal = _react2['default'].createClass({
	    displayName: 'ContactUsModal',
	
	
	    propTypes: {
	        'timePeriod': _react2['default'].PropTypes.string, // FIXME: We aren't actually using this
	        'pricingSource': _react2['default'].PropTypes.string,
	        'headerText': _react2['default'].PropTypes.string,
	        'onSuccess': _react2['default'].PropTypes.func
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            'timePeriod': 'Y'
	        };
	    },
	    getDefaultProps: function getDefaultProps() {
	        return {
	            'onSuccess': void 0,
	            'headerText': 'Need to add more seats?'
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        if (true) {
	            $(document).foundation();
	            $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
	        }
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	        if (true) {
	            $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
	        }
	    },
	
	
	    // Set up handler for when form is successfully submitted
	    handleMarketoFormLoaded: function handleMarketoFormLoaded(form) {
	        form.onSuccess(function () {
	            // Show thank you message
	            $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'close');
	            hellofaxJS.trackGoogleAnalyticsEvent('sales', 'contactus');
	            if (this.props.onSuccess) {
	                this.props.onSuccess();
	            } else {
	                var attachPoint = _hfReactHelper2['default'].getRevealAttachPoint('contact_us_modal_success', 'medium');
	                _reactDom2['default'].render(_react2['default'].createElement(_contactUsSuccess2['default'], null), attachPoint);
	            }
	
	            // Return false to prevent the submission handler from taking the lead to the follow up url
	            return false;
	        }.bind(this));
	    },
	    render: function render() {
	        // Change some stuff based on the pricingSource (web or api)
	        var modalHeader = this.props.headerText;
	        var marketoFormId = 1116; // Non-API Pricing Page Form
	        if (this.props.pricingSource == 'api') {
	            modalHeader = 'Need more?';
	            marketoFormId = 1115; // API Pricing Page Form
	        } else if (this.props.pricingSource == 'eventbrite') {
	            modalHeader = 'Need more?';
	            marketoFormId = 1214; // Eventbrite Pricing Page Form
	        }
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'm-contact-us row text-center' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'columns small-12' },
	                _react2['default'].createElement(
	                    'h3',
	                    null,
	                    modalHeader
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'row' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'columns small-10 small-offset-1 l-padding-t-10 l-padding-b-20' },
	                    _react2['default'].createElement(
	                        'p',
	                        null,
	                        'Please contact us below and we\'ll get back to you right away!'
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'columns small-12' },
	                    _react2['default'].createElement(_marketoForm2['default'], { formId: marketoFormId, onLoad: this.handleMarketoFormLoaded, trackingId: 'contactus' })
	                )
	            )
	        );
	    }
	});
	
	module.exports = ContactUsModal;

/***/ },
/* 1071 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1072 */,
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * "Contact Us" Modal
	 *
	 * May want to break this out into its own component, but for now
	 * it's only being used in the CorporatePricingLevel component so
	 * we'll keep it here for now.
	 *
	 * Also uses 'contact-us-modal.scss'
	 */
	var ContactUsSuccess = _react2['default'].createClass({
	    displayName: 'ContactUsSuccess',
	    componentDidMount: function componentDidMount() {
	        if (true) {
	            $(document).foundation();
	            $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
	        }
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	        if (true) {
	            $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
	        }
	    },
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            { className: 'm-contact-us text-center l-padding-h-80' },
	            _react2['default'].createElement('img', { className: 'l-padding-v-20 m-contact-us--checkmark', src: __webpack_require__(1074) }),
	            _react2['default'].createElement(
	                'h4',
	                null,
	                'Thanks for reaching out.',
	                _react2['default'].createElement('br', null),
	                'We\'ll get back to you shortly.'
	            )
	        );
	    }
	});
	
	module.exports = ContactUsSuccess;

/***/ },
/* 1074 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/803ceb3fef1efc0176285e042981e5b2.png";

/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1076);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _marketoForm = __webpack_require__(1078);
	
	var _marketoForm2 = _interopRequireDefault(_marketoForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * MarketoForm
	 *
	 * React component for embedding a Marketo Forms 2.0 form
	 *
	 * Marketo's API docs: http://developers.marketo.com/documentation/websites/forms-2-0/
	 *
	 * Normally, you embed a Marketo form like this:
	 *
	 *     <script src="//app-ab07.marketo.com/js/forms2/js/forms2.min.js"></script>
	 *     <form id="mktoForm_1115"></form>
	 *     <script>MktoForms2.loadForm("//app-ab07.marketo.com", "925-YQB-645", 1115);</script>
	 *
	 * This React component wraps that functionality for you. All you need to provide are the arguments to
	 *
	 *     MktoForms2.loadForm(baseUrl, munchkinId, formId, [onLoad callback])
	 *
	 * (as seen in the example above) as React props.
	 *
	 * TODO: Show some visual indication that the form is loading before Marketo injects it?
	 * TODO: (That could be accomplished by defining a callback function here, which removes a loading indicator after load)
	 * TODO: Show some fallback message when Marketo is blocked or fails to inject the form?
	 */
	var MarketoForm = _react2['default'].createClass({
	    displayName: 'MarketoForm',
	
	
	    //mixins: [watchAppNotifierMixin],
	
	    propTypes: {
	        'baseUrl': _react2['default'].PropTypes.string, // All of our forms use the same base URL so far, so this is optional
	        'munchkinId': _react2['default'].PropTypes.string, // All of our forms use the same munchkinId so far, so this is optional
	        'formId': _react2['default'].PropTypes.number.isRequired, // Numeric, typically 4-digit form ID
	        'className': _react2['default'].PropTypes.string, // Optional class name(s) for the form element
	        'onLoad': _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.func]),
	        'trackingId': _react2['default'].PropTypes.string //Optional, will be used for sending as tracking action to GA
	    },
	
	    getInitialState: function getInitialState() {
	        return {};
	    },
	    getDefaultProps: function getDefaultProps() {
	        return {
	            'baseUrl': '//app-ab07.marketo.com',
	            'munchkinId': '925-YQB-645',
	            'onLoad': null,
	            'className': '',
	            'trackingId': 'marketoform'
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        // Then call loadForm on our div
	        _marketoForm2['default'].loadForm(this.props.baseUrl, this.props.munchkinId, this.props.formId, this.onLoad);
	    },
	    shouldComponentUpdate: function shouldComponentUpdate() {
	        // We never want to re-render, since that would override the content injected by Marketo's script
	        return false;
	    },
	    onLoad: function onLoad(form) {
	        // Add values to hidden form fields
	        // TODO: Ask Paul to add a hidden field for this, and supply timePeriod into it
	        // Example: form.vals({"userIsAwesome":"true", "enrollDate":"2014-01-01"});
	
	        // TODO: Also set email/name from account profile if logged in
	
	        // Extract UTM tags from cookies
	        var utm_cookies = {
	            'hf_source': '',
	            'hf_campaign': '',
	            'hf_medium': '',
	            'hf_channel': '',
	            'hf_source_lt': '',
	            'hf_campaign_lt': '',
	            'hf_medium_lt': '',
	            'hf_channel_lt': ''
	        };
	        var pairs = document.cookie.split(';');
	        for (var k in pairs) {
	            var parts = $.trim(pairs[k]).split('=');
	            var name = parts.shift();
	            var value = parts.join('=');
	            if (name in utm_cookies) {
	                utm_cookies[name] = value;
	            }
	        }
	
	        // Add extracted UTM values to form submission
	        form.setValues({
	            'UTM_Source__c': utm_cookies['hf_source'],
	            'UTM_Campaign__c': utm_cookies['hf_campaign'],
	            'UTM_Medium__c': utm_cookies['hf_medium'],
	            'UTM_Channel__c': utm_cookies['hf_channel'],
	            'LT_UTM_Source__c': utm_cookies['hf_source_lt'],
	            'LT_UTM_Campaign__c': utm_cookies['hf_campaign_lt'],
	            'LT_UTM_Medium__c': utm_cookies['hf_medium_lt'],
	            'LT_UTM_Channel__c': utm_cookies['hf_channel_lt']
	        });
	
	        var onLoadFn = this.props.onLoad;
	        if (onLoadFn && typeof onLoadFn !== 'function') {
	            // onLoadFn refers to a function on window
	            onLoadFn = window[this.props.onLoad];
	        }
	        if (onLoadFn) {
	            // Execute onLoad function
	            onLoadFn(form);
	        }
	
	        form.onSuccess(this.onFormSuccess);
	    },
	    onFormSuccess: function onFormSuccess(e) {
	        hellofaxJS.trackGoogleAnalyticsEvent(this.props.trackingId, 'Form', window.location.pathname + window.location.search);
	    },
	    render: function render() {
	        var formId = 'mktoForm_' + this.props.formId;
	        var classNames = 'rx-marketo-form ' + this.props.className;
	        return _react2['default'].createElement(
	            'div',
	            { className: 'm-marketo-form' },
	            _react2['default'].createElement('form', { id: formId, className: classNames })
	        );
	    }
	});
	
	module.exports = MarketoForm;

/***/ },
/* 1076 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1077 */,
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	var require;var require;var __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*! forms2 2016-04-08  See forms2.js for license info */
	!function a(b,c,d){function e(g,h){if(!c[g]){if(!b[g]){var i="function"==typeof require&&require;if(!h&&i)return require(g,!0);if(f)return f(g,!0);var j=new Error("Cannot find module '"+g+"'");throw j.code="MODULE_NOT_FOUND",j}var k=c[g]={exports:{}};b[g][0].call(k.exports,function(a){var c=b[g][1][a];return e(c?c:a)},k,k.exports,a,b,c,d)}return c[g].exports}for(var f="function"==typeof require&&require,g=0;g<d.length;g++)e(d[g]);return e}({1:[function(a,b){function c(){this._events=this._events||{},this._maxListeners=this._maxListeners||void 0}function d(a){return"function"==typeof a}function e(a){return"number"==typeof a}function f(a){return"object"==typeof a&&null!==a}function g(a){return void 0===a}b.exports=c,c.EventEmitter=c,c.prototype._events=void 0,c.prototype._maxListeners=void 0,c.defaultMaxListeners=10,c.prototype.setMaxListeners=function(a){if(!e(a)||0>a||isNaN(a))throw TypeError("n must be a positive number");return this._maxListeners=a,this},c.prototype.emit=function(a){var b,c,e,h,i,j;if(this._events||(this._events={}),"error"===a&&(!this._events.error||f(this._events.error)&&!this._events.error.length)){if(b=arguments[1],b instanceof Error)throw b;throw TypeError('Uncaught, unspecified "error" event.')}if(c=this._events[a],g(c))return!1;if(d(c))switch(arguments.length){case 1:c.call(this);break;case 2:c.call(this,arguments[1]);break;case 3:c.call(this,arguments[1],arguments[2]);break;default:for(e=arguments.length,h=new Array(e-1),i=1;e>i;i++)h[i-1]=arguments[i];c.apply(this,h)}else if(f(c)){for(e=arguments.length,h=new Array(e-1),i=1;e>i;i++)h[i-1]=arguments[i];for(j=c.slice(),e=j.length,i=0;e>i;i++)j[i].apply(this,h)}return!0},c.prototype.addListener=function(a,b){var e;if(!d(b))throw TypeError("listener must be a function");if(this._events||(this._events={}),this._events.newListener&&this.emit("newListener",a,d(b.listener)?b.listener:b),this._events[a]?f(this._events[a])?this._events[a].push(b):this._events[a]=[this._events[a],b]:this._events[a]=b,f(this._events[a])&&!this._events[a].warned){var e;e=g(this._maxListeners)?c.defaultMaxListeners:this._maxListeners,e&&e>0&&this._events[a].length>e&&(this._events[a].warned=!0,console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.",this._events[a].length),"function"==typeof console.trace&&console.trace())}return this},c.prototype.on=c.prototype.addListener,c.prototype.once=function(a,b){function c(){this.removeListener(a,c),e||(e=!0,b.apply(this,arguments))}if(!d(b))throw TypeError("listener must be a function");var e=!1;return c.listener=b,this.on(a,c),this},c.prototype.removeListener=function(a,b){var c,e,g,h;if(!d(b))throw TypeError("listener must be a function");if(!this._events||!this._events[a])return this;if(c=this._events[a],g=c.length,e=-1,c===b||d(c.listener)&&c.listener===b)delete this._events[a],this._events.removeListener&&this.emit("removeListener",a,b);else if(f(c)){for(h=g;h-->0;)if(c[h]===b||c[h].listener&&c[h].listener===b){e=h;break}if(0>e)return this;1===c.length?(c.length=0,delete this._events[a]):c.splice(e,1),this._events.removeListener&&this.emit("removeListener",a,b)}return this},c.prototype.removeAllListeners=function(a){var b,c;if(!this._events)return this;if(!this._events.removeListener)return 0===arguments.length?this._events={}:this._events[a]&&delete this._events[a],this;if(0===arguments.length){for(b in this._events)"removeListener"!==b&&this.removeAllListeners(b);return this.removeAllListeners("removeListener"),this._events={},this}if(c=this._events[a],d(c))this.removeListener(a,c);else for(;c.length;)this.removeListener(a,c[c.length-1]);return delete this._events[a],this},c.prototype.listeners=function(a){var b;return b=this._events&&this._events[a]?d(this._events[a])?[this._events[a]]:this._events[a].slice():[]},c.listenerCount=function(a,b){var c;return c=a._events&&a._events[b]?d(a._events[b])?1:a._events[b].length:0}},{}],2:[function(a,b,c){(function(a){!function(d){function e(a){throw RangeError(H[a])}function f(a,b){for(var c=a.length;c--;)a[c]=b(a[c]);return a}function g(a,b){return f(a.split(G),b).join(".")}function h(a){for(var b,c,d=[],e=0,f=a.length;f>e;)b=a.charCodeAt(e++),b>=55296&&56319>=b&&f>e?(c=a.charCodeAt(e++),56320==(64512&c)?d.push(((1023&b)<<10)+(1023&c)+65536):(d.push(b),e--)):d.push(b);return d}function i(a){return f(a,function(a){var b="";return a>65535&&(a-=65536,b+=K(a>>>10&1023|55296),a=56320|1023&a),b+=K(a)}).join("")}function j(a){return 10>a-48?a-22:26>a-65?a-65:26>a-97?a-97:w}function k(a,b){return a+22+75*(26>a)-((0!=b)<<5)}function l(a,b,c){var d=0;for(a=c?J(a/A):a>>1,a+=J(a/b);a>I*y>>1;d+=w)a=J(a/I);return J(d+(I+1)*a/(a+z))}function m(a){var b,c,d,f,g,h,k,m,n,o,p=[],q=a.length,r=0,s=C,t=B;for(c=a.lastIndexOf(D),0>c&&(c=0),d=0;c>d;++d)a.charCodeAt(d)>=128&&e("not-basic"),p.push(a.charCodeAt(d));for(f=c>0?c+1:0;q>f;){for(g=r,h=1,k=w;f>=q&&e("invalid-input"),m=j(a.charCodeAt(f++)),(m>=w||m>J((v-r)/h))&&e("overflow"),r+=m*h,n=t>=k?x:k>=t+y?y:k-t,!(n>m);k+=w)o=w-n,h>J(v/o)&&e("overflow"),h*=o;b=p.length+1,t=l(r-g,b,0==g),J(r/b)>v-s&&e("overflow"),s+=J(r/b),r%=b,p.splice(r++,0,s)}return i(p)}function n(a){var b,c,d,f,g,i,j,m,n,o,p,q,r,s,t,u=[];for(a=h(a),q=a.length,b=C,c=0,g=B,i=0;q>i;++i)p=a[i],128>p&&u.push(K(p));for(d=f=u.length,f&&u.push(D);q>d;){for(j=v,i=0;q>i;++i)p=a[i],p>=b&&j>p&&(j=p);for(r=d+1,j-b>J((v-c)/r)&&e("overflow"),c+=(j-b)*r,b=j,i=0;q>i;++i)if(p=a[i],b>p&&++c>v&&e("overflow"),p==b){for(m=c,n=w;o=g>=n?x:n>=g+y?y:n-g,!(o>m);n+=w)t=m-o,s=w-o,u.push(K(k(o+t%s,0))),m=J(t/s);u.push(K(k(m,0))),g=l(c,r,d==f),c=0,++d}++c,++b}return u.join("")}function o(a){return g(a,function(a){return E.test(a)?m(a.slice(4).toLowerCase()):a})}function p(a){return g(a,function(a){return F.test(a)?"xn--"+n(a):a})}var q="object"==typeof c&&c,r="object"==typeof b&&b&&b.exports==q&&b,s="object"==typeof a&&a;(s.global===s||s.window===s)&&(d=s);var t,u,v=2147483647,w=36,x=1,y=26,z=38,A=700,B=72,C=128,D="-",E=/^xn--/,F=/[^ -~]/,G=/\x2E|\u3002|\uFF0E|\uFF61/g,H={overflow:"Overflow: input needs wider integers to process","not-basic":"Illegal input >= 0x80 (not a basic code point)","invalid-input":"Invalid input"},I=w-x,J=Math.floor,K=String.fromCharCode;if(t={version:"1.2.4",ucs2:{decode:h,encode:i},decode:m,encode:n,toASCII:p,toUnicode:o},"function"=="function"&&"object"==typeof __webpack_require__(1079)&&__webpack_require__(1079))!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return t}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if(q&&!q.nodeType)if(r)r.exports=t;else for(u in t)t.hasOwnProperty(u)&&(q[u]=t[u]);else d.punycode=t}(this)}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],3:[function(a,b){"use strict";function c(a,b){return Object.prototype.hasOwnProperty.call(a,b)}b.exports=function(a,b,e,f){b=b||"&",e=e||"=";var g={};if("string"!=typeof a||0===a.length)return g;var h=/\+/g;a=a.split(b);var i=1e3;f&&"number"==typeof f.maxKeys&&(i=f.maxKeys);var j=a.length;i>0&&j>i&&(j=i);for(var k=0;j>k;++k){var l,m,n,o,p=a[k].replace(h,"%20"),q=p.indexOf(e);q>=0?(l=p.substr(0,q),m=p.substr(q+1)):(l=p,m=""),n=decodeURIComponent(l),o=decodeURIComponent(m),c(g,n)?d(g[n])?g[n].push(o):g[n]=[g[n],o]:g[n]=o}return g};var d=Array.isArray||function(a){return"[object Array]"===Object.prototype.toString.call(a)}},{}],4:[function(a,b){"use strict";function c(a,b){if(a.map)return a.map(b);for(var c=[],d=0;d<a.length;d++)c.push(b(a[d],d));return c}var d=function(a){switch(typeof a){case"string":return a;case"boolean":return a?"true":"false";case"number":return isFinite(a)?a:"";default:return""}};b.exports=function(a,b,g,h){return b=b||"&",g=g||"=",null===a&&(a=void 0),"object"==typeof a?c(f(a),function(f){var h=encodeURIComponent(d(f))+g;return e(a[f])?c(a[f],function(a){return h+encodeURIComponent(d(a))}).join(b):h+encodeURIComponent(d(a[f]))}).join(b):h?encodeURIComponent(d(h))+g+encodeURIComponent(d(a)):""};var e=Array.isArray||function(a){return"[object Array]"===Object.prototype.toString.call(a)},f=Object.keys||function(a){var b=[];for(var c in a)Object.prototype.hasOwnProperty.call(a,c)&&b.push(c);return b}},{}],5:[function(a,b,c){"use strict";c.decode=c.parse=a("./decode"),c.encode=c.stringify=a("./encode")},{"./decode":3,"./encode":4}],6:[function(a,b,c){function d(){this.protocol=null,this.slashes=null,this.auth=null,this.host=null,this.port=null,this.hostname=null,this.hash=null,this.search=null,this.query=null,this.pathname=null,this.path=null,this.href=null}function e(a,b,c){if(a&&j(a)&&a instanceof d)return a;var e=new d;return e.parse(a,b,c),e}function f(a){return i(a)&&(a=e(a)),a instanceof d?a.format():d.prototype.format.call(a)}function g(a,b){return e(a,!1,!0).resolve(b)}function h(a,b){return a?e(a,!1,!0).resolveObject(b):b}function i(a){return"string"==typeof a}function j(a){return"object"==typeof a&&null!==a}function k(a){return null===a}function l(a){return null==a}var m=a("punycode");c.parse=e,c.resolve=g,c.resolveObject=h,c.format=f,c.Url=d;var n=/^([a-z0-9.+-]+:)/i,o=/:[0-9]*$/,p=["<",">",'"',"`"," ","\r","\n","	"],q=["{","}","|","\\","^","`"].concat(p),r=["'"].concat(q),s=["%","/","?",";","#"].concat(r),t=["/","?","#"],u=255,v=/^[a-z0-9A-Z_-]{0,63}$/,w=/^([a-z0-9A-Z_-]{0,63})(.*)$/,x={javascript:!0,"javascript:":!0},y={javascript:!0,"javascript:":!0},z={http:!0,https:!0,ftp:!0,gopher:!0,file:!0,"http:":!0,"https:":!0,"ftp:":!0,"gopher:":!0,"file:":!0},A=a("querystring");d.prototype.parse=function(a,b,c){if(!i(a))throw new TypeError("Parameter 'url' must be a string, not "+typeof a);var d=a;d=d.trim();var e=n.exec(d);if(e){e=e[0];var f=e.toLowerCase();this.protocol=f,d=d.substr(e.length)}if(c||e||d.match(/^\/\/[^@\/]+@[^@\/]+/)){var g="//"===d.substr(0,2);!g||e&&y[e]||(d=d.substr(2),this.slashes=!0)}if(!y[e]&&(g||e&&!z[e])){for(var h=-1,j=0;j<t.length;j++){var k=d.indexOf(t[j]);-1!==k&&(-1===h||h>k)&&(h=k)}var l,o;o=-1===h?d.lastIndexOf("@"):d.lastIndexOf("@",h),-1!==o&&(l=d.slice(0,o),d=d.slice(o+1),this.auth=decodeURIComponent(l)),h=-1;for(var j=0;j<s.length;j++){var k=d.indexOf(s[j]);-1!==k&&(-1===h||h>k)&&(h=k)}-1===h&&(h=d.length),this.host=d.slice(0,h),d=d.slice(h),this.parseHost(),this.hostname=this.hostname||"";var p="["===this.hostname[0]&&"]"===this.hostname[this.hostname.length-1];if(!p)for(var q=this.hostname.split(/\./),j=0,B=q.length;B>j;j++){var C=q[j];if(C&&!C.match(v)){for(var D="",E=0,F=C.length;F>E;E++)D+=C.charCodeAt(E)>127?"x":C[E];if(!D.match(v)){var G=q.slice(0,j),H=q.slice(j+1),I=C.match(w);I&&(G.push(I[1]),H.unshift(I[2])),H.length&&(d="/"+H.join(".")+d),this.hostname=G.join(".");break}}}if(this.hostname=this.hostname.length>u?"":this.hostname.toLowerCase(),!p){for(var J=this.hostname.split("."),K=[],j=0;j<J.length;++j){var L=J[j];K.push(L.match(/[^A-Za-z0-9_-]/)?"xn--"+m.encode(L):L)}this.hostname=K.join(".")}var M=this.port?":"+this.port:"",N=this.hostname||"";this.host=N+M,this.href+=this.host,p&&(this.hostname=this.hostname.substr(1,this.hostname.length-2),"/"!==d[0]&&(d="/"+d))}if(!x[f])for(var j=0,B=r.length;B>j;j++){var O=r[j],P=encodeURIComponent(O);P===O&&(P=escape(O)),d=d.split(O).join(P)}var Q=d.indexOf("#");-1!==Q&&(this.hash=d.substr(Q),d=d.slice(0,Q));var R=d.indexOf("?");if(-1!==R?(this.search=d.substr(R),this.query=d.substr(R+1),b&&(this.query=A.parse(this.query)),d=d.slice(0,R)):b&&(this.search="",this.query={}),d&&(this.pathname=d),z[f]&&this.hostname&&!this.pathname&&(this.pathname="/"),this.pathname||this.search){var M=this.pathname||"",L=this.search||"";this.path=M+L}return this.href=this.format(),this},d.prototype.format=function(){var a=this.auth||"";a&&(a=encodeURIComponent(a),a=a.replace(/%3A/i,":"),a+="@");var b=this.protocol||"",c=this.pathname||"",d=this.hash||"",e=!1,f="";this.host?e=a+this.host:this.hostname&&(e=a+(-1===this.hostname.indexOf(":")?this.hostname:"["+this.hostname+"]"),this.port&&(e+=":"+this.port)),this.query&&j(this.query)&&Object.keys(this.query).length&&(f=A.stringify(this.query));var g=this.search||f&&"?"+f||"";return b&&":"!==b.substr(-1)&&(b+=":"),this.slashes||(!b||z[b])&&e!==!1?(e="//"+(e||""),c&&"/"!==c.charAt(0)&&(c="/"+c)):e||(e=""),d&&"#"!==d.charAt(0)&&(d="#"+d),g&&"?"!==g.charAt(0)&&(g="?"+g),c=c.replace(/[?#]/g,function(a){return encodeURIComponent(a)}),g=g.replace("#","%23"),b+e+c+g+d},d.prototype.resolve=function(a){return this.resolveObject(e(a,!1,!0)).format()},d.prototype.resolveObject=function(a){if(i(a)){var b=new d;b.parse(a,!1,!0),a=b}var c=new d;if(Object.keys(this).forEach(function(a){c[a]=this[a]},this),c.hash=a.hash,""===a.href)return c.href=c.format(),c;if(a.slashes&&!a.protocol)return Object.keys(a).forEach(function(b){"protocol"!==b&&(c[b]=a[b])}),z[c.protocol]&&c.hostname&&!c.pathname&&(c.path=c.pathname="/"),c.href=c.format(),c;if(a.protocol&&a.protocol!==c.protocol){if(!z[a.protocol])return Object.keys(a).forEach(function(b){c[b]=a[b]}),c.href=c.format(),c;if(c.protocol=a.protocol,a.host||y[a.protocol])c.pathname=a.pathname;else{for(var e=(a.pathname||"").split("/");e.length&&!(a.host=e.shift()););a.host||(a.host=""),a.hostname||(a.hostname=""),""!==e[0]&&e.unshift(""),e.length<2&&e.unshift(""),c.pathname=e.join("/")}if(c.search=a.search,c.query=a.query,c.host=a.host||"",c.auth=a.auth,c.hostname=a.hostname||a.host,c.port=a.port,c.pathname||c.search){var f=c.pathname||"",g=c.search||"";c.path=f+g}return c.slashes=c.slashes||a.slashes,c.href=c.format(),c}var h=c.pathname&&"/"===c.pathname.charAt(0),j=a.host||a.pathname&&"/"===a.pathname.charAt(0),m=j||h||c.host&&a.pathname,n=m,o=c.pathname&&c.pathname.split("/")||[],e=a.pathname&&a.pathname.split("/")||[],p=c.protocol&&!z[c.protocol];if(p&&(c.hostname="",c.port=null,c.host&&(""===o[0]?o[0]=c.host:o.unshift(c.host)),c.host="",a.protocol&&(a.hostname=null,a.port=null,a.host&&(""===e[0]?e[0]=a.host:e.unshift(a.host)),a.host=null),m=m&&(""===e[0]||""===o[0])),j)c.host=a.host||""===a.host?a.host:c.host,c.hostname=a.hostname||""===a.hostname?a.hostname:c.hostname,c.search=a.search,c.query=a.query,o=e;else if(e.length)o||(o=[]),o.pop(),o=o.concat(e),c.search=a.search,c.query=a.query;else if(!l(a.search)){if(p){c.hostname=c.host=o.shift();var q=c.host&&c.host.indexOf("@")>0?c.host.split("@"):!1;q&&(c.auth=q.shift(),c.host=c.hostname=q.shift())}return c.search=a.search,c.query=a.query,k(c.pathname)&&k(c.search)||(c.path=(c.pathname?c.pathname:"")+(c.search?c.search:"")),c.href=c.format(),c}if(!o.length)return c.pathname=null,c.path=c.search?"/"+c.search:null,c.href=c.format(),c;for(var r=o.slice(-1)[0],s=(c.host||a.host)&&("."===r||".."===r)||""===r,t=0,u=o.length;u>=0;u--)r=o[u],"."==r?o.splice(u,1):".."===r?(o.splice(u,1),t++):t&&(o.splice(u,1),t--);if(!m&&!n)for(;t--;t)o.unshift("..");!m||""===o[0]||o[0]&&"/"===o[0].charAt(0)||o.unshift(""),s&&"/"!==o.join("/").substr(-1)&&o.push("");var v=""===o[0]||o[0]&&"/"===o[0].charAt(0);if(p){c.hostname=c.host=v?"":o.length?o.shift():"";var q=c.host&&c.host.indexOf("@")>0?c.host.split("@"):!1;q&&(c.auth=q.shift(),c.host=c.hostname=q.shift())}return m=m||c.host&&o.length,m&&!v&&o.unshift(""),o.length?c.pathname=o.join("/"):(c.pathname=null,c.path=null),k(c.pathname)&&k(c.search)||(c.path=(c.pathname?c.pathname:"")+(c.search?c.search:"")),c.auth=a.auth||c.auth,c.slashes=c.slashes||a.slashes,c.href=c.format(),c},d.prototype.parseHost=function(){var a=this.host,b=o.exec(a);b&&(b=b[0],":"!==b&&(this.port=b.substr(1)),a=a.substr(0,a.length-b.length)),a&&(this.hostname=a)}},{punycode:2,querystring:5}],7:[function(a,b){var c=function(a,b,c){c=c||{};var d=c.encode||g,e=[a+"="+d(b)];return c.maxAge&&e.push("Max-Age="+c.maxAge),c.domain&&e.push("Domain="+c.domain),c.path&&e.push("Path="+c.path),c.expires&&e.push("Expires="+c.expires.toUTCString()),c.httpOnly&&e.push("HttpOnly"),c.secure&&e.push("Secure"),e.join("; ")},d=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,e=function(a){return a.trim?a.trim():a.replace(d,"")},f=function(a,b){b=b||{};for(var c={},d=a.split(/[;,] */),f=b.decode||h,g=d.length,i=0;g>i;i++){var j=d[i],k=j.indexOf("=");if(!(0>k)){var l=e(j.substr(0,k)),m=e(j.substr(++k,j.length));if('"'==m[0]&&(m=m.slice(1,-1)),void 0==c[l])try{c[l]=f(m)}catch(n){c[l]=m}}}return c},g=encodeURIComponent,h=decodeURIComponent;b.exports.serialize=c,b.exports.parse=f},{}],8:[function(a,b){b.exports=a("./jquery.build.js")},{"./jquery.build.js":9}],9:[function(a,b){!function(){var a=function(a,b){var c=!0;try{var d=b.createElement("button");d.type="button"}catch(e){c=!1}var f=b.createElement("style");f.type="text/css";var g=f.styleSheet&&"cssText"in f.styleSheet,h=b.createElement("div");h.innerHTML=" s ";var i=h.childNodes[0].nodeValue,j=0!=i.indexOf(" "),k=2!=i.lastIndexOf(" "),l=/&apos;/g,m=/^((?:[\w\u00c0-\uFFFF\*_-]|\\.)+)/,n=/#((?:[\w\u00c0-\uFFFF_-]|\\.)+)/,o=/\.((?:[\w\u00c0-\uFFFF_-]|\\.)+)/g,p=/\[\s*((?:[\w\u00c0-\uFFFF_-]|\\.)+)\s*(?:(\S?=)\s*(['"]*)(.*?)\3|)\s*\]/g,q=/[\[\]]/g,r=function(a,c){j&&" "===c.charAt(0)&&a.appendChild(b.createTextNode(" ")),a.appendChild(b.createTextNode(c)),k&&" "===c.charAt(c.length-1)&&a.appendChild(b.createTextNode(" "))},s=function(b,c){if(c)if(c.jquery)b.appendChild(c.get(0));else if(1==c.nodeType||3==c.nodeType||11==c.nodeType)b.appendChild(c);else if(a.isArray(c)){var d=0,e=c.length;for(d=0;e>d;d++)s(b,c[d])}else r(b,c.toString())},t=function(c){var d=b.createDocumentFragment();if(c)if(a.isArray(c)){var e=0,f=c.length;for(e=0;f>e;e++)s(d,c[e])}else s(d,c);return d},u=function(a){var c=b.createDocumentFragment();if(a)if("undefined"!=typeof c.innerHTML)c.innerHTML=a;else{var d=b.createElement("div");for(d.innerHTML=a.replace(l,"'"),j&&0==a.indexOf(" ")&&c.appendChild(b.createTextNode(" "));d.hasChildNodes();)c.appendChild(d.firstChild);k&&a.lastIndexOf(" ")==a.length-1&&c.appendChild(b.createTextNode(" "))}return c};return a.build=function(d,e,f){2==arguments.length&&null!=e&&("string"==typeof e||a.isArray(e)||e.nodeType||e.jquery)&&(f=e,e=null),d=d||"";var h;h=d.match(m),h&&(h=h[0]);var i=null;if(-1!=d.indexOf("#")){var i=d.match(n);i=i?i[1]:null}var j;-1!=d.indexOf(".")&&(j=d.match(o));var k;-1!=d.indexOf("[")&&(k=d.match(p)),h=h||"div",k&&(e=e||{},a.each(k,function(a,b){var c=b.replace(q,"").split("=");c&&2==c.length&&(e[c[0]]=c[1])})),e=e||{};var l;if(c||"input"!==h&&"button"!==h)l=b.createElement(h);else{var r=e.type?'type="'+e.type+'"':"",s=e.name?'name="'+e.name+'"':"";l=b.createElement("<"+h+" "+r+" "+s+">"),delete e.type,delete e.name}var u=a(l);if(e&&u.attr(e),i&&(l.id=i),"img"===h&&(e.width||u.removeAttr("width"),e.height||u.removeAttr("height")),j){var v="";a.each(j,function(a,b){v+=b.replace(".","")+" "}),l.className=a.trim(l.className+" "+v)}return g&&"style"==h&&"string"==typeof f?(u.attr("type")||u.attr("type","text/css"),l.styleSheet.cssText=f):f&&l.appendChild(11==f.nodeType?f:t(f)),u},a.build.docFrag=t,a.build.html=u,a.build};"undefined"!=typeof b&&b.exports&&(b.exports=a),"undefined"!=typeof window&&window.jQuery&&window.document&&a(window.jQuery,window.document)}()},{}],10:[function(a,b){function c(a,b){var c={};return g.each(a,function(a,d){if("hidden"!=d.Datatype&&"profiling"!=d.Datatype){var e=d.VisibilityRule;if(e){if("fieldset"==d.Datatype){var f=i.flatten(b.fieldsetRows[""+d.Id]),h=c[d.Name];h||(h=[]),h=h.concat(g.map(f,function(a){return a.Name})),c[d.Name]=h}var j=e.rules||[e];g.each(j,function(a,b){if("string"!=typeof b){var e=c[b.subjectField];e||(e=[]),-1===g.inArray(d.Name,e)&&e.push(d.Name),c[b.subjectField]=e}})}}}),c}function d(a,b){for(var c=a.length,d=0;c>d;d++){var e=a[d];if(b(e))return e}return void 0}function e(a,b){if(b&&(a.PicklistValues||b.picklistKeys||b.altLabel)){if(a=g.extend(!0,{},a),a.PicklistValues)if(b.picklistFilterValues){var c={};g.each(b.picklistFilterValues,function(a,b){c.hasOwnProperty(b.value)||(c[b.value]=[]),c[b.value].push(b.label)}),a.PicklistValues=g.map(a.PicklistValues,function(a){return c.hasOwnProperty(a.value)&&-1!=g.inArray(a.label,c[a.value])?a:void 0})}else b.picklistKeys&&(a.PicklistValues=g.map(a.PicklistValues,function(a){return-1!=g.inArray(a.value,b.picklistKeys)?a:void 0}));b.altLabel&&(a.InputLabel=b.altLabel)}return a}function f(a,b){if(!a)return{show:!0};var c="show"==a.defaultVisibility,e=a.rules||[a],f=g.map(e,function(a){if("string"!=typeof a){var c=b[a.subjectField];g.isArray(c)||(c=c?[c]:[]);var d=h[a.operator],e=d(c,a.values);return e?a:null}}),i=d(f,function(a){return null!==a});return c?{show:!i,rule:i}:{show:!!i,rule:i}}var g=a("./jquery.js"),h=a("./comparators.js"),i=a("./fields/fieldhelpers.js");b.exports={getChangeMap:c,fieldChangeChecker:f,applyPicklistAlterations:e}},{"./comparators.js":12,"./fields/fieldhelpers.js":16,"./jquery.js":31}],11:[function(a,b){function c(a){var b,c=parseInt;return a=(a||"").replace(/\s\s*/g,""),(b=/^#([\da-f]{2})([\da-f]{2})([\da-f]{2})/i.exec(a))?[c(b[1],16),c(b[2],16),c(b[3],16),1]:(b=/^#([\da-f])([\da-f])([\da-f])/i.exec(a))?[17*c(b[1],16),17*c(b[2],16),17*c(b[3],16),1]:(b=/^rgba\(([\d]+),([\d]+),([\d]+),([\d]+|[\d]*.[\d]+)\)/i.exec(a))?[+b[1],+b[2],+b[3],+b[4]]:(b=/^rgb\(([\d]+),([\d]+),([\d]+)\)/i.exec(a))?[+b[1],+b[2],+b[3],1]:null}function d(a,b){var d=c(a),e=c(b);if(!d||!e)return!1;for(var f=0;4>f;f++)if(d[f]!==e[f])return!1;return!0}b.exports={parseColor:c,compareColor:d}},{}],12:[function(a,b){var c=function(a,b,c){for(var d=[],e=0;e<a.length;e++)for(var f=0;f<b.length;f++)if(c(a[e],b[f])){d.push(a[e]);break}return d},d={equal:function(a,b){var d=function(a,b){return a===b};return c(a,b,d).length>0},notEqual:function(a,b){var d=function(a,b){return a===b};return 0===c(a,b,d).length},empty:function(a){return 0===a.length},notEmpty:function(a){return a.length>0},any:function(a){return a.length>0},startsWith:function(a,b){var d=function(a,b){return 0===a.indexOf(b)};return c(a,b,d).length>0},notStartsWith:function(a,b){var d=function(a,b){return 0===a.indexOf(b)};return 0===c(a,b,d).length},endsWith:function(a,b){var d=function(a,b){return a.lastIndexOf(b)===a.length-b.length};return c(a,b,d).length>0},notEndsWith:function(a,b){var d=function(a,b){return a.lastIndexOf(b)===a.length-b.length};return 0===c(a,b,d).length},contains:function(a,b){var d=function(a,b){return a.match(new RegExp(b,"g"))};return c(a,b,d).length>0},notContains:function(a,b){var d=function(a,b){return a.match(new RegExp(b,"g"))};return 0===c(a,b,d).length},atLeast:function(a,b){return a[0]>=b[0]},atMost:function(a,b){return a[0]<=b[0]},greaterThan:function(a,b){return a[0]>b[0]},lessThan:function(a,b){return a[0]<b[0]},between:function(a,b){return a[0]>b[0]&&a[0]<b[1]},notBetween:function(a,b){return a[0]<b[0]||a[0]>b[1]},inTimeFrame:function(a,b){return new Date(a[0])>new Date(b[0])&&new Date(a[0])<new Date(b[1])},notInTimeFrame:function(a,b){return new Date(a[0])<new Date(b[0])||new Date(a[0])>new Date(b[1])},inPast:function(a){return new Date(a[0])<new Date},notInPast:function(a){return new Date(a[0])>=new Date},before:function(a,b){return new Date(a[0])<new Date(b[0])},after:function(a,b){return new Date(a[0])>new Date(b[0])},onOrBefore:function(a,b){return new Date(a[0])<=new Date(b[0])},onOrAfter:function(a,b){return new Date(a[0])>=new Date(b[0])}};b.exports=d},{}],13:[function(a,b){function c(a,b){b=b||location.hostname;var c=new Date;c.setFullYear(c.getFullYear()-1);var e=[];document.cookie=d.serialize(a,"",{expires:c,path:"/"}),e.push("");for(var f=b.split(".");f.length>1;){var g="."+f.join(".");document.cookie=d.serialize(a,"",{expires:c,path:"/",domain:g}),e.push(g),f.shift()}return e}var d=a("cookie");b.exports.removeCookieAllDomains=c},{cookie:7}],14:[function(a,b){var c=a("../jquery.js"),d=(c.build,a("./fieldHelpers.js")),e={};b.exports=e,e.fieldType="currency";var f=/[0-9]+/g,g=function(a){return a?a.match(f):!0};e.newField=function(a,b){var e=d.renderInput("text",a,b);return{name:a.Name,elem:d.formatStandardField(e,a,b),val:c.proxy(e.val,e),required:a.IsRequired,validator:g,validatorElem:e,onChange:function(a){e.on("change",a)}}}},{"../jquery.js":31,"./fieldHelpers.js":15}],15:[function(a,b){var c=a("../jquery.js"),d=c.build,e={};e.splitSemis=function(a){return a=""+a,a.split(/\s?;\s?/)},e.cap=function(a){return a.charAt(0).toUpperCase()+a.slice(1)},e.first=function(){for(var a=0;a<arguments.length;a++){var b=arguments[a];if(null!==b&&void 0!==b)return b}return null},e.formatStandardField=function(a,b,c){var f,g=e.first,h=d.docFrag([d(".mktoOffset").css({width:g(b.OffsetWidth,c.OffsetWidth,0)}),f=d(".mktoFieldWrap",[d("label.mktoLabel.mktoHasWidth",{"for":b.Name},[d(".mktoAsterix","*"),d.html(b.InputLabel)]).css({width:g(b.LabelWidth,c.LabelWidth,0)}),d(".mktoGutter.mktoHasWidth").css({width:g(b.GutterWidth,c.GutterWidth,0)}),a.addClass("mktoHasWidth").css({width:g(b.FieldWidth,c.FieldWidth,0)}),d(".mktoClear")]),d(".mktoClear")]);return b.IsRequired&&f.addClass("mktoRequiredField"),h},e.renderInput=function(a,b){var c=d("input[type="+a+"].mktoField.mkto"+e.cap(a)+"Field",{id:b.Name,name:b.Name,placeholder:b.PlaceholderText,maxlength:b.Maxlength||2e3,title:b.Description});return c},e.isSet=function(a){return null!==a&&void 0!==a},e.flatten=function(a,b){return b=b||[],c.each(a,function(a,d){c.isArray(d)?e.flatten(d,b):b.push(d)}),b},e.vals=function(a){return c.map(a,function(a){return a})},e.getFlattenedFields=function(a){var b=[];return b=e.flatten(a.rows),a.fieldsetRows&&(b=b.concat(e.flatten(e.vals(a.fieldsetRows)))),b},e.getFieldTypes=function(a){for(var b={},c=0;c<a.length;c++)b[a[c].Datatype]=!0;return b},e.anyFieldHasProperty=function(a,b){for(var c=0;c<a.length;c++)if(a[c][b])return!0;return!1},e.getFieldsByName=function(a){var b={};return c.each(a,function(a,c){b[c.Name]=c}),b},b.exports=e},{"../jquery.js":31}],16:[function(a,b,c){arguments[4][15][0].apply(c,arguments)},{"../jquery.js":31,dup:15}],17:[function(a,b){var c=a("../jquery.js"),d=c.build,e=a("./fieldHelpers.js"),f={};b.exports=f,f.fieldType="checkbox";var g={"true":"false",1:"0",Yes:"No",yes:"no"},h=function(a,b){return function(d){var f=a.find("input");if(0===arguments.length){if(b)return f.is(":checked")?b:g[b];f=a.find("input:checked");var h=[];return f.each(function(){h.push(c(this).val())}),h.length?1==h.length?h[0]:h:void 0}return b&&"boolean"==typeof d?void a.find("input").prop("checked",d):void(b&&null===d||(d&&!c.isArray(d)&&(d=""+d,d=e.splitSemis(""+d)),a.find("input").prop("checked",!1),d&&c.each(d,function(b,c){a.find("input[value='"+c+"']").prop("checked",!0)})))}};f.newField=function(a,b){var f=a.PicklistValues||[],i=d(".mktoLogicalField.mktoCheckboxList",{title:a.Description},[c.map(f,function(b,c){var e="mktoCheckbox_"+(a.Id||a.Name)+"_"+c,g=b.label||b.name;return 1!=f.length||g||(e=a.Name),d.docFrag([d("input.mktoField",{name:a.Name,id:e,type:"checkbox",value:b.value}),d("label",{"for":e},[d.html(g)])])})]);a.IsLabelToLeft&&i.addClass("mktoLabelToLeft");var j="";return 1===f.length&&-1!==c.inArray(f[0].value,Object.keys(g))&&(j=f[0].value),{name:a.Name,elem:e.formatStandardField(i,a,b),val:h(i,j),required:a.IsRequired,requiredValFn:function(a){return a=c.trim(a),a&&j?a!==g[j]:!!a},validatorElem:i,validatorFocusElem:i.find("input:eq(0)"),onChange:function(a){i.on("change",a)}}}},{"../jquery.js":31,"./fieldHelpers.js":15}],18:[function(a,b){var c=a("../jquery.js"),d=(c.build,a("./fieldHelpers.js")),e={};b.exports=e,e.fieldType="date";var f=function(a){var b=a.get(0);return b.validity&&!b.validity.valid?!1:!0};e.newField=function(a,b){var e=d.renderInput("date",a,b),g="en_US";return b.ProcessOptions&&b.ProcessOptions.locale&&(g=b.ProcessOptions.locale),e.data("mktoLocale",g),{name:a.Name,elem:d.formatStandardField(e,a,b),val:c.proxy(e.val,e),validator:function(){return f(e)},required:a.IsRequired,validatorElem:e,onChange:function(a){e.on("change",a)}}}},{"../jquery.js":31,"./fieldHelpers.js":15}],19:[function(a,b){var c=a("../jquery.js"),d=(c.build,a("./fieldHelpers.js")),e=/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,f={};b.exports=f,f.fieldType="email";var g=function(a){var b=a.val()||"";return b?b.match(e):!0};f.newField=function(a,b){var e=d.renderInput("email",a,b);return{name:a.Name,elem:d.formatStandardField(e,a,b),val:c.proxy(e.val,e),required:a.IsRequired,validator:function(){return g(e)},validatorElem:e,onChange:function(a){e.on("change",a)}}}},{"../jquery.js":31,"./fieldHelpers.js":15}],20:[function(a,b){function c(a){return a||0===a?""+a:""}function d(a,b,c){return""===a||null===a?!0:(a=parseFloat(a,10),isNaN(a)?!1:g.isSet(b)&&b>a?!1:g.isSet(c)&&a>c?!1:!0)}function e(a){return function(b){if(0===arguments.length){var c=a.val();if(g.isSet(c)){var d=parseFloat(c);return isNaN(d)?"":d}return null}a.val(b)}}var f=a("../jquery.js"),g=(f.build,a("./fieldHelpers.js")),f=a("../jquery.js"),g=(f.build,a("./fieldHelpers.js")),h={};b.exports=h,h.fieldType="number",h.newField=function(a,b){{var f=g.renderInput("number",a,b);f.attr({min:c(a.MinimumNumber),max:c(a.MaximumNumber),step:c(a.StepNumber)})}return{name:a.Name,val:e(f,a.MinimumNumber,a.MaximumNumber),elem:g.formatStandardField(f,a,b),required:a.IsRequired,validator:function(b){return d(b,a.MinimumNumber,a.MaximumNumber)},validatorElem:f,onChange:function(a){f.on("change",a)}}}},{"../jquery.js":31,"./fieldHelpers.js":15}],21:[function(a,b){var c=a("../jquery.js"),d=c.build,e=a("./fieldHelpers.js"),f={};b.exports=f,f.fieldType="radio";var g=function(a){return function(b){if(0===arguments.length){var d=a.find("input:checked").val();return d}a.find("input").prop("checked",!1),""!==b?a.find("input[value='"+b+"']").prop("checked",!0):a.find("input").each(function(a,b){b=c(b),""===b.val()&&b.prop("checked",!0)})}};f.newField=function(a,b){var f=d(".mktoRadioList",{title:a.Description},[c.map(a.PicklistValues||[],function(b,c){var e="mktoRadio_"+a.Id+"_"+c;return c||(firstVal=b.value),d.docFrag([d("input[type=radio].mktoField",{name:a.Name,id:e,value:b.value}),d("label",{"for":e},[d.html(b.label||b.name)])])})]);a.IsLabelToLeft&&f.addClass("mktoLabelToLeft");var h=g(f);return{name:a.Name,elem:e.formatStandardField(f,a,b),val:h,required:a.IsRequired,validatorElem:f,validatorFocusElem:f.find("input:eq(0)"),onChange:function(a){f.on("change",a)}}}},{"../jquery.js":31,"./fieldHelpers.js":15}],22:[function(a,b){var c=a("../jquery.js"),d=c.build,e=a("./fieldHelpers.js"),f=a("../modernizr.js"),g={};b.exports=g,g.fieldType="range";var h=function(a,b,c){var d=a.get(0);if(d.validity&&!d.validity.valid)return!1;var e=a.val();return e?i(e,b,c):!0},i=function(a,b,c){return a=parseFloat(a,10),isNaN(a)?!1:e.isSet(b)&&b>a?!1:e.isSet(c)&&a>c?!1:!0},j=function(a,b,c){return function(d){if(0===arguments.length){var f=a.val();if(e.isSet(f)){var g=parseFloat(f,10);return isNaN(g)?null:g}return null}null!==d&&void 0!==d&&""!==d&&i(d,b,c)&&(a.val(parseFloat(d,10)),a.trigger("change"))}};g.newField=function(a,b){var g,i,k,l,m=a.MinimumNumber||0,n=a.MaximumNumber||100,o=d(".mktoLogicalField.mktoRangeField",[k=d(".mktoRangeValue",[l=d(".mktoRangeValueArrowWrap",d(".mktoRangeValueArrow")),i=d(".mktoRangeValueText",""+a.MinimumNumber||0)]),g=d("input[type=range].mktoField",{id:a.Name,name:a.Name,min:m,max:n,step:a.StepNumber||1,title:a.Description}).addClass("mktoHasWidth").css({width:e.first(a.FieldWidth,b.FieldWidth,0)})]).hover(function(){o.addClass("mktoHover"),p()},function(){o.removeClass("mktoHover")});f.csstransforms||l.addClass("mktoArrowImage");var p=function(){var a=g.val()||0;i.html(""+a);var b=12,c=g.data("mktoNoCubicEase"),d=g.data("mktoPxAboveSlider")||0,e=(a-m)/(n-m),f=g.width()*e,h=0;c||(.5>e&&(h=Math.pow(1-e,3)*(b/2)),e>.5&&(h=-1*Math.pow(e,3)*(b/2)),f+=Math.floor(h));var j=f-k.outerWidth()/2,o=i.outerWidth()/2-l.outerWidth()/2;k.css("margin-left",j),k.css("margin-top",-1*(l.outerHeight()+i.outerHeight()+d)),l.css("margin-left",o)};return g.on("change",p),g.on("input",p),g.data("mktoRangeUpdate",p),c("body").on("mktoRender",p),{name:a.Name,val:j(g,a.MinimumNumber,a.MaximumNumber),elem:e.formatStandardField(o,a,b),required:a.IsRequired,validator:function(){return h(g,m,n)
	},validatorElem:g,onChange:function(a){g.on("change",a)}}}},{"../jquery.js":31,"../modernizr.js":34,"./fieldHelpers.js":15}],23:[function(a,b){var c=a("../jquery.js"),d=(c.build,a("./fieldHelpers.js")),e=/^([0-9()+. \t-])+(\s?(x|ext|extension)\s?([0-9()])+)?$/,f={};b.exports=f,f.fieldType="phone";var g=function(a){var b=a.val()||"";return b?b.match(e):!0};f.newField=function(a,b){var e=d.renderInput("tel",a,b);return{name:a.Name,elem:d.formatStandardField(e,a,b),val:c.proxy(e.val,e),required:a.IsRequired,validator:function(){return g(e)},validatorElem:e,onChange:function(a){e.on("change",a)}}}},{"../jquery.js":31,"./fieldHelpers.js":15}],24:[function(a,b){var c=a("../jquery.js"),d=(c.build,a("./fieldHelpers.js")),e={};b.exports=e,e.fieldType="string",e.newField=function(a,b){var c=a.Maxlength||255,e=d.renderInput("text",a,b);return a.FieldMask&&e.addClass("mktoInputMask").data("mktoInputMask",a.FieldMask),{name:a.Name,elem:d.formatStandardField(e,a,b),val:function(a){return 0===arguments.length?e.val():(a&&a.length>c&&(a=a.substring(0,c)),e.val(a))},required:a.IsRequired,validatorElem:e,onChange:function(a){e.on("change",a)}}}},{"../jquery.js":31,"./fieldHelpers.js":15}],25:[function(a,b){var c=a("../jquery.js"),d=(c.build,a("./fieldHelpers.js")),e={};b.exports=e,e.fieldType="url";var f=/^[a-zA-z0-9\.\-_~:/\?#\[\]@!$&\'\(\)\*\+,;=%]*$/,g=function(a){if(!a)return!0;var b=a.indexOf("://");return 1>b?!1:a.match(f)};e.newField=function(a,b){var e=d.renderInput("url",a,b);return{name:a.Name,elem:d.formatStandardField(e,a,b),val:c.proxy(e.val,e),required:a.IsRequired,validatorElem:e,validator:g,onChange:function(a){e.on("change",a)}}}},{"../jquery.js":31,"./fieldHelpers.js":15}],26:[function(a,b){var c=a("../jquery.js"),d=c.build,e=a("./fieldHelpers.js"),f=function(a,b){return function(d){return 0===arguments.length?a.val():(b&&d&&!c.isArray(d)&&(d=e.splitSemis(d)),a.val(d))}},g={};b.exports=g,g.fieldType="picklist",g.newField=function(a,b){var g=d("select.mktoField",{id:a.Name,name:a.Name,title:a.Description},[c.map(a.PicklistValues||[],function(a){return!a.isDefault||a.selected?d("option",{value:a.value},a.label||a.name):void 0})]);return a.IsMultiselect&&(g.attr("multiple","multiple"),g.attr("size",a.VisibleRows||5)),{name:a.Name,elem:e.formatStandardField(g,a,b),val:f(g,a.IsMultiselect),required:a.IsRequired,validatorElem:g,onChange:function(a){g.on("change",a)}}}},{"../jquery.js":31,"./fieldHelpers.js":15}],27:[function(a,b){var c=a("../jquery.js"),d=c.build,e=a("./fieldHelpers.js"),f={};b.exports=f,f.fieldType="textarea",f.newField=function(a,b){var c=a.Maxlength||2e3,f=d("textarea.mktoField",{id:a.Name,name:a.Name,placeholder:a.PlaceholderText,rows:Math.max(2,a.VisibleRows||2),title:a.Description});try{f.attr("maxlength",c)}catch(g){f.get(0).setAttribute("maxlength",""+c)}return{name:a.Name,elem:e.formatStandardField(f,a,b),val:function(a){return 0===arguments.length?f.val():(a&&a.length>c&&(a=a.substring(0,c)),f.val(a))},required:a.IsRequired,validatorElem:f,onChange:function(a){f.on("change",a)}}}},{"../jquery.js":31,"./fieldHelpers.js":15}],28:[function(a,b){var c=a("./jquery.js"),d=c.build,e=a("./validation.js"),f=a("./measure.js"),g=a("./fields/fieldhelpers.js"),h=g.cap,i=g.isSet,j=g.first,k=a("querystring"),l=a("url"),m=a("cookie"),n=a("./cookiehelper.js"),o=a("./tokenTemplate.js"),p=a("./changeManager.js"),q=a("./urlhelper.js"),r=a("./prefillcoercer.js"),s=a("./iframeproxy.js"),t=a("./safelog.js"),u=[a("./fields/inputRadio.js"),a("./fields/inputDate.js"),a("./fields/inputEmail.js"),a("./fields/inputCheckbox.js"),a("./fields/select.js"),a("./fields/inputRange.js"),a("./fields/inputText.js"),a("./fields/inputUrl.js"),a("./fields/inputTel.js"),a("./fields/inputNumber.js"),a("./fields/textarea.js"),a("./fields/currency.js")],v={};c.each(u,function(a,b){v[b.fieldType]=b}),v["int"]=v.number,v["double"]=v.number,v.single_checkbox=v.checkbox;var w=(a("./comparators.js"),navigator.userAgent.match(/msie ([6789])/i)),x=w?"ie"+w[1]:"",y=function(a,b,u){var w={},y={};y.hiddenFields={formid:a.Id},y.onSuccess=[],y.onSubmit=[],y.onValidate=[],y.values={},y.fieldsByName=g.getFieldsByName(g.getFlattenedFields(a)),y.changeMap=p.getChangeMap(y.fieldsByName,a),y.fieldElemsByName={},y.canSubmit="draft"!=a.Status;var z=function(a){var b=y.changeMap[a]||[],e=!1,f={defaultValuesToSet:{},fieldsToCheck:[]};c.each(b,function(a,b){var g=y.fieldElemsByName[b];if(g&&g[0]&&c.contains(y.formElem[0],g[0])){var h,i,j=!g.hasClass("mktoPlaceholder"),k=y.fieldsByName[b],l=p.fieldChangeChecker(k.VisibilityRule,w.getValues()),m=l.show,n=function(a,b){var c=A(a,f),d=C(c),e=d.elem;return e.hide(),b.replaceWith(e),G()&&H(e),e},o=function(a,b){var c=d(".mktoPlaceholder.mktoPlaceholder"+a.Name);return b.replaceWith(c),c};j&&m&&(h=p.applyPicklistAlterations(k,l.rule),h!==k&&(i=n(h,g),i.show(),e=!0)),j&&!m&&(i=o(k,g),y.fieldElemsByName[b]=i,f.fieldsToCheck.push(k)),!j&&m&&(h=p.applyPicklistAlterations(k,l.rule),i=n(h,g),i.show(),f.fieldsToCheck.push(k),e=!0),i&&(y.fieldElemsByName[b]=i),"fieldset"==k.Datatype&&z(k.Name),e&&i&&y.validation&&y.validation.initScoped(i)}}),w.setValues(f.defaultValuesToSet),c.each(f.fieldsToCheck,function(a,b){z(b.Name)}),e&&c("body").data("mktoRendered")&&c("body").trigger("mktoRender",w)},A=function(b,e){var f=y.values[b.Name]||b.DefaultValue||b.InputInitialValue;if(v[b.Datatype]){var g=v[b.Datatype].newField(b,a);if(g.validationMessage=g.validationMessage||b.ValidationMessage,g.requiredMessage=g.requiredMessage||b.RequiredMessage,g.required){if(!g.validatorElem)throw new Error("Required fields must have a validatorElem");g.validatorElem.addClass("mktoRequired")}y.changeMap[b.Name]&&g.onChange(function(){z(b.Name)}),i(f)&&(e.defaultValuesToSet[b.Name]=f);var h=d(".mktoFieldDescriptor",g.elem);return h.data("mktoFieldDescriptor",g),h}if("htmltext"==b.Datatype||"richtext"==b.Datatype)return d.docFrag([d(".mktoOffset.mktoHasWidth").css({width:j(b.OffsetWidth,a.OffsetWidth,0)}),d(".mktoFieldWrap",[d(".mktoHtmlText.mktoHasWidth",[d.html(b.Htmltext||b.InputLabel)]).css({width:j(b.LabelWidth,a.LabelWidth,0)}),d(".mktoClear")]),d(".mktoClear")]);if("hidden"==b.Datatype){var n=b.InputSourceChannel,o=b.InputSourceSelector,p=b.Name,q="";if("url"==n&&o){var r=k.parse(location.search.replace("?",""));q=r[o]||""}else if("cookie"==n&&o){var s=m.parse(document.cookie);q=s[o]}else if("referrer"==n&&o){var u=l.parse(document.referrer,!0);q=u.query[o]}return!q&&f&&(q=f),e.defaultValuesToSet[p]=q,E(q,p)}if("fieldset"==b.Datatype){var w=a.fieldsetRows[b.Id.toString()]||[];if(!w.length)return null;var x=d("fieldset",[d("legend",d.html(b.InputLabel)),c.map(w,function(a,b){return D(a,b,e)})]);return w.length&&w[0].length&&x.css({"padding-right":j(w[0][0].OffsetWidth,a.OffsetWidth,0)}),x}"profiling"!=b.Datatype&&t("invalid data type: "+b.Datatype)},B=function(b,e){var f=a.ProcessOptions,g=0;f&&f.profiling&&f.profiling.numberOfProfilingFields&&(g=f.profiling.numberOfProfilingFields);var h=b.ProfilingFieldNumber||g,j=a.fieldsetRows[b.Id.toString()]||[],k=[],l=0;return c.each(j,function(b,d){var e=[],f=[];a.filledFields&&(f=a.filledFields),c.each(d,function(a,b){!i(y.values[b.Name])&&-1==c.inArray(b.Name,f)&&h>l&&(e.push(b),l++)}),e.length>0&&k.push(e)}),d.docFrag(c.map(k,function(a,b){return D(a,b,e)}))},C=function(b){var c,e=0;return c=11==b.nodeType?d(".mktoFormCol",b):b.addClass("mktoFormCol"),e+=f.measure(c).w,c.css("margin-bottom",a.LineMargin||0),{elem:c,width:e}},D=function(a,b,e){var f=0;if(1==a.length&&"profiling"==a[0].Datatype)return B(a[0],e);var g=c.map(a,function(a){var b=A(a,e);if(!b)return null;var c=C(b);return f+=c.width,a.VisibilityRule&&"hidden"!=a.Datatype&&e.fieldsToCheck.push(a),y.fieldElemsByName[a.Name]=c.elem,c.elem});if(0===g.length)return null;var h=d(".mktoFormRow",[g,d(".mktoClear")]);return f>y.formWidth&&(y.formWidth=f),h},E=function(a,b){var e=d("input.mktoField.mktoFieldDescriptor",{type:"hidden",name:b}),f={name:b,val:c.proxy(e.val,e),onChange:function(a){e.on("change",a)}};return y.changeMap[b]&&f.onChange(function(){z(field.Name)}),e.data("mktoFieldDescriptor",f),e},F=function(a,b){var e={},f=function(a,b){e[a]=b};w.setValues(b,f);var g=c.map(e,E);a.append(d.docFrag(g)),w.setValues(b)},G=function(){return window.matchMedia&&c("body.mktoMobileShow").length?window.matchMedia("only screen and (max-width:480px), only screen and (max-device-width:480px), only screen and (max-device-height:480px)").matches:c(window).width()<=480},H=function(a){var b=a.find(".mktoHasWidth").andSelf();b.each(function(){var a=c(this);a.data("mktoFixedWidth",a.css("width")),a.css("width","")})},I=function(){if(y.formElem){{c(window).width()}y.hasRemovedWidths?G()||(y.formElem.find(".mktoHasWidth").andSelf().each(function(){var a=c(this);a.css("width",a.data("mktoFixedWidth"))}),y.hasRemovedWidths=!1):G()&&(H(y.formElem),y.hasRemovedWidths=!0)}},J=function(){var b=a.ButtonStyle||{className:""},c=a.ButtonText||a.SubmitLabel||"Submit",e=a.ButtonLocation||"",f=parseInt(e,10)||0,g=d("span.mktoButtonWrap",[d("button.mktoButton",{type:"submit"},[c])]).addClass(b.className).css({"margin-left":f+"px"});return g},K=function(){var b=a.ProcessOptions;if(!(b&&b.socialSignOn&&b.socialSignOn.isEnabled&&b.socialSignOn.enabledNetworks.length))return"";var c=b.socialSignOn.cfId+"_SocialSignOn",e=d(".cf_widgetLoader.cf_w_"+c);return window.cf_scripts&&window.CF?(setTimeout(function(){CF.widget.restart(c)},10),e):d.docFrag([d("script",{src:a.loaderJsUrl,type:"text/javascript"}),e])},L=function(c){c.addClass("mktoForm mktoHasWidth mktoLayout"+h(a.Layout||"left")+(b.csschecked?"":" mktoNoCheckedSupport")),x&&c.addClass(x)},M=function(a,b){var d=!0;return c.each(y.onSuccess,function(c,e){e(a,b)===!1&&(d=!1)}),d},N=function(a){var b,c=a.__cdrop;return c&&(b=c.split("."),3==b.length)?b[2]:null},O=function(a){var b={};return c.each(a,function(a,d){c.isArray(d)&&d.length>1?b[a+"[]"]=d:b[a]=d}),b},P=function(){var a=location;return-1!=a.hostname.indexOf(u.fbTabDomain)&&-1!=a.search.indexOf("fbTab=1")},Q=function(b){var c=P(),d="";return b&&("string"==typeof a.FormFollowup?(d=a.FormFollowup,c&&0!==d.indexOf("https://")&&(d=q.remapLandingPageUrl(d,location.href),d=q.addQueryParams(d,{fbTab:"1"}))):b.followUpUrl&&"string"==typeof b.followUpUrl?d=b.followUpUrl:b.followUpUrl&&b.followUpUrl.url&&(c&&b.followUpUrl.isLandingPage?(d=q.remapLandingPageUrl(b.followUpUrl.url,location.href),d=q.addQueryParams(d,{fbTab:"1"})):d=b.followUpUrl.url)),d=d||location.href,b.aliId&&(d=q.addQueryParams(d,{aliId:b.aliId})),d},R=function(){var d=w.getValues();if(window.Munchkin)try{window.Munchkin.createTrackingCookie(!0)}catch(e){}{var f=l.parse(location.href,!0).query,g=m.parse(document.cookie),h=l.parse(a.action).hostname,i=(h?"//"+h:"")+u.formSubmitPath;window.location}P()&&(i=u.formSubmitPath,h=location.hostname);var j="json",o="POST";void 0===d._mkt_trk&&(d._mkt_trk=g._mkto_trk),d.formVid=a.Vid,f.mkt_tok&&void 0===d.mkt_tok&&(d.mkt_tok=f.mkt_tok);var p=N(g);p&&(d.MarketoSocialSyndicationId=p),d._mktoReferrer=location.href;var q=k.stringify(O(d)),r=function(a){if(a.error)v(a);else if(a.formId){var b=Q(a);if(!1===M(d,b))return;n.removeCookieAllDomains("_mkto_purl"),location.href=b}},v=function(){if(t(arguments),y.submitButton){var b=y.submitButton.find("button");b.removeAttr("disabled"),b.html(a.ButtonText||a.SubmitLabel||"Submit")}},x={type:o,data:q,dataType:j,url:i,success:r,error:v};h&&h!=location.hostname?b.postmessage&&b.json?s.send(x):(x.dataType="jsonp",x.submitUrl+="?callback=?",x.type="GET",c.ajax(x)):c.ajax(x)},S=function(b){var d=w.validate();if(y.canSubmit&&d&&y.onSubmit&&c.each(y.onSubmit,function(a,b){b(w)}),b.preventDefault(),y.canSubmit&&d){var e=y.submitButton.find("button");return e.attr("disabled","disabled"),a.ButtonSubmissionText&&e.html(a.ButtonSubmissionText),R(),!1}return b.stopPropagation(),!1},T=function(b){var c=a.ButtonStyle||{className:""},e=d("span.mktoButtonWrap",[d("button.mktoButton",{type:"submit"},[b["default"]||""])]).addClass(c.className);return e.click(function(a){a.preventDefault(),R()}),e},U=function(a){return d("a.mktoNotYou",[a["default"]||"Not You?"]).click(function(){n.removeCookieAllDomains("_mkto_trk"),location.href=q.removeQueryParams(location.href,["mkt_tok","aliId"])})},V=function(){var b=a.ProcessOptions.knownLead.template;b=b.replace(/\{\[\((.*?)\)\]\}/g,"{{$1}}");var e={},f=0,g=function(a){return function(){var b=a.apply(null,arguments);if(b.jquery||b.nodeType){var c="__tempSwap"+f;return f++,e[c]=b,"<span id='"+c+"'></span>"}return b}},h={lead:a.knownLead,form:{Button:g(T),NotYou:g(U)}},i=d("div.mktoTemplateBox",d.html(o(b,h)));return c.each(e,function(a,b){i.find("#"+a).replaceWith(b)}),i};w.render=function(b){y.id=a.Vid||a.Id||1,b||(b=c("form#mktoForm_"+(a.Vid||a.Id))),b.length||(b=d("form#mktoForm_"+(a.Vid||a.Id))),y.formElem=b,b.attr({novalidate:"novalidate"}),b.css({"font-family":a.FontFamily||"","font-size":a.FontSize||"",color:a.FontColor||""}),L(b),f.init(y.formElem),y.formWidth=0;var g={defaultValuesToSet:{},fieldsToCheck:[]},h=c.map(a.rows,function(a,b){return D(a,b,g)}),i=K();c.each(g.fieldsToCheck,function(a,b){if(!p.fieldChangeChecker(b.VisibilityRule,g.defaultValuesToSet).show){var c=d(".mktoPlaceholder.mktoPlaceholder"+b.Name),e=y.fieldElemsByName[b.Name];e&&(e.replaceWith(c),y.fieldElemsByName[b.Name]=c)}});var j="",k=a.ButtonStyle;return k&&(k.css&&(j+=k.css),k.buttonColor&&(j+="\n.mktoForm .mktoButtonWrap."+k.className+" button.mktoButton {background:"+k.buttonColor+";}\n")),b.append(d("style",{type:"text/css"},j)),b.append(a.knownLead&&a.ProcessOptions&&a.ProcessOptions.knownLead&&"custom"==a.ProcessOptions.knownLead.type?V():d.docFrag([i,h,d(".mktoButtonRow",[y.submitButton=J(b)])])),F(b,y.hiddenFields),w.setValues(g.defaultValuesToSet),b.css({width:Math.max(y.submitButton?y.submitButton.outerWidth():0,y.formWidth+1)}),b.on("submit",S),y.validation=e(b),y.validation.init(),setTimeout(function(){c("body").trigger("mktoRender",w).data("mktoRendered",!0)},0),c(window).on("resize",I),I(),"ie7"==x&&W(b),b};var W=function(a){var b=a.find(".mktoFormRow, .mktoFormCol"),d=b.length;b.each(function(){c(this).css("z-index",d--)}),a.css("z-index",b.length+1)};w.getId=function(){return y.id},w.getFormElem=function(){return y.formElem},w.getElem=w.getFormElem(),w.validate=function(){var a=y.validation.check();return c.each(y.onValidate,function(b,c){c(a)}),a},w.onValidate=function(a){return a?y.onValidate.push(a):y.onValidate=[],w},w.offValidate=function(a){return y.onValidate=y.onValidate.filter(function(b){return b!==a}),w},w.submit=function(a){if(a&&"function"==typeof a){var b=function(){w.offSuccess(b),a.apply(null,arguments)};y.onSuccess.push(b)}return y.formElem.trigger("submit"),w},w.onSubmit=function(a){return a?y.onSubmit.push(a):y.onSubmit=[],w},w.offSubmit=function(a){return y.onSubmit=y.onSubmit.filter(function(b){return b!==a}),w},w.onSuccess=function(a){return a?y.onSuccess.push(a):y.onSuccess=[],w},w.offSuccess=function(a){return y.onSuccess=y.onSuccess.filter(function(b){return b!==a}),w},w.submitable=function(a){return arguments.length?(y.canSubmit=a,w):y.canSubmit},w.submittable=w.submitable,w.allFieldsFilled=function(){var a=w.getValues(),b=!0;return c.each(a,function(a,d){c.isArray(d)&&0===d.length?b=!1:(void 0===d||null===d||""===d)&&(b=!1)}),b};var X=function(){var a={};return y.formElem.find(".mktoFieldDescriptor").each(function(b,d){var e=c(d),f=e.data("mktoFieldDescriptor");a[f.name]=f.val}),a};return w.setValuesCoerced=function(b){var c=r.coerceTypes(b,a);w.setValues(c)},w.setValues=function(a,b){if(y.formElem){var d=[],e=X();c.each(a,function(a,c){e[a]?e[a](c):b&&b(a,c),y.changeMap[a]&&d.push(a)}),c.each(d,function(b,d){z(d);var e=X();c.each(y.changeMap[d],function(b,c){e[c]&&void 0!==a[c]&&e[c](a[c])})})}else y.values=a;return w},w.addHiddenFields=function(a){y.formElem?F(y.formElem,a):c.extend(y.hiddenFields,a)},w.getValues=function(){if(y.formElem){var a={},b=X();return c.each(b,function(b,c){var d=c();a[b]=d}),a}return y.values},w.vals=function(){return 0===arguments.length?w.getValues():w.setValues.apply(null,arguments)},w.showErrorMessage=function(a,b){return y.validation&&(b||(b=y.submitButton),y.validation.showError(b,a)),w},w.setErrorMessages=function(a){c.each(a,function(a,b){if(y.fieldsByName[a].ValidationMessage=b,y.formElem){var c=y.fieldElemsByName[a];if(c){var d=c.data("mktoFieldDescriptor");d&&(d.validationMessage=b,c.data("mktoFieldDescriptor",d))}}})},w};b.exports=y},{"./changeManager.js":10,"./comparators.js":12,"./cookiehelper.js":13,"./fields/currency.js":14,"./fields/fieldhelpers.js":16,"./fields/inputCheckbox.js":17,"./fields/inputDate.js":18,"./fields/inputEmail.js":19,"./fields/inputNumber.js":20,"./fields/inputRadio.js":21,"./fields/inputRange.js":22,"./fields/inputTel.js":23,"./fields/inputText.js":24,"./fields/inputUrl.js":25,"./fields/select.js":26,"./fields/textarea.js":27,"./iframeproxy.js":30,"./jquery.js":31,"./measure.js":32,"./prefillcoercer.js":35,"./safelog.js":36,"./tokenTemplate.js":38,"./urlhelper.js":39,"./validation.js":40,cookie:7,querystring:5,url:6}],29:[function(a,b){if("undefined"!=typeof window&&window.MktoForms2)return void(b.exports=window.MktoForms2);var c=a("./jquery.js"),d=a("jquery.build")(c,document),e=a("./form.js");a("./shimsham.js");var f={};f.$=c,f.$b=d,f.Modernizr=a("./modernizr.js");var g=f.Modernizr,h=a("querystring"),i=a("./fields/fieldhelpers.js"),j=a("cookie"),k=a("events"),l=new k.EventEmitter,m=a("url"),n=a("./iframeproxy.js"),o=a("./color.js"),p=a("./safelog.js"),q={rootUrl:"",baseUrl:"/js/forms2/",skipPolyfills:!1,formSubmitPath:"/index.php/leadCapture/save2",formXDPath:"/index.php/form/XDFrame",fbTabDomain:"marketo.com"},r=[];f.setOptions=function(a){c.extend(q,a)};var s=function(a){var b=d("#mktoStyleLoaded").css({display:"none","border-top-color":"#123456"}).appendTo(c("body")),e=0,f=1500,g=25,h=function(){var c=b.css("color"),d=b.css("background-color"),i=b.css("border-top-color");e>f/g?(p("Timeout loading CSS. #mktoStyleLoaded missing color #123456 for one of color, background-color, or border-top-color.",c,d,i),a()):o.compareColor(i,d)&&o.compareColor(i,c)?x(a):(e++,setTimeout(h,g))};h()},t=function(a,b){0===b.indexOf("//")&&(b=location.protocol+b);var e=d("link",{id:a,rel:"stylesheet",type:"text/css",href:b});c("head").append(e),document.createStyleSheet&&document.createStyleSheet(b)},u=function(a,b){window.console&&console.log("Error loading form:",a),b&&b(null)},v=function(a){return 0===a.indexOf("/")&&0!==a.indexOf("//")},w=function(a,b){var d="json";v(a)||(d="jsonp",a+="&callback=?"),c.ajax({dataType:d,url:a,success:b,error:function(a,c,d){u(d,b)}})};f.loadForm=function(a,b,c,d){f.setOptions({rootUrl:a,baseUrl:a+"/js/forms2/"});var e=function(c){c.action=(0===a.indexOf("http")?a:location.protocol+a)+q.formSubmitPath,f.newForm(c,function(a){a.addHiddenFields({munchkinId:b}),a.render(),d&&d(a)})},g=location.href.split("?")[0].split("#")[0];g.length>255&&(g=g.substring(0,255));var h=a+"/index.php/form/getForm?munchkinId="+b+"&form="+c+"&url="+encodeURIComponent(g);return w(h,function(a){a.error?u(a,d):e(a)}),f},f.lightbox=function(b,c){var d,e;return c=c||{},b.getFormElem?(b.getFormElem()||b.render(),d=b.getFormElem(),b.onSuccess(c.onSuccess||function(a,b){return e.hide(),b?void 0:!1})):d=b,e=a("./modal.js")(d,c)};var x=function(a){setTimeout(a,0)},y=function(a,b,d,e){if(window.mktoPreFillFields&&mktoPreFillFields.FirstName&&mktoPreFillFields.LastName)return void x(function(){e(mktoPreFillFields)});var f=j.parse(document.cookie),g=h.parse(location.search.replace("?","")),i=q.rootUrl+"/index.php/form/getKnownLead?";if(f._mkto_trk||g.mkt_tok){var k={form:a,munchkinId:b,filledFields:d};return f._mkto_trk&&(k._mkt_trk=f._mkto_trk),g.mkt_tok&&(k.mkt_tok=g.mkt_tok),i+=h.stringify(k),void w(i,function(a){a&&a.error?u(a,e):(window.mktoPreFillFields&&(a=c.extend({},window.mktoPrefillFields,a)),e(a))})}x(e)};f.newForm=function(a,b){if(0===c("#mktoForms2BaseStyle").length){var h=q.baseUrl+"css/forms2.css";t("mktoForms2BaseStyle",h)}0===c("#mktoForms2ThemeStyle").length&&a.ThemeStyle&&a.ThemeStyle.href?t("mktoForms2ThemeStyle",q.baseUrl+a.ThemeStyle.href):c("head").append(d("style","#mktoStyleLoaded {color:#123456;}")),a.FontUrl&&t("mktoFontUrl",a.FontUrl),a.ThemeStyleOverride&&c("head").append(d("style",a.ThemeStyleOverride)),f._polyfillsLoaded||(A(a),f._polyfillsLoaded=!0);var i=a.ProcessOptions,j=0,k=function(){var a=location;return-1!=a.hostname.indexOf(q.fbTabDomain)&&-1!=a.search.indexOf("fbTab=1")},o=function(){return-1!=location.hostname.indexOf(".marketodesigner.com")},p=function(){if(j--,0>=j){var c=e(a,g,q);r.push(c),b&&b(c),x(function(){if(a.action&&!k()&&!o()){var b=m.parse(a.action).hostname;b&&b!=location.hostname&&g.postmessage&&g.json&&n.init("//"+b+q.formXDPath)}}),x(function(){l.emit("mktoFormReady",c)})}},u=i&&i.profiling&&i.profiling.isEnabled,v=i&&i.knownLead&&"custom"==i.knownLead.type&&a.munchkinId;(v||u)&&(j++,y(a.Vid,a.munchkinId,u,function(b){b&&(a.filledFields=b.filledFields,b.FirstName&&b.LastName&&(a.knownLead=b)),p()})),j++,s(p)},f.getForm=function(a){for(var b=0;b<r.length;b++)if(""+r[b].getId()==""+a)return r[b]},f.getPageFields=function(){var a=h.parse(location.search.replace("?","")),b=h.parse(document.referrer.split("?")[0]);return{cr:a.cr||"",kw:a.kw||"",q:b.q||""}},f.allForms=function(){return r};var z=function(a){c.each(f.allForms(),function(b,c){x(function(){a(c)})})};f.whenReady=function(a){return l.on("mktoFormReady",a),z(a),f},f.onFormRender=function(a){return c("body").on("mktoRender",function(b,c){a(c)}),f},f.whenRendered=function(a){return f.onFormRender(a),z(a),f};var A=function(a){x(function(){var b=i.getFlattenedFields(a),c=i.getFieldTypes(b),d=i.anyFieldHasProperty(b,"FieldMask");if(!q.skipPolyfills){var e=q.baseUrl,f=g.load;f({test:g.input.placeholder,nope:[e+"polyfills/placeholder/placeholder.js",e+"polyfills/placeholder/placeholder.css"]}),f({test:c.date&&!g.inputtypes.date,yep:[e+"polyfills/datepicker/datepicker.js",e+"polyfills/datepicker/datepicker.css"]}),f({test:c.range&&!g.inputtypes.range,yep:[e+"polyfills/range/range.js",e+"polyfills/range/range.css"]}),f({test:c.textarea&&!g.textareamaxlength,yep:[e+"polyfills/maxlength/maxlength.js"]}),f({test:d,yep:[e+"polyfills/inputmask/inputmask.js"]})}})};"undefined"!=typeof window&&(window.MktoForms2=f),b.exports=f},{"./color.js":11,"./fields/fieldhelpers.js":16,"./form.js":28,"./iframeproxy.js":30,"./jquery.js":31,"./modal.js":33,"./modernizr.js":34,"./safelog.js":36,"./shimsham.js":37,cookie:7,events:1,"jquery.build":8,querystring:5,url:6}],30:[function(a,b){function c(a){return 0===a.indexOf("//")?a.match(/^\/\/app-.*?\.marketo\.com/i)?"https:"+a:location.protocol+a:0===a.indexOf("/")?location.protocol+"//"+location.hostname+a:a}function d(a){if(a.originalEvent&&a.originalEvent.data){var b;try{b=j.parseJSON(a.originalEvent.data)}catch(c){return}b.mktoReady?f():b.mktoResponse&&e(b.mktoResponse)}}function e(a){var b=a["for"],c=s[b];c&&(a.error?c.error(a.data):c.success(a.data)),delete s[b]}function f(){q=!0,j.each(t,function(a,b){g(b)}),t=[]}function g(a){var b="mktoFormMessage"+p++;if(s[b]={error:a.error,success:a.success},a.complete)throw new Error("complete parameter not supported");a.error=null,a.success=null;var c=k.parse(i);o.postMessage(JSON.stringify({mktoRequest:{ajaxParams:a,id:b}}),c.protocol+"//"+c.hostname)}function h(a){q?g(a):t.push(a)}var i,j=a("./jquery.js"),k=a("url"),l=j.build,m={},n=null,o=null,p=0,q=!1,r="mktoFormsXDIframe"+Math.random(),s={},t=[];m.init=function(a){n||(i=c(a),j("body").append(n=l("iframe#MktoForms2XDIframe",{name:r}).css({display:"none"})),n.get(0).src=i,o=window.frames[r],j(window).on("message",d))},m.send=function(a){h(a)},b.exports=m},{"./jquery.js":31,url:6}],31:[function(a,b){!function(a,c){function d(a){var b=a.length,c=lb.type(a);return lb.isWindow(a)?!1:1===a.nodeType&&b?!0:"array"===c||"function"!==c&&(0===b||"number"==typeof b&&b>0&&b-1 in a)}function e(a){var b=Ab[a]={};return lb.each(a.match(nb)||[],function(a,c){b[c]=!0}),b}function f(a,b,d,e){if(lb.acceptData(a)){var f,g,h=lb.expando,i=a.nodeType,j=i?lb.cache:a,k=i?a[h]:a[h]&&h;if(k&&j[k]&&(e||j[k].data)||d!==c||"string"!=typeof b)return k||(k=i?a[h]=cb.pop()||lb.guid++:h),j[k]||(j[k]=i?{}:{toJSON:lb.noop}),("object"==typeof b||"function"==typeof b)&&(e?j[k]=lb.extend(j[k],b):j[k].data=lb.extend(j[k].data,b)),g=j[k],e||(g.data||(g.data={}),g=g.data),d!==c&&(g[lb.camelCase(b)]=d),"string"==typeof b?(f=g[b],null==f&&(f=g[lb.camelCase(b)])):f=g,f}}function g(a,b,c){if(lb.acceptData(a)){var d,e,f=a.nodeType,g=f?lb.cache:a,h=f?a[lb.expando]:lb.expando;if(g[h]){if(b&&(d=c?g[h]:g[h].data)){lb.isArray(b)?b=b.concat(lb.map(b,lb.camelCase)):b in d?b=[b]:(b=lb.camelCase(b),b=b in d?[b]:b.split(" ")),e=b.length;for(;e--;)delete d[b[e]];if(c?!i(d):!lb.isEmptyObject(d))return}(c||(delete g[h].data,i(g[h])))&&(f?lb.cleanData([a],!0):lb.support.deleteExpando||g!=g.window?delete g[h]:g[h]=null)}}}function h(a,b,d){if(d===c&&1===a.nodeType){var e="data-"+b.replace(Cb,"-$1").toLowerCase();if(d=a.getAttribute(e),"string"==typeof d){try{d="true"===d?!0:"false"===d?!1:"null"===d?null:+d+""===d?+d:Bb.test(d)?lb.parseJSON(d):d}catch(f){}lb.data(a,b,d)}else d=c}return d}function i(a){var b;for(b in a)if(("data"!==b||!lb.isEmptyObject(a[b]))&&"toJSON"!==b)return!1;return!0}function j(){return!0}function k(){return!1}function l(){try{return Z.activeElement}catch(a){}}function m(a,b){do a=a[b];while(a&&1!==a.nodeType);return a}function n(a,b,c){if(lb.isFunction(b))return lb.grep(a,function(a,d){return!!b.call(a,d,a)!==c});if(b.nodeType)return lb.grep(a,function(a){return a===b!==c});if("string"==typeof b){if(Rb.test(b))return lb.filter(b,a,c);b=lb.filter(b,a)}return lb.grep(a,function(a){return lb.inArray(a,b)>=0!==c})}function o(a){var b=Vb.split("|"),c=a.createDocumentFragment();if(c.createElement)for(;b.length;)c.createElement(b.pop());return c}function p(a,b){return lb.nodeName(a,"table")&&lb.nodeName(1===b.nodeType?b:b.firstChild,"tr")?a.getElementsByTagName("tbody")[0]||a.appendChild(a.ownerDocument.createElement("tbody")):a}function q(a){return a.type=(null!==lb.find.attr(a,"type"))+"/"+a.type,a}function r(a){var b=fc.exec(a.type);return b?a.type=b[1]:a.removeAttribute("type"),a}function s(a,b){for(var c,d=0;null!=(c=a[d]);d++)lb._data(c,"globalEval",!b||lb._data(b[d],"globalEval"))}function t(a,b){if(1===b.nodeType&&lb.hasData(a)){var c,d,e,f=lb._data(a),g=lb._data(b,f),h=f.events;if(h){delete g.handle,g.events={};for(c in h)for(d=0,e=h[c].length;e>d;d++)lb.event.add(b,c,h[c][d])}g.data&&(g.data=lb.extend({},g.data))}}function u(a,b){var c,d,e;if(1===b.nodeType){if(c=b.nodeName.toLowerCase(),!lb.support.noCloneEvent&&b[lb.expando]){e=lb._data(b);for(d in e.events)lb.removeEvent(b,d,e.handle);b.removeAttribute(lb.expando)}"script"===c&&b.text!==a.text?(q(b).text=a.text,r(b)):"object"===c?(b.parentNode&&(b.outerHTML=a.outerHTML),lb.support.html5Clone&&a.innerHTML&&!lb.trim(b.innerHTML)&&(b.innerHTML=a.innerHTML)):"input"===c&&cc.test(a.type)?(b.defaultChecked=b.checked=a.checked,b.value!==a.value&&(b.value=a.value)):"option"===c?b.defaultSelected=b.selected=a.defaultSelected:("input"===c||"textarea"===c)&&(b.defaultValue=a.defaultValue)}}function v(a,b){var d,e,f=0,g=typeof a.getElementsByTagName!==X?a.getElementsByTagName(b||"*"):typeof a.querySelectorAll!==X?a.querySelectorAll(b||"*"):c;if(!g)for(g=[],d=a.childNodes||a;null!=(e=d[f]);f++)!b||lb.nodeName(e,b)?g.push(e):lb.merge(g,v(e,b));return b===c||b&&lb.nodeName(a,b)?lb.merge([a],g):g}function w(a){cc.test(a.type)&&(a.defaultChecked=a.checked)}function x(a,b){if(b in a)return b;for(var c=b.charAt(0).toUpperCase()+b.slice(1),d=b,e=zc.length;e--;)if(b=zc[e]+c,b in a)return b;return d}function y(a,b){return a=b||a,"none"===lb.css(a,"display")||!lb.contains(a.ownerDocument,a)}function z(a,b){for(var c,d,e,f=[],g=0,h=a.length;h>g;g++)d=a[g],d.style&&(f[g]=lb._data(d,"olddisplay"),c=d.style.display,b?(f[g]||"none"!==c||(d.style.display=""),""===d.style.display&&y(d)&&(f[g]=lb._data(d,"olddisplay",D(d.nodeName)))):f[g]||(e=y(d),(c&&"none"!==c||!e)&&lb._data(d,"olddisplay",e?c:lb.css(d,"display"))));for(g=0;h>g;g++)d=a[g],d.style&&(b&&"none"!==d.style.display&&""!==d.style.display||(d.style.display=b?f[g]||"":"none"));return a}function A(a,b,c){var d=sc.exec(b);return d?Math.max(0,d[1]-(c||0))+(d[2]||"px"):b}function B(a,b,c,d,e){for(var f=c===(d?"border":"content")?4:"width"===b?1:0,g=0;4>f;f+=2)"margin"===c&&(g+=lb.css(a,c+yc[f],!0,e)),d?("content"===c&&(g-=lb.css(a,"padding"+yc[f],!0,e)),"margin"!==c&&(g-=lb.css(a,"border"+yc[f]+"Width",!0,e))):(g+=lb.css(a,"padding"+yc[f],!0,e),"padding"!==c&&(g+=lb.css(a,"border"+yc[f]+"Width",!0,e)));return g}function C(a,b,c){var d=!0,e="width"===b?a.offsetWidth:a.offsetHeight,f=lc(a),g=lb.support.boxSizing&&"border-box"===lb.css(a,"boxSizing",!1,f);if(0>=e||null==e){if(e=mc(a,b,f),(0>e||null==e)&&(e=a.style[b]),tc.test(e))return e;d=g&&(lb.support.boxSizingReliable||e===a.style[b]),e=parseFloat(e)||0}return e+B(a,b,c||(g?"border":"content"),d,f)+"px"}function D(a){var b=Z,c=vc[a];return c||(c=E(a,b),"none"!==c&&c||(kc=(kc||lb("<iframe frameborder='0' width='0' height='0'/>").css("cssText","display:block !important")).appendTo(b.documentElement),b=(kc[0].contentWindow||kc[0].contentDocument).document,b.write("<!doctype html><html><body>"),b.close(),c=E(a,b),kc.detach()),vc[a]=c),c}function E(a,b){var c=lb(b.createElement(a)).appendTo(b.body),d=lb.css(c[0],"display");return c.remove(),d}function F(a,b,c,d){var e;if(lb.isArray(b))lb.each(b,function(b,e){c||Bc.test(a)?d(a,e):F(a+"["+("object"==typeof e?b:"")+"]",e,c,d)});else if(c||"object"!==lb.type(b))d(a,b);else for(e in b)F(a+"["+e+"]",b[e],c,d)}function G(a){return function(b,c){"string"!=typeof b&&(c=b,b="*");var d,e=0,f=b.toLowerCase().match(nb)||[];if(lb.isFunction(c))for(;d=f[e++];)"+"===d[0]?(d=d.slice(1)||"*",(a[d]=a[d]||[]).unshift(c)):(a[d]=a[d]||[]).push(c)}}function H(a,b,c,d){function e(h){var i;return f[h]=!0,lb.each(a[h]||[],function(a,h){var j=h(b,c,d);return"string"!=typeof j||g||f[j]?g?!(i=j):void 0:(b.dataTypes.unshift(j),e(j),!1)}),i}var f={},g=a===Sc;return e(b.dataTypes[0])||!f["*"]&&e("*")}function I(a,b){var d,e,f=lb.ajaxSettings.flatOptions||{};for(e in b)b[e]!==c&&((f[e]?a:d||(d={}))[e]=b[e]);return d&&lb.extend(!0,a,d),a}function J(a,b,d){for(var e,f,g,h,i=a.contents,j=a.dataTypes;"*"===j[0];)j.shift(),f===c&&(f=a.mimeType||b.getResponseHeader("Content-Type"));if(f)for(h in i)if(i[h]&&i[h].test(f)){j.unshift(h);break}if(j[0]in d)g=j[0];else{for(h in d){if(!j[0]||a.converters[h+" "+j[0]]){g=h;break}e||(e=h)}g=g||e}return g?(g!==j[0]&&j.unshift(g),d[g]):void 0}function K(a,b,c,d){var e,f,g,h,i,j={},k=a.dataTypes.slice();if(k[1])for(g in a.converters)j[g.toLowerCase()]=a.converters[g];for(f=k.shift();f;)if(a.responseFields[f]&&(c[a.responseFields[f]]=b),!i&&d&&a.dataFilter&&(b=a.dataFilter(b,a.dataType)),i=f,f=k.shift())if("*"===f)f=i;else if("*"!==i&&i!==f){if(g=j[i+" "+f]||j["* "+f],!g)for(e in j)if(h=e.split(" "),h[1]===f&&(g=j[i+" "+h[0]]||j["* "+h[0]])){g===!0?g=j[e]:j[e]!==!0&&(f=h[0],k.unshift(h[1]));break}if(g!==!0)if(g&&a["throws"])b=g(b);else try{b=g(b)}catch(l){return{state:"parsererror",error:g?l:"No conversion from "+i+" to "+f}}}return{state:"success",data:b}}function L(){try{return new a.XMLHttpRequest}catch(b){}}function M(){try{return new a.ActiveXObject("Microsoft.XMLHTTP")}catch(b){}}function N(){return setTimeout(function(){_c=c}),_c=lb.now()}function O(a,b,c){for(var d,e=(fd[b]||[]).concat(fd["*"]),f=0,g=e.length;g>f;f++)if(d=e[f].call(c,b,a))return d}function P(a,b,c){var d,e,f=0,g=ed.length,h=lb.Deferred().always(function(){delete i.elem}),i=function(){if(e)return!1;for(var b=_c||N(),c=Math.max(0,j.startTime+j.duration-b),d=c/j.duration||0,f=1-d,g=0,i=j.tweens.length;i>g;g++)j.tweens[g].run(f);return h.notifyWith(a,[j,f,c]),1>f&&i?c:(h.resolveWith(a,[j]),!1)
	},j=h.promise({elem:a,props:lb.extend({},b),opts:lb.extend(!0,{specialEasing:{}},c),originalProperties:b,originalOptions:c,startTime:_c||N(),duration:c.duration,tweens:[],createTween:function(b,c){var d=lb.Tween(a,j.opts,b,c,j.opts.specialEasing[b]||j.opts.easing);return j.tweens.push(d),d},stop:function(b){var c=0,d=b?j.tweens.length:0;if(e)return this;for(e=!0;d>c;c++)j.tweens[c].run(1);return b?h.resolveWith(a,[j,b]):h.rejectWith(a,[j,b]),this}}),k=j.props;for(Q(k,j.opts.specialEasing);g>f;f++)if(d=ed[f].call(j,a,k,j.opts))return d;return lb.map(k,O,j),lb.isFunction(j.opts.start)&&j.opts.start.call(a,j),lb.fx.timer(lb.extend(i,{elem:a,anim:j,queue:j.opts.queue})),j.progress(j.opts.progress).done(j.opts.done,j.opts.complete).fail(j.opts.fail).always(j.opts.always)}function Q(a,b){var c,d,e,f,g;for(c in a)if(d=lb.camelCase(c),e=b[d],f=a[c],lb.isArray(f)&&(e=f[1],f=a[c]=f[0]),c!==d&&(a[d]=f,delete a[c]),g=lb.cssHooks[d],g&&"expand"in g){f=g.expand(f),delete a[d];for(c in f)c in a||(a[c]=f[c],b[c]=e)}else b[d]=e}function R(a,b,c){var d,e,f,g,h,i,j=this,k={},l=a.style,m=a.nodeType&&y(a),n=lb._data(a,"fxshow");c.queue||(h=lb._queueHooks(a,"fx"),null==h.unqueued&&(h.unqueued=0,i=h.empty.fire,h.empty.fire=function(){h.unqueued||i()}),h.unqueued++,j.always(function(){j.always(function(){h.unqueued--,lb.queue(a,"fx").length||h.empty.fire()})})),1===a.nodeType&&("height"in b||"width"in b)&&(c.overflow=[l.overflow,l.overflowX,l.overflowY],"inline"===lb.css(a,"display")&&"none"===lb.css(a,"float")&&(lb.support.inlineBlockNeedsLayout&&"inline"!==D(a.nodeName)?l.zoom=1:l.display="inline-block")),c.overflow&&(l.overflow="hidden",lb.support.shrinkWrapBlocks||j.always(function(){l.overflow=c.overflow[0],l.overflowX=c.overflow[1],l.overflowY=c.overflow[2]}));for(d in b)if(e=b[d],bd.exec(e)){if(delete b[d],f=f||"toggle"===e,e===(m?"hide":"show"))continue;k[d]=n&&n[d]||lb.style(a,d)}if(!lb.isEmptyObject(k)){n?"hidden"in n&&(m=n.hidden):n=lb._data(a,"fxshow",{}),f&&(n.hidden=!m),m?lb(a).show():j.done(function(){lb(a).hide()}),j.done(function(){var b;lb._removeData(a,"fxshow");for(b in k)lb.style(a,b,k[b])});for(d in k)g=O(m?n[d]:0,d,j),d in n||(n[d]=g.start,m&&(g.end=g.start,g.start="width"===d||"height"===d?1:0))}}function S(a,b,c,d,e){return new S.prototype.init(a,b,c,d,e)}function T(a,b){var c,d={height:a},e=0;for(b=b?1:0;4>e;e+=2-b)c=yc[e],d["margin"+c]=d["padding"+c]=a;return b&&(d.opacity=d.width=a),d}function U(a){return lb.isWindow(a)?a:9===a.nodeType?a.defaultView||a.parentWindow:!1}var V,W,X=typeof c,Y=a.location,Z=a.document,$=Z.documentElement,_=a.jQuery,ab=a.$,bb={},cb=[],db="1.10.2",eb=cb.concat,fb=cb.push,gb=cb.slice,hb=cb.indexOf,ib=bb.toString,jb=bb.hasOwnProperty,kb=db.trim,lb=function(a,b){return new lb.fn.init(a,b,W)},mb=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,nb=/\S+/g,ob=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,pb=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,qb=/^<(\w+)\s*\/?>(?:<\/\1>|)$/,rb=/^[\],:{}\s]*$/,sb=/(?:^|:|,)(?:\s*\[)+/g,tb=/\\(?:["\\\/bfnrt]|u[\da-fA-F]{4})/g,ub=/"[^"\\\r\n]*"|true|false|null|-?(?:\d+\.|)\d+(?:[eE][+-]?\d+|)/g,vb=/^-ms-/,wb=/-([\da-z])/gi,xb=function(a,b){return b.toUpperCase()},yb=function(a){(Z.addEventListener||"load"===a.type||"complete"===Z.readyState)&&(zb(),lb.ready())},zb=function(){Z.addEventListener?(Z.removeEventListener("DOMContentLoaded",yb,!1),a.removeEventListener("load",yb,!1)):(Z.detachEvent("onreadystatechange",yb),a.detachEvent("onload",yb))};lb.fn=lb.prototype={jquery:db,constructor:lb,init:function(a,b,d){var e,f;if(!a)return this;if("string"==typeof a){if(e="<"===a.charAt(0)&&">"===a.charAt(a.length-1)&&a.length>=3?[null,a,null]:pb.exec(a),!e||!e[1]&&b)return!b||b.jquery?(b||d).find(a):this.constructor(b).find(a);if(e[1]){if(b=b instanceof lb?b[0]:b,lb.merge(this,lb.parseHTML(e[1],b&&b.nodeType?b.ownerDocument||b:Z,!0)),qb.test(e[1])&&lb.isPlainObject(b))for(e in b)lb.isFunction(this[e])?this[e](b[e]):this.attr(e,b[e]);return this}if(f=Z.getElementById(e[2]),f&&f.parentNode){if(f.id!==e[2])return d.find(a);this.length=1,this[0]=f}return this.context=Z,this.selector=a,this}return a.nodeType?(this.context=this[0]=a,this.length=1,this):lb.isFunction(a)?d.ready(a):(a.selector!==c&&(this.selector=a.selector,this.context=a.context),lb.makeArray(a,this))},selector:"",length:0,toArray:function(){return gb.call(this)},get:function(a){return null==a?this.toArray():0>a?this[this.length+a]:this[a]},pushStack:function(a){var b=lb.merge(this.constructor(),a);return b.prevObject=this,b.context=this.context,b},each:function(a,b){return lb.each(this,a,b)},ready:function(a){return lb.ready.promise().done(a),this},slice:function(){return this.pushStack(gb.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(a){var b=this.length,c=+a+(0>a?b:0);return this.pushStack(c>=0&&b>c?[this[c]]:[])},map:function(a){return this.pushStack(lb.map(this,function(b,c){return a.call(b,c,b)}))},end:function(){return this.prevObject||this.constructor(null)},push:fb,sort:[].sort,splice:[].splice},lb.fn.init.prototype=lb.fn,lb.extend=lb.fn.extend=function(){var a,b,d,e,f,g,h=arguments[0]||{},i=1,j=arguments.length,k=!1;for("boolean"==typeof h&&(k=h,h=arguments[1]||{},i=2),"object"==typeof h||lb.isFunction(h)||(h={}),j===i&&(h=this,--i);j>i;i++)if(null!=(f=arguments[i]))for(e in f)a=h[e],d=f[e],h!==d&&(k&&d&&(lb.isPlainObject(d)||(b=lb.isArray(d)))?(b?(b=!1,g=a&&lb.isArray(a)?a:[]):g=a&&lb.isPlainObject(a)?a:{},h[e]=lb.extend(k,g,d)):d!==c&&(h[e]=d));return h},lb.extend({expando:"jQuery"+(db+Math.random()).replace(/\D/g,""),noConflict:function(b){return a.$===lb&&(a.$=ab),b&&a.jQuery===lb&&(a.jQuery=_),lb},isReady:!1,readyWait:1,holdReady:function(a){a?lb.readyWait++:lb.ready(!0)},ready:function(a){if(a===!0?!--lb.readyWait:!lb.isReady){if(!Z.body)return setTimeout(lb.ready);lb.isReady=!0,a!==!0&&--lb.readyWait>0||(V.resolveWith(Z,[lb]),lb.fn.trigger&&lb(Z).trigger("ready").off("ready"))}},isFunction:function(a){return"function"===lb.type(a)},isArray:Array.isArray||function(a){return"array"===lb.type(a)},isWindow:function(a){return null!=a&&a==a.window},isNumeric:function(a){return!isNaN(parseFloat(a))&&isFinite(a)},type:function(a){return null==a?String(a):"object"==typeof a||"function"==typeof a?bb[ib.call(a)]||"object":typeof a},isPlainObject:function(a){var b;if(!a||"object"!==lb.type(a)||a.nodeType||lb.isWindow(a))return!1;try{if(a.constructor&&!jb.call(a,"constructor")&&!jb.call(a.constructor.prototype,"isPrototypeOf"))return!1}catch(d){return!1}if(lb.support.ownLast)for(b in a)return jb.call(a,b);for(b in a);return b===c||jb.call(a,b)},isEmptyObject:function(a){var b;for(b in a)return!1;return!0},error:function(a){throw new Error(a)},parseHTML:function(a,b,c){if(!a||"string"!=typeof a)return null;"boolean"==typeof b&&(c=b,b=!1),b=b||Z;var d=qb.exec(a),e=!c&&[];return d?[b.createElement(d[1])]:(d=lb.buildFragment([a],b,e),e&&lb(e).remove(),lb.merge([],d.childNodes))},parseJSON:function(b){return a.JSON&&a.JSON.parse?a.JSON.parse(b):null===b?b:"string"==typeof b&&(b=lb.trim(b),b&&rb.test(b.replace(tb,"@").replace(ub,"]").replace(sb,"")))?new Function("return "+b)():void lb.error("Invalid JSON: "+b)},parseXML:function(b){var d,e;if(!b||"string"!=typeof b)return null;try{a.DOMParser?(e=new DOMParser,d=e.parseFromString(b,"text/xml")):(d=new ActiveXObject("Microsoft.XMLDOM"),d.async="false",d.loadXML(b))}catch(f){d=c}return d&&d.documentElement&&!d.getElementsByTagName("parsererror").length||lb.error("Invalid XML: "+b),d},noop:function(){},globalEval:function(b){b&&lb.trim(b)&&(a.execScript||function(b){a.eval.call(a,b)})(b)},camelCase:function(a){return a.replace(vb,"ms-").replace(wb,xb)},nodeName:function(a,b){return a.nodeName&&a.nodeName.toLowerCase()===b.toLowerCase()},each:function(a,b,c){var e,f=0,g=a.length,h=d(a);if(c){if(h)for(;g>f&&(e=b.apply(a[f],c),e!==!1);f++);else for(f in a)if(e=b.apply(a[f],c),e===!1)break}else if(h)for(;g>f&&(e=b.call(a[f],f,a[f]),e!==!1);f++);else for(f in a)if(e=b.call(a[f],f,a[f]),e===!1)break;return a},trim:kb&&!kb.call("ï»¿Â ")?function(a){return null==a?"":kb.call(a)}:function(a){return null==a?"":(a+"").replace(ob,"")},makeArray:function(a,b){var c=b||[];return null!=a&&(d(Object(a))?lb.merge(c,"string"==typeof a?[a]:a):fb.call(c,a)),c},inArray:function(a,b,c){var d;if(b){if(hb)return hb.call(b,a,c);for(d=b.length,c=c?0>c?Math.max(0,d+c):c:0;d>c;c++)if(c in b&&b[c]===a)return c}return-1},merge:function(a,b){var d=b.length,e=a.length,f=0;if("number"==typeof d)for(;d>f;f++)a[e++]=b[f];else for(;b[f]!==c;)a[e++]=b[f++];return a.length=e,a},grep:function(a,b,c){var d,e=[],f=0,g=a.length;for(c=!!c;g>f;f++)d=!!b(a[f],f),c!==d&&e.push(a[f]);return e},map:function(a,b,c){var e,f=0,g=a.length,h=d(a),i=[];if(h)for(;g>f;f++)e=b(a[f],f,c),null!=e&&(i[i.length]=e);else for(f in a)e=b(a[f],f,c),null!=e&&(i[i.length]=e);return eb.apply([],i)},guid:1,proxy:function(a,b){var d,e,f;return"string"==typeof b&&(f=a[b],b=a,a=f),lb.isFunction(a)?(d=gb.call(arguments,2),e=function(){return a.apply(b||this,d.concat(gb.call(arguments)))},e.guid=a.guid=a.guid||lb.guid++,e):c},access:function(a,b,d,e,f,g,h){var i=0,j=a.length,k=null==d;if("object"===lb.type(d)){f=!0;for(i in d)lb.access(a,b,i,d[i],!0,g,h)}else if(e!==c&&(f=!0,lb.isFunction(e)||(h=!0),k&&(h?(b.call(a,e),b=null):(k=b,b=function(a,b,c){return k.call(lb(a),c)})),b))for(;j>i;i++)b(a[i],d,h?e:e.call(a[i],i,b(a[i],d)));return f?a:k?b.call(a):j?b(a[0],d):g},now:function(){return(new Date).getTime()},swap:function(a,b,c,d){var e,f,g={};for(f in b)g[f]=a.style[f],a.style[f]=b[f];e=c.apply(a,d||[]);for(f in b)a.style[f]=g[f];return e}}),lb.ready.promise=function(b){if(!V)if(V=lb.Deferred(),"complete"===Z.readyState)setTimeout(lb.ready);else if(Z.addEventListener)Z.addEventListener("DOMContentLoaded",yb,!1),a.addEventListener("load",yb,!1);else{Z.attachEvent("onreadystatechange",yb),a.attachEvent("onload",yb);var c=!1;try{c=null==a.frameElement&&Z.documentElement}catch(d){}c&&c.doScroll&&!function e(){if(!lb.isReady){try{c.doScroll("left")}catch(a){return setTimeout(e,50)}zb(),lb.ready()}}()}return V.promise(b)},lb.each("Boolean Number String Function Array Date RegExp Object Error".split(" "),function(a,b){bb["[object "+b+"]"]=b.toLowerCase()}),W=lb(Z),function(a,b){function c(a,b,c,d){var e,f,g,h,i,j,k,l,o,p;if((b?b.ownerDocument||b:O)!==G&&F(b),b=b||G,c=c||[],!a||"string"!=typeof a)return c;if(1!==(h=b.nodeType)&&9!==h)return[];if(I&&!d){if(e=tb.exec(a))if(g=e[1]){if(9===h){if(f=b.getElementById(g),!f||!f.parentNode)return c;if(f.id===g)return c.push(f),c}else if(b.ownerDocument&&(f=b.ownerDocument.getElementById(g))&&M(b,f)&&f.id===g)return c.push(f),c}else{if(e[2])return ab.apply(c,b.getElementsByTagName(a)),c;if((g=e[3])&&x.getElementsByClassName&&b.getElementsByClassName)return ab.apply(c,b.getElementsByClassName(g)),c}if(x.qsa&&(!J||!J.test(a))){if(l=k=N,o=b,p=9===h&&a,1===h&&"object"!==b.nodeName.toLowerCase()){for(j=m(a),(k=b.getAttribute("id"))?l=k.replace(wb,"\\$&"):b.setAttribute("id",l),l="[id='"+l+"'] ",i=j.length;i--;)j[i]=l+n(j[i]);o=nb.test(a)&&b.parentNode||b,p=j.join(",")}if(p)try{return ab.apply(c,o.querySelectorAll(p)),c}catch(q){}finally{k||b.removeAttribute("id")}}}return v(a.replace(jb,"$1"),b,c,d)}function d(){function a(c,d){return b.push(c+=" ")>z.cacheLength&&delete a[b.shift()],a[c]=d}var b=[];return a}function e(a){return a[N]=!0,a}function f(a){var b=G.createElement("div");try{return!!a(b)}catch(c){return!1}finally{b.parentNode&&b.parentNode.removeChild(b),b=null}}function g(a,b){for(var c=a.split("|"),d=a.length;d--;)z.attrHandle[c[d]]=b}function h(a,b){var c=b&&a,d=c&&1===a.nodeType&&1===b.nodeType&&(~b.sourceIndex||X)-(~a.sourceIndex||X);if(d)return d;if(c)for(;c=c.nextSibling;)if(c===b)return-1;return a?1:-1}function i(a){return function(b){var c=b.nodeName.toLowerCase();return"input"===c&&b.type===a}}function j(a){return function(b){var c=b.nodeName.toLowerCase();return("input"===c||"button"===c)&&b.type===a}}function k(a){return e(function(b){return b=+b,e(function(c,d){for(var e,f=a([],c.length,b),g=f.length;g--;)c[e=f[g]]&&(c[e]=!(d[e]=c[e]))})})}function l(){}function m(a,b){var d,e,f,g,h,i,j,k=S[a+" "];if(k)return b?0:k.slice(0);for(h=a,i=[],j=z.preFilter;h;){(!d||(e=kb.exec(h)))&&(e&&(h=h.slice(e[0].length)||h),i.push(f=[])),d=!1,(e=mb.exec(h))&&(d=e.shift(),f.push({value:d,type:e[0].replace(jb," ")}),h=h.slice(d.length));for(g in z.filter)!(e=rb[g].exec(h))||j[g]&&!(e=j[g](e))||(d=e.shift(),f.push({value:d,type:g,matches:e}),h=h.slice(d.length));if(!d)break}return b?h.length:h?c.error(a):S(a,i).slice(0)}function n(a){for(var b=0,c=a.length,d="";c>b;b++)d+=a[b].value;return d}function o(a,b,c){var d=b.dir,e=c&&"parentNode"===d,f=Q++;return b.first?function(b,c,f){for(;b=b[d];)if(1===b.nodeType||e)return a(b,c,f)}:function(b,c,g){var h,i,j,k=P+" "+f;if(g){for(;b=b[d];)if((1===b.nodeType||e)&&a(b,c,g))return!0}else for(;b=b[d];)if(1===b.nodeType||e)if(j=b[N]||(b[N]={}),(i=j[d])&&i[0]===k){if((h=i[1])===!0||h===y)return h===!0}else if(i=j[d]=[k],i[1]=a(b,c,g)||y,i[1]===!0)return!0}}function p(a){return a.length>1?function(b,c,d){for(var e=a.length;e--;)if(!a[e](b,c,d))return!1;return!0}:a[0]}function q(a,b,c,d,e){for(var f,g=[],h=0,i=a.length,j=null!=b;i>h;h++)(f=a[h])&&(!c||c(f,d,e))&&(g.push(f),j&&b.push(h));return g}function r(a,b,c,d,f,g){return d&&!d[N]&&(d=r(d)),f&&!f[N]&&(f=r(f,g)),e(function(e,g,h,i){var j,k,l,m=[],n=[],o=g.length,p=e||u(b||"*",h.nodeType?[h]:h,[]),r=!a||!e&&b?p:q(p,m,a,h,i),s=c?f||(e?a:o||d)?[]:g:r;if(c&&c(r,s,h,i),d)for(j=q(s,n),d(j,[],h,i),k=j.length;k--;)(l=j[k])&&(s[n[k]]=!(r[n[k]]=l));if(e){if(f||a){if(f){for(j=[],k=s.length;k--;)(l=s[k])&&j.push(r[k]=l);f(null,s=[],j,i)}for(k=s.length;k--;)(l=s[k])&&(j=f?cb.call(e,l):m[k])>-1&&(e[j]=!(g[j]=l))}}else s=q(s===g?s.splice(o,s.length):s),f?f(null,g,s,i):ab.apply(g,s)})}function s(a){for(var b,c,d,e=a.length,f=z.relative[a[0].type],g=f||z.relative[" "],h=f?1:0,i=o(function(a){return a===b},g,!0),j=o(function(a){return cb.call(b,a)>-1},g,!0),k=[function(a,c,d){return!f&&(d||c!==D)||((b=c).nodeType?i(a,c,d):j(a,c,d))}];e>h;h++)if(c=z.relative[a[h].type])k=[o(p(k),c)];else{if(c=z.filter[a[h].type].apply(null,a[h].matches),c[N]){for(d=++h;e>d&&!z.relative[a[d].type];d++);return r(h>1&&p(k),h>1&&n(a.slice(0,h-1).concat({value:" "===a[h-2].type?"*":""})).replace(jb,"$1"),c,d>h&&s(a.slice(h,d)),e>d&&s(a=a.slice(d)),e>d&&n(a))}k.push(c)}return p(k)}function t(a,b){var d=0,f=b.length>0,g=a.length>0,h=function(e,h,i,j,k){var l,m,n,o=[],p=0,r="0",s=e&&[],t=null!=k,u=D,v=e||g&&z.find.TAG("*",k&&h.parentNode||h),w=P+=null==u?1:Math.random()||.1;for(t&&(D=h!==G&&h,y=d);null!=(l=v[r]);r++){if(g&&l){for(m=0;n=a[m++];)if(n(l,h,i)){j.push(l);break}t&&(P=w,y=++d)}f&&((l=!n&&l)&&p--,e&&s.push(l))}if(p+=r,f&&r!==p){for(m=0;n=b[m++];)n(s,o,h,i);if(e){if(p>0)for(;r--;)s[r]||o[r]||(o[r]=$.call(j));o=q(o)}ab.apply(j,o),t&&!e&&o.length>0&&p+b.length>1&&c.uniqueSort(j)}return t&&(P=w,D=u),s};return f?e(h):h}function u(a,b,d){for(var e=0,f=b.length;f>e;e++)c(a,b[e],d);return d}function v(a,b,c,d){var e,f,g,h,i,j=m(a);if(!d&&1===j.length){if(f=j[0]=j[0].slice(0),f.length>2&&"ID"===(g=f[0]).type&&x.getById&&9===b.nodeType&&I&&z.relative[f[1].type]){if(b=(z.find.ID(g.matches[0].replace(xb,yb),b)||[])[0],!b)return c;a=a.slice(f.shift().value.length)}for(e=rb.needsContext.test(a)?0:f.length;e--&&(g=f[e],!z.relative[h=g.type]);)if((i=z.find[h])&&(d=i(g.matches[0].replace(xb,yb),nb.test(f[0].type)&&b.parentNode||b))){if(f.splice(e,1),a=d.length&&n(f),!a)return ab.apply(c,d),c;break}}return C(a,j)(d,b,!I,c,nb.test(a)),c}var w,x,y,z,A,B,C,D,E,F,G,H,I,J,K,L,M,N="sizzle"+-new Date,O=a.document,P=0,Q=0,R=d(),S=d(),T=d(),U=!1,V=function(a,b){return a===b?(U=!0,0):0},W=typeof b,X=1<<31,Y={}.hasOwnProperty,Z=[],$=Z.pop,_=Z.push,ab=Z.push,bb=Z.slice,cb=Z.indexOf||function(a){for(var b=0,c=this.length;c>b;b++)if(this[b]===a)return b;return-1},db="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",eb="[\\x20\\t\\r\\n\\f]",fb="(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",gb=fb.replace("w","w#"),hb="\\["+eb+"*("+fb+")"+eb+"*(?:([*^$|!~]?=)"+eb+"*(?:(['\"])((?:\\\\.|[^\\\\])*?)\\3|("+gb+")|)|)"+eb+"*\\]",ib=":("+fb+")(?:\\(((['\"])((?:\\\\.|[^\\\\])*?)\\3|((?:\\\\.|[^\\\\()[\\]]|"+hb.replace(3,8)+")*)|.*)\\)|)",jb=new RegExp("^"+eb+"+|((?:^|[^\\\\])(?:\\\\.)*)"+eb+"+$","g"),kb=new RegExp("^"+eb+"*,"+eb+"*"),mb=new RegExp("^"+eb+"*([>+~]|"+eb+")"+eb+"*"),nb=new RegExp(eb+"*[+~]"),ob=new RegExp("="+eb+"*([^\\]'\"]*)"+eb+"*\\]","g"),pb=new RegExp(ib),qb=new RegExp("^"+gb+"$"),rb={ID:new RegExp("^#("+fb+")"),CLASS:new RegExp("^\\.("+fb+")"),TAG:new RegExp("^("+fb.replace("w","w*")+")"),ATTR:new RegExp("^"+hb),PSEUDO:new RegExp("^"+ib),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+eb+"*(even|odd|(([+-]|)(\\d*)n|)"+eb+"*(?:([+-]|)"+eb+"*(\\d+)|))"+eb+"*\\)|)","i"),bool:new RegExp("^(?:"+db+")$","i"),needsContext:new RegExp("^"+eb+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+eb+"*((?:-\\d)?\\d*)"+eb+"*\\)|)(?=[^-]|$)","i")},sb=/^[^{]+\{\s*\[native \w/,tb=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,ub=/^(?:input|select|textarea|button)$/i,vb=/^h\d$/i,wb=/'|\\/g,xb=new RegExp("\\\\([\\da-f]{1,6}"+eb+"?|("+eb+")|.)","ig"),yb=function(a,b,c){var d="0x"+b-65536;return d!==d||c?b:0>d?String.fromCharCode(d+65536):String.fromCharCode(d>>10|55296,1023&d|56320)};try{ab.apply(Z=bb.call(O.childNodes),O.childNodes),Z[O.childNodes.length].nodeType}catch(zb){ab={apply:Z.length?function(a,b){_.apply(a,bb.call(b))}:function(a,b){for(var c=a.length,d=0;a[c++]=b[d++];);a.length=c-1}}}B=c.isXML=function(a){var b=a&&(a.ownerDocument||a).documentElement;return b?"HTML"!==b.nodeName:!1},x=c.support={},F=c.setDocument=function(a){var b=a?a.ownerDocument||a:O,c=b.defaultView;return b!==G&&9===b.nodeType&&b.documentElement?(G=b,H=b.documentElement,I=!B(b),c&&c.attachEvent&&c!==c.top&&c.attachEvent("onbeforeunload",function(){F()}),x.attributes=f(function(a){return a.className="i",!a.getAttribute("className")}),x.getElementsByTagName=f(function(a){return a.appendChild(b.createComment("")),!a.getElementsByTagName("*").length}),x.getElementsByClassName=f(function(a){return a.innerHTML="<div class='a'></div><div class='a i'></div>",a.firstChild.className="i",2===a.getElementsByClassName("i").length}),x.getById=f(function(a){return H.appendChild(a).id=N,!b.getElementsByName||!b.getElementsByName(N).length}),x.getById?(z.find.ID=function(a,b){if(typeof b.getElementById!==W&&I){var c=b.getElementById(a);return c&&c.parentNode?[c]:[]}},z.filter.ID=function(a){var b=a.replace(xb,yb);return function(a){return a.getAttribute("id")===b}}):(delete z.find.ID,z.filter.ID=function(a){var b=a.replace(xb,yb);return function(a){var c=typeof a.getAttributeNode!==W&&a.getAttributeNode("id");return c&&c.value===b}}),z.find.TAG=x.getElementsByTagName?function(a,b){return typeof b.getElementsByTagName!==W?b.getElementsByTagName(a):void 0}:function(a,b){var c,d=[],e=0,f=b.getElementsByTagName(a);if("*"===a){for(;c=f[e++];)1===c.nodeType&&d.push(c);return d}return f},z.find.CLASS=x.getElementsByClassName&&function(a,b){return typeof b.getElementsByClassName!==W&&I?b.getElementsByClassName(a):void 0},K=[],J=[],(x.qsa=sb.test(b.querySelectorAll))&&(f(function(a){a.innerHTML="<select><option selected=''></option></select>",a.querySelectorAll("[selected]").length||J.push("\\["+eb+"*(?:value|"+db+")"),a.querySelectorAll(":checked").length||J.push(":checked")}),f(function(a){var c=b.createElement("input");c.setAttribute("type","hidden"),a.appendChild(c).setAttribute("t",""),a.querySelectorAll("[t^='']").length&&J.push("[*^$]="+eb+"*(?:''|\"\")"),a.querySelectorAll(":enabled").length||J.push(":enabled",":disabled"),a.querySelectorAll("*,:x"),J.push(",.*:")})),(x.matchesSelector=sb.test(L=H.webkitMatchesSelector||H.mozMatchesSelector||H.oMatchesSelector||H.msMatchesSelector))&&f(function(a){x.disconnectedMatch=L.call(a,"div"),L.call(a,"[s!='']:x"),K.push("!=",ib)}),J=J.length&&new RegExp(J.join("|")),K=K.length&&new RegExp(K.join("|")),M=sb.test(H.contains)||H.compareDocumentPosition?function(a,b){var c=9===a.nodeType?a.documentElement:a,d=b&&b.parentNode;return a===d||!(!d||1!==d.nodeType||!(c.contains?c.contains(d):a.compareDocumentPosition&&16&a.compareDocumentPosition(d)))}:function(a,b){if(b)for(;b=b.parentNode;)if(b===a)return!0;return!1},V=H.compareDocumentPosition?function(a,c){if(a===c)return U=!0,0;var d=c.compareDocumentPosition&&a.compareDocumentPosition&&a.compareDocumentPosition(c);return d?1&d||!x.sortDetached&&c.compareDocumentPosition(a)===d?a===b||M(O,a)?-1:c===b||M(O,c)?1:E?cb.call(E,a)-cb.call(E,c):0:4&d?-1:1:a.compareDocumentPosition?-1:1}:function(a,c){var d,e=0,f=a.parentNode,g=c.parentNode,i=[a],j=[c];if(a===c)return U=!0,0;if(!f||!g)return a===b?-1:c===b?1:f?-1:g?1:E?cb.call(E,a)-cb.call(E,c):0;if(f===g)return h(a,c);for(d=a;d=d.parentNode;)i.unshift(d);for(d=c;d=d.parentNode;)j.unshift(d);for(;i[e]===j[e];)e++;return e?h(i[e],j[e]):i[e]===O?-1:j[e]===O?1:0},b):G},c.matches=function(a,b){return c(a,null,null,b)},c.matchesSelector=function(a,b){if((a.ownerDocument||a)!==G&&F(a),b=b.replace(ob,"='$1']"),!(!x.matchesSelector||!I||K&&K.test(b)||J&&J.test(b)))try{var d=L.call(a,b);if(d||x.disconnectedMatch||a.document&&11!==a.document.nodeType)return d}catch(e){}return c(b,G,null,[a]).length>0},c.contains=function(a,b){return(a.ownerDocument||a)!==G&&F(a),M(a,b)},c.attr=function(a,c){(a.ownerDocument||a)!==G&&F(a);var d=z.attrHandle[c.toLowerCase()],e=d&&Y.call(z.attrHandle,c.toLowerCase())?d(a,c,!I):b;return e===b?x.attributes||!I?a.getAttribute(c):(e=a.getAttributeNode(c))&&e.specified?e.value:null:e},c.error=function(a){throw new Error("Syntax error, unrecognized expression: "+a)},c.uniqueSort=function(a){var b,c=[],d=0,e=0;if(U=!x.detectDuplicates,E=!x.sortStable&&a.slice(0),a.sort(V),U){for(;b=a[e++];)b===a[e]&&(d=c.push(e));for(;d--;)a.splice(c[d],1)}return a},A=c.getText=function(a){var b,c="",d=0,e=a.nodeType;if(e){if(1===e||9===e||11===e){if("string"==typeof a.textContent)return a.textContent;for(a=a.firstChild;a;a=a.nextSibling)c+=A(a)}else if(3===e||4===e)return a.nodeValue}else for(;b=a[d];d++)c+=A(b);return c},z=c.selectors={cacheLength:50,createPseudo:e,match:rb,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(a){return a[1]=a[1].replace(xb,yb),a[3]=(a[4]||a[5]||"").replace(xb,yb),"~="===a[2]&&(a[3]=" "+a[3]+" "),a.slice(0,4)},CHILD:function(a){return a[1]=a[1].toLowerCase(),"nth"===a[1].slice(0,3)?(a[3]||c.error(a[0]),a[4]=+(a[4]?a[5]+(a[6]||1):2*("even"===a[3]||"odd"===a[3])),a[5]=+(a[7]+a[8]||"odd"===a[3])):a[3]&&c.error(a[0]),a},PSEUDO:function(a){var c,d=!a[5]&&a[2];return rb.CHILD.test(a[0])?null:(a[3]&&a[4]!==b?a[2]=a[4]:d&&pb.test(d)&&(c=m(d,!0))&&(c=d.indexOf(")",d.length-c)-d.length)&&(a[0]=a[0].slice(0,c),a[2]=d.slice(0,c)),a.slice(0,3))}},filter:{TAG:function(a){var b=a.replace(xb,yb).toLowerCase();return"*"===a?function(){return!0}:function(a){return a.nodeName&&a.nodeName.toLowerCase()===b}},CLASS:function(a){var b=R[a+" "];return b||(b=new RegExp("(^|"+eb+")"+a+"("+eb+"|$)"))&&R(a,function(a){return b.test("string"==typeof a.className&&a.className||typeof a.getAttribute!==W&&a.getAttribute("class")||"")})},ATTR:function(a,b,d){return function(e){var f=c.attr(e,a);return null==f?"!="===b:b?(f+="","="===b?f===d:"!="===b?f!==d:"^="===b?d&&0===f.indexOf(d):"*="===b?d&&f.indexOf(d)>-1:"$="===b?d&&f.slice(-d.length)===d:"~="===b?(" "+f+" ").indexOf(d)>-1:"|="===b?f===d||f.slice(0,d.length+1)===d+"-":!1):!0}},CHILD:function(a,b,c,d,e){var f="nth"!==a.slice(0,3),g="last"!==a.slice(-4),h="of-type"===b;return 1===d&&0===e?function(a){return!!a.parentNode}:function(b,c,i){var j,k,l,m,n,o,p=f!==g?"nextSibling":"previousSibling",q=b.parentNode,r=h&&b.nodeName.toLowerCase(),s=!i&&!h;if(q){if(f){for(;p;){for(l=b;l=l[p];)if(h?l.nodeName.toLowerCase()===r:1===l.nodeType)return!1;o=p="only"===a&&!o&&"nextSibling"}return!0}if(o=[g?q.firstChild:q.lastChild],g&&s){for(k=q[N]||(q[N]={}),j=k[a]||[],n=j[0]===P&&j[1],m=j[0]===P&&j[2],l=n&&q.childNodes[n];l=++n&&l&&l[p]||(m=n=0)||o.pop();)if(1===l.nodeType&&++m&&l===b){k[a]=[P,n,m];break}}else if(s&&(j=(b[N]||(b[N]={}))[a])&&j[0]===P)m=j[1];else for(;(l=++n&&l&&l[p]||(m=n=0)||o.pop())&&((h?l.nodeName.toLowerCase()!==r:1!==l.nodeType)||!++m||(s&&((l[N]||(l[N]={}))[a]=[P,m]),l!==b)););return m-=e,m===d||m%d===0&&m/d>=0}}},PSEUDO:function(a,b){var d,f=z.pseudos[a]||z.setFilters[a.toLowerCase()]||c.error("unsupported pseudo: "+a);return f[N]?f(b):f.length>1?(d=[a,a,"",b],z.setFilters.hasOwnProperty(a.toLowerCase())?e(function(a,c){for(var d,e=f(a,b),g=e.length;g--;)d=cb.call(a,e[g]),a[d]=!(c[d]=e[g])}):function(a){return f(a,0,d)}):f}},pseudos:{not:e(function(a){var b=[],c=[],d=C(a.replace(jb,"$1"));return d[N]?e(function(a,b,c,e){for(var f,g=d(a,null,e,[]),h=a.length;h--;)(f=g[h])&&(a[h]=!(b[h]=f))}):function(a,e,f){return b[0]=a,d(b,null,f,c),!c.pop()}}),has:e(function(a){return function(b){return c(a,b).length>0}}),contains:e(function(a){return function(b){return(b.textContent||b.innerText||A(b)).indexOf(a)>-1}}),lang:e(function(a){return qb.test(a||"")||c.error("unsupported lang: "+a),a=a.replace(xb,yb).toLowerCase(),function(b){var c;do if(c=I?b.lang:b.getAttribute("xml:lang")||b.getAttribute("lang"))return c=c.toLowerCase(),c===a||0===c.indexOf(a+"-");while((b=b.parentNode)&&1===b.nodeType);return!1}}),target:function(b){var c=a.location&&a.location.hash;return c&&c.slice(1)===b.id},root:function(a){return a===H},focus:function(a){return a===G.activeElement&&(!G.hasFocus||G.hasFocus())&&!!(a.type||a.href||~a.tabIndex)},enabled:function(a){return a.disabled===!1},disabled:function(a){return a.disabled===!0},checked:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&!!a.checked||"option"===b&&!!a.selected},selected:function(a){return a.parentNode&&a.parentNode.selectedIndex,a.selected===!0},empty:function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeName>"@"||3===a.nodeType||4===a.nodeType)return!1;return!0},parent:function(a){return!z.pseudos.empty(a)},header:function(a){return vb.test(a.nodeName)},input:function(a){return ub.test(a.nodeName)},button:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&"button"===a.type||"button"===b},text:function(a){var b;return"input"===a.nodeName.toLowerCase()&&"text"===a.type&&(null==(b=a.getAttribute("type"))||b.toLowerCase()===a.type)},first:k(function(){return[0]}),last:k(function(a,b){return[b-1]}),eq:k(function(a,b,c){return[0>c?c+b:c]}),even:k(function(a,b){for(var c=0;b>c;c+=2)a.push(c);return a}),odd:k(function(a,b){for(var c=1;b>c;c+=2)a.push(c);return a}),lt:k(function(a,b,c){for(var d=0>c?c+b:c;--d>=0;)a.push(d);return a}),gt:k(function(a,b,c){for(var d=0>c?c+b:c;++d<b;)a.push(d);return a})}},z.pseudos.nth=z.pseudos.eq;for(w in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})z.pseudos[w]=i(w);for(w in{submit:!0,reset:!0})z.pseudos[w]=j(w);l.prototype=z.filters=z.pseudos,z.setFilters=new l,C=c.compile=function(a,b){var c,d=[],e=[],f=T[a+" "];if(!f){for(b||(b=m(a)),c=b.length;c--;)f=s(b[c]),f[N]?d.push(f):e.push(f);f=T(a,t(e,d))}return f},x.sortStable=N.split("").sort(V).join("")===N,x.detectDuplicates=U,F(),x.sortDetached=f(function(a){return 1&a.compareDocumentPosition(G.createElement("div"))}),f(function(a){return a.innerHTML="<a href='#'></a>","#"===a.firstChild.getAttribute("href")})||g("type|href|height|width",function(a,b,c){return c?void 0:a.getAttribute(b,"type"===b.toLowerCase()?1:2)}),x.attributes&&f(function(a){return a.innerHTML="<input/>",a.firstChild.setAttribute("value",""),""===a.firstChild.getAttribute("value")})||g("value",function(a,b,c){return c||"input"!==a.nodeName.toLowerCase()?void 0:a.defaultValue}),f(function(a){return null==a.getAttribute("disabled")})||g(db,function(a,b,c){var d;return c?void 0:(d=a.getAttributeNode(b))&&d.specified?d.value:a[b]===!0?b.toLowerCase():null}),lb.find=c,lb.expr=c.selectors,lb.expr[":"]=lb.expr.pseudos,lb.unique=c.uniqueSort,lb.text=c.getText,lb.isXMLDoc=c.isXML,lb.contains=c.contains}(a);var Ab={};lb.Callbacks=function(a){a="string"==typeof a?Ab[a]||e(a):lb.extend({},a);var b,d,f,g,h,i,j=[],k=!a.once&&[],l=function(c){for(d=a.memory&&c,f=!0,h=i||0,i=0,g=j.length,b=!0;j&&g>h;h++)if(j[h].apply(c[0],c[1])===!1&&a.stopOnFalse){d=!1;break}b=!1,j&&(k?k.length&&l(k.shift()):d?j=[]:m.disable())},m={add:function(){if(j){var c=j.length;!function e(b){lb.each(b,function(b,c){var d=lb.type(c);"function"===d?a.unique&&m.has(c)||j.push(c):c&&c.length&&"string"!==d&&e(c)})}(arguments),b?g=j.length:d&&(i=c,l(d))}return this},remove:function(){return j&&lb.each(arguments,function(a,c){for(var d;(d=lb.inArray(c,j,d))>-1;)j.splice(d,1),b&&(g>=d&&g--,h>=d&&h--)}),this},has:function(a){return a?lb.inArray(a,j)>-1:!(!j||!j.length)},empty:function(){return j=[],g=0,this},disable:function(){return j=k=d=c,this},disabled:function(){return!j},lock:function(){return k=c,d||m.disable(),this},locked:function(){return!k},fireWith:function(a,c){return!j||f&&!k||(c=c||[],c=[a,c.slice?c.slice():c],b?k.push(c):l(c)),this},fire:function(){return m.fireWith(this,arguments),this},fired:function(){return!!f}};return m},lb.extend({Deferred:function(a){var b=[["resolve","done",lb.Callbacks("once memory"),"resolved"],["reject","fail",lb.Callbacks("once memory"),"rejected"],["notify","progress",lb.Callbacks("memory")]],c="pending",d={state:function(){return c},always:function(){return e.done(arguments).fail(arguments),this},then:function(){var a=arguments;return lb.Deferred(function(c){lb.each(b,function(b,f){var g=f[0],h=lb.isFunction(a[b])&&a[b];e[f[1]](function(){var a=h&&h.apply(this,arguments);a&&lb.isFunction(a.promise)?a.promise().done(c.resolve).fail(c.reject).progress(c.notify):c[g+"With"](this===d?c.promise():this,h?[a]:arguments)})}),a=null}).promise()},promise:function(a){return null!=a?lb.extend(a,d):d}},e={};return d.pipe=d.then,lb.each(b,function(a,f){var g=f[2],h=f[3];d[f[1]]=g.add,h&&g.add(function(){c=h},b[1^a][2].disable,b[2][2].lock),e[f[0]]=function(){return e[f[0]+"With"](this===e?d:this,arguments),this},e[f[0]+"With"]=g.fireWith}),d.promise(e),a&&a.call(e,e),e},when:function(a){var b,c,d,e=0,f=gb.call(arguments),g=f.length,h=1!==g||a&&lb.isFunction(a.promise)?g:0,i=1===h?a:lb.Deferred(),j=function(a,c,d){return function(e){c[a]=this,d[a]=arguments.length>1?gb.call(arguments):e,d===b?i.notifyWith(c,d):--h||i.resolveWith(c,d)}};if(g>1)for(b=new Array(g),c=new Array(g),d=new Array(g);g>e;e++)f[e]&&lb.isFunction(f[e].promise)?f[e].promise().done(j(e,d,f)).fail(i.reject).progress(j(e,c,b)):--h;return h||i.resolveWith(d,f),i.promise()}}),lb.support=function(b){var c,d,e,f,g,h,i,j,k,l=Z.createElement("div");if(l.setAttribute("className","t"),l.innerHTML="  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>",c=l.getElementsByTagName("*")||[],d=l.getElementsByTagName("a")[0],!d||!d.style||!c.length)return b;f=Z.createElement("select"),h=f.appendChild(Z.createElement("option")),e=l.getElementsByTagName("input")[0],d.style.cssText="top:1px;float:left;opacity:.5",b.getSetAttribute="t"!==l.className,b.leadingWhitespace=3===l.firstChild.nodeType,b.tbody=!l.getElementsByTagName("tbody").length,b.htmlSerialize=!!l.getElementsByTagName("link").length,b.style=/top/.test(d.getAttribute("style")),b.hrefNormalized="/a"===d.getAttribute("href"),b.opacity=/^0.5/.test(d.style.opacity),b.cssFloat=!!d.style.cssFloat,b.checkOn=!!e.value,b.optSelected=h.selected,b.enctype=!!Z.createElement("form").enctype,b.html5Clone="<:nav></:nav>"!==Z.createElement("nav").cloneNode(!0).outerHTML,b.inlineBlockNeedsLayout=!1,b.shrinkWrapBlocks=!1,b.pixelPosition=!1,b.deleteExpando=!0,b.noCloneEvent=!0,b.reliableMarginRight=!0,b.boxSizingReliable=!0,e.checked=!0,b.noCloneChecked=e.cloneNode(!0).checked,f.disabled=!0,b.optDisabled=!h.disabled;
	try{delete l.test}catch(m){b.deleteExpando=!1}e=Z.createElement("input"),e.setAttribute("value",""),b.input=""===e.getAttribute("value"),e.value="t",e.setAttribute("type","radio"),b.radioValue="t"===e.value,e.setAttribute("checked","t"),e.setAttribute("name","t"),g=Z.createDocumentFragment(),g.appendChild(e),b.appendChecked=e.checked,b.checkClone=g.cloneNode(!0).cloneNode(!0).lastChild.checked,l.attachEvent&&(l.attachEvent("onclick",function(){b.noCloneEvent=!1}),l.cloneNode(!0).click());for(k in{submit:!0,change:!0,focusin:!0})l.setAttribute(i="on"+k,"t"),b[k+"Bubbles"]=i in a||l.attributes[i].expando===!1;l.style.backgroundClip="content-box",l.cloneNode(!0).style.backgroundClip="",b.clearCloneStyle="content-box"===l.style.backgroundClip;for(k in lb(b))break;return b.ownLast="0"!==k,lb(function(){var c,d,e,f="padding:0;margin:0;border:0;display:block;box-sizing:content-box;-moz-box-sizing:content-box;-webkit-box-sizing:content-box;",g=Z.getElementsByTagName("body")[0];g&&(c=Z.createElement("div"),c.style.cssText="border:0;width:0;height:0;position:absolute;top:0;left:-9999px;margin-top:1px",g.appendChild(c).appendChild(l),l.innerHTML="<table><tr><td></td><td>t</td></tr></table>",e=l.getElementsByTagName("td"),e[0].style.cssText="padding:0;margin:0;border:0;display:none",j=0===e[0].offsetHeight,e[0].style.display="",e[1].style.display="none",b.reliableHiddenOffsets=j&&0===e[0].offsetHeight,l.innerHTML="",l.style.cssText="box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;padding:1px;border:1px;display:block;width:4px;margin-top:1%;position:absolute;top:1%;",lb.swap(g,null!=g.style.zoom?{zoom:1}:{},function(){b.boxSizing=4===l.offsetWidth}),a.getComputedStyle&&(b.pixelPosition="1%"!==(a.getComputedStyle(l,null)||{}).top,b.boxSizingReliable="4px"===(a.getComputedStyle(l,null)||{width:"4px"}).width,d=l.appendChild(Z.createElement("div")),d.style.cssText=l.style.cssText=f,d.style.marginRight=d.style.width="0",l.style.width="1px",b.reliableMarginRight=!parseFloat((a.getComputedStyle(d,null)||{}).marginRight)),typeof l.style.zoom!==X&&(l.innerHTML="",l.style.cssText=f+"width:1px;padding:1px;display:inline;zoom:1",b.inlineBlockNeedsLayout=3===l.offsetWidth,l.style.display="block",l.innerHTML="<div></div>",l.firstChild.style.width="5px",b.shrinkWrapBlocks=3!==l.offsetWidth,b.inlineBlockNeedsLayout&&(g.style.zoom=1)),g.removeChild(c),c=l=e=d=null)}),c=f=g=h=d=e=null,b}({});var Bb=/(?:\{[\s\S]*\}|\[[\s\S]*\])$/,Cb=/([A-Z])/g;lb.extend({cache:{},noData:{applet:!0,embed:!0,object:"clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"},hasData:function(a){return a=a.nodeType?lb.cache[a[lb.expando]]:a[lb.expando],!!a&&!i(a)},data:function(a,b,c){return f(a,b,c)},removeData:function(a,b){return g(a,b)},_data:function(a,b,c){return f(a,b,c,!0)},_removeData:function(a,b){return g(a,b,!0)},acceptData:function(a){if(a.nodeType&&1!==a.nodeType&&9!==a.nodeType)return!1;var b=a.nodeName&&lb.noData[a.nodeName.toLowerCase()];return!b||b!==!0&&a.getAttribute("classid")===b}}),lb.fn.extend({data:function(a,b){var d,e,f=null,g=0,i=this[0];if(a===c){if(this.length&&(f=lb.data(i),1===i.nodeType&&!lb._data(i,"parsedAttrs"))){for(d=i.attributes;g<d.length;g++)e=d[g].name,0===e.indexOf("data-")&&(e=lb.camelCase(e.slice(5)),h(i,e,f[e]));lb._data(i,"parsedAttrs",!0)}return f}return"object"==typeof a?this.each(function(){lb.data(this,a)}):arguments.length>1?this.each(function(){lb.data(this,a,b)}):i?h(i,a,lb.data(i,a)):null},removeData:function(a){return this.each(function(){lb.removeData(this,a)})}}),lb.extend({queue:function(a,b,c){var d;return a?(b=(b||"fx")+"queue",d=lb._data(a,b),c&&(!d||lb.isArray(c)?d=lb._data(a,b,lb.makeArray(c)):d.push(c)),d||[]):void 0},dequeue:function(a,b){b=b||"fx";var c=lb.queue(a,b),d=c.length,e=c.shift(),f=lb._queueHooks(a,b),g=function(){lb.dequeue(a,b)};"inprogress"===e&&(e=c.shift(),d--),e&&("fx"===b&&c.unshift("inprogress"),delete f.stop,e.call(a,g,f)),!d&&f&&f.empty.fire()},_queueHooks:function(a,b){var c=b+"queueHooks";return lb._data(a,c)||lb._data(a,c,{empty:lb.Callbacks("once memory").add(function(){lb._removeData(a,b+"queue"),lb._removeData(a,c)})})}}),lb.fn.extend({queue:function(a,b){var d=2;return"string"!=typeof a&&(b=a,a="fx",d--),arguments.length<d?lb.queue(this[0],a):b===c?this:this.each(function(){var c=lb.queue(this,a,b);lb._queueHooks(this,a),"fx"===a&&"inprogress"!==c[0]&&lb.dequeue(this,a)})},dequeue:function(a){return this.each(function(){lb.dequeue(this,a)})},delay:function(a,b){return a=lb.fx?lb.fx.speeds[a]||a:a,b=b||"fx",this.queue(b,function(b,c){var d=setTimeout(b,a);c.stop=function(){clearTimeout(d)}})},clearQueue:function(a){return this.queue(a||"fx",[])},promise:function(a,b){var d,e=1,f=lb.Deferred(),g=this,h=this.length,i=function(){--e||f.resolveWith(g,[g])};for("string"!=typeof a&&(b=a,a=c),a=a||"fx";h--;)d=lb._data(g[h],a+"queueHooks"),d&&d.empty&&(e++,d.empty.add(i));return i(),f.promise(b)}});var Db,Eb,Fb=/[\t\r\n\f]/g,Gb=/\r/g,Hb=/^(?:input|select|textarea|button|object)$/i,Ib=/^(?:a|area)$/i,Jb=/^(?:checked|selected)$/i,Kb=lb.support.getSetAttribute,Lb=lb.support.input;lb.fn.extend({attr:function(a,b){return lb.access(this,lb.attr,a,b,arguments.length>1)},removeAttr:function(a){return this.each(function(){lb.removeAttr(this,a)})},prop:function(a,b){return lb.access(this,lb.prop,a,b,arguments.length>1)},removeProp:function(a){return a=lb.propFix[a]||a,this.each(function(){try{this[a]=c,delete this[a]}catch(b){}})},addClass:function(a){var b,c,d,e,f,g=0,h=this.length,i="string"==typeof a&&a;if(lb.isFunction(a))return this.each(function(b){lb(this).addClass(a.call(this,b,this.className))});if(i)for(b=(a||"").match(nb)||[];h>g;g++)if(c=this[g],d=1===c.nodeType&&(c.className?(" "+c.className+" ").replace(Fb," "):" ")){for(f=0;e=b[f++];)d.indexOf(" "+e+" ")<0&&(d+=e+" ");c.className=lb.trim(d)}return this},removeClass:function(a){var b,c,d,e,f,g=0,h=this.length,i=0===arguments.length||"string"==typeof a&&a;if(lb.isFunction(a))return this.each(function(b){lb(this).removeClass(a.call(this,b,this.className))});if(i)for(b=(a||"").match(nb)||[];h>g;g++)if(c=this[g],d=1===c.nodeType&&(c.className?(" "+c.className+" ").replace(Fb," "):"")){for(f=0;e=b[f++];)for(;d.indexOf(" "+e+" ")>=0;)d=d.replace(" "+e+" "," ");c.className=a?lb.trim(d):""}return this},toggleClass:function(a,b){var c=typeof a;return"boolean"==typeof b&&"string"===c?b?this.addClass(a):this.removeClass(a):this.each(lb.isFunction(a)?function(c){lb(this).toggleClass(a.call(this,c,this.className,b),b)}:function(){if("string"===c)for(var b,d=0,e=lb(this),f=a.match(nb)||[];b=f[d++];)e.hasClass(b)?e.removeClass(b):e.addClass(b);else(c===X||"boolean"===c)&&(this.className&&lb._data(this,"__className__",this.className),this.className=this.className||a===!1?"":lb._data(this,"__className__")||"")})},hasClass:function(a){for(var b=" "+a+" ",c=0,d=this.length;d>c;c++)if(1===this[c].nodeType&&(" "+this[c].className+" ").replace(Fb," ").indexOf(b)>=0)return!0;return!1},val:function(a){var b,d,e,f=this[0];{if(arguments.length)return e=lb.isFunction(a),this.each(function(b){var f;1===this.nodeType&&(f=e?a.call(this,b,lb(this).val()):a,null==f?f="":"number"==typeof f?f+="":lb.isArray(f)&&(f=lb.map(f,function(a){return null==a?"":a+""})),d=lb.valHooks[this.type]||lb.valHooks[this.nodeName.toLowerCase()],d&&"set"in d&&d.set(this,f,"value")!==c||(this.value=f))});if(f)return d=lb.valHooks[f.type]||lb.valHooks[f.nodeName.toLowerCase()],d&&"get"in d&&(b=d.get(f,"value"))!==c?b:(b=f.value,"string"==typeof b?b.replace(Gb,""):null==b?"":b)}}}),lb.extend({valHooks:{option:{get:function(a){var b=lb.find.attr(a,"value");return null!=b?b:a.text}},select:{get:function(a){for(var b,c,d=a.options,e=a.selectedIndex,f="select-one"===a.type||0>e,g=f?null:[],h=f?e+1:d.length,i=0>e?h:f?e:0;h>i;i++)if(c=d[i],!(!c.selected&&i!==e||(lb.support.optDisabled?c.disabled:null!==c.getAttribute("disabled"))||c.parentNode.disabled&&lb.nodeName(c.parentNode,"optgroup"))){if(b=lb(c).val(),f)return b;g.push(b)}return g},set:function(a,b){for(var c,d,e=a.options,f=lb.makeArray(b),g=e.length;g--;)d=e[g],(d.selected=lb.inArray(lb(d).val(),f)>=0)&&(c=!0);return c||(a.selectedIndex=-1),f}}},attr:function(a,b,d){var e,f,g=a.nodeType;if(a&&3!==g&&8!==g&&2!==g)return typeof a.getAttribute===X?lb.prop(a,b,d):(1===g&&lb.isXMLDoc(a)||(b=b.toLowerCase(),e=lb.attrHooks[b]||(lb.expr.match.bool.test(b)?Eb:Db)),d===c?e&&"get"in e&&null!==(f=e.get(a,b))?f:(f=lb.find.attr(a,b),null==f?c:f):null!==d?e&&"set"in e&&(f=e.set(a,d,b))!==c?f:(a.setAttribute(b,d+""),d):void lb.removeAttr(a,b))},removeAttr:function(a,b){var c,d,e=0,f=b&&b.match(nb);if(f&&1===a.nodeType)for(;c=f[e++];)d=lb.propFix[c]||c,lb.expr.match.bool.test(c)?Lb&&Kb||!Jb.test(c)?a[d]=!1:a[lb.camelCase("default-"+c)]=a[d]=!1:lb.attr(a,c,""),a.removeAttribute(Kb?c:d)},attrHooks:{type:{set:function(a,b){if(!lb.support.radioValue&&"radio"===b&&lb.nodeName(a,"input")){var c=a.value;return a.setAttribute("type",b),c&&(a.value=c),b}}}},propFix:{"for":"htmlFor","class":"className"},prop:function(a,b,d){var e,f,g,h=a.nodeType;if(a&&3!==h&&8!==h&&2!==h)return g=1!==h||!lb.isXMLDoc(a),g&&(b=lb.propFix[b]||b,f=lb.propHooks[b]),d!==c?f&&"set"in f&&(e=f.set(a,d,b))!==c?e:a[b]=d:f&&"get"in f&&null!==(e=f.get(a,b))?e:a[b]},propHooks:{tabIndex:{get:function(a){var b=lb.find.attr(a,"tabindex");return b?parseInt(b,10):Hb.test(a.nodeName)||Ib.test(a.nodeName)&&a.href?0:-1}}}}),Eb={set:function(a,b,c){return b===!1?lb.removeAttr(a,c):Lb&&Kb||!Jb.test(c)?a.setAttribute(!Kb&&lb.propFix[c]||c,c):a[lb.camelCase("default-"+c)]=a[c]=!0,c}},lb.each(lb.expr.match.bool.source.match(/\w+/g),function(a,b){var d=lb.expr.attrHandle[b]||lb.find.attr;lb.expr.attrHandle[b]=Lb&&Kb||!Jb.test(b)?function(a,b,e){var f=lb.expr.attrHandle[b],g=e?c:(lb.expr.attrHandle[b]=c)!=d(a,b,e)?b.toLowerCase():null;return lb.expr.attrHandle[b]=f,g}:function(a,b,d){return d?c:a[lb.camelCase("default-"+b)]?b.toLowerCase():null}}),Lb&&Kb||(lb.attrHooks.value={set:function(a,b,c){return lb.nodeName(a,"input")?void(a.defaultValue=b):Db&&Db.set(a,b,c)}}),Kb||(Db={set:function(a,b,d){var e=a.getAttributeNode(d);return e||a.setAttributeNode(e=a.ownerDocument.createAttribute(d)),e.value=b+="","value"===d||b===a.getAttribute(d)?b:c}},lb.expr.attrHandle.id=lb.expr.attrHandle.name=lb.expr.attrHandle.coords=function(a,b,d){var e;return d?c:(e=a.getAttributeNode(b))&&""!==e.value?e.value:null},lb.valHooks.button={get:function(a,b){var d=a.getAttributeNode(b);return d&&d.specified?d.value:c},set:Db.set},lb.attrHooks.contenteditable={set:function(a,b,c){Db.set(a,""===b?!1:b,c)}},lb.each(["width","height"],function(a,b){lb.attrHooks[b]={set:function(a,c){return""===c?(a.setAttribute(b,"auto"),c):void 0}}})),lb.support.hrefNormalized||lb.each(["href","src"],function(a,b){lb.propHooks[b]={get:function(a){return a.getAttribute(b,4)}}}),lb.support.style||(lb.attrHooks.style={get:function(a){return a.style.cssText||c},set:function(a,b){return a.style.cssText=b+""}}),lb.support.optSelected||(lb.propHooks.selected={get:function(a){var b=a.parentNode;return b&&(b.selectedIndex,b.parentNode&&b.parentNode.selectedIndex),null}}),lb.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){lb.propFix[this.toLowerCase()]=this}),lb.support.enctype||(lb.propFix.enctype="encoding"),lb.each(["radio","checkbox"],function(){lb.valHooks[this]={set:function(a,b){return lb.isArray(b)?a.checked=lb.inArray(lb(a).val(),b)>=0:void 0}},lb.support.checkOn||(lb.valHooks[this].get=function(a){return null===a.getAttribute("value")?"on":a.value})});var Mb=/^(?:input|select|textarea)$/i,Nb=/^key/,Ob=/^(?:mouse|contextmenu)|click/,Pb=/^(?:focusinfocus|focusoutblur)$/,Qb=/^([^.]*)(?:\.(.+)|)$/;lb.event={global:{},add:function(a,b,d,e,f){var g,h,i,j,k,l,m,n,o,p,q,r=lb._data(a);if(r){for(d.handler&&(j=d,d=j.handler,f=j.selector),d.guid||(d.guid=lb.guid++),(h=r.events)||(h=r.events={}),(l=r.handle)||(l=r.handle=function(a){return typeof lb===X||a&&lb.event.triggered===a.type?c:lb.event.dispatch.apply(l.elem,arguments)},l.elem=a),b=(b||"").match(nb)||[""],i=b.length;i--;)g=Qb.exec(b[i])||[],o=q=g[1],p=(g[2]||"").split(".").sort(),o&&(k=lb.event.special[o]||{},o=(f?k.delegateType:k.bindType)||o,k=lb.event.special[o]||{},m=lb.extend({type:o,origType:q,data:e,handler:d,guid:d.guid,selector:f,needsContext:f&&lb.expr.match.needsContext.test(f),namespace:p.join(".")},j),(n=h[o])||(n=h[o]=[],n.delegateCount=0,k.setup&&k.setup.call(a,e,p,l)!==!1||(a.addEventListener?a.addEventListener(o,l,!1):a.attachEvent&&a.attachEvent("on"+o,l))),k.add&&(k.add.call(a,m),m.handler.guid||(m.handler.guid=d.guid)),f?n.splice(n.delegateCount++,0,m):n.push(m),lb.event.global[o]=!0);a=null}},remove:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,n,o,p,q=lb.hasData(a)&&lb._data(a);if(q&&(k=q.events)){for(b=(b||"").match(nb)||[""],j=b.length;j--;)if(h=Qb.exec(b[j])||[],n=p=h[1],o=(h[2]||"").split(".").sort(),n){for(l=lb.event.special[n]||{},n=(d?l.delegateType:l.bindType)||n,m=k[n]||[],h=h[2]&&new RegExp("(^|\\.)"+o.join("\\.(?:.*\\.|)")+"(\\.|$)"),i=f=m.length;f--;)g=m[f],!e&&p!==g.origType||c&&c.guid!==g.guid||h&&!h.test(g.namespace)||d&&d!==g.selector&&("**"!==d||!g.selector)||(m.splice(f,1),g.selector&&m.delegateCount--,l.remove&&l.remove.call(a,g));i&&!m.length&&(l.teardown&&l.teardown.call(a,o,q.handle)!==!1||lb.removeEvent(a,n,q.handle),delete k[n])}else for(n in k)lb.event.remove(a,n+b[j],c,d,!0);lb.isEmptyObject(k)&&(delete q.handle,lb._removeData(a,"events"))}},trigger:function(b,d,e,f){var g,h,i,j,k,l,m,n=[e||Z],o=jb.call(b,"type")?b.type:b,p=jb.call(b,"namespace")?b.namespace.split("."):[];if(i=l=e=e||Z,3!==e.nodeType&&8!==e.nodeType&&!Pb.test(o+lb.event.triggered)&&(o.indexOf(".")>=0&&(p=o.split("."),o=p.shift(),p.sort()),h=o.indexOf(":")<0&&"on"+o,b=b[lb.expando]?b:new lb.Event(o,"object"==typeof b&&b),b.isTrigger=f?2:3,b.namespace=p.join("."),b.namespace_re=b.namespace?new RegExp("(^|\\.)"+p.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,b.result=c,b.target||(b.target=e),d=null==d?[b]:lb.makeArray(d,[b]),k=lb.event.special[o]||{},f||!k.trigger||k.trigger.apply(e,d)!==!1)){if(!f&&!k.noBubble&&!lb.isWindow(e)){for(j=k.delegateType||o,Pb.test(j+o)||(i=i.parentNode);i;i=i.parentNode)n.push(i),l=i;l===(e.ownerDocument||Z)&&n.push(l.defaultView||l.parentWindow||a)}for(m=0;(i=n[m++])&&!b.isPropagationStopped();)b.type=m>1?j:k.bindType||o,g=(lb._data(i,"events")||{})[b.type]&&lb._data(i,"handle"),g&&g.apply(i,d),g=h&&i[h],g&&lb.acceptData(i)&&g.apply&&g.apply(i,d)===!1&&b.preventDefault();if(b.type=o,!f&&!b.isDefaultPrevented()&&(!k._default||k._default.apply(n.pop(),d)===!1)&&lb.acceptData(e)&&h&&e[o]&&!lb.isWindow(e)){l=e[h],l&&(e[h]=null),lb.event.triggered=o;try{e[o]()}catch(q){}lb.event.triggered=c,l&&(e[h]=l)}return b.result}},dispatch:function(a){a=lb.event.fix(a);var b,d,e,f,g,h=[],i=gb.call(arguments),j=(lb._data(this,"events")||{})[a.type]||[],k=lb.event.special[a.type]||{};if(i[0]=a,a.delegateTarget=this,!k.preDispatch||k.preDispatch.call(this,a)!==!1){for(h=lb.event.handlers.call(this,a,j),b=0;(f=h[b++])&&!a.isPropagationStopped();)for(a.currentTarget=f.elem,g=0;(e=f.handlers[g++])&&!a.isImmediatePropagationStopped();)(!a.namespace_re||a.namespace_re.test(e.namespace))&&(a.handleObj=e,a.data=e.data,d=((lb.event.special[e.origType]||{}).handle||e.handler).apply(f.elem,i),d!==c&&(a.result=d)===!1&&(a.preventDefault(),a.stopPropagation()));return k.postDispatch&&k.postDispatch.call(this,a),a.result}},handlers:function(a,b){var d,e,f,g,h=[],i=b.delegateCount,j=a.target;if(i&&j.nodeType&&(!a.button||"click"!==a.type))for(;j!=this;j=j.parentNode||this)if(1===j.nodeType&&(j.disabled!==!0||"click"!==a.type)){for(f=[],g=0;i>g;g++)e=b[g],d=e.selector+" ",f[d]===c&&(f[d]=e.needsContext?lb(d,this).index(j)>=0:lb.find(d,this,null,[j]).length),f[d]&&f.push(e);f.length&&h.push({elem:j,handlers:f})}return i<b.length&&h.push({elem:this,handlers:b.slice(i)}),h},fix:function(a){if(a[lb.expando])return a;var b,c,d,e=a.type,f=a,g=this.fixHooks[e];for(g||(this.fixHooks[e]=g=Ob.test(e)?this.mouseHooks:Nb.test(e)?this.keyHooks:{}),d=g.props?this.props.concat(g.props):this.props,a=new lb.Event(f),b=d.length;b--;)c=d[b],a[c]=f[c];return a.target||(a.target=f.srcElement||Z),3===a.target.nodeType&&(a.target=a.target.parentNode),a.metaKey=!!a.metaKey,g.filter?g.filter(a,f):a},props:"altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),fixHooks:{},keyHooks:{props:"char charCode key keyCode".split(" "),filter:function(a,b){return null==a.which&&(a.which=null!=b.charCode?b.charCode:b.keyCode),a}},mouseHooks:{props:"button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),filter:function(a,b){var d,e,f,g=b.button,h=b.fromElement;return null==a.pageX&&null!=b.clientX&&(e=a.target.ownerDocument||Z,f=e.documentElement,d=e.body,a.pageX=b.clientX+(f&&f.scrollLeft||d&&d.scrollLeft||0)-(f&&f.clientLeft||d&&d.clientLeft||0),a.pageY=b.clientY+(f&&f.scrollTop||d&&d.scrollTop||0)-(f&&f.clientTop||d&&d.clientTop||0)),!a.relatedTarget&&h&&(a.relatedTarget=h===a.target?b.toElement:h),a.which||g===c||(a.which=1&g?1:2&g?3:4&g?2:0),a}},special:{load:{noBubble:!0},focus:{trigger:function(){if(this!==l()&&this.focus)try{return this.focus(),!1}catch(a){}},delegateType:"focusin"},blur:{trigger:function(){return this===l()&&this.blur?(this.blur(),!1):void 0},delegateType:"focusout"},click:{trigger:function(){return lb.nodeName(this,"input")&&"checkbox"===this.type&&this.click?(this.click(),!1):void 0},_default:function(a){return lb.nodeName(a.target,"a")}},beforeunload:{postDispatch:function(a){a.result!==c&&(a.originalEvent.returnValue=a.result)}}},simulate:function(a,b,c,d){var e=lb.extend(new lb.Event,c,{type:a,isSimulated:!0,originalEvent:{}});d?lb.event.trigger(e,null,b):lb.event.dispatch.call(b,e),e.isDefaultPrevented()&&c.preventDefault()}},lb.removeEvent=Z.removeEventListener?function(a,b,c){a.removeEventListener&&a.removeEventListener(b,c,!1)}:function(a,b,c){var d="on"+b;a.detachEvent&&(typeof a[d]===X&&(a[d]=null),a.detachEvent(d,c))},lb.Event=function(a,b){return this instanceof lb.Event?(a&&a.type?(this.originalEvent=a,this.type=a.type,this.isDefaultPrevented=a.defaultPrevented||a.returnValue===!1||a.getPreventDefault&&a.getPreventDefault()?j:k):this.type=a,b&&lb.extend(this,b),this.timeStamp=a&&a.timeStamp||lb.now(),void(this[lb.expando]=!0)):new lb.Event(a,b)},lb.Event.prototype={isDefaultPrevented:k,isPropagationStopped:k,isImmediatePropagationStopped:k,preventDefault:function(){var a=this.originalEvent;this.isDefaultPrevented=j,a&&(a.preventDefault?a.preventDefault():a.returnValue=!1)},stopPropagation:function(){var a=this.originalEvent;this.isPropagationStopped=j,a&&(a.stopPropagation&&a.stopPropagation(),a.cancelBubble=!0)},stopImmediatePropagation:function(){this.isImmediatePropagationStopped=j,this.stopPropagation()}},lb.each({mouseenter:"mouseover",mouseleave:"mouseout"},function(a,b){lb.event.special[a]={delegateType:b,bindType:b,handle:function(a){var c,d=this,e=a.relatedTarget,f=a.handleObj;return(!e||e!==d&&!lb.contains(d,e))&&(a.type=f.origType,c=f.handler.apply(this,arguments),a.type=b),c}}}),lb.support.submitBubbles||(lb.event.special.submit={setup:function(){return lb.nodeName(this,"form")?!1:void lb.event.add(this,"click._submit keypress._submit",function(a){var b=a.target,d=lb.nodeName(b,"input")||lb.nodeName(b,"button")?b.form:c;d&&!lb._data(d,"submitBubbles")&&(lb.event.add(d,"submit._submit",function(a){a._submit_bubble=!0}),lb._data(d,"submitBubbles",!0))})},postDispatch:function(a){a._submit_bubble&&(delete a._submit_bubble,this.parentNode&&!a.isTrigger&&lb.event.simulate("submit",this.parentNode,a,!0))},teardown:function(){return lb.nodeName(this,"form")?!1:void lb.event.remove(this,"._submit")}}),lb.support.changeBubbles||(lb.event.special.change={setup:function(){return Mb.test(this.nodeName)?(("checkbox"===this.type||"radio"===this.type)&&(lb.event.add(this,"propertychange._change",function(a){"checked"===a.originalEvent.propertyName&&(this._just_changed=!0)}),lb.event.add(this,"click._change",function(a){this._just_changed&&!a.isTrigger&&(this._just_changed=!1),lb.event.simulate("change",this,a,!0)})),!1):void lb.event.add(this,"beforeactivate._change",function(a){var b=a.target;Mb.test(b.nodeName)&&!lb._data(b,"changeBubbles")&&(lb.event.add(b,"change._change",function(a){!this.parentNode||a.isSimulated||a.isTrigger||lb.event.simulate("change",this.parentNode,a,!0)}),lb._data(b,"changeBubbles",!0))})},handle:function(a){var b=a.target;return this!==b||a.isSimulated||a.isTrigger||"radio"!==b.type&&"checkbox"!==b.type?a.handleObj.handler.apply(this,arguments):void 0},teardown:function(){return lb.event.remove(this,"._change"),!Mb.test(this.nodeName)}}),lb.support.focusinBubbles||lb.each({focus:"focusin",blur:"focusout"},function(a,b){var c=0,d=function(a){lb.event.simulate(b,a.target,lb.event.fix(a),!0)};lb.event.special[b]={setup:function(){0===c++&&Z.addEventListener(a,d,!0)},teardown:function(){0===--c&&Z.removeEventListener(a,d,!0)}}}),lb.fn.extend({on:function(a,b,d,e,f){var g,h;if("object"==typeof a){"string"!=typeof b&&(d=d||b,b=c);for(g in a)this.on(g,b,d,a[g],f);return this}if(null==d&&null==e?(e=b,d=b=c):null==e&&("string"==typeof b?(e=d,d=c):(e=d,d=b,b=c)),e===!1)e=k;else if(!e)return this;return 1===f&&(h=e,e=function(a){return lb().off(a),h.apply(this,arguments)},e.guid=h.guid||(h.guid=lb.guid++)),this.each(function(){lb.event.add(this,a,e,d,b)})},one:function(a,b,c,d){return this.on(a,b,c,d,1)},off:function(a,b,d){var e,f;if(a&&a.preventDefault&&a.handleObj)return e=a.handleObj,lb(a.delegateTarget).off(e.namespace?e.origType+"."+e.namespace:e.origType,e.selector,e.handler),this;if("object"==typeof a){for(f in a)this.off(f,b,a[f]);return this}return(b===!1||"function"==typeof b)&&(d=b,b=c),d===!1&&(d=k),this.each(function(){lb.event.remove(this,a,d,b)})},trigger:function(a,b){return this.each(function(){lb.event.trigger(a,b,this)})},triggerHandler:function(a,b){var c=this[0];return c?lb.event.trigger(a,b,c,!0):void 0}});var Rb=/^.[^:#\[\.,]*$/,Sb=/^(?:parents|prev(?:Until|All))/,Tb=lb.expr.match.needsContext,Ub={children:!0,contents:!0,next:!0,prev:!0};lb.fn.extend({find:function(a){var b,c=[],d=this,e=d.length;if("string"!=typeof a)return this.pushStack(lb(a).filter(function(){for(b=0;e>b;b++)if(lb.contains(d[b],this))return!0}));for(b=0;e>b;b++)lb.find(a,d[b],c);return c=this.pushStack(e>1?lb.unique(c):c),c.selector=this.selector?this.selector+" "+a:a,c},has:function(a){var b,c=lb(a,this),d=c.length;return this.filter(function(){for(b=0;d>b;b++)if(lb.contains(this,c[b]))return!0})},not:function(a){return this.pushStack(n(this,a||[],!0))},filter:function(a){return this.pushStack(n(this,a||[],!1))},is:function(a){return!!n(this,"string"==typeof a&&Tb.test(a)?lb(a):a||[],!1).length},closest:function(a,b){for(var c,d=0,e=this.length,f=[],g=Tb.test(a)||"string"!=typeof a?lb(a,b||this.context):0;e>d;d++)for(c=this[d];c&&c!==b;c=c.parentNode)if(c.nodeType<11&&(g?g.index(c)>-1:1===c.nodeType&&lb.find.matchesSelector(c,a))){c=f.push(c);break}return this.pushStack(f.length>1?lb.unique(f):f)},index:function(a){return a?"string"==typeof a?lb.inArray(this[0],lb(a)):lb.inArray(a.jquery?a[0]:a,this):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(a,b){var c="string"==typeof a?lb(a,b):lb.makeArray(a&&a.nodeType?[a]:a),d=lb.merge(this.get(),c);return this.pushStack(lb.unique(d))},addBack:function(a){return this.add(null==a?this.prevObject:this.prevObject.filter(a))}}),lb.each({parent:function(a){var b=a.parentNode;return b&&11!==b.nodeType?b:null},parents:function(a){return lb.dir(a,"parentNode")},parentsUntil:function(a,b,c){return lb.dir(a,"parentNode",c)},next:function(a){return m(a,"nextSibling")},prev:function(a){return m(a,"previousSibling")},nextAll:function(a){return lb.dir(a,"nextSibling")},prevAll:function(a){return lb.dir(a,"previousSibling")},nextUntil:function(a,b,c){return lb.dir(a,"nextSibling",c)},prevUntil:function(a,b,c){return lb.dir(a,"previousSibling",c)},siblings:function(a){return lb.sibling((a.parentNode||{}).firstChild,a)},children:function(a){return lb.sibling(a.firstChild)},contents:function(a){return lb.nodeName(a,"iframe")?a.contentDocument||a.contentWindow.document:lb.merge([],a.childNodes)}},function(a,b){lb.fn[a]=function(c,d){var e=lb.map(this,b,c);return"Until"!==a.slice(-5)&&(d=c),d&&"string"==typeof d&&(e=lb.filter(d,e)),this.length>1&&(Ub[a]||(e=lb.unique(e)),Sb.test(a)&&(e=e.reverse())),this.pushStack(e)}}),lb.extend({filter:function(a,b,c){var d=b[0];return c&&(a=":not("+a+")"),1===b.length&&1===d.nodeType?lb.find.matchesSelector(d,a)?[d]:[]:lb.find.matches(a,lb.grep(b,function(a){return 1===a.nodeType}))},dir:function(a,b,d){for(var e=[],f=a[b];f&&9!==f.nodeType&&(d===c||1!==f.nodeType||!lb(f).is(d));)1===f.nodeType&&e.push(f),f=f[b];return e},sibling:function(a,b){for(var c=[];a;a=a.nextSibling)1===a.nodeType&&a!==b&&c.push(a);return c}});var Vb="abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",Wb=/ jQuery\d+="(?:null|\d+)"/g,Xb=new RegExp("<(?:"+Vb+")[\\s/>]","i"),Yb=/^\s+/,Zb=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,$b=/<([\w:]+)/,_b=/<tbody/i,ac=/<|&#?\w+;/,bc=/<(?:script|style|link)/i,cc=/^(?:checkbox|radio)$/i,dc=/checked\s*(?:[^=]|=\s*.checked.)/i,ec=/^$|\/(?:java|ecma)script/i,fc=/^true\/(.*)/,gc=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,hc={option:[1,"<select multiple='multiple'>","</select>"],legend:[1,"<fieldset>","</fieldset>"],area:[1,"<map>","</map>"],param:[1,"<object>","</object>"],thead:[1,"<table>","</table>"],tr:[2,"<table><tbody>","</tbody></table>"],col:[2,"<table><tbody></tbody><colgroup>","</colgroup></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:lb.support.htmlSerialize?[0,"",""]:[1,"X<div>","</div>"]},ic=o(Z),jc=ic.appendChild(Z.createElement("div"));hc.optgroup=hc.option,hc.tbody=hc.tfoot=hc.colgroup=hc.caption=hc.thead,hc.th=hc.td,lb.fn.extend({text:function(a){return lb.access(this,function(a){return a===c?lb.text(this):this.empty().append((this[0]&&this[0].ownerDocument||Z).createTextNode(a))},null,a,arguments.length)},append:function(){return this.domManip(arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=p(this,a);b.appendChild(a)}})},prepend:function(){return this.domManip(arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=p(this,a);b.insertBefore(a,b.firstChild)}})},before:function(){return this.domManip(arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this)})},after:function(){return this.domManip(arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this.nextSibling)})},remove:function(a,b){for(var c,d=a?lb.filter(a,this):this,e=0;null!=(c=d[e]);e++)b||1!==c.nodeType||lb.cleanData(v(c)),c.parentNode&&(b&&lb.contains(c.ownerDocument,c)&&s(v(c,"script")),c.parentNode.removeChild(c));return this},empty:function(){for(var a,b=0;null!=(a=this[b]);b++){for(1===a.nodeType&&lb.cleanData(v(a,!1));a.firstChild;)a.removeChild(a.firstChild);a.options&&lb.nodeName(a,"select")&&(a.options.length=0)}return this},clone:function(a,b){return a=null==a?!1:a,b=null==b?a:b,this.map(function(){return lb.clone(this,a,b)})},html:function(a){return lb.access(this,function(a){var b=this[0]||{},d=0,e=this.length;if(a===c)return 1===b.nodeType?b.innerHTML.replace(Wb,""):c;if(!("string"!=typeof a||bc.test(a)||!lb.support.htmlSerialize&&Xb.test(a)||!lb.support.leadingWhitespace&&Yb.test(a)||hc[($b.exec(a)||["",""])[1].toLowerCase()])){a=a.replace(Zb,"<$1></$2>");try{for(;e>d;d++)b=this[d]||{},1===b.nodeType&&(lb.cleanData(v(b,!1)),b.innerHTML=a);b=0}catch(f){}}b&&this.empty().append(a)},null,a,arguments.length)},replaceWith:function(){var a=lb.map(this,function(a){return[a.nextSibling,a.parentNode]}),b=0;return this.domManip(arguments,function(c){var d=a[b++],e=a[b++];e&&(d&&d.parentNode!==e&&(d=this.nextSibling),lb(this).remove(),e.insertBefore(c,d))},!0),b?this:this.remove()},detach:function(a){return this.remove(a,!0)},domManip:function(a,b,c){a=eb.apply([],a);var d,e,f,g,h,i,j=0,k=this.length,l=this,m=k-1,n=a[0],o=lb.isFunction(n);if(o||!(1>=k||"string"!=typeof n||lb.support.checkClone)&&dc.test(n))return this.each(function(d){var e=l.eq(d);o&&(a[0]=n.call(this,d,e.html())),e.domManip(a,b,c)});if(k&&(i=lb.buildFragment(a,this[0].ownerDocument,!1,!c&&this),d=i.firstChild,1===i.childNodes.length&&(i=d),d)){for(g=lb.map(v(i,"script"),q),f=g.length;k>j;j++)e=i,j!==m&&(e=lb.clone(e,!0,!0),f&&lb.merge(g,v(e,"script"))),b.call(this[j],e,j);if(f)for(h=g[g.length-1].ownerDocument,lb.map(g,r),j=0;f>j;j++)e=g[j],ec.test(e.type||"")&&!lb._data(e,"globalEval")&&lb.contains(h,e)&&(e.src?lb._evalUrl(e.src):lb.globalEval((e.text||e.textContent||e.innerHTML||"").replace(gc,"")));i=d=null}return this}}),lb.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(a,b){lb.fn[a]=function(a){for(var c,d=0,e=[],f=lb(a),g=f.length-1;g>=d;d++)c=d===g?this:this.clone(!0),lb(f[d])[b](c),fb.apply(e,c.get());return this.pushStack(e)}}),lb.extend({clone:function(a,b,c){var d,e,f,g,h,i=lb.contains(a.ownerDocument,a);if(lb.support.html5Clone||lb.isXMLDoc(a)||!Xb.test("<"+a.nodeName+">")?f=a.cloneNode(!0):(jc.innerHTML=a.outerHTML,jc.removeChild(f=jc.firstChild)),!(lb.support.noCloneEvent&&lb.support.noCloneChecked||1!==a.nodeType&&11!==a.nodeType||lb.isXMLDoc(a)))for(d=v(f),h=v(a),g=0;null!=(e=h[g]);++g)d[g]&&u(e,d[g]);if(b)if(c)for(h=h||v(a),d=d||v(f),g=0;null!=(e=h[g]);g++)t(e,d[g]);else t(a,f);return d=v(f,"script"),d.length>0&&s(d,!i&&v(a,"script")),d=h=e=null,f},buildFragment:function(a,b,c,d){for(var e,f,g,h,i,j,k,l=a.length,m=o(b),n=[],p=0;l>p;p++)if(f=a[p],f||0===f)if("object"===lb.type(f))lb.merge(n,f.nodeType?[f]:f);else if(ac.test(f)){for(h=h||m.appendChild(b.createElement("div")),i=($b.exec(f)||["",""])[1].toLowerCase(),k=hc[i]||hc._default,h.innerHTML=k[1]+f.replace(Zb,"<$1></$2>")+k[2],e=k[0];e--;)h=h.lastChild;if(!lb.support.leadingWhitespace&&Yb.test(f)&&n.push(b.createTextNode(Yb.exec(f)[0])),!lb.support.tbody)for(f="table"!==i||_b.test(f)?"<table>"!==k[1]||_b.test(f)?0:h:h.firstChild,e=f&&f.childNodes.length;e--;)lb.nodeName(j=f.childNodes[e],"tbody")&&!j.childNodes.length&&f.removeChild(j);for(lb.merge(n,h.childNodes),h.textContent="";h.firstChild;)h.removeChild(h.firstChild);h=m.lastChild}else n.push(b.createTextNode(f));for(h&&m.removeChild(h),lb.support.appendChecked||lb.grep(v(n,"input"),w),p=0;f=n[p++];)if((!d||-1===lb.inArray(f,d))&&(g=lb.contains(f.ownerDocument,f),h=v(m.appendChild(f),"script"),g&&s(h),c))for(e=0;f=h[e++];)ec.test(f.type||"")&&c.push(f);return h=null,m},cleanData:function(a,b){for(var c,d,e,f,g=0,h=lb.expando,i=lb.cache,j=lb.support.deleteExpando,k=lb.event.special;null!=(c=a[g]);g++)if((b||lb.acceptData(c))&&(e=c[h],f=e&&i[e])){if(f.events)for(d in f.events)k[d]?lb.event.remove(c,d):lb.removeEvent(c,d,f.handle);i[e]&&(delete i[e],j?delete c[h]:typeof c.removeAttribute!==X?c.removeAttribute(h):c[h]=null,cb.push(e))}},_evalUrl:function(a){return lb.ajax({url:a,type:"GET",dataType:"script",async:!1,global:!1,"throws":!0})}}),lb.fn.extend({wrapAll:function(a){if(lb.isFunction(a))return this.each(function(b){lb(this).wrapAll(a.call(this,b))});if(this[0]){var b=lb(a,this[0].ownerDocument).eq(0).clone(!0);this[0].parentNode&&b.insertBefore(this[0]),b.map(function(){for(var a=this;a.firstChild&&1===a.firstChild.nodeType;)a=a.firstChild;return a}).append(this)}return this},wrapInner:function(a){return this.each(lb.isFunction(a)?function(b){lb(this).wrapInner(a.call(this,b))}:function(){var b=lb(this),c=b.contents();
	c.length?c.wrapAll(a):b.append(a)})},wrap:function(a){var b=lb.isFunction(a);return this.each(function(c){lb(this).wrapAll(b?a.call(this,c):a)})},unwrap:function(){return this.parent().each(function(){lb.nodeName(this,"body")||lb(this).replaceWith(this.childNodes)}).end()}});var kc,lc,mc,nc=/alpha\([^)]*\)/i,oc=/opacity\s*=\s*([^)]*)/,pc=/^(top|right|bottom|left)$/,qc=/^(none|table(?!-c[ea]).+)/,rc=/^margin/,sc=new RegExp("^("+mb+")(.*)$","i"),tc=new RegExp("^("+mb+")(?!px)[a-z%]+$","i"),uc=new RegExp("^([+-])=("+mb+")","i"),vc={BODY:"block"},wc={position:"absolute",visibility:"hidden",display:"block"},xc={letterSpacing:0,fontWeight:400},yc=["Top","Right","Bottom","Left"],zc=["Webkit","O","Moz","ms"];lb.fn.extend({css:function(a,b){return lb.access(this,function(a,b,d){var e,f,g={},h=0;if(lb.isArray(b)){for(f=lc(a),e=b.length;e>h;h++)g[b[h]]=lb.css(a,b[h],!1,f);return g}return d!==c?lb.style(a,b,d):lb.css(a,b)},a,b,arguments.length>1)},show:function(){return z(this,!0)},hide:function(){return z(this)},toggle:function(a){return"boolean"==typeof a?a?this.show():this.hide():this.each(function(){y(this)?lb(this).show():lb(this).hide()})}}),lb.extend({cssHooks:{opacity:{get:function(a,b){if(b){var c=mc(a,"opacity");return""===c?"1":c}}}},cssNumber:{columnCount:!0,fillOpacity:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{"float":lb.support.cssFloat?"cssFloat":"styleFloat"},style:function(a,b,d,e){if(a&&3!==a.nodeType&&8!==a.nodeType&&a.style){var f,g,h,i=lb.camelCase(b),j=a.style;if(b=lb.cssProps[i]||(lb.cssProps[i]=x(j,i)),h=lb.cssHooks[b]||lb.cssHooks[i],d===c)return h&&"get"in h&&(f=h.get(a,!1,e))!==c?f:j[b];if(g=typeof d,"string"===g&&(f=uc.exec(d))&&(d=(f[1]+1)*f[2]+parseFloat(lb.css(a,b)),g="number"),!(null==d||"number"===g&&isNaN(d)||("number"!==g||lb.cssNumber[i]||(d+="px"),lb.support.clearCloneStyle||""!==d||0!==b.indexOf("background")||(j[b]="inherit"),h&&"set"in h&&(d=h.set(a,d,e))===c)))try{j[b]=d}catch(k){}}},css:function(a,b,d,e){var f,g,h,i=lb.camelCase(b);return b=lb.cssProps[i]||(lb.cssProps[i]=x(a.style,i)),h=lb.cssHooks[b]||lb.cssHooks[i],h&&"get"in h&&(g=h.get(a,!0,d)),g===c&&(g=mc(a,b,e)),"normal"===g&&b in xc&&(g=xc[b]),""===d||d?(f=parseFloat(g),d===!0||lb.isNumeric(f)?f||0:g):g}}),a.getComputedStyle?(lc=function(b){return a.getComputedStyle(b,null)},mc=function(a,b,d){var e,f,g,h=d||lc(a),i=h?h.getPropertyValue(b)||h[b]:c,j=a.style;return h&&(""!==i||lb.contains(a.ownerDocument,a)||(i=lb.style(a,b)),tc.test(i)&&rc.test(b)&&(e=j.width,f=j.minWidth,g=j.maxWidth,j.minWidth=j.maxWidth=j.width=i,i=h.width,j.width=e,j.minWidth=f,j.maxWidth=g)),i}):Z.documentElement.currentStyle&&(lc=function(a){return a.currentStyle},mc=function(a,b,d){var e,f,g,h=d||lc(a),i=h?h[b]:c,j=a.style;return null==i&&j&&j[b]&&(i=j[b]),tc.test(i)&&!pc.test(b)&&(e=j.left,f=a.runtimeStyle,g=f&&f.left,g&&(f.left=a.currentStyle.left),j.left="fontSize"===b?"1em":i,i=j.pixelLeft+"px",j.left=e,g&&(f.left=g)),""===i?"auto":i}),lb.each(["height","width"],function(a,b){lb.cssHooks[b]={get:function(a,c,d){return c?0===a.offsetWidth&&qc.test(lb.css(a,"display"))?lb.swap(a,wc,function(){return C(a,b,d)}):C(a,b,d):void 0},set:function(a,c,d){var e=d&&lc(a);return A(a,c,d?B(a,b,d,lb.support.boxSizing&&"border-box"===lb.css(a,"boxSizing",!1,e),e):0)}}}),lb.support.opacity||(lb.cssHooks.opacity={get:function(a,b){return oc.test((b&&a.currentStyle?a.currentStyle.filter:a.style.filter)||"")?.01*parseFloat(RegExp.$1)+"":b?"1":""},set:function(a,b){var c=a.style,d=a.currentStyle,e=lb.isNumeric(b)?"alpha(opacity="+100*b+")":"",f=d&&d.filter||c.filter||"";c.zoom=1,(b>=1||""===b)&&""===lb.trim(f.replace(nc,""))&&c.removeAttribute&&(c.removeAttribute("filter"),""===b||d&&!d.filter)||(c.filter=nc.test(f)?f.replace(nc,e):f+" "+e)}}),lb(function(){lb.support.reliableMarginRight||(lb.cssHooks.marginRight={get:function(a,b){return b?lb.swap(a,{display:"inline-block"},mc,[a,"marginRight"]):void 0}}),!lb.support.pixelPosition&&lb.fn.position&&lb.each(["top","left"],function(a,b){lb.cssHooks[b]={get:function(a,c){return c?(c=mc(a,b),tc.test(c)?lb(a).position()[b]+"px":c):void 0}}})}),lb.expr&&lb.expr.filters&&(lb.expr.filters.hidden=function(a){return a.offsetWidth<=0&&a.offsetHeight<=0||!lb.support.reliableHiddenOffsets&&"none"===(a.style&&a.style.display||lb.css(a,"display"))},lb.expr.filters.visible=function(a){return!lb.expr.filters.hidden(a)}),lb.each({margin:"",padding:"",border:"Width"},function(a,b){lb.cssHooks[a+b]={expand:function(c){for(var d=0,e={},f="string"==typeof c?c.split(" "):[c];4>d;d++)e[a+yc[d]+b]=f[d]||f[d-2]||f[0];return e}},rc.test(a)||(lb.cssHooks[a+b].set=A)});var Ac=/%20/g,Bc=/\[\]$/,Cc=/\r?\n/g,Dc=/^(?:submit|button|image|reset|file)$/i,Ec=/^(?:input|select|textarea|keygen)/i;lb.fn.extend({serialize:function(){return lb.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var a=lb.prop(this,"elements");return a?lb.makeArray(a):this}).filter(function(){var a=this.type;return this.name&&!lb(this).is(":disabled")&&Ec.test(this.nodeName)&&!Dc.test(a)&&(this.checked||!cc.test(a))}).map(function(a,b){var c=lb(this).val();return null==c?null:lb.isArray(c)?lb.map(c,function(a){return{name:b.name,value:a.replace(Cc,"\r\n")}}):{name:b.name,value:c.replace(Cc,"\r\n")}}).get()}}),lb.param=function(a,b){var d,e=[],f=function(a,b){b=lb.isFunction(b)?b():null==b?"":b,e[e.length]=encodeURIComponent(a)+"="+encodeURIComponent(b)};if(b===c&&(b=lb.ajaxSettings&&lb.ajaxSettings.traditional),lb.isArray(a)||a.jquery&&!lb.isPlainObject(a))lb.each(a,function(){f(this.name,this.value)});else for(d in a)F(d,a[d],b,f);return e.join("&").replace(Ac,"+")},lb.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "),function(a,b){lb.fn[b]=function(a,c){return arguments.length>0?this.on(b,null,a,c):this.trigger(b)}}),lb.fn.extend({hover:function(a,b){return this.mouseenter(a).mouseleave(b||a)},bind:function(a,b,c){return this.on(a,null,b,c)},unbind:function(a,b){return this.off(a,null,b)},delegate:function(a,b,c,d){return this.on(b,a,c,d)},undelegate:function(a,b,c){return 1===arguments.length?this.off(a,"**"):this.off(b,a||"**",c)}});var Fc,Gc,Hc=lb.now(),Ic=/\?/,Jc=/#.*$/,Kc=/([?&])_=[^&]*/,Lc=/^(.*?):[ \t]*([^\r\n]*)\r?$/gm,Mc=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,Nc=/^(?:GET|HEAD)$/,Oc=/^\/\//,Pc=/^([\w.+-]+:)(?:\/\/([^\/?#:]*)(?::(\d+)|)|)/,Qc=lb.fn.load,Rc={},Sc={},Tc="*/".concat("*");try{Gc=Y.href}catch(Uc){Gc=Z.createElement("a"),Gc.href="",Gc=Gc.href}Fc=Pc.exec(Gc.toLowerCase())||[],lb.fn.load=function(a,b,d){if("string"!=typeof a&&Qc)return Qc.apply(this,arguments);var e,f,g,h=this,i=a.indexOf(" ");return i>=0&&(e=a.slice(i,a.length),a=a.slice(0,i)),lb.isFunction(b)?(d=b,b=c):b&&"object"==typeof b&&(g="POST"),h.length>0&&lb.ajax({url:a,type:g,dataType:"html",data:b}).done(function(a){f=arguments,h.html(e?lb("<div>").append(lb.parseHTML(a)).find(e):a)}).complete(d&&function(a,b){h.each(d,f||[a.responseText,b,a])}),this},lb.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(a,b){lb.fn[b]=function(a){return this.on(b,a)}}),lb.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:Gc,type:"GET",isLocal:Mc.test(Fc[1]),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":Tc,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/xml/,html:/html/,json:/json/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":lb.parseJSON,"text xml":lb.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(a,b){return b?I(I(a,lb.ajaxSettings),b):I(lb.ajaxSettings,a)},ajaxPrefilter:G(Rc),ajaxTransport:G(Sc),ajax:function(a,b){function d(a,b,d,e){var f,l,s,t,v,x=b;2!==u&&(u=2,i&&clearTimeout(i),k=c,h=e||"",w.readyState=a>0?4:0,f=a>=200&&300>a||304===a,d&&(t=J(m,w,d)),t=K(m,t,w,f),f?(m.ifModified&&(v=w.getResponseHeader("Last-Modified"),v&&(lb.lastModified[g]=v),v=w.getResponseHeader("etag"),v&&(lb.etag[g]=v)),204===a||"HEAD"===m.type?x="nocontent":304===a?x="notmodified":(x=t.state,l=t.data,s=t.error,f=!s)):(s=x,(a||!x)&&(x="error",0>a&&(a=0))),w.status=a,w.statusText=(b||x)+"",f?p.resolveWith(n,[l,x,w]):p.rejectWith(n,[w,x,s]),w.statusCode(r),r=c,j&&o.trigger(f?"ajaxSuccess":"ajaxError",[w,m,f?l:s]),q.fireWith(n,[w,x]),j&&(o.trigger("ajaxComplete",[w,m]),--lb.active||lb.event.trigger("ajaxStop")))}"object"==typeof a&&(b=a,a=c),b=b||{};var e,f,g,h,i,j,k,l,m=lb.ajaxSetup({},b),n=m.context||m,o=m.context&&(n.nodeType||n.jquery)?lb(n):lb.event,p=lb.Deferred(),q=lb.Callbacks("once memory"),r=m.statusCode||{},s={},t={},u=0,v="canceled",w={readyState:0,getResponseHeader:function(a){var b;if(2===u){if(!l)for(l={};b=Lc.exec(h);)l[b[1].toLowerCase()]=b[2];b=l[a.toLowerCase()]}return null==b?null:b},getAllResponseHeaders:function(){return 2===u?h:null},setRequestHeader:function(a,b){var c=a.toLowerCase();return u||(a=t[c]=t[c]||a,s[a]=b),this},overrideMimeType:function(a){return u||(m.mimeType=a),this},statusCode:function(a){var b;if(a)if(2>u)for(b in a)r[b]=[r[b],a[b]];else w.always(a[w.status]);return this},abort:function(a){var b=a||v;return k&&k.abort(b),d(0,b),this}};if(p.promise(w).complete=q.add,w.success=w.done,w.error=w.fail,m.url=((a||m.url||Gc)+"").replace(Jc,"").replace(Oc,Fc[1]+"//"),m.type=b.method||b.type||m.method||m.type,m.dataTypes=lb.trim(m.dataType||"*").toLowerCase().match(nb)||[""],null==m.crossDomain&&(e=Pc.exec(m.url.toLowerCase()),m.crossDomain=!(!e||e[1]===Fc[1]&&e[2]===Fc[2]&&(e[3]||("http:"===e[1]?"80":"443"))===(Fc[3]||("http:"===Fc[1]?"80":"443")))),m.data&&m.processData&&"string"!=typeof m.data&&(m.data=lb.param(m.data,m.traditional)),H(Rc,m,b,w),2===u)return w;j=m.global,j&&0===lb.active++&&lb.event.trigger("ajaxStart"),m.type=m.type.toUpperCase(),m.hasContent=!Nc.test(m.type),g=m.url,m.hasContent||(m.data&&(g=m.url+=(Ic.test(g)?"&":"?")+m.data,delete m.data),m.cache===!1&&(m.url=Kc.test(g)?g.replace(Kc,"$1_="+Hc++):g+(Ic.test(g)?"&":"?")+"_="+Hc++)),m.ifModified&&(lb.lastModified[g]&&w.setRequestHeader("If-Modified-Since",lb.lastModified[g]),lb.etag[g]&&w.setRequestHeader("If-None-Match",lb.etag[g])),(m.data&&m.hasContent&&m.contentType!==!1||b.contentType)&&w.setRequestHeader("Content-Type",m.contentType),w.setRequestHeader("Accept",m.dataTypes[0]&&m.accepts[m.dataTypes[0]]?m.accepts[m.dataTypes[0]]+("*"!==m.dataTypes[0]?", "+Tc+"; q=0.01":""):m.accepts["*"]);for(f in m.headers)w.setRequestHeader(f,m.headers[f]);if(m.beforeSend&&(m.beforeSend.call(n,w,m)===!1||2===u))return w.abort();v="abort";for(f in{success:1,error:1,complete:1})w[f](m[f]);if(k=H(Sc,m,b,w)){w.readyState=1,j&&o.trigger("ajaxSend",[w,m]),m.async&&m.timeout>0&&(i=setTimeout(function(){w.abort("timeout")},m.timeout));try{u=1,k.send(s,d)}catch(x){if(!(2>u))throw x;d(-1,x)}}else d(-1,"No Transport");return w},getJSON:function(a,b,c){return lb.get(a,b,c,"json")},getScript:function(a,b){return lb.get(a,c,b,"script")}}),lb.each(["get","post"],function(a,b){lb[b]=function(a,d,e,f){return lb.isFunction(d)&&(f=f||e,e=d,d=c),lb.ajax({url:a,type:b,dataType:f,data:d,success:e})}}),lb.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/(?:java|ecma)script/},converters:{"text script":function(a){return lb.globalEval(a),a}}}),lb.ajaxPrefilter("script",function(a){a.cache===c&&(a.cache=!1),a.crossDomain&&(a.type="GET",a.global=!1)}),lb.ajaxTransport("script",function(a){if(a.crossDomain){var b,d=Z.head||lb("head")[0]||Z.documentElement;return{send:function(c,e){b=Z.createElement("script"),b.async=!0,a.scriptCharset&&(b.charset=a.scriptCharset),b.src=a.url,b.onload=b.onreadystatechange=function(a,c){(c||!b.readyState||/loaded|complete/.test(b.readyState))&&(b.onload=b.onreadystatechange=null,b.parentNode&&b.parentNode.removeChild(b),b=null,c||e(200,"success"))},d.insertBefore(b,d.firstChild)},abort:function(){b&&b.onload(c,!0)}}}});var Vc=[],Wc=/(=)\?(?=&|$)|\?\?/;lb.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var a=Vc.pop()||lb.expando+"_"+Hc++;return this[a]=!0,a}}),lb.ajaxPrefilter("json jsonp",function(b,d,e){var f,g,h,i=b.jsonp!==!1&&(Wc.test(b.url)?"url":"string"==typeof b.data&&!(b.contentType||"").indexOf("application/x-www-form-urlencoded")&&Wc.test(b.data)&&"data");return i||"jsonp"===b.dataTypes[0]?(f=b.jsonpCallback=lb.isFunction(b.jsonpCallback)?b.jsonpCallback():b.jsonpCallback,i?b[i]=b[i].replace(Wc,"$1"+f):b.jsonp!==!1&&(b.url+=(Ic.test(b.url)?"&":"?")+b.jsonp+"="+f),b.converters["script json"]=function(){return h||lb.error(f+" was not called"),h[0]},b.dataTypes[0]="json",g=a[f],a[f]=function(){h=arguments},e.always(function(){a[f]=g,b[f]&&(b.jsonpCallback=d.jsonpCallback,Vc.push(f)),h&&lb.isFunction(g)&&g(h[0]),h=g=c}),"script"):void 0});var Xc,Yc,Zc=0,$c=a.ActiveXObject&&function(){var a;for(a in Xc)Xc[a](c,!0)};lb.ajaxSettings.xhr=a.ActiveXObject?function(){return!this.isLocal&&L()||M()}:L,Yc=lb.ajaxSettings.xhr(),lb.support.cors=!!Yc&&"withCredentials"in Yc,Yc=lb.support.ajax=!!Yc,Yc&&lb.ajaxTransport(function(b){if(!b.crossDomain||lb.support.cors){var d;return{send:function(e,f){var g,h,i=b.xhr();if(b.username?i.open(b.type,b.url,b.async,b.username,b.password):i.open(b.type,b.url,b.async),b.xhrFields)for(h in b.xhrFields)i[h]=b.xhrFields[h];b.mimeType&&i.overrideMimeType&&i.overrideMimeType(b.mimeType),b.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest");try{for(h in e)i.setRequestHeader(h,e[h])}catch(j){}i.send(b.hasContent&&b.data||null),d=function(a,e){var h,j,k,l;try{if(d&&(e||4===i.readyState))if(d=c,g&&(i.onreadystatechange=lb.noop,$c&&delete Xc[g]),e)4!==i.readyState&&i.abort();else{l={},h=i.status,j=i.getAllResponseHeaders(),"string"==typeof i.responseText&&(l.text=i.responseText);try{k=i.statusText}catch(m){k=""}h||!b.isLocal||b.crossDomain?1223===h&&(h=204):h=l.text?200:404}}catch(n){e||f(-1,n)}l&&f(h,k,l,j)},b.async?4===i.readyState?setTimeout(d):(g=++Zc,$c&&(Xc||(Xc={},lb(a).unload($c)),Xc[g]=d),i.onreadystatechange=d):d()},abort:function(){d&&d(c,!0)}}}});var _c,ad,bd=/^(?:toggle|show|hide)$/,cd=new RegExp("^(?:([+-])=|)("+mb+")([a-z%]*)$","i"),dd=/queueHooks$/,ed=[R],fd={"*":[function(a,b){var c=this.createTween(a,b),d=c.cur(),e=cd.exec(b),f=e&&e[3]||(lb.cssNumber[a]?"":"px"),g=(lb.cssNumber[a]||"px"!==f&&+d)&&cd.exec(lb.css(c.elem,a)),h=1,i=20;if(g&&g[3]!==f){f=f||g[3],e=e||[],g=+d||1;do h=h||".5",g/=h,lb.style(c.elem,a,g+f);while(h!==(h=c.cur()/d)&&1!==h&&--i)}return e&&(g=c.start=+g||+d||0,c.unit=f,c.end=e[1]?g+(e[1]+1)*e[2]:+e[2]),c}]};lb.Animation=lb.extend(P,{tweener:function(a,b){lb.isFunction(a)?(b=a,a=["*"]):a=a.split(" ");for(var c,d=0,e=a.length;e>d;d++)c=a[d],fd[c]=fd[c]||[],fd[c].unshift(b)},prefilter:function(a,b){b?ed.unshift(a):ed.push(a)}}),lb.Tween=S,S.prototype={constructor:S,init:function(a,b,c,d,e,f){this.elem=a,this.prop=c,this.easing=e||"swing",this.options=b,this.start=this.now=this.cur(),this.end=d,this.unit=f||(lb.cssNumber[c]?"":"px")},cur:function(){var a=S.propHooks[this.prop];return a&&a.get?a.get(this):S.propHooks._default.get(this)},run:function(a){var b,c=S.propHooks[this.prop];return this.pos=b=this.options.duration?lb.easing[this.easing](a,this.options.duration*a,0,1,this.options.duration):a,this.now=(this.end-this.start)*b+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),c&&c.set?c.set(this):S.propHooks._default.set(this),this}},S.prototype.init.prototype=S.prototype,S.propHooks={_default:{get:function(a){var b;return null==a.elem[a.prop]||a.elem.style&&null!=a.elem.style[a.prop]?(b=lb.css(a.elem,a.prop,""),b&&"auto"!==b?b:0):a.elem[a.prop]},set:function(a){lb.fx.step[a.prop]?lb.fx.step[a.prop](a):a.elem.style&&(null!=a.elem.style[lb.cssProps[a.prop]]||lb.cssHooks[a.prop])?lb.style(a.elem,a.prop,a.now+a.unit):a.elem[a.prop]=a.now}}},S.propHooks.scrollTop=S.propHooks.scrollLeft={set:function(a){a.elem.nodeType&&a.elem.parentNode&&(a.elem[a.prop]=a.now)}},lb.each(["toggle","show","hide"],function(a,b){var c=lb.fn[b];lb.fn[b]=function(a,d,e){return null==a||"boolean"==typeof a?c.apply(this,arguments):this.animate(T(b,!0),a,d,e)}}),lb.fn.extend({fadeTo:function(a,b,c,d){return this.filter(y).css("opacity",0).show().end().animate({opacity:b},a,c,d)},animate:function(a,b,c,d){var e=lb.isEmptyObject(a),f=lb.speed(b,c,d),g=function(){var b=P(this,lb.extend({},a),f);(e||lb._data(this,"finish"))&&b.stop(!0)};return g.finish=g,e||f.queue===!1?this.each(g):this.queue(f.queue,g)},stop:function(a,b,d){var e=function(a){var b=a.stop;delete a.stop,b(d)};return"string"!=typeof a&&(d=b,b=a,a=c),b&&a!==!1&&this.queue(a||"fx",[]),this.each(function(){var b=!0,c=null!=a&&a+"queueHooks",f=lb.timers,g=lb._data(this);if(c)g[c]&&g[c].stop&&e(g[c]);else for(c in g)g[c]&&g[c].stop&&dd.test(c)&&e(g[c]);for(c=f.length;c--;)f[c].elem!==this||null!=a&&f[c].queue!==a||(f[c].anim.stop(d),b=!1,f.splice(c,1));(b||!d)&&lb.dequeue(this,a)})},finish:function(a){return a!==!1&&(a=a||"fx"),this.each(function(){var b,c=lb._data(this),d=c[a+"queue"],e=c[a+"queueHooks"],f=lb.timers,g=d?d.length:0;for(c.finish=!0,lb.queue(this,a,[]),e&&e.stop&&e.stop.call(this,!0),b=f.length;b--;)f[b].elem===this&&f[b].queue===a&&(f[b].anim.stop(!0),f.splice(b,1));for(b=0;g>b;b++)d[b]&&d[b].finish&&d[b].finish.call(this);delete c.finish})}}),lb.each({slideDown:T("show"),slideUp:T("hide"),slideToggle:T("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(a,b){lb.fn[a]=function(a,c,d){return this.animate(b,a,c,d)}}),lb.speed=function(a,b,c){var d=a&&"object"==typeof a?lb.extend({},a):{complete:c||!c&&b||lb.isFunction(a)&&a,duration:a,easing:c&&b||b&&!lb.isFunction(b)&&b};return d.duration=lb.fx.off?0:"number"==typeof d.duration?d.duration:d.duration in lb.fx.speeds?lb.fx.speeds[d.duration]:lb.fx.speeds._default,(null==d.queue||d.queue===!0)&&(d.queue="fx"),d.old=d.complete,d.complete=function(){lb.isFunction(d.old)&&d.old.call(this),d.queue&&lb.dequeue(this,d.queue)},d},lb.easing={linear:function(a){return a},swing:function(a){return.5-Math.cos(a*Math.PI)/2}},lb.timers=[],lb.fx=S.prototype.init,lb.fx.tick=function(){var a,b=lb.timers,d=0;for(_c=lb.now();d<b.length;d++)a=b[d],a()||b[d]!==a||b.splice(d--,1);b.length||lb.fx.stop(),_c=c},lb.fx.timer=function(a){a()&&lb.timers.push(a)&&lb.fx.start()},lb.fx.interval=13,lb.fx.start=function(){ad||(ad=setInterval(lb.fx.tick,lb.fx.interval))},lb.fx.stop=function(){clearInterval(ad),ad=null},lb.fx.speeds={slow:600,fast:200,_default:400},lb.fx.step={},lb.expr&&lb.expr.filters&&(lb.expr.filters.animated=function(a){return lb.grep(lb.timers,function(b){return a===b.elem}).length}),lb.fn.offset=function(a){if(arguments.length)return a===c?this:this.each(function(b){lb.offset.setOffset(this,a,b)});var b,d,e={top:0,left:0},f=this[0],g=f&&f.ownerDocument;if(g)return b=g.documentElement,lb.contains(b,f)?(typeof f.getBoundingClientRect!==X&&(e=f.getBoundingClientRect()),d=U(g),{top:e.top+(d.pageYOffset||b.scrollTop)-(b.clientTop||0),left:e.left+(d.pageXOffset||b.scrollLeft)-(b.clientLeft||0)}):e},lb.offset={setOffset:function(a,b,c){var d=lb.css(a,"position");"static"===d&&(a.style.position="relative");var e,f,g=lb(a),h=g.offset(),i=lb.css(a,"top"),j=lb.css(a,"left"),k=("absolute"===d||"fixed"===d)&&lb.inArray("auto",[i,j])>-1,l={},m={};k?(m=g.position(),e=m.top,f=m.left):(e=parseFloat(i)||0,f=parseFloat(j)||0),lb.isFunction(b)&&(b=b.call(a,c,h)),null!=b.top&&(l.top=b.top-h.top+e),null!=b.left&&(l.left=b.left-h.left+f),"using"in b?b.using.call(a,l):g.css(l)}},lb.fn.extend({position:function(){if(this[0]){var a,b,c={top:0,left:0},d=this[0];return"fixed"===lb.css(d,"position")?b=d.getBoundingClientRect():(a=this.offsetParent(),b=this.offset(),lb.nodeName(a[0],"html")||(c=a.offset()),c.top+=lb.css(a[0],"borderTopWidth",!0),c.left+=lb.css(a[0],"borderLeftWidth",!0)),{top:b.top-c.top-lb.css(d,"marginTop",!0),left:b.left-c.left-lb.css(d,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){for(var a=this.offsetParent||$;a&&!lb.nodeName(a,"html")&&"static"===lb.css(a,"position");)a=a.offsetParent;return a||$})}}),lb.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(a,b){var d=/Y/.test(b);lb.fn[a]=function(e){return lb.access(this,function(a,e,f){var g=U(a);return f===c?g?b in g?g[b]:g.document.documentElement[e]:a[e]:void(g?g.scrollTo(d?lb(g).scrollLeft():f,d?f:lb(g).scrollTop()):a[e]=f)},a,e,arguments.length,null)}}),lb.each({Height:"height",Width:"width"},function(a,b){lb.each({padding:"inner"+a,content:b,"":"outer"+a},function(d,e){lb.fn[e]=function(e,f){var g=arguments.length&&(d||"boolean"!=typeof e),h=d||(e===!0||f===!0?"margin":"border");return lb.access(this,function(b,d,e){var f;return lb.isWindow(b)?b.document.documentElement["client"+a]:9===b.nodeType?(f=b.documentElement,Math.max(b.body["scroll"+a],f["scroll"+a],b.body["offset"+a],f["offset"+a],f["client"+a])):e===c?lb.css(b,d,h):lb.style(b,d,e,h)},b,g?e:c,g,null)}})}),lb.fn.size=function(){return this.length},lb.fn.andSelf=lb.fn.addBack,"object"==typeof b&&b&&"object"==typeof b.exports?b.exports=lb:(a.jQuery=a.$=lb,"function"=="function"&&__webpack_require__(1079)&&!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){return lb}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)))}(window)},{}],32:[function(a,b){var c,d=a("./jquery.js"),e=(d.build,{});e.init=function(a){return c=a.clone().empty().removeAttr("id").css({visibility:"hidden",position:"absolute",top:-500,left:-1e3,width:d(window).width()}),d("body").append(c),e},e.measure=function(a){if(!c)throw new Error("Must call init before measure");var b=a.clone();c.append(b);var d=b.outerWidth(),e=b.outerHeight();return b.remove(),{w:d,h:e}},b.exports=e},{"./jquery.js":31}],33:[function(a,b){var c=a("./jquery.js"),d=c.build,e=a("./measure.js"),f=function(a,b){var f={};b=c.extend({closeBtn:!0},b);var g,h,i,j,k,l=function(){return g=d(".mktoModal",[h=d(".mktoModalMask"),i=d(".mktoModalContent",[k=d(".mktoModalClose",[" X "]).click(f.modalCloseClicked),j=d(".mktoModalMain")])])};f.modalCloseClicked=function(){f.hide()};var m=function(){var a=i.height(),b=i.width();if(!a||!b)return void setTimeout(m,25);var d=c(window).width(),e=c(window).height(),f=c(window).scrollTop(),g=c(document).height(),j=Math.max(0,d/2-b/2),k=Math.max(10,e/2-a/2);i.css({top:k+f+"px",left:j+"px"}),h.css("height",g)};return f.show=function(){var d=l(),g=e.measure(a);return j.css("width",g.w),j.append(a),b.closeBtn||k.remove(),h.hide(),i.hide(),m(),c("body").append(d),h.fadeIn(),i.fadeIn(),c(window).on("resize.mktoModal",m),f},f.hide=function(){return h.fadeOut(),i.fadeOut(function(){setTimeout(function(){a.detach(),g.remove(),c(window).off("resize.mktoModal")},10)}),f},f};b.exports=f},{"./jquery.js":31,"./measure.js":32}],34:[function(a,b){var c=function(a,b,c){function d(a){r.cssText=a}function e(a,b){return typeof a===b}function f(a,b){return!!~(""+a).indexOf(b)}function g(a,b){for(var d in a){var e=a[d];if(!f(e,"-")&&r[e]!==c)return"pfx"==b?e:!0}return!1}function h(a,b,d){for(var f in a){var g=b[a[f]];if(g!==c)return d===!1?a[f]:e(g,"function")?g.bind(d||b):g}return!1}function i(a,b,c){var d=a.charAt(0).toUpperCase()+a.slice(1),f=(a+" "+w.join(d+" ")+d).split(" ");return e(b,"string")||e(b,"undefined")?g(f,b):(f=(a+" "+x.join(d+" ")+d).split(" "),h(f,b,c))}function j(){n.input=function(c){for(var d=0,e=c.length;e>d;d++)A[c[d]]=!!(c[d]in s);return A.list&&(A.list=!(!b.createElement("datalist")||!a.HTMLDataListElement)),A}("autocomplete autofocus list placeholder max min multiple pattern required step".split(" ")),n.inputtypes=function(a){for(var d,e,f,g=0,h=a.length;h>g;g++){if(s.setAttribute("type",e=a[g]),d="text"!==s.type)if(s.value=t,s.style.cssText="position:absolute;visibility:hidden;",/^range$/.test(e)&&s.style.WebkitAppearance!==c){if(o.appendChild(s),f=b.defaultView,f.getComputedStyle){var i=f.getComputedStyle(s,null);d=i&&"textfield"!==i.WebkitAppearance&&0!==s.offsetHeight}o.removeChild(s)}else/^(search|tel)$/.test(e)||(d=/^(url|email)$/.test(e)?s.checkValidity&&s.checkValidity()===!1:s.value!=t);z[a[g]]=!!d}return z}("search tel url email datetime date month week time datetime-local number range color".split(" "))}var k,l,m="2.6.2",n={},o=b.documentElement,p="modernizr",q=b.createElement(p),r=q.style,s=b.createElement("input"),t=":)",u=({}.toString," -webkit- -moz- -o- -ms- ".split(" ")),v="Webkit Moz O ms",w=v.split(" "),x=v.toLowerCase().split(" "),y={},z={},A={},B=[],C=B.slice,D=function(a,c,d,e){var f,g,h,i,j=b.createElement("div"),k=b.body,l=k||b.createElement("body");if(parseInt(d,10))for(;d--;)h=b.createElement("div"),h.id=e?e[d]:p+(d+1),j.appendChild(h);return f=["&#173;",'<style id="s',p,'">',a,"</style>"].join(""),j.id=p,(k?j:l).innerHTML+=f,l.appendChild(j),k||(l.style.background="",l.style.overflow="hidden",i=o.style.overflow,o.style.overflow="hidden",o.appendChild(l)),g=c(j,a),k?j.parentNode.removeChild(j):(l.parentNode.removeChild(l),o.style.overflow=i),!!g},E=function(){function a(a,f){f=f||b.createElement(d[a]||"div"),a="on"+a;var g=a in f;return g||(f.setAttribute||(f=b.createElement("div")),f.setAttribute&&f.removeAttribute&&(f.setAttribute(a,""),g=e(f[a],"function"),e(f[a],"undefined")||(f[a]=c),f.removeAttribute(a))),f=null,g}var d={select:"input",change:"input",submit:"form",reset:"form",error:"img",load:"img",abort:"img"};return a}(),F={}.hasOwnProperty;l=e(F,"undefined")||e(F.call,"undefined")?function(a,b){return b in a&&e(a.constructor.prototype[b],"undefined")}:function(a,b){return F.call(a,b)},Function.prototype.bind||(Function.prototype.bind=function(a){var b=this;if("function"!=typeof b)throw new TypeError;var c=C.call(arguments,1),d=function(){if(this instanceof d){var e=function(){};e.prototype=b.prototype;var f=new e,g=b.apply(f,c.concat(C.call(arguments)));return Object(g)===g?g:f}return b.apply(a,c.concat(C.call(arguments)))};return d}),y.postmessage=function(){return!!a.postMessage},y.localstorage=function(){try{return localStorage.setItem(p,p),localStorage.removeItem(p),!0}catch(a){return!1}};for(var G in y)l(y,G)&&(k=G.toLowerCase(),n[k]=y[G](),B.push((n[k]?"":"no-")+k));return n.input||j(),n.addTest=function(a,b){if("object"==typeof a)for(var d in a)l(a,d)&&n.addTest(d,a[d]);else{if(a=a.toLowerCase(),n[a]!==c)return n;b="function"==typeof b?b():b,"undefined"!=typeof enableClasses&&enableClasses&&(o.className+=" "+(b?"":"no-")+a),n[a]=b}return n},d(""),q=s=null,n._version=m,n._prefixes=u,n._domPrefixes=x,n._cssomPrefixes=w,n.hasEvent=E,n.testProp=function(a){return g([a])},n.testAllProps=i,n.testStyles=D,n.prefixed=function(a,b,c){return b?i(a,b,c):i(a,"pfx")},n}(window,window.document),d=a("./yepnope.js");c.load=function(){d.apply(window,[].slice.call(arguments,0))},c.addTest("boxsizing",function(){return c.testAllProps("boxSizing")&&(void 0===document.documentMode||document.documentMode>7)}),c.addTest("borderradius",function(){return c.testAllProps("borderRadius")}),c.addTest("formvalidation",function(){var a=document.createElement("form");return"checkValidity"in a}),c.addTest("cors",function(){return!!(window.XMLHttpRequest&&"withCredentials"in new window.XMLHttpRequest)}),c.addTest("textareamaxlength",function(){var a=document.createElement("textarea");return"maxLength"in a}),c.addTest("csstransforms",function(){return!!c.testAllProps("transform")}),c.addTest("csschecked",function(){return c.testStyles("#modernizr input {width:100px} #modernizr input:checked {width:200px;display:block}",function(a){var b=document.createElement("input");return b.setAttribute("type","checkbox"),b.setAttribute("checked","checked"),a.appendChild(b),b.offsetWidth>=200})}),c.addTest("json",function(){return!(!(window.JSON&&JSON.stringify&&JSON.parse)||document.documentMode&&document.documentMode<9)}),b.exports=c},{"./yepnope.js":41}],35:[function(a,b){function c(a,b){var c=b;b=""+b;for(var d=p(q,b)?q:r,e=0;e<a.PicklistValues.length;e++){var f=a.PicklistValues[e].value||"";if(p(d,f))return f}return""+c}function d(a){for(var b=!1,c=!1,d=0;d<a.PicklistValues.length;d++){var e=a.PicklistValues[d].value||"";p(q,e)&&(b=!0),p(r,e)&&(c=!0)}return b&&c}function e(a){for(var b=0;b<a.PicklistValues.length;b++){var c=a.PicklistValues[b].value;if(""===c)return!0}return!1}function f(a){return!a.PicklistValues||a.IsMultiselect?!1:2==a.PicklistValues.length?d(a):3==a.PicklistValues.length?d(a)&&e(a):!1}function g(a){return a.PicklistValues?1==a.PicklistValues.length&&p(q,a.PicklistValues[0].value||""):!1}function h(a){return a.PicklistValues&&2==a.PicklistValues.length?d(a):!1}function i(a,b){if(null===b||void 0===b)return"";var d=f(a);return""===b&&d&&!e(a)&&(b=!1),""!==b&&d&&(b=c(a,b)),""+b}function j(a,b){if(null===b||void 0===b)return"";var d=h(a);return""===b&&d&&(b=!1),d&&(b=c(a,b)),""+b}function k(a,b){return null===b||void 0===b?"":(b=""+b,b.split(/\s|T/)[0])}function l(a,b){return null===b||void 0===b?"":(g(a)&&(b=c(a,b)),""+b)}function m(a,b){var c={},d=n.getFieldsByName(n.getFlattenedFields(b));return o.each(a,function(a,b){var e=d[a];if(e&&null!==b){var f=e.Datatype;"picklist"===f?c[a]=i(e,b):"radio"===f?c[a]=j(e,b):"checkbox"===f||"single_checkbox"===f?c[a]=l(e,b):"date"===f?c[a]=k(e,b):(b=""+b,c[a]=b)}}),c}{var n=a("./fields/fieldHelpers.js"),o=a("./jquery.js"),p=function(a,b){return-1!=o.inArray(b,a)},q=["true","1","yes","Yes"],r=["false","0","no","No"];q.concat(r)}b.exports.coerceTypes=m},{"./fields/fieldHelpers.js":15,"./jquery.js":31}],36:[function(a,b){function c(){try{if("undefined"!=typeof console&&"function"==typeof console.log)try{console.log.apply(console,arguments)}catch(a){console.log(Array.prototype.slice.call(arguments,0))}}catch(a){}}b.exports=c},{}],37:[function(a,b){function c(){}b.exports={};var d=a("./jquery.js");Function.prototype.bind||(Function.prototype.bind=function(a){var b=this;if("function"!=typeof b)throw new TypeError("Function.prototype.bind called on incompatible "+b);for(var d=h.call(arguments,1),e=function(){if(this instanceof j){var c=b.apply(this,d.concat(h.call(arguments)));return Object(c)===c?c:this}return b.apply(a,d.concat(h.call(arguments)))},f=Math.max(0,b.length-d.length),g=[],i=0;f>i;i++)g.push("$"+i);var j=Function("binder","return function("+g.join(",")+"){return binder.apply(this,arguments)}")(e);return b.prototype&&(c.prototype=b.prototype,j.prototype=new c,c.prototype=null),j});var e=Function.prototype.call,f=Array.prototype,g=Object.prototype,h=f.slice,i=e.bind(g.toString),j=e.bind(g.hasOwnProperty);if(!Object.keys){var k=!0,l=function(){}.propertyIsEnumerable("prototype"),m=["toString","toLocaleString","valueOf","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","constructor"],n=m.length;for(var o in{toString:null})k=!1;Object.keys=function q(a){var b="[object Function]"===i(a),c=null!==a&&"object"==typeof a;if(!c&&!b)throw new TypeError("Object.keys called on a non-object");var q=[],d=l&&b;for(var e in a)d&&"prototype"===e||!j(a,e)||q.push(e);if(k)for(var f=a.constructor,g=f&&f.prototype===a,h=0;n>h;h++){var o=m[h];g&&"constructor"===o||!j(a,o)||q.push(o)}return q}}if(String.prototype.trim||(String.prototype.trim=function(){return d.trim(this)}),Array.prototype.map||(Array.prototype.map=function(a){return d.map(this,a)}),"".substr&&"b"!=="0b".substr(-1)){var p=String.prototype.substr;String.prototype.substr=function(a,b){return p.call(this,0>a&&(a=this.length+a)<0?0:a,b)}}},{"./jquery.js":31}],38:[function(a,b){function c(a,b){var c=a.match(/\{\{.*?\}\}/g);if(!c)return a;var e={};d.each(c,function(a,c){var f=c.match(/\{\{\s?(\w*)\.(\w*)\s?:?\s?(.*?)\}\}/);if(f){var g=f[0],h=f[1],i=f[2],j=f[3]||"";if(!(h&&i&&b[h]&&b[h][i]))return;var k=b[h][i];if("function"==typeof k){attribParts=j.split("&");var l={};d.each(attribParts,function(a,b){var c=b.split("=");
	2==c.length&&(l[d.trim(decodeURIComponent(c[0]))]=d.trim(decodeURIComponent(c[1])))}),e[g]=k(l)}else e[g]=k.toString()}});var f=a;return d.each(e,function(a,b){f=f.split(a).join(b)}),f}var d=a("./jquery.js");b.exports=c},{"./jquery.js":31}],39:[function(a,b){function c(a,b){return a&&b?(a=g.parse(a),b=g.parse(b),a.protocol=b.protocol,a.host=b.host,g.format(a)):a}function d(a,b){return a&&b?(a=g.parse(a),b=g.parse(b),a.protocol=b.protocol,a.host=b.host,destPathParts=a.path.split("/"),sourcePathParts=b.path.split("/"),"lp"===sourcePathParts[1]&&sourcePathParts.length>=3&&"lp"!==destPathParts[1]&&(a.pathname=sourcePathParts.slice(0,3).join("/").concat(a.pathname)),g.format(a)):a}function e(a,b){var c=g.parse(a,!0);return h.extend(c.query,b),c.search="",a=g.format(c)}function f(a,b){if(!b)return a;h.isArray(b)||(b=[""+b]);var c=g.parse(a,!0);return h.each(b,function(a,b){delete c.query[b]}),c.search="",a=g.format(c)}var g=a("url"),h=a("./jquery.js");b.exports={swapHostsProtocols:c,addQueryParams:e,removeQueryParams:f,remapLandingPageUrl:d}},{"./jquery.js":31,url:6}],40:[function(a,b){var c=a("./jquery.js"),d=c.build,e=a("./measure.js"),f=a("./modernizr.js"),g=function(a){var b={};b.currentErrorElem=null,b.currentErrorMsg=null;var g=".mktoFieldDescriptor";return b.checkOne=function(a){var b=!0,d=!0,e=a.data("mktoFieldDescriptor"),f=e.val();return e.required&&(b=e.requiredValFn?e.requiredValFn(f):!!c.trim(f)),e.validator&&(d=e.validator(e.val())),b&&d&&e.validatorElem?(e.validatorElem.removeClass("mktoInvalid"),e.validatorElem.addClass("mktoValid")):e.validatorElem&&(e.validatorElem.removeClass("mktoValid"),e.validatorElem.addClass("mktoInvalid")),b?d?null:e.validationMessage||"Validation failed":e.requiredMessage||e.validationMessage||"This field is required"},b.checkOneAndHide=function(){var a=c(this),d=b.checkOne(a);!d&&b.currentErrorMsg&&b.currentErrorMsg.fadeOut()},b.checkOneAndShow=function(){var a=c(this);if(a.data("mktoErrorShowBlocked"))return b.checkOneAndHide.call(this);var d=a.data("mktoFieldDescriptor").validatorElem,e=b.checkOne(a);e?b.currentErrorElem!=a&&(b.currentErrorMsg&&b.currentErrorMsg.fadeOut(),b.showError(d,e)):b.currentErrorMsg&&b.currentErrorMsg.fadeOut()},b.initScoped=function(a){var d=function(a,d){d=c(d),d.data("mktoErrorShowBlocked",!0);var e=function(){d.data("mktoErrorShowBlocked",!1),b.checkOneAndHide.call(this)},f=function(a){return function(b){"div"!=b.target.tagName.toLowerCase()&&a.apply(this,arguments)}};d.on("focusin",f(b.checkOneAndShow)).on("focusout",f(e)).on("keyup",e).on("click",b.checkOneAndHide)};if(a.find(g).each(d),a.is(g)){var e=a.get(0);d.call(e,0,e)}},b.init=function(){b.clear(),b.initScoped(a)},b.showError=function(a,c){b.currentErrorMsg&&b.currentErrorMsg.remove();var g,h=d(".mktoError",[g=d(".mktoErrorArrowWrap",[d(".mktoErrorArrow")]),d(".mktoErrorMsg",d.html(c))]).hide();f.csstransforms||g.addClass("mktoArrowImage"),a.after(h),b.currentErrorElem=a,b.currentErrorMsg=h;var i,j=e.measure(h),k=a.outerWidth();i=k<j.w?-1*(j.w-k):(k-j.w)/2,h.css({right:i,bottom:-1*j.h}),h.fadeIn()},b.check=function(){b.clear();var d=null;if(a.find(g).each(function(){var a=c(this);a.data("mktoErrorShowBlocked",!1);var e=b.checkOne(a);e&&!d&&(d=a)}),d){var e=d.data("mktoFieldDescriptor"),f=e.validatorFocusElem||e.validatorElem;return f&&setTimeout(function(){f.focus()},10),!1}return!0},b.clear=function(){b.currentErrorElem=null,b.currentErrorMsg=null,a.find(".mktoInvalid").removeClass("mktoInvalid"),a.find(".mktoValid").removeClass("mktoValid"),a.find(".mktoError").remove()},b};b.exports=g},{"./jquery.js":31,"./measure.js":32,"./modernizr.js":34}],41:[function(a,b){!function(a,c,d){function e(a){return!a||"loaded"==a||"complete"==a||"uninitialized"==a}function f(a,b,d,f,g,i){var j,k,l=c.createElement("script");f=f||m.errorTimeout,l.src=a;for(k in d)l.setAttribute(k,d[k]);b=i?h:b||s,l.onreadystatechange=l.onload=function(){!j&&e(l.readyState)&&(j=1,b(),l.onload=l.onreadystatechange=null)},setTimeout(function(){j||(j=1,b(1))},f),F(),g?l.onload():o.parentNode.insertBefore(l,o)}function g(a,b,d,e,f,g){var i,j=c.createElement("link");e=e||m.errorTimeout,b=g?h:b||s,j.href=a,j.rel="stylesheet",j.type="text/css";for(i in d)j.setAttribute(i,d[i]);f||(F(),o.parentNode.insertBefore(j,o),setTimeout(b,0))}function h(){var a=q.shift();r=1,a?a.t?setTimeout(function(){("c"==a.t?m.injectCss:m.injectJs)(a.s,0,a.a,a.x,a.e,1)},0):(a(),h()):r=0}function i(a,b,d,f,g,i,j){function k(c){if(!n&&e(l.readyState)&&(s.r=n=1,!r&&h(),c)){"img"!=a&&setTimeout(function(){v.removeChild(l)},50);for(var d in H[b])H[b].hasOwnProperty(d)&&H[b][d].onload();l.onload=l.onreadystatechange=null}}j=j||m.errorTimeout;var l=c.createElement(a),n=0,p=0,s={t:d,s:b,e:g,a:i,x:j};1===H[b]&&(p=1,H[b]=[]),"object"==a?(l.data=b,l.setAttribute("type","text/css")):(l.src=b,l.type=a),l.width=l.height="0",l.onerror=l.onload=l.onreadystatechange=function(){k.call(this,p)},q.splice(f,0,s),"img"!=a&&(p||2===H[b]?(F(),v.insertBefore(l,u?null:o),setTimeout(k,j)):H[b].push(l))}function j(a,b,c,d,e){return r=0,b=b||"j",D(a)?i("c"==b?A:z,a,b,this.i++,c,d,e):(q.splice(this.i++,0,a),1==q.length&&h()),this}function k(){var a=m;return a.loader={load:j,i:0},a}var l,m,n=c.documentElement,o=(a.setTimeout,c.getElementsByTagName("script")[0]),p={}.toString,q=[],r=0,s=function(){},t="MozAppearance"in n.style,u=t&&!!c.createRange().compareNode,v=u?n:o.parentNode,w=a.opera&&"[object Opera]"==p.call(a.opera),x=!!c.attachEvent&&!w,y="webkitAppearance"in n.style&&!("async"in c.createElement("script")),z=t?"object":x||y?"script":"img",A=x?"script":y?"img":z,B=Array.isArray||function(a){return"[object Array]"==p.call(a)},C=function(a){return Object(a)===a},D=function(a){return"string"==typeof a},E=function(a){return"[object Function]"==p.call(a)},F=function(){o&&o.parentNode||(o=c.getElementsByTagName("script")[0])},G=[],H={},I={timeout:function(a,b){return b.length&&(a.timeout=b[0]),a}};m=function(a){function b(a){var b,c,d,e=a.split("!"),f=G.length,g=e.pop(),h=e.length,i={url:g,origUrl:g,prefixes:e};for(c=0;h>c;c++)d=e[c].split("="),b=I[d.shift()],b&&(i=b(i,d));for(c=0;f>c;c++)i=G[c](i);return i}function c(a){var b=a.split("?")[0];return b.substr(b.lastIndexOf(".")+1)}function e(a,e,f,g,h){{var i=b(a),j=i.autoCallback;c(i.url)}if(!i.bypass)return e&&(e=E(e)?e:e[a]||e[g]||e[a.split("/").pop().split("?")[0]]),i.instead?i.instead(a,e,f,g,h):(H[i.url]&&i.reexecute!==!0?i.noexec=!0:H[i.url]=1,a&&f.load(i.url,i.forceCSS||!i.forceJS&&"css"==c(i.url)?"c":d,i.noexec,i.attrs,i.timeout),(E(e)||E(j))&&f.load(function(){k(),e&&e(i.origUrl,h,g),j&&j(i.origUrl,h,g),H[i.url]=2}),void 0)}function f(a,b){function c(a,c){if(""===a||a){if(D(a))c||(j=function(){var a=[].slice.call(arguments);k.apply(this,a),l()}),e(a,j,b,0,g);else if(C(a)){d=function(){var b,c=0;for(b in a)a.hasOwnProperty(b)&&c++;return c}();for(f in a)a.hasOwnProperty(f)&&(c||--d||(E(j)?j=function(){var a=[].slice.call(arguments);k.apply(this,a),l()}:j[f]=function(a){return function(){var b=[].slice.call(arguments);a&&a.apply(this,b),l()}}(k[f])),e(a[f],j,b,f,g))}}else!c&&l()}var d,f,g=!!a.test,h=g?a.yep:a.nope,i=a.load||a.both,j=a.callback||s,k=j,l=a.complete||s;c(h,!!i||!!a.complete),i&&c(i),!i&&!!a.complete&&c("")}var g,h,i=m.loader;if(D(a))e(a,0,i,0);else if(B(a))for(g=0;g<a.length;g++)h=a[g],D(h)?e(h,0,i,0):B(h)?m(h):C(h)&&f(h,i);else C(a)&&f(a,i)},m.addPrefix=function(a,b){I[a]=b},m.addFilter=function(a){G.push(a)},m.errorTimeout=1e4,null==c.readyState&&c.addEventListener&&(c.readyState="loading",c.addEventListener("DOMContentLoaded",l=function(){c.removeEventListener("DOMContentLoaded",l,0),c.readyState="complete"},0)),b.exports=k(),b.exports.executeStack=h,b.exports.injectJs=f,b.exports.injectCss=g}(this,document)},{}]},{},[29]);
	module.exports = MktoForms2;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1079 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/56898458b2ff7b88077494e218702e2f.png";

/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1082);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _right_arrow = __webpack_require__(1084);
	
	var _right_arrow2 = _interopRequireDefault(_right_arrow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function Arrow(props) {
	    var arrowClasses = (0, _classnames2['default'])(_defineProperty({
	        'arrow-button': true
	    }, 'arrow-button-' + props.direction, true));
	    var lineClasses = (0, _classnames2['default'])(_defineProperty({
	        'arrow-line': true
	    }, 'arrow-line-' + props.direction, true));
	    return _react2['default'].createElement(
	        'div',
	        { className: 'm-pricing-arrow', 'data-test-id': 'arrow-button' },
	        _react2['default'].createElement('div', { className: lineClasses }),
	        _react2['default'].createElement('img', { src: _right_arrow2['default'], className: arrowClasses, onClick: props.handleClick })
	    );
	}
	
	module.exports = Arrow;

/***/ },
/* 1082 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1083 */,
/* 1084 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjIuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA1MS4yIDUyLjMiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxLjIgNTIuMzsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOiNERURFREU7fQoJLnN0MXtmaWxsOm5vbmU7c3Ryb2tlOiNBMEEwQTA7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7fQo8L3N0eWxlPgo8dGl0bGU+QXJyb3c8L3RpdGxlPgo8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KPGcgaWQ9IldlbGNvbWUiPgoJPGcgaWQ9IlByaWNpbmctMWEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC05NzkuMDAwMDAwLCAtODI4LjAwMDAwMCkiPgoJCTxnIGlkPSJBcnJvdyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOTc5LjAwMDAwMCwgODI4Ljc4OTA2MikiPgoJCQk8cGF0aCBpZD0iRmlsbC0xIiBjbGFzcz0ic3QwIiBkPSJNNTAuNiwyNS42YzAsMTMuOC0xMS4yLDI1LTI1LDI1cy0yNS0xMS4yLTI1LTI1czExLjItMjUsMjUtMjVTNTAuNiwxMS44LDUwLjYsMjUuNnoiLz4KCQkJPHBvbHlsaW5lIGlkPSJTdHJva2UtMyIgY2xhc3M9InN0MSIgcG9pbnRzPSIyMS44LDE1LjggMzEuNiwyNS42IDIxLjgsMzUuNSAJCQkiLz4KCQk8L2c+Cgk8L2c+CjwvZz4KPC9zdmc+Cg=="

/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var CouponDisplay = _react2['default'].createClass({
	    displayName: 'CouponDisplay',
	    render: function render() {
	        var couponDesc = '';
	        if (this.props.couponDescription) {
	            couponDesc = _react2['default'].createElement(
	                'div',
	                null,
	                this.props.couponDescription
	            );
	        }
	        return _react2['default'].createElement(
	            'div',
	            { 'data-test-id': 'coupon-display',
	                className: 'columns small-6 small-centered large-3 m-coupon-display'
	            },
	            _react2['default'].createElement(
	                'div',
	                null,
	                'Coupon Code:',
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'coupon-code' },
	                    this.props.couponCode
	                )
	            ),
	            couponDesc
	        );
	    }
	});
	
	module.exports = CouponDisplay;

/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ToggleChoice = _react2['default'].createClass({
	    displayName: 'ToggleChoice',
	    handleClick: function handleClick() {
	        this.props.handleSelection(this.props.value);
	    },
	    render: function render() {
	        var classes = (0, _classnames2['default'])({
	            'small-6': true,
	            'columns': true,
	            'm-toggle--choice': true,
	            'is-active': this.props.isActive,
	            'is-inactive': !this.props.isActive
	        });
	
	        return _react2['default'].createElement(
	            'div',
	            { className: classes, onClick: this.handleClick },
	            this.props.name
	        );
	    }
	});
	
	var Toggle = _react2['default'].createClass({
	    displayName: 'Toggle',
	
	
	    propTypes: {
	        initialSelection: _react2['default'].PropTypes.string
	    },
	
	    getInitialState: function getInitialState() {
	        var selected = this.props.choices[0].value;
	        if (this.props.initialSelection) {
	            for (var i = 0; i < this.props.choices.length; i++) {
	                if (this.props.initialSelection == this.props.choices[i].value) {
	                    selected = this.props.choices[i].value;
	                    break;
	                }
	            }
	        }
	        return { selected: selected };
	    },
	    handleSelection: function handleSelection(selected) {
	        this.setState({ 'selected': selected });
	        this.props.onSelection(selected);
	    },
	    renderChoice: function renderChoice(choice, i) {
	        var isEventbrite = this.props.isEventbrite;
	        var selected = this.state.selected;
	        var value = choice.value,
	            name = choice.name;
	
	        var isActive = selected === value;
	
	        name = isEventbrite && name === 'ANNUAL' ? 'ANNUAL - SAVE 20%!' : name;
	
	        var props = {
	            key: i,
	            value: value,
	            name: name,
	            isActive: isActive,
	            handleSelection: this.handleSelection
	        };
	
	        return _react2['default'].createElement(ToggleChoice, props);
	    },
	    render: function render() {
	        var isEventbrite = this.props.isEventbrite;
	
	        var classes = (0, _classnames2['default'])({
	            'small-12': true,
	            'small-centered': true,
	            'large-3': !isEventbrite,
	            'large-4': isEventbrite,
	            'large-centered': true,
	            'columns m-toggle': true
	        });
	        var choices = this.props.choices.map(this.renderChoice);
	        return _react2['default'].createElement(
	            'div',
	            { className: classes },
	            choices
	        );
	    }
	});
	
	exports.Toggle = Toggle;
	exports.ToggleChoice = ToggleChoice;

/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	__webpack_require__(1088);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _logger = __webpack_require__(482);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _logoOnlyHeader = __webpack_require__(1090);
	
	var _logoOnlyHeader2 = _interopRequireDefault(_logoOnlyHeader);
	
	var _captiveFooter = __webpack_require__(1092);
	
	var _captiveFooter2 = _interopRequireDefault(_captiveFooter);
	
	var _stripeSecurityCallout = __webpack_require__(1096);
	
	var _stripeSecurityCallout2 = _interopRequireDefault(_stripeSecurityCallout);
	
	var _titleArea = __webpack_require__(1100);
	
	var _titleArea2 = _interopRequireDefault(_titleArea);
	
	var _featureArea = __webpack_require__(1101);
	
	var _featureArea2 = _interopRequireDefault(_featureArea);
	
	var _paymentFormContainer = __webpack_require__(1117);
	
	var _paymentFormContainer2 = _interopRequireDefault(_paymentFormContainer);
	
	var _inlineStripeForm = __webpack_require__(1118);
	
	var _inlineStripeForm2 = _interopRequireDefault(_inlineStripeForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function PaymentArea(p) {
	
	    var enterCardBlurb = _react2['default'].createElement(
	        'p',
	        null,
	        'Enter your credit card information'
	    );
	
	    var formProps = {
	        targetPlan: p.planData.guid,
	        period: p.period
	    };
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'payment-area' },
	        enterCardBlurb,
	        _react2['default'].createElement(
	            _paymentFormContainer2['default'],
	            _extends({}, p, formProps),
	            _react2['default'].createElement(_inlineStripeForm2['default'], null)
	        )
	    );
	}
	
	function NoThanksLink(p) {
	
	    var link = '/info/chooseFreeOrEnterpriseSignupPlan';
	    var text = 'No thanks, downgrade me to a limited free plan';
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'no-thanks-link' },
	        _react2['default'].createElement(
	            'a',
	            { href: link },
	            text
	        )
	    );
	}
	
	function CtaArea(p) {
	    return _react2['default'].createElement(
	        'div',
	        { className: 'cta-area' },
	        _react2['default'].createElement(PaymentArea, p),
	        _react2['default'].createElement(NoThanksLink, null)
	    );
	}
	
	var PaymentPage = function (_Component) {
	    _inherits(PaymentPage, _Component);
	
	    function PaymentPage(p) {
	        _classCallCheck(this, PaymentPage);
	
	        var _this = _possibleConstructorReturn(this, (PaymentPage.__proto__ || Object.getPrototypeOf(PaymentPage)).call(this));
	
	        _this.onPeriodSwitch = function () {
	            var period = void 0;
	            if (_this.state.period === 'M') {
	                period = 'Y';
	            } else {
	                period = 'M';
	            }
	            _this.setState({ period: period });
	        };
	
	        _this.state = {
	            period: p.planData.period
	        };
	        return _this;
	    }
	
	    _createClass(PaymentPage, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            _logger2['default'].track('PaymentPage.load');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            var planName = this.props.planData.name;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'm-payment-page' },
	                _react2['default'].createElement(_logoOnlyHeader2['default'], null),
	                _react2['default'].createElement(_titleArea2['default'], _extends({ period: this.state.period, onPeriodSwitch: this.onPeriodSwitch }, this.props)),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'main-area' },
	                    _react2['default'].createElement(CtaArea, _extends({}, this.props, { period: this.state.period })),
	                    _react2['default'].createElement(_featureArea2['default'], { planName: planName })
	                ),
	                _react2['default'].createElement(_stripeSecurityCallout2['default'], null),
	                _react2['default'].createElement(_captiveFooter2['default'], null)
	            );
	        }
	    }]);
	
	    return PaymentPage;
	}(_react.Component);
	
	module.exports = PaymentPage;

/***/ },
/* 1088 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1089 */,
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports['default'] = LogoOnlyHeader;
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function LogoOnlyHeader() {
	    return _react2['default'].createElement(
	        'div',
	        { className: 'row l-header l-padded l-padding-b-30 l-padding-t-40' },
	        _react2['default'].createElement(
	            'div',
	            { className: 'small-12 columns logo' },
	            _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement('img', { src: __webpack_require__(1091) })
	            )
	        )
	    );
	}

/***/ },
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/df41c6bc1e5e178f05c46e94b34e11e7.png";

/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports['default'] = CaptiveFooter;
	
	__webpack_require__(1093);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HS_icon_Blue = __webpack_require__(1095);
	
	var _HS_icon_Blue2 = _interopRequireDefault(_HS_icon_Blue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function CaptiveFooter() {
	
	    // Inline to properly apply w/h to SVG
	    var logoStyle = {
	        width: 50,
	        height: 50,
	        float: 'left'
	    };
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'm-captive-footer columns' },
	        _react2['default'].createElement(
	            'div',
	            { className: 'row' },
	            _react2['default'].createElement('img', { style: logoStyle, src: _HS_icon_Blue2['default'] }),
	            _react2['default'].createElement(
	                'a',
	                { href: '/info/aboutUs', target: '_blank', rel: 'noopener noreferrer' },
	                'About HelloSign'
	            ),
	            _react2['default'].createElement(
	                'a',
	                { id: 'footer_contact', href: '#' },
	                'Contact Support'
	            ),
	            _react2['default'].createElement(
	                'span',
	                { className: 'copyright' },
	                'HelloSign \xA9 2016'
	            )
	        )
	    );
	}

/***/ },
/* 1093 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1094 */,
/* 1095 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMDAgMjAwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzAwYjNlNjt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkhTX2ljb25fPC90aXRsZT48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik05Ny44NywxMjMuNDhMNDkuNTcsNTIuNDNIMTUwLjQzWk03OS4yNyw2OC4xNUw5OC40MSw5Ni4zMmwyMC44My0yOC4xN2gtNDBaIi8+PHJlY3QgY2xhc3M9ImNscy0xIiB4PSI2NS4wNyIgeT0iMTMxLjg1IiB3aWR0aD0iNzAuNDEiIGhlaWdodD0iMTUuNzIiLz48L3N2Zz4="

/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports['default'] = StripeSecurityCallout;
	
	__webpack_require__(1097);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _secure_badge_2x = __webpack_require__(1099);
	
	var _secure_badge_2x2 = _interopRequireDefault(_secure_badge_2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function StripeSecurityCallout(p) {
	
	    var text = 'All payments made on HelloSign are 100% secure.';
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'stripe-security-callout' },
	        _react2['default'].createElement('img', { src: _secure_badge_2x2['default'] }),
	        _react2['default'].createElement(
	            'small',
	            null,
	            ' ',
	            text,
	            ' '
	        )
	    );
	}

/***/ },
/* 1097 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1098 */,
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/818a8c7e5e77b8d5d140968db631af82.png";

/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports['default'] = TitleArea;
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fecha = __webpack_require__(679);
	
	var _fecha2 = _interopRequireDefault(_fecha);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function TitleArea(p) {
	
	    var propTypes = {
	        planData: _react.PropTypes.object,
	        period: _react.PropTypes.string,
	        onPeriodSwitch: _react.PropTypes.func
	    };
	
	    var today = new Date();
	    var paymentStartDate = new Date(today.setMonth(today.getMonth() + 1));
	    var formattedStartDate = _fecha2['default'].format(paymentStartDate, 'MMM Do, YYYY');
	
	    var cost = void 0,
	        shortPeriod = void 0,
	        switchText = void 0;
	    if (p.period === 'M') {
	        cost = p.planData.monthly_price;
	        shortPeriod = 'mo';
	        switchText = 'Switch to annual plan and save 20%';
	    } else {
	        cost = p.planData.annual_price;
	        shortPeriod = 'yr';
	        switchText = 'Switch to monthly plan';
	    }
	
	    var mainText = 'Start your risk-free trial';
	    var subText = 'Your 30-day trial starts today. Cancel your account anytime. You\'ll be billed $' + cost + '/' + shortPeriod + ' starting ' + formattedStartDate;
	
	    var switchHandler = function switchHandler(e) {
	        e.preventDefault();
	
	        if (p.onPeriodSwitch) {
	            p.onPeriodSwitch();
	        }
	    };
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'main-title' },
	        _react2['default'].createElement(
	            'h1',
	            null,
	            mainText
	        ),
	        _react2['default'].createElement(
	            'h2',
	            null,
	            subText
	        ),
	        _react2['default'].createElement(
	            'a',
	            { onClick: switchHandler },
	            switchText
	        )
	    );
	}

/***/ },
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports['default'] = FeatureArea;
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _planFeaturesMap = __webpack_require__(1102);
	
	var _planFeaturesMap2 = _interopRequireDefault(_planFeaturesMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function FeatureArea(p) {
	
	    var planName = p.planName || 'Pro';
	    var features = _planFeaturesMap2['default'][planName]['features'];
	
	    var featureItems = features.map(function (feature, idx) {
	
	        var imgSrc = __webpack_require__(1103)("./" + feature.image);
	        var img = _react2['default'].createElement('img', { className: 'feature-image', src: imgSrc });
	        var text = _react2['default'].createElement(
	            'p',
	            { className: 'feature-text' },
	            feature.text
	        );
	
	        return _react2['default'].createElement(
	            'li',
	            { key: 'item-' + idx },
	            img,
	            text
	        );
	    });
	
	    var itemList = _react2['default'].createElement(
	        'ul',
	        null,
	        featureItems
	    );
	
	    var header = _react2['default'].createElement(
	        'div',
	        { className: 'feature-header' },
	        'Unlock access to these features'
	    );
	    var andmore = _react2['default'].createElement(
	        'div',
	        { className: 'and-more' },
	        'and more'
	    );
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'feature-area' },
	        header,
	        itemList,
	        andmore
	    );
	}

/***/ },
/* 1102 */
/***/ function(module, exports) {

	module.exports = {
		"Pro": {
			"features": [
				{
					"text": "Unlimited documents/month",
					"image": "unlimited-documents.svg"
				},
				{
					"text": "HelloSign integrations (Gmail, Box, etc.)",
					"image": "Google_integration_icon.svg"
				},
				{
					"text": "Time-stamped audit trail",
					"image": "clock_icon.svg"
				},
				{
					"text": "Data validation",
					"image": "Data_validation_icon.svg"
				},
				{
					"text": "1 template",
					"image": "reusable_templates.svg"
				},
				{
					"text": "Bank Level Security",
					"image": "lock_number2.svg"
				}
			]
		},
		"Business": {
			"features": [
				{
					"text": "Custom branding for your documents",
					"image": "megaphone.svg"
				},
				{
					"text": "In-person signing",
					"image": "inperson_icon.svg"
				},
				{
					"text": "Team features like transaction overviews",
					"image": "teams_icon.svg"
				},
				{
					"text": "Unlimited documents/month",
					"image": "unlimited-documents.svg"
				},
				{
					"text": "5 senders",
					"image": "send_icon_2.svg"
				},
				{
					"text": "5 templates",
					"image": "reusable_templates.svg"
				},
				{
					"text": "Bank Level Security",
					"image": "lock_number2.svg"
				}
			]
		},
		"Business 10": {
			"features": [
				{
					"text": "Custom branding for your documents",
					"image": "megaphone.svg"
				},
				{
					"text": "In-person signing",
					"image": "inperson_icon.svg"
				},
				{
					"text": "Team features like transaction overviews",
					"image": "teams_icon.svg"
				},
				{
					"text": "Unlimited documents/month",
					"image": "unlimited-documents.svg"
				},
				{
					"text": "10 senders",
					"image": "send_icon_2.svg"
				},
				{
					"text": "10 templates",
					"image": "reusable_templates.svg"
				},
				{
					"text": "Bank Level Security",
					"image": "lock_number2.svg"
				}
			]
		}
	};

/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./Data_validation_icon.svg": 1104,
		"./Google_integration_icon.svg": 1105,
		"./audit_trail_icon.svg": 1106,
		"./branding_icon.svg": 1107,
		"./clock_icon.svg": 1108,
		"./inperson_icon.svg": 1109,
		"./lock_number2.svg": 1110,
		"./megaphone.svg": 1111,
		"./name_icon.svg": 1112,
		"./reusable_templates.svg": 1113,
		"./secure_badge_@2x.png": 1099,
		"./send_icon_2.svg": 1114,
		"./teams_icon.svg": 1115,
		"./unlimited-documents.svg": 1116
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1103;


/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/19774a9f9d668eeb98c7610f5e91d7ca.svg";

/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/db72e9dccd53c6ba3b6a2d466bc191a9.svg";

/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/111a7a60d44dedc524b4aa3abe72e2db.svg";

/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/b9f90284664cc4683a694ce5c5e2591a.svg";

/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/7e65701d8dd1d1a95083fb142ab4b56f.svg";

/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/3f41a4d6e943cfe195359593a9ed3a62.svg";

/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/0c4b0095773ae4798aff42bcc49b3b25.svg";

/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/298c748e39de28782795f4002325a638.svg";

/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/c4d913eb18621044de64bd53dcbc2218.svg";

/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/edc11c4d9d70d0af5d1bcb315281905e.svg";

/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/aba1dffb62632939999d1ce8678196b7.svg";

/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/da3450c54d29a9d403c29c1b71dafc64.svg";

/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/b309c4b1e487c1081b5371371ee1dd02.svg";

/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _superagent = __webpack_require__(667);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _logger = __webpack_require__(482);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * PaymentFormContainer
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This component is designed to extract the logic of the Payment Form from the representation, making
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * other varieties of payment forms more possible / extensible. This is somewhat of a new approach, and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * is missing support for coupons or enterprise checkout at the moment.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * To use, wrap around a child component with your form itself and connect up the handlers via props.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See InlineStripeForm for an example, and see the props provided in render() below for what you need
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * to implement.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var MININUM_CREDIT_CARD_LENGTH = 15;
	
	var PaymentFormContainer = function (_Component) {
	    _inherits(PaymentFormContainer, _Component);
	
	    function PaymentFormContainer() {
	        _classCallCheck(this, PaymentFormContainer);
	
	        var _this = _possibleConstructorReturn(this, (PaymentFormContainer.__proto__ || Object.getPrototypeOf(PaymentFormContainer)).call(this));
	
	        _this.onCardholderNameChange = function (e) {
	            var card = _this.state.card;
	            card.name = e.target.value;
	            _this.setState({ card: card });
	        };
	
	        _this.onCardType = function (e) {
	            var card = _this.state.card;
	            var value = e.target.value;
	            card.type = Stripe.cardType(value);
	            card.number = value;
	            _this.setState({ card: card });
	        };
	
	        _this.onExpMonthChange = function (e) {
	            var card = _this.state.card;
	            card.expMonth = e.target.value;
	            _this.setState({ card: card });
	        };
	
	        _this.onExpYearChange = function (e) {
	            var card = _this.state.card;
	            card.expYear = e.target.value;
	            _this.setState({ card: card });
	        };
	
	        _this.onCvvChange = function (e) {
	            var card = _this.state.card;
	            card.cvv = e.target.value;
	            _this.setState({ card: card });
	        };
	
	        _this.onZipChange = function (e) {
	            var card = _this.state.card;
	            card.zip = e.target.value;
	            _this.setState({ card: card });
	        };
	
	        _this.cardIsValid = function () {
	
	            var valid = true;
	            var card = _this.state.card;
	
	            var cardErrors = {};
	            if (!_this.cardNumberIsValid()) {
	                cardErrors.number = 'Please enter a valid credit card number';
	            }
	
	            if (!card.name) {
	                cardErrors.name = 'Please enter a valid name';
	            }
	
	            if (!card.cvv) {
	                cardErrors.cvv = 'Please enter a valid security code';
	            }
	
	            if (!card.zip) {
	                cardErrors.zip = 'Please enter a valid post code';
	            }
	
	            valid = Object.keys(cardErrors).length === 0;
	
	            if (!valid) {
	                var errors = _this.state.errors || {};
	                errors.card = cardErrors;
	                _this.setState({ errors: errors });
	            }
	
	            return valid;
	        };
	
	        _this.cardNumberIsValid = function () {
	            var number = _this.numbersOnly(_this.state.card.number);
	
	            if (typeof number !== 'string' || number.length < MININUM_CREDIT_CARD_LENGTH) {
	                return false;
	            }
	
	            return true;
	        };
	
	        _this.numbersOnly = function (string) {
	            return string.replace(/[^0-9]/g, '');
	        };
	
	        _this.onStart = function (e) {
	            e.preventDefault();
	            _this.initializeErrors();
	
	            if (!_this.cardIsValid()) return;
	
	            var card = _this.state.card;
	            var cardNumber = _this.numbersOnly(card.number);
	            var dataForStripe = {
	                'number': cardNumber,
	                'cvc': card.cvv,
	                'exp_month': card.expMonth,
	                'exp_year': card.expYear,
	                'address_zip': card.zip,
	                'name': card.name
	            };
	
	            if (_this.state.isProcessing == false) {
	
	                _this.setState({
	                    isProcessing: true
	                });
	
	                var self = _this;
	                Stripe.card.createToken(dataForStripe, function (status, response) {
	                    if (response.error) {
	
	                        self.setGlobalError(response.error.message);
	                    } else {
	                        var token = response.id;
	                        self.setState({
	                            stripeToken: token
	                        });
	                        _logger2['default'].track('PaymentPage._onSuccess');
	                        self.submitForm();
	                    }
	                });
	            }
	        };
	
	        _this.submitForm = function () {
	
	            var paymentForm = _this.props.paymentForm;
	            var csrfToken = paymentForm.values._csrf_token;
	
	            var card = _this.state.card;
	            var cardNumber = _this.numbersOnly(card.number);
	            var stripeToken = _this.state.stripeToken;
	
	            var formData = {
	                'payment[_csrf_token]': csrfToken,
	                'payment[stripe_token]': stripeToken,
	                'payment[cc_name]': card.name,
	                'payment[cc_number]': cardNumber,
	                'payment[cc_exp_month]': card.expMonth,
	                'payment[cc_exp_year]': card.expYear,
	                'payment[cc_zip]': card.zip,
	                'payment[cc_security_code]': card.cvv,
	                'payment[target_plan]': _this.props.targetPlan,
	                'payment[period]': _this.props.period
	
	            };
	
	            var url = _this.props.formActionUrl || window.location.pathname;
	
	            _superagent2['default'].post(url).type('form').send(formData).end(function (err, res) {
	
	                if (err) {
	                    _this.setGlobalError();
	                    return;
	                }
	
	                var response = JSON.parse(res.text);
	                if (response.success != true) {
	                    _this.setGlobalError();
	                    return;
	                }
	
	                _this.onSuccess(response);
	            });
	        };
	
	        _this.onSuccess = function (response) {
	            if (_this.props.onSuccess) {
	                _this.props.onSuccess(response);
	                _this.setState({
	                    isProcessing: false
	                });
	            } else {
	                // No need to set state as we're redirecting
	                window.location = response.redirect_url;
	            }
	        };
	
	        _this.setGlobalError = function (message) {
	            var isProcessing = false;
	            var errors = _this.state.errors;
	            errors.global = message || 'There was an issue with your request.';
	            _this.setState({ errors: errors, isProcessing: isProcessing });
	        };
	
	        _this.initializeErrors = function () {
	            var errors = PaymentFormContainer.initialErrorState;
	            _this.setState({ errors: errors });
	        };
	
	        _this.state = {
	            card: {
	                name: '',
	                number: '',
	                type: '',
	                expMonth: '01',
	                expYear: new Date().getFullYear() + 1,
	                cvv: '',
	                zip: ''
	            },
	            stripeToken: '',
	            isProcessing: false,
	            errors: PaymentFormContainer.initialErrorState
	        };
	        return _this;
	    }
	
	    _createClass(PaymentFormContainer, [{
	        key: 'render',
	        value: function render() {
	
	            var props = {
	                // Data
	                card: this.state.card,
	                // States
	                errors: this.state.errors,
	                isProcessing: this.state.isProcessing,
	                // Functions
	                onCardholderNameChange: this.onCardholderNameChange,
	                onCardNumberChange: this.onCardType,
	                onExpMonthChange: this.onExpMonthChange,
	                onExpYearChange: this.onExpYearChange,
	                onCvvChange: this.onCvvChange,
	                onZipChange: this.onZipChange,
	                onStart: this.onStart
	            };
	
	            var childrenWithProps = _react2['default'].Children.map(this.props.children, function (child) {
	                return _react2['default'].cloneElement(child, props);
	            });
	
	            return _react2['default'].createElement(
	                'div',
	                null,
	                childrenWithProps
	            );
	        }
	    }]);
	
	    return PaymentFormContainer;
	}(_react.Component);
	
	PaymentFormContainer.propTypes = {
	    // Standard Symfony PaymentForm
	    paymentForm: _react.PropTypes.object.isRequired,
	    // (optional) Endpoint for post
	    formActionUrl: _react.PropTypes.string,
	    // Y or M
	    period: _react.PropTypes.string
	};
	PaymentFormContainer.initialErrorState = {
	    card: {},
	    global: ''
	};
	exports['default'] = PaymentFormContainer;

/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = InlineStripeForm;
	
	__webpack_require__(1119);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _loader_2x = __webpack_require__(1121);
	
	var _loader_2x2 = _interopRequireDefault(_loader_2x);
	
	var _name_icon = __webpack_require__(1112);
	
	var _name_icon2 = _interopRequireDefault(_name_icon);
	
	var _monthSelect = __webpack_require__(1122);
	
	var _monthSelect2 = _interopRequireDefault(_monthSelect);
	
	var _yearSelect = __webpack_require__(1123);
	
	var _yearSelect2 = _interopRequireDefault(_yearSelect);
	
	var _cardsDisplay = __webpack_require__(1124);
	
	var _cardsDisplay2 = _interopRequireDefault(_cardsDisplay);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function InlineStripeForm(p) {
	
	    var propTypes = {
	        'card': _react.PropTypes.object,
	        'onCardholderNameChange': _react.PropTypes.func,
	        'onCardNumberChange': _react.PropTypes.func,
	        'onExpMonthChange': _react.PropTypes.func,
	        'onExpYearChange': _react.PropTypes.func,
	        'onCvvChange': _react.PropTypes.func,
	        'onZipChange': _react.PropTypes.func,
	        'onStart': _react.PropTypes.func
	    };
	
	    var buttonProps = {
	        buttonText: 'Start 30-day free trial',
	        buttonColor: 'cerulean'
	    };
	
	    var buttonOrLoader = void 0;
	    if (p.isProcessing) {
	        buttonOrLoader = _react2['default'].createElement(
	            'div',
	            { className: 'loader' },
	            _react2['default'].createElement('img', { src: _loader_2x2['default'] })
	        );
	    } else {
	        buttonOrLoader = _react2['default'].createElement(_button2['default'], _extends({}, buttonProps, { onClick: p.onStart }));
	    }
	
	    var errors = p.errors || { card: {}, global: '' };
	    var cardErrorKeys = Object.keys(errors.card);
	    var cardErrorMap = {};
	    cardErrorKeys.map(function (key) {
	        cardErrorMap[key] = _react2['default'].createElement(
	            'div',
	            { className: 'error' },
	            errors.card[key]
	        );
	    });
	
	    var nameClasses = {
	        'cardholder-name': true,
	        'error': !!errors.card.name
	    };
	
	    var numberClasses = {
	        'card-number': true,
	        'error': !!errors.card.number
	    };
	
	    var cvvClasses = {
	        'cvv': true,
	        'error': !!errors.card.cvv
	    };
	
	    var zipClasses = {
	        'zip-code': true,
	        'error': !!errors.card.zip
	    };
	
	    return _react2['default'].createElement(
	        'form',
	        { className: 'm-inline-stripe-form' },
	        _react2['default'].createElement('input', { className: (0, _classnames2['default'])(nameClasses), placeholder: 'Cardholder Name', value: p.card.name, onChange: p.onCardholderNameChange }),
	        _react2['default'].createElement('img', { className: 'name-icon', src: _name_icon2['default'] }),
	        cardErrorMap.name,
	        _react2['default'].createElement(
	            'div',
	            { className: 'card-number-wrapper' },
	            _react2['default'].createElement('input', { className: (0, _classnames2['default'])(numberClasses), placeholder: '1234 4567 8912 3456', value: p.card.number, onChange: p.onCardNumberChange }),
	            _react2['default'].createElement(_cardsDisplay2['default'], { type: p.card.type }),
	            cardErrorMap.number
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'inline-fields' },
	            _react2['default'].createElement(_monthSelect2['default'], { value: p.card.expMonth, onChange: p.onExpMonthChange }),
	            _react2['default'].createElement(_yearSelect2['default'], { value: p.card.expYear, onChange: p.onExpYearChange }),
	            _react2['default'].createElement('input', { className: (0, _classnames2['default'])(cvvClasses), placeholder: 'CVV', value: p.card.cvv, onChange: p.onCvvChange }),
	            _react2['default'].createElement('input', { className: (0, _classnames2['default'])(zipClasses), placeholder: 'Zip Code', value: p.card.zip, onChange: p.onZipChange }),
	            cardErrorMap.cvv,
	            ' ',
	            cardErrorMap.zip
	        ),
	        buttonOrLoader,
	        _react2['default'].createElement(
	            'div',
	            { className: 'error' },
	            errors.global
	        )
	    );
	}

/***/ },
/* 1119 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1120 */,
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/a65003aeb58d133d1efa462d227ee392.gif";

/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports['default'] = MonthSelect;
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function MonthSelect(p) {
	    var months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
	    var monthOptions = months.map(function (month) {
	        return _react2['default'].createElement(
	            'option',
	            { key: month, value: month },
	            month
	        );
	    });
	
	    var value = p.value || '01';
	
	    return _react2['default'].createElement(
	        'select',
	        { className: 'm-payment--cc-exp-month', value: value, onChange: p.onChange },
	        monthOptions
	    );
	}

/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports['default'] = YearSelect;
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function YearSelect(p) {
	
	    var propTypes = {
	        'numYears': _react2['default'].PropTypes.Number
	    };
	
	    var curYear = new Date().getFullYear();
	    var numYears = p.numYears || 10;
	    var yearOptions = Array.apply(null, Array(numYears)).map(function (val, offset) {
	        var year = curYear + offset;
	        return _react2['default'].createElement(
	            'option',
	            { value: year, key: offset },
	            year
	        );
	    });
	
	    var value = p.value || curYear;
	
	    return _react2['default'].createElement(
	        'select',
	        { className: 'm-payment--cc-exp-year', value: value, onChange: p.onChange },
	        yearOptions
	    );
	}

/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports['default'] = CardsDisplay;
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function CardsDisplay(p) {
	
	    var propTypes = {
	        'type': _react.PropTypes.string
	    };
	
	    var CARD_TYPES = [{ 'long': 'MasterCard', 'short': 'mastercard' }, { 'long': 'Visa', 'short': 'visa' }, { 'long': 'American Express', 'short': 'amex' }, { 'long': 'Discover', 'short': 'discover' }];
	
	    var cardImages = CARD_TYPES.map(function (type, i) {
	        return _react2['default'].createElement('img', { key: i, src: _hfReactHelper2['default'].imgHelper('api/pricing/upgrade_popup/' + type.short + '_' + (p.type == type.long ? '' : 'in') + 'active.png') });
	    });
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'm-payment--ccs' },
	        cardImages
	    );
	}

/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _paymentModal = __webpack_require__(1062);
	
	var _paymentModal2 = _interopRequireDefault(_paymentModal);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _constants = __webpack_require__(1126);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _enterpriseAgreementPricingSummary = __webpack_require__(1127);
	
	var _enterpriseAgreementPricingSummary2 = _interopRequireDefault(_enterpriseAgreementPricingSummary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var EnterpriseAgreement = _react2['default'].createClass({
	    displayName: 'EnterpriseAgreement',
	
	
	    propTypes: {
	        'fullName': _react2['default'].PropTypes.string, // Full name of the person agreeing
	        'email': _react2['default'].PropTypes.string.isRequired, // Their email address
	        'companyName': _react2['default'].PropTypes.string, // Their company name
	        'billingName': _react2['default'].PropTypes.string, // Optional billing contact name, if different
	        'billingEmail': _react2['default'].PropTypes.string, // Optional billing contact email, if different
	        'numSeats': _react2['default'].PropTypes.number.isRequired, // Number of seats on the plan
	        'totalRate': _react2['default'].PropTypes.string.isRequired, // Total rate (formatted)
	        'periodName': _react2['default'].PropTypes.string.isRequired, // Billing period (month or year)
	        'features': _react2['default'].PropTypes.array.isRequired, // List of features { name, [code], [value], enabled }
	        'paymentForm': _react2['default'].PropTypes.object.isRequired, // Serialized payment form
	        'paymentInfo': _react2['default'].PropTypes.object.isRequired, // Payment information { card, subscription, ... }
	        'siteCode': _react2['default'].PropTypes.string.isRequired, // Site code
	        'isApi': _react2['default'].PropTypes.bool.isRequired, // Whether it's for an API plan
	        'termsAccepted': _react2['default'].PropTypes.bool, // If they've already accepted the terms
	        'numApiSigRequests': _react2['default'].PropTypes.number, // Number of API signature requests
	        'couponInfo': _react2['default'].PropTypes.object, // API coupon information { percentage, duration }
	        'isFreeTrial': _react2['default'].PropTypes.bool, // Whether to give the user a free trial
	        'billingType': _react2['default'].PropTypes.string,
	        'billingMethod': _react2['default'].PropTypes.string
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            'termsAccepted': false
	        };
	    },
	    continueClicked: function continueClicked(evt) {
	        if (this.isAlternateBilling()) {
	            this.submitForm();
	        } else {
	            this.launchPaymentModal(evt);
	        }
	    },
	    isAlternateBilling: function isAlternateBilling() {
	        var _this = this;
	
	        return _constants2['default'].ALTERNATIVE_BILLING_TYPES.filter(function (type) {
	            return type === _this.props.billingType;
	        }).length > 0;
	    },
	    launchPaymentModal: function launchPaymentModal(evt) {
	
	        var target = $(evt.target);
	        if (!target.hasClass('m-button') && target.parents('.m-button').length === 0) {
	            return;
	        }
	
	        evt.preventDefault();
	
	        var attachPoint = HfReactHelper.getRevealAttachPoint('payment_modal', this.props.paymentInfo.card ? 'small' : 'medium');
	        var d = this.props.paymentInfo;
	        var cc = d.card;
	        var s = d.subscription;
	        var n = this.props.numSeats;
	
	        var cardholder = '';
	        if (cc) {
	            cardholder = cc.holderName;
	        } else if (this.props.billingName && this.props.billingEmail !== this.props.email) {
	            cardholder = this.props.billingName;
	        }
	
	        // NOTE: isFreeTrial will force free-trial eligibility for enterprise customers, if it's been set
	        _reactDom2['default'].render(_react2['default'].createElement(_paymentModal2['default'], {
	            key: 'paymentModal_' + d.planId,
	            planId: d.planId,
	            isFreeTrialEligible: this.props.isFreeTrial,
	            forceFreeTrial: this.props.isFreeTrial,
	            price: d.price,
	            timePeriod: s.timePeriod,
	            monthlyExpectedRate: s.monthlyExpectedRate * n,
	            annualExpectedRate: s.annualExpectedRate * n,
	            monthlyProratedRate: s.monthlyProratedRate * n,
	            annualProratedRate: s.annualProratedRate * n,
	            currentMonthlyRate: s.currentMonthlyRate * n,
	            currentAnnualRate: s.currentAnnualRate * n,
	            proratio: s.proratio,
	            couponCode: s.couponCode,
	            ccSuffix: cc ? cc.suffix : '',
	            ccExpiration: cc ? cc.expiration : '',
	            cardHolderName: cardholder,
	            name: d.name,
	            isApi: d.isApi || false,
	            termsAccepted: this.props.termsAccepted,
	            paymentForm: this.props.paymentForm,
	            numSeats: this.props.numSeats,
	            headerText: 'Enterprise Plan' }), attachPoint);
	    },
	    submitForm: function submitForm() {
	        $('#agreementForm').submit();
	    },
	    render: function render() {
	
	        var name, company, onBehalfOf;
	        var continueButton, ctaSubText;
	        var paymentModal;
	        var features = [];
	        var hasSeparateBillingContact = this.props.billingEmail && this.props.billingEmail !== this.props.email;
	
	        // Header
	        if (this.props.fullName || this.props.billingName) {
	            name = _react2['default'].createElement(
	                'div',
	                { className: 'm-plan-agreement--header--name' },
	                hasSeparateBillingContact ? this.props.billingName : this.props.fullName
	            );
	        }
	        if (this.props.companyName) {
	            company = _react2['default'].createElement(
	                'div',
	                { className: 'm-plan-agreement--header--company' },
	                this.props.companyName
	            );
	        }
	        if (hasSeparateBillingContact) {
	            onBehalfOf = _react2['default'].createElement(
	                'div',
	                { className: 'm-plan-agreement--header--on-behalf-of' },
	                'On behalf of ',
	                this.props.fullName,
	                ' (',
	                this.props.email,
	                ')'
	            );
	        }
	
	        // Features
	        var i = -1;
	        var n = this.props.features.length;
	        var feature, featureClasses, featureValue, hasValue;
	        var hasHipaa = false;
	        for (var k in this.props.features) {
	            feature = this.props.features[k];
	            hasValue = false;
	            if (feature.enabled === undefined || feature.enabled === true) {
	                if (!hasHipaa && feature.code === HfReactHelper.HfConstants.enterpriseFeatures.HIPAA) {
	                    hasHipaa = true;
	                }
	                hasValue = feature.value !== undefined;
	                featureClasses = (0, _classnames2['default'])({
	                    'm-plan-agreement--features--table--item': true,
	                    'with-value': hasValue,
	                    'is-left': ++i % 2 === 0,
	                    'is-bottom': n % 2 === 0 && i >= n - 2 || n % 2 === 1 && i === n - 1,
	                    'is-top': i < 2
	                });
	                featureValue = hasValue ? _react2['default'].createElement(
	                    'div',
	                    { className: 'm-plan-agreement--features--table--item--value' },
	                    feature.value === null ? 'UNLIMITED' : feature.value
	                ) : undefined;
	                features.push(_react2['default'].createElement(
	                    'div',
	                    { key: 'feature-' + feature.name, className: featureClasses },
	                    featureValue,
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-plan-agreement--features--table--item--name' },
	                        feature.name
	                    )
	                ));
	            }
	        }
	
	        // Continue button
	        continueButton = _react2['default'].createElement(_button2['default'], {
	            key: 'agreementContinueButton',
	            buttonText: 'Continue',
	            buttonLink: '#',
	            buttonColor: 'cerulean',
	            buttonTextColor: 'white' });
	
	        // HIPAA warning
	        if (hasHipaa) {
	            var siteName = HfReactHelper.HfSites.getSiteName(this.props.siteCode);
	            ctaSubText = 'Upon payment, your account will be configured for HIPAA compliance. ' + 'It is your responsibility to continue to use ' + siteName + ' in a HIPAA compliant manner.';
	        }
	
	        // Dollars and cents
	        var totalRate = this.props.totalRate.split('.');
	        totalRate = _react2['default'].createElement(
	            'span',
	            null,
	            totalRate[0],
	            totalRate[1] ? _react2['default'].createElement(
	                'span',
	                { className: 'm-plan-agreement--summary--cents' },
	                totalRate[1]
	            ) : undefined
	        );
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'm-plan-agreement small-12' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-plan-agreement--header l-margin-b-40' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-plan-agreement--header--title' },
	                    'PLAN DETAILS'
	                ),
	                name,
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-plan-agreement--header--email' },
	                    hasSeparateBillingContact ? this.props.billingEmail : this.props.email
	                ),
	                onBehalfOf,
	                company,
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        this.props.isApi ? this.props.numApiSigRequests : this.props.numSeats,
	                        this.props.isApi ? ' signature requests per month' : ' senders'
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-plan-agreement--summary l-margin-b-40 small-12' },
	                _react2['default'].createElement(_enterpriseAgreementPricingSummary2['default'], {
	                    couponInfo: this.props.couponInfo,
	                    totalRate: this.props.totalRate,
	                    discountedRate: this.props.discountedTotalRate,
	                    periodName: this.props.periodName,
	                    isFreeTrial: this.props.isFreeTrial,
	                    billingType: this.props.billingType,
	                    billingMethod: this.props.billingMethod
	                })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-plan-agreement--features small-12 l-margin-b-40' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-plan-agreement--features--title' },
	                    'FEATURES'
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-plan-agreement--features--table' },
	                    features
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-plan-agreement--cta small-12' },
	                _react2['default'].createElement(
	                    'div',
	                    { onClick: this.continueClicked },
	                    continueButton
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-plan-agreement--cta--text' },
	                    ctaSubText
	                )
	            ),
	            _react2['default'].createElement('form', { id: 'agreementForm', method: 'POST', action: '' }),
	            paymentModal
	        );
	    }
	});
	
	module.exports = EnterpriseAgreement;

/***/ },
/* 1126 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	Billing/Pricing Constants
	**/
	
	module.exports = {
	    // These values mirror what's in SubscriptionInfo.class.php
	    BILLING_TYPE_STANDARD: 'S',
	    BILLING_TYPE_ALTERNATIVE_CHARGE_INDIVIDUAL: 'AI',
	    BILLING_TYPE_ALTERNATIVE_CHARGE_PARTNER: 'AP',
	    BILLING_TYPE_ALTERNATIVE_CHARGE_MASTER_SUB: 'AM',
	    ALTERNATIVE_BILLING_TYPES: ['AI', 'AP', 'AM'],
	
	    BILLING_METHOD_CREDIT_CARD: 'CC',
	    BILLING_METHOD_INVOICE: 'IN'
	};

/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports['default'] = EnterpriseAgreementPricingSummary;
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fecha = __webpack_require__(679);
	
	var _fecha2 = _interopRequireDefault(_fecha);
	
	var _pill = __webpack_require__(1128);
	
	var _pill2 = _interopRequireDefault(_pill);
	
	__webpack_require__(1131);
	
	var _constants = __webpack_require__(1126);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var periodShortNames = {
	    month: 'mo',
	    year: 'yr'
	};
	var cloneDate = function cloneDate(d) {
	    return new Date(d.getTime());
	};
	var isYearlyPlan = function isYearlyPlan(periodName) {
	    return periodName === 'year';
	};
	var isPerpetualCoupon = function isPerpetualCoupon(couponInfo) {
	    return couponInfo.duration === 9999;
	};
	
	function addMonths(amount, date) {
	    var d = cloneDate(date);
	    d.setMonth(d.getMonth() + amount);
	    return d;
	}
	
	function addDays(count, date) {
	    var d = cloneDate(date);
	    d.setDate(d.getDate() + count);
	    return d;
	}
	
	function subtractDays(count, date) {
	    var d = cloneDate(date);
	    d.setDate(d.getDate() - count);
	    return d;
	}
	
	/**
	 * Computes the date ranges for each scenario based on the defined scenarios.
	 *
	 * TODO: I'd like to try and find a cleaner way to write this section of code.
	 */
	function computeDateRanges(now, periodName, couponInfo, isFreeTrial) {
	    var freeTrialStart = void 0;
	    var freeTrialEnd = void 0;
	    var couponStart = void 0;
	    var couponEnd = void 0;
	    var listStart = void 0;
	
	    // Pointer to the date that represents a day before the next range's start
	    // date.  In each range, we compute the start date by adding one to this
	    // pointer
	    var nextEndDate = subtractDays(1, now);
	
	    // Month offset is used to compute the coupon end date if applicable.
	    var couponMonthOffset = 0;
	
	    if (isFreeTrial) {
	
	        freeTrialStart = addDays(1, nextEndDate);
	
	        // Free trials are 30 days, but we're including the last day so we only
	        // add 29
	        freeTrialEnd = addDays(29, freeTrialStart);
	
	        nextEndDate = freeTrialEnd;
	    }
	
	    if (couponInfo) {
	        couponStart = addDays(1, nextEndDate);
	
	        if (isYearlyPlan(periodName)) {
	            couponMonthOffset += 12;
	        } else {
	            couponMonthOffset = couponInfo.duration;
	        }
	
	        couponEnd = subtractDays(1, addMonths(couponMonthOffset, couponStart));
	        nextEndDate = couponEnd;
	    }
	
	    listStart = addDays(1, nextEndDate);
	
	    return {
	        freeTrialPrice: {
	            start: freeTrialStart,
	            end: freeTrialEnd
	        },
	        couponPrice: {
	            start: couponStart,
	            end: couponEnd
	        },
	        listPrice: {
	            start: listStart
	        }
	    };
	}
	
	var formatDate = function formatDate(d) {
	    return _fecha2['default'].format(d, 'MMM D, YYYY');
	};
	var dateRangeCopy = function dateRangeCopy(from, to) {
	    return formatDate(from) + ' - ' + formatDate(to);
	};
	
	/**
	 * Helper Component for displaying the rate
	 */
	function Rate(props) {
	    var rate = props.rate;
	
	    var _String$split = String(rate).split('.'),
	        _String$split2 = _slicedToArray(_String$split, 2),
	        dollars = _String$split2[0],
	        cents = _String$split2[1];
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'm-ent-plan-pricing-summary-rate c-castle-rock' },
	        _react2['default'].createElement(
	            'span',
	            { className: 'm-ent-plan-pricing-summary-rate__currency' },
	            '$'
	        ),
	        _react2['default'].createElement(
	            'span',
	            { className: 'm-ent-plan-pricing-summary-rate__amount' },
	            dollars,
	            cents && _react2['default'].createElement(
	                'span',
	                null,
	                '.',
	                cents
	            )
	        )
	    );
	}
	
	Rate.propTypes = {
	    rate: _react.PropTypes.string.isRequired,
	    per: _react.PropTypes.string
	};
	
	/**
	 * Helper component for displaying a pricing summary block.  Props here are
	 * provided as elements or strings because they may differ depending on the
	 * context.
	 *
	 */
	function EnterprisePricingSummaryBlock(props) {
	    var label = props.label,
	        copy = props.copy,
	        range = props.range,
	        testRef = props.testRef,
	        rate = props.rate,
	        per = props.per,
	        isPartnerPlan = props.isPartnerPlan;
	
	
	    var pill = void 0;
	    var rateBlock = void 0;
	    if (!isPartnerPlan) {
	
	        pill = _react2['default'].createElement(
	            'div',
	            { className: 'm-ent-plan-pricing-summary-block__pill' },
	            _react2['default'].createElement(
	                _pill2['default'],
	                { velvet: true },
	                label
	            )
	        );
	
	        rateBlock = _react2['default'].createElement(
	            'div',
	            { className: 'm-ent-plan-pricing-summary-block__rate', 'data-test-ref': 'rate' },
	            rate,
	            per && _react2['default'].createElement(
	                'span',
	                { className: 'm-ent-plan-pricing-summary-block__per' },
	                '/',
	                per
	            )
	        );
	    }
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'm-ent-plan-pricing-summary-block border-1-warm-chinchilla c-castle-rock bg-plume', 'data-test-ref': testRef },
	        pill,
	        rateBlock,
	        _react2['default'].createElement(
	            'div',
	            { className: 'm-ent-plan-pricing-summary-block__copy', 'data-test-ref': 'copy' },
	            copy
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'm-ent-plan-pricing-summary-block__range' + (isPartnerPlan ? ' partner' : ''), 'data-test-ref': 'range' },
	            range
	        ),
	        _react2['default'].createElement('div', { className: 'clear-both' })
	    );
	}
	
	EnterprisePricingSummaryBlock.propTypes = {
	    copy: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.string]),
	    label: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.string]),
	    range: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.string]),
	    rate: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.string]),
	    isPartnerPlan: _react.PropTypes.bool,
	    testRef: _react.PropTypes.string
	};
	
	/**
	 * Displays the pricing info to the user for enterprise agreements.  There are a
	 * lot of different rendering variations depending on the coupon, free trial,
	 * and billing plan period.  Please see the tests for the different scenarios.
	 */
	function EnterpriseAgreementPricingSummary(props) {
	    var couponInfo = props.couponInfo,
	        _props$now = props.now,
	        now = _props$now === undefined ? new Date() : _props$now,
	        discountedRate = props.discountedRate,
	        periodName = props.periodName,
	        totalRate = props.totalRate,
	        isFreeTrial = props.isFreeTrial,
	        billingType = props.billingType,
	        billingMethod = props.billingMethod;
	
	    var _computeDateRanges = computeDateRanges(now, periodName, couponInfo, isFreeTrial),
	        freeTrialPrice = _computeDateRanges.freeTrialPrice,
	        couponPrice = _computeDateRanges.couponPrice,
	        listPrice = _computeDateRanges.listPrice;
	
	    var shouldHideListPrice = couponInfo && isPerpetualCoupon(couponInfo);
	    var isPartnerPlan = billingType === _constants2['default'].BILLING_TYPE_ALTERNATIVE_CHARGE_PARTNER;
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'm-ent-plan-pricing-summary' },
	        isFreeTrial && _react2['default'].createElement(EnterprisePricingSummaryBlock, {
	            copy: 'For First 30 Days',
	            label: 'Free Trial',
	            range: dateRangeCopy(freeTrialPrice.start, freeTrialPrice.end),
	            rate: _react2['default'].createElement(Rate, { rate: '0' }),
	            isPartnerPlan: isPartnerPlan,
	            testRef: 'free-trial-price'
	        }),
	        couponInfo && _react2['default'].createElement(EnterprisePricingSummaryBlock, {
	            copy: _react2['default'].createElement(
	                'span',
	                { className: 'c-azure' },
	                (isYearlyPlan(periodName) ? couponInfo.annual_percentage : couponInfo.percentage) + '% off'
	            ),
	            label: 'Special Offer',
	            per: isYearlyPlan(periodName) && !isPerpetualCoupon(couponInfo) ? '' : periodShortNames[periodName],
	            range: isPerpetualCoupon(couponInfo) ? 'Starting ' + _fecha2['default'].format(couponPrice.start, 'MMM D, YYYY') : dateRangeCopy(couponPrice.start, couponPrice.end),
	            rate: _react2['default'].createElement(Rate, { rate: discountedRate }),
	            isPartnerPlan: isPartnerPlan,
	            testRef: 'coupon-price'
	        }),
	        !shouldHideListPrice && _react2['default'].createElement(EnterprisePricingSummaryBlock, {
	            label: 'List Price',
	            per: periodShortNames[periodName],
	            range: 'Starting ' + _fecha2['default'].format(listPrice.start, 'MMM D, YYYY'),
	            rate: _react2['default'].createElement(Rate, { rate: totalRate }),
	            isPartnerPlan: isPartnerPlan,
	            testRef: 'list-price'
	        })
	    );
	}
	
	EnterpriseAgreementPricingSummary.propTypes = {
	    couponInfo: _react.PropTypes.shape({
	        duration: _react.PropTypes.number
	    }),
	    isFreeTrial: _react.PropTypes.bool,
	
	    /**
	     * This is includced as a prop for ease
	     * of testing, but it will default to the current date for the general case.
	     */
	    now: _react.PropTypes.instanceOf(Date),
	    discountedRate: _react.PropTypes.string.isRequired,
	    periodName: _react.PropTypes.oneOf(['month', 'year']).isRequired,
	    totalRate: _react.PropTypes.string.isRequired,
	    billingType: _react.PropTypes.oneOf(['S', 'AI', 'AP', 'AM']),
	    billingMethod: _react.PropTypes.oneOf(['CC', 'IN'])
	};

/***/ },
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Pill = Pill;
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1129);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Pill component
	 *
	 * @example
	 * <Pill>Some Pill</Pill>
	 *
	 * @example
	 * <Pill velvet>Some Velvet Pill</Pill>
	 */
	function Pill(props) {
	    var children = props.children;
	
	    var className = (0, _classnames2['default'])('pill', { 'bg-velvet-evening c-white': props.velvet });
	
	    return _react2['default'].createElement(
	        'span',
	        { className: className },
	        children
	    );
	}
	
	Pill.propTypes = {
	    children: _react.PropTypes.string.isRequired,
	    velvet: _react.PropTypes.bool
	};
	
	exports['default'] = Pill;

/***/ },
/* 1129 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1130 */,
/* 1131 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1132 */,
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	var _tabSwitcher = __webpack_require__(1134);
	
	var _tabSwitcher2 = _interopRequireDefault(_tabSwitcher);
	
	var _tab = __webpack_require__(1137);
	
	var _tab2 = _interopRequireDefault(_tab);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TabbedArea = _react2['default'].createClass({
	    displayName: 'TabbedArea',
	
	
	    propTypes: {
	        tabData: _react2['default'].PropTypes.array.isRequired,
	        shouldUseTabSwitcher: _react2['default'].PropTypes.bool,
	        areaClassNames: _react2['default'].PropTypes.string,
	        rowClassNames: _react2['default'].PropTypes.string,
	        paneAreaClassNames: _react2['default'].PropTypes.string,
	        rememberActiveTab: _react2['default'].PropTypes.bool,
	        tabTypes: _react2['default'].PropTypes.string,
	        headerText: _react2['default'].PropTypes.string,
	        bottomImage: _react2['default'].PropTypes.string,
	        bottomImageWidth: _react2['default'].PropTypes.number,
	        bottomImageHeight: _react2['default'].PropTypes.number
	    },
	
	    getInitialState: function getInitialState() {
	        var key = 0;
	        if (this.props.rememberActiveTab) {
	            key = this.getSavedActiveTab();
	        }
	
	        return {
	            activeTab: key,
	            paneAreaClassNames: this.props.paneAreaClassNames,
	            tabRowClassNames: this.props.tabRowClassNames,
	            areaClassNames: this.props.areaClassNames
	        };
	    },
	    getDefaultProps: function getDefaultProps() {
	        return {
	            'areaClassNames': 'tabbed-area',
	            'tabRowClassNames': 'm-tabbed-area--row row',
	            'paneAreaClassNames': 'm-tabs--pane-area l-padding-v-60',
	            'rememberActiveTab': false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        $(document).bind('tabClick', this.handleClickEvent);
	        //FIXME: tabClick is a custom event, we should have a constant for it
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        $(document).unbind('tabClick', this.handleClickEvent);
	    },
	    handleClickEvent: function handleClickEvent(e) {
	        if (e.key != this.state.activeTab) {
	            this.onTabClick(e.key, true);
	        }
	    },
	    onTabClick: function onTabClick(key, noEvent) {
	        this.setState({ activeTab: key });
	        if (noEvent !== true) {
	            $(document).trigger({ 'type': 'tabClick', 'key': key });
	        }
	
	        if (this.props.rememberActiveTab) {
	            this.saveActiveTab(key);
	        }
	    },
	    onNextClick: function onNextClick() {
	        var key = this.state.activeTab == this.props.tabData.length - 1 ? 0 : this.state.activeTab + 1;
	        this.setState({ activeTab: key });
	        if (this.props.rememberActiveTab) {
	            this.saveActiveTab(key);
	        }
	    },
	    onPrevClick: function onPrevClick() {
	        var key = this.state.activeTab == 0 ? this.props.tabData.length - 1 : this.state.activeTab - 1;
	        this.setState({ activeTab: key });
	        if (this.props.rememberActiveTab) {
	            this.saveActiveTab(key);
	        }
	    },
	    saveActiveTab: function saveActiveTab(key) {
	        if (_hfReactHelper2['default'].hasLocalStorage()) {
	            localStorage.setItem('activeTab', key);
	        } else if (typeof Cookie != 'undefined') {
	            Cookie.set('activeTab', key, undefined, '/');
	        }
	    },
	    getSavedActiveTab: function getSavedActiveTab() {
	        var key;
	        if (_hfReactHelper2['default'].hasLocalStorage()) {
	            key = localStorage.getItem('activeTab');
	        } else if (typeof Cookie != 'undefined') {
	            key = Cookie.get('activeTab');
	        }
	        return key || 0;
	    },
	    render: function render() {
	
	        var tabs = this.props.tabData.map(function (tab, i) {
	            return _react2['default'].createElement(_tab2['default'], { clickableItemData: tab.clickableItemData,
	                index: i,
	                key: i,
	                tabClassNames: tab.tabClassNames,
	                onTabClick: this.onTabClick,
	                isActive: this.state.activeTab == i });
	        }.bind(this));
	
	        var panes = this.props.tabData.map(function (tab, i) {
	
	            var classNames = {
	                'is-active': this.state.activeTab == i
	            };
	            if (this.props.tabTypes == 'tabs') {
	                classNames = _hfReactHelper2['default'].extend({ 'm-tabs--pane': true, 'row': true }, classNames);
	            } else if (this.props.tabTypes == 'tiles') {
	                classNames = _hfReactHelper2['default'].extend({ 'm-tabs_tiles--pane': true }, classNames);
	                this.state.paneAreaClassNames = 'm-tabs_tiles--pane-area l-padding-t-40';
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                { key: 'pane' + i, className: (0, _classnames2['default'])(classNames) },
	                tab.contents,
	                tab.bottomImage ? _react2['default'].createElement('img', { className: 'm-tabs_tiles--bottom-image', width: tab.bottomImageWidth, height: tab.bottomImageHeight, src: tab.bottomImage }) : null
	            );
	        }.bind(this));
	
	        var tab_switcher = this.props.shouldUseTabSwitcher ? _react2['default'].createElement(_tabSwitcher2['default'], { onNextClick: this.onNextClick, onPrevClick: this.onPrevClick }) : '';
	
	        {
	            this.state.tabRowClassNames = this.props.tabTypes == 'tiles' ? 'columns small-12 small-centered text-center' : this.state.tabRowClassNames;
	        }
	        {
	            this.state.areaClassNames = this.props.tabTypes == 'tiles' ? 'tabbed-area text-center l-padding-t-80' : this.state.areaClassNames;
	        }
	
	        return _react2['default'].createElement(
	            'div',
	            { className: this.state.areaClassNames },
	            _react2['default'].createElement(
	                'h2',
	                { className: 'm-tabs_tiles--tile-header' },
	                this.props.headerText
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: this.state.tabRowClassNames },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-tabs--wrapper' },
	                    tabs
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: this.state.paneAreaClassNames, 'data-equalizer': true },
	                panes,
	                tab_switcher
	            )
	        );
	    }
	});
	
	module.exports = TabbedArea;

/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TabSwitcher = _react2['default'].createClass({
	    displayName: 'TabSwitcher',
	
	
	    propTypes: {
	        onNextClick: _react2['default'].PropTypes.func.isRequired,
	        onPrevClick: _react2['default'].PropTypes.func.isRequired
	    },
	
	    onNextClick: function onNextClick() {
	        this.props.onNextClick();
	    },
	    onPrevClick: function onPrevClick() {
	        this.props.onPrevClick();
	    },
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            { className: 'hide-for-large-up' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-tabs--switcher right', onClick: this.onNextClick },
	                _react2['default'].createElement('img', { className: 'm-tabs--right-arrow', src: __webpack_require__(1135) })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-tabs--switcher left', onClick: this.onPrevClick },
	                _react2['default'].createElement('img', { className: 'm-tabs--left-arrow', src: __webpack_require__(1136) })
	            )
	        );
	    }
	});
	
	module.exports = TabSwitcher;

/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/ce16c7e941cef0f27afda6d1dfd5165c.png";

/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/5877a49cfbb65c03ecbbd07e4cfcd2ef.png";

/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	var _clickableImage = __webpack_require__(1138);
	
	var _clickableImage2 = _interopRequireDefault(_clickableImage);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Tab = _react2['default'].createClass({
	    displayName: 'Tab',
	
	    propTypes: {
	        index: _react2['default'].PropTypes.number.isRequired,
	        onTabClick: _react2['default'].PropTypes.func.isRequired,
	        clickableItemData: _react2['default'].PropTypes.object,
	        isActive: _react2['default'].PropTypes.bool.isRequired,
	        tabClassNames: _react2['default'].PropTypes.object,
	        tabTypes: _react2['default'].PropTypes.string,
	        imgSourceWidth: _react2['default'].PropTypes.number,
	        imgSourceHeight: _react2['default'].PropTypes.number
	
	    },
	    getInitialState: function getInitialState() {
	        return { isActive: this.props.index == 0 };
	    },
	    onTabClick: function onTabClick() {
	        this.props.onTabClick(this.props.index);
	    },
	    render: function render() {
	        var classNames = {};
	
	        classNames = _hfReactHelper2['default'].extend({
	            'show-for-large-up': false,
	            'is-active': this.props.isActive
	        }, this.props.tabClassNames || {});
	
	        if (this.props.clickableItemData.tabTypes == 'tabs') {
	            classNames = _hfReactHelper2['default'].extend({ 'm-tabs--tab': true, 'large-3': true, 'columns': true }, classNames);
	        } else if (this.props.clickableItemData.tabTypes == 'tiles') {
	            classNames = _hfReactHelper2['default'].extend({ 'm-tabs_tiles--tiles': true }, classNames);
	        }
	
	        var classes = (0, _classnames2['default'])(classNames);
	        if (this.props.clickableItemData.tabTypes == 'tabs') {
	            return _react2['default'].createElement(
	                'div',
	                { className: classes, onClick: this.onTabClick },
	                ' ',
	                this.props.clickableItemData.title,
	                ' '
	            );
	        } else if (this.props.clickableItemData.tabTypes == 'tiles') {
	
	            var clickableImage = _react2['default'].createElement(_clickableImage2['default'], { imgSourceActiveWidth: this.props.clickableItemData.imgSourceActiveWidth, imgSourceActiveHeight: this.props.clickableItemData.imgSourceActiveHeight, imgSourceInactiveWidth: this.props.clickableItemData.imgSourceInactiveWidth, imgSourceInactiveHeight: this.props.clickableItemData.imgSourceInactiveHeight, imgSourceActive: this.props.clickableItemData.imgSourceActive, imgSourceInactive: this.props.clickableItemData.imgSourceInactive, isActive: this.props.isActive, imgText: this.props.clickableItemData.imgText });
	            return _react2['default'].createElement(
	                'div',
	                { className: classes, onClick: this.onTabClick },
	                ' ',
	                clickableImage,
	                ' '
	            );
	        }
	    }
	});
	
	module.exports = Tab;

/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ClickableImage = _react2['default'].createClass({
	    displayName: 'ClickableImage',
	
	
	    propTypes: {
	        imgSourceActive: _react2['default'].PropTypes.string.isRequired,
	        imgSourceInactive: _react2['default'].PropTypes.string.isRequired,
	        imgSourceActiveHeight: _react2['default'].PropTypes.number,
	        imgSourceActiveWidth: _react2['default'].PropTypes.number,
	        imgSourceInactiveHeight: _react2['default'].PropTypes.number,
	        imgSourceInactiveWidth: _react2['default'].PropTypes.number,
	        imgText: _react2['default'].PropTypes.string,
	        isActive: _react2['default'].PropTypes.bool
	
	    },
	    getInitialState: function getInitialState() {
	        return { isHover: false };
	    },
	    __onMouseEnter: function __onMouseEnter() {
	        this.setState({ isHover: true });
	    },
	    __onMouseLeave: function __onMouseLeave() {
	        this.setState({ isHover: false });
	    },
	    render: function render() {
	
	        if (this.props.isActive || this.state.isHover) {
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    'div',
	                    { onMouseEnter: this.__onMouseEnter, onMouseLeave: this.__onMouseLeave, className: 'm-tabs_tiles--tileWrapper' },
	                    _react2['default'].createElement('span', { className: 'm-tabs_tiles--center-helper' }),
	                    _react2['default'].createElement('img', { width: this.props.imgSourceActiveWidth, height: this.props.imgSourceActiveHeight, className: 'm-tabs_tiles--clickable-img', src: this.props.imgSourceActive })
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-tabs_tiles--tile-text-container ' },
	                    _react2['default'].createElement(
	                        'p',
	                        null,
	                        this.props.imgText
	                    )
	                )
	            );
	        } else {
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    'div',
	                    { onMouseEnter: this.__onMouseEnter, onMouseLeave: this.__onMouseLeave, className: 'm-tabs_tiles--tileWrapper show-for-large-up' },
	                    _react2['default'].createElement('span', { className: 'm-tabs_tiles--center-helper' }),
	                    _react2['default'].createElement('img', { width: this.props.imgSourceInactiveWidth, height: this.props.imgSourceInactiveHeight, className: 'm-tabs_tiles--clickable-img', src: this.props.imgSourceInactive })
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-tabs_tiles--tile-text-container show-for-large-up' },
	                    _react2['default'].createElement(
	                        'p',
	                        null,
	                        this.props.imgText
	                    )
	                )
	            );
	        }
	    }
	});
	
	module.exports = ClickableImage;

/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(1140);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _logoOnlyHeader = __webpack_require__(1090);
	
	var _logoOnlyHeader2 = _interopRequireDefault(_logoOnlyHeader);
	
	var _captiveFooter = __webpack_require__(1092);
	
	var _captiveFooter2 = _interopRequireDefault(_captiveFooter);
	
	var _planChoiceArea = __webpack_require__(1142);
	
	var _planChoiceArea2 = _interopRequireDefault(_planChoiceArea);
	
	var _paymentModal = __webpack_require__(1062);
	
	var _paymentModal2 = _interopRequireDefault(_paymentModal);
	
	var _contactUsLink = __webpack_require__(1151);
	
	var _contactUsLink2 = _interopRequireDefault(_contactUsLink);
	
	var _successTestDriveModal = __webpack_require__(1152);
	
	var _successTestDriveModal2 = _interopRequireDefault(_successTestDriveModal);
	
	var _couponDisplay = __webpack_require__(1085);
	
	var _couponDisplay2 = _interopRequireDefault(_couponDisplay);
	
	var _logger = __webpack_require__(482);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _planChoiceAreaV = __webpack_require__(1156);
	
	var _planChoiceAreaV2 = _interopRequireDefault(_planChoiceAreaV);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// V2
	
	
	var ChooseSignupPlan = function (_React$Component) {
	    _inherits(ChooseSignupPlan, _React$Component);
	
	    function ChooseSignupPlan(props) {
	        _classCallCheck(this, ChooseSignupPlan);
	
	        // Get initial state
	        var _this = _possibleConstructorReturn(this, (ChooseSignupPlan.__proto__ || Object.getPrototypeOf(ChooseSignupPlan)).call(this, props));
	
	        _this.onPlanChoice = function (options) {
	            // Experiment
	            var shouldShowPaymentPage = _this.props.paymentVersion === 2;
	            _this.trackPaymentVersion();
	
	            if (shouldShowPaymentPage) {
	                _this.redirectToPaymentPage(options);
	            } else {
	                _this.launchPaymentModal(options);
	            }
	        };
	
	        _this.redirectToPaymentPage = function (options) {
	            var url = '/info/startSignupPlanTrial?guid=' + options.planId + '&period=' + options.timePeriod;
	            window.location = url;
	        };
	
	        _this.trackPaymentVersion = function () {
	            var eventName = void 0;
	            // Add Pick a plan version stem
	            if (_this.props.version === 1) {
	                eventName = 'PickPlan.V1_';
	            } else {
	                eventName = 'PickPlan.V2_';
	            }
	            // Add payment version name
	            if (_this.props.paymentVersion === 1) {
	                eventName += 'PaymentModal';
	            } else {
	                eventName += 'PaymentPage';
	            }
	
	            _logger2['default'].track(eventName);
	        };
	
	        _this.onTeamSizeSelect = function (size) {
	            _this.setState({
	                teamSize: size
	            });
	        };
	
	        _this.onEnterpriseSuccess = function () {
	            _this.setState({
	                successModalVisible: true
	            });
	        };
	
	        _this.renderEnterpriseSuccessModal = function () {
	            var modal = void 0;
	
	            if (_this.state.successModalVisible) {
	                modal = _react2['default'].createElement(_successTestDriveModal2['default'], null);
	            }
	
	            return modal;
	        };
	
	        _this.errorMessage = function () {
	            var errors;
	            if (_this.props.errors) {
	                var errorMsg = 'Sorry, we could not process your payment.';
	                if (_this.props.errors['payment[submit]']) {
	                    errorMsg += ' ' + _this.props.errors['payment[submit]'];
	                }
	                if (_this.props.errors['payment[cc_number]']) {
	                    errorMsg += ' ' + _this.props.errors['payment[cc_number]'];
	                }
	                if (_this.props.errors['payment[0]']) {
	                    errorMsg += ' ' + _this.props.errors['payment[0]'];
	                }
	                errors = _react2['default'].createElement(
	                    'div',
	                    { 'data-test-id': 'errors', className: 'row text-center l-padding-v-20' },
	                    _react2['default'].createElement(
	                        'p',
	                        { className: 'c-red' },
	                        errorMsg
	                    )
	                );
	            }
	            return errors;
	        };
	
	        _this.renderCouponArea = function () {
	            var couponArea = void 0;
	
	            if (_this.props.coupon) {
	                couponArea = _react2['default'].createElement(_couponDisplay2['default'], { couponCode: _this.props.coupon.coupon_code, couponDescription: _this.props.coupon.description });
	            }
	            return couponArea;
	        };
	
	        _this.state = {
	            timePeriod: 'Y',
	            teamSize: '',
	            successModalVisible: false
	        };
	        return _this;
	    }
	
	    _createClass(ChooseSignupPlan, [{
	        key: 'launchPaymentModal',
	        value: function launchPaymentModal(_ref) {
	            var planId = _ref.planId,
	                timePeriod = _ref.timePeriod,
	                price = _ref.price;
	
	            var attachPoint = HfReactHelper.getRevealAttachPoint('payment_modal', 'medium');
	            var rates = this.calculateRates(price, timePeriod);
	            _reactDom2['default'].render(_react2['default'].createElement(_paymentModal2['default'], { key: planId,
	                planId: planId,
	                isFreeTrialEligible: true,
	                price: price,
	                headerText: 'Start Free Trial',
	                timePeriod: timePeriod,
	                monthlyExpectedRate: rates.monthlyExpectedRate,
	                annualExpectedRate: rates.annualExpectedRate,
	                monthlyProratedRate: rates.monthlyProratedRate,
	                annualProratedRate: rates.annualProratedRate,
	                currentMonthlyRate: rates.currentMonthlyRate,
	                currentAnnualRate: rates.currentAnnualRate,
	                isTrialing: false,
	                proratio: rates.proratio,
	                couponCode: this.props.coupon ? this.props.coupon.coupon_code : void 0,
	                ccSuffix: void 0,
	                ccExpiration: void 0,
	                cardHolderName: '',
	                name: void 0,
	                isApi: false,
	                isEventbrite: false,
	                termsAccepted: false,
	                paymentForm: this.props.paymentForm,
	                currentPlanName: void 0 }), attachPoint);
	        }
	    }, {
	        key: 'calculateRates',
	        value: function calculateRates(price, timePeriod) {
	
	            var annualExpectedRate = void 0,
	                monthlyExpectedRate = void 0;
	            if (timePeriod === 'Y') {
	                annualExpectedRate = price;
	                monthlyExpectedRate = Math.floor(price / 12);
	            } else {
	                monthlyExpectedRate = price;
	                annualExpectedRate = price * 12;
	            }
	
	            return {
	                monthlyExpectedRate: monthlyExpectedRate,
	                annualExpectedRate: annualExpectedRate,
	                // These are the same as above, since this is a new plan by definition (DB)
	                monthlyProratedRate: monthlyExpectedRate,
	                annualProratedRate: annualExpectedRate,
	                proratio: 0,
	                currentMonthlyRate: 0,
	                currentAnnualRate: 0
	            };
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            // V2 experiment
	            if (this.props.version == 2) {
	                if (this.props.paymentVersion == 2) {
	                    _logger2['default'].track('ChooseSignupPlan.v2.page');
	                } else {
	                    _logger2['default'].track('ChooseSignupPlan.v2.modal');
	                }
	
	                return this.renderV2();
	            } else {
	                if (this.props.paymentVersion == 2) {
	                    _logger2['default'].track('ChooseSignupPlan.v1.page');
	                } else {
	                    _logger2['default'].track('ChooseSignupPlan.v1.modal');
	                }
	            }
	
	            var Blurb = _react2['default'].createElement(
	                'div',
	                { className: 'm-choose-signup-plan--blurb row text-center l-padding-t-60 l-padding-b-70' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'columns' },
	                    _react2['default'].createElement(
	                        'h1',
	                        { className: 'hide-for-small' },
	                        'Pick a plan to get started'
	                    ),
	                    _react2['default'].createElement(
	                        'h2',
	                        { className: 'hide-for-medium-up' },
	                        'Pick a plan to get started'
	                    ),
	                    _react2['default'].createElement(
	                        'h4',
	                        { className: 'downsize' },
	                        'Choose one of our plans that meets your needs, or',
	                        _react2['default'].createElement(_contactUsLink2['default'], { timePeriod: this.state.timePeriod,
	                            linkText: ' contact us ',
	                            modalHeaderText: 'Contact Us for an Enterprise Plan',
	                            onSuccess: this.onEnterpriseSuccess,
	                            pricingSource: 'chooseSignupPlan' }),
	                        'for an Enterprise Plan'
	                    )
	                )
	            );
	
	            var ChoiceArea = _react2['default'].createElement(_planChoiceArea2['default'], _extends({
	                timePeriod: this.state.timePeriod,
	                onTimeToggle: function onTimeToggle(value) {
	                    _this2.setState({ timePeriod: value });
	                },
	                onPlanChoice: this.onPlanChoice,
	                onEnterpriseSuccess: this.onEnterpriseSuccess
	            }, this.props));
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'm-choose-signup-plan' },
	                _react2['default'].createElement(_logoOnlyHeader2['default'], null),
	                Blurb,
	                this.errorMessage(),
	                this.renderCouponArea(),
	                ChoiceArea,
	                this.renderEnterpriseSuccessModal(),
	                _react2['default'].createElement(_captiveFooter2['default'], null)
	            );
	        }
	    }, {
	        key: 'renderV2',
	        value: function renderV2() {
	            var _this3 = this;
	
	            var Blurb = _react2['default'].createElement(
	                'div',
	                { className: 'm-choose-signup-plan--blurb row text-center l-padding-t-40' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'columns' },
	                    _react2['default'].createElement(
	                        'h1',
	                        { className: 'hide-for-small l-padding-b-70' },
	                        'Pick a plan that\'s perfect for you'
	                    ),
	                    _react2['default'].createElement(
	                        'h2',
	                        { className: 'v2-subtitle' },
	                        'What\'s your team size?'
	                    )
	                )
	            );
	
	            var ChoiceArea = _react2['default'].createElement(_planChoiceAreaV2['default'], _extends({
	                timePeriod: this.state.timePeriod,
	                onTimeToggle: function onTimeToggle(value) {
	                    _this3.setState({ timePeriod: value });
	                },
	                teamSize: this.state.teamSize,
	                onTeamSizeSelect: this.onTeamSizeSelect,
	                onPlanChoice: this.onPlanChoice,
	                onEnterpriseSuccess: this.onEnterpriseSuccess
	            }, this.props));
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'm-choose-signup-plan' },
	                _react2['default'].createElement(_logoOnlyHeader2['default'], null),
	                Blurb,
	                this.errorMessage(),
	                this.renderCouponArea(),
	                ChoiceArea,
	                this.renderEnterpriseSuccessModal(),
	                _react2['default'].createElement(_captiveFooter2['default'], null)
	            );
	        }
	    }]);
	
	    return ChooseSignupPlan;
	}(_react2['default'].Component);
	
	module.exports = ChooseSignupPlan;

/***/ },
/* 1140 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1141 */,
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _planLevel = __webpack_require__(1143);
	
	var _planLevel2 = _interopRequireDefault(_planLevel);
	
	var _planLevelEnterprise = __webpack_require__(1147);
	
	var _planLevelEnterprise2 = _interopRequireDefault(_planLevelEnterprise);
	
	var _planLevelFree = __webpack_require__(1148);
	
	var _planLevelFree2 = _interopRequireDefault(_planLevelFree);
	
	var _toggle = __webpack_require__(1086);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PlanChoiceArea = function (_React$Component) {
	    _inherits(PlanChoiceArea, _React$Component);
	
	    function PlanChoiceArea() {
	        _classCallCheck(this, PlanChoiceArea);
	
	        return _possibleConstructorReturn(this, (PlanChoiceArea.__proto__ || Object.getPrototypeOf(PlanChoiceArea)).apply(this, arguments));
	    }
	
	    _createClass(PlanChoiceArea, [{
	        key: 'render',
	
	
	        // NOTE:
	        // This is currently hardcoded to 3 columns. We may want to consider something
	        // dynamic in the future, but this should work for our current needs.
	        value: function render() {
	
	            var timeChoices = [{ 'name': 'ANNUAL', 'value': 'Y' }, { 'name': 'MONTHLY', 'value': 'M' }];
	            var MonthlyAnnualSwitch = _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(_toggle.Toggle, {
	                    choices: timeChoices,
	                    initialSelection: 'Y',
	                    isEventbrite: false,
	                    onSelection: this.props.onTimeToggle
	                })
	            );
	
	            var period = this.props.timePeriod;
	            var choiceFunc = this.props.onPlanChoice;
	            var enterpriseSuccessFunc = this.props.onEnterpriseSuccess;
	            var levels = this.props.planData.map(function (plan, i) {
	                if (plan.is_enterprise === true) {
	                    return _react2['default'].createElement(_planLevelEnterprise2['default'], {
	                        key: 'plan-' + i,
	                        plan: plan,
	                        timePeriod: period,
	                        onSuccess: enterpriseSuccessFunc,
	                        pricingSource: 'chooseSignupPlan' });
	                } else {
	                    return _react2['default'].createElement(_planLevel2['default'], {
	                        key: 'plan-' + i,
	                        plan: plan,
	                        onPlanChoice: choiceFunc,
	                        timePeriod: period });
	                }
	            });
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'm-choose-signup-plan--plan-choice-area row text-center' },
	                MonthlyAnnualSwitch,
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'columns large-12' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-choose-signup-plan--paid-pricing-levels row' },
	                        levels
	                    )
	                ),
	                _react2['default'].createElement(_planLevelFree2['default'], null)
	            );
	        }
	    }]);
	
	    return PlanChoiceArea;
	}(_react2['default'].Component);
	
	PlanChoiceArea.propTypes = {
	    planData: _react2['default'].PropTypes.array.isRequired,
	    timePeriod: _react2['default'].PropTypes.string,
	    onPlanChoice: _react2['default'].PropTypes.func,
	    onEnterpriseSuccess: _react2['default'].PropTypes.func,
	    onTimeToggle: _react2['default'].PropTypes.func
	};
	exports['default'] = PlanChoiceArea;

/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(1144);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pricingLevelFeature = __webpack_require__(1064);
	
	var _pricingLevelFeature2 = _interopRequireDefault(_pricingLevelFeature);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// NOTE: If extending this to cover the general pricing case,
	// we'll want to reintroduce seatBadge / oldPrice / other currently unused vals
	// CF pricing-level.jsx for details
	
	var PlanLevel = function (_React$Component) {
	    _inherits(PlanLevel, _React$Component);
	
	    function PlanLevel(props) {
	        _classCallCheck(this, PlanLevel);
	
	        var _this = _possibleConstructorReturn(this, (PlanLevel.__proto__ || Object.getPrototypeOf(PlanLevel)).call(this, props));
	
	        _this.state = {
	            expanded: _this.props.expanded || false
	        };
	        return _this;
	    }
	
	    /*
	     * Click handling
	     */
	
	    _createClass(PlanLevel, [{
	        key: 'onLevelClick',
	        value: function onLevelClick() {
	            this.setState({
	                expanded: !this.state.expanded
	            });
	        }
	    }, {
	        key: 'onPlanChoiceButtonClick',
	        value: function onPlanChoiceButtonClick() {
	            this.props.onPlanChoice({
	                planId: this.props.plan.plan_id,
	                timePeriod: this.props.timePeriod,
	                price: this.getPrice()
	            });
	        }
	
	        /*
	         * Utility
	         */
	
	    }, {
	        key: 'getPrice',
	        value: function getPrice() {
	            if (this.props.coupon) {
	                if (this.props.timePeriod === 'Y') {
	                    return this.props.plan.coupon_annual_price;
	                } else {
	                    return this.props.plan.coupon_monthly_price;
	                }
	            } else {
	                if (this.props.timePeriod === 'Y') {
	                    return this.props.plan.annual_price;
	                } else {
	                    return this.props.plan.monthly_price;
	                }
	            }
	        }
	    }, {
	        key: 'getDisplayPrice',
	        value: function getDisplayPrice(price) {
	            if (this.props.timePeriod === 'Y') {
	                price = price / 12;
	            }
	            return Math.ceil(price);
	        }
	
	        /*
	         * Subrenders
	         */
	
	    }, {
	        key: 'renderFeatures',
	        value: function renderFeatures() {
	            var features = this.props.plan.features.map(function (feature, i) {
	                var name = feature.name ? feature.name : name;
	                var detail = feature.detail ? feature.detail : null;
	                var number = feature.number ? feature.number : null;
	                return _react2['default'].createElement(_pricingLevelFeature2['default'], {
	                    name: name,
	                    planName: this.props.name,
	                    detail: detail,
	                    number: number,
	                    key: 'feature' + i,
	                    isFree: false,
	                    expanded: this.state.expanded });
	            }.bind(this));
	            return features;
	        }
	    }, {
	        key: 'renderMainFeature',
	        value: function renderMainFeature() {
	            var mainFeature;
	            if (this.props.plan.main_feature) {
	                var mainFeature = this.props.plan.main_feature;
	                var name = mainFeature.name ? mainFeature.name : name;
	                var detail = mainFeature.detail ? mainFeature.detail : null;
	                var number = mainFeature.number ? mainFeature.number : null;
	                mainFeature = _react2['default'].createElement(_pricingLevelFeature2['default'], {
	                    name: name,
	                    planName: this.props.plan.name,
	                    detail: detail,
	                    number: number,
	                    isFree: false,
	                    key: 'main-feature',
	                    expanded: this.state.expanded });
	            }
	            return mainFeature;
	        }
	
	        /*
	         * Main render
	         */
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var mostPopular = this.props.plan.most_popular ? _react2['default'].createElement('img', { className: 'most-popular show-for-large-up', src: __webpack_require__(1146) }) : '';
	
	            var preCouponPrice = void 0;
	            if (this.props.plan.coupon) {
	
	                var oldPrice = this.props.timePeriod === 'Y' ? this.props.plan.annual_price : this.props.plan.monthly_price;
	
	                preCouponPrice = _react2['default'].createElement(
	                    'div',
	                    { className: 'm-pricing-level--body small-4 large-12 small-centered columns level-price' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'dollar crossed' },
	                        '$'
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'price crossed' },
	                        this.getDisplayPrice(oldPrice)
	                    )
	                );
	            }
	
	            var price = this.getDisplayPrice(this.getPrice());
	            var name = this.props.plan.name;
	
	            var period = this.props.timePeriod === 'M' ? 'per month' : 'per month when paid annually';
	            var billingPeriod = _react2['default'].createElement(
	                'div',
	                { className: 'billing-period' },
	                period
	            );
	
	            var ctaButton = _react2['default'].createElement(_button2['default'], { buttonText: 'Start 30-day Free Trial',
	                onClick: this.onPlanChoiceButtonClick.bind(this),
	                buttonColor: 'ashen',
	                buttonHoverColor: 'cerulean' });
	
	            var additionalFeatures = _react2['default'].createElement(
	                'div',
	                { className: 'additional-features small-12 columns block' },
	                this.props.plan.additional_features
	            );
	
	            var levelClasses = (0, _classnames2['default'])({
	                'small-5': true,
	                'medium-4': true,
	                'medium-offset-1': true,
	                'large-12': true,
	                'large-offset-0': true,
	                'columns': true,
	                'level-title': true
	            });
	            var priceClasses = (0, _classnames2['default'])({
	                'hide-for-large-up': true,
	                'small-7': true,
	                'medium-5': true,
	                'medium-offset-1': true,
	                'columns': true,
	                'level-price': true
	            });
	            var arrowContainerClasses = (0, _classnames2['default'])({
	                'arrow-container': true,
	                'hide-for-large-up': true,
	                'hide-for-small': true,
	                'small-2': true,
	                'medium-1': true,
	                'columns': true
	            });
	            var arrowClasses = (0, _classnames2['default'])({
	                'l-vertical-align': true,
	                'arrow': true,
	                'expanded': this.state.expanded
	            });
	            var bodyClasses = (0, _classnames2['default'])({
	                'm-pricing-level--body': true,
	                'small-12': true,
	                'columns': true,
	                'expanded': this.state.expanded
	            });
	            var topLevelClasses = 'm-pricing-level signup-plan small-12 medium-12 large-4 columns';
	
	            return _react2['default'].createElement(
	                'div',
	                { className: topLevelClasses },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-pricing-level--header small-12 medium-12 block', onClick: this.onLevelClick.bind(this) },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: levelClasses },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'level-title l-vertical-align-wrapper' },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'l-vertical-align' },
	                                name ? name.toUpperCase() : ''
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'subheader' },
	                            this.props.plan.subheader
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: priceClasses },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'level-title l-vertical-align-wrapper' },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'l-vertical-align' },
	                                _react2['default'].createElement(
	                                    'span',
	                                    { className: 'dollar' },
	                                    '$'
	                                ),
	                                _react2['default'].createElement(
	                                    'span',
	                                    { className: 'price' },
	                                    price,
	                                    _react2['default'].createElement(
	                                        'span',
	                                        { className: 'billing-period' },
	                                        period
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: arrowContainerClasses },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'level-title l-vertical-align-wrapper' },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: arrowClasses },
	                                '\xA0'
	                            )
	                        )
	                    ),
	                    mostPopular
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: bodyClasses },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'first-section block' },
	                        preCouponPrice,
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'm-pricing-level--body small-3 large-12 small-centered columns block' },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'dollar' },
	                                '$'
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'price' },
	                                price
	                            ),
	                            billingPeriod
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'block' },
	                            ctaButton
	                        ),
	                        this.renderMainFeature()
	                    )
	                ),
	                this.renderFeatures(),
	                additionalFeatures
	            );
	        }
	    }]);
	
	    return PlanLevel;
	}(_react2['default'].Component);
	
	PlanLevel.propTypes = {
	    plan: _react.PropTypes.object.isRequired,
	    timePeriod: _react.PropTypes.string,
	    onPlanChoice: _react.PropTypes.func
	};
	PlanLevel.defaultProps = {
	    periodType: 'Y'
	};
	exports['default'] = PlanLevel;

/***/ },
/* 1144 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1145 */,
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/8a4fff32de6a51c4324cfc6f86abe428.png";

/***/ },
/* 1147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1140);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	var _pricingLevelFeature = __webpack_require__(1064);
	
	var _pricingLevelFeature2 = _interopRequireDefault(_pricingLevelFeature);
	
	var _contactUsButton = __webpack_require__(1069);
	
	var _contactUsButton2 = _interopRequireDefault(_contactUsButton);
	
	var _pricingIconPhone2x = __webpack_require__(1080);
	
	var _pricingIconPhone2x2 = _interopRequireDefault(_pricingIconPhone2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PlanLevelEnterprise = _react2['default'].createClass({
	    displayName: 'PlanLevelEnterprise',
	
	
	    propTypes: {
	        'onSuccess': _react2['default'].PropTypes.func
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            expanded: false
	        };
	    },
	    onLevelClick: function onLevelClick() {
	        this.setState({ expanded: !this.state.expanded });
	    },
	    render: function render() {
	        var bodyClasses = (0, _classnames2['default'])({
	            'm-pricing-level--body': true,
	            'small-12': true,
	            'columns': true,
	            'expanded': this.state.expanded
	        });
	        var levelClasses = (0, _classnames2['default'])({
	            'small-6': true,
	            'medium-4': true,
	            'medium-offset-1': true,
	            'large-12': true,
	            'large-offset-0': true,
	            'columns': true,
	            'level-title': true
	        });
	        var arrowContainerClasses = (0, _classnames2['default'])({
	            'arrow-container': true,
	            'hide-for-large-up': true,
	            'hide-for-small': true,
	            'small-2': true,
	            'medium-1': true,
	            'columns': true
	        });
	        var arrowClasses = (0, _classnames2['default'])({
	            'l-vertical-align': true,
	            'arrow': true,
	            'expanded': this.state.expanded
	        });
	        var contactUsClasses = (0, _classnames2['default'])({
	            'phone-container': true,
	            'hide-for-large-up': true,
	            'small-6': true,
	            'medium-5': true,
	            'medium-offset-1': true,
	            'columns': true,
	            'level-price': true
	        });
	        var lookingForMoreClasses = (0, _classnames2['default'])({
	            'm-pricing-level--body': true,
	            'small-10': true,
	            'small-centered': true,
	            'columns': true,
	            'looking-for-more': true
	        });
	
	        var mainFeature = '';
	        var noFeatures = true;
	        if (this.props.plan.main_feature) {
	            var name = this.props.plan.main_feature.name ? this.props.plan.main_feature.name : name;
	            var detail = this.props.plan.main_feature.detail ? this.props.plan.main_feature.detail : null;
	            var number = this.props.plan.main_feature.number ? this.props.plan.main_feature.number : null;
	            mainFeature = _react2['default'].createElement(_pricingLevelFeature2['default'], { name: name, planName: this.props.name, detail: detail, number: number, key: 'main-feature', expanded: this.state.expanded });
	            noFeatures = false;
	        }
	
	        var features = '';
	        if (this.props.plan.features) {
	            features = this.props.plan.features.map(function (feature, i) {
	                var name = feature.name ? feature.name : name;
	                var detail = feature.detail ? feature.detail : null;
	                var number = feature.number ? feature.number : null;
	                return _react2['default'].createElement(_pricingLevelFeature2['default'], { name: name, planName: this.props.plan.name, detail: detail, number: number, key: 'feature' + i, expanded: this.state.expanded });
	            }.bind(this));
	        }
	
	        var additionalFeatures = _react2['default'].createElement(
	            'div',
	            { className: 'additional-features small-12 columns block' },
	            this.props.plan.additional_features
	        );
	
	        var phoneNumberClasses = (0, _classnames2['default'])({
	            'contact-us-phone-number': true,
	            'l-nowrap': true,
	            'no-features-padding': noFeatures
	        });
	
	        // Currently locked to 3 columns. To extend to different levels, cf pricing-level-corporate.jsx (DB)
	        var topLevelClasses = 'm-pricing-level signup-plan small-12 medium-12 large-4 columns';
	
	        return _react2['default'].createElement(
	            'div',
	            { className: topLevelClasses },
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-pricing-level--header small-12 columns block', onClick: this.onLevelClick },
	                _react2['default'].createElement(
	                    'div',
	                    { className: levelClasses },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'level-title l-vertical-align-wrapper' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'l-vertical-align' },
	                            this.props.plan.name.toUpperCase()
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'subheader' },
	                        this.props.plan.subheader
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: contactUsClasses },
	                    !this.state.expanded && _react2['default'].createElement(_contactUsButton2['default'], {
	                        timePeriod: this.state.timePeriod,
	                        pricingSource: this.props.pricingSource,
	                        modalHeaderText: 'Contact Us for an Enterprise Plan',
	                        onSuccess: this.props.onSuccess,
	                        buttonText: 'Contact Us',
	                        onClick: function onClick(e) {
	                            return e.stopPropagation();
	                        }
	                    })
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: arrowContainerClasses },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'level-title l-vertical-align-wrapper' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: arrowClasses },
	                            '\xA0'
	                        )
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: bodyClasses },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'first-section block' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: lookingForMoreClasses },
	                        'Looking for more?'
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'sales-team-blurb' },
	                        'Our Sales team can help find the perfect plan for you.'
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'block' },
	                        _react2['default'].createElement(_contactUsButton2['default'], {
	                            timePeriod: this.state.timePeriod,
	                            pricingSource: this.props.pricingSource,
	                            modalHeaderText: 'Contact Us for an Enterprise Plan',
	                            onSuccess: this.props.onSuccess,
	                            buttonText: 'Contact Us' })
	                    ),
	                    mainFeature
	                )
	            ),
	            features,
	            additionalFeatures
	        );
	    }
	});
	
	module.exports = PlanLevelEnterprise;

/***/ },
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports['default'] = PlanLevelFree;
	
	__webpack_require__(1149);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function PlanLevelFree(props) {
	
	    var url = '/info/chooseFreeOrEnterpriseSignupPlan';
	
	    var buttonProps = {
	        buttonText: 'Start Free Plan',
	        buttonColor: 'ashen',
	        buttonHoverColor: 'cerulean',
	        buttonLink: url
	    };
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'm-plan-level-free columns small-12 medium-12 large-12' },
	        _react2['default'].createElement(
	            'div',
	            { className: 'level-title free-title large-3 columns block' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'in' },
	                'Free'
	            )
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'large-6 free-blurb columns block' },
	            'Just need to sign a document? Try our ',
	            _react2['default'].createElement(
	                'strong',
	                null,
	                'FREE'
	            ),
	            ' plan.'
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'large-3 free-button columns block' },
	            _react2['default'].createElement(_button2['default'], buttonProps)
	        )
	    );
	}

/***/ },
/* 1149 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1150 */,
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _contactUsModal = __webpack_require__(1070);
	
	var _contactUsModal2 = _interopRequireDefault(_contactUsModal);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Clones ContactUsButton (DB)
	var ContactUsLink = _react2['default'].createClass({
	    displayName: 'ContactUsLink',
	
	    propTypes: {
	        'timePeriod': _react2['default'].PropTypes.string,
	        'pricingSource': _react2['default'].PropTypes.string,
	        'linkText': _react2['default'].PropTypes.string,
	        'modalHeaderText': _react2['default'].PropTypes.string,
	        'onSuccess': _react2['default'].PropTypes.func
	    },
	    componentDidMount: function componentDidMount() {
	
	        if (window.location.search.indexOf('showContactUs=1') > -1) {
	            this.handleClick();
	        }
	    },
	    getInitialState: function getInitialState() {
	        return {
	            'timePeriod': 'Y'
	        };
	    },
	    handleClick: function handleClick(e) {
	
	        e.preventDefault();
	
	        var attachPoint = _hfReactHelper2['default'].getRevealAttachPoint('contact_us_modal');
	        _reactDom2['default'].render(_react2['default'].createElement(_contactUsModal2['default'], {
	            timePeriod: this.state.timePeriod,
	            pricingSource: this.props.pricingSource,
	            headerText: this.props.modalHeaderText,
	            onSuccess: this.props.onSuccess }), attachPoint);
	    },
	    render: function render() {
	        var text = this.props.linkText !== undefined ? this.props.linkText : 'Contact Us';
	        return _react2['default'].createElement(
	            'a',
	            {
	                ref: 'contactUsLink',
	                id: 'contactUsLink',
	                onClick: this.handleClick },
	            text
	        );
	    }
	});
	
	module.exports = ContactUsLink;

/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(1153);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fixedModal = __webpack_require__(728);
	
	var _fixedModal2 = _interopRequireDefault(_fixedModal);
	
	var _loader = __webpack_require__(798);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _test_drive_illo = __webpack_require__(1155);
	
	var _test_drive_illo2 = _interopRequireDefault(_test_drive_illo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SuccessTestDriveModal = function (_Component) {
	    _inherits(SuccessTestDriveModal, _Component);
	
	    function SuccessTestDriveModal() {
	        _classCallCheck(this, SuccessTestDriveModal);
	
	        return _possibleConstructorReturn(this, (SuccessTestDriveModal.__proto__ || Object.getPrototypeOf(SuccessTestDriveModal)).apply(this, arguments));
	    }
	
	    _createClass(SuccessTestDriveModal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var timeout = 4000; // 4 seconds
	            var redirectUrl = '/info/chooseFreeOrEnterpriseSignupPlan';
	            redirectUrl += '?enterprise=1';
	            setTimeout(function () {
	                window.location = redirectUrl;
	            }, timeout);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(
	                _fixedModal2['default'],
	                { width: 400 },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-success-test-drive-modal' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-success-test-drive-modal--header' },
	                        _react2['default'].createElement(
	                            'h2',
	                            null,
	                            'Thanks! We\'ll be in touch shortly.'
	                        ),
	                        _react2['default'].createElement(
	                            'h1',
	                            null,
	                            'In the meantime, feel free to take us for a test drive!'
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'loader' },
	                            _react2['default'].createElement(_loader2['default'], null)
	                        )
	                    ),
	                    _react2['default'].createElement('img', { src: _test_drive_illo2['default'] })
	                )
	            );
	        }
	    }]);
	
	    return SuccessTestDriveModal;
	}(_react.Component);
	
	exports['default'] = SuccessTestDriveModal;

/***/ },
/* 1153 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1154 */,
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/7617d64c38a19b9b68a76370390196c5.svg";

/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(1157);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _smallToggle = __webpack_require__(1159);
	
	var _smallToggle2 = _interopRequireDefault(_smallToggle);
	
	var _teamSizeSelect = __webpack_require__(1162);
	
	var _teamSizeSelect2 = _interopRequireDefault(_teamSizeSelect);
	
	var _planCard = __webpack_require__(1168);
	
	var _planCard2 = _interopRequireDefault(_planCard);
	
	var _freePlanLink = __webpack_require__(1174);
	
	var _freePlanLink2 = _interopRequireDefault(_freePlanLink);
	
	var _enterprisePlanCustomerCallout = __webpack_require__(1177);
	
	var _enterprisePlanCustomerCallout2 = _interopRequireDefault(_enterprisePlanCustomerCallout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PlanChoiceAreaV2 = function (_Component) {
	    _inherits(PlanChoiceAreaV2, _Component);
	
	    function PlanChoiceAreaV2() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, PlanChoiceAreaV2);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PlanChoiceAreaV2.__proto__ || Object.getPrototypeOf(PlanChoiceAreaV2)).call.apply(_ref, [this].concat(args))), _this), _this.toggleTime = function () {
	            var value = void 0;
	            if (_this.props.timePeriod === 'M') {
	                value = 'Y';
	            } else {
	                value = 'M';
	            }
	            _this.props.onTimeToggle(value);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(PlanChoiceAreaV2, [{
	        key: 'render',
	        value: function render() {
	
	            var teamSize = this.props.teamSize;
	            var annual = this.props.timePeriod === 'Y';
	
	            var toggleAreaMiddle = void 0;
	            if (teamSize === 'large-team') {
	                toggleAreaMiddle = _react2['default'].createElement(
	                    'div',
	                    { className: 'middle placeholder' },
	                    _react2['default'].createElement('div', { className: 'line' })
	                );
	            } else {
	                toggleAreaMiddle = _react2['default'].createElement(
	                    'div',
	                    { className: 'middle' },
	                    _react2['default'].createElement(_smallToggle2['default'], {
	                        on: annual,
	                        onClick: this.toggleTime,
	                        offLabel: 'MONTHLY',
	                        onLabel: 'ANNUAL' })
	                );
	            }
	
	            var timeToggleArea = void 0;
	            if (teamSize) {
	                timeToggleArea = _react2['default'].createElement(
	                    'div',
	                    { className: 'time-toggle-area' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'side' },
	                        _react2['default'].createElement('div', { className: teamSize === 'individual' ? 'line pointer leftside' : 'line' })
	                    ),
	                    toggleAreaMiddle,
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'side' },
	                        _react2['default'].createElement('div', { className: teamSize === 'large-team' ? 'line pointer rightside' : 'line' })
	                    )
	                );
	            }
	
	            var planContent = void 0;
	            var plans = void 0;
	            switch (teamSize) {
	
	                case 'individual':
	                    plans = this.props.planData.filter(function (plan) {
	                        return plan.name === 'Pro';
	                    });
	                    planContent = _react2['default'].createElement(
	                        'div',
	                        null,
	                        _react2['default'].createElement(_planCard2['default'], {
	                            plan: plans[0],
	                            period: this.props.timePeriod,
	                            onPlanChoice: this.props.onPlanChoice }),
	                        _react2['default'].createElement(_freePlanLink2['default'], null)
	                    );
	                    break;
	
	                case 'small-team':
	                    plans = this.props.planData.filter(function (plan) {
	                        return plan.name.indexOf('Business') > -1;
	                    });
	                    planContent = _react2['default'].createElement(
	                        'div',
	                        { className: 'two-up' },
	                        _react2['default'].createElement(_planCard2['default'], {
	                            plan: plans[0],
	                            period: this.props.timePeriod,
	                            onPlanChoice: this.props.onPlanChoice }),
	                        _react2['default'].createElement(_planCard2['default'], {
	                            plan: plans[1],
	                            period: this.props.timePeriod,
	                            onPlanChoice: this.props.onPlanChoice })
	                    );
	                    break;
	
	                case 'large-team':
	                    plans = this.props.planData.filter(function (plan) {
	                        return plan.name === 'Enterprise';
	                    });
	                    planContent = _react2['default'].createElement(
	                        'div',
	                        { className: 'wide-card' },
	                        _react2['default'].createElement(_planCard2['default'], {
	                            plan: plans[0],
	                            period: this.props.timePeriod,
	                            onEnterpriseSuccess: this.props.onEnterpriseSuccess }),
	                        _react2['default'].createElement(_enterprisePlanCustomerCallout2['default'], null)
	                    );
	                    break;
	
	                default:
	                // No content
	
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'plan-choice-area-v2' },
	                _react2['default'].createElement(_teamSizeSelect2['default'], {
	                    selected: teamSize,
	                    onTeamSizeSelect: this.props.onTeamSizeSelect }),
	                timeToggleArea,
	                planContent
	            );
	        }
	    }]);
	
	    return PlanChoiceAreaV2;
	}(_react.Component);
	
	PlanChoiceAreaV2.propTypes = {
	    planData: _react.PropTypes.array.isRequired,
	    timePeriod: _react.PropTypes.string,
	    teamSize: _react.PropTypes.string,
	    onPlanChoice: _react.PropTypes.func,
	    onEnterpriseSuccess: _react.PropTypes.func,
	    onTimeToggle: _react.PropTypes.func,
	    onTeamSizeSelect: _react.PropTypes.func
	};
	exports['default'] = PlanChoiceAreaV2;

/***/ },
/* 1157 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1158 */,
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1160);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Toggle = _react2['default'].createClass({
	    displayName: 'Toggle',
	    handleClick: function handleClick() {
	        if (this.props.onClick) {
	            this.props.onClick();
	        }
	    },
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            { className: 'rx-toggle ' + (this.props.on ? ' on' : 'off'), onClick: this.handleClick },
	            _react2['default'].createElement(
	                'span',
	                { className: 'off-label uppercase' },
	                this.props.offLabel
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'switch' },
	                _react2['default'].createElement('div', { className: 'switch-button' })
	            ),
	            _react2['default'].createElement(
	                'span',
	                { className: 'on-label uppercase' },
	                this.props.onLabel
	            )
	        );
	    }
	});
	
	module.exports = Toggle;

/***/ },
/* 1160 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1161 */,
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports['default'] = TeamSizeSelect;
	
	__webpack_require__(1163);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _scooter_icon = __webpack_require__(1165);
	
	var _scooter_icon2 = _interopRequireDefault(_scooter_icon);
	
	var _car_icon = __webpack_require__(1166);
	
	var _car_icon2 = _interopRequireDefault(_car_icon);
	
	var _boat_icon = __webpack_require__(1167);
	
	var _boat_icon2 = _interopRequireDefault(_boat_icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function TeamSizeSelect(p) {
	
	    var baseClass = 'team-size-level';
	    var selectedClass = ' selected';
	
	    var individualLevel = _react2['default'].createElement(
	        'div',
	        {
	            className: p.selected === 'individual' ? baseClass + selectedClass : baseClass,
	            onClick: function onClick() {
	                return p.onTeamSizeSelect('individual');
	            } },
	        _react2['default'].createElement('img', { src: _scooter_icon2['default'] }),
	        _react2['default'].createElement(
	            'div',
	            { className: 'level-name' },
	            'Individual'
	        )
	    );
	
	    var smallTeamLevel = _react2['default'].createElement(
	        'div',
	        {
	            className: p.selected === 'small-team' ? baseClass + selectedClass : baseClass,
	            onClick: function onClick() {
	                return p.onTeamSizeSelect('small-team');
	            } },
	        _react2['default'].createElement('img', { src: _car_icon2['default'] }),
	        _react2['default'].createElement(
	            'div',
	            { className: 'level-name' },
	            'Small team'
	        )
	    );
	
	    var largeTeamLevel = _react2['default'].createElement(
	        'div',
	        {
	            className: p.selected === 'large-team' ? baseClass + selectedClass : baseClass,
	            onClick: function onClick() {
	                return p.onTeamSizeSelect('large-team');
	            } },
	        _react2['default'].createElement('img', { src: _boat_icon2['default'] }),
	        _react2['default'].createElement(
	            'div',
	            { className: 'level-name' },
	            'Large team'
	        )
	    );
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'm-team-size-select' },
	        individualLevel,
	        smallTeamLevel,
	        largeTeamLevel
	    );
	}

/***/ },
/* 1163 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1164 */,
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/66bd10af41c2d5aa5383f98adf787191.svg";

/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/d103c9b0642bf088f7b3708d5529382b.svg";

/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/061c51ec571533c5aec55c7fb4d3d1b3.svg";

/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports['default'] = PlanCard;
	
	__webpack_require__(1169);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _planFeaturesCard = __webpack_require__(1171);
	
	var _planFeaturesCard2 = _interopRequireDefault(_planFeaturesCard);
	
	var _contactUsButton = __webpack_require__(1069);
	
	var _contactUsButton2 = _interopRequireDefault(_contactUsButton);
	
	var _pricingIconPhone2x = __webpack_require__(1080);
	
	var _pricingIconPhone2x2 = _interopRequireDefault(_pricingIconPhone2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getPrice(plan, period) {
	    if (plan.coupon) {
	        if (period === 'Y') {
	            return plan.coupon_annual_price;
	        } else {
	            return plan.coupon_monthly_price;
	        }
	    } else {
	        if (period === 'Y') {
	            return plan.annual_price;
	        } else {
	            return plan.monthly_price;
	        }
	    }
	}
	
	function PlanCard(props) {
	
	    var plan = props.plan;
	    var period = props.period || 'M';
	    var features = plan.features;
	
	    var periodText = void 0;
	    var price = getPrice(plan, period);
	    if (period === 'M') {
	        periodText = 'per month when paid monthly';
	    } else {
	        price = price / 12;
	        periodText = 'per month when paid annually';
	    }
	    price = Math.ceil(price);
	
	    var preCouponPrice = void 0;
	    if (plan.coupon) {
	        var oldPrice = props.period === 'Y' ? Math.ceil(plan.annual_price / 12) : plan.monthly_price;
	
	        preCouponPrice = _react2['default'].createElement(
	            'div',
	            { className: 'm-pricing-level' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-pricing-level--body small-4 large-12 small-centered columns level-price' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'dollar crossed' },
	                    '$'
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'price crossed' },
	                    oldPrice
	                )
	            )
	        );
	    }
	
	    var details = void 0;
	    if (plan.is_enterprise) {
	        details = _react2['default'].createElement(
	            'div',
	            { className: 'plan-details' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'plan-name' },
	                plan.name
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'enterprise-plan-text' },
	                _react2['default'].createElement(
	                    'h1',
	                    null,
	                    'Looking for more?'
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    'Our Sales team can help find the perfect plan for you.'
	                )
	            ),
	            _react2['default'].createElement(_contactUsButton2['default'], {
	                timePeriod: period,
	                pricingSource: props.pricingSource,
	                modalHeaderText: 'Contact Us for an Enterprise Plan',
	                onSuccess: props.onEnterpriseSuccess,
	                buttonText: 'Contact Us' })
	        );
	    } else {
	        var planChoiceParameters = {
	            planId: plan.plan_id,
	            timePeriod: period,
	            price: getPrice(plan, period)
	        };
	        details = _react2['default'].createElement(
	            'div',
	            { className: 'plan-details' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'plan-name' },
	                plan.name
	            ),
	            preCouponPrice,
	            _react2['default'].createElement(
	                'div',
	                { className: 'price' },
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'currency' },
	                    '$'
	                ),
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'amount' },
	                    price
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'period' },
	                periodText
	            ),
	            _react2['default'].createElement(_button2['default'], {
	                buttonText: 'START 30-DAY FREE TRIAL',
	                onClick: function onClick() {
	                    return props.onPlanChoice(planChoiceParameters);
	                } })
	        );
	    }
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'm-plan-card' },
	        details,
	        _react2['default'].createElement(_planFeaturesCard2['default'], { features: features })
	    );
	}

/***/ },
/* 1169 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1170 */,
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports['default'] = PlanFeaturesCard;
	
	__webpack_require__(1172);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function PlanFeaturesCard(p) {
	
	    var features = p.features;
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'm-plan-features-card' },
	        _react2['default'].createElement(
	            'h1',
	            null,
	            'KEY FEATURES'
	        ),
	        _react2['default'].createElement(
	            'ul',
	            null,
	            features.map(function (feature, idx) {
	
	                var featureNote = void 0;
	                if (feature.note) {
	                    featureNote = _react2['default'].createElement(
	                        'small',
	                        null,
	                        feature.note
	                    );
	                }
	
	                return _react2['default'].createElement(
	                    'li',
	                    { key: 'feat-' + idx },
	                    feature.number,
	                    ' ',
	                    feature.name,
	                    featureNote
	                );
	            })
	        )
	    );
	}

/***/ },
/* 1172 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1173 */,
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports['default'] = FreePlanLink;
	
	__webpack_require__(1175);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function FreePlanLink() {
	
	    var url = '/info/chooseFreeOrEnterpriseSignupPlan';
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'm-free-plan-link' },
	        'Just need to sign a document? Try our',
	        _react2['default'].createElement(
	            'a',
	            { href: url },
	            ' free plan.'
	        )
	    );
	}

/***/ },
/* 1175 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1176 */,
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports['default'] = EnterprisePlanCustomerCallout;
	
	__webpack_require__(1178);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Twitter = __webpack_require__(1180);
	
	var _Twitter2 = _interopRequireDefault(_Twitter);
	
	var _Samsung_LogoSvg = __webpack_require__(1181);
	
	var _Samsung_LogoSvg2 = _interopRequireDefault(_Samsung_LogoSvg);
	
	var _instacart = __webpack_require__(1182);
	
	var _instacart2 = _interopRequireDefault(_instacart);
	
	var _Lyft = __webpack_require__(1183);
	
	var _Lyft2 = _interopRequireDefault(_Lyft);
	
	var _intuit_95x = __webpack_require__(1184);
	
	var _intuit_95x2 = _interopRequireDefault(_intuit_95x);
	
	var _openlegal_logo = __webpack_require__(1185);
	
	var _openlegal_logo2 = _interopRequireDefault(_openlegal_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function EnterprisePlanCustomerCallout() {
	
	    var blurb = _react2['default'].createElement(
	        'div',
	        { className: 'blurb' },
	        '45,000 companies trust us with their most important transactions.'
	    );
	
	    var allLogos = [_Twitter2['default'], _Samsung_LogoSvg2['default'], _instacart2['default'], _intuit_95x2['default'], _openlegal_logo2['default'], _Lyft2['default']];
	
	    var logos = _react2['default'].createElement(
	        'div',
	        { className: 'logos' },
	        allLogos.map(function (logosrc, idx) {
	            return _react2['default'].createElement(
	                'div',
	                { key: 'logo-' + idx },
	                _react2['default'].createElement('img', { src: logosrc })
	            );
	        })
	    );
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'm-enterprise-plan-customer-callout' },
	        blurb,
	        logos
	    );
	}

/***/ },
/* 1178 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1179 */,
/* 1180 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE4LjEuMSwgU1ZHIEV4cG9ydCBQbHVnLUluICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIg0KCSB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWxuczphPSJodHRwOi8vbnMuYWRvYmUuY29tL0Fkb2JlU1ZHVmlld2VyRXh0ZW5zaW9ucy8zLjAvIg0KCSB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjI3My40cHgiIGhlaWdodD0iMjIyLjJweCIgdmlld0JveD0iMCAwIDI3My40IDIyMi4yIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyNzMuNCAyMjIuMiINCgkgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8ZGVmcz4NCjwvZGVmcz4NCjxwYXRoIGZpbGw9IiM1NUFDRUUiIGQ9Ik0yNzMuNCwyNi4zYy0xMC4xLDQuNS0yMC45LDcuNS0zMi4yLDguOGMxMS42LTYuOSwyMC41LTE3LjksMjQuNy0zMUMyNTUsMTAuNSwyNDMsMTUuMiwyMzAuMiwxNy43DQoJQzIyMCw2LjgsMjA1LjQsMCwxODkuMywwYy0zMSwwLTU2LjEsMjUuMS01Ni4xLDU2LjFjMCw0LjQsMC41LDguNywxLjUsMTIuOEM4OCw2Ni41LDQ2LjcsNDQuMiwxOSwxMC4zYy00LjgsOC4zLTcuNiwxNy45LTcuNiwyOC4yDQoJYzAsMTkuNSw5LjksMzYuNiwyNSw0Ni43Yy05LjItMC4zLTE3LjgtMi44LTI1LjQtN2MwLDAuMiwwLDAuNSwwLDAuN2MwLDI3LjIsMTkuMyw0OS44LDQ1LDU1Yy00LjcsMS4zLTkuNywyLTE0LjgsMg0KCWMtMy42LDAtNy4xLTAuNC0xMC42LTFjNy4xLDIyLjMsMjcuOSwzOC41LDUyLjQsMzljLTE5LjIsMTUtNDMuNCwyNC02OS43LDI0Yy00LjUsMC05LTAuMy0xMy40LTAuOGMyNC44LDE1LjksNTQuMywyNS4yLDg2LDI1LjINCgljMTAzLjIsMCwxNTkuNi04NS41LDE1OS42LTE1OS42YzAtMi40LTAuMS00LjktMC4yLTcuM0MyNTYuNCw0Ny40LDI2NS45LDM3LjUsMjczLjQsMjYuM3oiLz4NCjwvc3ZnPg0K"

/***/ },
/* 1181 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/6dfc242ce6ea82216552d32683a6f616.png";

/***/ },
/* 1182 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/c6dfb70e4f54aea261afd655b951d751.svg";

/***/ },
/* 1183 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/77730f41dc38e681173cec2573184616.png";

/***/ },
/* 1184 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/8cb0436c4b4f3fdcceb4a864551e9e2f.png";

/***/ },
/* 1185 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/0d90d3f1e86dfb4a91b5a804655c2aae.svg";

/***/ },
/* 1186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _collectInfoModal = __webpack_require__(1187);
	
	var _collectInfoModal2 = _interopRequireDefault(_collectInfoModal);
	
	var _logger = __webpack_require__(482);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CollectInfo = function (_Component) {
	    _inherits(CollectInfo, _Component);
	
	    function CollectInfo(props) {
	        _classCallCheck(this, CollectInfo);
	
	        var _this = _possibleConstructorReturn(this, (CollectInfo.__proto__ || Object.getPrototypeOf(CollectInfo)).call(this, props));
	
	        _this.state = { show: true };
	        _this.hide = _this.hide.bind(_this);
	        _this.onSuccess = _this.onSuccess.bind(_this);
	        return _this;
	    }
	
	    _createClass(CollectInfo, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            _logger2['default'].track('CollectInfoModal.loaded');
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            this.setState({
	                show: false
	            });
	        }
	    }, {
	        key: 'onSuccess',
	        value: function onSuccess() {
	            this.hide();
	            if (this.props.shouldExplainAfterClose) {
	                var redirect = '/home/chooseSignMethod?explain=1';
	                if (this.props.isEnterprise) {
	                    redirect += '&enterprise=1';
	                }
	                window.location = redirect;
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            var modal = void 0;
	            if (this.state.show) {
	                modal = _react2['default'].createElement(_collectInfoModal2['default'], _extends({}, this.props, { onSuccess: this.onSuccess }));
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'm-collect-info' },
	                modal
	            );
	        }
	    }]);
	
	    return CollectInfo;
	}(_react.Component);
	
	module.exports = CollectInfo;

/***/ },
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(1188);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _collectInfoForm = __webpack_require__(1190);
	
	var _collectInfoForm2 = _interopRequireDefault(_collectInfoForm);
	
	var _fixedModal = __webpack_require__(728);
	
	var _fixedModal2 = _interopRequireDefault(_fixedModal);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CollectInfoModal = function (_Component) {
	    _inherits(CollectInfoModal, _Component);
	
	    function CollectInfoModal() {
	        _classCallCheck(this, CollectInfoModal);
	
	        return _possibleConstructorReturn(this, (CollectInfoModal.__proto__ || Object.getPrototypeOf(CollectInfoModal)).apply(this, arguments));
	    }
	
	    _createClass(CollectInfoModal, [{
	        key: 'render',
	        value: function render() {
	
	            var subheader = _react2['default'].createElement(
	                'div',
	                { className: 'subheader' },
	                _react2['default'].createElement(
	                    'h2',
	                    null,
	                    'Please take a few minutes to build your profile. This information will help us personalize your experience and better define future product updates.'
	                )
	            );
	
	            var _props$collectInfoFor = this.props.collectInfoForm,
	                fields = _props$collectInfoFor.fields,
	                values = _props$collectInfoFor.values,
	                namespace = _props$collectInfoFor.namespace;
	
	            var form = _react2['default'].createElement(_collectInfoForm2['default'], {
	                fields: fields,
	                values: values,
	                action: _hfReactHelper2['default'].urlHelper('home/collectInfo', _hfReactHelper2['default'].HfSites.SITE_CODE_HS),
	                onSuccess: this.props.onSuccess,
	                namespace: namespace,
	                isEnterprise: this.props.isEnterprise
	            });
	
	            return _react2['default'].createElement(
	                _fixedModal2['default'],
	                { width: 610, hideOnOverlayClick: true },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-collect-info-modal' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-collect-info-modal--header' },
	                        _react2['default'].createElement(
	                            'h1',
	                            null,
	                            'Build your e-signature profile'
	                        ),
	                        subheader
	                    ),
	                    form
	                )
	            );
	        }
	    }]);
	
	    return CollectInfoModal;
	}(_react.Component);
	
	exports['default'] = CollectInfoModal;

/***/ },
/* 1188 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1189 */,
/* 1190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseForm = __webpack_require__(703);
	
	var _baseForm2 = _interopRequireDefault(_baseForm);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _logger = __webpack_require__(482);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var CollectInfoForm = _baseForm2['default'].createFormClass({
	
	    displayName: 'CollectInfoForm',
	
	    propTypes: {
	        'tabOffset': _react2['default'].PropTypes.number,
	        'emailAddress': _react2['default'].PropTypes.string,
	        'fields': _react2['default'].PropTypes.array,
	        'values': _react2['default'].PropTypes.object
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            emailAddress: this.props.emailAddress,
	            fieldMap: this.mapFieldsToNames()
	        };
	    },
	
	
	    // Creates a named map of field names so you can find by name, instead of just array index
	    mapFieldsToNames: function mapFieldsToNames() {
	        if (!this.props.fields || !this.props.fields.length) return {};
	
	        return this.props.fields.reduce(function (map, field) {
	            if (field.type !== 'inputhidden') {
	                map[field.name] = field;
	            }
	            return map;
	        }, {});
	    },
	    isRequired: function isRequired(field) {
	        var classAttribute = field.attributes.className || field.attributes['class'] || '';
	        return classAttribute.indexOf('required') >= 0;
	    },
	    fieldnameHasErrors: function fieldnameHasErrors(fieldname) {
	        return this.state.hasErrors && fieldname in this.state.errors.named;
	    },
	    renderErrorsForFieldname: function renderErrorsForFieldname(fieldname) {
	        var errors = void 0;
	
	        if (this.fieldnameHasErrors(fieldname)) {
	            errors = _react2['default'].createElement(
	                'div',
	                { className: 'error' },
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    'This field is required'
	                )
	            );
	        }
	
	        return errors;
	    },
	    trackNumberFilledFields: function trackNumberFilledFields() {
	        var nodes = document.querySelectorAll('input[type="text"], select');
	        var filled = 0;
	        for (var i = 0; i < nodes.length; i++) {
	            if (nodes[i].value && nodes[i].value !== '0') {
	                // 0 is a placeholder for our dropdowns
	                filled++;
	            }
	        }
	        _logger2['default'].track('CollectInfoModal.filled-' + filled);
	    },
	    onSubmit: function onSubmit(evt) {
	        evt.preventDefault();
	
	        // Check to make sure we filled in: First Name, Last Name, Company before submitting
	        var firstNameVal = this.getDOMValueForFieldname('first_name');
	        var lastNameVal = this.getDOMValueForFieldname('last_name');
	        var companyNameVal = this.getDOMValueForFieldname('company_name');
	
	        var namedErrors = {};
	        // Validation
	        if (!firstNameVal) {
	            namedErrors['first_name'] = 'This field is required';
	        }
	        if (!lastNameVal) {
	            namedErrors['last_name'] = 'This field is required';
	        }
	        if (!companyNameVal) {
	            namedErrors['company_name'] = 'This field is required';
	        }
	
	        if (Object.keys(namedErrors).length) {
	            this.setState({
	                'errors': { 'named': namedErrors },
	                'hasErrors': true
	            });
	            return;
	        }
	
	        this.setState({
	            'errors': null,
	            'hasErrors': false
	        });
	
	        this.trackNumberFilledFields();
	        _logger2['default'].track('CollectInfoModal.submitted');
	
	        this.submitAsync(function (resp) {
	            if (resp.success) {
	                if (this.props.onSuccess) {
	                    this.props.onSuccess();
	                }
	            }
	        });
	    },
	    render: function render() {
	        var _this = this;
	
	        var initialTabValue = this.props.tabOffset || 0;
	        var tabOffset = parseInt(initialTabValue, 10);
	
	        var columnClasses = 'columns large-6 small-6 medium-6';
	        var fullwidthClasses = 'columns large-12 medium-12 small-12';
	
	        var fields = {};
	        var fieldKeys = Object.keys(this.state.fieldMap); // Because Object.forEach is not available
	        fieldKeys.map(function (key) {
	            var field = _this.state.fieldMap[key];
	
	            var options = {
	                'tabIndex': field.attributes.tabindex || ++tabOffset,
	                'className': _this.fieldnameHasErrors(field.name) ? 'error' : void 0,
	                'defaultValue': field['default']
	            };
	
	            if (field.type === 'input') {
	                options['placeholder'] = field.options.label;
	                options['data-format'] = 'text';
	            } else if (field.type === 'select') {
	                options['data-format'] = 'select';
	            }
	
	            var asterisk = void 0;
	            if (_this.isRequired(field)) {
	                asterisk = _react2['default'].createElement(
	                    'span',
	                    { className: 'asterisk' },
	                    '*'
	                );
	            }
	
	            // Currently one place where we want to use a fullwidth field; the rest are half
	            var clazz = field.name === 'use_case' ? fullwidthClasses : columnClasses;
	            fields[key] = _react2['default'].createElement(
	                'div',
	                { className: clazz },
	                _react2['default'].createElement(
	                    'label',
	                    null,
	                    field.options.label,
	                    asterisk
	                ),
	                _this.renderField(field.name, options),
	                _this.renderErrorsForFieldname(field.name)
	            );
	        });
	
	        var ctaBar = _react2['default'].createElement(
	            'div',
	            { className: 'cta-bar' },
	            _react2['default'].createElement(_button2['default'], { buttonText: 'Done', buttonTabIndex: 10, onClick: this.onSubmit, buttonColor: 'grasshopper' })
	        );
	
	        return _react2['default'].createElement(
	            'form',
	            { className: 'm-collect-info-form' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-collect-info-form--field-container' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'row' },
	                    fields.first_name,
	                    fields.last_name
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'row' },
	                    fields.job_title,
	                    fields.department
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'row' },
	                    fields.company_name,
	                    fields.industry
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'row' },
	                    fields.use_case
	                ),
	                this.renderHiddenFields()
	            ),
	            ctaBar
	        );
	    }
	});
	
	exports['default'] = CollectInfoForm;

/***/ },
/* 1191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _downloadPage = __webpack_require__(1192);
	
	var _downloadPage2 = _interopRequireDefault(_downloadPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _downloadPage2['default'];

/***/ },
/* 1192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DownloadPage = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _blocks = __webpack_require__(302);
	
	var _layout = __webpack_require__(1193);
	
	var _logo = __webpack_require__(763);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	__webpack_require__(1198);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = _react2['default'].Component,
	    PropTypes = _react2['default'].PropTypes;
	
	
	var iconSrc = __webpack_require__(1200);
	
	/**
	 * This is a full-page component for a file download screen with an automatic download.
	 */
	
	var DownloadPage = exports.DownloadPage = function (_Component) {
	    _inherits(DownloadPage, _Component);
	
	    function DownloadPage(props) {
	        _classCallCheck(this, DownloadPage);
	
	        var _this = _possibleConstructorReturn(this, (DownloadPage.__proto__ || Object.getPrototypeOf(DownloadPage)).call(this, props));
	
	        _this.handleDownloadLinkClick = _this.handleDownloadLinkClick.bind(_this);
	        return _this;
	    }
	
	    _createClass(DownloadPage, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _props = this.props,
	                downloadUrl = _props.downloadUrl,
	                onDownload = _props.onDownload;
	
	            if (downloadUrl.startsWith('https://')) {
	                window.location = downloadUrl;
	            } else {
	                console.log('Skipping download redirect because URL is missing or invalid');
	            }
	
	            if (typeof onDownload == 'function') {
	                onDownload({ automatic: true });
	            }
	        }
	    }, {
	        key: 'handleDownloadLinkClick',
	        value: function handleDownloadLinkClick(event) {
	            var onDownload = this.props.onDownload;
	
	            if (typeof onDownload == 'function') {
	                onDownload({ automatic: false });
	                event.preventDefault(); // Prevent actual navigation
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                heading = _props2.heading,
	                downloadUrl = _props2.downloadUrl,
	                backLabel = _props2.backLabel,
	                backUrl = _props2.backUrl;
	
	            return _react2['default'].createElement(
	                _layout.Layout,
	                { responsive: true },
	                _react2['default'].createElement(
	                    _blocks.Box,
	                    { pb: 5, pt: 5 },
	                    _react2['default'].createElement(_logo2['default'], { siteCode: 'S', isLink: true, href: '/' })
	                ),
	                _react2['default'].createElement(
	                    _layout.Main,
	                    { style: { textAlign: 'center' } },
	                    _react2['default'].createElement(
	                        _blocks.Box,
	                        { m: 2 },
	                        _react2['default'].createElement('img', {
	                            alt: 'File icon',
	                            src: iconSrc,
	                            style: { height: '100px' }
	                        })
	                    ),
	                    _react2['default'].createElement(
	                        _blocks.Box,
	                        {
	                            mb: 4,
	                            style: { fontSize: '26px', fontWeight: 'bold' }
	                        },
	                        heading
	                    ),
	                    _react2['default'].createElement(
	                        _blocks.Box,
	                        null,
	                        'Your download should begin shortly. If not,',
	                        ' ',
	                        _react2['default'].createElement(
	                            'a',
	                            {
	                                href: downloadUrl,
	                                onClick: this.handleDownloadLinkClick
	                            },
	                            _react2['default'].createElement(
	                                'strong',
	                                null,
	                                'click here'
	                            )
	                        ),
	                        '.'
	                    ),
	                    _react2['default'].createElement(
	                        _blocks.Box,
	                        { mt: 5, mb: 5 },
	                        _react2['default'].createElement(
	                            'a',
	                            { href: backUrl },
	                            'Go back to ',
	                            backLabel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DownloadPage;
	}(Component);
	
	DownloadPage.propTypes = {
	    heading: PropTypes.string.isRequired,
	    downloadUrl: PropTypes.string.isRequired,
	    backLabel: PropTypes.string.isRequired,
	    backUrl: PropTypes.string.isRequired,
	    onDownload: PropTypes.func // Used for tests/storybook
	};
	
	exports['default'] = DownloadPage;

/***/ },
/* 1193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Main = exports.Layout = undefined;
	
	var _layout = __webpack_require__(1194);
	
	Object.defineProperty(exports, 'Layout', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_layout)['default'];
	  }
	});
	
	var _main = __webpack_require__(1195);
	
	Object.defineProperty(exports, 'Main', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_main)['default'];
	  }
	});
	
	__webpack_require__(1196);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/***/ },
/* 1194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.HellosignLayout = HellosignLayout;
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _blocks = __webpack_require__(302);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function HellosignLayout(_ref) {
	    var children = _ref.children,
	        responsive = _ref.responsive;
	
	    var style = responsive ? {} : { minWidth: 1180 };
	
	    // The 'site-wrapper' is needed as a js-hook for the notifications component
	    return _react2['default'].createElement(
	        _blocks.Flex,
	        {
	            id: 'site-wrapper',
	            style: style,
	            flexDirection: 'column',
	            className: 'hellosign-layout-container',
	            marginX: 'auto',
	            px: responsive ? 3 : 1 },
	        children
	    );
	}
	
	exports['default'] = HellosignLayout;

/***/ },
/* 1195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _blocks = __webpack_require__(302);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = _react2['default'].Component,
	    PropTypes = _react2['default'].PropTypes;
	
	var Main = function (_Component) {
	    _inherits(Main, _Component);
	
	    function Main() {
	        _classCallCheck(this, Main);
	
	        return _possibleConstructorReturn(this, (Main.__proto__ || Object.getPrototypeOf(Main)).apply(this, arguments));
	    }
	
	    _createClass(Main, [{
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(
	                _blocks.Box,
	                _extends({ is: 'main', flex: 1 }, this.props),
	                this.props.children
	            );
	        }
	    }]);
	
	    return Main;
	}(Component);
	
	exports['default'] = Main;

/***/ },
/* 1196 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1197 */,
/* 1198 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1199 */,
/* 1200 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/0c3e47fd42f02195c404a8d58ec310be.svg";

/***/ },
/* 1201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1202);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _watchAppNotifier = __webpack_require__(835);
	
	var _watchAppNotifier2 = _interopRequireDefault(_watchAppNotifier);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _configEntry = __webpack_require__(1204);
	
	var _configEntry2 = _interopRequireDefault(_configEntry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var FaxLineConfigList = _react2['default'].createClass({
	    displayName: 'FaxLineConfigList',
	
	
	    mixins: [_watchAppNotifier2['default']],
	
	    propTypes: {},
	
	    getInitialState: function getInitialState() {
	        var app = this.props.app || window.app;
	        return {
	            app: app,
	            user: app.user,
	            faxLines: app.user.getFaxLines(),
	            teamMembers: app.serverSideGeneratedData.allTeamMembers, // app.user.getTeam().getMembers({ pageSize: Infinity }), // This should be allTeamMembers
	            query: ''
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        // register to receive addedFaxLine events
	        $(document).bind('addedFaxLine', this.handleAddedFaxLine); //FIXME: old jquery
	    },
	    componentDidUpdate: function componentDidUpdate() {
	        // FIXME: old jquery
	        $('.fax-line-member-email-search').autocomplete({
	            'source': this.getAutocompleteResults,
	            'select': this.autocompleteMadeSelection
	        });
	    },
	
	
	    // If there are more than this many fax lines, search functionality will be enabled.
	    // Also, only this many fax lines will be displayed on page load.
	    numFaxLinesForSearch: 5,
	
	    // Maximum number of fax line config widgets to display (because rendering too many hangs the browser)
	    maxFaxLineConfigsToDisplay: 50,
	
	    // Returns whether search functionality should be enabled
	    searchEnabled: function searchEnabled() {
	        return this.state.faxLines.length > this.numFaxLinesForSearch;
	    },
	
	
	    // Strip a string of everything but digits and plus symbols
	    // Example: '+1 (555) 444-3333' becomes '+15554443333'
	    stripFaxNumberString: function stripFaxNumberString(text) {
	        return text.replace(/[^\d+]/g, '');
	    },
	
	
	    // Provides search results to the autocomplete box
	    getAutocompleteResults: function getAutocompleteResults(request, response) {
	        var text = request.term;
	        var textDigits = this.stripFaxNumberString(text);
	        var matches = [];
	        var limit = 10;
	
	        if (textDigits.length > 0) {
	            (this.state.faxLines || []).map(function (faxLine) {
	                if (matches.length < limit && faxLine.number.includes(textDigits)) {
	                    matches.push(hellofaxJS.formatInternationalFaxNumber(faxLine.number));
	                }
	            });
	        }
	        (this.state.teamMembers || []).map(function (teamMember) {
	            if (matches.length < limit && teamMember.emailAddress.startsWith(text)) {
	                matches.push(teamMember.emailAddress);
	            }
	        });
	
	        response(matches);
	    },
	
	
	    // Invoked when an autocomplete item is selected
	    autocompleteMadeSelection: function autocompleteMadeSelection(event, ui) {
	        event.target.value = ui.item.value;
	        this.commitSearchQuery(event.target.form);
	    },
	
	
	    // Save the search query, triggering a re-render with the results
	    commitSearchQuery: function commitSearchQuery(form) {
	        var query = form.elements[0].value;
	        this.setState({ query: query });
	    },
	
	
	    // OnSubmit handler for search form
	    searchFaxLines: function searchFaxLines(event) {
	        event.preventDefault();
	
	        // Try to close the autocomplete menu
	        // FIXME: old jquery
	        $('.fax-line-member-email-search').autocomplete('close');
	
	        // Commit the search query
	        var form = event.target;
	        this.commitSearchQuery(form);
	    },
	
	
	    // OnChange handler for search input field
	    searchTextChanged: function searchTextChanged(event) {
	        // Clear the current search if the user clears the input
	        if (event.target.value === '') {
	            this.commitSearchQuery(event.target.form);
	        }
	    },
	    handleAddedFaxLine: function handleAddedFaxLine(e) {
	        this.state.faxLines.addFaxLine({ data: e.addedFaxLines[0] });
	    },
	    updateFaxLineStatusCode: function updateFaxLineStatusCode(guid, newStatusCode) {
	        var faxLines = this.state.faxLines;
	        for (var i in faxLines) {
	            if (faxLines[i].guid === guid) {
	                faxLines[i].statusCode = newStatusCode;
	            }
	        }
	        this.setState({ faxLines: faxLines });
	    },
	    removeFaxLine: function removeFaxLine(faxLine) {
	        var updatedFaxLines = this.state.faxLines.filter(function (candidate) {
	            return candidate.guid !== faxLine.guid;
	        });
	
	        this.setState({ faxLines: updatedFaxLines });
	    },
	    render: function render() {
	        // Get only the fax lines we wish to display right now (search functionality happens here)
	        var searchEnabled = this.searchEnabled();
	        var query = this.state.query;
	        var queryExists = query.length > 0;
	        var tooManyFaxLinesToDisplay = false;
	        var needToSearchToSeeMore = false;
	        var faxLines = (this.state.faxLines || []).filter(function (faxLine, i) {
	            if (searchEnabled && queryExists) {
	                // Return true if the number matches the query
	                var queryDigits = this.stripFaxNumberString(query);
	                if (queryDigits.length > 0 && faxLine.number.includes(queryDigits)) {
	                    return true;
	                }
	
	                // Return true if any user's email matches the query
	                for (var j = 0; j < faxLine.teamMembers.length; j++) {
	                    if (faxLine.teamMembers[j].emailAddress.startsWith(query)) {
	                        return true;
	                    }
	                }
	
	                // Don't show this FaxLine if it didn't match the query
	                return false;
	            } else {
	                // If no query present, just show the first n FaxLines by default
	                if (i >= this.numFaxLinesForSearch) {
	                    needToSearchToSeeMore = true;
	                    return false;
	                } else {
	                    return true;
	                }
	            }
	        }.bind(this));
	
	        if (faxLines.length >= this.maxFaxLineConfigsToDisplay) {
	            // Over the limit. Hide this fax line and show a message to the user
	            tooManyFaxLinesToDisplay = true;
	            faxLines = faxLines.slice(0, this.maxFaxLineConfigsToDisplay);
	        }
	
	        // Get only the team members that aren't pending
	        var teamMembers = (this.state.teamMembers || []).filter(function (tm) {
	            return !tm.pending;
	        });
	
	        // Create the search form if search is supposed to be enabled
	        var searchWidget;
	        if (searchEnabled) {
	            searchWidget = _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'search-header' },
	                    'Manage fax numbers'
	                ),
	                _react2['default'].createElement(
	                    'form',
	                    { className: 'search-fax-lines', onSubmit: this.searchFaxLines },
	                    _react2['default'].createElement('input', { type: 'text', placeholder: 'Fax number or email address', className: 'fax-line-member-email-search', onChange: this.searchTextChanged }),
	                    _react2['default'].createElement(_button2['default'], { iconUri: 'v2/common/search_icon_white.svg' })
	                )
	            );
	        }
	
	        // Create the configuration components for all the visible fax lines
	        var faxLineConfigs = faxLines.map(function (faxLine) {
	            return _react2['default'].createElement(_configEntry2['default'], {
	                handleDelete: this.removeFaxLine,
	                key: faxLine.number,
	                faxLine: faxLine,
	                teamMembers: teamMembers,
	                hasMultiple: faxLines.length > 1,
	                app: this.props.app });
	        }.bind(this));
	
	        // Create the message to conditionally show at the end of the list
	        var postMessage;
	        if (tooManyFaxLinesToDisplay) {
	            postMessage = _react2['default'].createElement(
	                'div',
	                { className: 'search-footer-msg' },
	                'Showing the the first ',
	                this.maxFaxLineConfigsToDisplay,
	                ' matches. Search for a more specific term to narrow the results.'
	            );
	        } else if (needToSearchToSeeMore) {
	            postMessage = _react2['default'].createElement(
	                'div',
	                { className: 'search-footer-msg' },
	                'Only showing ',
	                this.numFaxLinesForSearch,
	                ' fax lines. Perform a search using the form above to see more.'
	            );
	        } else if (queryExists && faxLines.length == 0) {
	            postMessage = _react2['default'].createElement(
	                'div',
	                { className: 'search-footer-msg' },
	                'No results found for ',
	                _react2['default'].createElement(
	                    'b',
	                    null,
	                    query
	                ),
	                '. Please try again.'
	            );
	        }
	
	        return _react2['default'].createElement(
	            'div',
	            { id: 'fax_line_config' },
	            searchWidget,
	            _react2['default'].createElement(
	                'div',
	                { className: 'clearfix' },
	                faxLineConfigs
	            ),
	            postMessage
	        );
	    }
	});
	
	module.exports = FaxLineConfigList;

/***/ },
/* 1202 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1203 */,
/* 1204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _watchAppNotifier = __webpack_require__(835);
	
	var _watchAppNotifier2 = _interopRequireDefault(_watchAppNotifier);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	var _formattedFaxNumber = __webpack_require__(1205);
	
	var _formattedFaxNumber2 = _interopRequireDefault(_formattedFaxNumber);
	
	var _tooltip = __webpack_require__(727);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _multiSelect = __webpack_require__(1206);
	
	var _multiSelect2 = _interopRequireDefault(_multiSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var FaxLineConfigEntry = _react2['default'].createClass({
	    displayName: 'FaxLineConfigEntry',
	
	
	    mixins: [_watchAppNotifier2['default']],
	
	    propTypes: {
	        hasMultiple: _react2['default'].PropTypes.bool.isRequired,
	        teamMembers: _react2['default'].PropTypes.array.isRequired, // This should be allTeamMembers
	        faxLine: function faxLine(props, propName, componentName) {
	            if (props[propName].number === undefined) {
	                throw new Error(propName + '.number must be defined for ' + componentName);
	            }
	            if (props[propName].statusCode === undefined) {
	                throw new Error(propName + '.statusCode must be defined for ' + componentName);
	            }
	            if (props[propName].guid === undefined) {
	                throw new Error(propName + '.guid must be defined for ' + componentName);
	            }
	        }
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            hasHover: false,
	            isDeleting: false,
	            statusMessage: null, // when not null, should be object in form of { text: '', className: '' }
	            isPorting: this.props.faxLine.statusCode !== _hfReactHelper2['default'].HfConstants.team_fax_lines.STATUS_CODES.STATUS_CODE_ACTIVE
	        };
	    },
	    handleMouseEnter: function handleMouseEnter() {
	        this.setState({ hasHover: true });
	    },
	    handleMouseLeave: function handleMouseLeave() {
	        this.setState({ hasHover: false });
	    },
	    handleDelete: function handleDelete() {
	        if (!window.confirm('Are you sure you want to ' + (this.state.isPorting ? 'cancel porting for this number?' : 'remove this fax line? You will no longer be able to receive faxes at this number.'))) {
	            return;
	        }
	
	        this.setState({ isDeleting: true });
	        this.props.faxLine.remove();
	    },
	    handleSelectionChange: function handleSelectionChange(selectedTeamMemberGuids) {
	
	        if (selectedTeamMemberGuids.length === 0) {
	            this.setState({
	                statusMessage: {
	                    text: 'Cannot save. At least one recipient is required.',
	                    className: 'error'
	                }
	            });
	        } else {
	            var onResult = function onResult(err) {
	                if (!err) {
	                    this.setState({ statusMessage: { text: 'Saved', className: 'success' } });
	                } else {
	                    this.setState({ statusMessage: { text: 'Error. Could not save.', className: '' } });
	                }
	            };
	
	            this.props.faxLine.setMembers(this.props.teamMembers.filter(function (tm) {
	                return !!~selectedTeamMemberGuids.indexOf(tm.guid);
	            })).then(onResult.bind(this, void 0), onResult.bind(this));
	        }
	    },
	    render: function render() {
	        var hintText;
	        var hintMsg;
	
	        if (this.props.faxLine.isDenied()) {
	            hintMsg = _react2['default'].createElement(
	                'span',
	                null,
	                'Thank you for your interest in switching over to HelloFax! Unfortunately, we are unable to port this number at this time.'
	            );
	            hintText = _react2['default'].createElement(
	                'span',
	                null,
	                'Porting not possible',
	                _react2['default'].createElement(_tooltip2['default'], {
	                    content: hintMsg,
	                    text: '?',
	                    arrowPosition: 'left'
	                })
	            );
	        } else if (this.props.faxLine.isPorting()) {
	            hintText = _react2['default'].createElement(
	                'span',
	                null,
	                'Checking portability'
	            );
	        } else if (this.props.faxLine.isAccepted()) {
	            hintMsg = _react2['default'].createElement(
	                'span',
	                null,
	                _react2['default'].createElement(
	                    'b',
	                    null,
	                    'Your number is portable!'
	                ),
	                _react2['default'].createElement('br', null),
	                'Please check your email for the steps to complete your porting request.'
	            );
	            hintText = _react2['default'].createElement(
	                'span',
	                null,
	                'Porting in progress',
	                _react2['default'].createElement(_tooltip2['default'], {
	                    content: hintMsg,
	                    text: '?',
	                    arrowPosition: 'left'
	                })
	            );
	        } else if (this.props.faxLine.isActive()) {
	            hintText = _react2['default'].createElement(
	                'span',
	                null,
	                'Email inbound faxes to:'
	            );
	        }
	
	        var deleteBtn = null;
	        if (true) {
	            deleteBtn = _react2['default'].createElement(
	                'span',
	                { onClick: this.handleDelete, className: 'remove-fax-line' + (this.state.isDeleting ? ' loading' : ''), 'data-fax-line-guid': this.props.faxLine.guid, 'data-fax-number': this.props.faxLine.number },
	                _react2['default'].createElement('img', { className: 'spinner', src: _hfReactHelper2['default'].HfConstants.team_fax_lines.URLS.spinnerUrl, width: '16', height: '16' })
	            );
	        }
	
	        var disabled = _hfReactHelper2['default'].inArray(this.props.faxLine.statusCode, [_hfReactHelper2['default'].HfConstants.team_fax_lines.STATUS_CODES.STATUS_CODE_PORTING_DENIED, _hfReactHelper2['default'].HfConstants.team_fax_lines.STATUS_CODES.STATUS_CODE_PORTING_DENIED]) > -1;
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'fax_line_select status-' + this.props.faxLine.statusCode, onMouseEnter: this.handleMouseEnter, onMouseLeave: this.handleMouseLeave },
	            _react2['default'].createElement(
	                'h4',
	                null,
	                _react2['default'].createElement(
	                    'span',
	                    null,
	                    _react2['default'].createElement(_formattedFaxNumber2['default'], { faxNumber: this.props.faxLine.number }),
	                    ' - ',
	                    _react2['default'].createElement(
	                        'span',
	                        { className: 'text' },
	                        hintText
	                    )
	                ),
	                deleteBtn
	            ),
	            _react2['default'].createElement(_multiSelect2['default'], { ref: 'multiSelect',
	                className: 'fax_line_select',
	                disabled: disabled,
	                statusMessage: this.state.statusMessage,
	                options: this.props.teamMembers.map(function (teamMember) {
	                    return { key: teamMember.guid, descr: teamMember.emailAddress };
	                }),
	                onSelectionChange: this.handleSelectionChange,
	                initiallySelectedOptionValues: this.props.faxLine.teamMembers.map(function (v) {
	                    return v.guid;
	                }),
	                'data-fax-line-guid': this.props.faxLine.guid })
	        );
	    }
	});
	
	module.exports = FaxLineConfigEntry;

/***/ },
/* 1205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var FormattedFaxNumber = _react2['default'].createClass({
	    displayName: 'FormattedFaxNumber',
	
	
	    propTypes: {
	        faxNumber: _react2['default'].PropTypes.string.isRequired
	    },
	
	    componentWillMount: function componentWillMount() {
	        var formattedFaxNumber = hellofaxJS.formatInternationalFaxNumber(this.props.faxNumber);
	        this.setState({ formattedFaxNumber: formattedFaxNumber });
	    },
	    render: function render() {
	        return _react2['default'].createElement(
	            'span',
	            { className: 'fax-number' },
	            this.state.formattedFaxNumber
	        );
	    }
	});
	module.exports = FormattedFaxNumber;

/***/ },
/* 1206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fadeOut = __webpack_require__(1207);
	
	var _fadeOut2 = _interopRequireDefault(_fadeOut);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _omit = __webpack_require__(819);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MultiSelect = _react2['default'].createClass({
	    displayName: 'MultiSelect',
	
	
	    propTypes: {
	        initiallySelectedOptionValues: _react2['default'].PropTypes.array.isRequired,
	        onSelectionChange: _react2['default'].PropTypes.func.isRequired,
	        disabled: _react2['default'].PropTypes.bool,
	
	        options: function options(props, propName, componentName) {
	            if (props[propName] === undefined || !$.isArray(props[propName])) {
	                throw new Error(propName + ' must be an array for ' + componentName);
	            }
	            props[propName].forEach(function (entry) {
	                if (entry.key === undefined) {
	                    throw new Error('key attribute must exist for each entry of ' + propName + ' for ' + componentName);
	                }
	                if (entry.descr === undefined) {
	                    throw new Error('descr attribute must exist for each entry of ' + propName + ' for ' + componentName);
	                }
	            });
	        },
	        statusMessage: function statusMessage(props, propName, componentName) {
	            if (props[propName]) {
	                if (props[propName].className === undefined) {
	                    throw new Error(propName + '.className must be defined for ' + componentName);
	                }
	                if (props[propName].text === undefined) {
	                    throw new Error(propName + '.text must be defined for ' + componentName);
	                }
	            }
	        }
	    },
	
	    // Just a band-aid to prevent react from making the multi-select from disappearing. Fix
	    // is to refactor this component to be entirely reactified. (CC)
	    shouldComponentUpdate: function shouldComponentUpdate() {
	        return !this.preventRerender;
	    },
	    getInitialState: function getInitialState() {
	        return {
	            selectedOptionValues: this.props.initiallySelectedOptionValues
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this._setupMultiSelect();
	    },
	    componentDidUpdate: function componentDidUpdate() {
	        this._setupMultiSelect();
	    },
	    _setupMultiSelect: function _setupMultiSelect() {
	        var self = this;
	        var selectEl = $('select', _reactDom2['default'].findDOMNode(this));
	
	        selectEl.multiselect('destroy');
	
	        selectEl.multiselect({
	            selectEl: this,
	            minWidth: 300,
	            maxHeight: 300,
	            noneSelectedText: 'Please select one',
	            open: function open() {
	                self.preventRerender = true;
	            },
	            selectedText: function selectedText(num, total, checkedEls) {
	                if (num > 2) {
	                    return checkedEls[0].title + ' and ' + (num - 1) + ' more';
	                } else if (num == 2) {
	                    return checkedEls[0].title + ' and ' + checkedEls[1].title;
	                } else if (num == 1) {
	                    return checkedEls[0].title;
	                }
	            },
	            close: function close() {
	
	                self.preventRerender = false;
	
	                if (self.props.disabled) {
	                    return;
	                }
	                // FIXME: onChange and .selectedOptions both don't work when we use jQuery multiselect plugin, so we have to go this less React-y route of fetching data from the DOM using jQuery
	                var checkedEls = selectEl.multiselect('getChecked');
	                var checkedValues = checkedEls.map(function () {
	                    return this.value;
	                }).get();
	
	                self.props.onSelectionChange(checkedValues);
	                self.setState({ selectedOptionValues: checkedValues });
	            }
	        });
	
	        if (this.props.disabled) {
	            selectEl.multiselect('disable');
	        }
	    },
	    render: function render() {
	        var selectionOptions = this.props.options.map(function (option) {
	            return _react2['default'].createElement(
	                'option',
	                { key: option.key, value: option.key },
	                option.descr
	            );
	        }, this);
	
	        var msg = this.props.statusMessage ? _react2['default'].createElement(
	            _fadeOut2['default'],
	            { key: this.state.selectedOptionValues + this.props.statusMessage.text },
	            _react2['default'].createElement(
	                'div',
	                { className: 'message ' + this.props.statusMessage.className },
	                this.props.statusMessage.text
	            )
	        ) : null;
	
	        return _react2['default'].createElement(
	            'span',
	            (0, _omit2['default'])(this.props, ['app', 'options', 'initiallySelectedOptionValues', 'onSelectionChange', 'statusMessage']),
	            _react2['default'].createElement(
	                'span',
	                null,
	                _react2['default'].createElement(
	                    'select',
	                    { className: this.props.disabled ? 'disabled' : '', multiple: 'multiple', defaultValue: this.state.selectedOptionValues },
	                    selectionOptions
	                )
	            ),
	            msg
	        );
	    }
	});
	
	module.exports = MultiSelect;

/***/ },
/* 1207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var FadeOut = _react2['default'].createClass({
	    displayName: 'FadeOut',
	
	
	    propTypes: {
	        key: _react2['default'].PropTypes.string //NOTE: If another React component is leveraging this component, include a unique key for each generated message. See MultiSelect for more info.
	    },
	
	    getInitialState: function getInitialState() {
	        return { isMounted: true };
	    },
	    componentDidMount: function componentDidMount() {
	        this.mountAndFadeOut();
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        _reactDom2['default'].unmountComponentAtNode(_reactDom2['default'].findDOMNode(this));
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (this.props.key !== nextProps.key) {
	            this.mountAndFadeOut();
	        }
	    },
	    mountAndFadeOut: function mountAndFadeOut() {
	        _reactDom2['default'].render(_react2['default'].createElement(
	            'span',
	            null,
	            this.props.children
	        ), this.refs.contents);
	        this.fadeOut();
	    },
	    fadeOut: function fadeOut() {
	        $(this.refs.contents).fadeOut(5000, function () {
	            if (this.isMounted()) {
	                _reactDom2['default'].unmountComponentAtNode(_reactDom2['default'].findDOMNode(this));
	            }
	        }.bind(this));
	    },
	    render: function render() {
	        return _react2['default'].createElement('span', { style: { display: 'inline-block' }, ref: 'contents' });
	    }
	});
	module.exports = FadeOut;

/***/ },
/* 1208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _titleSection = __webpack_require__(1209);
	
	var _titleSection2 = _interopRequireDefault(_titleSection);
	
	var _bodySection = __webpack_require__(1211);
	
	var _bodySection2 = _interopRequireDefault(_bodySection);
	
	var _ctaSection = __webpack_require__(1212);
	
	var _ctaSection2 = _interopRequireDefault(_ctaSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = _react2['default'].createClass({
	    displayName: 'eSignature Free SEO Page',
	
	    renderTitleSection: function renderTitleSection() {
	        var titleSectionProps = {
	            title: 'Use eSignatures for Free',
	            subtitle: 'Send your first eSignature for free',
	            buttonText: 'Create a Free Account'
	        };
	        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
	    },
	    renderBodySection: function renderBodySection() {
	        var headerClass = 'm-marketing-page--header';
	        var listClass = 'm-marketing-page--list';
	        return _react2['default'].createElement(
	            _bodySection2['default'],
	            null,
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'Can I use HelloSign eSignatures for free?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'You can begin signing documents for free by signing up for a HelloSign account. Our starter plan gives you three free eSignature requests per month and access to our user-friendly signer experience. You can upgrade to any pro plan or above for unlimited signatures.'
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'What happens if I need more than three signature requests?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Your first three signature requests are free. With an upgraded plan, you can send unlimited signature requests and enjoy HelloSign templates to format your frequently used documents. ',
	                _react2['default'].createElement(
	                    'a',
	                    { target: '_blank', rel: 'noopener noreferrer',
	                        href: 'https://app.hellosign.com/info/pricing' },
	                    'Learn more about our plans here.'
	                )
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'How can I use free eSignatures to sign documents online?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'It\u2019s simple to start signing for free! Once you\u2019ve activated a HelloSign account, you can begin your first signature request. Start by uploading the document you\u2019d like to have signed and format it with a signature field. Format other fields like name of signer and custom signature request message, then send your doc.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'You\u2019ll receive automatic email reminders to update you on the progress of the document.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'You can see what a signature request looks like from the signer\u2019s perspective ',
	                _react2['default'].createElement(
	                    'a',
	                    { target: '_blank', rel: 'noopener noreferrer', href: 'https://faq.hellosign.com/hc/en-us/articles/210929317-What-does-a-signature-request-look-like-from-the-signer-s-perspective-New-' },
	                    'here'
	                ),
	                '.'
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'How else can I use HelloSign?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'While we\u2019re the fastest and easiest way to get documents signed online, we\u2019re also proud to offer a bunch of handy tools to our users. These include:'
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: listClass },
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        'Document templates.'
	                    ),
	                    ' Templates save you the trouble of re-formatting your frequently used documents over and over. Simply upload a document, format with the appropriate fields, then save as a template you can use again and again.'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        'Integrations.'
	                    ),
	                    ' HelloSign also makes it easy to sign paper in your existing apps. This means you can sign documents in apps like ',
	                    _react2['default'].createElement(
	                        'a',
	                        { target: '_blank', rel: 'noopener noreferrer',
	                            href: 'http://blog.hellosign.com/hellosign-integrates-with-evernote/' },
	                        'Evernote'
	                    ),
	                    ',',
	                    _react2['default'].createElement(
	                        'a',
	                        { href: 'http://blog.hellosign.com/dropbox/',
	                            target: '_blank', rel: 'noopener noreferrer' },
	                        'Dropbox'
	                    ),
	                    ', Google (including ',
	                    _react2['default'].createElement(
	                        'a',
	                        {
	                            href: 'https://www.hellosign.com/gmail',
	                            target: '_blank', rel: 'noopener noreferrer' },
	                        'Gmail'
	                    ),
	                    ', ',
	                    _react2['default'].createElement(
	                        'a',
	                        {
	                            href: 'https://www.hellosign.com/googledrive',
	                            target: '_blank', rel: 'noopener noreferrer' },
	                        'Google Drive'
	                    ),
	                    ', and ',
	                    _react2['default'].createElement(
	                        'a',
	                        {
	                            href: 'https://www.hellosign.com/google-docs-add-on',
	                            target: '_blan' },
	                        'Google Docs'
	                    ),
	                    ').'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        'Mobile Signing.'
	                    ),
	                    ' Our signer experience was created with multiple devices in mind. That means it\u2019s easy to sign contracts or paperwork on the go from your desktop, tablet, or mobile device.'
	                )
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'How is HelloSign different from other free eSignature apps?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'The thing that sets HelloSign apart from the rest is our straightforward and friendly signer experience. We are and have always been focused on giving our users the best signing experience possible. That means providing an easy-to-navigate and intuitive signer page that guides users smoothly through the signing flow.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'For you as a signer, that means a more pleasant signing experience and an overall better user experience. To read more about our signer page updates, ',
	                _react2['default'].createElement(
	                    'a',
	                    { href: 'http://blog.hellosign.com/new-signer-experience/',
	                        target: '_blank', rel: 'noopener noreferrer' },
	                    'visit here'
	                ),
	                '.'
	            )
	        );
	    },
	    renderCTASection: function renderCTASection() {
	        var ctaSectionProps = {
	            title: 'Get Started',
	            subtitle: 'Start signing! You can sign up for a free account to test out any of our plans. If you want to connect with a HelloSign specialist to learn more about our business and team plans, schedule a demo.',
	            signupButtonText: 'CREATE A FREE HELLOSIGN ACCOUNT',
	            signupButtonUrl: this.props.homeUrl,
	            secondButtonText: 'SEE PRO PLANS',
	            secondButtonUrl: this.props.pricingUrl
	        };
	        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
	    },
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            null,
	            this.renderTitleSection(),
	            this.renderBodySection(),
	            this.renderCTASection()
	        );
	    }
	});

/***/ },
/* 1209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _signupOrLoginButton = __webpack_require__(1210);
	
	var _signupOrLoginButton2 = _interopRequireDefault(_signupOrLoginButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = _react2['default'].createClass({
	    displayName: 'SEO Title Section',
	
	    propTypes: {
	        title: _react2['default'].PropTypes.string.isRequired,
	        subtitle: _react2['default'].PropTypes.string.isRequired,
	        buttonText: _react2['default'].PropTypes.string.isRequired
	    },
	
	    render: function render() {
	        var props = this.props;
	        var signupOrLoginButtonProps = {
	            buttonText: props.signupButtonText
	        };
	        return _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-marketing-page--title-section row text-center l-padding-t-60 l-padding-b-10' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'columns small-12' },
	                    _react2['default'].createElement(
	                        'h1',
	                        { className: 'm-marketing-page--title' },
	                        props.title
	                    ),
	                    _react2['default'].createElement(
	                        'h4',
	                        { className: 'm-marketing-page--subtitle downsize' },
	                        props.subtitle
	                    )
	                )
	            ),
	            _react2['default'].createElement(_signupOrLoginButton2['default'], _extends({}, signupOrLoginButtonProps, props))
	        );
	    }
	});

/***/ },
/* 1210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = _react2['default'].createClass({
	    displayName: 'SEO Signup or Login Button',
	
	    propTypes: {
	        isUserLoggedIn: _react2['default'].PropTypes.bool.isRequired,
	        homeUrl: _react2['default'].PropTypes.string.isRequired,
	        buttonText: _react2['default'].PropTypes.string.isRequired
	    },
	
	    renderButton: function renderButton() {
	        var defaultButtonClass = {
	            buttonTextColor: 'white',
	            buttonColor: 'goldenrod',
	            buttonBorderColor: 'goldenrod',
	            buttonHoverColor: 'white',
	            buttonHoverTextColor: 'goldenrod'
	        };
	        var buttonContent = {
	            buttonText: this.props.buttonText,
	            buttonLink: this.props.homeUrl
	        };
	        return _react2['default'].createElement(_button2['default'], _extends({}, defaultButtonClass, buttonContent, this.props));
	    },
	    renderSignupButton: function renderSignupButton() {
	        var linkClassName = 'm-button bg-goldenrod hc-goldenrod border-1-goldenrod' + ' hbg-white c-white progress-button state-loading m-marketing-page--button';
	        var linkClassName = this.props.buttonClass || linkClassName;
	        var buttonContent = {
	            buttonText: this.props.linkText,
	            buttonLink: this.props.signUpUrl
	        };
	        return _react2['default'].createElement(_button2['default'], _extends({ className: linkClassName }, buttonContent, this.props));
	    },
	    render: function render() {
	        var className;
	        if (!this.props.isIntegration) {
	            className = 'l-padding-t-10 l-padding-b-10 text-center m-marketing-page--try-it-free';
	        }
	        return _react2['default'].createElement(
	            'div',
	            { className: className },
	            this.props.isUserLoggedIn ? this.renderButton() : this.renderSignupButton()
	        );
	    }
	});

/***/ },
/* 1211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = _react2['default'].createClass({
	    displayName: 'SEO Body Section',
	
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            { className: 'm-marketing-page row' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'columns small-12' },
	                this.props.children
	            )
	        );
	    }
	});

/***/ },
/* 1212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ctaButtons = __webpack_require__(1213);
	
	var _ctaButtons2 = _interopRequireDefault(_ctaButtons);
	
	var _apiUserImages = __webpack_require__(1214);
	
	var _apiUserImages2 = _interopRequireDefault(_apiUserImages);
	
	var _embeddedTweets = __webpack_require__(1215);
	
	var _embeddedTweets2 = _interopRequireDefault(_embeddedTweets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = _react2['default'].createClass({
	    displayName: 'SEO CTA Section',
	
	    render: function render() {
	        var props = this.props;
	        return _react2['default'].createElement(
	            'div',
	            { className: 'bg-plume' },
	            _react2['default'].createElement(_ctaButtons2['default'], props),
	            _react2['default'].createElement(_apiUserImages2['default'], props),
	            _react2['default'].createElement(_embeddedTweets2['default'], props)
	        );
	    }
	});

/***/ },
/* 1213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _signupOrLoginButton = __webpack_require__(1210);
	
	var _signupOrLoginButton2 = _interopRequireDefault(_signupOrLoginButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = _react2['default'].createClass({
	    displayName: 'SEO CTA Buttons',
	
	    signupOrLoginButtonProps: function signupOrLoginButtonProps() {
	        return {
	            classNames: 'm-marketing-page--button',
	            styleAttributes: 'width: 274px',
	            buttonText: this.props.signupButtonText
	        };
	    },
	    secondButtonProps: function secondButtonProps() {
	        return {
	            buttonText: this.props.secondButtonText,
	            buttonLink: this.props.secondButtonUrl,
	            buttonColor: 'plume',
	            buttonTextColor: 'goldenrod',
	            buttonTextUppercase: false,
	            buttonBorderColor: 'goldenrod',
	            buttonHoverColor: 'goldenrod',
	            buttonHoverTextColor: 'white'
	        };
	    },
	    render: function render() {
	        var props = this.props;
	        return _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	                'div',
	                { className: 'columns small-12 small-centered small-text-center' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'l-padding-t-40 l-padding-b-15' },
	                    _react2['default'].createElement(
	                        'h2',
	                        { className: 'm-marketing-page--get-started' },
	                        props.title
	                    ),
	                    _react2['default'].createElement(
	                        'h4',
	                        { className: 'm-marketing-page--subheader', style: { maxWidth: 1100 } },
	                        props.subtitle
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'row l-padding-b-30' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'small-12 columns text-center' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-marketing-page--button-inline' },
	                        _react2['default'].createElement(_signupOrLoginButton2['default'], _extends({}, this.signupOrLoginButtonProps(), props))
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-marketing-page--button-inline', id: 'set-up-a-demo-link' },
	                        _react2['default'].createElement(_button2['default'], _extends({}, this.secondButtonProps(), props))
	                    )
	                )
	            )
	        );
	    }
	});

/***/ },
/* 1214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = _react2['default'].createClass({
	    displayName: 'API User Images',
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            apiUsersHeaderText: 'LOOK WHO\'S USING HELLOSIGN'
	        };
	    },
	    renderImages: function renderImages() {
	        var imageData = this.props.apiUsersImageData;
	        return imageData.map(function (data, index) {
	            var imageProps = {
	                className: 'l-vertical-align',
	                src: data.imageUrl,
	                height: data.style.height,
	                width: data.style.width
	            };
	            return _react2['default'].createElement(
	                'li',
	                { className: 'm-feature-grid--list-item small-text-center', key: index },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-feature-grid--item-image-wrapper' },
	                    _react2['default'].createElement('img', imageProps)
	                )
	            );
	        });
	    },
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	                'div',
	                { className: 'small-12 small-centered small-text-center columns' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'l-padding-b-10' },
	                    _react2['default'].createElement(
	                        'h6',
	                        { className: 'm-marketing-page--subheader-small c-ashen', style: { fontSize: 18 } },
	                        this.props.apiUsersHeaderText
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'bg-plume m-feature-grid m-hs-companies--grid m-hs-companies--api--grid medium-12 columns' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'small-text-center' },
	                        _react2['default'].createElement(
	                            'ul',
	                            { className: 'm-feature-grid--list-item-group small-block-grid-2 medium-block-grid-6' },
	                            this.renderImages()
	                        )
	                    )
	                )
	            )
	        );
	    }
	});

/***/ },
/* 1215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = _react2['default'].createClass({
	    displayName: 'Embedded Tweets',
	
	    defaultProps: function defaultProps() {
	        return {
	            embeddedTweetsHeaderText: 'HAPPY TWEETS FROM HAPPY USERS'
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        var node = _reactDom2['default'].findDOMNode(this);
	        var twitterScript = document.createElement('script');
	        twitterScript.src = '//platform.twitter.com/widgets.js';
	        twitterScript.charset = 'utf-8';
	        twitterScript.async = true;
	        node.appendChild(twitterScript);
	    },
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	                'div',
	                { className: 'small-12 small-centered small-text-center columns' },
	                _react2['default'].createElement(
	                    'h6',
	                    { className: 'm-marketing-page--subheader-small c-ashen', style: { fontSize: 18 } },
	                    this.props.embeddedTweetsHeaderText
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'small-12 text-center m-marketing-page--embedded-tweets' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-marketing-page--embedded-tweet' },
	                    _react2['default'].createElement(
	                        'blockquote',
	                        { className: 'twitter-tweet', lang: 'en' },
	                        _react2['default'].createElement(
	                            'p',
	                            { lang: 'en', dir: 'ltr' },
	                            'A few of my favorite things that have up leveled my business into the modern age.',
	                            _react2['default'].createElement(
	                                'a',
	                                { href: 'https://twitter.com/AcuitySchedulin' },
	                                '@AcuitySchedulin'
	                            ),
	                            ',',
	                            _react2['default'].createElement(
	                                'a',
	                                { href: 'https://twitter.com/freshbooks' },
	                                '@freshbooks'
	                            ),
	                            ',',
	                            _react2['default'].createElement(
	                                'a',
	                                { href: 'https://twitter.com/HelloSign' },
	                                '@HelloSign'
	                            ),
	                            ',',
	                            _react2['default'].createElement(
	                                'a',
	                                { href: 'https://twitter.com/BraidCreative' },
	                                '@BraidCreative'
	                            )
	                        ),
	                        '\u2014 Jolene Park (@JolenePark)',
	                        _react2['default'].createElement(
	                            'a',
	                            { href: 'https://twitter.com/JolenePark/status/644242654952210432' },
	                            'September 16, 2015'
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-marketing-page--embedded-tweet' },
	                    _react2['default'].createElement(
	                        'blockquote',
	                        { className: 'twitter-tweet', lang: 'en' },
	                        _react2['default'].createElement(
	                            'p',
	                            { lang: 'en', dir: 'ltr' },
	                            _react2['default'].createElement(
	                                'a',
	                                { href: 'https://twitter.com/HelloSign' },
	                                '@HelloSign'
	                            ),
	                            'has finally helped me get my contract game on track! Now I\'ve got your signature.',
	                            _react2['default'].createElement(
	                                'a',
	                                { href: 'http://t.co/EewBKaXZCX' },
	                                'http://t.co/EewBKaXZCX'
	                            ),
	                            _react2['default'].createElement(
	                                'a',
	                                { href: 'https://twitter.com/hashtag/business?src=hash' },
	                                '#business'
	                            )
	                        ),
	                        '\u2014 Melissa Carter (@wcornercreative)',
	                        _react2['default'].createElement(
	                            'a',
	                            { href: 'https://twitter.com/wcornercreative/status/638107795896844290' },
	                            'August 30, 2015'
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-marketing-page--embedded-tweet' },
	                    _react2['default'].createElement(
	                        'blockquote',
	                        { className: 'twitter-tweet', lang: 'en' },
	                        _react2['default'].createElement(
	                            'p',
	                            { lang: 'en', dir: 'ltr' },
	                            _react2['default'].createElement(
	                                'a',
	                                { href: 'https://twitter.com/HelloSign' },
	                                '@HelloSign'
	                            ),
	                            ' You\'re brilliant.'
	                        ),
	                        '\u2014 Gloria Steinberg (@iprookie)',
	                        _react2['default'].createElement(
	                            'a',
	                            { href: 'https://twitter.com/iprookie/status/641273263092572160' },
	                            'September 8, 2015'
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-marketing-page--embedded-tweet' },
	                    _react2['default'].createElement(
	                        'blockquote',
	                        { className: 'twitter-tweet', lang: 'en' },
	                        _react2['default'].createElement(
	                            'p',
	                            { lang: 'en', dir: 'ltr' },
	                            'Fast, Secure, and Legally Binding eSignatures for Business',
	                            _react2['default'].createElement(
	                                'a',
	                                { href: 'https://t.co/yZG4FoIFkR' },
	                                'https://t.co/yZG4FoIFkR'
	                            )
	                        ),
	                        '\u2014 John Wojewoda (@D_digital_dog)',
	                        _react2['default'].createElement(
	                            'a',
	                            { href: 'https://twitter.com/D_digital_dog/status/637269988160749568' },
	                            'August 28, 2015'
	                        )
	                    )
	                )
	            )
	        );
	    }
	});

/***/ },
/* 1216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _titleSection = __webpack_require__(1209);
	
	var _titleSection2 = _interopRequireDefault(_titleSection);
	
	var _bodySection = __webpack_require__(1211);
	
	var _bodySection2 = _interopRequireDefault(_bodySection);
	
	var _ctaSection = __webpack_require__(1212);
	
	var _ctaSection2 = _interopRequireDefault(_ctaSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = _react2['default'].createClass({
	    displayName: 'Automate Paperwork SEO Page',
	
	    renderTitleSection: function renderTitleSection() {
	        var titleSectionProps = {
	            title: 'Automate Paperwork with eSignatures',
	            subtitle: 'Ready to start automating your paperwork with eSignatures?',
	            buttonText: 'SIGN UP FREE'
	        };
	        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
	    },
	    renderBodySection: function renderBodySection() {
	        var headerClass = 'm-marketing-page--header';
	        var listClass = 'm-marketing-page--list';
	        return _react2['default'].createElement(
	            _bodySection2['default'],
	            null,
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'What is HelloSign?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                _react2['default'].createElement(
	                    'a',
	                    { href: 'http://www.hellosign.com', target: '_blank', rel: 'noopener noreferrer' },
	                    'HelloSign'
	                ),
	                ' provides fast, secure, and legally-binding eSignatures. Our app is available for use on your desktop, your tablet, or any of your mobile devices.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'You can use HelloSign to send eSignature requests, track the signing status of any document, and format your online paperwork efficiently and accurately. But most importantly, you can use HelloSign to automate paperwork and save time and valuable resources.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Let\u2019s dive a little deeper...'
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'How can I use HelloSign to automate my workflow?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'HelloSign provides an easy way to make signing documents less time-consuming and mentally straining.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Here are a few ways eSignatures can be used to automate paperwork flows:'
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: listClass },
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Send signature requests via your email and receive automatic signature notifications.'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Create document templates so you don\u2019t have to reformat your frequently used documents.'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Autofill documents with information from a CRM. For an example of CRM data merging, check out our ',
	                    _react2['default'].createElement(
	                        'a',
	                        {
	                            href: 'https://faq.hellosign.com/hc/en-us/articles/212164958-Autofill-HelloSign-Templates-With-a-HubSpot-CRM-Contact-s-Info',
	                            target: '_blank', rel: 'noopener noreferrer' },
	                        'HubSpot CRM integration FAQ.'
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'HelloSign also works with other commonly used applications to make signing in whatever program you\u2019re in as simple as possible. We\u2019re happy to integrate with companies like ',
	                _react2['default'].createElement(
	                    'a',
	                    {
	                        href: 'http://hellosign.com/gmail',
	                        target: '_blank', rel: 'noopener noreferrer' },
	                    'Google'
	                ),
	                ', ',
	                _react2['default'].createElement(
	                    'a',
	                    {
	                        href: 'http://blog.hellosign.com/dropbox/',
	                        target: '_blank', rel: 'noopener noreferrer' },
	                    'Dropbox'
	                ),
	                ', and ',
	                _react2['default'].createElement(
	                    'a',
	                    {
	                        href: 'http://hellosign.com/slack', target: '_blank', rel: 'noopener noreferrer' },
	                    'Slack'
	                ),
	                '(to name a few).'
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'Why is paperwork automation important?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Imagine that you need to get an important document signed by the end of the day, but the stakeholder is out of the office. The traditional way of signing paper would require you to print the document, scan it over to them, and then wait for your partner print, sign, and fax back to you.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Now imagine if you could just send the document to your partner via email. They could open the doc and sign directly in their email account. You\u2019d get a notification when they\u2019ve signed and the completed form would automatically download to your account. This saves hours of admin work and reduces unnecessary back and forth.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'eSignatures simplify the signing process.'
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'Are eSignatures legal?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Yes, eSignatures are considered a legal form of signature by all fifty states in the US and most other countries.  ',
	                _react2['default'].createElement(
	                    'a',
	                    {
	                        href: 'http://blog.hellosign.com/esignatures-legal-handwritten-signatures/',
	                        target: '_blank', rel: 'noopener noreferrer' },
	                    'You can learn more about the legality of eSignatures here'
	                ),
	                '.  HelloSign signatures are secure and protected on all fronts. Here are just a few of the security checkpoints:'
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: listClass },
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Secure data storage'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'SSL hosting'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Audit-trails with time stamps'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Features like two-factor authentication'
	                )
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                _react2['default'].createElement(
	                    'a',
	                    { href: 'https://www.hellosign.com/info/security',
	                        target: '_blank', rel: 'noopener noreferrer' },
	                    'Learn more about the security of HelloSign eSignatures here.'
	                )
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'What industries are using HelloSign?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Most industries that deal with paperwork in some way or form have taken their paperwork online. Whether the majority of your documents are internal (like onboarding paperwork) or external (sales contracts), there\u2019s growing need to make the paperwork process as simple and seamless as possible.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Here are just a few examples of industries who have benefitted from taking their paperwork online:'
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: listClass },
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Real estate'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Insurance'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Sales'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'HR'
	                )
	            )
	        );
	    },
	    renderCTASection: function renderCTASection() {
	        var ctaSectionProps = {
	            title: 'Get Started',
	            subtitle: 'It\’s easy to start automating paperwork with HelloSign. Simply link your Google account to set up a free HelloSign plan and  start sending eSignature requests in minutes. Unlimited documents are included in any Pro and above plan.',
	            signupButtonText: 'CREATE A FREE HELLOSIGN ACCOUNT',
	            signupButtonUrl: this.props.homeUrl,
	            secondButtonText: 'SEE PRO PLANS',
	            secondButtonUrl: this.props.pricingUrl
	        };
	        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
	    },
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            null,
	            this.renderTitleSection(),
	            this.renderBodySection(),
	            this.renderCTASection()
	        );
	    }
	});

/***/ },
/* 1217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _titleSection = __webpack_require__(1209);
	
	var _titleSection2 = _interopRequireDefault(_titleSection);
	
	var _bodySection = __webpack_require__(1211);
	
	var _bodySection2 = _interopRequireDefault(_bodySection);
	
	var _ctaSection = __webpack_require__(1212);
	
	var _ctaSection2 = _interopRequireDefault(_ctaSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = _react2['default'].createClass({
	    displayName: 'Automate Workflow SEO Page',
	
	    renderTitleSection: function renderTitleSection() {
	        var titleSectionProps = {
	            title: 'Using Online Digital Signatures to Sign Documents',
	            subtitle: 'Create a HelloSign account to start signing now.',
	            buttonText: 'Create My Free Account!'
	        };
	        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
	    },
	    renderBodySection: function renderBodySection() {
	        var headerClass = 'm-marketing-page--header';
	        var listClass = 'm-marketing-page--list';
	        return _react2['default'].createElement(
	            _bodySection2['default'],
	            null,
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'Can I use HelloSign to automate my paperwork?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Yes! HelloSign enables users to automate paperwork and workflows through features like our automatic email reminders and the \u201CInsert Everywhere\u201D option which helps completes long paperwork quickly.  Features like these make it easy to follow-up on paperwork and streamline the signing process.'
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'Why automate a workflow?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Imagine the next document that you need to get signed. Have one in mind? Traditionally, it might take you one or two days to get the signature you need. It\u2019d likely require printing, signing, and faxing. By automating the paperwork flow with eSignatures, you can shrink the signing process down to just a few minutes and clicks.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Not only does automating your workflow save you time and paper, it saves productive hours and resources.'
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'What kind of workflows can I streamline using eSignatures?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'All different types of workflows can be streamlined using eSignatures. For example:'
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: listClass },
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Real estate agents can close deals onsite by having their clients sign paperwork on tablets or other mobile devices.'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Schools can automate the registration process by having their students sign online applications with legally-binding eSignatures.'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Sales teams seal can contracts faster by merging data from their CRM systems into online document templates. Psst\u2026 ',
	                    _react2['default'].createElement(
	                        'a',
	                        {
	                            href: 'http://blog.hellosign.com/hellosign-and-hubspot-join-forces/',
	                            target: '_blank', rel: 'noopener noreferrer' },
	                        'Check out how users are using the HelloSign + HubSpot integration to automate their sales document workflow'
	                    ),
	                    '.'
	                )
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'That\u2019s not all! You can ',
	                _react2['default'].createElement(
	                    'a',
	                    { target: '_blank', rel: 'noopener noreferrer',
	                        href: 'http://blog.hellosign.com/category/general/customer-stories/' },
	                    'read more about the different use cases here'
	                ),
	                '.'
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'How do HelloSign electronic signatures work?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'HelloSign makes it easy to electronically sign documents, send signature requests to others, and track where your documents are at all times. Here are just of few of the features that make it easy to automate your workflow:'
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: listClass },
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        'Automatic email reminders.'
	                    ),
	                    ' You\u2019ll get a notification each and every time someone signs your document. This removes the need keep track of each eSignature and the possibility of misplaced documents.'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        'Audit trails.'
	                    ),
	                    ' Each signing activity is recorded for each document. These audit trails help you to automatically store important signer information in one location.'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        '\u201CInsert Everywhere\u201D option.'
	                    ),
	                    ' When signing a lengthy document, you may have multiple spots for signature and initials. The \u201CInsert Everywhere\u201D option makes it possible for signers to automate the signing process by inserting their signature into all the required signature fields. Learn more about this feature and our signing experience here.  ',
	                    _react2['default'].createElement(
	                        'a',
	                        { target: '_blank', rel: 'noopener noreferrer',
	                            href: 'http://blog.hellosign.com/new-signer-experience/' },
	                        'Learn more about this feature and our signing experience here.'
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'What are some other ways to use HelloSign?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'You can enable some of our partner integrations for an even smoother document workflow. Want to sign from your email account? No problem. Sign a document stored in Dropbox? A-OK.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Here are just a few examples of our favorite integrations:'
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: listClass },
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Google (including ',
	                    _react2['default'].createElement(
	                        'a',
	                        { href: 'https://www.hellosign.com/gmail',
	                            target: '_blank', rel: 'noopener noreferrer' },
	                        'Gmail'
	                    ),
	                    ', ',
	                    _react2['default'].createElement(
	                        'a',
	                        { href: 'https://www.hellosign.com/googledrive',
	                            target: '_blank', rel: 'noopener noreferrer' },
	                        'Google Drive'
	                    ),
	                    ', and ',
	                    _react2['default'].createElement(
	                        'a',
	                        {
	                            href: 'https://www.hellosign.com/google-docs-add-on', target: '_blank', rel: 'noopener noreferrer' },
	                        'Google Docs'
	                    ),
	                    ')'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'a',
	                        { href: 'http://blog.hellosign.com/hellosign-integrates-with-evernote/',
	                            target: '_blank', rel: 'noopener noreferrer' },
	                        'Evernote'
	                    )
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'a',
	                        { href: 'http://blog.hellosign.com/dropbox/', target: '_blank', rel: 'noopener noreferrer' },
	                        'Dropbox'
	                    )
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'a',
	                        { href: 'http://blog.hellosign.com/hellosign-launches-integration-with-slack/',
	                            target: '_blank', rel: 'noopener noreferrer' },
	                        'Slack'
	                    )
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Zapier'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'a',
	                        { href: 'http://blog.hellosign.com/hellosign-and-hubspot-join-forces/',
	                            target: '_blank', rel: 'noopener noreferrer' },
	                        'HubSpot CRM'
	                    )
	                )
	            )
	        );
	    },
	    renderCTASection: function renderCTASection() {
	        var ctaSectionProps = {
	            title: 'Get Started',
	            subtitle: 'Document automation reduces loss of time, loss of resources, and loss of mental bandwidth. Gain back the loss by automating! We’re happy to get you  started.',
	            signupButtonText: 'CREATE A FREE HELLOSIGN ACCOUNT',
	            signupButtonUrl: this.props.homeUrl,
	            secondButtonText: 'SEE PRO PLANS',
	            secondButtonUrl: this.props.pricingUrl
	        };
	        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
	    },
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            null,
	            this.renderTitleSection(),
	            this.renderBodySection(),
	            this.renderCTASection()
	        );
	    }
	});

/***/ },
/* 1218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _titleSection = __webpack_require__(1209);
	
	var _titleSection2 = _interopRequireDefault(_titleSection);
	
	var _bodySection = __webpack_require__(1211);
	
	var _bodySection2 = _interopRequireDefault(_bodySection);
	
	var _ctaSection = __webpack_require__(1212);
	
	var _ctaSection2 = _interopRequireDefault(_ctaSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = _react2['default'].createClass({
	    displayName: 'Online Digital Signatures SEO Page',
	
	    renderTitleSection: function renderTitleSection() {
	        var titleSectionProps = {
	            title: 'Using Online Digital Signatures to Sign Documents',
	            subtitle: 'Create a HelloSign account to start signing now.',
	            buttonText: 'CREATE MY FREE ACCOUNT!'
	        };
	        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
	    },
	    renderBodySection: function renderBodySection() {
	        var headerClass = 'm-marketing-page--header';
	        var listClass = 'm-marketing-page--list';
	        return _react2['default'].createElement(
	            _bodySection2['default'],
	            null,
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'What is an online digital signatures?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'A digital signature refers to a set of algorithms and encryption protections used to determine the authenticity of a document or software. An electronic signature is an online sign or symbol that indicates a singer\u2019s intent to sign a document. HelloSign provides legally-binding, online electronic signatures for individuals and teams.'
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'How can I use online signatures to sign documents?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'It\u2019s easy to start signing documents using electronic signatures. By creating a HelloSign account, you\u2019ll have access to tools that allow you to format your document, sign documents in your gmail account, and create reusable templates. Take a look at our pricing page to see the plan-by-plan breakdown of features offered.'
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                ' What are some of the benefits of using online signatures?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Besides making it simple to sign a document online, there are quite a few benefits to incorporating HelloSign into your workflow. Here are just a few:'
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: listClass },
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        'Efficiency.'
	                    ),
	                    '  Once you take your paperwork online, you\u2019ll never waste time organizing paper documents or chasing down paper contracts in the office.  Users can sign documents entirely online with a few quick clicks.'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        'Mobility.'
	                    ),
	                    ' The HelloSign signer experience was designed to make it easy to sign contracts from anywhere, at anytime. Signers can easily access documents for signature using their tablet or mobile phone.'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        'Security.'
	                    ),
	                    ' HelloSign\u2019s online signatures are protected by bank-level security measures. Features like audit trails and two-factor authentication ensure you always know what\u2019s happening with your documents.'
	                )
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'How is HelloSign different from other free eSignature apps?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Since day one, we\u2019ve been focused on creating the very best signer experience in the eSignature industry. Every feature we\u2019ve build and every update we\u2019ve release has been guided by this dedication. We offer a clean and user-friendly design while providing top-notch security and support to our users.'
	            )
	        );
	    },
	    renderCTASection: function renderCTASection() {
	        var ctaSectionProps = {
	            title: 'Get Started',
	            subtitle: 'Set up your online digital signatures today by activating a HelloSign account. It only takes a few clicks and you’re ready to start signing in minutes.',
	            signupButtonText: 'CREATE A HELLOSIGN ACCOUNT',
	            signupButtonUrl: this.props.homeUrl,
	            secondButtonText: 'SEE PRO PLANS',
	            secondButtonUrl: this.props.pricingUrl
	        };
	        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
	    },
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            null,
	            this.renderTitleSection(),
	            this.renderBodySection(),
	            this.renderCTASection()
	        );
	    }
	});

/***/ },
/* 1219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _titleSection = __webpack_require__(1209);
	
	var _titleSection2 = _interopRequireDefault(_titleSection);
	
	var _bodySection = __webpack_require__(1211);
	
	var _bodySection2 = _interopRequireDefault(_bodySection);
	
	var _ctaSection = __webpack_require__(1212);
	
	var _ctaSection2 = _interopRequireDefault(_ctaSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = _react2['default'].createClass({
	    displayName: 'Online Contract SEO Page',
	
	    renderTitleSection: function renderTitleSection() {
	        var titleSectionProps = {
	            title: 'Sign Online Contracts',
	            subtitle: 'Ready to starting signing? Create a free account to send your first signature request.',
	            buttonText: 'CREATE MY ACCOUNT'
	        };
	        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
	    },
	    renderBodySection: function renderBodySection() {
	        var headerClass = 'm-marketing-page--header';
	        var listClass = 'm-marketing-page--list';
	        return _react2['default'].createElement(
	            _bodySection2['default'],
	            null,
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'How can I sign online contracts with HelloSign?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'HelloSign eSignatures can be used to sign all types of contracts, from informal agreements to enterprise sales deals. Our electronic signatures remove the need for printing, signing, scanning, and faxing, making it simple to sign a contract online at any time.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Here are just a few examples of contracts that are signed using eSignatures:'
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: listClass },
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Sales contracts'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Freelance contracts'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Real estate leases'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'And more!'
	                )
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'Is it legal to sign online contracts?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Yes! Electronic signatures are a legally-binding and federally protected way to sign online contracts and documents. eSignatures have been recognized in the USA since 2000 under the ESIGN Act. Internationally, eSignatures are protected under country and region specific laws including the Electronic Signatures Directive in the EU.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'For more information about what documents are legal, you can check out our blog post on ',
	                _react2['default'].createElement(
	                    'a',
	                    {
	                        href: 'http://blog.hellosign.com/esignatures-legal-handwritten-signatures/',
	                        target: '_blank', rel: 'noopener noreferrer' },
	                    'eSignature legality here'
	                )
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'How does HelloSign work?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'HelloSign is a desktop and device-friendly app that gives you the power to format online contracts with text fields, request electronic signatures for online contracts, keep a detailed audit-trail for every document, and securely store signed documents in your account. We provide technology that complies with current eSignature law and standards.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'We\u2019ve been around since 2010 and have grown tremendously over the past few years!'
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'What does an online contract signing flow look like?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'You can start signing online contracts soon as you create a HelloSign account. Here\u2019s a peek at what a signing flow looks like:'
	            ),
	            _react2['default'].createElement(
	                'ol',
	                null,
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Upload the sales contract you\u2019d like to sign or send.'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Use text boxes, signature boxes, or date boxes to format the appropriate fields in your document.'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Enter in recipient contact info (email) and add a personal message to recipients. '
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Click "Request Signature."'
	                )
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Once you\u2019ve sent your signature request, you\u2019ll receive automatic email reminders until the document has been signed. These reminders make it easy to keep track of any online contract you have out for signature so you don\u2019t lose a deal or a document in the cracks.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Bonus: All HelloSign\u2019s signing flows feature a device-optimized signer experience, so you can sign easily from your mobile phone or tablet.'
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'What other features are useful for someone wanting to send or sign online contracts?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'In addition to the basic features of HelloSign, there are other key features for anyone looking to sign an online contract. These features were all created to make it easier and more efficient to organize signing order and flow of a contract:'
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: listClass },
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        'Signer permissions.'
	                    ),
	                    ' Two-factor authentication is a protection tool that requires a signer to enter a unique code before accessing your document. This is particularly useful for highly-sensitive docs!'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        'Signer order.'
	                    ),
	                    ' Got more than one person signing a doc? You can assign a signing order to make sure the right fields are filled out in the right order.'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        'Data validation.'
	                    ),
	                    ' To protect against signer typos, you can set rules for your text fields. For example, you can set a \u201Cnumbers only\u201D rule for a phone number text field. A signer will receive an error if they enter in characters other than a number.'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        'Templates.'
	                    ),
	                    ' This features allows you you create a reusable template for your frequently used documents. You just have to format the document once, save a template, and then you can access the formatting again and again!'
	                )
	            )
	        );
	    },
	    renderCTASection: function renderCTASection() {
	        var ctaSectionProps = {
	            title: 'Get Started',
	            subtitle: 'It\'s easy to start signing your online contracts! Click below to set up your free account now or click on “See Plans” to see options for unlimited documents and templates.',
	            signupButtonText: 'CREATE A HELLOSIGN ACCOUNT',
	            signupButtonUrl: this.props.homeUrl,
	            secondButtonText: 'SEE PRO PLANS',
	            secondButtonUrl: this.props.pricingUrl
	        };
	        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
	    },
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            null,
	            this.renderTitleSection(),
	            this.renderBodySection(),
	            this.renderCTASection()
	        );
	    }
	});

/***/ },
/* 1220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(304);
	var TitleSection = __webpack_require__(1209);
	var BodySection = __webpack_require__(1211);
	var CTASection = __webpack_require__(1212);
	
	module.exports = React.createClass({
	    displayName: 'Free Esignature Tool SEO Page',
	
	    renderTitleSection: function renderTitleSection() {
	        var titleSectionProps = {
	            title: 'Free eSignature Tool',
	            subtitle: 'It\'s simple to start signing for free! Create your HelloSign account and start signing.',
	            buttonText: 'SIGN ME UP!'
	        };
	        return React.createElement(TitleSection, _extends({}, titleSectionProps, this.props));
	    },
	    renderBodySection: function renderBodySection() {
	        var headerClass = 'm-marketing-page--header';
	        return React.createElement(
	            BodySection,
	            null,
	            React.createElement(
	                'h2',
	                { className: headerClass },
	                'What is HelloSign?'
	            ),
	            React.createElement(
	                'p',
	                null,
	                'HelloSign is a desktop and device-friendly app allows you to complete paperwork online. Our technology is compliant with current eSignature laws and our bank-level security ensures a secure way to sign your paperwork online. We\u2019ve been around since 2010 and have been growing fast over the past few years!'
	            ),
	            React.createElement(
	                'h2',
	                { className: headerClass },
	                'How many free documents do I get per month with HelloSign?'
	            ),
	            React.createElement(
	                'p',
	                null,
	                'You get 3 free documents per month when you sign up for the free HelloSign plan. Your account is automatically refilled each month. Unused documents don\u2019t rollover .'
	            ),
	            React.createElement(
	                'h2',
	                { className: headerClass },
	                'What\u2019s included in the next plan up?'
	            ),
	            React.createElement(
	                'p',
	                null,
	                'Any Pro plan or above includes unlimited documents and access to HelloSign templates. You\u2019ll also have access to ',
	                React.createElement(
	                    'a',
	                    {
	                        href: 'https://www.hellosign.com/info/demo-data-validation',
	                        target: '_blank', rel: 'noopener noreferrer' },
	                    'data validation'
	                ),
	                ', a tool that helps you to prevent signer error by setting rules for your text fields. There are also plans for teams for cross-team document tracking and to make sure everyone on your team is always sending out the latest version.'
	            ),
	            React.createElement(
	                'p',
	                null,
	                'You can learn more about the plans by ',
	                React.createElement(
	                    'a',
	                    {
	                        href: 'https://app.hellosign.com/info/pricing', target: '_blank', rel: 'noopener noreferrer' },
	                    'visiting the pricing plan here.'
	                )
	            ),
	            React.createElement(
	                'h2',
	                { className: headerClass },
	                'Is it legal to sign documents online using HelloSign?'
	            ),
	            React.createElement(
	                'p',
	                null,
	                'Yes! It\u2019s legal to sign documents online using HelloSign\u2019s free eSignature tool. In fact, it\u2019s also a more secure way to keep track of your documents. Audit trails are attached to each document giving you a clear look at the journey of your doc. Audit trails log each time a person interacts with a document and timestamps these events.'
	            ),
	            React.createElement(
	                'h2',
	                { className: headerClass },
	                'How do I sign documents online?'
	            ),
	            React.createElement(
	                'p',
	                null,
	                'It\u2019s easy to start signing with HelloSign! You can create a free account by linking your Google login or entering in your email here. Once you\u2019ve created your free account, you\u2019re ready to start sending. Simply upload the document you\u2019d like signed, format it using signature or text fields, and send the signature request! You can also upload documents sent to you that require a signature and insert your own signature.'
	            )
	        );
	    },
	    renderCTASection: function renderCTASection() {
	        var ctaSectionProps = {
	            title: 'Get Started',
	            subtitle: 'Whatcha waiting for? Let’s get you signing!',
	            signupButtonText: 'CREATE A HELLOSIGN ACCOUNT',
	            signupButtonUrl: this.props.homeUrl,
	            secondButtonText: 'SEE PRO PLANS',
	            secondButtonUrl: this.props.pricingUrl
	        };
	        return React.createElement(CTASection, _extends({}, ctaSectionProps, this.props));
	    },
	    render: function render() {
	        return React.createElement(
	            'div',
	            null,
	            this.renderTitleSection(),
	            this.renderBodySection(),
	            this.renderCTASection()
	        );
	    }
	});

/***/ },
/* 1221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _titleSection = __webpack_require__(1209);
	
	var _titleSection2 = _interopRequireDefault(_titleSection);
	
	var _bodySection = __webpack_require__(1211);
	
	var _bodySection2 = _interopRequireDefault(_bodySection);
	
	var _ctaSection = __webpack_require__(1212);
	
	var _ctaSection2 = _interopRequireDefault(_ctaSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = _react2['default'].createClass({
	    displayName: 'Sign Documents Electronically SEO Page',
	
	    renderTitleSection: function renderTitleSection() {
	        var titleSectionProps = {
	            title: 'Sign Documents Electronically',
	            subtitle: 'It’s easy to get started signing electronically! Create a free HelloSign account to send and sign your first document. ',
	            buttonText: 'TRY FOR FREE'
	        };
	        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
	    },
	    renderBodySection: function renderBodySection() {
	        var headerClass = 'm-marketing-page--header';
	        var listClass = 'm-marketing-page--list';
	        return _react2['default'].createElement(
	            _bodySection2['default'],
	            null,
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'How do I create a signature to sign documents electronically?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'There are a few ways you or your signers can create a signature.'
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: listClass },
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        'Use your finger to draw a signature.'
	                    ),
	                    ' You can sign documents on any touchscreen device by using your finger or a stylus. This is a nice option since it most closely mimics the style of signing with pen and paper without the need for printing.'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        'Upload an image of your signature.'
	                    ),
	                    ' Upload or scan a picture of your signature and we\u2019ll turn it into a .png image. It overlays neatly on top of the signature line on your document.'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        'Draw your signature using a mouse.'
	                    ),
	                    ' Use your mouse to draw a signature using your cursor.'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        'Type in your signature.'
	                    ),
	                    ' Choose one of our fonts that most closely matches your signature.'
	                )
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'Is it safe to sign documents electronically?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Yep! It\u2019s safe to sign documents electronically. eSignatures have been federally protected since 2000 giving them legs in court. As for security, HelloSign offers bank level protection to ensure that your information is kept safe and secure. You can ',
	                _react2['default'].createElement(
	                    'a',
	                    {
	                        href: 'http://blog.hellosign.com/esignatures-legal-handwritten-signatures/',
	                        target: '_blank', rel: 'noopener noreferrer' },
	                    'learn more about the legality of eSignatures here'
	                ),
	                ' and ',
	                _react2['default'].createElement(
	                    'a',
	                    {
	                        href: 'https://www.hellosign.com/info/security',
	                        target: '_blank', rel: 'noopener noreferrer' },
	                    'more about the security provided by HelloSign here.'
	                )
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'What kinds of documents can I sign electronically?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'You can sign all sorts of documents electronically , from offer letters to sales contracts. Here are a few examples of documents you can sign using HelloSign:'
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: listClass },
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'NDAs'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Waivers'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Real estate contracts'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Rental agreements'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Onboarding paperwork'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Vendor contracts'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'And more!'
	                )
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'What does it look like to sign a document electronically?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Signing a document electronically looks a lot like it does when you sign a document using pen and paper.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'If you\u2019re just signing a document electronically, you simply click \u201CInsert Signature\u201D and use any of the 5 ways to create your signature for the document.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'If you\u2019re formatting a document to send out for signature, you\u2019ll need to upload your document and prep it for signature using text or signature fields.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'You can insert your signature into the appropropriate field if you need to sign the document as well.'
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'What else can I do using HelloSign?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'You can use HelloSign to format paperwork online, create templates for frequently used documents, and keep track of your documents using automatic email reminders.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'A few team features that are particularly useful are data validation to protect against signer error and user permissions to keep highly sensitive documents secure.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                _react2['default'].createElement(
	                    'a',
	                    { href: 'https://www.hellosign.com/info/tour',
	                        target: '_blank', rel: 'noopener noreferrer' },
	                    'Learn more about what you can do with HelloSign here.'
	                )
	            )
	        );
	    },
	    renderCTASection: function renderCTASection() {
	        var ctaSectionProps = {
	            title: 'Get Started',
	            subtitle: 'Start signing your documents electronically! It’s simple to get set up with a free HelloSign account. For higher volume plans (including unlimited documents), visit our pro plan page.',
	            signupButtonText: 'CREATE A HELLOSIGN ACCOUNT',
	            signupButtonUrl: this.props.homeUrl,
	            secondButtonText: 'SEE PRO PLANS',
	            secondButtonUrl: this.props.pricingUrl
	        };
	        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
	    },
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            null,
	            this.renderTitleSection(),
	            this.renderBodySection(),
	            this.renderCTASection()
	        );
	    }
	});

/***/ },
/* 1222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _titleSection = __webpack_require__(1209);
	
	var _titleSection2 = _interopRequireDefault(_titleSection);
	
	var _bodySection = __webpack_require__(1211);
	
	var _bodySection2 = _interopRequireDefault(_bodySection);
	
	var _ctaSection = __webpack_require__(1212);
	
	var _ctaSection2 = _interopRequireDefault(_ctaSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = _react2['default'].createClass({
	    displayName: 'How Create Electronic Signature SEO Page',
	
	    renderTitleSection: function renderTitleSection() {
	        var titleSectionProps = {
	            title: 'How Do I Create An Electronic Signature?',
	            subtitle: 'Ready to jump in and start signing?',
	            buttonText: 'CREATE YOUR FREE ACCOUNT'
	        };
	        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
	    },
	    renderBodySection: function renderBodySection() {
	        var headerClass = 'm-marketing-page--header';
	        var listClass = 'm-marketing-page--list';
	        return _react2['default'].createElement(
	            _bodySection2['default'],
	            null,
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'How do I create an electronic signature?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'You can create your electronic signature in a few different ways. Each signature takes only a few clicks or swipes and will be stored in your HelloSign account for future signing. Here are your options:'
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: listClass },
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        'Draw your signature using your finger or a stylus.'
	                    ),
	                    ' If you have access to a touchscreen, you can use your finger to create an electronic signature directly in your document. This is particularly helpful for when you\u2019re signing on a mobile device or tablet!'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        'Upload an image of your signature.'
	                    ),
	                    ' Use your phone or camera to take a picture of your paper signature. Once it\u2019s uploaded into your HelloSign account, it will be turned into a .png file that overlays neatly over the signature line in your document.'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        'Use your cursor to draw your signature.'
	                    ),
	                    ' Using your mouse or your touchpad, you can drag your cursor along the signature line to create a unique electronic signature.'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        'Use your keyboard to type in your signature.'
	                    ),
	                    ' This is the easiest way to create your electronic signature. Once you\u2019ve typed in your name, you can select a font that best matches your paper signature.'
	                )
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'Is an electronic signature as legal as a paper signature?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Yes! Electronic signatures are federally protected by the ESIGN Act of 2000. They\u2019re also protected on a statewide basis by the UETA Act. Internationally, eSignatures are protected by various acts and legislations. We have customers using HelloSign in Australia, the EU, and more!'
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'Is it secure to use electronic signatures to sign documents?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Yep! It\u2019s absolutely secure as long as you\u2019re working with a verified and secure eSignature provider. HelloSign offers bank-level security to ensure that your information and documents remain protected. This includes:'
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: listClass },
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Hosting in a state-of-the-art SAS70 Type II, SSAE 16 facility that has achieved ISO 27001 certification.'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'A connection that\u2019s encrypted using SSL (Secure Sockets Layer). That\u2019s the same level of security at most leading banks!'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Documents are stored and encrypted at rest using AES - 256 bit encryption.'
	                )
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'Do I have to electronically sign documents in my HelloSign account?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'HelloSign integrates with several other companies to make it as easy as possible to sign in whatever app you\u2019re using. Our integration partners include:'
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: listClass },
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Google (including ',
	                    _react2['default'].createElement(
	                        'a',
	                        { href: 'https://www.hellosign.com/gmail',
	                            target: '_blank', rel: 'noopener noreferrer' },
	                        'Gmail'
	                    ),
	                    ', ',
	                    _react2['default'].createElement(
	                        'a',
	                        { href: 'https://www.hellosign.com/googledrive',
	                            target: '_blank', rel: 'noopener noreferrer' },
	                        'Google Drive'
	                    ),
	                    ', and ',
	                    _react2['default'].createElement(
	                        'a',
	                        {
	                            href: 'https://www.hellosign.com/google-docs-add-on', target: '_blank', rel: 'noopener noreferrer' },
	                        'Google Docs'
	                    ),
	                    ')'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'a',
	                        { href: 'http://blog.hellosign.com/hellosign-integrates-with-evernote/',
	                            target: '_blank', rel: 'noopener noreferrer' },
	                        'Evernote'
	                    )
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'a',
	                        { href: 'http://blog.hellosign.com/dropbox/', target: '_blank', rel: 'noopener noreferrer' },
	                        'Dropbox'
	                    )
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'a',
	                        { href: 'http://blog.hellosign.com/hellosign-launches-integration-with-slack/',
	                            target: '_blank', rel: 'noopener noreferrer' },
	                        'Slack'
	                    )
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Zapier'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'a',
	                        { href: 'http://blog.hellosign.com/hellosign-and-hubspot-join-forces/',
	                            target: '_blank', rel: 'noopener noreferrer' },
	                        'HubSpot CRM'
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'You may be directed to our site to complete the signature, but you can initiate signature requests directly in the integrated apps.'
	            )
	        );
	    },
	    renderCTASection: function renderCTASection() {
	        var ctaSectionProps = {
	            title: 'Create an Electronic Signature',
	            subtitle: 'See it for yourself! Create your first electronic signature by opening a HelloSign account. You’ll get three signatures a month with our free plan and unlimited signatures with any Pro plan or above.',
	            signupButtonText: 'CREATE A HELLOSIGN ACCOUNT',
	            signupButtonUrl: this.props.homeUrl,
	            secondButtonText: 'SEE PRO PLANS',
	            secondButtonUrl: this.props.pricingUrl
	        };
	        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
	    },
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            null,
	            this.renderTitleSection(),
	            this.renderBodySection(),
	            this.renderCTASection()
	        );
	    }
	});

/***/ },
/* 1223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _titleSection = __webpack_require__(1209);
	
	var _titleSection2 = _interopRequireDefault(_titleSection);
	
	var _bodySection = __webpack_require__(1211);
	
	var _bodySection2 = _interopRequireDefault(_bodySection);
	
	var _ctaSection = __webpack_require__(1212);
	
	var _ctaSection2 = _interopRequireDefault(_ctaSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = _react2['default'].createClass({
	    displayName: 'How To Sign Online SEO Page',
	
	    renderTitleSection: function renderTitleSection() {
	        var titleSectionProps = {
	            title: 'How to Sign Online',
	            subtitle: 'Ready to start signing online? Set up your HelloSign account to create your first document.',
	            buttonText: 'TRY HELLOSIGN'
	        };
	        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
	    },
	    renderBodySection: function renderBodySection() {
	        var headerClass = 'm-marketing-page--header';
	        var listClass = 'm-marketing-page--list';
	        return _react2['default'].createElement(
	            _bodySection2['default'],
	            null,
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'What is HelloSign?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'HelloSign was created to make it easy to sign all your most important documents online. We know what a pain it is to run back and forth from the printer and scanner (if you even have one!) when completing paperwork. We also know some admin software can get complicated quickly. To solve these pain points, we focused on making a simple, sleek eSignature app that\u2019s easy to navigate.'
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'How do I Sign Documents Online?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'It\u2019s super easy to start signing online! Just create a free HelloSign account, upload your document, and format the document with a signature box in the appropriate area. Once you have a signature in place, you can either insert your own signature or send the document to another party to get their signature.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'There are a few different ways to create a signature which you can ',
	                _react2['default'].createElement(
	                    'a',
	                    {
	                        href: 'http://blog.hellosign.com/signature-maker/',
	                        target: '_blank', rel: 'noopener noreferrer' },
	                    'learn about here.'
	                )
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'What kind of documents can I sign online?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'You can sign all sorts of documents online! A few popular examples are offer letters and contracts, but it doesn\u2019t stop there. Our customers have used HelloSign to sign:'
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: listClass },
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Vendor applications'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Escrow paperwork'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Mortgage '
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Employee benefits paperwork'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Lease'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Plus more!'
	                )
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'Is it secure to sign my documents online?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Yep! HelloSign provides bank-level security to keep your information safe and secure. We also offer additional features that ensure that you always have full control over the journey of your document. These features include:'
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: listClass },
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        'Time stamped audit-trails'
	                    ),
	                    ' to give you an overview of every touchpoint of your document.'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        'User permissions'
	                    ),
	                    ' to securely share sensitive documents with included parties.'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        'Two factor authentication'
	                    ),
	                    ' as an added protection against for log-ins.'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'strong',
	                        null,
	                        'Signer order'
	                    ),
	                    ' to ensure that the person you want signing is getting the document at the right time.'
	                )
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'What types of industries use eSignatures to sign online?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'A lot! As eSignatures become the norm for signing, most industries have adopted some form of electronic signing. The cost and time savings associated with having an entirely electronic workflow are also huge! We\u2019ve had users cut the document turnaround time with their clients from over a month to less than a day.'
	            )
	        );
	    },
	    renderCTASection: function renderCTASection() {
	        var ctaSectionProps = {
	            title: 'Get Started',
	            subtitle: 'Ready to try signing online for yourself? You can sign up for a free account to test it out. For unlimited documents and templates, take a look at our pro plans.',
	            signupButtonText: 'CREATE A HELLOSIGN ACCOUNT',
	            signupButtonUrl: this.props.homeUrl,
	            secondButtonText: 'SEE PRO PLANS',
	            secondButtonUrl: this.props.pricingUrl
	        };
	        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
	    },
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            null,
	            this.renderTitleSection(),
	            this.renderBodySection(),
	            this.renderCTASection()
	        );
	    }
	});

/***/ },
/* 1224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _titleSection = __webpack_require__(1209);
	
	var _titleSection2 = _interopRequireDefault(_titleSection);
	
	var _bodySection = __webpack_require__(1211);
	
	var _bodySection2 = _interopRequireDefault(_bodySection);
	
	var _ctaSection = __webpack_require__(1212);
	
	var _ctaSection2 = _interopRequireDefault(_ctaSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = _react2['default'].createClass({
	    displayName: 'Online Signature App SEO Page',
	
	    renderTitleSection: function renderTitleSection() {
	        var titleSectionProps = {
	            title: 'Using Online Signature Apps',
	            subtitle: 'HelloSign is a free eSignature app providing a fast, simple, and secure way to sign online',
	            buttonText: 'CREATE A FREE ACCOUNT'
	        };
	        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
	    },
	    renderBodySection: function renderBodySection() {
	        var headerClass = 'm-marketing-page--header';
	        var listClass = 'm-marketing-page--list';
	        return _react2['default'].createElement(
	            _bodySection2['default'],
	            null,
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'Is HelloSign an Online Signature App?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'We sure are! HelloSign was founded in 2013 and has since helped hundreds of thousands of people safely and securely sign their documents online. You can learn a little more about what we do by visiting our ',
	                _react2['default'].createElement(
	                    'a',
	                    {
	                        href: 'https://www.hellosign.com/info/tour', target: '_blank', rel: 'noopener noreferrer' },
	                    'Tour Page.'
	                )
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'Can I use the HelloSign signature app to sign on my mobile phone?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Yes! Our online signature app is optimized for all your devices, including mobile phones. You can also use HelloSign to sign from your desktop or your tablet. Each device will give you an optimized signer experience that helps you efficiently navigate through any document you need to prepare or sign.'
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'What sets HelloSign apart as an online signature app?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'One of the biggest differentiators at HelloSign is our user-friendly interface. We know admin applications can get hairy and complicated pretty quickly. So our goal has always been to provide a tool that\u2019s both functional and easy to use! This continues to be top priority as as we add new features and integrating with new companies.'
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'What are some of your most valuable features?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Hard pressed, we\u2019d have to say some of our most valuable features include:'
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: listClass },
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Data Validation'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Automation features like \u201CInsert Signature Everywhere\u201D'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'User permissions'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'In-person signing'
	                )
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'But we have a whole squad of features that help users create their very best signing experience. You can learn about all our ',
	                _react2['default'].createElement(
	                    'a',
	                    {
	                        href: 'https://www.hellosign.com/info/tour', target: '_blank', rel: 'noopener noreferrer' },
	                    'features here'
	                ),
	                '!'
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'Does your signature app integrate with any other companies?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'We do! We\u2019ve integrated with quite a few companies over the years to bring online signing directly to the applications you use most. Since our first integration with Google, we\u2019ve integrated with companies like ',
	                _react2['default'].createElement(
	                    'a',
	                    {
	                        href: 'http://blog.hellosign.com/dropbox/',
	                        target: '_blank', rel: 'noopener noreferrer' },
	                    'Dropbox'
	                ),
	                ', ',
	                _react2['default'].createElement(
	                    'a',
	                    {
	                        href: 'http://blog.hellosign.com/hellosign-integrates-with-evernote/',
	                        target: '_blank', rel: 'noopener noreferrer' },
	                    'Evernote'
	                ),
	                ', Box, ',
	                _react2['default'].createElement(
	                    'a',
	                    {
	                        href: 'http://blog.hellosign.com/hellosign-launches-integration-with-slack/',
	                        target: '_blank', rel: 'noopener noreferrer' },
	                    'Slack'
	                ),
	                ', and the ',
	                _react2['default'].createElement(
	                    'a',
	                    {
	                        href: 'http://blog.hellosign.com/hellosign-and-hubspot-join-forces/',
	                        target: '_blank', rel: 'noopener noreferrer' },
	                    'HubSpot CRM'
	                ),
	                '.'
	            )
	        );
	    },
	    renderCTASection: function renderCTASection() {
	        var ctaSectionProps = {
	            title: 'Try The HelloSign App',
	            subtitle: 'We’d love to have you take a look! You can create a free account and start signing in under 5 minutes. If you want to take a look at some of the features included in our Pro plans, visit our plan page.',
	            signupButtonText: 'CREATE A HELLOSIGN ACCOUNT',
	            signupButtonUrl: this.props.homeUrl,
	            secondButtonText: 'SEE PRO PLANS',
	            secondButtonUrl: this.props.pricingUrl
	        };
	        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
	    },
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            null,
	            this.renderTitleSection(),
	            this.renderBodySection(),
	            this.renderCTASection()
	        );
	    }
	});

/***/ },
/* 1225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _titleSection = __webpack_require__(1209);
	
	var _titleSection2 = _interopRequireDefault(_titleSection);
	
	var _bodySection = __webpack_require__(1211);
	
	var _bodySection2 = _interopRequireDefault(_bodySection);
	
	var _ctaSection = __webpack_require__(1212);
	
	var _ctaSection2 = _interopRequireDefault(_ctaSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = _react2['default'].createClass({
	    displayName: 'Electronic Signature SEO Page',
	
	    renderTitleSection: function renderTitleSection() {
	        var titleSectionProps = {
	            title: 'HelloSign\'s Guide To Electronic Signatures',
	            subtitle: 'Jump in and try electronic signing for yourself! Click here to create your free HelloSign account.',
	            buttonText: 'LET\'S DO IT!'
	        };
	        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
	    },
	    renderBodySection: function renderBodySection() {
	        var headerClass = 'm-marketing-page--header';
	        var listClass = 'm-marketing-page--list';
	        return _react2['default'].createElement(
	            _bodySection2['default'],
	            null,
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'What is an electronic signature?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'According to the ',
	                _react2['default'].createElement(
	                    'a',
	                    {
	                        href: 'http://www.techlawjournal.com/cong106/digsig/Default.htm',
	                        target: '_blank', rel: 'noopener noreferrer' },
	                    'U.S. Federal ESIGN Act'
	                ),
	                ' passed in 2000, an electronic signature is an "electronic sound, symbol, or process, attached to or logically associated with a contract or other record and executed or adopted by a person with the intent to sign the record."'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'In layman\'s terms, an electronic signature, often referred to as an e-signature, is a person\'s electronic expression of his or her agreement to the terms of a particular document.'
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'What are electronic signatures used for?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Electronic signatures are used on every sort of document you can imagine. For instance, ',
	                _react2['default'].createElement(
	                    'a',
	                    { href: '/', target: '_blank', rel: 'noopener noreferrer' },
	                    'HelloSign'
	                ),
	                ' users use electronic signatures to:'
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: listClass },
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Esign NDAs, timesheets, and employee onboarding paperwork'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Esign sales contracts, invoices, and approve proposals'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Fill out and sign leases and other rental and housing agreements'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Electronically sign tax documents, bank forms, and insurance paperwork'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Fill out and sign permission slips, school forms, and release'
	                )
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'How do electronic signatures work with HelloSign?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'There are ',
	                _react2['default'].createElement(
	                    'a',
	                    { href: 'http://blog.hellosign.com/signature-maker',
	                        target: '_blank', rel: 'noopener noreferrer' },
	                    '4 ways to create an electronic signature'
	                ),
	                ' using HelloSign.'
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: listClass },
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Draw your signature using your computer mouse or touchpad'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Take a photo of your signature using your smartphone and upload it to HelloSign'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Type your name and select any one of our fonts to give your typed signature an authentic touch'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Sign using your finger either on our mobile app for iOS and Android, or using our in-person signing feature on the iPad'
	                )
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Once created, an electronic signature can be added to any document along with other annotations such as check marks or freeform text.'
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'text-center l-padding-t-60' },
	                _react2['default'].createElement('img', {
	                    src: __webpack_require__(1226),
	                    alt: 'Signature Modal',
	                    className: 'm-marketing-page--image-signature-modal'
	                })
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'Are electronic signatures legal?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Yes, ',
	                _react2['default'].createElement(
	                    'a',
	                    {
	                        href: 'http://blog.hellosign.com/esignatures-legal-handwritten-signatures',
	                        target: '_blank', rel: 'noopener noreferrer' },
	                    'electronic signatures are valid and legal'
	                ),
	                ' in the United States, Canada, the European Union, the UK, and many other areas of the world. View more about the legality ofelectronic signatures ',
	                _react2['default'].createElement(
	                    'a',
	                    {
	                        href: '/info/legal', target: '_blank', rel: 'noopener noreferrer' },
	                    'here'
	                ),
	                '.'
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'What are the benefits of electronic signatures?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'There are many benefits to using an electronic signature. Using electronic signatures through HelloSign you can:'
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: listClass },
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Get documents signed fast'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Sign documents from anywhere'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Collect ',
	                    _react2['default'].createElement(
	                        'a',
	                        { href: 'http://blog.hellosign.com/are-esignatures-secure',
	                            target: '_blank', rel: 'noopener noreferrer' },
	                        'secure and legally binding signatures'
	                    )
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'And ',
	                    _react2['default'].createElement(
	                        'a',
	                        { href: '/info/benefits', target: '_blank', rel: 'noopener noreferrer' },
	                        'many more'
	                    )
	                )
	            )
	        );
	    },
	    renderCTASection: function renderCTASection() {
	        var ctaSectionProps = {
	            title: 'Get started: eSign a document for free',
	            subtitle: 'Ready to dive in and try electronic signing for yourself? Want to see more?',
	            signupButtonText: 'SIGN UP FOR A HELLOSIGN ACCOUNT',
	            signupButtonUrl: this.props.homeUrl,
	            secondButtonText: 'SEE PRO PLANS',
	            secondButtonUrl: this.props.pricingUrl,
	            apiUsersHeaderText: 'OUR HAPPY USERS',
	            embeddedTweetsHeaderText: 'SOCIAL LOVE'
	        };
	        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
	    },
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            null,
	            this.renderTitleSection(),
	            this.renderBodySection(),
	            this.renderCTASection()
	        );
	    }
	});

/***/ },
/* 1226 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/00f50bcb4828bb397b220b8ba205f941.png";

/***/ },
/* 1227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _titleSection = __webpack_require__(1209);
	
	var _titleSection2 = _interopRequireDefault(_titleSection);
	
	var _bodySection = __webpack_require__(1211);
	
	var _bodySection2 = _interopRequireDefault(_bodySection);
	
	var _ctaSection = __webpack_require__(1212);
	
	var _ctaSection2 = _interopRequireDefault(_ctaSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = _react2['default'].createClass({
	    displayName: 'Digital Signature SEO Page',
	
	    renderTitleSection: function renderTitleSection() {
	        var titleSectionProps = {
	            title: 'All About Digital Signatures',
	            subtitle: 'Ready to start eSigning with HelloSign?',
	            buttonText: 'IT\'S ALWAYS FREE TO TRY!'
	        };
	        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
	    },
	    renderBodySection: function renderBodySection() {
	        var headerClass = 'm-marketing-page--header';
	        var listClass = 'm-marketing-page--list';
	        return _react2['default'].createElement(
	            _bodySection2['default'],
	            null,
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'What is a digital signature?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'A digital signature refers to a set of algorithms and encryption protections used to determine the authenticity of a document or software.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'In simpler terms, a digital signature is a complicated way to verify that a document hasn\u2019t been tampered with during transit between sender and signer.'
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'Does HelloSign provide digital signatures?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'HelloSign provides ',
	                _react2['default'].createElement(
	                    'a',
	                    { href: '/electronic-signature',
	                        target: '_blank', rel: 'noopener noreferrer' },
	                    'electronic signatures'
	                ),
	                '. HelloSign electronic signatures are legally binding and protected with bank-level security. By and large, anyone requesting or signing a document is using an electronic signature. Our security ensures that all documents are kept secure and protected. These security features include:'
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: listClass },
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Secure data storage'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'SSL hosting'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Audit-trails with time stamps'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Features like two-factor authentication'
	                )
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'You can read more about the ',
	                _react2['default'].createElement(
	                    'a',
	                    { href: '/info/security',
	                        target: '_blank', rel: 'noopener noreferrer' },
	                    'legality and security of electronic signatures here'
	                ),
	                '.'
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'How do HelloSign electronic signatures work?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'HelloSign electronic signatures allow you to legally sign documents online, send signature requests to others for signing, and track the progress of any document. Here are just some of the places you\u2019ll see electronic signatures used:'
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: listClass },
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'NDAs and release forms'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Vendor paperwork and other complicated applications'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Proposals and sales contracts'
	                )
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Happy users of HelloSign\u2019s electronic signatures include the BBB, Samsung, and Twitter.'
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'Digital signature vs. electronic signature'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'While most people use the terms interchangeably, there is a difference between the two. An electronic signature refers to a protected and legally binding online signature. A digital signature refers to a complicated method for authenticating a document.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'For the most part, people are looking for an electronic signature when they\u2019re searching for digital signatures.'
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'Who\u2019s using HelloSign signatures?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'HelloSign integrates with different companies to make signing as simple and easy as possible. We\u2019re happy to partner with:'
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: listClass },
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Google (including ',
	                    _react2['default'].createElement(
	                        'a',
	                        { href: 'https://www.hellosign.com/gmail',
	                            target: '_blank', rel: 'noopener noreferrer' },
	                        'Gmail'
	                    ),
	                    ', ',
	                    _react2['default'].createElement(
	                        'a',
	                        { href: 'https://www.hellosign.com/googledrive',
	                            target: '_blank', rel: 'noopener noreferrer' },
	                        'Google Drive'
	                    ),
	                    ', and ',
	                    _react2['default'].createElement(
	                        'a',
	                        {
	                            href: 'https://www.hellosign.com/google-docs-add-on', target: '_blank', rel: 'noopener noreferrer' },
	                        'Google Docs'
	                    ),
	                    ')'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'a',
	                        { href: 'http://blog.hellosign.com/hellosign-integrates-with-evernote/',
	                            target: '_blank', rel: 'noopener noreferrer' },
	                        'Evernote'
	                    )
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'a',
	                        { href: 'http://blog.hellosign.com/dropbox/', target: '_blank', rel: 'noopener noreferrer' },
	                        'Dropbox'
	                    )
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'a',
	                        { href: 'http://blog.hellosign.com/hellosign-launches-integration-with-slack/',
	                            target: '_blank', rel: 'noopener noreferrer' },
	                        'Slack'
	                    )
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Zapier'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'a',
	                        { href: 'http://blog.hellosign.com/hellosign-and-hubspot-join-forces/',
	                            target: '_blank', rel: 'noopener noreferrer' },
	                        'HubSpot CRM'
	                    )
	                )
	            )
	        );
	    },
	    renderCTASection: function renderCTASection() {
	        var ctaSectionProps = {
	            title: 'Get started: eSign a document for free',
	            subtitle: 'Now that you’re more familiar with electronic and digital signatures, try eSigning out for yourself! Or if you want to learn more about HelloSign eSignatures, schedule a live demo. We’ll walk you through our features and integrations.',
	            signupButtonText: 'CREATE A HELLOSIGN ACCOUNT',
	            signupButtonUrl: this.props.homeUrl,
	            secondButtonText: 'SEE PRO PLANS',
	            secondButtonUrl: this.props.pricingUrl,
	            apiUsersHeaderText: 'LOOK WHO\'S USING HELLOSIGN',
	            embeddedTweetsHeaderText: 'HAPPY TWEETS FROM HAPPY USERS'
	        };
	        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
	    },
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            null,
	            this.renderTitleSection(),
	            this.renderBodySection(),
	            this.renderCTASection()
	        );
	    }
	});

/***/ },
/* 1228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _titleSection = __webpack_require__(1209);
	
	var _titleSection2 = _interopRequireDefault(_titleSection);
	
	var _bodySection = __webpack_require__(1211);
	
	var _bodySection2 = _interopRequireDefault(_bodySection);
	
	var _ctaSection = __webpack_require__(1212);
	
	var _ctaSection2 = _interopRequireDefault(_ctaSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = _react2['default'].createClass({
	    displayName: 'eSignatures SEO Page',
	
	    renderTitleSection: function renderTitleSection() {
	        var titleSectionProps = {
	            title: 'HelloSign\'s Intro to eSignatures',
	            subtitle: 'Already an eSignature pro? Create your HelloSign account and send your first eSignature.',
	            buttonText: 'GET ESIGNING'
	        };
	        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
	    },
	    renderBodySection: function renderBodySection() {
	        var headerClass = 'm-marketing-page--header';
	        var listClass = 'm-marketing-page--list';
	        return _react2['default'].createElement(
	            _bodySection2['default'],
	            null,
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'What is an eSignature?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'According to the ',
	                _react2['default'].createElement(
	                    'a',
	                    {
	                        href: 'http://www.techlawjournal.com/cong106/digsig/Default.htm',
	                        target: '_blank', rel: 'noopener noreferrer' },
	                    'U.S. Federal ESIGN Act'
	                ),
	                ' passed in 2000, an electronic signature is an "electronic sound, symbol, or process, attached to or logically associated with a contract or other record and executed or adopted by a person with the intent to sign the record."'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'In other words, when a signer signs an online document willfully and intentionally, it\u2019s considered an eSignature. An eSignature works largely the same way as a handwritten or \u201Cwet\u201D signature.'
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'text-center l-padding-t-60' },
	                _react2['default'].createElement('img', {
	                    src: __webpack_require__(1226),
	                    alt: 'Signature Modal',
	                    className: 'm-marketing-page--image-signature-modal'
	                })
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'Are eSignatures secure?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'eSignatures have been considered a legally binding way to sign documents and paperwork since 2000 and the security of eSignatures depends in large part on the provider of your eSignatures. Here are some of the critical security checkpoints to check off before using any eSignature service:'
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: listClass },
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'SSL hosting'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Encryption at rest'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Secure data storage (HelloSign uses an SSAE 16 Certified Data Center)'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Additional security features like ',
	                    _react2['default'].createElement(
	                        'a',
	                        {
	                            href: 'http://blog.hellosign.com/esignature-two-factor-authentication',
	                            target: '_blank', rel: 'noopener noreferrer' },
	                        'two-factor authentication'
	                    ),
	                    ' and ',
	                    _react2['default'].createElement(
	                        'a',
	                        {
	                            href: 'https://faq.hellosign.com/hc/en-us/articles/205814918-What-Is-An-Audit-Trail',
	                            target: '_blank', rel: 'noopener noreferrer' },
	                        'audit trails'
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'You can learn more about HelloSign\'s security ',
	                _react2['default'].createElement(
	                    'a',
	                    { href: '/info/security',
	                        target: '_blank', rel: 'noopener noreferrer' },
	                    'here'
	                ),
	                ' and ',
	                _react2['default'].createElement(
	                    'a',
	                    {
	                        href: 'http://blog.hellosign.com/are-esignatures-secure',
	                        target: '_blank', rel: 'noopener noreferrer' },
	                    'here'
	                ),
	                '.'
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'Are eSignatures legal?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Yes! eSignatures are a legally binding and accepted form of signature in the US, Canada, the UK, and parts of the world.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'As it stands today, 47 of the 50 united states have signed the UETA. The remaining three states (Washington, New York, and Illinois) have passed their own laws regarding the legal status of eSignatures.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'You can learn more about the legality of eSignatures ',
	                _react2['default'].createElement(
	                    'a',
	                    {
	                        href: '/info/legal', target: '_blank', rel: 'noopener noreferrer' },
	                    'here'
	                ),
	                ' and ',
	                _react2['default'].createElement(
	                    'a',
	                    {
	                        href: 'http://blog.hellosign.com/esignatures-legal-handwritten-signatures',
	                        target: '_blank', rel: 'noopener noreferrer' },
	                    'here'
	                ),
	                '.'
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'Who uses eSignatures?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'eSignatures are used to sign all types of documents and paperwork, from simple one sheet agreements to complex mortgage and loan paperwork.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Here are just a few examples of how eSignatures are being used:'
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: listClass },
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Sales teams are closing deals faster by streamlining the signing process'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'HR directors using eSignatures to simplify complicated onboarding paperwork'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Real estate agents are signing housing contracts'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Schools and administrative industries are easily signing applications and releases'
	                )
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'How else are HelloSign eSignatures used?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Anyone can use HelloSign\u2019s stand alone product to sign documents or request eSignatures through our website, but many choose to use the HelloSign API to build eSignatures directly into their site.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'With the HelloSign eSignature API you can:'
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: listClass },
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Keep signers on your page by embedding eSignatures into online paperwork flows'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Customize the signer\'s experience with white-labeling'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Remove the extra step of sending signers to a third-party site to sign documents'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Automate your paperwork to sign documents faster'
	                )
	            )
	        );
	    },
	    renderCTASection: function renderCTASection() {
	        var ctaSectionProps = {
	            title: 'Ready to eSign your first document? It only takes a few minutes.',
	            subtitle: 'If you’re ready to start eSigning, set up a HelloSign account to try it out. If you want to learn more, schedule a demo and we’ll walk you through all our features.',
	            signupButtonText: 'CREATE A HELLOSIGN ACCOUNT',
	            signupButtonUrl: this.props.homeUrl,
	            secondButtonText: 'SEE PRO PLANS',
	            secondButtonUrl: this.props.pricingUrl,
	            apiUsersHeaderText: 'LOOK WHO\'S USING HELLOSIGN',
	            embeddedTweetsHeaderText: 'HAPPY TWEETS FROM HAPPY USERS'
	        };
	        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
	    },
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            null,
	            this.renderTitleSection(),
	            this.renderBodySection(),
	            this.renderCTASection()
	        );
	    }
	});

/***/ },
/* 1229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _titleSection = __webpack_require__(1209);
	
	var _titleSection2 = _interopRequireDefault(_titleSection);
	
	var _bodySection = __webpack_require__(1211);
	
	var _bodySection2 = _interopRequireDefault(_bodySection);
	
	var _ctaSection = __webpack_require__(1212);
	
	var _ctaSection2 = _interopRequireDefault(_ctaSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = _react2['default'].createClass({
	    displayName: 'ESign SEO Page',
	
	    renderTitleSection: function renderTitleSection() {
	        var titleSectionProps = {
	            title: 'eSign Basics',
	            subtitle: 'Need to eSign a document? Use HelloSign for free.',
	            buttonText: 'SIGN UP'
	        };
	        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
	    },
	    renderBodySection: function renderBodySection() {
	        var headerClass = 'm-marketing-page--header';
	        var listClass = 'm-marketing-page--list';
	        return _react2['default'].createElement(
	            _bodySection2['default'],
	            null,
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'How do I eSign a document?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'When you have a document to sign, it can be uploaded to an eSignature service, such as ',
	                _react2['default'].createElement(
	                    'a',
	                    { href: '/', target: '_blank', rel: 'noopener noreferrer' },
	                    'HelloSign'
	                ),
	                ', to generate a signature. Once the document is eSigned, you can email the document to your intended recipient. eSignatures are a legally accepted and protected form of signature. In the US, they\u2019re covered by the eSign Act.'
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'What is the ESIGN Act?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'The ESIGN Act, otherwise known as Electronic Signatures in Global and National Commerce Act, was signed in 2000 to give eSignatures the same status as written signatures.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Learn more about the ESIGN Act by ',
	                _react2['default'].createElement(
	                    'a',
	                    {
	                        href: 'http://info.hellosign.com/esignatures-cheat-sheet.html',
	                        target: '_blank', rel: 'noopener noreferrer' },
	                    'downloading our free eBook: eSignatures 101'
	                ),
	                '.'
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'What are the benefits of eSigning?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Being able to eSign a document is great for improving workflows. When you eSign a document, you eliminate the need to print the document, sign it, then scan it. Being able to eSign documents streamlines the process for completing paperwork and reduces productivity waste.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Here are some of the other ways eSignatures are beneficial:'
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: listClass },
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Faster turnaround time for completed documents and contracts'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Better security and document tracking'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Low cost'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Eliminate paper waste'
	                )
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'What are the limitations of eSigning?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'There are certain types of documentation that are not covered by the ESIGN Act (for example, adoption and divorce papers). For a list of documents that need to be signed in-person, you can ready about it in our ',
	                _react2['default'].createElement(
	                    'a',
	                    {
	                        href: 'http://blog.hellosign.com/esignatures-legal-handwritten-signatures',
	                        target: '_blank', rel: 'noopener noreferrer' },
	                    'blog post on eSignature legality'
	                ),
	                '.'
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'How do I use HelloSign to eSign?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Signing a document using HelloSign only takes a few minutes. Here are the steps to eSigning your first document:'
	            ),
	            _react2['default'].createElement(
	                'ol',
	                null,
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Create a Hellosign account.'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Choose who needs to sign (\u201CJust me\u201D, \u201CMe & Others\u201D, or \u201CJust Others\u201D).'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Upload your document.'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Sign or add signature fields.'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Send off your document to the intended recipient.'
	                )
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'For more detailed instructions, head over to our ',
	                _react2['default'].createElement(
	                    'a',
	                    {
	                        href: 'https://faq.hellosign.com/hc/en-us/categories/200353538-HelloSign-Help',
	                        target: '_blank', rel: 'noopener noreferrer' },
	                    'Help Center'
	                ),
	                ' for information on this and other features.'
	            )
	        );
	    },
	    renderCTASection: function renderCTASection() {
	        var ctaSectionProps = {
	            title: 'Get started: eSign a document for free',
	            subtitle: 'Want to try eSigning yourself? Create a free account with us (no strings attached, we promise!). Or if you’re looking for more features for your business (for example, team features, in-person signing, or signer access codes), request a demo with one of our eSignature experts.',
	            signupButtonText: 'CREATE A HELLOSIGN ACCOUNT',
	            signupButtonUrl: this.props.homeUrl,
	            secondButtonText: 'SEE PRO PLANS',
	            secondButtonUrl: this.props.pricingUrl,
	            apiUsersHeaderText: 'LOOK WHO\'S USING HELLOSIGN',
	            embeddedTweetsHeaderText: 'HAPPY TWEETS FROM HAPPY USERS'
	        };
	        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
	    },
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            null,
	            this.renderTitleSection(),
	            this.renderBodySection(),
	            this.renderCTASection()
	        );
	    }
	});

/***/ },
/* 1230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _titleSection = __webpack_require__(1209);
	
	var _titleSection2 = _interopRequireDefault(_titleSection);
	
	var _bodySection = __webpack_require__(1211);
	
	var _bodySection2 = _interopRequireDefault(_bodySection);
	
	var _ctaSection = __webpack_require__(1212);
	
	var _ctaSection2 = _interopRequireDefault(_ctaSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = _react2['default'].createClass({
	    displayName: 'PDF eSignature SEO Page',
	
	    renderTitleSection: function renderTitleSection() {
	        var titleSectionProps = {
	            title: 'Sign PDFs for Free Using HelloSign',
	            subtitle: 'Looking for a free tool to eSign a PDF? HelloSign provides legally binding and secure eSignatures for all your documents.',
	            buttonText: 'IT\'S ALWAYS FREE TO TRY!'
	        };
	        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
	    },
	    renderBodySection: function renderBodySection() {
	        var headerClass = 'm-marketing-page--header';
	        var listClass = 'm-marketing-page--list';
	        return _react2['default'].createElement(
	            _bodySection2['default'],
	            null,
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'How do you sign a PDF without printing?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'If you want to skip printing, signing, and scanning a document, you can do it all using the ',
	                _react2['default'].createElement(
	                    'a',
	                    { href: '/', target: '_blank', rel: 'noopener noreferrer' },
	                    'HelloSign'
	                ),
	                ' eSignature app.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Upload your document, sign it, and send it to the intended recipient. You also have the option to send your PDF out with a signature request if you need someone else (or several people!) to sign the document.'
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'How should you send your eSigned PDF?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'There are several ways to send an eSigned PDF. You have the following options when you use HelloSign:'
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: listClass },
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Send it directly from the eSignature app'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Download the document and attach it to an email'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Fax it using our other service, ',
	                    _react2['default'].createElement(
	                        'a',
	                        { href: 'https://www.hellofax.com',
	                            target: '_blank', rel: 'noopener noreferrer' },
	                        'HelloFax'
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'How much does it cost to use HelloSign?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'HelloSign is an eSignature app where you can sign up to 3 documents per month for free. If you need more documents to be signed or are looking for more features (like templates), a Pro account or higher may be more suitable for you. Check out our ',
	                _react2['default'].createElement(
	                    'a',
	                    { href: '/info/pricing',
	                        target: '_blank', rel: 'noopener noreferrer' },
	                    'pricing page'
	                ),
	                ' for the features per plan.'
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'Is this legal?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'The short answer is, \u201CYes, it is.\u201D eSignatures are backed by the ESIGN Act of 2000, which gives ',
	                _react2['default'].createElement(
	                    'a',
	                    {
	                        href: 'http://blog.hellosign.com/esignatures-legal-handwritten-signatures',
	                        target: '_blank', rel: 'noopener noreferrer' },
	                    'eSignatures the same legality as written'
	                ),
	                'signatures.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'There are certain types of documentation that are not included in the ESIGN Act and must still be signed on paper:'
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: listClass },
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Adoption and divorce paperwork'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Court orders and notices'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Wills, codicils, and trusts'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Cancellations of utility services (includes power, water, and heat)'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Notices of repossession, foreclosure, eviction, or the right to cure'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Product recalls or material failure'
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Documentation that accompanies hazardous materials, pesticides, or other toxic or dangerous materials'
	                )
	            ),
	            _react2['default'].createElement(
	                'h2',
	                { className: headerClass },
	                'Can you use Preview or Word instead of an eSignature service to eSign a PDF?'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Using software such as Preview or Word to sign your document is ',
	                _react2['default'].createElement(
	                    'strong',
	                    null,
	                    'not considered a secure method of eSigning'
	                ),
	                '. Even though you can paste an image of your signature from a scanned image to get a similar-looking result to an eSignature, these programs don\u2019t provide the security protections that eSignature services do.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'At HelloSign, we have ',
	                _react2['default'].createElement(
	                    'a',
	                    { href: '/info/security',
	                        target: '_blank', rel: 'noopener noreferrer' },
	                    'securities built in'
	                ),
	                '. Your documents are encrypted using SSL (Secure Sockets Layer), which is the same level of encryption used by leading banks and government agencies. We also have an audit trail that\u2019s appended to all signature requests so you have record of your business processes.'
	            )
	        );
	    },
	    renderCTASection: function renderCTASection() {
	        var ctaSectionProps = {
	            title: 'Get started: eSign a document for free',
	            subtitle: 'Have a document to sign? Use HelloSign as your PDF eSignature app for free (we even have mobile apps for iOS and Android). If you’re looking for more features for your business (for example, team features, in-person signing, or signer access codes), request a demo with one of our eSignature experts.',
	            signupButtonText: 'CREATE A HELLOSIGN ACCOUNT',
	            signupButtonUrl: this.props.homeUrl,
	            secondButtonText: 'SEE PRO PLANS',
	            secondButtonUrl: this.props.pricingUrl,
	            apiUsersHeaderText: 'LOOK WHO\'S USING HELLOSIGN',
	            embeddedTweetsHeaderText: 'HAPPY TWEETS FROM HAPPY USERS'
	        };
	        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
	    },
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            null,
	            this.renderTitleSection(),
	            this.renderBodySection(),
	            this.renderCTASection()
	        );
	    }
	});

/***/ },
/* 1231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _seoComponent = __webpack_require__(1232);
	
	var _seoComponent2 = _interopRequireDefault(_seoComponent);
	
	var _HS_logo_white = __webpack_require__(1233);
	
	var _HS_logo_white2 = _interopRequireDefault(_HS_logo_white);
	
	var _dropbox_logo_white = __webpack_require__(1234);
	
	var _dropbox_logo_white2 = _interopRequireDefault(_dropbox_logo_white);
	
	var _clouds_dropbox = __webpack_require__(1235);
	
	var _clouds_dropbox2 = _interopRequireDefault(_clouds_dropbox);
	
	var _cloud_left = __webpack_require__(1236);
	
	var _cloud_left2 = _interopRequireDefault(_cloud_left);
	
	var _cloud_right = __webpack_require__(1237);
	
	var _cloud_right2 = _interopRequireDefault(_cloud_right);
	
	var _folder_icon = __webpack_require__(1238);
	
	var _folder_icon2 = _interopRequireDefault(_folder_icon);
	
	var _signature_icon = __webpack_require__(1239);
	
	var _signature_icon2 = _interopRequireDefault(_signature_icon);
	
	var _cloud_icon = __webpack_require__(1240);
	
	var _cloud_icon2 = _interopRequireDefault(_cloud_icon);
	
	var _screenshot_dropbox = __webpack_require__(1241);
	
	var _screenshot_dropbox2 = _interopRequireDefault(_screenshot_dropbox);
	
	var _socialSection = __webpack_require__(1242);
	
	var _socialSection2 = _interopRequireDefault(_socialSection);
	
	var _quoteSection = __webpack_require__(1246);
	
	var _quoteSection2 = _interopRequireDefault(_quoteSection);
	
	var _faqSection = __webpack_require__(1247);
	
	var _faqSection2 = _interopRequireDefault(_faqSection);
	
	var _benefitsSection = __webpack_require__(1248);
	
	var _benefitsSection2 = _interopRequireDefault(_benefitsSection);
	
	var _howItWorksSection = __webpack_require__(1249);
	
	var _howItWorksSection2 = _interopRequireDefault(_howItWorksSection);
	
	var _pricingCtaSection = __webpack_require__(1250);
	
	var _pricingCtaSection2 = _interopRequireDefault(_pricingCtaSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function (_SEOComponent) {
	    _inherits(Dropbox, _SEOComponent);
	
	    function Dropbox() {
	        _classCallCheck(this, Dropbox);
	
	        return _possibleConstructorReturn(this, (Dropbox.__proto__ || Object.getPrototypeOf(Dropbox)).apply(this, arguments));
	    }
	
	    _createClass(Dropbox, [{
	        key: 'render',
	        value: function render() {
	            // Dropbox constants
	            var benefits = [{
	                icon: _folder_icon2['default'],
	                title: 'Access your Dropbox files from HelloSign',
	                text: 'View documents stored in Dropbox in your HelloSign account. Select a document and you\'re ready to start preparing your doc for signature.'
	            }, {
	                icon: _signature_icon2['default'],
	                title: 'Sign any document from Dropbox',
	                text: 'Prepare your Dropbox document for signature with a few easy clicks. Send your document with a signature request and you\'re almost there!'
	            }, {
	                icon: _cloud_icon2['default'],
	                title: 'Save signed copies in Dropbox',
	                text: 'Once your document is signed, a copy will automatically sync to your Dropbox account.'
	            }];
	            var howItWorks = ['To sync your HelloSign account with Dropbox, just click the Dropbox icon the next time you upload a document to be signed.', 'Once you are synced, you can click on the Dropbox icon whenever you need to pull a file from your Dropbox account to request a signature or sign and send.'];
	            var twitterLink = 'https://twitter.com/intent/tweet?text=Integrate%20%40Dropbox%20with%20%40HelloSign%20to%20easily%20store%20and%20share%20signed%20documents%20with%20your%20team.&url=https%3A%2F%2Fwww.hellosign.com%2Fdropbox%3Futm_medium%3Ds2s%26utm_source%3Dtwitter%26utm_campaign%3Ddropbox-integration-page-s2s';
	            var facebookLink = 'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.hellosign.com%2Fdropbox%3Futm_medium%3Ds2s%26utm_source%3Dfacebook%26utm_campaign%3Ddropbox-integration-page-s2s';
	            var linkedInLink = 'https://www.linkedin.com/shareArticle?mini=true&url=https%3A%2F%2Fwww.hellosign.com%2Fdropbox%3Futm_medium%3Ds2s%26utm_source%3Dlinkedin%26utm_campaign%3Ddropbox-integration-page-s2s&title=Integrate%20Dropbox%20%26%20HelloSign%20to%20easily%20store%20and%20share%20signed%20docs%20with%20your%20team&source=https%253A%252F%252Fwww.hellosign.com%252Fdropbox';
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'seo-cloud-integrations' },
	                _react2['default'].createElement(IllustrationArea, { button: this.renderSignupButton() }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'seo-cloud-integrations__main' },
	                    _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'top' }),
	                    _react2['default'].createElement(_benefitsSection2['default'], { benefits: benefits }),
	                    _react2['default'].createElement(_howItWorksSection2['default'], {
	                        image: _screenshot_dropbox2['default'],
	                        explanation: howItWorks }),
	                    _react2['default'].createElement(_quoteSection2['default'], {
	                        quote: 'We\'re particularly excited about our partnership with HelloSign because we both believe in the importance of a simple, yet powerful user experience.',
	                        name: 'MEGHAN KEANEY ANDERSON',
	                        title: 'Product Marketing Director at HubSpot' }),
	                    _react2['default'].createElement(_socialSection2['default'], {
	                        twitterLink: twitterLink,
	                        facebookLink: facebookLink,
	                        linkedInLink: linkedInLink }),
	                    _react2['default'].createElement(_faqSection2['default'], { link: 'https://faq.hellosign.com/hc/en-us/sections/200979147-Dropbox' }),
	                    _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'bottom' })
	                )
	            );
	        }
	    }]);
	
	    return Dropbox;
	}(_seoComponent2['default']);
	
	function IllustrationArea(p) {
	    return _react2['default'].createElement(
	        'div',
	        { className: 'top row dropbox-blue' },
	        _react2['default'].createElement(
	            'div',
	            { className: 'top-content-container large-5 large-push-6 columns' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'hellosign-dropbox' },
	                _react2['default'].createElement('img', { src: _HS_logo_white2['default'], alt: 'HelloSign Logo', className: 'hs-logo' }),
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'plus' },
	                    '+'
	                ),
	                _react2['default'].createElement('img', { src: _dropbox_logo_white2['default'], alt: 'Dropbox Logo', className: 'dropbox-logo', width: '130' })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'title' },
	                _react2['default'].createElement(
	                    'h1',
	                    null,
	                    'Sync Dropbox with HelloSign'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'subtitle' },
	                _react2['default'].createElement(
	                    'h2',
	                    null,
	                    'Access and sign your Dropbox documents with the Dropbox + HelloSign integration.'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'signup-button' },
	                p.button
	            )
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'clouds-container large-5 large-pull-4 columns' },
	            _react2['default'].createElement('img', { src: _clouds_dropbox2['default'], alt: 'cloud left' })
	        ),
	        _react2['default'].createElement('img', { src: _cloud_left2['default'], alt: 'cloud left', className: 'cloud-left' }),
	        _react2['default'].createElement('img', { src: _cloud_right2['default'], alt: 'cloud right', className: 'cloud-right' })
	    );
	}

/***/ },
/* 1232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _signupOrLoginButton = __webpack_require__(1210);
	
	var _signupOrLoginButton2 = _interopRequireDefault(_signupOrLoginButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function (_React$Component) {
	    _inherits(SEOComponent, _React$Component);
	
	    function SEOComponent() {
	        _classCallCheck(this, SEOComponent);
	
	        return _possibleConstructorReturn(this, (SEOComponent.__proto__ || Object.getPrototypeOf(SEOComponent)).apply(this, arguments));
	    }
	
	    _createClass(SEOComponent, [{
	        key: 'renderSignupButton',
	        value: function renderSignupButton() {
	            return _react2['default'].createElement(_signupOrLoginButton2['default'], _extends({}, this.props, {
	                buttonText: 'Sign in to HelloSign Integrations Page',
	                buttonClass: 'm-button bg-cerulean hbg-castle-rock c-white hc-white m-login-or-signup--sign-up-button',
	                isIntegration: true
	            }));
	        }
	    }]);
	
	    return SEOComponent;
	}(_react2['default'].Component);

/***/ },
/* 1233 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/66c29b912f055e2cf041380a972dfd10.svg";

/***/ },
/* 1234 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/df39c82e463916d1433231ac0c98bcb9.svg";

/***/ },
/* 1235 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/3443159958e835802603c50d44868689.svg";

/***/ },
/* 1236 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyODguNjEgMTI5LjgxIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2Y3ZjhmOTt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkNsb3VkU3RvcmFnZV88L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTI4OC42MSwxMjkuODFhMTAuMDksMTAuMDksMCwwLDAtMTcuNzktNi41MSw2LjQ0LDYuNDQsMCwwLDAtNi40My02LjA3LDYuMzcsNi4zNywwLDAsMC00LjI3LDEuNjMsMTQsMTQsMCwwLDAtMTkuOTEtMTEuNTMsMzEsMzEsMCwwLDAtNDMtMjAuNTFBOTksOTksMCwwLDAsMCw5OXYzMC44MUgyODguNjFaIi8+PC9zdmc+"

/***/ },
/* 1237 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNDcuODUgMTE2LjQyIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2Y3ZjhmOTt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkNsb3VkU3RvcmFnZV88L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIzNy4xNCwxMC4wOWE2Nyw2NywwLDAsMC0xMDEsNzBjLTIuNjguMDYtNC4xOCwxLjQzLTUsNC4yOGExMy4xOSwxMy4xOSwwLDAsMC0yNiwzLjM0LDEyLjM2LDEyLjM2LDAsMCwwLC4yMiwyLjM3LDI0LjksMjQuOSwwLDAsMC01Ljc3LS42N2MtMC41OCwwLTEuMTUsMC0xLjcyLjA2Vjg5LjM5YTI1LjI3LDI1LjI3LDAsMCwwLTUwLjU0LDBjMCwwLjQ4LDAsMSwwLDEuNDJhMTIuNTgsMTIuNTgsMCwwLDAtMTYuMSw1LjI5LDEyLjU5LDEyLjU5LDAsMCwwLTE1LjU5LTQuNjhjLTIxLjg5LDAtMTQuNTYsMjUtMTQuNTYsMjVIMjQ3Ljg1VjE1LjA4WiIvPjwvc3ZnPg=="

/***/ },
/* 1238 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/7e2444666c97509e9dcafda5d3399123.svg";

/***/ },
/* 1239 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/9ac04316413e58447ad279e48449d710.svg";

/***/ },
/* 1240 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/1f751b2d72002340e5bdd1b9262d587b.svg";

/***/ },
/* 1241 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/3ea5381577ac8159212d7d7c3b71673b.png";

/***/ },
/* 1242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _social_twitter2x = __webpack_require__(1243);
	
	var _social_twitter2x2 = _interopRequireDefault(_social_twitter2x);
	
	var _social_facebook2x = __webpack_require__(1244);
	
	var _social_facebook2x2 = _interopRequireDefault(_social_facebook2x);
	
	var _social_linkedin2x = __webpack_require__(1245);
	
	var _social_linkedin2x2 = _interopRequireDefault(_social_linkedin2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function Social(p) {
	    var title = p.title ? _react2['default'].createElement(
	        'h2',
	        { style: { marginBottom: 30 } },
	        p.title
	    ) : null;
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'seo-cloud-integrations__social', style: { marginTop: 50 } },
	        title,
	        _react2['default'].createElement(
	            'a',
	            { href: p.twitterLink, target: '_blank', rel: 'noopener noreferrer' },
	            _react2['default'].createElement('img', { src: _social_twitter2x2['default'], alt: 'twitter share' })
	        ),
	        _react2['default'].createElement(
	            'a',
	            { href: p.facebookLink, target: '_blank', rel: 'noopener noreferrer' },
	            _react2['default'].createElement('img', { src: _social_facebook2x2['default'], alt: 'facebook share', className: 'facebook-share' })
	        ),
	        _react2['default'].createElement(
	            'a',
	            { href: p.linkedInLink, target: '_blank', rel: 'noopener noreferrer' },
	            _react2['default'].createElement('img', { src: _social_linkedin2x2['default'], alt: 'linkedin share' })
	        )
	    );
	}
	
	module.exports = Social;

/***/ },
/* 1243 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAACgElEQVRIie2WO08UYRSGnzO3XVYuGlZBiKhoQoilFjbUtrbWRht/gcTChFIjMTFq4h+wMhYmNtpBJDZSmgAbLiZ4QWBVdpb9Zr5jMctFYMZFhML4VpOcL+eZ77znnBnpH61MAAXAsH8SwAfue8DZfQRt1UXnAGEA5YMG8h/41+WlBQSINXl2BXRTzBFYtfCpptQstHlw2BMiBd8Bl1/PNwQEMAqhVVpcwatDHYFyBL4o17s9OnPC2LJlZDnmZN6hapWaJi+8K+CiUa50ehwNhKGSoRgIrR6EcXKDR/05LrW7ANgeGF22zFSV4dkaPwzkUszaEahAaOFcs8PVbo9WD+5MR5QqSmiUaz3+Ooz6rQeOOOiSZTUGm1ZPUppGSN7w+ZcIo3DjhM/r83lunfYZKLpcaN1eMKvwYLrGhxVLXkBToKklzTmCqlAKLX0FhzMFYbDXZ7DXX2+mzaoqzFUUV0GtIu7OLqaORSVWOgLoK2w/slOuj1XL55pScAUQJKVrUoHtvvByIebejKEcpZ3a0MiiZS5UmrysrBkhX2BV4cVCTFvm8CT+PZk1HHIT/9NGIhNogRZPmKwoQyXD+xWbmuT2RI03S5ZiIL8lpgIFKPqQd+HpfJQKHC4Z7k4ZuvKCIyCS7h9kdGlo4VSTcLPb5/IxF3dTzCq8LVseThuezUe0B5J4JyC/2c6pwECgFCqP5wyvvsZ05YRA4JtRxsuW8bKlHCkd+Y2157rZt8sEri3sqVB59z1ixUBkFUeh2Un8Pb5eRnAagGUC12Y770A+ENSrbw9NYgLggKzNXAOwTOBWST05CioN59+m3X+A9wD7M+Ae9c8D2zxgkoP51Q+AsZ/CQ+IcWPvkuAAAAABJRU5ErkJggg=="

/***/ },
/* 1244 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAABsUlEQVRIie2Wu0oDQRSGvxONURAURBQEwUKxF2zsBbHwAcRO8Al8Bx/ATnsLKy31CRS0E2y84JWoMYlxjfGSY5G9TPaCZrNBEP9mZnZ35pvLP+esLK0cKr+g1G9A/8H/4L8Jbo/bUYCx4W6G+rtIp1PsHz2SL723Hrw4N8LEeK/bPrmyWg8e7Ot0oZd3Zc5vLIrWz6GxwX09HW59Y+eS02ur4TFigVPi1Stv1bp3qgBO+K99KEJADYNnpwaZnhxw28vzo1QV1rfPOTot+r5WezISgDcMTrenyHR4t7Az0wZA9rFsQzwgOEDFWX1s8O5elvt8hYWZYQBWN0+4zVXIFd5QBVUzy6oBr1fDAcR6/eTJcHC+9M5D4ZWqDVWj9OCgvqzfdOQyAc4215fhSiRk1lbpg33zX5MAOJzg8iMm0LIk4fjJMVbT1wmg+PzBwXEBgHLlM5Jcg4VYOi74IvvC2tYZ4N9KQXxRK0qxs1OkQnnBh4mAzfNT9eKziNhlsE/T5vIGNYHf90vU1SbQWW2UEjpjQURDs1Cirg4MLaBVDEfbUkEi9jSZrVYFCQlRopGh6wvWvJt29OTJuQAAAABJRU5ErkJggg=="

/***/ },
/* 1245 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAACpElEQVRIieWWu2sUURSHv3PuzO7O7iauWTTBSGIhqYOFhWIlWoi1YCP+AbZWio1gof4HVjYiFnY2xkoRQZsUChICLho18UFiXvuaucdiZwORnY0SEkRPc7lzh/Odx+8+5Nid2XdAACTsnCkgwNUAOLSDoF9tUncRBrCy20D+c6AKNBNjuZnQSgyVHQSqQL3tCVSYqOYRgUZsyDahmcB6bDgVbp4a4f65MW6cHMGAZmw7A2wnRjmnHB8rEapwfLxE3gmtbQKDrIWBnPJ1PebCww+cGC/yZHaF7ystYg/rbSEKHQCN2APgVNgbOVTA+sSUCUwMBvMOA159rOO9MZR3HBktUo4cb7+3aMSesxODRKHyrLbGi7k1qsWAfm3OBDYTIxLh1ukRRgdDpj83uDL1mVtnDhCFSm2pzXgl3HB+cbLC5cfzPJpZZl8pyMwys4ddR92SNRODVLkAhyohT2urPHi9BHRKeulolcgJrT7XQGaGXfNppN4bSexJ0vmbhQbn79VoJnB4KM+RAxHDZcdoyVFbjqkUe7v+7ZPGzDap4f1Si0CEgVD4tNze+O6AJPaY7+1nywyzLOeEnBNEIR9IGhT4dDQzpId8tsywe5xljSKCSycqAn012ifDbvWG0l5UIoeqUE3newqu01+DwUJnTxZzilPZ6PsfAXOuE+nt598YLQfMfK3zo55wbWqe/QMBb780KOcEccrd6UVezq3zbS1msR5TDLOzlGN3ZnvGI+mJsbAaU2978hiVvPJlLSEWKAdCteBQJyy2YKWdoN7YV1BCJ2jQWfvFrm9Z0uFy5xefGOaNg0MOEQFveANTqJaUKg7vDUv3Tdat8tsqVSeYCkgqCxXU2KQRVcFS0raBPZ30cLrVffl3PTH+BeBAANTYvaf+9E/e9u9O5ymAsgAAAABJRU5ErkJggg=="

/***/ },
/* 1246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function Quote(p) {
	    return _react2['default'].createElement(
	        'div',
	        { className: 'seo-cloud-integrations__quote-container' },
	        _react2['default'].createElement(
	            'p',
	            { className: 'quote' },
	            '\'',
	            p.quote,
	            '\''
	        ),
	        _react2['default'].createElement(
	            'p',
	            { className: 'quote-name' },
	            p.name
	        ),
	        _react2['default'].createElement(
	            'p',
	            { className: 'quote-title' },
	            p.title
	        )
	    );
	}
	
	module.exports = Quote;

/***/ },
/* 1247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function FAQ(p) {
	    return _react2['default'].createElement(
	        'div',
	        { className: 'seo-cloud-integrations__faq' },
	        _react2['default'].createElement(
	            'p',
	            null,
	            'Questions about this integration? We have answers.'
	        ),
	        _react2['default'].createElement(_button2['default'], {
	            buttonText: 'View our FAQ',
	            buttonLink: p.link,
	            buttonColor: 'cerulean',
	            openInNewWindow: true })
	    );
	}
	
	module.exports = FAQ;

/***/ },
/* 1248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports['default'] = Benefits;
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function Benefits(_ref) {
	    var _ref$benefits = _ref.benefits,
	        benefits = _ref$benefits === undefined ? [] : _ref$benefits;
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'seo-cloud-integrations__benefits' },
	        _react2['default'].createElement(
	            'h2',
	            null,
	            'Benefits'
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'row' },
	            benefits.map(function (benefit) {
	                return renderBenefit(benefit);
	            })
	        )
	    );
	}
	
	function renderBenefit(_ref2) {
	    var title = _ref2.title,
	        icon = _ref2.icon,
	        text = _ref2.text;
	
	    return _react2['default'].createElement(
	        'section',
	        { key: title, className: 'large-4 columns' },
	        _react2['default'].createElement(
	            'div',
	            { className: 'benefits-image-container' },
	            _react2['default'].createElement('img', { src: icon })
	        ),
	        _react2['default'].createElement(
	            'h3',
	            null,
	            title
	        ),
	        _react2['default'].createElement(
	            'p',
	            null,
	            text
	        )
	    );
	}

/***/ },
/* 1249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports['default'] = HowItWorks;
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function HowItWorks(_ref) {
	    var _ref$explanation = _ref.explanation,
	        explanation = _ref$explanation === undefined ? [] : _ref$explanation,
	        image = _ref.image;
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'seo-cloud-integrations__how-it-works' },
	        _react2['default'].createElement(
	            'h2',
	            null,
	            'How it Works'
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'row' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'screenshot-explanation large-3 large-push-9 columns' },
	                explanation.map(function (exp) {
	                    return renderExplanation(exp);
	                })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'dropbox-screenshot large-9 large-pull-3 columns' },
	                _react2['default'].createElement('img', { src: image })
	            )
	        )
	    );
	}
	
	function renderExplanation(exp) {
	    return _react2['default'].createElement(
	        'p',
	        { key: exp },
	        exp
	    );
	}

/***/ },
/* 1250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function PricingCTA(p) {
	    var className = 'seo-cloud-integrations__main__free_accounts__' + p.position;
	
	    var text = p.text ? p.text : 'Free accounts include three documents a month. Upgrade to a business plan for unlimited documents.';
	    var linkUrl = p.linkUrl ? p.linkUrl : 'info/pricing';
	    var linkText = p.linkText ? p.linkText : 'See Our Plans';
	    var link = _react2['default'].createElement(
	        'a',
	        { href: linkUrl, style: { fontWeight: 500 }, onClick: p.onClick },
	        linkText
	    );
	
	    return _react2['default'].createElement(
	        'div',
	        { className: className, style: p.style },
	        text,
	        '\xA0',
	        link,
	        '.'
	    );
	}
	
	module.exports = PricingCTA;

/***/ },
/* 1251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _seoComponent = __webpack_require__(1232);
	
	var _seoComponent2 = _interopRequireDefault(_seoComponent);
	
	var _HS_logo_white = __webpack_require__(1233);
	
	var _HS_logo_white2 = _interopRequireDefault(_HS_logo_white);
	
	var _box_logo_white = __webpack_require__(1252);
	
	var _box_logo_white2 = _interopRequireDefault(_box_logo_white);
	
	var _clouds_box = __webpack_require__(1253);
	
	var _clouds_box2 = _interopRequireDefault(_clouds_box);
	
	var _cloud_left = __webpack_require__(1236);
	
	var _cloud_left2 = _interopRequireDefault(_cloud_left);
	
	var _cloud_right = __webpack_require__(1237);
	
	var _cloud_right2 = _interopRequireDefault(_cloud_right);
	
	var _folder_icon = __webpack_require__(1238);
	
	var _folder_icon2 = _interopRequireDefault(_folder_icon);
	
	var _signature_icon = __webpack_require__(1239);
	
	var _signature_icon2 = _interopRequireDefault(_signature_icon);
	
	var _cloud_icon = __webpack_require__(1240);
	
	var _cloud_icon2 = _interopRequireDefault(_cloud_icon);
	
	var _screenshot_box = __webpack_require__(1254);
	
	var _screenshot_box2 = _interopRequireDefault(_screenshot_box);
	
	var _socialSection = __webpack_require__(1242);
	
	var _socialSection2 = _interopRequireDefault(_socialSection);
	
	var _quoteSection = __webpack_require__(1246);
	
	var _quoteSection2 = _interopRequireDefault(_quoteSection);
	
	var _faqSection = __webpack_require__(1247);
	
	var _faqSection2 = _interopRequireDefault(_faqSection);
	
	var _benefitsSection = __webpack_require__(1248);
	
	var _benefitsSection2 = _interopRequireDefault(_benefitsSection);
	
	var _howItWorksSection = __webpack_require__(1249);
	
	var _howItWorksSection2 = _interopRequireDefault(_howItWorksSection);
	
	var _pricingCtaSection = __webpack_require__(1250);
	
	var _pricingCtaSection2 = _interopRequireDefault(_pricingCtaSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function (_SEOComponent) {
	    _inherits(Box, _SEOComponent);
	
	    function Box() {
	        _classCallCheck(this, Box);
	
	        return _possibleConstructorReturn(this, (Box.__proto__ || Object.getPrototypeOf(Box)).apply(this, arguments));
	    }
	
	    _createClass(Box, [{
	        key: 'render',
	        value: function render() {
	            // Box constants
	            var benefits = [{
	                icon: _folder_icon2['default'],
	                title: 'Pull files from your Box account into your HelloSign account',
	                text: 'Sign in to your HelloSign account and access any file from a linked Box account.'
	            }, {
	                icon: _signature_icon2['default'],
	                title: 'Request signatures from your Box Account',
	                text: 'Select a Box document and send a request using the \'HelloSign\' option in the Box applications navigation menu.'
	            }, {
	                icon: _cloud_icon2['default'],
	                title: 'Automatically store copies of completed documents in Box',
	                text: 'Once a Box document has been signed, a copy of the completed document will be stored in your Box account. Never lose track of your signed documents again!'
	            }];
	            var howItWorks = ['To sync your HelloSign account with Box, just click the Box icon the next time you upload a document to be signed.', 'Once you are synced, you can click on the Box icon whenever you need to pull a file from your Box account to request a signature or sign and send.'];
	            var twitterLink = 'https://twitter.com/intent/tweet?text=Integrate%20%40BoxHQ%20with%20%40HelloSign%20to%20easily%20store%20and%20share%20signed%20documents%20with%20your%20team.&url=https%3A%2F%2Fwww.hellosign.com%2Fbox%3Futm_medium%3Ds2s%26utm_source%3Dtwitter%26utm_campaign%3Dbox-integration-page-s2s';
	            var facebookLink = 'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.hellosign.com%2Fbox%3Futm_medium%3Ds2s%26utm_source%3Dfacebook%26utm_campaign%3Dbox-integration-page-s2s';
	            var linkedInLink = 'https://www.linkedin.com/shareArticle?mini=true&url=https%3A%2F%2Fwww.hellosign.com%2Fbox%3Futm_medium%3Ds2s%26utm_source%3Dlinkedin%26utm_campaign%3Dbox-integration-page-s2s&title=Integrate%20Box%20%26%20HelloSign%20to%20easily%20store%20and%20share%20signed%20docs%20with%20your%20team&source=https%253A%252F%252Fwww.hellosign.com%252Fbox';
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'seo-cloud-integrations' },
	                _react2['default'].createElement(IllustrationArea, { button: this.renderSignupButton() }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'seo-cloud-integrations__main' },
	                    _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'top' }),
	                    _react2['default'].createElement(_benefitsSection2['default'], { benefits: benefits }),
	                    _react2['default'].createElement(_howItWorksSection2['default'], {
	                        image: _screenshot_box2['default'],
	                        explanation: howItWorks }),
	                    _react2['default'].createElement(_quoteSection2['default'], {
	                        quote: 'HelloFax and HelloSign provide our users with even more ways to achieve a truly paperless lifestyle. Together, they are incredibly useful additions to the Evernote Trunk.',
	                        name: 'SETH HITCHINGS',
	                        title: 'WVP OF PLATFORM STRATEGIES AT EVERNOTE' }),
	                    _react2['default'].createElement(_socialSection2['default'], {
	                        twitterLink: twitterLink,
	                        facebookLink: facebookLink,
	                        linkedInLink: linkedInLink }),
	                    _react2['default'].createElement(_faqSection2['default'], { link: 'https://faq.hellosign.com/hc/en-us/sections/200967267-Box-Integration' }),
	                    _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'bottom' })
	                )
	            );
	        }
	    }]);
	
	    return Box;
	}(_seoComponent2['default']);
	
	function IllustrationArea(p) {
	    return _react2['default'].createElement(
	        'div',
	        { className: 'top row box-yellow' },
	        _react2['default'].createElement(
	            'div',
	            { className: 'top-content-container large-5 large-push-6 columns' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'hellosign-dropbox' },
	                _react2['default'].createElement('img', { src: _HS_logo_white2['default'], alt: 'HelloSign Logo', className: 'hs-logo' }),
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'plus' },
	                    '+'
	                ),
	                _react2['default'].createElement('img', { src: _box_logo_white2['default'], alt: 'Box Logo', className: 'box-logo', width: '50' })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'title' },
	                _react2['default'].createElement(
	                    'h1',
	                    null,
	                    'Link Your HelloSign and Box Accounts'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'subtitle' },
	                _react2['default'].createElement(
	                    'h2',
	                    null,
	                    'Use the HelloSign + Box integration to access and sign Box documents from your HelloSign account and quickly send documents for signature from Box.'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'signup-button' },
	                p.button
	            )
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'clouds-container large-5 large-pull-4 columns' },
	            _react2['default'].createElement('img', { src: _clouds_box2['default'], alt: 'cloud left' })
	        ),
	        _react2['default'].createElement('img', { src: _cloud_left2['default'], alt: 'cloud left', className: 'cloud-left' }),
	        _react2['default'].createElement('img', { src: _cloud_right2['default'], alt: 'cloud right', className: 'cloud-right' })
	    );
	}

/***/ },
/* 1252 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/70d28f13e03563f29fc6f597884a9148.svg";

/***/ },
/* 1253 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/86d620367024af32c9e8d59e9afbafa8.svg";

/***/ },
/* 1254 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/ca05a94e13568fc68c5674e975f2e54a.png";

/***/ },
/* 1255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _seoComponent = __webpack_require__(1232);
	
	var _seoComponent2 = _interopRequireDefault(_seoComponent);
	
	var _HS_logo_white = __webpack_require__(1233);
	
	var _HS_logo_white2 = _interopRequireDefault(_HS_logo_white);
	
	var _evernote_logo_white = __webpack_require__(1256);
	
	var _evernote_logo_white2 = _interopRequireDefault(_evernote_logo_white);
	
	var _clouds_evernote = __webpack_require__(1257);
	
	var _clouds_evernote2 = _interopRequireDefault(_clouds_evernote);
	
	var _cloud_left = __webpack_require__(1236);
	
	var _cloud_left2 = _interopRequireDefault(_cloud_left);
	
	var _cloud_right = __webpack_require__(1237);
	
	var _cloud_right2 = _interopRequireDefault(_cloud_right);
	
	var _folder_icon = __webpack_require__(1238);
	
	var _folder_icon2 = _interopRequireDefault(_folder_icon);
	
	var _signature_icon = __webpack_require__(1239);
	
	var _signature_icon2 = _interopRequireDefault(_signature_icon);
	
	var _cloud_icon = __webpack_require__(1240);
	
	var _cloud_icon2 = _interopRequireDefault(_cloud_icon);
	
	var _screenshot_evernote = __webpack_require__(1258);
	
	var _screenshot_evernote2 = _interopRequireDefault(_screenshot_evernote);
	
	var _socialSection = __webpack_require__(1242);
	
	var _socialSection2 = _interopRequireDefault(_socialSection);
	
	var _quoteSection = __webpack_require__(1246);
	
	var _quoteSection2 = _interopRequireDefault(_quoteSection);
	
	var _faqSection = __webpack_require__(1247);
	
	var _faqSection2 = _interopRequireDefault(_faqSection);
	
	var _benefitsSection = __webpack_require__(1248);
	
	var _benefitsSection2 = _interopRequireDefault(_benefitsSection);
	
	var _howItWorksSection = __webpack_require__(1249);
	
	var _howItWorksSection2 = _interopRequireDefault(_howItWorksSection);
	
	var _pricingCtaSection = __webpack_require__(1250);
	
	var _pricingCtaSection2 = _interopRequireDefault(_pricingCtaSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function (_SEOComponent) {
	    _inherits(Evernote, _SEOComponent);
	
	    function Evernote() {
	        _classCallCheck(this, Evernote);
	
	        return _possibleConstructorReturn(this, (Evernote.__proto__ || Object.getPrototypeOf(Evernote)).apply(this, arguments));
	    }
	
	    _createClass(Evernote, [{
	        key: 'render',
	        value: function render() {
	            // Evernote constants
	            var benefits = [{
	                icon: _folder_icon2['default'],
	                title: 'Access Evernote notebooks in your HelloSign account',
	                text: 'View documents from your Evernote notebooks in your HelloSign account. Select a note and you’re all set to start preparing your doc for signature.'
	            }, {
	                icon: _signature_icon2['default'],
	                title: 'Send notes for signature request in HelloSign',
	                text: 'Prepare your notes for signature with a few quick clicks. Send your signature request and you’re almost there!'
	            }, {
	                icon: _cloud_icon2['default'],
	                title: 'Automatically sync signed documents in your Evernote notebook',
	                text: 'Once your document is signed, a copy of the completed document will sync to your Evernote account. Easy storage.'
	            }];
	            var howItWorks = ['To sync your HelloSign account with Evernote, just click the Evernote icon the next time you upload a document to be signed.', 'Once you are synced, you can click on the Evernote icon whenever you need to pull a file from your Evernote account to request a signature or sign and send.'];
	            var twitterLink = 'https://twitter.com/intent/tweet?text=Integrate%20%40Evernote%20with%20%40HelloSign%20to%20easily%20import%20notes%20and%20store%20signed%20documents%20in%20%23Evernote.&url=https%3A%2F%2Fwww.hellosign.com%2Fevernote%3Futm_medium%3Ds2s%26utm_source%3Dtwitter%26utm_campaign%3Devernote-integration-page-s2s';
	            var facebookLink = 'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.hellosign.com%2Fevernote%3Futm_medium%3Ds2s%26utm_source%3Dfacebook%26utm_campaign%3Devernote-integration-page-s2s';
	            var linkedInLink = 'https://www.linkedin.com/shareArticle?mini=true&url=https%3A%2F%2Fwww.hellosign.com%2Fevernote%3Futm_medium%3Ds2s%26utm_source%3Dlinkedin%26utm_campaign%3Devernote-integration-page-s2s&title=Integrate%20Evernote%20%26%20HelloSign%20to%20easily%20import%20notes%20and%20store%20signed%20docs%20in%20Evernote&source=https%253A%252F%252Fwww.hellosign.com%252Fevernote';
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'seo-cloud-integrations' },
	                _react2['default'].createElement(IllustrationArea, { button: this.renderSignupButton() }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'seo-cloud-integrations__main' },
	                    _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'top' }),
	                    _react2['default'].createElement(_benefitsSection2['default'], { benefits: benefits }),
	                    _react2['default'].createElement(_howItWorksSection2['default'], {
	                        image: _screenshot_evernote2['default'],
	                        explanation: howItWorks }),
	                    _react2['default'].createElement(_quoteSection2['default'], {
	                        quote: 'We\'re particularly excited about our partnership with HelloSign because we both believe in the importance of a simple, yet powerful user experience.',
	                        name: 'MEGHAN KEANEY ANDERSON',
	                        title: 'Product Marketing Director at HubSpot' }),
	                    _react2['default'].createElement(_socialSection2['default'], {
	                        twitterLink: twitterLink,
	                        facebookLink: facebookLink,
	                        linkedInLink: linkedInLink }),
	                    _react2['default'].createElement(_faqSection2['default'], { link: 'https://faq.hellosign.com/hc/en-us/sections/200998238-Evernote' }),
	                    _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'bottom' })
	                )
	            );
	        }
	    }]);
	
	    return Evernote;
	}(_seoComponent2['default']);
	
	function IllustrationArea(p) {
	    return _react2['default'].createElement(
	        'div',
	        { className: 'top row evernote-green' },
	        _react2['default'].createElement(
	            'div',
	            { className: 'top-content-container large-5 large-push-6 columns' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'hellosign-dropbox' },
	                _react2['default'].createElement('img', { src: _HS_logo_white2['default'], alt: 'HelloSign Logo', className: 'hs-logo' }),
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'plus' },
	                    '+'
	                ),
	                _react2['default'].createElement('img', { src: _evernote_logo_white2['default'], alt: 'Dropbox Logo', className: 'dropbox-logo', width: '130' })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'title' },
	                _react2['default'].createElement(
	                    'h1',
	                    null,
	                    'Access Evernote Documents in HelloSign'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'subtitle' },
	                _react2['default'].createElement(
	                    'h2',
	                    null,
	                    'Use the HelloSign + Evernote integration to access notes in HelloSign and store copies of signed documents in your Evernote account.'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'signup-button' },
	                p.button
	            )
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'clouds-container large-5 large-pull-4 columns' },
	            _react2['default'].createElement('img', { src: _clouds_evernote2['default'], alt: 'cloud left' })
	        ),
	        _react2['default'].createElement('img', { src: _cloud_left2['default'], alt: 'cloud left', className: 'cloud-left' }),
	        _react2['default'].createElement('img', { src: _cloud_right2['default'], alt: 'cloud right', className: 'cloud-right' })
	    );
	}

/***/ },
/* 1256 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/e4484894ae96cf362861bb444cdfc148.svg";

/***/ },
/* 1257 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/ddb359a0f5b85085d30788bb7e8a7220.svg";

/***/ },
/* 1258 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/96a9964c92b39da13038c02ace3eea95.png";

/***/ },
/* 1259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _seoComponent = __webpack_require__(1232);
	
	var _seoComponent2 = _interopRequireDefault(_seoComponent);
	
	var _HS_logo_white = __webpack_require__(1233);
	
	var _HS_logo_white2 = _interopRequireDefault(_HS_logo_white);
	
	var _onedrive_logo_white = __webpack_require__(1260);
	
	var _onedrive_logo_white2 = _interopRequireDefault(_onedrive_logo_white);
	
	var _clouds_onedrive = __webpack_require__(1261);
	
	var _clouds_onedrive2 = _interopRequireDefault(_clouds_onedrive);
	
	var _cloud_left = __webpack_require__(1236);
	
	var _cloud_left2 = _interopRequireDefault(_cloud_left);
	
	var _folder_icon = __webpack_require__(1238);
	
	var _folder_icon2 = _interopRequireDefault(_folder_icon);
	
	var _signature_icon = __webpack_require__(1239);
	
	var _signature_icon2 = _interopRequireDefault(_signature_icon);
	
	var _cloud_icon = __webpack_require__(1240);
	
	var _cloud_icon2 = _interopRequireDefault(_cloud_icon);
	
	var _screenshot_onedrive = __webpack_require__(1262);
	
	var _screenshot_onedrive2 = _interopRequireDefault(_screenshot_onedrive);
	
	var _socialSection = __webpack_require__(1242);
	
	var _socialSection2 = _interopRequireDefault(_socialSection);
	
	var _quoteSection = __webpack_require__(1246);
	
	var _quoteSection2 = _interopRequireDefault(_quoteSection);
	
	var _faqSection = __webpack_require__(1247);
	
	var _faqSection2 = _interopRequireDefault(_faqSection);
	
	var _benefitsSection = __webpack_require__(1248);
	
	var _benefitsSection2 = _interopRequireDefault(_benefitsSection);
	
	var _howItWorksSection = __webpack_require__(1249);
	
	var _howItWorksSection2 = _interopRequireDefault(_howItWorksSection);
	
	var _pricingCtaSection = __webpack_require__(1250);
	
	var _pricingCtaSection2 = _interopRequireDefault(_pricingCtaSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function (_SEOComponent) {
	    _inherits(OneDrive, _SEOComponent);
	
	    function OneDrive() {
	        _classCallCheck(this, OneDrive);
	
	        return _possibleConstructorReturn(this, (OneDrive.__proto__ || Object.getPrototypeOf(OneDrive)).apply(this, arguments));
	    }
	
	    _createClass(OneDrive, [{
	        key: 'render',
	        value: function render() {
	            // OneDrive constants
	            var benefits = [{
	                icon: _folder_icon2['default'],
	                title: 'Access OneDrive Documents in HelloSign',
	                text: 'Sign in to your HelloSign account to quickly access documents in OneDrive and prepare them for signature.'
	            }, {
	                icon: _signature_icon2['default'],
	                title: 'Request signatures from your OneDrive documents',
	                text: 'Save yourself the hassle of switching screens by initiating signature request directly from your OneDrive account.'
	            }, {
	                icon: _cloud_icon2['default'],
	                title: 'Store signed copied in your OneDrive Account',
	                text: 'Store copies of your completed documents in your OneDrive account for easy access.'
	            }];
	            var howItWorks = ['To sync your HelloSign account with OneDrive, just click the OneDrive icon the next time you upload a document to be signed.', 'Once you are synced, you can click on the OneDrive icon whenever you need to pull a file from your OneDrive account to request a signature or sign and send.'];
	            var twitterLink = 'https://twitter.com/intent/tweet?text=Integrate%20%40OneDrive%20with%20%40HelloSign%20to%20easily%20store%20and%20share%20signed%20documents%20with%20your%20team.&url=https%3A%2F%2Fwww.hellosign.com%2Fonedrive%3Futm_medium%3Ds2s%26utm_source%3Dtwitter%26utm_campaign%3Donedrive-integration-page-s2s';
	            var facebookLink = 'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.hellosign.com%2Fonedrive%3Futm_medium%3Ds2s%26utm_source%3Dfacebook%26utm_campaign%3Donedrive-integration-page-s2s';
	            var linkedInLink = 'https://www.linkedin.com/shareArticle?mini=true&url=https%3A%2F%2Fwww.hellosign.com%2Fonedrive%3Futm_medium%3Ds2s%26utm_source%3Dlinkedin%26utm_campaign%3Donedrive-integration-page-s2s&title=Integrate%20Microsoft%20OneDrive%20%26%20HelloSign%20to%20easily%20store%20and%20share%20signed%20docs%20with%20your%20team&source=https%253A%252F%252Fwww.hellosign.com%252Fonedrive';
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'seo-cloud-integrations' },
	                _react2['default'].createElement(IllustrationArea, { button: this.renderSignupButton() }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'seo-cloud-integrations__main' },
	                    _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'top' }),
	                    _react2['default'].createElement(_benefitsSection2['default'], { benefits: benefits }),
	                    _react2['default'].createElement(_howItWorksSection2['default'], {
	                        image: _screenshot_onedrive2['default'],
	                        explanation: howItWorks }),
	                    _react2['default'].createElement(_quoteSection2['default'], {
	                        quote: 'We\'re particularly excited about our partnership with HelloSign because we both believe in the importance of a simple, yet powerful user experience.',
	                        name: 'MEGHAN KEANEY ANDERSON',
	                        title: 'Product Marketing Director at HubSpot' }),
	                    _react2['default'].createElement(_socialSection2['default'], {
	                        twitterLink: twitterLink,
	                        facebookLink: facebookLink,
	                        linkedInLink: linkedInLink }),
	                    _react2['default'].createElement(_faqSection2['default'], { link: 'https://faq.hellosign.com/hc/en-us/sections/203690688-OneDrive' }),
	                    _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'bottom' })
	                )
	            );
	        }
	    }]);
	
	    return OneDrive;
	}(_seoComponent2['default']);
	
	function IllustrationArea(p) {
	    return _react2['default'].createElement(
	        'div',
	        { className: 'top row onedrive-orange' },
	        _react2['default'].createElement(
	            'div',
	            { className: 'top-content-container large-5 large-push-6 columns' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'hellosign-dropbox' },
	                _react2['default'].createElement('img', { src: _HS_logo_white2['default'], alt: 'HelloSign Logo', className: 'hs-logo' }),
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'plus' },
	                    '+'
	                ),
	                _react2['default'].createElement('img', { src: _onedrive_logo_white2['default'], alt: 'Dropbox Logo', className: 'dropbox-logo', width: '130' })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'title' },
	                _react2['default'].createElement(
	                    'h1',
	                    null,
	                    'HelloSign + OneDrive = Productivity'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'subtitle' },
	                _react2['default'].createElement(
	                    'h2',
	                    null,
	                    'Use the HelloSign + OneDrive access and sign documents stored in your OneDrive account.'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'signup-button' },
	                p.button
	            )
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'clouds-container large-5 large-pull-4 columns' },
	            _react2['default'].createElement('img', { src: _clouds_onedrive2['default'], alt: 'cloud left' })
	        ),
	        _react2['default'].createElement('img', { src: _cloud_left2['default'], alt: 'cloud left', className: 'cloud-left' }),
	        _react2['default'].createElement('img', { src: _cloud_left2['default'], alt: 'cloud right', className: 'cloud-right' })
	    );
	}

/***/ },
/* 1260 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/c20e9fe8a0ac25c226af77d666908f2e.svg";

/***/ },
/* 1261 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/3dc709dbfe26213699499bad4ccdcf68.svg";

/***/ },
/* 1262 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/9326a11224cf513ebd134760acb92e9a.png";

/***/ },
/* 1263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HS_logo_white = __webpack_require__(1233);
	
	var _HS_logo_white2 = _interopRequireDefault(_HS_logo_white);
	
	var _eventbrite_logo = __webpack_require__(1264);
	
	var _eventbrite_logo2 = _interopRequireDefault(_eventbrite_logo);
	
	var _eventbrite_integration = __webpack_require__(1265);
	
	var _eventbrite_integration2 = _interopRequireDefault(_eventbrite_integration);
	
	var _send_icon = __webpack_require__(1266);
	
	var _send_icon2 = _interopRequireDefault(_send_icon);
	
	var _customize_logo = __webpack_require__(1267);
	
	var _customize_logo2 = _interopRequireDefault(_customize_logo);
	
	var _dashboard_icon = __webpack_require__(1268);
	
	var _dashboard_icon2 = _interopRequireDefault(_dashboard_icon);
	
	var _overlay_left = __webpack_require__(1269);
	
	var _overlay_left2 = _interopRequireDefault(_overlay_left);
	
	var _overlay_right = __webpack_require__(1270);
	
	var _overlay_right2 = _interopRequireDefault(_overlay_right);
	
	var _socialSection = __webpack_require__(1242);
	
	var _socialSection2 = _interopRequireDefault(_socialSection);
	
	var _faqSection = __webpack_require__(1247);
	
	var _faqSection2 = _interopRequireDefault(_faqSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function EventbriteLandingPage(p) {
	    var twitterLink = 'https://twitter.com/intent/tweet?text=It%27s%20easy%20to%20get%20attendee%20waivers%20%26%20forms%20signed%20with%20%40HelloSign%20%2B%20%40Eventbrite&url=https%3A%2F%2Fwww.hellosign.com%2Feventbrite%3Futm_source%3Dtwitter%26utm_medium%3Ds2s';
	    var facebookLink = 'https://www.facebook.com/sharer/sharer.php?u=https%3A//www.hellosign.com/eventbrite?utm_source=facebook%26utm_medium=s2s';
	    var linkedInLink = 'https://www.linkedin.com/shareArticle?mini=true&url=https%3A//www.hellosign.com/eventbrite?utm_source=linkedin%26utm_medium=s2s&title=Check%20out%20the%20HelloSign%20Extension%20for%20Eventbrite&summary=It%27s%20easy%20to%20get%20attendee%20waivers%20%26%20forms%20signed%20with%20HelloSign%20%2B%20Eventbrite.%20https%3A//www.hellosign.com/eventbrite';
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'seo-cloud-integrations' },
	        _react2['default'].createElement(IllustrationArea, p),
	        _react2['default'].createElement(
	            'div',
	            { className: 'seo-cloud-integrations__main', style: { backgroundColor: 'white' } },
	            _react2['default'].createElement(PricingPlansCTA, { position: 'top' }),
	            _react2['default'].createElement(Benefits, null),
	            _react2['default'].createElement(HowItWorks, null),
	            _react2['default'].createElement(_socialSection2['default'], {
	                title: 'Share with your network!',
	                twitterLink: twitterLink,
	                facebookLink: facebookLink,
	                linkedInLink: linkedInLink }),
	            _react2['default'].createElement(_faqSection2['default'], { link: 'https://faq.hellosign.com/hc/en-us/sections/204169818-Eventbrite' }),
	            _react2['default'].createElement(PricingPlansCTA, { position: 'bottom' })
	        )
	    );
	}
	
	function IllustrationArea(p) {
	    // This overlay is slightly off from the other integrations. This transform
	    // compensate for that.
	    var imageStyle = { transform: 'translateY(1px)' };
	    return _react2['default'].createElement(
	        'div',
	        { className: 'top row drobox-blue' },
	        _react2['default'].createElement(
	            'div',
	            { className: 'top-content-container large-5 large-push-6 columns' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'hellosign-dropbox' },
	                _react2['default'].createElement('img', { src: _HS_logo_white2['default'], alt: 'HelloSign Logo', className: 'hs-logo' }),
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'plus' },
	                    '+'
	                ),
	                _react2['default'].createElement('img', { src: _eventbrite_logo2['default'], alt: 'Eventbrite Logo', className: 'dropbox-logo', width: '130' })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'title' },
	                _react2['default'].createElement(
	                    'h1',
	                    null,
	                    'Seamlessly Collect Event Waivers and Forms'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'subtitle' },
	                _react2['default'].createElement(
	                    'h2',
	                    { style: { fontWeight: 400, fontSize: 16, maxWidth: 600 } },
	                    'The HelloSign Waivers & Forms extension for Eventbrite allows you to send any event-related documents to your attendees for legally-binding signature. We\u2019ve made it easy to send, track, collect, and get real-time status updates on your photo releases, sponsor and exhibitor agreements, permission slips, waivers, and more for your Eventbrite event.'
	                )
	            ),
	            _react2['default'].createElement(SignupButton, p)
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'clouds-container large-5 large-pull-4 columns' },
	            _react2['default'].createElement('img', { src: _eventbrite_integration2['default'], alt: 'cloud left', style: { marginTop: 23 } })
	        ),
	        _react2['default'].createElement('img', { src: _overlay_left2['default'],
	            style: imageStyle,
	            alt: 'cloud left',
	            className: 'cloud-left'
	        }),
	        _react2['default'].createElement('img', { src: _overlay_right2['default'],
	            style: imageStyle,
	            alt: 'cloud right',
	            className: 'cloud-right'
	        })
	    );
	}
	
	function SignupButton() {
	    var buttonClass = 'm-button bg-cerulean hc-white c-white progress-button state-loading m-login-or-signup--sign-up-button';
	    var linkURL = 'https://www.eventbrite.com/spectrum/hellosign/';
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'signup-button' },
	        _react2['default'].createElement(
	            'a',
	            { href: linkURL, className: buttonClass },
	            'ENABLE HELLOSIGN WAIVERS & FORMS'
	        )
	    );
	}
	
	function Benefits(p) {
	    var titleStyle = {
	        display: 'inline-block',
	        maxWidth: 250
	    };
	    return _react2['default'].createElement(
	        'div',
	        { className: 'seo-cloud-integrations__benefits' },
	        _react2['default'].createElement(
	            'h2',
	            null,
	            'Benefits'
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'row' },
	            _react2['default'].createElement(
	                'section',
	                { className: 'access-dropbox-from-hs large-4 columns' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'benefits-image-container' },
	                    _react2['default'].createElement('img', { src: _send_icon2['default'], alt: 'folder icon' })
	                ),
	                _react2['default'].createElement(
	                    'h3',
	                    null,
	                    _react2['default'].createElement(
	                        'span',
	                        { style: titleStyle },
	                        'Send important forms automatically'
	                    )
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    'Send your event documents to attendees that have already registered and to any new attendees automatically as they join. We can pre-fill fields they\u2019ve already entered.'
	                )
	            ),
	            _react2['default'].createElement(
	                'section',
	                { className: 'sign-any-from-dropbox large-4 columns' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'benefits-image-container' },
	                    _react2['default'].createElement('img', { src: _customize_logo2['default'], alt: 'signature icon' })
	                ),
	                _react2['default'].createElement(
	                    'h3',
	                    null,
	                    _react2['default'].createElement(
	                        'span',
	                        { style: titleStyle },
	                        'Customize your documents'
	                    )
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    'Upload unique documents for different ticket types, automatically pull attendee data into your documents, and brand your documents with your logo, company name, and more!'
	                )
	            ),
	            _react2['default'].createElement(
	                'section',
	                { className: 'save-signed-copies large-4 columns end' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'benefits-image-container' },
	                    _react2['default'].createElement('img', { src: _dashboard_icon2['default'], alt: 'cloud icon' })
	                ),
	                _react2['default'].createElement(
	                    'h3',
	                    null,
	                    _react2['default'].createElement(
	                        'span',
	                        { style: titleStyle },
	                        'Get real-time status reports'
	                    )
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    'Check the status of any document out for signature for any attendee from your Eventbrite dashboard and download a report to simplify day-of-event check-ins.'
	                )
	            )
	        )
	    );
	}
	
	function HowItWorks(p) {
	    var linkURL = 'http://blog.hellosign.com/hellosign-and-eventbrite-integration/';
	    var link = _react2['default'].createElement(
	        'a',
	        { href: linkURL },
	        'Read our blog post'
	    );
	    var videoProps = {
	        src: 'https://www.youtube.com/embed/mQkUMjH_DxE',
	        frameBorder: 0,
	        style: {
	            width: '100%',
	            maxWidth: 800,
	            height: 430
	        }
	    };
	    var paragraphStyle = {
	        marginLeft: 20
	    };
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'seo-cloud-integrations__how-it-works' },
	        _react2['default'].createElement(
	            'h2',
	            null,
	            'How it Works'
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'row' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'screenshot-explanation large-3 large-push-9 columns' },
	                _react2['default'].createElement(
	                    'p',
	                    { style: paragraphStyle },
	                    'To get started, find the HelloSign Waivers & Forms extension in Eventbrite Spectrum.'
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    { style: paragraphStyle },
	                    'Once you add the extension to your event, you can upload documents, assign them to ticket types, automatically send your documents to registered attendees, and see which documents are still out for signature.'
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    { style: paragraphStyle },
	                    'All of the docs you send through the extension will show up in the documents view on HelloSign.com.'
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    { style: paragraphStyle },
	                    'Want to learn more about the integration? ',
	                    link,
	                    '.'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'dropbox-screenshot large-9 large-pull-3 columns' },
	                _react2['default'].createElement('iframe', videoProps)
	            )
	        )
	    );
	}
	
	function PricingPlansCTA(p) {
	    var position = p.position;
	    var className = 'seo-cloud-integrations__main__free_accounts__' + position;
	    var linkURL = 'eventbrite/pricing';
	    var link = _react2['default'].createElement(
	        'a',
	        { href: linkURL, style: { fontWeight: 500 } },
	        'See Our Plans'
	    );
	    var border = '2px solid #D7D7D7';
	    var style = {};
	    if (position === 'top') {
	        style['borderBottom'] = border;
	        style['backgroundColor'] = '#f7f8f9';
	    } else {
	        style['borderTop'] = border;
	    }
	
	    return _react2['default'].createElement(
	        'div',
	        { className: className, style: style },
	        _react2['default'].createElement(
	            'p',
	            { style: { fontWeight: 600, lineSpacing: 0 } },
	            'The HelloSign Waivers and Forms extension for Eventbrite plans start at $29 a month. ',
	            link,
	            '.'
	        )
	    );
	}
	
	module.exports = EventbriteLandingPage;

/***/ },
/* 1264 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/a5f56ace114b026f33460b447155136c.png";

/***/ },
/* 1265 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/cd0e954bd3a2d6a7fae60ba9479835a3.svg";

/***/ },
/* 1266 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNS45OTgxNiAzNiI+PGRlZnM+PHN0eWxlPi5jbHMtMSwuY2xzLTJ7ZmlsbDpub25lO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDt9LmNscy0xe3N0cm9rZTojMjIxZjFmO30uY2xzLTJ7c3Ryb2tlOiMwMWIyZTU7c3Ryb2tlLWRhc2hhcnJheToyLjg4NzU5O308L3N0eWxlPjwvZGVmcz48dGl0bGU+RXZlbnRicml0ZV9BcnR3b3JrPC90aXRsZT48cG9seWdvbiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iMjIuMDQzIDEzLjk3NSAxOS45NzcgMTcuMTg4IDE5Ljk3NyAxMi42OTIgMTQuMDg3IDEyLjgzNSAyOS42MTEgMS45NDUgMjguMDg5IDE3LjU1NyAyMi4wNDMgMTMuOTc1Ii8+PGxpbmUgY2xhc3M9ImNscy0xIiB4MT0iMjkuNjExMDMiIHkxPSIxLjk0NTIyIiB4Mj0iMjIuMDQ0NzciIHkyPSIxMy45NzY4OSIvPjxsaW5lIGNsYXNzPSJjbHMtMSIgeDE9IjE5Ljk3NzE2IiB5MT0iMTIuNjkxNjIiIHgyPSIyOS42MTEwMyIgeTI9IjEuOTQ1MjIiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik0xOS42OTE2OSwxOC41NjMxMkE3LjI4NTcsNy4yODU3LDAsMCwxLDE0LjYxMiwyMy4zMTUzNWExMS44MzQ5NCwxMS44MzQ5NCwwLDAsMC0zLjg0MywxLjQ4NzQ3LDQuNzI4NjcsNC43Mjg2NywwLDAsMC0uMzYzMTYsNy4zMzA0NiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTMwLjc1ODM3LDEwLjAyNzQ3QTE1LjM2OTM4LDE1LjM2OTM4LDAsMSwxLDIyLjc0NSwzLjk5OSIvPjwvc3ZnPg=="

/***/ },
/* 1267 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/fbbefb40231d56a05a53ca419e409712.svg";

/***/ },
/* 1268 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/0eb170b369cadb5fa79c7bd5cfa4786b.svg";

/***/ },
/* 1269 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMzMuNDY5OTcgMTMzLjU5MDY2Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2Y3ZjhmOTt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkV2ZW50YnJpdGVfQXJ0d29yazwvdGl0bGU+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjMzLjQ3LDEzMy41OTA2NkgwVjQuNDEwNjdjMjUuMTY5OTIsMS41MSw1MC4wOTAwOSw2Ljc3LDcyLjc5LDE3LjIzLDM4LjMxMDA2LDE3LjY4LDUzLjI5LDUyLjI4LDgzLjU1LDc4LjgxQzE3NS45MTk5MiwxMTcuNjEwNjgsMjA1LjQzOTk0LDEyOS40NDA2NCwyMzMuNDcsMTMzLjU5MDY2WiIvPjwvc3ZnPg=="

/***/ },
/* 1270 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMzkuNDE5NjggMTc2LjAzMjM3Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2Y3ZjhmOTt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkV2ZW50YnJpdGVfQXJ0d29yazwvdGl0bGU+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzM5LjA5NywxNzUuNTkwMTVjLTYyLjQ2Ljk5LTIxMC44MDAyOSwwLjAxLTI4MS4wODAxNCwwSDYuNjE4MUE1MC40NTg3Myw1MC40NTg3MywwLDAsMCwwLDE3NS42MjI5YzIzLjE1MjQtMi4wNDMxNCw0Ny4wMjQwOC0xMy4xMjMsNjQuNTM0ODUtMjguMjYwNDgsMTguMDU1NTQtMTUuNjA4NCwyOC4yNzI5MS0zOC44OTMyMyw0OC40MDc1Ni01Mi4wMTcxLDExLjQwMjQ4LTcuNDMyMTIsMjQuMzY1NzYtMTEuODU3NTcsMzcuNzA0NjgtMTQuMjU1LDE4LjkwNDQ5LTMuMzk3OCwzOC4yODIyMy0zLjI0NDYsNTcuNDIwMTEtMy41MzAxNyw0Mi4yMTk3My0uNjMsMTI5LjAxOTUzLTE5LjgsMTMxLjA1OTU3LTc0LjRDMzM5LjUyNzE2LDY4Ljc3MDE0LDMzOS41MTY5MSwxMDkuNjEwMTcsMzM5LjA5NywxNzUuNTkwMTVaIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNzYuODk2NzksMTM1LjM1MDE2Yy0wLjExOTYzLjE5LS4yNSwwLjM5LTAuMzc5ODgsMC41OWExLjM5MTI4LDEuMzkxMjgsMCwwLDEsLjMxMDA2LTAuNTloMC4wNjk4MloiLz48L3N2Zz4="

/***/ },
/* 1271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(1272);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _whiteLabeling = __webpack_require__(1274);
	
	var _whiteLabeling2 = _interopRequireDefault(_whiteLabeling);
	
	var _marketoForm = __webpack_require__(1075);
	
	var _marketoForm2 = _interopRequireDefault(_marketoForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function (_React$Component) {
	    _inherits(WhiteLabelingLandingPage, _React$Component);
	
	    function WhiteLabelingLandingPage(props) {
	        _classCallCheck(this, WhiteLabelingLandingPage);
	
	        var _this = _possibleConstructorReturn(this, (WhiteLabelingLandingPage.__proto__ || Object.getPrototypeOf(WhiteLabelingLandingPage)).call(this, props));
	
	        _this.state = {
	            'contactUsModalIsShown': false
	        };
	        return _this;
	    }
	
	    _createClass(WhiteLabelingLandingPage, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var q = document.location.search;
	            if (q && q.indexOf('aliId=') >= 0) {
	                document.location.hash = '';
	                this.closeContactUsModal();
	            }
	
	            this.timerId = setInterval(function () {
	                var h = document.location.hash;
	                if (h === '#contact-us') {
	                    _this2.openContactUsModal();
	                }
	            }, 100);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearInterval(this.timerId);
	        }
	    }, {
	        key: 'openContactUsModal',
	        value: function openContactUsModal() {
	            this.setState({
	                'contactUsModalIsShown': true
	            });
	        }
	    }, {
	        key: 'closeContactUsModal',
	        value: function closeContactUsModal() {
	            this.setState({
	                'contactUsModalIsShown': false
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            var modalClassNames = (0, _classnames2['default'])({
	                'm-white-labeling--contact-modal': true,
	                'is-shown': this.state.contactUsModalIsShown === true
	            });
	
	            var contactUsModal = _react2['default'].createElement(
	                'div',
	                { className: modalClassNames },
	                _react2['default'].createElement('div', { className: 'm-white-labeling--contact-modal--overlay' }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-white-labeling--contact-modal--form' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-white-labeling--contact-modal--form--header' },
	                        'Contact us'
	                    ),
	                    _react2['default'].createElement(
	                        'a',
	                        { href: '#',
	                            onClick: this.closeContactUsModal.bind(this),
	                            className: 'm-white-labeling--contact-modal--form--close' },
	                        'x'
	                    ),
	                    _react2['default'].createElement(_marketoForm2['default'], { formId: 1139, trackingId: 'whitelabel-contactus' })
	                )
	            );
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'm-white-labeling' },
	                _react2['default'].createElement(
	                    'header',
	                    null,
	                    _react2['default'].createElement(
	                        'h1',
	                        null,
	                        _react2['default'].createElement(
	                            'span',
	                            { className: 'm-white-labeling-try' },
	                            'Try '
	                        ),
	                        'HelloSign\'s API White Labeling'
	                    ),
	                    _react2['default'].createElement(
	                        'h2',
	                        null,
	                        'Our signer page is customizable so it matches your color scheme exactly.'
	                    ),
	                    _react2['default'].createElement(
	                        'a',
	                        { href: '#contact-us' },
	                        _react2['default'].createElement(
	                            'button',
	                            { className: 'bg-cerulean c-white hc-white hbg-velvet-evening' },
	                            'Contact Us'
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'main',
	                    null,
	                    contactUsModal,
	                    _react2['default'].createElement(_whiteLabeling2['default'], null),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-white-labeling-copy' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'm-white-labeling-bulb-computer' },
	                            _react2['default'].createElement('img', {
	                                src: __webpack_require__(1522),
	                                'aria-hidden': true,
	                                className: 'white-labeling-bulb-icon' }),
	                            _react2['default'].createElement(
	                                'span',
	                                null,
	                                'To try the interactive demo, please use your computer.'
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'm-white-labeling-copy-text' },
	                            _react2['default'].createElement(
	                                'p',
	                                null,
	                                'We\'re dedicated to powering effortless document workflows from end-to-end. White labeling is just one feature empowering you to make your product or service easier for your users.'
	                            ),
	                            _react2['default'].createElement(
	                                'p',
	                                null,
	                                'HelloSign\'s white labeling feature allows API users to customize a signing flow with their branding, colors, and logo. That means your signers/users can seamlessly complete forms directly on your site. HelloSign is the only eSignature provider offering this level of flexibility in customization.'
	                            ),
	                            _react2['default'].createElement(
	                                'p',
	                                null,
	                                'Connect with sales to learn more about adding this feature or explore the ',
	                                _react2['default'].createElement(
	                                    'a',
	                                    { href: '/api/documentation' },
	                                    'API documentation'
	                                ),
	                                '.'
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'm-white-labeling-copy-cta' },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'quote-and-documentation' },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: 'quote-container' },
	                                    _react2['default'].createElement(
	                                        'h2',
	                                        null,
	                                        'Let\'s get you set up.'
	                                    ),
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: 'get-a-quote', id: 'm-get-a-quote' },
	                                        _react2['default'].createElement(
	                                            'h3',
	                                            null,
	                                            _react2['default'].createElement(
	                                                'span',
	                                                { className: 'mobile-cta' },
	                                                'SEE A DEMO'
	                                            ),
	                                            _react2['default'].createElement(
	                                                'span',
	                                                { className: 'regular-cta' },
	                                                'GET A QUOTE'
	                                            )
	                                        ),
	                                        _react2['default'].createElement(_marketoForm2['default'], { formId: 1157, trackingId: 'whitelabel-quote' })
	                                    )
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: 'documentation' },
	                                    _react2['default'].createElement(
	                                        'div',
	                                        { className: 'see-documentation' },
	                                        _react2['default'].createElement(
	                                            'h3',
	                                            null,
	                                            'SEE DOCUMENTATION'
	                                        ),
	                                        _react2['default'].createElement(
	                                            'button',
	                                            { className: 'bg-cerulean c-white hc-white hbg-velvet-evening' },
	                                            _react2['default'].createElement(
	                                                'a',
	                                                { href: '/api/reference#WhiteLabeling' },
	                                                'TAKE ME THERE'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return WhiteLabelingLandingPage;
	}(_react2['default'].Component);

/***/ },
/* 1272 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1273 */,
/* 1274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(1275);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _documentUi = __webpack_require__(1277);
	
	var _documentUi2 = _interopRequireDefault(_documentUi);
	
	var _colorPickerUi = __webpack_require__(1284);
	
	var _colorPickerUi2 = _interopRequireDefault(_colorPickerUi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WhiteLabelingApp = function (_React$Component) {
	    _inherits(WhiteLabelingApp, _React$Component);
	
	    function WhiteLabelingApp(props) {
	        _classCallCheck(this, WhiteLabelingApp);
	
	        var _this = _possibleConstructorReturn(this, (WhiteLabelingApp.__proto__ || Object.getPrototypeOf(WhiteLabelingApp)).call(this, props));
	
	        _this.state = {
	            selectedColor: '#000000',
	            blinkingComponent: 'DocumentHeader'
	        };
	        return _this;
	    }
	
	    _createClass(WhiteLabelingApp, [{
	        key: 'handleChange',
	        value: function handleChange(color) {
	            this.setColor('' + color.hex);
	        }
	    }, {
	        key: 'setColor',
	        value: function setColor(color) {
	            this.setState({ selectedColor: color });
	        }
	    }, {
	        key: 'changeBlinkingComponent',
	        value: function changeBlinkingComponent(component) {
	            if (component === 'DocumentHeader') {
	                this.setState({ blinkingComponent: 'ColorPickerUI' });
	            } else {
	                this.setState({ blinkingComponent: null });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var props = _extends({
	                handleChange: this.handleChange.bind(this),
	                setColor: this.setColor.bind(this),
	                changeBlinkingComponent: this.changeBlinkingComponent.bind(this)
	            }, this.state);
	            return _react2['default'].createElement(
	                'div',
	                { className: 'm-white-labeling-app' },
	                _react2['default'].createElement('img', {
	                    src: __webpack_require__(1521),
	                    'aria-hidden': true,
	                    className: 'white-labeling-gif'
	                }),
	                _react2['default'].createElement(_documentUi2['default'], props),
	                _react2['default'].createElement(_colorPickerUi2['default'], props)
	            );
	        }
	    }]);
	
	    return WhiteLabelingApp;
	}(_react2['default'].Component);
	
	module.exports = WhiteLabelingApp;

/***/ },
/* 1275 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1276 */,
/* 1277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _documentHeader = __webpack_require__(1278);
	
	var _documentHeader2 = _interopRequireDefault(_documentHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Space = _react2['default'].createElement(
	    'u',
	    null,
	    '\xA0'.repeat(10)
	);
	var DocumentBody = _react2['default'].createElement(
	    'div',
	    { className: 'm-document-body' },
	    _react2['default'].createElement(
	        'h1',
	        null,
	        'NON-DISCLOSURE AGREEMENT'
	    ),
	    _react2['default'].createElement(
	        'p',
	        null,
	        'THIS AGREEMENT (the "Agreement") is entered into on this',
	        Space,
	        ' day of ',
	        Space,
	        ' by and between ',
	        Space,
	        ', located at',
	        Space,
	        ' (the "Disclosing Party"), and ',
	        Space,
	        ' with and address at ',
	        Space,
	        ' (the "Recipient" or the "Receiving Party").'
	    ),
	    _react2['default'].createElement(
	        'p',
	        null,
	        'The Recipient hereto desires to participate in discussions regarding ',
	        Space,
	        ' (the "Transaction").During these discussions, Disclosing Party may share certain proprietary information with the Recipient.Therefore, in consideration of the mutual promises and covenants contained in this Agreement, and other good and valuable consideration, the receipt and sufficiency of which is hereby acknowledged, the parties hereto agree as follows:'
	    )
	);
	
	var DocumentUI = function (_React$Component) {
	    _inherits(DocumentUI, _React$Component);
	
	    function DocumentUI() {
	        _classCallCheck(this, DocumentUI);
	
	        return _possibleConstructorReturn(this, (DocumentUI.__proto__ || Object.getPrototypeOf(DocumentUI)).apply(this, arguments));
	    }
	
	    _createClass(DocumentUI, [{
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(
	                'section',
	                { className: 'm-document-container' },
	                _react2['default'].createElement(
	                    'h2',
	                    null,
	                    _react2['default'].createElement('img', { src: __webpack_require__(1282) }),
	                    _react2['default'].createElement(
	                        'span',
	                        null,
	                        'First, select an area or text below.'
	                    ),
	                    _react2['default'].createElement('img', { src: __webpack_require__(1283), className: 'arrow-1' })
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-document' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-document-inner' },
	                        _react2['default'].createElement(_documentHeader2['default'], this.props),
	                        DocumentBody
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DocumentUI;
	}(_react2['default'].Component);
	
	module.exports = DocumentUI;

/***/ },
/* 1278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _headerText = __webpack_require__(1279);
	
	var _headerText2 = _interopRequireDefault(_headerText);
	
	var _headerButton = __webpack_require__(1280);
	
	var _headerButton2 = _interopRequireDefault(_headerButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var outlineStyle = { outline: '8px solid #3b99fc' };
	var isComponentOutlined = function isComponentOutlined(props, component) {
	    return props.selectedComponent === component;
	};
	
	module.exports = function (_React$Component) {
	    _inherits(DocumentHeader, _React$Component);
	
	    function DocumentHeader(props) {
	        _classCallCheck(this, DocumentHeader);
	
	        var _this = _possibleConstructorReturn(this, (DocumentHeader.__proto__ || Object.getPrototypeOf(DocumentHeader)).call(this, props));
	
	        _this.intervals = [];
	        _this.name = 'Header';
	
	        _this.state = {
	            'selectedComponent': null,
	            'isHeaderOutlined': false,
	            'isBlinking': true,
	            'colors': {
	                'Header': '#000000',
	                'HeaderText': '#FFFFFF',
	                'Button': '#00B3E6',
	                'ButtonText': '#FFFFFF'
	            }
	        };
	        return _this;
	    }
	
	    _createClass(DocumentHeader, [{
	        key: 'clearIntervals',
	        value: function clearIntervals() {
	            this.intervals.forEach(clearInterval);
	            this.intervals = [];
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var blink = function blink() {
	                return _this2.setState({ isHeaderOutlined: !_this2.state.isHeaderOutlined });
	            };
	            this.intervals.push(setInterval(blink, 500));
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.clearIntervals();
	        }
	    }, {
	        key: 'handleClick',
	        value: function handleClick(event, component) {
	            event.stopPropagation();
	            var newState = Object.assign({}, this.state, { selectedComponent: component });
	            if (this.state.isBlinking) {
	                this.clearIntervals();
	                newState.isHeaderOutlined = false;
	                newState.isBlinking = false;
	                this.props.changeBlinkingComponent('DocumentHeader');
	            }
	            this.props.setColor(this.state.colors[component]);
	            this.setState(newState);
	        }
	    }, {
	        key: 'getColors',
	        value: function getColors() {
	            var colors = this.state.colors;
	            colors[this.state.selectedComponent] = this.props.selectedColor;
	            return colors;
	        }
	    }, {
	        key: 'getStyle',
	        value: function getStyle(colors) {
	            var state = this.state;
	            var headerStyle = {
	                'backgroundColor': colors[this.name]
	            };
	            if (state.isHeaderOutlined || isComponentOutlined(state, this.name)) {
	                headerStyle = Object.assign(headerStyle, outlineStyle);
	            }
	            return headerStyle;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var colors = this.getColors();
	            var headerStyle = this.getStyle(colors);
	            var props = _extends({
	                handleClick: this.handleClick.bind(this),
	                colors: colors,
	                isComponentOutlined: isComponentOutlined,
	                outlineStyle: outlineStyle
	            }, this.state);
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'm-document-header', onClick: function onClick(event) {
	                        return _this3.handleClick(event, _this3.name);
	                    }, style: headerStyle },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-document-header-left' },
	                    _react2['default'].createElement(
	                        'div',
	                        null,
	                        _react2['default'].createElement('img', { src: __webpack_require__(1281), 'aria-hidden': true })
	                    ),
	                    _react2['default'].createElement(_headerText2['default'], props)
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-document-header-right' },
	                    _react2['default'].createElement(_headerButton2['default'], props)
	                )
	            );
	        }
	    }]);
	
	    return DocumentHeader;
	}(_react2['default'].Component);

/***/ },
/* 1279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function (_React$Component) {
	    _inherits(HeaderText, _React$Component);
	
	    function HeaderText(props) {
	        _classCallCheck(this, HeaderText);
	
	        var _this = _possibleConstructorReturn(this, (HeaderText.__proto__ || Object.getPrototypeOf(HeaderText)).call(this, props));
	
	        _this.name = 'HeaderText';
	        return _this;
	    }
	
	    _createClass(HeaderText, [{
	        key: 'getParentStyle',
	        value: function getParentStyle() {
	            return this.props.isComponentOutlined(this.props, this.name) ? this.props.outlineStyle : void 0;
	        }
	    }, {
	        key: 'getParagraphStyle',
	        value: function getParagraphStyle(colors) {
	            return { color: colors[this.name] };
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var parentStyle = this.getParentStyle(this.props.colors);
	            var paragraphStyle = this.getParagraphStyle(this.props.colors);
	            return _react2['default'].createElement(
	                'div',
	                { style: parentStyle, onClick: function onClick(event) {
	                        return _this2.props.handleClick(event, _this2.name);
	                    } },
	                _react2['default'].createElement(
	                    'p',
	                    { style: paragraphStyle },
	                    'Welcome to the demo.'
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    { style: paragraphStyle },
	                    'You can change the color of this text by picking a color on the right.'
	                )
	            );
	        }
	    }]);
	
	    return HeaderText;
	}(_react2['default'].Component);

/***/ },
/* 1280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function (_React$Component) {
	    _inherits(HeaderButton, _React$Component);
	
	    function HeaderButton(props) {
	        _classCallCheck(this, HeaderButton);
	
	        var _this = _possibleConstructorReturn(this, (HeaderButton.__proto__ || Object.getPrototypeOf(HeaderButton)).call(this, props));
	
	        _this.buttonName = 'Button';
	        _this.buttonTextName = 'ButtonText';
	        return _this;
	    }
	
	    _createClass(HeaderButton, [{
	        key: 'getButtonStyle',
	        value: function getButtonStyle() {
	            var buttonStyle = { background: this.props.colors[this.buttonName] };
	            if (this.props.isComponentOutlined(this.props, this.buttonName)) {
	                buttonStyle = this.outline(buttonStyle);
	            }
	            return buttonStyle;
	        }
	    }, {
	        key: 'getButtonTextStyle',
	        value: function getButtonTextStyle() {
	            var buttonTextStyle = { color: this.props.colors[this.buttonTextName] };
	            if (this.props.isComponentOutlined(this.props, this.buttonTextName)) {
	                buttonTextStyle = this.outline(buttonTextStyle);
	            }
	            return buttonTextStyle;
	        }
	    }, {
	        key: 'outline',
	        value: function outline(style) {
	            return Object.assign(style, this.props.outlineStyle);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var buttonStyle = this.getButtonStyle();
	            var buttonTextStyle = this.getButtonTextStyle();
	            return _react2['default'].createElement(
	                'button',
	                { onClick: function onClick(event) {
	                        return _this2.props.handleClick(event, _this2.buttonName);
	                    },
	                    style: buttonStyle
	                },
	                _react2['default'].createElement(
	                    'span',
	                    { onClick: function onClick(event) {
	                            return _this2.props.handleClick(event, _this2.buttonTextName);
	                        },
	                        style: buttonTextStyle
	                    },
	                    'BUTTON TEXT'
	                )
	            );
	        }
	    }]);
	
	    return HeaderButton;
	}(_react2['default'].Component);

/***/ },
/* 1281 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/56ba8cdf5d156ea785dc2ef4fb882613.png";

/***/ },
/* 1282 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/3270d97ee4efd536329b585837af0bd2.png";

/***/ },
/* 1283 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/6c608144e9340537e90788a887ef1ce4.png";

/***/ },
/* 1284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactColor = __webpack_require__(1285);
	
	var _reactColor2 = _interopRequireDefault(_reactColor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var outlineStyle = '8px solid #3b99fc';
	
	var ColorPickerUI = function (_React$Component) {
	    _inherits(ColorPickerUI, _React$Component);
	
	    function ColorPickerUI(props) {
	        _classCallCheck(this, ColorPickerUI);
	
	        var _this = _possibleConstructorReturn(this, (ColorPickerUI.__proto__ || Object.getPrototypeOf(ColorPickerUI)).call(this, props));
	
	        _this.intervals = [];
	        _this.name = 'ColorPickerUI';
	        _this.state = {
	            isBlinking: false
	        };
	        return _this;
	    }
	
	    _createClass(ColorPickerUI, [{
	        key: 'clearIntervals',
	        value: function clearIntervals() {
	            this.intervals.forEach(clearInterval);
	            this.intervals = [];
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.clearIntervals();
	        }
	    }, {
	        key: 'shouldStartBlinking',
	        value: function shouldStartBlinking() {
	            return this.props.blinkingComponent === this.name && this.intervals.length === 0;
	        }
	    }, {
	        key: 'startBlinking',
	        value: function startBlinking() {
	            var _this2 = this;
	
	            var blink = function blink() {
	                return _this2.setState({ isBlinking: !_this2.state.isBlinking });
	            };
	            this.intervals.push(setInterval(blink, 500));
	        }
	    }, {
	        key: 'handleChange',
	        value: function handleChange(color) {
	            this.clearIntervals();
	            this.props.changeBlinkingComponent('ColorPickerUI');
	            this.setState({ isBlinking: false });
	            this.props.handleChange(color);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            if (this.shouldStartBlinking()) this.startBlinking();
	            var style = this.state.isBlinking ? { outline: outlineStyle } : {};
	
	            return _react2['default'].createElement(
	                'section',
	                { className: 'm-colorpicker-container' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2['default'].createElement(
	                        'div',
	                        null,
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'm-colorpicker-title', style: style },
	                            _react2['default'].createElement('img', { src: __webpack_require__(1519), 'aria-hidden': true }),
	                            _react2['default'].createElement(
	                                'span',
	                                null,
	                                'Then, pick a new color.'
	                            )
	                        ),
	                        _react2['default'].createElement('img', {
	                            src: __webpack_require__(1520),
	                            'aria-hidden': true,
	                            className: 'arrow-2'
	                        })
	                    ),
	                    _react2['default'].createElement(_reactColor2['default'], {
	                        className: 'm-colorpicker',
	                        display: true,
	                        type: 'chrome',
	                        onChange: function onChange(color) {
	                            return _this3.handleChange(color);
	                        },
	                        color: this.props.selectedColor,
	                        positionCSS: { position: 'static' },
	                        style: { width: 10, outline: outlineStyle }
	                    })
	                )
	            );
	        }
	    }]);
	
	    return ColorPickerUI;
	}(_react2['default'].Component);
	
	module.exports = ColorPickerUI;

/***/ },
/* 1285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.CustomPicker = exports.SwatchesPicker = exports.SliderPicker = exports.SketchPicker = exports.PhotoshopPicker = exports.MaterialPicker = exports.CompactPicker = exports.ChromePicker = undefined;
	
	var _Chrome = __webpack_require__(1286);
	
	Object.defineProperty(exports, 'ChromePicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Chrome).default;
	  }
	});
	
	var _Compact = __webpack_require__(1492);
	
	Object.defineProperty(exports, 'CompactPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Compact).default;
	  }
	});
	
	var _Material = __webpack_require__(1503);
	
	Object.defineProperty(exports, 'MaterialPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Material).default;
	  }
	});
	
	var _Photoshop = __webpack_require__(1504);
	
	Object.defineProperty(exports, 'PhotoshopPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Photoshop).default;
	  }
	});
	
	var _Sketch = __webpack_require__(1508);
	
	Object.defineProperty(exports, 'SketchPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Sketch).default;
	  }
	});
	
	var _Slider = __webpack_require__(1511);
	
	Object.defineProperty(exports, 'SliderPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Slider).default;
	  }
	});
	
	var _Swatches = __webpack_require__(1515);
	
	Object.defineProperty(exports, 'SwatchesPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Swatches).default;
	  }
	});
	
	var _ColorWrap = __webpack_require__(1483);
	
	Object.defineProperty(exports, 'CustomPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ColorWrap).default;
	  }
	});
	
	var _Chrome2 = _interopRequireDefault(_Chrome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Chrome2.default;

/***/ },
/* 1286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Chrome = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1287);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(1462);
	
	var _ChromeFields = __webpack_require__(1489);
	
	var _ChromeFields2 = _interopRequireDefault(_ChromeFields);
	
	var _ChromePointer = __webpack_require__(1490);
	
	var _ChromePointer2 = _interopRequireDefault(_ChromePointer);
	
	var _ChromePointerCircle = __webpack_require__(1491);
	
	var _ChromePointerCircle2 = _interopRequireDefault(_ChromePointerCircle);
	
	var _reactAddonsShallowCompare = __webpack_require__(1464);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Chrome = exports.Chrome = function (_React$Component) {
	  _inherits(Chrome, _React$Component);
	
	  function Chrome() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, Chrome);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Chrome)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleChange = function (data) {
	      _this.props.onChange(data);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Chrome, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          picker: {
	            background: '#fff',
	            borderRadius: '2px',
	            boxShadow: '0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)',
	            boxSizing: 'initial',
	            width: '225px',
	            fontFamily: 'Menlo'
	          },
	          saturation: {
	            width: '100%',
	            paddingBottom: '55%',
	            position: 'relative',
	            borderRadius: '2px 2px 0 0',
	            overflow: 'hidden'
	          },
	          Saturation: {
	            radius: '2px 2px 0 0'
	          },
	          body: {
	            padding: '16px 16px 12px'
	          },
	          controls: {
	            display: 'flex'
	          },
	          color: {
	            width: '32px'
	          },
	          swatch: {
	            marginTop: '6px',
	            width: '16px',
	            height: '16px',
	            borderRadius: '8px',
	            position: 'relative',
	            overflow: 'hidden'
	          },
	          active: {
	            absolute: '0px 0px 0px 0px',
	            borderRadius: '8px',
	            boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.1)',
	            background: 'rgba(' + this.props.rgb.r + ', ' + this.props.rgb.g + ', ' + this.props.rgb.b + ', ' + this.props.rgb.a + ')',
	            zIndex: '2'
	          },
	          toggles: {
	            flex: '1'
	          },
	          hue: {
	            height: '10px',
	            position: 'relative',
	            marginBottom: '8px'
	          },
	          Hue: {
	            radius: '2px'
	          },
	          alpha: {
	            height: '10px',
	            position: 'relative'
	          },
	          Alpha: {
	            radius: '2px'
	          }
	        },
	        'disableAlpha': {
	          color: {
	            width: '22px'
	          },
	          alpha: {
	            display: 'none'
	          },
	          hue: {
	            marginBottom: '0px'
	          },
	          swatch: {
	            width: '10px',
	            height: '10px',
	            marginTop: '0px'
	          }
	        }
	      }, this.props);
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.picker },
	        _react2.default.createElement(
	          'div',
	          { style: styles.saturation },
	          _react2.default.createElement(_common.Saturation, _extends({ style: styles.Saturation }, this.props, { pointer: _ChromePointerCircle2.default, onChange: this.handleChange }))
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.body },
	          _react2.default.createElement(
	            'div',
	            { style: styles.controls, className: 'flexbox-fix' },
	            _react2.default.createElement(
	              'div',
	              { style: styles.color },
	              _react2.default.createElement(
	                'div',
	                { style: styles.swatch },
	                _react2.default.createElement('div', { style: styles.active }),
	                _react2.default.createElement(_common.Checkboard, null)
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: styles.toggles },
	              _react2.default.createElement(
	                'div',
	                { style: styles.hue },
	                _react2.default.createElement(_common.Hue, _extends({ style: styles.Hue }, this.props, { pointer: _ChromePointer2.default, onChange: this.handleChange }))
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: styles.alpha },
	                _react2.default.createElement(_common.Alpha, _extends({ style: styles.Alpha }, this.props, { pointer: _ChromePointer2.default, onChange: this.handleChange }))
	              )
	            )
	          ),
	          _react2.default.createElement(_ChromeFields2.default, _extends({}, this.props, { onChange: this.handleChange, disableAlpha: this.props.disableAlpha }))
	        )
	      );
	    }
	  }]);
	
	  return Chrome;
	}(_react2.default.Component);
	
	exports.default = (0, _common.ColorWrap)(Chrome);

/***/ },
/* 1287 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{"default":e}}Object.defineProperty(exports,"__esModule",{value:!0}),exports.ReactCSS=exports.loop=exports.handleActive=exports.handleHover=exports.hover=exports.Component=void 0;var _objectAssign=__webpack_require__(306),_objectAssign2=_interopRequireDefault(_objectAssign),_flattenNames=__webpack_require__(1288),_flattenNames2=_interopRequireDefault(_flattenNames),_mergeClasses=__webpack_require__(1413),_mergeClasses2=_interopRequireDefault(_mergeClasses),_autoprefix=__webpack_require__(1446),_autoprefix2=_interopRequireDefault(_autoprefix),_Component2=__webpack_require__(1447),_Component3=_interopRequireDefault(_Component2),_hover2=__webpack_require__(1459),_hover3=_interopRequireDefault(_hover2),_active=__webpack_require__(1460),_active2=_interopRequireDefault(_active),_loop2=__webpack_require__(1461),_loop3=_interopRequireDefault(_loop2);exports.Component=_Component3["default"],exports.hover=_hover3["default"],exports.handleHover=_hover3["default"],exports.handleActive=_active2["default"],exports.loop=_loop3["default"];var ReactCSS=exports.ReactCSS=function(e){for(var t=arguments.length,r=Array(t>1?t-1:0),o=1;o<t;o++)r[o-1]=arguments[o];var a=(0,_flattenNames2["default"])(r),s=(0,_mergeClasses2["default"])(e,a);return(0,_autoprefix2["default"])(s)};ReactCSS.m=_objectAssign2["default"],exports["default"]=ReactCSS;

/***/ },
/* 1288 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{"default":e}}Object.defineProperty(exports,"__esModule",{value:!0}),exports.flattenNames=void 0;var _map=__webpack_require__(1289),_map2=_interopRequireDefault(_map),_isPlainObject=__webpack_require__(1410),_isPlainObject2=_interopRequireDefault(_isPlainObject),_isString=__webpack_require__(1412),_isString2=_interopRequireDefault(_isString),flattenNames=exports.flattenNames=function e(t){var i=[];return t.map(function(t){return Array.isArray(t)&&e(t).map(function(e){return i.push(e)}),(0,_isPlainObject2["default"])(t)&&(0,_map2["default"])(t,function(e,t){e===!0&&i.push(t),i.push(t+"-"+e)}),(0,_isString2["default"])(t)&&i.push(t),t}),i};exports["default"]=flattenNames;

/***/ },
/* 1289 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(1290),
	    baseIteratee = __webpack_require__(1291),
	    baseMap = __webpack_require__(1404),
	    isArray = __webpack_require__(1354);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ },
/* 1290 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 1291 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(1292),
	    baseMatchesProperty = __webpack_require__(1385),
	    identity = __webpack_require__(1400),
	    isArray = __webpack_require__(1354),
	    property = __webpack_require__(1401);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 1292 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(1293),
	    getMatchData = __webpack_require__(1382),
	    matchesStrictComparable = __webpack_require__(1384);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 1293 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(1294),
	    baseIsEqual = __webpack_require__(1338);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 1294 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(1295),
	    stackClear = __webpack_require__(1303),
	    stackDelete = __webpack_require__(1304),
	    stackGet = __webpack_require__(1305),
	    stackHas = __webpack_require__(1306),
	    stackSet = __webpack_require__(1307);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 1295 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(1296),
	    listCacheDelete = __webpack_require__(1297),
	    listCacheGet = __webpack_require__(1300),
	    listCacheHas = __webpack_require__(1301),
	    listCacheSet = __webpack_require__(1302);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 1296 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 1297 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(1298);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 1298 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(1299);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 1299 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 1300 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(1298);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 1301 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(1298);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 1302 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(1298);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 1303 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(1295);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 1304 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 1305 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 1306 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 1307 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(1295),
	    Map = __webpack_require__(1308),
	    MapCache = __webpack_require__(1323);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 1308 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(1309),
	    root = __webpack_require__(1314);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 1309 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(1310),
	    getValue = __webpack_require__(1322);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 1310 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(1311),
	    isMasked = __webpack_require__(1319),
	    isObject = __webpack_require__(1318),
	    toSource = __webpack_require__(1321);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 1311 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(1312),
	    isObject = __webpack_require__(1318);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 1312 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(1313),
	    getRawTag = __webpack_require__(1316),
	    objectToString = __webpack_require__(1317);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 1313 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(1314);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 1314 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(1315);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 1315 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1316 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(1313);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 1317 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 1318 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 1319 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(1320);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 1320 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(1314);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 1321 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 1322 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 1323 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(1324),
	    mapCacheDelete = __webpack_require__(1332),
	    mapCacheGet = __webpack_require__(1335),
	    mapCacheHas = __webpack_require__(1336),
	    mapCacheSet = __webpack_require__(1337);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 1324 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(1325),
	    ListCache = __webpack_require__(1295),
	    Map = __webpack_require__(1308);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 1325 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(1326),
	    hashDelete = __webpack_require__(1328),
	    hashGet = __webpack_require__(1329),
	    hashHas = __webpack_require__(1330),
	    hashSet = __webpack_require__(1331);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 1326 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(1327);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 1327 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(1309);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 1328 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 1329 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(1327);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 1330 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(1327);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 1331 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(1327);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 1332 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(1333);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 1333 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(1334);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 1334 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 1335 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(1333);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 1336 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(1333);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 1337 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(1333);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 1338 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(1339),
	    isObjectLike = __webpack_require__(1363);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 1339 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(1294),
	    equalArrays = __webpack_require__(1340),
	    equalByTag = __webpack_require__(1346),
	    equalObjects = __webpack_require__(1350),
	    getTag = __webpack_require__(1377),
	    isArray = __webpack_require__(1354),
	    isBuffer = __webpack_require__(1364),
	    isTypedArray = __webpack_require__(1367);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 1340 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(1341),
	    arraySome = __webpack_require__(1344),
	    cacheHas = __webpack_require__(1345);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 1341 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(1323),
	    setCacheAdd = __webpack_require__(1342),
	    setCacheHas = __webpack_require__(1343);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 1342 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 1343 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 1344 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 1345 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 1346 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(1313),
	    Uint8Array = __webpack_require__(1347),
	    eq = __webpack_require__(1299),
	    equalArrays = __webpack_require__(1340),
	    mapToArray = __webpack_require__(1348),
	    setToArray = __webpack_require__(1349);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 1347 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(1314);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 1348 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 1349 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 1350 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(1351);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 1351 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(1352),
	    getSymbols = __webpack_require__(1355),
	    keys = __webpack_require__(1358);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 1352 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(1353),
	    isArray = __webpack_require__(1354);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 1353 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 1354 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 1355 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(1356),
	    stubArray = __webpack_require__(1357);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 1356 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 1357 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 1358 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(1359),
	    baseKeys = __webpack_require__(1372),
	    isArrayLike = __webpack_require__(1376);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 1359 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(1360),
	    isArguments = __webpack_require__(1361),
	    isArray = __webpack_require__(1354),
	    isBuffer = __webpack_require__(1364),
	    isIndex = __webpack_require__(1366),
	    isTypedArray = __webpack_require__(1367);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 1360 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 1361 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(1362),
	    isObjectLike = __webpack_require__(1363);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 1362 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(1312),
	    isObjectLike = __webpack_require__(1363);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 1363 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 1364 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(1314),
	    stubFalse = __webpack_require__(1365);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(705)(module)))

/***/ },
/* 1365 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 1366 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 1367 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(1368),
	    baseUnary = __webpack_require__(1370),
	    nodeUtil = __webpack_require__(1371);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 1368 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(1312),
	    isLength = __webpack_require__(1369),
	    isObjectLike = __webpack_require__(1363);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 1369 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 1370 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 1371 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(1315);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(705)(module)))

/***/ },
/* 1372 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(1373),
	    nativeKeys = __webpack_require__(1374);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 1373 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 1374 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(1375);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 1375 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 1376 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(1311),
	    isLength = __webpack_require__(1369);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 1377 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(1378),
	    Map = __webpack_require__(1308),
	    Promise = __webpack_require__(1379),
	    Set = __webpack_require__(1380),
	    WeakMap = __webpack_require__(1381),
	    baseGetTag = __webpack_require__(1312),
	    toSource = __webpack_require__(1321);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 1378 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(1309),
	    root = __webpack_require__(1314);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 1379 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(1309),
	    root = __webpack_require__(1314);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 1380 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(1309),
	    root = __webpack_require__(1314);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 1381 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(1309),
	    root = __webpack_require__(1314);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 1382 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(1383),
	    keys = __webpack_require__(1358);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 1383 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(1318);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 1384 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 1385 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(1338),
	    get = __webpack_require__(1386),
	    hasIn = __webpack_require__(1397),
	    isKey = __webpack_require__(1389),
	    isStrictComparable = __webpack_require__(1383),
	    matchesStrictComparable = __webpack_require__(1384),
	    toKey = __webpack_require__(1396);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 1386 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(1387);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 1387 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(1388),
	    toKey = __webpack_require__(1396);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 1388 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(1354),
	    isKey = __webpack_require__(1389),
	    stringToPath = __webpack_require__(1391),
	    toString = __webpack_require__(1394);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 1389 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(1354),
	    isSymbol = __webpack_require__(1390);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 1390 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(1312),
	    isObjectLike = __webpack_require__(1363);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 1391 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(1392);
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 1392 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(1393);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 1393 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(1323);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 1394 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(1395);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 1395 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(1313),
	    arrayMap = __webpack_require__(1290),
	    isArray = __webpack_require__(1354),
	    isSymbol = __webpack_require__(1390);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 1396 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(1390);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 1397 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(1398),
	    hasPath = __webpack_require__(1399);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 1398 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 1399 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(1388),
	    isArguments = __webpack_require__(1361),
	    isArray = __webpack_require__(1354),
	    isIndex = __webpack_require__(1366),
	    isLength = __webpack_require__(1369),
	    toKey = __webpack_require__(1396);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 1400 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 1401 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(1402),
	    basePropertyDeep = __webpack_require__(1403),
	    isKey = __webpack_require__(1389),
	    toKey = __webpack_require__(1396);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 1402 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 1403 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(1387);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 1404 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(1405),
	    isArrayLike = __webpack_require__(1376);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 1405 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(1406),
	    createBaseEach = __webpack_require__(1409);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 1406 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(1407),
	    keys = __webpack_require__(1358);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 1407 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(1408);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 1408 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 1409 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(1376);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 1410 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(1312),
	    getPrototype = __webpack_require__(1411),
	    isObjectLike = __webpack_require__(1363);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 1411 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(1375);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 1412 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(1312),
	    isArray = __webpack_require__(1354),
	    isObjectLike = __webpack_require__(1363);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 1413 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{"default":e}}Object.defineProperty(exports,"__esModule",{value:!0}),exports.mergeClasses=void 0;var _map=__webpack_require__(1289),_map2=_interopRequireDefault(_map),_cloneDeep=__webpack_require__(1414),_cloneDeep2=_interopRequireDefault(_cloneDeep),_objectAssign=__webpack_require__(306),_objectAssign2=_interopRequireDefault(_objectAssign),mergeClasses=exports.mergeClasses=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[],r=e["default"]&&(0,_cloneDeep2["default"])(e["default"])||{};return t.map(function(t){var s=e[t];return s&&(0,_map2["default"])(s,function(e,t){r[t]||(r[t]={}),(0,_objectAssign2["default"])(r[t],s[t])}),t}),r};exports["default"]=mergeClasses;

/***/ },
/* 1414 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(1415);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep(value) {
	  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = cloneDeep;


/***/ },
/* 1415 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(1294),
	    arrayEach = __webpack_require__(1416),
	    assignValue = __webpack_require__(1417),
	    baseAssign = __webpack_require__(1420),
	    baseAssignIn = __webpack_require__(1422),
	    cloneBuffer = __webpack_require__(1426),
	    copyArray = __webpack_require__(1427),
	    copySymbols = __webpack_require__(1428),
	    copySymbolsIn = __webpack_require__(1429),
	    getAllKeys = __webpack_require__(1351),
	    getAllKeysIn = __webpack_require__(1431),
	    getTag = __webpack_require__(1377),
	    initCloneArray = __webpack_require__(1432),
	    initCloneByTag = __webpack_require__(1433),
	    initCloneObject = __webpack_require__(1444),
	    isArray = __webpack_require__(1354),
	    isBuffer = __webpack_require__(1364),
	    isObject = __webpack_require__(1318),
	    keys = __webpack_require__(1358);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ },
/* 1416 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 1417 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(1418),
	    eq = __webpack_require__(1299);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 1418 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(1419);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },
/* 1419 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(1309);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 1420 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(1421),
	    keys = __webpack_require__(1358);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 1421 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(1417),
	    baseAssignValue = __webpack_require__(1418);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 1422 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(1421),
	    keysIn = __webpack_require__(1423);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ },
/* 1423 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(1359),
	    baseKeysIn = __webpack_require__(1424),
	    isArrayLike = __webpack_require__(1376);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ },
/* 1424 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(1318),
	    isPrototype = __webpack_require__(1373),
	    nativeKeysIn = __webpack_require__(1425);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 1425 */
/***/ function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ },
/* 1426 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(1314);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(705)(module)))

/***/ },
/* 1427 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 1428 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(1421),
	    getSymbols = __webpack_require__(1355);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ },
/* 1429 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(1421),
	    getSymbolsIn = __webpack_require__(1430);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ },
/* 1430 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(1353),
	    getPrototype = __webpack_require__(1411),
	    getSymbols = __webpack_require__(1355),
	    stubArray = __webpack_require__(1357);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ },
/* 1431 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(1352),
	    getSymbolsIn = __webpack_require__(1430),
	    keysIn = __webpack_require__(1423);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ },
/* 1432 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ },
/* 1433 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(1434),
	    cloneDataView = __webpack_require__(1435),
	    cloneMap = __webpack_require__(1436),
	    cloneRegExp = __webpack_require__(1439),
	    cloneSet = __webpack_require__(1440),
	    cloneSymbol = __webpack_require__(1442),
	    cloneTypedArray = __webpack_require__(1443);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ },
/* 1434 */
/***/ function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(1347);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ },
/* 1435 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(1434);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ },
/* 1436 */
/***/ function(module, exports, __webpack_require__) {

	var addMapEntry = __webpack_require__(1437),
	    arrayReduce = __webpack_require__(1438),
	    mapToArray = __webpack_require__(1348);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	module.exports = cloneMap;


/***/ },
/* 1437 */
/***/ function(module, exports) {

	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `map.set` because it's not chainable in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	module.exports = addMapEntry;


/***/ },
/* 1438 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ },
/* 1439 */
/***/ function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ },
/* 1440 */
/***/ function(module, exports, __webpack_require__) {

	var addSetEntry = __webpack_require__(1441),
	    arrayReduce = __webpack_require__(1438),
	    setToArray = __webpack_require__(1349);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	module.exports = cloneSet;


/***/ },
/* 1441 */
/***/ function(module, exports) {

	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  // Don't return `set.add` because it's not chainable in IE 11.
	  set.add(value);
	  return set;
	}
	
	module.exports = addSetEntry;


/***/ },
/* 1442 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(1313);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ },
/* 1443 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(1434);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ },
/* 1444 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(1445),
	    getPrototype = __webpack_require__(1411),
	    isPrototype = __webpack_require__(1373);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },
/* 1445 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(1318);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ },
/* 1446 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{"default":e}}Object.defineProperty(exports,"__esModule",{value:!0}),exports.autoprefix=void 0;var _map=__webpack_require__(1289),_map2=_interopRequireDefault(_map),_objectAssign=__webpack_require__(306),_objectAssign2=_interopRequireDefault(_objectAssign),transforms={borderRadius:function(e){return{msBorderRadius:e,MozBorderRadius:e,OBorderRadius:e,WebkitBorderRadius:e,borderRadius:e}},boxShadow:function(e){return{msBoxShadow:e,MozBoxShadow:e,OBoxShadow:e,WebkitBoxShadow:e,boxShadow:e}},userSelect:function(e){return{WebkitTouchCallout:e,KhtmlUserSelect:e,MozUserSelect:e,msUserSelect:e,WebkitUserSelect:e,userSelect:e}},flex:function(e){return{WebkitBoxFlex:e,MozBoxFlex:e,WebkitFlex:e,msFlex:e,flex:e}},flexBasis:function(e){return{WebkitFlexBasis:e,flexBasis:e}},justifyContent:function(e){return{WebkitJustifyContent:e,justifyContent:e}},transition:function(e){return{msTransition:e,MozTransition:e,OTransition:e,WebkitTransition:e,transition:e}},transform:function(e){return{msTransform:e,MozTransform:e,OTransform:e,WebkitTransform:e,transform:e}},absolute:function(e){var t=e&&e.split(" ");return{position:"absolute",top:t&&t[0],right:t&&t[1],bottom:t&&t[2],left:t&&t[3]}},extend:function(e,t){var r=t[e];return r?r:{extend:e}}},autoprefix=exports.autoprefix=function(e){var t={};return(0,_map2["default"])(e,function(e,r){var o={};(0,_map2["default"])(e,function(e,t){var r=transforms[t];r?(0,_objectAssign2["default"])(o,r(e)):o[t]=e}),t[r]=o}),t};exports["default"]=autoprefix;

/***/ },
/* 1447 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{"default":e}}function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function _possibleConstructorReturn(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function _inherits(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.ReactCSSComponent=void 0;var _createClass=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),_react=__webpack_require__(304),_react2=_interopRequireDefault(_react),_inline=__webpack_require__(1448),_inline2=_interopRequireDefault(_inline),_once=__webpack_require__(1454),_once2=_interopRequireDefault(_once),warning=(0,_once2["default"])(function(){return console.warn("Extending ReactCSS.Component\n  is deprecated in ReactCSS 1.0.0")}),ReactCSSComponent=exports.ReactCSSComponent=function(e){function t(){return _classCallCheck(this,t),_possibleConstructorReturn(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return _inherits(t,e),_createClass(t,[{key:"css",value:function(e){return warning(),_inline2["default"].call(this,e)}},{key:"styles",value:function(){return this.css()}}]),t}(_react2["default"].Component);ReactCSSComponent.contextTypes={mixins:_react2["default"].PropTypes.object},exports["default"]=ReactCSSComponent;

/***/ },
/* 1448 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{"default":e}}var _isObject=__webpack_require__(1318),_isObject2=_interopRequireDefault(_isObject),_checkClassStructure=__webpack_require__(1449),_checkClassStructure2=_interopRequireDefault(_checkClassStructure),_combine=__webpack_require__(1450),_combine2=_interopRequireDefault(_combine);module.exports=function(e){var s=this,t=[];if(!this.classes)throw console.warn("Define this.classes on `"+this.constructor.name+"`");(0,_checkClassStructure2["default"])(this.classes());var r=function(e,r){s.classes()[e]?t.push(s.classes()[e]):e&&r&&r.warn===!0&&console.warn("The `"+e+"` css class does not exist on `"+s.constructor.name+"`")};r("default");for(var i in this.props){var c=this.props[i];(0,_isObject2["default"])(c)||(c===!0?(r(i),r(i+"-true")):r(c?i+"-"+c:i+"-false"))}if(this.props&&this.props.activeBounds)for(var o=0;o<this.props.activeBounds.length;o++){var n=this.props.activeBounds[o];r(n)}for(var a in e){var u=e[a];u===!0&&r(a,{warn:!0})}var l={};return this.context&&this.context.mixins&&(l=this.context.mixins),(0,_combine2["default"])(t,l)};

/***/ },
/* 1449 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{"default":e}}Object.defineProperty(exports,"__esModule",{value:!0}),exports.checkClassStructure=void 0;var _map=__webpack_require__(1289),_map2=_interopRequireDefault(_map),_isObject=__webpack_require__(1318),_isObject2=_interopRequireDefault(_isObject),checkClassStructure=exports.checkClassStructure=function(e){(0,_map2["default"])(e,function(t,s){e.hasOwnProperty(s)&&((0,_isObject2["default"])(t)?(0,_map2["default"])(t,function(e,u){t.hasOwnProperty(u)&&((0,_isObject2["default"])(e)||console.warn("Make sure the value of the element `"+s+"`\n                is an object of css. You passed it `"+t+"`"))}):console.warn("Make sure the value of `"+s+"` is an object of\n          html elements. You passed it `"+t+"`"))})};exports["default"]=checkClassStructure;

/***/ },
/* 1450 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{"default":e}}Object.defineProperty(exports,"__esModule",{value:!0}),exports.combine=void 0;var _merge=__webpack_require__(1451),_merge2=_interopRequireDefault(_merge),_transformMixins=__webpack_require__(1453),_transformMixins2=_interopRequireDefault(_transformMixins),combine=exports.combine=function(e,r){var i=(0,_merge2["default"])(e);return(0,_transformMixins2["default"])(i,r)};exports["default"]=combine;

/***/ },
/* 1451 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{"default":e}}Object.defineProperty(exports,"__esModule",{value:!0});var _merge=__webpack_require__(1452),_merge2=_interopRequireDefault(_merge),_isObject=__webpack_require__(1318),_isObject2=_interopRequireDefault(_isObject),merge=function(e){return(0,_isObject2["default"])(e)&&!Array.isArray(e)?e:1===e.length?e[0]:_merge2["default"].recursive.apply(void 0,e)};exports["default"]=merge;

/***/ },
/* 1452 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/*!
	 * @name JavaScript/NodeJS Merge v1.2.0
	 * @author yeikos
	 * @repository https://github.com/yeikos/js.merge
	
	 * Copyright 2014 yeikos - MIT license
	 * https://raw.github.com/yeikos/js.merge/master/LICENSE
	 */
	
	;(function(isNode) {
	
		/**
		 * Merge one or more objects 
		 * @param bool? clone
		 * @param mixed,... arguments
		 * @return object
		 */
	
		var Public = function(clone) {
	
			return merge(clone === true, false, arguments);
	
		}, publicName = 'merge';
	
		/**
		 * Merge two or more objects recursively 
		 * @param bool? clone
		 * @param mixed,... arguments
		 * @return object
		 */
	
		Public.recursive = function(clone) {
	
			return merge(clone === true, true, arguments);
	
		};
	
		/**
		 * Clone the input removing any reference
		 * @param mixed input
		 * @return mixed
		 */
	
		Public.clone = function(input) {
	
			var output = input,
				type = typeOf(input),
				index, size;
	
			if (type === 'array') {
	
				output = [];
				size = input.length;
	
				for (index=0;index<size;++index)
	
					output[index] = Public.clone(input[index]);
	
			} else if (type === 'object') {
	
				output = {};
	
				for (index in input)
	
					output[index] = Public.clone(input[index]);
	
			}
	
			return output;
	
		};
	
		/**
		 * Merge two objects recursively
		 * @param mixed input
		 * @param mixed extend
		 * @return mixed
		 */
	
		function merge_recursive(base, extend) {
	
			if (typeOf(base) !== 'object')
	
				return extend;
	
			for (var key in extend) {
	
				if (typeOf(base[key]) === 'object' && typeOf(extend[key]) === 'object') {
	
					base[key] = merge_recursive(base[key], extend[key]);
	
				} else {
	
					base[key] = extend[key];
	
				}
	
			}
	
			return base;
	
		}
	
		/**
		 * Merge two or more objects
		 * @param bool clone
		 * @param bool recursive
		 * @param array argv
		 * @return object
		 */
	
		function merge(clone, recursive, argv) {
	
			var result = argv[0],
				size = argv.length;
	
			if (clone || typeOf(result) !== 'object')
	
				result = {};
	
			for (var index=0;index<size;++index) {
	
				var item = argv[index],
	
					type = typeOf(item);
	
				if (type !== 'object') continue;
	
				for (var key in item) {
	
					var sitem = clone ? Public.clone(item[key]) : item[key];
	
					if (recursive) {
	
						result[key] = merge_recursive(result[key], sitem);
	
					} else {
	
						result[key] = sitem;
	
					}
	
				}
	
			}
	
			return result;
	
		}
	
		/**
		 * Get type of variable
		 * @param mixed input
		 * @return string
		 *
		 * @see http://jsperf.com/typeofvar
		 */
	
		function typeOf(input) {
	
			return ({}).toString.call(input).slice(8, -1).toLowerCase();
	
		}
	
		if (isNode) {
	
			module.exports = Public;
	
		} else {
	
			window[publicName] = Public;
	
		}
	
	})(typeof module === 'object' && module && typeof module.exports === 'object' && module.exports);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(705)(module)))

/***/ },
/* 1453 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{"default":e}}var _isObject=__webpack_require__(1318),_isObject2=_interopRequireDefault(_isObject),_merge=__webpack_require__(1452),_merge2=_interopRequireDefault(_merge),localProps={borderRadius:function(e){if(null!==e)return{msBorderRadius:e,MozBorderRadius:e,OBorderRadius:e,WebkitBorderRadius:e,borderRadius:e}},boxShadow:function(e){if(null!==e)return{msBoxShadow:e,MozBoxShadow:e,OBoxShadow:e,WebkitBoxShadow:e,boxShadow:e}},userSelect:function(e){if(null!==e)return{WebkitTouchCallout:e,KhtmlUserSelect:e,MozUserSelect:e,msUserSelect:e,WebkitUserSelect:e,userSelect:e}},flex:function(e){if(null!==e)return{WebkitBoxFlex:e,MozBoxFlex:e,WebkitFlex:e,msFlex:e,flex:e}},flexBasis:function(e){if(null!==e)return{WebkitFlexBasis:e,flexBasis:e}},justifyContent:function(e){if(null!==e)return{WebkitJustifyContent:e,justifyContent:e}},transition:function(e){if(null!==e)return{msTransition:e,MozTransition:e,OTransition:e,WebkitTransition:e,transition:e}},transform:function(e){if(null!==e)return{msTransform:e,MozTransform:e,OTransform:e,WebkitTransform:e,transform:e}},Absolute:function(e){if(null!==e){var r=e.split(" ");return{position:"absolute",top:r[0],right:r[1],bottom:r[2],left:r[3]}}},Extend:function(e,r){var t=r[e];if(t)return t}},transform=function e(r,t,n){var i=(0,_merge2["default"])(t,localProps),o={};for(var u in r){var s=r[u];if((0,_isObject2["default"])(s)&&!Array.isArray(s))o[u]=e(s,t,r);else if(i[u]){var l=i[u](s,n);for(var a in l){var f=l[a];o[a]=f}}else o[u]=s}return o};module.exports=function(e,r,t){return transform(e,r,t)};

/***/ },
/* 1454 */
/***/ function(module, exports, __webpack_require__) {

	var before = __webpack_require__(1455);
	
	/**
	 * Creates a function that is restricted to invoking `func` once. Repeat calls
	 * to the function return the value of the first invocation. The `func` is
	 * invoked with the `this` binding and arguments of the created function.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new restricted function.
	 * @example
	 *
	 * var initialize = _.once(createApplication);
	 * initialize();
	 * initialize();
	 * // => `createApplication` is invoked once
	 */
	function once(func) {
	  return before(2, func);
	}
	
	module.exports = once;


/***/ },
/* 1455 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(1456);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that invokes `func`, with the `this` binding and arguments
	 * of the created function, while it's called less than `n` times. Subsequent
	 * calls to the created function return the result of the last `func` invocation.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {number} n The number of calls at which `func` is no longer invoked.
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new restricted function.
	 * @example
	 *
	 * jQuery(element).on('click', _.before(5, addContactToList));
	 * // => Allows adding up to 4 contacts to the list.
	 */
	function before(n, func) {
	  var result;
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  n = toInteger(n);
	  return function() {
	    if (--n > 0) {
	      result = func.apply(this, arguments);
	    }
	    if (n <= 1) {
	      func = undefined;
	    }
	    return result;
	  };
	}
	
	module.exports = before;


/***/ },
/* 1456 */
/***/ function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(1457);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ },
/* 1457 */
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(1458);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },
/* 1458 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(1318),
	    isSymbol = __webpack_require__(1390);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 1459 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{"default":e}}function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function _possibleConstructorReturn(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function _inherits(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.hover=void 0;var _extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var o in r)Object.prototype.hasOwnProperty.call(r,o)&&(e[o]=r[o])}return e},_react=__webpack_require__(304),_react2=_interopRequireDefault(_react),hover=exports.hover=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"span";return function(r){function o(){var r,n,u,a;_classCallCheck(this,o);for(var s=arguments.length,c=Array(s),i=0;i<s;i++)c[i]=arguments[i];return n=u=_possibleConstructorReturn(this,(r=o.__proto__||Object.getPrototypeOf(o)).call.apply(r,[this].concat(c))),u.state={hover:!1},u.handleMouseOver=function(){return u.setState({hover:!0})},u.handleMouseOut=function(){return u.setState({hover:!1})},u.render=function(){return _react2["default"].createElement(t,{onMouseOver:u.handleMouseOver,onMouseOut:u.handleMouseOut},_react2["default"].createElement(e,_extends({},u.props,u.state)))},a=n,_possibleConstructorReturn(u,a)}return _inherits(o,r),o}(_react2["default"].Component)};exports["default"]=hover;

/***/ },
/* 1460 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{"default":e}}function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function _possibleConstructorReturn(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function _inherits(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.active=void 0;var _extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},_react=__webpack_require__(304),_react2=_interopRequireDefault(_react),active=exports.active=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"span";return function(r){function n(){var r,o,a,c;_classCallCheck(this,n);for(var u=arguments.length,s=Array(u),i=0;i<u;i++)s[i]=arguments[i];return o=a=_possibleConstructorReturn(this,(r=n.__proto__||Object.getPrototypeOf(n)).call.apply(r,[this].concat(s))),a.state={active:!1},a.handleMouseDown=function(){return a.setState({active:!0})},a.handleMouseUp=function(){return a.setState({active:!1})},a.render=function(){return _react2["default"].createElement(t,{onMouseDown:a.handleMouseDown,onMouseUp:a.handleMouseUp},_react2["default"].createElement(e,_extends({},a.props,a.state)))},c=o,_possibleConstructorReturn(a,c)}return _inherits(n,r),n}(_react2["default"].Component)};exports["default"]=active;

/***/ },
/* 1461 */
/***/ function(module, exports) {

	"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var loopable=function(e,t){var l={},o=function(e){var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];l[e]=t};return 0===e&&o("first-child"),e===t-1&&o("last-child"),(0===e||e%2===0)&&o("even"),1===Math.abs(e%2)&&o("odd"),o("nth-child",e),l};exports["default"]=loopable;

/***/ },
/* 1462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Alpha = __webpack_require__(1463);
	
	Object.defineProperty(exports, 'Alpha', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Alpha).default;
	  }
	});
	
	var _Checkboard = __webpack_require__(1466);
	
	Object.defineProperty(exports, 'Checkboard', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Checkboard).default;
	  }
	});
	
	var _EditableInput = __webpack_require__(1467);
	
	Object.defineProperty(exports, 'EditableInput', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_EditableInput).default;
	  }
	});
	
	var _Hue = __webpack_require__(1468);
	
	Object.defineProperty(exports, 'Hue', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Hue).default;
	  }
	});
	
	var _Saturation = __webpack_require__(1469);
	
	Object.defineProperty(exports, 'Saturation', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Saturation).default;
	  }
	});
	
	var _ColorWrap = __webpack_require__(1483);
	
	Object.defineProperty(exports, 'ColorWrap', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ColorWrap).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Alpha = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1287);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1464);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _Checkboard = __webpack_require__(1466);
	
	var _Checkboard2 = _interopRequireDefault(_Checkboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Alpha = exports.Alpha = function (_React$Component) {
	  _inherits(Alpha, _React$Component);
	
	  function Alpha() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, Alpha);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Alpha)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleChange = function (e, skip) {
	      !skip && e.preventDefault();
	      var container = _this.refs.container;
	      var containerWidth = container.clientWidth;
	      var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
	      var inIFrame = window.self !== window.top || window.document !== container.ownerDocument;
	      var left = x - (container.getBoundingClientRect().left + (inIFrame ? 0 : window.pageXOffset));
	
	      var a;
	      if (left < 0) {
	        a = 0;
	      } else if (left > containerWidth) {
	        a = 1;
	      } else {
	        a = Math.round(left * 100 / containerWidth) / 100;
	      }
	
	      if (_this.props.a !== a) {
	        _this.props.onChange({
	          h: _this.props.hsl.h,
	          s: _this.props.hsl.s,
	          l: _this.props.hsl.l,
	          a: a,
	          source: 'rgb'
	        });
	      }
	    }, _this.handleMouseDown = function (e) {
	      _this.handleChange(e, true);
	      window.addEventListener('mousemove', _this.handleChange);
	      window.addEventListener('mouseup', _this.handleMouseUp);
	    }, _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    }, _this.unbindEventListeners = function () {
	      window.removeEventListener('mousemove', _this.handleChange);
	      window.removeEventListener('mouseup', _this.handleMouseUp);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Alpha, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          alpha: {
	            absolute: '0px 0px 0px 0px',
	            borderRadius: this.props.radius
	          },
	          checkboard: {
	            absolute: '0px 0px 0px 0px',
	            overflow: 'hidden'
	          },
	          gradient: {
	            absolute: '0px 0px 0px 0px',
	            background: 'linear-gradient(to right, rgba(' + this.props.rgb.r + ', ' + this.props.rgb.g + ', ' + this.props.rgb.b + ', 0) 0%, rgba(' + this.props.rgb.r + ', ' + this.props.rgb.g + ', ' + this.props.rgb.b + ', 1) 100%)',
	            boxShadow: this.props.shadow,
	            borderRadius: this.props.radius
	          },
	          container: {
	            position: 'relative',
	            height: '100%',
	            margin: '0 3px'
	          },
	          pointer: {
	            position: 'absolute',
	            left: this.props.rgb.a * 100 + '%'
	          },
	          slider: {
	            width: '4px',
	            borderRadius: '1px',
	            height: '8px',
	            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
	            background: '#fff',
	            marginTop: '1px',
	            transform: 'translateX(-2px)'
	          }
	        }
	      });
	
	      var pointer = _react2.default.createElement('div', { style: styles.slider });
	
	      if (this.props.pointer) {
	        pointer = _react2.default.createElement(this.props.pointer, this.props);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.alpha },
	        _react2.default.createElement(
	          'div',
	          { style: styles.checkboard },
	          _react2.default.createElement(_Checkboard2.default, null)
	        ),
	        _react2.default.createElement('div', { style: styles.gradient }),
	        _react2.default.createElement(
	          'div',
	          { style: styles.container, ref: 'container', onMouseDown: this.handleMouseDown,
	            onTouchMove: this.handleChange,
	            onTouchStart: this.handleChange },
	          _react2.default.createElement(
	            'div',
	            { style: styles.pointer, ref: 'pointer' },
	            pointer
	          )
	        )
	      );
	    }
	  }]);
	
	  return Alpha;
	}(_react2.default.Component);
	
	exports.default = Alpha;

/***/ },
/* 1464 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1465);

/***/ },
/* 1465 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var shallowEqual = __webpack_require__(612);
	
	/**
	 * Does a shallow comparison for props and state.
	 * See ReactComponentWithPureRenderMixin
	 * See also https://facebook.github.io/react/docs/shallow-compare.html
	 */
	function shallowCompare(instance, nextProps, nextState) {
	  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
	}
	
	module.exports = shallowCompare;

/***/ },
/* 1466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Checkboard = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1287);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1464);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _checkboardCache = {};
	
	function renderCheckboard(c1, c2, size) {
	  if (typeof document == 'undefined') return null; // Dont Render On Server
	  var canvas = document.createElement('canvas');
	  canvas.width = canvas.height = size * 2;
	  var ctx = canvas.getContext('2d');
	  if (!ctx) return null; // If no context can be found, return early.
	  ctx.fillStyle = c1;
	  ctx.fillRect(0, 0, canvas.width, canvas.height);
	  ctx.fillStyle = c2;
	  ctx.fillRect(0, 0, size, size);
	  ctx.translate(size, size);
	  ctx.fillRect(0, 0, size, size);
	  return canvas.toDataURL();
	}
	
	function getCheckboard(c1, c2, size) {
	  var key = c1 + ',' + c2 + ',' + size;
	
	  if (_checkboardCache[key]) {
	    return _checkboardCache[key];
	  } else {
	    var checkboard = renderCheckboard(c1, c2, size);
	    _checkboardCache[key] = checkboard;
	    return checkboard;
	  }
	}
	
	var Checkboard = exports.Checkboard = function (_React$Component) {
	  _inherits(Checkboard, _React$Component);
	
	  function Checkboard() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, Checkboard);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Checkboard)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Checkboard, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          grid: {
	            absolute: '0px 0px 0px 0px',
	            background: 'url(' + getCheckboard(this.props.white, this.props.grey, this.props.size) + ') center left'
	          }
	        }
	      });
	
	      return _react2.default.createElement('div', { style: styles.grid, ref: 'grid' });
	    }
	  }]);
	
	  return Checkboard;
	}(_react2.default.Component);
	
	Checkboard.defaultProps = {
	  size: 8,
	  white: '#fff',
	  grey: '#e6e6e6'
	};
	
	exports.default = Checkboard;

/***/ },
/* 1467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EditableInput = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1287);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1464);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditableInput = exports.EditableInput = function (_React$Component) {
	  _inherits(EditableInput, _React$Component);
	
	  function EditableInput(props) {
	    _classCallCheck(this, EditableInput);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(EditableInput).call(this));
	
	    _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]);
	
	    _this.handleBlur = function () {
	      if (_this.state.blurValue) {
	        _this.setState({ value: _this.state.blurValue, blurValue: null });
	      }
	    };
	
	    _this.handleChange = function (e) {
	      if (_this.props.label !== null) {
	        var obj = {};
	        obj[_this.props.label] = e.target.value;
	        _this.props.onChange(obj);
	      } else {
	        _this.props.onChange(e.target.value);
	      }
	
	      _this.setState({ value: e.target.value });
	    };
	
	    _this.handleKeyDown = function (e) {
	      var number = Number(e.target.value);
	      if (number) {
	        var amount = _this.props.arrowOffset || 1;
	
	        // Up
	        if (e.keyCode === 38) {
	          if (_this.props.label !== null) {
	            var obj = {};
	            obj[_this.props.label] = number + amount;
	            _this.props.onChange(obj);
	          } else {
	            _this.props.onChange(number + amount);
	          }
	
	          _this.setState({ value: number + amount });
	        }
	
	        // Down
	        if (e.keyCode === 40) {
	          if (_this.props.label !== null) {
	            var obj = {};
	            obj[_this.props.label] = number - amount;
	            _this.props.onChange(obj);
	          } else {
	            _this.props.onChange(number - amount);
	          }
	
	          _this.setState({ value: number - amount });
	        }
	      }
	    };
	
	    _this.handleDrag = function (e) {
	      if (_this.props.dragLabel) {
	        var newValue = Math.round(_this.props.value + e.movementX);
	        if (newValue >= 0 && newValue <= _this.props.dragMax) {
	          var obj = {};
	          obj[_this.props.label] = newValue;
	          _this.props.onChange(obj);
	        }
	      }
	    };
	
	    _this.handleMouseDown = function (e) {
	      if (_this.props.dragLabel) {
	        e.preventDefault();
	        _this.handleDrag(e);
	        window.addEventListener('mousemove', _this.handleDrag);
	        window.addEventListener('mouseup', _this.handleMouseUp);
	      }
	    };
	
	    _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    };
	
	    _this.unbindEventListeners = function () {
	      window.removeEventListener('mousemove', _this.handleChange);
	      window.removeEventListener('mouseup', _this.handleMouseUp);
	    };
	
	    _this.state = {
	      value: String(props.value).toUpperCase(),
	      blurValue: String(props.value).toUpperCase()
	    };
	    return _this;
	  }
	
	  _createClass(EditableInput, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var input = this.refs.input;
	      if (nextProps.value !== this.state.value) {
	        if (input === document.activeElement) {
	          this.setState({ blurValue: String(nextProps.value).toUpperCase() });
	        } else {
	          this.setState({ value: String(nextProps.value).toUpperCase() });
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'user-override': {
	          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
	          input: this.props.style && this.props.style.input ? this.props.style.input : {},
	          label: this.props.style && this.props.style.label ? this.props.style.label : {}
	        },
	        'dragLabel-true': {
	          label: {
	            cursor: 'ew-resize'
	          }
	        }
	      }, {
	        'user-override': true
	      }, this.props);
	
	      var label;
	      if (this.props.label) {
	        label = _react2.default.createElement(
	          'span',
	          { style: styles.label, ref: 'label', onMouseDown: this.handleMouseDown },
	          this.props.label
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.wrap, ref: 'container' },
	        _react2.default.createElement('input', { style: styles.input, ref: 'input', value: this.state.value, onKeyDown: this.handleKeyDown, onChange: this.handleChange, onBlur: this.handleBlur }),
	        label
	      );
	    }
	  }]);
	
	  return EditableInput;
	}(_react2.default.Component);
	
	exports.default = EditableInput;

/***/ },
/* 1468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Hue = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1287);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1464);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Hue = exports.Hue = function (_React$Component) {
	  _inherits(Hue, _React$Component);
	
	  function Hue() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, Hue);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Hue)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleChange = function (e, skip) {
	      !skip && e.preventDefault();
	      var container = _this.refs.container;
	      var containerWidth = container.clientWidth;
	      var containerHeight = container.clientHeight;
	      var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
	      var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
	      var inIFrame = window.self !== window.top || window.document !== container.ownerDocument;
	      var left = x - (container.getBoundingClientRect().left + (inIFrame ? 0 : window.pageXOffset));
	      var top = y - (container.getBoundingClientRect().top + (inIFrame ? 0 : window.pageYOffset));
	
	      if (_this.props.direction === 'vertical') {
	        var h;
	        if (top < 0) {
	          h = 359;
	        } else if (top > containerHeight) {
	          h = 0;
	        } else {
	          var percent = -(top * 100 / containerHeight) + 100;
	          h = 360 * percent / 100;
	        }
	
	        if (_this.props.hsl.h !== h) {
	          _this.props.onChange({
	            h: h,
	            s: _this.props.hsl.s,
	            l: _this.props.hsl.l,
	            a: _this.props.hsl.a,
	            source: 'rgb'
	          });
	        }
	      } else {
	        var h;
	        if (left < 0) {
	          h = 0;
	        } else if (left > containerWidth) {
	          h = 359;
	        } else {
	          var percent = left * 100 / containerWidth;
	          h = 360 * percent / 100;
	        }
	
	        if (_this.props.hsl.h !== h) {
	          _this.props.onChange({
	            h: h,
	            s: _this.props.hsl.s,
	            l: _this.props.hsl.l,
	            a: _this.props.hsl.a,
	            source: 'rgb'
	          });
	        }
	      }
	    }, _this.handleMouseDown = function (e) {
	      _this.handleChange(e, true);
	      window.addEventListener('mousemove', _this.handleChange);
	      window.addEventListener('mouseup', _this.handleMouseUp);
	    }, _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Hue, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'unbindEventListeners',
	    value: function unbindEventListeners() {
	      window.removeEventListener('mousemove', this.handleChange);
	      window.removeEventListener('mouseup', this.handleMouseUp);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          hue: {
	            absolute: '0px 0px 0px 0px',
	            background: 'linear-gradient(to right, #f00 0%, #ff0 17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%)',
	            borderRadius: this.props.radius,
	            boxShadow: this.props.shadow
	          },
	          container: {
	            margin: '0 2px',
	            position: 'relative',
	            height: '100%'
	          },
	          pointer: {
	            position: 'absolute',
	            left: this.props.hsl.h * 100 / 360 + '%'
	          },
	          slider: {
	            marginTop: '1px',
	            width: '4px',
	            borderRadius: '1px',
	            height: '8px',
	            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
	            background: '#fff',
	            transform: 'translateX(-2px)'
	          }
	        },
	        'direction-vertical': {
	          hue: {
	            background: 'linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%)'
	          },
	          pointer: {
	            left: '0px',
	            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
	          }
	        }
	      }, this.props);
	
	      var pointer = _react2.default.createElement('div', { style: styles.slider });
	
	      if (this.props.pointer) {
	        pointer = _react2.default.createElement(this.props.pointer, this.props);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.hue },
	        _react2.default.createElement(
	          'div',
	          { style: styles.container, ref: 'container', onMouseDown: this.handleMouseDown,
	            onTouchMove: this.handleChange,
	            onTouchStart: this.handleChange },
	          _react2.default.createElement(
	            'div',
	            { style: styles.pointer, ref: 'pointer' },
	            pointer
	          )
	        )
	      );
	    }
	  }]);
	
	  return Hue;
	}(_react2.default.Component);
	
	exports.default = Hue;

/***/ },
/* 1469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Saturation = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1287);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _throttle = __webpack_require__(1470);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _reactAddonsShallowCompare = __webpack_require__(1464);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Saturation = exports.Saturation = function (_React$Component) {
	  _inherits(Saturation, _React$Component);
	
	  function Saturation(props) {
	    _classCallCheck(this, Saturation);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Saturation).call(this));
	
	    _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]);
	
	    _this.handleChange = function (e, skip) {
	      !skip && e.preventDefault();
	      var container = _this.refs.container;
	      var containerWidth = container.clientWidth;
	      var containerHeight = container.clientHeight;
	      var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
	      var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
	      var inIFrame = window.self !== window.top || window.document !== container.ownerDocument;
	      var left = x - (container.getBoundingClientRect().left + (inIFrame ? 0 : window.pageXOffset));
	      var top = y - (container.getBoundingClientRect().top + (inIFrame ? 0 : window.pageYOffset));
	
	      if (left < 0) {
	        left = 0;
	      } else if (left > containerWidth) {
	        left = containerWidth;
	      } else if (top < 0) {
	        top = 0;
	      } else if (top > containerHeight) {
	        top = containerHeight;
	      }
	
	      var saturation = left * 100 / containerWidth;
	      var bright = -(top * 100 / containerHeight) + 100;
	
	      _this.throttle(_this.props.onChange, {
	        h: _this.props.hsl.h,
	        s: saturation,
	        v: bright,
	        a: _this.props.hsl.a,
	        source: 'rgb'
	      });
	    };
	
	    _this.handleMouseDown = function (e) {
	      _this.handleChange(e, true);
	      window.addEventListener('mousemove', _this.handleChange);
	      window.addEventListener('mouseup', _this.handleMouseUp);
	    };
	
	    _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    };
	
	    _this.throttle = (0, _throttle2.default)(function (fn, data) {
	      fn(data);
	    }, 50);
	    return _this;
	  }
	
	  _createClass(Saturation, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'unbindEventListeners',
	    value: function unbindEventListeners() {
	      window.removeEventListener('mousemove', this.handleChange);
	      window.removeEventListener('mouseup', this.handleMouseUp);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          color: {
	            absolute: '0px 0px 0px 0px',
	            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
	            borderRadius: this.props.radius
	          },
	          white: {
	            absolute: '0px 0px 0px 0px',
	            background: 'linear-gradient(to right, #fff, rgba(255,255,255,0))'
	          },
	          black: {
	            absolute: '0px 0px 0px 0px',
	            background: 'linear-gradient(to top, #000, rgba(0,0,0,0))',
	            boxShadow: this.props.shadow
	          },
	          pointer: {
	            position: 'absolute',
	            top: -(this.props.hsv.v * 100) + 100 + '%',
	            left: this.props.hsv.s * 100 + '%',
	            cursor: 'default'
	          },
	          circle: {
	            width: '4px',
	            height: '4px',
	            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3), 0 0 1px 2px rgba(0,0,0,.4)',
	            borderRadius: '50%',
	            cursor: 'hand',
	            transform: 'translate(-2px, -2px)'
	          }
	        }
	      });
	
	      var pointer = _react2.default.createElement('div', { style: styles.circle });
	
	      if (this.props.pointer) {
	        pointer = _react2.default.createElement(this.props.pointer, this.props);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.color, ref: 'container', onMouseDown: this.handleMouseDown,
	          onTouchMove: this.handleChange,
	          onTouchStart: this.handleChange },
	        _react2.default.createElement(
	          'div',
	          { style: styles.white },
	          _react2.default.createElement('div', { style: styles.black }),
	          _react2.default.createElement(
	            'div',
	            { style: styles.pointer, ref: 'pointer' },
	            pointer
	          )
	        )
	      );
	    }
	  }]);
	
	  return Saturation;
	}(_react2.default.Component);
	
	exports.default = Saturation;

/***/ },
/* 1470 */
/***/ function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(1471),
	    isObject = __webpack_require__(1472);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ },
/* 1471 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(1472),
	    now = __webpack_require__(1473),
	    toNumber = __webpack_require__(1476);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ },
/* 1472 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 1473 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(1474);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ },
/* 1474 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(1475);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 1475 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1476 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(1472),
	    isSymbol = __webpack_require__(1477);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 1477 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(1478),
	    isObjectLike = __webpack_require__(1482);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 1478 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(1479),
	    getRawTag = __webpack_require__(1480),
	    objectToString = __webpack_require__(1481);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 1479 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(1474);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 1480 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(1479);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 1481 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 1482 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 1483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ColorWrap = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _merge = __webpack_require__(1452);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _isPlainObject = __webpack_require__(1484);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _debounce = __webpack_require__(1471);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _color = __webpack_require__(1487);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _reactAddonsShallowCompare = __webpack_require__(1464);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ColorWrap = exports.ColorWrap = function ColorWrap(Picker) {
	  var ColorPicker = function (_React$Component) {
	    _inherits(ColorPicker, _React$Component);
	
	    function ColorPicker(props) {
	      _classCallCheck(this, ColorPicker);
	
	      var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ColorPicker).call(this));
	
	      _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]);
	
	      _this.handleChange = function (data) {
	        data = _color2.default.simpleCheckForValidColor(data);
	        if (data) {
	          var colors = _color2.default.toState(data, data.h || _this.state.oldHue);
	          _this.setState(colors);
	          _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors);
	          _this.props.onChange && _this.props.onChange(colors);
	        }
	      };
	
	      _this.state = (0, _merge2.default)(_color2.default.toState(props.color, 0), {
	        visible: props.display
	      });
	
	      _this.debounce = (0, _debounce2.default)(function (fn, data) {
	        fn(data);
	      }, 100);
	      return _this;
	    }
	
	    _createClass(ColorPicker, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        this.setState((0, _merge2.default)(_color2.default.toState(nextProps.color, this.state.oldHue), {
	          visible: nextProps.display
	        }));
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(Picker, _extends({}, this.props, this.state, { onChange: this.handleChange }));
	      }
	    }]);
	
	    return ColorPicker;
	  }(_react2.default.Component);
	
	  ColorPicker.defaultProps = {
	    color: {
	      h: 250,
	      s: .50,
	      l: .20,
	      a: 1
	    }
	  };
	
	  return ColorPicker;
	};
	
	exports.default = ColorWrap;

/***/ },
/* 1484 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(1478),
	    getPrototype = __webpack_require__(1485),
	    isObjectLike = __webpack_require__(1482);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 1485 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(1486);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 1486 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 1487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tinycolor = __webpack_require__(1488);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  simpleCheckForValidColor: function simpleCheckForValidColor(data) {
	    var keysToCheck = ['r', 'g', 'b', 'a', 'h', 's', 'a', 'v'];
	    var checked = 0;
	    var passed = 0;
	    for (var i = 0; i < keysToCheck.length; i++) {
	      var letter = keysToCheck[i];
	      if (data[letter]) {
	        checked++;
	        if (!isNaN(data[letter])) {
	          passed++;
	        }
	      }
	    }
	
	    if (checked === passed) {
	      return data;
	    }
	  },
	
	  toState: function toState(data, oldHue) {
	    var color = data.hex ? (0, _tinycolor2.default)(data.hex) : (0, _tinycolor2.default)(data);
	    var hsl = color.toHsl();
	    var hsv = color.toHsv();
	    if (hsl.s === 0) {
	      hsl.h = oldHue || 0;
	      hsv.h = oldHue || 0;
	    }
	
	    return {
	      hsl: hsl,
	      hex: '#' + color.toHex(),
	      rgb: color.toRgb(),
	      hsv: hsv,
	      oldHue: data.h || oldHue || hsl.h,
	      source: data.source
	    };
	  },
	
	  isValidHex: function isValidHex(hex) {
	    return (0, _tinycolor2.default)(hex).isValid();
	  }
	
	};

/***/ },
/* 1488 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;// jscs: disable
	
	// TinyColor v1.1.2
	// https://github.com/bgrins/TinyColor
	// Brian Grinstead, MIT License
	
	(function() {
	
	var trimLeft = /^[\s,#]+/;
	var trimRight = /\s+$/;
	var tinyCounter = 0;
	var math = Math;
	var mathRound = math.round;
	var mathMin = math.min;
	var mathMax = math.max;
	var mathRandom = math.random;
	
	function tinycolor(color, opts) {
	
			color = (color) ? color : '';
			opts = opts || { };
	
			// If input is already a tinycolor, return itself
			if (color instanceof tinycolor) {
				 return color;
			}
			// If we are called as a function, call using new instead
			if (!(this instanceof tinycolor)) {
					return new tinycolor(color, opts);
			}
	
			var rgb = inputToRGB(color);
			this._originalInput = color,
			this._r = rgb.r,
			this._g = rgb.g,
			this._b = rgb.b,
			this._a = rgb.a,
			this._roundA = mathRound(100*this._a) / 100,
			this._format = opts.format || rgb.format;
			this._gradientType = opts.gradientType;
	
			// Don't let the range of [0,255] come back in [0,1].
			// Potentially lose a little bit of precision here, but will fix issues where
			// .5 gets interpreted as half of the total, instead of half of 1
			// If it was supposed to be 128, this was already taken care of by `inputToRgb`
			if (this._r < 1) { this._r = mathRound(this._r); }
			if (this._g < 1) { this._g = mathRound(this._g); }
			if (this._b < 1) { this._b = mathRound(this._b); }
	
			this._ok = rgb.ok;
			this._tc_id = tinyCounter++;
	}
	
	tinycolor.prototype = {
			isDark: function() {
					return this.getBrightness() < 128;
			},
			isLight: function() {
					return !this.isDark();
			},
			isValid: function() {
					return this._ok;
			},
			getOriginalInput: function() {
				return this._originalInput;
			},
			getFormat: function() {
					return this._format;
			},
			getAlpha: function() {
					return this._a;
			},
			getBrightness: function() {
					//http://www.w3.org/TR/AERT#color-contrast
					var rgb = this.toRgb();
					return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
			},
			getLuminance: function() {
					//http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
					var rgb = this.toRgb();
					var RsRGB, GsRGB, BsRGB, R, G, B;
					RsRGB = rgb.r/255;
					GsRGB = rgb.g/255;
					BsRGB = rgb.b/255;
	
					if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
					if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
					if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
					return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
			},
			setAlpha: function(value) {
					this._a = boundAlpha(value);
					this._roundA = mathRound(100*this._a) / 100;
					return this;
			},
			toHsv: function() {
					var hsv = rgbToHsv(this._r, this._g, this._b);
					return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
			},
			toHsvString: function() {
					var hsv = rgbToHsv(this._r, this._g, this._b);
					var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
					return (this._a == 1) ?
						"hsv("	+ h + ", " + s + "%, " + v + "%)" :
						"hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
			},
			toHsl: function() {
					var hsl = rgbToHsl(this._r, this._g, this._b);
					return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
			},
			toHslString: function() {
					var hsl = rgbToHsl(this._r, this._g, this._b);
					var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
					return (this._a == 1) ?
						"hsl("	+ h + ", " + s + "%, " + l + "%)" :
						"hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
			},
			toHex: function(allow3Char) {
					return rgbToHex(this._r, this._g, this._b, allow3Char);
			},
			toHexString: function(allow3Char) {
					return '#' + this.toHex(allow3Char);
			},
			toHex8: function() {
					return rgbaToHex(this._r, this._g, this._b, this._a);
			},
			toHex8String: function() {
					return '#' + this.toHex8();
			},
			toRgb: function() {
					return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
			},
			toRgbString: function() {
					return (this._a == 1) ?
						"rgb("	+ mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
						"rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
			},
			toPercentageRgb: function() {
					return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
			},
			toPercentageRgbString: function() {
					return (this._a == 1) ?
						"rgb("	+ mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
						"rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
			},
			toName: function() {
					if (this._a === 0) {
							return "transparent";
					}
	
					if (this._a < 1) {
							return false;
					}
	
					return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
			},
			toFilter: function(secondColor) {
					var hex8String = '#' + rgbaToHex(this._r, this._g, this._b, this._a);
					var secondHex8String = hex8String;
					var gradientType = this._gradientType ? "GradientType = 1, " : "";
	
					if (secondColor) {
							var s = tinycolor(secondColor);
							secondHex8String = s.toHex8String();
					}
	
					return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
			},
			toString: function(format) {
					var formatSet = !!format;
					format = format || this._format;
	
					var formattedString = false;
					var hasAlpha = this._a < 1 && this._a >= 0;
					var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "name");
	
					if (needsAlphaFormat) {
							// Special case for "transparent", all other non-alpha formats
							// will return rgba when there is transparency.
							if (format === "name" && this._a === 0) {
									return this.toName();
							}
							return this.toRgbString();
					}
					if (format === "rgb") {
							formattedString = this.toRgbString();
					}
					if (format === "prgb") {
							formattedString = this.toPercentageRgbString();
					}
					if (format === "hex" || format === "hex6") {
							formattedString = this.toHexString();
					}
					if (format === "hex3") {
							formattedString = this.toHexString(true);
					}
					if (format === "hex8") {
							formattedString = this.toHex8String();
					}
					if (format === "name") {
							formattedString = this.toName();
					}
					if (format === "hsl") {
							formattedString = this.toHslString();
					}
					if (format === "hsv") {
							formattedString = this.toHsvString();
					}
	
					return formattedString || this.toHexString();
			},
	
			_applyModification: function(fn, args) {
					var color = fn.apply(null, [this].concat([].slice.call(args)));
					this._r = color._r;
					this._g = color._g;
					this._b = color._b;
					this.setAlpha(color._a);
					return this;
			},
			lighten: function() {
					return this._applyModification(lighten, arguments);
			},
			brighten: function() {
					return this._applyModification(brighten, arguments);
			},
			darken: function() {
					return this._applyModification(darken, arguments);
			},
			desaturate: function() {
					return this._applyModification(desaturate, arguments);
			},
			saturate: function() {
					return this._applyModification(saturate, arguments);
			},
			greyscale: function() {
					return this._applyModification(greyscale, arguments);
			},
			spin: function() {
					return this._applyModification(spin, arguments);
			},
	
			_applyCombination: function(fn, args) {
					return fn.apply(null, [this].concat([].slice.call(args)));
			},
			analogous: function() {
					return this._applyCombination(analogous, arguments);
			},
			complement: function() {
					return this._applyCombination(complement, arguments);
			},
			monochromatic: function() {
					return this._applyCombination(monochromatic, arguments);
			},
			splitcomplement: function() {
					return this._applyCombination(splitcomplement, arguments);
			},
			triad: function() {
					return this._applyCombination(triad, arguments);
			},
			tetrad: function() {
					return this._applyCombination(tetrad, arguments);
			}
	};
	
	// If input is an object, force 1 into "1.0" to handle ratios properly
	// String input requires "1.0" as input, so 1 will be treated as 1
	tinycolor.fromRatio = function(color, opts) {
			if (typeof color == "object") {
					var newColor = {};
					for (var i in color) {
							if (color.hasOwnProperty(i)) {
									if (i === "a") {
											newColor[i] = color[i];
									}
									else {
											newColor[i] = convertToPercentage(color[i]);
									}
							}
					}
					color = newColor;
			}
	
			return tinycolor(color, opts);
	};
	
	// Given a string or object, convert that input to RGB
	// Possible string inputs:
	//
	//		 "red"
	//		 "#f00" or "f00"
	//		 "#ff0000" or "ff0000"
	//		 "#ff000000" or "ff000000"
	//		 "rgb 255 0 0" or "rgb (255, 0, 0)"
	//		 "rgb 1.0 0 0" or "rgb (1, 0, 0)"
	//		 "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
	//		 "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
	//		 "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
	//		 "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
	//		 "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
	//
	function inputToRGB(color) {
	
			var rgb = { r: 0, g: 0, b: 0 };
			var a = 1;
			var ok = false;
			var format = false;
	
			if (typeof color == "string") {
					color = stringInputToObject(color);
			}
	
			if (typeof color == "object") {
					if (color.hasOwnProperty("r") && color.hasOwnProperty("g") && color.hasOwnProperty("b")) {
							rgb = rgbToRgb(color.r, color.g, color.b);
							ok = true;
							format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
					}
					else if (color.hasOwnProperty("h") && color.hasOwnProperty("s") && color.hasOwnProperty("v")) {
							color.s = convertToPercentage(color.s, 1);
							color.v = convertToPercentage(color.v, 1);
							rgb = hsvToRgb(color.h, color.s, color.v);
							ok = true;
							format = "hsv";
					}
					else if (color.hasOwnProperty("h") && color.hasOwnProperty("s") && color.hasOwnProperty("l")) {
							color.s = convertToPercentage(color.s);
							color.l = convertToPercentage(color.l);
							rgb = hslToRgb(color.h, color.s, color.l);
							ok = true;
							format = "hsl";
					}
	
					if (color.hasOwnProperty("a")) {
							a = color.a;
					}
			}
	
			a = boundAlpha(a);
	
			return {
					ok: ok,
					format: color.format || format,
					r: mathMin(255, mathMax(rgb.r, 0)),
					g: mathMin(255, mathMax(rgb.g, 0)),
					b: mathMin(255, mathMax(rgb.b, 0)),
					a: a
			};
	}
	
	
	// Conversion Functions
	// --------------------
	
	// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
	// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
	
	// `rgbToRgb`
	// Handle bounds / percentage checking to conform to CSS color spec
	// <http://www.w3.org/TR/css3-color/>
	// *Assumes:* r, g, b in [0, 255] or [0, 1]
	// *Returns:* { r, g, b } in [0, 255]
	function rgbToRgb(r, g, b){
			return {
					r: bound01(r, 255) * 255,
					g: bound01(g, 255) * 255,
					b: bound01(b, 255) * 255
			};
	}
	
	// `rgbToHsl`
	// Converts an RGB color value to HSL.
	// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
	// *Returns:* { h, s, l } in [0,1]
	function rgbToHsl(r, g, b) {
	
			r = bound01(r, 255);
			g = bound01(g, 255);
			b = bound01(b, 255);
	
			var max = mathMax(r, g, b), min = mathMin(r, g, b);
			var h, s, l = (max + min) / 2;
	
			if(max == min) {
					h = s = 0; // achromatic
			}
			else {
					var d = max - min;
					s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
					switch(max) {
							case r: h = (g - b) / d + (g < b ? 6 : 0); break;
							case g: h = (b - r) / d + 2; break;
							case b: h = (r - g) / d + 4; break;
					}
	
					h /= 6;
			}
	
			return { h: h, s: s, l: l };
	}
	
	// `hslToRgb`
	// Converts an HSL color value to RGB.
	// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
	// *Returns:* { r, g, b } in the set [0, 255]
	function hslToRgb(h, s, l) {
			var r, g, b;
	
			h = bound01(h, 360);
			s = bound01(s, 100);
			l = bound01(l, 100);
	
			function hue2rgb(p, q, t) {
					if(t < 0) t += 1;
					if(t > 1) t -= 1;
					if(t < 1/6) return p + (q - p) * 6 * t;
					if(t < 1/2) return q;
					if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
					return p;
			}
	
			if(s === 0) {
					r = g = b = l; // achromatic
			}
			else {
					var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
					var p = 2 * l - q;
					r = hue2rgb(p, q, h + 1/3);
					g = hue2rgb(p, q, h);
					b = hue2rgb(p, q, h - 1/3);
			}
	
			return { r: r * 255, g: g * 255, b: b * 255 };
	}
	
	// `rgbToHsv`
	// Converts an RGB color value to HSV
	// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
	// *Returns:* { h, s, v } in [0,1]
	function rgbToHsv(r, g, b) {
	
			r = bound01(r, 255);
			g = bound01(g, 255);
			b = bound01(b, 255);
	
			var max = mathMax(r, g, b), min = mathMin(r, g, b);
			var h, s, v = max;
	
			var d = max - min;
			s = max === 0 ? 0 : d / max;
	
			if(max == min) {
					h = 0; // achromatic
			}
			else {
					switch(max) {
							case r: h = (g - b) / d + (g < b ? 6 : 0); break;
							case g: h = (b - r) / d + 2; break;
							case b: h = (r - g) / d + 4; break;
					}
					h /= 6;
			}
			return { h: h, s: s, v: v };
	}
	
	// `hsvToRgb`
	// Converts an HSV color value to RGB.
	// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
	// *Returns:* { r, g, b } in the set [0, 255]
	 function hsvToRgb(h, s, v) {
	
			h = bound01(h, 360) * 6;
			s = bound01(s, 100);
			v = bound01(v, 100);
	
			var i = math.floor(h),
					f = h - i,
					p = v * (1 - s),
					q = v * (1 - f * s),
					t = v * (1 - (1 - f) * s),
					mod = i % 6,
					r = [v, q, p, p, t, v][mod],
					g = [t, v, v, q, p, p][mod],
					b = [p, p, t, v, v, q][mod];
	
			return { r: r * 255, g: g * 255, b: b * 255 };
	}
	
	// `rgbToHex`
	// Converts an RGB color to hex
	// Assumes r, g, and b are contained in the set [0, 255]
	// Returns a 3 or 6 character hex
	function rgbToHex(r, g, b, allow3Char) {
	
			var hex = [
					pad2(mathRound(r).toString(16)),
					pad2(mathRound(g).toString(16)),
					pad2(mathRound(b).toString(16))
			];
	
			// Return a 3 character hex if possible
			if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
					return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
			}
	
			return hex.join("");
	}
			// `rgbaToHex`
			// Converts an RGBA color plus alpha transparency to hex
			// Assumes r, g, b and a are contained in the set [0, 255]
			// Returns an 8 character hex
			function rgbaToHex(r, g, b, a) {
	
					var hex = [
							pad2(convertDecimalToHex(a)),
							pad2(mathRound(r).toString(16)),
							pad2(mathRound(g).toString(16)),
							pad2(mathRound(b).toString(16))
					];
	
					return hex.join("");
			}
	
	// `equals`
	// Can be called with any tinycolor input
	tinycolor.equals = function (color1, color2) {
			if (!color1 || !color2) { return false; }
			return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
	};
	tinycolor.random = function() {
			return tinycolor.fromRatio({
					r: mathRandom(),
					g: mathRandom(),
					b: mathRandom()
			});
	};
	
	
	// Modification Functions
	// ----------------------
	// Thanks to less.js for some of the basics here
	// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
	
	function desaturate(color, amount) {
			amount = (amount === 0) ? 0 : (amount || 10);
			var hsl = tinycolor(color).toHsl();
			hsl.s -= amount / 100;
			hsl.s = clamp01(hsl.s);
			return tinycolor(hsl);
	}
	
	function saturate(color, amount) {
			amount = (amount === 0) ? 0 : (amount || 10);
			var hsl = tinycolor(color).toHsl();
			hsl.s += amount / 100;
			hsl.s = clamp01(hsl.s);
			return tinycolor(hsl);
	}
	
	function greyscale(color) {
			return tinycolor(color).desaturate(100);
	}
	
	function lighten (color, amount) {
			amount = (amount === 0) ? 0 : (amount || 10);
			var hsl = tinycolor(color).toHsl();
			hsl.l += amount / 100;
			hsl.l = clamp01(hsl.l);
			return tinycolor(hsl);
	}
	
	function brighten(color, amount) {
			amount = (amount === 0) ? 0 : (amount || 10);
			var rgb = tinycolor(color).toRgb();
			rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
			rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
			rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
			return tinycolor(rgb);
	}
	
	function darken (color, amount) {
			amount = (amount === 0) ? 0 : (amount || 10);
			var hsl = tinycolor(color).toHsl();
			hsl.l -= amount / 100;
			hsl.l = clamp01(hsl.l);
			return tinycolor(hsl);
	}
	
	// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
	// Values outside of this range will be wrapped into this range.
	function spin(color, amount) {
			var hsl = tinycolor(color).toHsl();
			var hue = (mathRound(hsl.h) + amount) % 360;
			hsl.h = hue < 0 ? 360 + hue : hue;
			return tinycolor(hsl);
	}
	
	// Combination Functions
	// ---------------------
	// Thanks to jQuery xColor for some of the ideas behind these
	// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
	
	function complement(color) {
			var hsl = tinycolor(color).toHsl();
			hsl.h = (hsl.h + 180) % 360;
			return tinycolor(hsl);
	}
	
	function triad(color) {
			var hsl = tinycolor(color).toHsl();
			var h = hsl.h;
			return [
					tinycolor(color),
					tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
					tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
			];
	}
	
	function tetrad(color) {
			var hsl = tinycolor(color).toHsl();
			var h = hsl.h;
			return [
					tinycolor(color),
					tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
					tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
					tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
			];
	}
	
	function splitcomplement(color) {
			var hsl = tinycolor(color).toHsl();
			var h = hsl.h;
			return [
					tinycolor(color),
					tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
					tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
			];
	}
	
	function analogous(color, results, slices) {
			results = results || 6;
			slices = slices || 30;
	
			var hsl = tinycolor(color).toHsl();
			var part = 360 / slices;
			var ret = [tinycolor(color)];
	
			for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
					hsl.h = (hsl.h + part) % 360;
					ret.push(tinycolor(hsl));
			}
			return ret;
	}
	
	function monochromatic(color, results) {
			results = results || 6;
			var hsv = tinycolor(color).toHsv();
			var h = hsv.h, s = hsv.s, v = hsv.v;
			var ret = [];
			var modification = 1 / results;
	
			while (results--) {
					ret.push(tinycolor({ h: h, s: s, v: v}));
					v = (v + modification) % 1;
			}
	
			return ret;
	}
	
	// Utility Functions
	// ---------------------
	
	tinycolor.mix = function(color1, color2, amount) {
			amount = (amount === 0) ? 0 : (amount || 50);
	
			var rgb1 = tinycolor(color1).toRgb();
			var rgb2 = tinycolor(color2).toRgb();
	
			var p = amount / 100;
			var w = p * 2 - 1;
			var a = rgb2.a - rgb1.a;
	
			var w1;
	
			if (w * a == -1) {
					w1 = w;
			} else {
					w1 = (w + a) / (1 + w * a);
			}
	
			w1 = (w1 + 1) / 2;
	
			var w2 = 1 - w1;
	
			var rgba = {
					r: rgb2.r * w1 + rgb1.r * w2,
					g: rgb2.g * w1 + rgb1.g * w2,
					b: rgb2.b * w1 + rgb1.b * w2,
					a: rgb2.a * p	+ rgb1.a * (1 - p)
			};
	
			return tinycolor(rgba);
	};
	
	
	// Readability Functions
	// ---------------------
	// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
	
	// `contrast`
	// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
	tinycolor.readability = function(color1, color2) {
			var c1 = tinycolor(color1);
			var c2 = tinycolor(color2);
			return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
	};
	
	// `isReadable`
	// Ensure that foreground and background color combinations meet WCAG2 guidelines.
	// The third argument is an optional Object.
	//			the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
	//			the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
	// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
	
	// *Example*
	//		tinycolor.isReadable("#000", "#111") => false
	//		tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
	
	tinycolor.isReadable = function(color1, color2, wcag2) {
			var readability = tinycolor.readability(color1, color2);
			var wcag2Parms, out;
	
			out = false;
	
			wcag2Parms = validateWCAG2Parms(wcag2);
			switch (wcag2Parms.level + wcag2Parms.size) {
					case "AAsmall":
					case "AAAlarge":
							out = readability >= 4.5;
							break;
					case "AAlarge":
							out = readability >= 3;
							break;
					case "AAAsmall":
							out = readability >= 7;
							break;
			}
			return out;
	
	};
	
	// `mostReadable`
	// Given a base color and a list of possible foreground or background
	// colors for that base, returns the most readable color.
	// Optionally returns Black or White if the most readable color is unreadable.
	// *Example*
	//		tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
	//		tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();	// "#ffffff"
	//		tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
	//		tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
	
	
	tinycolor.mostReadable = function(baseColor, colorList, args) {
			var bestColor = null;
			var bestScore = 0;
			var readability;
			var includeFallbackColors, level, size ;
			args = args || {};
			includeFallbackColors = args.includeFallbackColors ;
			level = args.level;
			size = args.size;
	
			for (var i= 0; i < colorList.length ; i++) {
					readability = tinycolor.readability(baseColor, colorList[i]);
					if (readability > bestScore) {
							bestScore = readability;
							bestColor = tinycolor(colorList[i]);
					}
			}
	
			if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
					return bestColor;
			}
			else {
					args.includeFallbackColors=false;
					return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
			}
	};
	
	
	// Big List of Colors
	// ------------------
	// <http://www.w3.org/TR/css3-color/#svg-color>
	var names = tinycolor.names = {
			aliceblue: "f0f8ff",
			antiquewhite: "faebd7",
			aqua: "0ff",
			aquamarine: "7fffd4",
			azure: "f0ffff",
			beige: "f5f5dc",
			bisque: "ffe4c4",
			black: "000",
			blanchedalmond: "ffebcd",
			blue: "00f",
			blueviolet: "8a2be2",
			brown: "a52a2a",
			burlywood: "deb887",
			burntsienna: "ea7e5d",
			cadetblue: "5f9ea0",
			chartreuse: "7fff00",
			chocolate: "d2691e",
			coral: "ff7f50",
			cornflowerblue: "6495ed",
			cornsilk: "fff8dc",
			crimson: "dc143c",
			cyan: "0ff",
			darkblue: "00008b",
			darkcyan: "008b8b",
			darkgoldenrod: "b8860b",
			darkgray: "a9a9a9",
			darkgreen: "006400",
			darkgrey: "a9a9a9",
			darkkhaki: "bdb76b",
			darkmagenta: "8b008b",
			darkolivegreen: "556b2f",
			darkorange: "ff8c00",
			darkorchid: "9932cc",
			darkred: "8b0000",
			darksalmon: "e9967a",
			darkseagreen: "8fbc8f",
			darkslateblue: "483d8b",
			darkslategray: "2f4f4f",
			darkslategrey: "2f4f4f",
			darkturquoise: "00ced1",
			darkviolet: "9400d3",
			deeppink: "ff1493",
			deepskyblue: "00bfff",
			dimgray: "696969",
			dimgrey: "696969",
			dodgerblue: "1e90ff",
			firebrick: "b22222",
			floralwhite: "fffaf0",
			forestgreen: "228b22",
			fuchsia: "f0f",
			gainsboro: "dcdcdc",
			ghostwhite: "f8f8ff",
			gold: "ffd700",
			goldenrod: "daa520",
			gray: "808080",
			green: "008000",
			greenyellow: "adff2f",
			grey: "808080",
			honeydew: "f0fff0",
			hotpink: "ff69b4",
			indianred: "cd5c5c",
			indigo: "4b0082",
			ivory: "fffff0",
			khaki: "f0e68c",
			lavender: "e6e6fa",
			lavenderblush: "fff0f5",
			lawngreen: "7cfc00",
			lemonchiffon: "fffacd",
			lightblue: "add8e6",
			lightcoral: "f08080",
			lightcyan: "e0ffff",
			lightgoldenrodyellow: "fafad2",
			lightgray: "d3d3d3",
			lightgreen: "90ee90",
			lightgrey: "d3d3d3",
			lightpink: "ffb6c1",
			lightsalmon: "ffa07a",
			lightseagreen: "20b2aa",
			lightskyblue: "87cefa",
			lightslategray: "789",
			lightslategrey: "789",
			lightsteelblue: "b0c4de",
			lightyellow: "ffffe0",
			lime: "0f0",
			limegreen: "32cd32",
			linen: "faf0e6",
			magenta: "f0f",
			maroon: "800000",
			mediumaquamarine: "66cdaa",
			mediumblue: "0000cd",
			mediumorchid: "ba55d3",
			mediumpurple: "9370db",
			mediumseagreen: "3cb371",
			mediumslateblue: "7b68ee",
			mediumspringgreen: "00fa9a",
			mediumturquoise: "48d1cc",
			mediumvioletred: "c71585",
			midnightblue: "191970",
			mintcream: "f5fffa",
			mistyrose: "ffe4e1",
			moccasin: "ffe4b5",
			navajowhite: "ffdead",
			navy: "000080",
			oldlace: "fdf5e6",
			olive: "808000",
			olivedrab: "6b8e23",
			orange: "ffa500",
			orangered: "ff4500",
			orchid: "da70d6",
			palegoldenrod: "eee8aa",
			palegreen: "98fb98",
			paleturquoise: "afeeee",
			palevioletred: "db7093",
			papayawhip: "ffefd5",
			peachpuff: "ffdab9",
			peru: "cd853f",
			pink: "ffc0cb",
			plum: "dda0dd",
			powderblue: "b0e0e6",
			purple: "800080",
			rebeccapurple: "663399",
			red: "f00",
			rosybrown: "bc8f8f",
			royalblue: "4169e1",
			saddlebrown: "8b4513",
			salmon: "fa8072",
			sandybrown: "f4a460",
			seagreen: "2e8b57",
			seashell: "fff5ee",
			sienna: "a0522d",
			silver: "c0c0c0",
			skyblue: "87ceeb",
			slateblue: "6a5acd",
			slategray: "708090",
			slategrey: "708090",
			snow: "fffafa",
			springgreen: "00ff7f",
			steelblue: "4682b4",
			tan: "d2b48c",
			teal: "008080",
			thistle: "d8bfd8",
			tomato: "ff6347",
			turquoise: "40e0d0",
			violet: "ee82ee",
			wheat: "f5deb3",
			white: "fff",
			whitesmoke: "f5f5f5",
			yellow: "ff0",
			yellowgreen: "9acd32"
	};
	
	// Make it easy to access colors via `hexNames[hex]`
	var hexNames = tinycolor.hexNames = flip(names);
	
	
	// Utilities
	// ---------
	
	// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
	function flip(o) {
			var flipped = { };
			for (var i in o) {
					if (o.hasOwnProperty(i)) {
							flipped[o[i]] = i;
					}
			}
			return flipped;
	}
	
	// Return a valid alpha value [0,1] with all invalid values being set to 1
	function boundAlpha(a) {
			a = parseFloat(a);
	
			if (isNaN(a) || a < 0 || a > 1) {
					a = 1;
			}
	
			return a;
	}
	
	// Take input from [0, n] and return it as [0, 1]
	function bound01(n, max) {
			if (isOnePointZero(n)) { n = "100%"; }
	
			var processPercent = isPercentage(n);
			n = mathMin(max, mathMax(0, parseFloat(n)));
	
			// Automatically convert percentage into number
			if (processPercent) {
					n = parseInt(n * max, 10) / 100;
			}
	
			// Handle floating point rounding errors
			if ((math.abs(n - max) < 0.000001)) {
					return 1;
			}
	
			// Convert into [0, 1] range if it isn't already
			return (n % max) / parseFloat(max);
	}
	
	// Force a number between 0 and 1
	function clamp01(val) {
			return mathMin(1, mathMax(0, val));
	}
	
	// Parse a base-16 hex value into a base-10 integer
	function parseIntFromHex(val) {
			return parseInt(val, 16);
	}
	
	// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
	// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
	function isOnePointZero(n) {
			return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
	}
	
	// Check to see if string passed in is a percentage
	function isPercentage(n) {
			return typeof n === "string" && n.indexOf('%') != -1;
	}
	
	// Force a hex value to have 2 characters
	function pad2(c) {
			return c.length == 1 ? '0' + c : '' + c;
	}
	
	// Replace a decimal with it's percentage value
	function convertToPercentage(n, multiplier) {
			multiplier = multiplier || 100;
			if (n <= 1) {
					n = (n * multiplier) + "%";
			}
	
			return n;
	}
	
	// Converts a decimal to a hex value
	function convertDecimalToHex(d) {
			return Math.round(parseFloat(d) * 255).toString(16);
	}
	// Converts a hex value to a decimal
	function convertHexToDecimal(h) {
			return (parseIntFromHex(h) / 255);
	}
	
	var matchers = (function() {
	
			// <http://www.w3.org/TR/css3-values/#integers>
			var CSS_INTEGER = "[-\\+]?\\d+%?";
	
			// <http://www.w3.org/TR/css3-values/#number-value>
			var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
	
			// Allow positive/negative integer/number.	Don't capture the either/or, just the entire outcome.
			var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
	
			// Actual matching.
			// Parentheses and commas are optional, but not required.
			// Whitespace can take the place of commas or opening paren
			var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
			var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
	
			return {
					rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
					rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
					hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
					hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
					hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
					hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
					hex3: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
					hex6: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
					hex8: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
			};
	})();
	
	// `stringInputToObject`
	// Permissive string parsing.	Take in a number of formats, and output an object
	// based on detected format.	Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
	function stringInputToObject(color) {
	
			color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
			var named = false;
			if (names[color]) {
					color = names[color];
					named = true;
			}
			else if (color == 'transparent') {
					return { r: 0, g: 0, b: 0, a: 0, format: "name" };
			}
	
			// Try to match string input using regular expressions.
			// Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
			// Just return an object and let the conversion functions handle that.
			// This way the result will be the same whether the tinycolor is initialized with string or object.
			var match;
			if ((match = matchers.rgb.exec(color))) {
					return { r: match[1], g: match[2], b: match[3] };
			}
			if ((match = matchers.rgba.exec(color))) {
					return { r: match[1], g: match[2], b: match[3], a: match[4] };
			}
			if ((match = matchers.hsl.exec(color))) {
					return { h: match[1], s: match[2], l: match[3] };
			}
			if ((match = matchers.hsla.exec(color))) {
					return { h: match[1], s: match[2], l: match[3], a: match[4] };
			}
			if ((match = matchers.hsv.exec(color))) {
					return { h: match[1], s: match[2], v: match[3] };
			}
			if ((match = matchers.hsva.exec(color))) {
					return { h: match[1], s: match[2], v: match[3], a: match[4] };
			}
			if ((match = matchers.hex8.exec(color))) {
					return {
							a: convertHexToDecimal(match[1]),
							r: parseIntFromHex(match[2]),
							g: parseIntFromHex(match[3]),
							b: parseIntFromHex(match[4]),
							format: named ? "name" : "hex8"
					};
			}
			if ((match = matchers.hex6.exec(color))) {
					return {
							r: parseIntFromHex(match[1]),
							g: parseIntFromHex(match[2]),
							b: parseIntFromHex(match[3]),
							format: named ? "name" : "hex"
					};
			}
			if ((match = matchers.hex3.exec(color))) {
					return {
							r: parseIntFromHex(match[1] + '' + match[1]),
							g: parseIntFromHex(match[2] + '' + match[2]),
							b: parseIntFromHex(match[3] + '' + match[3]),
							format: named ? "name" : "hex"
					};
			}
	
			return false;
	}
	
	function validateWCAG2Parms(parms) {
			// return valid WCAG2 parms for isReadable.
			// If input parms are invalid, return {"level":"AA", "size":"small"}
			var level, size;
			parms = parms || {"level":"AA", "size":"small"};
			level = (parms.level || "AA").toUpperCase();
			size = (parms.size || "small").toLowerCase();
			if (level !== "AA" && level !== "AAA") {
					level = "AA";
			}
			if (size !== "small" && size !== "large") {
					size = "small";
			}
			return {"level":level, "size":size};
	}
	// Node: Export function
	if (typeof module !== "undefined" && module.exports) {
			module.exports = tinycolor;
	}
	// AMD/requirejs: Define the module
	else if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {return tinycolor;}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	// Browser: Expose to window
	else {
			window.tinycolor = tinycolor;
	}
	
	})();


/***/ },
/* 1489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChromeFields = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1287);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(1487);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _reactAddonsShallowCompare = __webpack_require__(1464);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _common = __webpack_require__(1462);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChromeFields = exports.ChromeFields = function (_React$Component) {
	  _inherits(ChromeFields, _React$Component);
	
	  function ChromeFields() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, ChromeFields);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(ChromeFields)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.state = {
	      view: ''
	    }, _this.handleChange = function (data) {
	      _this.props.onChange(data);
	    }, _this.toggleViews = function () {
	      if (_this.state.view === 'hex') {
	        _this.setState({ view: 'rgb' });
	      } else if (_this.state.view === 'rgb') {
	        _this.setState({ view: 'hsl' });
	      } else if (_this.state.view === 'hsl') {
	        if (_this.props.hsl.a === 1) {
	          _this.setState({ view: 'hex' });
	        } else {
	          _this.setState({ view: 'rgb' });
	        }
	      }
	    }, _this.handleChange = function (data) {
	      if (data.hex) {
	        _color2.default.isValidHex(data.hex) && _this.props.onChange({
	          hex: data.hex,
	          source: 'hex'
	        });
	      } else if (data.r || data.g || data.b) {
	        _this.props.onChange({
	          r: data.r || _this.props.rgb.r,
	          g: data.g || _this.props.rgb.g,
	          b: data.b || _this.props.rgb.b,
	          source: 'rgb'
	        });
	      } else if (data.a) {
	        if (data.a < 0) {
	          data.a = 0;
	        } else if (data.a > 1) {
	          data.a = 1;
	        }
	
	        _this.props.onChange({
	          h: _this.props.hsl.h,
	          s: _this.props.hsl.s,
	          l: _this.props.hsl.l,
	          a: Math.round(data.a * 100) / 100,
	          source: 'rgb'
	        });
	      } else if (data.h || data.s || data.l) {
	
	        _this.props.onChange({
	          h: data.h || _this.props.hsl.h,
	          s: data.s && data.s.replace('%', '') || _this.props.hsl.s,
	          l: data.l && data.l.replace('%', '') || _this.props.hsl.l,
	          source: 'hsl'
	        });
	      }
	    }, _this.showHighlight = function (e) {
	      e.target.style.background = "#eee";
	    }, _this.hideHighlight = function (e) {
	      e.target.style.background = "transparent";
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ChromeFields, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.hsl.a === 1 && this.state.view !== 'hex') {
	        this.setState({ view: 'hex' });
	      } else if (this.state.view !== 'rgb' && this.state.view !== 'hsl') {
	        this.setState({ view: 'rgb' });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.hsl.a !== 1 && this.state.view === 'hex') {
	        this.setState({ view: 'rgb' });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          wrap: {
	            paddingTop: '16px',
	            display: 'flex'
	          },
	          fields: {
	            flex: '1',
	            display: 'flex',
	            marginLeft: '-6px'
	          },
	          field: {
	            paddingLeft: '6px',
	            width: '100%'
	          },
	          alpha: {
	            paddingLeft: '6px',
	            width: '100%'
	          },
	          toggle: {
	            width: '32px',
	            textAlign: 'right',
	            position: 'relative'
	          },
	          icon: {
	            marginRight: '-4px',
	            marginTop: '12px',
	            cursor: 'pointer',
	            position: 'relative'
	          },
	          iconHighlight: {
	            position: 'absolute',
	            width: '24px',
	            height: '28px',
	            background: '#eee',
	            borderRadius: '4px',
	            top: '10px',
	            left: '12px',
	            display: 'none'
	          },
	          input: {
	            fontSize: '11px',
	            color: '#333',
	            width: '100%',
	            borderRadius: '2px',
	            border: 'none',
	            boxShadow: 'inset 0 0 0 1px #dadada',
	            height: '21px',
	            textAlign: 'center'
	          },
	          label: {
	            textTransform: 'uppercase',
	            fontSize: '11px',
	            lineHeight: '11px',
	            color: '#969696',
	            textAlign: 'center',
	            display: 'block',
	            marginTop: '12px'
	          }
	        },
	        'disableAlpha': {
	          alpha: {
	            display: 'none'
	          }
	        }
	      }, this.props, this.state);
	
	      var fields;
	      if (this.state.view === 'hex') {
	        fields = _react2.default.createElement(
	          'div',
	          { style: styles.fields, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, { style: { input: styles.input, label: styles.label }, label: 'hex', value: this.props.hex, onChange: this.handleChange })
	          )
	        );
	      } else if (this.state.view === 'rgb') {
	        fields = _react2.default.createElement(
	          'div',
	          { style: styles.fields, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, { style: { input: styles.input, label: styles.label }, label: 'r', value: this.props.rgb.r, onChange: this.handleChange })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, { style: { input: styles.input, label: styles.label }, label: 'g', value: this.props.rgb.g, onChange: this.handleChange })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, { style: { input: styles.input, label: styles.label }, label: 'b', value: this.props.rgb.b, onChange: this.handleChange })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.alpha },
	            _react2.default.createElement(_common.EditableInput, { style: { input: styles.input, label: styles.label }, label: 'a', value: this.props.rgb.a, arrowOffset: .01, onChange: this.handleChange })
	          )
	        );
	      } else if (this.state.view === 'hsl') {
	        fields = _react2.default.createElement(
	          'div',
	          { style: styles.fields, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, { style: { input: styles.input, label: styles.label }, label: 'h', value: Math.round(this.props.hsl.h), onChange: this.handleChange })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, { style: { input: styles.input, label: styles.label }, label: 's', value: Math.round(this.props.hsl.s * 100) + '%', onChange: this.handleChange })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, { style: { input: styles.input, label: styles.label }, label: 'l', value: Math.round(this.props.hsl.l * 100) + '%', onChange: this.handleChange })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.alpha },
	            _react2.default.createElement(_common.EditableInput, { style: { input: styles.input, label: styles.label }, label: 'a', value: this.props.hsl.a, arrowOffset: .01, onChange: this.handleChange })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.wrap, className: 'flexbox-fix' },
	        fields,
	        _react2.default.createElement(
	          'div',
	          { style: styles.toggle },
	          _react2.default.createElement(
	            'div',
	            { style: styles.icon, onClick: this.toggleViews, ref: 'icon' },
	            _react2.default.createElement(
	              'svg',
	              { style: { width: '24px', height: '24px', border: '1px transparent solid', borderRadius: '5px' },
	                viewBox: '0 0 24 24',
	                onMouseOver: this.showHighlight,
	                onMouseEnter: this.showHighlight,
	                onMouseOut: this.hideHighlight },
	              _react2.default.createElement('path', { ref: 'iconUp', fill: '#333', d: 'M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z' }),
	              _react2.default.createElement('path', { ref: 'iconDown', fill: '#333', d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15Z' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ChromeFields;
	}(_react2.default.Component);
	
	exports.default = ChromeFields;

/***/ },
/* 1490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChromePointer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1287);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1464);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChromePointer = exports.ChromePointer = function (_React$Component) {
	  _inherits(ChromePointer, _React$Component);
	
	  function ChromePointer() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, ChromePointer);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(ChromePointer)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ChromePointer, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          picker: {
	            width: '12px',
	            height: '12px',
	            borderRadius: '6px',
	            transform: 'translate(-6px, -1px)',
	            backgroundColor: 'rgb(248, 248, 248)',
	            boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
	          }
	        }
	      });
	
	      return _react2.default.createElement('div', { style: styles.picker });
	    }
	  }]);
	
	  return ChromePointer;
	}(_react2.default.Component);
	
	exports.default = ChromePointer;

/***/ },
/* 1491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChromePointerCircle = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1287);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1464);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChromePointerCircle = exports.ChromePointerCircle = function (_React$Component) {
	  _inherits(ChromePointerCircle, _React$Component);
	
	  function ChromePointerCircle() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, ChromePointerCircle);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(ChromePointerCircle)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ChromePointerCircle, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          picker: {
	            width: '12px',
	            height: '12px',
	            borderRadius: '6px',
	            boxShadow: 'inset 0 0 0 1px #fff',
	            transform: 'translate(-6px, -6px)'
	          }
	        }
	      });
	
	      return _react2.default.createElement('div', { style: styles.picker });
	    }
	  }]);
	
	  return ChromePointerCircle;
	}(_react2.default.Component);
	
	exports.default = ChromePointerCircle;

/***/ },
/* 1492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Compact = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1287);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(1487);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _reactAddonsShallowCompare = __webpack_require__(1464);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _reactMaterialDesign = __webpack_require__(1493);
	
	var _common = __webpack_require__(1462);
	
	var _CompactColor = __webpack_require__(1501);
	
	var _CompactColor2 = _interopRequireDefault(_CompactColor);
	
	var _CompactFields = __webpack_require__(1502);
	
	var _CompactFields2 = _interopRequireDefault(_CompactFields);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Compact = exports.Compact = function (_React$Component) {
	  _inherits(Compact, _React$Component);
	
	  function Compact() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, Compact);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Compact)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleChange = function (data) {
	      if (data.hex) {
	        _color2.default.isValidHex(data.hex) && _this.props.onChange({
	          hex: data.hex,
	          source: 'hex'
	        });
	      } else {
	        _this.props.onChange(data);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Compact, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          Compact: {
	            background: '#f6f6f6',
	            radius: '4px'
	          },
	          compact: {
	            paddingTop: '5px',
	            paddingLeft: '5px',
	            boxSizing: 'initial',
	            width: '240px'
	          },
	
	          clear: {
	            clear: 'both'
	          }
	        }
	      });
	
	      var colors = [];
	      if (this.props.colors) {
	        for (var i = 0; i < this.props.colors.length; i++) {
	          var color = this.props.colors[i];
	          colors.push(_react2.default.createElement(_CompactColor2.default, { key: color, color: color, active: color.toLowerCase() == this.props.hex, onClick: this.handleChange }));
	        }
	      }
	
	      return _react2.default.createElement(
	        _reactMaterialDesign.Raised,
	        { style: styles.Compact },
	        _react2.default.createElement(
	          'div',
	          { style: styles.compact },
	          _react2.default.createElement(
	            'div',
	            { ref: 'colors' },
	            colors,
	            _react2.default.createElement('div', { style: styles.clear })
	          ),
	          _react2.default.createElement(_CompactFields2.default, _extends({}, this.props, { onChange: this.handleChange }))
	        )
	      );
	    }
	  }]);
	
	  return Compact;
	}(_react2.default.Component);
	
	Compact.defaultProps = {
	  colors: ['#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#333333', '#808080', '#cccccc', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E']
	};
	
	exports.default = (0, _common.ColorWrap)(Compact);

/***/ },
/* 1493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true,
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _libComponentsRaised = __webpack_require__(1494);
	
	var _libComponentsRaised2 = _interopRequireDefault(_libComponentsRaised);
	
	var _libComponentsTile = __webpack_require__(1495);
	
	var _libComponentsTile2 = _interopRequireDefault(_libComponentsTile);
	
	var _libComponentsTabs = __webpack_require__(1496);
	
	var _libComponentsTabs2 = _interopRequireDefault(_libComponentsTabs);
	
	exports.Raised = _libComponentsRaised2['default'];
	exports.Tile = _libComponentsTile2['default'];
	exports.Tabs = _libComponentsTabs2['default'];


/***/ },
/* 1494 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node: true, esnext: true */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1287);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Raised = function (_React$Component) {
	  _inherits(Raised, _React$Component);
	
	  function Raised() {
	    _classCallCheck(this, Raised);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Raised).apply(this, arguments));
	  }
	
	  _createClass(Raised, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          wrap: {
	            position: 'relative'
	          },
	          content: {
	            position: 'relative'
	          },
	          bg: {
	            absolute: '0px 0px 0px 0px',
	            boxShadow: '0 ${ this.props.zDepth }px ${ this.props.zDepth * 4 }px rgba(0,0,0,.24)',
	            borderRadius: this.props.radius,
	            background: this.props.background
	          }
	        },
	        'zDepth-0': {
	          bg: {
	            boxShadow: 'none'
	          }
	        },
	
	        'zDepth-1': {
	          bg: {
	            boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
	          }
	        },
	        'zDepth-2': {
	          bg: {
	            boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
	          }
	        },
	        'zDepth-3': {
	          bg: {
	            boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
	          }
	        },
	        'zDepth-4': {
	          bg: {
	            boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
	          }
	        },
	        'zDepth-5': {
	          bg: {
	            boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
	          }
	        },
	        'square': {
	          bg: {
	            borderRadius: '0'
	          }
	        },
	        'circle': {
	          bg: {
	            borderRadius: '50%'
	          }
	        }
	      }, this.props);
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.wrap },
	        _react2.default.createElement('div', { style: styles.bg }),
	        _react2.default.createElement(
	          'div',
	          { style: styles.content },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return Raised;
	}(_react2.default.Component);
	
	Raised.propTypes = {
	  background: _react2.default.PropTypes.string,
	  zDepth: _react2.default.PropTypes.oneOf(['0', '1', '2', '3', '4', '5', 0, 1, 2, 3, 4, 5]),
	  radius: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.number])
	};
	
	Raised.defaultProps = {
	  background: '#fff',
	  zDepth: '1',
	  radius: '2px'
	};
	
	exports.default = Raised;

/***/ },
/* 1495 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node: true, esnext: true */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1287);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tile = function (_React$Component) {
	  _inherits(Tile, _React$Component);
	
	  function Tile() {
	    _classCallCheck(this, Tile);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Tile).apply(this, arguments));
	  }
	
	  _createClass(Tile, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          tile: {
	            fontSize: '16px',
	            padding: '16px',
	            display: 'flex',
	            justifyContent: 'space-between',
	            color: this.props.color
	          },
	          primary: {
	            display: 'flex',
	            width: '100%'
	          },
	          sidebar: {
	            minWidth: '56px',
	            maxWidth: '56px',
	            flexBasis: '56px' },
	          content: {
	            background: 'none',
	            flex: '1',
	            overflow: 'scroll'
	          },
	          secondary: {
	            flexBasis: '42',
	            textAlign: 'center'
	          },
	          sidebarIcon: {
	            marginTop: '-12px',
	            marginLeft: '-12px',
	            marginBottom: '-12px'
	          }
	        },
	        'divider': {
	          tile: {
	            boxShadow: 'inset 0 -1px 0 rgba(0,0,0,.12)'
	          }
	        },
	        'condensed': {
	          tile: {
	            paddingBottom: '0px',
	            paddingTop: '0px'
	          },
	          sidebar: {
	            minWidth: '28px',
	            maxWidth: '28px',
	            flexBasis: '28px'
	          }
	        }
	      }, {
	        'clickable': this.props.onClick
	      }, this.props);
	
	      var _props$children = _slicedToArray(this.props.children, 2);
	
	      var sidebar = _props$children[0];
	      var content = _props$children[1];
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.tile, className: 'flexbox-fix' },
	        _react2.default.createElement(
	          'div',
	          { style: styles.primary, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.sidebar, key: "sidebar-#{ sidebar }" },
	            sidebar
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.content, key: "content-#{ content }" },
	            content
	          )
	        )
	      );
	    }
	  }]);
	
	  return Tile;
	}(_react2.default.Component);
	
	;
	
	exports.default = Tile;

/***/ },
/* 1496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1287);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _isString = __webpack_require__(1497);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _Tab = __webpack_require__(1499);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _Link = __webpack_require__(1500);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// var Ink = require('./Ink');
	
	// var context = {
	//   primaryColor: '#2196F3',
	//   accentColor: '#E91E63',
	//   theme: 'light'
	// }
	
	var Tabs = function (_React$Component) {
	  _inherits(Tabs, _React$Component);
	
	  function Tabs(props) {
	    _classCallCheck(this, Tabs);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Tabs).call(this));
	
	    var selectedTab;
	    if (props.selectedTab < (props.tabs && props.tabs.length)) {
	      selectedTab = props.selectedTab;
	    } else {
	      selectedTab = 0;
	    }
	
	    _this.state = {
	      selectedTab: selectedTab
	    };
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.slide = _this.slide.bind(_this);
	    return _this;
	  }
	
	  _createClass(Tabs, [{
	    key: 'handleClick',
	    value: function handleClick(tab) {
	      if (this.props.onChange) {
	        this.props.onChange(tab);
	      }
	
	      this.setState({
	        selectedTab: tab
	      });
	    }
	  }, {
	    key: 'slide',
	    value: function slide() {
	      if (this.props.tabs.length) {
	        var containerNode = this.refs.tabs.getDOMNode();
	        var containerLeft = containerNode.scrollLeft;
	        var containerRight = containerNode.offsetWidth + containerNode.scrollLeft;
	
	        var selectedNode = this.refs['tab-' + this.state.selectedTab] && this.refs['tab-' + this.state.selectedTab].getDOMNode();
	        var selectedLeft = selectedNode && selectedNode.getBoundingClientRect().left - containerNode.getBoundingClientRect().left + containerNode.scrollLeft;
	        var selectedRight = selectedNode && selectedLeft + selectedNode.offsetWidth;
	
	        // scroll right if tab is off screen
	        if (selectedRight > containerRight) {
	          containerNode.scrollLeft += selectedRight - containerRight;
	        }
	
	        // scroll left if tab is off screen
	        if (selectedLeft < containerLeft) {
	          containerNode.scrollLeft -= containerLeft - selectedLeft;
	        }
	
	        // slide the indicator
	        var indicator = this.refs.indicator;
	        indicator.style.left = selectedLeft + 'px';
	        indicator.style.width = selectedNode.offsetWidth + 'px';
	        indicator.style.height = '2px';
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.slide();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.selectedTab !== this.state.selectedTab) {
	        this.setState({ selectedTab: nextProps.selectedTab });
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      if (nextState.selectedTab >= (nextProps.tabs && nextProps.tabs.length)) {
	        nextState.selectedTab = nextProps.tabs.length - 1;
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.slide();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          tabs: {
	            position: 'relative',
	            background: this.props.background
	          },
	          tabWrap: {
	            display: 'flex'
	          },
	          tab: {
	            justifyContent: 'flex-start',
	            minWidth: '68px',
	            maxWidth: '240px'
	          },
	          Tab: {
	            color: this.props.color,
	            inactive: this.props.inactive,
	            capitalize: this.props.capitalize
	          },
	          indicator: {
	            height: '0',
	            position: 'absolute',
	            bottom: '0',
	            left: '0',
	            background: this.props.color,
	            transition: 'all 200ms linear'
	          }
	        },
	        'scrollable': {
	          tabs: {
	            overflowX: 'scroll'
	          },
	          tabWrap: {
	            paddingLeft: '60px',
	            justifyContent: 'flex-start',
	            width: '400%'
	          },
	          tab: {
	            width: 'auto'
	          }
	        },
	        'align-justify': {
	          tabWrap: {
	            justifyContent: 'space-between'
	          },
	          tab: {
	            width: 100 / this.props.tabs.length + '%'
	          }
	        },
	        'align-left': {
	          tabWrap: {
	            paddingLeft: '60px',
	            justifyContent: 'flex-start'
	          },
	          tab: {
	            width: 'auto'
	          }
	        },
	        'align-center': {
	          tabWrap: {
	            justifyContent: 'center'
	          },
	          tab: {
	            width: 'auto'
	          }
	        }
	      }, {
	        'scrollable': this.props.width / this.props.tabs.length < 72
	      }, this.props, this.state);
	
	      var tabs = [];
	      for (var i = 0; i < this.props.tabs.length; i++) {
	        var tab = this.props.tabs[i];
	
	        var label;
	        var callback;
	        var callbackValue;
	        var newTab;
	        if ((0, _isString2.default)(tab)) {
	          label = tab;
	          callback = null;
	        } else {
	          label = tab.label;
	          callback = tab.onClick;
	          callbackValue = tab.callbackValue;
	          newTab = tab.newTab;
	        }
	
	        tabs.push(_react2.default.createElement(
	          'div',
	          { style: styles.tab, ref: 'tab-' + i, key: i },
	          _react2.default.createElement(
	            _Link2.default,
	            { onClick: callback, callbackValue: callbackValue, newTab: newTab },
	            _react2.default.createElement(
	              _Tab2.default,
	              { style: styles.Tab, tab: i, selected: this.state.selectedTab === i, selectable: tab.selectable, onClick: this.handleClick },
	              label
	            )
	          )
	        ));
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.tabs, ref: 'tabs' },
	        _react2.default.createElement(
	          'div',
	          { style: styles.tabWrap, className: 'flexbox-fix' },
	          tabs
	        ),
	        _react2.default.createElement('div', { style: styles.indicator, ref: 'indicator' })
	      );
	    }
	  }]);
	
	  return Tabs;
	}(_react2.default.Component);
	
	Tabs.defaultProps = {
	  selectedTab: 0,
	  background: 'transparent',
	  color: '#fff'
	};
	
	exports.default = Tabs;

/***/ },
/* 1497 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(1478),
	    isArray = __webpack_require__(1498),
	    isObjectLike = __webpack_require__(1482);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 1498 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 1499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1287);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tab = function (_React$Component) {
	  _inherits(Tab, _React$Component);
	
	  function Tab() {
	    _classCallCheck(this, Tab);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Tab).call(this));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Tab, [{
	    key: 'handleClick',
	    value: function handleClick() {
	      if (this.props.selectable !== false) {
	        this.props.onClick(this.props.tab);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          tab: {
	            color: this.props.inactive || this.props.color,
	            cursor: 'pointer',
	            paddingLeft: '12px',
	            paddingRight: '12px',
	            height: '48px',
	            lineHeight: '48px',
	            textAlign: 'center',
	            fontSize: '14px',
	            textTransform: this.props.capitalize === false ? '' : 'uppercase',
	            fontWeight: '500',
	            whiteSpace: 'nowrap',
	            opacity: '.47',
	            transition: 'opacity 100ms linear'
	          }
	        },
	        'selected': {
	          tab: {
	            color: this.props.color,
	            opacity: '.87'
	          }
	        }
	      }, this.props);
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.tab, onClick: this.handleClick },
	        this.props.children
	      );
	    }
	  }]);
	
	  return Tab;
	}(_react2.default.Component);
	
	Tab.propTypes = {
	  selected: _react2.default.PropTypes.bool
	};
	
	Tab.defaultProps = {
	  selected: false,
	  color: '#fff'
	};
	
	exports.default = Tab;

/***/ },
/* 1500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _isString = __webpack_require__(1497);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Link = function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    _classCallCheck(this, Link);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Link).call(this));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Link, [{
	    key: 'handleClick',
	    value: function handleClick(e) {
	      if (this.props.onClick) {
	        this.props.onClick(e, this.props.callbackValue);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var a;
	      if ((0, _isString2.default)(this.props.onClick)) {
	        a = _react2.default.createElement(
	          'a',
	          { style: { textDecoration: 'none' }, href: this.props.onClick, target: this.props.newTab && '_blank' },
	          this.props.children
	        );
	      } else {
	        a = _react2.default.createElement(
	          'a',
	          { style: { textDecoration: 'none' }, onClick: this.handleClick },
	          this.props.children
	        );
	      }
	
	      return a;
	    }
	  }]);
	
	  return Link;
	}(_react2.default.Component);
	
	// Link.propTypes =
	//   onClick: React.PropTypes.oneOfType(
	//     React.PropTypes.string,
	//     React.PropTypes.func
	//   );
	
	Link.defaultProps = {
	  newTab: false
	};
	
	exports.default = Link;

/***/ },
/* 1501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CompactColor = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1287);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1464);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CompactColor = exports.CompactColor = function (_React$Component) {
	  _inherits(CompactColor, _React$Component);
	
	  function CompactColor() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, CompactColor);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(CompactColor)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleClick = function () {
	      _this.props.onClick({ hex: _this.props.color });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CompactColor, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          color: {
	            background: this.props.color,
	            width: '15px',
	            height: '15px',
	            float: 'left',
	            marginRight: '5px',
	            marginBottom: '5px',
	            position: 'relative',
	            cursor: 'pointer'
	          },
	          dot: {
	            absolute: '5px 5px 5px 5px',
	            background: '#fff',
	            borderRadius: '50%',
	            opacity: '0'
	          }
	        },
	        'active': {
	          dot: {
	            opacity: '1'
	          }
	        },
	        'color-#FFFFFF': {
	          color: {
	            boxShadow: 'inset 0 0 0 1px #ddd'
	          },
	          dot: {
	            background: '#000'
	          }
	        }
	      }, this.props);
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.color, ref: 'color', onClick: this.handleClick },
	        _react2.default.createElement('div', { style: styles.dot })
	      );
	    }
	  }]);
	
	  return CompactColor;
	}(_react2.default.Component);
	
	exports.default = CompactColor;

/***/ },
/* 1502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CompactColor = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1287);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1464);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _common = __webpack_require__(1462);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CompactColor = exports.CompactColor = function (_React$Component) {
	  _inherits(CompactColor, _React$Component);
	
	  function CompactColor() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, CompactColor);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(CompactColor)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleChange = function (data) {
	      if (data.r || data.g || data.b) {
	        _this.props.onChange({
	          r: data.r || _this.props.rgb.r,
	          g: data.g || _this.props.rgb.g,
	          b: data.b || _this.props.rgb.b,
	          source: 'rgb'
	        });
	      } else {
	        _this.props.onChange({
	          hex: data,
	          source: 'hex'
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CompactColor, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          fields: {
	            display: 'flex',
	            paddingBottom: '6px',
	            paddingRight: '5px',
	            position: 'relative'
	          },
	          active: {
	            position: 'absolute',
	            top: '6px',
	            left: '5px',
	            height: '9px',
	            width: '9px',
	            background: '#' + this.props.hex
	          },
	          HEXwrap: {
	            flex: '6',
	            position: 'relative'
	          },
	          HEXinput: {
	            width: '80%',
	            padding: '0px',
	            paddingLeft: '20%',
	            border: 'none',
	            outline: 'none',
	            background: 'none',
	            fontSize: '12px',
	            color: '#333',
	            height: '16px'
	          },
	          HEXlabel: {
	            display: 'none'
	          },
	          RGBwrap: {
	            flex: '3',
	            position: 'relative'
	          },
	          RGBinput: {
	            width: '70%',
	            padding: '0px',
	            paddingLeft: '30%',
	            border: 'none',
	            outline: 'none',
	            background: 'none',
	            fontSize: '12px',
	            color: '#333',
	            height: '16px'
	          },
	          RGBlabel: {
	            position: 'absolute',
	            top: '3px',
	            left: '0px',
	            lineHeight: '16px',
	            textTransform: 'uppercase',
	            fontSize: '12px',
	            color: '#999'
	          }
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.fields, className: 'flexbox-fix' },
	        _react2.default.createElement('div', { style: styles.active }),
	        _react2.default.createElement(_common.EditableInput, { style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel }, label: 'hex', value: this.props.hex, onChange: this.handleChange }),
	        _react2.default.createElement(_common.EditableInput, { style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel }, label: 'r', value: this.props.rgb.r, onChange: this.handleChange }),
	        _react2.default.createElement(_common.EditableInput, { style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel }, label: 'g', value: this.props.rgb.g, onChange: this.handleChange }),
	        _react2.default.createElement(_common.EditableInput, { style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel }, label: 'b', value: this.props.rgb.b, onChange: this.handleChange })
	      );
	    }
	  }]);
	
	  return CompactColor;
	}(_react2.default.Component);
	
	exports.default = CompactColor;

/***/ },
/* 1503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Material = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1287);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(1487);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _reactAddonsShallowCompare = __webpack_require__(1464);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _reactMaterialDesign = __webpack_require__(1493);
	
	var _common = __webpack_require__(1462);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Material = exports.Material = function (_React$Component) {
	  _inherits(Material, _React$Component);
	
	  function Material() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, Material);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Material)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleChange = function (data) {
	      if (data.hex) {
	        _color2.default.isValidHex(data.hex) && _this.props.onChange({
	          hex: data.hex,
	          source: 'hex'
	        });
	      } else if (data.r || data.g || data.b) {
	        _this.props.onChange({
	          r: data.r || _this.props.rgb.r,
	          g: data.g || _this.props.rgb.g,
	          b: data.b || _this.props.rgb.b,
	          source: 'rgb'
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Material, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          material: {
	            width: '98px',
	            height: '98px',
	            padding: '16px',
	            fontFamily: 'Roboto'
	          },
	          HEXwrap: {
	            position: 'relative'
	          },
	          HEXinput: {
	            width: '100%',
	            marginTop: '12px',
	            fontSize: '15px',
	            color: '#333',
	            padding: '0px',
	            border: '0px',
	            borderBottom: '2px solid ' + this.props.hex,
	            outline: 'none',
	            height: '30px'
	          },
	          HEXlabel: {
	            position: 'absolute',
	            top: '0px',
	            left: '0px',
	            fontSize: '11px',
	            color: '#999999',
	            textTransform: 'capitalize'
	          },
	          Hex: {
	            style: {}
	          },
	          RGBwrap: {
	            position: 'relative'
	          },
	          RGBinput: {
	            width: '100%',
	            marginTop: '12px',
	            fontSize: '15px',
	            color: '#333',
	            padding: '0px',
	            border: '0px',
	            borderBottom: '1px solid #eee',
	            outline: 'none',
	            height: '30px'
	          },
	          RGBlabel: {
	            position: 'absolute',
	            top: '0px',
	            left: '0px',
	            fontSize: '11px',
	            color: '#999999',
	            textTransform: 'capitalize'
	          },
	          split: {
	            display: 'flex',
	            marginRight: '-10px',
	            paddingTop: '11px'
	          },
	          third: {
	            flex: '1',
	            paddingRight: '10px'
	          }
	        }
	      });
	
	      return _react2.default.createElement(
	        _reactMaterialDesign.Raised,
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: styles.material },
	          _react2.default.createElement(_common.EditableInput, { style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel }, label: 'hex', value: this.props.hex, onChange: this.handleChange }),
	          _react2.default.createElement(
	            'div',
	            { style: styles.split, className: 'flexbox-fix' },
	            _react2.default.createElement(
	              'div',
	              { style: styles.third },
	              _react2.default.createElement(_common.EditableInput, { style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel }, label: 'r', value: this.props.rgb.r, onChange: this.handleChange })
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: styles.third },
	              _react2.default.createElement(_common.EditableInput, { style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel }, label: 'g', value: this.props.rgb.g, onChange: this.handleChange })
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: styles.third },
	              _react2.default.createElement(_common.EditableInput, { style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel }, label: 'b', value: this.props.rgb.b, onChange: this.handleChange })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Material;
	}(_react2.default.Component);
	
	exports.default = (0, _common.ColorWrap)(Material);

/***/ },
/* 1504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Photoshop = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1287);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1464);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _common = __webpack_require__(1462);
	
	var _PhotoshopFields = __webpack_require__(1505);
	
	var _PhotoshopFields2 = _interopRequireDefault(_PhotoshopFields);
	
	var _PhotoshopPointerCircle = __webpack_require__(1506);
	
	var _PhotoshopPointerCircle2 = _interopRequireDefault(_PhotoshopPointerCircle);
	
	var _PhotoshopPointer = __webpack_require__(1507);
	
	var _PhotoshopPointer2 = _interopRequireDefault(_PhotoshopPointer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Photoshop = exports.Photoshop = function (_React$Component) {
	  _inherits(Photoshop, _React$Component);
	
	  function Photoshop(props) {
	    _classCallCheck(this, Photoshop);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Photoshop).call(this));
	
	    _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]);
	
	    _this.handleChange = function (data) {
	      _this.props.onChange(data);
	    };
	
	    _this.handleAccept = function () {
	      _this.props.onAccept && _this.props.onAccept();
	    };
	
	    _this.handleCancel = function () {
	      _this.props.onCancel && _this.props.onCancel();
	    };
	
	    _this.state = {
	      currentColor: props.hex
	    };
	    return _this;
	  }
	
	  _createClass(Photoshop, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          picker: {
	            background: '#DCDCDC',
	            borderRadius: '4px',
	            boxShadow: '0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)',
	            boxSizing: 'initial',
	            width: '513px'
	          },
	          head: {
	            backgroundImage: 'linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)',
	            borderBottom: '1px solid #B1B1B1',
	            boxShadow: 'inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)',
	            height: '23px',
	            lineHeight: '24px',
	            borderRadius: '4px 4px 0 0',
	            fontSize: '13px',
	            color: '#4D4D4D',
	            textAlign: 'center'
	          },
	          body: {
	            padding: '15px 15px 0',
	            display: 'flex'
	          },
	          saturation: {
	            width: '256px',
	            height: '256px',
	            position: 'relative',
	            border: '2px solid #B3B3B3',
	            borderBottom: '2px solid #F0F0F0',
	            overflow: 'hidden'
	          },
	          hue: {
	            position: 'relative',
	            height: '256px',
	            width: '19px',
	            marginLeft: '10px',
	            border: '2px solid #B3B3B3',
	            borderBottom: '2px solid #F0F0F0'
	          },
	          Hue: {
	            direction: 'vertical'
	          },
	          controls: {
	            width: '180px',
	            marginLeft: '10px'
	          },
	
	          top: {
	            display: 'flex'
	          },
	          previews: {
	            width: '60px'
	          },
	          swatches: {
	            border: '1px solid #B3B3B3',
	            borderBottom: '1px solid #F0F0F0',
	            marginBottom: '2px',
	            marginTop: '1px'
	          },
	          new: {
	            height: '34px',
	            background: 'rgb(' + this.props.rgb.r + ', ' + this.props.rgb.g + ', ' + this.props.rgb.b + ')',
	            boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000'
	          },
	          current: {
	            height: '34px',
	            background: '#' + this.state.currentColor,
	            boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000'
	          },
	          label: {
	            fontSize: '14px',
	            color: '#000',
	            textAlign: 'center'
	          },
	          actions: {
	            flex: '1',
	            marginLeft: '20px'
	          },
	          button: {
	            backgroundImage: 'linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)',
	            border: '1px solid #878787',
	            borderRadius: '2px',
	            height: '20px',
	            boxShadow: '0 1px 0 0 #EAEAEA',
	            fontSize: '14px',
	            color: '#000',
	            lineHeight: '20px',
	            textAlign: 'center',
	            marginBottom: '10px'
	          },
	          acceptButton: _defineProperty({
	            backgroundImage: 'linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)',
	            border: '1px solid #878787',
	            borderRadius: '2px',
	            height: '20px',
	            boxShadow: '0 1px 0 0 #EAEAEA',
	            fontSize: '14px',
	            color: '#000',
	            lineHeight: '20px',
	            textAlign: 'center',
	            marginBottom: '10px'
	          }, 'boxShadow', '0 0 0 1px #878787')
	        }
	      });
	
	      var header;
	
	      if (this.props.header) {
	        header = _react2.default.createElement(
	          'div',
	          { style: styles.head },
	          this.props.header
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.picker },
	        header,
	        _react2.default.createElement(
	          'div',
	          { style: styles.body, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.saturation },
	            _react2.default.createElement(_common.Saturation, _extends({ style: styles.Saturation }, this.props, { pointer: _PhotoshopPointerCircle2.default, onChange: this.handleChange }))
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.hue },
	            _react2.default.createElement(_common.Hue, _extends({}, styles.Hue, this.props, { pointer: _PhotoshopPointer2.default, onChange: this.handleChange }))
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.controls },
	            _react2.default.createElement(
	              'div',
	              { style: styles.top, className: 'flexbox-fix' },
	              _react2.default.createElement(
	                'div',
	                { style: styles.previews },
	                _react2.default.createElement(
	                  'div',
	                  { style: styles.label },
	                  'new'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: styles.swatches },
	                  _react2.default.createElement('div', { style: styles.new }),
	                  _react2.default.createElement('div', { style: styles.current })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: styles.label },
	                  'current'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: styles.actions },
	                _react2.default.createElement(
	                  'div',
	                  { style: styles.acceptButton, ref: 'accept', onClick: this.handleAccept },
	                  'OK'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: styles.button, ref: 'cancel', onClick: this.handleCancel },
	                  'Cancel'
	                ),
	                _react2.default.createElement(_PhotoshopFields2.default, this.props)
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Photoshop;
	}(_react2.default.Component);
	
	Photoshop.defaultProps = {
	  header: 'Color Picker'
	};
	
	exports.default = (0, _common.ColorWrap)(Photoshop);

/***/ },
/* 1505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPicker = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1287);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(1487);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _reactAddonsShallowCompare = __webpack_require__(1464);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _common = __webpack_require__(1462);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PhotoshopPicker = exports.PhotoshopPicker = function (_React$Component) {
	  _inherits(PhotoshopPicker, _React$Component);
	
	  function PhotoshopPicker() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, PhotoshopPicker);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(PhotoshopPicker)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleChange = function (data) {
	      if (data['#']) {
	        _color2.default.isValidHex(data['#']) && _this.props.onChange({
	          hex: data['#'],
	          source: 'hex'
	        });
	      } else if (data.r || data.g || data.b) {
	        _this.props.onChange({
	          r: data.r || _this.props.rgb.r,
	          g: data.g || _this.props.rgb.g,
	          b: data.b || _this.props.rgb.b,
	          source: 'rgb'
	        });
	      } else if (data.h || data.s || data.v) {
	        _this.props.onChange({
	          h: data.h || _this.props.hsv.h,
	          s: data.s || _this.props.hsv.s,
	          v: data.v || _this.props.hsv.v,
	          source: 'hsv'
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PhotoshopPicker, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          fields: {
	            paddingTop: '5px',
	            paddingBottom: '9px',
	            width: '80px',
	            position: 'relative'
	          },
	          divider: {
	            height: '5px'
	          },
	          RGBwrap: {
	            position: 'relative'
	          },
	          RGBinput: {
	            marginLeft: '40%',
	            width: '40%',
	            height: '18px',
	            border: '1px solid #888888',
	            boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
	            marginBottom: '5px',
	            fontSize: '13px',
	            paddingLeft: '3px',
	            marginRight: '10px'
	          },
	          RGBlabel: {
	            left: '0px',
	            width: '34px',
	            textTransform: 'uppercase',
	            fontSize: '13px',
	            height: '18px',
	            lineHeight: '22px',
	            position: 'absolute'
	          },
	          HEXwrap: {
	            position: 'relative'
	          },
	          HEXinput: {
	            marginLeft: '20%',
	            width: '80%',
	            height: '18px',
	            border: '1px solid #888888',
	            boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
	            marginBottom: '6px',
	            fontSize: '13px',
	            paddingLeft: '3px'
	          },
	          HEXlabel: {
	            position: 'absolute',
	            top: '0px',
	            left: '0px',
	            width: '14px',
	            textTransform: 'uppercase',
	            fontSize: '13px',
	            height: '18px',
	            lineHeight: '22px'
	          },
	          fieldSymbols: {
	            position: 'absolute',
	            top: '5px',
	            right: '-7px',
	            fontSize: '13px'
	          },
	          symbol: {
	            height: '20px',
	            lineHeight: '22px',
	            paddingBottom: '7px'
	          }
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.fields },
	        _react2.default.createElement(_common.EditableInput, { style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel }, label: 'h', value: Math.round(this.props.hsv.h), onChange: this.handleChange }),
	        _react2.default.createElement(_common.EditableInput, { style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel }, label: 's', value: Math.round(this.props.hsv.s * 100), onChange: this.handleChange }),
	        _react2.default.createElement(_common.EditableInput, { style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel }, label: 'v', value: Math.round(this.props.hsv.v * 100), onChange: this.handleChange }),
	        _react2.default.createElement('div', { style: styles.divider }),
	        _react2.default.createElement(_common.EditableInput, { style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel }, label: 'r', value: this.props.rgb.r, onChange: this.handleChange }),
	        _react2.default.createElement(_common.EditableInput, { style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel }, label: 'g', value: this.props.rgb.g, onChange: this.handleChange }),
	        _react2.default.createElement(_common.EditableInput, { style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel }, label: 'b', value: this.props.rgb.b, onChange: this.handleChange }),
	        _react2.default.createElement('div', { style: styles.divider }),
	        _react2.default.createElement(_common.EditableInput, { style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel }, label: '#', value: this.props.hex.replace('#', ''), onChange: this.handleChange }),
	        _react2.default.createElement(
	          'div',
	          { style: styles.fieldSymbols },
	          _react2.default.createElement(
	            'div',
	            { style: styles.symbol },
	            '°'
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.symbol },
	            '%'
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.symbol },
	            '%'
	          )
	        )
	      );
	    }
	  }]);
	
	  return PhotoshopPicker;
	}(_react2.default.Component);
	
	exports.default = PhotoshopPicker;

/***/ },
/* 1506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPointerCircle = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1287);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1464);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PhotoshopPointerCircle = exports.PhotoshopPointerCircle = function (_React$Component) {
	  _inherits(PhotoshopPointerCircle, _React$Component);
	
	  function PhotoshopPointerCircle() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, PhotoshopPointerCircle);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(PhotoshopPointerCircle)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PhotoshopPointerCircle, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          picker: {
	            width: '12px',
	            height: '12px',
	            borderRadius: '6px',
	            boxShadow: 'inset 0 0 0 1px #fff',
	            transform: 'translate(-6px, -6px)'
	          }
	        },
	        'black-outline': {
	          picker: {
	            boxShadow: 'inset 0 0 0 1px #000'
	          }
	        }
	      }, {
	        'black-outline': this.props.hsl.l > .5
	      });
	
	      return _react2.default.createElement('div', { style: styles.picker });
	    }
	  }]);
	
	  return PhotoshopPointerCircle;
	}(_react2.default.Component);
	
	exports.default = PhotoshopPointerCircle;

/***/ },
/* 1507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPointerCircle = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1287);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1464);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PhotoshopPointerCircle = exports.PhotoshopPointerCircle = function (_React$Component) {
	  _inherits(PhotoshopPointerCircle, _React$Component);
	
	  function PhotoshopPointerCircle() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, PhotoshopPointerCircle);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(PhotoshopPointerCircle)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PhotoshopPointerCircle, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          triangle: {
	            width: 0,
	            height: 0,
	            borderStyle: 'solid',
	            borderWidth: '4px 0 4px 6px',
	            borderColor: 'transparent transparent transparent #fff',
	            position: 'absolute',
	            top: '1px',
	            left: '1px'
	          },
	          triangleBorder: {
	            width: 0,
	            height: 0,
	            borderStyle: 'solid',
	            borderWidth: '5px 0 5px 8px',
	            borderColor: 'transparent transparent transparent #555'
	          },
	
	          left: {
	            Extend: 'triangleBorder',
	            transform: 'translate(-13px, -4px)'
	          },
	          leftInside: {
	            Extend: 'triangle',
	            transform: 'translate(-8px, -5px)'
	          },
	
	          right: {
	            Extend: 'triangleBorder',
	            transform: 'translate(20px, -14px) rotate(180deg)'
	          },
	          rightInside: {
	            Extend: 'triangle',
	            transform: 'translate(-8px, -5px)'
	          }
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.pointer },
	        _react2.default.createElement(
	          'div',
	          { style: styles.left },
	          _react2.default.createElement('div', { style: styles.leftInside })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.right },
	          _react2.default.createElement('div', { style: styles.rightInside })
	        )
	      );
	    }
	  }]);
	
	  return PhotoshopPointerCircle;
	}(_react2.default.Component);
	
	exports.default = PhotoshopPointerCircle;

/***/ },
/* 1508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Sketch = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1287);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1464);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _common = __webpack_require__(1462);
	
	var _SketchFields = __webpack_require__(1509);
	
	var _SketchFields2 = _interopRequireDefault(_SketchFields);
	
	var _SketchPresetColors = __webpack_require__(1510);
	
	var _SketchPresetColors2 = _interopRequireDefault(_SketchPresetColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Sketch = exports.Sketch = function (_React$Component) {
	  _inherits(Sketch, _React$Component);
	
	  function Sketch() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, Sketch);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Sketch)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleChange = function (data) {
	      _this.props.onChange(data);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Sketch, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          picker: {
	            width: this.props.width,
	            padding: '10px 10px 0',
	            boxSizing: 'initial',
	            background: '#fff',
	            borderRadius: '4px',
	            boxShadow: '0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)'
	          },
	          saturation: {
	            width: '100%',
	            paddingBottom: '75%',
	            position: 'relative',
	            overflow: 'hidden'
	          },
	          Saturation: {
	            radius: '3px',
	            shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	          },
	          controls: {
	            display: 'flex'
	          },
	          sliders: {
	            padding: '4px 0',
	            flex: '1'
	          },
	          color: {
	            width: '24px',
	            height: '24px',
	            position: 'relative',
	            marginTop: '4px',
	            marginLeft: '4px',
	            borderRadius: '3px'
	          },
	          activeColor: {
	            absolute: '0px 0px 0px 0px',
	            borderRadius: '2px',
	            background: 'rgba(' + this.props.rgb.r + ', ' + this.props.rgb.g + ', ' + this.props.rgb.b + ', ' + this.props.rgb.a + ')',
	            boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	          },
	          hue: {
	            position: 'relative',
	            height: '10px',
	            overflow: 'hidden'
	          },
	          Hue: {
	            radius: '2px',
	            shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	          },
	
	          alpha: {
	            position: 'relative',
	            height: '10px',
	            marginTop: '4px',
	            overflow: 'hidden'
	          },
	          Alpha: {
	            radius: '2px',
	            shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	          }
	        },
	        'disableAlpha': {
	          color: {
	            height: '10px'
	          },
	          hue: {
	            height: '10px'
	          },
	          alpha: {
	            display: 'none'
	          }
	        }
	      }, this.props);
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.picker },
	        _react2.default.createElement(
	          'div',
	          { style: styles.saturation },
	          _react2.default.createElement(_common.Saturation, _extends({ style: styles.Saturation }, this.props, { onChange: this.handleChange }))
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.controls, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.sliders },
	            _react2.default.createElement(
	              'div',
	              { style: styles.hue },
	              _react2.default.createElement(_common.Hue, _extends({ style: styles.Hue }, this.props, { onChange: this.handleChange }))
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: styles.alpha },
	              _react2.default.createElement(_common.Alpha, _extends({ style: styles.Alpha }, this.props, { onChange: this.handleChange }))
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.color },
	            _react2.default.createElement(_common.Checkboard, null),
	            _react2.default.createElement('div', { style: styles.activeColor })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.fields },
	          _react2.default.createElement(_SketchFields2.default, _extends({}, this.props, { onChange: this.handleChange, disableAlpha: this.props.disableAlpha }))
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.presets },
	          _react2.default.createElement(_SketchPresetColors2.default, { colors: this.props.presetColors, onClick: this.handleChange })
	        )
	      );
	    }
	  }]);
	
	  return Sketch;
	}(_react2.default.Component);
	
	Sketch.defaultProps = {
	  presetColors: ['#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF'],
	  width: 200
	};
	
	exports.default = (0, _common.ColorWrap)(Sketch);

/***/ },
/* 1509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ShetchFields = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1287);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(1487);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _reactAddonsShallowCompare = __webpack_require__(1464);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _common = __webpack_require__(1462);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShetchFields = exports.ShetchFields = function (_React$Component) {
	  _inherits(ShetchFields, _React$Component);
	
	  function ShetchFields() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, ShetchFields);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(ShetchFields)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleChange = function (data) {
	      if (data.hex) {
	        _color2.default.isValidHex(data.hex) && _this.props.onChange({
	          hex: data.hex,
	          source: 'hex'
	        });
	      } else if (data.r || data.g || data.b) {
	        _this.props.onChange({
	          r: data.r || _this.props.rgb.r,
	          g: data.g || _this.props.rgb.g,
	          b: data.b || _this.props.rgb.b,
	          a: _this.props.rgb.a,
	          source: 'rgb'
	        });
	      } else if (data.a) {
	        if (data.a < 0) {
	          data.a = 0;
	        } else if (data.a > 100) {
	          data.a = 100;
	        }
	
	        data.a = data.a / 100;
	        _this.props.onChange({
	          h: _this.props.hsl.h,
	          s: _this.props.hsl.s,
	          l: _this.props.hsl.l,
	          a: data.a,
	          source: 'rgb'
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ShetchFields, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          fields: {
	            display: 'flex',
	            paddingTop: '4px'
	          },
	          single: {
	            flex: '1',
	            paddingLeft: '6px'
	          },
	          alpha: {
	            flex: '1',
	            paddingLeft: '6px'
	          },
	          double: {
	            flex: '2'
	          },
	          input: {
	            width: '80%',
	            padding: '4px 10% 3px',
	            border: 'none',
	            boxShadow: 'inset 0 0 0 1px #ccc',
	            fontSize: '11px'
	          },
	          label: {
	            display: 'block',
	            textAlign: 'center',
	            fontSize: '11px',
	            color: '#222',
	            paddingTop: '3px',
	            paddingBottom: '4px',
	            textTransform: 'capitalize'
	          }
	        },
	        'disableAlpha': {
	          alpha: {
	            display: 'none'
	          }
	        }
	      }, this.props);
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.fields, className: 'flexbox-fix' },
	        _react2.default.createElement(
	          'div',
	          { style: styles.double },
	          _react2.default.createElement(_common.EditableInput, { style: { input: styles.input, label: styles.label }, label: 'hex', value: this.props.hex.replace('#', ''), onChange: this.handleChange })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.single },
	          _react2.default.createElement(_common.EditableInput, { style: { input: styles.input, label: styles.label }, label: 'r', value: this.props.rgb.r, onChange: this.handleChange, dragLabel: 'true', dragMax: '255' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.single },
	          _react2.default.createElement(_common.EditableInput, { style: { input: styles.input, label: styles.label }, label: 'g', value: this.props.rgb.g, onChange: this.handleChange, dragLabel: 'true', dragMax: '255' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.single },
	          _react2.default.createElement(_common.EditableInput, { style: { input: styles.input, label: styles.label }, label: 'b', value: this.props.rgb.b, onChange: this.handleChange, dragLabel: 'true', dragMax: '255' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.alpha },
	          _react2.default.createElement(_common.EditableInput, { style: { input: styles.input, label: styles.label }, label: 'a', value: Math.round(this.props.rgb.a * 100), onChange: this.handleChange, dragLabel: 'true', dragMax: '100' })
	        )
	      );
	    }
	  }]);
	
	  return ShetchFields;
	}(_react2.default.Component);
	
	exports.default = ShetchFields;

/***/ },
/* 1510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SketchPresetColors = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1287);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1464);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SketchPresetColors = exports.SketchPresetColors = function (_React$Component) {
	  _inherits(SketchPresetColors, _React$Component);
	
	  function SketchPresetColors() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, SketchPresetColors);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(SketchPresetColors)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleClick = function (hex) {
	      _this.props.onClick({
	        hex: hex,
	        source: 'hex'
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SketchPresetColors, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          colors: {
	            marginRight: '-10px',
	            marginLeft: '-10px',
	            paddingLeft: '10px',
	            paddingTop: '10px',
	            borderTop: '1px solid #eee'
	          },
	          li: {
	            borderRadius: '3px',
	            overflow: 'hidden',
	            position: 'relative',
	            display: 'inline-block',
	            margin: '0 10px 10px 0',
	            verticalAlign: 'top',
	            cursor: 'pointer'
	          },
	          square: {
	            borderRadius: '3px',
	            width: '16px',
	            height: '16px',
	            boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15)'
	          }
	        },
	        'no-presets': {
	          colors: {
	            display: 'none'
	          }
	        }
	      }, {
	        'no-presets': !this.props.colors || !this.props.colors.length
	      });
	
	      var colors = [];
	      if (this.props.colors) {
	        for (var i = 0; i < this.props.colors.length; i++) {
	          var color = this.props.colors[i];
	          colors.push(_react2.default.createElement(
	            'div',
	            { key: color, style: styles.li, ref: color, onClick: this.handleClick.bind(null, color) },
	            _react2.default.createElement(
	              'div',
	              { style: { background: color } },
	              ' ',
	              _react2.default.createElement('div', { style: styles.square }),
	              ' '
	            )
	          ));
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.colors },
	        colors
	      );
	    }
	  }]);
	
	  return SketchPresetColors;
	}(_react2.default.Component);
	
	exports.default = SketchPresetColors;

/***/ },
/* 1511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Slider = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1287);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1464);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _common = __webpack_require__(1462);
	
	var _SliderSwatches = __webpack_require__(1512);
	
	var _SliderSwatches2 = _interopRequireDefault(_SliderSwatches);
	
	var _SliderPointer = __webpack_require__(1514);
	
	var _SliderPointer2 = _interopRequireDefault(_SliderPointer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Slider = exports.Slider = function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, Slider);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Slider)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleChange = function (data) {
	      _this.props.onChange(data);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Slider, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          slider: {},
	          hue: {
	            height: '12px',
	            position: 'relative'
	          },
	          Hue: {
	            radius: '2px'
	          }
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.slider },
	        _react2.default.createElement(
	          'div',
	          { style: styles.hue },
	          _react2.default.createElement(_common.Hue, _extends({ style: styles.Hue }, this.props, { pointer: _SliderPointer2.default, onChange: this.handleChange }))
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.swatches },
	          _react2.default.createElement(_SliderSwatches2.default, _extends({}, this.props, { onClick: this.handleChange }))
	        )
	      );
	    }
	  }]);
	
	  return Slider;
	}(_react2.default.Component);
	
	exports.default = (0, _common.ColorWrap)(Slider);

/***/ },
/* 1512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderSwatches = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1287);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1464);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _SliderSwatch = __webpack_require__(1513);
	
	var _SliderSwatch2 = _interopRequireDefault(_SliderSwatch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SliderSwatches = exports.SliderSwatches = function (_React$Component) {
	  _inherits(SliderSwatches, _React$Component);
	
	  function SliderSwatches() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, SliderSwatches);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(SliderSwatches)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleClick = function (data) {
	      _this.props.onClick(data);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SliderSwatches, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          swatches: {
	            marginTop: '20px'
	          },
	          swatch: {
	            boxSizing: 'border-box',
	            width: '20%',
	            paddingRight: '1px',
	            float: 'left'
	          },
	          clear: {
	            clear: 'both'
	          }
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.swatches },
	        _react2.default.createElement(
	          'div',
	          { style: styles.swatch },
	          _react2.default.createElement(_SliderSwatch2.default, _extends({}, this.props, { offset: '.80', active: Math.round(this.props.hsl.l * 100) / 100 == .80 && Math.round(this.props.hsl.s * 100) / 100 == .50, onClick: this.handleClick, first: true }))
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.swatch },
	          _react2.default.createElement(_SliderSwatch2.default, _extends({}, this.props, { offset: '.65', active: Math.round(this.props.hsl.l * 100) / 100 == .65 && Math.round(this.props.hsl.s * 100) / 100 == .50, onClick: this.handleClick }))
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.swatch },
	          _react2.default.createElement(_SliderSwatch2.default, _extends({}, this.props, { offset: '.50', active: Math.round(this.props.hsl.l * 100) / 100 == .50 && Math.round(this.props.hsl.s * 100) / 100 == .50, onClick: this.handleClick }))
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.swatch },
	          _react2.default.createElement(_SliderSwatch2.default, _extends({}, this.props, { offset: '.35', active: Math.round(this.props.hsl.l * 100) / 100 == .35 && Math.round(this.props.hsl.s * 100) / 100 == .50, onClick: this.handleClick }))
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.swatch },
	          _react2.default.createElement(_SliderSwatch2.default, _extends({}, this.props, { offset: '.20', active: Math.round(this.props.hsl.l * 100) / 100 == .20 && Math.round(this.props.hsl.s * 100) / 100 == .50, onClick: this.handleClick, last: true }))
	        ),
	        _react2.default.createElement('div', { style: styles.clear })
	      );
	    }
	  }]);
	
	  return SliderSwatches;
	}(_react2.default.Component);
	
	exports.default = SliderSwatches;

/***/ },
/* 1513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderSwatch = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1287);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1464);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SliderSwatch = exports.SliderSwatch = function (_React$Component) {
	  _inherits(SliderSwatch, _React$Component);
	
	  function SliderSwatch() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, SliderSwatch);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(SliderSwatch)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleClick = function () {
	      _this.props.onClick({
	        h: _this.props.hsl.h,
	        s: .5,
	        l: _this.props.offset,
	        source: 'hsl'
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SliderSwatch, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          swatch: {
	            height: '12px',
	            background: 'hsl(' + this.props.hsl.h + ', 50%, ' + this.props.offset * 100 + '%)',
	            cursor: 'pointer'
	          }
	        },
	        'first': {
	          swatch: {
	            borderRadius: '2px 0 0 2px'
	          }
	        },
	        'last': {
	          swatch: {
	            borderRadius: '0 2px 2px 0'
	          }
	        },
	        active: {
	          swatch: {
	            transform: 'scaleY(1.8)',
	            borderRadius: '3.6px/2px'
	          }
	        }
	      });
	
	      return _react2.default.createElement('div', { style: styles.swatch, ref: 'swatch', onClick: this.handleClick });
	    }
	  }]);
	
	  return SliderSwatch;
	}(_react2.default.Component);
	
	exports.default = SliderSwatch;

/***/ },
/* 1514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderPointer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1287);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1464);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SliderPointer = exports.SliderPointer = function (_React$Component) {
	  _inherits(SliderPointer, _React$Component);
	
	  function SliderPointer() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, SliderPointer);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(SliderPointer)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SliderPointer, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          picker: {
	            width: '14px',
	            height: '14px',
	            borderRadius: '6px',
	            transform: 'translate(-7px, -1px)',
	            backgroundColor: 'rgb(248, 248, 248)',
	            boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
	          }
	        }
	      });
	
	      return _react2.default.createElement('div', { style: styles.picker });
	    }
	  }]);
	
	  return SliderPointer;
	}(_react2.default.Component);
	
	exports.default = SliderPointer;

/***/ },
/* 1515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Swatches = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1287);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(1487);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _materialColors = __webpack_require__(1516);
	
	var _materialColors2 = _interopRequireDefault(_materialColors);
	
	var _reactAddonsShallowCompare = __webpack_require__(1464);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _common = __webpack_require__(1462);
	
	var _reactMaterialDesign = __webpack_require__(1493);
	
	var _SwatchesGroup = __webpack_require__(1517);
	
	var _SwatchesGroup2 = _interopRequireDefault(_SwatchesGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Swatches = exports.Swatches = function (_React$Component) {
	  _inherits(Swatches, _React$Component);
	
	  function Swatches() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, Swatches);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Swatches)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleChange = function (data) {
	      _color2.default.isValidHex(data) && _this.props.onChange({
	        hex: data,
	        source: 'hex'
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Swatches, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          picker: {
	            width: this.props.width,
	            height: this.props.height
	          },
	          overflow: {
	            height: this.props.height,
	            overflowY: 'scroll'
	          },
	          body: {
	            padding: '16px 0 6px 16px'
	          },
	
	          clear: {
	            clear: 'both'
	          }
	        }
	      });
	
	      var groups = [];
	      if (this.props.colors) {
	        for (var i = 0; i < this.props.colors.length; i++) {
	          var group = this.props.colors[i];
	          groups.push(_react2.default.createElement(_SwatchesGroup2.default, { key: group.toString(), group: group, active: this.props.hex, onClick: this.handleChange }));
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.picker },
	        _react2.default.createElement(
	          _reactMaterialDesign.Raised,
	          null,
	          _react2.default.createElement(
	            'div',
	            { style: styles.overflow },
	            _react2.default.createElement(
	              'div',
	              { style: styles.body, ref: 'body' },
	              groups,
	              _react2.default.createElement('div', { style: styles.clear })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Swatches;
	}(_react2.default.Component);
	
	Swatches.defaultProps = {
	  width: 320,
	  height: 240,
	  colors: [[_materialColors2.default.red['900'], _materialColors2.default.red['700'], _materialColors2.default.red['500'], _materialColors2.default.red['300'], _materialColors2.default.red['100']], [_materialColors2.default.pink['900'], _materialColors2.default.pink['700'], _materialColors2.default.pink['500'], _materialColors2.default.pink['300'], _materialColors2.default.pink['100']], [_materialColors2.default.purple['900'], _materialColors2.default.purple['700'], _materialColors2.default.purple['500'], _materialColors2.default.purple['300'], _materialColors2.default.purple['100']], [_materialColors2.default.deepPurple['900'], _materialColors2.default.deepPurple['700'], _materialColors2.default.deepPurple['500'], _materialColors2.default.deepPurple['300'], _materialColors2.default.deepPurple['100']], [_materialColors2.default.indigo['900'], _materialColors2.default.indigo['700'], _materialColors2.default.indigo['500'], _materialColors2.default.indigo['300'], _materialColors2.default.indigo['100']], [_materialColors2.default.blue['900'], _materialColors2.default.blue['700'], _materialColors2.default.blue['500'], _materialColors2.default.blue['300'], _materialColors2.default.blue['100']], [_materialColors2.default.lightBlue['900'], _materialColors2.default.lightBlue['700'], _materialColors2.default.lightBlue['500'], _materialColors2.default.lightBlue['300'], _materialColors2.default.lightBlue['100']], [_materialColors2.default.cyan['900'], _materialColors2.default.cyan['700'], _materialColors2.default.cyan['500'], _materialColors2.default.cyan['300'], _materialColors2.default.cyan['100']], [_materialColors2.default.teal['900'], _materialColors2.default.teal['700'], _materialColors2.default.teal['500'], _materialColors2.default.teal['300'], _materialColors2.default.teal['100']], ['#194D33', _materialColors2.default.green['700'], _materialColors2.default.green['500'], _materialColors2.default.green['300'], _materialColors2.default.green['100']], [_materialColors2.default.lightGreen['900'], _materialColors2.default.lightGreen['700'], _materialColors2.default.lightGreen['500'], _materialColors2.default.lightGreen['300'], _materialColors2.default.lightGreen['100']], [_materialColors2.default.lime['900'], _materialColors2.default.lime['700'], _materialColors2.default.lime['500'], _materialColors2.default.lime['300'], _materialColors2.default.lime['100']], [_materialColors2.default.yellow['900'], _materialColors2.default.yellow['700'], _materialColors2.default.yellow['500'], _materialColors2.default.yellow['300'], _materialColors2.default.yellow['100']], [_materialColors2.default.amber['900'], _materialColors2.default.amber['700'], _materialColors2.default.amber['500'], _materialColors2.default.amber['300'], _materialColors2.default.amber['100']], [_materialColors2.default.orange['900'], _materialColors2.default.orange['700'], _materialColors2.default.orange['500'], _materialColors2.default.orange['300'], _materialColors2.default.orange['100']], [_materialColors2.default.deepOrange['900'], _materialColors2.default.deepOrange['700'], _materialColors2.default.deepOrange['500'], _materialColors2.default.deepOrange['300'], _materialColors2.default.deepOrange['100']], [_materialColors2.default.brown['900'], _materialColors2.default.brown['700'], _materialColors2.default.brown['500'], _materialColors2.default.brown['300'], _materialColors2.default.brown['100']], [_materialColors2.default.blueGrey['900'], _materialColors2.default.blueGrey['700'], _materialColors2.default.blueGrey['500'], _materialColors2.default.blueGrey['300'], _materialColors2.default.blueGrey['100']], ['#000000', '#525252', '#969696', '#D9D9D9', '#FFFFFF']]
	};
	
	exports.default = (0, _common.ColorWrap)(Swatches);

/***/ },
/* 1516 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = factory();
	  } else {
	    root.materialColors = factory();
	  }
	})(this, function() {
	  return {"red":{"50":"#ffebee","100":"#ffcdd2","200":"#ef9a9a","300":"#e57373","400":"#ef5350","500":"#f44336","600":"#e53935","700":"#d32f2f","800":"#c62828","900":"#b71c1c","a100":"#ff8a80","a200":"#ff5252","a400":"#ff1744","a700":"#d50000"},"pink":{"50":"#fce4ec","100":"#f8bbd0","200":"#f48fb1","300":"#f06292","400":"#ec407a","500":"#e91e63","600":"#d81b60","700":"#c2185b","800":"#ad1457","900":"#880e4f","a100":"#ff80ab","a200":"#ff4081","a400":"#f50057","a700":"#c51162"},"purple":{"50":"#f3e5f5","100":"#e1bee7","200":"#ce93d8","300":"#ba68c8","400":"#ab47bc","500":"#9c27b0","600":"#8e24aa","700":"#7b1fa2","800":"#6a1b9a","900":"#4a148c","a100":"#ea80fc","a200":"#e040fb","a400":"#d500f9","a700":"#aa00ff"},"deepPurple":{"50":"#ede7f6","100":"#d1c4e9","200":"#b39ddb","300":"#9575cd","400":"#7e57c2","500":"#673ab7","600":"#5e35b1","700":"#512da8","800":"#4527a0","900":"#311b92","a100":"#b388ff","a200":"#7c4dff","a400":"#651fff","a700":"#6200ea"},"indigo":{"50":"#e8eaf6","100":"#c5cae9","200":"#9fa8da","300":"#7986cb","400":"#5c6bc0","500":"#3f51b5","600":"#3949ab","700":"#303f9f","800":"#283593","900":"#1a237e","a100":"#8c9eff","a200":"#536dfe","a400":"#3d5afe","a700":"#304ffe"},"blue":{"50":"#e3f2fd","100":"#bbdefb","200":"#90caf9","300":"#64b5f6","400":"#42a5f5","500":"#2196f3","600":"#1e88e5","700":"#1976d2","800":"#1565c0","900":"#0d47a1","a100":"#82b1ff","a200":"#448aff","a400":"#2979ff","a700":"#2962ff"},"lightBlue":{"50":"#e1f5fe","100":"#b3e5fc","200":"#81d4fa","300":"#4fc3f7","400":"#29b6f6","500":"#03a9f4","600":"#039be5","700":"#0288d1","800":"#0277bd","900":"#01579b","a100":"#80d8ff","a200":"#40c4ff","a400":"#00b0ff","a700":"#0091ea"},"cyan":{"50":"#e0f7fa","100":"#b2ebf2","200":"#80deea","300":"#4dd0e1","400":"#26c6da","500":"#00bcd4","600":"#00acc1","700":"#0097a7","800":"#00838f","900":"#006064","a100":"#84ffff","a200":"#18ffff","a400":"#00e5ff","a700":"#00b8d4"},"teal":{"50":"#e0f2f1","100":"#b2dfdb","200":"#80cbc4","300":"#4db6ac","400":"#26a69a","500":"#009688","600":"#00897b","700":"#00796b","800":"#00695c","900":"#004d40","a100":"#a7ffeb","a200":"#64ffda","a400":"#1de9b6","a700":"#00bfa5"},"green":{"50":"#e8f5e9","100":"#c8e6c9","200":"#a5d6a7","300":"#81c784","400":"#66bb6a","500":"#4caf50","600":"#43a047","700":"#388e3c","800":"#2e7d32","900":"#1b5e20","a100":"#b9f6ca","a200":"#69f0ae","a400":"#00e676","a700":"#00c853"},"lightGreen":{"50":"#f1f8e9","100":"#dcedc8","200":"#c5e1a5","300":"#aed581","400":"#9ccc65","500":"#8bc34a","600":"#7cb342","700":"#689f38","800":"#558b2f","900":"#33691e","a100":"#ccff90","a200":"#b2ff59","a400":"#76ff03","a700":"#64dd17"},"lime":{"50":"#f9fbe7","100":"#f0f4c3","200":"#e6ee9c","300":"#dce775","400":"#d4e157","500":"#cddc39","600":"#c0ca33","700":"#afb42b","800":"#9e9d24","900":"#827717","a100":"#f4ff81","a200":"#eeff41","a400":"#c6ff00","a700":"#aeea00"},"yellow":{"50":"#fffde7","100":"#fff9c4","200":"#fff59d","300":"#fff176","400":"#ffee58","500":"#ffeb3b","600":"#fdd835","700":"#fbc02d","800":"#f9a825","900":"#f57f17","a100":"#ffff8d","a200":"#ffff00","a400":"#ffea00","a700":"#ffd600"},"amber":{"50":"#fff8e1","100":"#ffecb3","200":"#ffe082","300":"#ffd54f","400":"#ffca28","500":"#ffc107","600":"#ffb300","700":"#ffa000","800":"#ff8f00","900":"#ff6f00","a100":"#ffe57f","a200":"#ffd740","a400":"#ffc400","a700":"#ffab00"},"orange":{"50":"#fff3e0","100":"#ffe0b2","200":"#ffcc80","300":"#ffb74d","400":"#ffa726","500":"#ff9800","600":"#fb8c00","700":"#f57c00","800":"#ef6c00","900":"#e65100","a100":"#ffd180","a200":"#ffab40","a400":"#ff9100","a700":"#ff6d00"},"deepOrange":{"50":"#fbe9e7","100":"#ffccbc","200":"#ffab91","300":"#ff8a65","400":"#ff7043","500":"#ff5722","600":"#f4511e","700":"#e64a19","800":"#d84315","900":"#bf360c","a100":"#ff9e80","a200":"#ff6e40","a400":"#ff3d00","a700":"#dd2c00"},"brown":{"50":"#efebe9","100":"#d7ccc8","200":"#bcaaa4","300":"#a1887f","400":"#8d6e63","500":"#795548","600":"#6d4c41","700":"#5d4037","800":"#4e342e","900":"#3e2723"},"grey":{"50":"#fafafa","100":"#f5f5f5","200":"#eeeeee","300":"#e0e0e0","400":"#bdbdbd","500":"#9e9e9e","600":"#757575","700":"#616161","800":"#424242","900":"#212121"},"blueGrey":{"50":"#eceff1","100":"#cfd8dc","200":"#b0bec5","300":"#90a4ae","400":"#78909c","500":"#607d8b","600":"#546e7a","700":"#455a64","800":"#37474f","900":"#263238"},"darkText":{"primary":"rgba(0, 0, 0, 0.87)","secondary":"rgba(0, 0, 0, 0.54)","disabled":"rgba(0, 0, 0, 0.38)","dividers":"rgba(0, 0, 0, 0.12)"},"lightText":{"primary":"rgba(255, 255, 255, 1)","secondary":"rgba(255, 255, 255, 0.7)","disabled":"rgba(255, 255, 255, 0.5)","dividers":"rgba(255, 255, 255, 0.12)"},"darkIcons":{"active":"rgba(0, 0, 0, 0.54)","inactive":"rgba(0, 0, 0, 0.38)"},"lightIcons":{"active":"rgba(255, 255, 255, 1)","inactive":"rgba(255, 255, 255, 0.5)"},"white":"#ffffff","black":"#000000"};
	});


/***/ },
/* 1517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SwatchesGroup = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1287);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1464);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _SwatchesColor = __webpack_require__(1518);
	
	var _SwatchesColor2 = _interopRequireDefault(_SwatchesColor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SwatchesGroup = exports.SwatchesGroup = function (_React$Component) {
	  _inherits(SwatchesGroup, _React$Component);
	
	  function SwatchesGroup() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, SwatchesGroup);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(SwatchesGroup)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleClick = function (data) {
	      _this.props.onClick(data);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SwatchesGroup, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          group: {
	            paddingBottom: '10px',
	            width: '40px',
	            float: 'left',
	            marginRight: '10px'
	          }
	        }
	      });
	
	      var colors = [];
	      for (var i = 0; i < this.props.group.length; i++) {
	        var color = this.props.group[i];
	
	        colors.push(_react2.default.createElement(_SwatchesColor2.default, { key: color, color: color, active: color.toLowerCase() === this.props.active, first: i === 0, last: i === this.props.group.length - 1, onClick: this.handleClick }));
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.group, ref: 'group' },
	        colors
	      );
	    }
	  }]);
	
	  return SwatchesGroup;
	}(_react2.default.Component);
	
	exports.default = SwatchesGroup;

/***/ },
/* 1518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SwatchesColor = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(1287);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAddonsShallowCompare = __webpack_require__(1464);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SwatchesColor = exports.SwatchesColor = function (_React$Component) {
	  _inherits(SwatchesColor, _React$Component);
	
	  function SwatchesColor() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, SwatchesColor);
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(SwatchesColor)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsShallowCompare2.default.bind(_this, _this, arguments[0], arguments[1]), _this.handleClick = function () {
	      _this.props.onClick(_this.props.color);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SwatchesColor, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          color: {
	            width: '40px',
	            height: '24px',
	            cursor: 'pointer',
	            background: this.props.color,
	            marginBottom: '1px'
	          },
	          check: {
	            fill: '#fff',
	            marginLeft: '8px',
	            display: 'none'
	          }
	        },
	        'first': {
	          color: {
	            overflow: 'hidden',
	            borderRadius: '2px 2px 0 0'
	          }
	        },
	        'last': {
	          color: {
	            overflow: 'hidden',
	            borderRadius: '0 0 2px 2px'
	          }
	        },
	        active: {
	          check: {
	            display: 'block'
	          }
	        }
	      }, this.props);
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.color, ref: 'color', onClick: this.handleClick },
	        _react2.default.createElement(
	          'div',
	          { style: styles.check },
	          _react2.default.createElement(
	            'svg',
	            { style: { width: '24px', height: '24px' }, viewBox: '0 0 24 24' },
	            _react2.default.createElement('path', { d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SwatchesColor;
	}(_react2.default.Component);
	
	exports.default = SwatchesColor;

/***/ },
/* 1519 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/804c91553615388a8293a719c330c6b1.png";

/***/ },
/* 1520 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/994835115bb2cdc90183431535516e75.png";

/***/ },
/* 1521 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/fa55170b2b0937f9490efc8607b34feb.gif";

/***/ },
/* 1522 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/6d162294d70cd12df5f0eb674e633ad4.png";

/***/ },
/* 1523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createAccountTrigger = __webpack_require__(883);
	
	var _createAccountTrigger2 = _interopRequireDefault(_createAccountTrigger);
	
	var _HS_logo_white = __webpack_require__(1233);
	
	var _HS_logo_white2 = _interopRequireDefault(_HS_logo_white);
	
	var _city_overlay_left = __webpack_require__(1524);
	
	var _city_overlay_left2 = _interopRequireDefault(_city_overlay_left);
	
	var _city_overlay_right = __webpack_require__(1525);
	
	var _city_overlay_right2 = _interopRequireDefault(_city_overlay_right);
	
	var _document_send_icon = __webpack_require__(1526);
	
	var _document_send_icon2 = _interopRequireDefault(_document_send_icon);
	
	var _signature_icon = __webpack_require__(1239);
	
	var _signature_icon2 = _interopRequireDefault(_signature_icon);
	
	var _handshake_icon = __webpack_require__(1527);
	
	var _handshake_icon2 = _interopRequireDefault(_handshake_icon);
	
	var _hubspot_crm_integration_header = __webpack_require__(1528);
	
	var _hubspot_crm_integration_header2 = _interopRequireDefault(_hubspot_crm_integration_header);
	
	var _hubspot_logo = __webpack_require__(1529);
	
	var _hubspot_logo2 = _interopRequireDefault(_hubspot_logo);
	
	var _screenshot_hubspot_crm_animated = __webpack_require__(1530);
	
	var _screenshot_hubspot_crm_animated2 = _interopRequireDefault(_screenshot_hubspot_crm_animated);
	
	var _socialSection = __webpack_require__(1242);
	
	var _socialSection2 = _interopRequireDefault(_socialSection);
	
	var _faqSection = __webpack_require__(1247);
	
	var _faqSection2 = _interopRequireDefault(_faqSection);
	
	var _benefitsSection = __webpack_require__(1248);
	
	var _benefitsSection2 = _interopRequireDefault(_benefitsSection);
	
	var _pricingCtaSection = __webpack_require__(1250);
	
	var _pricingCtaSection2 = _interopRequireDefault(_pricingCtaSection);
	
	var _ctaButton = __webpack_require__(1531);
	
	var _ctaButton2 = _interopRequireDefault(_ctaButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function HubSpotLandingPage(p) {
	    // HubSpot constants
	    var benefits = [{
	        icon: _handshake_icon2['default'],
	        title: 'Close Contracts Faster',
	        text: 'The average turnaround time for a contract is 44 minutes when using HelloSign. Seal those deals even faster!'
	    }, {
	        icon: _signature_icon2['default'],
	        title: 'Request and Track Signatures',
	        text: 'Make it easy to organize and follow-up on any eSignature request in your HubSpot CRM. You\'ll never have to worry about hunting down a document again.'
	    }, {
	        icon: _document_send_icon2['default'],
	        title: 'Templates for High-volume Documents',
	        text: 'Auto-populate high volume documents with information using our templates and merge fields. Create once, reuse again and again.'
	    }];
	    var twitterLink = 'https://twitter.com/intent/tweet?original_referer=https%3A%2F%2Fwww.hellosign.com%2Fhubspot-crm&ref_src=twsrc%5Etfw&text=Did%20you%20know%20%40HelloSign%20integrates%20with%20%40HubSpot%3F%20Send%20contracts%20for%20signature%20directly%20from%20HubSpot%20CRM.&tw_p=tweetbutton&url=http%3A%2F%2Fwww.hellosign.com%2Fhubspot-crm%3Futm_campaign%3DHUB-101515%26utm_medium%3Ds2s%26utm_source%3Dtwitter';
	    var facebookLink = 'https://www.facebook.com/sharer/sharer.php?u=https%3A//www.hellosign.com/hubspot-crm?utm_source=facebook%26utm_medium=s2s';
	    var linkedInLink = 'https://www.linkedin.com/cws/share?url=https%3A%2F%2Fwww.hellosign.com%2Fhubspot-crm%3Futm_campaign%3DHUB-101515%26utm_medium%3Ds2s%26utm_source%3Dlinkedin&original_referer=https%3A%2F%2Fwww.hellosign.com%2Fhubspot-crm&token=&isFramed=false&lang=en_US&_ts=1462214138386.6147&xd_origin_host=https%3A%2F%2Fwww.hellosign.com';
	    var border = '2px solid #D7D7D7';
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'seo-cloud-integrations hubspot-crm' },
	        _react2['default'].createElement(IllustrationArea, p),
	        _react2['default'].createElement(
	            'div',
	            { className: 'seo-cloud-integrations__main', style: { backgroundColor: 'white' } },
	            _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'top', style: { borderBottom: border, backgroundColor: '#F7F8F9', fontWeight: 600 } }),
	            _react2['default'].createElement(_benefitsSection2['default'], { benefits: benefits }),
	            _react2['default'].createElement(HowItWorks, p),
	            _react2['default'].createElement(_socialSection2['default'], {
	                title: 'Share with your networks!',
	                twitterLink: twitterLink,
	                facebookLink: facebookLink,
	                linkedInLink: linkedInLink }),
	            _react2['default'].createElement(_faqSection2['default'], { link: 'https://faq.hellosign.com/hc/en-us/articles/211846118-Hubspot-Integration' }),
	            _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'bottom', style: { borderTop: border, fontWeight: 600 } })
	        )
	    );
	}
	
	function IllustrationArea(p) {
	    var imageStyle = { transform: 'translateY(1px)' };
	    return _react2['default'].createElement(
	        'div',
	        { className: 'top row hubspot-orange' },
	        _react2['default'].createElement(
	            'div',
	            { className: 'top-content-container large-5 large-push-6 columns' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'hellosign-dropbox' },
	                _react2['default'].createElement('img', { src: _HS_logo_white2['default'], alt: 'HelloSign Logo', className: 'hs-logo' }),
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'plus' },
	                    '+'
	                ),
	                _react2['default'].createElement('img', { src: _hubspot_logo2['default'], alt: 'HubSpot Logo', className: 'dropbox-logo', width: '130' })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'title' },
	                _react2['default'].createElement(
	                    'h1',
	                    null,
	                    'Send contracts directly from HubSpot CRM'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'subtitle' },
	                _react2['default'].createElement(
	                    'h2',
	                    { style: { fontWeight: 400, fontSize: 16, maxWidth: 600 } },
	                    'Integrate HelloSign with HubSpot CRM to request signatures, track lifecycle status, and manage contracts out for signature. Sort your documents by last viewed or signature status to know when to follow up with leads before they get cold.'
	                )
	            ),
	            _react2['default'].createElement(_ctaButton2['default'], _extends({}, p, { buttonText: 'Get started' }))
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'clouds-container large-5 large-pull-4 columns' },
	            _react2['default'].createElement('img', { src: _hubspot_crm_integration_header2['default'], alt: 'cityscape', style: { marginTop: 23 } })
	        ),
	        _react2['default'].createElement('img', { src: _city_overlay_left2['default'],
	            style: imageStyle,
	            alt: 'city left',
	            className: 'cloud-left'
	        }),
	        _react2['default'].createElement('img', { src: _city_overlay_right2['default'],
	            style: imageStyle,
	            alt: 'city right',
	            className: 'cloud-right'
	        })
	    );
	}
	
	function CTALink(p) {
	    var linkURL = '/home/myAccount#integrations';
	
	    // Return standard link if user is already logged in
	    if (p.isUserLoggedIn) {
	        return _react2['default'].createElement(
	            'a',
	            { href: linkURL },
	            p.linkText
	        );
	    }
	
	    // Otherwise, create a trigger so we can display the signup modal
	    var trigger = _react2['default'].createElement(
	        'a',
	        null,
	        p.linkText
	    );
	    return _react2['default'].createElement(_createAccountTrigger2['default'], _extends({}, p, {
	        trigger: trigger,
	        redirectUrl: linkURL,
	        homeUrl: linkURL,
	        googleOpenIdUrl: p.googleOpenIdLocationUrl,
	        header: 'Get Started' }));
	}
	
	function HowItWorks(p) {
	    var linkURL = 'http://blog.hellosign.com/hellosign-and-hubspot-join-forces/';
	    var link = _react2['default'].createElement(
	        'a',
	        { href: linkURL },
	        'Read our blog post'
	    );
	    var paragraphStyle = {
	        marginLeft: 20
	    };
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'seo-cloud-integrations__how-it-works' },
	        _react2['default'].createElement(
	            'h2',
	            null,
	            'How it Works'
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'row' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'screenshot-explanation large-3 large-push-9 columns' },
	                _react2['default'].createElement(
	                    'p',
	                    { style: paragraphStyle },
	                    'To get started,',
	                    _react2['default'].createElement(CTALink, _extends({ linkText: ' activate the HubSpot CRM integration ' }, p)),
	                    'on your settings page and insert your Hub ID.'
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    { style: paragraphStyle },
	                    'Then you\u2019ll be able to track documents in your HubSpot contact feeds, request signatures within HubSpot, autofill documents with a contact\u2019s information, and access your completed documents.'
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    { style: paragraphStyle },
	                    'All of the docs you send through the extension will show up in the documents view on HelloSign.com.'
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    { style: paragraphStyle },
	                    'Want to learn more about the integration? ',
	                    link,
	                    '.'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'dropbox-screenshot large-9 large-pull-3 columns' },
	                _react2['default'].createElement('img', { src: _screenshot_hubspot_crm_animated2['default'], alt: 'hubspot screenshot' })
	            )
	        )
	    );
	}
	
	module.exports = HubSpotLandingPage;

/***/ },
/* 1524 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/1836af357153fc1009e50c76dacfe04b.svg";

/***/ },
/* 1525 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNDcuODQ3MTEgMTE2LjQxNTY4Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2Y3ZjhmOTt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjQ3Ljg0NzExLDI1LjQ1NTQ3djkwLjk2MDIxSDAuOTk3TDE1LjQyMjY2LDkwLjY0MTgxQTIuMDA1ODQsMi4wMDU4NCwwLDAsMSwxNy4xNzMsODkuNjE1NjNIMzcuNDE2OTN2LTE3LjUzaC0zLjk5di0zLjVoMzIuNXYzLjVoLTUuNVY4Mi41MDU3N0g5MS41MDdWNDEuMTM1NjVoNS41di02LjVoMTl2Ni41aDUuNXYzOC45OGgyNC44NFY2Mi4yNDU1MWEyLjMyNTE5LDIuMzI1MTksMCwwLDEsLjg2LTEuNzk5OGwxMS4wNjAwNi05LjA1YTIuMzMyNDUsMi4zMzI0NSwwLDAsMSwzLjgxMDA2LDEuOHY0LjE4OTk0YTIuMzMwMDgsMi4zMzAwOCwwLDAsMCwyLjMzMDA4LDIuMzMwMDhoNi43Njk3OGEyLjMzMDA4LDIuMzMwMDgsMCwwLDAsMi4zMzAwOC0yLjMzMDA4VjUyLjUxNTUzYTIuMzAzNzksMi4zMDM3OSwwLDAsMSwuNjg5OTQtMS42NDk5LDIuMzM3LDIuMzM3LDAsMCwxLDEuNjUwMTUtLjY3OTkzLDIuMzI4MjUsMi4zMjgyNSwwLDAsMCwyLjMxOTgyLTIuNDI5OTNsLTAuMzEwMDYtNy4xOTAxOWEyLjM0NTczLDIuMzQ1NzMsMCwwLDEsMS4wODAwOC0yLjA1OTgxbDU1LjcxLTM1LjVhMi4zMzMsMi4zMzMsMCwwLDEsMy4zNjAxMS45OGw5LjYxOTg3LDIwLjQ4QTIuMzgyNjksMi4zODI2OSwwLDAsMSwyNDcuODQ3MTEsMjUuNDU1NDdaIi8+PC9zdmc+"

/***/ },
/* 1526 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNiAzNiI+PGRlZnM+PHN0eWxlPi5jbHMtMSwuY2xzLTJ7ZmlsbDpub25lO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDt9LmNscy0xe3N0cm9rZTojMTkxOTFhO30uY2xzLTJ7c3Ryb2tlOiMwMWIyZTU7fTwvc3R5bGU+PC9kZWZzPjxwb2x5bGluZSBjbGFzcz0iY2xzLTEiIHBvaW50cz0iMjguMDYyIDEzLjc1NSAyOC4wNjIgMzQuMTYxIDQuNTI0IDM0LjE2MSA0LjUyNCA1LjAzMyAyMi4wMzQgNS4wMzMiLz48bGluZSBjbGFzcz0iY2xzLTEiIHgxPSI3Ljg5MTUiIHkxPSIxMy43MjEyMSIgeDI9IjIyLjAzNDM2IiB5Mj0iMTMuNzIxMjEiLz48bGluZSBjbGFzcz0iY2xzLTEiIHgxPSI3Ljg5MTUiIHkxPSIxNi4yNDY3MiIgeDI9IjI0LjQ1ODg1IiB5Mj0iMTYuMjQ2NzIiLz48bGluZSBjbGFzcz0iY2xzLTEiIHgxPSI3Ljg5MTUiIHkxPSIxOC43Mzg1NiIgeDI9IjIwLjgyMjExIiB5Mj0iMTguNzM4NTYiLz48bGluZSBjbGFzcz0iY2xzLTIiIHgxPSI4LjE2MDg5IiB5MT0iMjMuNjg4NTYiIHgyPSIxMS4wMjMxNCIgeTI9IjI2LjU1MDgiLz48bGluZSBjbGFzcz0iY2xzLTIiIHgxPSIxMS4wMjMxNCIgeTE9IjIzLjY4ODU2IiB4Mj0iOC4xNjA4OSIgeTI9IjI2LjU1MDgiLz48bGluZSBjbGFzcz0iY2xzLTIiIHgxPSI3Ljg1NzgzIiB5MT0iMjguNzM5NTgiIHgyPSIyNC40NTg4NSIgeTI9IjI4LjczOTU4Ii8+PHBvbHlsaW5lIGNsYXNzPSJjbHMtMSIgcG9pbnRzPSIyNC44MjkgOS4xMDggMzEuOTM0IDEuMTYxIDI0LjgyOSAxMi40MDggMjQuODI5IDkuMTA4IDIwLjUxOSA5LjIwOSAzMS45MzQgMS4xNjEgMzAuODIzIDEyLjY3NyAyNi40NDYgMTAuMTUyIi8+PC9zdmc+"

/***/ },
/* 1527 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/7e3f488cef3f5af01c1ae7e3dc7b3495.svg";

/***/ },
/* 1528 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/27da9fb5c37f18d0f78bbf0207050d26.svg";

/***/ },
/* 1529 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/c5111370167e69a42f7a867d09f300e4.svg";

/***/ },
/* 1530 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/c81d881b39d24c48535b53c2e21094aa.gif";

/***/ },
/* 1531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _signupOrLoginButton = __webpack_require__(1210);
	
	var _signupOrLoginButton2 = _interopRequireDefault(_signupOrLoginButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function CTAButton(p) {
	    var buttonClass = 'm-button bg-cerulean hc-white c-white progress-button state-loading m-login-or-signup--sign-up-button';
	    var linkURL = '/home/myAccount#integrations';
	
	    return _react2['default'].createElement(_signupOrLoginButton2['default'], _extends({}, p, {
	        buttonText: p.buttonText,
	        homeUrl: linkURL,
	        redirectUrl: linkURL,
	        googleOpenIdUrl: p.googleOpenIdLocationUrl,
	        buttonClass: buttonClass,
	        isIntegration: true,
	        buttonTextColor: 'white',
	        buttonColor: 'cerulean',
	        buttonBorderColor: 'cerulean',
	        buttonHoverColor: 'cerulean',
	        buttonHoverTextColor: 'white' }));
	}
	
	module.exports = CTAButton;

/***/ },
/* 1532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(1533);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _contactLink = __webpack_require__(1535);
	
	var _contactLink2 = _interopRequireDefault(_contactLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function (_React$Component) {
	    _inherits(DocusignSwitch, _React$Component);
	
	    function DocusignSwitch() {
	        _classCallCheck(this, DocusignSwitch);
	
	        return _possibleConstructorReturn(this, (DocusignSwitch.__proto__ || Object.getPrototypeOf(DocusignSwitch)).apply(this, arguments));
	    }
	
	    _createClass(DocusignSwitch, [{
	        key: 'render',
	        value: function render() {
	            var words = ['better', 'easier', 'friendly'];
	            return _react2['default'].createElement(
	                'div',
	                { className: 'm-docusign-switch' },
	                _react2['default'].createElement(
	                    'header',
	                    null,
	                    _react2['default'].createElement(
	                        'h1',
	                        null,
	                        'Say Hello to ',
	                        _react2['default'].createElement(WordSlider, { words: words }),
	                        ' eSignatures'
	                    ),
	                    _react2['default'].createElement(
	                        'h2',
	                        null,
	                        'DocuSign',
	                        '\xAE',
	                        ' users, welcome to the future of eSigning'
	                    ),
	                    _react2['default'].createElement(
	                        'a',
	                        { href: '/info/pricing' },
	                        _react2['default'].createElement(
	                            'button',
	                            { className: 'bg-cerulean c-white hc-white hbg-velvet-evening' },
	                            'SWITCH NOW'
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'section',
	                    { className: 'm-docusign-switch__why-switch' },
	                    _react2['default'].createElement(
	                        'h2',
	                        null,
	                        'WHY SWITCH?'
	                    ),
	                    _react2['default'].createElement(
	                        'section',
	                        { className: 'm-docusign-switch__better-signing-experience' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'center-image-wrapper macbook' },
	                            _react2['default'].createElement('img', { src: __webpack_require__(1536), 'aria-hidden': true })
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'm-docusign-switch__copy why-switch-copy' },
	                            _react2['default'].createElement(
	                                'h3',
	                                null,
	                                'Better signing experience for you and your customers.'
	                            ),
	                            _react2['default'].createElement(
	                                'p',
	                                null,
	                                'We\'ve created the ',
	                                _react2['default'].createElement(
	                                    'a',
	                                    { target: '_blank', rel: 'noopener noreferrer',
	                                        href: 'http://blog.hellosign.com/new-signer-experience/' },
	                                    'most intuitive interface in the industry'
	                                ),
	                                ' without compromising on functionality. Our stream-lined, user-friendly design combined with powerful features won\u2019t disappoint you, your team, or your customers when it comes to signing important docs online. We don\u2019t believe in unnecessary clutter.'
	                            )
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'section',
	                        { className: 'm-docusign__easier-to-sign-anywhere' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'center-image-wrapper signer-experience-image-wrapper' },
	                            _react2['default'].createElement('img', { src: __webpack_require__(1537), 'aria-hidden': true })
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'm-docusign-switch__copy sign-anywhere-copy' },
	                            _react2['default'].createElement(
	                                'h3',
	                                null,
	                                'Easier to sign anywhere, at any time, on any device.'
	                            ),
	                            _react2['default'].createElement(
	                                'p',
	                                null,
	                                'Sometimes signing a document needs to happen at a moment\'s notice. Our responsive design allows you to request a signature or sign on-the-go. And with a ',
	                                _react2['default'].createElement(
	                                    'a',
	                                    { target: '_blank', rel: 'noopener noreferrer',
	                                        href: 'https://www.hellosign.com/info/tour' },
	                                    'growing list of industry-first features'
	                                ),
	                                ' like our \'Insert Everywhere\' button and data validation, we\u2019re confident you\u2019ll love the experience.'
	                            )
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'section',
	                        { className: 'm-docusign-switch__features' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'm-docusign-switch__features-row' },
	                            _react2['default'].createElement(
	                                'section',
	                                null,
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: 'm-docusign-switch__copy' },
	                                    _react2['default'].createElement('img', { src: __webpack_require__(1538),
	                                        'aria-hidden': true,
	                                        className: 'm-docusign-switch-support_icon' }),
	                                    _react2['default'].createElement(
	                                        'h3',
	                                        null,
	                                        'Best-in-class developer and user support.'
	                                    ),
	                                    _react2['default'].createElement(
	                                        'p',
	                                        null,
	                                        'We understand that eSignatures power a critical piece of your business, so we take support very seriously. Our expert support team is devoted to helping you get the most value out of eSignatures. We also have a specialized API support team which means the person that helped integrate eSignatures into your product will be the same person you can come to for questions.'
	                                    )
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'section',
	                                null,
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: 'm-docusign-switch__copy integrate-copy' },
	                                    _react2['default'].createElement('img', { src: __webpack_require__(1539),
	                                        'aria-hidden': true,
	                                        className: 'm-docusign-switch-integrate_icon' }),
	                                    _react2['default'].createElement(
	                                        'h3',
	                                        null,
	                                        'Integrate eSignatures with anything, faster.'
	                                    ),
	                                    _react2['default'].createElement(
	                                        'p',
	                                        null,
	                                        'Want to integrate eSignatures into your own apps or site?',
	                                        _react2['default'].createElement(
	                                            'a',
	                                            { href: 'https://www.hellosign.com/api', target: '_blank', rel: 'noopener noreferrer' },
	                                            ' Our API '
	                                        ),
	                                        'makes that a cinch too. Our eSignature API is designed with ',
	                                        _react2['default'].createElement(
	                                            'a',
	                                            { target: '_blank',
	                                                href: 'http://blog.hellosign.com/the-rise-of-developer-experience/' },
	                                            'developer experience top of mind'
	                                        ),
	                                        '. We offer a variety of ways to integrate a signing flow directly into your site and the highest level of customization available in the industry with our ',
	                                        _react2['default'].createElement(
	                                            'a',
	                                            { target: '_blank', rel: 'noopener noreferrer',
	                                                href: 'https://www.hellosign.com/api/white-labeling' },
	                                            'white labeling functionality'
	                                        ),
	                                        '. We believe in making eSignatures feel like a seemless part of your product.'
	                                    )
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'm-docusign-switch__features-row' },
	                            _react2['default'].createElement(
	                                'section',
	                                { className: 'copy-shift' },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: 'm-docusign-switch__copy' },
	                                    _react2['default'].createElement('img', { src: __webpack_require__(1540),
	                                        'aria-hidden': true,
	                                        className: 'm-docusign-switch-pricing_icon' }),
	                                    _react2['default'].createElement(
	                                        'h3',
	                                        null,
	                                        'Transparent pricing. No hidden fees. No hassle.'
	                                    ),
	                                    _react2['default'].createElement(
	                                        'p',
	                                        null,
	                                        'Unlike DocuSign, we offer transparent pricing from the get go. That means no hidden fees and no unexpected price hikes. DocuSign users are often surprised by unexplained fees or charges. You\'ll be happy to hear we\u2019ll never surprise you with pricing \u2014 we\u2019re just not really into that kind of thing.'
	                                    )
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'section',
	                                null,
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: 'm-docusign-switch__copy modern-tools-copy' },
	                                    _react2['default'].createElement('img', { src: __webpack_require__(1541),
	                                        'aria-hidden': true,
	                                        className: 'm-docusign-switch-pricing_icon' }),
	                                    _react2['default'].createElement(
	                                        'h3',
	                                        null,
	                                        'Sync eSignatures with your favorite modern tools.'
	                                    ),
	                                    _react2['default'].createElement(
	                                        'p',
	                                        null,
	                                        'We integrate with all your favorite apps. Easily pull files from your cloud storage account into HelloSign, or send a signature request directly from Dropbox, OneDrive, or Box. Sign a document right from Gmail with one click \u2014 we work seamlessly with Google Apps. Keep up to date with actionable eSignature updates in Slack and Hubspot CRM. You can even access all of your Evernote documents in HelloSign.'
	                                    )
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'section',
	                            { className: 'pricing-button' },
	                            _react2['default'].createElement(
	                                'a',
	                                { href: '/info/pricing' },
	                                _react2['default'].createElement(
	                                    'button',
	                                    { className: 'bg-cerulean c-white hc-white hbg-velvet-evening' },
	                                    'SEE PRICING'
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'section',
	                    { className: 'm-docusign-switch__api-container' },
	                    _react2['default'].createElement(
	                        'h2',
	                        null,
	                        'See how HelloSign\'s eSignature API compares to Docusign API'
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-docusign-switch__api-icons-container' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'm-docusign-switch__api-container__icon-container' },
	                            _react2['default'].createElement('img', { src: __webpack_require__(1542),
	                                'aria-hidden': true }),
	                            _react2['default'].createElement(
	                                'p',
	                                null,
	                                'Accept eSignatures in minutes'
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'm-docusign-switch__api-container__icon-container' },
	                            _react2['default'].createElement('img', { src: __webpack_require__(1543),
	                                'aria-hidden': true }),
	                            _react2['default'].createElement(
	                                'p',
	                                null,
	                                'Free during development'
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'm-docusign-switch__api-container__icon-container' },
	                            _react2['default'].createElement('img', { src: __webpack_require__(1544),
	                                className: 'docs-icon',
	                                'aria-hidden': true }),
	                            _react2['default'].createElement(
	                                'p',
	                                null,
	                                'Clean Documentation'
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'm-docusign-switch__api-container__icon-container' },
	                            _react2['default'].createElement('img', { src: __webpack_require__(1545),
	                                className: 'docs-icon',
	                                'aria-hidden': true }),
	                            _react2['default'].createElement(
	                                'p',
	                                null,
	                                'Industry-first API Dashboard'
	                            )
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        null,
	                        _react2['default'].createElement(
	                            'a',
	                            { href: '/api/hellosign-vs-docusign' },
	                            _react2['default'].createElement(
	                                'button',
	                                { className: 'bg-goldenrod hc-goldenrod border-1-goldenrod hbg-white c-white' },
	                                'LEARN MORE'
	                            )
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'section',
	                    { className: 'm-docusign-switch__happy-customers' },
	                    _react2['default'].createElement(
	                        'h2',
	                        null,
	                        'HAPPY HELLOSIGN CUSTOMERS'
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-docusign-switch__logos-container' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'm-docusign-switch__happy-customer__intuit' },
	                            _react2['default'].createElement('img', { src: __webpack_require__(1546), 'aria-hidden': true })
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'm-docusign-switch__happy-customer__instacart' },
	                            _react2['default'].createElement('img', { src: __webpack_require__(1547), 'aria-hidden': true })
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'm-docusign-switch__happy-customer__lyft' },
	                            _react2['default'].createElement('img', { src: __webpack_require__(1548), 'aria-hidden': true })
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'm-docusign-switch__happy-customer__samsung' },
	                            _react2['default'].createElement('img', { src: __webpack_require__(1549), 'aria-hidden': true })
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'm-docusign-switch__happy-customer__twitter' },
	                            _react2['default'].createElement('img', { src: __webpack_require__(1550), 'aria-hidden': true })
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'section',
	                    { className: 'm-docusign-switch__case-studies' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'case-study-header' },
	                        _react2['default'].createElement(
	                            'h2',
	                            null,
	                            'CASE STUDIES'
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-docusign-switch__case-studies-container' },
	                        _react2['default'].createElement(
	                            'section',
	                            { className: 'm-docusign-switch__case-study openlegal' },
	                            _react2['default'].createElement('img', { src: __webpack_require__(1551), 'aria-hidden': true }),
	                            _react2['default'].createElement(
	                                'h4',
	                                null,
	                                'Law startup Openlegal reduced administrative costs by 30-50% with HelloSign.'
	                            ),
	                            _react2['default'].createElement(
	                                'p',
	                                null,
	                                '\'[HelloSign] syncs to Google Drive, Dropbox, etc. which means we can often access documents without having to open up HelloSign.\''
	                            ),
	                            _react2['default'].createElement(
	                                'p',
	                                null,
	                                'Ric Gruber, Partner, ',
	                                _react2['default'].createElement(
	                                    'strong',
	                                    null,
	                                    'Openlegal'
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'case-study-learn-more' },
	                                _react2['default'].createElement(
	                                    'a',
	                                    { href: 'http://info.hellosign.com/openlegal-case-study.html', target: '_blank', rel: 'noopener noreferrer' },
	                                    'LEARN MORE'
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement('div', { className: 'm-docusign-switch__case-study-border' }),
	                        _react2['default'].createElement(
	                            'section',
	                            { className: 'm-docusign-switch__case-study trxade' },
	                            _react2['default'].createElement('img', { src: __webpack_require__(1552), 'aria-hidden': true }),
	                            _react2['default'].createElement(
	                                'h4',
	                                null,
	                                'When their eSignature provider hiked their rates more than 400%, pharmacy platform Trxade switched to HelloSign\'s API in days.'
	                            ),
	                            _react2['default'].createElement(
	                                'p',
	                                null,
	                                '\'My biggest liking about HelloSign was just the ease. We used some of your advanced functionality right off the bat and it was really quick to implement and that was really nice.\''
	                            ),
	                            _react2['default'].createElement(
	                                'p',
	                                null,
	                                'Jeff Davis, CTO, ',
	                                _react2['default'].createElement(
	                                    'strong',
	                                    null,
	                                    'Trxade'
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'case-study-learn-more' },
	                                _react2['default'].createElement(
	                                    'a',
	                                    { href: 'http://info.hellosign.com/trxade-case-study.html', target: '_blank', rel: 'noopener noreferrer' },
	                                    'LEARN MORE'
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'footer',
	                    null,
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-docusign-switch__footer-left' },
	                        _react2['default'].createElement(
	                            'a',
	                            { href: '/info/aboutUs', target: '_blank', rel: 'noopener noreferrer' },
	                            'About HelloSign'
	                        ),
	                        _react2['default'].createElement(_contactLink2['default'], null)
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-docusign-switch__footer-right' },
	                        _react2['default'].createElement(
	                            'span',
	                            { className: 'hs-copyright' },
	                            'HelloSign ',
	                            '\xA9',
	                            ' 2016'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DocusignSwitch;
	}(_react2['default'].Component);
	
	var WordSlider = function (_React$Component2) {
	    _inherits(WordSlider, _React$Component2);
	
	    function WordSlider(props) {
	        _classCallCheck(this, WordSlider);
	
	        var _this2 = _possibleConstructorReturn(this, (WordSlider.__proto__ || Object.getPrototypeOf(WordSlider)).call(this, props));
	
	        _this2.timeouts = [];
	        _this2.state = {
	            currentWordIndex: 0,
	            animation: 'animate-in'
	        };
	        return _this2;
	    }
	
	    _createClass(WordSlider, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.initiateAnimateOut();
	        }
	    }, {
	        key: 'clearTimeouts',
	        value: function clearTimeouts() {
	            this.timeouts.forEach(clearTimeout);
	            this.timeouts = [];
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.clearTimeouts();
	        }
	    }, {
	        key: 'initiateAnimateOut',
	        value: function initiateAnimateOut() {
	            var _this3 = this;
	
	            this.timeouts.push(setTimeout(function () {
	                return _this3.animateOut();
	            }, 3000));
	        }
	    }, {
	        key: 'animateOut',
	        value: function animateOut() {
	            var _this4 = this;
	
	            this.setState({ animation: 'animate-out' });
	            this.timeouts.push(setTimeout(function () {
	                return _this4.incrementIndex();
	            }, 320));
	        }
	    }, {
	        key: 'incrementIndex',
	        value: function incrementIndex() {
	            var currentWordIndex = this.state.currentWordIndex;
	            if (currentWordIndex < this.props.words.length - 1) currentWordIndex++;else currentWordIndex = 0;
	            this.initiateAnimateOut();
	            this.setState({
	                currentWordIndex: currentWordIndex,
	                animation: 'animate-in'
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var currentWord = this.props.words[this.state.currentWordIndex];
	            var classes = 'slider-text ' + this.state.animation;
	            return _react2['default'].createElement(
	                'span',
	                { className: classes },
	                currentWord
	            );
	        }
	    }]);
	
	    return WordSlider;
	}(_react2['default'].Component);

/***/ },
/* 1533 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1534 */,
/* 1535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function (_React$Component) {
	    _inherits(ContactLink, _React$Component);
	
	    function ContactLink(props) {
	        _classCallCheck(this, ContactLink);
	
	        return _possibleConstructorReturn(this, (ContactLink.__proto__ || Object.getPrototypeOf(ContactLink)).call(this, props));
	    }
	
	    _createClass(ContactLink, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.zEmbed || function (e, t) {
	                var n,
	                    o,
	                    d,
	                    i,
	                    s,
	                    a = [],
	                    r = document.createElement('iframe');
	                window.zEmbed = function () {
	                    a.push(arguments);
	                }, window.zE = window.zE || window.zEmbed, r.src = 'javascript:false', r.title = '', r.role = 'presentation', (r.frameElement || r).style.cssText = 'display: none', d = document.getElementsByTagName('script'), d = d[d.length - 1], d.parentNode.insertBefore(r, d), i = r.contentWindow, s = i.document;
	                try {
	                    o = s;
	                } catch (c) {
	                    n = document.domain, r.src = 'javascript:var d=document.open();d.domain=\"" + n + "\";void(0);', o = s;
	                }
	                o.open()._l = function () {
	                    var o = this.createElement('script');
	                    n && (this.domain = n), o.id = 'js-iframe-async', o.src = e, this.t = +new Date(), this.zendeskHost = t, this.zEQueue = a, this.body.appendChild(o);
	                }, o.write('<body onload=\"document._l();\">'), o.close();
	            }('https://assets.zendesk.com/embeddable_framework/main.js', 'hellosign.zendesk.com'); /*]]>*/
	            zE(function () {
	                zE.hide();
	            });
	        }
	    }, {
	        key: 'handleClick',
	        value: function handleClick() {
	            zE(function () {
	                zE.activate({ hideOnClose: true });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var contactText = this.props.contactText || 'Contact';
	            return _react2['default'].createElement(
	                'a',
	                { href: 'javascript:;', onClick: function onClick() {
	                        return _this2.handleClick();
	                    } },
	                contactText
	            );
	        }
	    }]);
	
	    return ContactLink;
	}(_react2['default'].Component);

/***/ },
/* 1536 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/92c219fb4e1d6b7b86b196575fd480bc.png";

/***/ },
/* 1537 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/a095402814684d3c9025bc53f8836156.png";

/***/ },
/* 1538 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/a4b84bc3a5a6ff494b750685992ecffb.svg";

/***/ },
/* 1539 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/441debacd7f3a85ce8a8c6e9dae8f636.svg";

/***/ },
/* 1540 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/b6880f9e0f918728e9eac6b913c1c036.png";

/***/ },
/* 1541 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/d841cd33efbbf60a070ef313f2271eee.svg";

/***/ },
/* 1542 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/44bda4cbeeb2795dca54a1ed3efc85a7.svg";

/***/ },
/* 1543 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/96b882d6bca19a033ded097fc79dfe3e.svg";

/***/ },
/* 1544 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/be5b69cd56e85e1fb7f9b035edb6af8f.svg";

/***/ },
/* 1545 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/5cabcdd0ff0768c7ee4e3ff4d5ea9e93.svg";

/***/ },
/* 1546 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/f814091ff8a5061f932fe45c14da3849.png";

/***/ },
/* 1547 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/b49b75f4c9718cd4f5d40b44674242ce.png";

/***/ },
/* 1548 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/66fb903990671231c4039b3bb2eba9ee.png";

/***/ },
/* 1549 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/eb57055cd4f1eb9bf8110dc4bb1f95f9.png";

/***/ },
/* 1550 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/a00781f7a3c558d13989387f95b96c4f.png";

/***/ },
/* 1551 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/7086976f8baccb5e32a34f379b00b9d5.png";

/***/ },
/* 1552 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/1baeff323aa538dcaf7a49b1d0a361ba.png";

/***/ },
/* 1553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1554);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _currentOpenings = __webpack_require__(1558);
	
	var _currentOpenings2 = _interopRequireDefault(_currentOpenings);
	
	var _slideshow = __webpack_require__(1561);
	
	var _slideshow2 = _interopRequireDefault(_slideshow);
	
	var _lifeAtHellosign = __webpack_require__(1565);
	
	var _lifeAtHellosign2 = _interopRequireDefault(_lifeAtHellosign);
	
	var _testimonials = __webpack_require__(1576);
	
	var _testimonials2 = _interopRequireDefault(_testimonials);
	
	var _weveGotYouCovered = __webpack_require__(1584);
	
	var _weveGotYouCovered2 = _interopRequireDefault(_weveGotYouCovered);
	
	var _our_values_ = __webpack_require__(1593);
	
	var _our_values_2 = _interopRequireDefault(_our_values_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var JOBS_URL = 'https://jobs.lever.co/hellosign';
	
	function CareersPage(props) {
	    return _react2['default'].createElement(
	        'div',
	        { className: 'm-careers-page' },
	        _react2['default'].createElement(Header, null),
	        _react2['default'].createElement(_currentOpenings2['default'], { departments: props.departments, jobsUrl: JOBS_URL }),
	        _react2['default'].createElement(_slideshow2['default'], null),
	        _react2['default'].createElement(WhatWeValue, null),
	        _react2['default'].createElement(_lifeAtHellosign2['default'], null),
	        _react2['default'].createElement(_testimonials2['default'], null),
	        _react2['default'].createElement(_weveGotYouCovered2['default'], null),
	        _react2['default'].createElement(JoinUs, { jobsUrl: JOBS_URL })
	    );
	}
	
	function Header() {
	    return _react2['default'].createElement(
	        'header',
	        null,
	        _react2['default'].createElement(
	            'h1',
	            null,
	            'Our mission is to build something that makes the lives of millions of people easier. Join us!'
	        )
	    );
	}
	
	function WhatWeValue() {
	    return _react2['default'].createElement(
	        'div',
	        { className: 'm-careers-page--what-we-value row' },
	        _react2['default'].createElement(
	            'div',
	            { className: 'columns small-12 medium-6 large-4' },
	            _react2['default'].createElement(
	                'h2',
	                null,
	                'What we value'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'We\'re a fun and driven group, dedicated to meaningful work. HelloSign\'s core values are our not-so-secret weapons.  They\'re posted in every conference room, right next to our whiteboards, so we can use them in real time.  They surfaced directly from our team! Our values guide our decision-making and how we work together everyday, so we all collectively own building a culture that we thrive in.'
	            )
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'm-careers-page--our-values columns small-12 medium-6 large-6 large-offset-2' },
	            _react2['default'].createElement(
	                'h3',
	                null,
	                'OUR VALUES'
	            ),
	            _react2['default'].createElement('img', { src: _our_values_2['default'] })
	        )
	    );
	}
	
	function JoinUs(props) {
	    var jobsUrl = props.jobsUrl;
	    var buttonClassName = 'm-button m-careers-page--join-us--button bg-cerulean hbg-castle-rock c-white hc-white';
	    return _react2['default'].createElement(
	        'div',
	        { className: 'm-careers-page--join-us' },
	        _react2['default'].createElement(
	            'h2',
	            null,
	            'Join us.'
	        ),
	        _react2['default'].createElement(
	            'a',
	            { href: jobsUrl, className: buttonClassName, target: '_blank', rel: 'noopener noreferrer' },
	            'VIEW JOB OPENINGS'
	        )
	    );
	}
	
	module.exports = CareersPage;

/***/ },
/* 1554 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports['default'] = CurrentOpenings;
	
	__webpack_require__(1559);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(333);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function CurrentOpenings(props) {
	    return _react2['default'].createElement(
	        'div',
	        { className: 'm-careers-page--current-openings' },
	        _react2['default'].createElement(
	            'h2',
	            null,
	            _react2['default'].createElement(
	                'span',
	                null,
	                'CURRENT OPENINGS'
	            )
	        ),
	        _react2['default'].createElement(DepartmentsListings, { departments: props.departments }),
	        _react2['default'].createElement(ViewAllButton, { jobsUrl: props.jobsUrl })
	    );
	}
	
	function DepartmentsListings(props) {
	    var departments = cleanDepartmentData(props.departments);
	    return _react2['default'].createElement(
	        'div',
	        { className: 'm-careers-page--departments row' },
	        departments.map(renderDepartment)
	    );
	}
	
	function cleanDepartmentData(departmentsObject) {
	    return Object.values(departmentsObject).filter(function (department) {
	        return !!department.jobs.length;
	    });
	}
	function renderDepartment(department, i, array) {
	    var props = {
	        department: department,
	        key: i,
	        isBorderRight: !!((i + 1) % 3), // This allows us to add border except on edge of row
	        isLast: i >= array.length - 1 // determins the last element of collection
	    };
	    return _react2['default'].createElement(Department, props);
	}
	
	function Department(props) {
	    var _props$department = props.department,
	        name = _props$department.name,
	        jobs = _props$department.jobs;
	
	    var className = (0, _classnames2['default'])({
	        'm-careers-page--department': true,
	        'columns': true,
	        'small-12': true,
	        'medium-4': true,
	        'large-4': true,
	        'border-right': props.isBorderRight,
	        'end': props.isLast
	    });
	    return _react2['default'].createElement(
	        'div',
	        { className: className },
	        _react2['default'].createElement(
	            'h3',
	            null,
	            name
	        ),
	        jobs.map(function (job, i) {
	            return _react2['default'].createElement(Job, { job: job, key: i });
	        })
	    );
	}
	
	function Job(props) {
	    var _props$job = props.job,
	        absolute_url = _props$job.absolute_url,
	        title = _props$job.title;
	
	    var linkProps = {
	        href: absolute_url,
	        className: 'm-careers-page--department--job-listing'
	    };
	    return _react2['default'].createElement(
	        'a',
	        linkProps,
	        title
	    );
	}
	
	function ViewAllButton(props) {
	    var jobsUrl = props.jobsUrl;
	    var buttonClassName = (0, _classnames2['default'])({
	        'm-button': true,
	        'm-careers-page--current-opening--button': true,
	        'bg-cerulean': true,
	        'hbg-castle-rock': true,
	        'c-white': true,
	        'hc-white': true
	    });
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'm-careers-page--current-openings--view-all' },
	        _react2['default'].createElement(
	            'a',
	            { href: jobsUrl, className: buttonClassName, target: '_blank', rel: 'noopener noreferrer' },
	            'View All'
	        )
	    );
	}

/***/ },
/* 1559 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1560 */,
/* 1561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(1562);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var INTERVAL = 3000;
	var IMAGE_PATHS = [__webpack_require__(1564)];
	
	var Slideshow = function (_React$Component) {
	    _inherits(Slideshow, _React$Component);
	
	    function Slideshow() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Slideshow);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Slideshow.__proto__ || Object.getPrototypeOf(Slideshow)).call.apply(_ref, [this].concat(args))), _this), _this.state = { currentIndex: 0 }, _this.initiateSlideshow = function () {
	            _this.interval = setInterval(function () {
	                return _this.incrementIndex();
	            }, INTERVAL);
	        }, _this.incrementIndex = function () {
	            var currentIndex = _this.state.currentIndex;
	
	            var nextIndex = (currentIndex + 1) % IMAGE_PATHS.length;
	            _this.setState({ currentIndex: nextIndex });
	        }, _this.stopSlideshow = function () {
	            if (_this.interval) clearInterval(_this.interval);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Slideshow, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.initiateSlideshow();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.stopSlideshow();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var currentImagePath = IMAGE_PATHS[this.state.currentIndex];
	            return _react2['default'].createElement(
	                'div',
	                { className: 'm-careers-page--slideshow' },
	                _react2['default'].createElement('img', { src: currentImagePath })
	            );
	        }
	    }]);
	
	    return Slideshow;
	}(_react2['default'].Component);
	
	module.exports = Slideshow;

/***/ },
/* 1562 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1563 */,
/* 1564 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/dd520462f1b3b2e6ac99afa20f8d0375.png";

/***/ },
/* 1565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1566);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _life_at_hs_icon_ = __webpack_require__(1568);
	
	var _life_at_hs_icon_2 = _interopRequireDefault(_life_at_hs_icon_);
	
	var _life_at_hs_icon_3 = __webpack_require__(1569);
	
	var _life_at_hs_icon_4 = _interopRequireDefault(_life_at_hs_icon_3);
	
	var _life_at_hs_icon_5 = __webpack_require__(1570);
	
	var _life_at_hs_icon_6 = _interopRequireDefault(_life_at_hs_icon_5);
	
	var _life_at_hs_icon_7 = __webpack_require__(1571);
	
	var _life_at_hs_icon_8 = _interopRequireDefault(_life_at_hs_icon_7);
	
	var _life_at_hs_icon_9 = __webpack_require__(1572);
	
	var _life_at_hs_icon_10 = _interopRequireDefault(_life_at_hs_icon_9);
	
	var _life_at_hs_icon_11 = __webpack_require__(1573);
	
	var _life_at_hs_icon_12 = _interopRequireDefault(_life_at_hs_icon_11);
	
	var _life_at_hs_icon_13 = __webpack_require__(1574);
	
	var _life_at_hs_icon_14 = _interopRequireDefault(_life_at_hs_icon_13);
	
	var _life_at_hs_icon_15 = __webpack_require__(1575);
	
	var _life_at_hs_icon_16 = _interopRequireDefault(_life_at_hs_icon_15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var imagePaths = [_life_at_hs_icon_2['default'], _life_at_hs_icon_4['default'], _life_at_hs_icon_6['default'], _life_at_hs_icon_8['default'], _life_at_hs_icon_10['default'], _life_at_hs_icon_12['default'], _life_at_hs_icon_14['default'], _life_at_hs_icon_16['default']];
	var makeImage = function makeImage(imagePath) {
	    return _react2['default'].createElement('img', { src: imagePath });
	};
	var images = imagePaths.map(makeImage);
	
	function LifeAtHelloSign() {
	    return _react2['default'].createElement(
	        'div',
	        { className: 'm-careers-page--life-at-hellosign' },
	        _react2['default'].createElement(
	            'h2',
	            null,
	            'Life at HelloSign'
	        ),
	        _react2['default'].createElement(
	            'p',
	            null,
	            'We have raving fans ',
	            images[0],
	            ' who love what we make \u2022 We\u2019re always evolving with eye towards improvement ',
	            images[1],
	            ' \u2022 We\u2019re committed to building a product people want ',
	            images[2],
	            ' \u2022 We actively build our culture together as a team ',
	            images[3],
	            ' \u2022 We work in an open, airy, creative space with communal dining and lounge spaces ',
	            images[4],
	            ' \u2022 We thrive on teaching and learning from each other ',
	            images[5],
	            ' \u2022 We laugh a lot ',
	            images[5],
	            ' \u2022 And we\u2019ll never forget your birthday! ',
	            images[6]
	        )
	    );
	}
	
	module.exports = LifeAtHelloSign;

/***/ },
/* 1566 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1567 */,
/* 1568 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/396362083f09372a75c035bc73d47acb.png";

/***/ },
/* 1569 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/d7cb80e8276fc8baf1bcf099232e60d4.png";

/***/ },
/* 1570 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/47c5b5faa6a74a68727be613399a46a9.png";

/***/ },
/* 1571 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/7dbd730e36e972cf334bd894f53d9dac.png";

/***/ },
/* 1572 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/2d5068acf944d241c14b4084bb9fab62.png";

/***/ },
/* 1573 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/cc2f9739cbf28018b255906550bc2510.png";

/***/ },
/* 1574 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/e0e0243326291966176aae366168b33f.png";

/***/ },
/* 1575 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/228a7f6c371094905860017a2c403446.png";

/***/ },
/* 1576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports['default'] = Testimonials;
	
	__webpack_require__(1577);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _quotation_mark = __webpack_require__(1582);
	
	var _quotation_mark2 = _interopRequireDefault(_quotation_mark);
	
	var _emil = __webpack_require__(1583);
	
	var _emil2 = _interopRequireDefault(_emil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function Testimonials() {
	    return _react2['default'].createElement(
	        'div',
	        { style: { backgroundColor: '#F7F8F9' } },
	        _react2['default'].createElement(
	            'div',
	            { className: 'm-careers-page--testimonials' },
	            _react2['default'].createElement(
	                'div',
	                { style: { maxWidth: 1120, margin: 'auto' } },
	                _react2['default'].createElement('img', { src: _quotation_mark2['default'] }),
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    'Nobody is afraid to ask any questions because they know that immediately they will be met with a response, or an idea, or an \'I don\u2019t know but let\u2019s find out.\''
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-careers-page--testimonials--profile' },
	                    _react2['default'].createElement('img', { src: _emil2['default'] }),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'm-careers-page--testimonials--profile-info' },
	                        _react2['default'].createElement(
	                            'p',
	                            { className: 'm-careers-page--testimonials--profile-name' },
	                            'Emil Gallardo'
	                        ),
	                        _react2['default'].createElement(
	                            'p',
	                            { className: 'm-careers-page--testimonials--profile-title' },
	                            'Product Manager'
	                        )
	                    )
	                )
	            )
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'm-careers-page--testimonials--featured row' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-careers-page--testimonials--featured--muse columns small-12 medium-4 large-4' },
	                _react2['default'].createElement(
	                    'h2',
	                    null,
	                    'WE WERE FEATURED ON \'THE MUSE\''
	                ),
	                _react2['default'].createElement(
	                    'h2',
	                    null,
	                    'CHECK US OUT'
	                ),
	                _react2['default'].createElement('a', { href: 'https://www.themuse.com/companies/hellosign/office', target: '_blank', rel: 'noopener noreferrer' })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-careers-page--testimonials--featured--glassdoor columns small-12 medium-4 large-4' },
	                _react2['default'].createElement('a', { href: 'https://www.glassdoor.com/Overview/Working-at-HelloSign-EI_IE879257.11,20.htm', target: '_blank', rel: 'noopener noreferrer' })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-careers-page--testimonials--featured--hirepalooza columns small-12 medium-4 large-4 end' },
	                _react2['default'].createElement('a', { href: 'http://blog.hellosign.com/hellosign-at-hirepalooza-2015/', target: '_blank', rel: 'noopener noreferrer' })
	            )
	        )
	    );
	}

/***/ },
/* 1577 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/c20c4db9a1eaf7d0e2e08297448a7046.png";

/***/ },
/* 1583 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/9d04d1926b5a89734350eab59192f9c5.png";

/***/ },
/* 1584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports['default'] = WeveGotYouCovered;
	
	__webpack_require__(1585);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _benefits_icon_ = __webpack_require__(1587);
	
	var _benefits_icon_2 = _interopRequireDefault(_benefits_icon_);
	
	var _benefits_icon_3 = __webpack_require__(1588);
	
	var _benefits_icon_4 = _interopRequireDefault(_benefits_icon_3);
	
	var _benefits_icon_5 = __webpack_require__(1589);
	
	var _benefits_icon_6 = _interopRequireDefault(_benefits_icon_5);
	
	var _benefits_icon_7 = __webpack_require__(1590);
	
	var _benefits_icon_8 = _interopRequireDefault(_benefits_icon_7);
	
	var _benefits_icon_9 = __webpack_require__(1591);
	
	var _benefits_icon_10 = _interopRequireDefault(_benefits_icon_9);
	
	var _benefits_icon_11 = __webpack_require__(1592);
	
	var _benefits_icon_12 = _interopRequireDefault(_benefits_icon_11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function WeveGotYouCovered() {
	    return _react2['default'].createElement(
	        'div',
	        { className: 'm-careers-page--weve-got-you-covered row' },
	        _react2['default'].createElement(
	            'div',
	            { className: 'm-careers-page--weve-got-you-covered--intro columns small-12 medium-4' },
	            _react2['default'].createElement(
	                'h2',
	                null,
	                'We\'ve got you covered'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'HelloSign takes employee happiness and well-being very seriously. We offer perks beyond basic benefits (though we cover those, too!) and do everything we can to make our team feel awesome.'
	            ),
	            _react2['default'].createElement(
	                'p',
	                null,
	                'Here\u2019s a peek into what you can expect from your first day on.'
	            )
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'columns small-12 medium-6 medium-offset-2 end' },
	            _react2['default'].createElement(
	                'h3',
	                null,
	                'STELLAR BENEFITS'
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-careers-page-weve-got-you-covered--benefit' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-careers-page-weve-got-you-covered--benefit--image' },
	                    _react2['default'].createElement('img', { src: _benefits_icon_2['default'] })
	                ),
	                _react2['default'].createElement(
	                    'h4',
	                    null,
	                    'The Basics'
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    'We pay 100% of team member\u2019s medical, dental, and vision insurance premiums and also cover 50% for your dependents. We offer pre-tax commuter benefits and a 401(k) plan, which even includes financial planning services.'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-careers-page-weve-got-you-covered--benefit' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-careers-page-weve-got-you-covered--benefit--image' },
	                    _react2['default'].createElement('img', { src: _benefits_icon_4['default'] })
	                ),
	                _react2['default'].createElement(
	                    'h4',
	                    null,
	                    'Flexible Scheduling'
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    'Flexible vacation days, generous paid holidays, and the occasional work from home (or cafe or park) day. You can partner with your team to balance life, work and what drives your productivity.'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-careers-page-weve-got-you-covered--benefit' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-careers-page-weve-got-you-covered--benefit--image competitive-salary' },
	                    _react2['default'].createElement('img', { src: _benefits_icon_6['default'] })
	                ),
	                _react2['default'].createElement(
	                    'h4',
	                    null,
	                    'Competitive Salary'
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    'Every team member is paid a competitive salary and offered a generous stock option plan. You have the opportunity to literally own a part of what we\u2019re building together.'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-careers-page-weve-got-you-covered--benefit' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-careers-page-weve-got-you-covered--benefit--image culture-of-learning' },
	                    _react2['default'].createElement('img', { src: _benefits_icon_8['default'] })
	                ),
	                _react2['default'].createElement(
	                    'h4',
	                    null,
	                    'A Culture of Learning'
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    'Between our catered lunch & learns, guest speakers, blameless post-mortems, cross-department squads and many other new initiatives we\u2019re working on, we take a deliberate approach to empowering our team\u2019s constant learning.'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-careers-page-weve-got-you-covered--benefit' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-careers-page-weve-got-you-covered--benefit--image' },
	                    _react2['default'].createElement('img', { src: _benefits_icon_10['default'] })
	                ),
	                _react2['default'].createElement(
	                    'h4',
	                    null,
	                    'Dogs'
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    'We are simply dog lovers so pups, large and small, frequent the office. Some even have their own HipChat emoticons!  Need we say more?'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'm-careers-page-weve-got-you-covered--benefit' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'm-careers-page-weve-got-you-covered--benefit--image' },
	                    _react2['default'].createElement('img', { src: _benefits_icon_12['default'] })
	                ),
	                _react2['default'].createElement(
	                    'h4',
	                    null,
	                    'HelloSign Community'
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    'Our team is encouraged to kick-off their own HelloSign team events like our running club, volunteer events, spring & holiday potlucks, game nights, ping-pong tournaments. Moms, dads, kids, friends and significant others frequently drop by and are considered our extended HelloSign family!'
	                )
	            )
	        )
	    );
	}

/***/ },
/* 1585 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1586 */,
/* 1587 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/1bca4010da1f81fdff51bd817289294e.png";

/***/ },
/* 1588 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/cdc27e19ab75f0d75b7545c081ca0349.png";

/***/ },
/* 1589 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/cfe27a70be60d07e19ee685ea9ddc148.png";

/***/ },
/* 1590 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/9f1a75e96541e0ed4ae20f7bd18dc826.png";

/***/ },
/* 1591 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/92d7dc673f3e9b05210e570ccad1de5b.png";

/***/ },
/* 1592 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/e6fc6d02ea8743712f94bc83a73fc0b7.png";

/***/ },
/* 1593 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/0477757c29a16d762c19d545a9bfa052.svg";

/***/ },
/* 1594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(1595);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _integrations = __webpack_require__(1597);
	
	var _integrations2 = _interopRequireDefault(_integrations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Integrations = function (_React$Component) {
	    _inherits(Integrations, _React$Component);
	
	    function Integrations() {
	        _classCallCheck(this, Integrations);
	
	        return _possibleConstructorReturn(this, (Integrations.__proto__ || Object.getPrototypeOf(Integrations)).apply(this, arguments));
	    }
	
	    _createClass(Integrations, [{
	        key: '_onLoad',
	        value: function _onLoad(e) {
	            var el = e.target;
	            if (el.width > el.height * 2) {
	                el.className = 'landscape';
	            }
	        }
	    }, {
	        key: 'renderIntegration',
	        value: function renderIntegration(props) {
	            return _react2['default'].createElement(
	                'a',
	                { className: 'm-integrations__item', key: props.name, href: props.href, target: '_blank', rel: 'noopener noreferrer' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'content' },
	                    _react2['default'].createElement('img', { src: __webpack_require__(1598)("./" + props.src + '.svg'),
	                        onLoad: this._onLoad,
	                        'aria-hidden': true }),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'text' },
	                        _react2['default'].createElement(
	                            'span',
	                            null,
	                            props.name
	                        ),
	                        _react2['default'].createElement(
	                            'span',
	                            null,
	                            props.desc
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            var script = document.createElement('script');
	
	            script.src = 'https://zapier.com/zapbook/embed/widget.js?services=hellosign&container=true&limit=5&html_id=zapiermount';
	            script.async = true;
	            $(script).appendTo('#zapiermount');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'm-integrations' },
	                _react2['default'].createElement(
	                    'header',
	                    { className: 'text-center l-margin-t-120' },
	                    _react2['default'].createElement('img', { src: __webpack_require__(1608), className: 'l-margin-b-15' }),
	                    _react2['default'].createElement(
	                        'h1',
	                        { className: 'l-margin-b-10' },
	                        'HELLOSIGN INTEGRATIONS'
	                    ),
	                    _react2['default'].createElement(
	                        'span',
	                        null,
	                        'Extend eSignatures'
	                    ),
	                    _react2['default'].createElement(
	                        'h2',
	                        { className: 'l-margin-t-20' },
	                        'HelloSign connects with the services you already use to power your business.'
	                    )
	                ),
	                _react2['default'].createElement('a', { name: 'google-integrations' }),
	                _react2['default'].createElement(
	                    'section',
	                    { className: 'google-integrations row' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'header' },
	                        _react2['default'].createElement(
	                            'h3',
	                            null,
	                            'GOOGLE INTEGRATIONS'
	                        )
	                    ),
	                    _integrations2['default'].googleIntegrations.map(function (int) {
	                        return _this2.renderIntegration(int);
	                    })
	                ),
	                _react2['default'].createElement('a', { name: 'business-applications' }),
	                _react2['default'].createElement(
	                    'section',
	                    { className: 'business-applications row' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'header' },
	                        _react2['default'].createElement(
	                            'h3',
	                            null,
	                            'BUSINESS APPLICATIONS'
	                        )
	                    ),
	                    _integrations2['default'].businessApplications.map(function (int) {
	                        return _this2.renderIntegration(int);
	                    })
	                ),
	                _react2['default'].createElement('a', { name: 'event-waivers' }),
	                _react2['default'].createElement(
	                    'section',
	                    { className: 'event-waivers row' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'section-title' },
	                        _react2['default'].createElement(
	                            'h3',
	                            null,
	                            'EVENT WAIVERS AND FORMS'
	                        )
	                    ),
	                    _integrations2['default'].eventWaivers.map(function (int) {
	                        return _this2.renderIntegration(int);
	                    })
	                ),
	                _react2['default'].createElement('a', { name: 'insurance-tools' }),
	                _react2['default'].createElement(
	                    'section',
	                    { className: 'insurance-tools row' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'section-title' },
	                        _react2['default'].createElement(
	                            'h3',
	                            null,
	                            'INSURANCE TOOLS'
	                        )
	                    ),
	                    _integrations2['default'].insuranceTools.map(function (int) {
	                        return _this2.renderIntegration(int);
	                    })
	                ),
	                _react2['default'].createElement('a', { name: 'zapier' }),
	                _react2['default'].createElement(
	                    'section',
	                    { className: '3rd-party-integrations row' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'section-title' },
	                        _react2['default'].createElement(
	                            'h3',
	                            null,
	                            'THIRD PARTY INTEGRATIONS!'
	                        )
	                    ),
	                    _integrations2['default'].thirdParty.map(function (int) {
	                        return _this2.renderIntegration(int);
	                    }),
	                    _react2['default'].createElement('br', null),
	                    _react2['default'].createElement('div', { id: 'zapiermount' })
	                ),
	                _react2['default'].createElement(
	                    'section',
	                    { className: 'footer' },
	                    _react2['default'].createElement(
	                        'span',
	                        null,
	                        'Looking to partner to extend HelloSign\'s eSignature tools to your users?'
	                    ),
	                    _react2['default'].createElement(
	                        'a',
	                        { href: 'mailto:bizdev@hellosign.com?subject=HelloSign Partnership' },
	                        _react2['default'].createElement(
	                            'span',
	                            null,
	                            'Reach out to our Business Development team.'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Integrations;
	}(_react2['default'].Component);
	
	module.exports = Integrations;

/***/ },
/* 1595 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1596 */,
/* 1597 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	    googleIntegrations: [{
	        name: 'Gmail',
	        desc: 'Fill out and sign documents without ever leaving Gmail. It takes less than 30 seconds.',
	        href: '/gmail', // Integration link
	        src: 'gmail' // Image src
	    }, {
	        name: 'Google Docs',
	        desc: 'Draft, edit and send your document for signature without ever leaving Google Docs.',
	        href: '/google-docs-add-on',
	        src: 'googledocs'
	    }, {
	        name: 'Google Drive',
	        desc: 'Connect your account with HelloSign to sign documents, request signatures, and set-up templates right in Drive.',
	        href: '/googledrive',
	        src: 'googledrive'
	    }, {
	        name: 'Google Apps For Work',
	        desc: 'Deploy eSignatures to your entire company in minutes. All of your users can log in to their HelloSign account with Single Sign On (SSO).',
	        href: 'https://apps.google.com/marketplace/app/cmblnlmegcfpannmkinlnfpjplgfmbcb',
	        src: 'googleapps'
	    }],
	    businessApplications: [{
	        name: 'Box',
	        desc: 'Sign Box documents from your HelloSign account and quickly send documents for signature from Box.',
	        href: '/box',
	        src: 'box'
	    }, {
	        name: 'Dropbox',
	        desc: 'Import documents from Dropbox and save signed copies in Dropbox.',
	        href: '/dropbox',
	        src: 'dropbox'
	    }, {
	        name: 'Evernote',
	        desc: 'Access notes in HelloSign and store signed documents in your Evernote account.',
	        href: '/evernote',
	        src: 'evernote'
	    }, {
	        name: 'HubSpot CRM',
	        desc: 'Integrate HelloSign with HubSpot CRM to request signatures, track lifecycle status, and manage sales contracts out for signature.',
	        href: '/hubspot-crm',
	        src: 'hubspot'
	    }, {
	        name: 'Microsoft OneDrive',
	        desc: 'Store copies of documents in your OneDrive account and easily send files for signature.',
	        href: '/onedrive',
	        src: 'onedrive'
	    }, {
	        name: 'Oracle',
	        desc: 'Request signatures for your contracts, agreements, and waivers directly from Oracle Documents Cloud.',
	        href: '/oracle',
	        src: 'oracle'
	    }, {
	        name: 'Salesforce',
	        desc: 'Send contracts for signature directly from Salesforce. Get status updates in Salesforce, auto-fill contract details and more.',
	        href: '/salesforce',
	        src: 'salesforce'
	    }, {
	        name: 'Slack',
	        desc: 'Keep your teams and channels in the know on the status of your signed documents.',
	        href: '/slack',
	        src: 'slack'
	    }],
	    eventWaivers: [{
	        name: 'Eventbrite',
	        desc: 'Automagically send event waivers, photo releases, contracts, and more to your attendees directly from Eventbrite.',
	        href: 'https://www.eventbrite.com/spectrum/hellosign',
	        src: 'eventbrite'
	    }],
	    insuranceTools: [{
	        name: 'QQ Catalyst',
	        desc: 'Sync QQ Catalyst documents back to QQ Catalyst once they are signed by all parties.',
	        href: '/home/myAccount#integrations',
	        src: 'qqcatalyst'
	    }],
	    thirdParty: [{
	        name: 'Zapier',
	        desc: 'Integrate with hundreds of services by connecting your HelloSign account to Zapier.',
	        href: 'https://zapier.com/zapbook/hellosign',
	        src: 'zapier'
	    }]
	};

/***/ },
/* 1598 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./box.svg": 1599,
		"./dropbox.svg": 1600,
		"./eventbrite.svg": 1601,
		"./evernote.svg": 1602,
		"./gmail.svg": 1603,
		"./googleapps.svg": 1604,
		"./googledocs.svg": 1605,
		"./googledrive.svg": 1606,
		"./hubspot.svg": 1607,
		"./integrations_icon.svg": 1608,
		"./onedrive.svg": 1609,
		"./oracle.svg": 1610,
		"./qqcatalyst.svg": 1611,
		"./salesforce.svg": 1612,
		"./slack.svg": 1613,
		"./zapier.svg": 1614
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1598;


/***/ },
/* 1599 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/659b394541a52876aee837cff7ec3ecc.svg";

/***/ },
/* 1600 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/61ea61368a3749a5618af0ed26a0be3d.svg";

/***/ },
/* 1601 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/1dcf38cf66267af5b6a3d62f34cea888.svg";

/***/ },
/* 1602 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/9c1be6bc736fdf85cb6b2da1dd9eabd9.svg";

/***/ },
/* 1603 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/81826dc8e6bc9604581e4d33732b4335.svg";

/***/ },
/* 1604 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/d10126091fedcad3e1ed40b18da983ec.svg";

/***/ },
/* 1605 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/16cbb6488b0eef3d4743f070446bacba.svg";

/***/ },
/* 1606 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/f59c496002a76a16f1acf0312daf9e4b.svg";

/***/ },
/* 1607 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/c5111370167e69a42f7a867d09f300e4.svg";

/***/ },
/* 1608 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/9e2d7b323afc3663855b7a3df95e76ba.svg";

/***/ },
/* 1609 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/7cc67ec927b7035d5a23c45a44a00578.svg";

/***/ },
/* 1610 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/a46ce7d562532cb0e41897207a5ec11c.svg";

/***/ },
/* 1611 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/64dbed1abcce4f192850660ff4592cf3.svg";

/***/ },
/* 1612 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/174607ae606f34ef171886fb6b06eae1.svg";

/***/ },
/* 1613 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/e18912ae8473d1dc330175acff10f30e.svg";

/***/ },
/* 1614 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/dbebac2c680cd8d1ef55814434da3e4b.svg";

/***/ },
/* 1615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1616);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _marketoForm = __webpack_require__(1075);
	
	var _marketoForm2 = _interopRequireDefault(_marketoForm);
	
	var _salesforce_logo = __webpack_require__(1618);
	
	var _salesforce_logo2 = _interopRequireDefault(_salesforce_logo);
	
	var _clouds_salesforce = __webpack_require__(1619);
	
	var _clouds_salesforce2 = _interopRequireDefault(_clouds_salesforce);
	
	var _cloud_left = __webpack_require__(1236);
	
	var _cloud_left2 = _interopRequireDefault(_cloud_left);
	
	var _cloud_right = __webpack_require__(1237);
	
	var _cloud_right2 = _interopRequireDefault(_cloud_right);
	
	var _handshake_icon = __webpack_require__(1527);
	
	var _handshake_icon2 = _interopRequireDefault(_handshake_icon);
	
	var _signature_icon = __webpack_require__(1239);
	
	var _signature_icon2 = _interopRequireDefault(_signature_icon);
	
	var _document_send_icon = __webpack_require__(1526);
	
	var _document_send_icon2 = _interopRequireDefault(_document_send_icon);
	
	var _benefitsSection = __webpack_require__(1248);
	
	var _benefitsSection2 = _interopRequireDefault(_benefitsSection);
	
	var _socialSection = __webpack_require__(1242);
	
	var _socialSection2 = _interopRequireDefault(_socialSection);
	
	var _faqSection = __webpack_require__(1247);
	
	var _faqSection2 = _interopRequireDefault(_faqSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function Salesforce(p) {
	    // Salesforce constants
	    var benefits = [{
	        icon: _handshake_icon2['default'],
	        title: 'Close Opportunities in Minutes',
	        text: 'The average turnaround time for a contract is 44 minutes using HelloSign. Seal deals even faster! And it’s customizable to fit your workflow.'
	    }, {
	        icon: _signature_icon2['default'],
	        title: 'Easily Track the Status of Signatures',
	        text: 'Make it easy to organize and follow-up on any eSignature request in Salesforce. The document status is automatically tracked in the HelloSign Signature Requests section.'
	    }, {
	        icon: _document_send_icon2['default'],
	        title: 'Auto-populate High-volume Documents',
	        text: 'Pre-fill your documents with Salesforce data using templates and merge fields. Create documents only once, then reuse them without ever leaving Salesforce.'
	    }];
	    var twitterLink = 'https://twitter.com/intent/tweet?text=Check%20out%20the%20awesome%20HelloSign%20for%20Salesforce%21%20http%3A%2F%2Fwww.hellosign.com%2Fsalesforce%3Futm_campaign%3DSFDC-082016%26utm_medium%3Ds2s%26utm_source%3Dtwitter&source=clicktotweet&related=clicktotweet';
	    var facebookLink = 'https://www.facebook.com/sharer/sharer.php?u=http%3A//www.hellosign.com/salesforce?utm_campaign=SFDC-072016%26utm_medium=s2s%26utm_source=facebook';
	    var linkedInLink = 'https://www.linkedin.com/shareArticle?mini=true&url=www.hellosign.com/salesforce?utm_campaign=SFDC-072016%2526utm_medium=s2s%2526utm_source=linkedin&title=Check%20out%20HelloSign%20for%20Salesforce%20Integration!&summary=&source=';
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'seo-cloud-integrations seo-salesforce' },
	        _react2['default'].createElement(IllustrationArea, null),
	        _react2['default'].createElement(
	            'div',
	            { className: 'seo-cloud-integrations__main bg-white' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'seo-cloud-integrations__main__free_accounts__top bg-plume', style: { fontWeight: 600 } },
	                'Get this integration started today.\xA0',
	                _react2['default'].createElement(ContactSalesLink, null)
	            ),
	            _react2['default'].createElement(_benefitsSection2['default'], { benefits: benefits }),
	            _react2['default'].createElement(HowItWorks, null),
	            _react2['default'].createElement(_socialSection2['default'], {
	                title: 'Share with your networks!',
	                twitterLink: twitterLink,
	                facebookLink: facebookLink,
	                linkedInLink: linkedInLink }),
	            _react2['default'].createElement(_faqSection2['default'], { link: 'https://faq.hellosign.com/hc/en-us/sections/205929427-SFDC' }),
	            _react2['default'].createElement(
	                'div',
	                { className: 'seo-cloud-integrations__main__free_accounts__bottom', style: { fontWeight: 600 } },
	                'Get this integration started today.\xA0',
	                _react2['default'].createElement(ContactSalesLink, null)
	            )
	        )
	    );
	}
	
	function IllustrationArea(p) {
	    return _react2['default'].createElement(
	        'div',
	        { className: 'top row dropbox-blue' },
	        _react2['default'].createElement(
	            'div',
	            { className: 'top-content-container large-5 large-push-6 columns' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'hellosign-dropbox' },
	                _react2['default'].createElement('img', { src: _salesforce_logo2['default'], alt: 'Salesforce Logo' })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'title' },
	                _react2['default'].createElement(
	                    'h1',
	                    null,
	                    'Send contracts directly from Salesforce\xAE'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'subtitle' },
	                _react2['default'].createElement(
	                    'h2',
	                    null,
	                    'HelloSign for Salesforce lets you quickly prepare documents for eSignature, minimize the back-and-forth follow-up, and simplify the signing process for your clients.'
	                )
	            ),
	            _react2['default'].createElement(ContactSalesButton, null)
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'clouds-container large-5 large-pull-4 columns salesforce-clouds' },
	            _react2['default'].createElement('img', { src: _clouds_salesforce2['default'], alt: 'cloud left' })
	        ),
	        _react2['default'].createElement('img', { src: _cloud_left2['default'], alt: 'cloud left', className: 'cloud-left' }),
	        _react2['default'].createElement('img', { src: _cloud_right2['default'], alt: 'cloud right', className: 'cloud-right' })
	    );
	}
	
	function HowItWorks(p) {
	    var videoProps = {
	        src: 'https://www.youtube.com/embed/8MSbsPE2S_o',
	        frameBorder: 0,
	        style: {
	            width: '100%',
	            maxWidth: 800,
	            height: 430
	        }
	    };
	    var paragraphStyle = {
	        marginLeft: 20
	    };
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'seo-cloud-integrations__how-it-works' },
	        _react2['default'].createElement(
	            'h2',
	            null,
	            'How it Works'
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'row' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'screenshot-explanation large-4 large-push-8 columns' },
	                _react2['default'].createElement(
	                    'p',
	                    { style: paragraphStyle },
	                    'To get started, activate the HelloSign for Salesforce integration.'
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    { onClick: handleClick, style: paragraphStyle },
	                    _react2['default'].createElement(
	                        'span',
	                        { style: { color: '#00B3E6', cursor: 'pointer', fontWeight: 400 } },
	                        'Contact HelloSign Sales to get started.'
	                    )
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    { style: paragraphStyle },
	                    'You\u2019ll be able to track your documents in the HelloSign Signature Requests section on the lead, contact, opportunity, or account record. Autofill your documents using templates, and we\u2019ll pull in data from your Salesforce fields.'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'dropbox-screenshot large-8 large-pull-4 columns' },
	                _react2['default'].createElement('iframe', videoProps)
	            )
	        )
	    );
	}
	
	function ContactSalesButton() {
	    return _react2['default'].createElement(_button2['default'], {
	        buttonText: 'Contact sales',
	        buttonColor: 'cerulean',
	        buttonBorderColor: 'cerulean',
	        buttonHoverColor: 'white',
	        buttonHoverTextColor: 'cerulean',
	        onClick: handleClick });
	}
	
	function ContactSalesLink(p) {
	    return _react2['default'].createElement(
	        'a',
	        { onClick: handleClick },
	        'Contact our Sales team.'
	    );
	}
	
	function handleClick(e) {
	    // Click handler to launch contact sales modal
	    var attachPoint = HfReactHelper.getRevealAttachPoint('contact_sales_modal');
	    var node = _reactDom2['default'].render(_react2['default'].createElement(_marketoForm2['default'], { formId: 1262, trackingId: 'salesforce' }), attachPoint);
	    $(document).foundation();
	    $(_reactDom2['default'].findDOMNode(node)).closest('.reveal-modal').foundation('reveal', 'open');
	}
	
	module.exports = Salesforce;

/***/ },
/* 1616 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1617 */,
/* 1618 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/dc9baf47e6e311f3fe03d186684e804e.svg";

/***/ },
/* 1619 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/19555627b9f772b5d99c906733d7d285.svg";

/***/ },
/* 1620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1621);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(528);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _hfReactHelper = __webpack_require__(517);
	
	var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);
	
	var _marketoForm = __webpack_require__(1075);
	
	var _marketoForm2 = _interopRequireDefault(_marketoForm);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _clouds_oracle = __webpack_require__(1623);
	
	var _clouds_oracle2 = _interopRequireDefault(_clouds_oracle);
	
	var _HS_logo_white = __webpack_require__(1233);
	
	var _HS_logo_white2 = _interopRequireDefault(_HS_logo_white);
	
	var _oracle_logo = __webpack_require__(1624);
	
	var _oracle_logo2 = _interopRequireDefault(_oracle_logo);
	
	var _overlay_left = __webpack_require__(1269);
	
	var _overlay_left2 = _interopRequireDefault(_overlay_left);
	
	var _overlay_right = __webpack_require__(1270);
	
	var _overlay_right2 = _interopRequireDefault(_overlay_right);
	
	var _clock_icon = __webpack_require__(1625);
	
	var _clock_icon2 = _interopRequireDefault(_clock_icon);
	
	var _notifications_icon = __webpack_require__(1626);
	
	var _notifications_icon2 = _interopRequireDefault(_notifications_icon);
	
	var _cloud_icon_bw = __webpack_require__(1627);
	
	var _cloud_icon_bw2 = _interopRequireDefault(_cloud_icon_bw);
	
	var _socialSection = __webpack_require__(1242);
	
	var _socialSection2 = _interopRequireDefault(_socialSection);
	
	var _benefitsSection = __webpack_require__(1248);
	
	var _benefitsSection2 = _interopRequireDefault(_benefitsSection);
	
	var _pricingCtaSection = __webpack_require__(1250);
	
	var _pricingCtaSection2 = _interopRequireDefault(_pricingCtaSection);
	
	var _faqSection = __webpack_require__(1247);
	
	var _faqSection2 = _interopRequireDefault(_faqSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function Oracle(p) {
	    // Oracle constants
	    var benefits = [{
	        icon: _clock_icon2['default'],
	        title: 'Reduce time preparing important agreements',
	        text: 'Send your documents out for signature directly from Documents Cloud and avoid toggling between different applications.'
	    }, {
	        icon: _notifications_icon2['default'],
	        title: 'Monitor your documents in real time',
	        text: 'You’ll know when your document is signed in Documents Cloud by way of a status icon and through email notifications so you’re never left wondering.'
	    }, {
	        icon: _cloud_icon_bw2['default'],
	        title: 'Find your documents easily in Documents Cloud',
	        text: 'Stop digging through your inbox to find your signed document. All your signed docs are automatically saved in your Documents Cloud account.'
	    }];
	    var twitterLink = 'https://twitter.com/intent/tweet?text=Check%20out%20HelloSign%20for%20Oracle%20Documents%20Cloud.%20https%3A%2F%2Fwww.hellosign.com%2Foracle%3Futm_campaign%3DORC-082016%26utm_medium%3Ds2s%26utm_source%3Dtwitter&source=clicktotweet&related=clicktotweet';
	    var facebookLink = 'https://www.facebook.com/sharer/sharer.php?u=http%3A//www.hellosign.com/oracle?utm_campaign=ORC-082016%26utm_medium=s2s%26utm_source=facebook';
	    var linkedInLink = 'https://www.linkedin.com/shareArticle?mini=true&url=http%3A//www.hellosign.com/oracle?utm_campaign=ORC-082016%26utm_medium=s2s%26utm_source=linkedin&title=Check%20out%20HelloSign%20for%20Oracle%20Documents%20Cloud&summary=&source=';
	    var border = '2px solid #D7D7D7';
	    var ctaText = 'Get this integration started today.';
	    var linkText = 'Contact our Sales team';
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'seo-cloud-integrations oracle' },
	        _react2['default'].createElement(IllustrationArea, null),
	        _react2['default'].createElement(
	            'div',
	            { className: 'seo-cloud-integrations__main', style: { backgroundColor: 'white' } },
	            _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'top',
	                text: ctaText,
	                linkText: linkText,
	                onClick: handleClick,
	                style: { borderBottom: border, backgroundColor: '#F7F8F9', fontWeight: 600 } }),
	            _react2['default'].createElement(_benefitsSection2['default'], { benefits: benefits }),
	            _react2['default'].createElement(HowItWorks, null),
	            _react2['default'].createElement(_socialSection2['default'], { title: 'Share with your networks!',
	                twitterLink: twitterLink,
	                facebookLink: facebookLink,
	                linkedInLink: linkedInLink }),
	            _react2['default'].createElement(_faqSection2['default'], { link: 'https://faq.hellosign.com/hc/en-us/sections/205421488-Oracle' }),
	            _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'bottom',
	                text: ctaText,
	                linkText: linkText,
	                onClick: handleClick,
	                style: { borderTop: border, fontWeight: 600 } })
	        )
	    );
	}
	
	function IllustrationArea(p) {
	    return _react2['default'].createElement(
	        'div',
	        { className: 'top row', style: { backgroundColor: '#FFD58D' } },
	        _react2['default'].createElement(
	            'div',
	            { className: 'top-content-container large-5 large-push-6 columns' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'hellosign-dropbox' },
	                _react2['default'].createElement('img', { src: _HS_logo_white2['default'], alt: 'HelloSign Logo', className: 'hs-logo' }),
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'plus' },
	                    '+'
	                ),
	                _react2['default'].createElement('img', { src: _oracle_logo2['default'], alt: 'Oracle Logo', className: 'dropbox-logo', width: '130' })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'title' },
	                _react2['default'].createElement(
	                    'h1',
	                    null,
	                    'Request signatures straight from Oracle Documents Cloud'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'subtitle' },
	                _react2['default'].createElement(
	                    'h2',
	                    { style: { fontWeight: 400, fontSize: 16, maxWidth: 600 } },
	                    'Integrate HelloSign with Oracle Documents Cloud to request signatures for your contracts, agreements, and waivers. You can check the signature status in real time, and the signed document is automatically saved in Documents Cloud for easy access.'
	                )
	            ),
	            _react2['default'].createElement(ContactSalesButton, null)
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'clouds-container large-5 large-pull-4 columns', style: { float: 'left' } },
	            _react2['default'].createElement('img', { src: _clouds_oracle2['default'], alt: 'cloud left', style: { marginTop: 60, width: 550 } })
	        ),
	        _react2['default'].createElement('img', { src: _overlay_left2['default'], style: { transform: 'translateY(1px)' }, alt: 'cloud left', className: 'cloud-left' }),
	        _react2['default'].createElement('img', { src: _overlay_right2['default'], style: { transform: 'translateY(1px)' }, alt: 'cloud right', className: 'cloud-right' })
	    );
	}
	
	function ContactSalesButton(p) {
	    return _react2['default'].createElement(_button2['default'], {
	        buttonText: 'Contact sales',
	        buttonColor: 'cerulean',
	        buttonBorderColor: 'cerulean',
	        buttonHoverColor: 'white',
	        buttonHoverTextColor: 'cerulean',
	        onClick: handleClick });
	}
	
	function handleClick(e) {
	    e.preventDefault();
	
	    // Click handler to launch contact sales modal
	    var attachPoint = _hfReactHelper2['default'].getRevealAttachPoint('contact_sales_modal');
	    var node = _reactDom2['default'].render(_react2['default'].createElement(_marketoForm2['default'], { formId: 1249, trackingId: 'oracle-contact' }), attachPoint);
	    $(document).foundation();
	    $(_reactDom2['default'].findDOMNode(node)).closest('.reveal-modal').foundation('reveal', 'open');
	}
	
	function HowItWorks(p) {
	    var paragraphStyle = {
	        marginLeft: 20
	    };
	    var videoProps = {
	        src: 'https://www.youtube.com/embed/1Z6KHuKTQd4',
	        frameBorder: 0,
	        style: {
	            width: '100%',
	            maxWidth: 800,
	            height: 430
	        }
	    };
	    // For linter
	    var approvalText = 'In the menu, click "More" and choose "Gather approval signatures." This will launch HelloSign, allowing you to quickly prepare your document for signature.';
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'seo-cloud-integrations__how-it-works' },
	        _react2['default'].createElement(
	            'h2',
	            null,
	            'How it Works'
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'row' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'screenshot-explanation large-4 large-push-8 columns' },
	                _react2['default'].createElement(
	                    'p',
	                    { style: paragraphStyle },
	                    'To get started, select the document you\'d like signed from your documents list in Oracle Documents Cloud.'
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    { style: paragraphStyle },
	                    approvalText
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    { style: paragraphStyle },
	                    'After you send your document for signature, retrieve the signed document by clicking \u201CGet Signed File\u201D in the menu. Your document will automatically be added into your Documents Cloud account.'
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    { style: paragraphStyle, onClick: handleClick },
	                    _react2['default'].createElement(
	                        'span',
	                        { style: { color: '#00B3E6', cursor: 'pointer', fontWeight: 400 } },
	                        'Contact sales to get started.'
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'dropbox-screenshot large-8 large-pull-4 columns' },
	                _react2['default'].createElement('iframe', videoProps)
	            )
	        )
	    );
	}
	
	module.exports = Oracle;

/***/ },
/* 1621 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1622 */,
/* 1623 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/505d3b55f8d090318ae02ba72d3795c4.svg";

/***/ },
/* 1624 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/a46ce7d562532cb0e41897207a5ec11c.svg";

/***/ },
/* 1625 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/7e65701d8dd1d1a95083fb142ab4b56f.svg";

/***/ },
/* 1626 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/cf56ebb4b6b1282b3eda49fd01181103.svg";

/***/ },
/* 1627 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/a6edfaa77d7ca18c123000c270a37dfd.svg";

/***/ },
/* 1628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1629);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _clouds_real_estate = __webpack_require__(1631);
	
	var _clouds_real_estate2 = _interopRequireDefault(_clouds_real_estate);
	
	var _teams_icon = __webpack_require__(1632);
	
	var _teams_icon2 = _interopRequireDefault(_teams_icon);
	
	var _audit_trail_icon = __webpack_require__(1633);
	
	var _audit_trail_icon2 = _interopRequireDefault(_audit_trail_icon);
	
	var _templates_icon = __webpack_require__(1634);
	
	var _templates_icon2 = _interopRequireDefault(_templates_icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function RealEstate(p) {
	    return _react2['default'].createElement(
	        'div',
	        { className: 'seo-cloud-integrations real-estate' },
	        _react2['default'].createElement(TopArea, p),
	        _react2['default'].createElement(
	            'div',
	            { className: 'seo-cloud-integrations__main', style: { backgroundColor: 'white' } },
	            _react2['default'].createElement(PricingPlansCTA, { position: 'top' }),
	            _react2['default'].createElement(Benefits, null),
	            _react2['default'].createElement(HowItWorks, null),
	            _react2['default'].createElement(Testimonial, null),
	            _react2['default'].createElement(FAQ, null),
	            _react2['default'].createElement(PricingPlansCTA, { position: 'bottom' })
	        )
	    );
	}
	
	function TopArea(p) {
	    return _react2['default'].createElement(
	        'div',
	        { className: 'top row' },
	        _react2['default'].createElement(
	            'div',
	            { className: 'top-content-container large-5 large-push-6 columns' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'title' },
	                _react2['default'].createElement(
	                    'h1',
	                    null,
	                    'HelloSign helps Agents & Brokers close deals'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'subtitle' },
	                _react2['default'].createElement(
	                    'h2',
	                    { style: { fontWeight: 400, fontSize: 16, maxWidth: 600 } },
	                    'Real estate agents and brokers love HelloSign because it\u2019s simple to use and helps get offer letters, counter offers, and listing agreements signed. There are enough headaches getting contracts signed, so our easy-to-use interface lets you track the status of your documents out for signature and notifies you once it\u2019s been signed. HelloSign\u2019s legally binding signatures have an average turnaround time of 44 minutes, so you can close deals faster.'
	                )
	            ),
	            _react2['default'].createElement(SignUpButton, p)
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'clouds-container large-5 large-pull-4 columns', style: { float: 'left' } },
	            _react2['default'].createElement('img', { src: _clouds_real_estate2['default'], alt: 'cloud left', style: { marginTop: 60, width: 550 } })
	        )
	    );
	}
	
	function SignUpButton(p) {
	    return _react2['default'].createElement(_button2['default'], {
	        buttonText: 'Get started',
	        buttonColor: 'cerulean',
	        buttonBorderColor: 'cerulean',
	        buttonHoverColor: 'white',
	        buttonHoverTextColor: 'cerulean',
	        buttonLink: p.signUpUrl
	    });
	}
	
	function PricingPlansCTA(p) {
	    var position = p.position;
	    var border = '2px solid #D7D7D7';
	    var style = {
	        borderTop: border,
	        padding: '10px 0'
	    };
	    if (position === 'top') {
	        style['borderBottom'] = border;
	    }
	    return _react2['default'].createElement(
	        'div',
	        { style: style },
	        _react2['default'].createElement(
	            'p',
	            { style: { fontWeight: 600, lineSpacing: 0 } },
	            'Free accounts include three documents a month. Upgrade for unlimited documents and more features. ',
	            _react2['default'].createElement(
	                'a',
	                { href: '/info/pricing', target: '_blank', rel: 'noopener noreferrer',
	                    style: { fontWeight: 500 } },
	                'See Our Plans'
	            ),
	            '.'
	        )
	    );
	}
	
	function Benefits(p) {
	    return _react2['default'].createElement(
	        'div',
	        { className: 'seo-cloud-integrations__benefits' },
	        _react2['default'].createElement(
	            'h2',
	            null,
	            'Benefits'
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'row' },
	            _react2['default'].createElement(
	                'section',
	                { className: 'large-4 columns' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'benefits-image-container' },
	                    _react2['default'].createElement('img', { src: _teams_icon2['default'], alt: 'teams icon' })
	                ),
	                _react2['default'].createElement(
	                    'h3',
	                    null,
	                    'Add your whole office'
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    'Admins can share templates, track the status of team members\u2019 open documents, and configure team settings and custom branding.'
	                )
	            ),
	            _react2['default'].createElement(
	                'section',
	                { className: 'large-4 columns' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'benefits-image-container' },
	                    _react2['default'].createElement('img', { src: _audit_trail_icon2['default'], alt: 'audit trail icon' })
	                ),
	                _react2['default'].createElement(
	                    'h3',
	                    null,
	                    'Track signatures at every stage'
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    'Stay up-to-date with notifications when your documents are viewed and signed. These activities are also logged in the document\u2019s legally binding audit trail.'
	                )
	            ),
	            _react2['default'].createElement(
	                'section',
	                { className: 'large-4 columns end' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'benefits-image-container' },
	                    _react2['default'].createElement('img', { src: _templates_icon2['default'], alt: 'templates icon' })
	                ),
	                _react2['default'].createElement(
	                    'h3',
	                    null,
	                    'Templates for frequently used documents'
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    'Auto-populate high volume documents with information using our templates and merge fields. Create the document once, reuse again and again.'
	                )
	            )
	        )
	    );
	}
	
	function HowItWorks(p) {
	    var videoProps = {
	        src: 'https://www.youtube.com/embed/sYpuROHdPbQ',
	        frameBorder: 0,
	        style: {
	            width: '100%',
	            maxWidth: 800,
	            height: 430
	        }
	    };
	    var paragraphStyle = {
	        marginLeft: 20
	    };
	    return _react2['default'].createElement(
	        'div',
	        { className: 'seo-cloud-integrations__how-it-works' },
	        _react2['default'].createElement(
	            'h2',
	            null,
	            'How it Works'
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'row' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'screenshot-explanation large-4 large-push-8 columns' },
	                _react2['default'].createElement(
	                    'p',
	                    { style: paragraphStyle },
	                    'It\u2019s easy to send a document with HelloSign. To get started, figure out who has to sign your document: just you, just other people, or both you and others.'
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    { style: paragraphStyle },
	                    'You can upload the document from your hard drive, use a saved template, or bring in a document from one of your cloud storage accounts. Then, drag and drop the fields you want in the document.'
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    { style: paragraphStyle },
	                    'When the document is prepared, add your signers, set the order for signatures, and send! HelloSign\u2019s responsive design helps get the signatures you need on phones, tablets, or desktops.'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'dropbox-screenshot large-8 large-pull-4 columns' },
	                _react2['default'].createElement('iframe', videoProps)
	            )
	        )
	    );
	}
	
	function Testimonial(p) {
	    return _react2['default'].createElement(
	        'div',
	        { className: 'seo-cloud-integrations__testimonial', style: { marginBottom: 70 } },
	        _react2['default'].createElement(
	            'p',
	            { style: { fontSize: 14, fontWeight: 600 } },
	            _react2['default'].createElement(
	                'span',
	                { style: { fontSize: 22, fontWeight: 300 } },
	                '"Every one of our agents has a HelloSign Account."'
	            ),
	            '\xA0\xA0TOM TOGNOLI, Founder & CEO Intero Real Estate Services'
	        )
	    );
	}
	
	function FAQ(p) {
	    var button = _react2['default'].createElement(_button2['default'], {
	        buttonText: 'Visit our FAQ',
	        buttonColor: 'cerulean',
	        buttonBorderColor: 'cerulean',
	        buttonHoverColor: 'white',
	        buttonHoverTextColor: 'cerulean',
	        buttonLink: 'https://faq.hellosign.com/hc/en-us/categories/200353538-HelloSign',
	        openInNewWindow: true });
	    return _react2['default'].createElement(
	        'div',
	        { className: 'seo-cloud-integrations__faq' },
	        _react2['default'].createElement(
	            'p',
	            null,
	            'Questions about this integration? We have answers.'
	        ),
	        button
	    );
	}
	
	module.exports = RealEstate;

/***/ },
/* 1629 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1630 */,
/* 1631 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/08e15bf6e740503f849ab7211ac7aede.svg";

/***/ },
/* 1632 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/8109ddc4f09423cea9324e227333a4eb.svg";

/***/ },
/* 1633 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/c891b1f24e7bbfec1a4685ecd3c99b2f.svg";

/***/ },
/* 1634 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/09205cbdbed7581b426febb894c91fb2.svg";

/***/ },
/* 1635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createAccountTrigger = __webpack_require__(883);
	
	var _createAccountTrigger2 = _interopRequireDefault(_createAccountTrigger);
	
	var _HS_logo_white = __webpack_require__(1233);
	
	var _HS_logo_white2 = _interopRequireDefault(_HS_logo_white);
	
	var _slack_logo = __webpack_require__(1636);
	
	var _slack_logo2 = _interopRequireDefault(_slack_logo);
	
	var _clouds_slack = __webpack_require__(1637);
	
	var _clouds_slack2 = _interopRequireDefault(_clouds_slack);
	
	var _overlay_left = __webpack_require__(1269);
	
	var _overlay_left2 = _interopRequireDefault(_overlay_left);
	
	var _overlay_right = __webpack_require__(1270);
	
	var _overlay_right2 = _interopRequireDefault(_overlay_right);
	
	var _notifications_icon = __webpack_require__(1626);
	
	var _notifications_icon2 = _interopRequireDefault(_notifications_icon);
	
	var _daily_reminder_icon = __webpack_require__(1638);
	
	var _daily_reminder_icon2 = _interopRequireDefault(_daily_reminder_icon);
	
	var _megaphone_icon = __webpack_require__(1639);
	
	var _megaphone_icon2 = _interopRequireDefault(_megaphone_icon);
	
	var _screenshot_slack = __webpack_require__(1640);
	
	var _screenshot_slack2 = _interopRequireDefault(_screenshot_slack);
	
	var _socialSection = __webpack_require__(1242);
	
	var _socialSection2 = _interopRequireDefault(_socialSection);
	
	var _faqSection = __webpack_require__(1247);
	
	var _faqSection2 = _interopRequireDefault(_faqSection);
	
	var _benefitsSection = __webpack_require__(1248);
	
	var _benefitsSection2 = _interopRequireDefault(_benefitsSection);
	
	var _pricingCtaSection = __webpack_require__(1250);
	
	var _pricingCtaSection2 = _interopRequireDefault(_pricingCtaSection);
	
	var _ctaButton = __webpack_require__(1531);
	
	var _ctaButton2 = _interopRequireDefault(_ctaButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function Slack(p) {
	    // Slack constants
	    var benefits = [{
	        icon: _notifications_icon2['default'],
	        title: 'Real time notifications in your channels',
	        text: 'Get updated in real time when your documents and contracts are signed, all within your designated Slack channel.'
	    }, {
	        icon: _daily_reminder_icon2['default'],
	        title: 'Daily reminders for unsigned docs',
	        text: 'Be reminded of which customers currently have outstanding signature requests. Your team will always know when to follow up.'
	    }, {
	        icon: _megaphone_icon2['default'],
	        title: 'Celebrate your wins',
	        text: 'Pin fun reactions to HelloSign updates and celebrate as soon as that important deal closes!'
	    }];
	    var twitterLink = 'https://twitter.com/intent/tweet?original_referer=https%3A%2F%2Fwww.hellosign.com%2Fslack&ref_src=twsrc%5Etfw&text=Did%20you%20know%20%40HelloSign%20now%20integrates%20with%20Slack%3F%20Get%20updates%20on%20your%20docs%20posted%20right%20to%20your%20favorite%20channel.&tw_p=tweetbutton&url=http%3A%2F%2Fwww.hellosign.com%2Fslack%3Futm_source%3Dtwitter%26utm_medium%3Ds2s';
	    var facebookLink = 'https://www.facebook.com/sharer/sharer.php?u=https%3A//www.hellosign.com/slack?utm_source=facebook%26utm_medium=s2s';
	    var linkedInLink = 'https://www.linkedin.com/cws/share?url=http%3A%2F%2Fwww.hellosign.com%2Fslack%3Futm_source%3Dlinkedin%26utm_medium%3Ds2s&original_referer=https%3A%2F%2Fwww.hellosign.com%2Fslack&token=&isFramed=false&lang=en_US&_ts=1467407448802.2288&xd_origin_host=https%3A%2F%2Fwww.hellosign.com';
	    var border = '2px solid #D7D7D7';
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'seo-cloud-integrations' },
	        _react2['default'].createElement(IllustrationArea, p),
	        _react2['default'].createElement(
	            'div',
	            { className: 'seo-cloud-integrations__main', style: { backgroundColor: 'white' } },
	            _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'top', style: { borderBottom: border, backgroundColor: '#F7F8F9', fontWeight: 600 } }),
	            _react2['default'].createElement(_benefitsSection2['default'], { benefits: benefits }),
	            _react2['default'].createElement(HowItWorks, p),
	            _react2['default'].createElement(_socialSection2['default'], {
	                title: 'Share with your networks!',
	                twitterLink: twitterLink,
	                facebookLink: facebookLink,
	                linkedInLink: linkedInLink }),
	            _react2['default'].createElement(_faqSection2['default'], { link: 'https://faq.hellosign.com/hc/en-us/sections/201427097-Slack' }),
	            _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'bottom', style: { borderTop: border, fontWeight: 600 } })
	        )
	    );
	}
	
	function CTALink(p) {
	    var linkURL = '/home/myAccount#integrations';
	
	    // Return standard link if user is already logged in
	    if (p.isUserLoggedIn) {
	        return _react2['default'].createElement(
	            'a',
	            { href: linkURL },
	            p.linkText
	        );
	    }
	
	    // Otherwise, create a trigger so we can display the signup modal
	    var trigger = _react2['default'].createElement(
	        'a',
	        null,
	        p.linkText
	    );
	    return _react2['default'].createElement(_createAccountTrigger2['default'], _extends({}, p, {
	        trigger: trigger,
	        redirectUrl: linkURL,
	        homeUrl: linkURL,
	        googleOpenIdUrl: p.googleOpenIdLocationUrl,
	        header: 'Get Started' }));
	}
	
	function HowItWorks(p) {
	    var loginTrigger = _react2['default'].createElement(CTALink, _extends({}, p, { linkText: 'add HelloSign to Slack' }));
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'seo-cloud-integrations__how-it-works' },
	        _react2['default'].createElement(
	            'h2',
	            null,
	            'How it Works'
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'row' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'screenshot-explanation large-3 large-push-9 columns' },
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    'When you ',
	                    loginTrigger,
	                    ', all you need to do is connect your accounts and choose if you want to send your notifications to one of your channels, as a direct message to a team member, or to Slackbot.'
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    'You\u2019ll get notifications when someone views and signs a document and when the document has been signed by everyone. Just click the document name to preview the document and check its progress.'
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    'All of the documents you send through the extension will show up in the documents view on HelloSign.com.'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'dropbox-screenshot large-9 large-pull-3 columns' },
	                _react2['default'].createElement('img', { src: _screenshot_slack2['default'] })
	            )
	        )
	    );
	}
	
	function IllustrationArea(p) {
	    return _react2['default'].createElement(
	        'div',
	        { className: 'top row', style: { backgroundColor: '#AEDEDA' } },
	        _react2['default'].createElement(
	            'div',
	            { className: 'top-content-container large-5 large-push-6 columns' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'hellosign-dropbox' },
	                _react2['default'].createElement('img', { src: _HS_logo_white2['default'], alt: 'HelloSign Logo', className: 'hs-logo' }),
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'plus' },
	                    '+'
	                ),
	                _react2['default'].createElement('img', { src: _slack_logo2['default'], alt: 'Slack Logo', className: 'dropbox-logo', style: { width: 120 } })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'title' },
	                _react2['default'].createElement(
	                    'h1',
	                    null,
	                    'Get HelloSign Updates in Your Slack Channels'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'subtitle' },
	                _react2['default'].createElement(
	                    'h2',
	                    null,
	                    'Keep your teams & channels in the know on the status of your eSigned documents with the "Add to Slack" button integration. It\'s free to sign up!'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'signup-button' },
	                _react2['default'].createElement(_ctaButton2['default'], _extends({}, p, { buttonText: 'Try it free' }))
	            )
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'clouds-container large-5 large-pull-4 columns' },
	            _react2['default'].createElement('img', { src: _clouds_slack2['default'], alt: 'cloud left' })
	        ),
	        _react2['default'].createElement('img', { src: _overlay_left2['default'], style: { transform: 'translateY(1px)' }, alt: 'cloud left', className: 'cloud-left' }),
	        _react2['default'].createElement('img', { src: _overlay_right2['default'], style: { transform: 'translateY(1px)' }, alt: 'cloud right', className: 'cloud-right' })
	    );
	}
	
	module.exports = Slack;

/***/ },
/* 1636 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/7e079521f59191633b3f7f14fc7ca4a3.svg";

/***/ },
/* 1637 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/3b0f51289531cf5d3dc658dc3d01f88f.svg";

/***/ },
/* 1638 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/6781d7252d5ab7b7310eecf11baf10fa.svg";

/***/ },
/* 1639 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/298c748e39de28782795f4002325a638.svg";

/***/ },
/* 1640 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/fc36941276743be56601ff12b737bde7.gif";

/***/ },
/* 1641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(696);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _icon_check2x = __webpack_require__(1642);
	
	var _icon_check2x2 = _interopRequireDefault(_icon_check2x);
	
	var _HS_logo_white = __webpack_require__(1233);
	
	var _HS_logo_white2 = _interopRequireDefault(_HS_logo_white);
	
	var _gmail_logo = __webpack_require__(1643);
	
	var _gmail_logo2 = _interopRequireDefault(_gmail_logo);
	
	var _clouds_gmail = __webpack_require__(1644);
	
	var _clouds_gmail2 = _interopRequireDefault(_clouds_gmail);
	
	var _overlay_left = __webpack_require__(1269);
	
	var _overlay_left2 = _interopRequireDefault(_overlay_left);
	
	var _overlay_right = __webpack_require__(1270);
	
	var _overlay_right2 = _interopRequireDefault(_overlay_right);
	
	var _signature_icon = __webpack_require__(1239);
	
	var _signature_icon2 = _interopRequireDefault(_signature_icon);
	
	var _clock_icon = __webpack_require__(1625);
	
	var _clock_icon2 = _interopRequireDefault(_clock_icon);
	
	var _security_icon = __webpack_require__(1645);
	
	var _security_icon2 = _interopRequireDefault(_security_icon);
	
	var _screenshot_gmail = __webpack_require__(1646);
	
	var _screenshot_gmail2 = _interopRequireDefault(_screenshot_gmail);
	
	var _socialSection = __webpack_require__(1242);
	
	var _socialSection2 = _interopRequireDefault(_socialSection);
	
	var _faqSection = __webpack_require__(1247);
	
	var _faqSection2 = _interopRequireDefault(_faqSection);
	
	var _howItWorksSection = __webpack_require__(1249);
	
	var _howItWorksSection2 = _interopRequireDefault(_howItWorksSection);
	
	var _benefitsSection = __webpack_require__(1248);
	
	var _benefitsSection2 = _interopRequireDefault(_benefitsSection);
	
	var _pricingCtaSection = __webpack_require__(1250);
	
	var _pricingCtaSection2 = _interopRequireDefault(_pricingCtaSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function Gmail(p) {
	    // Gmail constants
	    var benefits = [{
	        icon: _signature_icon2['default'],
	        title: 'Stay focused on tasks',
	        text: 'Forget downloading and then uploading to another site—now you never need to even leave Gmail to sign a document.'
	    }, {
	        icon: _clock_icon2['default'],
	        title: 'Sign documents faster',
	        text: 'It takes less than 30 seconds to sign a contract, so you\'ll be able to get through your inbox faster.'
	    }, {
	        icon: _security_icon2['default'],
	        title: 'Secure your legal documents',
	        text: 'All signed documents are legally binding and automatically backed up in your HelloSign account.'
	    }];
	    var howItWorks = ['Once you install the HelloSign for Gmail chrome browser extension, documents you receive as attachments in Gmail will have a “Sign” button.', 'Click the “Sign” button to load the HelloSign signature window, sign, and send. You can also choose to download the signed document.', 'All of the documents you send through the extension will show up in the documents view on HelloSign.com.'];
	    var twitterLink = 'https://twitter.com/intent/tweet?original_referer=https%3A%2F%2Fwww.hellosign.com%2Fgmail&ref_src=twsrc%5Etfw&text=Did%20you%20know%20%40HelloSign%20integrates%20with%20%40Gmail%3F%20Sign%20documents%20directly%20in%20your%20Gmail%20inbox.&tw_p=tweetbutton&url=http%3A%2F%2Fwww.hellosign.com%2Fgmail%26utm_medium%3Ds2s%26utm_source%3Dtwitter';
	    var facebookLink = 'https://www.facebook.com/sharer/sharer.php?u=https%3A//www.hellosign.com/gmail?utm_source=facebook%26utm_medium=s2s';
	    var linkedInLink = 'https://www.linkedin.com/cws/share?url=https%3A%2F%2Fwww.hellosign.com%2Fgmail%3Futm_medium%3Ds2s%26utm_source%3Dlinkedin&original_referer=https%3A%2F%2Fwww.hellosign.com%2Fgmail&token=&isFramed=false&lang=en_US&_ts=1462214138386.6147&xd_origin_host=https%3A%2F%2Fwww.hellosign.com';
	    var border = '2px solid #D7D7D7';
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'seo-cloud-integrations' },
	        _react2['default'].createElement(GmailInstalledArea, null),
	        _react2['default'].createElement(IllustrationArea, p),
	        _react2['default'].createElement(
	            'div',
	            { className: 'seo-cloud-integrations__main', style: { backgroundColor: 'white' } },
	            _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'top', style: { borderBottom: border, backgroundColor: '#F7F8F9', fontWeight: 600 } }),
	            _react2['default'].createElement(_benefitsSection2['default'], { benefits: benefits }),
	            _react2['default'].createElement(_howItWorksSection2['default'], {
	                image: _screenshot_gmail2['default'],
	                explanation: howItWorks }),
	            _react2['default'].createElement(Quote, null),
	            _react2['default'].createElement(_socialSection2['default'], {
	                title: 'Share with your networks!',
	                twitterLink: twitterLink,
	                facebookLink: facebookLink,
	                linkedInLink: linkedInLink }),
	            _react2['default'].createElement(_faqSection2['default'], { link: 'https://faq.hellosign.com/hc/en-us/sections/200977977' }),
	            _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'bottom', style: { borderTop: border, fontWeight: 600 } })
	        )
	    );
	}
	
	function GmailInstalledArea(p) {
	    return _react2['default'].createElement(
	        'div',
	        { className: 'l-padding-t-80 l-padding-b-80 gmail-not-installed bg-deep-blue text-center' },
	        _react2['default'].createElement('img', { src: _icon_check2x2['default'], width: '51', className: 'l-padding-b-20' }),
	        _react2['default'].createElement(
	            'h3',
	            { style: { color: 'white' } },
	            'Installed! Log in to Gmail to start signing documents.'
	        ),
	        _react2['default'].createElement(_button2['default'], {
	            buttonTextColor: 'cerulean',
	            buttonLink: 'https://www.gmail.com',
	            buttonText: 'Go to Gmail now',
	            buttonHoverTextColor: 'white',
	            buttonColor: 'white' })
	    );
	}
	
	function handleClick(e) {
	    e.preventDefault();
	    var config = window.config;
	    var ua = navigator.userAgent.toLowerCase();
	    if (/safari/.test(ua) && !/chrome/.test(ua)) {
	        window.open(config.open_id_safari, '_blank', 'width=640, height=480');
	    } else if (/firefox/.test(ua)) {
	        window.open(config.open_id_firefox, '_blank', 'width=640, height=480');
	    } else {
	        chrome.webstore.install(config.chrome_store, function (e) {
	            location.reload();
	        }, function (e) {
	            console.log(e);
	        });
	    }
	}
	
	function IllustrationArea(p) {
	    return _react2['default'].createElement(
	        'div',
	        { className: 'top row', style: { backgroundColor: '#FAB697' } },
	        _react2['default'].createElement(
	            'div',
	            { className: 'top-content-container large-5 large-push-6 columns' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'hellosign-dropbox' },
	                _react2['default'].createElement('img', { src: _HS_logo_white2['default'], alt: 'HelloSign Logo', className: 'hs-logo' }),
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'plus' },
	                    '+'
	                ),
	                _react2['default'].createElement('img', { src: _gmail_logo2['default'], alt: 'Dropbox Logo', className: 'dropbox-logo', style: { width: 120, marginLeft: 28 } })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'title' },
	                _react2['default'].createElement(
	                    'h1',
	                    null,
	                    'Sign documents in Gmail'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'subtitle' },
	                _react2['default'].createElement(
	                    'h2',
	                    null,
	                    'Fill out and sign documents in less than 30 seconds without ever leaving Gmail. Our easy-to-use Chrome browser extension lets you sign attachments right from your inbox. Never print, sign, and scan again!'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'signup-button' },
	                _react2['default'].createElement(_button2['default'], {
	                    buttonText: 'Try it free',
	                    onClick: handleClick,
	                    buttonColor: 'cerulean',
	                    buttonTextColor: 'white',
	                    buttonClass: 'gmail-not-installed',
	                    buttonId: 'try-it-free-link' })
	            )
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'clouds-container large-5 large-pull-4 columns' },
	            _react2['default'].createElement('img', { src: _clouds_gmail2['default'], alt: 'cloud left' })
	        ),
	        _react2['default'].createElement('img', { src: _overlay_left2['default'], style: { transform: 'translateY(1px)' }, alt: 'cloud left', className: 'cloud-left' }),
	        _react2['default'].createElement('img', { src: _overlay_right2['default'], style: { transform: 'translateY(1px)' }, alt: 'cloud right', className: 'cloud-right' })
	    );
	}
	
	function Quote(p) {
	    return _react2['default'].createElement(
	        'div',
	        { className: 'seo-cloud-integrations__quote-container' },
	        _react2['default'].createElement(
	            'p',
	            { className: 'quote', style: { textAlign: 'center' } },
	            '\'HelloSign for Gmail is awesome!\''
	        ),
	        _react2['default'].createElement(
	            'p',
	            { className: 'quote-name' },
	            'PAUL BUCHHEIT'
	        ),
	        _react2['default'].createElement(
	            'p',
	            { className: 'quote-title' },
	            'Creator of Gmail and investor in HelloSign'
	        )
	    );
	}
	
	module.exports = Gmail;

/***/ },
/* 1642 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/8e61b52322eff6a8750d6716c57893b3.png";

/***/ },
/* 1643 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/b23aa16ea896864ada06f7dec1aa4df8.svg";

/***/ },
/* 1644 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/b940c5d52efce07f8032647abb832662.svg";

/***/ },
/* 1645 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/fcef6ac3874368d084b8bb6b576f7188.svg";

/***/ },
/* 1646 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/99969c0d43972a84c830e25ba0e06eda.png";

/***/ },
/* 1647 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	__webpack_require__(1648);
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HS_logo_white = __webpack_require__(1233);
	
	var _HS_logo_white2 = _interopRequireDefault(_HS_logo_white);
	
	var _googledrive_logo = __webpack_require__(1650);
	
	var _googledrive_logo2 = _interopRequireDefault(_googledrive_logo);
	
	var _clouds_googledrive = __webpack_require__(1651);
	
	var _clouds_googledrive2 = _interopRequireDefault(_clouds_googledrive);
	
	var _overlay_left = __webpack_require__(1269);
	
	var _overlay_left2 = _interopRequireDefault(_overlay_left);
	
	var _overlay_right = __webpack_require__(1270);
	
	var _overlay_right2 = _interopRequireDefault(_overlay_right);
	
	var _signature_icon = __webpack_require__(1239);
	
	var _signature_icon2 = _interopRequireDefault(_signature_icon);
	
	var _document_icon = __webpack_require__(1652);
	
	var _document_icon2 = _interopRequireDefault(_document_icon);
	
	var _security_icon = __webpack_require__(1645);
	
	var _security_icon2 = _interopRequireDefault(_security_icon);
	
	var _screenshot_googledrive = __webpack_require__(1653);
	
	var _screenshot_googledrive2 = _interopRequireDefault(_screenshot_googledrive);
	
	var _socialSection = __webpack_require__(1242);
	
	var _socialSection2 = _interopRequireDefault(_socialSection);
	
	var _faqSection = __webpack_require__(1247);
	
	var _faqSection2 = _interopRequireDefault(_faqSection);
	
	var _howItWorksSection = __webpack_require__(1249);
	
	var _howItWorksSection2 = _interopRequireDefault(_howItWorksSection);
	
	var _benefitsSection = __webpack_require__(1248);
	
	var _benefitsSection2 = _interopRequireDefault(_benefitsSection);
	
	var _pricingCtaSection = __webpack_require__(1250);
	
	var _pricingCtaSection2 = _interopRequireDefault(_pricingCtaSection);
	
	var _ctaButton = __webpack_require__(1531);
	
	var _ctaButton2 = _interopRequireDefault(_ctaButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function GoogleDrive(p) {
	    // Google Drive constants
	    var benefits = [{
	        icon: _signature_icon2['default'],
	        title: 'Sign documents from Google Drive',
	        text: 'Prepare documents for signature in Google Drive with a few easy clicks — just choose whether to sign and download or send a signature request.'
	    }, {
	        icon: _document_icon2['default'],
	        title: 'Access your Google Drive documents',
	        text: 'Once you’ve linked your accounts, you can import documents from Google Drive on HelloSign.com.'
	    }, {
	        icon: _security_icon2['default'],
	        title: 'Save copies of signed documents',
	        text: 'Documents are stored both in Google Drive and in your HelloSign account.'
	    }];
	    var howItWorks = ['Connect your Google Drive and HelloSign accounts to start signing documents from within Google Drive. Then you’ll be able to sign or send any document in your drive folders.', 'On HelloSign.com, you’ll also be able to import documents stored in Google Drive.', 'All of the docs you send through the extension will show up in the documents view on HelloSign.com.'];
	    var twitterLink = 'https://twitter.com/intent/tweet?original_referer=https%3a%2f%2fwww.hellosign.com%2fgoogldrive&ref_src=twsrc%5Etfw&text=Did%20you%20know%20%40HelloSign%20integrates%20with%20%40GoogleDrive%3F%20Sign%20documents%20directly%20from%20Google%20Drive.&tw_p=tweetbutton&url=https%3a%2f%2fwww.hellosign.com%2fgoogledrive%3futm_medium%3Ds2s%26utm_source%3Dtwitter';
	    var facebookLink = 'https://www.facebook.com/sharer/sharer.php?u=https%3A//www.hellosign.com/googledrive?utm_source=facebook%26utm_medium=s2s ';
	    var linkedInLink = 'https://www.linkedin.com/cws/share?url=https%3a%2f%2fwww.hellosign.com%2fgoogledrive%3futm_medium%3Ds2s%26utm_source%3Dlinkedin&original_referer=https%3a%2f%2fwww.hellosign.com%2fgoogledrive&token=&isFramed=false&lang=en_US&_ts=1462214138386.6147&xd_origin_host=https%3A%2F%2Fwww.hellosign.com';
	    var border = '2px solid #D7D7D7';
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'seo-cloud-integrations google-drive' },
	        _react2['default'].createElement(IllustrationArea, p),
	        _react2['default'].createElement(
	            'div',
	            { className: 'seo-cloud-integrations__main', style: { backgroundColor: 'white' } },
	            _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'top', style: { borderBottom: border, backgroundColor: '#F7F8F9', fontWeight: 600 } }),
	            _react2['default'].createElement(_benefitsSection2['default'], { benefits: benefits }),
	            _react2['default'].createElement(_howItWorksSection2['default'], {
	                image: _screenshot_googledrive2['default'],
	                explanation: howItWorks }),
	            _react2['default'].createElement(_socialSection2['default'], {
	                title: 'Share with your networks!',
	                twitterLink: twitterLink,
	                facebookLink: facebookLink,
	                linkedInLink: linkedInLink }),
	            _react2['default'].createElement(_faqSection2['default'], { link: 'https://faq.hellosign.com/hc/en-us/articles/205794528' }),
	            _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'bottom', style: { borderTop: border, fontWeight: 600 } })
	        )
	    );
	}
	
	function IllustrationArea(p) {
	    return _react2['default'].createElement(
	        'div',
	        { className: 'top row', style: { backgroundColor: '#AEDEDA' } },
	        _react2['default'].createElement(
	            'div',
	            { className: 'top-content-container large-5 large-push-6 columns' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'hellosign-dropbox' },
	                _react2['default'].createElement('img', { src: _HS_logo_white2['default'], alt: 'HelloSign Logo', className: 'hs-logo' }),
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'plus' },
	                    '+'
	                ),
	                _react2['default'].createElement('img', { src: _googledrive_logo2['default'], alt: 'GoogleDrive Logo', className: 'dropbox-logo' })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'title' },
	                _react2['default'].createElement(
	                    'h1',
	                    null,
	                    'Sign and send directly from Google Drive'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'subtitle' },
	                _react2['default'].createElement(
	                    'h2',
	                    null,
	                    'It\u2019s easy to add legally binding eSignatures to documents that are stored in your Google Drive with the HelloSign integration. You can sign and download a document or add fields for others to fill out and sign from within Google Drive.'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'signup-button' },
	                _react2['default'].createElement(_ctaButton2['default'], _extends({}, p, {
	                    buttonText: 'Try it free' }))
	            )
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'clouds-container large-5 large-pull-4 columns' },
	            _react2['default'].createElement('img', { src: _clouds_googledrive2['default'], alt: 'cloud left' })
	        ),
	        _react2['default'].createElement('img', { src: _overlay_left2['default'], style: { transform: 'translateY(1px)' }, alt: 'cloud left', className: 'cloud-left' }),
	        _react2['default'].createElement('img', { src: _overlay_right2['default'], style: { transform: 'translateY(1px)' }, alt: 'cloud right', className: 'cloud-right' })
	    );
	}
	
	module.exports = GoogleDrive;

/***/ },
/* 1648 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1649 */,
/* 1650 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/67fb7728345b56f0b539df8179f1381d.svg";

/***/ },
/* 1651 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/ff316548c03be74b60dff2563a79f13c.svg";

/***/ },
/* 1652 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjggMTI4Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzFhMWExYTt9LmNscy0ye2ZpbGw6bm9uZTtzdHJva2U6IzFhMWExYTtzdHJva2UtbGluZWpvaW46cm91bmQ7c3Ryb2tlLXdpZHRoOjNweDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPl9pY29uPC90aXRsZT48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik05MS4zMjA1NSw0LjM3MjI4bDIwLjQ4ODg5LDIwLjYxNzQzVjEyNEgxNi4xOTA2N1Y0LjM3MjI4SDkxLjMyMDU1bTEuMjQ4MTctM0gxMy4xOTA2N1YxMjdIMTE0LjgwOTQ0VjIzLjc1MjUzTDkyLjU2ODcyLDEuMzcyMjhoMFoiLz48cG9seWxpbmUgY2xhc3M9ImNscy0yIiBwb2ludHM9IjExMy41MjkgMjMuNzA2IDkyLjU2OSAyMy43MDYgOTIuNTY5IDMuMDAyIi8+PGxpbmUgY2xhc3M9ImNscy0yIiB4MT0iMjcuNzA3NTUiIHkxPSIzOC44OTMwNiIgeDI9Ijk5LjE3NTc5IiB5Mj0iMzguODkzMDYiLz48bGluZSBjbGFzcz0iY2xzLTIiIHgxPSIyNy43MDc1NSIgeTE9IjQ5LjczMjIiIHgyPSI5OS4xNzU3OSIgeTI9IjQ5LjczMjIiLz48bGluZSBjbGFzcz0iY2xzLTIiIHgxPSIyNy43MDc1NSIgeTE9IjYwLjU3MTM0IiB4Mj0iODMuNTQyMTEiIHkyPSI2MC41NzEzNCIvPjxsaW5lIGNsYXNzPSJjbHMtMiIgeDE9IjI4LjkwMTc1IiB5MT0iODEuODg3NDIiIHgyPSI0MS4yODUwNiIgeTI9Ijk0LjI3MDczIi8+PGxpbmUgY2xhc3M9ImNscy0yIiB4MT0iNDEuMjg1MDYiIHkxPSI4MS44ODc0MiIgeDI9IjI4LjkwMTc1IiB5Mj0iOTQuMjcwNzMiLz48bGluZSBjbGFzcz0iY2xzLTIiIHgxPSIyNy42NjIxMSIgeTE9IjEwMy42NjExNSIgeDI9Ijk5LjE3NTc5IiB5Mj0iMTAzLjY2MTE1Ii8+PC9zdmc+"

/***/ },
/* 1653 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/513837c03e4c5c550d627ca9e5176bea.png";

/***/ },
/* 1654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(304);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HS_logo_white = __webpack_require__(1233);
	
	var _HS_logo_white2 = _interopRequireDefault(_HS_logo_white);
	
	var _googledocs_logo = __webpack_require__(1655);
	
	var _googledocs_logo2 = _interopRequireDefault(_googledocs_logo);
	
	var _clouds_googledocs = __webpack_require__(1656);
	
	var _clouds_googledocs2 = _interopRequireDefault(_clouds_googledocs);
	
	var _overlay_left = __webpack_require__(1269);
	
	var _overlay_left2 = _interopRequireDefault(_overlay_left);
	
	var _overlay_right = __webpack_require__(1270);
	
	var _overlay_right2 = _interopRequireDefault(_overlay_right);
	
	var _approval_icon = __webpack_require__(1657);
	
	var _approval_icon2 = _interopRequireDefault(_approval_icon);
	
	var _drop_signature_icon = __webpack_require__(1658);
	
	var _drop_signature_icon2 = _interopRequireDefault(_drop_signature_icon);
	
	var _security_icon = __webpack_require__(1645);
	
	var _security_icon2 = _interopRequireDefault(_security_icon);
	
	var _screenshot_googledocs = __webpack_require__(1659);
	
	var _screenshot_googledocs2 = _interopRequireDefault(_screenshot_googledocs);
	
	var _socialSection = __webpack_require__(1242);
	
	var _socialSection2 = _interopRequireDefault(_socialSection);
	
	var _faqSection = __webpack_require__(1247);
	
	var _faqSection2 = _interopRequireDefault(_faqSection);
	
	var _benefitsSection = __webpack_require__(1248);
	
	var _benefitsSection2 = _interopRequireDefault(_benefitsSection);
	
	var _pricingCtaSection = __webpack_require__(1250);
	
	var _pricingCtaSection2 = _interopRequireDefault(_pricingCtaSection);
	
	var _ctaButton = __webpack_require__(1531);
	
	var _ctaButton2 = _interopRequireDefault(_ctaButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function GoogleDocs(p) {
	    // Google Docs constants
	    var benefits = [{
	        icon: _approval_icon2['default'],
	        title: 'Simplify signing',
	        text: 'Remove extra steps from the document lifecycle by writing, editing, sending a document for signature, and signing it in Google Docs.'
	    }, {
	        icon: _drop_signature_icon2['default'],
	        title: 'Click and insert your signature',
	        text: 'Before you send or download your document, just click to insert your signature wherever it needs to be.'
	    }, {
	        icon: _security_icon2['default'],
	        title: 'HelloSign docs are safe and secure',
	        text: 'All signed documents are legally binding and automatically backed up in your HelloSign account.'
	    }];
	    var howItWorks = ['Connect your Google Drive and HelloSign accounts to start signing documents from within Google Drive. Then you’ll be able to sign or send any document in your drive folders.', 'On HelloSign.com, you’ll also be able to import documents stored in Google Drive.', 'All of the docs you send through the extension will show up in the documents view on HelloSign.com.'];
	    var twitterLink = 'https://twitter.com/intent/tweet?original_referer=https%3a%2f%2fwww.hellosign.com%2fgoogle-docs-add-on&ref_src=twsrc%5Etfw&text=Did%20you%20know%20%40HelloSign%20integrates%20with%20%40GoogleDocs%3F%20Sign%20documents%20directly%20from%20Google%20Docs.&tw_p=tweetbutton&url=https%3a%2f%2fwww.hellosign.com%2fgoogle-docs-add-on%3futm_medium%3Ds2s%26utm_source%3Dtwitter';
	    var facebookLink = 'https://www.facebook.com/sharer/sharer.php?u=https%3A//www.hellosign.com/google-docs-add-on?utm_source=facebook%26utm_medium=s2s';
	    var linkedInLink = 'https://www.linkedin.com/cws/share?url=https%3a%2f%2fwww.hellosign.com%2fgoogle-docs-add-on%3futm_medium%3Ds2s%26utm_source%3Dlinkedin&original_referer=https%3a%2f%2fwww.hellosign.com%2fgoogle-docs-add-on&token=&isFramed=false&lang=en_US&_ts=1462214138386.6147&xd_origin_host=https%3A%2F%2Fwww.hellosign.com';
	    var border = '2px solid #D7D7D7';
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'seo-cloud-integrations' },
	        _react2['default'].createElement(IllustrationArea, p),
	        _react2['default'].createElement(
	            'div',
	            { className: 'seo-cloud-integrations__main', style: { backgroundColor: 'white' } },
	            _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'top', style: { borderBottom: border, backgroundColor: '#F7F8F9', fontWeight: 600 } }),
	            _react2['default'].createElement(_benefitsSection2['default'], { benefits: benefits }),
	            _react2['default'].createElement(HowItWorks, {
	                image: _screenshot_googledocs2['default'],
	                explanation: howItWorks }),
	            _react2['default'].createElement(_socialSection2['default'], {
	                title: 'Share with your networks!',
	                twitterLink: twitterLink,
	                facebookLink: facebookLink,
	                linkedInLink: linkedInLink }),
	            _react2['default'].createElement(_faqSection2['default'], { link: 'https://faq.hellosign.com/hc/en-us/articles/205794398-HelloSign-For-Google-Docs-Add-on' }),
	            _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'bottom', style: { borderTop: border, fontWeight: 600 } })
	        )
	    );
	}
	
	function HowItWorks(p) {
	    var linkURL = 'https://www.hellosign.com/info/googleDocsInstall';
	    var link = _react2['default'].createElement(
	        'a',
	        { href: linkURL, target: '_blank', rel: 'noopener noreferrer' },
	        'Add the free HelloSign add-on'
	    );
	
	    return _react2['default'].createElement(
	        'div',
	        { className: 'seo-cloud-integrations__how-it-works' },
	        _react2['default'].createElement(
	            'h2',
	            null,
	            'How it Works'
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'row' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'screenshot-explanation large-3 large-push-9 columns' },
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    link,
	                    ' for Google Docs to start signing directly inside Google Docs. From the HelloSign sidebar, you\u2019ll be able to sign documents or send them for signature.'
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    'To sign a document, draw a new signature or insert any previously saved signatures. Then email it as a legally binding PDF.'
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    'If someone else needs to sign your Google Doc, this extension automatically imports your document into HelloSign to add recipients and signature fields.'
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    'All of the docs you send through the extension will show up in the documents view on HelloSign.com.'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'dropbox-screenshot large-9 large-pull-3 columns' },
	                _react2['default'].createElement('img', { src: _screenshot_googledocs2['default'], alt: 'google drive screenshot' })
	            )
	        )
	    );
	}
	
	function IllustrationArea(p) {
	    return _react2['default'].createElement(
	        'div',
	        { className: 'top row', style: { backgroundColor: '#B1DCF5' } },
	        _react2['default'].createElement(
	            'div',
	            { className: 'top-content-container large-5 large-push-6 columns' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'hellosign-dropbox' },
	                _react2['default'].createElement('img', { src: _HS_logo_white2['default'], alt: 'HelloSign Logo', className: 'hs-logo' }),
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'plus' },
	                    '+'
	                ),
	                _react2['default'].createElement('img', { src: _googledocs_logo2['default'], alt: 'GoogleDocs Logo', className: 'dropbox-logo' })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'title' },
	                _react2['default'].createElement(
	                    'h1',
	                    null,
	                    'Sign and send Google Docs in seconds'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'subtitle' },
	                _react2['default'].createElement(
	                    'h2',
	                    null,
	                    'Add your signature to a Google Doc or add fields for others to fill out and sign. Now you can write, invite others to comment and redline, and send a document for signature entirely from within Google Docs \u2014 there\u2019s no need to export and upload.'
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'signup-button' },
	                _react2['default'].createElement(_ctaButton2['default'], _extends({}, p, {
	                    buttonText: 'Try it free' }))
	            )
	        ),
	        _react2['default'].createElement(
	            'div',
	            { className: 'clouds-container large-5 large-pull-4 columns' },
	            _react2['default'].createElement('img', { src: _clouds_googledocs2['default'], alt: 'cloud left' })
	        ),
	        _react2['default'].createElement('img', { src: _overlay_left2['default'], style: { transform: 'translateY(1px)' }, alt: 'cloud left', className: 'cloud-left' }),
	        _react2['default'].createElement('img', { src: _overlay_right2['default'], style: { transform: 'translateY(1px)' }, alt: 'cloud right', className: 'cloud-right' })
	    );
	}
	
	module.exports = GoogleDocs;

/***/ },
/* 1655 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/3de25a8c0e4e8983ce62433bb4336ad6.svg";

/***/ },
/* 1656 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/5e935374327894f2157cba50706c4734.svg";

/***/ },
/* 1657 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/c563ac03accfe05666530033b7a2ccf0.svg";

/***/ },
/* 1658 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/10dba709647d78338c9b2dfb17a920c4.svg";

/***/ },
/* 1659 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "/119bd24ff4a608ef7d5901728f475934.png";

/***/ },
/* 1660 */
/***/ function(module, exports) {

	'use strict';
	
	//  ----  CONSTANTS  --------------------------------------
	
	// if you change the validation types here, also change them in HFApi.class
	
	var ValidationTypes = {
	    VALIDATION_TYPE_NUMBERS_ONLY: 'numbers_only',
	    VALIDATION_TYPE_LETTERS_ONLY: 'letters_only',
	    VALIDATION_TYPE_PHONE_NUMBER: 'phone_number',
	    VALIDATION_TYPE_BANK_ROUTING_NUMBER: 'bank_routing_number',
	    VALIDATION_TYPE_BANK_ACCOUNT_NUMBER: 'bank_account_number',
	    VALIDATION_TYPE_EMAIL_ADDRESS: 'email_address',
	    VALIDATION_TYPE_ZIP_CODE: 'zip_code',
	    VALIDATION_TYPE_SOCIAL_SECURITY_NUMBER: 'social_security_number',
	    VALIDATION_TYPE_EMPLOYER_IDENTIFICATION_NUMBER: 'employer_identification_number'
	};
	
	var ValidationRegex = {};
	ValidationRegex[ValidationTypes.VALIDATION_TYPE_NUMBERS_ONLY] = /^[-]?\d+(\.\d+)?$/;
	ValidationRegex[ValidationTypes.VALIDATION_TYPE_LETTERS_ONLY] = /^[a-zA-Z\-\'\u00C0-\u00ff]+(\s+[a-zA-Z\-\'\u00C0-\u00ff]+)*$/i;
	ValidationRegex[ValidationTypes.VALIDATION_TYPE_PHONE_NUMBER] = /^(1[\s.-]?)?[\(\[\s.-]{0,2}?\d{3}[\)\]\s.-]{0,2}?\d{3}[\s.-]?\d{4}$/;
	ValidationRegex[ValidationTypes.VALIDATION_TYPE_BANK_ROUTING_NUMBER] = /^\d{9}$/;
	ValidationRegex[ValidationTypes.VALIDATION_TYPE_BANK_ACCOUNT_NUMBER] = /^\d{6,}$/;
	ValidationRegex[ValidationTypes.VALIDATION_TYPE_EMAIL_ADDRESS] = /^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	ValidationRegex[ValidationTypes.VALIDATION_TYPE_ZIP_CODE] = /^\d{5}([-]?\d{4})?$/;
	ValidationRegex[ValidationTypes.VALIDATION_TYPE_SOCIAL_SECURITY_NUMBER] = /^\d{3}[-]?\d{2}[-]?\d{4}$/;
	ValidationRegex[ValidationTypes.VALIDATION_TYPE_EMPLOYER_IDENTIFICATION_NUMBER] = /^\d{2}[-]?\d{7}$/;
	
	var validationTypesToDisplayNames = {};
	validationTypesToDisplayNames[ValidationTypes.VALIDATION_TYPE_NUMBERS_ONLY] = 'Numbers only';
	validationTypesToDisplayNames[ValidationTypes.VALIDATION_TYPE_LETTERS_ONLY] = 'Letters only';
	validationTypesToDisplayNames[ValidationTypes.VALIDATION_TYPE_PHONE_NUMBER] = 'Phone number';
	validationTypesToDisplayNames[ValidationTypes.VALIDATION_TYPE_BANK_ROUTING_NUMBER] = 'Bank routing number';
	validationTypesToDisplayNames[ValidationTypes.VALIDATION_TYPE_BANK_ACCOUNT_NUMBER] = 'Bank account number';
	validationTypesToDisplayNames[ValidationTypes.VALIDATION_TYPE_EMAIL_ADDRESS] = 'Email address';
	validationTypesToDisplayNames[ValidationTypes.VALIDATION_TYPE_ZIP_CODE] = 'Zip code';
	validationTypesToDisplayNames[ValidationTypes.VALIDATION_TYPE_SOCIAL_SECURITY_NUMBER] = 'Social security number';
	validationTypesToDisplayNames[ValidationTypes.VALIDATION_TYPE_EMPLOYER_IDENTIFICATION_NUMBER] = 'Employer identification number';
	
	var validationTypesToRules = {};
	validationTypesToRules[ValidationTypes.VALIDATION_TYPE_PHONE_NUMBER] = '10 digits will be required';
	validationTypesToRules[ValidationTypes.VALIDATION_TYPE_BANK_ROUTING_NUMBER] = '9 digits will be required';
	validationTypesToRules[ValidationTypes.VALIDATION_TYPE_BANK_ACCOUNT_NUMBER] = 'Minimum of 6 digits will be required';
	validationTypesToRules[ValidationTypes.VALIDATION_TYPE_ZIP_CODE] = '5 or 9 digits will be required';
	validationTypesToRules[ValidationTypes.VALIDATION_TYPE_SOCIAL_SECURITY_NUMBER] = '9 digits will be required';
	validationTypesToRules[ValidationTypes.VALIDATION_TYPE_EMPLOYER_IDENTIFICATION_NUMBER] = '9 digits will be required';
	
	module.exports = {
	    'validationTypes': ValidationTypes,
	    'validationRegex': ValidationRegex,
	    'validationTypesToDisplayNames': validationTypesToDisplayNames,
	    'validationTypesToRules': validationTypesToRules
	};

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** hellosign.js
 **/